/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		186: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = "text/javascript";
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".build.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 722);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js
//! version : 2.29.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.moment = factory();
})(this, function () {
    'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function some(fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            }),
                isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);

            if (m._strict) {
                isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [],
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (_typeof(arguments[i]) === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function keys(obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function func() {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
                return tok.slice(1);
            }
            return tok;
        }).join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid() ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if ((typeof units === 'undefined' ? 'undefined' : _typeof(units)) === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/,
        //       0 - 9
    match2 = /\d\d/,
        //      00 - 99
    match3 = /\d{3}/,
        //     000 - 999
    match4 = /\d{4}/,
        //    0000 - 9999
    match6 = /[+-]?\d{6}/,
        // -999999 - 999999
    match1to2 = /\d\d?/,
        //       0 - 99
    match3to4 = /\d\d\d\d?/,
        //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
        //   99999 - 999999
    match1to3 = /\d{1,3}/,
        //       0 - 999
    match1to4 = /\d{1,4}/,
        //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
        // -999999 - 999999
    matchUnsigned = /\d+/,
        //       0 - inf
    matchSigned = /[+-]?\d+/,
        //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
        // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
        // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
        // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function func(input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return (n % x + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function indexOf(o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months) ? this._months : this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,

        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6 // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                __webpack_require__(1642)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key + ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],

    // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || format === undefined && input === '') {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }),
        prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    });

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,

        // matching against regexp is expensive, do it on demand
        match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if ((typeof duration === 'undefined' ? 'undefined' : _typeof(duration)) === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest = input.filter(function (item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),

        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    });

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (_typeof(eras[i].since)) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (_typeof(eras[i].until)) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
                return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [{
            since: '0001-01-01',
            until: +Infinity,
            offset: 1,
            name: 'Anno Domini',
            narrow: 'AD',
            abbr: 'AD'
        }, {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: 'Before Christ',
            narrow: 'BC',
            abbr: 'BC'
        }],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
        ss: 44, // a few seconds to seconds
        s: 45, // seconds to minute
        m: 45, // minutes to hour
        h: 22, // hours to day
        d: 26, // days to month/week
        w: null, // weeks to month
        M: 11 // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];

        if (thresholds.w != null) {
            a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
        }
        a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if ((typeof argWithSuffix === 'undefined' ? 'undefined' : _typeof(argWithSuffix)) === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if ((typeof argThresholds === 'undefined' ? 'undefined' : _typeof(argThresholds)) === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.3';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM' // <input type="month" />
    };

    return hooks;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(29);
var hide = __webpack_require__(22);
var redefine = __webpack_require__(23);
var ctx = __webpack_require__(30);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1001);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accessTokenInfo; });
var accessTokenInfo = function accessTokenInfo() {
    var accessToken = localStorage.getItem('accessToken');

    var accessInfo = {
        headers: { 'X-ETA-ACCESS-TOKEN': accessToken }
    };

    return accessInfo;
};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function (useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if (item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function (modules, mediaQuery) {
		if (typeof modules === "string") modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for (var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if (typeof id === "number") alreadyImportedModules[id] = true;
		}
		for (i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if (typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if (mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if (mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */';
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(930)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Session_Signup_Index_vue__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Session_Signup_Step1_vue__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Session_Signup_Step2_vue__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Session_Login_vue__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Session_ChangePassword_vue__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_Session_ForgotPassword_vue__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_Session_MasterLogin_vue__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_Tasks_Index_vue__ = __webpack_require__(1047);











/** LAZY LOADING **/
/*const EmailConfirmation = resolve => {
  require.ensure(['../views/Sessions/EmailConfirmation/Index.vue'], () => {
    resolve(require('../views/Sessions/EmailConfirmation/Index.vue'))
})
}
/** END LAZY LOADING **/

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{ path: '/signup', component: __WEBPACK_IMPORTED_MODULE_2__views_Session_Signup_Index_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/signup/step1', component: __WEBPACK_IMPORTED_MODULE_3__views_Session_Signup_Step1_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/signup/step2', component: __WEBPACK_IMPORTED_MODULE_4__views_Session_Signup_Step2_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_5__views_Session_Login_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/masteraccount', component: __WEBPACK_IMPORTED_MODULE_8__views_Session_MasterLogin_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/changepassword', component: __WEBPACK_IMPORTED_MODULE_6__views_Session_ChangePassword_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/forgotpassword', component: __WEBPACK_IMPORTED_MODULE_7__views_Session_ForgotPassword_vue__["a" /* default */], meta: { requiresAuth: false } }, { path: '/tasks', component: __WEBPACK_IMPORTED_MODULE_9__views_Tasks_Index_vue__["a" /* default */], meta: { requiresAuth: true } }, { path: '/preferences', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(5).then((function () {
      resolve(__webpack_require__(548));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/verifygoogleauthcode', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(185).then((function () {
      resolve(__webpack_require__(549));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/shops', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(83).then((function () {
      resolve(__webpack_require__(550));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/shops/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(6).then((function () {
      resolve(__webpack_require__(551));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/taskcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(75).then((function () {
      resolve(__webpack_require__(552));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/taskcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(76).then((function () {
      resolve(__webpack_require__(553));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/teamcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(72).then((function () {
      resolve(__webpack_require__(554));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/teamcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(73).then((function () {
      resolve(__webpack_require__(555));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salescategory', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(89).then((function () {
      resolve(__webpack_require__(556));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salescategory/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(90).then((function () {
      resolve(__webpack_require__(557));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customertags', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(145).then((function () {
      resolve(__webpack_require__(558));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customertags/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(146).then((function () {
      resolve(__webpack_require__(559));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salestags', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(86).then((function () {
      resolve(__webpack_require__(560));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salestags/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(87).then((function () {
      resolve(__webpack_require__(561));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/contacttags', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(152).then((function () {
      resolve(__webpack_require__(562));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/contacttags/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(153).then((function () {
      resolve(__webpack_require__(563));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/communicationtemplates', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(154).then((function () {
      resolve(__webpack_require__(564));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/communicationtemplates/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(155).then((function () {
      resolve(__webpack_require__(565));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/discountcoupons', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(139).then((function () {
      resolve(__webpack_require__(566));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/discountcoupons/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(140).then((function () {
      resolve(__webpack_require__(567));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/usergroups', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(70).then((function () {
      resolve(__webpack_require__(568));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/usergroups/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(27).then((function () {
      resolve(__webpack_require__(569));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/devicelist', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(141).then((function () {
      resolve(__webpack_require__(570));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(46).then((function () {
      resolve(__webpack_require__(571));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringcollections', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(81).then((function () {
      resolve(__webpack_require__(572));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringcollections/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(82).then((function () {
      resolve(__webpack_require__(573));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringtrialtype', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(77).then((function () {
      resolve(__webpack_require__(574));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringtrialtype/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(78).then((function () {
      resolve(__webpack_require__(575));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringsizes', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(79).then((function () {
      resolve(__webpack_require__(576));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/tailoringsizes/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(39).then((function () {
      resolve(__webpack_require__(577));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/measurementtemplates', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(102).then((function () {
      resolve(__webpack_require__(578));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/measurementtemplates/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(33).then((function () {
      resolve(__webpack_require__(579));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/mastermsmtsheet', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(43).then((function () {
      resolve(__webpack_require__(580));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productionstages', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(92).then((function () {
      resolve(__webpack_require__(581));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productionstages/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(25).then((function () {
      resolve(__webpack_require__(582));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/mastertailoringsalesform', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(80).then((function () {
      resolve(__webpack_require__(583));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/mastertailoringsalesform/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(7).then((function () {
      resolve(__webpack_require__(541));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/leavemaster', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(106).then((function () {
      resolve(__webpack_require__(584));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/leavemaster/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(107).then((function () {
      resolve(__webpack_require__(585));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/overtimeslabs', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(97).then((function () {
      resolve(__webpack_require__(586));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/overtimeslabs/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(98).then((function () {
      resolve(__webpack_require__(587));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/holidaylist', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(119).then((function () {
      resolve(__webpack_require__(588));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/holidaylist/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(120).then((function () {
      resolve(__webpack_require__(589));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/designations', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(142).then((function () {
      resolve(__webpack_require__(590));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/designations/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(143).then((function () {
      resolve(__webpack_require__(591));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/employees', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(129).then((function () {
      resolve(__webpack_require__(592));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/employees/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(11).then((function () {
      resolve(__webpack_require__(593));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/genericcontacts', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(124).then((function () {
      resolve(__webpack_require__(594));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/genericcontacts/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(62).then((function () {
      resolve(__webpack_require__(595));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/manageteams', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(74).then((function () {
      resolve(__webpack_require__(596));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/manageteams/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(38).then((function () {
      resolve(__webpack_require__(597));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/leaveapplications', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(45).then((function () {
      resolve(__webpack_require__(598));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/leaveapplications/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(108).then((function () {
      resolve(__webpack_require__(599));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/attendanceentry', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(159).then((function () {
      resolve(__webpack_require__(600));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/attendanceentry/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(66).then((function () {
      resolve(__webpack_require__(601));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/banknames', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(157).then((function () {
      resolve(__webpack_require__(602));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/banknames/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(158).then((function () {
      resolve(__webpack_require__(603));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/paymentmodes', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(95).then((function () {
      resolve(__webpack_require__(604));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/paymentmodes/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(96).then((function () {
      resolve(__webpack_require__(605));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/currencies', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(148).then((function () {
      resolve(__webpack_require__(606));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/currencies/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(149).then((function () {
      resolve(__webpack_require__(607));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expenseaccounts', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(127).then((function () {
      resolve(__webpack_require__(608));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expenseaccounts/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(59).then((function () {
      resolve(__webpack_require__(609));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expensejournals', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(126).then((function () {
      resolve(__webpack_require__(610));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expensejournals/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(36).then((function () {
      resolve(__webpack_require__(611));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/contraentry', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(150).then((function () {
      resolve(__webpack_require__(612));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/contraentry/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(151).then((function () {
      resolve(__webpack_require__(613));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabriccategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(49).then((function () {
      resolve(__webpack_require__(614));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabriccategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/retailcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(47).then((function () {
      resolve(__webpack_require__(615));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/retailcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/rawmaterialcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(48).then((function () {
      resolve(__webpack_require__(616));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/rawmaterialcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/assetcategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(50).then((function () {
      resolve(__webpack_require__(617));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/assetcategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function () {
      resolve(__webpack_require__(39));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabricpriceslabs', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(125).then((function () {
      resolve(__webpack_require__(618));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabricpriceslabs/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(57).then((function () {
      resolve(__webpack_require__(619));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryvariants', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(109).then((function () {
      resolve(__webpack_require__(620));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryvariants/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(51).then((function () {
      resolve(__webpack_require__(621));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryracks', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(113).then((function () {
      resolve(__webpack_require__(622));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryracks/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(114).then((function () {
      resolve(__webpack_require__(623));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/vendors', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(69).then((function () {
      resolve(__webpack_require__(624));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/vendors/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(20).then((function () {
      resolve(__webpack_require__(625));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryproducts', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(116).then((function () {
      resolve(__webpack_require__(533));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryproducts/form', component: function component(resolve) {
    new Promise(function(resolve) { resolve(); }).then((function () {
      resolve(__webpack_require__(81));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/purchaseorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(115).then((function () {
      resolve(__webpack_require__(626));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/purchaseorders/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(54).then((function () {
      resolve(__webpack_require__(627));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/purchaseinvoices', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(117).then((function () {
      resolve(__webpack_require__(628));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/purchaseinvoices/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(10).then((function () {
      resolve(__webpack_require__(629));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/vendorpayment', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(68).then((function () {
      resolve(__webpack_require__(543));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/vendorpayment/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(37).then((function () {
      resolve(__webpack_require__(542));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/intrabranchtransfer', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(118).then((function () {
      resolve(__webpack_require__(630));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/intrabranchtransfer/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(35).then((function () {
      resolve(__webpack_require__(631));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/externalsourcing', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(111).then((function () {
      resolve(__webpack_require__(632));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/externalsourcing/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(34).then((function () {
      resolve(__webpack_require__(633));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventorycheck', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(110).then((function () {
      resolve(__webpack_require__(634));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventorycheck/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(52).then((function () {
      resolve(__webpack_require__(635));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customers', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(147).then((function () {
      resolve(__webpack_require__(636));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customers/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(16).then((function () {
      resolve(__webpack_require__(534));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesestimates', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(32).then((function () {
      resolve(__webpack_require__(637));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesestimates/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
      resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(29).then((function () {
      resolve(__webpack_require__(639));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesorders/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
      resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesinvoices', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(31).then((function () {
      resolve(__webpack_require__(640));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesinvoices/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
      resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/manufacturingorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(30).then((function () {
      resolve(__webpack_require__(641));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/manufacturingorders/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function () {
      resolve(__webpack_require__(49));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customerpayment', component: function component(resolve) {
    new Promise(function(resolve) { resolve(); }).then((function () {
      resolve(__webpack_require__(114));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customerpayment/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(63).then((function () {
      resolve(__webpack_require__(544));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estoreorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(61).then((function () {
      resolve(__webpack_require__(642));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/purchaserequests', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(91).then((function () {
      resolve(__webpack_require__(643));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/manageworkorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(161).then((function () {
      resolve(__webpack_require__(644));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/giftcards', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(123).then((function () {
      resolve(__webpack_require__(645));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/giftcards/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(12).then((function () {
      resolve(__webpack_require__(646));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/deliveryreceipts', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(88).then((function () {
      resolve(__webpack_require__(647));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/deliveryreceipts/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(9).then((function () {
      resolve(__webpack_require__(648));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/issuerawmaterials', component: function component(resolve) {
    new Promise(function(resolve) { resolve(); }).then((function () {
      resolve(__webpack_require__(111));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/workerstatus', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(40).then((function () {
      resolve(__webpack_require__(649));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/workerdues', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(41).then((function () {
      resolve(__webpack_require__(650));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/transferworkorder', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(71).then((function () {
      resolve(__webpack_require__(651));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/transferworkorder/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(28).then((function () {
      resolve(__webpack_require__(652));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/custombatch', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(94).then((function () {
      resolve(__webpack_require__(653));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/custombatch/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(15).then((function () {
      resolve(__webpack_require__(654));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productionworkorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(23).then((function () {
      resolve(__webpack_require__(545));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/groupworkorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(182).then((function () {
      resolve(__webpack_require__(655));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/groupworkorders/viewlist', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(22).then((function () {
      resolve(__webpack_require__(656));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabricsegregation', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(112).then((function () {
      resolve(__webpack_require__(657));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/fabricsegregation/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(53).then((function () {
      resolve(__webpack_require__(658));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/processbatch', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(181).then((function () {
      resolve(__webpack_require__(659));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/processbatch/list', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(26).then((function () {
      resolve(__webpack_require__(532));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/pendingworkorderapproval', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(21).then((function () {
      resolve(__webpack_require__(660));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productioncapacity', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(93).then((function () {
      resolve(__webpack_require__(661));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productioncapacity/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(42).then((function () {
      resolve(__webpack_require__(662));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/employeeloans', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(131).then((function () {
      resolve(__webpack_require__(663));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/employeeloans/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(60).then((function () {
      resolve(__webpack_require__(664));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/payroll', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(130).then((function () {
      resolve(__webpack_require__(546));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/payroll/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {
      resolve(__webpack_require__(115));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/singlepayrollform', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function () {
      resolve(__webpack_require__(115));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/readyorders', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(180).then((function () {
      resolve(__webpack_require__(665));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesappointments', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(17).then((function () {
      resolve(__webpack_require__(666));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productionplanner', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(18).then((function () {
      resolve(__webpack_require__(667));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/prioritylist', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(19).then((function () {
      resolve(__webpack_require__(668));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customeranalysis', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(14).then((function () {
      resolve(__webpack_require__(669));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salessummary', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(163).then((function () {
      resolve(__webpack_require__(670));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customerbalances', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(165).then((function () {
      resolve(__webpack_require__(671));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/salesanalysis', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(164).then((function () {
      resolve(__webpack_require__(672));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/supplierpayables', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(176).then((function () {
      resolve(__webpack_require__(673));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/cashflow', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(178).then((function () {
      resolve(__webpack_require__(674));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/incomevsexpense', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(179).then((function () {
      resolve(__webpack_require__(675));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/taxreport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(177).then((function () {
      resolve(__webpack_require__(676));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/closingstock', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(169).then((function () {
      resolve(__webpack_require__(677));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/inventoryanalysis', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(170).then((function () {
      resolve(__webpack_require__(678));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/agingreport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(171).then((function () {
      resolve(__webpack_require__(679));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/dailyattendancereport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(173).then((function () {
      resolve(__webpack_require__(680));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expiringdocuments', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(172).then((function () {
      resolve(__webpack_require__(681));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/customeranniversarywishes', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(174).then((function () {
      resolve(__webpack_require__(682));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/assets', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(160).then((function () {
      resolve(__webpack_require__(683));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/assets/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(67).then((function () {
      resolve(__webpack_require__(684));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/productionanalysis', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(166).then((function () {
      resolve(__webpack_require__(685));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/dayendreport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(175).then((function () {
      resolve(__webpack_require__(686));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/intrabranchtransferreport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(168).then((function () {
      resolve(__webpack_require__(687));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/issuematerialreport', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(167).then((function () {
      resolve(__webpack_require__(688));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/exportexpense', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(58).then((function () {
      resolve(__webpack_require__(689));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/exportinventorydiscount', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(55).then((function () {
      resolve(__webpack_require__(690));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/importcustomerlist', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(56).then((function () {
      resolve(__webpack_require__(691));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/accountexpired', component: function component(resolve) {
    new Promise(function(resolve) { resolve(); }).then((function () {
      resolve(__webpack_require__(144));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/bankstatement', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(65).then((function () {
      resolve(__webpack_require__(692));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/ecampaigns', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(156).then((function () {
      resolve(__webpack_require__(693));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/ecampaigns/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(64).then((function () {
      resolve(__webpack_require__(694));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/shipmentpartners', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(84).then((function () {
      resolve(__webpack_require__(695));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/shipmentpartners/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(85).then((function () {
      resolve(__webpack_require__(696));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/handloomclusters', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(121).then((function () {
      resolve(__webpack_require__(697));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/handloomclusters/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(122).then((function () {
      resolve(__webpack_require__(698));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/lettertemplates', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(104).then((function () {
      resolve(__webpack_require__(699));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/lettertemplates/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(105).then((function () {
      resolve(__webpack_require__(700));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/damagedgoods', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(103).then((function () {
      resolve(__webpack_require__(701));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/damagedgoods/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(44).then((function () {
      resolve(__webpack_require__(702));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expensebills', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(128).then((function () {
      resolve(__webpack_require__(703));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/expensebills/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(24).then((function () {
      resolve(__webpack_require__(704));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } },

/** ESTORE MODULES **/

{ path: '/estorecategories', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(136).then((function () {
      resolve(__webpack_require__(705));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorecategories/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(137).then((function () {
      resolve(__webpack_require__(706));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estoretopmenu', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(132).then((function () {
      resolve(__webpack_require__(707));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estoretopmenu/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(133).then((function () {
      resolve(__webpack_require__(708));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estoreproducts', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(134).then((function () {
      resolve(__webpack_require__(709));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estoreproducts/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(3).then((function () {
      resolve(__webpack_require__(710));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorehomepage', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(135).then((function () {
      resolve(__webpack_require__(711));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorehomepage/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(13).then((function () {
      resolve(__webpack_require__(712));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorecatalogs', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(138).then((function () {
      resolve(__webpack_require__(713));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorecatalogs/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(8).then((function () {
      resolve(__webpack_require__(714));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorenews', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(100).then((function () {
      resolve(__webpack_require__(715));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/estorenews/form', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(101).then((function () {
      resolve(__webpack_require__(716));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } },

/** END ESTORE MODULES **/

{ path: '/', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(4).then((function () {
      resolve(__webpack_require__(717));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/orderprogress', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(99).then((function () {
      resolve(__webpack_require__(547));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/databackup', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(144).then((function () {
      resolve(__webpack_require__(718));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '/master-login-request/', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(183).then((function () {
      resolve(__webpack_require__(719));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: false } }, { path: '/importtallydata', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(162).then((function () {
      resolve(__webpack_require__(720));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }, { path: '*', component: function component(resolve) {
    __webpack_require__.e/* require.ensure */(184).then((function () {
      resolve(__webpack_require__(721));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
  }, meta: { requiresAuth: true } }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: Object({"NODE_ENV":"production"}).BASE_URL,
  routes: routes
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(73)('wks');
var uid = __webpack_require__(51);
var _Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(32);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(10)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var IE8_DOM_DEFINE = __webpack_require__(171);
var toPrimitive = __webpack_require__(34);
var dP = Object.defineProperty;

exports.f = __webpack_require__(14) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(35);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return warning; });
/* harmony export (immutable) */ __webpack_exports__["d"] = format;
/* harmony export (immutable) */ __webpack_exports__["e"] = isEmptyValue;
/* unused harmony export isEmptyObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncMap;
/* harmony export (immutable) */ __webpack_exports__["b"] = complementError;
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var formatRegExp = /%[sdj%]/g;

var warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var next = function next(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === objArrLength) {
      callback(results);
    }
  };
  objArrKeys.forEach(function (key) {
    var arr = objArr[key];
    if (firstFields.indexOf(key) !== -1) {
      asyncSerialArray(arr, func, next);
    } else {
      asyncParallelArray(arr, func, next);
    }
  });
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(value)) === 'object' && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(target[s]) === 'object') {
          target[s] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
  return v === undefined || v === null;
}

function isDef(v) {
  return v !== undefined && v !== null;
}

function isTrue(v) {
  return v === true;
}

function isFalse(v) {
  return v === false;
}

/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' ||
  // $flow-disable-line
  (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol' || typeof value === 'boolean';
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType(value) {
  return _toString.call(value).slice(8, -1);
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
  return _toString.call(obj) === '[object Object]';
}

function isRegExp(v) {
  return _toString.call(v) === '[object RegExp]';
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val);
}

function isPromise(val) {
  return isDef(val) && typeof val.then === 'function' && typeof val.catch === 'function';
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
  return val == null ? '' : Array.isArray(val) || isPlainObject(val) && val.toString === _toString ? JSON.stringify(val, null, 2) : String(val);
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n;
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase ? function (val) {
    return map[val.toLowerCase()];
  } : function (val) {
    return map[val];
  };
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove(arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) {
    return c ? c.toUpperCase() : '';
  });
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase();
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind(fn, ctx) {
  function boundFn(a) {
    var l = arguments.length;
    return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
  }

  boundFn._length = fn.length;
  return boundFn;
}

function nativeBind(fn, ctx) {
  return fn.bind(ctx);
}

var bind = Function.prototype.bind ? nativeBind : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret;
}

/**
 * Mix properties into target object.
 */
function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) {}

/**
 * Always return false.
 */
var no = function no(a, b, c) {
  return false;
};

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function identity(_) {
  return _;
};

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys(modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || []);
  }, []).join(',');
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
  if (a === b) {
    return true;
  }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i]);
        });
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key]);
        });
      } else {
        /* istanbul ignore next */
        return false;
      }
    } catch (e) {
      /* istanbul ignore next */
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) {
      return i;
    }
  }
  return -1;
}

/**
 * Ensure a function is called only once.
 */
function once(fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  };
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = ['component', 'directive', 'filter'];

var LIFECYCLE_HOOKS = ['beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeUpdate', 'updated', 'beforeDestroy', 'destroyed', 'activated', 'deactivated', 'errorCaptured', 'serverPrefetch'];

/*  */

var config = {
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
};

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F;
}

/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^" + unicodeRegExp.source + ".$_\\d]");
function parsePath(path) {
  if (bailRE.test(path)) {
    return;
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) {
        return;
      }
      obj = obj[segments[i]];
    }
    return obj;
  };
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0 || weexPlatform === 'android';
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA) || weexPlatform === 'ios';
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = {}.watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', {
      get: function get() {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    }); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function isServerRendering() {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer;
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative(Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}

var hasSymbol = typeof Symbol !== 'undefined' && isNative(Symbol) && typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/function () {
    function Set() {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has(key) {
      return this.set[key] === true;
    };
    Set.prototype.add = function add(key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear() {
      this.set = Object.create(null);
    };

    return Set;
  }();
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = noop; // work around flow check
var formatComponentName = noop;

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function classify(str) {
    return str.replace(classifyRE, function (c) {
      return c.toUpperCase();
    }).replace(/[-_]/g, '');
  };

  warn = function warn(msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && !config.silent) {
      console.error("[Vue warn]: " + msg + trace);
    }
  };

  tip = function tip(msg, vm) {
    if (hasConsole && !config.silent) {
      console.warn("[Vue tip]: " + msg + (vm ? generateComponentTrace(vm) : ''));
    }
  };

  formatComponentName = function formatComponentName(vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>';
    }
    var options = typeof vm === 'function' && vm.cid != null ? vm.options : vm._isVue ? vm.$options || vm.constructor.options : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (name ? "<" + classify(name) + ">" : "<Anonymous>") + (file && includeFile !== false ? " at " + file : '');
  };

  var repeat = function repeat(str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) {
        res += str;
      }
      if (n > 1) {
        str += str;
      }
      n >>= 1;
    }
    return res;
  };

  generateComponentTrace = function generateComponentTrace(vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue;
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree.map(function (vm, i) {
        return "" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? formatComponentName(vm[0]) + "... (" + vm[1] + " recursive calls)" : formatComponentName(vm));
      }).join('\n');
    } else {
      return "\n\n(found in " + formatComponentName(vm) + ")";
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep() {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub(sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub(sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend() {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify() {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) {
      return a.id - b.id;
    });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget(target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget() {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance;
};

Object.defineProperties(VNode.prototype, prototypeAccessors);

var createEmptyVNode = function createEmptyVNode(text) {
  if (text === void 0) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node;
};

function createTextVNode(val) {
  return new VNode(undefined, undefined, undefined, String(val));
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
  var cloned = new VNode(vnode.tag, vnode.data,
  // #7975
  // clone children array to avoid mutating original in case of cloning
  // a child.
  vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned;
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = ['push', 'pop', 'shift', 'unshift', 'splice', 'sort', 'reverse'];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator() {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break;
      case 'splice':
        inserted = args.slice(2);
        break;
    }
    if (inserted) {
      ob.observeArray(inserted);
    }
    // notify change
    ob.dep.notify();
    return result;
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving(value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer(value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk(obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray(items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment(target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment(target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return;
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (shouldObserve && !isServerRendering() && (Array.isArray(value) || isPlainObject(value)) && Object.isExtensible(value) && !value._isVue) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob;
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1(obj, key, val, customSetter, shallow) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return;
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter() {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value;
    },
    set: function reactiveSetter(newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || newVal !== newVal && value !== value) {
        return;
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) {
        return;
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set(target, key, val) {
  if (false) {
    warn("Cannot set reactive property on undefined, null, or primitive value: " + target);
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val;
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val;
  }
  var ob = target.__ob__;
  if (target._isVue || ob && ob.vmCount) {
    "production" !== 'production' && warn('Avoid adding reactive properties to a Vue instance or its root $data ' + 'at runtime - declare it upfront in the data option.');
    return val;
  }
  if (!ob) {
    target[key] = val;
    return val;
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
  if (false) {
    warn("Cannot delete reactive property on undefined, null, or primitive value: " + target);
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return;
  }
  var ob = target.__ob__;
  if (target._isVue || ob && ob.vmCount) {
    "production" !== 'production' && warn('Avoid deleting properties on a Vue instance or its root $data ' + '- just set it to null.');
    return;
  }
  if (!hasOwn(target, key)) {
    return;
  }
  delete target[key];
  if (!ob) {
    return;
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
  for (var e = void 0, i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn("option \"" + key + "\" can only be used during instance " + 'creation with the `new` keyword.');
    }
    return defaultStrat(parent, child);
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from) {
  if (!from) {
    return to;
  }
  var key, toVal, fromVal;

  var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') {
      continue;
    }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (toVal !== fromVal && isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to;
}

/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal;
    }
    if (!parentVal) {
      return childVal;
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn() {
      return mergeData(typeof childVal === 'function' ? childVal.call(this, this) : childVal, typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal);
    };
  } else {
    return function mergedInstanceDataFn() {
      // instance merge
      var instanceData = typeof childVal === 'function' ? childVal.call(vm, vm) : childVal;
      var defaultData = typeof parentVal === 'function' ? parentVal.call(vm, vm) : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData);
      } else {
        return defaultData;
      }
    };
  }
}

strats.data = function (parentVal, childVal, vm) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn('The "data" option should be a function ' + 'that returns a per-instance value in component ' + 'definitions.', vm);

      return parentVal;
    }
    return mergeDataOrFn(parentVal, childVal);
  }

  return mergeDataOrFn(parentVal, childVal, vm);
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook(parentVal, childVal) {
  var res = childVal ? parentVal ? parentVal.concat(childVal) : Array.isArray(childVal) ? childVal : [childVal] : parentVal;
  return res ? dedupeHooks(res) : res;
}

function dedupeHooks(hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res;
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal);
  } else {
    return res;
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) {
    parentVal = undefined;
  }
  if (childVal === nativeWatch) {
    childVal = undefined;
  }
  /* istanbul ignore if */
  if (!childVal) {
    return Object.create(parentVal || null);
  }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent ? parent.concat(child) : Array.isArray(child) ? child : [child];
  }
  return ret;
};

/**
 * Other object hashes.
 */
strats.props = strats.methods = strats.inject = strats.computed = function (parentVal, childVal, vm, key) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) {
    return childVal;
  }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) {
    extend(ret, childVal);
  }
  return ret;
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function defaultStrat(parentVal, childVal) {
  return childVal === undefined ? parentVal : childVal;
};

/**
 * Validate component names
 */
function checkComponents(options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName(name) {
  if (!new RegExp("^[a-zA-Z][\\-\\.0-9_" + unicodeRegExp.source + "]*$").test(name)) {
    warn('Invalid component name: "' + name + '". Component names ' + 'should conform to valid custom element name in html5 specification.');
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn('Do not use built-in or reserved HTML elements as component ' + 'id: ' + name);
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
  var props = options.props;
  if (!props) {
    return;
  }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val) ? val : { type: val };
    }
  } else if (false) {
    warn("Invalid value for option \"props\": expected an Array or an Object, " + "but got " + toRawType(props) + ".", vm);
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
  var inject = options.inject;
  if (!inject) {
    return;
  }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val) ? extend({ from: key }, val) : { from: val };
    }
  } else if (false) {
    warn("Invalid value for option \"inject\": expected an Array or an Object, " + "but got " + toRawType(inject) + ".", vm);
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives(options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType(name, value, vm) {
  if (!isPlainObject(value)) {
    warn("Invalid value for option \"" + name + "\": expected an Object, " + "but got " + toRawType(value) + ".", vm);
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField(key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options;
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return;
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) {
    return assets[id];
  }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) {
    return assets[camelizedId];
  }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) {
    return assets[PascalCaseId];
  }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn('Failed to resolve ' + type.slice(0, -1) + ': ' + id, options);
  }
  return res;
}

/*  */

function validateProp(key, propOptions, propsData, vm) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value;
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined;
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn('Invalid default value for prop "' + key + '": ' + 'Props with type Object/Array must use a factory function ' + 'to return the default value.', vm);
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) {
    return vm._props[key];
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function' ? def.call(vm) : def;
}

/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
  if (prop.required && absent) {
    warn('Missing required prop: "' + name + '"', vm);
    return;
  }
  if (value == null && !prop.required) {
    return;
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i], vm);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  var haveExpectedTypes = expectedTypes.some(function (t) {
    return t;
  });
  if (!valid && haveExpectedTypes) {
    warn(getInvalidTypeMessage(name, value, expectedTypes), vm);
    return;
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;

function assertType(value, type, vm) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value === 'undefined' ? 'undefined' : _typeof(value);
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    try {
      valid = value instanceof type;
    } catch (e) {
      warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
      valid = false;
    }
  }
  return {
    valid: valid,
    expectedType: expectedType
  };
}

var functionTypeCheckRE = /^\s*function (\w+)/;

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
  var match = fn && fn.toString().match(functionTypeCheckRE);
  return match ? match[1] : '';
}

function isSameType(a, b) {
  return getType(a) === getType(b);
}

function getTypeIndex(type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1;
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i;
    }
  }
  return -1;
}

function getInvalidTypeMessage(name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." + " Expected " + expectedTypes.map(capitalize).join(', ');
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 && isExplicable(expectedType) && isExplicable(typeof value === 'undefined' ? 'undefined' : _typeof(value)) && !isBoolean(expectedType, receivedType)) {
    message += " with value " + styleValue(value, expectedType);
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + styleValue(value, receivedType) + ".";
  }
  return message;
}

function styleValue(value, type) {
  if (type === 'String') {
    return "\"" + value + "\"";
  } else if (type === 'Number') {
    return "" + Number(value);
  } else {
    return "" + value;
  }
}

var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
  return EXPLICABLE_TYPES.some(function (elem) {
    return value.toLowerCase() === elem;
  });
}

function isBoolean() {
  var args = [],
      len = arguments.length;
  while (len--) {
    args[len] = arguments[len];
  }return args.some(function (elem) {
    return elem.toLowerCase() === 'boolean';
  });
}

/*  */

function handleError(err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while (cur = cur.$parent) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) {
                return;
              }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling(handler, context, args, vm, info) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) {
        return handleError(e, vm, info + " (Promise/async)");
      });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res;
}

function globalHandleError(err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info);
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError(err, vm, info) {
  if (false) {
    warn("Error in " + info + ": \"" + err.toString() + "\"", vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err;
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks() {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function timerFunc() {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) {
      setTimeout(noop);
    }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (isNative(MutationObserver) ||
// PhantomJS and iOS 7.x
MutationObserver.toString() === '[object MutationObserverConstructor]')) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function timerFunc() {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function timerFunc() {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function timerFunc() {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick(cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    });
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (perf && perf.mark && perf.measure && perf.clearMarks && perf.clearMeasures) {
    mark = function mark(tag) {
      return perf.mark(tag);
    };
    measure = function measure(name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' + 'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' + 'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' + 'require' // for Webpack/Browserify
  );

  var warnNonPresent = function warnNonPresent(target, key) {
    warn("Property or method \"" + key + "\" is not defined on the instance but " + 'referenced during render. Make sure that this property is reactive, ' + 'either in the data option, or for class-based components, by ' + 'initializing the property. ' + 'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
  };

  var warnReservedPrefix = function warnReservedPrefix(target, key) {
    warn("Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " + 'properties starting with "$" or "_" are not proxied in the Vue instance to ' + 'prevent conflicts with Vue internals. ' + 'See: https://vuejs.org/v2/api/#data', target);
  };

  var hasProxy = typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set(target, key, value) {
        if (isBuiltInModifier(key)) {
          warn("Avoid overwriting built-in modifier in config.keyCodes: ." + key);
          return false;
        } else {
          target[key] = value;
          return true;
        }
      }
    });
  }

  var hasHandler = {
    has: function has(target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data);
      if (!has && !isAllowed) {
        if (key in target.$data) {
          warnReservedPrefix(target, key);
        } else {
          warnNonPresent(target, key);
        }
      }
      return has || !isAllowed;
    }
  };

  var getHandler = {
    get: function get(target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) {
          warnReservedPrefix(target, key);
        } else {
          warnNonPresent(target, key);
        }
      }
      return target[key];
    }
  };

  initProxy = function initProxy(vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped ? getHandler : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse(val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if (!isA && !isObject(val) || Object.isFrozen(val) || val instanceof VNode) {
    return;
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return;
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) {
      _traverse(val[i], seen);
    }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) {
      _traverse(val[keys[i]], seen);
    }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  };
});

function createFnInvoker(fns, vm) {
  function invoker() {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
    }
  }
  invoker.fns = fns;
  return invoker;
}

function updateListeners(on, oldOn, add, remove$$1, createOnceHandler, vm) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn("Invalid handler for event \"" + event.name + "\": got " + String(cur), vm);
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook(def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook() {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData(data, Ctor, tag) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return;
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
          tip("Prop \"" + keyInLowerCase + "\" is passed to component " + formatComponentName(tag || Ctor) + ", but the declared prop name is" + " \"" + key + "\". " + "Note that HTML attributes are case-insensitive and camelCased " + "props need to use their kebab-case equivalents when using in-DOM " + "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\".");
        }
      }
      checkProp(res, props, key, altKey, true) || checkProp(res, attrs, key, altKey, false);
    }
  }
  return res;
}

function checkProp(res, hash, key, altKey, preserve) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true;
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true;
    }
  }
  return false;
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children);
    }
  }
  return children;
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
  return isPrimitive(children) ? [createTextVNode(children)] : Array.isArray(children) ? normalizeArrayChildren(children) : undefined;
}

function isTextNode(node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}

function normalizeArrayChildren(children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') {
      continue;
    }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, (nestedIndex || '') + "_" + i);
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + c[0].text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) && isDef(c.tag) && isUndef(c.key) && isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res;
}

/*  */

function initProvide(vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function' ? provide.call(vm) : provide;
  }
}

function initInjections(vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn("Avoid mutating an injected value directly since the changes will be " + "overwritten whenever the provided component re-renders. " + "injection being mutated: \"" + key + "\"", vm);
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject(inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') {
        continue;
      }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break;
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function' ? provideDefault.call(vm) : provideDefault;
        } else if (false) {
          warn("Injection \"" + key + "\" not found", vm);
        }
      }
    }
    return result;
  }
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
  if (!children || !children.length) {
    return {};
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
      var name = data.slot;
      var slot = slots[name] || (slots[name] = []);
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots;
}

function isWhitespace(node) {
  return node.isComment && !node.asyncFactory || node.text === ' ';
}

/*  */

function isAsyncPlaceholder(node) {
  return node.isComment && node.asyncFactory;
}

/*  */

function normalizeScopedSlots(slots, normalSlots, prevSlots) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized;
  } else if (isStable && prevSlots && prevSlots !== emptyObject && key === prevSlots.$key && !hasNormalSlots && !prevSlots.$hasNormal) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots;
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    slots._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res;
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function normalized() {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && (typeof res === 'undefined' ? 'undefined' : _typeof(res)) === 'object' && !Array.isArray(res) ? [res] // single vnode
    : normalizeChildren(res);
    var vnode = res && res[0];
    return res && (!vnode || res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode) // #9658, #10391
    ) ? undefined : res;
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized;
}

function proxyNormalSlot(slots, key) {
  return function () {
    return slots[key];
  };
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  ret._isVList = true;
  return ret;
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) {
    // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn('slot v-bind without argument expects an Object', this);
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  } else {
    nodes = this.$slots[name] || (typeof fallbackRender === 'function' ? fallbackRender() : fallbackRender);
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes);
  } else {
    return nodes;
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity;
}

/*  */

function isKeyNotMatch(expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1;
  } else {
    return expect !== actual;
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName);
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode);
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key;
  }
  return eventKeyCode === undefined;
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn('v-bind without argument expects an Object or Array value', this);
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function loop(key) {
        if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on["update:" + key] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) {
        loop(key);
      }
    }
  }
  return data;
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree;
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, null, this // for render fns generated for functional component templates
  );
  markStatic(tree, "__static__" + index, false);
  return tree;
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
  markStatic(tree, "__once__" + index + (key ? "_" + key : ""), true);
  return tree;
}

function markStatic(tree, key, isOnce) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], key + "_" + i, isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode(node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners(data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn('v-on without argument expects an Object value', this);
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data;
}

/*  */

function resolveScopedSlots(fns, // see flow/vnode
res,
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    res.$key = contentHashKey;
  }
  return res;
}

/*  */

function bindDynamicKeys(baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn("Invalid value for dynamic directive argument (expected string or null): " + key, this);
    }
  }
  return baseObj;
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
  return typeof value === 'string' ? symbol + value : value;
}

/*  */

function installRenderHelpers(target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext(data, props, children, parent, Ctor) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(data.scopedSlots, this$1.$slots = resolveSlots(children, parent));
    }
    return this$1.$slots;
  };

  Object.defineProperty(this, 'scopedSlots', {
    enumerable: true,
    get: function get() {
      return normalizeScopedSlots(data.scopedSlots, this.slots());
    }
  });

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode;
    };
  } else {
    this._c = function (a, b, c, d) {
      return createElement(contextVm, a, b, c, d, needNormalization);
    };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) {
      mergeProps(props, data.attrs);
    }
    if (isDef(data.props)) {
      mergeProps(props, data.props);
    }
  }

  var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res;
  }
}

function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone;
}

function mergeProps(to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init(vnode, hydrating) {
    if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance);
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch(oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(child, options.propsData, // updated props
    options.listeners, // updated listeners
    vnode, // new parent vnode
    options.children // new children
    );
  },

  insert: function insert(vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy(vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent(Ctor, data, context, children, tag) {
  if (isUndef(Ctor)) {
    return;
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn("Invalid Component definition: " + String(Ctor), context);
    }
    return;
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children);
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode("vue-component-" + Ctor.cid + (name ? "-" + name : ''), data, undefined, undefined, undefined, context, { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);

  return vnode;
}

function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode,
// activeInstance in lifecycle state
parent) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options);
}

function installComponentHooks(data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1(f1, f2) {
  var merged = function merged(a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged;
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
  var prop = options.model && options.model.prop || 'value';
  var event = options.model && options.model.event || 'input';(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (Array.isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement(context, tag, data, children, normalizationType, alwaysNormalize) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType);
}

function _createElement(context, tag, data, children, normalizationType) {
  if (isDef(data) && isDef(data.__ob__)) {
    "production" !== 'production' && warn("Avoid using observed data object as vnode data: " + JSON.stringify(data) + "\n" + 'Always create fresh vnode data objects in each render!', context);
    return createEmptyVNode();
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode();
  }
  // warn against non-primitive key
  if (false) {
    {
      warn('Avoid using non-primitive value as key, ' + 'use string/number value instead.', context);
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) && typeof children[0] === 'function') {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = context.$vnode && context.$vnode.ns || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">.", context);
      }
      vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(tag, data, children, undefined, undefined, context);
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode;
  } else if (isDef(vnode)) {
    if (isDef(ns)) {
      applyNS(vnode, ns);
    }
    if (isDef(data)) {
      registerDeepBindings(data);
    }
    return vnode;
  } else {
    return createEmptyVNode();
  }
}

function applyNS(vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force) && child.tag !== 'svg')) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender(vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) {
    return createElement(vm, a, b, c, d, false);
  };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) {
    return createElement(vm, a, b, c, d, true);
  };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin(Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this);
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(_parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn('Multiple root nodes returned from render function. Render function ' + 'should return a single root node.', vm);
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode;
  };
}

/*  */

function ensureCtor(comp, base) {
  if (comp.__esModule || hasSymbol && comp[Symbol.toStringTag] === 'Module') {
    comp = comp.default;
  }
  return isObject(comp) ? base.extend(comp) : comp;
}

function createAsyncPlaceholder(factory, data, context, children, tag) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node;
}

function resolveAsyncComponent(factory, baseCtor) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp;
  }

  if (isDef(factory.resolved)) {
    return factory.resolved;
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp;
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null;owner.$on('hook:destroyed', function () {
      return remove(owners, owner);
    });

    var forceRender = function forceRender(renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        owners[i].$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn("Failed to resolve async component: " + String(factory) + (reason ? "\nReason: " + reason : ''));
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject( false ? "timeout (" + res.timeout + "ms)" : null);
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading ? factory.loadingComp : factory.resolved;
  }
}

/*  */

function getFirstComponentChild(children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c;
      }
    }
  }
}

/*  */

/*  */

function initEvents(vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add(event, fn) {
  target.$on(event, fn);
}

function remove$1(event, fn) {
  target.$off(event, fn);
}

function createOnceHandler(event, fn) {
  var _target = target;
  return function onceHandler() {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  };
}

function updateComponentListeners(vm, listeners, oldListeners) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin(Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm;
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on() {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm;
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm;
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm;
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm;
    }
    if (!fn) {
      vm._events[event] = null;
      return vm;
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break;
      }
    }
    return vm;
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip("Event \"" + lowerCaseEvent + "\" is emitted in component " + formatComponentName(vm) + " but the handler is registered for \"" + event + "\". " + "Note that HTML attributes are case-insensitive and you cannot use " + "v-on to listen to camelCase events when using in-DOM templates. " + "You should probably use \"" + hyphenate(event) + "\" instead of \"" + event + "\".");
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm;
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  };
}

function initLifecycle(vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin(Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return;
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent(vm, el, hydrating) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if (vm.$options.template && vm.$options.template.charAt(0) !== '#' || vm.$options.el || el) {
        warn('You are using the runtime-only build of Vue where the template ' + 'compiler is not available. Either pre-compile the templates into ' + 'render functions, or use the compiler-included build.', vm);
      } else {
        warn('Failed to mount component: template or render function not defined.', vm);
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function updateComponent() {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure("vue " + name + " render", startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure("vue " + name + " patch", startTag, endTag);
    };
  } else {
    updateComponent = function updateComponent() {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before() {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm;
}

function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(renderChildren || // has new static slots
  vm.$options._renderChildren || // has old static slots
  hasDynamicScopedSlot);

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) {
    // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree(vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) {
      return true;
    }
  }
  return false;
}

function activateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return;
    }
  } else if (vm._directInactive) {
    return;
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent(vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return;
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook(vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (performance && typeof performance.now === 'function' && getNow() > document.createEvent('Event').timeStamp) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function getNow() {
      return performance.now();
    };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) {
    return a.id - b.id;
  });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn('You may have an infinite update loop ' + (watcher.user ? "in watcher with expression \"" + watcher.expression + "\"" : "in a component render function."), watcher.vm);
        break;
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks(queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks(queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return;
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false ? expOrFn.toString() : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn("Failed watching path: \"" + expOrFn + "\" " + 'Watcher only accepts simple dot-delimited paths. ' + 'For full control, use a function instead.', vm);
    }
  }
  this.value = this.lazy ? undefined : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get() {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, "getter for watcher \"" + this.expression + "\"");
    } else {
      throw e;
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value;
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep(dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps() {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update() {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run() {
  if (this.active) {
    var value = this.get();
    if (value !== this.value ||
    // Deep watchers and watchers on Object/Arrays should fire even
    // when the value is the same, because the value may
    // have mutated.
    isObject(value) || this.deep) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        var info = "callback for watcher \"" + this.expression + "\"";
        invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate() {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend() {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown() {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy(target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter() {
    return this[sourceKey][key];
  };
  sharedPropertyDefinition.set = function proxySetter(val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState(vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) {
    initProps(vm, opts.props);
  }
  if (opts.methods) {
    initMethods(vm, opts.methods);
  }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) {
    initComputed(vm, opts.computed);
  }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps(vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function loop(key) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) || config.isReservedAttr(hyphenatedKey)) {
        warn("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop.", vm);
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn("Avoid mutating a prop directly since the value will be " + "overwritten whenever the parent component re-renders. " + "Instead, use a data or computed property based on the prop's " + "value. Prop being mutated: \"" + key + "\"", vm);
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) {
    loop(key);
  }toggleObserving(true);
}

function initData(vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function' ? getData(data, vm) : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn('data functions should return an object:\n' + 'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn("Method \"" + key + "\" has already been defined as a data property.", vm);
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn("The data property \"" + key + "\" is already declared as a prop. " + "Use prop default value instead.", vm);
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData(data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm);
  } catch (e) {
    handleError(e, vm, "data()");
    return {};
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed(vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn("Getter is missing for computed property \"" + key + "\".", vm);
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn("The computed property \"" + key + "\" is already defined in data.", vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn("The computed property \"" + key + "\" is already defined as a prop.", vm);
      } else if (vm.$options.methods && key in vm.$options.methods) {
        warn("The computed property \"" + key + "\" is already defined as a method.", vm);
      }
    }
  }
}

function defineComputed(target, key, userDef) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache ? createComputedGetter(key) : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? createComputedGetter(key) : createGetterInvoker(userDef.get) : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn("Computed property \"" + key + "\" was assigned to but it has no setter.", this);
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter(key) {
  return function computedGetter() {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value;
    }
  };
}

function createGetterInvoker(fn) {
  return function computedGetter() {
    return fn.call(this, this);
  };
}

function initMethods(vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn("Method \"" + key + "\" has type \"" + _typeof(methods[key]) + "\" in the component definition. " + "Did you reference the function correctly?", vm);
      }
      if (props && hasOwn(props, key)) {
        warn("Method \"" + key + "\" has already been defined as a prop.", vm);
      }
      if (key in vm && isReserved(key)) {
        warn("Method \"" + key + "\" conflicts with an existing Vue instance method. " + "Avoid defining component methods that start with _ or $.");
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch(vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher(vm, expOrFn, handler, options) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options);
}

function stateMixin(Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () {
    return this._data;
  };
  var propsDef = {};
  propsDef.get = function () {
    return this._props;
  };
  if (false) {
    dataDef.set = function () {
      warn('Avoid replacing instance root $data. ' + 'Use nested data properties instead.', this);
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (expOrFn, cb, options) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options);
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      var info = "callback for immediate watcher \"" + watcher.expression + "\"";
      pushTarget();
      invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
      popTarget();
    }
    return function unwatchFn() {
      watcher.teardown();
    };
  };
}

/*  */

var uid$3 = 0;

function initMixin(Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + vm._uid;
      endTag = "vue-perf-end:" + vm._uid;
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure("vue " + vm._name + " init", startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent(vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions(Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options;
}

function resolveModifiedOptions(Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) {
        modified = {};
      }
      modified[key] = latest[key];
    }
  }
  return modified;
}

function Vue(options) {
  if (false) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse(Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
    if (installedPlugins.indexOf(plugin) > -1) {
      return this;
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this;
  };
}

/*  */

function initMixin$1(Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this;
  };
}

/*  */

function initExtend(Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId];
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent(options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(Super.options, extendOptions);
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub;
  };
}

function initProps$1(Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1(Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters(Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (id, definition) {
      if (!definition) {
        return this.options[type + 's'][id];
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition;
      }
    };
  });
}

/*  */

function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag);
}

function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1;
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1;
  } else if (isRegExp(pattern)) {
    return pattern.test(name);
  }
  /* istanbul ignore next */
  return false;
}

function pruneCache(keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var entry = cache[key];
    if (entry) {
      var name = entry.name;
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry(cache, key, keys, current) {
  var entry = cache[key];
  if (entry && (!current || entry.tag !== current.tag)) {
    entry.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  methods: {
    cacheVNode: function cacheVNode() {
      var ref = this;
      var cache = ref.cache;
      var keys = ref.keys;
      var vnodeToCache = ref.vnodeToCache;
      var keyToCache = ref.keyToCache;
      if (vnodeToCache) {
        var tag = vnodeToCache.tag;
        var componentInstance = vnodeToCache.componentInstance;
        var componentOptions = vnodeToCache.componentOptions;
        cache[keyToCache] = {
          name: getComponentName(componentOptions),
          tag: tag,
          componentInstance: componentInstance
        };
        keys.push(keyToCache);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
        this.vnodeToCache = null;
      }
    }
  },

  created: function created() {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed() {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted() {
    var this$1 = this;

    this.cacheVNode();
    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) {
        return matches(val, name);
      });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) {
        return !matches(val, name);
      });
    });
  },

  updated: function updated() {
    this.cacheVNode();
  },

  render: function render() {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
      // not included
      include && (!name || !matches(include, name)) ||
      // excluded
      exclude && name && matches(exclude, name)) {
        return vnode;
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
      // same constructor may get registered as different local components
      // so cid alone is not enough (#3269)
      ? componentOptions.Ctor.cid + (componentOptions.tag ? "::" + componentOptions.tag : '') : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        // delay setting the cache until update
        this.vnodeToCache = vnode;
        this.keyToCache = key;
      }

      vnode.data.keepAlive = true;
    }
    return vnode || slot && slot[0];
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI(Vue) {
  // config
  var configDef = {};
  configDef.get = function () {
    return config;
  };
  if (false) {
    configDef.set = function () {
      warn('Do not replace the Vue.config object, set individual fields instead.');
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj;
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get() {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext;
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.14';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function mustUseProp(tag, type, attr) {
  return attr === 'value' && acceptValue(tag) && type !== 'button' || attr === 'selected' && tag === 'option' || attr === 'checked' && tag === 'input' || attr === 'muted' && tag === 'video';
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function convertEnumeratedValue(key, value) {
  return isFalsyAttrValue(value) || value === 'false' ? 'false'
  // allow arbitrary string value for contenteditable
  : key === 'contenteditable' && isValidContentEditableValue(value) ? value : 'true';
};

var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' + 'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' + 'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' + 'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' + 'required,reversed,scoped,seamless,selected,sortable,' + 'truespeed,typemustmatch,visible');

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function isXlink(name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};

var getXlinkProp = function getXlinkProp(name) {
  return isXlink(name) ? name.slice(6, name.length) : '';
};

var isFalsyAttrValue = function isFalsyAttrValue(val) {
  return val == null || val === false;
};

/*  */

function genClassForVnode(vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class);
}

function mergeClassData(child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class) ? [child.class, parent.class] : parent.class
  };
}

function renderClass(staticClass, dynamicClass) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass));
  }
  /* istanbul ignore next */
  return '';
}

function concat(a, b) {
  return a ? b ? a + ' ' + b : a : b || '';
}

function stringifyClass(value) {
  if (Array.isArray(value)) {
    return stringifyArray(value);
  }
  if (isObject(value)) {
    return stringifyObject(value);
  }
  if (typeof value === 'string') {
    return value;
  }
  /* istanbul ignore next */
  return '';
}

function stringifyArray(value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) {
        res += ' ';
      }
      res += stringified;
    }
  }
  return res;
}

function stringifyObject(value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) {
        res += ' ';
      }
      res += key;
    }
  }
  return res;
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' + 'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' + 'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' + 'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' + 's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' + 'embed,object,param,source,canvas,script,noscript,del,ins,' + 'caption,col,colgroup,table,thead,tbody,td,th,tr,' + 'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' + 'output,progress,select,textarea,' + 'details,dialog,menu,menuitem,summary,' + 'content,element,shadow,template,blockquote,iframe,tfoot');

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' + 'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' + 'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);

var isPreTag = function isPreTag(tag) {
  return tag === 'pre';
};

var isReservedTag = function isReservedTag(tag) {
  return isHTMLTag(tag) || isSVG(tag);
};

function getTagNamespace(tag) {
  if (isSVG(tag)) {
    return 'svg';
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math';
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true;
  }
  if (isReservedTag(tag)) {
    return false;
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag];
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
  } else {
    return unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn('Cannot find element: ' + el);
      return document.createElement('div');
    }
    return selected;
  } else {
    return el;
  }
}

/*  */

function createElement$1(tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm;
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm;
}

function createElementNS(namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName);
}

function createTextNode(text) {
  return document.createTextNode(text);
}

function createComment(text) {
  return document.createComment(text);
}

function insertBefore(parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild(node, child) {
  node.removeChild(child);
}

function appendChild(node, child) {
  node.appendChild(child);
}

function parentNode(node) {
  return node.parentNode;
}

function nextSibling(node) {
  return node.nextSibling;
}

function tagName(node) {
  return node.tagName;
}

function setTextContent(node, text) {
  node.textContent = text;
}

function setStyleScope(node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create(_, vnode) {
    registerRef(vnode);
  },
  update: function update(oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy(vnode) {
    registerRef(vnode, true);
  }
};

function registerRef(vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) {
    return;
  }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode(a, b) {
  return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && isDef(a.data) === isDef(b.data) && sameInputType(a, b) || isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error));
}

function sameInputType(a, b) {
  if (a.tag !== 'input') {
    return true;
  }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB);
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) {
      map[key] = i;
    }
  }
  return map;
}

function createPatchFunction(backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt(elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
  }

  function createRmCb(childElm, listeners) {
    function remove$$1() {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1;
  }

  function removeNode(el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1(vnode, inVPre) {
    return !inVPre && !vnode.ns && !(config.ignoredElements.length && config.ignoredElements.some(function (ignore) {
      return isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
    })) && config.isUnknownElement(vnode.tag);
  }

  var creatingElmInVPre = 0;

  function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return;
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn('Unknown custom element: <' + tag + '> - did you ' + 'register the component correctly? For recursive components, ' + 'make sure to provide the "name" option.', vnode.context);
        }
      }

      vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true;
      }
    }
  }

  function initComponent(vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break;
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert(parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren(vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable(vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag);
  }

  function invokeCreateHooks(vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) {
        i.create(emptyNode, vnode);
      }
      if (isDef(i.insert)) {
        insertedVnodeQueue.push(vnode);
      }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope(vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) && i !== vnode.context && i !== vnode.fnContext && isDef(i = i.$options._scopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook(vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) {
        i(vnode);
      }
      for (i = 0; i < cbs.destroy.length; ++i) {
        cbs.destroy[i](vnode);
      }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes(vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else {
          // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook(vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) {
        // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) {
        // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) {
          oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
        }
        idxInOld = isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) {
          // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys(children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn("Duplicate keys detected: '" + key + "'. This may cause an update error.", vnode.context);
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld(node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) {
        return i;
      }
    }
  }

  function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
    if (oldVnode === vnode) {
      return;
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return;
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) && isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
      vnode.componentInstance = oldVnode.componentInstance;
      return;
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) {
        cbs.update[i](oldVnode, vnode);
      }
      if (isDef(i = data.hook) && isDef(i = i.update)) {
        i(oldVnode, vnode);
      }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) {
          updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
        }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) {
          nodeOps.setTextContent(elm, '');
        }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) {
        i(oldVnode, vnode);
      }
    }
  }

  function invokeInsertHook(vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || data && data.pre;
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true;
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false;
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) {
        i(vnode, true /* hydrating */);
      }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true;
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false;
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break;
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false;
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break;
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true;
  }

  function assertNodeMatch(node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || !isUnknownElement$$1(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3);
    }
  }

  return function patch(oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) {
        invokeDestroyHook(oldVnode);
      }
      return;
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode;
            } else if (false) {
              warn('The client-side rendered virtual DOM tree is not matching ' + 'server-rendered content. This is likely caused by incorrect ' + 'HTML markup, for example nesting block-level elements inside ' + '<p>, or missing <tbody>. Bailing hydration and performing ' + 'full client-side render.');
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(vnode, insertedVnodeQueue,
        // extremely rare edge case: do not insert if old element is in a
        // leaving transition. Only happens when combining transition +
        // keep-alive + HOCs. (#4590)
        oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm;
  };
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives(vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives(oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update(oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function callInsert() {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1(dirs, vm) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res;
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res;
}

function getRawDirName(dir) {
  return dir.rawName || dir.name + "." + Object.keys(dir.modifiers || {}).join('.');
}

function callHook$1(dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, "directive " + dir.name + " " + hook + " hook");
    }
  }
}

var baseModules = [ref, directives];

/*  */

function updateAttrs(oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return;
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return;
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur, vnode.data.pre);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr(el, key, value, isInPre) {
  if (isInPre || el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr(el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (isIE && !isIE9 && el.tagName === 'TEXTAREA' && key === 'placeholder' && value !== '' && !el.__ieph) {
      var blocker = function blocker(e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass(oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (isUndef(data.staticClass) && isUndef(data.class) && (isUndef(oldData) || isUndef(oldData.staticClass) && isUndef(oldData.class))) {
    return;
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters(exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) {
        inSingle = false;
      }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) {
        inDouble = false;
      }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) {
        inTemplateString = false;
      }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) {
        inRegex = false;
      }
    } else if (c === 0x7C && // pipe
    exp.charCodeAt(i + 1) !== 0x7C && exp.charCodeAt(i - 1) !== 0x7C && !curly && !square && !paren) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22:
          inDouble = true;break; // "
        case 0x27:
          inSingle = true;break; // '
        case 0x60:
          inTemplateString = true;break; // `
        case 0x28:
          paren++;break; // (
        case 0x29:
          paren--;break; // )
        case 0x5B:
          square++;break; // [
        case 0x5D:
          square--;break; // ]
        case 0x7B:
          curly++;break; // {
        case 0x7D:
          curly--;break; // }
      }
      if (c === 0x2f) {
        // /
        var j = i - 1;
        var p = void 0;
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') {
            break;
          }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter() {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression;
}

function wrapFilter(exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return "_f(\"" + filter + "\")(" + exp + ")";
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return "_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args);
  }
}

/*  */

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
  console.error("[Vue compiler]: " + msg);
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction(modules, key) {
  return modules ? modules.map(function (m) {
    return m[key];
  }).filter(function (_) {
    return _;
  }) : [];
}

function addProp(el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr(el, name, value, range, dynamic) {
  var attrs = dynamic ? el.dynamicAttrs || (el.dynamicAttrs = []) : el.attrs || (el.attrs = []);
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker(symbol, name, dynamic) {
  return dynamic ? "_p(" + name + ",\"" + symbol + "\")" : symbol + name; // mark the event as captured
}

function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (false) {
    warn('passive and prevent can\'t be used together. ' + 'Passive handler can\'t prevent default event.', range);
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr(el, name) {
  return el.rawAttrsMap[':' + name] || el.rawAttrsMap['v-bind:' + name] || el.rawAttrsMap[name];
}

function getBindingAttr(el, name, getStatic) {
  var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue);
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue);
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break;
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val;
}

function getAndRemoveAttrByRegex(el, name) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr;
    }
  }
}

function rangeSetItem(item, range) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item;
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression = "(typeof " + baseValueExpression + " === 'string'" + "? " + baseValueExpression + ".trim()" + ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: "(" + value + ")",
    expression: JSON.stringify(value),
    callback: "function (" + baseValueExpression + ") {" + assignment + "}"
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
  var res = parseModel(value);
  if (res.key === null) {
    return value + "=" + assignment;
  } else {
    return "$set(" + res.exp + ", " + res.key + ", " + assignment + ")";
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;

function parseModel(val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      };
    } else {
      return {
        exp: val,
        key: null
      };
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  };
}

function next() {
  return str.charCodeAt(++index$1);
}

function eof() {
  return index$1 >= len;
}

function isStringStart(chr) {
  return chr === 0x22 || chr === 0x27;
}

function parseBracket(chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue;
    }
    if (chr === 0x5B) {
      inBracket++;
    }
    if (chr === 0x5D) {
      inBracket--;
    }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break;
    }
  }
}

function parseString(chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break;
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model(el, dir, _warn) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1("<" + el.tag + " v-model=\"" + value + "\" type=\"file\">:\n" + "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false;
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false;
  } else if (false) {
    warn$1("<" + el.tag + " v-model=\"" + value + "\">: " + "v-model is not supported on this element type. " + 'If you are working with contenteditable, it\'s recommended to ' + 'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
  }

  // ensure runtime directive metadata
  return true;
}

function genCheckboxModel(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked', "Array.isArray(" + value + ")" + "?_i(" + value + "," + valueBinding + ")>-1" + (trueValueBinding === 'true' ? ":(" + value + ")" : ":_q(" + value + "," + trueValueBinding + ")"));
  addHandler(el, 'change', "var $$a=" + value + "," + '$$el=$event.target,' + "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" + 'if(Array.isArray($$a)){' + "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," + '$$i=_i($$a,$$v);' + "if($$el.checked){$$i<0&&(" + genAssignmentCode(value, '$$a.concat([$$v])') + ")}" + "else{$$i>-1&&(" + genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))') + ")}" + "}else{" + genAssignmentCode(value, '$$c') + "}", null, true);
}

function genRadioModel(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? "_n(" + valueBinding + ")" : valueBinding;
  addProp(el, 'checked', "_q(" + value + "," + valueBinding + ")");
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect(el, value, modifiers) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" + ".call($event.target.options,function(o){return o.selected})" + ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" + "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + genAssignmentCode(value, assignment);
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel(el, value, modifiers) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " + 'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', "(" + value + ")");
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1(event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler() {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  };
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1(name, handler, capture, passive) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
      // no bubbling, should always fire.
      // this is just a safety net in case event.timeStamp is unreliable in
      // certain weird environments...
      e.target === e.currentTarget ||
      // event is fired after handler attachment
      e.timeStamp >= attachedTimestamp ||
      // bail for environments that have buggy event.timeStamp implementations
      // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
      // #9681 QtWebEngine event.timeStamp is negative value
      e.timeStamp <= 0 ||
      // #9448 bail if event is fired in another document in a multi-page
      // electron/nw.js app, since event.timeStamp will be using a different
      // starting reference
      e.target.ownerDocument !== document) {
        return original.apply(this, arguments);
      }
    };
  }
  target$1.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}

function remove$2(name, handler, capture, _target) {
  (_target || target$1).removeEventListener(name, handler._wrapper || handler, capture);
}

function updateDOMListeners(oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return;
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps(oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return;
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) {
        vnode.children.length = 0;
      }
      if (cur === oldProps[key]) {
        continue;
      }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
    // skip the update if old and new VDOM state is the same.
    // `value` is handled separately because the DOM value may be temporarily
    // out of sync with VDOM state due to focus, composition and modifiers.
    // This  #4521 by skipping the unnecessary `checked` update.
    cur !== oldProps[key]) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue(elm, checkVal) {
  return !elm.composing && (elm.tagName === 'OPTION' || isNotInFocusAndDirty(elm, checkVal) || isDirtyWithModifiers(elm, checkVal));
}

function isNotInFocusAndDirty(elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try {
    notInFocus = document.activeElement !== elm;
  } catch (e) {}
  return notInFocus && elm.value !== checkVal;
}

function isDirtyWithModifiers(elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal);
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim();
    }
  }
  return value !== newVal;
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res;
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle ? extend(data.staticStyle, style) : style;
}

// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle);
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle);
  }
  return bindingStyle;
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode && childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if (styleData = normalizeStyleData(vnode.data)) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while (parentNode = parentNode.parent) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res;
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function setProp(el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && prop in emptyStyle) {
    return prop;
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name;
    }
  }
});

function updateStyle(oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) && isUndef(oldData.staticStyle) && isUndef(oldData.style)) {
    return;
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return;
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) {
        return el.classList.add(c);
      });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return;
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) {
        return el.classList.remove(c);
      });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition(def$$1) {
  if (!def$$1) {
    return;
  }
  /* istanbul ignore else */
  if ((typeof def$$1 === 'undefined' ? 'undefined' : _typeof(def$$1)) === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res;
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1);
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: name + "-enter",
    enterToClass: name + "-enter-to",
    enterActiveClass: name + "-enter-active",
    leaveClass: name + "-leave",
    leaveToClass: name + "-leave-to",
    leaveActiveClass: name + "-leave-active"
  };
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */function (fn) {
  return fn();
};

function nextFrame(fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass(el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass(el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds(el, expectedType, cb) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) {
    return cb();
  }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function end() {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function onEnd(e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo(el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
    propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
  }
  var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  };
}

function getTimeout(delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i]);
  }));
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

/*  */

function enter(vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return;
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return;
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return;
  }

  var startClass = isAppear && appearClass ? appearClass : enterClass;
  var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
  var toClass = isAppear && appearToClass ? appearToClass : enterToClass;

  var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
  var enterHook = isAppear ? typeof appear === 'function' ? appear : enter : enter;
  var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
  var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;

  var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave(vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm();
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return;
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave() {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return;
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration(val, name, vnode) {
  if (typeof val !== 'number') {
    warn("<transition> explicit " + name + " duration is not a valid number - " + "got " + JSON.stringify(val) + ".", vnode.context);
  } else if (isNaN(val)) {
    warn("<transition> explicit " + name + " duration is NaN - " + 'the duration expression might be incorrect.', vnode.context);
  }
}

function isValidDuration(val) {
  return typeof val === 'number' && !isNaN(val);
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
  if (isUndef(fn)) {
    return false;
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
  } else {
    return (fn._length || fn.length) > 1;
  }
}

function _enter(_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1(vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [attrs, klass, events, domProps, style, transition];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted(el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated(el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) {
        return !looseEqual(o, prevOptions[i]);
      })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple ? binding.value.some(function (v) {
          return hasNoMatchingOption(v, curOptions);
        }) : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected(el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected(el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn("<select multiple v-model=\"" + binding.expression + "\"> " + "expects an Array value for its binding, but got " + Object.prototype.toString.call(value).slice(8, -1), vm);
    return;
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return;
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption(value, options) {
  return options.every(function (o) {
    return !looseEqual(o, value);
  });
}

function getValue(option) {
  return '_value' in option ? option._value : option.value;
}

function onCompositionStart(e) {
  e.target.composing = true;
}

function onCompositionEnd(e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) {
    return;
  }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? locateNode(vnode.componentInstance._vnode) : vnode;
}

var show = {
  bind: function bind(el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay = el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update(el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) {
      return;
    }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind(el, binding, vnode, oldVnode, isDestroy) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children));
  } else {
    return vnode;
  }
}

function extractTransitionData(comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data;
}

function placeholder(h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    });
  }
}

function hasParentTransition(vnode) {
  while (vnode = vnode.parent) {
    if (vnode.data.transition) {
      return true;
    }
  }
}

function isSameChild(child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag;
}

var isNotTextNode = function isNotTextNode(c) {
  return c.tag || isAsyncPlaceholder(c);
};

var isVShowDirective = function isVShowDirective(d) {
  return d.name === 'show';
};

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render(h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return;
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return;
    }

    // warn multiple elements
    if (false) {
      warn('<transition> can only be used on a single element. Use ' + '<transition-group> for lists.', this.$parent);
    }

    var mode = this.mode;

    // warn invalid mode
    if (false) {
      warn('invalid <transition> mode: ' + mode, this.$parent);
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild;
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild;
    }

    if (this._leaving) {
      return placeholder(h, rawChild);
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + this._uid + "-";
    child.key = child.key == null ? child.isComment ? id + 'comment' : id + child.tag : isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (oldChild && oldChild.data && !isSameChild(child, oldChild) && !isAsyncPlaceholder(oldChild) &&
    // #6687 component root is a comment node
    !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild);
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild;
        }
        var delayedLeave;
        var performLeave = function performLeave() {
          delayedLeave();
        };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) {
          delayedLeave = leave;
        });
      }
    }

    return rawChild;
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount() {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(this$1._vnode, this$1.kept, false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render(h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? opts.Ctor.options.name || opts.tag || '' : c.tag;
          warn("<transition-group> children must be keyed: <" + name + ">");
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children);
  },

  updated: function updated() {
    var children = this.prevChildren;
    var moveClass = this.moveClass || (this.name || 'v') + '-move';
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return;
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb(e) {
          if (e && e.target !== el) {
            return;
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove(el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false;
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove;
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) {
          removeClass(clone, cls);
        });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return this._hasMove = info.hasTransform;
    }
  }
};

function callPendingCbs(c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition(c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation(c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (el, hydrating) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating);
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (false) {
        console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' + 'https://github.com/vuejs/vue-devtools');
      }
    }
    if (false) {
      console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" + "Make sure to turn on production mode when deploying for production.\n" + "See more tips at https://vuejs.org/guide/deployment.html");
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});

function parseText(text, delimiters) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return;
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while (match = tagRE.exec(text)) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push("_s(" + exp + ")");
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  };
}

/*  */

function transformNode(el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn("class=\"" + staticClass + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData(el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + el.staticClass + ",";
  }
  if (el.classBinding) {
    data += "class:" + el.classBinding + ",";
  }
  return data;
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1(el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn("style=\"" + staticStyle + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1(el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + el.staticStyle + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + el.styleBinding + "),";
  }
  return data;
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode(html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent;
  }
};

/*  */

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' + 'link,meta,param,source,track,wbr');

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' + 'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' + 'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' + 'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' + 'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + unicodeRegExp.source + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp("^<" + qnameCapture);
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/" + qnameCapture + "[^>]*>");
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function shouldIgnoreFirstNewline(tag, html) {
  return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};

function decodeAttr(value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) {
    return decodingMap[match];
  });
}

function parseHTML(html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue;
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue;
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue;
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue;
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue;
        }
      }

      var text = void 0,
          rest = void 0,
          next = void 0;
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (!endTag.test(rest) && !startTagOpen.test(rest) && !comment.test(rest) && !conditionalComment.test(rest)) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) {
            break;
          }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text.replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
          .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return '';
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn("Mal-formatted tag at end of template: \"" + html + "\"", { start: index + html.length });
      }
      break;
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance(n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag() {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match;
      }
    }
  }

  function handleStartTag(match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href' ? options.shouldDecodeNewlinesForHref : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag(tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) {
      start = index;
    }
    if (end == null) {
      end = index;
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break;
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false) {
          options.warn("tag <" + stack[i].tag + "> has no matching end tag.", { start: stack[i].start, end: stack[i].end });
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /[ \f\t\r\n]+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement(tag, attrs, parent) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  };
}

/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function maybeComponent(el) {
    return !!(el.component || el.attrsMap[':is'] || el.attrsMap['v-bind:is'] || !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
  };
  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce(msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement(element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce("Component template should contain exactly one root element. " + "If you are using v-if on multiple elements, " + "use v-else-if to chain them instead.", { start: element.start });
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) {
      return !c.slotScope;
    });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace(el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while ((lastNode = el.children[el.children.length - 1]) && lastNode.type === 3 && lastNode.text === ' ') {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints(el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce("Cannot use <" + el.tag + "> as component root element because it may " + 'contain multiple nodes.', { start: el.start });
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce('Cannot use v-for on stateful component root element because ' + 'it renders multiple elements.', el.rawAttrsMap['v-for']);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start(tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = currentParent && currentParent.ns || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated;
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2("Invalid dynamic argument expression: attribute names cannot contain " + "spaces, quotes, <, >, / or =.", {
              start: attr.start + attr.name.indexOf("["),
              end: attr.start + attr.name.length
            });
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2('Templates should only be responsible for mapping the state to the ' + 'UI. Avoid placing tags with side-effects in your templates, such as ' + "<" + tag + ">" + ', as they will not be parsed.', { start: element.start });
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end(tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars(text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce('Component template requires a root element, rather than just text.', { start: start });
          } else if (text = text.trim()) {
            warnOnce("text \"" + text + "\" outside root element will be ignored.", { start: start });
          }
        }
        return;
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE && currentParent.tag === 'textarea' && currentParent.attrsMap.placeholder === text) {
        return;
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment(text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root;
}

function processPre(el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs(el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement(element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.scopedSlots && !element.attrsList.length;

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element;
}

function processKey(el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2("Do not use v-for index as key on <transition-group> children, " + "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef(el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor(el) {
  var exp;
  if (exp = getAndRemoveAttr(el, 'v-for')) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2("Invalid v-for expression: " + exp, el.rawAttrsMap['v-for']);
    }
  }
}

function parseFor(exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) {
    return;
  }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res;
}

function processIf(el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions(el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2("v-" + (el.elseif ? 'else-if="' + el.elseif + '"' : 'else') + " " + "used on element <" + el.tag + "> without corresponding v-if.", el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
  }
}

function findPrevElement(children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i];
    } else {
      if (false) {
        warn$2("text \"" + children[i].text.trim() + "\" between v-if and v-else(-if) " + "will be ignored.", children[i]);
      }
      children.pop();
    }
  }
}

function addIfCondition(el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce(el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2("the \"scope\" attribute for scoped slots have been deprecated and " + "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " + "can also be used on plain elements in addition to <template> to " + "denote scoped slots.", el.rawAttrsMap['scope'], true);
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if (slotScope = getAndRemoveAttr(el, 'slot-scope')) {
    /* istanbul ignore if */
    if (false) {
      warn$2("Ambiguous combined usage of slot-scope and v-for on <" + el.tag + "> " + "(v-for takes higher priority). Use a wrapper <template> for the " + "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2("Unexpected mixed usage of different slot syntaxes.", el);
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2("<template v-slot> can only appear at the root level inside " + "the receiving component", el);
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2("v-slot can only be used on components or <template>.", slotBinding$1);
          }
          if (el.slotScope || el.slotTarget) {
            warn$2("Unexpected mixed usage of different slot syntaxes.", el);
          }
          if (el.scopedSlots) {
            warn$2("To avoid scope ambiguity, the default slot should also use " + "<template> syntax when there are other named slots.", slotBinding$1);
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true;
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName(binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2("v-slot shorthand syntax requires a slot name.", binding);
    }
  }
  return dynamicArgRE.test(name)
  // dynamic [name]
  ? { name: name.slice(1, -1), dynamic: true
    // static name
  } : { name: "\"" + name + "\"", dynamic: false };
}

// handle <slot/> outlets
function processSlotOutlet(el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2("`key` does not work on <slot> because slots are abstract outlets " + "and can possibly expand into multiple elements. " + "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
    }
  }
}

function processComponent(el) {
  var binding;
  if (binding = getBindingAttr(el, 'is')) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs(el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) {
        // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (false) {
          warn$2("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"");
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') {
              name = 'innerHTML';
            }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(el, "update:" + camelize(name), syncGen, null, false, warn$2, list[i]);
              if (hyphenate(name) !== camelize(name)) {
                addHandler(el, "update:" + hyphenate(name), syncGen, null, false, warn$2, list[i]);
              }
            } else {
              // handler w/ dynamic event name
              addHandler(el, "\"update:\"+(" + name + ")", syncGen, null, false, warn$2, list[i], true // dynamic
              );
            }
          }
        }
        if (modifiers && modifiers.prop || !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) {
        // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else {
        // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(name + "=\"" + value + "\": " + 'Interpolation inside attributes has been removed. ' + 'Use v-bind or the colon shorthand instead. For example, ' + 'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component && name === 'muted' && platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor(el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true;
    }
    parent = parent.parent;
  }
  return false;
}

function parseModifiers(name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) {
      ret[m.slice(1)] = true;
    });
    return ret;
  }
}

function makeAttrsMap(attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (false) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map;
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
  return el.tag === 'script' || el.tag === 'style';
}

function isForbiddenTag(el) {
  return el.tag === 'style' || el.tag === 'script' && (!el.attrsMap.type || el.attrsMap.type === 'text/javascript');
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug(attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res;
}

function checkForAliasModel(el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2("<" + el.tag + " v-model=\"" + value + "\">: " + "You are binding v-model directly to a v-for iteration alias. " + "This will not be able to modify the v-for source array because " + "writing to the alias is like modifying a function local variable. " + "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode(el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return;
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + map['v-bind'] + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? "&&(" + ifCondition + ")" : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0;
    }
  }
}

function cloneASTElement(el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [klass$1, style$1, model$1];

/*  */

function text(el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', "_s(" + dir.value + ")", dir);
  }
}

/*  */

function html(el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', "_s(" + dir.value + ")", dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
  if (!root) {
    return;
  }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1(keys) {
  return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' + (keys ? ',' + keys : ''));
}

function markStatic$1(node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (!isPlatformReservedTag(node.tag) && node.tag !== 'slot' && node.attrsMap['inline-template'] == null) {
      return;
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots(node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(node.children.length === 1 && node.children[0].type === 3)) {
      node.staticRoot = true;
      return;
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic(node) {
  if (node.type === 2) {
    // expression
    return false;
  }
  if (node.type === 3) {
    // text
    return true;
  }
  return !!(node.pre || !node.hasBindings && // no dynamic bindings
  !node.if && !node.for && // not v-if or v-for or v-else
  !isBuiltInTag(node.tag) && // not a built-in
  isPlatformReservedTag(node.tag) && // not a component
  !isDirectChildOfTemplateFor(node) && Object.keys(node).every(isStaticKey));
}

function isDirectChildOfTemplateFor(node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false;
    }
    if (node.for) {
      return true;
    }
  }
  return false;
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function genGuard(condition) {
  return "if(" + condition + ")return null;";
};

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers(events, isNative) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + staticHandlers.slice(0, -1) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + dynamicHandlers.slice(0, -1) + "])";
  } else {
    return prefix + staticHandlers;
  }
}

function genHandler(handler) {
  if (!handler) {
    return 'function(){}';
  }

  if (Array.isArray(handler)) {
    return "[" + handler.map(function (handler) {
      return genHandler(handler);
    }).join(',') + "]";
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value;
    }
    return "function($event){" + (isFunctionInvocation ? "return " + handler.value : handler.value) + "}"; // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = handler.modifiers;
        genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta'].filter(function (keyModifier) {
          return !modifiers[keyModifier];
        }).map(function (keyModifier) {
          return "$event." + keyModifier + "Key";
        }).join('||'));
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath ? "return " + handler.value + ".apply(null, arguments)" : isFunctionExpression ? "return (" + handler.value + ").apply(null, arguments)" : isFunctionInvocation ? "return " + handler.value : handler.value;
    return "function($event){" + code + handlerCode + "}";
  }
}

function genKeyFilter(keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" + keys.map(genFilterCode).join('&&') + ")return null;"
  );
}

function genFilterCode(key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return "$event.keyCode!==" + keyVal;
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return "_k($event.keyCode," + JSON.stringify(key) + "," + JSON.stringify(keyCode) + "," + "$event.key," + "" + JSON.stringify(keyName) + ")";
}

/*  */

function on(el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) {
    return "_g(" + code + "," + dir.value + ")";
  };
}

/*  */

function bind$1(el, dir) {
  el.wrapData = function (code) {
    return "_b(" + code + ",'" + el.tag + "'," + dir.value + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")";
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState(options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) {
    return !!el.component || !isReservedTag(el.tag);
  };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};

function generate(ast, options) {
  var state = new CodegenState(options);
  // fix #11483, Root level <script> tags should not be rendered.
  var code = ast ? ast.tag === 'script' ? 'null' : genElement(ast, state) : '_c("div")';
  return {
    render: "with(this){return " + code + "}",
    staticRenderFns: state.staticRenderFns
  };
}

function genElement(el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state);
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state);
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state);
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state);
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0';
  } else if (el.tag === 'slot') {
    return genSlot(el, state);
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || el.pre && state.maybeComponent(el)) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + el.tag + "'" + (data ? "," + data : '') + (children ? "," + children : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code;
  }
}

// hoist static sub-trees out
function genStatic(el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push("with(this){return " + genElement(el, state) + "}");
  state.pre = originalPreState;
  return "_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")";
}

// v-once
function genOnce(el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state);
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break;
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
      return genElement(el, state);
    }
    return "_o(" + genElement(el, state) + "," + state.onceId++ + "," + key + ")";
  } else {
    return genStatic(el, state);
  }
}

function genIf(el, state, altGen, altEmpty) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}

function genIfConditions(conditions, state, altGen, altEmpty) {
  if (!conditions.length) {
    return altEmpty || '_e()';
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return "(" + condition.exp + ")?" + genTernaryExp(condition.block) + ":" + genIfConditions(conditions, state, altGen, altEmpty);
  } else {
    return "" + genTernaryExp(condition.block);
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp(el) {
    return altGen ? altGen(el, state) : el.once ? genOnce(el, state) : genElement(el, state);
  }
}

function genFor(el, state, altGen, altHelper) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? "," + el.iterator1 : '';
  var iterator2 = el.iterator2 ? "," + el.iterator2 : '';

  if (false) {
    state.warn("<" + el.tag + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " + "v-for should have explicit keys. " + "See https://vuejs.org/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," + "function(" + alias + iterator1 + iterator2 + "){" + "return " + (altGen || genElement)(el, state) + '})';
}

function genData$2(el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) {
    data += dirs + ',';
  }

  // key
  if (el.key) {
    data += "key:" + el.key + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + el.ref + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + el.tag + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + genProps(el.attrs) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + genProps(el.props) + ",";
  }
  // event handlers
  if (el.events) {
    data += genHandlers(el.events, false) + ",";
  }
  if (el.nativeEvents) {
    data += genHandlers(el.nativeEvents, true) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + el.slotTarget + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += genScopedSlots(el, el.scopedSlots, state) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + el.model.value + ",callback:" + el.model.callback + ",expression:" + el.model.expression + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + el.tag + "\"," + genProps(el.dynamicAttrs) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data;
}

function genDirectives(el, state) {
  var dirs = el.directives;
  if (!dirs) {
    return;
  }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + dir.name + "\",rawName:\"" + dir.rawName + "\"" + (dir.value ? ",value:(" + dir.value + "),expression:" + JSON.stringify(dir.value) : '') + (dir.arg ? ",arg:" + (dir.isDynamicArg ? dir.arg : "\"" + dir.arg + "\"") : '') + (dir.modifiers ? ",modifiers:" + JSON.stringify(dir.modifiers) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']';
  }
}

function genInlineTemplate(el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.', { start: el.start });
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return "inlineTemplate:{render:function(){" + inlineRenderFns.render + "},staticRenderFns:[" + inlineRenderFns.staticRenderFns.map(function (code) {
      return "function(){" + code + "}";
    }).join(',') + "]}";
  }
}

function genScopedSlots(el, slots, state) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    ;
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (parent.slotScope && parent.slotScope !== emptySlotScopeToken || parent.for) {
        needsForceUpdate = true;
        break;
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots).map(function (key) {
    return genScopedSlot(slots[key], state);
  }).join(',');

  return "scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? ",null,false," + hash(generatedSlots) : "") + ")";
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while (i) {
    hash = hash * 33 ^ str.charCodeAt(--i);
  }
  return hash >>> 0;
}

function containsSlotChild(el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true;
    }
    return el.children.some(containsSlotChild);
  }
  return false;
}

function genScopedSlot(el, state) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null");
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot);
  }
  var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
  var fn = "function(" + slotScope + "){" + "return " + (el.tag === 'template' ? el.if && isLegacySyntax ? "(" + el.if + ")?" + (genChildren(el, state) || 'undefined') + ":undefined" : genChildren(el, state) || 'undefined' : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return "{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}";
}

function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 && el$1.for && el$1.tag !== 'template' && el$1.tag !== 'slot') {
      var normalizationType = checkSkip ? state.maybeComponent(el$1) ? ",1" : ",0" : "";
      return "" + (altGenElement || genElement)(el$1, state) + normalizationType;
    }
    var normalizationType$1 = checkSkip ? getNormalizationType(children, state.maybeComponent) : 0;
    var gen = altGenNode || genNode;
    return "[" + children.map(function (c) {
      return gen(c, state);
    }).join(',') + "]" + (normalizationType$1 ? "," + normalizationType$1 : '');
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue;
    }
    if (needsNormalization(el) || el.ifConditions && el.ifConditions.some(function (c) {
      return needsNormalization(c.block);
    })) {
      res = 2;
      break;
    }
    if (maybeComponent(el) || el.ifConditions && el.ifConditions.some(function (c) {
      return maybeComponent(c.block);
    })) {
      res = 1;
    }
  }
  return res;
}

function needsNormalization(el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}

function genNode(node, state) {
  if (node.type === 1) {
    return genElement(node, state);
  } else if (node.type === 3 && node.isComment) {
    return genComment(node);
  } else {
    return genText(node);
  }
}

function genText(text) {
  return "_v(" + (text.type === 2 ? text.expression // no need for () because already wrapped in _s()
  : transformSpecialNewlines(JSON.stringify(text.text))) + ")";
}

function genComment(comment) {
  return "_e(" + JSON.stringify(comment.text) + ")";
}

function genSlot(el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ",function(){return " + children + "}" : '');
  var attrs = el.attrs || el.dynamicAttrs ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) {
    return {
      // slot props are camelized
      name: camelize(attr.name),
      value: attr.value,
      dynamic: attr.dynamic
    };
  })) : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')';
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return "_c(" + componentName + "," + genData$2(el, state) + (children ? "," + children : '') + ")";
}

function genProps(props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += prop.name + "," + value + ",";
    } else {
      staticProps += "\"" + prop.name + "\":" + value + ",";
    }
  }
  staticProps = "{" + staticProps.slice(0, -1) + "}";
  if (dynamicProps) {
    return "_d(" + staticProps + ",[" + dynamicProps.slice(0, -1) + "])";
  } else {
    return staticProps;
  }
}

// #3895, #4268
function transformSpecialNewlines(text) {
  return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' + 'super,throw,while,yield,delete,export,import,return,switch,default,' + 'extends,finally,continue,debugger,function,arguments').split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + 'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors(ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode(node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, "v-for=\"" + value + "\"", warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, name + "=\"" + value + "\"", warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, name + "=\"" + value + "\"", warn, range);
          } else {
            checkExpression(value, name + "=\"" + value + "\"", warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent(exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn("avoid using JavaScript unary operator as property name: " + "\"" + keywordMatch[0] + "\" in expression " + text.trim(), range);
  }
  checkExpression(exp, text, warn, range);
}

function checkFor(node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier(ident, type, text, warn, range) {
  if (typeof ident === 'string') {
    try {
      new Function("var " + ident + "=_");
    } catch (e) {
      warn("invalid " + type + " \"" + ident + "\" in expression: " + text.trim(), range);
    }
  }
}

function checkExpression(exp, text, warn, range) {
  try {
    new Function("return " + exp);
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn("avoid using JavaScript keyword as property name: " + "\"" + keywordMatch[0] + "\"\n  Raw expression: " + text.trim(), range);
    } else {
      warn("invalid expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
    }
  }
}

function checkFunctionParameterExpression(exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn("invalid function parameter expression: " + e.message + " in\n\n" + "    " + exp + "\n\n" + "  Raw expression: " + text.trim() + "\n", range);
  }
}

/*  */

var range = 2;

function generateCodeFrame(source, start, end) {
  if (start === void 0) start = 0;
  if (end === void 0) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) {
          continue;
        }
        res.push("" + (j + 1) + repeat$1(" ", 3 - String(j + 1).length) + "|  " + lines[j]);
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break;
    }
  }
  return res.join('\n');
}

function repeat$1(str, n) {
  var result = '';
  if (n > 0) {
    while (true) {
      // eslint-disable-line
      if (n & 1) {
        result += str;
      }
      n >>>= 1;
      if (n <= 0) {
        break;
      }
      str += str;
    }
  }
  return result;
}

/*  */

function createFunction(code, errors) {
  try {
    return new Function(code);
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop;
  }
}

function createCompileToFunctionFn(compile) {
  var cache = Object.create(null);

  return function compileToFunctions(template, options, vm) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1('It seems you are using the standalone build of Vue.js in an ' + 'environment with Content Security Policy that prohibits unsafe-eval. ' + 'The template compiler cannot work in this environment. Consider ' + 'relaxing the policy to allow unsafe-eval or pre-compiling your ' + 'templates into render functions.');
        }
      }
    }

    // check cache
    var key = options.delimiters ? String(options.delimiters) + template : template;
    if (cache[key]) {
      return cache[key];
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1("Error compiling template:\n\n" + e.msg + "\n\n" + generateCodeFrame(template, e.start, e.end), vm);
          });
        } else {
          warn$$1("Error compiling template:\n\n" + template + "\n\n" + compiled.errors.map(function (e) {
            return "- " + e;
          }).join('\n') + '\n', vm);
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) {
            return tip(e.msg, vm);
          });
        } else {
          compiled.tips.forEach(function (msg) {
            return tip(msg, vm);
          });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors);
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1("Failed to generate render function:\n\n" + fnGenErrors.map(function (ref) {
          var err = ref.err;
          var code = ref.code;

          return err.toString() + " in\n\n" + code + "\n";
        }).join('\n'), vm);
      }
    }

    return cache[key] = res;
  };
}

/*  */

function createCompilerCreator(baseCompile) {
  return function createCompiler(baseOptions) {
    function compile(template, options) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function warn(msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function warn(msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled;
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    };
  };
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  };
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0;
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML;
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
    return this;
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn("Template element not found or is empty: " + options.template, this);
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this;
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure("vue " + this._name + " compile", 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating);
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
  if (el.outerHTML) {
    return el.outerHTML;
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML;
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40), __webpack_require__(143).setImmediate))

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var bind = __webpack_require__(228);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__required__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whitespace__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__range__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enum__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pattern__ = __webpack_require__(1266);







/* harmony default export */ __webpack_exports__["a"] = ({
  required: __WEBPACK_IMPORTED_MODULE_0__required__["a" /* default */],
  whitespace: __WEBPACK_IMPORTED_MODULE_1__whitespace__["a" /* default */],
  type: __WEBPACK_IMPORTED_MODULE_2__type__["a" /* default */],
  range: __WEBPACK_IMPORTED_MODULE_3__range__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_4__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_5__pattern__["a" /* default */]
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var createDesc = __webpack_require__(50);
module.exports = __webpack_require__(14) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(22);
var has = __webpack_require__(25);
var SRC = __webpack_require__(51)('src');
var $toString = __webpack_require__(726);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(29).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var fails = __webpack_require__(10);
var defined = __webpack_require__(35);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function createHTML(string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

/***/ }),
/* 25 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(74);
var defined = __webpack_require__(35);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(75);
var createDesc = __webpack_require__(50);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(34);
var has = __webpack_require__(25);
var IE8_DOM_DEFINE = __webpack_require__(171);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(14) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(25);
var toObject = __webpack_require__(16);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(19);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__(10);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () {/* empty */}, 1) : method.call(null);
  });
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(1);
var core = __webpack_require__(29);
var fails = __webpack_require__(10);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(30);
var IObject = __webpack_require__(74);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var asc = __webpack_require__(134);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) {
      if (NO_HOLES || index in self) {
        val = self[index];
        res = f(val, index, O);
        if (TYPE) {
          if (IS_MAP) result[index] = res; // map
          else if (res) switch (TYPE) {
              case 3:
                return true; // some
              case 5:
                return val; // find
              case 6:
                return index; // findIndex
              case 2:
                result.push(val); // filter
            } else if (IS_EVERY) return false; // every
        }
      }
    }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isEmpty = exports.isEqual = exports.arrayEquals = exports.looseEqual = exports.capitalize = exports.kebabCase = exports.autoprefixer = exports.isFirefox = exports.isEdge = exports.isIE = exports.coerceTruthyValueToArray = exports.arrayFind = exports.arrayFindIndex = exports.escapeRegexpString = exports.valueEquals = exports.generateId = exports.getValueByPath = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.noop = noop;
exports.hasOwn = hasOwn;
exports.toObject = toObject;
exports.getPropByPath = getPropByPath;
exports.rafThrottle = rafThrottle;
exports.objToArray = objToArray;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _types = __webpack_require__(287);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {};

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
};

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
};

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
};

var getValueByPath = exports.getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
};

var generateId = exports.generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = exports.valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = exports.escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = exports.arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = exports.arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = exports.coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = exports.isIE = function isIE() {
  return !_vue2.default.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = exports.isEdge = function isEdge() {
  return !_vue2.default.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = exports.isFirefox = function isFirefox() {
  return !_vue2.default.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = exports.autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var kebabCase = exports.kebabCase = function kebabCase(str) {
  var hyphenateRE = /([^-])([A-Z])/g;
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
};

var capitalize = exports.capitalize = function capitalize(str) {
  if (!(0, _types.isString)(str)) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var looseEqual = exports.looseEqual = function looseEqual(a, b) {
  var isObjectA = (0, _types.isObject)(a);
  var isObjectB = (0, _types.isObject)(b);
  if (isObjectA && isObjectB) {
    return JSON.stringify(a) === JSON.stringify(b);
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
};

var arrayEquals = exports.arrayEquals = function arrayEquals(arrayA, arrayB) {
  arrayA = arrayA || [];
  arrayB = arrayB || [];

  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    if (!looseEqual(arrayA[i], arrayB[i])) {
      return false;
    }
  }

  return true;
};

var isEqual = exports.isEqual = function isEqual(value1, value2) {
  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arrayEquals(value1, value2);
  }
  return looseEqual(value1, value2);
};

var isEmpty = exports.isEmpty = function isEmpty(val) {
  // null or undefined
  if (val == null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]':
      {
        return !val.size;
      }
    // Plain Object
    case '[object Object]':
      {
        return !Object.keys(val).length;
      }
  }

  return false;
};

function rafThrottle(fn) {
  var locked = false;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (locked) return;
    locked = true;
    window.requestAnimationFrame(function (_) {
      fn.apply(_this, args);
      locked = false;
    });
  };
}

function objToArray(obj) {
  if (Array.isArray(obj)) {
    return obj;
  }
  return isEmpty(obj) ? [] : [obj];
}

/***/ }),
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

if (__webpack_require__(14)) {
  var LIBRARY = __webpack_require__(45);
  var global = __webpack_require__(9);
  var fails = __webpack_require__(10);
  var $export = __webpack_require__(1);
  var $typed = __webpack_require__(92);
  var $buffer = __webpack_require__(142);
  var ctx = __webpack_require__(30);
  var anInstance = __webpack_require__(57);
  var propertyDesc = __webpack_require__(50);
  var hide = __webpack_require__(22);
  var redefineAll = __webpack_require__(59);
  var toInteger = __webpack_require__(32);
  var toLength = __webpack_require__(13);
  var toIndex = __webpack_require__(199);
  var toAbsoluteIndex = __webpack_require__(53);
  var toPrimitive = __webpack_require__(34);
  var has = __webpack_require__(25);
  var classof = __webpack_require__(65);
  var isObject = __webpack_require__(11);
  var toObject = __webpack_require__(16);
  var isArrayIter = __webpack_require__(131);
  var create = __webpack_require__(54);
  var getPrototypeOf = __webpack_require__(28);
  var gOPN = __webpack_require__(55).f;
  var getIterFn = __webpack_require__(133);
  var uid = __webpack_require__(51);
  var wks = __webpack_require__(12);
  var createArrayMethod = __webpack_require__(37);
  var createArrayIncludes = __webpack_require__(82);
  var speciesConstructor = __webpack_require__(77);
  var ArrayIterators = __webpack_require__(136);
  var Iterators = __webpack_require__(67);
  var $iterDetect = __webpack_require__(87);
  var setSpecies = __webpack_require__(56);
  var arrayFill = __webpack_require__(135);
  var arrayCopyWithin = __webpack_require__(188);
  var $DP = __webpack_require__(15);
  var $GOPD = __webpack_require__(27);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function toOffset(it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function validate(it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function allocate(C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    }return new C(length);
  };

  var speciesFromList = function speciesFromList(O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function fromList(C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) {
      result[index] = list[index++];
    }return result;
  };

  var addGetter = function addGetter(it, key, internal) {
    dP(it, key, { get: function get() {
        return this._d[internal];
      } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      }O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of() /* ...items */{
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) {
      result[index] = arguments[index++];
    }return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
    arrayToLocaleString.call(new Uint8Array(1));
  });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) {
      // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) {
      // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) {
      // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) {
      // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      }return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) {
      this[offset + index] = src[index++];
    }
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function isTAIndex(target, key) {
    return isObject(target) && target[TYPED_ARRAY] && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
    // TODO: add validation descriptor w/o calling accessors
    && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
      target[key] = desc.value;
      return target;
    }return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () {
    arrayToString.call({});
  })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function constructor() {/* noop */},
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function get() {
      return this[TYPED_ARRAY];
    }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function getter(that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function setter(that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function addElement(that, index) {
      dP(that, index, {
        get: function get() {
          return getter(this, index);
        },
        set: function set(value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) {
          addElement(that, index++);
        }
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function get() {
          return NAME;
        }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () {
      Base.of.call(TypedArray, 1);
    }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () {/* empty */};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var Map = __webpack_require__(194);
var $export = __webpack_require__(1);
var shared = __webpack_require__(73)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(197))());

var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  }return keyMetadata;
};
var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) {
    keys.push(key);
  });
  return keys;
};
var toMetaKey = function toMetaKey(it) {
  return it === undefined || (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : String(it);
};
var exp = function exp(O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isInContainer = exports.getScrollContainer = exports.isScroll = exports.getStyle = exports.once = exports.off = exports.on = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
}; /* istanbul ignore next */

exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.setStyle = setStyle;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isServer = _vue2.default.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = exports.on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = exports.off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = exports.once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.setAttribute('class', curClass);
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.setAttribute('class', trim(curClass));
  }
};

/* istanbul ignore next */
var getStyle = exports.getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

var isScroll = exports.isScroll = function isScroll(el, vertical) {
  if (isServer) return;

  var determinedDirection = vertical !== null && vertical !== undefined;
  var overflow = determinedDirection ? vertical ? getStyle(el, 'overflow-y') : getStyle(el, 'overflow-x') : getStyle(el, 'overflow');

  return overflow.match(/(scroll|auto|overlay)/);
};

var getScrollContainer = exports.getScrollContainer = function getScrollContainer(el, vertical) {
  if (isServer) return;

  var parent = el;
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window;
    }
    if (isScroll(parent, vertical)) {
      return parent;
    }
    parent = parent.parentNode;
  }

  return parent;
};

var isInContainer = exports.isInContainer = function isInContainer(el, container) {
  if (isServer || !el || !container) return false;

  var elRect = el.getBoundingClientRect();
  var containerRect = void 0;

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    };
  } else {
    containerRect = container.getBoundingClientRect();
  }

  return elRect.top < containerRect.bottom && elRect.bottom > containerRect.top && elRect.right > containerRect.left && elRect.left < containerRect.right;
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, {
        /******/configurable: false,
        /******/enumerable: true,
        /******/get: getter
        /******/ });
      /******/
    }
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "";
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 1);
  /******/
}(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  var DEVICE_TYPES = {
    MOBILE: "mobile",
    TABLET: "tablet",
    SMART_TV: "smarttv",
    CONSOLE: "console",
    WEARABLE: "wearable",
    BROWSER: undefined
  };

  var BROWSER_TYPES = {
    CHROME: "Chrome",
    FIREFOX: "Firefox",
    OPERA: "Opera",
    YANDEX: "Yandex",
    SAFARI: "Safari",
    INTERNET_EXPLORER: "Internet Explorer",
    EDGE: "Edge",
    CHROMIUM: "Chromium",
    IE: "IE",
    MOBILE_SAFARI: "Mobile Safari",
    EDGE_CHROMIUM: "Edge Chromium"
  };

  var OS_TYPES = {
    IOS: "iOS",
    ANDROID: "Android",
    WINDOWS_PHONE: "Windows Phone",
    WINDOWS: "Windows",
    MAC_OS: "Mac OS"
  };

  var defaultData = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
  };

  module.exports = { BROWSER_TYPES: BROWSER_TYPES, DEVICE_TYPES: DEVICE_TYPES, OS_TYPES: OS_TYPES, defaultData: defaultData };

  /***/
},
/* 1 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  var UAParser = __webpack_require__(2);

  var _require = __webpack_require__(0),
      BROWSER_TYPES = _require.BROWSER_TYPES,
      OS_TYPES = _require.OS_TYPES,
      DEVICE_TYPES = _require.DEVICE_TYPES;

  var _require2 = __webpack_require__(4),
      checkType = _require2.checkType,
      broPayload = _require2.broPayload,
      mobilePayload = _require2.mobilePayload,
      wearPayload = _require2.wearPayload,
      consolePayload = _require2.consolePayload,
      stvPayload = _require2.stvPayload,
      getNavigatorInstance = _require2.getNavigatorInstance,
      isIOS13Check = _require2.isIOS13Check;

  var UA = new UAParser();

  var browser = UA.getBrowser();
  var device = UA.getDevice();
  var engine = UA.getEngine();
  var os = UA.getOS();
  var ua = UA.getUA();

  var CHROME = BROWSER_TYPES.CHROME,
      CHROMIUM = BROWSER_TYPES.CHROMIUM,
      IE = BROWSER_TYPES.IE,
      INTERNET_EXPLORER = BROWSER_TYPES.INTERNET_EXPLORER,
      OPERA = BROWSER_TYPES.OPERA,
      FIREFOX = BROWSER_TYPES.FIREFOX,
      SAFARI = BROWSER_TYPES.SAFARI,
      EDGE = BROWSER_TYPES.EDGE,
      YANDEX = BROWSER_TYPES.YANDEX,
      MOBILE_SAFARI = BROWSER_TYPES.MOBILE_SAFARI;
  var MOBILE = DEVICE_TYPES.MOBILE,
      TABLET = DEVICE_TYPES.TABLET,
      SMART_TV = DEVICE_TYPES.SMART_TV,
      BROWSER = DEVICE_TYPES.BROWSER,
      WEARABLE = DEVICE_TYPES.WEARABLE,
      CONSOLE = DEVICE_TYPES.CONSOLE;
  var ANDROID = OS_TYPES.ANDROID,
      WINDOWS_PHONE = OS_TYPES.WINDOWS_PHONE,
      IOS = OS_TYPES.IOS,
      WINDOWS = OS_TYPES.WINDOWS,
      MAC_OS = OS_TYPES.MAC_OS;

  var isMobileType = function isMobileType() {
    return device.type === MOBILE;
  };
  var isTabletType = function isTabletType() {
    return device.type === TABLET;
  };

  var isMobileAndTabletType = function isMobileAndTabletType() {
    switch (device.type) {
      case MOBILE:
      case TABLET:
        return true;
      default:
        return false;
    }
  };

  var isEdgeChromiumType = function isEdgeChromiumType() {
    if (os.name === OS_TYPES.WINDOWS && os.version === '10') {
      return typeof ua === 'string' && ua.indexOf('Edg/') !== -1;
    }

    return false;
  };

  var isSmartTVType = function isSmartTVType() {
    return device.type === SMART_TV;
  };
  var isBrowserType = function isBrowserType() {
    return device.type === BROWSER;
  };
  var isWearableType = function isWearableType() {
    return device.type === WEARABLE;
  };
  var isConsoleType = function isConsoleType() {
    return device.type === CONSOLE;
  };
  var isAndroidType = function isAndroidType() {
    return os.name === ANDROID;
  };
  var isWindowsType = function isWindowsType() {
    return os.name === WINDOWS;
  };
  var isMacOsType = function isMacOsType() {
    return os.name === MAC_OS;
  };
  var isWinPhoneType = function isWinPhoneType() {
    return os.name === WINDOWS_PHONE;
  };
  var isIOSType = function isIOSType() {
    return os.name === IOS;
  };
  var isChromeType = function isChromeType() {
    return browser.name === CHROME;
  };
  var isFirefoxType = function isFirefoxType() {
    return browser.name === FIREFOX;
  };
  var isChromiumType = function isChromiumType() {
    return browser.name === CHROMIUM;
  };
  var isEdgeType = function isEdgeType() {
    return browser.name === EDGE;
  };
  var isYandexType = function isYandexType() {
    return browser.name === YANDEX;
  };
  var isSafariType = function isSafariType() {
    return browser.name === SAFARI || browser.name === MOBILE_SAFARI;
  };

  var isMobileSafariType = function isMobileSafariType() {
    return browser.name === MOBILE_SAFARI;
  };
  var isOperaType = function isOperaType() {
    return browser.name === OPERA;
  };
  var isIEType = function isIEType() {
    return browser.name === INTERNET_EXPLORER || browser.name === IE;
  };

  var isElectronType = function isElectronType() {
    var nav = getNavigatorInstance();
    var ua = nav && nav.userAgent.toLowerCase();

    return typeof ua === 'string' ? /electron/.test(ua) : false;
  };

  var getIOS13 = function getIOS13() {
    var nav = getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
  };

  var getIPad13 = function getIPad13() {
    return isIOS13Check('iPad');
  };
  var getIphone13 = function getIphone13() {
    return isIOS13Check('iPhone');
  };
  var getIPod13 = function getIPod13() {
    return isIOS13Check('iPod');
  };

  var getBrowserFullVersion = function getBrowserFullVersion() {
    return browser.major;
  };
  var getBrowserVersion = function getBrowserVersion() {
    return browser.version;
  };
  var getOsVersion = function getOsVersion() {
    return os.version ? os.version : "none";
  };
  var getOsName = function getOsName() {
    return os.name ? os.name : "none";
  };
  var getBrowserName = function getBrowserName() {
    return browser.name;
  };
  var getMobileVendor = function getMobileVendor() {
    return device.vendor ? device.vendor : "none";
  };
  var getMobileModel = function getMobileModel() {
    return device.model ? device.model : "none";
  };
  var getEngineName = function getEngineName() {
    return engine.name;
  };
  var getEngineVersion = function getEngineVersion() {
    return engine.version;
  };
  var getUseragent = function getUseragent() {
    return ua;
  };
  var getDeviceType = function getDeviceType() {
    return device.type;
  };

  var isSmartTV = isSmartTVType();
  var isConsole = isConsoleType();
  var isWearable = isWearableType();
  var isMobileSafari = isMobileSafariType() || getIPad13();
  var isChromium = isChromiumType();
  var isMobile = isMobileAndTabletType() || getIPad13();
  var isMobileOnly = isMobileType();
  var isTablet = isTabletType() || getIPad13();
  var isBrowser = isBrowserType();
  var isAndroid = isAndroidType();
  var isWinPhone = isWinPhoneType();
  var isIOS = isIOSType() || getIPad13();
  var isChrome = isChromeType();
  var isFirefox = isFirefoxType();
  var isSafari = isSafariType();
  var isOpera = isOperaType();
  var isIE = isIEType();
  var osVersion = getOsVersion();
  var osName = getOsName();
  var fullBrowserVersion = getBrowserFullVersion();
  var browserVersion = getBrowserVersion();
  var browserName = getBrowserName();
  var mobileVendor = getMobileVendor();
  var mobileModel = getMobileModel();
  var engineName = getEngineName();
  var engineVersion = getEngineVersion();
  var getUA = getUseragent();
  var isEdge = isEdgeType() || isEdgeChromiumType();
  var isYandex = isYandexType();
  var deviceType = getDeviceType();
  var isIOS13 = getIOS13();
  var isIPad13 = getIPad13();
  var isIPhone13 = getIphone13();
  var isIPod13 = getIPod13();
  var isElectron = isElectronType();
  var isEdgeChromium = isEdgeChromiumType();
  var isLegacyEdge = isEdgeType();
  var isWindows = isWindowsType();
  var isMacOs = isMacOsType();

  var type = checkType(device.type);

  function deviceDetect() {
    var isBrowser = type.isBrowser,
        isMobile = type.isMobile,
        isTablet = type.isTablet,
        isSmartTV = type.isSmartTV,
        isConsole = type.isConsole,
        isWearable = type.isWearable;

    if (isBrowser) {
      return broPayload(isBrowser, browser, engine, os, ua);
    }

    if (isSmartTV) {
      return stvPayload(isSmartTV, engine, os, ua);
    }

    if (isConsole) {
      return consolePayload(isConsole, engine, os, ua);
    }

    if (isMobile) {
      return mobilePayload(type, device, os, ua);
    }

    if (isTablet) {
      return mobilePayload(type, device, os, ua);
    }

    if (isWearable) {
      return wearPayload(isWearable, engine, os, ua);
    }
  };

  module.exports = {
    deviceDetect: deviceDetect,
    isSmartTV: isSmartTV,
    isConsole: isConsole,
    isWearable: isWearable,
    isMobileSafari: isMobileSafari,
    isChromium: isChromium,
    isMobile: isMobile,
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    isBrowser: isBrowser,
    isAndroid: isAndroid,
    isWinPhone: isWinPhone,
    isIOS: isIOS,
    isChrome: isChrome,
    isFirefox: isFirefox,
    isSafari: isSafari,
    isOpera: isOpera,
    isIE: isIE,
    osVersion: osVersion,
    osName: osName,
    fullBrowserVersion: fullBrowserVersion,
    browserVersion: browserVersion,
    browserName: browserName,
    mobileVendor: mobileVendor,
    mobileModel: mobileModel,
    engineName: engineName,
    engineVersion: engineVersion,
    getUA: getUA,
    isEdge: isEdge,
    isYandex: isYandex,
    deviceType: deviceType,
    isIOS13: isIOS13,
    isIPad13: isIPad13,
    isIPhone13: isIPhone13,
    isIPod13: isIPod13,
    isElectron: isElectron,
    isEdgeChromium: isEdgeChromium,
    isLegacyEdge: isLegacyEdge,
    isWindows: isWindows,
    isMacOs: isMacOs
  };

  /***/
},
/* 2 */
/***/function (module, exports, __webpack_require__) {

  var __WEBPACK_AMD_DEFINE_RESULT__; /*!
                                     * UAParser.js v0.7.18
                                     * Lightweight JavaScript-based User-Agent string parser
                                     * https://github.com/faisalman/ua-parser-js
                                     *
                                     * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
                                     * Dual licensed under GPLv2 or MIT
                                     */
  (function (window, undefined) {
    "use strict";
    var LIBVERSION = "0.7.18",
        EMPTY = "",
        UNKNOWN = "?",
        FUNC_TYPE = "function",
        UNDEF_TYPE = "undefined",
        OBJ_TYPE = "object",
        STR_TYPE = "string",
        MAJOR = "major",
        MODEL = "model",
        NAME = "name",
        TYPE = "type",
        VENDOR = "vendor",
        VERSION = "version",
        ARCHITECTURE = "architecture",
        CONSOLE = "console",
        MOBILE = "mobile",
        TABLET = "tablet",
        SMARTTV = "smarttv",
        WEARABLE = "wearable",
        EMBEDDED = "embedded";var util = { extend: function extend(regexes, extensions) {
        var margedRegexes = {};for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            margedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            margedRegexes[i] = regexes[i];
          }
        }return margedRegexes;
      }, has: function has(str1, str2) {
        if (typeof str1 === "string") {
          return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
        } else {
          return false;
        }
      }, lowerize: function lowerize(str) {
        return str.toLowerCase();
      }, major: function major(version) {
        return (typeof version === 'undefined' ? 'undefined' : _typeof(version)) === STR_TYPE ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined;
      }, trim: function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      } };var mapper = { rgx: function rgx(ua, arrays) {
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match;while (i < arrays.length && !matches) {
          var regex = arrays[i],
              props = arrays[i + 1];j = k = 0;while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];q = props[p];if ((typeof q === 'undefined' ? 'undefined' : _typeof(q)) === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (_typeof(q[1]) == FUNC_TYPE) {
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    if (_typeof(q[1]) === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                    } else {
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                  }
                } else {
                  this[q] = match ? match : undefined;
                }
              }
            }
          }i += 2;
        }
      }, str: function str(_str, map) {
        for (var i in map) {
          if (_typeof(map[i]) === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined : i;
          }
        }return _str;
      } };var maps = { browser: { oldsafari: { version: { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" } } }, device: { amazon: { model: { "Fire Phone": ["SD", "KF"] } }, sprint: { model: { "Evo Shift 4G": "7373KT" }, vendor: { HTC: "APA", Sprint: "Sprint" } } }, os: { windows: { version: { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2000: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" } } } };var regexes = { browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i], [[NAME, "Opera Mini"], VERSION], [/\s(opr)\/([\w\.]+)/i], [[NAME, "Opera"], VERSION], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i], [NAME, VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[NAME, "IE"], VERSION], [/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i], [[NAME, "Edge"], VERSION], [/(yabrowser)\/([\w\.]+)/i], [[NAME, "Yandex"], VERSION], [/(puffin)\/([\w\.]+)/i], [[NAME, "Puffin"], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[NAME, "UCBrowser"], VERSION], [/(comodo_dragon)\/([\w\.]+)/i], [[NAME, /_/g, " "], VERSION], [/(micromessenger)\/([\w\.]+)/i], [[NAME, "WeChat"], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(BIDUBrowser)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i], [NAME], [/(LBBROWSER)/i], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [VERSION, [NAME, "Facebook"]], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [VERSION, [NAME, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 WebView"], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, "$1 $2"], VERSION], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [VERSION, [NAME, "Android Browser"]], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i], [[NAME, "Dolphin"], VERSION], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[NAME, "Chrome"], VERSION], [/(coast)\/([\w\.]+)/i], [[NAME, "Opera Coast"], VERSION], [/fxios\/([\w\.-]+)/i], [VERSION, [NAME, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[NAME, "GSA"], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/([\w\.]+)/i, /(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape)\/([\w\.-]+)/i], [[NAME, "Netscape"], VERSION], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [NAME, VERSION]], cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[ARCHITECTURE, /ower/, "", util.lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[ARCHITECTURE, util.lowerize]]], device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/], [MODEL, [VENDOR, "Apple"], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i], [[MODEL, "Apple TV"], [VENDOR, "Apple"]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, "Amazon"], [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i], [MODEL, [VENDOR, "Apple"], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i], [MODEL, [VENDOR, "BlackBerry"], [TYPE, MOBILE]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i], [MODEL, [VENDOR, "Asus"], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, "Sony"], [MODEL, "Xperia Tablet"], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i], [MODEL, [VENDOR, "Sony"], [TYPE, MOBILE]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i], [MODEL, [VENDOR, "Sony"], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/(nexus\s9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i], [MODEL, [VENDOR, "Huawei"], [TYPE, MOBILE]], [/(microsoft);\s(lumia[\s\w]+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [MODEL, [VENDOR, "Microsoft"], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, "Microsoft"], [TYPE, MOBILE]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, "Motorola"], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, "Motorola"], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, "Samsung"], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i], [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, TABLET]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, "Nokia"], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w;-]{10}(a\d{3})/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[VENDOR, "LG"], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, MOBILE]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [/linux;.+((jolla));/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i], [[MODEL, "Chromecast"], [VENDOR, "Google"]], [/android.+;\s(glass)\s\d/i], [MODEL, [VENDOR, "Google"], [TYPE, WEARABLE]], [/android.+;\s(pixel c)\s/i], [MODEL, [VENDOR, "Google"], [TYPE, TABLET]], [/android.+;\s(pixel xl|pixel)\s/i], [MODEL, [VENDOR, "Google"], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [MODEL, [VENDOR, "Meizu"], [TYPE, TABLET]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[VENDOR, "Barnes & Noble"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[TYPE, util.lowerize], VENDOR, MODEL], [/(android[\w\.\s\-]{0,9});.+build/i], [MODEL, [VENDOR, "Generic"]]], engine: [[/windows.+\sedge\/([\w\.]+)/i], [VERSION, [NAME, "EdgeHTML"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i], [VERSION, NAME]], os: [[/microsoft\s(windows)\s(vista|xp)/i], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, mapper.str, maps.os.windows.version]], [/\((bb)(10);/i], [[NAME, "BlackBerry"], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i, /linux;.+(sailfish);/i], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[NAME, "Symbian"], VERSION], [/\((series40);/i], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[NAME, "Firefox OS"], VERSION], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[NAME, "Chromium OS"], VERSION], [/(sunos)\s?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [NAME, VERSION], [/(haiku)\s(\w+)/i], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i, /(unix)\s?([\w\.]*)/i], [NAME, VERSION]] };var UAParser = function UAParser(uastring, extensions) {
      if ((typeof uastring === 'undefined' ? 'undefined' : _typeof(uastring)) === "object") {
        extensions = uastring;uastring = undefined;
      }if (!(this instanceof UAParser)) {
        return new UAParser(uastring, extensions).getResult();
      }var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;this.getBrowser = function () {
        var browser = { name: undefined, version: undefined };mapper.rgx.call(browser, ua, rgxmap.browser);browser.major = util.major(browser.version);return browser;
      };this.getCPU = function () {
        var cpu = { architecture: undefined };mapper.rgx.call(cpu, ua, rgxmap.cpu);return cpu;
      };this.getDevice = function () {
        var device = { vendor: undefined, model: undefined, type: undefined };mapper.rgx.call(device, ua, rgxmap.device);return device;
      };this.getEngine = function () {
        var engine = { name: undefined, version: undefined };mapper.rgx.call(engine, ua, rgxmap.engine);return engine;
      };this.getOS = function () {
        var os = { name: undefined, version: undefined };mapper.rgx.call(os, ua, rgxmap.os);return os;
      };this.getResult = function () {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      };this.getUA = function () {
        return ua;
      };this.setUA = function (uastring) {
        ua = uastring;return this;
      };return this;
    };UAParser.VERSION = LIBVERSION;UAParser.BROWSER = { NAME: NAME, MAJOR: MAJOR, VERSION: VERSION };UAParser.CPU = { ARCHITECTURE: ARCHITECTURE };UAParser.DEVICE = { MODEL: MODEL, VENDOR: VENDOR, TYPE: TYPE, CONSOLE: CONSOLE, MOBILE: MOBILE, SMARTTV: SMARTTV, TABLET: TABLET, WEARABLE: WEARABLE, EMBEDDED: EMBEDDED };UAParser.ENGINE = { NAME: NAME, VERSION: VERSION };UAParser.OS = { NAME: NAME, VERSION: VERSION };if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) !== UNDEF_TYPE) {
      if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) !== UNDEF_TYPE && module.exports) {
        exports = module.exports = UAParser;
      }exports.UAParser = UAParser;
    } else {
      if ("function" === FUNC_TYPE && __webpack_require__(3)) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
          return UAParser;
        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else if (window) {
        window.UAParser = UAParser;
      }
    }var $ = window && (window.jQuery || window.Zepto);if ((typeof $ === 'undefined' ? 'undefined' : _typeof($)) !== UNDEF_TYPE) {
      var parser = new UAParser();$.ua = parser.getResult();$.ua.get = function () {
        return parser.getUA();
      };$.ua.set = function (uastring) {
        parser.setUA(uastring);var result = parser.getResult();for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object" ? window : this);

  /***/
},
/* 3 */
/***/function (module, exports) {

  /* WEBPACK VAR INJECTION */(function (__webpack_amd_options__) {
    /* globals __webpack_amd_options__ */
    module.exports = __webpack_amd_options__;

    /* WEBPACK VAR INJECTION */
  }).call(exports, {});

  /***/
},
/* 4 */
/***/function (module, exports, __webpack_require__) {

  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };

  var _require = __webpack_require__(0),
      DEVICE_TYPES = _require.DEVICE_TYPES,
      defaultData = _require.defaultData;

  var checkType = function checkType(type) {
    switch (type) {
      case DEVICE_TYPES.MOBILE:
        return { isMobile: true };
      case DEVICE_TYPES.TABLET:
        return { isTablet: true };
      case DEVICE_TYPES.SMART_TV:
        return { isSmartTV: true };
      case DEVICE_TYPES.CONSOLE:
        return { isConsole: true };
      case DEVICE_TYPES.WEARABLE:
        return { isWearable: true };
      case DEVICE_TYPES.BROWSER:
        return { isBrowser: true };
      default:
        return defaultData;
    }
  };

  var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
    return {
      isBrowser: isBrowser,
      browserMajorVersion: browser.major,
      browserFullVersion: browser.version,
      browserName: browser.name,
      engineName: engine.name || false,
      engineVersion: engine.version,
      osName: os.name,
      osVersion: os.version,
      userAgent: ua
    };
  };

  var mobilePayload = function mobilePayload(type, device, os, ua) {
    return _extends({}, type, {
      vendor: device.vendor,
      model: device.model,
      os: os.name,
      osVersion: os.version,
      ua: ua
    });
  };

  var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
    return {
      isSmartTV: isSmartTV,
      engineName: engine.name,
      engineVersion: engine.version,
      osName: os.name,
      osVersion: os.version,
      userAgent: ua
    };
  };

  var consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
      isConsole: isConsole,
      engineName: engine.name,
      engineVersion: engine.version,
      osName: os.name,
      osVersion: os.version,
      userAgent: ua
    };
  };

  var wearPayload = function wearPayload(isWearable, engine, os, ua) {
    return {
      isWearable: isWearable,
      engineName: engine.name,
      engineVersion: engine.version,
      osName: os.name,
      osVersion: os.version,
      userAgent: ua
    };
  };

  var getNavigatorInstance = exports.getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
      if (window.navigator || navigator) {
        return window.navigator || navigator;
      }
    }

    return false;
  };

  var isIOS13Check = exports.isIOS13Check = function isIOS13Check(type) {
    var nav = getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
  };

  module.exports = {
    checkType: checkType,
    broPayload: broPayload,
    mobilePayload: mobilePayload,
    stvPayload: stvPayload,
    consolePayload: consolePayload,
    wearPayload: wearPayload,
    getNavigatorInstance: getNavigatorInstance,
    isIOS13Check: isIOS13Check
  };

  /***/
}]
/******/);

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(51)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(25);
var setDesc = __webpack_require__(15).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(10)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(12)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(22)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 49 */,
/* 50 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(173);
var enumBugKeys = __webpack_require__(119);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(8);
var dPs = __webpack_require__(174);
var enumBugKeys = __webpack_require__(119);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(116)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(120).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(173);
var hiddenKeys = __webpack_require__(119).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(9);
var dP = __webpack_require__(15);
var DESCRIPTORS = __webpack_require__(14);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function get() {
      return this;
    }
  });
};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
    throw TypeError(name + ': incorrect invocation!');
  }return it;
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var call = __webpack_require__(186);
var isArrayIter = __webpack_require__(131);
var anObject = __webpack_require__(8);
var toLength = __webpack_require__(13);
var getIterFn = __webpack_require__(133);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () {
    return iterable;
  } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(23);
module.exports = function (target, src, safe) {
  for (var key in src) {
    redefine(target, key, src[key], safe);
  }return target;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
exports.default = {
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(80)(function () {
  return Object.defineProperty({}, 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).f;
var has = __webpack_require__(25);
var TAG = __webpack_require__(12)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(31);
var TAG = __webpack_require__(12)('toStringTag');
// ES3 wrong here
var ARG = cof(function () {
  return arguments;
}()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function tryGet(it, key) {
  try {
    return it[key];
  } catch (e) {/* empty */}
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
  // @@toStringTag case
  : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
  // builtinTag case
  : ARG ? cof(O)
  // ES3 arguments fallback
  : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var defined = __webpack_require__(35);
var fails = __webpack_require__(10);
var spaces = __webpack_require__(122);
var space = '[' + spaces + ']';
var non = '\u200B\x85';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function exporter(KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var createDesc = __webpack_require__(104);
module.exports = __webpack_require__(62) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(103);
var IE8_DOM_DEFINE = __webpack_require__(296);
var toPrimitive = __webpack_require__(156);
var dP = Object.defineProperty;

exports.f = __webpack_require__(62) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(299);
var defined = __webpack_require__(157);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(160)('wks');
var uid = __webpack_require__(107);
var _Symbol = __webpack_require__(48).Symbol;
var USE_SYMBOL = typeof _Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(29);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(45) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(31);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 75 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags

var anObject = __webpack_require__(8);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(19);
var SPECIES = __webpack_require__(12)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 79 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(215);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_816beba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(992);
function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_816beba0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(13);
var toAbsoluteIndex = __webpack_require__(53);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(31);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(32);
var defined = __webpack_require__(35);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(11);
var cof = __webpack_require__(31);
var MATCH = __webpack_require__(12)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(12)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () {
    SAFE_CLOSING = true;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () {
    throw 2;
  });
} catch (e) {/* empty */}

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () {
      return { done: safe = true };
    };
    arr[ITERATOR] = function () {
      return iter;
    };
    exec(arr);
  } catch (e) {/* empty */}
  return safe;
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var classof = __webpack_require__(65);
var builtinExec = RegExp.prototype.exec;

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(190);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var fails = __webpack_require__(10);
var defined = __webpack_require__(35);
var wks = __webpack_require__(12);
var regexpExec = __webpack_require__(137);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () {
    return originalExec.apply(this, arguments);
  };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
}();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () {
      return 7;
    };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () {
      execCalled = true;return null;
    };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () {
        return re;
      };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
    // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
    // 21.2.5.11 RegExp.prototype[@@split](string, limit)
    ? function (string, arg) {
      return rxfn.call(string, this, arg);
    }
    // 21.2.5.6 RegExp.prototype[@@match](string)
    // 21.2.5.9 RegExp.prototype[@@search](string)
    : function (string) {
      return rxfn.call(string, this);
    });
  }
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var redefineAll = __webpack_require__(59);
var meta = __webpack_require__(46);
var forOf = __webpack_require__(58);
var anInstance = __webpack_require__(57);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var $iterDetect = __webpack_require__(87);
var setToStringTag = __webpack_require__(64);
var inheritIfRequired = __webpack_require__(123);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function fixMethod(KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY, KEY == 'delete' ? function (a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'has' ? function has(a) {
      return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'get' ? function get(a) {
      return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
    } : KEY == 'add' ? function add(a) {
      fn.call(this, a === 0 ? 0 : a);return this;
    } : function set(a, b) {
      fn.call(this, a === 0 ? 0 : a, b);return this;
    });
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () {
      instance.has(1);
    });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) {
      new C(iter);
    }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) {
        $instance[ADDER](index, index);
      }return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(22);
var uid = __webpack_require__(51);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods

module.exports = __webpack_require__(45) || !__webpack_require__(10)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () {/* empty */});
  delete __webpack_require__(9)[K];
});

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/

var $export = __webpack_require__(1);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
      var length = arguments.length;
      var A = new Array(length);
      while (length--) {
        A[length] = arguments[length];
      }return new this(A);
    } });
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/

var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var ctx = __webpack_require__(30);
var forOf = __webpack_require__(58);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
      var mapFn = arguments[1];
      var mapping, A, n, cb;
      aFunction(this);
      mapping = mapFn !== undefined;
      if (mapping) aFunction(mapFn);
      if (source == undefined) return new this();
      A = [];
      if (mapping) {
        n = 0;
        cb = ctx(mapFn, arguments[2], 2);
        forOf(source, false, function (nextItem) {
          A.push(cb(nextItem, n++));
        });
      } else {
        forOf(source, false, A.push, A);
      }
      return new this(A);
    } });
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eta.png?cdcc2318f972486b79869ed490e44d22";

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(20);
var normalizeHeaderName = __webpack_require__(1006);
var enhanceError = __webpack_require__(230);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(231);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(231);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(207)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _popup = __webpack_require__(288);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var PopperJS = _vue2.default.prototype.$isServer ? function () {} : __webpack_require__(1209);
var stop = function stop(e) {
  return e.stopPropagation();
};

/**
 * @param {HTMLElement} [reference=$refs.reference] - The reference element used to position the popper.
 * @param {HTMLElement} [popper=$refs.popper] - The HTML element used as popper, or a configuration used to generate the popper.
 * @param {String} [placement=button] - Placement of the popper accepted values: top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
 * @param {Number} [offset=0] - Amount of pixels the popper will be shifted (can be negative).
 * @param {Boolean} [visible=false] Visibility of the popup element.
 * @param {Boolean} [visible-arrow=false] Visibility of the arrow, no style.
 */
exports.default = {
  props: {
    transformOrigin: {
      type: [Boolean, String],
      default: true
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    boundariesPadding: {
      type: Number,
      default: 5
    },
    reference: {},
    popper: {},
    offset: {
      default: 0
    },
    value: Boolean,
    visibleArrow: Boolean,
    arrowOffset: {
      type: Number,
      default: 35
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return {
          gpuAcceleration: false
        };
      }
    }
  },

  data: function data() {
    return {
      showPopper: false,
      currentPlacement: ''
    };
  },

  watch: {
    value: {
      immediate: true,
      handler: function handler(val) {
        this.showPopper = val;
        this.$emit('input', val);
      }
    },

    showPopper: function showPopper(val) {
      if (this.disabled) return;
      val ? this.updatePopper() : this.destroyPopper();
      this.$emit('input', val);
    }
  },

  methods: {
    createPopper: function createPopper() {
      var _this = this;

      if (this.$isServer) return;
      this.currentPlacement = this.currentPlacement || this.placement;
      if (!/^(top|bottom|left|right)(-start|-end)?$/g.test(this.currentPlacement)) {
        return;
      }

      var options = this.popperOptions;
      var popper = this.popperElm = this.popperElm || this.popper || this.$refs.popper;
      var reference = this.referenceElm = this.referenceElm || this.reference || this.$refs.reference;

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm;
      }

      if (!popper || !reference) return;
      if (this.visibleArrow) this.appendArrow(popper);
      if (this.appendToBody) document.body.appendChild(this.popperElm);
      if (this.popperJS && this.popperJS.destroy) {
        this.popperJS.destroy();
      }

      options.placement = this.currentPlacement;
      options.offset = this.offset;
      options.arrowOffset = this.arrowOffset;
      this.popperJS = new PopperJS(reference, popper, options);
      this.popperJS.onCreate(function (_) {
        _this.$emit('created', _this);
        _this.resetTransformOrigin();
        _this.$nextTick(_this.updatePopper);
      });
      if (typeof options.onUpdate === 'function') {
        this.popperJS.onUpdate(options.onUpdate);
      }
      this.popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
      this.popperElm.addEventListener('click', stop);
    },
    updatePopper: function updatePopper() {
      var popperJS = this.popperJS;
      if (popperJS) {
        popperJS.update();
        if (popperJS._popper) {
          popperJS._popper.style.zIndex = _popup.PopupManager.nextZIndex();
        }
      } else {
        this.createPopper();
      }
    },
    doDestroy: function doDestroy(forceDestroy) {
      /* istanbul ignore if */
      if (!this.popperJS || this.showPopper && !forceDestroy) return;
      this.popperJS.destroy();
      this.popperJS = null;
    },
    destroyPopper: function destroyPopper() {
      if (this.popperJS) {
        this.resetTransformOrigin();
      }
    },
    resetTransformOrigin: function resetTransformOrigin() {
      if (!this.transformOrigin) return;
      var placementMap = {
        top: 'bottom',
        bottom: 'top',
        left: 'right',
        right: 'left'
      };
      var placement = this.popperJS._popper.getAttribute('x-placement').split('-')[0];
      var origin = placementMap[placement];
      this.popperJS._popper.style.transformOrigin = typeof this.transformOrigin === 'string' ? this.transformOrigin : ['top', 'bottom'].indexOf(placement) > -1 ? 'center ' + origin : origin + ' center';
    },
    appendArrow: function appendArrow(element) {
      var hash = void 0;
      if (this.appended) {
        return;
      }

      this.appended = true;

      for (var item in element.attributes) {
        if (/^_v-/.test(element.attributes[item].name)) {
          hash = element.attributes[item].name;
          break;
        }
      }

      var arrow = document.createElement('div');

      if (hash) {
        arrow.setAttribute(hash, '');
      }
      arrow.setAttribute('x-arrow', '');
      arrow.className = 'popper__arrow';
      element.appendChild(arrow);
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.doDestroy(true);
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },

  // call destroy in keep-alive mode
  deactivated: function deactivated() {
    this.$options.beforeDestroy[0].call(this);
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
};

;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isDef = isDef;
exports.isKorean = isKorean;
function isDef(val) {
  return val !== undefined && val !== null;
}
function isKorean(text) {
  var reg = /([(\uAC00-\uD7AF)|(\u3130-\u318F)])+/gi;
  return reg.test(text);
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-undefined */

var throttle = __webpack_require__(150);

/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {Number}   delay         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}  [atBegin]     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @return {Function} A new, debounced function.
 */
module.exports = function (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(79);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(298);
var enumBugKeys = __webpack_require__(161);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _iterator = __webpack_require__(1237);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1249);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && _typeof2(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
	( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(function () {
		try {
			return __webpack_require__(0);
		} catch (e) {}
	}()) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__], __WEBPACK_AMD_DEFINE_RESULT__ = (function (require) {
		return factory(function () {
			try {
				return __webpack_require__(0);
			} catch (e) {}
		}());
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : (global = global || self, global.Chart = factory(global.moment));
})(this, function (moment) {
	'use strict';

	moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace(n) {
		return n && n['default'] || n;
	}

	var colorName = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

	var conversions = createCommonjsModule(function (module) {
		/* MIT license */

		// NOTE: conversions should only return primitive values (i.e. arrays, or
		//       values that give correct `typeof` results).
		//       do not use box values types (i.e. Number(), String(), etc.)

		var reverseKeywords = {};
		for (var key in colorName) {
			if (colorName.hasOwnProperty(key)) {
				reverseKeywords[colorName[key]] = key;
			}
		}

		var convert = module.exports = {
			rgb: { channels: 3, labels: 'rgb' },
			hsl: { channels: 3, labels: 'hsl' },
			hsv: { channels: 3, labels: 'hsv' },
			hwb: { channels: 3, labels: 'hwb' },
			cmyk: { channels: 4, labels: 'cmyk' },
			xyz: { channels: 3, labels: 'xyz' },
			lab: { channels: 3, labels: 'lab' },
			lch: { channels: 3, labels: 'lch' },
			hex: { channels: 1, labels: ['hex'] },
			keyword: { channels: 1, labels: ['keyword'] },
			ansi16: { channels: 1, labels: ['ansi16'] },
			ansi256: { channels: 1, labels: ['ansi256'] },
			hcg: { channels: 3, labels: ['h', 'c', 'g'] },
			apple: { channels: 3, labels: ['r16', 'g16', 'b16'] },
			gray: { channels: 1, labels: ['gray'] }
		};

		// hide .channels and .labels properties
		for (var model in convert) {
			if (convert.hasOwnProperty(model)) {
				if (!('channels' in convert[model])) {
					throw new Error('missing channels property: ' + model);
				}

				if (!('labels' in convert[model])) {
					throw new Error('missing channel labels property: ' + model);
				}

				if (convert[model].labels.length !== convert[model].channels) {
					throw new Error('channel and label counts mismatch: ' + model);
				}

				var channels = convert[model].channels;
				var labels = convert[model].labels;
				delete convert[model].channels;
				delete convert[model].labels;
				Object.defineProperty(convert[model], 'channels', { value: channels });
				Object.defineProperty(convert[model], 'labels', { value: labels });
			}
		}

		convert.rgb.hsl = function (rgb) {
			var r = rgb[0] / 255;
			var g = rgb[1] / 255;
			var b = rgb[2] / 255;
			var min = Math.min(r, g, b);
			var max = Math.max(r, g, b);
			var delta = max - min;
			var h;
			var s;
			var l;

			if (max === min) {
				h = 0;
			} else if (r === max) {
				h = (g - b) / delta;
			} else if (g === max) {
				h = 2 + (b - r) / delta;
			} else if (b === max) {
				h = 4 + (r - g) / delta;
			}

			h = Math.min(h * 60, 360);

			if (h < 0) {
				h += 360;
			}

			l = (min + max) / 2;

			if (max === min) {
				s = 0;
			} else if (l <= 0.5) {
				s = delta / (max + min);
			} else {
				s = delta / (2 - max - min);
			}

			return [h, s * 100, l * 100];
		};

		convert.rgb.hsv = function (rgb) {
			var rdif;
			var gdif;
			var bdif;
			var h;
			var s;

			var r = rgb[0] / 255;
			var g = rgb[1] / 255;
			var b = rgb[2] / 255;
			var v = Math.max(r, g, b);
			var diff = v - Math.min(r, g, b);
			var diffc = function diffc(c) {
				return (v - c) / 6 / diff + 1 / 2;
			};

			if (diff === 0) {
				h = s = 0;
			} else {
				s = diff / v;
				rdif = diffc(r);
				gdif = diffc(g);
				bdif = diffc(b);

				if (r === v) {
					h = bdif - gdif;
				} else if (g === v) {
					h = 1 / 3 + rdif - bdif;
				} else if (b === v) {
					h = 2 / 3 + gdif - rdif;
				}
				if (h < 0) {
					h += 1;
				} else if (h > 1) {
					h -= 1;
				}
			}

			return [h * 360, s * 100, v * 100];
		};

		convert.rgb.hwb = function (rgb) {
			var r = rgb[0];
			var g = rgb[1];
			var b = rgb[2];
			var h = convert.rgb.hsl(rgb)[0];
			var w = 1 / 255 * Math.min(r, Math.min(g, b));

			b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));

			return [h, w * 100, b * 100];
		};

		convert.rgb.cmyk = function (rgb) {
			var r = rgb[0] / 255;
			var g = rgb[1] / 255;
			var b = rgb[2] / 255;
			var c;
			var m;
			var y;
			var k;

			k = Math.min(1 - r, 1 - g, 1 - b);
			c = (1 - r - k) / (1 - k) || 0;
			m = (1 - g - k) / (1 - k) || 0;
			y = (1 - b - k) / (1 - k) || 0;

			return [c * 100, m * 100, y * 100, k * 100];
		};

		/**
   * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
   * */
		function comparativeDistance(x, y) {
			return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
		}

		convert.rgb.keyword = function (rgb) {
			var reversed = reverseKeywords[rgb];
			if (reversed) {
				return reversed;
			}

			var currentClosestDistance = Infinity;
			var currentClosestKeyword;

			for (var keyword in colorName) {
				if (colorName.hasOwnProperty(keyword)) {
					var value = colorName[keyword];

					// Compute comparative distance
					var distance = comparativeDistance(rgb, value);

					// Check if its less, if so set as closest
					if (distance < currentClosestDistance) {
						currentClosestDistance = distance;
						currentClosestKeyword = keyword;
					}
				}
			}

			return currentClosestKeyword;
		};

		convert.keyword.rgb = function (keyword) {
			return colorName[keyword];
		};

		convert.rgb.xyz = function (rgb) {
			var r = rgb[0] / 255;
			var g = rgb[1] / 255;
			var b = rgb[2] / 255;

			// assume sRGB
			r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
			g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
			b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

			var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
			var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
			var z = r * 0.0193 + g * 0.1192 + b * 0.9505;

			return [x * 100, y * 100, z * 100];
		};

		convert.rgb.lab = function (rgb) {
			var xyz = convert.rgb.xyz(rgb);
			var x = xyz[0];
			var y = xyz[1];
			var z = xyz[2];
			var l;
			var a;
			var b;

			x /= 95.047;
			y /= 100;
			z /= 108.883;

			x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
			y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
			z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

			l = 116 * y - 16;
			a = 500 * (x - y);
			b = 200 * (y - z);

			return [l, a, b];
		};

		convert.hsl.rgb = function (hsl) {
			var h = hsl[0] / 360;
			var s = hsl[1] / 100;
			var l = hsl[2] / 100;
			var t1;
			var t2;
			var t3;
			var rgb;
			var val;

			if (s === 0) {
				val = l * 255;
				return [val, val, val];
			}

			if (l < 0.5) {
				t2 = l * (1 + s);
			} else {
				t2 = l + s - l * s;
			}

			t1 = 2 * l - t2;

			rgb = [0, 0, 0];
			for (var i = 0; i < 3; i++) {
				t3 = h + 1 / 3 * -(i - 1);
				if (t3 < 0) {
					t3++;
				}
				if (t3 > 1) {
					t3--;
				}

				if (6 * t3 < 1) {
					val = t1 + (t2 - t1) * 6 * t3;
				} else if (2 * t3 < 1) {
					val = t2;
				} else if (3 * t3 < 2) {
					val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
				} else {
					val = t1;
				}

				rgb[i] = val * 255;
			}

			return rgb;
		};

		convert.hsl.hsv = function (hsl) {
			var h = hsl[0];
			var s = hsl[1] / 100;
			var l = hsl[2] / 100;
			var smin = s;
			var lmin = Math.max(l, 0.01);
			var sv;
			var v;

			l *= 2;
			s *= l <= 1 ? l : 2 - l;
			smin *= lmin <= 1 ? lmin : 2 - lmin;
			v = (l + s) / 2;
			sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);

			return [h, sv * 100, v * 100];
		};

		convert.hsv.rgb = function (hsv) {
			var h = hsv[0] / 60;
			var s = hsv[1] / 100;
			var v = hsv[2] / 100;
			var hi = Math.floor(h) % 6;

			var f = h - Math.floor(h);
			var p = 255 * v * (1 - s);
			var q = 255 * v * (1 - s * f);
			var t = 255 * v * (1 - s * (1 - f));
			v *= 255;

			switch (hi) {
				case 0:
					return [v, t, p];
				case 1:
					return [q, v, p];
				case 2:
					return [p, v, t];
				case 3:
					return [p, q, v];
				case 4:
					return [t, p, v];
				case 5:
					return [v, p, q];
			}
		};

		convert.hsv.hsl = function (hsv) {
			var h = hsv[0];
			var s = hsv[1] / 100;
			var v = hsv[2] / 100;
			var vmin = Math.max(v, 0.01);
			var lmin;
			var sl;
			var l;

			l = (2 - s) * v;
			lmin = (2 - s) * vmin;
			sl = s * vmin;
			sl /= lmin <= 1 ? lmin : 2 - lmin;
			sl = sl || 0;
			l /= 2;

			return [h, sl * 100, l * 100];
		};

		// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
		convert.hwb.rgb = function (hwb) {
			var h = hwb[0] / 360;
			var wh = hwb[1] / 100;
			var bl = hwb[2] / 100;
			var ratio = wh + bl;
			var i;
			var v;
			var f;
			var n;

			// wh + bl cant be > 1
			if (ratio > 1) {
				wh /= ratio;
				bl /= ratio;
			}

			i = Math.floor(6 * h);
			v = 1 - bl;
			f = 6 * h - i;

			if ((i & 0x01) !== 0) {
				f = 1 - f;
			}

			n = wh + f * (v - wh); // linear interpolation

			var r;
			var g;
			var b;
			switch (i) {
				default:
				case 6:
				case 0:
					r = v;g = n;b = wh;break;
				case 1:
					r = n;g = v;b = wh;break;
				case 2:
					r = wh;g = v;b = n;break;
				case 3:
					r = wh;g = n;b = v;break;
				case 4:
					r = n;g = wh;b = v;break;
				case 5:
					r = v;g = wh;b = n;break;
			}

			return [r * 255, g * 255, b * 255];
		};

		convert.cmyk.rgb = function (cmyk) {
			var c = cmyk[0] / 100;
			var m = cmyk[1] / 100;
			var y = cmyk[2] / 100;
			var k = cmyk[3] / 100;
			var r;
			var g;
			var b;

			r = 1 - Math.min(1, c * (1 - k) + k);
			g = 1 - Math.min(1, m * (1 - k) + k);
			b = 1 - Math.min(1, y * (1 - k) + k);

			return [r * 255, g * 255, b * 255];
		};

		convert.xyz.rgb = function (xyz) {
			var x = xyz[0] / 100;
			var y = xyz[1] / 100;
			var z = xyz[2] / 100;
			var r;
			var g;
			var b;

			r = x * 3.2406 + y * -1.5372 + z * -0.4986;
			g = x * -0.9689 + y * 1.8758 + z * 0.0415;
			b = x * 0.0557 + y * -0.2040 + z * 1.0570;

			// assume sRGB
			r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;

			g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;

			b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;

			r = Math.min(Math.max(0, r), 1);
			g = Math.min(Math.max(0, g), 1);
			b = Math.min(Math.max(0, b), 1);

			return [r * 255, g * 255, b * 255];
		};

		convert.xyz.lab = function (xyz) {
			var x = xyz[0];
			var y = xyz[1];
			var z = xyz[2];
			var l;
			var a;
			var b;

			x /= 95.047;
			y /= 100;
			z /= 108.883;

			x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
			y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
			z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

			l = 116 * y - 16;
			a = 500 * (x - y);
			b = 200 * (y - z);

			return [l, a, b];
		};

		convert.lab.xyz = function (lab) {
			var l = lab[0];
			var a = lab[1];
			var b = lab[2];
			var x;
			var y;
			var z;

			y = (l + 16) / 116;
			x = a / 500 + y;
			z = y - b / 200;

			var y2 = Math.pow(y, 3);
			var x2 = Math.pow(x, 3);
			var z2 = Math.pow(z, 3);
			y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
			x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
			z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;

			x *= 95.047;
			y *= 100;
			z *= 108.883;

			return [x, y, z];
		};

		convert.lab.lch = function (lab) {
			var l = lab[0];
			var a = lab[1];
			var b = lab[2];
			var hr;
			var h;
			var c;

			hr = Math.atan2(b, a);
			h = hr * 360 / 2 / Math.PI;

			if (h < 0) {
				h += 360;
			}

			c = Math.sqrt(a * a + b * b);

			return [l, c, h];
		};

		convert.lch.lab = function (lch) {
			var l = lch[0];
			var c = lch[1];
			var h = lch[2];
			var a;
			var b;
			var hr;

			hr = h / 360 * 2 * Math.PI;
			a = c * Math.cos(hr);
			b = c * Math.sin(hr);

			return [l, a, b];
		};

		convert.rgb.ansi16 = function (args) {
			var r = args[0];
			var g = args[1];
			var b = args[2];
			var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

			value = Math.round(value / 50);

			if (value === 0) {
				return 30;
			}

			var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));

			if (value === 2) {
				ansi += 60;
			}

			return ansi;
		};

		convert.hsv.ansi16 = function (args) {
			// optimization here; we already know the value and don't need to get
			// it converted for us.
			return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
		};

		convert.rgb.ansi256 = function (args) {
			var r = args[0];
			var g = args[1];
			var b = args[2];

			// we use the extended greyscale palette here, with the exception of
			// black and white. normal palette only has 4 greyscale shades.
			if (r === g && g === b) {
				if (r < 8) {
					return 16;
				}

				if (r > 248) {
					return 231;
				}

				return Math.round((r - 8) / 247 * 24) + 232;
			}

			var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);

			return ansi;
		};

		convert.ansi16.rgb = function (args) {
			var color = args % 10;

			// handle greyscale
			if (color === 0 || color === 7) {
				if (args > 50) {
					color += 3.5;
				}

				color = color / 10.5 * 255;

				return [color, color, color];
			}

			var mult = (~~(args > 50) + 1) * 0.5;
			var r = (color & 1) * mult * 255;
			var g = (color >> 1 & 1) * mult * 255;
			var b = (color >> 2 & 1) * mult * 255;

			return [r, g, b];
		};

		convert.ansi256.rgb = function (args) {
			// handle greyscale
			if (args >= 232) {
				var c = (args - 232) * 10 + 8;
				return [c, c, c];
			}

			args -= 16;

			var rem;
			var r = Math.floor(args / 36) / 5 * 255;
			var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
			var b = rem % 6 / 5 * 255;

			return [r, g, b];
		};

		convert.rgb.hex = function (args) {
			var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);

			var string = integer.toString(16).toUpperCase();
			return '000000'.substring(string.length) + string;
		};

		convert.hex.rgb = function (args) {
			var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
			if (!match) {
				return [0, 0, 0];
			}

			var colorString = match[0];

			if (match[0].length === 3) {
				colorString = colorString.split('').map(function (char) {
					return char + char;
				}).join('');
			}

			var integer = parseInt(colorString, 16);
			var r = integer >> 16 & 0xFF;
			var g = integer >> 8 & 0xFF;
			var b = integer & 0xFF;

			return [r, g, b];
		};

		convert.rgb.hcg = function (rgb) {
			var r = rgb[0] / 255;
			var g = rgb[1] / 255;
			var b = rgb[2] / 255;
			var max = Math.max(Math.max(r, g), b);
			var min = Math.min(Math.min(r, g), b);
			var chroma = max - min;
			var grayscale;
			var hue;

			if (chroma < 1) {
				grayscale = min / (1 - chroma);
			} else {
				grayscale = 0;
			}

			if (chroma <= 0) {
				hue = 0;
			} else if (max === r) {
				hue = (g - b) / chroma % 6;
			} else if (max === g) {
				hue = 2 + (b - r) / chroma;
			} else {
				hue = 4 + (r - g) / chroma + 4;
			}

			hue /= 6;
			hue %= 1;

			return [hue * 360, chroma * 100, grayscale * 100];
		};

		convert.hsl.hcg = function (hsl) {
			var s = hsl[1] / 100;
			var l = hsl[2] / 100;
			var c = 1;
			var f = 0;

			if (l < 0.5) {
				c = 2.0 * s * l;
			} else {
				c = 2.0 * s * (1.0 - l);
			}

			if (c < 1.0) {
				f = (l - 0.5 * c) / (1.0 - c);
			}

			return [hsl[0], c * 100, f * 100];
		};

		convert.hsv.hcg = function (hsv) {
			var s = hsv[1] / 100;
			var v = hsv[2] / 100;

			var c = s * v;
			var f = 0;

			if (c < 1.0) {
				f = (v - c) / (1 - c);
			}

			return [hsv[0], c * 100, f * 100];
		};

		convert.hcg.rgb = function (hcg) {
			var h = hcg[0] / 360;
			var c = hcg[1] / 100;
			var g = hcg[2] / 100;

			if (c === 0.0) {
				return [g * 255, g * 255, g * 255];
			}

			var pure = [0, 0, 0];
			var hi = h % 1 * 6;
			var v = hi % 1;
			var w = 1 - v;
			var mg = 0;

			switch (Math.floor(hi)) {
				case 0:
					pure[0] = 1;pure[1] = v;pure[2] = 0;break;
				case 1:
					pure[0] = w;pure[1] = 1;pure[2] = 0;break;
				case 2:
					pure[0] = 0;pure[1] = 1;pure[2] = v;break;
				case 3:
					pure[0] = 0;pure[1] = w;pure[2] = 1;break;
				case 4:
					pure[0] = v;pure[1] = 0;pure[2] = 1;break;
				default:
					pure[0] = 1;pure[1] = 0;pure[2] = w;
			}

			mg = (1.0 - c) * g;

			return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
		};

		convert.hcg.hsv = function (hcg) {
			var c = hcg[1] / 100;
			var g = hcg[2] / 100;

			var v = c + g * (1.0 - c);
			var f = 0;

			if (v > 0.0) {
				f = c / v;
			}

			return [hcg[0], f * 100, v * 100];
		};

		convert.hcg.hsl = function (hcg) {
			var c = hcg[1] / 100;
			var g = hcg[2] / 100;

			var l = g * (1.0 - c) + 0.5 * c;
			var s = 0;

			if (l > 0.0 && l < 0.5) {
				s = c / (2 * l);
			} else if (l >= 0.5 && l < 1.0) {
				s = c / (2 * (1 - l));
			}

			return [hcg[0], s * 100, l * 100];
		};

		convert.hcg.hwb = function (hcg) {
			var c = hcg[1] / 100;
			var g = hcg[2] / 100;
			var v = c + g * (1.0 - c);
			return [hcg[0], (v - c) * 100, (1 - v) * 100];
		};

		convert.hwb.hcg = function (hwb) {
			var w = hwb[1] / 100;
			var b = hwb[2] / 100;
			var v = 1 - b;
			var c = v - w;
			var g = 0;

			if (c < 1) {
				g = (v - c) / (1 - c);
			}

			return [hwb[0], c * 100, g * 100];
		};

		convert.apple.rgb = function (apple) {
			return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
		};

		convert.rgb.apple = function (rgb) {
			return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
		};

		convert.gray.rgb = function (args) {
			return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
		};

		convert.gray.hsl = convert.gray.hsv = function (args) {
			return [0, 0, args[0]];
		};

		convert.gray.hwb = function (gray) {
			return [0, 100, gray[0]];
		};

		convert.gray.cmyk = function (gray) {
			return [0, 0, 0, gray[0]];
		};

		convert.gray.lab = function (gray) {
			return [gray[0], 0, 0];
		};

		convert.gray.hex = function (gray) {
			var val = Math.round(gray[0] / 100 * 255) & 0xFF;
			var integer = (val << 16) + (val << 8) + val;

			var string = integer.toString(16).toUpperCase();
			return '000000'.substring(string.length) + string;
		};

		convert.rgb.gray = function (rgb) {
			var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
			return [val / 255 * 100];
		};
	});
	var conversions_1 = conversions.rgb;
	var conversions_2 = conversions.hsl;
	var conversions_3 = conversions.hsv;
	var conversions_4 = conversions.hwb;
	var conversions_5 = conversions.cmyk;
	var conversions_6 = conversions.xyz;
	var conversions_7 = conversions.lab;
	var conversions_8 = conversions.lch;
	var conversions_9 = conversions.hex;
	var conversions_10 = conversions.keyword;
	var conversions_11 = conversions.ansi16;
	var conversions_12 = conversions.ansi256;
	var conversions_13 = conversions.hcg;
	var conversions_14 = conversions.apple;
	var conversions_15 = conversions.gray;

	/*
 	this function routes a model to all other models.
 
 	all functions that are routed have a property `.conversion` attached
 	to the returned synthetic function. This property is an array
 	of strings, each with the steps in between the 'from' and 'to'
 	color models (inclusive).
 
 	conversions that are not possible simply are not included.
 */

	function buildGraph() {
		var graph = {};
		// https://jsperf.com/object-keys-vs-for-in-with-closure/3
		var models = Object.keys(conversions);

		for (var len = models.length, i = 0; i < len; i++) {
			graph[models[i]] = {
				// http://jsperf.com/1-vs-infinity
				// micro-opt, but this is simple.
				distance: -1,
				parent: null
			};
		}

		return graph;
	}

	// https://en.wikipedia.org/wiki/Breadth-first_search
	function deriveBFS(fromModel) {
		var graph = buildGraph();
		var queue = [fromModel]; // unshift -> queue -> pop

		graph[fromModel].distance = 0;

		while (queue.length) {
			var current = queue.pop();
			var adjacents = Object.keys(conversions[current]);

			for (var len = adjacents.length, i = 0; i < len; i++) {
				var adjacent = adjacents[i];
				var node = graph[adjacent];

				if (node.distance === -1) {
					node.distance = graph[current].distance + 1;
					node.parent = current;
					queue.unshift(adjacent);
				}
			}
		}

		return graph;
	}

	function link(from, to) {
		return function (args) {
			return to(from(args));
		};
	}

	function wrapConversion(toModel, graph) {
		var path = [graph[toModel].parent, toModel];
		var fn = conversions[graph[toModel].parent][toModel];

		var cur = graph[toModel].parent;
		while (graph[cur].parent) {
			path.unshift(graph[cur].parent);
			fn = link(conversions[graph[cur].parent][cur], fn);
			cur = graph[cur].parent;
		}

		fn.conversion = path;
		return fn;
	}

	var route = function route(fromModel) {
		var graph = deriveBFS(fromModel);
		var conversion = {};

		var models = Object.keys(graph);
		for (var len = models.length, i = 0; i < len; i++) {
			var toModel = models[i];
			var node = graph[toModel];

			if (node.parent === null) {
				// no possible conversion, or this node is the source model.
				continue;
			}

			conversion[toModel] = wrapConversion(toModel, graph);
		}

		return conversion;
	};

	var convert = {};

	var models = Object.keys(conversions);

	function wrapRaw(fn) {
		var wrappedFn = function wrappedFn(args) {
			if (args === undefined || args === null) {
				return args;
			}

			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}

			return fn(args);
		};

		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}

		return wrappedFn;
	}

	function wrapRounded(fn) {
		var wrappedFn = function wrappedFn(args) {
			if (args === undefined || args === null) {
				return args;
			}

			if (arguments.length > 1) {
				args = Array.prototype.slice.call(arguments);
			}

			var result = fn(args);

			// we're assuming the result is an array here.
			// see notice in conversions.js; don't use box types
			// in conversion functions.
			if ((typeof result === 'undefined' ? 'undefined' : _typeof(result)) === 'object') {
				for (var len = result.length, i = 0; i < len; i++) {
					result[i] = Math.round(result[i]);
				}
			}

			return result;
		};

		// preserve .conversion property if there is one
		if ('conversion' in fn) {
			wrappedFn.conversion = fn.conversion;
		}

		return wrappedFn;
	}

	models.forEach(function (fromModel) {
		convert[fromModel] = {};

		Object.defineProperty(convert[fromModel], 'channels', { value: conversions[fromModel].channels });
		Object.defineProperty(convert[fromModel], 'labels', { value: conversions[fromModel].labels });

		var routes = route(fromModel);
		var routeModels = Object.keys(routes);

		routeModels.forEach(function (toModel) {
			var fn = routes[toModel];

			convert[fromModel][toModel] = wrapRounded(fn);
			convert[fromModel][toModel].raw = wrapRaw(fn);
		});
	});

	var colorConvert = convert;

	var colorName$1 = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};

	/* MIT license */

	var colorString = {
		getRgba: getRgba,
		getHsla: getHsla,
		getRgb: getRgb,
		getHsl: getHsl,
		getHwb: getHwb,
		getAlpha: getAlpha,

		hexString: hexString,
		rgbString: rgbString,
		rgbaString: rgbaString,
		percentString: percentString,
		percentaString: percentaString,
		hslString: hslString,
		hslaString: hslaString,
		hwbString: hwbString,
		keyword: keyword
	};

	function getRgba(string) {
		if (!string) {
			return;
		}
		var abbr = /^#([a-fA-F0-9]{3,4})$/i,
		    hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
		    rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
		    per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
		    keyword = /(\w+)/;

		var rgb = [0, 0, 0],
		    a = 1,
		    match = string.match(abbr),
		    hexAlpha = "";
		if (match) {
			match = match[1];
			hexAlpha = match[3];
			for (var i = 0; i < rgb.length; i++) {
				rgb[i] = parseInt(match[i] + match[i], 16);
			}
			if (hexAlpha) {
				a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
			}
		} else if (match = string.match(hex)) {
			hexAlpha = match[2];
			match = match[1];
			for (var i = 0; i < rgb.length; i++) {
				rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
			}
			if (hexAlpha) {
				a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
			}
		} else if (match = string.match(rgba)) {
			for (var i = 0; i < rgb.length; i++) {
				rgb[i] = parseInt(match[i + 1]);
			}
			a = parseFloat(match[4]);
		} else if (match = string.match(per)) {
			for (var i = 0; i < rgb.length; i++) {
				rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
			}
			a = parseFloat(match[4]);
		} else if (match = string.match(keyword)) {
			if (match[1] == "transparent") {
				return [0, 0, 0, 0];
			}
			rgb = colorName$1[match[1]];
			if (!rgb) {
				return;
			}
		}

		for (var i = 0; i < rgb.length; i++) {
			rgb[i] = scale(rgb[i], 0, 255);
		}
		if (!a && a != 0) {
			a = 1;
		} else {
			a = scale(a, 0, 1);
		}
		rgb[3] = a;
		return rgb;
	}

	function getHsla(string) {
		if (!string) {
			return;
		}
		var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
		var match = string.match(hsl);
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = scale(parseInt(match[1]), 0, 360),
			    s = scale(parseFloat(match[2]), 0, 100),
			    l = scale(parseFloat(match[3]), 0, 100),
			    a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, s, l, a];
		}
	}

	function getHwb(string) {
		if (!string) {
			return;
		}
		var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
		var match = string.match(hwb);
		if (match) {
			var alpha = parseFloat(match[4]);
			var h = scale(parseInt(match[1]), 0, 360),
			    w = scale(parseFloat(match[2]), 0, 100),
			    b = scale(parseFloat(match[3]), 0, 100),
			    a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
			return [h, w, b, a];
		}
	}

	function getRgb(string) {
		var rgba = getRgba(string);
		return rgba && rgba.slice(0, 3);
	}

	function getHsl(string) {
		var hsla = getHsla(string);
		return hsla && hsla.slice(0, 3);
	}

	function getAlpha(string) {
		var vals = getRgba(string);
		if (vals) {
			return vals[3];
		} else if (vals = getHsla(string)) {
			return vals[3];
		} else if (vals = getHwb(string)) {
			return vals[3];
		}
	}

	// generators
	function hexString(rgba, a) {
		var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
		return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
	}

	function rgbString(rgba, alpha) {
		if (alpha < 1 || rgba[3] && rgba[3] < 1) {
			return rgbaString(rgba, alpha);
		}
		return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}

	function rgbaString(rgba, alpha) {
		if (alpha === undefined) {
			alpha = rgba[3] !== undefined ? rgba[3] : 1;
		}
		return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
	}

	function percentString(rgba, alpha) {
		if (alpha < 1 || rgba[3] && rgba[3] < 1) {
			return percentaString(rgba, alpha);
		}
		var r = Math.round(rgba[0] / 255 * 100),
		    g = Math.round(rgba[1] / 255 * 100),
		    b = Math.round(rgba[2] / 255 * 100);

		return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}

	function percentaString(rgba, alpha) {
		var r = Math.round(rgba[0] / 255 * 100),
		    g = Math.round(rgba[1] / 255 * 100),
		    b = Math.round(rgba[2] / 255 * 100);
		return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}

	function hslString(hsla, alpha) {
		if (alpha < 1 || hsla[3] && hsla[3] < 1) {
			return hslaString(hsla, alpha);
		}
		return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}

	function hslaString(hsla, alpha) {
		if (alpha === undefined) {
			alpha = hsla[3] !== undefined ? hsla[3] : 1;
		}
		return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
	}

	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
		if (alpha === undefined) {
			alpha = hwb[3] !== undefined ? hwb[3] : 1;
		}
		return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}

	function keyword(rgb) {
		return reverseNames[rgb.slice(0, 3)];
	}

	// helpers
	function scale(num, min, max) {
		return Math.min(Math.max(min, num), max);
	}

	function hexDouble(num) {
		var str = num.toString(16).toUpperCase();
		return str.length < 2 ? "0" + str : str;
	}

	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorName$1) {
		reverseNames[colorName$1[name]] = name;
	}

	/* MIT license */

	var Color = function Color(obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}

		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};

		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = colorString.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = colorString.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = colorString.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};

	Color.prototype = {
		isValid: function isValid() {
			return this.valid;
		},
		rgb: function rgb() {
			return this.setSpace('rgb', arguments);
		},
		hsl: function hsl() {
			return this.setSpace('hsl', arguments);
		},
		hsv: function hsv() {
			return this.setSpace('hsv', arguments);
		},
		hwb: function hwb() {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function cmyk() {
			return this.setSpace('cmyk', arguments);
		},

		rgbArray: function rgbArray() {
			return this.values.rgb;
		},
		hslArray: function hslArray() {
			return this.values.hsl;
		},
		hsvArray: function hsvArray() {
			return this.values.hsv;
		},
		hwbArray: function hwbArray() {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function cmykArray() {
			return this.values.cmyk;
		},
		rgbaArray: function rgbaArray() {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function hslaArray() {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function alpha(val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},

		red: function red(val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function green(val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function blue(val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function hue(val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function saturation(val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function lightness(val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function saturationv(val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function whiteness(val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function blackness(val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function value(val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function cyan(val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function magenta(val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function yellow(val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function black(val) {
			return this.setChannel('cmyk', 3, val);
		},

		hexString: function hexString() {
			return colorString.hexString(this.values.rgb);
		},
		rgbString: function rgbString() {
			return colorString.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function rgbaString() {
			return colorString.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function percentString() {
			return colorString.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function hslString() {
			return colorString.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function hslaString() {
			return colorString.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function hwbString() {
			return colorString.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function keyword() {
			return colorString.keyword(this.values.rgb, this.values.alpha);
		},

		rgbNumber: function rgbNumber() {
			var rgb = this.values.rgb;
			return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
		},

		luminosity: function luminosity() {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},

		contrast: function contrast(color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},

		level: function level(color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}

			return contrastRatio >= 4.5 ? 'AA' : '';
		},

		dark: function dark() {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},

		light: function light() {
			return !this.dark();
		},

		negate: function negate() {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},

		lighten: function lighten(ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		darken: function darken(ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		saturate: function saturate(ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		desaturate: function desaturate(ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},

		whiten: function whiten(ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		blacken: function blacken(ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},

		greyscale: function greyscale() {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},

		clearer: function clearer(ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - alpha * ratio);
			return this;
		},

		opaquer: function opaquer(ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + alpha * ratio);
			return this;
		},

		rotate: function rotate(degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},

		/**
   * Ported from sass implementation in C
   * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
   */
		mix: function mix(mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;

			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();

			var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;

			return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},

		toJSON: function toJSON() {
			return this.rgb();
		},

		clone: function clone() {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;

			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = {}.toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}

			return result;
		}
	};

	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};

	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};

	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};

		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}

		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}

		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};

	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;

		this.valid = true;

		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}

			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];

			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}

			alpha = vals.alpha;
		}

		values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));

		if (space === 'alpha') {
			return false;
		}

		var capped;

		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}

		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = colorConvert[space][sname](values[space]);
			}
		}

		return true;
	};

	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];

		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}

		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}

		this.setValues(space, vals);
		return this;
	};

	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}

		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);

		return this;
	};

	if (typeof window !== 'undefined') {
		window.Color = Color;
	}

	var chartjsColor = Color;

	function isValidKey(key) {
		return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
	}

	/**
  * @namespace Chart.helpers
  */
	var helpers = {
		/**
   * An empty function that can be used, for example, for optional callback.
   */
		noop: function noop() {},

		/**
   * Returns a unique id, sequentially generated from a global variable.
   * @returns {number}
   * @function
   */
		uid: function () {
			var id = 0;
			return function () {
				return id++;
			};
		}(),

		/**
   * Returns true if `value` is neither null nor undefined, else returns false.
   * @param {*} value - The value to test.
   * @returns {boolean}
   * @since 2.7.0
   */
		isNullOrUndef: function isNullOrUndef(value) {
			return value === null || typeof value === 'undefined';
		},

		/**
   * Returns true if `value` is an array (including typed arrays), else returns false.
   * @param {*} value - The value to test.
   * @returns {boolean}
   * @function
   */
		isArray: function isArray(value) {
			if (Array.isArray && Array.isArray(value)) {
				return true;
			}
			var type = Object.prototype.toString.call(value);
			if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
				return true;
			}
			return false;
		},

		/**
   * Returns true if `value` is an object (excluding null), else returns false.
   * @param {*} value - The value to test.
   * @returns {boolean}
   * @since 2.7.0
   */
		isObject: function isObject(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},

		/**
   * Returns true if `value` is a finite number, else returns false
   * @param {*} value  - The value to test.
   * @returns {boolean}
   */
		isFinite: function (_isFinite) {
			function isFinite(_x) {
				return _isFinite.apply(this, arguments);
			}

			isFinite.toString = function () {
				return _isFinite.toString();
			};

			return isFinite;
		}(function (value) {
			return (typeof value === 'number' || value instanceof Number) && isFinite(value);
		}),

		/**
   * Returns `value` if defined, else returns `defaultValue`.
   * @param {*} value - The value to return if defined.
   * @param {*} defaultValue - The value to return if `value` is undefined.
   * @returns {*}
   */
		valueOrDefault: function valueOrDefault(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},

		/**
   * Returns value at the given `index` in array if defined, else returns `defaultValue`.
   * @param {Array} value - The array to lookup for value at `index`.
   * @param {number} index - The index in `value` to lookup for value.
   * @param {*} defaultValue - The value to return if `value[index]` is undefined.
   * @returns {*}
   */
		valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},

		/**
   * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
   * value returned by `fn`. If `fn` is not a function, this method returns undefined.
   * @param {function} fn - The function to call.
   * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
   * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
   * @returns {*}
   */
		callback: function callback(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},

		/**
   * Note(SB) for performance sake, this method should only be used when loopable type
   * is unknown or in none intensive code (not called often and small loopable). Else
   * it's preferable to use a regular for() loop and save extra function calls.
   * @param {object|Array} loopable - The object or array to be iterated.
   * @param {function} fn - The function to call for each item.
   * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
   * @param {boolean} [reverse] - If true, iterates backward on the loopable.
   */
		each: function each(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},

		/**
   * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
   * @see https://stackoverflow.com/a/14853974
   * @param {Array} a0 - The array to compare
   * @param {Array} a1 - The array to compare
   * @returns {boolean}
   */
		arrayEquals: function arrayEquals(a0, a1) {
			var i, ilen, v0, v1;

			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}

			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];

				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}

			return true;
		},

		/**
   * Returns a deep copy of `source` without keeping references on objects and arrays.
   * @param {*} source - The value to clone.
   * @returns {*}
   */
		clone: function clone(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}

			if (helpers.isObject(source)) {
				var target = Object.create(source);
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;

				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}

				return target;
			}

			return source;
		},

		/**
   * The default merger when Chart.helpers.merge is called without merger option.
   * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
   * @private
   */
		_merger: function _merger(key, target, source, options) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}

			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},

		/**
   * Merges source[key] in target[key] only if target[key] is undefined.
   * @private
   */
		_mergerIf: function _mergerIf(key, target, source) {
			if (!isValidKey(key)) {
				// We want to ensure we do not copy prototypes over
				// as this can pollute global namespaces
				return;
			}

			var tval = target[key];
			var sval = source[key];

			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},

		/**
   * Recursively deep copies `source` properties into `target` with the given `options`.
   * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
   * @param {object} target - The target object in which all sources are merged into.
   * @param {object|object[]} source - Object(s) to merge into `target`.
   * @param {object} [options] - Merging options:
   * @param {function} [options.merger] - The merge method (key, target, source, options)
   * @returns {object} The `target` object.
   */
		merge: function merge(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;

			if (!helpers.isObject(target)) {
				return target;
			}

			options = options || {};
			merge = options.merger || helpers._merger;

			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}

				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}

			return target;
		},

		/**
   * Recursively deep copies `source` properties into `target` *only* if not defined in target.
   * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
   * @param {object} target - The target object in which all sources are merged into.
   * @param {object|object[]} source - Object(s) to merge into `target`.
   * @returns {object} The `target` object.
   */
		mergeIf: function mergeIf(target, source) {
			return helpers.merge(target, source, { merger: helpers._mergerIf });
		},

		/**
   * Applies the contents of two or more objects together into the first object.
   * @param {object} target - The target object in which all objects are merged into.
   * @param {object} arg1 - Object containing additional properties to merge in target.
   * @param {object} argN - Additional objects containing properties to merge in target.
   * @returns {object} The `target` object.
   */
		extend: Object.assign || function (target) {
			return helpers.merge(target, [].slice.call(arguments, 1), {
				merger: function merger(key, dst, src) {
					dst[key] = src[key];
				}
			});
		},

		/**
   * Basic javascript inheritance based on the model created in Backbone.js
   */
		inherits: function inherits(extensions) {
			var me = this;
			var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
				return me.apply(this, arguments);
			};

			var Surrogate = function Surrogate() {
				this.constructor = ChartElement;
			};

			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;

			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}

			ChartElement.__super__ = me.prototype;
			return ChartElement;
		},

		_deprecated: function _deprecated(scope, value, previous, current) {
			if (value !== undefined) {
				console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
			}
		}
	};

	var helpers_core = helpers;

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart.helpers.callback instead.
  * @function Chart.helpers.callCallback
  * @deprecated since version 2.6.0
  * @todo remove at version 3
  * @private
  */
	helpers.callCallback = helpers.callback;

	/**
  * Provided for backward compatibility, use Array.prototype.indexOf instead.
  * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
  * @function Chart.helpers.indexOf
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers.indexOf = function (array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};

	/**
  * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
  * @function Chart.helpers.getValueOrDefault
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers.getValueOrDefault = helpers.valueOrDefault;

	/**
  * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
  * @function Chart.helpers.getValueAtIndexOrDefault
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

	/**
  * Easing functions adapted from Robert Penner's easing equations.
  * @namespace Chart.helpers.easingEffects
  * @see http://www.robertpenner.com/easing/
  */
	var effects = {
		linear: function linear(t) {
			return t;
		},

		easeInQuad: function easeInQuad(t) {
			return t * t;
		},

		easeOutQuad: function easeOutQuad(t) {
			return -t * (t - 2);
		},

		easeInOutQuad: function easeInOutQuad(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * (--t * (t - 2) - 1);
		},

		easeInCubic: function easeInCubic(t) {
			return t * t * t;
		},

		easeOutCubic: function easeOutCubic(t) {
			return (t = t - 1) * t * t + 1;
		},

		easeInOutCubic: function easeInOutCubic(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},

		easeInQuart: function easeInQuart(t) {
			return t * t * t * t;
		},

		easeOutQuart: function easeOutQuart(t) {
			return -((t = t - 1) * t * t * t - 1);
		},

		easeInOutQuart: function easeInOutQuart(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},

		easeInQuint: function easeInQuint(t) {
			return t * t * t * t * t;
		},

		easeOutQuint: function easeOutQuint(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},

		easeInOutQuint: function easeInOutQuint(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},

		easeInSine: function easeInSine(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},

		easeOutSine: function easeOutSine(t) {
			return Math.sin(t * (Math.PI / 2));
		},

		easeInOutSine: function easeInOutSine(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},

		easeInExpo: function easeInExpo(t) {
			return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
		},

		easeOutExpo: function easeOutExpo(t) {
			return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
		},

		easeInOutExpo: function easeInOutExpo(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},

		easeInCirc: function easeInCirc(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},

		easeOutCirc: function easeOutCirc(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},

		easeInOutCirc: function easeInOutCirc(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},

		easeInElastic: function easeInElastic(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},

		easeOutElastic: function easeOutElastic(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},

		easeInOutElastic: function easeInOutElastic(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function easeInBack(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},

		easeOutBack: function easeOutBack(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},

		easeInOutBack: function easeInOutBack(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
		},

		easeInBounce: function easeInBounce(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},

		easeOutBounce: function easeOutBounce(t) {
			if (t < 1 / 2.75) {
				return 7.5625 * t * t;
			}
			if (t < 2 / 2.75) {
				return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
			}
			if (t < 2.5 / 2.75) {
				return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
			}
			return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
		},

		easeInOutBounce: function easeInOutBounce(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};

	var helpers_easing = {
		effects: effects
	};

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
  * @function Chart.helpers.easingEffects
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers_core.easingEffects = effects;

	var PI = Math.PI;
	var RAD_PER_DEG = PI / 180;
	var DOUBLE_PI = PI * 2;
	var HALF_PI = PI / 2;
	var QUARTER_PI = PI / 4;
	var TWO_THIRDS_PI = PI * 2 / 3;

	/**
  * @namespace Chart.helpers.canvas
  */
	var exports$1 = {
		/**
   * Clears the entire canvas associated to the given `chart`.
   * @param {Chart} chart - The chart for which to clear the canvas.
   */
		clear: function clear(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},

		/**
   * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
   * given size (width, height) and the same `radius` for all corners.
   * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
   * @param {number} x - The x axis of the coordinate for the rectangle starting point.
   * @param {number} y - The y axis of the coordinate for the rectangle starting point.
   * @param {number} width - The rectangle's width.
   * @param {number} height - The rectangle's height.
   * @param {number} radius - The rounded amount (in pixels) for the four corners.
   * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
   */
		roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
			if (radius) {
				var r = Math.min(radius, height / 2, width / 2);
				var left = x + r;
				var top = y + r;
				var right = x + width - r;
				var bottom = y + height - r;

				ctx.moveTo(x, top);
				if (left < right && top < bottom) {
					ctx.arc(left, top, r, -PI, -HALF_PI);
					ctx.arc(right, top, r, -HALF_PI, 0);
					ctx.arc(right, bottom, r, 0, HALF_PI);
					ctx.arc(left, bottom, r, HALF_PI, PI);
				} else if (left < right) {
					ctx.moveTo(left, y);
					ctx.arc(right, top, r, -HALF_PI, HALF_PI);
					ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
				} else if (top < bottom) {
					ctx.arc(left, top, r, -PI, 0);
					ctx.arc(left, bottom, r, 0, PI);
				} else {
					ctx.arc(left, top, r, -PI, PI);
				}
				ctx.closePath();
				ctx.moveTo(x, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},

		drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
			var type, xOffset, yOffset, size, cornerRadius;
			var rad = (rotation || 0) * RAD_PER_DEG;

			if (style && (typeof style === 'undefined' ? 'undefined' : _typeof(style)) === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.save();
					ctx.translate(x, y);
					ctx.rotate(rad);
					ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
					ctx.restore();
					return;
				}
			}

			if (isNaN(radius) || radius <= 0) {
				return;
			}

			ctx.beginPath();

			switch (style) {
				// Default includes circle
				default:
					ctx.arc(x, y, radius, 0, DOUBLE_PI);
					ctx.closePath();
					break;
				case 'triangle':
					ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
					rad += TWO_THIRDS_PI;
					ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
					rad += TWO_THIRDS_PI;
					ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
					ctx.closePath();
					break;
				case 'rectRounded':
					// NOTE: the rounded rect implementation changed to use `arc` instead of
					// `quadraticCurveTo` since it generates better results when rect is
					// almost a circle. 0.516 (instead of 0.5) produces results with visually
					// closer proportion to the previous impl and it is inscribed in the
					// circle with `radius`. For more details, see the following PRs:
					// https://github.com/chartjs/Chart.js/issues/5597
					// https://github.com/chartjs/Chart.js/issues/5858
					cornerRadius = radius * 0.516;
					size = radius - cornerRadius;
					xOffset = Math.cos(rad + QUARTER_PI) * size;
					yOffset = Math.sin(rad + QUARTER_PI) * size;
					ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
					ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
					ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
					ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
					ctx.closePath();
					break;
				case 'rect':
					if (!rotation) {
						size = Math.SQRT1_2 * radius;
						ctx.rect(x - size, y - size, 2 * size, 2 * size);
						break;
					}
					rad += QUARTER_PI;
				/* falls through */
				case 'rectRot':
					xOffset = Math.cos(rad) * radius;
					yOffset = Math.sin(rad) * radius;
					ctx.moveTo(x - xOffset, y - yOffset);
					ctx.lineTo(x + yOffset, y - xOffset);
					ctx.lineTo(x + xOffset, y + yOffset);
					ctx.lineTo(x - yOffset, y + xOffset);
					ctx.closePath();
					break;
				case 'crossRot':
					rad += QUARTER_PI;
				/* falls through */
				case 'cross':
					xOffset = Math.cos(rad) * radius;
					yOffset = Math.sin(rad) * radius;
					ctx.moveTo(x - xOffset, y - yOffset);
					ctx.lineTo(x + xOffset, y + yOffset);
					ctx.moveTo(x + yOffset, y - xOffset);
					ctx.lineTo(x - yOffset, y + xOffset);
					break;
				case 'star':
					xOffset = Math.cos(rad) * radius;
					yOffset = Math.sin(rad) * radius;
					ctx.moveTo(x - xOffset, y - yOffset);
					ctx.lineTo(x + xOffset, y + yOffset);
					ctx.moveTo(x + yOffset, y - xOffset);
					ctx.lineTo(x - yOffset, y + xOffset);
					rad += QUARTER_PI;
					xOffset = Math.cos(rad) * radius;
					yOffset = Math.sin(rad) * radius;
					ctx.moveTo(x - xOffset, y - yOffset);
					ctx.lineTo(x + xOffset, y + yOffset);
					ctx.moveTo(x + yOffset, y - xOffset);
					ctx.lineTo(x - yOffset, y + xOffset);
					break;
				case 'line':
					xOffset = Math.cos(rad) * radius;
					yOffset = Math.sin(rad) * radius;
					ctx.moveTo(x - xOffset, y - yOffset);
					ctx.lineTo(x + xOffset, y + yOffset);
					break;
				case 'dash':
					ctx.moveTo(x, y);
					ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
					break;
			}

			ctx.fill();
			ctx.stroke();
		},

		/**
   * Returns true if the point is inside the rectangle
   * @param {object} point - The point to test
   * @param {object} area - The rectangle
   * @returns {boolean}
   * @private
   */
		_isPointInArea: function _isPointInArea(point, area) {
			var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

			return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
		},

		clipArea: function clipArea(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},

		unclipArea: function unclipArea(ctx) {
			ctx.restore();
		},

		lineTo: function lineTo(ctx, previous, target, flip) {
			var stepped = target.steppedLine;
			if (stepped) {
				if (stepped === 'middle') {
					var midpoint = (previous.x + target.x) / 2.0;
					ctx.lineTo(midpoint, flip ? target.y : previous.y);
					ctx.lineTo(midpoint, flip ? previous.y : target.y);
				} else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}

			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}

			ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
		}
	};

	var helpers_canvas = exports$1;

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
  * @namespace Chart.helpers.clear
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers_core.clear = exports$1.clear;

	/**
  * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
  * @namespace Chart.helpers.drawRoundedRectangle
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers_core.drawRoundedRectangle = function (ctx) {
		ctx.beginPath();
		exports$1.roundedRect.apply(exports$1, arguments);
	};

	var defaults = {
		/**
   * @private
   */
		_set: function _set(scope, values) {
			return helpers_core.merge(this[scope] || (this[scope] = {}), values);
		}
	};

	// TODO(v3): remove 'global' from namespace.  all default are global and
	// there's inconsistency around which options are under 'global'
	defaults._set('global', {
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		defaultLineHeight: 1.2,
		showLines: true
	});

	var core_defaults = defaults;

	var valueOrDefault = helpers_core.valueOrDefault;

	/**
  * Converts the given font object into a CSS font string.
  * @param {object} font - A font object.
  * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
  * @private
  */
	function toFontString(font) {
		if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
			return null;
		}

		return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
	}

	/**
  * @alias Chart.helpers.options
  * @namespace
  */
	var helpers_options = {
		/**
   * Converts the given line height `value` in pixels for a specific font `size`.
   * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
   * @param {number} size - The font size (in pixels) used to resolve relative `value`.
   * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
   * @since 2.7.0
   */
		toLineHeight: function toLineHeight(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}

			value = +matches[2];

			switch (matches[3]) {
				case 'px':
					return value;
				case '%':
					value /= 100;
					break;
			}

			return size * value;
		},

		/**
   * Converts the given value into a padding object with pre-computed width/height.
   * @param {number|object} value - If a number, set the value to all TRBL component,
   *  else, if and object, use defined properties and sets undefined ones to 0.
   * @returns {object} The padding values (top, right, bottom, left, width, height)
   * @since 2.7.0
   */
		toPadding: function toPadding(value) {
			var t, r, b, l;

			if (helpers_core.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}

			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},

		/**
   * Parses font options and returns the font object.
   * @param {object} options - A object that contains font options to be parsed.
   * @return {object} The font object.
   * @todo Support font.* options and renamed to toFont().
   * @private
   */
		_parseFont: function _parseFont(options) {
			var globalDefaults = core_defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var font = {
				family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
				lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
				size: size,
				style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
				weight: null,
				string: ''
			};

			font.string = toFontString(font);
			return font;
		},

		/**
   * Evaluates the given `inputs` sequentially and returns the first defined value.
   * @param {Array} inputs - An array of values, falling back to the last value.
   * @param {object} [context] - If defined and the current value is a function, the value
   * is called with `context` as first argument and the result becomes the new input.
   * @param {number} [index] - If defined and the current value is an array, the value
   * at `index` become the new input.
   * @param {object} [info] - object to return information about resolution in
   * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
   * @since 2.7.0
   */
		resolve: function resolve(inputs, context, index, info) {
			var cacheable = true;
			var i, ilen, value;

			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
					cacheable = false;
				}
				if (index !== undefined && helpers_core.isArray(value)) {
					value = value[index];
					cacheable = false;
				}
				if (value !== undefined) {
					if (info && !cacheable) {
						info.cacheable = false;
					}
					return value;
				}
			}
		}
	};

	/**
  * @alias Chart.helpers.math
  * @namespace
  */
	var exports$2 = {
		/**
   * Returns an array of factors sorted from 1 to sqrt(value)
   * @private
   */
		_factorize: function _factorize(value) {
			var result = [];
			var sqrt = Math.sqrt(value);
			var i;

			for (i = 1; i < sqrt; i++) {
				if (value % i === 0) {
					result.push(i);
					result.push(value / i);
				}
			}
			if (sqrt === (sqrt | 0)) {
				// if value is a square number
				result.push(sqrt);
			}

			result.sort(function (a, b) {
				return a - b;
			}).pop();
			return result;
		},

		log10: Math.log10 || function (x) {
			var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
			// Check for whole powers of 10,
			// which due to floating point rounding error should be corrected.
			var powerOf10 = Math.round(exponent);
			var isPowerOf10 = x === Math.pow(10, powerOf10);

			return isPowerOf10 ? powerOf10 : exponent;
		}
	};

	var helpers_math = exports$2;

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
  * @namespace Chart.helpers.log10
  * @deprecated since version 2.9.0
  * @todo remove at version 3
  * @private
  */
	helpers_core.log10 = exports$2.log10;

	var getRtlAdapter = function getRtlAdapter(rectX, width) {
		return {
			x: function x(_x2) {
				return rectX + rectX + width - _x2;
			},
			setWidth: function setWidth(w) {
				width = w;
			},
			textAlign: function textAlign(align) {
				if (align === 'center') {
					return align;
				}
				return align === 'right' ? 'left' : 'right';
			},
			xPlus: function xPlus(x, value) {
				return x - value;
			},
			leftForLtr: function leftForLtr(x, itemWidth) {
				return x - itemWidth;
			}
		};
	};

	var getLtrAdapter = function getLtrAdapter() {
		return {
			x: function x(_x3) {
				return _x3;
			},
			setWidth: function setWidth(w) {// eslint-disable-line no-unused-vars
			},
			textAlign: function textAlign(align) {
				return align;
			},
			xPlus: function xPlus(x, value) {
				return x + value;
			},
			leftForLtr: function leftForLtr(x, _itemWidth) {
				// eslint-disable-line no-unused-vars
				return x;
			}
		};
	};

	var getAdapter = function getAdapter(rtl, rectX, width) {
		return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
	};

	var overrideTextDirection = function overrideTextDirection(ctx, direction) {
		var style, original;
		if (direction === 'ltr' || direction === 'rtl') {
			style = ctx.canvas.style;
			original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];

			style.setProperty('direction', direction, 'important');
			ctx.prevTextDirection = original;
		}
	};

	var restoreTextDirection = function restoreTextDirection(ctx) {
		var original = ctx.prevTextDirection;
		if (original !== undefined) {
			delete ctx.prevTextDirection;
			ctx.canvas.style.setProperty('direction', original[0], original[1]);
		}
	};

	var helpers_rtl = {
		getRtlAdapter: getAdapter,
		overrideTextDirection: overrideTextDirection,
		restoreTextDirection: restoreTextDirection
	};

	var helpers$1 = helpers_core;
	var easing = helpers_easing;
	var canvas = helpers_canvas;
	var options = helpers_options;
	var math = helpers_math;
	var rtl = helpers_rtl;
	helpers$1.easing = easing;
	helpers$1.canvas = canvas;
	helpers$1.options = options;
	helpers$1.math = math;
	helpers$1.rtl = rtl;

	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;

		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];

			target = model[key];

			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}

			actual = view[key];

			if (actual === target || key[0] === '_') {
				continue;
			}

			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}

			origin = start[key];

			type = typeof target === 'undefined' ? 'undefined' : _typeof(target);

			if (type === (typeof origin === 'undefined' ? 'undefined' : _typeof(origin))) {
				if (type === 'string') {
					c0 = chartjsColor(origin);
					if (c0.valid) {
						c1 = chartjsColor(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}

			view[key] = target;
		}
	}

	var Element = function Element(configuration) {
		helpers$1.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};

	helpers$1.extend(Element.prototype, {
		_type: undefined,

		initialize: function initialize() {
			this.hidden = false;
		},

		pivot: function pivot() {
			var me = this;
			if (!me._view) {
				me._view = helpers$1.extend({}, me._model);
			}
			me._start = {};
			return me;
		},

		transition: function transition(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;

			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = helpers$1.extend({}, model);
				me._start = null;
				return me;
			}

			if (!view) {
				view = me._view = {};
			}

			if (!start) {
				start = me._start = {};
			}

			interpolate(start, view, model, ease);

			return me;
		},

		tooltipPosition: function tooltipPosition() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},

		hasValue: function hasValue() {
			return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
		}
	});

	Element.extend = helpers$1.inherits;

	var core_element = Element;

	var exports$3 = core_element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null // user specified callback to fire when the animation finishes
	});

	var core_animation = exports$3;

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart.Animation instead
  * @prop Chart.Animation#animationObject
  * @deprecated since version 2.6.0
  * @todo remove at version 3
  */
	Object.defineProperty(exports$3.prototype, 'animationObject', {
		get: function get() {
			return this;
		}
	});

	/**
  * Provided for backward compatibility, use Chart.Animation#chart instead
  * @prop Chart.Animation#chartInstance
  * @deprecated since version 2.6.0
  * @todo remove at version 3
  */
	Object.defineProperty(exports$3.prototype, 'chartInstance', {
		get: function get() {
			return this.chart;
		},
		set: function set(value) {
			this.chart = value;
		}
	});

	core_defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers$1.noop,
			onComplete: helpers$1.noop
		}
	});

	var core_animations = {
		animations: [],
		request: null,

		/**
   * @param {Chart} chart - The chart to animate.
   * @param {Chart.Animation} animation - The animation that we will animate.
   * @param {number} duration - The animation duration in ms.
   * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
   */
		addAnimation: function addAnimation(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;
			animation.startTime = Date.now();
			animation.duration = duration;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function cancelAnimation(chart) {
			var index = helpers$1.findIndex(this.animations, function (animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function requestAnimationFrame() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers$1.requestAnimFrame.call(window, function () {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
   * @private
   */
		startDigest: function startDigest() {
			var me = this;

			me.advance();

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
   * @private
   */
		advance: function advance() {
			var animations = this.animations;
			var animation, chart, numSteps, nextStep;
			var i = 0;

			// 1 animation per chart, so we are looping charts here
			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;
				numSteps = animation.numSteps;

				// Make sure that currentStep starts at 1
				// https://github.com/chartjs/Chart.js/issues/6104
				nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
				animation.currentStep = Math.min(nextStep, numSteps);

				helpers$1.callback(animation.render, [chart, animation], chart);
				helpers$1.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= numSteps) {
					helpers$1.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	var resolve = helpers$1.options.resolve;

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
  * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
  * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
  * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
  */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function (key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function value() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers$1.each(array._chartjs.listeners, function (object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
  * Removes the given array event listener and cleanup extra attached properties (such as
  * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
  */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function (key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	var DatasetController = function DatasetController(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers$1.extend(DatasetController.prototype, {

		/**
   * Element type used to generate a meta dataset (e.g. Chart.element.Line).
   * @type {Chart.core.element}
   */
		datasetElementType: null,

		/**
   * Element type used to generate a meta data (e.g. Chart.element.Point).
   * @type {Chart.core.element}
   */
		dataElementType: null,

		/**
   * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
   * A derived controller may override this to resolve controller-specific options.
   * The keys defined here are for backward compatibility for legend styles.
   * @private
   */
		_datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],

		/**
   * Data element option keys to be resolved in _resolveDataElementOptions.
   * A derived controller may override this to resolve controller-specific options.
   * The keys defined here are for backward compatibility for legend styles.
   * @private
   */
		_dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],

		initialize: function initialize(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
			me._type = me.getMeta().type;
		},

		updateIndex: function updateIndex(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function linkScales() {
			var me = this;
			var meta = me.getMeta();
			var chart = me.chart;
			var scales = chart.scales;
			var dataset = me.getDataset();
			var scalesOpts = chart.options.scales;

			if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
				meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
			}
			if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
				meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
			}
		},

		getDataset: function getDataset() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function getMeta() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function getScaleForId(scaleID) {
			return this.chart.scales[scaleID];
		},

		/**
   * @private
   */
		_getValueScaleId: function _getValueScaleId() {
			return this.getMeta().yAxisID;
		},

		/**
   * @private
   */
		_getIndexScaleId: function _getIndexScaleId() {
			return this.getMeta().xAxisID;
		},

		/**
   * @private
   */
		_getValueScale: function _getValueScale() {
			return this.getScaleForId(this._getValueScaleId());
		},

		/**
   * @private
   */
		_getIndexScale: function _getIndexScale() {
			return this.getScaleForId(this._getIndexScaleId());
		},

		reset: function reset() {
			this._update(true);
		},

		/**
   * @private
   */
		destroy: function destroy() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function createMetaDataset() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function createMetaData(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function addElements() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function addElementAndReset(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function buildOrUpdateElements() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				if (data && Object.isExtensible(data)) {
					listenArrayEvents(data, me);
				}
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		/**
   * Returns the merged user-supplied and default dataset-level options
   * @private
   */
		_configure: function _configure() {
			var me = this;
			me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
				merger: function merger(key, target, source) {
					if (key !== '_meta' && key !== 'data') {
						helpers$1._merger(key, target, source);
					}
				}
			});
		},

		_update: function _update(reset) {
			var me = this;
			me._configure();
			me._cachedDataOpts = null;
			me.update(reset);
		},

		update: helpers$1.noop,

		transition: function transition(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function draw() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		/**
   * Returns a set of predefined style properties that should be used to represent the dataset
   * or the data if the index is specified
   * @param {number} index - data index
   * @return {IStyleInterface} style object
   */
		getStyle: function getStyle(index) {
			var me = this;
			var meta = me.getMeta();
			var dataset = meta.dataset;
			var style;

			me._configure();
			if (dataset && index === undefined) {
				style = me._resolveDatasetElementOptions(dataset || {});
			} else {
				index = index || 0;
				style = me._resolveDataElementOptions(meta.data[index] || {}, index);
			}

			if (style.fill === false || style.fill === null) {
				style.backgroundColor = style.borderColor;
			}

			return style;
		},

		/**
   * @private
   */
		_resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
			var me = this;
			var chart = me.chart;
			var datasetOpts = me._config;
			var custom = element.custom || {};
			var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
			var elementOptions = me._datasetElementOptions;
			var values = {};
			var i, ilen, key, readKey;

			// Scriptable options
			var context = {
				chart: chart,
				dataset: me.getDataset(),
				datasetIndex: me.index,
				hover: hover
			};

			for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
				key = elementOptions[i];
				readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
				values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
			}

			return values;
		},

		/**
   * @private
   */
		_resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
			var me = this;
			var custom = element && element.custom;
			var cached = me._cachedDataOpts;
			if (cached && !custom) {
				return cached;
			}
			var chart = me.chart;
			var datasetOpts = me._config;
			var options = chart.options.elements[me.dataElementType.prototype._type] || {};
			var elementOptions = me._dataElementOptions;
			var values = {};

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: me.getDataset(),
				datasetIndex: me.index
			};

			// `resolve` sets cacheable to `false` if any option is indexed or scripted
			var info = { cacheable: !custom };

			var keys, i, ilen, key;

			custom = custom || {};

			if (helpers$1.isArray(elementOptions)) {
				for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
					key = elementOptions[i];
					values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
				}
			} else {
				keys = Object.keys(elementOptions);
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
				}
			}

			if (info.cacheable) {
				me._cachedDataOpts = Object.freeze(values);
			}

			return values;
		},

		removeHoverStyle: function removeHoverStyle(element) {
			helpers$1.merge(element._model, element.$previousStyle || {});
			delete element.$previousStyle;
		},

		setHoverStyle: function setHoverStyle(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var model = element._model;
			var getHoverColor = helpers$1.getHoverColor;

			element.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};

			model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
			model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
			model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
		},

		/**
   * @private
   */
		_removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
			var element = this.getMeta().dataset;

			if (element) {
				this.removeHoverStyle(element);
			}
		},

		/**
   * @private
   */
		_setDatasetHoverStyle: function _setDatasetHoverStyle() {
			var element = this.getMeta().dataset;
			var prev = {};
			var i, ilen, key, keys, hoverOptions, model;

			if (!element) {
				return;
			}

			model = element._model;
			hoverOptions = this._resolveDatasetElementOptions(element, true);

			keys = Object.keys(hoverOptions);
			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				prev[key] = model[key];
				model[key] = hoverOptions[key];
			}

			element.$previousStyle = prev;
		},

		/**
   * @private
   */
		resyncElements: function resyncElements() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
   * @private
   */
		insertElements: function insertElements(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
   * @private
   */
		onDataPush: function onDataPush() {
			var count = arguments.length;
			this.insertElements(this.getDataset().data.length - count, count);
		},

		/**
   * @private
   */
		onDataPop: function onDataPop() {
			this.getMeta().data.pop();
		},

		/**
   * @private
   */
		onDataShift: function onDataShift() {
			this.getMeta().data.shift();
		},

		/**
   * @private
   */
		onDataSplice: function onDataSplice(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
   * @private
   */
		onDataUnshift: function onDataUnshift() {
			this.insertElements(0, arguments.length);
		}
	});

	DatasetController.extend = helpers$1.inherits;

	var core_datasetController = DatasetController;

	var TAU = Math.PI * 2;

	core_defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: core_defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2,
				borderAlign: 'center'
			}
		}
	});

	function clipArc(ctx, arc) {
		var startAngle = arc.startAngle;
		var endAngle = arc.endAngle;
		var pixelMargin = arc.pixelMargin;
		var angleMargin = pixelMargin / arc.outerRadius;
		var x = arc.x;
		var y = arc.y;

		// Draw an inner border by cliping the arc and drawing a double-width border
		// Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
		ctx.beginPath();
		ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
		if (arc.innerRadius > pixelMargin) {
			angleMargin = pixelMargin / arc.innerRadius;
			ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
		} else {
			ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
		}
		ctx.closePath();
		ctx.clip();
	}

	function drawFullCircleBorders(ctx, vm, arc, inner) {
		var endAngle = arc.endAngle;
		var i;

		if (inner) {
			arc.endAngle = arc.startAngle + TAU;
			clipArc(ctx, arc);
			arc.endAngle = endAngle;
			if (arc.endAngle === arc.startAngle && arc.fullCircles) {
				arc.endAngle += TAU;
				arc.fullCircles--;
			}
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
		for (i = 0; i < arc.fullCircles; ++i) {
			ctx.stroke();
		}
	}

	function drawBorder(ctx, vm, arc) {
		var inner = vm.borderAlign === 'inner';

		if (inner) {
			ctx.lineWidth = vm.borderWidth * 2;
			ctx.lineJoin = 'round';
		} else {
			ctx.lineWidth = vm.borderWidth;
			ctx.lineJoin = 'bevel';
		}

		if (arc.fullCircles) {
			drawFullCircleBorders(ctx, vm, arc, inner);
		}

		if (inner) {
			clipArc(ctx, arc);
		}

		ctx.beginPath();
		ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
		ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
		ctx.closePath();
		ctx.stroke();
	}

	var element_arc = core_element.extend({
		_type: 'arc',

		inLabelRange: function inLabelRange(mouseX) {
			var vm = this._view;

			if (vm) {
				return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
			}
			return false;
		},

		inRange: function inRange(chartX, chartY) {
			var vm = this._view;

			if (vm) {
				var pointRelativePosition = helpers$1.getAngleFromPoint(vm, { x: chartX, y: chartY });
				var angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;

				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += TAU;
				}
				while (angle > endAngle) {
					angle -= TAU;
				}
				while (angle < startAngle) {
					angle += TAU;
				}

				// Check if within the range of the open/close angle
				var betweenAngles = angle >= startAngle && angle <= endAngle;
				var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;

				return betweenAngles && withinRadius;
			}
			return false;
		},

		getCenterPoint: function getCenterPoint() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},

		getArea: function getArea() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},

		tooltipPosition: function tooltipPosition() {
			var vm = this._view;
			var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

			return {
				x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
				y: vm.y + Math.sin(centreAngle) * rangeFromCentre
			};
		},

		draw: function draw() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
			var arc = {
				x: vm.x,
				y: vm.y,
				innerRadius: vm.innerRadius,
				outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
				pixelMargin: pixelMargin,
				startAngle: vm.startAngle,
				endAngle: vm.endAngle,
				fullCircles: Math.floor(vm.circumference / TAU)
			};
			var i;

			ctx.save();

			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;

			if (arc.fullCircles) {
				arc.endAngle = arc.startAngle + TAU;
				ctx.beginPath();
				ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
				ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
				ctx.closePath();
				for (i = 0; i < arc.fullCircles; ++i) {
					ctx.fill();
				}
				arc.endAngle = arc.startAngle + vm.circumference % TAU;
			}

			ctx.beginPath();
			ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
			ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
			ctx.closePath();
			ctx.fill();

			if (vm.borderWidth) {
				drawBorder(ctx, vm, arc);
			}

			ctx.restore();
		}
	});

	var valueOrDefault$1 = helpers$1.valueOrDefault;

	var defaultColor = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: defaultColor,
				borderWidth: 3,
				borderColor: defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true // do we fill in the area between the line and its base axis
			}
		}
	});

	var element_line = core_element.extend({
		_type: 'line',

		draw: function draw() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalDefaults = core_defaults.global;
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var closePath = me._loop;
			var index, previous, currentVM;

			if (!points.length) {
				return;
			}

			if (me._loop) {
				for (index = 0; index < points.length; ++index) {
					previous = helpers$1.previousItem(points, index);
					// If the line has an open path, shift the point array
					if (!points[index]._view.skip && previous._view.skip) {
						points = points.slice(index).concat(points.slice(0, index));
						closePath = spanGaps;
						break;
					}
				}
				// If the line has a close path, add the first point again
				if (closePath) {
					points.push(points[0]);
				}
			}

			ctx.save();

			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}

			ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

			// Stroke Line
			ctx.beginPath();

			// First point moves to it's starting position no matter what
			currentVM = points[0]._view;
			if (!currentVM.skip) {
				ctx.moveTo(currentVM.x, currentVM.y);
				lastDrawnIndex = 0;
			}

			for (index = 1; index < points.length; ++index) {
				currentVM = points[index]._view;
				previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
					}
					lastDrawnIndex = index;
				}
			}

			if (closePath) {
				ctx.closePath();
			}

			ctx.stroke();
			ctx.restore();
		}
	});

	var valueOrDefault$2 = helpers$1.valueOrDefault;

	var defaultColor$1 = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor$1,
				borderColor: defaultColor$1,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});

	function xRange(mouseX) {
		var vm = this._view;
		return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
	}

	function yRange(mouseY) {
		var vm = this._view;
		return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
	}

	var element_point = core_element.extend({
		_type: 'point',

		inRange: function inRange(mouseX, mouseY) {
			var vm = this._view;
			return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
		},

		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,

		getCenterPoint: function getCenterPoint() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},

		getArea: function getArea() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},

		tooltipPosition: function tooltipPosition() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},

		draw: function draw(chartArea) {
			var vm = this._view;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var rotation = vm.rotation;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

			if (vm.skip) {
				return;
			}

			// Clipping for Points.
			if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
				ctx.strokeStyle = vm.borderColor || defaultColor;
				ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
				ctx.fillStyle = vm.backgroundColor || defaultColor;
				helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
			}
		}
	});

	var defaultColor$2 = core_defaults.global.defaultColor;

	core_defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaultColor$2,
				borderColor: defaultColor$2,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});

	function isVertical(vm) {
		return vm && vm.width !== undefined;
	}

	/**
  * Helper function to get the bounds of the bar regardless of the orientation
  * @param bar {Chart.Element.Rectangle} the bar
  * @return {Bounds} bounds of the bar
  * @private
  */
	function getBarBounds(vm) {
		var x1, x2, y1, y2, half;

		if (isVertical(vm)) {
			half = vm.width / 2;
			x1 = vm.x - half;
			x2 = vm.x + half;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			half = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - half;
			y2 = vm.y + half;
		}

		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}

	function swap(orig, v1, v2) {
		return orig === v1 ? v2 : orig === v2 ? v1 : orig;
	}

	function parseBorderSkipped(vm) {
		var edge = vm.borderSkipped;
		var res = {};

		if (!edge) {
			return res;
		}

		if (vm.horizontal) {
			if (vm.base > vm.x) {
				edge = swap(edge, 'left', 'right');
			}
		} else if (vm.base < vm.y) {
			edge = swap(edge, 'bottom', 'top');
		}

		res[edge] = true;
		return res;
	}

	function parseBorderWidth(vm, maxW, maxH) {
		var value = vm.borderWidth;
		var skip = parseBorderSkipped(vm);
		var t, r, b, l;

		if (helpers$1.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
			r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
			b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
			l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
		};
	}

	function boundingRects(vm) {
		var bounds = getBarBounds(vm);
		var width = bounds.right - bounds.left;
		var height = bounds.bottom - bounds.top;
		var border = parseBorderWidth(vm, width / 2, height / 2);

		return {
			outer: {
				x: bounds.left,
				y: bounds.top,
				w: width,
				h: height
			},
			inner: {
				x: bounds.left + border.l,
				y: bounds.top + border.t,
				w: width - border.l - border.r,
				h: height - border.t - border.b
			}
		};
	}

	function _inRange(vm, x, y) {
		var skipX = x === null;
		var skipY = y === null;
		var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);

		return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
	}

	var element_rectangle = core_element.extend({
		_type: 'rectangle',

		draw: function draw() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var rects = boundingRects(vm);
			var outer = rects.outer;
			var inner = rects.inner;

			ctx.fillStyle = vm.backgroundColor;
			ctx.fillRect(outer.x, outer.y, outer.w, outer.h);

			if (outer.w === inner.w && outer.h === inner.h) {
				return;
			}

			ctx.save();
			ctx.beginPath();
			ctx.rect(outer.x, outer.y, outer.w, outer.h);
			ctx.clip();
			ctx.fillStyle = vm.borderColor;
			ctx.rect(inner.x, inner.y, inner.w, inner.h);
			ctx.fill('evenodd');
			ctx.restore();
		},

		height: function height() {
			var vm = this._view;
			return vm.base - vm.y;
		},

		inRange: function inRange(mouseX, mouseY) {
			return _inRange(this._view, mouseX, mouseY);
		},

		inLabelRange: function inLabelRange(mouseX, mouseY) {
			var vm = this._view;
			return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
		},

		inXRange: function inXRange(mouseX) {
			return _inRange(this._view, mouseX, null);
		},

		inYRange: function inYRange(mouseY) {
			return _inRange(this._view, null, mouseY);
		},

		getCenterPoint: function getCenterPoint() {
			var vm = this._view;
			var x, y;
			if (isVertical(vm)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}

			return { x: x, y: y };
		},

		getArea: function getArea() {
			var vm = this._view;

			return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
		},

		tooltipPosition: function tooltipPosition() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});

	var elements = {};
	var Arc = element_arc;
	var Line = element_line;
	var Point = element_point;
	var Rectangle = element_rectangle;
	elements.Arc = Arc;
	elements.Line = Line;
	elements.Point = Point;
	elements.Rectangle = Rectangle;

	var deprecated = helpers$1._deprecated;
	var valueOrDefault$3 = helpers$1.valueOrDefault;

	core_defaults._set('bar', {
		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}],

			yAxes: [{
				type: 'linear'
			}]
		}
	});

	core_defaults._set('global', {
		datasets: {
			bar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});

	/**
  * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
  * @private
  */
	function computeMinSampleSize(scale, pixels) {
		var min = scale._length;
		var prev, curr, i, ilen;

		for (i = 1, ilen = pixels.length; i < ilen; ++i) {
			min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
		}

		for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
			curr = scale.getPixelForTick(i);
			min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
			prev = curr;
		}

		return min;
	}

	/**
  * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
  * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
  * mode currently always generates bars equally sized (until we introduce scriptable options?).
  * @private
  */
	function computeFitCategoryTraits(index, ruler, options) {
		var thickness = options.barThickness;
		var count = ruler.stackCount;
		var curr = ruler.pixels[index];
		var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
		var size, ratio;

		if (helpers$1.isNullOrUndef(thickness)) {
			size = min * options.categoryPercentage;
			ratio = options.barPercentage;
		} else {
			// When bar thickness is enforced, category and bar percentages are ignored.
			// Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
			// and deprecate barPercentage since this value is ignored when thickness is absolute.
			size = thickness * count;
			ratio = 1;
		}

		return {
			chunk: size / count,
			ratio: ratio,
			start: curr - size / 2
		};
	}

	/**
  * Computes an "optimal" category that globally arranges bars side by side (no gap when
  * percentage options are 1), based on the previous and following categories. This mode
  * generates bars with different widths when data are not evenly spaced.
  * @private
  */
	function computeFlexCategoryTraits(index, ruler, options) {
		var pixels = ruler.pixels;
		var curr = pixels[index];
		var prev = index > 0 ? pixels[index - 1] : null;
		var next = index < pixels.length - 1 ? pixels[index + 1] : null;
		var percent = options.categoryPercentage;
		var start, size;

		if (prev === null) {
			// first data: its size is double based on the next point or,
			// if it's also the last data, we use the scale size.
			prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
		}

		if (next === null) {
			// last data: its size is also double based on the previous point.
			next = curr + curr - prev;
		}

		start = curr - (curr - Math.min(prev, next)) / 2 * percent;
		size = Math.abs(next - prev) / 2 * percent;

		return {
			chunk: size / ruler.stackCount,
			ratio: options.barPercentage,
			start: start
		};
	}

	var controller_bar = core_datasetController.extend({

		dataElementType: elements.Rectangle,

		/**
   * @private
   */
		_dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],

		initialize: function initialize() {
			var me = this;
			var meta, scaleOpts;

			core_datasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;

			scaleOpts = me._getIndexScale().options;
			deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
			deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
			deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
			deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
			deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
		},

		update: function update(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function updateElement(rectangle, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var options = me._resolveDataElementOptions(rectangle, index);

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;
			rectangle._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderSkipped: options.borderSkipped,
				borderWidth: options.borderWidth,
				datasetLabel: dataset.label,
				label: me.chart.data.labels[index]
			};

			if (helpers$1.isArray(dataset.data[index])) {
				rectangle._model.borderSkipped = null;
			}

			me._updateElementGeometry(rectangle, index, reset, options);

			rectangle.pivot();
		},

		/**
   * @private
   */
		_updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
			var me = this;
			var model = rectangle._model;
			var vscale = me._getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index, options);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
   * Returns the stacks based on groups and bar visibility.
   * @param {number} [last] - The dataset index
   * @returns {string[]} The list of stack IDs
   * @private
   */
		_getStacks: function _getStacks(last) {
			var me = this;
			var scale = me._getIndexScale();
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var stacked = scale.options.stacked;
			var ilen = metasets.length;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				// stacked   | meta.stack
				//           | found | not found | undefined
				// false     |   x   |     x     |     x
				// true      |       |     x     |
				// undefined |       |     x     |     x
				if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
					stacks.push(meta.stack);
				}
				if (meta.index === last) {
					break;
				}
			}

			return stacks;
		},

		/**
   * Returns the effective number of stacks based on groups and bar visibility.
   * @private
   */
		getStackCount: function getStackCount() {
			return this._getStacks().length;
		},

		/**
   * Returns the stack index for the given dataset based on groups and bar visibility.
   * @param {number} [datasetIndex] - The dataset index
   * @param {string} [name] - The stack name to find
   * @returns {number} The stack index
   * @private
   */
		getStackIndex: function getStackIndex(datasetIndex, name) {
			var stacks = this._getStacks(datasetIndex);
			var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present

			return index === -1 ? stacks.length - 1 : index;
		},

		/**
   * @private
   */
		getRuler: function getRuler() {
			var me = this;
			var scale = me._getIndexScale();
			var pixels = [];
			var i, ilen;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, me.index));
			}

			return {
				pixels: pixels,
				start: scale._startPixel,
				end: scale._endPixel,
				stackCount: me.getStackCount(),
				scale: scale
			};
		},

		/**
   * Note: pixel values are not clamped to the scale area.
   * @private
   */
		calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var isHorizontal = scale.isHorizontal();
			var datasets = chart.data.datasets;
			var metasets = scale._getMatchingVisibleMetas(me._type);
			var value = scale._parseValue(datasets[datasetIndex].data[index]);
			var minBarLength = options.minBarLength;
			var stacked = scale.options.stacked;
			var stack = me.getMeta().stack;
			var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
			var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
			var ilen = metasets.length;
			var i, imeta, ivalue, base, head, size, stackLength;

			if (stacked || stacked === undefined && stack !== undefined) {
				for (i = 0; i < ilen; ++i) {
					imeta = metasets[i];

					if (imeta.index === datasetIndex) {
						break;
					}

					if (imeta.stack === stack) {
						stackLength = scale._parseValue(datasets[imeta.index].data[index]);
						ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;

						if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + length);
			size = head - base;

			if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
				size = minBarLength;
				if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
					head = base - minBarLength;
				} else {
					head = base + minBarLength;
				}
			}

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
   * @private
   */
		calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
			var me = this;
			var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);

			var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
			var center = range.start + range.chunk * stackIndex + range.chunk / 2;
			var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);

			return {
				base: center - size / 2,
				head: center + size / 2,
				center: center,
				size: size
			};
		},

		draw: function draw() {
			var me = this;
			var chart = me.chart;
			var scale = me._getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				var val = scale._parseValue(dataset.data[i]);
				if (!isNaN(val.min) && !isNaN(val.max)) {
					rects[i].draw();
				}
			}

			helpers$1.canvas.unclipArea(chart.ctx);
		},

		/**
   * @private
   */
		_resolveDataElementOptions: function _resolveDataElementOptions() {
			var me = this;
			var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
			var indexOpts = me._getIndexScale().options;
			var valueOpts = me._getValueScale().options;

			values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
			values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
			values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
			values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
			values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);

			return values;
		}

	});

	var valueOrDefault$4 = helpers$1.valueOrDefault;
	var resolve$1 = helpers$1.options.resolve;

	core_defaults._set('bubble', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},

		tooltips: {
			callbacks: {
				title: function title() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function label(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});

	var controller_bubble = core_datasetController.extend({
		/**
   * @protected
   */
		dataElementType: elements.Point,

		/**
   * @private
   */
		_dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],

		/**
   * @protected
   */
		update: function update(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers$1.each(points, function (point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
   * @protected
   */
		updateElement: function updateElement(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveDataElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y
			};

			point.pivot();
		},

		/**
   * @protected
   */
		setHoverStyle: function setHoverStyle(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
   * @private
   */
		_resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var custom = point.custom || {};
			var data = dataset.data[index] || {};
			var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			// In case values were cached (and thus frozen), we need to clone the values
			if (me._cachedDataOpts === values) {
				values = helpers$1.extend({}, values);
			}

			// Custom radius resolution
			values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);

			return values;
		}
	});

	var valueOrDefault$5 = helpers$1.valueOrDefault;

	var PI$1 = Math.PI;
	var DOUBLE_PI$1 = PI$1 * 2;
	var HALF_PI$1 = PI$1 / 2;

	core_defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function legendCallback(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;

			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}

			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function generateLabels(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function (label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);

							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function onClick(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}

				chart.update();
			}
		},

		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,

		// The rotation of the chart, where the first data arc begins.
		rotation: -HALF_PI$1,

		// The total circumference of the chart.
		circumference: DOUBLE_PI$1,

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function title() {
					return '';
				},
				label: function label(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

					if (helpers$1.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}

					return dataLabel;
				}
			}
		}
	});

	var controller_doughnut = core_datasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers$1.noop,

		/**
   * @private
   */
		_dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function getRingIndex(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function update(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var ratioX = 1;
			var ratioY = 1;
			var offsetX = 0;
			var offsetY = 0;
			var meta = me.getMeta();
			var arcs = meta.data;
			var cutout = opts.cutoutPercentage / 100 || 0;
			var circumference = opts.circumference;
			var chartWeight = me._getRingWeight(me.index);
			var maxWidth, maxHeight, i, ilen;

			// If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
			if (circumference < DOUBLE_PI$1) {
				var startAngle = opts.rotation % DOUBLE_PI$1;
				startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
				var endAngle = startAngle + circumference;
				var startX = Math.cos(startAngle);
				var startY = Math.sin(startAngle);
				var endX = Math.cos(endAngle);
				var endY = Math.sin(endAngle);
				var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
				var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
				var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
				var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
				var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
				var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
				var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
				var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
				ratioX = (maxX - minX) / 2;
				ratioY = (maxY - minY) / 2;
				offsetX = -(maxX + minX) / 2;
				offsetY = -(maxY + minY) / 2;
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
			}

			chart.borderWidth = me.getMaxBorderWidth();
			maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
			maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
			chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
			chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
			chart.offsetX = offsetX * chart.outerRadius;
			chart.offsetY = offsetY * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				me.updateElement(arcs[i], i, reset);
			}
		},

		updateElement: function updateElement(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var options = arc._options || {};

			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		calculateTotal: function calculateTotal() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers$1.each(meta.data, function (element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
   	total = NaN;
   }*/

			return total;
		},

		calculateCircumference: function calculateCircumference(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return DOUBLE_PI$1 * (Math.abs(value) / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function getMaxBorderWidth(arcs) {
			var me = this;
			var max = 0;
			var chart = me.chart;
			var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;

			if (!arcs) {
				// Find the outmost visible dataset
				for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						meta = chart.getDatasetMeta(i);
						arcs = meta.data;
						if (i !== me.index) {
							controller = meta.controller;
						}
						break;
					}
				}
			}

			if (!arcs) {
				return 0;
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arc = arcs[i];
				if (controller) {
					controller._configure();
					options = controller._resolveDataElementOptions(arc, i);
				} else {
					options = arc._options;
				}
				if (options.borderAlign !== 'inner') {
					borderWidth = options.borderWidth;
					hoverWidth = options.hoverBorderWidth;

					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
			}
			return max;
		},

		/**
   * @protected
   */
		setHoverStyle: function setHoverStyle(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;

			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};

			model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
		},

		/**
   * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
   * @private
   */
		_getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
			var ringWeightOffset = 0;

			for (var i = 0; i < datasetIndex; ++i) {
				if (this.chart.isDatasetVisible(i)) {
					ringWeightOffset += this._getRingWeight(i);
				}
			}

			return ringWeightOffset;
		},

		/**
   * @private
   */
		_getRingWeight: function _getRingWeight(dataSetIndex) {
			return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
		},

		/**
   * Returns the sum of all visibile data set weights.  This value can be 0.
   * @private
   */
		_getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
			return this._getRingWeightOffset(this.chart.data.datasets.length);
		}
	});

	core_defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},

		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],

			yAxes: [{
				type: 'category',
				position: 'left',
				offset: true,
				gridLines: {
					offsetGridLines: true
				}
			}]
		},

		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},

		tooltips: {
			mode: 'index',
			axis: 'y'
		}
	});

	core_defaults._set('global', {
		datasets: {
			horizontalBar: {
				categoryPercentage: 0.8,
				barPercentage: 0.9
			}
		}
	});

	var controller_horizontalBar = controller_bar.extend({
		/**
   * @private
   */
		_getValueScaleId: function _getValueScaleId() {
			return this.getMeta().xAxisID;
		},

		/**
   * @private
   */
		_getIndexScaleId: function _getIndexScaleId() {
			return this.getMeta().yAxisID;
		}
	});

	var valueOrDefault$6 = helpers$1.valueOrDefault;
	var resolve$2 = helpers$1.options.resolve;
	var isPointInArea = helpers$1.canvas._isPointInArea;

	core_defaults._set('line', {
		showLines: true,
		spanGaps: false,

		hover: {
			mode: 'label'
		},

		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});

	function scaleClip(scale, halfBorderWidth) {
		var tickOpts = scale && scale.options.ticks || {};
		var reverse = tickOpts.reverse;
		var min = tickOpts.min === undefined ? halfBorderWidth : 0;
		var max = tickOpts.max === undefined ? halfBorderWidth : 0;
		return {
			start: reverse ? max : min,
			end: reverse ? min : max
		};
	}

	function defaultClip(xScale, yScale, borderWidth) {
		var halfBorderWidth = borderWidth / 2;
		var x = scaleClip(xScale, halfBorderWidth);
		var y = scaleClip(yScale, halfBorderWidth);

		return {
			top: y.end,
			right: x.end,
			bottom: y.start,
			left: x.start
		};
	}

	function toClip(value) {
		var t, r, b, l;

		if (helpers$1.isObject(value)) {
			t = value.top;
			r = value.right;
			b = value.bottom;
			l = value.left;
		} else {
			t = r = b = l = value;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l
		};
	}

	var controller_line = core_datasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		/**
   * @private
   */
		_datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],

		/**
   * @private
   */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},

		update: function update(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var config = me._config;
			var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
			var i, ilen;

			me._xScale = me.getScaleForId(meta.xAxisID);
			me._yScale = me.getScaleForId(meta.yAxisID);

			// Update Line
			if (showLine) {
				// Compatibility: If the properties are defined with only the old name, use those values
				if (config.tension !== undefined && config.lineTension === undefined) {
					config.lineTension = config.tension;
				}

				// Utility
				line._scale = me._yScale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = me._resolveDatasetElementOptions(line);

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		updateElement: function updateElement(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var xScale = me._xScale;
			var yScale = me._yScale;
			var lineModel = meta.dataset._model;
			var x, y;

			var options = me._resolveDataElementOptions(point, index);

			x = xScale.getPixelForValue((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
				steppedLine: lineModel ? lineModel.steppedLine : false,
				// Tooltip
				hitRadius: options.hitRadius
			};
		},

		/**
   * @private
   */
		_resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
			var me = this;
			var config = me._config;
			var custom = element.custom || {};
			var options = me.chart.options;
			var lineOptions = options.elements.line;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

			// The default behavior of lines is to break at null values, according
			// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
			// This option gives lines the ability to span gaps
			values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
			values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
			values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));

			return values;
		},

		calculatePointY: function calculatePointY(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var yScale = me._yScale;
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;

			if (yScale.options.stacked) {
				rightValue = +yScale.getRightValue(value);
				metasets = chart._getSortedVisibleDatasetMetas();
				ilen = metasets.length;

				for (i = 0; i < ilen; ++i) {
					dsMeta = metasets[i];
					if (dsMeta.index === datasetIndex) {
						break;
					}

					ds = chart.data.datasets[dsMeta.index];
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
						stackedRightValue = +yScale.getRightValue(ds.data[index]);
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}
			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function updateBezierControlPoints() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var lineModel = meta.dataset._model;
			var area = chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (lineModel.spanGaps) {
				points = points.filter(function (pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (lineModel.cubicInterpolationMode === 'monotone') {
				helpers$1.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					if (isPointInArea(model, area)) {
						if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
							model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
							model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						}
						if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
							model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
							model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
						}
					}
				}
			}
		},

		draw: function draw() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var canvas = chart.canvas;
			var i = 0;
			var ilen = points.length;
			var clip;

			if (me._showLine) {
				clip = meta.dataset._model.clip;

				helpers$1.canvas.clipArea(chart.ctx, {
					left: clip.left === false ? 0 : area.left - clip.left,
					right: clip.right === false ? canvas.width : area.right + clip.right,
					top: clip.top === false ? 0 : area.top - clip.top,
					bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
				});

				meta.dataset.draw();

				helpers$1.canvas.unclipArea(chart.ctx);
			}

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		/**
   * @protected
   */
		setHoverStyle: function setHoverStyle(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
		}
	});

	var resolve$3 = helpers$1.options.resolve;

	core_defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},

		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},

		startAngle: -0.5 * Math.PI,
		legendCallback: function legendCallback(chart) {
			var list = document.createElement('ul');
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
			var i, ilen, listItem, listItemSpan;

			list.setAttribute('class', chart.id + '-legend');
			if (datasets.length) {
				for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
					listItem = list.appendChild(document.createElement('li'));
					listItemSpan = listItem.appendChild(document.createElement('span'));
					listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
					if (labels[i]) {
						listItem.appendChild(document.createTextNode(labels[i]));
					}
				}
			}

			return list.outerHTML;
		},
		legend: {
			labels: {
				generateLabels: function generateLabels(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function (label, i) {
							var meta = chart.getDatasetMeta(0);
							var style = meta.controller.getStyle(i);

							return {
								text: label,
								fillStyle: style.backgroundColor,
								strokeStyle: style.borderColor,
								lineWidth: style.borderWidth,
								hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,

								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},

			onClick: function onClick(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;

				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}

				chart.update();
			}
		},

		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function title() {
					return '';
				},
				label: function label(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});

	var controller_polarArea = core_datasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers$1.noop,

		/**
   * @private
   */
		_dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],

		/**
   * @private
   */
		_getIndexScaleId: function _getIndexScaleId() {
			return this.chart.scale.id;
		},

		/**
   * @private
   */
		_getValueScaleId: function _getValueScaleId() {
			return this.chart.scale.id;
		},

		update: function update(reset) {
			var me = this;
			var dataset = me.getDataset();
			var meta = me.getMeta();
			var start = me.chart.options.startAngle || 0;
			var starts = me._starts = [];
			var angles = me._angles = [];
			var arcs = meta.data;
			var i, ilen, angle;

			me._updateRadius();

			meta.count = me.countVisibleElements();

			for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
				starts[i] = start;
				angle = me._computeAngle(i);
				angles[i] = angle;
				start += angle;
			}

			for (i = 0, ilen = arcs.length; i < ilen; ++i) {
				arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
				me.updateElement(arcs[i], i, reset);
			}
		},

		/**
   * @private
   */
		_updateRadius: function _updateRadius() {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);

			chart.outerRadius = Math.max(minSize / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
			me.innerRadius = me.outerRadius - chart.radiusLength;
		},

		updateElement: function updateElement(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = me._starts[index];
			var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var options = arc._options || {};

			helpers$1.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					borderAlign: options.borderAlign,
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			arc.pivot();
		},

		countVisibleElements: function countVisibleElements() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers$1.each(meta.data, function (element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		/**
   * @protected
   */
		setHoverStyle: function setHoverStyle(arc) {
			var model = arc._model;
			var options = arc._options;
			var getHoverColor = helpers$1.getHoverColor;
			var valueOrDefault = helpers$1.valueOrDefault;

			arc.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth
			};

			model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
		},

		/**
   * @private
   */
		_computeAngle: function _computeAngle(index) {
			var me = this;
			var count = this.getMeta().count;
			var dataset = me.getDataset();
			var meta = me.getMeta();

			if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
				return 0;
			}

			// Scriptable options
			var context = {
				chart: me.chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
		}
	});

	core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
	core_defaults._set('pie', {
		cutoutPercentage: 0
	});

	// Pie charts are Doughnut chart with different defaults
	var controller_pie = controller_doughnut;

	var valueOrDefault$7 = helpers$1.valueOrDefault;

	core_defaults._set('radar', {
		spanGaps: false,
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				fill: 'start',
				tension: 0 // no bezier in radar
			}
		}
	});

	var controller_radar = core_datasetController.extend({
		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers$1.noop,

		/**
   * @private
   */
		_datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],

		/**
   * @private
   */
		_dataElementOptions: {
			backgroundColor: 'pointBackgroundColor',
			borderColor: 'pointBorderColor',
			borderWidth: 'pointBorderWidth',
			hitRadius: 'pointHitRadius',
			hoverBackgroundColor: 'pointHoverBackgroundColor',
			hoverBorderColor: 'pointHoverBorderColor',
			hoverBorderWidth: 'pointHoverBorderWidth',
			hoverRadius: 'pointHoverRadius',
			pointStyle: 'pointStyle',
			radius: 'pointRadius',
			rotation: 'pointRotation'
		},

		/**
   * @private
   */
		_getIndexScaleId: function _getIndexScaleId() {
			return this.chart.scale.id;
		},

		/**
   * @private
   */
		_getValueScaleId: function _getValueScaleId() {
			return this.chart.scale.id;
		},

		update: function update(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var scale = me.chart.scale;
			var config = me._config;
			var i, ilen;

			// Compatibility: If the properties are defined with only the old name, use those values
			if (config.tension !== undefined && config.lineTension === undefined) {
				config.lineTension = config.tension;
			}

			// Utility
			line._scale = scale;
			line._datasetIndex = me.index;
			// Data
			line._children = points;
			line._loop = true;
			// Model
			line._model = me._resolveDatasetElementOptions(line);

			line.pivot();

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			// Update bezier control points
			me.updateBezierControlPoints();

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		updateElement: function updateElement(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
			var options = me._resolveDataElementOptions(point, index);
			var lineModel = me.getMeta().dataset._model;
			var x = reset ? scale.xCenter : pointPosition.x;
			var y = reset ? scale.yCenter : pointPosition.y;

			// Utility
			point._scale = scale;
			point._options = options;
			point._datasetIndex = me.index;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x, // value not used in dataset scale, but we want a consistent API between scales
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: options.radius,
				pointStyle: options.pointStyle,
				rotation: options.rotation,
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),

				// Tooltip
				hitRadius: options.hitRadius
			};
		},

		/**
   * @private
   */
		_resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
			var me = this;
			var config = me._config;
			var options = me.chart.options;
			var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

			values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
			values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);

			return values;
		},

		updateBezierControlPoints: function updateBezierControlPoints() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = meta.data || [];
			var i, ilen, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function (pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			for (i = 0, ilen = points.length; i < ilen; ++i) {
				model = points[i]._model;
				controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
				model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
				model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
				model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
			}
		},

		setHoverStyle: function setHoverStyle(point) {
			var model = point._model;
			var options = point._options;
			var getHoverColor = helpers$1.getHoverColor;

			point.$previousStyle = {
				backgroundColor: model.backgroundColor,
				borderColor: model.borderColor,
				borderWidth: model.borderWidth,
				radius: model.radius
			};

			model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
			model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
			model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
			model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
		}
	});

	core_defaults._set('scatter', {
		hover: {
			mode: 'single'
		},

		scales: {
			xAxes: [{
				id: 'x-axis-1', // need an ID so datasets can reference the scale
				type: 'linear', // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},

		tooltips: {
			callbacks: {
				title: function title() {
					return ''; // doesn't make sense for scatter since data are formatted as a point
				},
				label: function label(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});

	core_defaults._set('global', {
		datasets: {
			scatter: {
				showLine: false
			}
		}
	});

	// Scatter charts use line controllers
	var controller_scatter = controller_line;

	// NOTE export a map in which the key represents the controller type, not
	// the class, and so must be CamelCase in order to be correctly retrieved
	// by the controller in core.controller.js (`controllers[meta.type]`).

	var controllers = {
		bar: controller_bar,
		bubble: controller_bubble,
		doughnut: controller_doughnut,
		horizontalBar: controller_horizontalBar,
		line: controller_line,
		polarArea: controller_polarArea,
		pie: controller_pie,
		radar: controller_radar,
		scatter: controller_scatter
	};

	/**
  * Helper function to get relative position for an event
  * @param {Event|IEvent} event - The event to get the position for
  * @param {Chart} chart - The chart
  * @returns {object} the event position
  */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}

		return helpers$1.getRelativePosition(e, chart);
	}

	/**
  * Helper function to traverse all of the visible elements in the chart
  * @param {Chart} chart - the chart
  * @param {function} handler - the callback to execute for each visible item
  */
	function parseVisibleItems(chart, handler) {
		var metasets = chart._getSortedVisibleDatasetMetas();
		var metadata, i, j, ilen, jlen, element;

		for (i = 0, ilen = metasets.length; i < ilen; ++i) {
			metadata = metasets[i].data;
			for (j = 0, jlen = metadata.length; j < jlen; ++j) {
				element = metadata[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}

	/**
  * Helper function to get the items that intersect the event position
  * @param {ChartElement[]} items - elements to filter
  * @param {object} position - the point to be nearest to
  * @return {ChartElement[]} the nearest items
  */
	function getIntersectItems(chart, position) {
		var elements = [];

		parseVisibleItems(chart, function (element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});

		return elements;
	}

	/**
  * Helper function to get the items nearest to the event position considering all visible items in teh chart
  * @param {Chart} chart - the chart to look at elements from
  * @param {object} position - the point to be nearest to
  * @param {boolean} intersect - if true, only consider items that intersect the position
  * @param {function} distanceMetric - function to provide the distance between points
  * @return {ChartElement[]} the nearest items
  */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];

		parseVisibleItems(chart, function (element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}

			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});

		return nearestItems;
	}

	/**
  * Get a distance metric function for two points based on the
  * axis mode setting
  * @param {string} axis - the axis mode. x|y|xy
  */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;

		return function (pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}

	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];

		if (!items.length) {
			return [];
		}

		chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		});

		return elements;
	}

	/**
  * @interface IInteractionOptions
  */
	/**
  * If true, only consider items that intersect the point
  * @name IInterfaceOptions#boolean
  * @type Boolean
  */

	/**
  * Contains interaction related functions
  * @namespace Chart.Interaction
  */
	var core_interaction = {
		// Helper function for different modes
		modes: {
			single: function single(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];

				parseVisibleItems(chart, function (element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});

				return elements.slice(0, 1);
			},

			/**
    * @function Chart.Interaction.modes.label
    * @deprecated since version 2.4.0
    * @todo remove at version 3
    * @private
    */
			label: indexMode,

			/**
    * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
    * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
    * @function Chart.Interaction.modes.index
    * @since v2.4.0
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @param {IInteractionOptions} options - options to use during interaction
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			index: indexMode,

			/**
    * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
    * If the options.intersect is false, we find the nearest item and return the items in that dataset
    * @function Chart.Interaction.modes.dataset
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @param {IInteractionOptions} options - options to use during interaction
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			dataset: function dataset(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}

				return items;
			},

			/**
    * @function Chart.Interaction.modes.x-axis
    * @deprecated since version 2.4.0. Use index mode and intersect == true
    * @todo remove at version 3
    * @private
    */
			'x-axis': function xAxis(chart, e) {
				return indexMode(chart, e, { intersect: false });
			},

			/**
    * Point mode returns all elements that hit test based on the event position
    * of the event
    * @function Chart.Interaction.modes.intersect
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			point: function point(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},

			/**
    * nearest mode returns the element closest to the point
    * @function Chart.Interaction.modes.intersect
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @param {IInteractionOptions} options - options to use
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			nearest: function nearest(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				return getNearestItems(chart, position, options.intersect, distanceMetric);
			},

			/**
    * x mode returns the elements that hit-test at the current x coordinate
    * @function Chart.Interaction.modes.x
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @param {IInteractionOptions} options - options to use
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			x: function x(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function (element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},

			/**
    * y mode returns the elements that hit-test at the current y coordinate
    * @function Chart.Interaction.modes.y
    * @param {Chart} chart - the chart we are returning items from
    * @param {Event} e - the event we are find things at
    * @param {IInteractionOptions} options - options to use
    * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
    */
			y: function y(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;

				parseVisibleItems(chart, function (element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}

					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});

				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};

	var extend = helpers$1.extend;

	function filterByPosition(array, position) {
		return helpers$1.where(array, function (v) {
			return v.pos === position;
		});
	}

	function sortByWeight(array, reverse) {
		return array.sort(function (a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
		});
	}

	function wrapBoxes(boxes) {
		var layoutBoxes = [];
		var i, ilen, box;

		for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
			box = boxes[i];
			layoutBoxes.push({
				index: i,
				box: box,
				pos: box.position,
				horizontal: box.isHorizontal(),
				weight: box.weight
			});
		}
		return layoutBoxes;
	}

	function setLayoutDims(layouts, params) {
		var i, ilen, layout;
		for (i = 0, ilen = layouts.length; i < ilen; ++i) {
			layout = layouts[i];
			// store width used instead of chartArea.w in fitBoxes
			layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
			// store height used instead of chartArea.h in fitBoxes
			layout.height = layout.horizontal && params.hBoxMaxHeight;
		}
	}

	function buildLayoutBoxes(boxes) {
		var layoutBoxes = wrapBoxes(boxes);
		var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
		var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
		var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
		var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));

		return {
			leftAndTop: left.concat(top),
			rightAndBottom: right.concat(bottom),
			chartArea: filterByPosition(layoutBoxes, 'chartArea'),
			vertical: left.concat(right),
			horizontal: top.concat(bottom)
		};
	}

	function getCombinedMax(maxPadding, chartArea, a, b) {
		return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
	}

	function updateDims(chartArea, params, layout) {
		var box = layout.box;
		var maxPadding = chartArea.maxPadding;
		var newWidth, newHeight;

		if (layout.size) {
			// this layout was already counted for, lets first reduce old size
			chartArea[layout.pos] -= layout.size;
		}
		layout.size = layout.horizontal ? box.height : box.width;
		chartArea[layout.pos] += layout.size;

		if (box.getPadding) {
			var boxPadding = box.getPadding();
			maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
			maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
			maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
			maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
		}

		newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
		newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');

		if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
			chartArea.w = newWidth;
			chartArea.h = newHeight;

			// return true if chart area changed in layout's direction
			var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
			return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
		}
	}

	function handleMaxPadding(chartArea) {
		var maxPadding = chartArea.maxPadding;

		function updatePos(pos) {
			var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
			chartArea[pos] += change;
			return change;
		}
		chartArea.y += updatePos('top');
		chartArea.x += updatePos('left');
		updatePos('right');
		updatePos('bottom');
	}

	function getMargins(horizontal, chartArea) {
		var maxPadding = chartArea.maxPadding;

		function marginForPositions(positions) {
			var margin = { left: 0, top: 0, right: 0, bottom: 0 };
			positions.forEach(function (pos) {
				margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
			});
			return margin;
		}

		return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
	}

	function fitBoxes(boxes, chartArea, params) {
		var refitBoxes = [];
		var i, ilen, layout, box, refit, changed;

		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;

			box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
			if (updateDims(chartArea, params, layout)) {
				changed = true;
				if (refitBoxes.length) {
					// Dimensions changed and there were non full width boxes before this
					// -> we have to refit those
					refit = true;
				}
			}
			if (!box.fullWidth) {
				// fullWidth boxes don't need to be re-fitted in any case
				refitBoxes.push(layout);
			}
		}

		return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
	}

	function placeBoxes(boxes, chartArea, params) {
		var userPadding = params.padding;
		var x = chartArea.x;
		var y = chartArea.y;
		var i, ilen, layout, box;

		for (i = 0, ilen = boxes.length; i < ilen; ++i) {
			layout = boxes[i];
			box = layout.box;
			if (layout.horizontal) {
				box.left = box.fullWidth ? userPadding.left : chartArea.left;
				box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
				box.top = y;
				box.bottom = y + box.height;
				box.width = box.right - box.left;
				y = box.bottom;
			} else {
				box.left = x;
				box.right = x + box.width;
				box.top = chartArea.top;
				box.bottom = chartArea.top + chartArea.h;
				box.height = box.bottom - box.top;
				x = box.right;
			}
		}

		chartArea.x = x;
		chartArea.y = y;
	}

	core_defaults._set('global', {
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});

	/**
  * @interface ILayoutItem
  * @prop {string} position - The position of the item in the chart layout. Possible values are
  * 'left', 'top', 'right', 'bottom', and 'chartArea'
  * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
  * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
  * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
  * @prop {function} update - Takes two parameters: width and height. Returns size of item
  * @prop {function} getPadding -  Returns an object with padding on the edges
  * @prop {number} width - Width of item. Must be valid after update()
  * @prop {number} height - Height of item. Must be valid after update()
  * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
  * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
  * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
  * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
  */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	var core_layouts = {
		defaults: {},

		/**
   * Register a box to a chart.
   * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
   * @param {Chart} chart - the chart to use
   * @param {ILayoutItem} item - the item to add to be layed out
   */
		addBox: function addBox(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;
			item._layers = item._layers || function () {
				return [{
					z: 0,
					draw: function draw() {
						item.draw.apply(item, arguments);
					}
				}];
			};

			chart.boxes.push(item);
		},

		/**
   * Remove a layoutItem from a chart
   * @param {Chart} chart - the chart to remove the box from
   * @param {ILayoutItem} layoutItem - the item to remove from the layout
   */
		removeBox: function removeBox(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
   * Sets (or updates) options on the given `item`.
   * @param {Chart} chart - the chart in which the item lives (or will be added to)
   * @param {ILayoutItem} item - the item to configure with the given options
   * @param {object} options - the new item options.
   */
		configure: function configure(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
   * Fits boxes of the given chart into the given size by having each box measure itself
   * then running a fitting algorithm
   * @param {Chart} chart - the chart
   * @param {number} width - the width to fit into
   * @param {number} height - the height to fit into
   */
		update: function update(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers$1.options.toPadding(layoutOptions.padding);

			var availableWidth = width - padding.width;
			var availableHeight = height - padding.height;
			var boxes = buildLayoutBoxes(chart.boxes);
			var verticalBoxes = boxes.vertical;
			var horizontalBoxes = boxes.horizontal;

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//

			var params = Object.freeze({
				outerWidth: width,
				outerHeight: height,
				padding: padding,
				availableWidth: availableWidth,
				vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
				hBoxMaxHeight: availableHeight / 2
			});
			var chartArea = extend({
				maxPadding: extend({}, padding),
				w: availableWidth,
				h: availableHeight,
				x: padding.left,
				y: padding.top
			}, padding);

			setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

			// First fit vertical boxes
			fitBoxes(verticalBoxes, chartArea, params);

			// Then fit horizontal boxes
			if (fitBoxes(horizontalBoxes, chartArea, params)) {
				// if the area changed, re-fit vertical boxes
				fitBoxes(verticalBoxes, chartArea, params);
			}

			handleMaxPadding(chartArea);

			// Finally place the boxes to correct coordinates
			placeBoxes(boxes.leftAndTop, chartArea, params);

			// Move to opposite side of chart
			chartArea.x += chartArea.w;
			chartArea.y += chartArea.h;

			placeBoxes(boxes.rightAndBottom, chartArea, params);

			chart.chartArea = {
				left: chartArea.left,
				top: chartArea.top,
				right: chartArea.left + chartArea.w,
				bottom: chartArea.top + chartArea.h
			};

			// Finally update boxes in chartArea (radial scale for example)
			helpers$1.each(boxes.chartArea, function (layout) {
				var box = layout.box;
				extend(box, chart.chartArea);
				box.update(chartArea.w, chartArea.h);
			});
		}
	};

	/**
  * Platform fallback implementation (minimal).
  * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
  */

	var platform_basic = {
		acquireContext: function acquireContext(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			return item && item.getContext('2d') || null;
		}
	};

	var platform_dom = "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n";

	var platform_dom$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		'default': platform_dom
	});

	var stylesheet = getCjsExportFromNamespace(platform_dom$1);

	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

	/**
  * DOM event types -> Chart.js event types.
  * Note: only events with different types are mapped.
  * @see https://developer.mozilla.org/en-US/docs/Web/Events
  */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};

	/**
  * The "used" size is the final value of a dimension property after all calculations have
  * been performed. This method uses the computed style of `element` but returns undefined
  * if the computed style is not expressed in pixels. That can happen in some cases where
  * `element` has a size relative to its parent and this last one is not yet displayed,
  * for example because of `display: none` on a parent node.
  * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
  * @returns {number} Size in pixels or undefined if unknown.
  */
	function readUsedSize(element, property) {
		var value = helpers$1.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}

	/**
  * Initializes the canvas style and render size without modifying the canvas display size,
  * since responsiveness is handled by the controller.resize() method. The config is used
  * to determine the aspect ratio to apply in case no explicit height has been specified.
  */
	function initCanvas(canvas, config) {
		var style = canvas.style;

		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');

		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};

		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';

		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}

		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}

		return canvas;
	}

	/**
  * Detects support for options object argument in addEventListener.
  * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
  * @private
  */
	var supportsEventListenerOptions = function () {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				// eslint-disable-next-line getter-return
				get: function get() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}();

	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? { passive: true } : false;

	function addListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}

	function removeListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}

	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null
		};
	}

	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers$1.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}

	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];

		return function () {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;

			if (!ticking) {
				ticking = true;
				helpers$1.requestAnimFrame.call(window, function () {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}

	function createDiv(cls) {
		var el = document.createElement('div');
		el.className = cls || '';
		return el;
	}

	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var maxSize = 1000000;

		// NOTE(SB) Don't use innerHTML because it could be considered unsafe.
		// https://github.com/chartjs/Chart.js/issues/5902
		var resizer = createDiv(CSS_SIZE_MONITOR);
		var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
		var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');

		expand.appendChild(createDiv());
		shrink.appendChild(createDiv());

		resizer.appendChild(expand);
		resizer.appendChild(shrink);
		resizer._reset = function () {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};

		var onScroll = function onScroll() {
			resizer._reset();
			handler();
		};

		addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

		return resizer;
	}

	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function (e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};

		helpers$1.each(ANIMATION_START_EVENTS, function (type) {
			addListener(node, type, proxy);
		});

		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;

		node.classList.add(CSS_RENDER_MONITOR);
	}

	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;

		if (proxy) {
			helpers$1.each(ANIMATION_START_EVENTS, function (type) {
				removeListener(node, type, proxy);
			});

			delete expando.renderProxy;
		}

		node.classList.remove(CSS_RENDER_MONITOR);
	}

	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function () {
			if (expando.resizer) {
				var container = chart.options.maintainAspectRatio && node.parentNode;
				var w = container ? container.clientWidth : 0;
				listener(createEvent('resize', chart));
				if (container && container.clientWidth < w && chart.canvas) {
					// If the container size shrank during chart resize, let's assume
					// scrollbar appeared. So we resize again with the scrollbar visible -
					// effectively making chart smaller and the scrollbar hidden again.
					// Because we are inside `throttled`, and currently `ticking`, scroll
					// events are ignored during this whole 2 resize process.
					// If we assumed wrong and something else happened, we are resizing
					// twice in a frame (potential performance issue)
					listener(createEvent('resize', chart));
				}
			}
		}));

		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function () {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}

				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}

	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;

		delete expando.resizer;
		unwatchForRender(node);

		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}

	/**
  * Injects CSS styles inline if the styles are not already present.
  * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
  * @param {string} css - the CSS to be injected.
  */
	function injectCSS(rootNode, css) {
		// https://stackoverflow.com/q/3922139
		var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
		if (!expando.containsStyles) {
			expando.containsStyles = true;
			css = '/* Chart.js */\n' + css;
			var style = document.createElement('style');
			style.setAttribute('type', 'text/css');
			style.appendChild(document.createTextNode(css));
			rootNode.appendChild(style);
		}
	}

	var platform_dom$2 = {
		/**
   * When `true`, prevents the automatic injection of the stylesheet required to
   * correctly detect when the chart is added to the DOM and then resized. This
   * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
   * to be manually imported to make this library compatible with any CSP.
   * See https://github.com/chartjs/Chart.js/issues/5208
   */
		disableCSSInjection: false,

		/**
   * This property holds whether this platform is enabled for the current environment.
   * Currently used by platform.js to select the proper implementation.
   * @private
   */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

		/**
   * Initializes resources that depend on platform options.
   * @param {HTMLCanvasElement} canvas - The Canvas element.
   * @private
   */
		_ensureLoaded: function _ensureLoaded(canvas) {
			if (!this.disableCSSInjection) {
				// If the canvas is in a shadow DOM, then the styles must also be inserted
				// into the same shadow DOM.
				// https://github.com/chartjs/Chart.js/issues/5763
				var root = canvas.getRootNode ? canvas.getRootNode() : document;
				var targetNode = root.host ? root : document.head;
				injectCSS(targetNode, stylesheet);
			}
		},

		acquireContext: function acquireContext(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}

			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}

			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');

			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				// Load platform resources on first chart creation, to make it possible to
				// import the library before setting platform options.
				this._ensureLoaded(item);
				initCanvas(item, config);
				return context;
			}

			return null;
		},

		releaseContext: function releaseContext(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}

			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function (prop) {
				var value = initial[prop];
				if (helpers$1.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});

			helpers$1.each(initial.style || {}, function (value, key) {
				canvas.style[key] = value;
			});

			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			// eslint-disable-next-line no-self-assign
			canvas.width = canvas.width;

			delete canvas[EXPANDO_KEY];
		},

		addEventListener: function addEventListener(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}

			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function (event) {
				listener(fromNativeEvent(event, chart));
			};

			addListener(canvas, type, proxy);
		},

		removeEventListener: function removeEventListener(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas);
				return;
			}

			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}

			removeListener(canvas, type, proxy);
		}
	};

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use EventTarget.addEventListener instead.
  * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
  * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
  * @function Chart.helpers.addEvent
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers$1.addEvent = addListener;

	/**
  * Provided for backward compatibility, use EventTarget.removeEventListener instead.
  * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
  * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
  * @function Chart.helpers.removeEvent
  * @deprecated since version 2.7.0
  * @todo remove at version 3
  * @private
  */
	helpers$1.removeEvent = removeListener;

	// @TODO Make possible to select another platform at build time.
	var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

	/**
  * @namespace Chart.platform
  * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
  * @since 2.4.0
  */
	var platform = helpers$1.extend({
		/**
   * @since 2.7.0
   */
		initialize: function initialize() {},

		/**
   * Called at chart construction time, returns a context2d instance implementing
   * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
   * @param {*} item - The native item from which to acquire context (platform specific)
   * @param {object} options - The chart options
   * @returns {CanvasRenderingContext2D} context2d instance
   */
		acquireContext: function acquireContext() {},

		/**
   * Called at chart destruction time, releases any resources associated to the context
   * previously returned by the acquireContext() method.
   * @param {CanvasRenderingContext2D} context - The context2d instance
   * @returns {boolean} true if the method succeeded, else false
   */
		releaseContext: function releaseContext() {},

		/**
   * Registers the specified listener on the given chart.
   * @param {Chart} chart - Chart from which to listen for event
   * @param {string} type - The ({@link IEvent}) type to listen for
   * @param {function} listener - Receives a notification (an object that implements
   * the {@link IEvent} interface) when an event of the specified type occurs.
   */
		addEventListener: function addEventListener() {},

		/**
   * Removes the specified listener previously registered with addEventListener.
   * @param {Chart} chart - Chart from which to remove the listener
   * @param {string} type - The ({@link IEvent}) type to remove
   * @param {function} listener - The listener function to remove from the event target.
   */
		removeEventListener: function removeEventListener() {}

	}, implementation);

	core_defaults._set('global', {
		plugins: {}
	});

	/**
  * The plugin service singleton
  * @namespace Chart.plugins
  * @since 2.1.0
  */
	var core_plugins = {
		/**
   * Globally registered plugins.
   * @private
   */
		_plugins: [],

		/**
   * This identifier is used to invalidate the descriptors cache attached to each chart
   * when a global plugin is registered or unregistered. In this case, the cache ID is
   * incremented and descriptors are regenerated during following API calls.
   * @private
   */
		_cacheId: 0,

		/**
   * Registers the given plugin(s) if not already registered.
   * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
   */
		register: function register(plugins) {
			var p = this._plugins;
			[].concat(plugins).forEach(function (plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
   * Unregisters the given plugin(s) only if registered.
   * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
   */
		unregister: function unregister(plugins) {
			var p = this._plugins;
			[].concat(plugins).forEach(function (plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
   * Remove all registered plugins.
   * @since 2.1.5
   */
		clear: function clear() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
   * Returns the number of registered plugins?
   * @returns {number}
   * @since 2.1.5
   */
		count: function count() {
			return this._plugins.length;
		},

		/**
   * Returns all registered plugin instances.
   * @returns {IPlugin[]} array of plugin objects.
   * @since 2.1.5
   */
		getAll: function getAll() {
			return this._plugins;
		},

		/**
   * Calls enabled plugins for `chart` on the specified hook and with the given args.
   * This method immediately returns as soon as a plugin explicitly returns false. The
   * returned value can be used, for instance, to interrupt the current action.
   * @param {Chart} chart - The chart instance for which plugins should be called.
   * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
   * @param {Array} [args] - Extra arguments to apply to the hook call.
   * @returns {boolean} false if any of the plugins return false, else returns true.
   */
		notify: function notify(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
   * Returns descriptors of enabled plugins for the given chart.
   * @returns {object[]} [{ plugin, options }]
   * @private
   */
		descriptors: function descriptors(chart) {
			var cache = chart.$plugins || (chart.$plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = chart && chart.config || {};
			var options = config.options && config.options.plugins || {};

			this._plugins.concat(config.plugins || []).forEach(function (plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers$1.clone(core_defaults.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		},

		/**
   * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
   * but in some cases, this reference can be changed by the user when updating options.
   * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
   * @private
   */
		_invalidate: function _invalidate(chart) {
			delete chart.$plugins;
		}
	};

	var core_scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers$1.clone(scaleDefaults);
		},
		getScaleConstructor: function getScaleConstructor(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function getScaleDefaults(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function updateScaleDefaults(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function addScalesToLayout(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers$1.each(chart.scales, function (scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				core_layouts.addBox(chart, scale);
			});
		}
	};

	var valueOrDefault$8 = helpers$1.valueOrDefault;
	var getRtlHelper = helpers$1.rtl.getRtlAdapter;

	core_defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers$1.noop,
				title: function title(tooltipItems, data) {
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;

					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
						if (item.label) {
							title = item.label;
						} else if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}

					return title;
				},
				afterTitle: helpers$1.noop,

				// Args are: (tooltipItems, data)
				beforeBody: helpers$1.noop,

				// Args are: (tooltipItem, data)
				beforeLabel: helpers$1.noop,
				label: function label(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';

					if (label) {
						label += ': ';
					}
					if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
						label += tooltipItem.value;
					} else {
						label += tooltipItem.yLabel;
					}
					return label;
				},
				labelColor: function labelColor(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function labelTextColor() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers$1.noop,

				// Args are: (tooltipItems, data)
				afterBody: helpers$1.noop,

				// Args are: (tooltipItems, data)
				beforeFooter: helpers$1.noop,
				footer: helpers$1.noop,
				afterFooter: helpers$1.noop
			}
		}
	});

	var positioners = {
		/**
   * Average mode places the tooltip at the average position of the elements shown
   * @function Chart.Tooltip.positioners.average
   * @param elements {ChartElement[]} the elements being displayed in the tooltip
   * @returns {object} tooltip position
   */
		average: function average(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: x / count,
				y: y / count
			};
		},

		/**
   * Gets the tooltip position nearest of the item nearest to the event position
   * @function Chart.Tooltip.positioners.nearest
   * @param elements {Chart.Element[]} the tooltip elements
   * @param eventPosition {object} the position of the event in canvas coordinates
   * @returns {object} the tooltip position
   */
		nearest: function nearest(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers$1.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers$1.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	/**
  * Returns array of strings split by newline
  * @param {string} value - The value to split by newline.
  * @returns {string[]} value if newline present - Returned from String split() method
  * @function
  */
	function splitNewlines(str) {
		if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
			return str.split('\n');
		}
		return str;
	}

	/**
  * Private helper to create a tooltip item model
  * @param element - the chart element (point, arc, bar) to create the tooltip item for
  * @return new tooltip item
  */
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;
		var controller = element._chart.getDatasetMeta(datasetIndex).controller;
		var indexScale = controller._getIndexScale();
		var valueScale = controller._getValueScale();

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
			value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
  * Helper to get the reset model for the tooltip
  * @param tooltipOpts {object} the tooltip options
  */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = core_defaults.global;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Drawing direction and text direction
			rtl: tooltipOpts.rtl,
			textDirection: tooltipOpts.textDirection,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
  * Get the size of the tooltip
  */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function (count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * footerFontSize; // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function maxLineWidth(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers$1.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
		helpers$1.each(body, function (bodyItem) {
			helpers$1.each(bodyItem.before, maxLineWidth);
			helpers$1.each(bodyItem.lines, maxLineWidth);
			helpers$1.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers$1.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
  * Helper to get the alignment of a tooltip given the size
  */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > chart.height - size.height) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function lf(x) {
				return x <= midX;
			};
			rf = function rf(x) {
				return x > midX;
			};
		} else {
			lf = function lf(x) {
				return x <= size.width / 2;
			};
			rf = function rf(x) {
				return x >= chart.width - size.width / 2;
			};
		}

		olf = function olf(x) {
			return x + size.width + model.caretSize + model.caretPadding > chart.width;
		};
		orf = function orf(x) {
			return x - size.width - model.caretSize - model.caretPadding < 0;
		};
		yf = function yf(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
  * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
  */
	function getBackgroundPoint(vm, size, alignment, chart) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= size.width / 2;
			if (x + size.width > chart.width) {
				x = chart.width - size.width;
			}
			if (x < 0) {
				x = 0;
			}
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= size.height / 2;
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	function getAlignedX(vm, align) {
		return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
	}

	/**
  * Helper to build before and after body lines
  */
	function getBeforeAfterBodyLines(callback) {
		return pushOrConcat([], splitNewlines(callback));
	}

	var exports$4 = core_element.extend({
		initialize: function initialize() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function getTitle() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeTitle));
			lines = pushOrConcat(lines, splitNewlines(title));
			lines = pushOrConcat(lines, splitNewlines(afterTitle));

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function getBeforeBody() {
			return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
		},

		// Args are: (tooltipItem, data)
		getBody: function getBody(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers$1.each(tooltipItems, function (tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function getAfterBody() {
			return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function getFooter() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, splitNewlines(beforeFooter));
			lines = pushOrConcat(lines, splitNewlines(footer));
			lines = pushOrConcat(lines, splitNewlines(afterFooter));

			return lines;
		},

		update: function update(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function (a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function (a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers$1.each(tooltipItems, function (tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});

				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = tooltipPosition.x;
				model.y = tooltipPosition.y;
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},

		drawCaret: function drawCaret(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + height / 2;

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = vm.caretX;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return { x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3 };
		},

		drawTitle: function drawTitle(pt, vm, ctx) {
			var title = vm.title;
			var length = title.length;
			var titleFontSize, titleSpacing, i;

			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

				pt.x = getAlignedX(vm, vm._titleAlign);

				ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
				ctx.textBaseline = 'middle';

				titleFontSize = vm.titleFontSize;
				titleSpacing = vm.titleSpacing;

				ctx.fillStyle = vm.titleFontColor;
				ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				for (i = 0; i < length; ++i) {
					ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},

		drawBody: function drawBody(pt, vm, ctx) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var bodyAlign = vm._bodyAlign;
			var body = vm.body;
			var drawColorBoxes = vm.displayColors;
			var xLinePadding = 0;
			var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;

			var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

			var fillLineOfText = function fillLineOfText(line) {
				ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
				pt.y += bodyFontSize + bodySpacing;
			};

			var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
			var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);

			ctx.textAlign = bodyAlign;
			ctx.textBaseline = 'middle';
			ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			pt.x = getAlignedX(vm, bodyAlignForCalculation);

			// Before body lines
			ctx.fillStyle = vm.bodyFontColor;
			helpers$1.each(vm.beforeBody, fillLineOfText);

			xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;

			// Draw body lines now
			for (i = 0, ilen = body.length; i < ilen; ++i) {
				bodyItem = body[i];
				textColor = vm.labelTextColors[i];
				labelColors = vm.labelColors[i];

				ctx.fillStyle = textColor;
				helpers$1.each(bodyItem.before, fillLineOfText);

				lines = bodyItem.lines;
				for (j = 0, jlen = lines.length; j < jlen; ++j) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						var rtlColorX = rtlHelper.x(colorX);

						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = vm.legendColorBackground;
						ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = labelColors.borderColor;
						ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = labelColors.backgroundColor;
						ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(lines[j]);
				}

				helpers$1.each(bodyItem.after, fillLineOfText);
			}

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers$1.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},

		drawFooter: function drawFooter(pt, vm, ctx) {
			var footer = vm.footer;
			var length = footer.length;
			var footerFontSize, i;

			if (length) {
				var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);

				pt.x = getAlignedX(vm, vm._footerAlign);
				pt.y += vm.footerMarginTop;

				ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
				ctx.textBaseline = 'middle';

				footerFontSize = vm.footerFontSize;

				ctx.fillStyle = vm.footerFontColor;
				ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				for (i = 0; i < length; ++i) {
					ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
					pt.y += footerFontSize + vm.footerSpacing;
				}
			}
		},

		drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},

		draw: function draw() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				ctx.save();
				ctx.globalAlpha = opacity;

				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize);

				// Draw Title, Body, and Footer
				pt.y += vm.yPadding;

				helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

				// Titles
				this.drawTitle(pt, vm, ctx);

				// Body
				this.drawBody(pt, vm, ctx);

				// Footer
				this.drawFooter(pt, vm, ctx);

				helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);

				ctx.restore();
			}
		},

		/**
   * Handle an event
   * @private
   * @param {IEvent} event - The event to handle
   * @returns {boolean} true if the tooltip changed
   */
		handleEvent: function handleEvent(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				if (options.reverse) {
					me._active.reverse();
				}
			}

			// Remember Last Actives
			changed = !helpers$1.arrayEquals(me._active, me._lastActive);

			// Only handle target event on tooltip change
			if (changed) {
				me._lastActive = me._active;

				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};

					me.update(true);
					me.pivot();
				}
			}

			return changed;
		}
	});

	/**
  * @namespace Chart.Tooltip.positioners
  */
	var positioners_1 = positioners;

	var core_tooltip = exports$4;
	core_tooltip.positioners = positioners_1;

	var valueOrDefault$9 = helpers$1.valueOrDefault;

	core_defaults._set('global', {
		elements: {},
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		maintainAspectRatio: true,
		responsive: true,
		responsiveAnimationDuration: 0
	});

	/**
  * Recursively merge the given config objects representing the `scales` option
  * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
  * returns a deep copy of the result, thus doesn't alter inputs.
  */
	function mergeScaleConfig() /* config objects ... */{
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function merger(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers$1.merge(target[key][i], scale);
						}
					}
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}

	/**
  * Recursively merge the given config objects as the root options by handling
  * default scale options for the `scales` and `scale` properties, then returns
  * a deep copy of the result, thus doesn't alter inputs.
  */
	function mergeConfig() /* config objects ... */{
		return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
			merger: function merger(key, target, source, options) {
				var tval = target[key] || Object.create(null);
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = mergeScaleConfig(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers$1._merger(key, target, source, options);
				}
			}
		});
	}

	function initConfig(config) {
		config = config || Object.create(null);

		// Do NOT use mergeConfig for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});

		return config;
	}

	function updateConfig(chart) {
		var newOptions = chart.options;

		helpers$1.each(chart.scales, function (scale) {
			core_layouts.removeBox(chart, scale);
		});

		newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);

		chart.options = chart.config.options = newOptions;
		chart.ensureScalesHaveIDs();
		chart.buildOrUpdateScales();

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
		chart.tooltip.initialize();
	}

	function nextAvailableScaleId(axesOpts, prefix, index) {
		var id;
		var hasId = function hasId(obj) {
			return obj.id === id;
		};

		do {
			id = prefix + index++;
		} while (helpers$1.findIndex(axesOpts, hasId) >= 0);

		return id;
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	function compare2Level(l1, l2) {
		return function (a, b) {
			return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
		};
	}

	var Chart = function Chart(item, config) {
		this.construct(item, config);
		return this;
	};

	helpers$1.extend(Chart.prototype, /** @lends Chart */{
		/**
   * @private
   */
		construct: function construct(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers$1.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;
			me._layers = [];

			/**
    * Provided for backward compatibility, Chart and Chart.Controller have been merged,
    * the "instance" still need to be defined since it might be called from plugins.
    * @prop Chart#chart
    * @deprecated since version 2.6.0
    * @todo remove at version 3
    * @private
    */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function get() {
					return me.config.data;
				},
				set: function set(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
   * @private
   */
		initialize: function initialize() {
			var me = this;

			// Before init plugin notification
			core_plugins.notify(me, 'beforeInit');

			helpers$1.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			me.initToolTip();

			// After init plugin notification
			core_plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function clear() {
			helpers$1.canvas.clear(this);
			return this;
		},

		stop: function stop() {
			// Stops any current animation loop occurring
			core_animations.cancelAnimation(this);
			return this;
		},

		resize: function resize(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
			var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers$1.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = { width: newWidth, height: newHeight };
				core_plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (options.onResize) {
					options.onResize(me, newSize);
				}

				me.stop();
				me.update({
					duration: options.responsiveAnimationDuration
				});
			}
		},

		ensureScalesHaveIDs: function ensureScalesHaveIDs() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
				if (!xAxisOptions.id) {
					xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
				}
			});

			helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
				if (!yAxisOptions.id) {
					yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
				}
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
   * Builds a map of scale ID to scale object for future lookup.
   */
		buildOrUpdateScales: function buildOrUpdateScales() {
			var me = this;
			var options = me.options;
			var scales = me.scales || {};
			var items = [];
			var updated = Object.keys(scales).reduce(function (obj, id) {
				obj[id] = false;
				return obj;
			}, {});

			if (options.scales) {
				items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
					return { options: xAxisOptions, dtype: 'category', dposition: 'bottom' };
				}), (options.scales.yAxes || []).map(function (yAxisOptions) {
					return { options: yAxisOptions, dtype: 'linear', dposition: 'left' };
				}));
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers$1.each(items, function (item) {
				var scaleOptions = item.options;
				var id = scaleOptions.id;
				var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				updated[id] = true;
				var scale = null;
				if (id in scales && scales[id].type === scaleType) {
					scale = scales[id];
					scale.options = scaleOptions;
					scale.ctx = me.ctx;
					scale.chart = me;
				} else {
					var scaleClass = core_scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
					scale = new scaleClass({
						id: id,
						type: scaleType,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
					scales[scale.id] = scale;
				}

				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});
			// clear up discarded scales
			helpers$1.each(updated, function (hasUpdated, id) {
				if (!hasUpdated) {
					delete scales[id];
				}
			});

			me.scales = scales;

			core_scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function buildOrUpdateControllers() {
			var me = this;
			var newControllers = [];
			var datasets = me.data.datasets;
			var i, ilen;

			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				var dataset = datasets[i];
				var meta = me.getDatasetMeta(i);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(i);
					meta = me.getDatasetMeta(i);
				}
				meta.type = type;
				meta.order = dataset.order || 0;
				meta.index = i;

				if (meta.controller) {
					meta.controller.updateIndex(i);
					meta.controller.linkScales();
				} else {
					var ControllerClass = controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, i);
					newControllers.push(meta.controller);
				}
			}

			return newControllers;
		},

		/**
   * Reset the elements of all datasets
   * @private
   */
		resetElements: function resetElements() {
			var me = this;
			helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
  * Resets the chart back to it's state before the initial animation
  */
		reset: function reset() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function update(config) {
			var me = this;
			var i, ilen;

			if (!config || (typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			// plugins options references might have change, let's invalidate the cache
			// https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
			core_plugins._invalidate(me);

			if (core_plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
				me.getDatasetMeta(i).controller.buildOrUpdateElements();
			}

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			if (me.options.animation && me.options.animation.duration) {
				helpers$1.each(newControllers, function (controller) {
					controller.reset();
				});
			}

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			core_plugins.notify(me, 'afterUpdate');

			me._layers.sort(compare2Level('z', '_idx'));

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
   * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
   * hook, in which case, plugins will not be called on `afterLayout`.
   * @private
   */
		updateLayout: function updateLayout() {
			var me = this;

			if (core_plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			core_layouts.update(this, this.width, this.height);

			me._layers = [];
			helpers$1.each(me.boxes, function (box) {
				// _configure is called twice, once in core.scale.update and once here.
				// Here the boxes are fully updated and at their final positions.
				if (box._configure) {
					box._configure();
				}
				me._layers.push.apply(me._layers, box._layers());
			}, me);

			me._layers.forEach(function (item, index) {
				item._idx = index;
			});

			/**
    * Provided for backward compatibility, use `afterLayout` instead.
    * @method IPlugin#afterScaleUpdate
    * @deprecated since version 2.5.0
    * @todo remove at version 3
    * @private
    */
			core_plugins.notify(me, 'afterScaleUpdate');
			core_plugins.notify(me, 'afterLayout');
		},

		/**
   * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
   * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
   * @private
   */
		updateDatasets: function updateDatasets() {
			var me = this;

			if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			core_plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
   * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
   * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
   * @private
   */
		updateDataset: function updateDataset(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller._update();

			core_plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function render(config) {
			var me = this;

			if (!config || (typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var animationOptions = me.options.animation;
			var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
			var lazy = config.lazy;

			if (core_plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var onComplete = function onComplete(animation) {
				core_plugins.notify(me, 'afterRender');
				helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && duration) {
				var animation = new core_animation({
					numSteps: duration / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function render(chart, animationObject) {
						var easingFunction = helpers$1.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				core_animations.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new core_animation({ numSteps: 0, chart: me }));
			}

			return me;
		},

		draw: function draw(easingValue) {
			var me = this;
			var i, layers;

			me.clear();

			if (helpers$1.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (me.width <= 0 || me.height <= 0) {
				return;
			}

			if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Because of plugin hooks (before/afterDatasetsDraw), datasets can't
			// currently be part of layers. Instead, we draw
			// layers <= 0 before(default, backward compat), and the rest after
			layers = me._layers;
			for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
				layers[i].draw(me.chartArea);
			}

			me.drawDatasets(easingValue);

			// Rest of layers
			for (; i < layers.length; ++i) {
				layers[i].draw(me.chartArea);
			}

			me._drawTooltip(easingValue);

			core_plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
   * @private
   */
		transition: function transition(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
   * @private
   */
		_getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
			var me = this;
			var datasets = me.data.datasets || [];
			var result = [];
			var i, ilen;

			for (i = 0, ilen = datasets.length; i < ilen; ++i) {
				if (!filterVisible || me.isDatasetVisible(i)) {
					result.push(me.getDatasetMeta(i));
				}
			}

			result.sort(compare2Level('order', 'index'));

			return result;
		},

		/**
   * @private
   */
		_getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
			return this._getSortedDatasetMetas(true);
		},

		/**
   * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
   * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
   * @private
   */
		drawDatasets: function drawDatasets(easingValue) {
			var me = this;
			var metasets, i;

			if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			metasets = me._getSortedVisibleDatasetMetas();
			for (i = metasets.length - 1; i >= 0; --i) {
				me.drawDataset(metasets[i], easingValue);
			}

			core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
   * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
   * hook, in which case, plugins will not be called on `afterDatasetDraw`.
   * @private
   */
		drawDataset: function drawDataset(meta, easingValue) {
			var me = this;
			var args = {
				meta: meta,
				index: meta.index,
				easingValue: easingValue
			};

			if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			core_plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
   * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
   * hook, in which case, plugins will not be called on `afterTooltipDraw`.
   * @private
   */
		_drawTooltip: function _drawTooltip(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			core_plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		/**
   * Get the single element that was clicked on
   * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
   */
		getElementAtEvent: function getElementAtEvent(e) {
			return core_interaction.modes.single(this, e);
		},

		getElementsAtEvent: function getElementsAtEvent(e) {
			return core_interaction.modes.label(this, e, { intersect: true });
		},

		getElementsAtXAxis: function getElementsAtXAxis(e) {
			return core_interaction.modes['x-axis'](this, e, { intersect: true });
		},

		getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
			var method = core_interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function getDatasetAtEvent(e) {
			return core_interaction.modes.dataset(this, e, { intersect: true });
		},

		getDatasetMeta: function getDatasetMeta(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null, // See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null,
					order: dataset.order || 0,
					index: datasetIndex
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function getVisibleDatasetCount() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function isDatasetVisible(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function generateLegend() {
			return this.options.legendCallback(this);
		},

		/**
   * @private
   */
		destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function destroy() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers$1.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			core_plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function toBase64Image() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function initToolTip() {
			var me = this;
			me.tooltip = new core_tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
   * @private
   */
		bindEvents: function bindEvents() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function listener() {
				me.eventHandler.apply(me, arguments);
			};

			helpers$1.each(me.options.events, function (type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function listener() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
   * @private
   */
		unbindEvents: function unbindEvents() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers$1.each(listeners, function (listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
			var prefix = enabled ? 'set' : 'remove';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
				}
			}

			if (mode === 'dataset') {
				this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
			}
		},

		/**
   * @private
   */
		eventHandler: function eventHandler(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			// for smooth tooltip animations issue #4989
			// the tooltip should be the source of change
			// Animation check workaround:
			// tooltip._start will be null when tooltip isn't animating
			if (tooltip) {
				changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
			}

			core_plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render({
					duration: me.options.hover.animationDuration,
					lazy: true
				});
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
   * Handle an event
   * @private
   * @param {IEvent} event the event to handle
   * @return {boolean} true if the chart needs to re-render
   */
		handleEvent: function handleEvent(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers$1.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers$1.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
  * NOTE(SB) We actually don't use this container anymore but we need to keep it
  * for backward compatibility. Though, it can still be useful for plugins that
  * would need to work on multiple charts?!
  */
	Chart.instances = {};

	var core_controller = Chart;

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, use Chart instead.
  * @class Chart.Controller
  * @deprecated since version 2.6
  * @todo remove at version 3
  * @private
  */
	Chart.Controller = Chart;

	/**
  * Provided for backward compatibility, not available anymore.
  * @namespace Chart
  * @deprecated since version 2.8
  * @todo remove at version 3
  * @private
  */
	Chart.types = {};

	/**
  * Provided for backward compatibility, not available anymore.
  * @namespace Chart.helpers.configMerge
  * @deprecated since version 2.8.0
  * @todo remove at version 3
  * @private
  */
	helpers$1.configMerge = mergeConfig;

	/**
  * Provided for backward compatibility, not available anymore.
  * @namespace Chart.helpers.scaleMerge
  * @deprecated since version 2.8.0
  * @todo remove at version 3
  * @private
  */
	helpers$1.scaleMerge = mergeScaleConfig;

	var core_helpers = function core_helpers() {

		// -- Basic js utility methods

		helpers$1.where = function (collection, filterCallback) {
			if (helpers$1.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];

			helpers$1.each(collection, function (item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});

			return filtered;
		};
		helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
			return array.findIndex(callback, scope);
		} : function (array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
		helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers$1.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};

		// -- Math methods
		helpers$1.isNumber = function (n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers$1.almostEquals = function (x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers$1.almostWhole = function (x, epsilon) {
			var rounded = Math.round(x);
			return rounded - epsilon <= x && rounded + epsilon >= x;
		};
		helpers$1.max = function (array) {
			return array.reduce(function (max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers$1.min = function (array) {
			return array.reduce(function (min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers$1.sign = Math.sign ? function (x) {
			return Math.sign(x);
		} : function (x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
		helpers$1.toRadians = function (degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers$1.toDegrees = function (radians) {
			return radians * (180 / Math.PI);
		};

		/**
   * Returns the number of decimal places
   * i.e. the number of digits after the decimal point, of the value of this Number.
   * @param {number} x - A number.
   * @returns {number} The number of decimal places.
   * @private
   */
		helpers$1._decimalPlaces = function (x) {
			if (!helpers$1.isFinite(x)) {
				return;
			}
			var e = 1;
			var p = 0;
			while (Math.round(x * e) / e !== x) {
				e *= 10;
				p++;
			}
			return p;
		};

		// Gets the angle from vertical upright to the point about a centre.
		helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

			if (angle < -0.5 * Math.PI) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}

			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers$1.distanceBetweenPoints = function (pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};

		/**
   * Provided for backward compatibility, not available anymore
   * @function Chart.helpers.aliasPixel
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   */
		helpers$1.aliasPixel = function (pixelWidth) {
			return pixelWidth % 2 === 0 ? 0 : 0.5;
		};

		/**
   * Returns the aligned pixel value to avoid anti-aliasing blur
   * @param {Chart} chart - The chart instance.
   * @param {number} pixel - A pixel value.
   * @param {number} width - The width of the element.
   * @returns {number} The aligned pixel value.
   * @private
   */
		helpers$1._alignPixel = function (chart, pixel, width) {
			var devicePixelRatio = chart.currentDevicePixelRatio;
			var halfWidth = width / 2;
			return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
		};

		helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html

			// This function must also respect "skipped" points

			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;

			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);

			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;

			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;

			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers$1.EPSILON = Number.EPSILON || 1e-14;
		helpers$1.splineCurveMonotone = function (points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

			var pointsWithTangents = (points || []).map(function (point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});

			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;

					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}

				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}

			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}

				if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}

				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}

				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}

			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}

				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers$1.nextItem = function (collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers$1.previousItem = function (collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers$1.niceNum = function (range, round) {
			var exponent = Math.floor(helpers$1.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;

			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}

			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers$1.requestAnimFrame = function () {
			if (typeof window === 'undefined') {
				return function (callback) {
					callback();
				};
			}
			return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
		}();
		// -- DOM methods
		helpers$1.getRelativePosition = function (evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.target || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();

			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}

			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);

			return {
				x: mouseX,
				y: mouseY
			};
		};

		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);

				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}

			return valueInPixels;
		}

		/**
   * Returns if the given value contains an effective constraint.
   * @private
   */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}

		/**
   * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
   * @param {HTMLElement} domNode - the node to check the constraint on
   * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
   * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
   * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
   */
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = helpers$1._getParentNode(domNode);
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;

			if (hasCNode || hasCContainer) {
				return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}

			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers$1.getConstraintWidth = function (domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers$1.getConstraintHeight = function (domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		/**
   * @private
  	 */
		helpers$1._calculatePadding = function (container, padding, parentDimension) {
			padding = helpers$1.getStyle(container, padding);

			return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
		};
		/**
   * @private
   */
		helpers$1._getParentNode = function (domNode) {
			var parent = domNode.parentNode;
			if (parent && parent.toString() === '[object ShadowRoot]') {
				parent = parent.host;
			}
			return parent;
		};
		helpers$1.getMaximumWidth = function (domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientWidth;
			}

			var clientWidth = container.clientWidth;
			var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
			var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);

			var w = clientWidth - paddingLeft - paddingRight;
			var cw = helpers$1.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers$1.getMaximumHeight = function (domNode) {
			var container = helpers$1._getParentNode(domNode);
			if (!container) {
				return domNode.clientHeight;
			}

			var clientHeight = container.clientHeight;
			var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
			var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);

			var h = clientHeight - paddingTop - paddingBottom;
			var ch = helpers$1.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers$1.getStyle = function (el, property) {
			return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers$1.retinaScale = function (chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}

			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;

			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);

			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			if (!canvas.style.height && !canvas.style.width) {
				canvas.style.height = height + 'px';
				canvas.style.width = width + 'px';
			}
		};
		// -- Canvas methods
		helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];

			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}

			ctx.font = font;
			var longest = 0;
			var ilen = arrayOfThings.length;
			var i, j, jlen, thing, nestedThing;
			for (i = 0; i < ilen; i++) {
				thing = arrayOfThings[i];

				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
					longest = helpers$1.measureText(ctx, data, gc, longest, thing);
				} else if (helpers$1.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					for (j = 0, jlen = thing.length; j < jlen; j++) {
						nestedThing = thing[j];
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
							longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
						}
					}
				}
			}

			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers$1.measureText = function (ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};

		/**
   * @deprecated
   */
		helpers$1.numberOfLabelLines = function (arrayOfThings) {
			var numberOfLines = 1;
			helpers$1.each(arrayOfThings, function (thing) {
				if (helpers$1.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};

		helpers$1.color = !chartjsColor ? function (value) {
			console.error('Color.js not found!');
			return value;
		} : function (value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = core_defaults.global.defaultColor;
			}

			return chartjsColor(value);
		};

		helpers$1.getHoverColor = function (colorValue) {
			/* global CanvasPattern */
			return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};

	function abstract() {
		throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
	}

	/**
  * Date adapter (current used by the time scale)
  * @namespace Chart._adapters._date
  * @memberof Chart._adapters
  * @private
  */

	/**
  * Currently supported unit string values.
  * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
  * @memberof Chart._adapters._date
  * @name Unit
  */

	/**
  * @class
  */
	function DateAdapter(options) {
		this.options = options || {};
	}

	helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */{
		/**
   * Returns a map of time formats for the supported formatting units defined
   * in Unit as well as 'datetime' representing a detailed date/time string.
   * @returns {{string: string}}
   */
		formats: abstract,

		/**
   * Parses the given `value` and return the associated timestamp.
   * @param {any} value - the value to parse (usually comes from the data)
   * @param {string} [format] - the expected data format
   * @returns {(number|null)}
   * @function
   */
		parse: abstract,

		/**
   * Returns the formatted date in the specified `format` for a given `timestamp`.
   * @param {number} timestamp - the timestamp to format
   * @param {string} format - the date/time token
   * @return {string}
   * @function
   */
		format: abstract,

		/**
   * Adds the specified `amount` of `unit` to the given `timestamp`.
   * @param {number} timestamp - the input timestamp
   * @param {number} amount - the amount to add
   * @param {Unit} unit - the unit as string
   * @return {number}
   * @function
   */
		add: abstract,

		/**
   * Returns the number of `unit` between the given timestamps.
   * @param {number} max - the input timestamp (reference)
   * @param {number} min - the timestamp to substract
   * @param {Unit} unit - the unit as string
   * @return {number}
   * @function
   */
		diff: abstract,

		/**
   * Returns start of `unit` for the given `timestamp`.
   * @param {number} timestamp - the input timestamp
   * @param {Unit} unit - the unit as string
   * @param {number} [weekday] - the ISO day of the week with 1 being Monday
   * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
   * @function
   */
		startOf: abstract,

		/**
   * Returns end of `unit` for the given `timestamp`.
   * @param {number} timestamp - the input timestamp
   * @param {Unit} unit - the unit as string
   * @function
   */
		endOf: abstract,

		// DEPRECATIONS

		/**
   * Provided for backward compatibility for scale.getValueForPixel(),
   * this method should be overridden only by the moment adapter.
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   * @private
   */
		_create: function _create(value) {
			return value;
		}
	});

	DateAdapter.override = function (members) {
		helpers$1.extend(DateAdapter.prototype, members);
	};

	var _date = DateAdapter;

	var core_adapters = {
		_date: _date
	};

	/**
  * Namespace to hold static tick generation functions
  * @namespace Chart.Ticks
  */
	var core_ticks = {
		/**
   * Namespace to hold formatters for different types of ticks
   * @namespace Chart.Ticks.formatters
   */
		formatters: {
			/**
    * Formatter for value labels
    * @method Chart.Ticks.formatters.values
    * @param value the value to display
    * @return {string|string[]} the label to display
    */
			values: function values(value) {
				return helpers$1.isArray(value) ? value : '' + value;
			},

			/**
    * Formatter for linear numeric ticks
    * @method Chart.Ticks.formatters.linear
    * @param tickValue {number} the value to be formatted
    * @param index {number} the position of the tickValue parameter in the ticks array
    * @param ticks {number[]} the list of ticks being converted
    * @return {string} string representation of the tickValue parameter
    */
			linear: function linear(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}

				var logDelta = helpers$1.log10(Math.abs(delta));
				var tickString = '';

				if (tickValue !== 0) {
					var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
					if (maxTick < 1e-4) {
						// all ticks are small numbers; use scientific notation
						var logTick = helpers$1.log10(Math.abs(tickValue));
						var numExponential = Math.floor(logTick) - Math.floor(logDelta);
						numExponential = Math.max(Math.min(numExponential, 20), 0);
						tickString = tickValue.toExponential(numExponential);
					} else {
						var numDecimal = -1 * Math.floor(logDelta);
						numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
						tickString = tickValue.toFixed(numDecimal);
					}
				} else {
					tickString = '0'; // never show decimal places for 0
				}

				return tickString;
			},

			logarithmic: function logarithmic(tickValue, index, ticks) {
				var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));

				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};

	var isArray = helpers$1.isArray;
	var isNullOrUndef = helpers$1.isNullOrUndef;
	var valueOrDefault$a = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;

	core_defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,

		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},

		// scale label
		scaleLabel: {
			// display property
			display: false,

			// actual label
			labelString: '',

			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},

		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: core_ticks.formatters.values,
			minor: {},
			major: {}
		}
	});

	/** Returns a new array containing numItems from arr */
	function sample(arr, numItems) {
		var result = [];
		var increment = arr.length / numItems;
		var i = 0;
		var len = arr.length;

		for (; i < len; i += increment) {
			result.push(arr[Math.floor(i)]);
		}
		return result;
	}

	function getPixelForGridLine(scale, index, offsetGridLines) {
		var length = scale.getTicks().length;
		var validIndex = Math.min(index, length - 1);
		var lineValue = scale.getPixelForTick(validIndex);
		var start = scale._startPixel;
		var end = scale._endPixel;
		var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
		var offset;

		if (offsetGridLines) {
			if (length === 1) {
				offset = Math.max(lineValue - start, end - lineValue);
			} else if (index === 0) {
				offset = (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
			}
			lineValue += validIndex < index ? offset : -offset;

			// Return undefined if the pixel is out of the range
			if (lineValue < start - epsilon || lineValue > end + epsilon) {
				return;
			}
		}
		return lineValue;
	}

	function garbageCollect(caches, length) {
		helpers$1.each(caches, function (cache) {
			var gc = cache.gc;
			var gcLen = gc.length / 2;
			var i;
			if (gcLen > length) {
				for (i = 0; i < gcLen; ++i) {
					delete cache.data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
		});
	}

	/**
  * Returns {width, height, offset} objects for the first, last, widest, highest tick
  * labels where offset indicates the anchor point offset from the top in pixels.
  */
	function computeLabelSizes(ctx, tickFonts, ticks, caches) {
		var length = ticks.length;
		var widths = [];
		var heights = [];
		var offsets = [];
		var widestLabelSize = 0;
		var highestLabelSize = 0;
		var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;

		for (i = 0; i < length; ++i) {
			label = ticks[i].label;
			tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
			ctx.font = fontString = tickFont.string;
			cache = caches[fontString] = caches[fontString] || { data: {}, gc: [] };
			lineHeight = tickFont.lineHeight;
			width = height = 0;
			// Undefined labels and arrays should not be measured
			if (!isNullOrUndef(label) && !isArray(label)) {
				width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
				height = lineHeight;
			} else if (isArray(label)) {
				// if it is an array let's measure each element
				for (j = 0, jlen = label.length; j < jlen; ++j) {
					nestedLabel = label[j];
					// Undefined labels and arrays should not be measured
					if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
						width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
						height += lineHeight;
					}
				}
			}
			widths.push(width);
			heights.push(height);
			offsets.push(lineHeight / 2);
			widestLabelSize = Math.max(width, widestLabelSize);
			highestLabelSize = Math.max(height, highestLabelSize);
		}
		garbageCollect(caches, length);

		widest = widths.indexOf(widestLabelSize);
		highest = heights.indexOf(highestLabelSize);

		function valueAt(idx) {
			return {
				width: widths[idx] || 0,
				height: heights[idx] || 0,
				offset: offsets[idx] || 0
			};
		}

		return {
			first: valueAt(0),
			last: valueAt(length - 1),
			widest: valueAt(widest),
			highest: valueAt(highest)
		};
	}

	function getTickMarkLength(options) {
		return options.drawTicks ? options.tickMarkLength : 0;
	}

	function getScaleLabelHeight(options) {
		var font, padding;

		if (!options.display) {
			return 0;
		}

		font = helpers$1.options._parseFont(options);
		padding = helpers$1.options.toPadding(options.padding);

		return font.lineHeight + padding.height;
	}

	function parseFontOptions(options, nestedOpts) {
		return helpers$1.extend(helpers$1.options._parseFont({
			fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
			fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
			fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
			lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
		}), {
			color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
		});
	}

	function parseTickFontOptions(options) {
		var minor = parseFontOptions(options, options.minor);
		var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;

		return { minor: minor, major: major };
	}

	function nonSkipped(ticksToFilter) {
		var filtered = [];
		var item, index, len;
		for (index = 0, len = ticksToFilter.length; index < len; ++index) {
			item = ticksToFilter[index];
			if (typeof item._index !== 'undefined') {
				filtered.push(item);
			}
		}
		return filtered;
	}

	function getEvenSpacing(arr) {
		var len = arr.length;
		var i, diff;

		if (len < 2) {
			return false;
		}

		for (diff = arr[0], i = 1; i < len; ++i) {
			if (arr[i] - arr[i - 1] !== diff) {
				return false;
			}
		}
		return diff;
	}

	function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
		var evenMajorSpacing = getEvenSpacing(majorIndices);
		var spacing = (ticks.length - 1) / ticksLimit;
		var factors, factor, i, ilen;

		// If the major ticks are evenly spaced apart, place the minor ticks
		// so that they divide the major ticks into even chunks
		if (!evenMajorSpacing) {
			return Math.max(spacing, 1);
		}

		factors = helpers$1.math._factorize(evenMajorSpacing);
		for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
			factor = factors[i];
			if (factor > spacing) {
				return factor;
			}
		}
		return Math.max(spacing, 1);
	}

	function getMajorIndices(ticks) {
		var result = [];
		var i, ilen;
		for (i = 0, ilen = ticks.length; i < ilen; i++) {
			if (ticks[i].major) {
				result.push(i);
			}
		}
		return result;
	}

	function skipMajors(ticks, majorIndices, spacing) {
		var count = 0;
		var next = majorIndices[0];
		var i, tick;

		spacing = Math.ceil(spacing);
		for (i = 0; i < ticks.length; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = majorIndices[count * spacing];
			} else {
				delete tick.label;
			}
		}
	}

	function skip(ticks, spacing, majorStart, majorEnd) {
		var start = valueOrDefault$a(majorStart, 0);
		var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
		var count = 0;
		var length, i, tick, next;

		spacing = Math.ceil(spacing);
		if (majorEnd) {
			length = majorEnd - majorStart;
			spacing = length / Math.floor(length / spacing);
		}

		next = start;

		while (next < 0) {
			count++;
			next = Math.round(start + count * spacing);
		}

		for (i = Math.max(start, 0); i < end; i++) {
			tick = ticks[i];
			if (i === next) {
				tick._index = i;
				count++;
				next = Math.round(start + count * spacing);
			} else {
				delete tick.label;
			}
		}
	}

	var Scale = core_element.extend({

		zeroLineIndex: 0,

		/**
   * Get the padding needed for the scale
   * @method getPadding
   * @private
   * @returns {Padding} the necessary padding
   */
		getPadding: function getPadding() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
   * Returns the scale tick objects ({label, major})
   * @since 2.7
   */
		getTicks: function getTicks() {
			return this._ticks;
		},

		/**
  * @private
  */
		_getLabels: function _getLabels() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		/**
   * Provided for backward compatibility, not available anymore
   * @function Chart.Scale.mergeTicksOptions
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   */
		mergeTicksOptions: function mergeTicksOptions() {
			// noop
		},

		beforeUpdate: function beforeUpdate() {
			helpers$1.callback(this.options.beforeUpdate, [this]);
		},

		/**
   * @param {number} maxWidth - the max width in pixels
   * @param {number} maxHeight - the max height in pixels
   * @param {object} margins - the space between the edge of the other scales and edge of the chart
   *   This space comes from two sources:
   *     - padding - space that's required to show the labels at the edges of the scale
   *     - thickness of scales or legends in another orientation
   */
		update: function update(maxWidth, maxHeight, margins) {
			var me = this;
			var tickOpts = me.options.ticks;
			var sampleSize = tickOpts.sampleSize;
			var i, ilen, labels, ticks, samplingEnabled;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers$1.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);

			me._ticks = null;
			me.ticks = null;
			me._labelSizes = null;
			me._maxLabelLines = 0;
			me.longestLabelWidth = 0;
			me.longestTextCache = me.longestTextCache || {};
			me._gridLineItems = null;
			me._labelItems = null;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			// Allow modification of ticks in callback.
			ticks = me.afterBuildTicks(ticks) || ticks;

			// Ensure ticks contains ticks in new tick format
			if ((!ticks || !ticks.length) && me.ticks) {
				ticks = [];
				for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
					ticks.push({
						value: me.ticks[i],
						major: false
					});
				}
			}

			me._ticks = ticks;

			// Compute tick rotation and fit using a sampled subset of labels
			// We generally don't need to compute the size of every single label for determining scale size
			samplingEnabled = sampleSize < ticks.length;
			labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

			// _configure is called twice, once here, once from core.controller.updateLayout.
			// Here we haven't been positioned yet, but dimensions are correct.
			// Variables set in _configure are needed for calculateTickRotation, and
			// it's ok that coordinates are not correct there, only dimensions matter.
			me._configure();

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();

			me.beforeFit();
			me.fit();
			me.afterFit();

			// Auto-skip
			me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;

			if (samplingEnabled) {
				// Generate labels using all non-skipped ticks
				labels = me._convertTicksToLabels(me._ticksToDraw);
			}

			me.ticks = labels; // BACKWARD COMPATIBILITY

			// IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

			me.afterUpdate();

			// TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
			// make maxWidth and maxHeight private
			return me.minSize;
		},

		/**
   * @private
   */
		_configure: function _configure() {
			var me = this;
			var reversePixels = me.options.ticks.reverse;
			var startPixel, endPixel;

			if (me.isHorizontal()) {
				startPixel = me.left;
				endPixel = me.right;
			} else {
				startPixel = me.top;
				endPixel = me.bottom;
				// by default vertical scales are from bottom to top, so pixels are reversed
				reversePixels = !reversePixels;
			}
			me._startPixel = startPixel;
			me._endPixel = endPixel;
			me._reversePixels = reversePixels;
			me._length = endPixel - startPixel;
		},

		afterUpdate: function afterUpdate() {
			helpers$1.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function beforeSetDimensions() {
			helpers$1.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function setDimensions() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function afterSetDimensions() {
			helpers$1.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function beforeDataLimits() {
			helpers$1.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers$1.noop,
		afterDataLimits: function afterDataLimits() {
			helpers$1.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function beforeBuildTicks() {
			helpers$1.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers$1.noop,
		afterBuildTicks: function afterBuildTicks(ticks) {
			var me = this;
			// ticks is empty for old axis implementations here
			if (isArray(ticks) && ticks.length) {
				return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
			}
			// Support old implementations (that modified `this.ticks` directly in buildTicks)
			me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
			return ticks;
		},

		beforeTickToLabelConversion: function beforeTickToLabelConversion() {
			helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function convertTicksToLabels() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function afterTickToLabelConversion() {
			helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function beforeCalculateTickRotation() {
			helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function calculateTickRotation() {
			var me = this;
			var options = me.options;
			var tickOpts = options.ticks;
			var numTicks = me.getTicks().length;
			var minRotation = tickOpts.minRotation || 0;
			var maxRotation = tickOpts.maxRotation;
			var labelRotation = minRotation;
			var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;

			if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
				me.labelRotation = minRotation;
				return;
			}

			labelSizes = me._getLabelSizes();
			maxLabelWidth = labelSizes.widest.width;
			maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

			// Estimate the width of each grid based on the canvas width, the maximum
			// label width and the number of tick intervals
			maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
			tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

			// Allow 3 pixels x2 padding either side for label readability
			if (maxLabelWidth + 6 > tickWidth) {
				tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
				maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
				maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
				labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
				labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function afterCalculateTickRotation() {
			helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function beforeFit() {
			helpers$1.callback(this.options.beforeFit, [this]);
		},
		fit: function fit() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var chart = me.chart;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = me._isVisible();
			var isBottom = opts.position === 'bottom';
			var isHorizontal = me.isHorizontal();

			// Width
			if (isHorizontal) {
				minSize.width = me.maxWidth;
			} else if (display) {
				minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}

			// height
			if (!isHorizontal) {
				minSize.height = me.maxHeight; // fill all the height
			} else if (display) {
				minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
			}

			// Don't bother fitting the ticks if we are not showing the labels
			if (tickOpts.display && display) {
				var tickFonts = parseTickFontOptions(tickOpts);
				var labelSizes = me._getLabelSizes();
				var firstLabelSize = labelSizes.first;
				var lastLabelSize = labelSizes.last;
				var widestLabelSize = labelSizes.widest;
				var highestLabelSize = labelSizes.highest;
				var lineSpace = tickFonts.minor.lineHeight * 0.4;
				var tickPadding = tickOpts.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					var isRotated = me.labelRotation !== 0;
					var angleRadians = helpers$1.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					var offsetLeft = me.getPixelForTick(0) - me.left;
					var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
					var paddingLeft, paddingRight;

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (isRotated) {
						paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
						paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
					} else {
						paddingLeft = firstLabelSize.width / 2;
						paddingRight = lastLabelSize.width / 2;
					}

					// Adjust padding taking into account changes in offsets
					// and add 3 px to move away from canvas edges
					me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
					me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					var labelWidth = tickOpts.mirror ? 0 :
					// use lineSpace for consistency with horizontal axis
					// tickPadding is not implemented for horizontal
					widestLabelSize.width + tickPadding + lineSpace;

					minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);

					me.paddingTop = firstLabelSize.height / 2;
					me.paddingBottom = lastLabelSize.height / 2;
				}
			}

			me.handleMargins();

			if (isHorizontal) {
				me.width = me._length = chart.width - me.margins.left - me.margins.right;
				me.height = minSize.height;
			} else {
				me.width = minSize.width;
				me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
			}
		},

		/**
   * Handle margins and padding interactions
   * @private
   */
		handleMargins: function handleMargins() {
			var me = this;
			if (me.margins) {
				me.margins.left = Math.max(me.paddingLeft, me.margins.left);
				me.margins.top = Math.max(me.paddingTop, me.margins.top);
				me.margins.right = Math.max(me.paddingRight, me.margins.right);
				me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
			}
		},

		afterFit: function afterFit() {
			helpers$1.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function isHorizontal() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},
		isFullWidth: function isFullWidth() {
			return this.options.fullWidth;
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function getRightValue(rawValue) {
			// Null and undefined values first
			if (isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
				return NaN;
			}

			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		_convertTicksToLabels: function _convertTicksToLabels(ticks) {
			var me = this;
			var labels, i, ilen;

			me.ticks = ticks.map(function (tick) {
				return tick.value;
			});

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				ticks[i].label = labels[i];
			}

			return labels;
		},

		/**
   * @private
   */
		_getLabelSizes: function _getLabelSizes() {
			var me = this;
			var labelSizes = me._labelSizes;

			if (!labelSizes) {
				me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
				me.longestLabelWidth = labelSizes.widest.width;
			}

			return labelSizes;
		},

		/**
   * @private
   */
		_parseValue: function _parseValue(value) {
			var start, end, min, max;

			if (isArray(value)) {
				start = +this.getRightValue(value[0]);
				end = +this.getRightValue(value[1]);
				min = Math.min(start, end);
				max = Math.max(start, end);
			} else {
				value = +this.getRightValue(value);
				start = undefined;
				end = value;
				min = value;
				max = value;
			}

			return {
				min: min,
				max: max,
				start: start,
				end: end
			};
		},

		/**
  * @private
  */
		_getScaleLabel: function _getScaleLabel(rawValue) {
			var v = this._parseValue(rawValue);
			if (v.start !== undefined) {
				return '[' + v.start + ', ' + v.end + ']';
			}

			return +this.getRightValue(rawValue);
		},

		/**
   * Used to get the value to display in the tooltip for the data at the given index
   * @param index
   * @param datasetIndex
   */
		getLabelForIndex: helpers$1.noop,

		/**
   * Returns the location of the given data point. Value can either be an index or a numerical value
   * The coordinate (0, 0) is at the upper-left corner of the canvas
   * @param value
   * @param index
   * @param datasetIndex
   */
		getPixelForValue: helpers$1.noop,

		/**
   * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
   * The coordinate (0, 0) is at the upper-left corner of the canvas
   * @param pixel
   */
		getValueForPixel: helpers$1.noop,

		/**
   * Returns the location of the tick at the given index
   * The coordinate (0, 0) is at the upper-left corner of the canvas
   */
		getPixelForTick: function getPixelForTick(index) {
			var me = this;
			var offset = me.options.offset;
			var numTicks = me._ticks.length;
			var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);

			return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
		},

		/**
   * Utility for getting the pixel location of a percentage of scale
   * The coordinate (0, 0) is at the upper-left corner of the canvas
   */
		getPixelForDecimal: function getPixelForDecimal(decimal) {
			var me = this;

			if (me._reversePixels) {
				decimal = 1 - decimal;
			}

			return me._startPixel + decimal * me._length;
		},

		getDecimalForPixel: function getDecimalForPixel(pixel) {
			var decimal = (pixel - this._startPixel) / this._length;
			return this._reversePixels ? 1 - decimal : decimal;
		},

		/**
   * Returns the pixel for the minimum chart value
   * The coordinate (0, 0) is at the upper-left corner of the canvas
   */
		getBasePixel: function getBasePixel() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function getBaseValue() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
		},

		/**
   * Returns a subset of ticks to be plotted to avoid overlapping labels.
   * @private
   */
		_autoSkip: function _autoSkip(ticks) {
			var me = this;
			var tickOpts = me.options.ticks;
			var axisLength = me._length;
			var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
			var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
			var numMajorIndices = majorIndices.length;
			var first = majorIndices[0];
			var last = majorIndices[numMajorIndices - 1];
			var i, ilen, spacing, avgMajorSpacing;

			// If there are too many major ticks to display them all
			if (numMajorIndices > ticksLimit) {
				skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
				return nonSkipped(ticks);
			}

			spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);

			if (numMajorIndices > 0) {
				for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
					skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
				}
				avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
				skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
				skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
				return nonSkipped(ticks);
			}
			skip(ticks, spacing);
			return nonSkipped(ticks);
		},

		/**
   * @private
   */
		_tickSize: function _tickSize() {
			var me = this;
			var optionTicks = me.options.ticks;

			// Calculate space needed by label in axis direction.
			var rot = helpers$1.toRadians(me.labelRotation);
			var cos = Math.abs(Math.cos(rot));
			var sin = Math.abs(Math.sin(rot));

			var labelSizes = me._getLabelSizes();
			var padding = optionTicks.autoSkipPadding || 0;
			var w = labelSizes ? labelSizes.widest.width + padding : 0;
			var h = labelSizes ? labelSizes.highest.height + padding : 0;

			// Calculate space needed for 1 tick in axis direction.
			return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
		},

		/**
   * @private
   */
		_isVisible: function _isVisible() {
			var me = this;
			var chart = me.chart;
			var display = me.options.display;
			var i, ilen, meta;

			if (display !== 'auto') {
				return !!display;
			}

			// When 'auto', the scale is visible if at least one associated dataset is visible.
			for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					meta = chart.getDatasetMeta(i);
					if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
						return true;
					}
				}
			}

			return false;
		},

		/**
   * @private
   */
		_computeGridLineItems: function _computeGridLineItems(chartArea) {
			var me = this;
			var chart = me.chart;
			var options = me.options;
			var gridLines = options.gridLines;
			var position = options.position;
			var offsetGridLines = gridLines.offsetGridLines;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);

			var tl = getTickMarkLength(gridLines);
			var items = [];
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var axisHalfWidth = axisWidth / 2;
			var alignPixel = helpers$1._alignPixel;
			var alignBorderValue = function alignBorderValue(pixel) {
				return alignPixel(chart, pixel, axisWidth);
			};
			var borderValue, i, tick, lineValue, alignedLineValue;
			var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;

			if (position === 'top') {
				borderValue = alignBorderValue(me.bottom);
				ty1 = me.bottom - tl;
				ty2 = borderValue - axisHalfWidth;
				y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
				y2 = chartArea.bottom;
			} else if (position === 'bottom') {
				borderValue = alignBorderValue(me.top);
				y1 = chartArea.top;
				y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
				ty1 = borderValue + axisHalfWidth;
				ty2 = me.top + tl;
			} else if (position === 'left') {
				borderValue = alignBorderValue(me.right);
				tx1 = me.right - tl;
				tx2 = borderValue - axisHalfWidth;
				x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
				x2 = chartArea.right;
			} else {
				borderValue = alignBorderValue(me.left);
				x1 = chartArea.left;
				x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
				tx1 = borderValue + axisHalfWidth;
				tx2 = me.left + tl;
			}

			for (i = 0; i < ticksLength; ++i) {
				tick = ticks[i] || {};

				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(tick.label) && i < ticks.length) {
					continue;
				}

				if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash || [];
					borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
				} else {
					lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
					lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
					borderDash = gridLines.borderDash || [];
					borderDashOffset = gridLines.borderDashOffset || 0.0;
				}

				lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

				// Skip if the pixel is out of the range
				if (lineValue === undefined) {
					continue;
				}

				alignedLineValue = alignPixel(chart, lineValue, lineWidth);

				if (isHorizontal) {
					tx1 = tx2 = x1 = x2 = alignedLineValue;
				} else {
					ty1 = ty2 = y1 = y2 = alignedLineValue;
				}

				items.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					width: lineWidth,
					color: lineColor,
					borderDash: borderDash,
					borderDashOffset: borderDashOffset
				});
			}

			items.ticksLength = ticksLength;
			items.borderValue = borderValue;

			return items;
		},

		/**
   * @private
   */
		_computeLabelItems: function _computeLabelItems() {
			var me = this;
			var options = me.options;
			var optionTicks = options.ticks;
			var position = options.position;
			var isMirrored = optionTicks.mirror;
			var isHorizontal = me.isHorizontal();
			var ticks = me._ticksToDraw;
			var fonts = parseTickFontOptions(optionTicks);
			var tickPadding = optionTicks.padding;
			var tl = getTickMarkLength(options.gridLines);
			var rotation = -helpers$1.toRadians(me.labelRotation);
			var items = [];
			var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;

			if (position === 'top') {
				y = me.bottom - tl - tickPadding;
				textAlign = !rotation ? 'center' : 'left';
			} else if (position === 'bottom') {
				y = me.top + tl + tickPadding;
				textAlign = !rotation ? 'center' : 'right';
			} else if (position === 'left') {
				x = me.right - (isMirrored ? 0 : tl) - tickPadding;
				textAlign = isMirrored ? 'left' : 'right';
			} else {
				x = me.left + (isMirrored ? 0 : tl) + tickPadding;
				textAlign = isMirrored ? 'right' : 'left';
			}

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				tick = ticks[i];
				label = tick.label;

				// autoskipper skipped this tick (#4635)
				if (isNullOrUndef(label)) {
					continue;
				}

				pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
				font = tick.major ? fonts.major : fonts.minor;
				lineHeight = font.lineHeight;
				lineCount = isArray(label) ? label.length : 1;

				if (isHorizontal) {
					x = pixel;
					textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
				} else {
					y = pixel;
					textOffset = (1 - lineCount) * lineHeight / 2;
				}

				items.push({
					x: x,
					y: y,
					rotation: rotation,
					label: label,
					font: font,
					textOffset: textOffset,
					textAlign: textAlign
				});
			}

			return items;
		},

		/**
   * @private
   */
		_drawGrid: function _drawGrid(chartArea) {
			var me = this;
			var gridLines = me.options.gridLines;

			if (!gridLines.display) {
				return;
			}

			var ctx = me.ctx;
			var chart = me.chart;
			var alignPixel = helpers$1._alignPixel;
			var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
			var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
			var width, color, i, ilen, item;

			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				width = item.width;
				color = item.color;

				if (width && color) {
					ctx.save();
					ctx.lineWidth = width;
					ctx.strokeStyle = color;
					if (ctx.setLineDash) {
						ctx.setLineDash(item.borderDash);
						ctx.lineDashOffset = item.borderDashOffset;
					}

					ctx.beginPath();

					if (gridLines.drawTicks) {
						ctx.moveTo(item.tx1, item.ty1);
						ctx.lineTo(item.tx2, item.ty2);
					}

					if (gridLines.drawOnChartArea) {
						ctx.moveTo(item.x1, item.y1);
						ctx.lineTo(item.x2, item.y2);
					}

					ctx.stroke();
					ctx.restore();
				}
			}

			if (axisWidth) {
				// Draw the line at the edge of the axis
				var firstLineWidth = axisWidth;
				var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
				var borderValue = items.borderValue;
				var x1, x2, y1, y2;

				if (me.isHorizontal()) {
					x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
					x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
					y1 = y2 = borderValue;
				} else {
					y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
					y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
					x1 = x2 = borderValue;
				}

				ctx.lineWidth = axisWidth;
				ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
				ctx.beginPath();
				ctx.moveTo(x1, y1);
				ctx.lineTo(x2, y2);
				ctx.stroke();
			}
		},

		/**
   * @private
   */
		_drawLabels: function _drawLabels() {
			var me = this;
			var optionTicks = me.options.ticks;

			if (!optionTicks.display) {
				return;
			}

			var ctx = me.ctx;
			var items = me._labelItems || (me._labelItems = me._computeLabelItems());
			var i, j, ilen, jlen, item, tickFont, label, y;

			for (i = 0, ilen = items.length; i < ilen; ++i) {
				item = items[i];
				tickFont = item.font;

				// Make sure we draw text in the correct color and font
				ctx.save();
				ctx.translate(item.x, item.y);
				ctx.rotate(item.rotation);
				ctx.font = tickFont.string;
				ctx.fillStyle = tickFont.color;
				ctx.textBaseline = 'middle';
				ctx.textAlign = item.textAlign;

				label = item.label;
				y = item.textOffset;
				if (isArray(label)) {
					for (j = 0, jlen = label.length; j < jlen; ++j) {
						// We just make sure the multiline element is a string here..
						ctx.fillText('' + label[j], 0, y);
						y += tickFont.lineHeight;
					}
				} else {
					ctx.fillText(label, 0, y);
				}
				ctx.restore();
			}
		},

		/**
   * @private
   */
		_drawTitle: function _drawTitle() {
			var me = this;
			var ctx = me.ctx;
			var options = me.options;
			var scaleLabel = options.scaleLabel;

			if (!scaleLabel.display) {
				return;
			}

			var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
			var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
			var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
			var halfLineHeight = scaleLabelFont.lineHeight / 2;
			var position = options.position;
			var rotation = 0;
			var scaleLabelX, scaleLabelY;

			if (me.isHorizontal()) {
				scaleLabelX = me.left + me.width / 2; // midpoint of the width
				scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
			} else {
				var isLeft = position === 'left';
				scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
				scaleLabelY = me.top + me.height / 2;
				rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
			}

			ctx.save();
			ctx.translate(scaleLabelX, scaleLabelY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';
			ctx.fillStyle = scaleLabelFontColor; // render in correct colour
			ctx.font = scaleLabelFont.string;
			ctx.fillText(scaleLabel.labelString, 0, 0);
			ctx.restore();
		},

		draw: function draw(chartArea) {
			var me = this;

			if (!me._isVisible()) {
				return;
			}

			me._drawGrid(chartArea);
			me._drawTitle();
			me._drawLabels();
		},

		/**
   * @private
   */
		_layers: function _layers() {
			var me = this;
			var opts = me.options;
			var tz = opts.ticks && opts.ticks.z || 0;
			var gz = opts.gridLines && opts.gridLines.z || 0;

			if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
				// backward compatibility: draw has been overridden by custom scale
				return [{
					z: tz,
					draw: function draw() {
						me.draw.apply(me, arguments);
					}
				}];
			}

			return [{
				z: gz,
				draw: function draw() {
					me._drawGrid.apply(me, arguments);
					me._drawTitle.apply(me, arguments);
				}
			}, {
				z: tz,
				draw: function draw() {
					me._drawLabels.apply(me, arguments);
				}
			}];
		},

		/**
   * @private
   */
		_getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
				return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
			});
		}
	});

	Scale.prototype._draw = Scale.prototype.draw;

	var core_scale = Scale;

	var isNullOrUndef$1 = helpers$1.isNullOrUndef;

	var defaultConfig = {
		position: 'bottom'
	};

	var scale_category = core_scale.extend({
		determineDataLimits: function determineDataLimits() {
			var me = this;
			var labels = me._getLabels();
			var ticksOpts = me.options.ticks;
			var min = ticksOpts.min;
			var max = ticksOpts.max;
			var minIndex = 0;
			var maxIndex = labels.length - 1;
			var findIndex;

			if (min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(min);
				if (findIndex >= 0) {
					minIndex = findIndex;
				}
			}

			if (max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(max);
				if (findIndex >= 0) {
					maxIndex = findIndex;
				}
			}

			me.minIndex = minIndex;
			me.maxIndex = maxIndex;
			me.min = labels[minIndex];
			me.max = labels[maxIndex];
		},

		buildTicks: function buildTicks() {
			var me = this;
			var labels = me._getLabels();
			var minIndex = me.minIndex;
			var maxIndex = me.maxIndex;

			// If we are viewing some subset of labels, slice the original array
			me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
		},

		getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
			var me = this;
			var chart = me.chart;

			if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
				return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
			}

			return me._getLabels()[index];
		},

		_configure: function _configure() {
			var me = this;
			var offset = me.options.offset;
			var ticks = me.ticks;

			core_scale.prototype._configure.call(me);

			if (!me.isHorizontal()) {
				// For backward compatibility, vertical category scale reverse is inverted.
				me._reversePixels = !me._reversePixels;
			}

			if (!ticks) {
				return;
			}

			me._startValue = me.minIndex - (offset ? 0.5 : 0);
			me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
			var me = this;
			var valueCategory, labels, idx;

			if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
				value = me.chart.data.datasets[datasetIndex].data[index];
			}

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			if (!isNullOrUndef$1(value)) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
				labels = me._getLabels();
				value = helpers$1.valueOrDefault(valueCategory, value);
				idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
				if (isNaN(index)) {
					index = value;
				}
			}
			return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
		},

		getPixelForTick: function getPixelForTick(index) {
			var ticks = this.ticks;
			return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
		},

		getValueForPixel: function getValueForPixel(pixel) {
			var me = this;
			var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
			return Math.min(Math.max(value, 0), me.ticks.length - 1);
		},

		getBasePixel: function getBasePixel() {
			return this.bottom;
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults = defaultConfig;
	scale_category._defaults = _defaults;

	var noop = helpers$1.noop;
	var isNullOrUndef$2 = helpers$1.isNullOrUndef;

	/**
  * Generate a set of linear ticks
  * @param generationOptions the options used to generate the ticks
  * @param dataRange the range of the data
  * @returns {number[]} array of tick values
  */
	function generateTicks(generationOptions, dataRange) {
		var ticks = [];
		// To get a "nice" value for the tick spacing, we will use the appropriately named
		// "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
		// for details.

		var MIN_SPACING = 1e-14;
		var stepSize = generationOptions.stepSize;
		var unit = stepSize || 1;
		var maxNumSpaces = generationOptions.maxTicks - 1;
		var min = generationOptions.min;
		var max = generationOptions.max;
		var precision = generationOptions.precision;
		var rmin = dataRange.min;
		var rmax = dataRange.max;
		var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
		var factor, niceMin, niceMax, numSpaces;

		// Beyond MIN_SPACING floating point numbers being to lose precision
		// such that we can't do the math necessary to generate ticks
		if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
			return [rmin, rmax];
		}

		numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
		if (numSpaces > maxNumSpaces) {
			// If the calculated num of spaces exceeds maxNumSpaces, recalculate it
			spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
		}

		if (stepSize || isNullOrUndef$2(precision)) {
			// If a precision is not specified, calculate factor based on spacing
			factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
		} else {
			// If the user specified a precision, round to that number of decimal places
			factor = Math.pow(10, precision);
			spacing = Math.ceil(spacing * factor) / factor;
		}

		niceMin = Math.floor(rmin / spacing) * spacing;
		niceMax = Math.ceil(rmax / spacing) * spacing;

		// If min, max and stepSize is set and they make an evenly spaced scale use it.
		if (stepSize) {
			// If very close to our whole number, use it.
			if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
				niceMin = min;
			}
			if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
				niceMax = max;
			}
		}

		numSpaces = (niceMax - niceMin) / spacing;
		// If very close to our rounded value, use it.
		if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
			numSpaces = Math.round(numSpaces);
		} else {
			numSpaces = Math.ceil(numSpaces);
		}

		niceMin = Math.round(niceMin * factor) / factor;
		niceMax = Math.round(niceMax * factor) / factor;
		ticks.push(isNullOrUndef$2(min) ? niceMin : min);
		for (var j = 1; j < numSpaces; ++j) {
			ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
		}
		ticks.push(isNullOrUndef$2(max) ? niceMax : max);

		return ticks;
	}

	var scale_linearbase = core_scale.extend({
		getRightValue: function getRightValue(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return core_scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function handleTickRangeOptions() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers$1.sign(me.min);
				var maxSign = helpers$1.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},

		getTickLimit: function getTickLimit() {
			var me = this;
			var tickOpts = me.options.ticks;
			var stepSize = tickOpts.stepSize;
			var maxTicksLimit = tickOpts.maxTicksLimit;
			var maxTicks;

			if (stepSize) {
				maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
			} else {
				maxTicks = me._computeTickLimit();
				maxTicksLimit = maxTicksLimit || 11;
			}

			if (maxTicksLimit) {
				maxTicks = Math.min(maxTicksLimit, maxTicks);
			}

			return maxTicks;
		},

		_computeTickLimit: function _computeTickLimit() {
			return Number.POSITIVE_INFINITY;
		},

		handleDirectionalChanges: noop,

		buildTicks: function buildTicks() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 40
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				precision: tickOpts.precision,
				stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},

		convertTicksToLabels: function convertTicksToLabels() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			core_scale.prototype.convertTicksToLabels.call(me);
		},

		_configure: function _configure() {
			var me = this;
			var ticks = me.getTicks();
			var start = me.min;
			var end = me.max;
			var offset;

			core_scale.prototype._configure.call(me);

			if (me.options.offset && ticks.length) {
				offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
				start -= offset;
				end += offset;
			}
			me._startValue = start;
			me._endValue = end;
			me._valueRange = end - start;
		}
	});

	var defaultConfig$1 = {
		position: 'left',
		ticks: {
			callback: core_ticks.formatters.linear
		}
	};

	var DEFAULT_MIN = 0;
	var DEFAULT_MAX = 1;

	function getOrCreateStack(stacks, stacked, meta) {
		var key = [meta.type,
		// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
		stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');

		if (stacks[key] === undefined) {
			stacks[key] = {
				pos: [],
				neg: []
			};
		}

		return stacks[key];
	}

	function stackData(scale, stacks, meta, data) {
		var opts = scale.options;
		var stacked = opts.stacked;
		var stack = getOrCreateStack(stacks, stacked, meta);
		var pos = stack.pos;
		var neg = stack.neg;
		var ilen = data.length;
		var i, value;

		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}

			pos[i] = pos[i] || 0;
			neg[i] = neg[i] || 0;

			if (opts.relativePoints) {
				pos[i] = 100;
			} else if (value.min < 0 || value.max < 0) {
				neg[i] += value.min;
			} else {
				pos[i] += value.max;
			}
		}
	}

	function updateMinMax(scale, meta, data) {
		var ilen = data.length;
		var i, value;

		for (i = 0; i < ilen; ++i) {
			value = scale._parseValue(data[i]);
			if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
				continue;
			}

			scale.min = Math.min(scale.min, value.min);
			scale.max = Math.max(scale.max, value.max);
		}
	}

	var scale_linear = scale_linearbase.extend({
		determineDataLimits: function determineDataLimits() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var metasets = me._getMatchingVisibleMetas();
			var hasStacks = opts.stacked;
			var stacks = {};
			var ilen = metasets.length;
			var i, meta, data, values;

			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;

			if (hasStacks === undefined) {
				for (i = 0; !hasStacks && i < ilen; ++i) {
					meta = metasets[i];
					hasStacks = meta.stack !== undefined;
				}
			}

			for (i = 0; i < ilen; ++i) {
				meta = metasets[i];
				data = datasets[meta.index].data;
				if (hasStacks) {
					stackData(me, stacks, meta, data);
				} else {
					updateMinMax(me, meta, data);
				}
			}

			helpers$1.each(stacks, function (stackValues) {
				values = stackValues.pos.concat(stackValues.neg);
				me.min = Math.min(me.min, helpers$1.min(values));
				me.max = Math.max(me.max, helpers$1.max(values));
			});

			me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},

		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function _computeTickLimit() {
			var me = this;
			var tickFont;

			if (me.isHorizontal()) {
				return Math.ceil(me.width / 40);
			}
			tickFont = helpers$1.options._parseFont(me.options.ticks);
			return Math.ceil(me.height / tickFont.lineHeight);
		},

		// Called after the ticks are built. We need
		handleDirectionalChanges: function handleDirectionalChanges() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},

		getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},

		// Utils
		getPixelForValue: function getPixelForValue(value) {
			var me = this;
			return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
		},

		getValueForPixel: function getValueForPixel(pixel) {
			return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
		},

		getPixelForTick: function getPixelForTick(index) {
			var ticks = this.ticksAsNumbers;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$1 = defaultConfig$1;
	scale_linear._defaults = _defaults$1;

	var valueOrDefault$b = helpers$1.valueOrDefault;
	var log10 = helpers$1.math.log10;

	/**
  * Generate a set of logarithmic ticks
  * @param generationOptions the options used to generate the ticks
  * @param dataRange the range of the data
  * @returns {number[]} array of tick values
  */
	function generateTicks$1(generationOptions, dataRange) {
		var ticks = [];

		var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));

		var endExp = Math.floor(log10(dataRange.max));
		var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
		var exp, significand;

		if (tickVal === 0) {
			exp = Math.floor(log10(dataRange.minNotZero));
			significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

			ticks.push(tickVal);
			tickVal = significand * Math.pow(10, exp);
		} else {
			exp = Math.floor(log10(tickVal));
			significand = Math.floor(tickVal / Math.pow(10, exp));
		}
		var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;

		do {
			ticks.push(tickVal);

			++significand;
			if (significand === 10) {
				significand = 1;
				++exp;
				precision = exp >= 0 ? 1 : precision;
			}

			tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
		} while (exp < endExp || exp === endExp && significand < endSignificand);

		var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
		ticks.push(lastTick);

		return ticks;
	}

	var defaultConfig$2 = {
		position: 'left',

		// label settings
		ticks: {
			callback: core_ticks.formatters.logarithmic
		}
	};

	// TODO(v3): change this to positiveOrDefault
	function nonNegativeOrDefault(value, defaultValue) {
		return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
	}

	var scale_logarithmic = core_scale.extend({
		determineDataLimits: function determineDataLimits() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}
			var datasetIndex, meta, value, data, i, ilen;

			// Calculate Range
			me.min = Number.POSITIVE_INFINITY;
			me.max = Number.NEGATIVE_INFINITY;
			me.minNotZero = Number.POSITIVE_INFINITY;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
						hasStacks = true;
						break;
					}
				}
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					var key = [meta.type,
					// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
					opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							var values = valuesPerStack[key];
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}
							values[i] = values[i] || 0;
							values[i] += value.max;
						}
					}
				}

				helpers$1.each(valuesPerStack, function (valuesForType) {
					if (valuesForType.length > 0) {
						var minVal = helpers$1.min(valuesForType);
						var maxVal = helpers$1.max(valuesForType);
						me.min = Math.min(me.min, minVal);
						me.max = Math.max(me.max, maxVal);
					}
				});
			} else {
				for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
					meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						data = datasets[datasetIndex].data;
						for (i = 0, ilen = data.length; i < ilen; i++) {
							value = me._parseValue(data[i]);
							// invalid, hidden and negative values are ignored
							if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
								continue;
							}

							me.min = Math.min(value.min, me.min);
							me.max = Math.max(value.max, me.max);

							if (value.min !== 0) {
								me.minNotZero = Math.min(value.min, me.minNotZero);
							}
						}
					}
				}
			}

			me.min = helpers$1.isFinite(me.min) ? me.min : null;
			me.max = helpers$1.isFinite(me.max) ? me.max : null;
			me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

			// Common base implementation to handle ticks.min, ticks.max
			this.handleTickRangeOptions();
		},

		handleTickRangeOptions: function handleTickRangeOptions() {
			var me = this;
			var tickOpts = me.options.ticks;
			var DEFAULT_MIN = 1;
			var DEFAULT_MAX = 10;

			me.min = nonNegativeOrDefault(tickOpts.min, me.min);
			me.max = nonNegativeOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
				} else {
					me.min = DEFAULT_MIN;
					me.max = DEFAULT_MAX;
				}
			}
			if (me.min === null) {
				me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
			}
			if (me.max === null) {
				me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
			}
			if (me.minNotZero === null) {
				if (me.min > 0) {
					me.minNotZero = me.min;
				} else if (me.max < 1) {
					me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
				} else {
					me.minNotZero = DEFAULT_MIN;
				}
			}
		},

		buildTicks: function buildTicks() {
			var me = this;
			var tickOpts = me.options.ticks;
			var reverse = !me.isHorizontal();

			var generationOptions = {
				min: nonNegativeOrDefault(tickOpts.min),
				max: nonNegativeOrDefault(tickOpts.max)
			};
			var ticks = me.ticks = generateTicks$1(generationOptions, me);

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers$1.max(ticks);
			me.min = helpers$1.min(ticks);

			if (tickOpts.reverse) {
				reverse = !reverse;
				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
			if (reverse) {
				ticks.reverse();
			}
		},

		convertTicksToLabels: function convertTicksToLabels() {
			this.tickValues = this.ticks.slice();

			core_scale.prototype.convertTicksToLabels.call(this);
		},

		// Get the correct tooltip label
		getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
			return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
		},

		getPixelForTick: function getPixelForTick(index) {
			var ticks = this.tickValues;
			if (index < 0 || index > ticks.length - 1) {
				return null;
			}
			return this.getPixelForValue(ticks[index]);
		},

		/**
   * Returns the value of the first tick.
   * @param {number} value - The minimum not zero value.
   * @return {number} The first tick value.
   * @private
   */
		_getFirstTickValue: function _getFirstTickValue(value) {
			var exp = Math.floor(log10(value));
			var significand = Math.floor(value / Math.pow(10, exp));

			return significand * Math.pow(10, exp);
		},

		_configure: function _configure() {
			var me = this;
			var start = me.min;
			var offset = 0;

			core_scale.prototype._configure.call(me);

			if (start === 0) {
				start = me._getFirstTickValue(me.minNotZero);
				offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
			}

			me._startValue = log10(start);
			me._valueOffset = offset;
			me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
		},

		getPixelForValue: function getPixelForValue(value) {
			var me = this;
			var decimal = 0;

			value = +me.getRightValue(value);

			if (value > me.min && value > 0) {
				decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
			}
			return me.getPixelForDecimal(decimal);
		},

		getValueForPixel: function getValueForPixel(pixel) {
			var me = this;
			var decimal = me.getDecimalForPixel(pixel);
			return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$2 = defaultConfig$2;
	scale_logarithmic._defaults = _defaults$2;

	var valueOrDefault$c = helpers$1.valueOrDefault;
	var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
	var resolve$4 = helpers$1.options.resolve;

	var defaultConfig$3 = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0,0,0,0.1)',
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0.0
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: core_ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function callback(label) {
				return label;
			}
		}
	};

	function getTickBackdropHeight(opts) {
		var tickOpts = opts.ticks;

		if (tickOpts.display && opts.display) {
			return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
		}
		return 0;
	}

	function measureLabelSize(ctx, lineHeight, label) {
		if (helpers$1.isArray(label)) {
			return {
				w: helpers$1.longestText(ctx, ctx.font, label),
				h: label.length * lineHeight
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: lineHeight
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - size / 2,
				end: pos + size / 2
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size
		};
	}

	/**
  * Helper function to fit a radial linear scale with point labels
  */
	function fitWithPointLabels(scale) {

		// Right, this is really confusing and there is a lot of maths going on here
		// The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		//
		// Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		//
		// Solution:
		//
		// We assume the radius of the polygon is half the size of the canvas at first
		// at each index we check if the text overlaps.
		//
		// Where it does, we store that angle and that index.
		//
		// After finding the largest index and angle we calculate how much we need to remove
		// from the shape radius to move the point inwards by that x.
		//
		// We average the left and right distances to get the maximum shape radius that can fit in the box
		// along with labels.
		//
		// Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		// on each side, removing that from the size, halving it and adding the left x protrusion width.
		//
		// This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		// and position it in the most space efficient manner
		//
		// https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

		var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var furthestLimits = {
			l: 0,
			r: scale.width,
			t: 0,
			b: scale.height - scale.paddingTop
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.string;
		scale._pointLabelSizes = [];

		var valueCount = scale.chart.data.labels.length;
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
			textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, lineHeight) {
		var y = position.y + lineHeight / 2;
		var i, ilen;

		if (helpers$1.isArray(text)) {
			for (i = 0, ilen = text.length; i < ilen; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += lineHeight;
			}
		} else {
			ctx.fillText(text, position.x, y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= textSize.h / 2;
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var opts = scale.options;
		var pointLabelOpts = opts.pointLabels;
		var tickBackdropHeight = getTickBackdropHeight(opts);
		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
		var plFont = helpers$1.options._parseFont(pointLabelOpts);

		ctx.save();

		ctx.font = plFont.string;
		ctx.textBaseline = 'middle';

		for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
			// Extra pixels out for some label spacing
			var extra = i === 0 ? tickBackdropHeight / 2 : 0;
			var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

			// Keep this in loop since we may support array properties here
			var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
			ctx.fillStyle = pointLabelFontColor;

			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers$1.toDegrees(angleRadians);
			ctx.textAlign = getTextAlignForAngle(angle);
			adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
			fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
		}
		ctx.restore();
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		var circular = gridLineOpts.circular;
		var valueCount = scale.chart.data.labels.length;
		var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
		var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
		var pointPosition;

		if (!circular && !valueCount || !lineColor || !lineWidth) {
			return;
		}

		ctx.save();
		ctx.strokeStyle = lineColor;
		ctx.lineWidth = lineWidth;
		if (ctx.setLineDash) {
			ctx.setLineDash(gridLineOpts.borderDash || []);
			ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
		}

		ctx.beginPath();
		if (circular) {
			// Draw circular arcs between the points
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
		} else {
			// Draw straight lines connecting each index
			pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}
		}
		ctx.closePath();
		ctx.stroke();
		ctx.restore();
	}

	function numberOrZero(param) {
		return helpers$1.isNumber(param) ? param : 0;
	}

	var scale_radialLinear = scale_linearbase.extend({
		setDimensions: function setDimensions() {
			var me = this;

			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.paddingTop = getTickBackdropHeight(me.options) / 2;
			me.xCenter = Math.floor(me.width / 2);
			me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
			me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
		},

		determineDataLimits: function determineDataLimits() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers$1.each(dataset.data, function (rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
			me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},

		// Returns the maximum number of ticks based on the scale dimension
		_computeTickLimit: function _computeTickLimit() {
			return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
		},

		convertTicksToLabels: function convertTicksToLabels() {
			var me = this;

			scale_linearbase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(function () {
				var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
				return label || label === 0 ? label : '';
			});
		},

		getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},

		fit: function fit() {
			var me = this;
			var opts = me.options;

			if (opts.display && opts.pointLabels.display) {
				fitWithPointLabels(me);
			} else {
				me.setCenterPoint(0, 0, 0, 0);
			}
		},

		/**
   * Set radius reductions and determine new radius and center point
   * @private
   */
		setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},

		setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;

			me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
			me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
		},

		getIndexAngle: function getIndexAngle(index) {
			var chart = this.chart;
			var angleMultiplier = 360 / chart.data.labels.length;
			var options = chart.options || {};
			var startAngle = options.startAngle || 0;

			// Start from the top instead of right, so remove a quarter of the circle
			var angle = (index * angleMultiplier + startAngle) % 360;

			return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
		},

		getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
			var me = this;

			if (helpers$1.isNullOrUndef(value)) {
				return NaN;
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},

		getPointPosition: function getPointPosition(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
			return {
				x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
				y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
			};
		},

		getPointPositionForValue: function getPointPositionForValue(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function getBasePosition(index) {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
		},

		/**
   * @private
   */
		_drawGrid: function _drawGrid() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var angleLineOpts = opts.angleLines;
			var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
			var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
			var i, offset, position;

			if (opts.pointLabels.display) {
				drawPointLabels(me);
			}

			if (gridLineOpts.display) {
				helpers$1.each(me.ticks, function (label, index) {
					if (index !== 0) {
						offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
						drawRadiusLine(me, gridLineOpts, offset, index);
					}
				});
			}

			if (angleLineOpts.display && lineWidth && lineColor) {
				ctx.save();
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = lineColor;
				if (ctx.setLineDash) {
					ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
					ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
				}

				for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
					offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
					position = me.getPointPosition(i, offset);
					ctx.beginPath();
					ctx.moveTo(me.xCenter, me.yCenter);
					ctx.lineTo(position.x, position.y);
					ctx.stroke();
				}

				ctx.restore();
			}
		},

		/**
   * @private
   */
		_drawLabels: function _drawLabels() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;
			var tickOpts = opts.ticks;

			if (!tickOpts.display) {
				return;
			}

			var startAngle = me.getIndexAngle(0);
			var tickFont = helpers$1.options._parseFont(tickOpts);
			var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
			var offset, width;

			ctx.save();
			ctx.font = tickFont.string;
			ctx.translate(me.xCenter, me.yCenter);
			ctx.rotate(startAngle);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			helpers$1.each(me.ticks, function (label, index) {
				if (index === 0 && !tickOpts.reverse) {
					return;
				}

				offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

				if (tickOpts.showLabelBackdrop) {
					width = ctx.measureText(label).width;
					ctx.fillStyle = tickOpts.backdropColor;

					ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
				}

				ctx.fillStyle = tickFontColor;
				ctx.fillText(label, 0, -offset);
			});

			ctx.restore();
		},

		/**
   * @private
   */
		_drawTitle: helpers$1.noop
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$3 = defaultConfig$3;
	scale_radialLinear._defaults = _defaults$3;

	var deprecated$1 = helpers$1._deprecated;
	var resolve$5 = helpers$1.options.resolve;
	var valueOrDefault$d = helpers$1.valueOrDefault;

	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: 1000
		},
		second: {
			common: true,
			size: 1000,
			steps: 60
		},
		minute: {
			common: true,
			size: 60000,
			steps: 60
		},
		hour: {
			common: true,
			size: 3600000,
			steps: 24
		},
		day: {
			common: true,
			size: 86400000,
			steps: 30
		},
		week: {
			common: false,
			size: 604800000,
			steps: 4
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: 12
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: 4
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};

	var UNITS = Object.keys(INTERVALS);

	function sorter(a, b) {
		return a - b;
	}

	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}

		return out;
	}

	function getMin(options) {
		return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
	}

	function getMax(options) {
		return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
	}

	/**
  * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
  * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
  * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
  * extremity (left + width or top + height). Note that it would be more optimized to directly
  * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
  * to create the lookup table. The table ALWAYS contains at least two items: min and max.
  *
  * @param {number[]} timestamps - timestamps sorted from lowest to highest.
  * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
  * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
  * If 'series', timestamps will be positioned at the same distance from each other. In this
  * case, only timestamps that break the time linearity are registered, meaning that in the
  * best case, all timestamps are linear, the table contains only min and max.
  */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [{ time: min, pos: 0 }, { time: max, pos: 1 }];
		}

		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;

		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}

		items.push(max);

		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];

			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({ time: curr, pos: i / (ilen - 1) });
			}
		}

		return table;
	}

	// @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;

		while (lo >= 0 && lo <= hi) {
			mid = lo + hi >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];

			if (!i0) {
				// given value is outside table (before first item)
				return { lo: null, hi: i1 };
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return { lo: i0, hi: i1 };
			}
		}

		// given value is outside table (after last item)
		return { lo: i1, hi: null };
	}

	/**
  * Linearly interpolates the given source `value` using the table items `skey` values and
  * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
  * returns the position for a timestamp equal to 42. If value is out of bounds, values at
  * index [0, 1] or [n - 1, n] are used for the interpolation.
  */
	function interpolate$1(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);

		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;

		return prev[tkey] + offset;
	}

	function toTimestamp(scale, input) {
		var adapter = scale._adapter;
		var options = scale.options.time;
		var parser = options.parser;
		var format = parser || options.format;
		var value = input;

		if (typeof parser === 'function') {
			value = parser(value);
		}

		// Only parse if its not a timestamp already
		if (!helpers$1.isFinite(value)) {
			value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
		}

		if (value !== null) {
			return +value;
		}

		// Labels are in an incompatible format and no `parser` has been provided.
		// The user might still use the deprecated `format` option for parsing.
		if (!parser && typeof format === 'function') {
			value = format(input);

			// `format` could return something else than a timestamp, if so, parse it
			if (!helpers$1.isFinite(value)) {
				value = adapter.parse(value);
			}
		}

		return value;
	}

	function parse(scale, input) {
		if (helpers$1.isNullOrUndef(input)) {
			return null;
		}

		var options = scale.options.time;
		var value = toTimestamp(scale, scale.getRightValue(input));
		if (value === null) {
			return value;
		}

		if (options.round) {
			value = +scale._adapter.startOf(value, options.round);
		}

		return value;
	}

	/**
  * Figures out what unit results in an appropriate number of auto-generated ticks
  */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;

		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps : MAX_INTEGER;

			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}

		return UNITS[ilen - 1];
	}

	/**
  * Figures out what unit to format a set of ticks with
  */
	function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
		var i, unit;

		for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
				return unit;
			}
		}

		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}

	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}

	/**
  * Generates a maximum of `capacity` timestamps between min and max, rounded to the
  * `minor` unit using the given scale time `options`.
  * Important: this method can return ticks outside the min and max range, it's the
  * responsibility of the calling code to clamp values if needed.
  */
	function generate(scale, min, max, capacity) {
		var adapter = scale._adapter;
		var options = scale.options;
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var first = min;
		var ticks = [];
		var time;

		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = +adapter.startOf(first, 'isoWeek', weekday);
		}

		// Align first ticks on unit
		first = +adapter.startOf(first, weekday ? 'day' : minor);

		// Prevent browser from freezing in case user options request millions of milliseconds
		if (adapter.diff(max, min, minor) > 100000 * stepSize) {
			throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
		}

		for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
			ticks.push(time);
		}

		if (time === max || options.bounds === 'ticks') {
			ticks.push(time);
		}

		return ticks;
	}

	/**
  * Returns the start and end offsets from edges in the form of {start, end}
  * where each value is a relative width to the scale and ranges between 0 and 1.
  * They add extra margins on the both sides by scaling down the original scale.
  * Offsets are added when the `offset` option is true.
  */
	function computeOffsets(table, ticks, min, max, options) {
		var start = 0;
		var end = 0;
		var first, last;

		if (options.offset && ticks.length) {
			first = interpolate$1(table, 'time', ticks[0], 'pos');
			if (ticks.length === 1) {
				start = 1 - first;
			} else {
				start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
			}
			last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
			if (ticks.length === 1) {
				end = last;
			} else {
				end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
			}
		}

		return { start: start, end: end, factor: 1 / (start + 1 + end) };
	}

	function setMajorTicks(scale, ticks, map, majorUnit) {
		var adapter = scale._adapter;
		var first = +adapter.startOf(ticks[0].value, majorUnit);
		var last = ticks[ticks.length - 1].value;
		var major, index;

		for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
			index = map[major];
			if (index >= 0) {
				ticks[index].major = true;
			}
		}
		return ticks;
	}

	function ticksFromTimestamps(scale, values, majorUnit) {
		var ticks = [];
		var map = {};
		var ilen = values.length;
		var i, value;

		for (i = 0; i < ilen; ++i) {
			value = values[i];
			map[value] = i;

			ticks.push({
				value: value,
				major: false
			});
		}

		// We set the major ticks separately from the above loop because calling startOf for every tick
		// is expensive when there is a large number of ticks
		return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
	}

	var defaultConfig$4 = {
		position: 'bottom',

		/**
   * Data distribution along the scale:
   * - 'linear': data are spread according to their time (distances can vary),
   * - 'series': data are spread at the same distance from each other.
   * @see https://github.com/chartjs/Chart.js/pull/4507
   * @since 2.7.0
   */
		distribution: 'linear',

		/**
   * Scale boundary strategy (bypassed by min/max time options)
   * - `data`: make sure data are fully visible, ticks outside are removed
   * - `ticks`: make sure ticks are fully visible, data outside are truncated
   * @see https://github.com/chartjs/Chart.js/pull/4556
   * @since 2.7.0
   */
		bounds: 'data',

		adapters: {},
		time: {
			parser: false, // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',
			displayFormats: {}
		},
		ticks: {
			autoSkip: false,

			/**
    * Ticks generation input values:
    * - 'auto': generates "optimal" ticks based on scale size and time options.
    * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
    * - 'labels': generates ticks from user given `data.labels` values ONLY.
    * @see https://github.com/chartjs/Chart.js/pull/4507
    * @since 2.7.0
    */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var scale_time = core_scale.extend({
		initialize: function initialize() {
			this.mergeTicksOptions();
			core_scale.prototype.initialize.call(this);
		},

		update: function update() {
			var me = this;
			var options = me.options;
			var time = options.time || (options.time = {});
			var adapter = me._adapter = new core_adapters._date(options.adapters.date);

			// DEPRECATIONS: output a message only one time per update
			deprecated$1('time scale', time.format, 'time.format', 'time.parser');
			deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
			deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

			// Backward compatibility: before introducing adapter, `displayFormats` was
			// supposed to contain *all* unit/string pairs but this can't be resolved
			// when loading the scale (adapters are loaded afterward), so let's populate
			// missing formats on update
			helpers$1.mergeIf(time.displayFormats, adapter.formats());

			return core_scale.prototype.update.apply(me, arguments);
		},

		/**
   * Allows data to be referenced via 't' attribute
   */
		getRightValue: function getRightValue(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return core_scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function determineDataLimits() {
			var me = this;
			var chart = me.chart;
			var adapter = me._adapter;
			var options = me.options;
			var unit = options.time.unit || 'day';
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp, labelsAdded;
			var dataLabels = me._getLabels();

			for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
				labels.push(parse(me, dataLabels[i]));
			}

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers$1.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(me, data[j]);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						datasets[i] = labels.slice(0);
						if (!labelsAdded) {
							timestamps = timestamps.concat(labels);
							labelsAdded = true;
						}
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;

			// In case there is no valid min/max, set limits based on unit time option
			min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
			max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function buildTicks() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var tickOpts = options.ticks;
			var timeOpts = options.time;
			var timestamps = me._timestamps;
			var ticks = [];
			var capacity = me.getLabelCapacity(min);
			var source = tickOpts.source;
			var distribution = options.distribution;
			var i, ilen, timestamp;

			if (source === 'data' || source === 'auto' && distribution === 'series') {
				timestamps = timestamps.data;
			} else if (source === 'labels') {
				timestamps = timestamps.labels;
			} else {
				timestamps = generate(me, min, max, capacity);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(me, getMin(options)) || min;
			max = parse(me, getMax(options)) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			// determineUnitForFormatting relies on the number of ticks so we don't use it when
			// autoSkip is enabled because we don't yet know what the final number of ticks will be
			me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
			me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);

			if (tickOpts.reverse) {
				ticks.reverse();
			}

			return ticksFromTimestamps(me, ticks, me._majorUnit);
		},

		getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
			var me = this;
			var adapter = me._adapter;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers$1.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
			}
			if (typeof label === 'string') {
				return label;
			}
			return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
		},

		/**
   * Function to format an individual tick mark
   * @private
   */
		tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
			var me = this;
			var adapter = me._adapter;
			var options = me.options;
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var tick = ticks[index];
			var tickOpts = options.ticks;
			var major = majorUnit && majorFormat && tick && tick.major;
			var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
			var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
			var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function convertTicksToLabels(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
			}

			return labels;
		},

		/**
   * @private
   */
		getPixelForOffset: function getPixelForOffset(time) {
			var me = this;
			var offsets = me._offsets;
			var pos = interpolate$1(me._table, 'time', time, 'pos');
			return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
		},

		getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(me, value);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function getPixelForTick(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
		},

		getValueForPixel: function getValueForPixel(pixel) {
			var me = this;
			var offsets = me._offsets;
			var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
			var time = interpolate$1(me._table, 'pos', pos, 'time');

			// DEPRECATION, we should return time directly
			return me._adapter._create(time);
		},

		/**
   * @private
   */
		_getLabelSize: function _getLabelSize(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);

			return {
				w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
				h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
			};
		},

		/**
   * Crude approximation of what the label width might be
   * @private
   */
		getLabelWidth: function getLabelWidth(label) {
			return this._getLabelSize(label).w;
		},

		/**
   * @private
   */
		getLabelCapacity: function getLabelCapacity(exampleTime) {
			var me = this;
			var timeOpts = me.options.time;
			var displayFormats = timeOpts.displayFormats;

			// pick the longest format (milliseconds) for guestimation
			var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
			var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
			var size = me._getLabelSize(exampleLabel);
			var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);

			if (me.options.offset) {
				capacity--;
			}

			return capacity > 0 ? capacity : 1;
		}
	});

	// INTERNAL: static default options, registered in src/index.js
	var _defaults$4 = defaultConfig$4;
	scale_time._defaults = _defaults$4;

	var scales = {
		category: scale_category,
		linear: scale_linear,
		logarithmic: scale_logarithmic,
		radialLinear: scale_radialLinear,
		time: scale_time
	};

	var FORMATS = {
		datetime: 'MMM D, YYYY, h:mm:ss a',
		millisecond: 'h:mm:ss.SSS a',
		second: 'h:mm:ss a',
		minute: 'h:mm a',
		hour: 'hA',
		day: 'MMM D',
		week: 'll',
		month: 'MMM YYYY',
		quarter: '[Q]Q - YYYY',
		year: 'YYYY'
	};

	core_adapters._date.override(typeof moment === 'function' ? {
		_id: 'moment', // DEBUG ONLY

		formats: function formats() {
			return FORMATS;
		},

		parse: function parse(value, format) {
			if (typeof value === 'string' && typeof format === 'string') {
				value = moment(value, format);
			} else if (!(value instanceof moment)) {
				value = moment(value);
			}
			return value.isValid() ? value.valueOf() : null;
		},

		format: function format(time, _format) {
			return moment(time).format(_format);
		},

		add: function add(time, amount, unit) {
			return moment(time).add(amount, unit).valueOf();
		},

		diff: function diff(max, min, unit) {
			return moment(max).diff(moment(min), unit);
		},

		startOf: function startOf(time, unit, weekday) {
			time = moment(time);
			if (unit === 'isoWeek') {
				return time.isoWeekday(weekday).valueOf();
			}
			return time.startOf(unit).valueOf();
		},

		endOf: function endOf(time, unit) {
			return moment(time).endOf(unit).valueOf();
		},

		// DEPRECATIONS

		/**
   * Provided for backward compatibility with scale.getValueForPixel().
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   * @private
   */
		_create: function _create(time) {
			return moment(time);
		}
	} : {});

	core_defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});

	var mappers = {
		dataset: function dataset(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = visible && meta.dataset._children || [];
			var length = points.length || 0;

			return !length ? null : function (point, i) {
				return i < length && points[i]._view || null;
			};
		},

		boundary: function boundary(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			if (helpers$1.isArray(boundary)) {
				return function (point, i) {
					return boundary[i];
				};
			}

			return function (point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
			// compatibility
			case 'bottom':
				return 'start';
			case 'top':
				return 'end';
			case 'zero':
				return 'origin';
			// supported boundaries
			case 'origin':
			case 'start':
			case 'end':
				return fill;
			// invalid fill values
			default:
				return false;
		}
	}

	function computeLinearBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (helpers$1.isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function computeCircularBoundary(source) {
		var scale = source.el._scale;
		var options = scale.options;
		var length = scale.chart.data.labels.length;
		var fill = source.fill;
		var target = [];
		var start, end, center, i, point;

		if (!length) {
			return null;
		}

		start = options.ticks.reverse ? scale.max : scale.min;
		end = options.ticks.reverse ? scale.min : scale.max;
		center = scale.getPointPositionForValue(0, start);
		for (i = 0; i < length; ++i) {
			point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
			if (options.gridLines.circular) {
				point.cx = center.x;
				point.cy = center.y;
				point.angle = scale.getIndexAngle(i) - Math.PI / 2;
			}
			target.push(point);
		}
		return target;
	}

	function computeBoundary(source) {
		var scale = source.el._scale || {};

		if (scale.getPointPositionForValue) {
			return computeCircularBoundary(source);
		}
		return computeLinearBoundary(source);
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i, cx, cy, r;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		if (curve1[0].angle !== undefined) {
			cx = curve1[0].cx;
			cy = curve1[0].cy;
			r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
			for (i = len1 - 1; i > 0; --i) {
				ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
			}
			return;
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1, loopOffset;

		ctx.beginPath();

		for (i = 0, ilen = count; i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (loop && loopOffset === undefined && d0) {
				loopOffset = i + 1;
				ilen = count + loopOffset;
			}

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	var plugin_filler = {
		id: 'filler',

		afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
			var metasets = chart._getSortedVisibleDatasetMetas();
			var ctx = chart.ctx;
			var meta, i, el, view, points, mapper, color;

			for (i = metasets.length - 1; i >= 0; --i) {
				meta = metasets[i].$filler;

				if (!meta || !meta.visible) {
					continue;
				}

				el = meta.el;
				view = el._view;
				points = el._children || [];
				mapper = meta.mapper;
				color = view.backgroundColor || core_defaults.global.defaultColor;

				if (mapper && color && points.length) {
					helpers$1.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers$1.canvas.unclipArea(ctx);
				}
			}
		}
	};

	var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
	var noop$1 = helpers$1.noop;
	var valueOrDefault$e = helpers$1.valueOrDefault;

	core_defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			align: 'center',
			fullWidth: true,
			reverse: false,
			weight: 1000,

			// a callback that will handle
			onClick: function onClick(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);

				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

				// We hid a dataset ... rerender the chart
				ci.update();
			},

			onHover: null,
			onLeave: null,

			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function generateLabels(chart) {
					var datasets = chart.data.datasets;
					var options = chart.options.legend || {};
					var usePointStyle = options.labels && options.labels.usePointStyle;

					return chart._getSortedDatasetMetas().map(function (meta) {
						var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);

						return {
							text: datasets[meta.index].label,
							fillStyle: style.backgroundColor,
							hidden: !chart.isDatasetVisible(meta.index),
							lineCap: style.borderCapStyle,
							lineDash: style.borderDash,
							lineDashOffset: style.borderDashOffset,
							lineJoin: style.borderJoinStyle,
							lineWidth: style.borderWidth,
							strokeStyle: style.borderColor,
							pointStyle: style.pointStyle,
							rotation: style.rotation,

							// Below is extra data used for toggling the datasets
							datasetIndex: meta.index
						};
					}, this);
				}
			}
		},

		legendCallback: function legendCallback(chart) {
			var list = document.createElement('ul');
			var datasets = chart.data.datasets;
			var i, ilen, listItem, listItemSpan;

			list.setAttribute('class', chart.id + '-legend');

			for (i = 0, ilen = datasets.length; i < ilen; i++) {
				listItem = list.appendChild(document.createElement('li'));
				listItemSpan = listItem.appendChild(document.createElement('span'));
				listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
				if (datasets[i].label) {
					listItem.appendChild(document.createTextNode(datasets[i].label));
				}
			}

			return list.outerHTML;
		}
	});

	/**
  * Helper function to get the box width based on the usePointStyle option
  * @param {object} labelopts - the label options on the legend
  * @param {number} fontSize - the label font size
  * @return {number} width of the color box area
  */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
	}

	/**
  * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
  */
	var Legend = core_element.extend({

		initialize: function initialize(config) {
			var me = this;
			helpers$1.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];

			/**
   	 * @private
   	 */
			me._hoveredItem = null;

			// Are we in doughnut mode which has a different data type
			me.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop$1,
		update: function update(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop$1,

		//

		beforeSetDimensions: noop$1,
		setDimensions: function setDimensions() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$1,

		//

		beforeBuildLabels: noop$1,
		buildLabels: function buildLabels() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function (item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop$1,

		//

		beforeFit: noop$1,
		fit: function fit() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (!display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}
			ctx.font = labelFont.string;

			if (isHorizontal) {
				// Labels

				// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
				var lineWidths = me.lineWidths = [0];
				var totalHeight = 0;

				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';

				helpers$1.each(me.legendItems, function (legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

					if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
						totalHeight += fontSize + labelOpts.padding;
						lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
					}

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: width,
						height: fontSize
					};

					lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
				});

				minSize.height += totalHeight;
			} else {
				var vPadding = labelOpts.padding;
				var columnWidths = me.columnWidths = [];
				var columnHeights = me.columnHeights = [];
				var totalWidth = labelOpts.padding;
				var currentColWidth = 0;
				var currentColHeight = 0;

				helpers$1.each(me.legendItems, function (legendItem, i) {
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

					// If too tall, go to new column
					if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
						totalWidth += currentColWidth + labelOpts.padding;
						columnWidths.push(currentColWidth); // previous column width
						columnHeights.push(currentColHeight);
						currentColWidth = 0;
						currentColHeight = 0;
					}

					// Get max width
					currentColWidth = Math.max(currentColWidth, itemWidth);
					currentColHeight += fontSize + vPadding;

					// Store the hitbox width and height here. Final position will be updated in `draw`
					hitboxes[i] = {
						left: 0,
						top: 0,
						width: itemWidth,
						height: fontSize
					};
				});

				totalWidth += currentColWidth;
				columnWidths.push(currentColWidth);
				columnHeights.push(currentColHeight);
				minSize.width += totalWidth;
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop$1,

		// Shared Methods
		isHorizontal: function isHorizontal() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function draw() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefaults = core_defaults.global;
			var defaultColor = globalDefaults.defaultColor;
			var lineDefault = globalDefaults.elements.line;
			var legendHeight = me.height;
			var columnHeights = me.columnHeights;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (!opts.display) {
				return;
			}

			var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
			var ctx = me.ctx;
			var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
			var labelFont = helpers$1.options._parseFont(labelOpts);
			var fontSize = labelFont.size;
			var cursor;

			// Canvas setup
			ctx.textAlign = rtlHelper.textAlign('left');
			ctx.textBaseline = 'middle';
			ctx.lineWidth = 0.5;
			ctx.strokeStyle = fontColor; // for strikethrough effect
			ctx.fillStyle = fontColor; // render in correct colour
			ctx.font = labelFont.string;

			var boxWidth = getBoxWidth(labelOpts, fontSize);
			var hitboxes = me.legendHitBoxes;

			// current position
			var drawLegendBox = function drawLegendBox(x, y, legendItem) {
				if (isNaN(boxWidth) || boxWidth <= 0) {
					return;
				}

				// Set the ctx for the box
				ctx.save();

				var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
				ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
				ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
				ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
				ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
				ctx.lineWidth = lineWidth;
				ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);

				if (ctx.setLineDash) {
					// IE 9 and 10 do not support line dash
					ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
				}

				if (labelOpts && labelOpts.usePointStyle) {
					// Recalculate x and y for drawPoint() because its expecting
					// x and y to be center of figure (instead of top left)
					var radius = boxWidth * Math.SQRT2 / 2;
					var centerX = rtlHelper.xPlus(x, boxWidth / 2);
					var centerY = y + fontSize / 2;

					// Draw pointStyle as legend symbol
					helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
				} else {
					// Draw box as legend symbol
					ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					if (lineWidth !== 0) {
						ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
					}
				}

				ctx.restore();
			};

			var fillText = function fillText(x, y, legendItem, textWidth) {
				var halfFontSize = fontSize / 2;
				var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
				var yMiddle = y + halfFontSize;

				ctx.fillText(legendItem.text, xLeft, yMiddle);

				if (legendItem.hidden) {
					// Strikethrough the text if hidden
					ctx.beginPath();
					ctx.lineWidth = 2;
					ctx.moveTo(xLeft, yMiddle);
					ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
					ctx.stroke();
				}
			};

			var alignmentOffset = function alignmentOffset(dimension, blockSize) {
				switch (opts.align) {
					case 'start':
						return labelOpts.padding;
					case 'end':
						return dimension - blockSize;
					default:
						// center
						return (dimension - blockSize + labelOpts.padding) / 2;
				}
			};

			// Horizontal
			var isHorizontal = me.isHorizontal();
			if (isHorizontal) {
				cursor = {
					x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
					y: me.top + labelOpts.padding,
					line: 0
				};
			} else {
				cursor = {
					x: me.left + labelOpts.padding,
					y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
					line: 0
				};
			}

			helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);

			var itemHeight = fontSize + labelOpts.padding;
			helpers$1.each(me.legendItems, function (legendItem, i) {
				var textWidth = ctx.measureText(legendItem.text).width;
				var width = boxWidth + fontSize / 2 + textWidth;
				var x = cursor.x;
				var y = cursor.y;

				rtlHelper.setWidth(me.minSize.width);

				// Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
				// instead of me.right and me.bottom because me.width and me.height
				// may have been changed since me.minSize was calculated
				if (isHorizontal) {
					if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
						y = cursor.y += itemHeight;
						cursor.line++;
						x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
					}
				} else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
					x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
					cursor.line++;
					y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
				}

				var realX = rtlHelper.x(x);

				drawLegendBox(realX, y, legendItem);

				hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
				hitboxes[i].top = y;

				// Fill the actual label
				fillText(realX, y, legendItem, textWidth);

				if (isHorizontal) {
					cursor.x += width + labelOpts.padding;
				} else {
					cursor.y += itemHeight;
				}
			});

			helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
		},

		/**
   * @private
   */
		_getLegendItemAt: function _getLegendItemAt(x, y) {
			var me = this;
			var i, hitBox, lh;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				lh = me.legendHitBoxes;
				for (i = 0; i < lh.length; ++i) {
					hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						return me.legendItems[i];
					}
				}
			}

			return null;
		},

		/**
   * Handle an event
   * @private
   * @param {IEvent} event - The event to handle
   */
		handleEvent: function handleEvent(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var hoveredItem;

			if (type === 'mousemove') {
				if (!opts.onHover && !opts.onLeave) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			hoveredItem = me._getLegendItemAt(e.x, e.y);

			if (type === 'click') {
				if (hoveredItem && opts.onClick) {
					// use e.native for backwards compatibility
					opts.onClick.call(me, e.native, hoveredItem);
				}
			} else {
				if (opts.onLeave && hoveredItem !== me._hoveredItem) {
					if (me._hoveredItem) {
						opts.onLeave.call(me, e.native, me._hoveredItem);
					}
					me._hoveredItem = hoveredItem;
				}

				if (opts.onHover && hoveredItem) {
					// use e.native for backwards compatibility
					opts.onHover.call(me, e.native, hoveredItem);
				}
			}
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		core_layouts.configure(chart, legend, legendOpts);
		core_layouts.addBox(chart, legend);
		chart.legend = legend;
	}

	var plugin_legend = {
		id: 'legend',

		/**
   * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
   * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
   * the plugin, which one will be re-exposed in the chart.js file.
   * https://github.com/chartjs/Chart.js/pull/2640
   * @private
   */
		_element: Legend,

		beforeInit: function beforeInit(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function beforeUpdate(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers$1.mergeIf(legendOpts, core_defaults.global.legend);

				if (legend) {
					core_layouts.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				core_layouts.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function afterEvent(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};

	var noop$2 = helpers$1.noop;

	core_defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000 // by default greater than legend (1000) to be above
		}
	});

	/**
  * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
  */
	var Title = core_element.extend({
		initialize: function initialize(config) {
			var me = this;
			helpers$1.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop$2,
		update: function update(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop$2,

		//

		beforeSetDimensions: noop$2,
		setDimensions: function setDimensions() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop$2,

		//

		beforeBuildLabels: noop$2,
		buildLabels: noop$2,
		afterBuildLabels: noop$2,

		//

		beforeFit: noop$2,
		fit: function fit() {
			var me = this;
			var opts = me.options;
			var minSize = me.minSize = {};
			var isHorizontal = me.isHorizontal();
			var lineCount, textSize;

			if (!opts.display) {
				me.width = minSize.width = me.height = minSize.height = 0;
				return;
			}

			lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
			textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;

			me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
			me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
		},
		afterFit: noop$2,

		// Shared Methods
		isHorizontal: function isHorizontal() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function draw() {
			var me = this;
			var ctx = me.ctx;
			var opts = me.options;

			if (!opts.display) {
				return;
			}

			var fontOpts = helpers$1.options._parseFont(opts);
			var lineHeight = fontOpts.lineHeight;
			var offset = lineHeight / 2 + opts.padding;
			var rotation = 0;
			var top = me.top;
			var left = me.left;
			var bottom = me.bottom;
			var right = me.right;
			var maxWidth, titleX, titleY;

			ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
			ctx.font = fontOpts.string;

			// Horizontal
			if (me.isHorizontal()) {
				titleX = left + (right - left) / 2; // midpoint of the width
				titleY = top + offset;
				maxWidth = right - left;
			} else {
				titleX = opts.position === 'left' ? left + offset : right - offset;
				titleY = top + (bottom - top) / 2;
				maxWidth = bottom - top;
				rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
			}

			ctx.save();
			ctx.translate(titleX, titleY);
			ctx.rotate(rotation);
			ctx.textAlign = 'center';
			ctx.textBaseline = 'middle';

			var text = opts.text;
			if (helpers$1.isArray(text)) {
				var y = 0;
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], 0, y, maxWidth);
					y += lineHeight;
				}
			} else {
				ctx.fillText(text, 0, 0, maxWidth);
			}

			ctx.restore();
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		core_layouts.configure(chart, title, titleOpts);
		core_layouts.addBox(chart, title);
		chart.titleBlock = title;
	}

	var plugin_title = {
		id: 'title',

		/**
   * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
   * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
   * the plugin, which one will be re-exposed in the chart.js file.
   * https://github.com/chartjs/Chart.js/pull/2640
   * @private
   */
		_element: Title,

		beforeInit: function beforeInit(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function beforeUpdate(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers$1.mergeIf(titleOpts, core_defaults.global.title);

				if (titleBlock) {
					core_layouts.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				core_layouts.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};

	var plugins = {};
	var filler = plugin_filler;
	var legend = plugin_legend;
	var title = plugin_title;
	plugins.filler = filler;
	plugins.legend = legend;
	plugins.title = title;

	/**
  * @namespace Chart
  */

	core_controller.helpers = helpers$1;

	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	core_helpers();

	core_controller._adapters = core_adapters;
	core_controller.Animation = core_animation;
	core_controller.animationService = core_animations;
	core_controller.controllers = controllers;
	core_controller.DatasetController = core_datasetController;
	core_controller.defaults = core_defaults;
	core_controller.Element = core_element;
	core_controller.elements = elements;
	core_controller.Interaction = core_interaction;
	core_controller.layouts = core_layouts;
	core_controller.platform = platform;
	core_controller.plugins = core_plugins;
	core_controller.Scale = core_scale;
	core_controller.scaleService = core_scaleService;
	core_controller.Ticks = core_ticks;
	core_controller.Tooltip = core_tooltip;

	// Register built-in scales

	core_controller.helpers.each(scales, function (scale, type) {
		core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
	});

	// Load to register built-in adapters (as side effects)


	// Loading built-in plugins

	for (var k in plugins) {
		if (plugins.hasOwnProperty(k)) {
			core_controller.plugins.register(plugins[k]);
		}
	}

	core_controller.platform.initialize();

	var src = core_controller;
	if (typeof window !== 'undefined') {
		window.Chart = core_controller;
	}

	// DEPRECATIONS

	/**
  * Provided for backward compatibility, not available anymore
  * @namespace Chart.Chart
  * @deprecated since version 2.8.0
  * @todo remove at version 3
  * @private
  */
	core_controller.Chart = core_controller;

	/**
  * Provided for backward compatibility, not available anymore
  * @namespace Chart.Legend
  * @deprecated since version 2.1.5
  * @todo remove at version 3
  * @private
  */
	core_controller.Legend = plugins.legend._element;

	/**
  * Provided for backward compatibility, not available anymore
  * @namespace Chart.Title
  * @deprecated since version 2.1.5
  * @todo remove at version 3
  * @private
  */
	core_controller.Title = plugins.title._element;

	/**
  * Provided for backward compatibility, use Chart.plugins instead
  * @namespace Chart.pluginService
  * @deprecated since version 2.1.5
  * @todo remove at version 3
  * @private
  */
	core_controller.pluginService = core_controller.plugins;

	/**
  * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
  * effect, instead simply create/register plugins via plain JavaScript objects.
  * @interface Chart.PluginBase
  * @deprecated since version 2.5.0
  * @todo remove at version 3
  * @private
  */
	core_controller.PluginBase = core_controller.Element.extend({});

	/**
  * Provided for backward compatibility, use Chart.helpers.canvas instead.
  * @namespace Chart.canvasHelpers
  * @deprecated since version 2.6.0
  * @todo remove at version 3
  * @private
  */
	core_controller.canvasHelpers = core_controller.helpers.canvas;

	/**
  * Provided for backward compatibility, use Chart.layouts instead.
  * @namespace Chart.layoutService
  * @deprecated since version 2.7.3
  * @todo remove at version 3
  * @private
  */
	core_controller.layoutService = core_controller.layouts;

	/**
  * Provided for backward compatibility, not available anymore.
  * @namespace Chart.LinearScaleBase
  * @deprecated since version 2.8
  * @todo remove at version 3
  * @private
  */
	core_controller.LinearScaleBase = scale_linearbase;

	/**
  * Provided for backward compatibility, instead we should create a new Chart
  * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
  * @deprecated since version 2.8.0
  * @todo remove at version 3
  */
	core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
		core_controller[klass] = function (ctx, cfg) {
			return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
				type: klass.charAt(0).toLowerCase() + klass.slice(1)
			}));
		};
	});

	return src;
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(272);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5e97e38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1155);
function injectStyle (ssrContext) {
  __webpack_require__(1145)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5e97e38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskForm_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c78f8f0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskForm_vue__ = __webpack_require__(996);
function injectStyle (ssrContext) {
  __webpack_require__(994)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c78f8f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TaskForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c78f8f0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TaskForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionList_vue__ = __webpack_require__(269);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337a92c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionList_vue__ = __webpack_require__(1156);
function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductionList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_337a92c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductionList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(278);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3438c1c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1178);
function injectStyle (ssrContext) {
  __webpack_require__(1172)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3438c1c1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 115 */,
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(29);
var LIBRARY = __webpack_require__(45);
var wksExt = __webpack_require__(172);
var defineProperty = __webpack_require__(15).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(73)('keys');
var uid = __webpack_require__(51);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(8);
var check = function check(O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(30)(Function.call, __webpack_require__(27).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = '\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003' + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(121).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  }return that;
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toInteger = __webpack_require__(32);
var defined = __webpack_require__(35);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (; n > 0; (n >>>= 1) && (str += str)) {
    if (n & 1) res += str;
  }return res;
};

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = !$expm1
// Old FF bug
|| $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
// Tor Browser bug
|| $expm1(-2e-17) != -2e-17 ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(45);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(67);
var $iterCreate = __webpack_require__(128);
var setToStringTag = __webpack_require__(64);
var getPrototypeOf = __webpack_require__(28);
var ITERATOR = __webpack_require__(12)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(54);
var descriptor = __webpack_require__(50);
var setToStringTag = __webpack_require__(64);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(22)(IteratorPrototype, __webpack_require__(12)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(86);
var defined = __webpack_require__(35);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(12)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }return true;
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(67);
var ITERATOR = __webpack_require__(12)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(15);
var createDesc = __webpack_require__(50);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(65);
var ITERATOR = __webpack_require__(12)('iterator');
var Iterators = __webpack_require__(67);
module.exports = __webpack_require__(29).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(815);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)


var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(53);
var toLength = __webpack_require__(13);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) {
    O[index++] = value;
  }return O;
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(47);
var step = __webpack_require__(189);
var Iterators = __webpack_require__(67);
var toIObject = __webpack_require__(26);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(127)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(76);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
}();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var at = __webpack_require__(85)(true);

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(30);
var invoke = __webpack_require__(179);
var html = __webpack_require__(120);
var cel = __webpack_require__(116);
var global = __webpack_require__(9);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function run() {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function listener(event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(31)(process) == 'process') {
    defer = function defer(id) {
      process.nextTick(ctx(run, id, 1));
    };
    // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function defer(id) {
      Dispatch.now(ctx(run, id, 1));
    };
    // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function defer(id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
    // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function defer(id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
    // Rest old browsers
  } else {
    defer = function defer(id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var macrotask = __webpack_require__(139).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(31)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function flush() {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();else last = undefined;
        throw e;
      }
    }last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function notify() {
      process.nextTick(flush);
    };
    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function notify() {
      node.data = toggle = !toggle;
    };
    // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function notify() {
      promise.then(flush);
    };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
  } else {
    notify = function notify() {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    }last = task;
  };
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)

var aFunction = __webpack_require__(19);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(14);
var LIBRARY = __webpack_require__(45);
var $typed = __webpack_require__(92);
var hide = __webpack_require__(22);
var redefineAll = __webpack_require__(59);
var fails = __webpack_require__(10);
var anInstance = __webpack_require__(57);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
var toIndex = __webpack_require__(199);
var gOPN = __webpack_require__(55).f;
var dP = __webpack_require__(15).f;
var arrayFill = __webpack_require__(135);
var setToStringTag = __webpack_require__(64);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  }return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function get() {
      return this[internal];
    } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) {
    store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
  }
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(926);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || this && this.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || this && this.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(211);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd52bc2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(939);
function injectStyle (ssrContext) {
  __webpack_require__(937)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd52bc2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.i18n = exports.use = exports.t = undefined;

var _zhCN = __webpack_require__(1205);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _deepmerge = __webpack_require__(1206);

var _deepmerge2 = _interopRequireDefault(_deepmerge);

var _format = __webpack_require__(1207);

var _format2 = _interopRequireDefault(_format);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var format = (0, _format2.default)(_vue2.default);
var lang = _zhCN2.default;
var merged = false;
var i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || _vue2.default).$t;
  if (typeof vuei18n === 'function' && !!_vue2.default.locale) {
    if (!merged) {
      merged = true;
      _vue2.default.locale(_vue2.default.config.lang, (0, _deepmerge2.default)(lang, _vue2.default.locale(_vue2.default.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = exports.t = function t(path, options) {
  var value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = exports.use = function use(l) {
  lang = l || lang;
};

var i18n = exports.i18n = function i18n(fn) {
  i18nHandler = fn || i18nHandler;
};

exports.default = { use: use, t: t, i18n: i18n };

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(145);

exports.default = {
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _locale.t.apply(this, args);
    }
  }
};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
  if (_vue2.default.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'el-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
};

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var scrollBarWidth = void 0;

;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 74);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/11:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(289);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(101);

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/74:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: [_vm.type === "textarea" ? "el-textarea" : "el-input", _vm.inputSize ? "el-input--" + _vm.inputSize : "", {
          "is-disabled": _vm.inputDisabled,
          "is-exceed": _vm.inputExceed,
          "el-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "el-input-group--append": _vm.$slots.append,
          "el-input-group--prepend": _vm.$slots.prepend,
          "el-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "el-input--suffix": _vm.$slots.suffix || _vm.suffixIcon || _vm.clearable || _vm.showPassword
        }],
        on: {
          mouseenter: function mouseenter($event) {
            _vm.hovering = true;
          },
          mouseleave: function mouseleave($event) {
            _vm.hovering = false;
          }
        }
      }, [_vm.type !== "textarea" ? [_vm.$slots.prepend ? _c("div", { staticClass: "el-input-group__prepend" }, [_vm._t("prepend")], 2) : _vm._e(), _vm.type !== "textarea" ? _c("input", _vm._b({
        ref: "input",
        staticClass: "el-input__inner",
        attrs: {
          tabindex: _vm.tabindex,
          type: _vm.showPassword ? _vm.passwordVisible ? "text" : "password" : _vm.type,
          disabled: _vm.inputDisabled,
          readonly: _vm.readonly,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          "aria-label": _vm.label
        },
        on: {
          compositionstart: _vm.handleCompositionStart,
          compositionupdate: _vm.handleCompositionUpdate,
          compositionend: _vm.handleCompositionEnd,
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          change: _vm.handleChange
        }
      }, "input", _vm.$attrs, false)) : _vm._e(), _vm.$slots.prefix || _vm.prefixIcon ? _c("span", { staticClass: "el-input__prefix" }, [_vm._t("prefix"), _vm.prefixIcon ? _c("i", {
        staticClass: "el-input__icon",
        class: _vm.prefixIcon
      }) : _vm._e()], 2) : _vm._e(), _vm.getSuffixVisible() ? _c("span", { staticClass: "el-input__suffix" }, [_c("span", { staticClass: "el-input__suffix-inner" }, [!_vm.showClear || !_vm.showPwdVisible || !_vm.isWordLimitVisible ? [_vm._t("suffix"), _vm.suffixIcon ? _c("i", {
        staticClass: "el-input__icon",
        class: _vm.suffixIcon
      }) : _vm._e()] : _vm._e(), _vm.showClear ? _c("i", {
        staticClass: "el-input__icon el-icon-circle-close el-input__clear",
        on: {
          mousedown: function mousedown($event) {
            $event.preventDefault();
          },
          click: _vm.clear
        }
      }) : _vm._e(), _vm.showPwdVisible ? _c("i", {
        staticClass: "el-input__icon el-icon-view el-input__clear",
        on: { click: _vm.handlePasswordVisible }
      }) : _vm._e(), _vm.isWordLimitVisible ? _c("span", { staticClass: "el-input__count" }, [_c("span", { staticClass: "el-input__count-inner" }, [_vm._v("\n            " + _vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit) + "\n          ")])]) : _vm._e()], 2), _vm.validateState ? _c("i", {
        staticClass: "el-input__icon",
        class: ["el-input__validateIcon", _vm.validateIcon]
      }) : _vm._e()]) : _vm._e(), _vm.$slots.append ? _c("div", { staticClass: "el-input-group__append" }, [_vm._t("append")], 2) : _vm._e()] : _c("textarea", _vm._b({
        ref: "textarea",
        staticClass: "el-textarea__inner",
        style: _vm.textareaStyle,
        attrs: {
          tabindex: _vm.tabindex,
          disabled: _vm.inputDisabled,
          readonly: _vm.readonly,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          "aria-label": _vm.label
        },
        on: {
          compositionstart: _vm.handleCompositionStart,
          compositionupdate: _vm.handleCompositionUpdate,
          compositionend: _vm.handleCompositionEnd,
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          change: _vm.handleChange
        }
      }, "textarea", _vm.$attrs, false)), _vm.isWordLimitVisible && _vm.type === "textarea" ? _c("span", { staticClass: "el-input__count" }, [_vm._v(_vm._s(_vm.textLength) + "/" + _vm._s(_vm.upperLimit))]) : _vm._e()], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
    var migrating_ = __webpack_require__(11);
    var migrating_default = /*#__PURE__*/__webpack_require__.n(migrating_);

    // CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
    var hiddenTextarea = void 0;

    var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

    var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

    function calculateNodeStyling(targetElement) {
      var style = window.getComputedStyle(targetElement);

      var boxSizing = style.getPropertyValue('box-sizing');

      var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

      var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

      var contextStyle = CONTEXT_STYLE.map(function (name) {
        return name + ':' + style.getPropertyValue(name);
      }).join(';');

      return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
    }

    function calcTextareaHeight(targetElement) {
      var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        document.body.appendChild(hiddenTextarea);
      }

      var _calculateNodeStyling = calculateNodeStyling(targetElement),
          paddingSize = _calculateNodeStyling.paddingSize,
          borderSize = _calculateNodeStyling.borderSize,
          boxSizing = _calculateNodeStyling.boxSizing,
          contextStyle = _calculateNodeStyling.contextStyle;

      hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
      hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

      var height = hiddenTextarea.scrollHeight;
      var result = {};

      if (boxSizing === 'border-box') {
        height = height + borderSize;
      } else if (boxSizing === 'content-box') {
        height = height - paddingSize;
      }

      hiddenTextarea.value = '';
      var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

      if (minRows !== null) {
        var minHeight = singleRowHeight * minRows;
        if (boxSizing === 'border-box') {
          minHeight = minHeight + paddingSize + borderSize;
        }
        height = Math.max(minHeight, height);
        result.minHeight = minHeight + 'px';
      }
      if (maxRows !== null) {
        var maxHeight = singleRowHeight * maxRows;
        if (boxSizing === 'border-box') {
          maxHeight = maxHeight + paddingSize + borderSize;
        }
        height = Math.min(maxHeight, height);
      }
      result.height = height + 'px';
      hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      hiddenTextarea = null;
      return result;
    };
    // EXTERNAL MODULE: external "element-ui/lib/utils/merge"
    var merge_ = __webpack_require__(9);
    var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var inputvue_type_script_lang_js_ = {
      name: 'ElInput',

      componentName: 'ElInput',

      mixins: [emitter_default.a, migrating_default.a],

      inheritAttrs: false,

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      data: function data() {
        return {
          textareaCalcStyle: {},
          hovering: false,
          focused: false,
          isComposing: false,
          passwordVisible: false
        };
      },

      props: {
        value: [String, Number],
        size: String,
        resize: String,
        form: String,
        disabled: Boolean,
        readonly: Boolean,
        type: {
          type: String,
          default: 'text'
        },
        autosize: {
          type: [Boolean, Object],
          default: false
        },
        autocomplete: {
          type: String,
          default: 'off'
        },
        /** @Deprecated in next major version */
        autoComplete: {
          type: String,
          validator: function validator(val) {
            false && false;
            return true;
          }
        },
        validateEvent: {
          type: Boolean,
          default: true
        },
        suffixIcon: String,
        prefixIcon: String,
        label: String,
        clearable: {
          type: Boolean,
          default: false
        },
        showPassword: {
          type: Boolean,
          default: false
        },
        showWordLimit: {
          type: Boolean,
          default: false
        },
        tabindex: String
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        validateState: function validateState() {
          return this.elFormItem ? this.elFormItem.validateState : '';
        },
        needStatusIcon: function needStatusIcon() {
          return this.elForm ? this.elForm.statusIcon : false;
        },
        validateIcon: function validateIcon() {
          return {
            validating: 'el-icon-loading',
            success: 'el-icon-circle-check',
            error: 'el-icon-circle-close'
          }[this.validateState];
        },
        textareaStyle: function textareaStyle() {
          return merge_default()({}, this.textareaCalcStyle, { resize: this.resize });
        },
        inputSize: function inputSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        inputDisabled: function inputDisabled() {
          return this.disabled || (this.elForm || {}).disabled;
        },
        nativeInputValue: function nativeInputValue() {
          return this.value === null || this.value === undefined ? '' : String(this.value);
        },
        showClear: function showClear() {
          return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
        },
        showPwdVisible: function showPwdVisible() {
          return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
        },
        isWordLimitVisible: function isWordLimitVisible() {
          return this.showWordLimit && this.$attrs.maxlength && (this.type === 'text' || this.type === 'textarea') && !this.inputDisabled && !this.readonly && !this.showPassword;
        },
        upperLimit: function upperLimit() {
          return this.$attrs.maxlength;
        },
        textLength: function textLength() {
          if (typeof this.value === 'number') {
            return String(this.value).length;
          }

          return (this.value || '').length;
        },
        inputExceed: function inputExceed() {
          // show exceed style if length of initial value greater then maxlength
          return this.isWordLimitVisible && this.textLength > this.upperLimit;
        }
      },

      watch: {
        value: function value(val) {
          this.$nextTick(this.resizeTextarea);
          if (this.validateEvent) {
            this.dispatch('ElFormItem', 'el.form.change', [val]);
          }
        },

        // native input value is set explicitly
        // do not use v-model / :value in template
        // see: https://github.com/ElemeFE/element/issues/14521
        nativeInputValue: function nativeInputValue() {
          this.setNativeInputValue();
        },

        // when change between <input> and <textarea>,
        // update DOM dependent value and styles
        // https://github.com/ElemeFE/element/issues/14857
        type: function type() {
          var _this = this;

          this.$nextTick(function () {
            _this.setNativeInputValue();
            _this.resizeTextarea();
            _this.updateIconOffset();
          });
        }
      },

      methods: {
        focus: function focus() {
          this.getInput().focus();
        },
        blur: function blur() {
          this.getInput().blur();
        },
        getMigratingConfig: function getMigratingConfig() {
          return {
            props: {
              'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
              'on-icon-click': 'on-icon-click is removed.'
            },
            events: {
              'click': 'click is removed.'
            }
          };
        },
        handleBlur: function handleBlur(event) {
          this.focused = false;
          this.$emit('blur', event);
          if (this.validateEvent) {
            this.dispatch('ElFormItem', 'el.form.blur', [this.value]);
          }
        },
        select: function select() {
          this.getInput().select();
        },
        resizeTextarea: function resizeTextarea() {
          if (this.$isServer) return;
          var autosize = this.autosize,
              type = this.type;

          if (type !== 'textarea') return;
          if (!autosize) {
            this.textareaCalcStyle = {
              minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
            };
            return;
          }
          var minRows = autosize.minRows;
          var maxRows = autosize.maxRows;

          this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
        },
        setNativeInputValue: function setNativeInputValue() {
          var input = this.getInput();
          if (!input) return;
          if (input.value === this.nativeInputValue) return;
          input.value = this.nativeInputValue;
        },
        handleFocus: function handleFocus(event) {
          this.focused = true;
          this.$emit('focus', event);
        },
        handleCompositionStart: function handleCompositionStart(event) {
          this.$emit('compositionstart', event);
          this.isComposing = true;
        },
        handleCompositionUpdate: function handleCompositionUpdate(event) {
          this.$emit('compositionupdate', event);
          var text = event.target.value;
          var lastCharacter = text[text.length - 1] || '';
          this.isComposing = !Object(shared_["isKorean"])(lastCharacter);
        },
        handleCompositionEnd: function handleCompositionEnd(event) {
          this.$emit('compositionend', event);
          if (this.isComposing) {
            this.isComposing = false;
            this.handleInput(event);
          }
        },
        handleInput: function handleInput(event) {
          // should not emit input during composition
          // see: https://github.com/ElemeFE/element/issues/10516
          if (this.isComposing) return;

          // hack for https://github.com/ElemeFE/element/issues/8548
          // should remove the following line when we don't support IE
          if (event.target.value === this.nativeInputValue) return;

          this.$emit('input', event.target.value);

          // ensure native input value is controlled
          // see: https://github.com/ElemeFE/element/issues/12850
          this.$nextTick(this.setNativeInputValue);
        },
        handleChange: function handleChange(event) {
          this.$emit('change', event.target.value);
        },
        calcIconOffset: function calcIconOffset(place) {
          var elList = [].slice.call(this.$el.querySelectorAll('.el-input__' + place) || []);
          if (!elList.length) return;
          var el = null;
          for (var i = 0; i < elList.length; i++) {
            if (elList[i].parentNode === this.$el) {
              el = elList[i];
              break;
            }
          }
          if (!el) return;
          var pendantMap = {
            suffix: 'append',
            prefix: 'prepend'
          };

          var pendant = pendantMap[place];
          if (this.$slots[pendant]) {
            el.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$el.querySelector('.el-input-group__' + pendant).offsetWidth + 'px)';
          } else {
            el.removeAttribute('style');
          }
        },
        updateIconOffset: function updateIconOffset() {
          this.calcIconOffset('prefix');
          this.calcIconOffset('suffix');
        },
        clear: function clear() {
          this.$emit('input', '');
          this.$emit('change', '');
          this.$emit('clear');
        },
        handlePasswordVisible: function handlePasswordVisible() {
          var _this2 = this;

          this.passwordVisible = !this.passwordVisible;
          this.$nextTick(function () {
            _this2.focus();
          });
        },
        getInput: function getInput() {
          return this.$refs.input || this.$refs.textarea;
        },
        getSuffixVisible: function getSuffixVisible() {
          return this.$slots.suffix || this.suffixIcon || this.showClear || this.showPassword || this.isWordLimitVisible || this.validateState && this.needStatusIcon;
        }
      },

      created: function created() {
        this.$on('inputSelect', this.select);
      },
      mounted: function mounted() {
        this.setNativeInputValue();
        this.resizeTextarea();
        this.updateIconOffset();
      },
      updated: function updated() {
        this.$nextTick(this.updateIconOffset);
      }
    };
    // CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
    /* harmony default export */var src_inputvue_type_script_lang_js_ = inputvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/input/src/input.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_inputvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/input/src/input.vue";
    /* harmony default export */var input = component.exports;
    // CONCATENATED MODULE: ./packages/input/index.js


    /* istanbul ignore next */
    input.install = function (Vue) {
      Vue.component(input.name, input);
    };

    /* harmony default export */var packages_input = __webpack_exports__["default"] = input;

    /***/
  },

  /***/9:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(100);

    /***/
  }

  /******/ });

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.removeResizeListener = exports.addResizeListener = undefined;

var _resizeObserverPolyfill = __webpack_require__(1211);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _throttleDebounce = __webpack_require__(292);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var resizeHandler = function resizeHandler(entries) {
  for (var _iterator = entries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var entry = _ref;

    var listeners = entry.target.__resizeListeners__ || [];
    if (listeners.length) {
      listeners.forEach(function (fn) {
        fn();
      });
    }
  }
};

/* istanbul ignore next */
var addResizeListener = exports.addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new _resizeObserverPolyfill2.default((0, _throttleDebounce.debounce)(16, resizeHandler));
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn);
};

/* istanbul ignore next */
var removeResizeListener = exports.removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};

/***/ }),
/* 150 */
/***/ (function(module, exports) {

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
module.exports = function (delay, noTrailing, callback, debounceMode) {

	// After wrapper has stopped being called, this timeout ensures that
	// `callback` is executed at the proper times in `throttle` and `end`
	// debounce modes.
	var timeoutID;

	// Keep track of the last time `callback` was executed.
	var lastExec = 0;

	// `noTrailing` defaults to falsy.
	if (typeof noTrailing !== 'boolean') {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	// The `wrapper` function encapsulates all of the throttling / debouncing
	// functionality and when executed will limit the rate at which `callback`
	// is executed.
	function wrapper() {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		// Execute `callback` and update the `lastExec` timestamp.
		function exec() {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		// If `debounceMode` is true (at begin) this is used to clear the flag
		// to allow future `callback` executions.
		function clear() {
			timeoutID = undefined;
		}

		if (debounceMode && !timeoutID) {
			// Since `wrapper` is being called for the first time and
			// `debounceMode` is true (at begin), execute `callback`.
			exec();
		}

		// Clear any existing timeout.
		if (timeoutID) {
			clearTimeout(timeoutID);
		}

		if (debounceMode === undefined && elapsed > delay) {
			// In throttle mode, if `delay` time has been exceeded, execute
			// `callback`.
			exec();
		} else if (noTrailing !== true) {
			// In trailing throttle mode, since `delay` time has not been
			// exceeded, schedule `callback` to execute `delay` ms after most
			// recent execution.
			//
			// If `debounceMode` is true (at begin), schedule `clear` to execute
			// after `delay` ms.
			//
			// If `debounceMode` is false (at end), schedule `callback` to
			// execute after `delay` ms.
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}
	}

	// Return the wrapper function.
	return wrapper;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 131);
  /******/
}(
/************************************************************************/
/******/{

  /***/131:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
    var resize_event_ = __webpack_require__(16);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
    var scrollbar_width_ = __webpack_require__(38);
    var scrollbar_width_default = /*#__PURE__*/__webpack_require__.n(scrollbar_width_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // CONCATENATED MODULE: ./packages/scrollbar/src/util.js
    var BAR_MAP = {
      vertical: {
        offset: 'offsetHeight',
        scroll: 'scrollTop',
        scrollSize: 'scrollHeight',
        size: 'height',
        key: 'vertical',
        axis: 'Y',
        client: 'clientY',
        direction: 'top'
      },
      horizontal: {
        offset: 'offsetWidth',
        scroll: 'scrollLeft',
        scrollSize: 'scrollWidth',
        size: 'width',
        key: 'horizontal',
        axis: 'X',
        client: 'clientX',
        direction: 'left'
      }
    };

    function renderThumbStyle(_ref) {
      var move = _ref.move,
          size = _ref.size,
          bar = _ref.bar;

      var style = {};
      var translate = 'translate' + bar.axis + '(' + move + '%)';

      style[bar.size] = size;
      style.transform = translate;
      style.msTransform = translate;
      style.webkitTransform = translate;

      return style;
    };
    // CONCATENATED MODULE: ./packages/scrollbar/src/bar.js


    /* istanbul ignore next */
    /* harmony default export */var src_bar = {
      name: 'Bar',

      props: {
        vertical: Boolean,
        size: String,
        move: Number
      },

      computed: {
        bar: function bar() {
          return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
        },
        wrap: function wrap() {
          return this.$parent.wrap;
        }
      },

      render: function render(h) {
        var size = this.size,
            move = this.move,
            bar = this.bar;

        return h('div', {
          'class': ['el-scrollbar__bar', 'is-' + bar.key],
          on: {
            'mousedown': this.clickTrackHandler
          }
        }, [h('div', {
          ref: 'thumb',
          'class': 'el-scrollbar__thumb',
          on: {
            'mousedown': this.clickThumbHandler
          },

          style: renderThumbStyle({ size: size, move: move, bar: bar }) })]);
      },

      methods: {
        clickThumbHandler: function clickThumbHandler(e) {
          // prevent click event of right button
          if (e.ctrlKey || e.button === 2) {
            return;
          }
          this.startDrag(e);
          this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
        },
        clickTrackHandler: function clickTrackHandler(e) {
          var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
          var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
          var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

          this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
        },
        startDrag: function startDrag(e) {
          e.stopImmediatePropagation();
          this.cursorDown = true;

          Object(dom_["on"])(document, 'mousemove', this.mouseMoveDocumentHandler);
          Object(dom_["on"])(document, 'mouseup', this.mouseUpDocumentHandler);
          document.onselectstart = function () {
            return false;
          };
        },
        mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
          if (this.cursorDown === false) return;
          var prevPage = this[this.bar.axis];

          if (!prevPage) return;

          var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
          var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
          var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

          this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
        },
        mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
          this.cursorDown = false;
          this[this.bar.axis] = 0;
          Object(dom_["off"])(document, 'mousemove', this.mouseMoveDocumentHandler);
          document.onselectstart = null;
        }
      },

      destroyed: function destroyed() {
        Object(dom_["off"])(document, 'mouseup', this.mouseUpDocumentHandler);
      }
    };
    // CONCATENATED MODULE: ./packages/scrollbar/src/main.js
    // reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js


    /* istanbul ignore next */
    /* harmony default export */var main = {
      name: 'ElScrollbar',

      components: { Bar: src_bar },

      props: {
        native: Boolean,
        wrapStyle: {},
        wrapClass: {},
        viewClass: {},
        viewStyle: {},
        noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
        tag: {
          type: String,
          default: 'div'
        }
      },

      data: function data() {
        return {
          sizeWidth: '0',
          sizeHeight: '0',
          moveX: 0,
          moveY: 0
        };
      },

      computed: {
        wrap: function wrap() {
          return this.$refs.wrap;
        }
      },

      render: function render(h) {
        var gutter = scrollbar_width_default()();
        var style = this.wrapStyle;

        if (gutter) {
          var gutterWith = '-' + gutter + 'px';
          var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

          if (Array.isArray(this.wrapStyle)) {
            style = Object(util_["toObject"])(this.wrapStyle);
            style.marginRight = style.marginBottom = gutterWith;
          } else if (typeof this.wrapStyle === 'string') {
            style += gutterStyle;
          } else {
            style = gutterStyle;
          }
        }
        var view = h(this.tag, {
          class: ['el-scrollbar__view', this.viewClass],
          style: this.viewStyle,
          ref: 'resize'
        }, this.$slots.default);
        var wrap = h('div', {
          ref: 'wrap',
          style: style,
          on: {
            'scroll': this.handleScroll
          },

          'class': [this.wrapClass, 'el-scrollbar__wrap', gutter ? '' : 'el-scrollbar__wrap--hidden-default'] }, [[view]]);
        var nodes = void 0;

        if (!this.native) {
          nodes = [wrap, h(src_bar, {
            attrs: {
              move: this.moveX,
              size: this.sizeWidth }
          }), h(src_bar, {
            attrs: {
              vertical: true,
              move: this.moveY,
              size: this.sizeHeight }
          })];
        } else {
          nodes = [h('div', {
            ref: 'wrap',
            'class': [this.wrapClass, 'el-scrollbar__wrap'],
            style: style }, [[view]])];
        }
        return h('div', { class: 'el-scrollbar' }, nodes);
      },

      methods: {
        handleScroll: function handleScroll() {
          var wrap = this.wrap;

          this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
          this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;
        },
        update: function update() {
          var heightPercentage = void 0,
              widthPercentage = void 0;
          var wrap = this.wrap;
          if (!wrap) return;

          heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
          widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

          this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
          this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
        }
      },

      mounted: function mounted() {
        if (this.native) return;
        this.$nextTick(this.update);
        !this.noresize && Object(resize_event_["addResizeListener"])(this.$refs.resize, this.update);
      },
      beforeDestroy: function beforeDestroy() {
        if (this.native) return;
        !this.noresize && Object(resize_event_["removeResizeListener"])(this.$refs.resize, this.update);
      }
    };
    // CONCATENATED MODULE: ./packages/scrollbar/index.js


    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.component(main.name, main);
    };

    /* harmony default export */var scrollbar = __webpack_exports__["default"] = main;

    /***/
  },

  /***/16:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(149);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(43);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/38:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(147);

    /***/
  }

  /******/ });

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (ref) {
  return {
    methods: {
      focus: function focus() {
        this.$refs[ref].focus();
      }
    }
  };
};

;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = scrollIntoView;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollIntoView(container, selected) {
  if (_vue2.default.prototype.$isServer) return;

  if (!selected) {
    container.scrollTop = 0;
    return;
  }

  var offsetParents = [];
  var pointer = selected.offsetParent;
  while (pointer && container !== pointer && container.contains(pointer)) {
    offsetParents.push(pointer);
    pointer = pointer.offsetParent;
  }
  var top = selected.offsetTop + offsetParents.reduce(function (prev, curr) {
    return prev + curr.offsetTop;
  }, 0);
  var bottom = top + selected.offsetHeight;
  var viewRectTop = container.scrollTop;
  var viewRectBottom = viewRectTop + container.clientHeight;

  if (top < viewRectTop) {
    container.scrollTop = top;
  } else if (bottom > viewRectBottom) {
    container.scrollTop = bottom - container.clientHeight;
  }
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var aria = aria || {};

aria.Utils = aria.Utils || {};

/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */
aria.Utils.focusFirstDescendant = function (element) {
  for (var i = 0; i < element.childNodes.length; i++) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusFirstDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */

aria.Utils.focusLastDescendant = function (element) {
  for (var i = element.childNodes.length - 1; i >= 0; i--) {
    var child = element.childNodes[i];
    if (aria.Utils.attemptFocus(child) || aria.Utils.focusLastDescendant(child)) {
      return true;
    }
  }
  return false;
};

/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */
aria.Utils.attemptFocus = function (element) {
  if (!aria.Utils.isFocusable(element)) {
    return false;
  }
  aria.Utils.IgnoreUtilFocusChanges = true;
  try {
    element.focus();
  } catch (e) {}
  aria.Utils.IgnoreUtilFocusChanges = false;
  return document.activeElement === element;
};

aria.Utils.isFocusable = function (element) {
  if (element.tabIndex > 0 || element.tabIndex === 0 && element.getAttribute('tabIndex') !== null) {
    return true;
  }

  if (element.disabled) {
    return false;
  }

  switch (element.nodeName) {
    case 'A':
      return !!element.href && element.rel !== 'ignore';
    case 'INPUT':
      return element.type !== 'hidden' && element.type !== 'file';
    case 'BUTTON':
    case 'SELECT':
    case 'TEXTAREA':
      return true;
    default:
      return false;
  }
};

/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */
aria.Utils.triggerEvent = function (elm, name) {
  var eventName = void 0;

  if (/^mouse|click/.test(name)) {
    eventName = 'MouseEvents';
  } else if (/^key/.test(name)) {
    eventName = 'KeyboardEvent';
  } else {
    eventName = 'HTMLEvents';
  }
  var evt = document.createEvent(eventName);

  for (var _len = arguments.length, opts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    opts[_key - 2] = arguments[_key];
  }

  evt.initEvent.apply(evt, [name].concat(opts));
  elm.dispatchEvent ? elm.dispatchEvent(evt) : elm.fireEvent('on' + name, evt);

  return elm;
};

aria.Utils.keys = {
  tab: 9,
  enter: 13,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  esc: 27
};

exports.default = aria.Utils;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(48);
var core = __webpack_require__(78);
var ctx = __webpack_require__(1231);
var hide = __webpack_require__(69);
var has = __webpack_require__(63);
var PROTOTYPE = 'prototype';

var $export = function $export(type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function F(a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(79);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(160)('keys');
var uid = __webpack_require__(107);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(78);
var global = __webpack_require__(48);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(106) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 162 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(157);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(70).f;
var has = __webpack_require__(63);
var TAG = __webpack_require__(72)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(72);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(48);
var core = __webpack_require__(78);
var LIBRARY = __webpack_require__(106);
var wksExt = __webpack_require__(166);
var defineProperty = __webpack_require__(70).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export createApp */
/* unused harmony export createRef */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Plugin; });
/* unused harmony export defineAsyncComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defineComponent; });
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createElement; });
/* unused harmony export inject */
/* unused harmony export isRaw */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export markRaw */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* unused harmony export onMounted */
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* unused harmony export ref */
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCSSModule */
/* unused harmony export useCssModule */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export warn */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destroy on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(18);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

var SKIPFLAG = '__v_skip';
function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return val;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (!isForceTrigger() && val === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob[SKIPFLAG] = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_a = observed === null || observed === void 0 ? void 0 : observed.__ob__) === null || _a === void 0 ? void 0 : _a.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue)
            ? defaultValue()
            : defaultValue;
    }
    else if ((false)) {
        warn("Injection \"".concat(String(key), "\" not found."), vm);
    }
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var provide = {};
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        provide: function (key, value) {
            provide[key] = value;
            return this;
        },
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign(__assign({ propsData: rootProps }, rootComponent), { provide: __assign(__assign({}, provide), rootComponent.provide) }));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (this === null || this === void 0 ? void 0 : this.proxy) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode) {
            if (vnode.context)
                updateTemplateRef(vnode.context);
            if (vnode.children) {
                for (var i = 0; i < vnode.children.length; ++i) {
                    stack.push(vnode.children[i]);
                }
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.7.0";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755dc49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1158);
function injectStyle (ssrContext) {
  __webpack_require__(1089)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755dc49_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed52303_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1072);
function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ed52303_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(14) && !__webpack_require__(10)(function () {
  return Object.defineProperty(__webpack_require__(116)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(12);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(25);
var toIObject = __webpack_require__(26);
var arrayIndexOf = __webpack_require__(82)(false);
var IE_PROTO = __webpack_require__(118)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15);
var anObject = __webpack_require__(8);
var getKeys = __webpack_require__(52);

module.exports = __webpack_require__(14) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(26);
var gOPN = __webpack_require__(55).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(52);
var gOPS = __webpack_require__(83);
var pIE = __webpack_require__(75);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(74);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(10)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var aFunction = __webpack_require__(19);
var isObject = __webpack_require__(11);
var invoke = __webpack_require__(179);
var arraySlice = [].slice;
var factories = {};

var construct = function construct(F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) {
      n[i] = 'a[' + i + ']';
    } // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  }return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function bound() /* args... */{
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
                  var un = that === undefined;
                  switch (args.length) {
                                    case 0:
                                                      return un ? fn() : fn.call(that);
                                    case 1:
                                                      return un ? fn(args[0]) : fn.call(that, args[0]);
                                    case 2:
                                                      return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
                                    case 3:
                                                      return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
                                    case 4:
                                                      return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
                  }return fn.apply(that, args);
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(9).parseInt;
var $trim = __webpack_require__(66).trim;
var ws = __webpack_require__(122);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
} : $parseInt;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(9).parseFloat;
var $trim = __webpack_require__(66).trim;

module.exports = 1 / $parseFloat(__webpack_require__(122) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(31);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(11);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(125);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function roundTiesToEven(n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(8);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(16);
var IObject = __webpack_require__(74);
var toLength = __webpack_require__(13);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (; isRight ? index >= 0 : length > index; index += i) {
    if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
  }return memo;
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)


var toObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(53);
var toLength = __webpack_require__(13);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];else delete O[to];
    to += inc;
    from += inc;
  }return O;
};

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpExec = __webpack_require__(137);
__webpack_require__(1)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(14) && /./g.flags != 'g') __webpack_require__(15).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(76)
});

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(8);
var isObject = __webpack_require__(11);
var newPromiseCapability = __webpack_require__(141);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(195);
var validate = __webpack_require__(60);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(91)(MAP, function (get) {
  return function Map() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dP = __webpack_require__(15).f;
var create = __webpack_require__(54);
var redefineAll = __webpack_require__(59);
var ctx = __webpack_require__(30);
var anInstance = __webpack_require__(57);
var forOf = __webpack_require__(58);
var $iterDefine = __webpack_require__(127);
var step = __webpack_require__(189);
var setSpecies = __webpack_require__(56);
var DESCRIPTORS = __webpack_require__(14);
var fastKey = __webpack_require__(46).fastKey;
var validate = __webpack_require__(60);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function getEntry(that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = create(null); // index
      that._f = undefined; // first entry
      that._l = undefined; // last entry
      that[SIZE] = 0; // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function _delete(key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        }return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) {
            entry = entry.p;
          }
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function get() {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
      // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key, // <- key
        v: value, // <- value
        p: prev = that._l, // <- previous entry
        n: undefined, // <- next entry
        r: false // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    }return that;
  },
  getEntry: getEntry,
  setStrong: function setStrong(C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind; // kind
      this._l = undefined; // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) {
        entry = entry.p;
      } // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strong = __webpack_require__(195);
var validate = __webpack_require__(60);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(91)(SET, function (get) {
  return function Set() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(9);
var each = __webpack_require__(37)(0);
var redefine = __webpack_require__(23);
var meta = __webpack_require__(46);
var assign = __webpack_require__(176);
var weak = __webpack_require__(198);
var isObject = __webpack_require__(11);
var validate = __webpack_require__(60);
var NATIVE_WEAK_MAP = __webpack_require__(60);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function wrapper(get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(91)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
        // store all the rest on native weakmap
      }return method.call(this, a, b);
    });
  });
}

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var redefineAll = __webpack_require__(59);
var getWeak = __webpack_require__(46).getWeak;
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(11);
var anInstance = __webpack_require__(57);
var forOf = __webpack_require__(58);
var createArrayMethod = __webpack_require__(37);
var $has = __webpack_require__(25);
var validate = __webpack_require__(60);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function UncaughtFrozenStore() {
  this.a = [];
};
var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function get(key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function has(key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function set(key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;else this.a.push([key, value]);
  },
  'delete': function _delete(key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME; // collection type
      that._i = id++; // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function _delete(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function def(that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(55);
var gOPS = __webpack_require__(83);
var anObject = __webpack_require__(8);
var Reflect = __webpack_require__(9).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

var isArray = __webpack_require__(84);
var isObject = __webpack_require__(11);
var toLength = __webpack_require__(13);
var ctx = __webpack_require__(30);
var IS_CONCAT_SPREADABLE = __webpack_require__(12)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(13);
var repeat = __webpack_require__(124);
var defined = __webpack_require__(35);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(14);
var getKeys = __webpack_require__(52);
var toIObject = __webpack_require__(26);
var isEnum = __webpack_require__(75).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(65);
var from = __webpack_require__(205);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(58);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (arguments.length === 0
  // eslint-disable-next-line no-self-compare
  || x != x
  // eslint-disable-next-line no-self-compare
  || inLow != inLow
  // eslint-disable-next-line no-self-compare
  || inHigh != inHigh
  // eslint-disable-next-line no-self-compare
  || outLow != outLow
  // eslint-disable-next-line no-self-compare
  || outHigh != outHigh) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

/***/ }),
/* 207 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import { ipcRenderer  } from "electron";



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { Header: __WEBPACK_IMPORTED_MODULE_0__components_Header_vue__["a" /* default */] },
  data: function data() {
    return {};
  },

  computed: {
    getCurrentHostName: function getCurrentHostName() {
      return window.location.hostname;
    },
    isCustomDomainMatching: function isCustomDomainMatching() {
      if (this.getCurrentHostName.includes(this.$store.getters.getCustomDomainName)) {
        return true;
      }
      return false;
    },
    isAuthActive: function isAuthActive() {
      return this.$store.getters.isAuthenticated;
    },
    getWindowObject: function getWindowObject() {
      return this.win;
    },
    getAccessToken: function getAccessToken() {
      return localStorage.getItem('accessToken');
    },
    getExistingDeviceToken: function getExistingDeviceToken() {
      return localStorage.getItem("device_token");
    },
    isMobileDevice: function isMobileDevice() {
      return __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__["isMobile"];
    }
  },
  methods: {
    setDefaultProperties: function setDefaultProperties() {

      var deviceToken = '';
      if (this.$route.query.redirect) {
        deviceToken = this.$route.query.redirect.replace('/?device_token=', '');
      } else if (this.$route.query.device_token) {
        deviceToken = this.$route.query.device_token;
      }

      if (deviceToken.length > 5) {
        this.$store.commit('setDeviceToken', deviceToken);
      } else if (this.isMobileDevice) {
        //alert(JSON.stringify(this.$route.query)+'Failed to recognise the device, this may result in abrupt printing service')
      }

      if (this.getAccessToken !== null && this.getAccessToken.length > 0) {
        this.$store.dispatch('checkAccessToken', { navigate: false, device_token: deviceToken });
      } else {
        this.$store.dispatch('loadCountryList');
        this.$store.dispatch('loadShipmentPartner');
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.setDefaultProperties();
    }, 2000);
    window.scroll(0, 0);
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__ = __webpack_require__(934);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { MainMenu: __WEBPACK_IMPORTED_MODULE_0__MainMenu_vue__["a" /* default */] },
  computed: {
    isBookmarked: function isBookmarked() {
      var _this = this;

      return this.$store.getters.getBookmarkList.findIndex(function (t) {
        return t.page_id === _this.$store.getters.getAccessRights.id;
      }) >= 0;
    },
    isOnlyOrderProgressWindow: function isOnlyOrderProgressWindow() {
      var menuList = this.$store.getters.getAccessibleMenu;

      var status = false;

      if (menuList.length === 1) {
        menuList.forEach(function (element) {
          element.sub_menu.forEach(function (element1) {
            if (element1.menu_name.includes('Order Progress')) {
              status = true;
            }
          });
        });
      }
      return status;
    }
  },
  methods: {
    logout: function logout() {
      var _this2 = this;

      this.$confirm('Are you sure to logout?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this2.$store.dispatch('logout');
      }).catch(function () {});
    },
    initiateCopy: function initiateCopy() {
      this.$store.dispatch('copyInformation', this.$store.getters.getMachineId);
    },
    openHelpSite: function openHelpSite() {
      window.open('https://reachus.easytailorapp.com');
    },
    goToHome: function goToHome() {
      this.$store.state.master.breadcrumbs = [{ icon: 'el-icon-s-home', target: '/' }];
      this.$router.push('/');
    },
    saveBookmark: function saveBookmark() {
      this.$store.dispatch('saveBookmark', { page_id: this.$store.getters.getAccessRights.id });
    },
    toggleFullScreen: function toggleFullScreen() {
      var elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    }
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_AccountExpired_Index_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_StockCheck_Index_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mobile_device_detect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Tasks_TaskForm_vue__ = __webpack_require__(112);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isOnlyOrderProgressWindow'],
  components: { AccountExpired: __WEBPACK_IMPORTED_MODULE_0__views_AccountExpired_Index_vue__["default"], StockCheck: __WEBPACK_IMPORTED_MODULE_1__views_StockCheck_Index_vue__["a" /* default */], TaskForm: __WEBPACK_IMPORTED_MODULE_3__views_Tasks_TaskForm_vue__["a" /* default */] },
  data: function data() {
    return {
      activeIndex: '1',
      show_calendar: false,
      production_calendar: false,
      show_renew: true,
      show_menu: false,
      show_stock_search: false,
      current_path: '/'
    };
  },

  computed: {
    isProductionOnly: function isProductionOnly() {
      return this.$store.getters.getUserInformation.is_production_member && !this.$store.getters.getUserInformation.is_a_production_supervisor && !this.$store.getters.getUserInformation.is_qc_manager;
    },
    getTopLogo: function getTopLogo() {
      var retailLogo = '';
      this.$store.getters.getAccessibleStoreList.forEach(function (element) {
        if (element.retail) {
          if (retailLogo === null) {
            retailLogo = element.brand_logo;
          } else if (retailLogo.length === 0) {
            retailLogo = element.brand_logo;
          }
        }
      });
      if (retailLogo.length === 0) {
        retailLogo = 'https://etacdn.b-cdn.net/eta-small.png';
      }
      localStorage.setItem('default_logo', retailLogo);
      return retailLogo;
    },
    getCurrentHostName: function getCurrentHostName() {
      return window.location.hostname;
    },
    isHomeDomain: function isHomeDomain() {
      return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost');
    },
    getDaysLeft: function getDaysLeft() {
      return this.$store.state.master.days_left;
    },
    isMobileDevice: function isMobileDevice() {
      return __WEBPACK_IMPORTED_MODULE_2_mobile_device_detect__["isMobile"];
    },
    isMobileDeviceOnly: function isMobileDeviceOnly() {
      return __WEBPACK_IMPORTED_MODULE_2_mobile_device_detect__["isMobileOnly"];
    },
    getCurrentRoute: function getCurrentRoute() {
      return this.current_path;
    },
    isProductionCalendar: function isProductionCalendar() {
      return this.production_calendar;
    }
  },
  methods: {
    newTask: function newTask() {
      this.$store.commit('resetTaskData');
      this.$store.commit('resetTaskGroupData');
      this.$store.state.tasks.show_task_form = true;
    },
    displayMenu: function displayMenu() {
      if (this.isMobileDevice) {
        this.show_menu = !this.show_menu;
      } else {
        this.show_menu = true;
      }
    },
    handleSelect: function handleSelect(key) {
      this.handleRouteChange(key);
    },
    handleRouteChange: function handleRouteChange(routePath) {
      this.current_path = routePath;
      this.displayMenu();
      var breadcrumbs = [];
      if (routePath == "homepage") {
        breadcrumbs.push({
          crumbName: 'Dashboard'
        });
        this.$store.commit('appendBreadcrumbs', breadcrumbs);
        this.$router.replace('/');
        this.$store.commit('setAccessRights', { id: 0 });
      } else if (routePath == '/logout') {
        this.displayMenu();
        this.logout();
      } else if (routePath == '/changepassword') {
        this.displayMenu();
        breadcrumbs.push({
          crumbName: 'Change Password'
        });
        this.$store.commit('appendBreadcrumbs', breadcrumbs);
        this.$router.replace('/changepassword');
      } else if (routePath == '/tasks') {
        this.displayMenu();
        breadcrumbs.push({
          crumbName: 'Tasks'
        });
        this.$store.commit('appendBreadcrumbs', breadcrumbs);
        this.$router.replace('/tasks');
      } else if (routePath == 'reachus') {} else if (routePath == 'salesCalendar') {
        this.show_calendar = true;
        this.production_calendar = false;
      } else if (routePath == 'productionCalendar') {
        this.show_calendar = true;
        this.production_calendar = true;
      } else if (routePath == 'stocksearch') {
        this.displayMenu();
        this.show_stock_search = true;
      } else if (routePath == 'addtask') {
        this.displayMenu();
        this.newTask();
      } else {
        var routeIndex = this.$store.getters.getAllMenus.findIndex(function (t) {
          return t.route_path == routePath;
        });
        var canMoveForward = false;
        if (routeIndex >= 0) {
          var routeAccessInfo = this.$store.getters.getAllMenus[routeIndex];
          if (routeAccessInfo.can_view) {
            canMoveForward = true;
          }
          this.$store.commit('setAccessRights', routeAccessInfo);
        }
        if (canMoveForward) {
          breadcrumbs.push({
            crumbName: this.$store.getters.getAllMenus[routeIndex].menu_name
          });
          this.$store.commit('appendBreadcrumbs', breadcrumbs);
          this.$router.replace(routePath);
        } else {
          this.$store.commit('displayMessageAlert', { message: 'Access Denied', type: 'Error' });
        }
      }
    },
    logout: function logout() {
      var _this = this;

      this.$confirm('Are you sure to logout?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.$store.dispatch('logout');
      }).catch(function () {});
    },
    loadPageAccess: function loadPageAccess() {
      var routePath = this.$router.currentRoute.path;
      var routeIndex = this.$store.getters.getAllMenus.findIndex(function (t) {
        return t.route_path == routePath;
      });
      var canMoveForward = false;
      if (routeIndex >= 0) {
        var routeAccessInfo = this.$store.getters.getAllMenus[routeIndex];
        if (routeAccessInfo.can_view) {
          canMoveForward = true;
        }
        this.$store.commit('setAccessRights', routeAccessInfo);
      }
      if (canMoveForward) {
        var breadcrumbs = [{
          crumbName: this.$store.getters.getAllMenus[routeIndex].menu_name
        }];
        this.$store.commit('appendBreadcrumbs', breadcrumbs);
      } else {
        //this.$store.commit('displayMessageAlert', {message: 'Access Denied', type: 'Error'})    
        this.$router.replace('/');
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.dispatch('fetchPreferences');
    this.$store.state.tasks.show_task_form = false;
    this.$store.dispatch('fetchTaskCategoryList');
    this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });

    setTimeout(function () {
      if (_this2.isMobileDevice) {
        _this2.show_menu = false;
      } else {
        _this2.show_menu = true;
      }

      _this2.loadPageAccess();
    }, 1000);
  }
});

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['days_left']
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryMaster_Form_Statement_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InventoryMaster_Form_Index_vue__ = __webpack_require__(81);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { InventoryStatement: __WEBPACK_IMPORTED_MODULE_0__InventoryMaster_Form_Statement_vue__["a" /* default */], InventoryMaster: __WEBPACK_IMPORTED_MODULE_1__InventoryMaster_Form_Index_vue__["default"] },
    data: function data() {
        return {
            search_text: '',
            show_qr_window: false,
            show_statement: false,
            store_id: 0,
            item_id: 0,
            search_type: 1,
            showInventoryMaster: false
        };
    },

    computed: {
        getStoreId: function getStoreId() {
            return this.store_id;
        },
        getItemId: function getItemId() {
            return this.item_id;
        },
        getSalesPrice: function getSalesPrice() {
            if (this.$store.getters.getInventoryMasterAutocompleteList.length > 0) {}
            return 0;
        }
    },
    methods: {
        openInventoryWindow: function openInventoryWindow() {
            if (this.checkIfModuleAccessAvailable('/inventoryproducts', 'can_edit')) {
                this.$store.commit('resetInventoryMasterData');
                this.showInventoryMaster = true;
                this.$store.dispatch('fetchInventoryMasterData', { id: this.getItemId, copy: false, navigate: false });
            }
        },
        searchSKUCode: function searchSKUCode(query, cb) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.search_type === 1)) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 3;
                                return _this.$store.dispatch('fetchInventoryMasterAutocompleteList', { query: query, show_all_item: true, search_column: ['sku_code'], store_id: _this.$store.getters.getAccessibleStoreList[0].id });

                            case 3:

                                setTimeout(function () {
                                    var list = [];
                                    _this.$store.getters.getInventoryMasterAutocompleteList.forEach(function (element) {

                                        var salePrice = '';
                                        if (element.fabric_price_category_id > 0 && _this.$store.getters.getFabricPriceSlabList.filter(function (t) {
                                            return t.id == element.fabric_price_category_id;
                                        }).length > 0) {
                                            salePrice = _this.$store.getters.getFabricPriceSlabList.filter(function (t) {
                                                return t.id == element.fabric_price_category_id;
                                            })[0].price_category_name;
                                        } else {
                                            salePrice = _this.formatCurrency(element.sale_price);
                                        }

                                        element.value = element.sku_code + ', ' + element.article_name + ', ' + salePrice;
                                        list.push(element);
                                    });
                                    cb(list);
                                }, 2000);
                                _context.next = 10;
                                break;

                            case 6:
                                if (!(_this.search_type === 0)) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 9;
                                return _this.$store.dispatch('fetchCustomerMasterAutocompleteList', { query: query, customer_code: _this.getLocalCustomerCode });

                            case 9:
                                setTimeout(function () {
                                    var list = [];
                                    _this.$store.getters.getCustomerMasterAutocompleteList.forEach(function (element) {
                                        element.value = element.customer_name;

                                        list.push(element);
                                    });
                                    cb(list);
                                }, 2000);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        loadSearchedItem: function loadSearchedItem($event) {

            if (this.search_type === 1) {
                this.$store.state.inventoryMaster.props.id = $event.id;
                this.item_id = $event.id;
                this.$store.dispatch('fetchSingleItemStock', { item_code: $event.id, unit_name: $event.unit_name, store_list: this.$store.getters.getAccessibleStoreList });
            } else if (this.search_type === 0) {

                this.$router.push('/salesappointments/?customer_id=' + $event.id);
                this.$emit('closed');
            }
        },
        openQRScanner: function openQRScanner() {
            this.show_qr_window = true;
        },
        onDecode: function onDecode($event) {
            this.search_text = $event;
            this.searchSKUCode($event);
            this.show_qr_window = false;
            this.changeFocus('inventory_item_id');
        },
        showStatement: function showStatement($event) {
            this.$store.state.inventoryMaster.statement.store_id = $event;

            var currentDate = "";

            var date = new Date();

            var currentMonth = date.getUTCMonth() + 1;
            if (currentMonth < 10) {
                currentMonth = "0" + currentMonth;
            }
            var currentDay = date.getUTCDate();
            if (currentDay < 10) {
                currentDay = "0" + currentDay;
            }
            var currentYear = date.getUTCFullYear();

            currentDate = currentYear + '-' + currentMonth + '-' + currentDay;

            this.$store.state.inventoryMaster.statement.date_range = ['2017-04-01', currentDate];
            this.show_statement = true;
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$store.state.inventoryMaster.stock_list = [];

        setTimeout(function () {
            if (_this2.checkIfModuleAccessAvailable('/salesappointments', 'can_view')) {
                _this2.search_type = 0;
            }

            if (_this2.checkIfModuleAccessAvailable('/inventoryproducts', 'can_view')) {
                _this2.search_type = 1;
            }
        }, 1000);
        this.$store.dispatch('fetchFabricPriceSlabList');
    }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statement_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2aaded_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statement_vue__ = __webpack_require__(945);
function injectStyle (ssrContext) {
  __webpack_require__(943)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Statement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e2aaded_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Statement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            page_number: 1
        };
    },

    computed: {
        getStatementList: function getStatementList() {
            return this.$store.state.inventoryMaster.statement.list;
        },
        getPagenumber: function getPagenumber() {
            return this.page_number * this.$store.getters.getDefaultPageLimit - this.$store.getters.getDefaultPageLimit;
        },
        getUOMID: function getUOMID() {
            return this.$store.state.inventoryMaster.props.unit_of_measurement_id;
        },
        getUOM: function getUOM() {
            var _this = this;

            var uomList = this.$store.getters.getUOMMasterList;

            var index = uomList.findIndex(function (t) {
                return t.id === _this.getUOMID;
            });
            if (index >= 0) {
                return uomList[index].unit_name;
            }

            return '';
        }
    },
    methods: {
        getSummaries: function getSummaries(param) {
            var _this2 = this;

            var columns = param.columns;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 2) {
                    sums[index] = '';
                    return;
                } else if (index === 3) {
                    sums[index] = '';
                    return;
                } else if (index === 4) {
                    var total = _this2.getStatementList.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.stock)) && element1.opening_stock ? count + parseFloat(element1.stock) : count + 0;
                    }, 0);
                    sums[index] = total.toFixed(2) + ' ' + _this2.getUOM;
                    return;
                } else if (index === 5) {
                    var _total = _this2.getStatementList.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.debit_qty)) ? count + parseFloat(element1.debit_qty) : count + 0;
                    }, 0);
                    sums[index] = _total.toFixed(2) + ' ' + _this2.getUOM;
                    return;
                } else if (index === 6) {
                    var _total2 = _this2.getStatementList.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.credit_qty)) ? count + parseFloat(element1.credit_qty) : count + 0;
                    }, 0);
                    sums[index] = _total2.toFixed(2) + ' ' + _this2.getUOM;
                    return;
                } else if (index === 7) {
                    var _total3 = _this2.getStatementList.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.stock)) && element1.closing_stock ? count + parseFloat(element1.stock) : count + 0;
                    }, 0);
                    sums[index] = _total3.toFixed(2) + ' ' + _this2.getUOM;
                    return;
                }
            });
            return sums;
        },
        loadStatement: function loadStatement() {
            this.page_number = 1;
            this.$store.dispatch('loadInventoryStatement', { date_range: this.$store.state.inventoryMaster.statement.date_range,
                store_id: this.$store.state.inventoryMaster.statement.store_id,
                item_code: this.$store.state.inventoryMaster.props.id });
        }
    },
    mounted: function mounted() {
        this.$store.state.inventoryMaster.statement.list = [];
        if (this.$store.state.inventoryMaster.statement.date_range[0].length > 0) {
            this.loadStatement();
        }
    }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Basic_vue__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriceAndTax_vue__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VariantList_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Statement_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServiceLog_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ImageList__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EStore_Index_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__OtherVariant_vue__ = __webpack_require__(988);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['popup'],
    components: { OtherVariant: __WEBPACK_IMPORTED_MODULE_7__OtherVariant_vue__["a" /* default */], EStore: __WEBPACK_IMPORTED_MODULE_6__EStore_Index_vue__["a" /* default */], ImageList: __WEBPACK_IMPORTED_MODULE_5__ImageList__["a" /* default */], Basic: __WEBPACK_IMPORTED_MODULE_0__Basic_vue__["a" /* default */], PriceAndTax: __WEBPACK_IMPORTED_MODULE_1__PriceAndTax_vue__["a" /* default */], VariantList: __WEBPACK_IMPORTED_MODULE_2__VariantList_vue__["a" /* default */], Statement: __WEBPACK_IMPORTED_MODULE_3__Statement_vue__["a" /* default */], ServiceLog: __WEBPACK_IMPORTED_MODULE_4__ServiceLog_vue__["a" /* default */] },
    data: function data() {
        return {
            activeTab: '1',
            showPrintWindow: false,
            printSrc: '',
            printTitle: ''
        };
    },

    computed: {
        getPrintTitle: function getPrintTitle() {
            return this.printTitle;
        },
        getPrintSrc: function getPrintSrc() {
            return this.printSrc;
        },
        isPrintWindowVisible: function isPrintWindowVisible() {
            return this.showPrintWindow;
        }
    },
    methods: {
        submit: function submit() {
            var payload = JSON.parse(JSON.stringify(this.$store.getters.getInventoryMasterDataProps));
            if (this.popup) {
                payload.popup = true;
            }
            if (payload.item_type === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select the inventory type', type: 'Error' });
                return;
            } else if (payload.sub_category_id === null || payload.sub_category_id === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select the category of this article', type: 'Error' });
                document.getElementById(payload.sub_category_id).focus();
                return;
            }
            this.$store.dispatch('submitInventoryMasterData', payload);
        },
        handleDropdownCommand: function handleDropdownCommand(command) {
            if (command === 'printRetailQr') {
                var labelType = this.$store.getters.getInventoryMasterDataProps.item_type === 1 ? 'retail' : 'ready_item';
                this.printSrc = this.master_url + 'target=printQrTag&subpage=print&print_type=' + labelType + '&item_id=' + this.$store.getters.getInventoryMasterDataProps.id + '&access_token=' + this.$store.getters.getAccessToken;
            } else if (command === 'printStockQr') {
                this.printSrc = this.master_url + 'target=printQrTag&subpage=print&print_type=stock&item_id=' + this.$store.getters.getInventoryMasterDataProps.id + '&access_token=' + this.$store.getters.getAccessToken;
            }
            this.printTitle = 'Paper Size: Custom';
            this.showPrintWindow = true;
        },
        close: function close() {
            var _this = this;

            if (this.popup) {

                var uomName = "";
                var uomIndex = this.$store.getters.getUOMMasterList.findIndex(function (t) {
                    return t.id === _this.$store.getters.getInventoryMasterDataProps.unit_of_measurement_id;
                });
                if (uomIndex >= 0) {
                    uomName = this.$store.getters.getUOMMasterList[uomIndex].unit_name;
                }

                var emitPayload = {
                    id: this.$store.getters.getInventoryMasterDataProps.id,
                    sku_code: this.$store.getters.getInventoryMasterDataProps.sku_code,
                    article_name: this.$store.getters.getInventoryMasterDataProps.article_name,
                    unit_name: uomName
                };

                if (this.$store.getters.getInventoryMasterDataProps.id === 0) {
                    this.$confirm('Are you sure to leave this page?', 'Warning', {
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(function () {
                        _this.$emit('closed', emitPayload);
                        return;
                    }).catch(function () {
                        return;
                    });
                } else {
                    this.$emit('closed', emitPayload);
                }
            } else {
                this.$router.push(this.$router.currentRoute.fullPath.replace('/form/', ''));
            }
        }
    },
    mounted: function mounted() {
        if (this.$store.getters.getInventoryRackList.length === 0) {
            this.$store.dispatch('fetchInventoryRackList');
        }
        if (this.popup) {
            this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });
        }
        this.$store.state.inventoryMaster.statement.list = [];
    }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        getItemType: function getItemType() {
            return this.$store.state.inventoryMaster.props.item_type;
        },
        getUOMList: function getUOMList() {
            var uomList = this.$store.getters.getUOMMasterList;
            return uomList;
            /*let returnList = []
             if(this.getItemType === 1) {
                returnList = uomList.filter((option) => {
                    return option.for_fabric === 1
                })
            } else {
                returnList = uomList
            }
            return returnList*/
        }
    },
    methods: {
        loadItemCategories: function loadItemCategories(type) {
            this.$store.state.inventoryMaster.props.most_popular = false;
            this.$store.dispatch('fetchItemSubCategoryList', { type: type });
        },
        searchSKUCode: function searchSKUCode(query) {
            this.$store.dispatch('fetchTailoringMasterAutocompleteList', {
                query: query,
                sales_form_request: true,
                inventoryPayload: {
                    query: query,
                    store_id: 0,
                    sales_form_request: true,
                    search_fabric_only: false,
                    search_column: ['sku_code', 'article_name']
                }
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.loadItemCategories(_this.$store.state.inventoryMaster.props.item_type);
        }, 400);
    }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        caluclateRate: function caluclateRate(source) {

            var flat_price = parseFloat(this.$store.state.inventoryMaster.props.flat_price);
            var default_retail_fabric_unit = parseFloat(this.$store.state.inventoryMaster.props.default_retail_fabric_unit);
            var sale_price = parseFloat(this.$store.state.inventoryMaster.props.sale_price);

            if (source == "sale_price") {
                this.$store.state.inventoryMaster.props.flat_price = (sale_price / default_retail_fabric_unit).toFixed(2);
            } else if (source == "flat_price") {
                this.$store.state.inventoryMaster.props.sale_price = (flat_price * default_retail_fabric_unit).toFixed(2);
            } else if (source == "default_retail_fabric_unit") {
                this.$store.state.inventoryMaster.props.flat_price = (sale_price / default_retail_fabric_unit).toFixed(2);
            }
        },
        addProfitPercent: function addProfitPercent() {
            var costPrice = parseFloat(this.$store.state.inventoryMaster.props.cost_price);
            var profitPercent = parseFloat(this.$store.state.inventoryMaster.props.profit_percent);

            if (profitPercent > 0 && costPrice > 0) {
                this.$store.state.inventoryMaster.props.sale_price = costPrice + costPrice * (profitPercent / 100);
            }
        }
    }
});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        getAllVariants: function getAllVariants() {
            var list = [];

            JSON.parse(JSON.stringify(this.$store.getters.getInventoryVariantList)).forEach(function (element) {
                element.sub_variant_list.forEach(function (variant) {
                    list.push({
                        variant_id: element.id,
                        sub_variant_id: variant.id,
                        sub_variant_name: variant.sub_variant_name
                    });
                });
            });
            return list;
        }
    }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

    computed: {
        getDocumentList: function getDocumentList() {
            return this.$store.state.document.props;
        }
    },
    methods: {
        toggleThumnailStatus: function toggleThumnailStatus(rowData) {
            this.$store.getters.getInventoryMasterDataProps.image_list.forEach(function (el) {
                el.default_online_thumbnail = false;
            });

            rowData.default_online_thumbnail = !rowData.default_online_thumbnail;
        },
        toggleThumnailHoverStatus: function toggleThumnailHoverStatus(rowData) {
            this.$store.getters.getInventoryMasterDataProps.image_list.forEach(function (el) {
                el.default_online_thumbnail_hover = false;
            });

            rowData.default_online_thumbnail_hover = !rowData.default_online_thumbnail_hover;
        }
    }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Basic_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PriceVariation__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Downloadables__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdditionalInformation__ = __webpack_require__(983);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Basic: __WEBPACK_IMPORTED_MODULE_0__Basic_vue__["a" /* default */], Downloadables: __WEBPACK_IMPORTED_MODULE_2__Downloadables__["a" /* default */], PriceVariation: __WEBPACK_IMPORTED_MODULE_1__PriceVariation__["a" /* default */], AdditionalInformation: __WEBPACK_IMPORTED_MODULE_3__AdditionalInformation__["a" /* default */] },
    data: function data() {
        return {
            activeTab: '1'
        };
    },

    methods: {
        searchSKUCode: function searchSKUCode(query) {
            this.$store.dispatch('fetchInventoryMasterAutocompleteList', { query: query, show_all_item: true, search_column: ['sku_code'], store_id: this.$store.state.inventoryMaster.props.store_id });
        }
    }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {
        loadSource: function loadSource($event) {
            var dataId = parseInt($event);
            if (dataId === 9 || dataId === 11 || dataId === 13) {
                if (dataId === 9) {
                    this.loadCategory(0);
                } else if (dataId === 11) {
                    this.loadCategory(2);
                } else if (dataId === 13) {
                    this.loadCategory(1);
                }
            } else if (dataId === 10 || dataId === 12 || dataId === 14) {
                if (dataId === 10) {
                    this.loadItemCategories(0);
                } else if (dataId === 12) {
                    this.loadItemCategories(2);
                } else if (dataId === 14) {
                    this.loadItemCategories(1);
                }
            }
        },
        loadCategory: function loadCategory(type) {
            this.$store.dispatch('fetchItemCategoryList', { type: type });
        },
        loadItemCategories: function loadItemCategories(type) {
            this.$store.dispatch('fetchItemSubCategoryList', { type: type });
        }
    }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    methods: {}
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        getAllVariants: function getAllVariants() {
            var list = [];

            JSON.parse(JSON.stringify(this.$store.getters.getInventoryVariantList)).forEach(function (element) {
                element.sub_variant_list.forEach(function (variant) {
                    list.push({
                        variant_id: element.id,
                        sub_variant_id: variant.id,
                        sub_variant_name: variant.sub_variant_name
                    });
                });
            });
            return list;
        }
    }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            bank_id: null,
            store_id: null,
            transaction_date: new Date(),
            amount: 0,
            staff_name: ''
        };
    },

    computed: {
        isMobileDevice: function isMobileDevice() {
            return __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__["isMobile"];
        },
        getCurrentPath: function getCurrentPath() {
            return this.$router.currentRoute.fullPath;
        },
        getStaffNameList: function getStaffNameList() {
            var _this = this;

            var returnList = [{
                value: "Admin",
                id: 0
            }];

            this.$store.getters.getEmployeeMasterList.filter(function (t) {
                return t.active;
            }).forEach(function (element) {
                returnList.push({
                    value: element.id === _this.$store.getters.getUserInformation.staff_id ? 'Self' : element.staff_name,
                    id: element.id
                });
            });

            return returnList;
        }
    },
    methods: {
        loadSelectedStaffName: function loadSelectedStaffName($event) {
            this.$store.state.tasks.props.assigned_to_staff_id = $event.id;
            this.staff_name = $event.value;
        },
        queryStaffSearch: function queryStaffSearch(queryString, cb) {
            var links = this.getStaffNameList;
            var results = queryString ? links.filter(this.createFilter(queryString)) : links;
            // call callback function to return suggestions
            cb(results);
        },
        createFilter: function createFilter(queryString) {
            return function (link) {
                return link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
            };
        },
        submitBalance: function submitBalance() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this2.$store.state.tasks.props.title.length === 0)) {
                                    _context.next = 5;
                                    break;
                                }

                                _this2.$store.commit('displayMessageAlert', { message: 'Please mention title of the task', type: 'Error' });
                                return _context.abrupt('return');

                            case 5:
                                if (!(_this2.$store.state.tasks.props.description.length === 0)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this2.$store.commit('displayMessageAlert', { message: 'Please describe the task', type: 'Error' });
                                return _context.abrupt('return');

                            case 10:
                                if (!(_this2.$store.state.tasks.props.category_id === null || _this2.$store.state.tasks.props.category_id !== null && _this2.$store.state.tasks.props.category_id === 0)) {
                                    _context.next = 13;
                                    break;
                                }

                                _this2.$store.commit('displayMessageAlert', { message: 'Please select the category of the task', type: 'Error' });
                                return _context.abrupt('return');

                            case 13:
                                _context.next = 15;
                                return _this2.$store.dispatch('submitTaskData', _this2.$store.state.tasks.props);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    }
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);
var settle = __webpack_require__(1007);
var cookies = __webpack_require__(1008);
var buildURL = __webpack_require__(229);
var buildFullPath = __webpack_require__(1009);
var parseHeaders = __webpack_require__(1012);
var isURLSameOrigin = __webpack_require__(1013);
var createError = __webpack_require__(232);
var defaults = __webpack_require__(97);
var Cancel = __webpack_require__(98);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function onCanceled(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(230);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
  });

  return config;
};

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = {
  "version": "0.25.0"
};

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            processing: false,
            tailoring_category: [{ id: 0, name: 'Western Wear' }, { id: 1, name: 'Western Wear - Outsourcing' }, { id: 2, name: 'Indo-Western Wear' }, { id: 3, name: 'Middle East Ethnic Wear' }]
        };
    },

    computed: {
        isProcessing: function isProcessing() {
            return this.processing;
        }
    },
    methods: {
        checkIfTenantExists: function checkIfTenantExists() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var payload;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.$store.state.signup.props.first_name.length === 0)) {
                                    _context.next = 6;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'First name is missing', type: 'Error' });
                                document.getElementById('firstName').focus();
                                return _context.abrupt('return');

                            case 6:
                                if (!(_this.$store.state.signup.props.last_name.length === 0)) {
                                    _context.next = 12;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Last name is missing', type: 'Error' });
                                document.getElementById('lastName').focus();
                                return _context.abrupt('return');

                            case 12:
                                if (!(_this.$store.state.signup.props.brand_name.length === 0)) {
                                    _context.next = 18;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Brand name is missing', type: 'Error' });
                                document.getElementById('brandName').focus();
                                return _context.abrupt('return');

                            case 18:
                                if (!(_this.$store.state.signup.props.country_id === null)) {
                                    _context.next = 24;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Please mention you country of origin', type: 'Error' });
                                document.getElementById('countryId').focus();
                                return _context.abrupt('return');

                            case 24:
                                if (!(_this.$store.state.signup.props.email_address === null)) {
                                    _context.next = 30;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Email address is missing', type: 'Error' });
                                document.getElementById('emailAddress').focus();
                                return _context.abrupt('return');

                            case 30:
                                if (!_this.invalidEmailAddress(_this.$store.state.signup.props.email_address)) {
                                    _context.next = 34;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Invalid Email Address', type: 'Error' });
                                document.getElementById('emailAddress').focus();
                                return _context.abrupt('return');

                            case 34:

                                _this.processing = true;

                                payload = _this.$store.getters.getSignupProps;
                                _context.next = 38;
                                return _this.$store.dispatch('checkIfTenantExists', payload);

                            case 38:

                                setTimeout(function () {
                                    _this.processing = false;
                                }, 1000);

                            case 39:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            processing: false
        };
    },

    computed: {
        isProcessing: function isProcessing() {
            return this.processing;
        }
    },
    methods: {
        checkTenantConfirmationCode: function checkTenantConfirmationCode() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.$store.state.signup.props.confirmation_code.length === 0)) {
                                    _context.next = 3;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Confirmation code is not valid', type: 'Error' });
                                return _context.abrupt('return');

                            case 3:

                                _this.processing = true;

                                _context.next = 6;
                                return _this.$store.dispatch('checkTenantConfirmationCode', {
                                    id: _this.$store.state.signup.props.id,
                                    email_confirmation_code: _this.$store.state.signup.props.confirmation_code,
                                    machine_id: _this.$store.getters.getMachineId
                                });

                            case 6:

                                setTimeout(function () {
                                    _this.processing = false;
                                }, 1000);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            processing: false,
            hideMasterLogin: true
        };
    },

    computed: {
        getTopLogo: function getTopLogo() {
            var logo = localStorage.getItem('default_logo');
            if (logo !== null) {
                if (logo.length === 0) {
                    logo = "https://etacdn.b-cdn.net/eta-new-logo.pngg";
                }
            } else {
                logo = "https://etacdn.b-cdn.net/white-blank.png";
            }
            return logo;
        },
        isMobileDevice: function isMobileDevice() {
            return __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__["isMobile"];
        },
        isProcessing: function isProcessing() {
            return this.processing;
        },
        isMasterLoginHidden: function isMasterLoginHidden() {
            return this.hideMasterLogin;
        },
        getDeviceTokenId: function getDeviceTokenId() {
            return localStorage.getItem('device_token_id');
        },
        getCurrentHostName: function getCurrentHostName() {
            return window.location.hostname;
        },
        isHomeDomain: function isHomeDomain() {
            return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost');
        }
    },
    methods: {
        login: function login() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var payload;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(_this.$store.state.master.login.user_name.length === 0)) {
                                    _context.next = 6;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Email address or user id is missing', type: 'Error' });
                                document.getElementById('loginId').focus();
                                return _context.abrupt('return');

                            case 6:
                                if (!(_this.$store.state.master.login.password.length === 0)) {
                                    _context.next = 10;
                                    break;
                                }

                                _this.$store.commit('displayMessageAlert', { message: 'Password is missing', type: 'Error' });
                                document.getElementById('loginPassword').focus();
                                return _context.abrupt('return');

                            case 10:

                                _this.processing = true;

                                payload = _this.$store.getters.getLoginProps;

                                payload.machine_id = _this.$store.getters.getMachineId;
                                payload.device_token_id = _this.getDeviceTokenId;

                                _context.next = 16;
                                return _this.$store.dispatch('login', payload);

                            case 16:

                                setTimeout(function () {
                                    _this.processing = false;
                                }, 1000);

                            case 17:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }

});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            current_password: '',
            new_password: '',
            confirm_password: '',
            processing: false
        };
    },

    computed: {
        isProcessing: function isProcessing() {
            return this.processing;
        }
    },
    methods: {
        changePassword: function changePassword() {

            if (this.current_password.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Current password is wrong/missing!!!', type: 'Error' });
                document.getElementById('current_password').focus();
                return;
            } else if (this.new_password.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'New password is missing!!!', type: 'Error' });
                document.getElementById('new_password').focus();
                return;
            } else if (this.confirm_password.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Confirm password is missing!!!', type: 'Error' });
                document.getElementById('confirm_password').focus();
                return;
            } else if (this.new_password !== this.confirm_password) {
                this.$store.commit('displayMessageAlert', { message: 'New and confirm password do not match!!!', type: 'Error' });
                document.getElementById('new_password').focus();
                return;
            }

            this.$store.dispatch('changePassword', {
                current_password: this.current_password,
                new_password: this.new_password,
                confirm_password: this.confirm_password
            });
        }
    }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            user_name: '',
            processing: false
        };
    },

    computed: {
        getTopLogo: function getTopLogo() {
            var logo = localStorage.getItem('default_logo');
            if (logo !== null) {
                if (logo.length === 0) {
                    logo = "https://etacdn.b-cdn.net/eta-new-logo.pngg";
                }
            } else {
                logo = "https://etacdn.b-cdn.net/white-blank.png";
            }
            return logo;
        },
        isProcessing: function isProcessing() {
            return this.processing;
        },
        getCurrentHostName: function getCurrentHostName() {
            return window.location.hostname;
        },
        isHomeDomain: function isHomeDomain() {
            return this.getCurrentHostName.includes('cloud.easytailor') || this.getCurrentHostName.includes('localhost');
        }
    },
    methods: {
        forgotPassword: function forgotPassword() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.processing = true;

                                _context.next = 3;
                                return _this.$store.dispatch('forgotPassword', { user_name: _this.user_name });

                            case 3:

                                setTimeout(function () {
                                    _this.processing = false;
                                    _this.user_name = "";
                                }, 1000);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            processing: false
        };
    },

    computed: {
        isProcessing: function isProcessing() {
            return this.processing;
        }
    },
    methods: {
        login: function login() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var payload;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.processing = true;

                                payload = _this.$store.getters.getLoginProps;
                                _context.next = 4;
                                return _this.$store.dispatch('masterLogin', payload);

                            case 4:

                                setTimeout(function () {
                                    _this.processing = false;
                                }, 1000);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TaskForm__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupTask__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__List_vue__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mobile_device_detect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import TaskListDisplay from './TaskListDisplay'





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            search_term: '',
            selected_category_id: -1,
            selected_priority: -1,
            selected_status: -1
        };
    },

    computed: {
        isMobileDevice: function isMobileDevice() {
            return __WEBPACK_IMPORTED_MODULE_3_mobile_device_detect__["isMobile"];
        },
        getSelectedCategoryId: function getSelectedCategoryId() {
            return this.selected_category_id;
        },
        getSelectedPriority: function getSelectedPriority() {
            return this.selected_priority;
        },
        getSelectedStatus: function getSelectedStatus() {
            return this.selected_status;
        },
        getDataList: function getDataList() {
            var search_term = this.search_term.toLowerCase();

            return this.$store.getters.getTaskList.filter(function (t) {
                return t.title.toLowerCase().match(search_term) || t.assigned_to_alias_name.toLowerCase().match(search_term) || t.created_by_alias_name.toLowerCase().match(search_term) || t.assigned_to_name.toLowerCase().match(search_term) || t.created_by_name.toLowerCase().match(search_term);
            });
        },
        getDisplayList: function getDisplayList() {
            var _this = this;

            var list = this.getSelectedCategoryId >= 0 ? this.getDataList.filter(function (t) {
                return t.category_id === _this.getSelectedCategoryId;
            }) : this.getDataList;
            list = this.getSelectedPriority >= 0 ? list.filter(function (t) {
                return t.priority === _this.getSelectedPriority;
            }) : list;
            list = this.getSelectedStatus >= 0 ? list.filter(function (t) {
                return t.status === _this.getSelectedStatus;
            }) : list;

            return list;
        }
    },
    components: { List: __WEBPACK_IMPORTED_MODULE_2__List_vue__["a" /* default */], TaskForm: __WEBPACK_IMPORTED_MODULE_0__TaskForm__["a" /* default */], GroupTask: __WEBPACK_IMPORTED_MODULE_1__GroupTask__["a" /* default */] },
    methods: {
        loadList: function loadList() {
            this.$store.dispatch('fetchTaskList');
        },
        newTask: function newTask() {
            this.$store.commit('resetTaskData');
            this.$store.commit('resetTaskGroupData');
            this.$store.state.tasks.show_task_form = true;
        },
        openTaskForm: function openTaskForm(command) {
            if (command == 'single_task') {
                this.newTask();
            } else if (command == 'group_task') {
                this.$store.commit('resetTaskData');
                this.$store.commit('resetTaskGroupData');
                this.$store.state.tasks.show_task_group_form = true;
            }
        }
    },
    mounted: function mounted() {
        this.$store.state.tasks.show_task_form = false;
        this.$store.dispatch('fetchTaskCategoryList');
        this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });
        this.loadList();
    }
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    submitGroup: function submitGroup() {
      this.$store.dispatch('submitGroupTasks', this.$store.state.tasks.group_task);
    }
  }
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['dataList']
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileList_vue__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MasterMeasurementSheet_vue__ = __webpack_require__(537);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['item_category_id', 'customer_measurement_profile', 'msmt_form'],
    components: { MasterMeasurementSheet: __WEBPACK_IMPORTED_MODULE_1__MasterMeasurementSheet_vue__["a" /* default */], ProfileList: __WEBPACK_IMPORTED_MODULE_0__ProfileList_vue__["a" /* default */] },
    methods: {
        loadAllMsmtHistory: function loadAllMsmtHistory() {
            this.$store.state.customerMaster.props.load_all_msmt_history = true;
            this.$store.dispatch('fetchCustomerMasterMeasurementData', { id: this.$store.state.customerMaster.props.id, copy: false, navigate: false, load_all_msmt_history: true });
        }
    },
    computed: {
        getMeasurementTemplateList: function getMeasurementTemplateList() {
            var _this = this;

            if (this.item_category_id) {
                return this.$store.getters.getMeasurementTemplateList.filter(function (element) {
                    return element.category_id === _this.item_category_id;
                });
            } else {
                return this.$store.getters.getMeasurementTemplateList;
            }
        },
        getCustomerMeasurementProfileList: function getCustomerMeasurementProfileList() {
            return this.$store.getters.getCustomerMasterDataProps.measurement_profile_list;
        },
        getTempMeasurementProfile: function getTempMeasurementProfile() {
            var _this2 = this;

            this.getMeasurementTemplateList.forEach(function (element) {
                var existingCustomerProfile = _this2.getCustomerMeasurementProfileList.filter(function (element1) {
                    return element1.tailoring_category_id === element.category_id;
                });

                if (existingCustomerProfile.length > 0) {
                    existingCustomerProfile.forEach(function (element1) {

                        var profile_list = element1.profile_list;
                        _this2.$store.state.customerMaster.props.temp_measurement_profile_list.push({
                            tailoring_category_id: element1.tailoring_category_id,
                            profile_list: profile_list
                        });
                    });
                } else {
                    _this2.$store.state.customerMaster.props.temp_measurement_profile_list.push({
                        tailoring_category_id: element.category_id,
                        profile_list: []
                    });
                }
            });

            return this.$store.state.customerMaster.props.temp_measurement_profile_list;
        }
    }
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeasurementFieldList_vue__ = __webpack_require__(1064);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { MeasurementFieldList: __WEBPACK_IMPORTED_MODULE_0__MeasurementFieldList_vue__["a" /* default */] },
    props: ['msmt_form', 'item_category_id', 'item_category_name', 'master_measurement_list', 'inline', 'customer_measurement_profile'],
    data: function data() {
        return {
            msmt_profile_key: -1,
            msmt_list_visible: false
        };
    },

    computed: {
        getMsmtProfileKey: function getMsmtProfileKey() {
            return this.msmt_profile_key;
        },
        getCurrentItemCategoryId: function getCurrentItemCategoryId() {
            return this.item_category_id;
        },
        getCustomerTempMeasurementList: function getCustomerTempMeasurementList() {
            return this.$store.state.customerMaster.props.temp_measurement_profile_list[this.getTailoringCategoryIndex];
        },
        getTailoringCategoryIndex: function getTailoringCategoryIndex() {
            var _this = this;

            return this.$store.state.customerMaster.props.temp_measurement_profile_list.findIndex(function (element) {
                return element.tailoring_category_id === _this.getCurrentItemCategoryId;
            });
        }
    },
    methods: {
        submitMeasurement: function submitMeasurement() {
            this.msmt_list_visible = false;
            var payload = JSON.parse(JSON.stringify(this.$store.getters.getCustomerMasterDataProps));
            if (payload.salutation_id === null || payload.salutation_id === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select a salutation of the customer', type: 'Error' });
                document.getElementById('salutation_id').focus();
                return;
            } else if (payload.type_of_customer === 1 && payload.company_name.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please enter name of the business entity', type: 'Error' });
                document.getElementById('company_name').focus();
                return;
            } else if (payload.customer_name.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please enter name of the customer', type: 'Error' });
                document.getElementById('customer_name').focus();
                return;
            } else if (payload.customer_name.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please enter name of the customer', type: 'Error' });
                document.getElementById('customer_name').focus();
                return;
            } else if (payload.primary_mobile_number_calling_code === null || payload.primary_mobile_number_calling_code === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide a valid country code for primary mobile number', type: 'Error' });
                document.getElementById('primary_mobile_number_calling_code').focus();
                return;
            } else if (payload.primary_mobile_number.length < 5) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide a valid primary mobile number', type: 'Error' });
                document.getElementById('primary_mobile_number').focus();
                return;
            } else if (this.$store.getters.getPreferenceProps.email_address_required_in_customer_form && payload.email_address.length === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide a valid email address', type: 'Error' });
                document.getElementById('email_address').focus();
                return;
            } else if (this.$store.getters.getPreferenceProps.email_address_required_in_customer_form && payload.email_address.length > 0 && this.invalidEmailAddress(payload.email_address)) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide a valid email address', type: 'Error' });
                document.getElementById('email_address').focus();
                return;
            } else if (this.$store.getters.getPreferenceProps.customer_address_required_in_customer_form && (payload.address.length === 0 || payload.country_id === null || payload.country_id === 0 || payload.province_id === null || payload.province_id === 0 || payload.city_id === null || payload.city_id === 0)) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide a valid address', type: 'Error' });
                return;
            } else if (this.$store.getters.isIndiaTax && payload.tax_registration_number !== null && payload.tax_registration_number.length > 3 && (payload.province_id === null || payload.province_id === 0)) {
                this.$store.commit('displayMessageAlert', { message: 'Please select a valid state or province code for GST calculation.', type: 'Error' });
                document.getElementById('country_id').focus();
                return;
            }

            this.$store.dispatch('submitCustomerMasterData', payload);
        },
        addNewMeasurement: function addNewMeasurement() {
            this.$store.commit('addNewCustomerMasterMeasurementProfileListRow', this.getCurrentItemCategoryId);

            if (this.inline) {
                this.openMeasurementListPopup(this.getCustomerTempMeasurementList.profile_list.length - 1);
            }
        },
        openMeasurementListPopup: function openMeasurementListPopup(key) {
            var _this2 = this;

            var masterMeasurementList = this.$store.getters.getMeasurementTemplateList.filter(function (element) {
                return element.category_id === _this2.getCurrentItemCategoryId;
            });

            if (masterMeasurementList.length > 0) {

                var msmt_master_list = JSON.parse(JSON.stringify(masterMeasurementList[0].measurement_list));

                var msmt_field_list = this.getCustomerTempMeasurementList.profile_list[key].measurement_field_list;

                if (msmt_field_list.length === 0) {

                    msmt_master_list.forEach(function (element) {
                        element.measurement_id = element.id;

                        var msmtFieldIndex = -1;
                        if (_this2.getCustomerTempMeasurementList.profile_list[0] !== undefined) {
                            msmtFieldIndex = _this2.getCustomerTempMeasurementList.profile_list[0].measurement_field_list.findIndex(function (t) {
                                return t.measurement_id === element.measurement_id;
                            });
                        }

                        if (msmtFieldIndex >= 0) {
                            element.measurement_value = _this2.getCustomerTempMeasurementList.profile_list[0].measurement_field_list[msmtFieldIndex].measurement_value;
                        } else {
                            element.measurement_value = '';
                        }
                    });
                    this.$store.state.customerMaster.props.temp_measurement_profile_list[this.getTailoringCategoryIndex].profile_list[key].measurement_field_list = msmt_master_list;
                } else {

                    msmt_master_list.forEach(function (masterElement) {
                        msmt_field_list.forEach(function (element) {
                            if (masterElement.id === element.measurement_id) {
                                element.measurement_value_fixed = masterElement.measurement_value_fixed;
                                element.measurement_instruction_image = masterElement.measurement_instruction_image;
                                element.measurement_drop_down_list = masterElement.measurement_drop_down_list;
                                element.measurement_name = masterElement.measurement_name;
                            } else {
                                element = JSON.parse(JSON.stringify(masterElement));
                                element.measurement_id = element.id;
                                element.measurement_value = '';
                            }
                        });
                    });
                }
                this.msmt_profile_key = key;
                this.msmt_list_visible = true;
            } else {
                this.$store.commit('displayMessageAlert', { message: 'Error, please contact your administrator or email us.', type: 'Error' });
            }
        },
        removeList: function removeList(key) {
            this.msmt_profile_key = -1;
            this.$store.commit('removeCustomerMasterMeasurementProfileListRow', { key: key, tailoring_category_id: this.getCurrentItemCategoryId });
        }
    }
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['msmt_form', 'windowTitle', 'profile_id', 'measurement_list', 'profile_data', 'inline', 'item_category_id'],
    computed: {
        getMeasurementList: function getMeasurementList() {
            if (this.inline) {
                return this.profile_data.measurement_field_list;
            }
            return this.measurement_list;
        }
    },
    methods: {
        addToTrialList: function addToTrialList(msmtData) {
            if (this.msmt_form) {
                var found = false;

                this.msmt_form.forEach(function (element) {
                    if (element.id === msmtData.measurement_id) {
                        found = true;
                    }
                });

                if (!found) {
                    this.msmt_form.push({
                        id: msmtData.measurement_id,
                        measurement_name: msmtData.measurement_name,
                        measurement_value: msmtData.measurement_value
                    });
                }
            }
        }
    }
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            item_list: []
        };
    },

    computed: {
        getItemList: function getItemList() {
            var _this = this;

            this.$store.state.customerMaster.props.measurement_master_size_id = [];
            this.$store.getters.getItemCategoryList.forEach(function (element) {

                var categoryIndex = _this.$store.getters.getCustomerMasterDataProps.temp_measurement_profile_list.findIndex(function (t) {
                    return t.tailoring_category_id === element.id;
                });

                var sizeId = 0;
                if (categoryIndex >= 0) {

                    var size = 0;
                    if (_this.$store.state.customerMaster.props.temp_measurement_profile_list[categoryIndex].profile_list[0] !== undefined) {
                        size = _this.$store.state.customerMaster.props.temp_measurement_profile_list[categoryIndex].profile_list[0].size_id;
                    }
                    sizeId = size !== undefined ? size : 0;
                }
                _this.$store.state.customerMaster.props.measurement_master_size_id.push({
                    category_id: element.id,
                    category_name: element.category_name,
                    size_id: sizeId
                });
            });
            return this.$store.state.customerMaster.props.measurement_master_size_id;
        },
        getMasterMeasurementSheet: function getMasterMeasurementSheet() {
            var _this2 = this;

            var measurement_master_sheet = this.$store.state.customerMaster.props.measurement_master_sheet;
            var list = [];

            this.$store.getters.getMeasurementMasterList.forEach(function (element) {
                var measurement_value = "";
                var msmtIndex = _this2.getAllMeasurementFieldList.findIndex(function (t) {
                    return t.master_measurement_id === element.id;
                });
                if (msmtIndex >= 0) {
                    measurement_value = _this2.getAllMeasurementFieldList[msmtIndex].measurement_value;
                }
                list.push({
                    id: element.id,
                    measurement_name: element.measurement_name,
                    measurement_value_fixed: element.measurement_value_fixed,
                    measurement_drop_down_list: element.measurement_drop_down_list,
                    measurement_value: measurement_value,
                    measurement_instruction_image: element.measurement_instruction_image
                });
            });
            return this.$store.state.customerMaster.props.measurement_master_sheet = measurement_master_sheet.length > 0 ? measurement_master_sheet : list;
        },
        getCustomerMeasurementProfileList: function getCustomerMeasurementProfileList() {
            return this.$store.getters.getCustomerMasterDataProps.measurement_profile_list;
        },
        getAllMeasurementFieldList: function getAllMeasurementFieldList() {
            var returnList = [];

            this.getCustomerMeasurementProfileList.forEach(function (element) {
                element.profile_list[0].measurement_field_list.forEach(function (field) {
                    returnList.push(field);
                });
            });

            return returnList;
        }
    },
    methods: {
        setMasterMeasurementSheet: function setMasterMeasurementSheet() {
            var _this3 = this;

            var list = [];

            this.$store.getters.getMeasurementMasterList.forEach(function (element) {
                var measurement_value = "";
                var msmtIndex = _this3.getAllMeasurementFieldList.findIndex(function (t) {
                    return t.master_measurement_id === element.id;
                });
                if (msmtIndex >= 0) {
                    measurement_value = _this3.getAllMeasurementFieldList[msmtIndex].measurement_value;
                }
                list.push({
                    id: element.id,
                    measurement_name: element.measurement_name,
                    measurement_value_fixed: element.measurement_value_fixed,
                    measurement_drop_down_list: element.measurement_drop_down_list,
                    measurement_value: measurement_value,
                    measurement_instruction_image: element.measurement_instruction_image
                });
            });
            this.$store.state.customerMaster.props.measurement_master_sheet = list;
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        setTimeout(function () {
            _this4.setMasterMeasurementSheet();
        }, 400);
    }
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form_OrderItem_OrderList_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WorkOrder_ProductionList_vue__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CustomerPayment_Index_vue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GroupProductionStatus_vue__ = __webpack_require__(1179);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: { OrderList: __WEBPACK_IMPORTED_MODULE_0__Form_OrderItem_OrderList_vue__["a" /* default */], ProductionList: __WEBPACK_IMPORTED_MODULE_1__WorkOrder_ProductionList_vue__["a" /* default */], CustomerPaymentList: __WEBPACK_IMPORTED_MODULE_2__CustomerPayment_Index_vue__["default"], GroupProductionStatus: __WEBPACK_IMPORTED_MODULE_3__GroupProductionStatus_vue__["a" /* default */] },
    props: ['sale_id', 'calendar_source', 'selected_date', 'store_id', 'payroll'],
    data: function data() {
        return {
            activeTab: '1'
        };
    },

    computed: {
        isSalesEditAllowed: function isSalesEditAllowed() {
            return this.checkIfModuleAccessAvailable('/salesorders', 'can_edit');
        }
    },
    methods: {
        updateSalesDeliveryDate: function updateSalesDeliveryDate() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('updateSalesDeliveryDate', { data: _this.$store.getters.getSaleMasterDataProps, selected_date: _this.selected_date, store_id: _this.store_id });

                            case 2:

                                setTimeout(function () {
                                    _this.$emit('closed');
                                }, 1000);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        updateSalesTrialDate: function updateSalesTrialDate() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return _this2.$store.dispatch('updateSalesTrialDate', { data: _this2.$store.getters.getSaleMasterDataProps, selected_date: _this2.selected_date, store_id: _this2.store_id });

                            case 2:

                                setTimeout(function () {
                                    _this2.$emit('closed');
                                }, 1000);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('fetchSaleMasterData', { id: this.sale_id, fabricPriceSlabExists: this.$store.getters.getFabricPriceSlabList.length > 0 });
    }
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditFabricQty_vue__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditPrice__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PurchaseRequest__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WorkOrder_Index_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FabricChange_vue__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CostSheet_Index_vue__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TrialSchedule__ = __webpack_require__(1167);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CostSheet: __WEBPACK_IMPORTED_MODULE_5__CostSheet_Index_vue__["a" /* default */], EditFabricQty: __WEBPACK_IMPORTED_MODULE_0__EditFabricQty_vue__["a" /* default */], FabricChange: __WEBPACK_IMPORTED_MODULE_4__FabricChange_vue__["a" /* default */], EditPrice: __WEBPACK_IMPORTED_MODULE_1__EditPrice__["a" /* default */], PurchaseRequest: __WEBPACK_IMPORTED_MODULE_2__PurchaseRequest__["a" /* default */], WorkOrder: __WEBPACK_IMPORTED_MODULE_3__WorkOrder_Index_vue__["a" /* default */], TrialSchedule: __WEBPACK_IMPORTED_MODULE_6__TrialSchedule__["a" /* default */] },
    props: ['currency_symbol', 'quickView', 'type'],
    data: function data() {
        return {
            showFabricQtyWindow: false,
            showPriceWindow: false,
            rowData: null,
            showPurchaseRequest: false,
            showWorkOrder: false,
            wo_confirmed: false,
            showFabric: false,
            rowDataCreate: null,
            show_stock_list: false,
            cost_sheet_view: false,
            note_window: false,
            trial_schedule: false,
            selected_list_item_id: 0
        };
    },

    computed: {
        getSelectedListItemId: function getSelectedListItemId() {
            return this.selected_list_item_id;
        },
        isWOConfirmed: function isWOConfirmed() {
            return this.wo_confirmed;
        },
        getRowData: function getRowData() {
            return this.rowData;
        },
        getRowDataCreate: function getRowDataCreate() {
            return this.rowDataCreate;
        },
        isRegularOrder: function isRegularOrder() {
            return this.$store.getters.getSaleMasterDataProps.sale_type === 1;
        },
        getOrderList: function getOrderList() {

            if (this.type > 0) {
                if (this.type === 1) {
                    return this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                        return t.tailoring_item_id > 0;
                    });
                } else if (this.type === 2) {
                    return this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                        return t.retail_item_id > 0;
                    });
                }
            }
            return this.$store.getters.getSaleMasterDataProps.item_list;
        }
    },
    methods: {
        openTrialScheduleWindow: function openTrialScheduleWindow(selected_list_item_id) {
            this.selected_list_item_id = selected_list_item_id;
            this.trial_schedule = true;
        },
        openNoteView: function openNoteView(rowData) {

            this.rowData = rowData;

            this.note_window = true;
        },
        openCostSheet: function openCostSheet(rowData) {
            this.rowData = rowData;
            this.cost_sheet_view = true;
        },
        copyOrderRow: function copyOrderRow(rowData) {
            var rowDataCopy = JSON.parse(JSON.stringify(rowData));

            if (rowDataCopy.work_order_id !== null && rowDataCopy.work_order_id !== undefined && rowDataCopy.work_order_id > 0) {
                //this.showWorkOrderWindow(rowDataCopy, true)                       
            }

            this.$store.commit('copyNewSaleMasterOrderItem', rowDataCopy);
        },
        deleteListItem: function deleteListItem(rowData) {
            var _this = this;

            this.$store.commit('removeSaleMasterItemListRow', rowData.key);

            /*if(rowData.id >0 && rowData.tailoring_item_id>0 && this.$store.getters.getSaleMasterDataProps.sale_type>0) {
                 rowData.is_cancelled = 1
                rowData.tailoring_unit_rate = -rowData.tailoring_unit_rate
                rowData.tailoring_unit_discount_amount = -rowData.tailoring_unit_discount_amount
                rowData.extra_charge_unit_rate = -rowData.extra_charge_unit_rate
                rowData.extra_charge_unit_discount_amount = -rowData.extra_charge_unit_discount_amount
                rowData.fabric_unit_rate = -rowData.fabric_unit_rate
                rowData.fabric_unit_discount_amount = -rowData.fabric_unit_discount_amount
                rowData.retail_unit_rate = -rowData.retail_unit_rate
                rowData.retail_unit_discount_amount = -rowData.retail_unit_discount_amount
                 rowData.tailoring_tax_percent = -rowData.tailoring_tax_percent
                rowData.fabric_tax_percent = -rowData.fabric_tax_percent
                
            } else {
                
                    
            }*/
            setTimeout(function () {
                _this.$store.commit('editRowCalculations');
            }, 200);
        },
        showFabricQtyEditWindow: function showFabricQtyEditWindow(rowData) {
            this.rowData = rowData;
            this.showFabricQtyWindow = true;
        },
        showPurchaseRequestWindow: function showPurchaseRequestWindow(rowData) {
            this.rowData = rowData;
            this.showPurchaseRequest = true;
        },
        showWorkOrderWindow: function showWorkOrderWindow(rowData) {
            var copy_request = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


            rowData.sale_id = this.$store.getters.getSaleMasterDataProps.id;
            rowData.store_id = this.$store.getters.getSaleMasterDataProps.store_id;
            rowData.fabricPriceSlabExists = this.$store.getters.getFabricPriceSlabList.length > 0;

            if (rowData.id === 0) {
                /*
                if(this.$store.getters.getSaleMasterDataProps.sale_status === 0) {
                    this.$emit('saveDraft')
                } else if(this.$store.getters.getSaleMasterDataProps.sale_status === 1) {
                    this.$emit('saveOrder')
                }*/

                if (this.$store.getters.getSaleMasterDataProps.id === 0) {
                    this.$store.dispatch('submitShortcutSale', {
                        props: this.$store.getters.getSaleMasterDataProps,
                        newSaleItemProps: rowData
                    });
                } else {
                    this.$store.dispatch('submitNewSaleItem', rowData);
                }
                rowData.wo_processing = true;
            } else {
                this.wo_confirmed = false;

                if (this.checkIfModuleAccessAvailable('/manageworkorders', rowData.work_order.length === 0 ? 'can_add' : 'can_view')) {
                    this.$store.commit('resetSingleWorkOrderData');
                    this.rowData = rowData;
                    /*if(rowData.work_order.length > 0) {
                        this.$store.state.workOrder.props = rowData.work_order
                    } else {*/

                    this.$store.dispatch('fetchSingleWorkOrder', {
                        work_order_id: rowData.work_order_id,
                        sale_item_id: rowData.id,
                        tailoring_item_id: rowData.tailoring_item_id,
                        customer_id: this.$store.getters.getSaleMasterDataProps.customer_id,
                        combination_item: rowData.is_combination_tailoring_item,
                        combination_item_list: rowData.combination_item_list,
                        download_request: copy_request
                    });

                    //}

                    if (rowData.work_order.length > 0 || rowData.work_order_id > 0) {
                        this.wo_confirmed = true;
                    }

                    this.showWorkOrder = true;
                }
            }
        },
        showPriceEditWindow: function showPriceEditWindow(rowData) {
            if ((this.$store.getters.getSaleMasterDataProps.sale_type === 0 || this.$store.getters.getSaleMasterDataProps.sale_type === 1) && this.$store.getters.getSaleMasterDataProps.e_cart_id === 0) {
                this.rowData = rowData;
                this.showPriceWindow = true;
            } else {
                this.$store.commit('displayMessageAlert', { message: 'Price editing is not allowed!!!', type: 'Warning' });
            }
        },
        updateQty: function updateQty(rowData) {
            var _this2 = this;

            this.$store.commit('editRowCalculations');
            //this.changeFocus('sale_net_total_'+key)
            setTimeout(function () {
                if (_this2.$store.state.preferences.props.sale_step_post_qty === 0) {
                    _this2.showPriceEditWindow(rowData);
                } else if (_this2.$store.state.preferences.props.sale_step_post_qty === 1) {
                    _this2.changeFocus('item_search_field');
                } else if (_this2.$store.state.preferences.props.sale_step_post_qty === 2) {

                    var itemType = _this2.type;
                    if (itemType === 1) {
                        itemType = 0;
                    }
                    if (document.getElementById('item_search_field' + itemType)) {
                        _this2.changeFocus('item_search_field' + itemType);
                    } else {
                        _this2.changeFocus('item_search_field');
                    }
                }
            }, 200);
        },
        updateNetTotal: function updateNetTotal(rowData) {

            var copyRowData = JSON.parse(JSON.stringify(rowData));
            var taxPercent = parseFloat(rowData.tax_percent);
            rowData.alter_net_total = parseFloat(copyRowData.edit_net_total);
            var alter_net_sale_total = rowData.alter_net_total;

            var totalAmountBeforeTax = 0;

            totalAmountBeforeTax = alter_net_sale_total - alter_net_sale_total / (100 + taxPercent) * taxPercent;

            if (parseFloat(rowData.retail_item_id) > 0) {
                rowData.tailoring_unit_rate = 0;
                rowData.tailoring_qty = 0;
                rowData.fabric_unit_rate = 0;
                rowData.fabric_unit_qty = 0;
            } else if (parseFloat(rowData.tailoring_item_id) > 0) {
                rowData.retail_qty = 0;
            }

            rowData.discount_amount = 0;
            rowData.discount_percent = 0;
            rowData.extra_amount = 0;
            rowData.extra_amount_reason = "";
            rowData.extra_charge_unit_rate = 0;
            rowData.extra_charge_unit_discount_amount = 0;

            var tailoring_unit_rate = parseFloat(rowData.tailoring_unit_rate);
            var tailoring_qty = parseInt(rowData.tailoring_qty);
            var totalTailoringPrice = tailoring_unit_rate * parseFloat(tailoring_qty);

            var fabric_unit_rate = parseFloat(rowData.fabric_unit_rate);
            var fabric_unit_qty = parseFloat(rowData.fabric_unit_qty);
            var totalFabricPrice = fabric_unit_rate * (fabric_unit_qty * tailoring_qty);

            if (fabric_unit_qty > 0) {
                var priceForFabric = totalAmountBeforeTax - totalTailoringPrice;
                totalFabricPrice = priceForFabric;

                rowData.fabric_unit_rate = totalFabricPrice / (fabric_unit_qty * tailoring_qty);
            } else if (tailoring_qty > 0) {
                rowData.tailoring_unit_rate = totalAmountBeforeTax / tailoring_qty;
            } else if (rowData.retail_qty > 0) {
                rowData.retail_unit_rate = totalAmountBeforeTax / parseFloat(rowData.retail_qty);
            }

            this.$store.commit('editRowCalculations');
            this.showFabricQtyWindow = false;
            this.showPriceWindow = false;
            this.showPurchaseRequest = false;
            this.showWorkOrder = false;

            this.changeFocus('item_search_field');
        },
        closeWindow: function closeWindow() {
            this.$store.commit('editRowCalculations');
            this.showFabricQtyWindow = false;
            this.showPriceWindow = false;
            this.showPurchaseRequest = false;
            this.showWorkOrder = false;
        },
        updateFabricQty: function updateFabricQty(rowData) {

            var selectedTailoring = rowData.tailoring_detail;

            var required_fabric_unit = selectedTailoring.required_fabric_unit;
            if (selectedTailoring.fabric_unit_remain_flat === 0 && rowData.fabric_info !== null) {
                var fabricConsumptionIndex = selectedTailoring.fabric_consumption_list.findIndex(function (t) {
                    return t.size_id == rowData.size_id && t.fabric_width_id == selectedTailoring.selected_fabric.fabric_width_id;
                });
                if (fabricConsumptionIndex >= 0) {
                    required_fabric_unit = selectedTailoring.fabric_consumption_list[fabricConsumptionIndex].required_fabric_unit;
                }
            }

            rowData.fabric_unit_qty = required_fabric_unit;
        },
        showFabricChangeWindow: function showFabricChangeWindow(rowData) {
            this.rowData = rowData;
            this.showFabric = true;
        },
        changeFabricRate: function changeFabricRate(rowData) {
            if (rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 || rowData.fabric_detail.stitching_rate_flat && !rowData.fabric_price_fixed) {
                rowData.fabric_actual_rate = rowData.fabric_detail.flat_price ? rowData.fabric_detail.flat_price : 0;
                var fabricUnitSalePrice = parseFloat(rowData.fabric_actual_rate);
                rowData.fabric_unit_rate = fabricUnitSalePrice;
            } else if (rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 || rowData.fabric_detail.stitching_rate_flat && rowData.fabric_price_fixed) {
                rowData.fabric_actual_rate = rowData.fabric_detail.sale_price;
                var _fabricUnitSalePrice = parseFloat(rowData.fabric_actual_rate) / parseFloat(rowData.fabric_unit_qty);
                rowData.fabric_unit_rate = _fabricUnitSalePrice;
            }
            this.$store.commit('editRowCalculations');
        },
        viewStock: function viewStock(item_code, unit_name) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this3.$store.dispatch('fetchSingleItemStock', { item_code: item_code, unit_name: unit_name, store_list: _this3.$store.getters.getAccessibleStoreList });

                            case 2:
                                setTimeout(function () {
                                    _this3.show_stock_list = true;
                                }, 1000);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        addAlteration: function addAlteration(rowData) {
            var _this4 = this;

            var retail_detail = JSON.parse(JSON.stringify(rowData.retail_detail));

            var template_name = retail_detail.tailoring_detail.template_name + ', ' + retail_detail.sku_code;
            retail_detail.tailoring_detail.template_name = template_name;
            retail_detail.tailoring_detail.is_fabric_required = 0;
            retail_detail.tailoring_detail.required_fabric_unit = 0;
            retail_detail.tailoring_detail.selected_fabric = { id: 0, sku_code: '', article_name: "", profile_photo: "", cost_price: null,
                sale_price: 0, unit_of_measurement_id: 0, composition: "", fabric_width_id: 0, fabric_price_category_id: null, hsn_sac_code: "",
                tax_percent: 0, fabric_cut_length: 0, item_type: 1, stitching_rate_flat: false, discount_percent: 0, flat_price: 0,
                default_retail_fabric_unit: 0, unit_name: "", closing_stock: 0 };

            this.$store.commit('addNewSaleMasterOrderItem', {
                item_type: 0,
                sale_step_post_qty: this.$store.state.preferences.props.sale_step_post_qty,
                selected_item: retail_detail.tailoring_detail
            });
            setTimeout(function () {
                _this4.$store.commit('editRowCalculations');
            }, 300);
        }
    }
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    computed: {
        getCombinationItems: function getCombinationItems() {
            var _this = this;

            var list = this.rowData.combination_item_list;

            list.forEach(function (element) {
                var tailoringItemIndex = _this.rowData.tailoring_detail.combination_items.findIndex(function (t) {
                    return t.id === element.tailoring_item_id;
                });
                if (tailoringItemIndex >= 0) {
                    element.tailoring_item_name = _this.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name;
                }
            });

            return list;
        }
    },
    methods: {
        closeNormal: function closeNormal() {
            this.changeFocus('sale_net_total_' + this.rowData.key);
            this.$emit('closed');
        },
        closeWindow: function closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce(function (count, element1) {
                return count + parseFloat(element1.fabric_unit_qty);
            }, 0).toFixed(2);
            this.changeFocus('sale_net_total_' + this.rowData.key);
            this.$emit('closed');
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        setTimeout(function () {
            document.getElementById('fabric_field_0_' + _this2.rowData.sl_no).focus();
        }, 300);
    }
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    data: function data() {
        return {
            show_tailoring_discount: false,
            show_fabric_discount: false
        };
    },

    computed: {
        getBillingCurrency: function getBillingCurrency() {
            var _this = this;

            if (this.$store.state.saleMaster.props.billing_currency_id !== null) {
                return this.$store.getters.getCountryList.filter(function (t) {
                    return t.id === _this.$store.state.saleMaster.props.billing_currency_id;
                });
            }
            return [];
        },
        getCombinationItems: function getCombinationItems() {
            var _this2 = this;

            var list = this.rowData.combination_item_list;

            list.forEach(function (element) {
                var tailoringItemIndex = _this2.rowData.tailoring_detail.combination_items.findIndex(function (t) {
                    return t.id === element.tailoring_item_id;
                });
                if (tailoringItemIndex >= 0) {
                    element.tailoring_item_name = _this2.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name;
                }
            });

            return list;
        }
    },
    methods: {
        editNetTotal: function editNetTotal() {
            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;


            if (this.$store.state.saleMaster.props.billing_currency_id > 0 && this.$store.state.saleMaster.props.exchange_rate > 0) {
                this.rowData.alter_net_total = (this.rowData.alter_net_total * this.$store.state.saleMaster.props.exchange_rate).toFixed(2);
            }

            var rowData = this.rowData;

            var taxPercent = parseFloat(this.rowData.tax_percent);
            var alter_net_sale_total = parseFloat(this.rowData.alter_net_total);

            var totalAmountBeforeTax = 0;

            if (source === 1) {
                var taxable_total = parseFloat(this.rowData.taxable_total);
                alter_net_sale_total = taxable_total + taxable_total * taxPercent / 100;
            }

            totalAmountBeforeTax = alter_net_sale_total - alter_net_sale_total / (100 + taxPercent) * taxPercent;

            if (parseFloat(rowData.retail_item_id) > 0) {
                rowData.tailoring_unit_rate = 0;
                rowData.tailoring_qty = 0;
                rowData.fabric_unit_rate = 0;
                rowData.fabric_unit_qty = 0;
            } else if (parseFloat(rowData.tailoring_item_id) > 0) {
                rowData.retail_qty = 0;
            }

            rowData.discount_amount = 0;
            rowData.discount_percent = 0;
            rowData.extra_amount = 0;
            rowData.extra_amount_reason = "";
            rowData.extra_charge_unit_rate = 0;
            rowData.extra_charge_unit_discount_amount = 0;

            var tailoring_unit_rate = parseFloat(rowData.tailoring_unit_rate);
            var tailoring_qty = parseInt(rowData.tailoring_qty);
            var totalTailoringPrice = tailoring_unit_rate * parseFloat(tailoring_qty);

            var fabric_unit_rate = parseFloat(rowData.fabric_unit_rate);
            var fabric_unit_qty = parseFloat(rowData.fabric_unit_qty);
            var totalFabricPrice = fabric_unit_rate * (fabric_unit_qty * tailoring_qty);

            if (fabric_unit_qty > 0) {
                var priceForFabric = totalAmountBeforeTax - totalTailoringPrice;
                totalFabricPrice = priceForFabric;

                rowData.fabric_unit_rate = totalFabricPrice / (fabric_unit_qty * tailoring_qty);
            } else if (tailoring_qty > 0) {
                rowData.tailoring_unit_rate = totalAmountBeforeTax / tailoring_qty;
            } else if (rowData.retail_qty > 0) {
                rowData.retail_unit_rate = totalAmountBeforeTax / parseFloat(rowData.retail_qty);
            }

            this.rowData.alter_net_total = 0;
            if (this.$store.state.preferences.props.sale_step_post_qty === 2) {

                var itemType = rowData.tailoring_item_id > 0 ? 0 : 2;
                if (document.getElementById('item_search_field' + itemType)) {
                    this.changeFocus('item_search_field' + itemType);
                } else {
                    this.changeFocus('item_search_field');
                }
            } else {
                this.changeFocus('item_search_field');
            }

            this.$emit('closed');
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        setTimeout(function () {

            _this3.rowData.taxable_total = parseFloat(_this3.rowData.taxable_total).toFixed(2);
            _this3.rowData.fabric_unit_rate = parseFloat(_this3.rowData.fabric_unit_rate).toFixed(2);

            if (_this3.rowData.tax_percent > 0) {} else {}
            //document.getElementById('alter_net_total_'+(this.rowData.sl_no)).focus();
            document.getElementById('taxable_total_' + _this3.rowData.sl_no).focus();
        }, 300);
    }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    computed: {
        getCombinationItems: function getCombinationItems() {
            var _this = this;

            var list = this.rowData.combination_item_list;

            list.forEach(function (element) {
                var tailoringItemIndex = _this.rowData.tailoring_detail.combination_items.findIndex(function (t) {
                    return t.id === element.tailoring_item_id;
                });
                if (tailoringItemIndex >= 0) {
                    element.tailoring_item_name = _this.rowData.tailoring_detail.combination_items[tailoringItemIndex].template_name;
                }
            });

            return list;
        }
    },
    methods: {
        closeWindow: function closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce(function (count, element1) {
                return count + parseFloat(element1.fabric_unit_qty);
            }, 0);
            this.$emit('closed');
        }
    },
    mounted: function mounted() {
        setTimeout(function () {
            document.getElementById('material_qty').focus();
        }, 300);
    }
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Wrapper__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductionList__ = __webpack_require__(113);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['popup', 'sale_item_index', 'wo_confirmed', 'shortcut'],
  components: { Wrapper: __WEBPACK_IMPORTED_MODULE_0__Wrapper__["a" /* default */], ProductionList: __WEBPACK_IMPORTED_MODULE_1__ProductionList__["a" /* default */] },
  data: function data() {
    return {
      search_text: '',
      activeTab: 'tab-0',
      printTitle: '',
      printSrc: '',
      showPrintWindow: false,
      showProductionList: false,
      sale_item_id: 0,
      show_calendar: false
    };
  },

  computed: {
    getSaleItemId: function getSaleItemId() {
      return this.sale_item_id;
    },
    getPopup: function getPopup() {
      return this.popup;
    },
    isWOConfirmed: function isWOConfirmed() {
      return true; //this.$store.getters.getSaleMasterDataProps.sale_status >0 || 
    },
    getPrintTitle: function getPrintTitle() {
      return this.printTitle;
    },
    getPrintSrc: function getPrintSrc() {
      return this.printSrc;
    },
    isPrintWindowVisible: function isPrintWindowVisible() {
      return this.showPrintWindow;
    },
    getSaleItemList: function getSaleItemList() {
      var _this = this;

      return this.$store.state.saleMaster.props.item_list[this.sale_item_index];
      if (this.sale_item_index !== undefined && this.sale_item_index >= 0) {
        var list = this.$store.state.saleMaster.props.item_list.filter(function (t) {
          return t.sl_no === _this.sale_item_index;
        });
        return list;
      }
      return [];
    }
  },
  methods: {
    printTrial: function printTrial($event) {
      this.printTitle = 'Paper Size: A4';
      this.printSrc = this.master_url + 'target=trialWorkOrder&subpage=print&trial_id=' + $event.trial_id + '&access_token=' + this.$store.getters.getAccessToken;
      this.showPrintWindow = true;
    },
    goBack: function goBack() {
      this.$emit('closed');
    },
    handleDropdownCommand: function handleDropdownCommand(command) {

      if (command == "submitFinal") {

        this.submitWorkOrder(1);
      } else if (command.command == "printWO") {

        this.printTitle = this.$store.getters.getPreferenceProps.print_thermal_wo ? 'Paper Size: Thermal' : 'Paper Size: ' + (this.$store.getters.getPreferenceProps.print_a5_wo ? 'A5' : 'A4');
        this.printSrc = this.master_url + 'target=workOrder&subpage=print&type=multi&work_order_id=' + command.data.id + '&sale_item_id=' + command.data.sale_item_id + '&access_token=' + this.$store.getters.getAccessToken;
        this.showPrintWindow = true;
      } else if (command.command == "printWOQR") {

        this.printTitle = 'Paper Size: Custom';
        this.printSrc = this.master_url + 'target=printQrTag&subpage=print&print_type=workorder&id=0&work_order_id=0&sale_item_id=' + command.data.sale_item_id + '&access_token=' + this.$store.getters.getAccessToken;
        this.showPrintWindow = true;
      } else if (command.command == "viewProductionStatus") {
        this.sale_item_id = command.data.sale_item_id;
        this.showProductionList = true;
      }
    },
    submitWorkOrder: function submitWorkOrder(status) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var proceed, itemListSingle, woPayload, sale_item_index;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                proceed = true;

                _this2.$store.getters.getWorkOrderDataProps.forEach(function (element) {
                  element.work_order_status = status;
                });

                if (!proceed) {
                  _context.next = 23;
                  break;
                }

                if (!(_this2.sale_item_index >= 0)) {
                  _context.next = 22;
                  break;
                }

                itemListSingle = _this2.$store.state.saleMaster.props.item_list[_this2.sale_item_index];


                itemListSingle.work_order = _this2.$store.getters.getWorkOrderDataProps;
                itemListSingle.extra_charge_unit_rate = 0;
                itemListSingle.extra_charge_description = '<ul style="padding: 0px;">';

                itemListSingle.work_order.forEach(function (element) {

                  element.style_list.forEach(function (style) {
                    console.log(JSON.stringify(style));
                    if (style.extra_charge > 0) {
                      itemListSingle.extra_charge_unit_rate = parseFloat(itemListSingle.extra_charge_unit_rate) + parseFloat(style.extra_charge) * parseFloat(style.qty);
                      itemListSingle.extra_charge_description = itemListSingle.extra_charge_description + "<li>" + style.extra_charge_notes + ' @ ' + _this2.formatCurrency(parseFloat(style.extra_charge) * parseFloat(style.qty)) + "</li>";
                    } else if (style.option_detail.option_name && style.option_detail.option_name.length > 0) {
                      itemListSingle.extra_charge_description = itemListSingle.extra_charge_description + "<li>" + style.style_name + ': ' + style.option_detail.option_name + "</li>";
                    }
                  });

                  element.process_list.forEach(function (process) {
                    if (process.is_required && process.extra_charge > 0) {

                      var processCharge = parseFloat(process.extra_charge);
                      var extraChargeDescription = process.process_name;

                      process.option_list.forEach(function (processOption) {
                        if (processOption.id === process.process_option_id) {
                          processCharge = processCharge + parseFloat(processOption.extra_charge);
                        }
                      });

                      itemListSingle.extra_charge_unit_rate = parseFloat(itemListSingle.extra_charge_unit_rate) + processCharge;
                      itemListSingle.extra_charge_description = itemListSingle.extra_charge_description + "<li>" + extraChargeDescription + "</li>";
                    }
                  });
                });

                itemListSingle.extra_charge_description += "</ul>";

                if (!(_this2.sale_item_index >= 0 && _this2.getSaleItemList.id > 0)) {
                  _context.next = 19;
                  break;
                }

                woPayload = JSON.parse(JSON.stringify(_this2.$store.getters.getWorkOrderDataProps));

                woPayload.forEach(function (element) {

                  element.sale_item_id = _this2.getSaleItemList.id;

                  if (_this2.getSaleItemList.combination_item_list.length > 0) {
                    var combinationList = _this2.getSaleItemList.combination_item_list.filter(function (t) {
                      return t.tailoring_item_id === element.tailoring_item_id;
                    });
                    element.sale_sub_item_id = combinationList[0].id;
                  }
                });

                sale_item_index = _this2.sale_item_index !== undefined && _this2.sale_item_index >= 0 ? _this2.sale_item_index : -1;
                _context.next = 16;
                return _this2.$store.dispatch('submitWorkOrderData', { shortcut: _this2.shortcut ? true : false, work_order_list: woPayload, sale_item_index: sale_item_index, sale_id: _this2.$store.state.saleMaster.props.id });

              case 16:

                setTimeout(function () {
                  console.log(_this2.sale_item_index);
                  if (_this2.$store.state.saleMaster.props.item_list[_this2.sale_item_index].work_order_id === 0) {
                    _this2.$store.state.saleMaster.props.item_list[_this2.sale_item_index].work_order = [];
                    _this2.$store.state.saleMaster.props.item_list[_this2.sale_item_index].work_order_id = 1;
                  }
                  _this2.$emit('closed');
                }, 1000);
                _context.next = 20;
                break;

              case 19:
                _this2.$emit('closed');

              case 20:
                _context.next = 23;
                break;

              case 22:
                _this2.$store.dispatch('submitWorkOrderData', { shortcut: _this2.shortcut ? true : false, work_order_list: _this2.$store.getters.getWorkOrderDataProps });

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  },
  mounted: function mounted() {
    if (this.$store.getters.getEmployeeMasterList.length === 0) {
      this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });
    }
    if (this.$store.getters.getTailoringTrialTypeList.length === 0) {
      this.$store.dispatch('fetchTailoringTrialTypeList');
    }
    setTimeout(function () {
      //this.$store.dispatch('lazyLoadWorkOrderSections', this.$store.getters.getWorkOrderDataProps)
    }, 1000);
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__History__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseDetail__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProcessList__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StyleList__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ImageList__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrialWindow__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomerMaster_Form_MeasurementProfile_Index_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CopyItems__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CustomerPhotos__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DisplayWOLoad_vue__ = __webpack_require__(1129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CustomStyle_vue__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ProductionList__ = __webpack_require__(113);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    components: { CustomStyle: __WEBPACK_IMPORTED_MODULE_10__CustomStyle_vue__["a" /* default */], DisplayWOLoad: __WEBPACK_IMPORTED_MODULE_9__DisplayWOLoad_vue__["a" /* default */], CustomerPhotos: __WEBPACK_IMPORTED_MODULE_8__CustomerPhotos__["a" /* default */], CopyItems: __WEBPACK_IMPORTED_MODULE_7__CopyItems__["a" /* default */], ProductionList: __WEBPACK_IMPORTED_MODULE_11__ProductionList__["a" /* default */], History: __WEBPACK_IMPORTED_MODULE_0__History__["a" /* default */], PromiseDetail: __WEBPACK_IMPORTED_MODULE_1__PromiseDetail__["a" /* default */], ProcessList: __WEBPACK_IMPORTED_MODULE_2__ProcessList__["a" /* default */], MeasurementForm: __WEBPACK_IMPORTED_MODULE_6__CustomerMaster_Form_MeasurementProfile_Index_vue__["a" /* default */], StyleList: __WEBPACK_IMPORTED_MODULE_3__StyleList__["a" /* default */], ImageList: __WEBPACK_IMPORTED_MODULE_4__ImageList__["a" /* default */], TrialWindow: __WEBPACK_IMPORTED_MODULE_5__TrialWindow__["a" /* default */] },
    props: ['workOrderData', 'wo_confirmed', 'sale_item_index', 'wo_index', 'shortcut'],
    data: function data() {
        return {
            activeTab: '1',
            activeTab_1: '1'
        };
    },

    computed: {
        getActiveTab: function getActiveTab() {
            return this.activeTab;
        }
    },
    methods: {
        printTrial: function printTrial($event) {
            this.$emit('printTrial', $event);
        },
        tabIsClicked: function tabIsClicked(tab, event) {
            /*if(this.getActiveTab === '2' 
                || this.getActiveTab === '3' 
                    || this.getActiveTab === '4')
            
            if(this.getActiveTab === '2' 
                && this.workOrderData.customer_measurement_profile.length === 0) {
                    //this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } else if(this.getActiveTab === '3' 
                && this.workOrderData.style_list.length === 0) {
                    this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } else if(this.getActiveTab === '4' 
                && this.workOrderData.process_list.length === 0) {
                    this.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: this.workOrderData, activeTab: this.getActiveTab})
            } */
            //
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            if (_this.workOrderData.id > 0 && _this.$store.getters.getSaleMasterDataProps.item_list[_this.sale_item_index].extra_charge_unit_rate > 0) {
                //this.activeTab = '3'
                //this.tabIsClicked(null, null)
            }
        }, 300);
    }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['workOrderData', 'wo_index'],
    methods: {
        downloadWorkOrder: function downloadWorkOrder(workOrderId) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$store.dispatch('fetchSingleWorkOrder', {
                                    wo_index: _this.wo_index,
                                    work_order_id: workOrderId,
                                    sale_item_id_copy: _this.workOrderData.sale_item_id,
                                    sale_item_sub_id_copy: _this.workOrderData.sale_item_sub_id !== null ? _this.workOrderData.sale_item_sub_id : 0,
                                    download_request: true,
                                    download_wo: true
                                });

                            case 2:

                                setTimeout(function () {
                                    //this.$emit('swapTab')
                                }, 1000);

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['workOrderData', 'wo_confirmed'],
    computed: {
        getAppointmentType: function getAppointmentType() {
            return this.workOrderData.appointment_type;
        }
    },
    methods: {
        toggleProcessList: function toggleProcessList() {
            var appointment_type = this.getAppointmentType;
            this.workOrderData.process_list.forEach(function (element) {
                if (element.hidden_process === 1 && appointment_type === 1) {
                    element.is_required = true;
                } else if (element.hidden_process === 2 && appointment_type === 1) {
                    element.is_required = false;
                }

                if (element.hidden_process === 1 && appointment_type === 0) {
                    element.is_required = false;
                } else if (element.hidden_process === 2 && appointment_type === 0) {
                    element.is_required = true;
                }
            });
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.toggleProcessList();
        }, 1000);

        if (!this.wo_confirmed) {

            var sale_item_id = this.workOrderData.sale_item_id;

            if (this.$store.getters.getSaleMasterDataProps.trial_required) {
                this.workOrderData.appointment_type = 1;
            }

            var itemTrial = this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                return t.id === sale_item_id;
            })[0].tailoring_trial_required;
            if (itemTrial) {
                this.workOrderData.appointment_type = itemTrial ? 1 : 0;
            }

            this.workOrderData.special_instruction = this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                return t.id === sale_item_id;
            })[0].notes;

            if (this.workOrderData.appointment_type === 0) {
                //this.workOrderData.appointment_date = this.$store.getters.getSaleMasterDataProps.delivery_date            
            } else {
                    //this.workOrderData.appointment_date = this.$store.getters.getSaleMasterDataProps.trial_date            
                }
        }
    }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['process_list']
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleList_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625f55da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleList_vue__ = __webpack_require__(1112);
function injectStyle (ssrContext) {
  __webpack_require__(1106)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625f55da_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StyleListOption_vue__ = __webpack_require__(1108);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['style_list'],
  components: { StyleListOption: __WEBPACK_IMPORTED_MODULE_0__StyleListOption_vue__["a" /* default */] },
  data: function data() {
    return {
      showOptionWindow: false,
      parentKey: -1
    };
  },

  computed: {
    getParentKey: function getParentKey() {
      return this.parentKey;
    },
    getOptionWindowTitle: function getOptionWindowTitle() {
      if (this.getParentKey >= 0) {
        return this.getStyleList[this.getParentKey].style_name + ' Options';
      }
      return "Error";
    },
    getStyleList: function getStyleList() {
      var styleList = [];

      var key = 0;
      this.style_list.forEach(function (element) {
        element.key = key;
        styleList.push(element);
        key++;
      });
      return styleList;
    }
  },
  methods: {
    openOptionPopup: function openOptionPopup(parentKey) {
      var _this = this;

      this.parentKey = parentKey;

      setTimeout(function () {
        _this.showOptionWindow = true;
      }, 100);
    }
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['parentKey', 'style_list'],
    methods: {
        selectOption: function selectOption(data) {
            if (data.edited_option.length > 0) {
                this.style_list[this.parentKey].edited_option = data.edited_option;
            }
            this.style_list[this.parentKey].option_detail = data;
            this.style_list[this.parentKey].style_choice_option_id = data.id;
            this.style_list[this.parentKey].extra_charge = data.charges;
            this.style_list[this.parentKey].qty = data.qty;
            this.style_list[this.parentKey].extra_charge_notes = (data.qty > 1 ? data.qty + ' x ' : '') + data.option_name + ' ' + this.style_list[this.parentKey].style_name;

            if (data.is_editable && data.edited_option.length === 0) {
                this.style_list[this.parentKey].edited_option = "";
                this.style_list[this.parentKey].option_detail = [];
                this.style_list[this.parentKey].style_choice_option_id = 0;
                this.style_list[this.parentKey].qty = 1;
                this.style_list[this.parentKey].extra_charge = 0;
                this.style_list[this.parentKey].extra_charge_notes = "";
            }

            this.$emit('close');
        }
    }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['image_list'],
    methods: {
        addNewImage: function addNewImage(index, $event) {
            this.image_list[index] = $event;
            this.image_list.push("");
        },
        removeImage: function removeImage(index) {
            var _this = this;

            this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this.image_list.splice(index, 1);
            }).catch(function () {});
        }
    }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerMaster_Form_MeasurementProfile_Index_vue__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StyleList__ = __webpack_require__(260);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { MeasurementForm: __WEBPACK_IMPORTED_MODULE_0__CustomerMaster_Form_MeasurementProfile_Index_vue__["a" /* default */], StyleList: __WEBPACK_IMPORTED_MODULE_1__StyleList__["a" /* default */] },
    props: ['workOrderData'],
    data: function data() {
        return {
            customToolbar: [[{ list: "ordered" }]],
            activeTab: '1',
            trialTab: '1'
        };
    },

    methods: {
        toggleProcessList: function toggleProcessList() {
            var appointment_type = this.workOrderData.appointment_type;
            this.workOrderData.process_list.forEach(function (element) {
                if (element.hidden_process === 1 && appointment_type === 1) {
                    element.is_required = true;
                } else if (element.hidden_process === 2 && appointment_type === 1) {
                    element.is_required = false;
                }

                if (element.hidden_process === 1 && appointment_type === 0) {
                    element.is_required = false;
                } else if (element.hidden_process === 2 && appointment_type === 0) {
                    element.is_required = true;
                }
            });
        },
        addNewImage: function addNewImage(index, $event) {
            this.workOrderData.trial_form.trial_image_list[index] = $event;
            this.workOrderData.trial_form.trial_image_list.push("");
        },
        removeImage: function removeImage(index) {
            var _this = this;

            this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this.workOrderData.trial_form.trial_image_list.splice(index, 1);
            }).catch(function () {});
        },
        printTrial: function printTrial(trialId) {
            //console.log(JSON.stringify(this.workOrderData))
            this.$emit('printTrial', { trial_id: trialId });
        }
    }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['workOrderData', 'sale_item_index'],
    computed: {
        getSaleItemList: function getSaleItemList() {
            return this.workOrderData.copy_items;
        },
        getItemList: function getItemList() {
            return [];
        }
    },
    methods: {
        selectData: function selectData(data) {
            data.selected = !data.selected;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.workOrderData.copy_items = [];
        if (this.$store.getters.getWorkOrderDataProps.length > 1) {
            this.$store.getters.getWorkOrderDataProps.filter(function (t) {
                return t.tailoring_item_id === _this.workOrderData.tailoring_item_id;
            }).forEach(function (el) {
                var singleItem = JSON.parse(JSON.stringify(_this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                    return t.sl_no !== _this.sale_item_index && t.tailoring_item_id === el.tailoring_item_id;
                })));
                if (singleItem.length > 0) {
                    singleItem.forEach(function (item) {
                        item.selected = false;
                        item.sale_item_id = item.id;
                        item.sale_sub_item_id = 0;
                        item.single_item = true;
                        _this.workOrderData.copy_items.push(item);
                    });
                }

                var subItemList = _this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                    return t.sl_no !== _this.sale_item_index && t.tailoring_detail.is_combination_item === 1;
                });

                if (subItemList.length > 0) {
                    subItemList.forEach(function (mainItem) {
                        var combination_item_list = JSON.parse(JSON.stringify(mainItem.combination_item_list.filter(function (t) {
                            return t.tailoring_item_id === el.tailoring_item_id;
                        })));
                        combination_item_list.forEach(function (item) {
                            item.selected = false;
                            item.sl_no = mainItem.sl_no;
                            item.sale_item_id = mainItem.id;
                            item.sale_sub_item_id = item.id;
                            item.single_item = false;
                            _this.workOrderData.copy_items.push(item);
                        });
                    });
                }
            });
        } else {
            var copyItems = JSON.parse(JSON.stringify(this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                return t.sl_no !== _this.sale_item_index && t.tailoring_item_id === _this.workOrderData.tailoring_item_id;
            })));
            copyItems.forEach(function (item) {
                item.selected = false;
                item.sale_item_id = item.id;
                item.sale_sub_item_id = 0;
                item.single_item = true;
                _this.workOrderData.copy_items.push(item);
            });
        }
    }
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['image_list']
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['workOrderData'],
    methods: {
        fetchWorkOrderLoad: function fetchWorkOrderLoad() {
            this.$store.dispatch('workOrderLoad', {
                sale_item_id: this.workOrderData.sale_item_id,
                category_id: this.workOrderData.category_id,
                tailoring_item_id: this.workOrderData.tailoring_item_id,
                appointment_date: this.workOrderData.appointment_date
            });
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['customer_style_sheet'],
  data: function data() {
    return {};
  }
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Production_WorkOrderAssignmentHistory__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProductionItemIssue_Index_vue__ = __webpack_require__(111);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['sale_id', 'sale_item_id', 'allow_delivery', 'quickView', 'payroll', 'calendar_source'],
    components: { ProductionItemIssue: __WEBPACK_IMPORTED_MODULE_1__ProductionItemIssue_Index_vue__["default"], WorkOrderAssignmentHistory: __WEBPACK_IMPORTED_MODULE_0__Production_WorkOrderAssignmentHistory__["a" /* default */] },
    data: function data() {
        return {
            delivery_item_list: [],
            master_payload: null,
            search_term: '',
            production_title: '',
            show_assignment_history: false,
            production_id: 0,
            show_item_issue_window: false,
            selected_row: null
        };
    },

    computed: {
        getSelectedRowData: function getSelectedRowData() {
            return this.selected_row;
        },
        getSelectedProductionId: function getSelectedProductionId() {
            return this.production_id;
        },
        getProductionTitle: function getProductionTitle() {
            return this.production_title;
        },
        getDeliveryItemList: function getDeliveryItemList() {
            return this.delivery_item_list;
        },
        getItemList: function getItemList() {
            var _this = this;

            var list = this.$store.getters.getProductionWorkOrderAutocompleteList;

            var returnList = [];

            list.forEach(function (element) {
                if (_this.allow_delivery && element.production_id === null) {
                    returnList.push(element);
                } else {
                    returnList.push(element);
                }
            });
            return returnList;
        }
    },
    methods: {
        convertToInventory: function convertToInventory(rowData) {
            var _this2 = this;

            this.$confirm('Are you sure to convert?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this2.$store.dispatch('convertToInventory', rowData);

                setTimeout(function () {
                    rowData.inventory_converted = true;
                }, 1000);
            }).catch(function () {});
        },
        loadProductionWorkHistory: function loadProductionWorkHistory(rowData) {
            this.production_title = rowData.work_order_number;
            this.production_id = rowData.id;
            this.show_assignment_history = true;
        },
        deliver: function deliver(rowData, hasItemIndex) {
            if (hasItemIndex >= 0) {
                this.delivery_item_list.splice(hasItemIndex, 1);
            } else {
                this.delivery_item_list.push(rowData);
            }
        },
        confirmOnHold: function confirmOnHold() {
            var _this3 = this;

            if (this.getItemList.filter(function (element) {
                return element.on_hold && element.on_hold_remarks === null;
            }).length > 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please provide remarks for on-hold items', type: 'Error' });
                return;
            }

            this.$confirm('Are you sure to proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this3.$store.dispatch('putProductionOrderOnHold', { master_payload: _this3.master_payload, item_list: _this3.getItemList });
            }).catch(function () {});
        },
        createDeliveryReceipt: function createDeliveryReceipt() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this4.$store.commit('resetSaleDeliveryData');
                                _this4.$store.state.saleDelivery.props.customer_id = _this4.$store.getters.getSaleMasterDataProps.customer_id;

                                _context.next = 4;
                                return _this4.$store.dispatch('fetchCustomerMasterAutocompleteList', { load_delivery_receipt: true, customer_id: _this4.$store.getters.getSaleMasterDataProps.customer_id });

                            case 4:

                                _this4.$store.commit('appendBreadcrumbs', {
                                    crumbName: 'Delivery Receipts'
                                });

                                _this4.$emit('closed');

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        issueRawMaterials: function issueRawMaterials(rowData) {
            if (this.checkIfModuleAccessAvailable('/issuerawmaterials', 'can_add')) {
                this.selected_row = {
                    work_order_number: rowData.work_order_number,
                    id: rowData.id,
                    tailoring_item_id: rowData.tailoring_item_id
                };
                this.show_item_issue_window = true;
            }
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        this.$store.commit('resetProductionAutoCompleteList');
        setTimeout(function () {
            _this5.master_payload = {
                show_all: true,
                sale_item_id: _this5.sale_item_id,
                sale_id: _this5.sale_id,
                store_list: _this5.$store.getters.getAccessibleStoreList,
                no_limit: true
            };
            _this5.$store.dispatch('fetchProductionWorkOrderAutocompleteList', _this5.master_payload);
        }, 200);
    }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QCWindow__ = __webpack_require__(536);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { QCWindow: __WEBPACK_IMPORTED_MODULE_0__QCWindow__["a" /* default */] },
    props: ['production_id'],
    data: function data() {
        return {
            show_qc_window: false,
            row_data: []
        };
    },

    computed: {
        getRowData: function getRowData() {
            return this.row_data;
        },
        getProductionData: function getProductionData() {
            var _this = this;

            var list = this.$store.getters.getProductionWorkOrderList;

            if (list.filter(function (t) {
                return t.id == _this.production_id;
            }).length > 0) {
                return list.filter(function (t) {
                    return t.id == _this.production_id;
                })[0];
            }

            return null;
        }
    },
    methods: {
        handleRowDropdownCommand: function handleRowDropdownCommand(command) {
            if (command.command == 'qcSheet') {
                this.row_data = command.rowData;
                this.show_qc_window = true;
            } else if (command.command == 'update') {
                this.submitUpdate(command.rowData);
            } else if (command.command == 'restart') {
                this.restartProcess(command.rowData);
            } else if (command.command == 'assignWO') {

                var findRowIndex = this.$store.state.production.assignment_history.findIndex(function (t) {
                    return t.id === command.rowData.id;
                });

                if (this.$store.state.production.assignment_history.length > findRowIndex + 1) {
                    command.rowData.work_status = 4;
                    this.submitUpdate(command.rowData);
                } else {
                    this.$emit('markAsFinishFromHistory', { command: 'assignWO', action_type: 'finish', production_work_row: this.getProductionData });
                }
            }
        },
        submitUpdate: function submitUpdate(rowData) {
            this.$store.dispatch('updateWorkOrderAssignmentHistory', rowData);
        },
        restartProcess: function restartProcess(rowData) {
            var _this2 = this;

            this.$confirm('Are you sure to proceed?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this2.$store.dispatch('restartProductionProcess', {
                    production_id: rowData.production_id,
                    work_order_process_id: rowData.work_order_process_id
                });
            }).catch(function () {});
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('fetchWorkOrderAssignmentHistory', { production_id: this.production_id });
    }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['row_data', 'read_only'],
    computed: {
        getQCChart: function getQCChart() {
            return this.row_data.qc_chart;
        },
        getRowData: function getRowData() {
            return this.row_data;
        }
    },
    methods: {
        processQC: function processQC(action_type) {
            var _this = this;

            this.$confirm('Are you sure to submit?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(function () {
                _this.submitQC(action_type);
            }).catch(function () {});
        },
        submitQC: function submitQC(action_type) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var itemPlacementRackNumber;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                itemPlacementRackNumber = "";

                                if (!_this2.$store.getters.getPreferenceProps.production_assign_work_order_rack_number) {
                                    _context.next = 5;
                                    break;
                                }

                                _this2.$prompt('Mention Item Placement Rack No.', 'Request', {
                                    confirmButtonText: 'OK',
                                    cancelButtonText: 'Cancel'
                                }).then(function (_ref) {
                                    var value = _ref.value;

                                    if (value.length === 0) {
                                        _this2.$alert('Rack no. is required, please try again!!!', 'Error');
                                        return;
                                    }
                                    itemPlacementRackNumber = value;
                                    _this2.$store.dispatch('updateWorkOrderAssignment', {
                                        action_type: action_type,
                                        production_id: _this2.getRowData.id,
                                        work_log_id: _this2.getRowData.production_work_log_id,
                                        worker_id: _this2.getRowData.worker_id,
                                        work_order_process_id: _this2.getRowData.work_order_process_id,
                                        process_id: _this2.getRowData.process_id,
                                        sub_tailoring_item_id: _this2.getRowData.sub_tailoring_item_id,
                                        tailoring_item_id: _this2.getRowData.tailoring_item_id,
                                        remarks: _this2.getRowData.remarks,
                                        qc_chart: _this2.getQCChart,
                                        item_placement_rack_number: itemPlacementRackNumber,
                                        update_finished_item: false,
                                        trial: _this2.getRowData.appointment_type === 1
                                    });
                                }).catch(function () {
                                    _this2.$alert('Rack no. is required, please try again!!!', 'Error');
                                    return;
                                });
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return _this2.$store.dispatch('updateWorkOrderAssignment', {
                                    action_type: action_type,
                                    production_id: _this2.getRowData.id,
                                    work_log_id: _this2.getRowData.production_work_log_id,
                                    worker_id: _this2.getRowData.worker_id,
                                    work_order_process_id: _this2.getRowData.work_order_process_id,
                                    process_id: _this2.getRowData.process_id,
                                    sub_tailoring_item_id: _this2.getRowData.sub_tailoring_item_id,
                                    tailoring_item_id: _this2.getRowData.tailoring_item_id,
                                    remarks: _this2.getRowData.remarks,
                                    qc_chart: _this2.getQCChart,
                                    item_placement_rack_number: itemPlacementRackNumber,
                                    update_finished_item: false,
                                    trial: _this2.getRowData.appointment_type === 1
                                });

                            case 7:

                                setTimeout(function () {
                                    _this2.$emit('closed');
                                }, 1000);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        setTimeout(function () {
            if (_this3.getQCChart === null) {
                _this3.row_data.qc_chart = [];
            }
            if (_this3.getQCChart.length === 0) {
                var list = [];
                var key = 0;
                _this3.$store.getters.getItemCategoryDataProps.quality_point_list.forEach(function (element) {
                    list.push({
                        key: key,
                        quality_point: element.quality_point,
                        status: 0, //1=ok, 2=reject
                        comment: ''
                    });
                    key++;
                });
                _this3.$store.getters.getProductionStageDataProps.quality_point_list.forEach(function (element) {
                    list.push({
                        key: key,
                        quality_point: element.quality_point,
                        status: 0, //1=ok, 2=reject
                        comment: ''
                    });
                    key++;
                });

                if (list.length === 0) {
                    list.push({
                        key: 0,
                        quality_point: 'Everything OK?',
                        status: 0,
                        comment: ''
                    });
                }
                _this3.row_data.qc_chart = list;
            }
        }, 1000);
    }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Basic_vue__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ItemList_vue__ = __webpack_require__(1151);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    components: { Basic: __WEBPACK_IMPORTED_MODULE_0__Basic_vue__["a" /* default */], ItemList: __WEBPACK_IMPORTED_MODULE_1__ItemList_vue__["a" /* default */] },
    data: function data() {
        return {
            showPrintWindow: false,
            printSrc: '',
            printTitle: ''
        };
    },

    computed: {
        getPrintTitle: function getPrintTitle() {
            return this.printTitle;
        },
        getPrintSrc: function getPrintSrc() {
            return this.printSrc;
        },
        isPrintWindowVisible: function isPrintWindowVisible() {
            return this.showPrintWindow;
        }
    },
    methods: {
        submit: function submit() {
            var payload = JSON.parse(JSON.stringify(this.$store.getters.getProductionItemIssueDataProps));

            if (payload.issued_to_staff_id === null || payload.issued_to_staff_id === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select the issued to employee', type: 'Error' });
                document.getElementById('sourced_by_staff_id').focus();
                return;
            } else if (payload.issued_by_staff_id === null || payload.issued_by_staff_id === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select the issued by employee', type: 'Error' });
                document.getElementById('delivered_by_staff_id').focus();
                return;
            }

            this.$store.dispatch('submitProductionItemIssueData', payload);
        },
        changeStatus: function changeStatus(status) {
            var _this = this;

            this.$store.getters.getProductionItemIssueDataProps.status = status;

            setTimeout(function () {
                _this.submit();
            }, 300);
        },
        handleDropdownCommand: function handleDropdownCommand(command) {
            var _this2 = this;

            if (command == "printPO") {
                this.printTitle = 'Paper Size: A4';
                this.printSrc = this.master_url + 'target=purchaseOrder&subpage=print&purchase_order_id=' + this.$store.getters.getProductionItemIssueDataProps.id + '&access_token=' + this.$store.getters.getAccessToken;
                this.showPrintWindow = true;
            } else if (command == "emailPO") {
                this.$confirm('Are you sure to proceed?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(function () {
                    _this2.printTitle = 'Processing Mail';
                    _this2.printSrc = _this2.master_url + 'target=purchaseOrder&subpage=email&purchase_order_id=' + _this2.$store.getters.getProductionItemIssueDataProps.id + '&access_token=' + _this2.$store.getters.getAccessToken;
                    _this2.showPrintWindow = true;
                }).catch(function () {});
            }
        },
        printRcpt: function printRcpt() {
            this.printTitle = 'Paper Size: A4';
            this.printSrc = this.master_url + 'target=productionItemIssue&subpage=print&sourcing_id=' + this.$store.getters.getProductionItemIssueDataProps.id + '&access_token=' + this.$store.getters.getAccessToken;
            this.showPrintWindow = true;
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });

        this.$store.commit('resetProductionItemIssueData');
    }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    methods: {
        loadSearchedItem: function loadSearchedItem($event) {

            var loadData = $event;
            this.$store.state.productionItemIssue.props.work_order_number = loadData.work_order_number;
            this.$store.state.productionItemIssue.props.production_id = loadData.id;
            this.$store.state.productionItemIssue.props.tailoring_item_id = loadData.sub_tailoring_item_id && loadData.sub_tailoring_item_id !== null ? loadData.sub_tailoring_item_id : loadData.tailoring_item_id;

            this.$store.dispatch('fetchProductionItemIssueData', {
                id: 0,
                production_id: this.$store.state.productionItemIssue.props.production_id,
                work_order_number: this.$store.state.productionItemIssue.props.work_order_number,
                tailoring_item_id: this.$store.state.productionItemIssue.props.tailoring_item_id,
                item_issue_mode: true
            });
        },
        searchWorkOrderAutoComplete: function searchWorkOrderAutoComplete(query) {
            this.$store.dispatch('fetchProductionWorkOrderAutocompleteList', { query: query, customer_id: 0, store_list: this.$store.getters.getAccessibleStoreList });
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            if (_this.rowData) {
                _this.$store.state.productionItemIssue.props.work_order_number = _this.rowData.work_order_number;
                _this.loadSearchedItem(_this.rowData);
            }
        }, 1000);
    }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            showInventoryMaster: false,
            key: -1,
            show_qr_window: false
        };
    },

    computed: {
        getKey: function getKey() {
            return this.key;
        },
        getLoading: function getLoading() {
            return this.$store.state.inventoryMaster.loading;
        }
    },
    methods: {
        openQRScanner: function openQRScanner(key) {
            this.key = key;
            this.show_qr_window = true;
        },
        onDecode: function onDecode($event) {
            this.searchSKUCode($event);
            this.show_qr_window = false;
            this.changeFocus('inventory_item_id_' + this.key);
        },
        loadProductDetails: function loadProductDetails(key) {
            var skuId = this.$store.state.productionItemIssue.props.item_list[key].inventory_item_id;
            if (skuId !== null) {
                var itemIndex = this.$store.getters.getInventoryMasterAutocompleteList.findIndex(function (t) {
                    return t.id === parseInt(skuId);
                });
                if (itemIndex >= 0) {

                    var itemDetail = this.$store.getters.getInventoryMasterAutocompleteList[itemIndex];

                    this.$store.state.productionItemIssue.props.item_list[key].item_detail = { id: itemDetail.id, sku_code: itemDetail.sku_code, article_name: itemDetail.article_name, unit_name: itemDetail.unit_name };

                    this.$store.state.productionItemIssue.props.item_list[key].item_edit = 1;
                    setTimeout(function () {
                        document.getElementById('qty_' + key).focus();
                    }, 200);
                }
            }
        },
        searchSKUCode: function searchSKUCode(query) {
            this.$store.dispatch('fetchInventoryMasterAutocompleteList', { query: query, search_raw_material_only: true, search_column: ['sku_code', 'article_name'], store_id: this.$store.state.productionItemIssue.props.store_id });
        },
        addRow: function addRow(key) {
            var itemId = this.$store.state.productionItemIssue.props.item_list[key].inventory_item_id;
            if (itemId === null || itemId === 0) {
                this.$store.commit('displayMessageAlert', { message: 'Please select a SKU code', type: 'Error' });
                return;
            }
            this.$store.state.productionItemIssue.props.item_list[key].item_edit = false;
            this.$store.commit('addNewProductionItemIssueItemListRow');
        },
        addNewArticle: function addNewArticle(key) {
            this.$store.commit('resetInventoryMasterData');
            this.key = key;
            this.showInventoryMaster = true;
        },
        closeInventoryWindow: function closeInventoryWindow($event) {
            var _this = this;

            this.showInventoryMaster = false;
            if ($event.id > 0) {
                this.$store.state.productionItemIssue.props.item_list[this.getKey].item_detail = $event;
                this.$store.state.productionItemIssue.props.item_list[this.getKey].inventory_item_id = $event.id;
                this.$store.state.productionItemIssue.props.item_list[this.getKey].item_edit = 1;
                setTimeout(function () {
                    _this.loadProductDetails();
                }, 300);
            }
        },
        disableEdit: function disableEdit(key) {
            this.$store.state.productionItemIssue.props.item_list[key].item_edit = 0;
        },
        checkIfInventoryAddAccessGiven: function checkIfInventoryAddAccessGiven(key) {

            var routeIndex = this.$store.getters.getAccessibleMenu.findIndex(function (t) {
                return t.route_path == '/inventoryproducts';
            });
            var routeAccessInfo = this.$store.getters.getAccessibleMenu[routeIndex];

            if (routeAccessInfo.can_add) {
                this.addNewArticle(key);
            } else {
                this.$store.commit('displayMessageAlert', { message: 'You do not have access to inventory master form', type: 'Error' });
                return;
            }
        }
    }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InventoryMaster_Form_Index_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { InventoryMaster: __WEBPACK_IMPORTED_MODULE_0__InventoryMaster_Form_Index_vue__["default"] },
  props: ['title', 'rowData'],
  data: function data() {
    return {
      search_text: '',
      fabric_info: null,
      active: 0,
      showInventoryMaster: false,
      show_search_window: false
    };
  },

  computed: {
    getFabricInfo: function getFabricInfo() {
      return this.rowData.fabric_detail;
    },
    getSelectedFabric: function getSelectedFabric() {
      return this.$store.state.saleMaster.fabric;
    },
    getSearchText: function getSearchText() {
      return this.search_text;
    },
    getLoading: function getLoading() {
      return this.$store.state.inventoryMaster.loading;
    },
    isMobileDevice: function isMobileDevice() {
      return __WEBPACK_IMPORTED_MODULE_1_mobile_device_detect__["isMobile"];
    }
  },
  methods: {
    closeInventoryWindow: function closeInventoryWindow($event) {
      this.changeFocus('fabric_item_search_field');
      this.searchSKUCode($event.sku_code);
      this.showInventoryMaster = false;
    },
    checkIfInventoryAddAccessGiven: function checkIfInventoryAddAccessGiven() {

      if (this.checkIfModuleAccessAvailable('/inventoryproducts', 'can_add')) {
        this.$store.commit('resetInventoryMasterData');
        this.$store.state.inventoryMaster.props.item_type = 1;
        this.showInventoryMaster = true;
      }
    },
    loadLocalFabric: function loadLocalFabric($event) {
      var _this = this;

      this.rowData.fabric_id = $event.id;
      this.rowData.fabric_detail = $event;
      var fabric_sales_price = parseFloat($event.sale_price);
      var fabric_actual_rate = fabric_sales_price;
      var fabric_price_fixed = false;
      if (this.rowData.tailoring_detail.fabric_sales_price_remains_flat === 1) {
        fabric_sales_price = (parseFloat(fabric_sales_price) / parseFloat(this.rowData.required_fabric_unit)).toFixed(2);
        fabric_price_fixed = true;
      } else if ($event.fabric_price_category_id !== null && $event.fabric_price_category_id > 0) {
        fabric_sales_price = (parseFloat(fabric_sales_price) / parseFloat(this.rowData.required_fabric_unit)).toFixed(2);
        fabric_price_fixed = true;
      } else if ($event.stitching_rate_flat) {
        fabric_sales_price = (parseFloat(fabric_sales_price) / parseFloat(this.rowData.required_fabric_unit)).toFixed(2);
        fabric_price_fixed = true;
      } else if ($event.fabric_info !== null && $event.default_tailoring_consumption && $event.default_tailoring_consumption > 0) {
        this.rowData.fabric_unit_qty = parseFloat($event.default_tailoring_consumption);
      }

      this.rowData.fabric_price_fixed = fabric_price_fixed;
      this.rowData.fabric_actual_rate = fabric_actual_rate;
      this.rowData.fabric_unit_rate = fabric_sales_price;

      setTimeout(function () {
        _this.$store.commit('editRowCalculations');
        _this.closeClicked();
      }, 300);
    },
    closeClicked: function closeClicked() {
      this.$emit('closed');
    },
    searchSKUCode: function searchSKUCode(query, cb) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$store.dispatch('fetchInventoryMasterAutocompleteList', {
                  query: query,
                  search_fabric_only: true,
                  search_column: ['sku_code', 'article_name'],
                  store_id: _this2.getWarehouseId > 0 ? _this2.getWarehouseId : _this2.$store.state.saleMaster.props.store_id
                });

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    searchSKU2: function searchSKU2() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$store.dispatch('fetchInventoryMasterAutocompleteList', {
                  query: _this3.search_text,
                  search_fabric_only: true,
                  search_column: ['sku_code', 'article_name'],
                  store_id: _this3.getWarehouseId > 0 ? _this3.getWarehouseId : _this3.$store.state.saleMaster.props.store_id
                });

              case 2:
                if (_this3.isMobileDevice) {
                  setTimeout(function () {
                    _this3.show_search_window = true;
                  }, 300);
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  mounted: function mounted() {
    setTimeout(function () {
      document.getElementById('fabric_item_search_field').focus();
    }, 300);
    this.$store.commit('resetInventoryMasterAutocompleteList');
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['rowData'],
    computed: {
        getSaleCostSheet: function getSaleCostSheet() {
            return this.$store.state.saleMaster.sales_cost_sheet;
        },
        getTotalCost: function getTotalCost() {
            var fabric_cost = parseFloat(this.getSaleCostSheet.fabric_cost);
            var piece_rate_total = parseFloat(this.getSaleCostSheet.piece_rate_total);
            var fixed_salary_rate = parseFloat(this.getSaleCostSheet.fixed_salary_rate);
            var material_cost = parseFloat(this.getSaleCostSheet.material_cost);
            var markup = parseFloat(this.getSaleCostSheet.markup);

            return fabric_cost + piece_rate_total + fixed_salary_rate + material_cost;
        },
        getTotalSale: function getTotalSale() {
            var fabric_cost = parseFloat(this.getSaleCostSheet.fabric_cost);
            var piece_rate_total = parseFloat(this.getSaleCostSheet.piece_rate_total);
            var fixed_salary_rate = parseFloat(this.getSaleCostSheet.fixed_salary_rate);
            var material_cost = parseFloat(this.getSaleCostSheet.material_cost);
            var markup = parseFloat(this.getSaleCostSheet.markup);

            var total = fabric_cost + piece_rate_total + fixed_salary_rate + material_cost;
            return total + total * markup / 100;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$store.state.saleMaster.sales_cost_sheet = null;
        setTimeout(function () {
            _this.$store.dispatch('fetchCostSheet', { sale_item_id: _this.rowData.id });
        }, 1000);
    }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['selected_list_item_id'],
    computed: {
        getTrialScheduleList: function getTrialScheduleList() {
            return this.$store.state.saleMaster.trial_schedule_list;
        }
    },
    methods: {
        closeNormal: function closeNormal() {
            this.changeFocus('sale_net_total_' + this.rowData.key);
            this.$emit('closed');
        },
        closeWindow: function closeWindow() {
            this.rowData.fabric_unit_qty = this.rowData.combination_item_list.reduce(function (count, element1) {
                return count + parseFloat(element1.fabric_unit_qty);
            }, 0).toFixed(2);
            this.changeFocus('sale_net_total_' + this.rowData.key);
            this.$emit('closed');
        }
    },
    mounted: function mounted() {
        var _this = this;

        setTimeout(function () {
            _this.$store.state.saleMaster.trial_schedule_list = [];
            _this.$store.dispatch('fetchTrialSchedule', { sale_item_id: _this.selected_list_item_id });
        }, 300);
    }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1174);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['popup', 'source', 'source_id', 'readonly'],
    components: { List: __WEBPACK_IMPORTED_MODULE_0__List__["a" /* default */] },
    computed: {
        getResultKeys: function getResultKeys() {
            return [{ value: "t1.payment_date", label: "Payment Date", date_field: true }, { value: "t1.payment_date_array", label: "Payment Date Range", date_range_field: true }, { value: "t1.additional_notes", label: "Additional Notes" }, { value: "t2.locality_name", label: "Locality Name", store_list: true }, { value: "t4.company_name", label: "Company Name" }, { value: "t4.customer_name", label: "Customer Name" }, { value: "t5.mode_name", label: "Mode Name" }, { value: "t6.sale_number", label: "Sale Number" }, { value: "t6.external_number", label: "External Sale Number" }];
        }
    },
    methods: {
        createNew: function createNew() {
            this.$store.commit('resetCustomerPaymentData');
            if (this.popup) {
                if (this.checkIfModuleAccessAvailable('/customerpayment', 'can_add')) {
                    this.$emit('openPaymentForm');
                }
            } else {
                this.$router.push(this.$router.currentRoute.fullPath + '/form/');
            }
        },
        loadList: function loadList($event) {
            this.$store.state.customerPayment.nav.search_term = $event.search_term;
            this.$store.state.customerPayment.nav.total = 0;
            this.$store.state.customerPayment.nav.page_number = 1;
            this.$store.state.customerPayment.nav.search_term_array = $event.search_term_array;
            this.$store.dispatch('fetchCustomerPaymentList', { store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav });
        }
    },
    mounted: function mounted() {
        var _this = this;

        if (this.$store.getters.getPaymentModeList.length === 0) {
            this.$store.dispatch('fetchPaymentModeList');
        }
        this.$store.commit('resetSaleMasterOutstandingList');
        setTimeout(function () {
            if (!_this.popup) {
                _this.loadList({ search_term: _this.$store.state.customerPayment.nav.search_term, search_term_array: _this.$store.state.customerPayment.nav.search_term_array });
            } else {
                _this.$store.dispatch('fetchCustomerPaymentList', {
                    store_list: [{ store_id: 0 }],
                    sale_id: _this.$store.getters.getSaleMasterDataProps.id
                });
            }
        }, 1000);
    }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['popup', 'source', 'source_id', 'readonly'],
    data: function data() {
        return {
            paidAmount: 0,
            redeemed_amount: 0,
            showPrintWindow: false,
            printSrc: '',
            printTitle: ''
        };
    },

    computed: {
        getPrintTitle: function getPrintTitle() {
            return this.printTitle;
        },
        getPrintSrc: function getPrintSrc() {
            return this.printSrc;
        },
        isPrintWindowVisible: function isPrintWindowVisible() {
            return this.showPrintWindow;
        }
    },
    methods: {
        navigateButton: function navigateButton() {
            this.$store.dispatch('fetchCustomerPaymentList', { store_list: this.$store.getters.getAccessibleStoreList, nav: this.$store.state.customerPayment.nav });
        },
        headerClick: function headerClick($column) {
            this.$store.state.customerPayment.nav.sort_column_name = $column.property;
            var sortDirection = this.$store.state.customerPayment.nav.sort_direction;
            if (sortDirection === 0) {
                this.$store.state.customerPayment.nav.sort_direction = 1;
            } else {
                this.$store.state.customerPayment.nav.sort_direction = 0;
            }

            this.navigateButton();
        },
        getSummaries: function getSummaries(param) {
            var _this = this;

            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 2) {
                    sums[index] = '';
                    return;
                } else if (index === 3) {
                    _this.paidAmount = data.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.paid_amount)) ? count + parseFloat(element1.paid_amount) : count + 0;
                    }, 0);
                    sums[index] = _this.formatCurrency(_this.paidAmount);
                    return;
                } else if (index === 4) {
                    _this.redeemed_amount = data.reduce(function (count, element1) {
                        return !isNaN(parseFloat(element1.redeemed_amount)) ? count + parseFloat(element1.redeemed_amount) : count + 0;
                    }, 0);
                    sums[index] = _this.formatCurrency(_this.redeemed_amount);
                    return;
                } else if (index === 5) {
                    sums[index] = '';
                    return;
                } else if (index === 6) {
                    sums[index] = '';
                    return;
                }
            });
            return sums;
        },
        openForm: function openForm(payload) {
            if (this.popup) {
                if (this.checkIfModuleAccessAvailable('/customerpayment', 'can_edit')) {
                    this.$emit('openPaymentForm');
                    payload.navigate = false;
                    this.$store.dispatch('fetchCustomerPaymentData', payload);
                }
            } else {
                this.$store.dispatch('fetchCustomerPaymentData', payload);
            }
        },
        deleteData: function deleteData(rowScope) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this2.popup) {
                                    _context.next = 7;
                                    break;
                                }

                                if (!_this2.checkIfModuleAccessAvailable('/customerpayment', 'can_delete')) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 4;
                                return _this2.$store.dispatch('deleteCustomerPaymentData', {
                                    id: rowScope.id,
                                    customer_id: rowScope.customer_id,
                                    sale_id: rowScope.sale_id,
                                    store_list: _this2.$store.getters.getAccessibleStoreList,
                                    list: { store_list: _this2.$store.getters.getAccessibleStoreList, nav: _this2.$store.state.customerPayment.nav }
                                });

                            case 4:
                                setTimeout(function () {
                                    _this2.$emit('closed');
                                }, 1000);

                            case 5:
                                _context.next = 8;
                                break;

                            case 7:
                                if (_this2.checkIfModuleAccessAvailable('/customerpayment', 'can_delete')) {
                                    _this2.$store.dispatch('deleteCustomerPaymentData', {
                                        id: rowScope.id,
                                        customer_id: rowScope.customer_id,
                                        sale_id: rowScope.sale_id,
                                        store_list: _this2.$store.getters.getAccessibleStoreList,
                                        list: { store_list: _this2.$store.getters.getAccessibleStoreList, nav: _this2.$store.state.customerPayment.nav }
                                    });
                                }

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        printRcpt: function printRcpt(paymentId, command) {
            var _this3 = this;

            if (command == "print") {
                this.printTitle = 'Paper Size: A5';
                this.printSrc = this.master_url + 'target=customerPayment&subpage=print&customer_payment_id=' + paymentId + '&access_token=' + this.$store.getters.getAccessToken;
                this.showPrintWindow = true;
            } else if (command == "email") {
                this.$confirm('Are you sure to proceed?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(function () {
                    _this3.printTitle = 'Processing Mail';
                    _this3.printSrc = _this3.master_url + 'target=customerPayment&subpage=email&customer_payment_id=' + paymentId + '&access_token=' + _this3.$store.getters.getAccessToken;
                    _this3.showPrintWindow = true;
                }).catch(function () {});
            }
        },
        createNew: function createNew() {
            this.$store.commit('resetCustomerPaymentData');
            if (this.popup) {
                if (this.checkIfModuleAccessAvailable('/customerpayment', 'can_add')) {
                    this.$emit('openPaymentForm');
                }
            } else {
                this.$router.push(this.$router.currentRoute.fullPath + '/form/');
            }
        }
    }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['data_list'],
    computed: {
        getNoWOList: function getNoWOList() {
            return this.$store.getters.getSaleMasterDataProps.item_list.filter(function (t) {
                return t.work_order_id === 0 && t.tailoring_item_id > 0;
            });
        },
        getDistinctSaleItemId: function getDistinctSaleItemId() {
            return this.data_list.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.sale_item_id === thing.sale_item_id && t.qty_sl_no === thing.qty_sl_no;
                });
            });
        },
        getDistinctSingleItemList: function getDistinctSingleItemList() {
            return this.data_list.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.tailoring_item_id === thing.tailoring_item_id && t.sub_tailoring_item_id === null && t.process_name === thing.process_name && t.delivered === thing.delivered && t.fabric_id === thing.fabric_id;
                });
            });
        },
        getDistinctComboItemList: function getDistinctComboItemList() {
            return this.data_list.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.tailoring_item_id === thing.tailoring_item_id && t.sub_tailoring_item_id !== null && t.process_name === thing.process_name && t.delivered === thing.delivered && t.fabric_id === thing.fabric_id;
                });
            });
        }
    }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['customer_id', 'plannerSource', 'searchType'],
    data: function data() {
        return {
            appointment_date: new Date(),
            selectAll: false
        };
    },

    computed: {
        getDataList: function getDataList() {
            return this.$store.state.production.ready_order_detail_list;
        },
        getMasterStageList: function getMasterStageList() {
            return this.$store.getters.getProductionStageList;
        },
        getFinalList: function getFinalList() {
            var _this = this;

            var returnList = [];

            this.getDataList.forEach(function (element) {

                var newElement = {
                    id: element.id,
                    current_store_id: element.current_store_id,
                    customer_name: element.customer_name,
                    work_order_id: element.work_order_id,
                    work_order_number: element.work_order_number,
                    sale_id: element.sale_id,
                    sale_number: element.sale_number,
                    sl_no: element.sl_no,
                    qty_sl_no: element.qty_sl_no,
                    template_name: element.sub_template_name !== null ? element.sub_template_name : element.template_name,
                    appointment_date: element.appointment_date,
                    appointment_date_changed: element.appointment_date_changed,
                    schedule_notes: element.schedule_notes,
                    appointment_type: element.appointment_type,
                    selected: element.selected,
                    priority: {
                        added_to_priority: element.added_to_priority === 1,
                        priority_date: element.priority_date,
                        priority_notes: element.priority_notes,
                        priority_number: element.priority_number
                    }
                };

                _this.getMasterStageList.forEach(function (stage) {
                    var stageFilter = element.required_stages.filter(function (t) {
                        return t.process_id === stage.id;
                    });
                    if (stageFilter.length > 0) {
                        var workLog = stageFilter[0].work_log;

                        var node = stage.process_name;
                        var obj1 = newElement;

                        var workStatus = 0;
                        if (workLog.work_status) {
                            workStatus = workLog.work_status;
                        }
                        if (workLog.hidden_process) {
                            if (workLog.hidden_process >= 0 && stageFilter[0].is_required) {
                                workStatus = 4;
                            }
                        }

                        obj1[node] = {
                            id: stage.id,
                            is_required: stageFilter[0].is_required,
                            work_staus: workStatus,
                            staff_name: workLog.staff_name ? workLog.staff_name : '',
                            started_at: workLog.started_at_changed_time ? workLog.started_at_changed_time : '',
                            finished_at: workLog.finished_at_changed_time ? workLog.finished_at_changed_time : ''
                        };
                    }
                });

                returnList.push(newElement);
            });

            if (this.searchType && this.searchType === 2) {
                return returnList.filter(function (t) {
                    return t.priority.added_to_priority;
                });
            }
            return returnList;
        }
    },
    methods: {
        notifyCustomerReadyItems: function notifyCustomerReadyItems() {
            this.$store.dispatch('notifyCustomerForReadyItems', {
                customer_id_list: [this.customer_id]
            });
        },
        updateScheduledDate: function updateScheduledDate(rowData) {
            var _this2 = this;

            var show_detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            this.$store.dispatch('updateScheduledDate', { id: rowData.id,
                work_order_id: rowData.work_order_id,
                sale_id: rowData.sale_id,
                customer_id: this.customer_id,
                schedule_notes: rowData.schedule_notes,
                appointment_date: rowData.appointment_date,
                show_detail: show_detail,
                plannerSource: this.plannerSource ? true : false });

            setTimeout(function () {
                _this2.$emit('closed');
            }, 1000);
        },
        updateAllPromise: function updateAllPromise() {
            var _this3 = this;

            var key = 0;
            var filterList = this.getFinalList.filter(function (t) {
                return t.selected;
            });
            filterList.forEach(function (element) {
                element.appointment_date = _this3.appointment_date;
                _this3.updateScheduledDate(element, key === filterList.length - 1);
                setTimeout(function () {}, 500);
                key++;
            });

            this.$emit('closed');
        },
        updatePriority: function updatePriority(rowData) {
            this.$store.dispatch('updatePriority', { id: rowData.id, priority: rowData.priority });
        },
        selectAllRows: function selectAllRows() {
            if (this.selectAll) {
                this.$store.state.production.ready_order_detail_list.forEach(function (element) {
                    element.selected = true;
                });
            } else {
                this.$store.state.production.ready_order_detail_list.forEach(function (element) {
                    element.selected = false;
                });
            }
        }
    }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary_vue__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProcessList_Index_vue__ = __webpack_require__(1193);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Summary: __WEBPACK_IMPORTED_MODULE_0__Summary_vue__["a" /* default */], ProcessList: __WEBPACK_IMPORTED_MODULE_1__ProcessList_Index_vue__["a" /* default */] },
    props: ['data_list', 'searchType', 'calendar_view'],
    data: function data() {
        return {
            active_tab: "1",
            sub_active_tab: "1",
            store_id: null,
            item_list: [],
            display_window: false
        };
    },

    methods: {
        addTask: function addTask($event) {
            this.$emit('addTask', $event);
        },
        loadCustomerInvoiceList: function loadCustomerInvoiceList($event) {
            this.$emit('loadCustomerInvoiceList', $event);
        },
        navigateMasterProductionQuery: function navigateMasterProductionQuery($event) {
            this.$emit('navigateMasterProductionQuery', $event);
        },
        downloadItemCSVList: function downloadItemCSVList(masterItemList) {
            var _this = this;

            if (masterItemList) {
                masterItemList.forEach(function (item) {

                    item.item_list.filter(function (t) {
                        return _this.getStoreId > 0 ? t.store_id === _this.getStoreId : t.store_id > 0;
                    }).forEach(function (item1) {
                        _this.item_list.push(item1);
                    });
                });
                this.$store.dispatch('downloadCSV', { data: this.getCSVItemList, title: 'All_Item_Promises' });
            }
        }
    },
    computed: {
        getCSVItemList: function getCSVItemList() {

            var dataList = [];
            this.item_list.forEach(function (element) {
                dataList.push(element);
            });

            var data = [];

            var returnData = {
                wo_number: 'WO#',
                promise_date: 'Promise Date',
                customer: 'Customer',
                category: 'Category Name',
                sub_category: 'Sub-Category',
                garment_name: 'Garment',
                process_name: 'Current Process',
                status: 'work_order_status'
            };

            data.push(returnData);
            var allItemCategoryList = this.$store.getters.getAllItemCategoryList;

            dataList.forEach(function (element) {

                var subCategoryIndex = allItemCategoryList.findIndex(function (t) {
                    return t.id === element.sub_category_id;
                });

                var returnData = {
                    wo_number: element.work_order_number,
                    promise_date: element.appointment_date,
                    customer: element.customer_name,
                    category: element.category_name,
                    sub_category: subCategoryIndex >= 0 ? allItemCategoryList[subCategoryIndex].sub_category_name : '',
                    garment_name: element.template_name,
                    process_name: element.process_name,
                    status: element.work_order_status
                };

                data.push(returnData);
            });
            return data;
        },
        getStoreId: function getStoreId() {
            return this.store_id;
        },
        getCategoryWiseList: function getCategoryWiseList() {
            var _this2 = this;

            var list = [];

            this.$store.getters.getItemCategoryList.forEach(function (category) {

                var procsessWiseList = [];

                _this2.$store.getters.getProductionStageList.forEach(function (process) {

                    var itemList = _this2.data_list.filter(function (t) {
                        return t.category_id == category.id || t.sub_template_category_id !== null && t.sub_template_category_id == category.id;
                    });
                    procsessWiseList.push({
                        process_id: process.id,
                        process_name: process.process_name,
                        item_list: itemList.filter(function (t) {
                            return t.process_id == process.id;
                        })
                    });
                });

                list.push({
                    category_id: category.id,
                    category_name: category.category_name,
                    item_list: procsessWiseList
                });
            });

            return list;
        },
        getCategoryWiseAllItem: function getCategoryWiseAllItem() {
            var _this3 = this;

            var list = [];

            this.$store.getters.getItemCategoryList.forEach(function (category) {

                var itemList = _this3.data_list.filter(function (t) {
                    return t.category_id == category.id || t.sub_template_category_id !== null && t.sub_template_category_id == category.id;
                });

                itemList.forEach(function (element) {
                    list.push(element);
                });
            });

            return list;
        }
    },
    mounted: function mounted() {
        var _this4 = this;

        setTimeout(function () {
            _this4.display_window = true;
        }, 3000);
    }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReadyOrders_DetailList_vue__ = __webpack_require__(539);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { DetailList: __WEBPACK_IMPORTED_MODULE_0__ReadyOrders_DetailList_vue__["a" /* default */] },
    props: ['data_list', 'searchType', 'calendar_view'],
    data: function data() {
        return {
            selected_list: [],
            selected_customer_name: '',
            show_detail_list: false,
            search_term: '',
            search_term_1: '',
            dd_priority_date: '',
            promise_date_array: [],
            processing: false,
            page_number: 1

        };
    },

    computed: {
        getCSVItemList: function getCSVItemList() {

            var dataList = [];
            this.data_list.forEach(function (element) {
                dataList.push(element);
            });

            var data = [];

            var returnData = {
                wo_number: 'WO#',
                promise_date: 'Promise Date',
                customer: 'Customer',
                category: 'Category Name',
                sub_category: 'Sub-Category',
                garment_name: 'Garment',
                process_name: 'Current Process',
                status: 'work_order_status'
            };

            data.push(returnData);

            var allItemCategoryList = this.$store.getters.getAllItemCategoryList;

            dataList.forEach(function (element) {

                var subCategoryIndex = allItemCategoryList.findIndex(function (t) {
                    return t.id === element.sub_category_id;
                });

                var returnData = {
                    wo_number: element.work_order_number,
                    promise_date: element.appointment_date_changed,
                    customer: element.customer_name,
                    category: element.category_name,
                    sub_category: subCategoryIndex >= 0 ? allItemCategoryList[subCategoryIndex].sub_category_name : '',
                    garment_name: element.template_name,
                    process_name: element.process_name,
                    status: element.work_order_status
                };

                data.push(returnData);
            });
            return data;
        },
        getCSVList: function getCSVList() {
            var _this = this;

            var data = [];

            var returnData = {
                customer_id: 'Cust#',
                customer: 'Name',
                promise_date: 'Promise Date',
                promise_type: 'Type',
                total_orders: 'Total Orders',
                trial_ready: 'Trial Ready',
                delivery_ready: 'Delivery Ready'
            };

            this.$store.getters.getItemCategoryList.forEach(function (category) {

                var categoryFilter = _this.data_list.filter(function (t) {
                    return t.category_id === category.id || t.sub_template_category_id === category.id;
                });
                var node = category.category_name;
                var obj = returnData;
                if (categoryFilter.length > 0) {
                    obj[node] = category.category_name;
                } else {
                    obj[node] = 0;
                }

                node = category.category_name + ' Ready';
                obj = returnData;
                if (categoryFilter.length > 0) {
                    obj[node] = category.category_name + ' Ready';
                } else {
                    obj[node] = 0;
                }
            });

            data.push(returnData);

            this.getDistinctCustomers.forEach(function (element) {

                var returnData = {
                    customer_id: element.customer_code,
                    customer: element.customer_name,
                    promise_date: _this.changeDate(element.appointment_date), //element.sale_appointment_date_changed,
                    promise_type: element.appointment_type === 0 ? 'Delivery' : 'Trial',
                    total_orders: _this.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id;
                    }).length,
                    trial_ready: _this.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id && t.hidden_process == 1;
                    }).length,
                    delivery_ready: _this.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id && t.hidden_process == 2;
                    }).length
                };

                _this.$store.getters.getItemCategoryList.forEach(function (category) {

                    var categoryFilter = _this.data_list.filter(function (t) {
                        return (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id;
                    });
                    var node = category.category_name;
                    var obj = returnData;
                    if (categoryFilter.length > 0) {
                        obj[node] = categoryFilter.length;
                    } else {
                        obj[node] = 0;
                    }

                    node = category.category_name + ' Ready';
                    obj = returnData;
                    if (categoryFilter.length > 0) {
                        obj[node] = _this.data_list.filter(function (t) {
                            return (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id && t.hidden_process > 0;
                        }).length;
                    } else {
                        obj[node] = 0;
                    }
                });

                data.push(returnData);
            });
            return data;
        },
        getResultKeys: function getResultKeys() {
            var payload = [{ value: "t2.appointment_date", label: "Promise Date", date_field: true }, { value: "t2.appointment_date_array", label: "Promise Date Range", date_range_field: true }, { value: "t6.customer_name", label: "Customer Name" }, { value: "t6.company_name", label: "Company Name" }];

            return payload;
        },
        getSelectedCustomerName: function getSelectedCustomerName() {
            return this.selected_customer_name;
        },
        getSelectedCustomerId: function getSelectedCustomerId() {
            return this.selected_customer_id;
        },
        getSelectedList: function getSelectedList() {
            return this.selected_list;
        },
        getDistinctCustomers: function getDistinctCustomers() {
            var _this2 = this;

            var returnList = this.data_list;

            var filterList = returnList;
            if (this.search_term.length > 0) {
                filterList = returnList.filter(function (t) {
                    return t.customer_name.toLowerCase().match(_this2.search_term.toLowerCase());
                });
            }

            var list = filterList.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.customer_id === thing.customer_id;
                });
            });

            return list;
        },
        getFinalList: function getFinalList() {
            var _this3 = this;

            var returnList = [];

            this.getDistinctCustomers.forEach(function (element) {

                var dd_activity = element.dd_activity;
                var dd_status = element.dd_status;
                var dd_promise_date = element.dd_promise_date;
                var dd_notes = element.dd_notes;
                var dd_sales_coordinator = element.dd_sales_coordinator;
                var dd_priority_date = element.dd_priority_date;

                if (dd_activity === null || dd_activity.length === 0) {
                    dd_activity = element.appointment_type === 0 ? 'Delivery' : 'Trial';
                }
                if (dd_promise_date === null || dd_promise_date.length === 0) {
                    dd_promise_date = element.appointment_date;
                }
                if (dd_priority_date === null || dd_priority_date.length === 0) {
                    dd_priority_date = dd_promise_date;
                }
                if (dd_sales_coordinator === null || dd_sales_coordinator === 0) {
                    dd_sales_coordinator = element.sale_person_staff_id;
                }

                var newElement = {
                    customer_id: element.customer_id,
                    customer_code: element.customer_code,
                    store_id: element.store_id,
                    customer_name: element.customer_name,
                    promise_type: element.appointment_type,
                    appointment_date: element.appointment_date,
                    appointment_date_changed: element.sale_appointment_date !== null ? element.sale_appointment_date_changed : element.appointment_date_changed,
                    total_orders: _this3.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id;
                    }).length,
                    trial_ready: _this3.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id && t.hidden_process == 1;
                    }),
                    delivery_ready: _this3.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id && t.hidden_process == 2;
                    }),
                    dd_activity: dd_activity,
                    dd_status: dd_status,
                    dd_promise_date: dd_promise_date,
                    dd_priority_date: dd_priority_date,
                    dd_notes: dd_notes,
                    dd_sales_coordinator: dd_sales_coordinator,
                    work_order_list: _this3.data_list.filter(function (t) {
                        return t.customer_id === element.customer_id;
                    })
                };

                _this3.$store.getters.getItemCategoryList.forEach(function (category) {

                    var categoryFilter = _this3.data_list.filter(function (t) {
                        return (t.category_id === category.id || t.sub_template_category_id === category.id) && t.customer_id === element.customer_id;
                    });
                    if (categoryFilter.length > 0) {

                        var node = category.category_name;
                        var obj = newElement;
                        obj[node] = {
                            data_list: categoryFilter
                        };
                    }
                });

                returnList.push(newElement);
            });

            return returnList;
        }
    },
    methods: {
        addTask: function addTask($event) {
            this.$emit('addTask', $event);
        },
        handleDropdownCommand: function handleDropdownCommand(command) {
            if (command == 'downloadOverview') {
                this.$store.dispatch('downloadCSV', { data: this.getCSVList, title: 'All_Customer_Promises' });
            } else if (command == 'downloadList') {
                this.$store.dispatch('downloadCSV', { data: this.getCSVItemList, title: 'All_Item_Promises' });
            }
        },
        handleSizeChange: function handleSizeChange($val) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this4.$store.state.master.default_page_limit = parseInt($val);
                                _context.next = 3;
                                return _this4.$store.dispatch('updatePageLimit', { limit: _this4.$store.state.master.default_page_limit });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        updateAllPromises: function updateAllPromises() {
            var _this5 = this;

            this.processing = true;
            this.promise_date_array.forEach(function (element) {
                _this5.submitCustomerDD(element);
            });

            setTimeout(function () {
                _this5.processing = false;
                _this5.promise_date_array = [];
            }, 2000);
        },
        addToPromiseDateArray: function addToPromiseDateArray(rowData) {
            var _this6 = this;

            /*rowData.work_order_list.forEach(workOrder => {
                this.promise_date_array.push(workOrder.work_order_id)
            })*/
            if (this.promise_date_array.findIndex(function (t) {
                return t.customer_id === rowData.customer_id;
            }) < 0) {
                this.promise_date_array.push(rowData);
            }

            setTimeout(function () {
                rowData.work_order_list.forEach(function (workOrder) {

                    var filterIndex = _this6.$store.state.production.planner.list.future_orders.findIndex(function (t) {
                        return t.work_order_id == workOrder.work_order_id;
                    });

                    if (filterIndex >= 0) {

                        var dateValue = new Date(rowData.appointment_date);
                        var monthValue = dateValue.getUTCMonth();

                        var monthName = _this6.masterMonthShort[monthValue];

                        var monthDisplay = monthName + " " + dateValue.getUTCFullYear();

                        _this6.$store.state.production.planner.list.future_orders[filterIndex].work_order_month = monthDisplay;
                        _this6.$store.state.production.planner.list.future_orders[filterIndex].appointment_date = rowData.appointment_date;
                        _this6.$store.state.production.planner.list.future_orders[filterIndex].appointment_date_changed = _this6.changeDate(rowData.appointment_date);

                        if (dateValue < new Date()) {
                            _this6.$store.state.production.planner.list.future_orders[filterIndex].failed = true;
                        } else {
                            _this6.$store.state.production.planner.list.future_orders[filterIndex].failed = false;
                        }
                    }
                });
            }, 1000);
        },
        submitCustomerDD: function submitCustomerDD(rowData) {

            var work_orders = [];

            rowData.work_order_list.forEach(function (workOrder) {
                work_orders.push(workOrder.work_order_id);
            });

            rowData.work_orders = work_orders;
            this.$store.dispatch('submitCustomerDD', rowData);
        },
        loadList: function loadList($event) {
            this.$store.state.production.nav.search_term = $event.search_term;
            this.$store.state.production.nav.total = 0;
            this.$store.state.production.nav.page_number = 1;
            this.$store.state.production.nav.search_term_array = $event.search_term_array;
            this.navigateButton();
        },
        clearSearch: function clearSearch() {
            this.search_term = '';
            this.navigateButton();
        },
        navigateButton: function navigateButton() {
            this.$emit('navigateMasterProductionQuery');
        },
        openOrderDetails: function openOrderDetails(rowData) {
            this.selected_customer_id = rowData.customer_id;
            this.selected_customer_name = rowData.customer_name;

            var work_orders = [];
            rowData.work_order_list.forEach(function (workOrder) {
                work_orders.push(workOrder.work_order_id);
            });

            this.$store.dispatch('openCustomerOrderDetails_ProductionStageWise', { customer_id: rowData.customer_id, work_orders: work_orders });
            this.show_detail_list = true;
        },
        getSummaries: function getSummaries(param) {
            var _this7 = this;

            var columns = param.columns,
                data = param.data;

            var sums = [];
            columns.forEach(function (column, index) {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index === 1) {
                    sums[index] = '';
                    return;
                } else if (index === 7) {
                    var total = 0;
                    var readyTotal = 0;
                    _this7.getFinalList.forEach(function (element) {
                        total = total + element.total_orders;
                        if (element.trial_ready.length > 0) {
                            readyTotal = readyTotal + element.trial_ready.length;
                        } else {
                            readyTotal = readyTotal + element.delivery_ready.length;
                        }
                    });
                    sums[index] = total + ' (' + readyTotal + ')';
                    return;
                } else {
                    var key = 8;
                    var _total = 0;
                    var _readyTotal = 0;
                    _this7.$store.getters.getItemCategoryList.forEach(function (element) {
                        _total = 0;
                        _readyTotal = 0;
                        _this7.getFinalList.forEach(function (element1) {
                            if (element1[element.category_name] !== undefined) {
                                _total = _total + element1[element.category_name].data_list.length;
                                _readyTotal = _readyTotal + element1[element.category_name].data_list.filter(function (t) {
                                    return t.hidden_process > 0 && t.work_status === 0;
                                }).length;
                            }
                        });
                        if (_readyTotal > 0) {
                            sums[key] = _total + ' (' + _readyTotal + ')';
                        } else {
                            sums[key] = _total;
                        }

                        key++;
                    });

                    //sums[key] = total
                    return;
                }
            });
            return sums;
        }
    }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkOrder_Index_vue__ = __webpack_require__(169);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { WorkOrder: __WEBPACK_IMPORTED_MODULE_0__WorkOrder_Index_vue__["a" /* default */] },
    props: ['data_list', 'searchType', 'store_id', 'calendar_view', 'all_list'],
    data: function data() {
        return {
            work_order_title: '',
            sale_index: 0,
            showWorkOrder: false,
            page_number: 1
        };
    },

    computed: {
        getStoreId: function getStoreId() {
            return this.store_id !== null ? this.store_id : 0;
        }
    },
    methods: {
        togglePriority: function togglePriority(rowData) {
            var toggle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

            if (toggle) {
                rowData.added_to_priority = !rowData.added_to_priority;
            }
            this.$store.dispatch('updatePriority', { id: rowData.id, priority_date: rowData.priority_date, priority: rowData.added_to_priority });
        },
        handleSizeChange: function handleSizeChange($val) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.$store.state.master.default_page_limit = parseInt($val);
                                _context.next = 3;
                                return _this.$store.dispatch('updatePageLimit', { limit: _this.$store.state.master.default_page_limit });

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        openWorkOrder: function openWorkOrder(rowData) {
            if (this.checkIfModuleAccessAvailable('/manageworkorders', 'can_edit')) {

                this.$store.commit('resetSingleWorkOrderData');
                this.rowData = rowData;
                this.$store.dispatch('fetchSingleWorkOrder', {
                    work_order_id: rowData.work_order_id,
                    sale_item_id: rowData.sale_item_id,
                    tailoring_item_id: rowData.tailoring_item_id,
                    customer_id: rowData.customer_id
                });

                this.sale_index = rowData.sl_no;
                this.work_order_title = rowData.work_order_number;
                this.showWorkOrder = true;
            }
        },
        updateScheduledDate: function updateScheduledDate(rowData) {
            var _this2 = this;

            var show_detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


            this.$store.dispatch('updateScheduledDate', { id: rowData.id,
                work_order_id: rowData.work_order_id,
                sale_id: rowData.sale_id,
                customer_id: this.customer_id,
                schedule_notes: rowData.schedule_notes,
                appointment_date: rowData.appointment_date,
                show_detail: show_detail,
                plannerSource: true });

            setTimeout(function () {
                var filterIndex = _this2.$store.state.production.planner.list.future_orders.findIndex(function (t) {
                    return t.work_order_id == rowData.work_order_id;
                });

                if (filterIndex >= 0) {
                    _this2.$store.state.production.planner.list.future_orders[filterIndex].appointment_date = rowData.appointment_date;
                    _this2.$store.state.production.planner.list.future_orders[filterIndex].appointment_date_changed = _this2.changeDate(rowData.appointment_date);
                }
            }, 500);
        }
    }
});

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};module.exports=/******/function(modules){// webpackBootstrap
/******/// The module cache
/******/var installedModules={};/******//******/// The require function
/******/function __webpack_require__(moduleId){/******//******/// Check if module is in cache
/******/if(installedModules[moduleId]){/******/return installedModules[moduleId].exports;/******/}/******/// Create a new module (and put it into the cache)
/******/var module=installedModules[moduleId]={/******/i:moduleId,/******/l:false,/******/exports:{}/******/};/******//******/// Execute the module function
/******/modules[moduleId].call(module.exports,module,module.exports,__webpack_require__);/******//******/// Flag the module as loaded
/******/module.l=true;/******//******/// Return the exports of the module
/******/return module.exports;/******/}/******//******//******/// expose the modules object (__webpack_modules__)
/******/__webpack_require__.m=modules;/******//******/// expose the module cache
/******/__webpack_require__.c=installedModules;/******//******/// define getter function for harmony exports
/******/__webpack_require__.d=function(exports,name,getter){/******/if(!__webpack_require__.o(exports,name)){/******/Object.defineProperty(exports,name,{enumerable:true,get:getter});/******/}/******/};/******//******/// define __esModule on exports
/******/__webpack_require__.r=function(exports){/******/if(typeof Symbol!=='undefined'&&Symbol.toStringTag){/******/Object.defineProperty(exports,Symbol.toStringTag,{value:'Module'});/******/}/******/Object.defineProperty(exports,'__esModule',{value:true});/******/};/******//******/// create a fake namespace object
/******/// mode & 1: value is a module id, require it
/******/// mode & 2: merge all properties of value into the ns
/******/// mode & 4: return value when already ns object
/******/// mode & 8|1: behave like require
/******/__webpack_require__.t=function(value,mode){/******/if(mode&1)value=__webpack_require__(value);/******/if(mode&8)return value;/******/if(mode&4&&(typeof value==='undefined'?'undefined':_typeof2(value))==='object'&&value&&value.__esModule)return value;/******/var ns=Object.create(null);/******/__webpack_require__.r(ns);/******/Object.defineProperty(ns,'default',{enumerable:true,value:value});/******/if(mode&2&&typeof value!='string')for(var key in value){__webpack_require__.d(ns,key,function(key){return value[key];}.bind(null,key));}/******/return ns;/******/};/******//******/// getDefaultExport function for compatibility with non-harmony modules
/******/__webpack_require__.n=function(module){/******/var getter=module&&module.__esModule?/******/function getDefault(){return module['default'];}:/******/function getModuleExports(){return module;};/******/__webpack_require__.d(getter,'a',getter);/******/return getter;/******/};/******//******/// Object.prototype.hasOwnProperty.call
/******/__webpack_require__.o=function(object,property){return Object.prototype.hasOwnProperty.call(object,property);};/******//******/// __webpack_public_path__
/******/__webpack_require__.p="/dist/";/******//******//******/// Load entry module and return exports
/******/return __webpack_require__(__webpack_require__.s=45);/******/}(/************************************************************************//******/[/* 0 *//***/function(module,exports){module.exports=__webpack_require__(1204);/***/},/* 1 *//***/function(module,exports){module.exports=__webpack_require__(43);/***/},/* 2 *//***/function(module,exports){module.exports=__webpack_require__(38);/***/},/* 3 *//***/function(module,exports){module.exports=__webpack_require__(61);/***/},/* 4 *//***/function(module,exports){module.exports=__webpack_require__(146);/***/},/* 5 *//***/function(module,exports){module.exports=__webpack_require__(99);/***/},/* 6 *//***/function(module,exports){module.exports=__webpack_require__(18);/***/},/* 7 *//***/function(module,exports){module.exports=__webpack_require__(100);/***/},/* 8 *//***/function(module,exports){module.exports=__webpack_require__(148);/***/},/* 9 *//***/function(module,exports){module.exports=__webpack_require__(289);/***/},/* 10 *//***/function(module,exports){module.exports=__webpack_require__(290);/***/},/* 11 *//***/function(module,exports){module.exports=__webpack_require__(288);/***/},/* 12 *//***/function(module,exports){module.exports=__webpack_require__(145);/***/},/* 13 *//***/function(module,exports){module.exports=__webpack_require__(1210);/***/},/* 14 *//***/function(module,exports){module.exports=__webpack_require__(291);/***/},/* 15 *//***/function(module,exports){module.exports=__webpack_require__(149);/***/},/* 16 *//***/function(module,exports){module.exports=__webpack_require__(287);/***/},/* 17 *//***/function(module,exports){module.exports=__webpack_require__(102);/***/},/* 18 *//***/function(module,exports){module.exports=__webpack_require__(151);/***/},/* 19 *//***/function(module,exports){module.exports=__webpack_require__(101);/***/},/* 20 *//***/function(module,exports){module.exports=__webpack_require__(286);/***/},/* 21 *//***/function(module,exports){module.exports=__webpack_require__(1212);/***/},/* 22 *//***/function(module,exports){module.exports=__webpack_require__(1213);/***/},/* 23 *//***/function(module,exports){module.exports=__webpack_require__(152);/***/},/* 24 *//***/function(module,exports){module.exports=__webpack_require__(293);/***/},/* 25 *//***/function(module,exports){module.exports=__webpack_require__(150);/***/},/* 26 *//***/function(module,exports){module.exports=__webpack_require__(1214);/***/},/* 27 *//***/function(module,exports){module.exports=__webpack_require__(153);/***/},/* 28 *//***/function(module,exports){module.exports=__webpack_require__(1215);/***/},/* 29 *//***/function(module,exports){module.exports=__webpack_require__(294);/***/},/* 30 *//***/function(module,exports){module.exports=__webpack_require__(147);/***/},/* 31 *//***/function(module,exports){module.exports=__webpack_require__(1216);/***/},/* 32 *//***/function(module,exports){module.exports=__webpack_require__(1217);/***/},/* 33 *//***/function(module,exports){module.exports=__webpack_require__(1218);/***/},/* 34 *//***/function(module,exports){module.exports=__webpack_require__(154);/***/},/* 35 *//***/function(module,exports){module.exports=__webpack_require__(292);/***/},/* 36 *//***/function(module,exports){module.exports=__webpack_require__(1219);/***/},/* 37 *//***/function(module,exports){module.exports=__webpack_require__(1220);/***/},/* 38 *//***/function(module,exports){module.exports=__webpack_require__(1221);/***/},/* 39 *//***/function(module,exports){module.exports=__webpack_require__(1226);/***/},/* 40 *//***/function(module,exports){module.exports=__webpack_require__(1227);/***/},/* 41 *//***/function(module,exports){module.exports=__webpack_require__(1281);/***/},/* 42 *//***/function(module,exports){module.exports=__webpack_require__(1282);/***/},/* 43 *//***/function(module,exports){module.exports=__webpack_require__(306);/***/},/* 44 *//***/function(module,exports){module.exports=__webpack_require__(1283);/***/},/* 45 *//***/function(module,exports,__webpack_require__){module.exports=__webpack_require__(46);/***/},/* 46 *//***/function(module,__webpack_exports__,__webpack_require__){"use strict";__webpack_require__.r(__webpack_exports__);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
var pagervue_type_template_id_7274f267_render=function pagervue_type_template_id_7274f267_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("ul",{staticClass:"el-pager",on:{click:_vm.onPagerClick}},[_vm.pageCount>0?_c("li",{staticClass:"number",class:{active:_vm.currentPage===1,disabled:_vm.disabled}},[_vm._v("1")]):_vm._e(),_vm.showPrevMore?_c("li",{staticClass:"el-icon more btn-quickprev",class:[_vm.quickprevIconClass,{disabled:_vm.disabled}],on:{mouseenter:function mouseenter($event){_vm.onMouseenter("left");},mouseleave:function mouseleave($event){_vm.quickprevIconClass="el-icon-more";}}}):_vm._e(),_vm._l(_vm.pagers,function(pager){return _c("li",{key:pager,staticClass:"number",class:{active:_vm.currentPage===pager,disabled:_vm.disabled}},[_vm._v(_vm._s(pager))]);}),_vm.showNextMore?_c("li",{staticClass:"el-icon more btn-quicknext",class:[_vm.quicknextIconClass,{disabled:_vm.disabled}],on:{mouseenter:function mouseenter($event){_vm.onMouseenter("right");},mouseleave:function mouseleave($event){_vm.quicknextIconClass="el-icon-more";}}}):_vm._e(),_vm.pageCount>1?_c("li",{staticClass:"number",class:{active:_vm.currentPage===_vm.pageCount,disabled:_vm.disabled}},[_vm._v(_vm._s(_vm.pageCount))]):_vm._e()],2);};var staticRenderFns=[];pagervue_type_template_id_7274f267_render._withStripped=true;// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=template&id=7274f267&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/pagination/src/pager.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var pagervue_type_script_lang_js_={name:'ElPager',props:{currentPage:Number,pageCount:Number,pagerCount:Number,disabled:Boolean},watch:{showPrevMore:function showPrevMore(val){if(!val)this.quickprevIconClass='el-icon-more';},showNextMore:function showNextMore(val){if(!val)this.quicknextIconClass='el-icon-more';}},methods:{onPagerClick:function onPagerClick(event){var target=event.target;if(target.tagName==='UL'||this.disabled){return;}var newPage=Number(event.target.textContent);var pageCount=this.pageCount;var currentPage=this.currentPage;var pagerCountOffset=this.pagerCount-2;if(target.className.indexOf('more')!==-1){if(target.className.indexOf('quickprev')!==-1){newPage=currentPage-pagerCountOffset;}else if(target.className.indexOf('quicknext')!==-1){newPage=currentPage+pagerCountOffset;}}/* istanbul ignore if */if(!isNaN(newPage)){if(newPage<1){newPage=1;}if(newPage>pageCount){newPage=pageCount;}}if(newPage!==currentPage){this.$emit('change',newPage);}},onMouseenter:function onMouseenter(direction){if(this.disabled)return;if(direction==='left'){this.quickprevIconClass='el-icon-d-arrow-left';}else{this.quicknextIconClass='el-icon-d-arrow-right';}}},computed:{pagers:function pagers(){var pagerCount=this.pagerCount;var halfPagerCount=(pagerCount-1)/2;var currentPage=Number(this.currentPage);var pageCount=Number(this.pageCount);var showPrevMore=false;var showNextMore=false;if(pageCount>pagerCount){if(currentPage>pagerCount-halfPagerCount){showPrevMore=true;}if(currentPage<pageCount-halfPagerCount){showNextMore=true;}}var array=[];if(showPrevMore&&!showNextMore){var startPage=pageCount-(pagerCount-2);for(var i=startPage;i<pageCount;i++){array.push(i);}}else if(!showPrevMore&&showNextMore){for(var _i=2;_i<pagerCount;_i++){array.push(_i);}}else if(showPrevMore&&showNextMore){var offset=Math.floor(pagerCount/2)-1;for(var _i2=currentPage-offset;_i2<=currentPage+offset;_i2++){array.push(_i2);}}else{for(var _i3=2;_i3<pageCount;_i3++){array.push(_i3);}}this.showPrevMore=showPrevMore;this.showNextMore=showNextMore;return array;}},data:function data(){return{current:null,showPrevMore:false,showNextMore:false,quicknextIconClass:'el-icon-more',quickprevIconClass:'el-icon-more'};}};// CONCATENATED MODULE: ./packages/pagination/src/pager.vue?vue&type=script&lang=js&
/* harmony default export */var src_pagervue_type_script_lang_js_=pagervue_type_script_lang_js_;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.
function normalizeComponent(scriptExports,render,staticRenderFns,functionalTemplate,injectStyles,scopeId,moduleIdentifier,/* server only */shadowMode/* vue-cli only */){// Vue.extend constructor export interop
var options=typeof scriptExports==='function'?scriptExports.options:scriptExports;// render functions
if(render){options.render=render;options.staticRenderFns=staticRenderFns;options._compiled=true;}// functional template
if(functionalTemplate){options.functional=true;}// scopedId
if(scopeId){options._scopeId='data-v-'+scopeId;}var hook;if(moduleIdentifier){// server build
hook=function hook(context){// 2.3 injection
context=context||// cached call
this.$vnode&&this.$vnode.ssrContext||// stateful
this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext;// functional
// 2.2 with runInNewContext: true
if(!context&&typeof __VUE_SSR_CONTEXT__!=='undefined'){context=__VUE_SSR_CONTEXT__;}// inject component styles
if(injectStyles){injectStyles.call(this,context);}// register component module identifier for async chunk inferrence
if(context&&context._registeredComponents){context._registeredComponents.add(moduleIdentifier);}};// used by ssr in case component is cached and beforeCreate
// never gets called
options._ssrRegister=hook;}else if(injectStyles){hook=shadowMode?function(){injectStyles.call(this,this.$root.$options.shadowRoot);}:injectStyles;}if(hook){if(options.functional){// for template-only hot-reload because in that case the render fn doesn't
// go through the normalizer
options._injectStyles=hook;// register for functioal component in vue file
var originalRender=options.render;options.render=function renderWithStyleInjection(h,context){hook.call(context);return originalRender(h,context);};}else{// inject component registration as beforeCreate hook
var existing=options.beforeCreate;options.beforeCreate=existing?[].concat(existing,hook):[hook];}}return{exports:scriptExports,options:options};}// CONCATENATED MODULE: ./packages/pagination/src/pager.vue
/* normalize component */var component=normalizeComponent(src_pagervue_type_script_lang_js_,pagervue_type_template_id_7274f267_render,staticRenderFns,false,null,null,null);/* hot reload */if(false){var api;}component.options.__file="packages/pagination/src/pager.vue";/* harmony default export */var pager=component.exports;// EXTERNAL MODULE: external "element-ui/lib/select"
var select_=__webpack_require__(36);var select_default=/*#__PURE__*/__webpack_require__.n(select_);// EXTERNAL MODULE: external "element-ui/lib/option"
var option_=__webpack_require__(37);var option_default=/*#__PURE__*/__webpack_require__.n(option_);// EXTERNAL MODULE: external "element-ui/lib/input"
var input_=__webpack_require__(8);var input_default=/*#__PURE__*/__webpack_require__.n(input_);// EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
var locale_=__webpack_require__(4);var locale_default=/*#__PURE__*/__webpack_require__.n(locale_);// EXTERNAL MODULE: external "element-ui/lib/utils/util"
var util_=__webpack_require__(2);// CONCATENATED MODULE: ./packages/pagination/src/pagination.js
/* harmony default export */var pagination={name:'ElPagination',props:{pageSize:{type:Number,default:10},small:Boolean,total:Number,pageCount:Number,pagerCount:{type:Number,validator:function validator(value){return(value|0)===value&&value>4&&value<22&&value%2===1;},default:7},currentPage:{type:Number,default:1},layout:{default:'prev, pager, next, jumper, ->, total'},pageSizes:{type:Array,default:function _default(){return[10,20,30,40,50,100];}},popperClass:String,prevText:String,nextText:String,background:Boolean,disabled:Boolean,hideOnSinglePage:Boolean},data:function data(){return{internalCurrentPage:1,internalPageSize:0,lastEmittedPage:-1,userChangePageSize:false};},render:function render(h){var layout=this.layout;if(!layout)return null;if(this.hideOnSinglePage&&(!this.internalPageCount||this.internalPageCount===1))return null;var template=h('div',{'class':['el-pagination',{'is-background':this.background,'el-pagination--small':this.small}]});var TEMPLATE_MAP={prev:h('prev'),jumper:h('jumper'),pager:h('pager',{attrs:{currentPage:this.internalCurrentPage,pageCount:this.internalPageCount,pagerCount:this.pagerCount,disabled:this.disabled},on:{'change':this.handleCurrentChange}}),next:h('next'),sizes:h('sizes',{attrs:{pageSizes:this.pageSizes}}),slot:h('slot',[this.$slots.default?this.$slots.default:'']),total:h('total')};var components=layout.split(',').map(function(item){return item.trim();});var rightWrapper=h('div',{'class':'el-pagination__rightwrapper'});var haveRightWrapper=false;template.children=template.children||[];rightWrapper.children=rightWrapper.children||[];components.forEach(function(compo){if(compo==='->'){haveRightWrapper=true;return;}if(!haveRightWrapper){template.children.push(TEMPLATE_MAP[compo]);}else{rightWrapper.children.push(TEMPLATE_MAP[compo]);}});if(haveRightWrapper){template.children.unshift(rightWrapper);}return template;},components:{Prev:{render:function render(h){return h('button',{attrs:{type:'button',disabled:this.$parent.disabled||this.$parent.internalCurrentPage<=1},'class':'btn-prev',on:{'click':this.$parent.prev}},[this.$parent.prevText?h('span',[this.$parent.prevText]):h('i',{'class':'el-icon el-icon-arrow-left'})]);}},Next:{render:function render(h){return h('button',{attrs:{type:'button',disabled:this.$parent.disabled||this.$parent.internalCurrentPage===this.$parent.internalPageCount||this.$parent.internalPageCount===0},'class':'btn-next',on:{'click':this.$parent.next}},[this.$parent.nextText?h('span',[this.$parent.nextText]):h('i',{'class':'el-icon el-icon-arrow-right'})]);}},Sizes:{mixins:[locale_default.a],props:{pageSizes:Array},watch:{pageSizes:{immediate:true,handler:function handler(newVal,oldVal){if(Object(util_["valueEquals"])(newVal,oldVal))return;if(Array.isArray(newVal)){this.$parent.internalPageSize=newVal.indexOf(this.$parent.pageSize)>-1?this.$parent.pageSize:this.pageSizes[0];}}}},render:function render(h){var _this=this;return h('span',{'class':'el-pagination__sizes'},[h('el-select',{attrs:{value:this.$parent.internalPageSize,popperClass:this.$parent.popperClass||'',size:'mini',disabled:this.$parent.disabled},on:{'input':this.handleChange}},[this.pageSizes.map(function(item){return h('el-option',{attrs:{value:item,label:item+_this.t('el.pagination.pagesize')}});})])]);},components:{ElSelect:select_default.a,ElOption:option_default.a},methods:{handleChange:function handleChange(val){if(val!==this.$parent.internalPageSize){this.$parent.internalPageSize=val=parseInt(val,10);this.$parent.userChangePageSize=true;this.$parent.$emit('update:pageSize',val);this.$parent.$emit('size-change',val);}}}},Jumper:{mixins:[locale_default.a],components:{ElInput:input_default.a},data:function data(){return{userInput:null};},watch:{'$parent.internalCurrentPage':function $parentInternalCurrentPage(){this.userInput=null;}},methods:{handleKeyup:function handleKeyup(_ref){var keyCode=_ref.keyCode,target=_ref.target;// Chrome, Safari, Firefox triggers change event on Enter
// Hack for IE: https://github.com/ElemeFE/element/issues/11710
// Drop this method when we no longer supports IE
if(keyCode===13){this.handleChange(target.value);}},handleInput:function handleInput(value){this.userInput=value;},handleChange:function handleChange(value){this.$parent.internalCurrentPage=this.$parent.getValidCurrentPage(value);this.$parent.emitChange();this.userInput=null;}},render:function render(h){return h('span',{'class':'el-pagination__jump'},[this.t('el.pagination.goto'),h('el-input',{'class':'el-pagination__editor is-in-pagination',attrs:{min:1,max:this.$parent.internalPageCount,value:this.userInput!==null?this.userInput:this.$parent.internalCurrentPage,type:'number',disabled:this.$parent.disabled},nativeOn:{'keyup':this.handleKeyup},on:{'input':this.handleInput,'change':this.handleChange}}),this.t('el.pagination.pageClassifier')]);}},Total:{mixins:[locale_default.a],render:function render(h){return typeof this.$parent.total==='number'?h('span',{'class':'el-pagination__total'},[this.t('el.pagination.total',{total:this.$parent.total})]):'';}},Pager:pager},methods:{handleCurrentChange:function handleCurrentChange(val){this.internalCurrentPage=this.getValidCurrentPage(val);this.userChangePageSize=true;this.emitChange();},prev:function prev(){if(this.disabled)return;var newVal=this.internalCurrentPage-1;this.internalCurrentPage=this.getValidCurrentPage(newVal);this.$emit('prev-click',this.internalCurrentPage);this.emitChange();},next:function next(){if(this.disabled)return;var newVal=this.internalCurrentPage+1;this.internalCurrentPage=this.getValidCurrentPage(newVal);this.$emit('next-click',this.internalCurrentPage);this.emitChange();},getValidCurrentPage:function getValidCurrentPage(value){value=parseInt(value,10);var havePageCount=typeof this.internalPageCount==='number';var resetValue=void 0;if(!havePageCount){if(isNaN(value)||value<1)resetValue=1;}else{if(value<1){resetValue=1;}else if(value>this.internalPageCount){resetValue=this.internalPageCount;}}if(resetValue===undefined&&isNaN(value)){resetValue=1;}else if(resetValue===0){resetValue=1;}return resetValue===undefined?value:resetValue;},emitChange:function emitChange(){var _this2=this;this.$nextTick(function(){if(_this2.internalCurrentPage!==_this2.lastEmittedPage||_this2.userChangePageSize){_this2.$emit('current-change',_this2.internalCurrentPage);_this2.lastEmittedPage=_this2.internalCurrentPage;_this2.userChangePageSize=false;}});}},computed:{internalPageCount:function internalPageCount(){if(typeof this.total==='number'){return Math.max(1,Math.ceil(this.total/this.internalPageSize));}else if(typeof this.pageCount==='number'){return Math.max(1,this.pageCount);}return null;}},watch:{currentPage:{immediate:true,handler:function handler(val){this.internalCurrentPage=this.getValidCurrentPage(val);}},pageSize:{immediate:true,handler:function handler(val){this.internalPageSize=isNaN(val)?10:val;}},internalCurrentPage:{immediate:true,handler:function handler(newVal){this.$emit('update:currentPage',newVal);this.lastEmittedPage=-1;}},internalPageCount:function internalPageCount(newVal){/* istanbul ignore if */var oldPage=this.internalCurrentPage;if(newVal>0&&oldPage===0){this.internalCurrentPage=1;}else if(oldPage>newVal){this.internalCurrentPage=newVal===0?1:newVal;this.userChangePageSize&&this.emitChange();}this.userChangePageSize=false;}}};// CONCATENATED MODULE: ./packages/pagination/index.js
/* istanbul ignore next */pagination.install=function(Vue){Vue.component(pagination.name,pagination);};/* harmony default export */var packages_pagination=pagination;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
var componentvue_type_template_id_60140e62_render=function componentvue_type_template_id_60140e62_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"dialog-fade"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-dialog__wrapper",on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{key:_vm.key,ref:"dialog",class:["el-dialog",{"is-fullscreen":_vm.fullscreen,"el-dialog--center":_vm.center},_vm.customClass],style:_vm.style,attrs:{role:"dialog","aria-modal":"true","aria-label":_vm.title||"dialog"}},[_c("div",{staticClass:"el-dialog__header"},[_vm._t("title",[_c("span",{staticClass:"el-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-dialog__headerbtn",attrs:{type:"button","aria-label":"Close"},on:{click:_vm.handleClose}},[_c("i",{staticClass:"el-dialog__close el-icon el-icon-close"})]):_vm._e()],2),_vm.rendered?_c("div",{staticClass:"el-dialog__body"},[_vm._t("default")],2):_vm._e(),_vm.$slots.footer?_c("div",{staticClass:"el-dialog__footer"},[_vm._t("footer")],2):_vm._e()])])]);};var componentvue_type_template_id_60140e62_staticRenderFns=[];componentvue_type_template_id_60140e62_render._withStripped=true;// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=template&id=60140e62&
// EXTERNAL MODULE: external "element-ui/lib/utils/popup"
var popup_=__webpack_require__(11);var popup_default=/*#__PURE__*/__webpack_require__.n(popup_);// EXTERNAL MODULE: external "element-ui/lib/mixins/migrating"
var migrating_=__webpack_require__(9);var migrating_default=/*#__PURE__*/__webpack_require__.n(migrating_);// EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
var emitter_=__webpack_require__(3);var emitter_default=/*#__PURE__*/__webpack_require__.n(emitter_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dialog/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var componentvue_type_script_lang_js_={name:'ElDialog',mixins:[popup_default.a,emitter_default.a,migrating_default.a],props:{title:{type:String,default:''},modal:{type:Boolean,default:true},modalAppendToBody:{type:Boolean,default:true},appendToBody:{type:Boolean,default:false},lockScroll:{type:Boolean,default:true},closeOnClickModal:{type:Boolean,default:true},closeOnPressEscape:{type:Boolean,default:true},showClose:{type:Boolean,default:true},width:String,fullscreen:Boolean,customClass:{type:String,default:''},top:{type:String,default:'15vh'},beforeClose:Function,center:{type:Boolean,default:false},destroyOnClose:Boolean},data:function data(){return{closed:false,key:0};},watch:{visible:function visible(val){var _this=this;if(val){this.closed=false;this.$emit('open');this.$el.addEventListener('scroll',this.updatePopper);this.$nextTick(function(){_this.$refs.dialog.scrollTop=0;});if(this.appendToBody){document.body.appendChild(this.$el);}}else{this.$el.removeEventListener('scroll',this.updatePopper);if(!this.closed)this.$emit('close');if(this.destroyOnClose){this.$nextTick(function(){_this.key++;});}}}},computed:{style:function style(){var style={};if(!this.fullscreen){style.marginTop=this.top;if(this.width){style.width=this.width;}}return style;}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'size':'size is removed.'}};},handleWrapperClick:function handleWrapperClick(){if(!this.closeOnClickModal)return;this.handleClose();},handleClose:function handleClose(){if(typeof this.beforeClose==='function'){this.beforeClose(this.hide);}else{this.hide();}},hide:function hide(cancel){if(cancel!==false){this.$emit('update:visible',false);this.$emit('close');this.closed=true;}},updatePopper:function updatePopper(){this.broadcast('ElSelectDropdown','updatePopper');this.broadcast('ElDropdownMenu','updatePopper');},afterEnter:function afterEnter(){this.$emit('opened');},afterLeave:function afterLeave(){this.$emit('closed');}},mounted:function mounted(){if(this.visible){this.rendered=true;this.open();if(this.appendToBody){document.body.appendChild(this.$el);}}},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/dialog/src/component.vue?vue&type=script&lang=js&
/* harmony default export */var src_componentvue_type_script_lang_js_=componentvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dialog/src/component.vue
/* normalize component */var component_component=normalizeComponent(src_componentvue_type_script_lang_js_,componentvue_type_template_id_60140e62_render,componentvue_type_template_id_60140e62_staticRenderFns,false,null,null,null);/* hot reload */if(false){var component_api;}component_component.options.__file="packages/dialog/src/component.vue";/* harmony default export */var src_component=component_component.exports;// CONCATENATED MODULE: ./packages/dialog/index.js
/* istanbul ignore next */src_component.install=function(Vue){Vue.component(src_component.name,src_component);};/* harmony default export */var dialog=src_component;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
var autocompletevue_type_template_id_152f2ee6_render=function autocompletevue_type_template_id_152f2ee6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.close,expression:"close"}],staticClass:"el-autocomplete",attrs:{"aria-haspopup":"listbox",role:"combobox","aria-expanded":_vm.suggestionVisible,"aria-owns":_vm.id}},[_c("el-input",_vm._b({ref:"input",on:{input:_vm.handleInput,change:_vm.handleChange,focus:_vm.handleFocus,blur:_vm.handleBlur,clear:_vm.handleClear},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();_vm.highlight(_vm.highlightedIndex-1);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();_vm.highlight(_vm.highlightedIndex+1);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleKeyEnter($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}return _vm.close($event);}]}},"el-input",[_vm.$props,_vm.$attrs],false),[_vm.$slots.prepend?_c("template",{slot:"prepend"},[_vm._t("prepend")],2):_vm._e(),_vm.$slots.append?_c("template",{slot:"append"},[_vm._t("append")],2):_vm._e(),_vm.$slots.prefix?_c("template",{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),_vm.$slots.suffix?_c("template",{slot:"suffix"},[_vm._t("suffix")],2):_vm._e()],2),_c("el-autocomplete-suggestions",{ref:"suggestions",class:[_vm.popperClass?_vm.popperClass:""],attrs:{"visible-arrow":"","popper-options":_vm.popperOptions,"append-to-body":_vm.popperAppendToBody,placement:_vm.placement,id:_vm.id}},_vm._l(_vm.suggestions,function(item,index){return _c("li",{key:index,class:{highlighted:_vm.highlightedIndex===index},attrs:{id:_vm.id+"-item-"+index,role:"option","aria-selected":_vm.highlightedIndex===index},on:{click:function click($event){_vm.select(item);}}},[_vm._t("default",[_vm._v("\n        "+_vm._s(item[_vm.valueKey])+"\n      ")],{item:item})],2);}),0)],1);};var autocompletevue_type_template_id_152f2ee6_staticRenderFns=[];autocompletevue_type_template_id_152f2ee6_render._withStripped=true;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=template&id=152f2ee6&
// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_=__webpack_require__(17);var debounce_default=/*#__PURE__*/__webpack_require__.n(debounce_);// EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
var clickoutside_=__webpack_require__(10);var clickoutside_default=/*#__PURE__*/__webpack_require__.n(clickoutside_);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
var autocomplete_suggestionsvue_type_template_id_cd10dcf0_render=function autocomplete_suggestionsvue_type_template_id_cd10dcf0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-autocomplete-suggestion el-popper",class:{"is-loading":!_vm.parent.hideLoading&&_vm.parent.loading},style:{width:_vm.dropdownWidth},attrs:{role:"region"}},[_c("el-scrollbar",{attrs:{tag:"ul","wrap-class":"el-autocomplete-suggestion__wrap","view-class":"el-autocomplete-suggestion__list"}},[!_vm.parent.hideLoading&&_vm.parent.loading?_c("li",[_c("i",{staticClass:"el-icon-loading"})]):_vm._t("default")],2)],1)]);};var autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns=[];autocomplete_suggestionsvue_type_template_id_cd10dcf0_render._withStripped=true;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=template&id=cd10dcf0&
// EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
var vue_popper_=__webpack_require__(5);var vue_popper_default=/*#__PURE__*/__webpack_require__.n(vue_popper_);// EXTERNAL MODULE: external "element-ui/lib/scrollbar"
var scrollbar_=__webpack_require__(18);var scrollbar_default=/*#__PURE__*/__webpack_require__.n(scrollbar_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var autocomplete_suggestionsvue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},mixins:[vue_popper_default.a,emitter_default.a],componentName:'ElAutocompleteSuggestions',data:function data(){return{parent:this.$parent,dropdownWidth:''};},props:{options:{default:function _default(){return{gpuAcceleration:false};}},id:String},methods:{select:function select(item){this.dispatch('ElAutocomplete','item-click',item);}},updated:function updated(){var _this=this;this.$nextTick(function(_){_this.popperJS&&_this.updatePopper();});},mounted:function mounted(){this.$parent.popperElm=this.popperElm=this.$el;this.referenceElm=this.$parent.$refs.input.$refs.input||this.$parent.$refs.input.$refs.textarea;this.referenceList=this.$el.querySelector('.el-autocomplete-suggestion__list');this.referenceList.setAttribute('role','listbox');this.referenceList.setAttribute('id',this.id);},created:function created(){var _this2=this;this.$on('visible',function(val,inputWidth){_this2.dropdownWidth=inputWidth+'px';_this2.showPopper=val;});}};// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue?vue&type=script&lang=js&
/* harmony default export */var src_autocomplete_suggestionsvue_type_script_lang_js_=autocomplete_suggestionsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete-suggestions.vue
/* normalize component */var autocomplete_suggestions_component=normalizeComponent(src_autocomplete_suggestionsvue_type_script_lang_js_,autocomplete_suggestionsvue_type_template_id_cd10dcf0_render,autocomplete_suggestionsvue_type_template_id_cd10dcf0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var autocomplete_suggestions_api;}autocomplete_suggestions_component.options.__file="packages/autocomplete/src/autocomplete-suggestions.vue";/* harmony default export */var autocomplete_suggestions=autocomplete_suggestions_component.exports;// EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
var focus_=__webpack_require__(23);var focus_default=/*#__PURE__*/__webpack_require__.n(focus_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var autocompletevue_type_script_lang_js_={name:'ElAutocomplete',mixins:[emitter_default.a,focus_default()('input'),migrating_default.a],inheritAttrs:false,componentName:'ElAutocomplete',components:{ElInput:input_default.a,ElAutocompleteSuggestions:autocomplete_suggestions},directives:{Clickoutside:clickoutside_default.a},props:{valueKey:{type:String,default:'value'},popperClass:String,popperOptions:Object,placeholder:String,clearable:{type:Boolean,default:false},disabled:Boolean,name:String,size:String,value:String,maxlength:Number,minlength:Number,autofocus:Boolean,fetchSuggestions:Function,triggerOnFocus:{type:Boolean,default:true},customItem:String,selectWhenUnmatched:{type:Boolean,default:false},prefixIcon:String,suffixIcon:String,label:String,debounce:{type:Number,default:300},placement:{type:String,default:'bottom-start'},hideLoading:Boolean,popperAppendToBody:{type:Boolean,default:true},highlightFirstItem:{type:Boolean,default:false}},data:function data(){return{activated:false,suggestions:[],loading:false,highlightedIndex:-1,suggestionDisabled:false};},computed:{suggestionVisible:function suggestionVisible(){var suggestions=this.suggestions;var isValidData=Array.isArray(suggestions)&&suggestions.length>0;return(isValidData||this.loading)&&this.activated;},id:function id(){return'el-autocomplete-'+Object(util_["generateId"])();}},watch:{suggestionVisible:function suggestionVisible(val){var $input=this.getInput();if($input){this.broadcast('ElAutocompleteSuggestions','visible',[val,$input.offsetWidth]);}}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'custom-item':'custom-item is removed, use scoped slot instead.','props':'props is removed, use value-key instead.'}};},getData:function getData(queryString){var _this=this;if(this.suggestionDisabled){return;}this.loading=true;this.fetchSuggestions(queryString,function(suggestions){_this.loading=false;if(_this.suggestionDisabled){return;}if(Array.isArray(suggestions)){_this.suggestions=suggestions;_this.highlightedIndex=_this.highlightFirstItem?0:-1;}else{console.error('[Element Error][Autocomplete]autocomplete suggestions must be an array');}});},handleInput:function handleInput(value){this.$emit('input',value);this.suggestionDisabled=false;if(!this.triggerOnFocus&&!value){this.suggestionDisabled=true;this.suggestions=[];return;}this.debouncedGetData(value);},handleChange:function handleChange(value){this.$emit('change',value);},handleFocus:function handleFocus(event){this.activated=true;this.$emit('focus',event);if(this.triggerOnFocus){this.debouncedGetData(this.value);}},handleBlur:function handleBlur(event){this.$emit('blur',event);},handleClear:function handleClear(){this.activated=false;this.$emit('clear');},close:function close(e){this.activated=false;},handleKeyEnter:function handleKeyEnter(e){var _this2=this;if(this.suggestionVisible&&this.highlightedIndex>=0&&this.highlightedIndex<this.suggestions.length){e.preventDefault();this.select(this.suggestions[this.highlightedIndex]);}else if(this.selectWhenUnmatched){this.$emit('select',{value:this.value});this.$nextTick(function(_){_this2.suggestions=[];_this2.highlightedIndex=-1;});}},select:function select(item){var _this3=this;this.$emit('input',item[this.valueKey]);this.$emit('select',item);this.$nextTick(function(_){_this3.suggestions=[];_this3.highlightedIndex=-1;});},highlight:function highlight(index){if(!this.suggestionVisible||this.loading){return;}if(index<0){this.highlightedIndex=-1;return;}if(index>=this.suggestions.length){index=this.suggestions.length-1;}var suggestion=this.$refs.suggestions.$el.querySelector('.el-autocomplete-suggestion__wrap');var suggestionList=suggestion.querySelectorAll('.el-autocomplete-suggestion__list li');var highlightItem=suggestionList[index];var scrollTop=suggestion.scrollTop;var offsetTop=highlightItem.offsetTop;if(offsetTop+highlightItem.scrollHeight>scrollTop+suggestion.clientHeight){suggestion.scrollTop+=highlightItem.scrollHeight;}if(offsetTop<scrollTop){suggestion.scrollTop-=highlightItem.scrollHeight;}this.highlightedIndex=index;var $input=this.getInput();$input.setAttribute('aria-activedescendant',this.id+'-item-'+this.highlightedIndex);},getInput:function getInput(){return this.$refs.input.getInput();}},mounted:function mounted(){var _this4=this;this.debouncedGetData=debounce_default()(this.debounce,this.getData);this.$on('item-click',function(item){_this4.select(item);});var $input=this.getInput();$input.setAttribute('role','textbox');$input.setAttribute('aria-autocomplete','list');$input.setAttribute('aria-controls','id');$input.setAttribute('aria-activedescendant',this.id+'-item-'+this.highlightedIndex);},beforeDestroy:function beforeDestroy(){this.$refs.suggestions.$destroy();}};// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue?vue&type=script&lang=js&
/* harmony default export */var src_autocompletevue_type_script_lang_js_=autocompletevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/autocomplete/src/autocomplete.vue
/* normalize component */var autocomplete_component=normalizeComponent(src_autocompletevue_type_script_lang_js_,autocompletevue_type_template_id_152f2ee6_render,autocompletevue_type_template_id_152f2ee6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var autocomplete_api;}autocomplete_component.options.__file="packages/autocomplete/src/autocomplete.vue";/* harmony default export */var autocomplete=autocomplete_component.exports;// CONCATENATED MODULE: ./packages/autocomplete/index.js
/* istanbul ignore next */autocomplete.install=function(Vue){Vue.component(autocomplete.name,autocomplete);};/* harmony default export */var packages_autocomplete=autocomplete;// EXTERNAL MODULE: external "element-ui/lib/button"
var button_=__webpack_require__(13);var button_default=/*#__PURE__*/__webpack_require__.n(button_);// EXTERNAL MODULE: external "element-ui/lib/button-group"
var button_group_=__webpack_require__(28);var button_group_default=/*#__PURE__*/__webpack_require__.n(button_group_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var dropdownvue_type_script_lang_js_={name:'ElDropdown',componentName:'ElDropdown',mixins:[emitter_default.a,migrating_default.a],directives:{Clickoutside:clickoutside_default.a},components:{ElButton:button_default.a,ElButtonGroup:button_group_default.a},provide:function provide(){return{dropdown:this};},props:{trigger:{type:String,default:'hover'},type:String,size:{type:String,default:''},splitButton:Boolean,hideOnClick:{type:Boolean,default:true},placement:{type:String,default:'bottom-end'},visibleArrow:{default:true},showTimeout:{type:Number,default:250},hideTimeout:{type:Number,default:150},tabindex:{type:Number,default:0},disabled:{type:Boolean,default:false}},data:function data(){return{timeout:null,visible:false,triggerElm:null,menuItems:null,menuItemsArray:null,dropdownElm:null,focusing:false,listId:'dropdown-menu-'+Object(util_["generateId"])()};},computed:{dropdownSize:function dropdownSize(){return this.size||(this.$ELEMENT||{}).size;}},mounted:function mounted(){this.$on('menu-item-click',this.handleMenuItemClick);},watch:{visible:function visible(val){this.broadcast('ElDropdownMenu','visible',val);this.$emit('visible-change',val);},focusing:function focusing(val){var selfDefine=this.$el.querySelector('.el-dropdown-selfdefine');if(selfDefine){// 自定义
if(val){selfDefine.className+=' focusing';}else{selfDefine.className=selfDefine.className.replace('focusing','');}}}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'menu-align':'menu-align is renamed to placement.'}};},show:function show(){var _this=this;if(this.disabled)return;clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this.visible=true;},this.trigger==='click'?0:this.showTimeout);},hide:function hide(){var _this2=this;if(this.disabled)return;this.removeTabindex();if(this.tabindex>=0){this.resetTabindex(this.triggerElm);}clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this2.visible=false;},this.trigger==='click'?0:this.hideTimeout);},handleClick:function handleClick(){if(this.disabled)return;if(this.visible){this.hide();}else{this.show();}},handleTriggerKeyDown:function handleTriggerKeyDown(ev){var keyCode=ev.keyCode;if([38,40].indexOf(keyCode)>-1){// up/down
this.removeTabindex();this.resetTabindex(this.menuItems[0]);this.menuItems[0].focus();ev.preventDefault();ev.stopPropagation();}else if(keyCode===13){// space enter选中
this.handleClick();}else if([9,27].indexOf(keyCode)>-1){// tab || esc
this.hide();}},handleItemKeyDown:function handleItemKeyDown(ev){var keyCode=ev.keyCode;var target=ev.target;var currentIndex=this.menuItemsArray.indexOf(target);var max=this.menuItemsArray.length-1;var nextIndex=void 0;if([38,40].indexOf(keyCode)>-1){// up/down
if(keyCode===38){// up
nextIndex=currentIndex!==0?currentIndex-1:0;}else{// down
nextIndex=currentIndex<max?currentIndex+1:max;}this.removeTabindex();this.resetTabindex(this.menuItems[nextIndex]);this.menuItems[nextIndex].focus();ev.preventDefault();ev.stopPropagation();}else if(keyCode===13){// enter选中
this.triggerElmFocus();target.click();if(this.hideOnClick){// click关闭
this.visible=false;}}else if([9,27].indexOf(keyCode)>-1){// tab // esc
this.hide();this.triggerElmFocus();}},resetTabindex:function resetTabindex(ele){// 下次tab时组件聚焦元素
this.removeTabindex();ele.setAttribute('tabindex','0');// 下次期望的聚焦元素
},removeTabindex:function removeTabindex(){this.triggerElm.setAttribute('tabindex','-1');this.menuItemsArray.forEach(function(item){item.setAttribute('tabindex','-1');});},initAria:function initAria(){this.dropdownElm.setAttribute('id',this.listId);this.triggerElm.setAttribute('aria-haspopup','list');this.triggerElm.setAttribute('aria-controls',this.listId);if(!this.splitButton){// 自定义
this.triggerElm.setAttribute('role','button');this.triggerElm.setAttribute('tabindex',this.tabindex);this.triggerElm.setAttribute('class',(this.triggerElm.getAttribute('class')||'')+' el-dropdown-selfdefine');// 控制
}},initEvent:function initEvent(){var _this3=this;var trigger=this.trigger,show=this.show,hide=this.hide,handleClick=this.handleClick,splitButton=this.splitButton,handleTriggerKeyDown=this.handleTriggerKeyDown,handleItemKeyDown=this.handleItemKeyDown;this.triggerElm=splitButton?this.$refs.trigger.$el:this.$slots.default[0].elm;var dropdownElm=this.dropdownElm;this.triggerElm.addEventListener('keydown',handleTriggerKeyDown);// triggerElm keydown
dropdownElm.addEventListener('keydown',handleItemKeyDown,true);// item keydown
// 控制自定义元素的样式
if(!splitButton){this.triggerElm.addEventListener('focus',function(){_this3.focusing=true;});this.triggerElm.addEventListener('blur',function(){_this3.focusing=false;});this.triggerElm.addEventListener('click',function(){_this3.focusing=false;});}if(trigger==='hover'){this.triggerElm.addEventListener('mouseenter',show);this.triggerElm.addEventListener('mouseleave',hide);dropdownElm.addEventListener('mouseenter',show);dropdownElm.addEventListener('mouseleave',hide);}else if(trigger==='click'){this.triggerElm.addEventListener('click',handleClick);}},handleMenuItemClick:function handleMenuItemClick(command,instance){if(this.hideOnClick){this.visible=false;}this.$emit('command',command,instance);},triggerElmFocus:function triggerElmFocus(){this.triggerElm.focus&&this.triggerElm.focus();},initDomOperation:function initDomOperation(){this.dropdownElm=this.popperElm;this.menuItems=this.dropdownElm.querySelectorAll("[tabindex='-1']");this.menuItemsArray=[].slice.call(this.menuItems);this.initEvent();this.initAria();}},render:function render(h){var _this4=this;var hide=this.hide,splitButton=this.splitButton,type=this.type,dropdownSize=this.dropdownSize,disabled=this.disabled;var handleMainButtonClick=function handleMainButtonClick(event){_this4.$emit('click',event);hide();};var triggerElm=null;if(splitButton){triggerElm=h('el-button-group',[h('el-button',{attrs:{type:type,size:dropdownSize,disabled:disabled},nativeOn:{'click':handleMainButtonClick}},[this.$slots.default]),h('el-button',{ref:'trigger',attrs:{type:type,size:dropdownSize,disabled:disabled},'class':'el-dropdown__caret-button'},[h('i',{'class':'el-dropdown__icon el-icon-arrow-down'})])]);}else{triggerElm=this.$slots.default;var vnodeData=triggerElm[0].data||{};var _vnodeData$attrs=vnodeData.attrs,attrs=_vnodeData$attrs===undefined?{}:_vnodeData$attrs;if(disabled&&!attrs.disabled){attrs.disabled=true;vnodeData.attrs=attrs;}}var menuElm=disabled?null:this.$slots.dropdown;return h('div',{'class':'el-dropdown',directives:[{name:'clickoutside',value:hide}],attrs:{'aria-disabled':disabled}},[triggerElm,menuElm]);}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdownvue_type_script_lang_js_=dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown.vue
var dropdown_render,dropdown_staticRenderFns;/* normalize component */var dropdown_component=normalizeComponent(src_dropdownvue_type_script_lang_js_,dropdown_render,dropdown_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_api;}dropdown_component.options.__file="packages/dropdown/src/dropdown.vue";/* harmony default export */var dropdown=dropdown_component.exports;// CONCATENATED MODULE: ./packages/dropdown/index.js
/* istanbul ignore next */dropdown.install=function(Vue){Vue.component(dropdown.name,dropdown);};/* harmony default export */var packages_dropdown=dropdown;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
var dropdown_menuvue_type_template_id_0da6b714_render=function dropdown_menuvue_type_template_id_0da6b714_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("ul",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-dropdown-menu el-popper",class:[_vm.size&&"el-dropdown-menu--"+_vm.size]},[_vm._t("default")],2)]);};var dropdown_menuvue_type_template_id_0da6b714_staticRenderFns=[];dropdown_menuvue_type_template_id_0da6b714_render._withStripped=true;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=template&id=0da6b714&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */var dropdown_menuvue_type_script_lang_js_={name:'ElDropdownMenu',componentName:'ElDropdownMenu',mixins:[vue_popper_default.a],props:{visibleArrow:{type:Boolean,default:true},arrowOffset:{type:Number,default:0}},data:function data(){return{size:this.dropdown.dropdownSize};},inject:['dropdown'],created:function created(){var _this=this;this.$on('updatePopper',function(){if(_this.showPopper)_this.updatePopper();});this.$on('visible',function(val){_this.showPopper=val;});},mounted:function mounted(){this.dropdown.popperElm=this.popperElm=this.$el;this.referenceElm=this.dropdown.$el;// compatible with 2.6 new v-slot syntax
// issue link https://github.com/ElemeFE/element/issues/14345
this.dropdown.initDomOperation();},watch:{'dropdown.placement':{immediate:true,handler:function handler(val){this.currentPlacement=val;}}}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdown_menuvue_type_script_lang_js_=dropdown_menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-menu.vue
/* normalize component */var dropdown_menu_component=normalizeComponent(src_dropdown_menuvue_type_script_lang_js_,dropdown_menuvue_type_template_id_0da6b714_render,dropdown_menuvue_type_template_id_0da6b714_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_menu_api;}dropdown_menu_component.options.__file="packages/dropdown/src/dropdown-menu.vue";/* harmony default export */var dropdown_menu=dropdown_menu_component.exports;// CONCATENATED MODULE: ./packages/dropdown-menu/index.js
/* istanbul ignore next */dropdown_menu.install=function(Vue){Vue.component(dropdown_menu.name,dropdown_menu);};/* harmony default export */var packages_dropdown_menu=dropdown_menu;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
var dropdown_itemvue_type_template_id_6359102a_render=function dropdown_itemvue_type_template_id_6359102a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-dropdown-menu__item",class:{"is-disabled":_vm.disabled,"el-dropdown-menu__item--divided":_vm.divided},attrs:{"aria-disabled":_vm.disabled,tabindex:_vm.disabled?null:-1},on:{click:_vm.handleClick}},[_vm.icon?_c("i",{class:_vm.icon}):_vm._e(),_vm._t("default")],2);};var dropdown_itemvue_type_template_id_6359102a_staticRenderFns=[];dropdown_itemvue_type_template_id_6359102a_render._withStripped=true;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=template&id=6359102a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var dropdown_itemvue_type_script_lang_js_={name:'ElDropdownItem',mixins:[emitter_default.a],props:{command:{},disabled:Boolean,divided:Boolean,icon:String},methods:{handleClick:function handleClick(e){this.dispatch('ElDropdown','menu-item-click',[this.command,this]);}}};// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_dropdown_itemvue_type_script_lang_js_=dropdown_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/dropdown/src/dropdown-item.vue
/* normalize component */var dropdown_item_component=normalizeComponent(src_dropdown_itemvue_type_script_lang_js_,dropdown_itemvue_type_template_id_6359102a_render,dropdown_itemvue_type_template_id_6359102a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var dropdown_item_api;}dropdown_item_component.options.__file="packages/dropdown/src/dropdown-item.vue";/* harmony default export */var dropdown_item=dropdown_item_component.exports;// CONCATENATED MODULE: ./packages/dropdown-item/index.js
/* istanbul ignore next */dropdown_item.install=function(Vue){Vue.component(dropdown_item.name,dropdown_item);};/* harmony default export */var packages_dropdown_item=dropdown_item;// CONCATENATED MODULE: ./src/utils/aria-utils.js
var aria=aria||{};aria.Utils=aria.Utils||{};/**
 * @desc Set focus on descendant nodes until the first focusable element is
 *       found.
 * @param element
 *          DOM node for which to find the first focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */aria.Utils.focusFirstDescendant=function(element){for(var i=0;i<element.childNodes.length;i++){var child=element.childNodes[i];if(aria.Utils.attemptFocus(child)||aria.Utils.focusFirstDescendant(child)){return true;}}return false;};/**
 * @desc Find the last descendant node that is focusable.
 * @param element
 *          DOM node for which to find the last focusable descendant.
 * @returns
 *  true if a focusable element is found and focus is set.
 */aria.Utils.focusLastDescendant=function(element){for(var i=element.childNodes.length-1;i>=0;i--){var child=element.childNodes[i];if(aria.Utils.attemptFocus(child)||aria.Utils.focusLastDescendant(child)){return true;}}return false;};/**
 * @desc Set Attempt to set focus on the current node.
 * @param element
 *          The node to attempt to focus on.
 * @returns
 *  true if element is focused.
 */aria.Utils.attemptFocus=function(element){if(!aria.Utils.isFocusable(element)){return false;}aria.Utils.IgnoreUtilFocusChanges=true;try{element.focus();}catch(e){}aria.Utils.IgnoreUtilFocusChanges=false;return document.activeElement===element;};aria.Utils.isFocusable=function(element){if(element.tabIndex>0||element.tabIndex===0&&element.getAttribute('tabIndex')!==null){return true;}if(element.disabled){return false;}switch(element.nodeName){case'A':return!!element.href&&element.rel!=='ignore';case'INPUT':return element.type!=='hidden'&&element.type!=='file';case'BUTTON':case'SELECT':case'TEXTAREA':return true;default:return false;}};/**
 * 触发一个事件
 * mouseenter, mouseleave, mouseover, keyup, change, click 等
 * @param  {Element} elm
 * @param  {String} name
 * @param  {*} opts
 */aria.Utils.triggerEvent=function(elm,name){var eventName=void 0;if(/^mouse|click/.test(name)){eventName='MouseEvents';}else if(/^key/.test(name)){eventName='KeyboardEvent';}else{eventName='HTMLEvents';}var evt=document.createEvent(eventName);for(var _len=arguments.length,opts=Array(_len>2?_len-2:0),_key=2;_key<_len;_key++){opts[_key-2]=arguments[_key];}evt.initEvent.apply(evt,[name].concat(opts));elm.dispatchEvent?elm.dispatchEvent(evt):elm.fireEvent('on'+name,evt);return elm;};aria.Utils.keys={tab:9,enter:13,space:32,left:37,up:38,right:39,down:40,esc:27};/* harmony default export */var aria_utils=aria.Utils;// CONCATENATED MODULE: ./src/utils/menu/aria-submenu.js
var SubMenu=function SubMenu(parent,domNode){this.domNode=domNode;this.parent=parent;this.subMenuItems=[];this.subIndex=0;this.init();};SubMenu.prototype.init=function(){this.subMenuItems=this.domNode.querySelectorAll('li');this.addListeners();};SubMenu.prototype.gotoSubIndex=function(idx){if(idx===this.subMenuItems.length){idx=0;}else if(idx<0){idx=this.subMenuItems.length-1;}this.subMenuItems[idx].focus();this.subIndex=idx;};SubMenu.prototype.addListeners=function(){var _this=this;var keys=aria_utils.keys;var parentNode=this.parent.domNode;Array.prototype.forEach.call(this.subMenuItems,function(el){el.addEventListener('keydown',function(event){var prevDef=false;switch(event.keyCode){case keys.down:_this.gotoSubIndex(_this.subIndex+1);prevDef=true;break;case keys.up:_this.gotoSubIndex(_this.subIndex-1);prevDef=true;break;case keys.tab:aria_utils.triggerEvent(parentNode,'mouseleave');break;case keys.enter:case keys.space:prevDef=true;event.currentTarget.click();break;}if(prevDef){event.preventDefault();event.stopPropagation();}return false;});});};/* harmony default export */var aria_submenu=SubMenu;// CONCATENATED MODULE: ./src/utils/menu/aria-menuitem.js
var MenuItem=function MenuItem(domNode){this.domNode=domNode;this.submenu=null;this.init();};MenuItem.prototype.init=function(){this.domNode.setAttribute('tabindex','0');var menuChild=this.domNode.querySelector('.el-menu');if(menuChild){this.submenu=new aria_submenu(this,menuChild);}this.addListeners();};MenuItem.prototype.addListeners=function(){var _this=this;var keys=aria_utils.keys;this.domNode.addEventListener('keydown',function(event){var prevDef=false;switch(event.keyCode){case keys.down:aria_utils.triggerEvent(event.currentTarget,'mouseenter');_this.submenu&&_this.submenu.gotoSubIndex(0);prevDef=true;break;case keys.up:aria_utils.triggerEvent(event.currentTarget,'mouseenter');_this.submenu&&_this.submenu.gotoSubIndex(_this.submenu.subMenuItems.length-1);prevDef=true;break;case keys.tab:aria_utils.triggerEvent(event.currentTarget,'mouseleave');break;case keys.enter:case keys.space:prevDef=true;event.currentTarget.click();break;}if(prevDef){event.preventDefault();}});};/* harmony default export */var aria_menuitem=MenuItem;// CONCATENATED MODULE: ./src/utils/menu/aria-menubar.js
var Menu=function Menu(domNode){this.domNode=domNode;this.init();};Menu.prototype.init=function(){var menuChildren=this.domNode.childNodes;[].filter.call(menuChildren,function(child){return child.nodeType===1;}).forEach(function(child){new aria_menuitem(child);// eslint-disable-line
});};/* harmony default export */var aria_menubar=Menu;// EXTERNAL MODULE: external "element-ui/lib/utils/dom"
var dom_=__webpack_require__(1);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu.vue?vue&type=script&lang=js&
/* harmony default export */var menuvue_type_script_lang_js_={name:'ElMenu',render:function render(h){var component=h('ul',{attrs:{role:'menubar'},key:+this.collapse,style:{backgroundColor:this.backgroundColor||''},'class':{'el-menu--horizontal':this.mode==='horizontal','el-menu--collapse':this.collapse,"el-menu":true}},[this.$slots.default]);if(this.collapseTransition){return h('el-menu-collapse-transition',[component]);}else{return component;}},componentName:'ElMenu',mixins:[emitter_default.a,migrating_default.a],provide:function provide(){return{rootMenu:this};},components:{'el-menu-collapse-transition':{functional:true,render:function render(createElement,context){var data={props:{mode:'out-in'},on:{beforeEnter:function beforeEnter(el){el.style.opacity=0.2;},enter:function enter(el){Object(dom_["addClass"])(el,'el-opacity-transition');el.style.opacity=1;},afterEnter:function afterEnter(el){Object(dom_["removeClass"])(el,'el-opacity-transition');el.style.opacity='';},beforeLeave:function beforeLeave(el){if(!el.dataset)el.dataset={};if(Object(dom_["hasClass"])(el,'el-menu--collapse')){Object(dom_["removeClass"])(el,'el-menu--collapse');el.dataset.oldOverflow=el.style.overflow;el.dataset.scrollWidth=el.clientWidth;Object(dom_["addClass"])(el,'el-menu--collapse');}else{Object(dom_["addClass"])(el,'el-menu--collapse');el.dataset.oldOverflow=el.style.overflow;el.dataset.scrollWidth=el.clientWidth;Object(dom_["removeClass"])(el,'el-menu--collapse');}el.style.width=el.scrollWidth+'px';el.style.overflow='hidden';},leave:function leave(el){Object(dom_["addClass"])(el,'horizontal-collapse-transition');el.style.width=el.dataset.scrollWidth+'px';}}};return createElement('transition',data,context.children);}}},props:{mode:{type:String,default:'vertical'},defaultActive:{type:String,default:''},defaultOpeneds:Array,uniqueOpened:Boolean,router:Boolean,menuTrigger:{type:String,default:'hover'},collapse:Boolean,backgroundColor:String,textColor:String,activeTextColor:String,collapseTransition:{type:Boolean,default:true}},data:function data(){return{activeIndex:this.defaultActive,openedMenus:this.defaultOpeneds&&!this.collapse?this.defaultOpeneds.slice(0):[],items:{},submenus:{}};},computed:{hoverBackground:function hoverBackground(){return this.backgroundColor?this.mixColor(this.backgroundColor,0.2):'';},isMenuPopup:function isMenuPopup(){return this.mode==='horizontal'||this.mode==='vertical'&&this.collapse;}},watch:{defaultActive:function defaultActive(value){if(!this.items[value]){this.activeIndex=null;}this.updateActiveIndex(value);},defaultOpeneds:function defaultOpeneds(value){if(!this.collapse){this.openedMenus=value;}},collapse:function collapse(value){if(value)this.openedMenus=[];this.broadcast('ElSubmenu','toggle-collapse',value);}},methods:{updateActiveIndex:function updateActiveIndex(val){var item=this.items[val]||this.items[this.activeIndex]||this.items[this.defaultActive];if(item){this.activeIndex=item.index;this.initOpenedMenu();}else{this.activeIndex=null;}},getMigratingConfig:function getMigratingConfig(){return{props:{'theme':'theme is removed.'}};},getColorChannels:function getColorChannels(color){color=color.replace('#','');if(/^[0-9a-fA-F]{3}$/.test(color)){color=color.split('');for(var i=2;i>=0;i--){color.splice(i,0,color[i]);}color=color.join('');}if(/^[0-9a-fA-F]{6}$/.test(color)){return{red:parseInt(color.slice(0,2),16),green:parseInt(color.slice(2,4),16),blue:parseInt(color.slice(4,6),16)};}else{return{red:255,green:255,blue:255};}},mixColor:function mixColor(color,percent){var _getColorChannels=this.getColorChannels(color),red=_getColorChannels.red,green=_getColorChannels.green,blue=_getColorChannels.blue;if(percent>0){// shade given color
red*=1-percent;green*=1-percent;blue*=1-percent;}else{// tint given color
red+=(255-red)*percent;green+=(255-green)*percent;blue+=(255-blue)*percent;}return'rgb('+Math.round(red)+', '+Math.round(green)+', '+Math.round(blue)+')';},addItem:function addItem(item){this.$set(this.items,item.index,item);},removeItem:function removeItem(item){delete this.items[item.index];},addSubmenu:function addSubmenu(item){this.$set(this.submenus,item.index,item);},removeSubmenu:function removeSubmenu(item){delete this.submenus[item.index];},openMenu:function openMenu(index,indexPath){var openedMenus=this.openedMenus;if(openedMenus.indexOf(index)!==-1)return;// 将不在该菜单路径下的其余菜单收起
// collapse all menu that are not under current menu item
if(this.uniqueOpened){this.openedMenus=openedMenus.filter(function(index){return indexPath.indexOf(index)!==-1;});}this.openedMenus.push(index);},closeMenu:function closeMenu(index){var i=this.openedMenus.indexOf(index);if(i!==-1){this.openedMenus.splice(i,1);}},handleSubmenuClick:function handleSubmenuClick(submenu){var index=submenu.index,indexPath=submenu.indexPath;var isOpened=this.openedMenus.indexOf(index)!==-1;if(isOpened){this.closeMenu(index);this.$emit('close',index,indexPath);}else{this.openMenu(index,indexPath);this.$emit('open',index,indexPath);}},handleItemClick:function handleItemClick(item){var _this=this;var index=item.index,indexPath=item.indexPath;var oldActiveIndex=this.activeIndex;var hasIndex=item.index!==null;if(hasIndex){this.activeIndex=item.index;}this.$emit('select',index,indexPath,item);if(this.mode==='horizontal'||this.collapse){this.openedMenus=[];}if(this.router&&hasIndex){this.routeToItem(item,function(error){_this.activeIndex=oldActiveIndex;if(error){// vue-router 3.1.0+ push/replace cause NavigationDuplicated error 
// https://github.com/ElemeFE/element/issues/17044
if(error.name==='NavigationDuplicated')return;console.error(error);}});}},// 初始化展开菜单
// initialize opened menu
initOpenedMenu:function initOpenedMenu(){var _this2=this;var index=this.activeIndex;var activeItem=this.items[index];if(!activeItem||this.mode==='horizontal'||this.collapse)return;var indexPath=activeItem.indexPath;// 展开该菜单项的路径上所有子菜单
// expand all submenus of the menu item
indexPath.forEach(function(index){var submenu=_this2.submenus[index];submenu&&_this2.openMenu(index,submenu.indexPath);});},routeToItem:function routeToItem(item,onError){var route=item.route||item.index;try{this.$router.push(route,function(){},onError);}catch(e){console.error(e);}},open:function open(index){var _this3=this;var indexPath=this.submenus[index.toString()].indexPath;indexPath.forEach(function(i){return _this3.openMenu(i,indexPath);});},close:function close(index){this.closeMenu(index);}},mounted:function mounted(){this.initOpenedMenu();this.$on('item-click',this.handleItemClick);this.$on('submenu-click',this.handleSubmenuClick);if(this.mode==='horizontal'){new aria_menubar(this.$el);// eslint-disable-line
}this.$watch('items',this.updateActiveIndex);}};// CONCATENATED MODULE: ./packages/menu/src/menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_menuvue_type_script_lang_js_=menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu.vue
var menu_render,menu_staticRenderFns;/* normalize component */var menu_component=normalizeComponent(src_menuvue_type_script_lang_js_,menu_render,menu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_api;}menu_component.options.__file="packages/menu/src/menu.vue";/* harmony default export */var src_menu=menu_component.exports;// CONCATENATED MODULE: ./packages/menu/index.js
/* istanbul ignore next */src_menu.install=function(Vue){Vue.component(src_menu.name,src_menu);};/* harmony default export */var packages_menu=src_menu;// EXTERNAL MODULE: external "element-ui/lib/transitions/collapse-transition"
var collapse_transition_=__webpack_require__(21);var collapse_transition_default=/*#__PURE__*/__webpack_require__.n(collapse_transition_);// CONCATENATED MODULE: ./packages/menu/src/menu-mixin.js
/* harmony default export */var menu_mixin={inject:['rootMenu'],computed:{indexPath:function indexPath(){var path=[this.index];var parent=this.$parent;while(parent.$options.componentName!=='ElMenu'){if(parent.index){path.unshift(parent.index);}parent=parent.$parent;}return path;},parentMenu:function parentMenu(){var parent=this.$parent;while(parent&&['ElMenu','ElSubmenu'].indexOf(parent.$options.componentName)===-1){parent=parent.$parent;}return parent;},paddingStyle:function paddingStyle(){if(this.rootMenu.mode!=='vertical')return{};var padding=20;var parent=this.$parent;if(this.rootMenu.collapse){padding=20;}else{while(parent&&parent.$options.componentName!=='ElMenu'){if(parent.$options.componentName==='ElSubmenu'){padding+=20;}parent=parent.$parent;}}return{paddingLeft:padding+'px'};}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/submenu.vue?vue&type=script&lang=js&
var poperMixins={props:{transformOrigin:{type:[Boolean,String],default:false},offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,popperOptions:vue_popper_default.a.props.popperOptions},data:vue_popper_default.a.data,methods:vue_popper_default.a.methods,beforeDestroy:vue_popper_default.a.beforeDestroy,deactivated:vue_popper_default.a.deactivated};/* harmony default export */var submenuvue_type_script_lang_js_={name:'ElSubmenu',componentName:'ElSubmenu',mixins:[menu_mixin,emitter_default.a,poperMixins],components:{ElCollapseTransition:collapse_transition_default.a},props:{index:{type:String,required:true},showTimeout:{type:Number,default:300},hideTimeout:{type:Number,default:300},popperClass:String,disabled:Boolean,popperAppendToBody:{type:Boolean,default:undefined}},data:function data(){return{popperJS:null,timeout:null,items:{},submenus:{},mouseInChild:false};},watch:{opened:function opened(val){var _this=this;if(this.isMenuPopup){this.$nextTick(function(_){_this.updatePopper();});}}},computed:{// popper option
appendToBody:function appendToBody(){return this.popperAppendToBody===undefined?this.isFirstLevel:this.popperAppendToBody;},menuTransitionName:function menuTransitionName(){return this.rootMenu.collapse?'el-zoom-in-left':'el-zoom-in-top';},opened:function opened(){return this.rootMenu.openedMenus.indexOf(this.index)>-1;},active:function active(){var isActive=false;var submenus=this.submenus;var items=this.items;Object.keys(items).forEach(function(index){if(items[index].active){isActive=true;}});Object.keys(submenus).forEach(function(index){if(submenus[index].active){isActive=true;}});return isActive;},hoverBackground:function hoverBackground(){return this.rootMenu.hoverBackground;},backgroundColor:function backgroundColor(){return this.rootMenu.backgroundColor||'';},activeTextColor:function activeTextColor(){return this.rootMenu.activeTextColor||'';},textColor:function textColor(){return this.rootMenu.textColor||'';},mode:function mode(){return this.rootMenu.mode;},isMenuPopup:function isMenuPopup(){return this.rootMenu.isMenuPopup;},titleStyle:function titleStyle(){if(this.mode!=='horizontal'){return{color:this.textColor};}return{borderBottomColor:this.active?this.rootMenu.activeTextColor?this.activeTextColor:'':'transparent',color:this.active?this.activeTextColor:this.textColor};},isFirstLevel:function isFirstLevel(){var isFirstLevel=true;var parent=this.$parent;while(parent&&parent!==this.rootMenu){if(['ElSubmenu','ElMenuItemGroup'].indexOf(parent.$options.componentName)>-1){isFirstLevel=false;break;}else{parent=parent.$parent;}}return isFirstLevel;}},methods:{handleCollapseToggle:function handleCollapseToggle(value){if(value){this.initPopper();}else{this.doDestroy();}},addItem:function addItem(item){this.$set(this.items,item.index,item);},removeItem:function removeItem(item){delete this.items[item.index];},addSubmenu:function addSubmenu(item){this.$set(this.submenus,item.index,item);},removeSubmenu:function removeSubmenu(item){delete this.submenus[item.index];},handleClick:function handleClick(){var rootMenu=this.rootMenu,disabled=this.disabled;if(rootMenu.menuTrigger==='hover'&&rootMenu.mode==='horizontal'||rootMenu.collapse&&rootMenu.mode==='vertical'||disabled){return;}this.dispatch('ElMenu','submenu-click',this);},handleMouseenter:function handleMouseenter(event){var _this2=this;var showTimeout=arguments.length>1&&arguments[1]!==undefined?arguments[1]:this.showTimeout;if(!('ActiveXObject'in window)&&event.type==='focus'&&!event.relatedTarget){return;}var rootMenu=this.rootMenu,disabled=this.disabled;if(rootMenu.menuTrigger==='click'&&rootMenu.mode==='horizontal'||!rootMenu.collapse&&rootMenu.mode==='vertical'||disabled){return;}this.dispatch('ElSubmenu','mouse-enter-child');clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this2.rootMenu.openMenu(_this2.index,_this2.indexPath);},showTimeout);if(this.appendToBody){this.$parent.$el.dispatchEvent(new MouseEvent('mouseenter'));}},handleMouseleave:function handleMouseleave(){var _this3=this;var deepDispatch=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var rootMenu=this.rootMenu;if(rootMenu.menuTrigger==='click'&&rootMenu.mode==='horizontal'||!rootMenu.collapse&&rootMenu.mode==='vertical'){return;}this.dispatch('ElSubmenu','mouse-leave-child');clearTimeout(this.timeout);this.timeout=setTimeout(function(){!_this3.mouseInChild&&_this3.rootMenu.closeMenu(_this3.index);},this.hideTimeout);if(this.appendToBody&&deepDispatch){if(this.$parent.$options.name==='ElSubmenu'){this.$parent.handleMouseleave(true);}}},handleTitleMouseenter:function handleTitleMouseenter(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;var title=this.$refs['submenu-title'];title&&(title.style.backgroundColor=this.rootMenu.hoverBackground);},handleTitleMouseleave:function handleTitleMouseleave(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;var title=this.$refs['submenu-title'];title&&(title.style.backgroundColor=this.rootMenu.backgroundColor||'');},updatePlacement:function updatePlacement(){this.currentPlacement=this.mode==='horizontal'&&this.isFirstLevel?'bottom-start':'right-start';},initPopper:function initPopper(){this.referenceElm=this.$el;this.popperElm=this.$refs.menu;this.updatePlacement();}},created:function created(){var _this4=this;this.$on('toggle-collapse',this.handleCollapseToggle);this.$on('mouse-enter-child',function(){_this4.mouseInChild=true;clearTimeout(_this4.timeout);});this.$on('mouse-leave-child',function(){_this4.mouseInChild=false;clearTimeout(_this4.timeout);});},mounted:function mounted(){this.parentMenu.addSubmenu(this);this.rootMenu.addSubmenu(this);this.initPopper();},beforeDestroy:function beforeDestroy(){this.parentMenu.removeSubmenu(this);this.rootMenu.removeSubmenu(this);},render:function render(h){var _this5=this;var active=this.active,opened=this.opened,paddingStyle=this.paddingStyle,titleStyle=this.titleStyle,backgroundColor=this.backgroundColor,rootMenu=this.rootMenu,currentPlacement=this.currentPlacement,menuTransitionName=this.menuTransitionName,mode=this.mode,disabled=this.disabled,popperClass=this.popperClass,$slots=this.$slots,isFirstLevel=this.isFirstLevel;var popupMenu=h('transition',{attrs:{name:menuTransitionName}},[h('div',{ref:'menu',directives:[{name:'show',value:opened}],'class':['el-menu--'+mode,popperClass],on:{'mouseenter':function mouseenter($event){return _this5.handleMouseenter($event,100);},'mouseleave':function mouseleave(){return _this5.handleMouseleave(true);},'focus':function focus($event){return _this5.handleMouseenter($event,100);}}},[h('ul',{attrs:{role:'menu'},'class':['el-menu el-menu--popup','el-menu--popup-'+currentPlacement],style:{backgroundColor:rootMenu.backgroundColor||''}},[$slots.default])])]);var inlineMenu=h('el-collapse-transition',[h('ul',{attrs:{role:'menu'},'class':'el-menu el-menu--inline',directives:[{name:'show',value:opened}],style:{backgroundColor:rootMenu.backgroundColor||''}},[$slots.default])]);var submenuTitleIcon=rootMenu.mode==='horizontal'&&isFirstLevel||rootMenu.mode==='vertical'&&!rootMenu.collapse?'el-icon-arrow-down':'el-icon-arrow-right';return h('li',{'class':{'el-submenu':true,'is-active':active,'is-opened':opened,'is-disabled':disabled},attrs:{role:'menuitem','aria-haspopup':'true','aria-expanded':opened},on:{'mouseenter':this.handleMouseenter,'mouseleave':function mouseleave(){return _this5.handleMouseleave(false);},'focus':this.handleMouseenter}},[h('div',{'class':'el-submenu__title',ref:'submenu-title',on:{'click':this.handleClick,'mouseenter':this.handleTitleMouseenter,'mouseleave':this.handleTitleMouseleave},style:[paddingStyle,titleStyle,{backgroundColor:backgroundColor}]},[$slots.title,h('i',{'class':['el-submenu__icon-arrow',submenuTitleIcon]})]),this.isMenuPopup?popupMenu:inlineMenu]);}};// CONCATENATED MODULE: ./packages/menu/src/submenu.vue?vue&type=script&lang=js&
/* harmony default export */var src_submenuvue_type_script_lang_js_=submenuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/submenu.vue
var submenu_render,submenu_staticRenderFns;/* normalize component */var submenu_component=normalizeComponent(src_submenuvue_type_script_lang_js_,submenu_render,submenu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var submenu_api;}submenu_component.options.__file="packages/menu/src/submenu.vue";/* harmony default export */var submenu=submenu_component.exports;// CONCATENATED MODULE: ./packages/submenu/index.js
/* istanbul ignore next */submenu.install=function(Vue){Vue.component(submenu.name,submenu);};/* harmony default export */var packages_submenu=submenu;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
var menu_itemvue_type_template_id_2a5dbfea_render=function menu_itemvue_type_template_id_2a5dbfea_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-menu-item",class:{"is-active":_vm.active,"is-disabled":_vm.disabled},style:[_vm.paddingStyle,_vm.itemStyle,{backgroundColor:_vm.backgroundColor}],attrs:{role:"menuitem",tabindex:"-1"},on:{click:_vm.handleClick,mouseenter:_vm.onMouseEnter,focus:_vm.onMouseEnter,blur:_vm.onMouseLeave,mouseleave:_vm.onMouseLeave}},[_vm.parentMenu.$options.componentName==="ElMenu"&&_vm.rootMenu.collapse&&_vm.$slots.title?_c("el-tooltip",{attrs:{effect:"dark",placement:"right"}},[_c("div",{attrs:{slot:"content"},slot:"content"},[_vm._t("title")],2),_c("div",{staticStyle:{position:"absolute",left:"0",top:"0",height:"100%",width:"100%",display:"inline-block","box-sizing":"border-box",padding:"0 20px"}},[_vm._t("default")],2)]):[_vm._t("default"),_vm._t("title")]],2);};var menu_itemvue_type_template_id_2a5dbfea_staticRenderFns=[];menu_itemvue_type_template_id_2a5dbfea_render._withStripped=true;// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=template&id=2a5dbfea&
// EXTERNAL MODULE: external "element-ui/lib/tooltip"
var tooltip_=__webpack_require__(26);var tooltip_default=/*#__PURE__*/__webpack_require__.n(tooltip_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var menu_itemvue_type_script_lang_js_={name:'ElMenuItem',componentName:'ElMenuItem',mixins:[menu_mixin,emitter_default.a],components:{ElTooltip:tooltip_default.a},props:{index:{default:null,validator:function validator(val){return typeof val==='string'||val===null;}},route:[String,Object],disabled:Boolean},computed:{active:function active(){return this.index===this.rootMenu.activeIndex;},hoverBackground:function hoverBackground(){return this.rootMenu.hoverBackground;},backgroundColor:function backgroundColor(){return this.rootMenu.backgroundColor||'';},activeTextColor:function activeTextColor(){return this.rootMenu.activeTextColor||'';},textColor:function textColor(){return this.rootMenu.textColor||'';},mode:function mode(){return this.rootMenu.mode;},itemStyle:function itemStyle(){var style={color:this.active?this.activeTextColor:this.textColor};if(this.mode==='horizontal'&&!this.isNested){style.borderBottomColor=this.active?this.rootMenu.activeTextColor?this.activeTextColor:'':'transparent';}return style;},isNested:function isNested(){return this.parentMenu!==this.rootMenu;}},methods:{onMouseEnter:function onMouseEnter(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;this.$el.style.backgroundColor=this.hoverBackground;},onMouseLeave:function onMouseLeave(){if(this.mode==='horizontal'&&!this.rootMenu.backgroundColor)return;this.$el.style.backgroundColor=this.backgroundColor;},handleClick:function handleClick(){if(!this.disabled){this.dispatch('ElMenu','item-click',this);this.$emit('click',this);}}},mounted:function mounted(){this.parentMenu.addItem(this);this.rootMenu.addItem(this);},beforeDestroy:function beforeDestroy(){this.parentMenu.removeItem(this);this.rootMenu.removeItem(this);}};// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_menu_itemvue_type_script_lang_js_=menu_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu-item.vue
/* normalize component */var menu_item_component=normalizeComponent(src_menu_itemvue_type_script_lang_js_,menu_itemvue_type_template_id_2a5dbfea_render,menu_itemvue_type_template_id_2a5dbfea_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_item_api;}menu_item_component.options.__file="packages/menu/src/menu-item.vue";/* harmony default export */var menu_item=menu_item_component.exports;// CONCATENATED MODULE: ./packages/menu-item/index.js
/* istanbul ignore next */menu_item.install=function(Vue){Vue.component(menu_item.name,menu_item);};/* harmony default export */var packages_menu_item=menu_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
var menu_item_groupvue_type_template_id_543b7bdc_render=function menu_item_groupvue_type_template_id_543b7bdc_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-menu-item-group"},[_c("div",{staticClass:"el-menu-item-group__title",style:{paddingLeft:_vm.levelPadding+"px"}},[!_vm.$slots.title?[_vm._v(_vm._s(_vm.title))]:_vm._t("title")],2),_c("ul",[_vm._t("default")],2)]);};var menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns=[];menu_item_groupvue_type_template_id_543b7bdc_render._withStripped=true;// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=template&id=543b7bdc&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var menu_item_groupvue_type_script_lang_js_={name:'ElMenuItemGroup',componentName:'ElMenuItemGroup',inject:['rootMenu'],props:{title:{type:String}},data:function data(){return{paddingLeft:20};},computed:{levelPadding:function levelPadding(){var padding=20;var parent=this.$parent;if(this.rootMenu.collapse)return 20;while(parent&&parent.$options.componentName!=='ElMenu'){if(parent.$options.componentName==='ElSubmenu'){padding+=20;}parent=parent.$parent;}return padding;}}};// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_menu_item_groupvue_type_script_lang_js_=menu_item_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/menu/src/menu-item-group.vue
/* normalize component */var menu_item_group_component=normalizeComponent(src_menu_item_groupvue_type_script_lang_js_,menu_item_groupvue_type_template_id_543b7bdc_render,menu_item_groupvue_type_template_id_543b7bdc_staticRenderFns,false,null,null,null);/* hot reload */if(false){var menu_item_group_api;}menu_item_group_component.options.__file="packages/menu/src/menu-item-group.vue";/* harmony default export */var menu_item_group=menu_item_group_component.exports;// CONCATENATED MODULE: ./packages/menu-item-group/index.js
/* istanbul ignore next */menu_item_group.install=function(Vue){Vue.component(menu_item_group.name,menu_item_group);};/* harmony default export */var packages_menu_item_group=menu_item_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var inputvue_type_template_id_343dd774_render=function inputvue_type_template_id_343dd774_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:[_vm.type==="textarea"?"el-textarea":"el-input",_vm.inputSize?"el-input--"+_vm.inputSize:"",{"is-disabled":_vm.inputDisabled,"is-exceed":_vm.inputExceed,"el-input-group":_vm.$slots.prepend||_vm.$slots.append,"el-input-group--append":_vm.$slots.append,"el-input-group--prepend":_vm.$slots.prepend,"el-input--prefix":_vm.$slots.prefix||_vm.prefixIcon,"el-input--suffix":_vm.$slots.suffix||_vm.suffixIcon||_vm.clearable||_vm.showPassword}],on:{mouseenter:function mouseenter($event){_vm.hovering=true;},mouseleave:function mouseleave($event){_vm.hovering=false;}}},[_vm.type!=="textarea"?[_vm.$slots.prepend?_c("div",{staticClass:"el-input-group__prepend"},[_vm._t("prepend")],2):_vm._e(),_vm.type!=="textarea"?_c("input",_vm._b({ref:"input",staticClass:"el-input__inner",attrs:{tabindex:_vm.tabindex,type:_vm.showPassword?_vm.passwordVisible?"text":"password":_vm.type,disabled:_vm.inputDisabled,readonly:_vm.readonly,autocomplete:_vm.autoComplete||_vm.autocomplete,"aria-label":_vm.label},on:{compositionstart:_vm.handleCompositionStart,compositionupdate:_vm.handleCompositionUpdate,compositionend:_vm.handleCompositionEnd,input:_vm.handleInput,focus:_vm.handleFocus,blur:_vm.handleBlur,change:_vm.handleChange}},"input",_vm.$attrs,false)):_vm._e(),_vm.$slots.prefix||_vm.prefixIcon?_c("span",{staticClass:"el-input__prefix"},[_vm._t("prefix"),_vm.prefixIcon?_c("i",{staticClass:"el-input__icon",class:_vm.prefixIcon}):_vm._e()],2):_vm._e(),_vm.getSuffixVisible()?_c("span",{staticClass:"el-input__suffix"},[_c("span",{staticClass:"el-input__suffix-inner"},[!_vm.showClear||!_vm.showPwdVisible||!_vm.isWordLimitVisible?[_vm._t("suffix"),_vm.suffixIcon?_c("i",{staticClass:"el-input__icon",class:_vm.suffixIcon}):_vm._e()]:_vm._e(),_vm.showClear?_c("i",{staticClass:"el-input__icon el-icon-circle-close el-input__clear",on:{mousedown:function mousedown($event){$event.preventDefault();},click:_vm.clear}}):_vm._e(),_vm.showPwdVisible?_c("i",{staticClass:"el-input__icon el-icon-view el-input__clear",on:{click:_vm.handlePasswordVisible}}):_vm._e(),_vm.isWordLimitVisible?_c("span",{staticClass:"el-input__count"},[_c("span",{staticClass:"el-input__count-inner"},[_vm._v("\n            "+_vm._s(_vm.textLength)+"/"+_vm._s(_vm.upperLimit)+"\n          ")])]):_vm._e()],2),_vm.validateState?_c("i",{staticClass:"el-input__icon",class:["el-input__validateIcon",_vm.validateIcon]}):_vm._e()]):_vm._e(),_vm.$slots.append?_c("div",{staticClass:"el-input-group__append"},[_vm._t("append")],2):_vm._e()]:_c("textarea",_vm._b({ref:"textarea",staticClass:"el-textarea__inner",style:_vm.textareaStyle,attrs:{tabindex:_vm.tabindex,disabled:_vm.inputDisabled,readonly:_vm.readonly,autocomplete:_vm.autoComplete||_vm.autocomplete,"aria-label":_vm.label},on:{compositionstart:_vm.handleCompositionStart,compositionupdate:_vm.handleCompositionUpdate,compositionend:_vm.handleCompositionEnd,input:_vm.handleInput,focus:_vm.handleFocus,blur:_vm.handleBlur,change:_vm.handleChange}},"textarea",_vm.$attrs,false)),_vm.isWordLimitVisible&&_vm.type==="textarea"?_c("span",{staticClass:"el-input__count"},[_vm._v(_vm._s(_vm.textLength)+"/"+_vm._s(_vm.upperLimit))]):_vm._e()],2);};var inputvue_type_template_id_343dd774_staticRenderFns=[];inputvue_type_template_id_343dd774_render._withStripped=true;// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&
// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea=void 0;var HIDDEN_STYLE='\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';var CONTEXT_STYLE=['letter-spacing','line-height','padding-top','padding-bottom','font-family','font-weight','font-size','text-rendering','text-transform','width','text-indent','padding-left','padding-right','border-width','box-sizing'];function calculateNodeStyling(targetElement){var style=window.getComputedStyle(targetElement);var boxSizing=style.getPropertyValue('box-sizing');var paddingSize=parseFloat(style.getPropertyValue('padding-bottom'))+parseFloat(style.getPropertyValue('padding-top'));var borderSize=parseFloat(style.getPropertyValue('border-bottom-width'))+parseFloat(style.getPropertyValue('border-top-width'));var contextStyle=CONTEXT_STYLE.map(function(name){return name+':'+style.getPropertyValue(name);}).join(';');return{contextStyle:contextStyle,paddingSize:paddingSize,borderSize:borderSize,boxSizing:boxSizing};}function calcTextareaHeight(targetElement){var minRows=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var maxRows=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(!hiddenTextarea){hiddenTextarea=document.createElement('textarea');document.body.appendChild(hiddenTextarea);}var _calculateNodeStyling=calculateNodeStyling(targetElement),paddingSize=_calculateNodeStyling.paddingSize,borderSize=_calculateNodeStyling.borderSize,boxSizing=_calculateNodeStyling.boxSizing,contextStyle=_calculateNodeStyling.contextStyle;hiddenTextarea.setAttribute('style',contextStyle+';'+HIDDEN_STYLE);hiddenTextarea.value=targetElement.value||targetElement.placeholder||'';var height=hiddenTextarea.scrollHeight;var result={};if(boxSizing==='border-box'){height=height+borderSize;}else if(boxSizing==='content-box'){height=height-paddingSize;}hiddenTextarea.value='';var singleRowHeight=hiddenTextarea.scrollHeight-paddingSize;if(minRows!==null){var minHeight=singleRowHeight*minRows;if(boxSizing==='border-box'){minHeight=minHeight+paddingSize+borderSize;}height=Math.max(minHeight,height);result.minHeight=minHeight+'px';}if(maxRows!==null){var maxHeight=singleRowHeight*maxRows;if(boxSizing==='border-box'){maxHeight=maxHeight+paddingSize+borderSize;}height=Math.min(maxHeight,height);}result.height=height+'px';hiddenTextarea.parentNode&&hiddenTextarea.parentNode.removeChild(hiddenTextarea);hiddenTextarea=null;return result;};// EXTERNAL MODULE: external "element-ui/lib/utils/merge"
var merge_=__webpack_require__(7);var merge_default=/*#__PURE__*/__webpack_require__.n(merge_);// EXTERNAL MODULE: external "element-ui/lib/utils/shared"
var shared_=__webpack_require__(19);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var inputvue_type_script_lang_js_={name:'ElInput',componentName:'ElInput',mixins:[emitter_default.a,migrating_default.a],inheritAttrs:false,inject:{elForm:{default:''},elFormItem:{default:''}},data:function data(){return{textareaCalcStyle:{},hovering:false,focused:false,isComposing:false,passwordVisible:false};},props:{value:[String,Number],size:String,resize:String,form:String,disabled:Boolean,readonly:Boolean,type:{type:String,default:'text'},autosize:{type:[Boolean,Object],default:false},autocomplete:{type:String,default:'off'},/** @Deprecated in next major version */autoComplete:{type:String,validator:function validator(val){false&&false;return true;}},validateEvent:{type:Boolean,default:true},suffixIcon:String,prefixIcon:String,label:String,clearable:{type:Boolean,default:false},showPassword:{type:Boolean,default:false},showWordLimit:{type:Boolean,default:false},tabindex:String},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},validateState:function validateState(){return this.elFormItem?this.elFormItem.validateState:'';},needStatusIcon:function needStatusIcon(){return this.elForm?this.elForm.statusIcon:false;},validateIcon:function validateIcon(){return{validating:'el-icon-loading',success:'el-icon-circle-check',error:'el-icon-circle-close'}[this.validateState];},textareaStyle:function textareaStyle(){return merge_default()({},this.textareaCalcStyle,{resize:this.resize});},inputSize:function inputSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},inputDisabled:function inputDisabled(){return this.disabled||(this.elForm||{}).disabled;},nativeInputValue:function nativeInputValue(){return this.value===null||this.value===undefined?'':String(this.value);},showClear:function showClear(){return this.clearable&&!this.inputDisabled&&!this.readonly&&this.nativeInputValue&&(this.focused||this.hovering);},showPwdVisible:function showPwdVisible(){return this.showPassword&&!this.inputDisabled&&!this.readonly&&(!!this.nativeInputValue||this.focused);},isWordLimitVisible:function isWordLimitVisible(){return this.showWordLimit&&this.$attrs.maxlength&&(this.type==='text'||this.type==='textarea')&&!this.inputDisabled&&!this.readonly&&!this.showPassword;},upperLimit:function upperLimit(){return this.$attrs.maxlength;},textLength:function textLength(){if(typeof this.value==='number'){return String(this.value).length;}return(this.value||'').length;},inputExceed:function inputExceed(){// show exceed style if length of initial value greater then maxlength
return this.isWordLimitVisible&&this.textLength>this.upperLimit;}},watch:{value:function value(val){this.$nextTick(this.resizeTextarea);if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',[val]);}},// native input value is set explicitly
// do not use v-model / :value in template
// see: https://github.com/ElemeFE/element/issues/14521
nativeInputValue:function nativeInputValue(){this.setNativeInputValue();},// when change between <input> and <textarea>,
// update DOM dependent value and styles
// https://github.com/ElemeFE/element/issues/14857
type:function type(){var _this=this;this.$nextTick(function(){_this.setNativeInputValue();_this.resizeTextarea();_this.updateIconOffset();});}},methods:{focus:function focus(){this.getInput().focus();},blur:function blur(){this.getInput().blur();},getMigratingConfig:function getMigratingConfig(){return{props:{'icon':'icon is removed, use suffix-icon / prefix-icon instead.','on-icon-click':'on-icon-click is removed.'},events:{'click':'click is removed.'}};},handleBlur:function handleBlur(event){this.focused=false;this.$emit('blur',event);if(this.validateEvent){this.dispatch('ElFormItem','el.form.blur',[this.value]);}},select:function select(){this.getInput().select();},resizeTextarea:function resizeTextarea(){if(this.$isServer)return;var autosize=this.autosize,type=this.type;if(type!=='textarea')return;if(!autosize){this.textareaCalcStyle={minHeight:calcTextareaHeight(this.$refs.textarea).minHeight};return;}var minRows=autosize.minRows;var maxRows=autosize.maxRows;this.textareaCalcStyle=calcTextareaHeight(this.$refs.textarea,minRows,maxRows);},setNativeInputValue:function setNativeInputValue(){var input=this.getInput();if(!input)return;if(input.value===this.nativeInputValue)return;input.value=this.nativeInputValue;},handleFocus:function handleFocus(event){this.focused=true;this.$emit('focus',event);},handleCompositionStart:function handleCompositionStart(event){this.$emit('compositionstart',event);this.isComposing=true;},handleCompositionUpdate:function handleCompositionUpdate(event){this.$emit('compositionupdate',event);var text=event.target.value;var lastCharacter=text[text.length-1]||'';this.isComposing=!Object(shared_["isKorean"])(lastCharacter);},handleCompositionEnd:function handleCompositionEnd(event){this.$emit('compositionend',event);if(this.isComposing){this.isComposing=false;this.handleInput(event);}},handleInput:function handleInput(event){// should not emit input during composition
// see: https://github.com/ElemeFE/element/issues/10516
if(this.isComposing)return;// hack for https://github.com/ElemeFE/element/issues/8548
// should remove the following line when we don't support IE
if(event.target.value===this.nativeInputValue)return;this.$emit('input',event.target.value);// ensure native input value is controlled
// see: https://github.com/ElemeFE/element/issues/12850
this.$nextTick(this.setNativeInputValue);},handleChange:function handleChange(event){this.$emit('change',event.target.value);},calcIconOffset:function calcIconOffset(place){var elList=[].slice.call(this.$el.querySelectorAll('.el-input__'+place)||[]);if(!elList.length)return;var el=null;for(var i=0;i<elList.length;i++){if(elList[i].parentNode===this.$el){el=elList[i];break;}}if(!el)return;var pendantMap={suffix:'append',prefix:'prepend'};var pendant=pendantMap[place];if(this.$slots[pendant]){el.style.transform='translateX('+(place==='suffix'?'-':'')+this.$el.querySelector('.el-input-group__'+pendant).offsetWidth+'px)';}else{el.removeAttribute('style');}},updateIconOffset:function updateIconOffset(){this.calcIconOffset('prefix');this.calcIconOffset('suffix');},clear:function clear(){this.$emit('input','');this.$emit('change','');this.$emit('clear');},handlePasswordVisible:function handlePasswordVisible(){var _this2=this;this.passwordVisible=!this.passwordVisible;this.$nextTick(function(){_this2.focus();});},getInput:function getInput(){return this.$refs.input||this.$refs.textarea;},getSuffixVisible:function getSuffixVisible(){return this.$slots.suffix||this.suffixIcon||this.showClear||this.showPassword||this.isWordLimitVisible||this.validateState&&this.needStatusIcon;}},created:function created(){this.$on('inputSelect',this.select);},mounted:function mounted(){this.setNativeInputValue();this.resizeTextarea();this.updateIconOffset();},updated:function updated(){this.$nextTick(this.updateIconOffset);}};// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
/* harmony default export */var src_inputvue_type_script_lang_js_=inputvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/input/src/input.vue
/* normalize component */var input_component=normalizeComponent(src_inputvue_type_script_lang_js_,inputvue_type_template_id_343dd774_render,inputvue_type_template_id_343dd774_staticRenderFns,false,null,null,null);/* hot reload */if(false){var input_api;}input_component.options.__file="packages/input/src/input.vue";/* harmony default export */var src_input=input_component.exports;// CONCATENATED MODULE: ./packages/input/index.js
/* istanbul ignore next */src_input.install=function(Vue){Vue.component(src_input.name,src_input);};/* harmony default export */var packages_input=src_input;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
var input_numbervue_type_template_id_42f8cf66_render=function input_numbervue_type_template_id_42f8cf66_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-input-number",_vm.inputNumberSize?"el-input-number--"+_vm.inputNumberSize:"",{"is-disabled":_vm.inputNumberDisabled},{"is-without-controls":!_vm.controls},{"is-controls-right":_vm.controlsAtRight}],on:{dragstart:function dragstart($event){$event.preventDefault();}}},[_vm.controls?_c("span",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-input-number__decrease",class:{"is-disabled":_vm.minDisabled},attrs:{role:"button"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.decrease($event);}}},[_c("i",{class:"el-icon-"+(_vm.controlsAtRight?"arrow-down":"minus")})]):_vm._e(),_vm.controls?_c("span",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-input-number__increase",class:{"is-disabled":_vm.maxDisabled},attrs:{role:"button"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.increase($event);}}},[_c("i",{class:"el-icon-"+(_vm.controlsAtRight?"arrow-up":"plus")})]):_vm._e(),_c("el-input",{ref:"input",attrs:{value:_vm.displayValue,placeholder:_vm.placeholder,disabled:_vm.inputNumberDisabled,size:_vm.inputNumberSize,max:_vm.max,min:_vm.min,name:_vm.name,label:_vm.label},on:{blur:_vm.handleBlur,focus:_vm.handleFocus,input:_vm.handleInput,change:_vm.handleInputChange},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();return _vm.increase($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();return _vm.decrease($event);}]}})],1);};var input_numbervue_type_template_id_42f8cf66_staticRenderFns=[];input_numbervue_type_template_id_42f8cf66_render._withStripped=true;// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
// CONCATENATED MODULE: ./src/directives/repeat-click.js
/* harmony default export */var repeat_click={bind:function bind(el,binding,vnode){var interval=null;var startTime=void 0;var handler=function handler(){return vnode.context[binding.expression].apply();};var clear=function clear(){if(Date.now()-startTime<100){handler();}clearInterval(interval);interval=null;};Object(dom_["on"])(el,'mousedown',function(e){if(e.button!==0)return;startTime=Date.now();Object(dom_["once"])(document,'mouseup',clear);clearInterval(interval);interval=setInterval(handler,100);});}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var input_numbervue_type_script_lang_js_={name:'ElInputNumber',mixins:[focus_default()('input')],inject:{elForm:{default:''},elFormItem:{default:''}},directives:{repeatClick:repeat_click},components:{ElInput:input_default.a},props:{step:{type:Number,default:1},stepStrictly:{type:Boolean,default:false},max:{type:Number,default:Infinity},min:{type:Number,default:-Infinity},value:{},disabled:Boolean,size:String,controls:{type:Boolean,default:true},controlsPosition:{type:String,default:''},name:String,label:String,placeholder:String,precision:{type:Number,validator:function validator(val){return val>=0&&val===parseInt(val,10);}}},data:function data(){return{currentValue:0,userInput:null};},watch:{value:{immediate:true,handler:function handler(value){var newVal=value===undefined?value:Number(value);if(newVal!==undefined){if(isNaN(newVal)){return;}if(this.stepStrictly){var stepPrecision=this.getPrecision(this.step);var precisionFactor=Math.pow(10,stepPrecision);newVal=Math.round(newVal/this.step)*precisionFactor*this.step/precisionFactor;}if(this.precision!==undefined){newVal=this.toPrecision(newVal,this.precision);}}if(newVal>=this.max)newVal=this.max;if(newVal<=this.min)newVal=this.min;this.currentValue=newVal;this.userInput=null;this.$emit('input',newVal);}}},computed:{minDisabled:function minDisabled(){return this._decrease(this.value,this.step)<this.min;},maxDisabled:function maxDisabled(){return this._increase(this.value,this.step)>this.max;},numPrecision:function numPrecision(){var value=this.value,step=this.step,getPrecision=this.getPrecision,precision=this.precision;var stepPrecision=getPrecision(step);if(precision!==undefined){if(stepPrecision>precision){console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');}return precision;}else{return Math.max(getPrecision(value),stepPrecision);}},controlsAtRight:function controlsAtRight(){return this.controls&&this.controlsPosition==='right';},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},inputNumberSize:function inputNumberSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},inputNumberDisabled:function inputNumberDisabled(){return this.disabled||!!(this.elForm||{}).disabled;},displayValue:function displayValue(){if(this.userInput!==null){return this.userInput;}var currentValue=this.currentValue;if(typeof currentValue==='number'){if(this.stepStrictly){var stepPrecision=this.getPrecision(this.step);var precisionFactor=Math.pow(10,stepPrecision);currentValue=Math.round(currentValue/this.step)*precisionFactor*this.step/precisionFactor;}if(this.precision!==undefined){currentValue=currentValue.toFixed(this.precision);}}return currentValue;}},methods:{toPrecision:function toPrecision(num,precision){if(precision===undefined)precision=this.numPrecision;return parseFloat(Math.round(num*Math.pow(10,precision))/Math.pow(10,precision));},getPrecision:function getPrecision(value){if(value===undefined)return 0;var valueString=value.toString();var dotPosition=valueString.indexOf('.');var precision=0;if(dotPosition!==-1){precision=valueString.length-dotPosition-1;}return precision;},_increase:function _increase(val,step){if(typeof val!=='number'&&val!==undefined)return this.currentValue;var precisionFactor=Math.pow(10,this.numPrecision);// Solve the accuracy problem of JS decimal calculation by converting the value to integer.
return this.toPrecision((precisionFactor*val+precisionFactor*step)/precisionFactor);},_decrease:function _decrease(val,step){if(typeof val!=='number'&&val!==undefined)return this.currentValue;var precisionFactor=Math.pow(10,this.numPrecision);return this.toPrecision((precisionFactor*val-precisionFactor*step)/precisionFactor);},increase:function increase(){if(this.inputNumberDisabled||this.maxDisabled)return;var value=this.value||0;var newVal=this._increase(value,this.step);this.setCurrentValue(newVal);},decrease:function decrease(){if(this.inputNumberDisabled||this.minDisabled)return;var value=this.value||0;var newVal=this._decrease(value,this.step);this.setCurrentValue(newVal);},handleBlur:function handleBlur(event){this.$emit('blur',event);},handleFocus:function handleFocus(event){this.$emit('focus',event);},setCurrentValue:function setCurrentValue(newVal){var oldVal=this.currentValue;if(typeof newVal==='number'&&this.precision!==undefined){newVal=this.toPrecision(newVal,this.precision);}if(newVal>=this.max)newVal=this.max;if(newVal<=this.min)newVal=this.min;if(oldVal===newVal)return;this.userInput=null;this.$emit('input',newVal);this.$emit('change',newVal,oldVal);this.currentValue=newVal;},handleInput:function handleInput(value){this.userInput=value;},handleInputChange:function handleInputChange(value){var newVal=value===''?undefined:Number(value);if(!isNaN(newVal)||value===''){this.setCurrentValue(newVal);}this.userInput=null;},select:function select(){this.$refs.input.select();}},mounted:function mounted(){var innerInput=this.$refs.input.$refs.input;innerInput.setAttribute('role','spinbutton');innerInput.setAttribute('aria-valuemax',this.max);innerInput.setAttribute('aria-valuemin',this.min);innerInput.setAttribute('aria-valuenow',this.currentValue);innerInput.setAttribute('aria-disabled',this.inputNumberDisabled);},updated:function updated(){if(!this.$refs||!this.$refs.input)return;var innerInput=this.$refs.input.$refs.input;innerInput.setAttribute('aria-valuenow',this.currentValue);}};// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
/* harmony default export */var src_input_numbervue_type_script_lang_js_=input_numbervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/input-number/src/input-number.vue
/* normalize component */var input_number_component=normalizeComponent(src_input_numbervue_type_script_lang_js_,input_numbervue_type_template_id_42f8cf66_render,input_numbervue_type_template_id_42f8cf66_staticRenderFns,false,null,null,null);/* hot reload */if(false){var input_number_api;}input_number_component.options.__file="packages/input-number/src/input-number.vue";/* harmony default export */var input_number=input_number_component.exports;// CONCATENATED MODULE: ./packages/input-number/index.js
/* istanbul ignore next */input_number.install=function(Vue){Vue.component(input_number.name,input_number);};/* harmony default export */var packages_input_number=input_number;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
var radiovue_type_template_id_69cd6268_render=function radiovue_type_template_id_69cd6268_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-radio",class:[_vm.border&&_vm.radioSize?"el-radio--"+_vm.radioSize:"",{"is-disabled":_vm.isDisabled},{"is-focus":_vm.focus},{"is-bordered":_vm.border},{"is-checked":_vm.model===_vm.label}],attrs:{role:"radio","aria-checked":_vm.model===_vm.label,"aria-disabled":_vm.isDisabled,tabindex:_vm.tabIndex},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.model=_vm.isDisabled?_vm.model:_vm.label;}}},[_c("span",{staticClass:"el-radio__input",class:{"is-disabled":_vm.isDisabled,"is-checked":_vm.model===_vm.label}},[_c("span",{staticClass:"el-radio__inner"}),_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],ref:"radio",staticClass:"el-radio__original",attrs:{type:"radio","aria-hidden":"true",name:_vm.name,disabled:_vm.isDisabled,tabindex:"-1",autocomplete:"off"},domProps:{value:_vm.label,checked:_vm._q(_vm.model,_vm.label)},on:{focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;},change:[function($event){_vm.model=_vm.label;},_vm.handleChange]}})]),_c("span",{staticClass:"el-radio__label",on:{keydown:function keydown($event){$event.stopPropagation();}}},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)]);};var radiovue_type_template_id_69cd6268_staticRenderFns=[];radiovue_type_template_id_69cd6268_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var radiovue_type_script_lang_js_={name:'ElRadio',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},componentName:'ElRadio',props:{value:{},label:{},disabled:Boolean,name:String,border:Boolean,size:String},data:function data(){return{focus:false};},computed:{isGroup:function isGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElRadioGroup'){parent=parent.$parent;}else{this._radioGroup=parent;return true;}}return false;},model:{get:function get(){return this.isGroup?this._radioGroup.value:this.value;},set:function set(val){if(this.isGroup){this.dispatch('ElRadioGroup','input',[val]);}else{this.$emit('input',val);}this.$refs.radio&&(this.$refs.radio.checked=this.model===this.label);}},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},radioSize:function radioSize(){var temRadioSize=this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;return this.isGroup?this._radioGroup.radioGroupSize||temRadioSize:temRadioSize;},isDisabled:function isDisabled(){return this.isGroup?this._radioGroup.disabled||this.disabled||(this.elForm||{}).disabled:this.disabled||(this.elForm||{}).disabled;},tabIndex:function tabIndex(){return this.isDisabled||this.isGroup&&this.model!==this.label?-1:0;}},methods:{handleChange:function handleChange(){var _this=this;this.$nextTick(function(){_this.$emit('change',_this.model);_this.isGroup&&_this.dispatch('ElRadioGroup','handleChange',_this.model);});}}};// CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
/* harmony default export */var src_radiovue_type_script_lang_js_=radiovue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio.vue
/* normalize component */var radio_component=normalizeComponent(src_radiovue_type_script_lang_js_,radiovue_type_template_id_69cd6268_render,radiovue_type_template_id_69cd6268_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_api;}radio_component.options.__file="packages/radio/src/radio.vue";/* harmony default export */var src_radio=radio_component.exports;// CONCATENATED MODULE: ./packages/radio/index.js
/* istanbul ignore next */src_radio.install=function(Vue){Vue.component(src_radio.name,src_radio);};/* harmony default export */var packages_radio=src_radio;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
var radio_groupvue_type_template_id_818a704c_render=function radio_groupvue_type_template_id_818a704c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm._elTag,{tag:"component",staticClass:"el-radio-group",attrs:{role:"radiogroup"},on:{keydown:_vm.handleKeydown}},[_vm._t("default")],2);};var radio_groupvue_type_template_id_818a704c_staticRenderFns=[];radio_groupvue_type_template_id_818a704c_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=template&id=818a704c&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
var keyCode=Object.freeze({LEFT:37,UP:38,RIGHT:39,DOWN:40});/* harmony default export */var radio_groupvue_type_script_lang_js_={name:'ElRadioGroup',componentName:'ElRadioGroup',inject:{elFormItem:{default:''}},mixins:[emitter_default.a],props:{value:{},size:String,fill:String,textColor:String,disabled:Boolean},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},_elTag:function _elTag(){var tag=(this.$vnode.data||{}).tag;if(!tag||tag==='component')tag='div';return tag;},radioGroupSize:function radioGroupSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;}},created:function created(){var _this=this;this.$on('handleChange',function(value){_this.$emit('change',value);});},mounted:function mounted(){// 当radioGroup没有默认选项时，第一个可以选中Tab导航
var radios=this.$el.querySelectorAll('[type=radio]');var firstLabel=this.$el.querySelectorAll('[role=radio]')[0];if(![].some.call(radios,function(radio){return radio.checked;})&&firstLabel){firstLabel.tabIndex=0;}},methods:{handleKeydown:function handleKeydown(e){// 左右上下按键 可以在radio组内切换不同选项
var target=e.target;var className=target.nodeName==='INPUT'?'[type=radio]':'[role=radio]';var radios=this.$el.querySelectorAll(className);var length=radios.length;var index=[].indexOf.call(radios,target);var roleRadios=this.$el.querySelectorAll('[role=radio]');switch(e.keyCode){case keyCode.LEFT:case keyCode.UP:e.stopPropagation();e.preventDefault();if(index===0){roleRadios[length-1].click();roleRadios[length-1].focus();}else{roleRadios[index-1].click();roleRadios[index-1].focus();}break;case keyCode.RIGHT:case keyCode.DOWN:if(index===length-1){e.stopPropagation();e.preventDefault();roleRadios[0].click();roleRadios[0].focus();}else{roleRadios[index+1].click();roleRadios[index+1].focus();}break;default:break;}}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',[this.value]);}}};// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_radio_groupvue_type_script_lang_js_=radio_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio-group.vue
/* normalize component */var radio_group_component=normalizeComponent(src_radio_groupvue_type_script_lang_js_,radio_groupvue_type_template_id_818a704c_render,radio_groupvue_type_template_id_818a704c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_group_api;}radio_group_component.options.__file="packages/radio/src/radio-group.vue";/* harmony default export */var radio_group=radio_group_component.exports;// CONCATENATED MODULE: ./packages/radio-group/index.js
/* istanbul ignore next */radio_group.install=function(Vue){Vue.component(radio_group.name,radio_group);};/* harmony default export */var packages_radio_group=radio_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
var radio_buttonvue_type_template_id_18a77a32_render=function radio_buttonvue_type_template_id_18a77a32_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-radio-button",class:[_vm.size?"el-radio-button--"+_vm.size:"",{"is-active":_vm.value===_vm.label},{"is-disabled":_vm.isDisabled},{"is-focus":_vm.focus}],attrs:{role:"radio","aria-checked":_vm.value===_vm.label,"aria-disabled":_vm.isDisabled,tabindex:_vm.tabIndex},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.value=_vm.isDisabled?_vm.value:_vm.label;}}},[_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.value,expression:"value"}],staticClass:"el-radio-button__orig-radio",attrs:{type:"radio",name:_vm.name,disabled:_vm.isDisabled,tabindex:"-1",autocomplete:"off"},domProps:{value:_vm.label,checked:_vm._q(_vm.value,_vm.label)},on:{change:[function($event){_vm.value=_vm.label;},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}),_c("span",{staticClass:"el-radio-button__inner",style:_vm.value===_vm.label?_vm.activeStyle:null,on:{keydown:function keydown($event){$event.stopPropagation();}}},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2)]);};var radio_buttonvue_type_template_id_18a77a32_staticRenderFns=[];radio_buttonvue_type_template_id_18a77a32_render._withStripped=true;// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=template&id=18a77a32&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var radio_buttonvue_type_script_lang_js_={name:'ElRadioButton',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},props:{label:{},disabled:Boolean,name:String},data:function data(){return{focus:false};},computed:{value:{get:function get(){return this._radioGroup.value;},set:function set(value){this._radioGroup.$emit('input',value);}},_radioGroup:function _radioGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElRadioGroup'){parent=parent.$parent;}else{return parent;}}return false;},activeStyle:function activeStyle(){return{backgroundColor:this._radioGroup.fill||'',borderColor:this._radioGroup.fill||'',boxShadow:this._radioGroup.fill?'-1px 0 0 0 '+this._radioGroup.fill:'',color:this._radioGroup.textColor||''};},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},size:function size(){return this._radioGroup.radioGroupSize||this._elFormItemSize||(this.$ELEMENT||{}).size;},isDisabled:function isDisabled(){return this.disabled||this._radioGroup.disabled||(this.elForm||{}).disabled;},tabIndex:function tabIndex(){return this.isDisabled||this._radioGroup&&this.value!==this.label?-1:0;}},methods:{handleChange:function handleChange(){var _this=this;this.$nextTick(function(){_this.dispatch('ElRadioGroup','handleChange',_this.value);});}}};// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue?vue&type=script&lang=js&
/* harmony default export */var src_radio_buttonvue_type_script_lang_js_=radio_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/radio/src/radio-button.vue
/* normalize component */var radio_button_component=normalizeComponent(src_radio_buttonvue_type_script_lang_js_,radio_buttonvue_type_template_id_18a77a32_render,radio_buttonvue_type_template_id_18a77a32_staticRenderFns,false,null,null,null);/* hot reload */if(false){var radio_button_api;}radio_button_component.options.__file="packages/radio/src/radio-button.vue";/* harmony default export */var radio_button=radio_button_component.exports;// CONCATENATED MODULE: ./packages/radio-button/index.js
/* istanbul ignore next */radio_button.install=function(Vue){Vue.component(radio_button.name,radio_button);};/* harmony default export */var packages_radio_button=radio_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
var checkboxvue_type_template_id_d0387074_render=function checkboxvue_type_template_id_d0387074_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-checkbox",class:[_vm.border&&_vm.checkboxSize?"el-checkbox--"+_vm.checkboxSize:"",{"is-disabled":_vm.isDisabled},{"is-bordered":_vm.border},{"is-checked":_vm.isChecked}],attrs:{id:_vm.id}},[_c("span",{staticClass:"el-checkbox__input",class:{"is-disabled":_vm.isDisabled,"is-checked":_vm.isChecked,"is-indeterminate":_vm.indeterminate,"is-focus":_vm.focus},attrs:{tabindex:_vm.indeterminate?0:false,role:_vm.indeterminate?"checkbox":false,"aria-checked":_vm.indeterminate?"mixed":false}},[_c("span",{staticClass:"el-checkbox__inner"}),_vm.trueLabel||_vm.falseLabel?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox__original",attrs:{type:"checkbox","aria-hidden":_vm.indeterminate?"true":"false",name:_vm.name,disabled:_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{checked:Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?_vm.trueLabel:_vm.falseLabel;if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}):_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox__original",attrs:{type:"checkbox","aria-hidden":_vm.indeterminate?"true":"false",disabled:_vm.isDisabled,name:_vm.name},domProps:{value:_vm.label,checked:Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:_vm.model},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?true:false;if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}})]),_vm.$slots.default||_vm.label?_c("span",{staticClass:"el-checkbox__label"},[_vm._t("default"),!_vm.$slots.default?[_vm._v(_vm._s(_vm.label))]:_vm._e()],2):_vm._e()]);};var checkboxvue_type_template_id_d0387074_staticRenderFns=[];checkboxvue_type_template_id_d0387074_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var checkboxvue_type_script_lang_js_={name:'ElCheckbox',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},componentName:'ElCheckbox',data:function data(){return{selfModel:false,focus:false,isLimitExceeded:false};},computed:{model:{get:function get(){return this.isGroup?this.store:this.value!==undefined?this.value:this.selfModel;},set:function set(val){if(this.isGroup){this.isLimitExceeded=false;this._checkboxGroup.min!==undefined&&val.length<this._checkboxGroup.min&&(this.isLimitExceeded=true);this._checkboxGroup.max!==undefined&&val.length>this._checkboxGroup.max&&(this.isLimitExceeded=true);this.isLimitExceeded===false&&this.dispatch('ElCheckboxGroup','input',[val]);}else{this.$emit('input',val);this.selfModel=val;}}},isChecked:function isChecked(){if({}.toString.call(this.model)==='[object Boolean]'){return this.model;}else if(Array.isArray(this.model)){return this.model.indexOf(this.label)>-1;}else if(this.model!==null&&this.model!==undefined){return this.model===this.trueLabel;}},isGroup:function isGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElCheckboxGroup'){parent=parent.$parent;}else{this._checkboxGroup=parent;return true;}}return false;},store:function store(){return this._checkboxGroup?this._checkboxGroup.value:this.value;},/* used to make the isDisabled judgment under max/min props */isLimitDisabled:function isLimitDisabled(){var _checkboxGroup=this._checkboxGroup,max=_checkboxGroup.max,min=_checkboxGroup.min;return!!(max||min)&&this.model.length>=max&&!this.isChecked||this.model.length<=min&&this.isChecked;},isDisabled:function isDisabled(){return this.isGroup?this._checkboxGroup.disabled||this.disabled||(this.elForm||{}).disabled||this.isLimitDisabled:this.disabled||(this.elForm||{}).disabled;},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},checkboxSize:function checkboxSize(){var temCheckboxSize=this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;return this.isGroup?this._checkboxGroup.checkboxGroupSize||temCheckboxSize:temCheckboxSize;}},props:{value:{},label:{},indeterminate:Boolean,disabled:Boolean,checked:Boolean,name:String,trueLabel:[String,Number],falseLabel:[String,Number],id:String,/* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/controls:String,/* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/border:Boolean,size:String},methods:{addToStore:function addToStore(){if(Array.isArray(this.model)&&this.model.indexOf(this.label)===-1){this.model.push(this.label);}else{this.model=this.trueLabel||true;}},handleChange:function handleChange(ev){var _this=this;if(this.isLimitExceeded)return;var value=void 0;if(ev.target.checked){value=this.trueLabel===undefined?true:this.trueLabel;}else{value=this.falseLabel===undefined?false:this.falseLabel;}this.$emit('change',value,ev);this.$nextTick(function(){if(_this.isGroup){_this.dispatch('ElCheckboxGroup','change',[_this._checkboxGroup.value]);}});}},created:function created(){this.checked&&this.addToStore();},mounted:function mounted(){// 为indeterminate元素 添加aria-controls 属性
if(this.indeterminate){this.$el.setAttribute('aria-controls',this.controls);}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',_value);}}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkboxvue_type_script_lang_js_=checkboxvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue
/* normalize component */var checkbox_component=normalizeComponent(src_checkboxvue_type_script_lang_js_,checkboxvue_type_template_id_d0387074_render,checkboxvue_type_template_id_d0387074_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_api;}checkbox_component.options.__file="packages/checkbox/src/checkbox.vue";/* harmony default export */var src_checkbox=checkbox_component.exports;// CONCATENATED MODULE: ./packages/checkbox/index.js
/* istanbul ignore next */src_checkbox.install=function(Vue){Vue.component(src_checkbox.name,src_checkbox);};/* harmony default export */var packages_checkbox=src_checkbox;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
var checkbox_buttonvue_type_template_id_478e906e_render=function checkbox_buttonvue_type_template_id_478e906e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("label",{staticClass:"el-checkbox-button",class:[_vm.size?"el-checkbox-button--"+_vm.size:"",{"is-disabled":_vm.isDisabled},{"is-checked":_vm.isChecked},{"is-focus":_vm.focus}],attrs:{role:"checkbox","aria-checked":_vm.isChecked,"aria-disabled":_vm.isDisabled}},[_vm.trueLabel||_vm.falseLabel?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{type:"checkbox",name:_vm.name,disabled:_vm.isDisabled,"true-value":_vm.trueLabel,"false-value":_vm.falseLabel},domProps:{checked:Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:_vm._q(_vm.model,_vm.trueLabel)},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?_vm.trueLabel:_vm.falseLabel;if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}):_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.model,expression:"model"}],staticClass:"el-checkbox-button__original",attrs:{type:"checkbox",name:_vm.name,disabled:_vm.isDisabled},domProps:{value:_vm.label,checked:Array.isArray(_vm.model)?_vm._i(_vm.model,_vm.label)>-1:_vm.model},on:{change:[function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?true:false;if(Array.isArray($$a)){var $$v=_vm.label,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]));}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)));}}else{_vm.model=$$c;}},_vm.handleChange],focus:function focus($event){_vm.focus=true;},blur:function blur($event){_vm.focus=false;}}}),_vm.$slots.default||_vm.label?_c("span",{staticClass:"el-checkbox-button__inner",style:_vm.isChecked?_vm.activeStyle:null},[_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2):_vm._e()]);};var checkbox_buttonvue_type_template_id_478e906e_staticRenderFns=[];checkbox_buttonvue_type_template_id_478e906e_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=template&id=478e906e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var checkbox_buttonvue_type_script_lang_js_={name:'ElCheckboxButton',mixins:[emitter_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},data:function data(){return{selfModel:false,focus:false,isLimitExceeded:false};},props:{value:{},label:{},disabled:Boolean,checked:Boolean,name:String,trueLabel:[String,Number],falseLabel:[String,Number]},computed:{model:{get:function get(){return this._checkboxGroup?this.store:this.value!==undefined?this.value:this.selfModel;},set:function set(val){if(this._checkboxGroup){this.isLimitExceeded=false;this._checkboxGroup.min!==undefined&&val.length<this._checkboxGroup.min&&(this.isLimitExceeded=true);this._checkboxGroup.max!==undefined&&val.length>this._checkboxGroup.max&&(this.isLimitExceeded=true);this.isLimitExceeded===false&&this.dispatch('ElCheckboxGroup','input',[val]);}else if(this.value!==undefined){this.$emit('input',val);}else{this.selfModel=val;}}},isChecked:function isChecked(){if({}.toString.call(this.model)==='[object Boolean]'){return this.model;}else if(Array.isArray(this.model)){return this.model.indexOf(this.label)>-1;}else if(this.model!==null&&this.model!==undefined){return this.model===this.trueLabel;}},_checkboxGroup:function _checkboxGroup(){var parent=this.$parent;while(parent){if(parent.$options.componentName!=='ElCheckboxGroup'){parent=parent.$parent;}else{return parent;}}return false;},store:function store(){return this._checkboxGroup?this._checkboxGroup.value:this.value;},activeStyle:function activeStyle(){return{backgroundColor:this._checkboxGroup.fill||'',borderColor:this._checkboxGroup.fill||'',color:this._checkboxGroup.textColor||'','box-shadow':'-1px 0 0 0 '+this._checkboxGroup.fill};},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},size:function size(){return this._checkboxGroup.checkboxGroupSize||this._elFormItemSize||(this.$ELEMENT||{}).size;},/* used to make the isDisabled judgment under max/min props */isLimitDisabled:function isLimitDisabled(){var _checkboxGroup2=this._checkboxGroup,max=_checkboxGroup2.max,min=_checkboxGroup2.min;return!!(max||min)&&this.model.length>=max&&!this.isChecked||this.model.length<=min&&this.isChecked;},isDisabled:function isDisabled(){return this._checkboxGroup?this._checkboxGroup.disabled||this.disabled||(this.elForm||{}).disabled||this.isLimitDisabled:this.disabled||(this.elForm||{}).disabled;}},methods:{addToStore:function addToStore(){if(Array.isArray(this.model)&&this.model.indexOf(this.label)===-1){this.model.push(this.label);}else{this.model=this.trueLabel||true;}},handleChange:function handleChange(ev){var _this=this;if(this.isLimitExceeded)return;var value=void 0;if(ev.target.checked){value=this.trueLabel===undefined?true:this.trueLabel;}else{value=this.falseLabel===undefined?false:this.falseLabel;}this.$emit('change',value,ev);this.$nextTick(function(){if(_this._checkboxGroup){_this.dispatch('ElCheckboxGroup','change',[_this._checkboxGroup.value]);}});}},created:function created(){this.checked&&this.addToStore();}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkbox_buttonvue_type_script_lang_js_=checkbox_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-button.vue
/* normalize component */var checkbox_button_component=normalizeComponent(src_checkbox_buttonvue_type_script_lang_js_,checkbox_buttonvue_type_template_id_478e906e_render,checkbox_buttonvue_type_template_id_478e906e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_button_api;}checkbox_button_component.options.__file="packages/checkbox/src/checkbox-button.vue";/* harmony default export */var checkbox_button=checkbox_button_component.exports;// CONCATENATED MODULE: ./packages/checkbox-button/index.js
/* istanbul ignore next */checkbox_button.install=function(Vue){Vue.component(checkbox_button.name,checkbox_button);};/* harmony default export */var packages_checkbox_button=checkbox_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
var checkbox_groupvue_type_template_id_7289a290_render=function checkbox_groupvue_type_template_id_7289a290_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-checkbox-group",attrs:{role:"group","aria-label":"checkbox-group"}},[_vm._t("default")],2);};var checkbox_groupvue_type_template_id_7289a290_staticRenderFns=[];checkbox_groupvue_type_template_id_7289a290_render._withStripped=true;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
/* harmony default export */var checkbox_groupvue_type_script_lang_js_={name:'ElCheckboxGroup',componentName:'ElCheckboxGroup',mixins:[emitter_default.a],inject:{elFormItem:{default:''}},props:{value:{},disabled:Boolean,min:Number,max:Number,size:String,fill:String,textColor:String},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},checkboxGroupSize:function checkboxGroupSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;}},watch:{value:function value(_value){this.dispatch('ElFormItem','el.form.change',[_value]);}}};// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_checkbox_groupvue_type_script_lang_js_=checkbox_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue
/* normalize component */var checkbox_group_component=normalizeComponent(src_checkbox_groupvue_type_script_lang_js_,checkbox_groupvue_type_template_id_7289a290_render,checkbox_groupvue_type_template_id_7289a290_staticRenderFns,false,null,null,null);/* hot reload */if(false){var checkbox_group_api;}checkbox_group_component.options.__file="packages/checkbox/src/checkbox-group.vue";/* harmony default export */var checkbox_group=checkbox_group_component.exports;// CONCATENATED MODULE: ./packages/checkbox-group/index.js
/* istanbul ignore next */checkbox_group.install=function(Vue){Vue.component(checkbox_group.name,checkbox_group);};/* harmony default export */var packages_checkbox_group=checkbox_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
var componentvue_type_template_id_2dcd8fbb_render=function componentvue_type_template_id_2dcd8fbb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-switch",class:{"is-disabled":_vm.switchDisabled,"is-checked":_vm.checked},attrs:{role:"switch","aria-checked":_vm.checked,"aria-disabled":_vm.switchDisabled},on:{click:function click($event){$event.preventDefault();return _vm.switchValue($event);}}},[_c("input",{ref:"input",staticClass:"el-switch__input",attrs:{type:"checkbox",id:_vm.id,name:_vm.name,"true-value":_vm.activeValue,"false-value":_vm.inactiveValue,disabled:_vm.switchDisabled},on:{change:_vm.handleChange,keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.switchValue($event);}}}),_vm.inactiveIconClass||_vm.inactiveText?_c("span",{class:["el-switch__label","el-switch__label--left",!_vm.checked?"is-active":""]},[_vm.inactiveIconClass?_c("i",{class:[_vm.inactiveIconClass]}):_vm._e(),!_vm.inactiveIconClass&&_vm.inactiveText?_c("span",{attrs:{"aria-hidden":_vm.checked}},[_vm._v(_vm._s(_vm.inactiveText))]):_vm._e()]):_vm._e(),_c("span",{ref:"core",staticClass:"el-switch__core",style:{width:_vm.coreWidth+"px"}}),_vm.activeIconClass||_vm.activeText?_c("span",{class:["el-switch__label","el-switch__label--right",_vm.checked?"is-active":""]},[_vm.activeIconClass?_c("i",{class:[_vm.activeIconClass]}):_vm._e(),!_vm.activeIconClass&&_vm.activeText?_c("span",{attrs:{"aria-hidden":!_vm.checked}},[_vm._v(_vm._s(_vm.activeText))]):_vm._e()]):_vm._e()]);};var componentvue_type_template_id_2dcd8fbb_staticRenderFns=[];componentvue_type_template_id_2dcd8fbb_render._withStripped=true;// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=template&id=2dcd8fbb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/switch/src/component.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var switch_src_componentvue_type_script_lang_js_={name:'ElSwitch',mixins:[focus_default()('input'),migrating_default.a,emitter_default.a],inject:{elForm:{default:''}},props:{value:{type:[Boolean,String,Number],default:false},disabled:{type:Boolean,default:false},width:{type:Number,default:40},activeIconClass:{type:String,default:''},inactiveIconClass:{type:String,default:''},activeText:String,inactiveText:String,activeColor:{type:String,default:''},inactiveColor:{type:String,default:''},activeValue:{type:[Boolean,String,Number],default:true},inactiveValue:{type:[Boolean,String,Number],default:false},name:{type:String,default:''},validateEvent:{type:Boolean,default:true},id:String},data:function data(){return{coreWidth:this.width};},created:function created(){if(!~[this.activeValue,this.inactiveValue].indexOf(this.value)){this.$emit('input',this.inactiveValue);}},computed:{checked:function checked(){return this.value===this.activeValue;},switchDisabled:function switchDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{checked:function checked(){this.$refs.input.checked=this.checked;if(this.activeColor||this.inactiveColor){this.setBackgroundColor();}if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',[this.value]);}}},methods:{handleChange:function handleChange(event){var _this=this;var val=this.checked?this.inactiveValue:this.activeValue;this.$emit('input',val);this.$emit('change',val);this.$nextTick(function(){// set input's checked property
// in case parent refuses to change component's value
if(_this.$refs.input){_this.$refs.input.checked=_this.checked;}});},setBackgroundColor:function setBackgroundColor(){var newColor=this.checked?this.activeColor:this.inactiveColor;this.$refs.core.style.borderColor=newColor;this.$refs.core.style.backgroundColor=newColor;},switchValue:function switchValue(){!this.switchDisabled&&this.handleChange();},getMigratingConfig:function getMigratingConfig(){return{props:{'on-color':'on-color is renamed to active-color.','off-color':'off-color is renamed to inactive-color.','on-text':'on-text is renamed to active-text.','off-text':'off-text is renamed to inactive-text.','on-value':'on-value is renamed to active-value.','off-value':'off-value is renamed to inactive-value.','on-icon-class':'on-icon-class is renamed to active-icon-class.','off-icon-class':'off-icon-class is renamed to inactive-icon-class.'}};}},mounted:function mounted(){/* istanbul ignore if */this.coreWidth=this.width||40;if(this.activeColor||this.inactiveColor){this.setBackgroundColor();}this.$refs.input.checked=this.checked;}};// CONCATENATED MODULE: ./packages/switch/src/component.vue?vue&type=script&lang=js&
/* harmony default export */var packages_switch_src_componentvue_type_script_lang_js_=switch_src_componentvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/switch/src/component.vue
/* normalize component */var src_component_component=normalizeComponent(packages_switch_src_componentvue_type_script_lang_js_,componentvue_type_template_id_2dcd8fbb_render,componentvue_type_template_id_2dcd8fbb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_component_api;}src_component_component.options.__file="packages/switch/src/component.vue";/* harmony default export */var switch_src_component=src_component_component.exports;// CONCATENATED MODULE: ./packages/switch/index.js
/* istanbul ignore next */switch_src_component.install=function(Vue){Vue.component(switch_src_component.name,switch_src_component);};/* harmony default export */var packages_switch=switch_src_component;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
var selectvue_type_template_id_0e4aade6_render=function selectvue_type_template_id_0e4aade6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],staticClass:"el-select",class:[_vm.selectSize?"el-select--"+_vm.selectSize:""],on:{click:function click($event){$event.stopPropagation();return _vm.toggleMenu($event);}}},[_vm.multiple?_c("div",{ref:"tags",staticClass:"el-select__tags",style:{"max-width":_vm.inputWidth-32+"px",width:"100%"}},[_vm.collapseTags&&_vm.selected.length?_c("span",[_c("el-tag",{attrs:{closable:!_vm.selectDisabled,size:_vm.collapseTagSize,hit:_vm.selected[0].hitState,type:"info","disable-transitions":""},on:{close:function close($event){_vm.deleteTag($event,_vm.selected[0]);}}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(_vm.selected[0].currentLabel))])]),_vm.selected.length>1?_c("el-tag",{attrs:{closable:false,size:_vm.collapseTagSize,type:"info","disable-transitions":""}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v("+ "+_vm._s(_vm.selected.length-1))])]):_vm._e()],1):_vm._e(),!_vm.collapseTags?_c("transition-group",{on:{"after-leave":_vm.resetInputHeight}},_vm._l(_vm.selected,function(item){return _c("el-tag",{key:_vm.getValueKey(item),attrs:{closable:!_vm.selectDisabled,size:_vm.collapseTagSize,hit:item.hitState,type:"info","disable-transitions":""},on:{close:function close($event){_vm.deleteTag($event,item);}}},[_c("span",{staticClass:"el-select__tags-text"},[_vm._v(_vm._s(item.currentLabel))])]);}),1):_vm._e(),_vm.filterable?_c("input",{directives:[{name:"model",rawName:"v-model",value:_vm.query,expression:"query"}],ref:"input",staticClass:"el-select__input",class:[_vm.selectSize?"is-"+_vm.selectSize:""],style:{"flex-grow":"1",width:_vm.inputLength/(_vm.inputWidth-32)+"%","max-width":_vm.inputWidth-42+"px"},attrs:{type:"text",disabled:_vm.selectDisabled,autocomplete:_vm.autoComplete||_vm.autocomplete},domProps:{value:_vm.query},on:{focus:_vm.handleFocus,blur:function blur($event){_vm.softFocus=false;},keyup:_vm.managePlaceholder,keydown:[_vm.resetInputState,function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();_vm.handleNavigate("next");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();_vm.handleNavigate("prev");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.preventDefault();return _vm.selectOption($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.visible=false;},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}return _vm.deletePrevTag($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}_vm.visible=false;}],compositionstart:_vm.handleComposition,compositionupdate:_vm.handleComposition,compositionend:_vm.handleComposition,input:[function($event){if($event.target.composing){return;}_vm.query=$event.target.value;},_vm.debouncedQueryChange]}}):_vm._e()],1):_vm._e(),_c("el-input",{ref:"reference",class:{"is-focus":_vm.visible},attrs:{type:"text",placeholder:_vm.currentPlaceholder,name:_vm.name,id:_vm.id,autocomplete:_vm.autoComplete||_vm.autocomplete,size:_vm.selectSize,disabled:_vm.selectDisabled,readonly:_vm.readonly,"validate-event":false,tabindex:_vm.multiple&&_vm.filterable?"-1":null},on:{focus:_vm.handleFocus,blur:_vm.handleBlur,input:_vm.debouncedOnInputChange,compositionstart:_vm.handleComposition,compositionupdate:_vm.handleComposition,compositionend:_vm.handleComposition},nativeOn:{keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.handleNavigate("next");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.handleNavigate("prev");},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.preventDefault();return _vm.selectOption($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){return null;}$event.stopPropagation();$event.preventDefault();_vm.visible=false;},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"tab",9,$event.key,"Tab")){return null;}_vm.visible=false;}],mouseenter:function mouseenter($event){_vm.inputHovering=true;},mouseleave:function mouseleave($event){_vm.inputHovering=false;}},model:{value:_vm.selectedLabel,callback:function callback($$v){_vm.selectedLabel=$$v;},expression:"selectedLabel"}},[_vm.$slots.prefix?_c("template",{slot:"prefix"},[_vm._t("prefix")],2):_vm._e(),_c("template",{slot:"suffix"},[_c("i",{directives:[{name:"show",rawName:"v-show",value:!_vm.showClose,expression:"!showClose"}],class:["el-select__caret","el-input__icon","el-icon-"+_vm.iconClass]}),_vm.showClose?_c("i",{staticClass:"el-select__caret el-input__icon el-icon-circle-close",on:{click:_vm.handleClearClick}}):_vm._e()])],2),_c("transition",{attrs:{name:"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":_vm.doDestroy}},[_c("el-select-menu",{directives:[{name:"show",rawName:"v-show",value:_vm.visible&&_vm.emptyText!==false,expression:"visible && emptyText !== false"}],ref:"popper",attrs:{"append-to-body":_vm.popperAppendToBody}},[_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.options.length>0&&!_vm.loading,expression:"options.length > 0 && !loading"}],ref:"scrollbar",class:{"is-empty":!_vm.allowCreate&&_vm.query&&_vm.filteredOptionsCount===0},attrs:{tag:"ul","wrap-class":"el-select-dropdown__wrap","view-class":"el-select-dropdown__list"}},[_vm.showNewOption?_c("el-option",{attrs:{value:_vm.query,created:""}}):_vm._e(),_vm._t("default")],2),_vm.emptyText&&(!_vm.allowCreate||_vm.loading||_vm.allowCreate&&_vm.options.length===0)?[_vm.$slots.empty?_vm._t("empty"):_c("p",{staticClass:"el-select-dropdown__empty"},[_vm._v("\n          "+_vm._s(_vm.emptyText)+"\n        ")])]:_vm._e()],2)],1)],1);};var selectvue_type_template_id_0e4aade6_staticRenderFns=[];selectvue_type_template_id_0e4aade6_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
var select_dropdownvue_type_template_id_06828748_render=function select_dropdownvue_type_template_id_06828748_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-select-dropdown el-popper",class:[{"is-multiple":_vm.$parent.multiple},_vm.popperClass],style:{minWidth:_vm.minWidth}},[_vm._t("default")],2);};var select_dropdownvue_type_template_id_06828748_staticRenderFns=[];select_dropdownvue_type_template_id_06828748_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
/* harmony default export */var select_dropdownvue_type_script_lang_js_={name:'ElSelectDropdown',componentName:'ElSelectDropdown',mixins:[vue_popper_default.a],props:{placement:{default:'bottom-start'},boundariesPadding:{default:0},popperOptions:{default:function _default(){return{gpuAcceleration:false};}},visibleArrow:{default:true},appendToBody:{type:Boolean,default:true}},data:function data(){return{minWidth:''};},computed:{popperClass:function popperClass(){return this.$parent.popperClass;}},watch:{'$parent.inputWidth':function $parentInputWidth(){this.minWidth=this.$parent.$el.getBoundingClientRect().width+'px';}},mounted:function mounted(){var _this=this;this.referenceElm=this.$parent.$refs.reference.$el;this.$parent.popperElm=this.popperElm=this.$el;this.$on('updatePopper',function(){if(_this.$parent.visible)_this.updatePopper();});this.$on('destroyPopper',this.destroyPopper);}};// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var src_select_dropdownvue_type_script_lang_js_=select_dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue
/* normalize component */var select_dropdown_component=normalizeComponent(src_select_dropdownvue_type_script_lang_js_,select_dropdownvue_type_template_id_06828748_render,select_dropdownvue_type_template_id_06828748_staticRenderFns,false,null,null,null);/* hot reload */if(false){var select_dropdown_api;}select_dropdown_component.options.__file="packages/select/src/select-dropdown.vue";/* harmony default export */var select_dropdown=select_dropdown_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var optionvue_type_template_id_7a44c642_render=function optionvue_type_template_id_7a44c642_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-select-dropdown__item",class:{selected:_vm.itemSelected,"is-disabled":_vm.disabled||_vm.groupDisabled||_vm.limitReached,hover:_vm.hover},on:{mouseenter:_vm.hoverItem,click:function click($event){$event.stopPropagation();return _vm.selectOptionClick($event);}}},[_vm._t("default",[_c("span",[_vm._v(_vm._s(_vm.currentLabel))])])],2);};var optionvue_type_template_id_7a44c642_staticRenderFns=[];optionvue_type_template_id_7a44c642_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var optionvue_type_script_lang_js_={mixins:[emitter_default.a],name:'ElOption',componentName:'ElOption',inject:['select'],props:{value:{required:true},label:[String,Number],created:Boolean,disabled:{type:Boolean,default:false}},data:function data(){return{index:-1,groupDisabled:false,visible:true,hitState:false,hover:false};},computed:{isObject:function isObject(){return Object.prototype.toString.call(this.value).toLowerCase()==='[object object]';},currentLabel:function currentLabel(){return this.label||(this.isObject?'':this.value);},currentValue:function currentValue(){return this.value||this.label||'';},itemSelected:function itemSelected(){if(!this.select.multiple){return this.isEqual(this.value,this.select.value);}else{return this.contains(this.select.value,this.value);}},limitReached:function limitReached(){if(this.select.multiple){return!this.itemSelected&&(this.select.value||[]).length>=this.select.multipleLimit&&this.select.multipleLimit>0;}else{return false;}}},watch:{currentLabel:function currentLabel(){if(!this.created&&!this.select.remote)this.dispatch('ElSelect','setSelected');},value:function value(val,oldVal){var _select=this.select,remote=_select.remote,valueKey=_select.valueKey;if(!this.created&&!remote){if(valueKey&&(typeof val==='undefined'?'undefined':_typeof(val))==='object'&&(typeof oldVal==='undefined'?'undefined':_typeof(oldVal))==='object'&&val[valueKey]===oldVal[valueKey]){return;}this.dispatch('ElSelect','setSelected');}}},methods:{isEqual:function isEqual(a,b){if(!this.isObject){return a===b;}else{var valueKey=this.select.valueKey;return Object(util_["getValueByPath"])(a,valueKey)===Object(util_["getValueByPath"])(b,valueKey);}},contains:function contains(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var target=arguments[1];if(!this.isObject){return arr&&arr.indexOf(target)>-1;}else{var valueKey=this.select.valueKey;return arr&&arr.some(function(item){return Object(util_["getValueByPath"])(item,valueKey)===Object(util_["getValueByPath"])(target,valueKey);});}},handleGroupDisabled:function handleGroupDisabled(val){this.groupDisabled=val;},hoverItem:function hoverItem(){if(!this.disabled&&!this.groupDisabled){this.select.hoverIndex=this.select.options.indexOf(this);}},selectOptionClick:function selectOptionClick(){if(this.disabled!==true&&this.groupDisabled!==true){this.dispatch('ElSelect','handleOptionClick',[this,true]);}},queryChange:function queryChange(query){this.visible=new RegExp(Object(util_["escapeRegexpString"])(query),'i').test(this.currentLabel)||this.created;if(!this.visible){this.select.filteredOptionsCount--;}}},created:function created(){this.select.options.push(this);this.select.cachedOptions.push(this);this.select.optionsCount++;this.select.filteredOptionsCount++;this.$on('queryChange',this.queryChange);this.$on('handleGroupDisabled',this.handleGroupDisabled);},beforeDestroy:function beforeDestroy(){var _select2=this.select,selected=_select2.selected,multiple=_select2.multiple;var selectedOptions=multiple?selected:[selected];var index=this.select.cachedOptions.indexOf(this);var selectedIndex=selectedOptions.indexOf(this);// if option is not selected, remove it from cache
if(index>-1&&selectedIndex<0){this.select.cachedOptions.splice(index,1);}this.select.onOptionDestroy(this.select.options.indexOf(this));}};// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
/* harmony default export */var src_optionvue_type_script_lang_js_=optionvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/option.vue
/* normalize component */var option_component=normalizeComponent(src_optionvue_type_script_lang_js_,optionvue_type_template_id_7a44c642_render,optionvue_type_template_id_7a44c642_staticRenderFns,false,null,null,null);/* hot reload */if(false){var option_api;}option_component.options.__file="packages/select/src/option.vue";/* harmony default export */var src_option=option_component.exports;// EXTERNAL MODULE: external "element-ui/lib/tag"
var tag_=__webpack_require__(29);var tag_default=/*#__PURE__*/__webpack_require__.n(tag_);// EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
var resize_event_=__webpack_require__(15);// EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
var scroll_into_view_=__webpack_require__(27);var scroll_into_view_default=/*#__PURE__*/__webpack_require__.n(scroll_into_view_);// CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
/* harmony default export */var navigation_mixin={data:function data(){return{hoverOption:-1};},computed:{optionsAllDisabled:function optionsAllDisabled(){return this.options.filter(function(option){return option.visible;}).every(function(option){return option.disabled;});}},watch:{hoverIndex:function hoverIndex(val){var _this=this;if(typeof val==='number'&&val>-1){this.hoverOption=this.options[val]||{};}this.options.forEach(function(option){option.hover=_this.hoverOption===option;});}},methods:{navigateOptions:function navigateOptions(direction){var _this2=this;if(!this.visible){this.visible=true;return;}if(this.options.length===0||this.filteredOptionsCount===0)return;if(!this.optionsAllDisabled){if(direction==='next'){this.hoverIndex++;if(this.hoverIndex===this.options.length){this.hoverIndex=0;}}else if(direction==='prev'){this.hoverIndex--;if(this.hoverIndex<0){this.hoverIndex=this.options.length-1;}}var option=this.options[this.hoverIndex];if(option.disabled===true||option.groupDisabled===true||!option.visible){this.navigateOptions(direction);}this.$nextTick(function(){return _this2.scrollToOption(_this2.hoverOption);});}}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var selectvue_type_script_lang_js_={mixins:[emitter_default.a,locale_default.a,focus_default()('reference'),navigation_mixin],name:'ElSelect',componentName:'ElSelect',inject:{elForm:{default:''},elFormItem:{default:''}},provide:function provide(){return{'select':this};},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},readonly:function readonly(){return!this.filterable||this.multiple||!Object(util_["isIE"])()&&!Object(util_["isEdge"])()&&!this.visible;},showClose:function showClose(){var hasValue=this.multiple?Array.isArray(this.value)&&this.value.length>0:this.value!==undefined&&this.value!==null&&this.value!=='';var criteria=this.clearable&&!this.selectDisabled&&this.inputHovering&&hasValue;return criteria;},iconClass:function iconClass(){return this.remote&&this.filterable?'':this.visible?'arrow-up is-reverse':'arrow-up';},debounce:function debounce(){return this.remote?300:0;},emptyText:function emptyText(){if(this.loading){return this.loadingText||this.t('el.select.loading');}else{if(this.remote&&this.query===''&&this.options.length===0)return false;if(this.filterable&&this.query&&this.options.length>0&&this.filteredOptionsCount===0){return this.noMatchText||this.t('el.select.noMatch');}if(this.options.length===0){return this.noDataText||this.t('el.select.noData');}}return null;},showNewOption:function showNewOption(){var _this=this;var hasExistingOption=this.options.filter(function(option){return!option.created;}).some(function(option){return option.currentLabel===_this.query;});return this.filterable&&this.allowCreate&&this.query!==''&&!hasExistingOption;},selectSize:function selectSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},selectDisabled:function selectDisabled(){return this.disabled||(this.elForm||{}).disabled;},collapseTagSize:function collapseTagSize(){return['small','mini'].indexOf(this.selectSize)>-1?'mini':'small';},propPlaceholder:function propPlaceholder(){return typeof this.placeholder!=='undefined'?this.placeholder:this.t('el.select.placeholder');}},components:{ElInput:input_default.a,ElSelectMenu:select_dropdown,ElOption:src_option,ElTag:tag_default.a,ElScrollbar:scrollbar_default.a},directives:{Clickoutside:clickoutside_default.a},props:{name:String,id:String,value:{required:true},autocomplete:{type:String,default:'off'},/** @Deprecated in next major version */autoComplete:{type:String,validator:function validator(val){false&&false;return true;}},automaticDropdown:Boolean,size:String,disabled:Boolean,clearable:Boolean,filterable:Boolean,allowCreate:Boolean,loading:Boolean,popperClass:String,remote:Boolean,loadingText:String,noMatchText:String,noDataText:String,remoteMethod:Function,filterMethod:Function,multiple:Boolean,multipleLimit:{type:Number,default:0},placeholder:{type:String,required:false},defaultFirstOption:Boolean,reserveKeyword:Boolean,valueKey:{type:String,default:'value'},collapseTags:Boolean,popperAppendToBody:{type:Boolean,default:true}},data:function data(){return{options:[],cachedOptions:[],createdLabel:null,createdSelected:false,selected:this.multiple?[]:{},inputLength:20,inputWidth:0,initialInputHeight:0,cachedPlaceHolder:'',optionsCount:0,filteredOptionsCount:0,visible:false,softFocus:false,selectedLabel:'',hoverIndex:-1,query:'',previousQuery:null,inputHovering:false,currentPlaceholder:'',menuVisibleOnFocus:false,isOnComposition:false,isSilentBlur:false};},watch:{selectDisabled:function selectDisabled(){var _this2=this;this.$nextTick(function(){_this2.resetInputHeight();});},propPlaceholder:function propPlaceholder(val){this.cachedPlaceHolder=this.currentPlaceholder=val;},value:function value(val,oldVal){if(this.multiple){this.resetInputHeight();if(val&&val.length>0||this.$refs.input&&this.query!==''){this.currentPlaceholder='';}else{this.currentPlaceholder=this.cachedPlaceHolder;}if(this.filterable&&!this.reserveKeyword){this.query='';this.handleQueryChange(this.query);}}this.setSelected();if(this.filterable&&!this.multiple){this.inputLength=20;}if(!Object(util_["valueEquals"])(val,oldVal)){this.dispatch('ElFormItem','el.form.change',val);}},visible:function visible(val){var _this3=this;if(!val){this.broadcast('ElSelectDropdown','destroyPopper');if(this.$refs.input){this.$refs.input.blur();}this.query='';this.previousQuery=null;this.selectedLabel='';this.inputLength=20;this.menuVisibleOnFocus=false;this.resetHoverIndex();this.$nextTick(function(){if(_this3.$refs.input&&_this3.$refs.input.value===''&&_this3.selected.length===0){_this3.currentPlaceholder=_this3.cachedPlaceHolder;}});if(!this.multiple){if(this.selected){if(this.filterable&&this.allowCreate&&this.createdSelected&&this.createdLabel){this.selectedLabel=this.createdLabel;}else{this.selectedLabel=this.selected.currentLabel;}if(this.filterable)this.query=this.selectedLabel;}if(this.filterable){this.currentPlaceholder=this.cachedPlaceHolder;}}}else{this.broadcast('ElSelectDropdown','updatePopper');if(this.filterable){this.query=this.remote?'':this.selectedLabel;this.handleQueryChange(this.query);if(this.multiple){this.$refs.input.focus();}else{if(!this.remote){this.broadcast('ElOption','queryChange','');this.broadcast('ElOptionGroup','queryChange');}if(this.selectedLabel){this.currentPlaceholder=this.selectedLabel;this.selectedLabel='';}}}}this.$emit('visible-change',val);},options:function options(){var _this4=this;if(this.$isServer)return;this.$nextTick(function(){_this4.broadcast('ElSelectDropdown','updatePopper');});if(this.multiple){this.resetInputHeight();}var inputs=this.$el.querySelectorAll('input');if([].indexOf.call(inputs,document.activeElement)===-1){this.setSelected();}if(this.defaultFirstOption&&(this.filterable||this.remote)&&this.filteredOptionsCount){this.checkDefaultFirstOption();}}},methods:{handleNavigate:function handleNavigate(direction){if(this.isOnComposition)return;this.navigateOptions(direction);},handleComposition:function handleComposition(event){var _this5=this;var text=event.target.value;if(event.type==='compositionend'){this.isOnComposition=false;this.$nextTick(function(_){return _this5.handleQueryChange(text);});}else{var lastCharacter=text[text.length-1]||'';this.isOnComposition=!Object(shared_["isKorean"])(lastCharacter);}},handleQueryChange:function handleQueryChange(val){var _this6=this;if(this.previousQuery===val||this.isOnComposition)return;if(this.previousQuery===null&&(typeof this.filterMethod==='function'||typeof this.remoteMethod==='function')){this.previousQuery=val;return;}this.previousQuery=val;this.$nextTick(function(){if(_this6.visible)_this6.broadcast('ElSelectDropdown','updatePopper');});this.hoverIndex=-1;if(this.multiple&&this.filterable){this.$nextTick(function(){var length=_this6.$refs.input.value.length*15+20;_this6.inputLength=_this6.collapseTags?Math.min(50,length):length;_this6.managePlaceholder();_this6.resetInputHeight();});}if(this.remote&&typeof this.remoteMethod==='function'){this.hoverIndex=-1;this.remoteMethod(val);}else if(typeof this.filterMethod==='function'){this.filterMethod(val);this.broadcast('ElOptionGroup','queryChange');}else{this.filteredOptionsCount=this.optionsCount;this.broadcast('ElOption','queryChange',val);this.broadcast('ElOptionGroup','queryChange');}if(this.defaultFirstOption&&(this.filterable||this.remote)&&this.filteredOptionsCount){this.checkDefaultFirstOption();}},scrollToOption:function scrollToOption(option){var target=Array.isArray(option)&&option[0]?option[0].$el:option.$el;if(this.$refs.popper&&target){var menu=this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');scroll_into_view_default()(menu,target);}this.$refs.scrollbar&&this.$refs.scrollbar.handleScroll();},handleMenuEnter:function handleMenuEnter(){var _this7=this;this.$nextTick(function(){return _this7.scrollToOption(_this7.selected);});},emitChange:function emitChange(val){if(!Object(util_["valueEquals"])(this.value,val)){this.$emit('change',val);}},getOption:function getOption(value){var option=void 0;var isObject=Object.prototype.toString.call(value).toLowerCase()==='[object object]';var isNull=Object.prototype.toString.call(value).toLowerCase()==='[object null]';var isUndefined=Object.prototype.toString.call(value).toLowerCase()==='[object undefined]';for(var i=this.cachedOptions.length-1;i>=0;i--){var cachedOption=this.cachedOptions[i];var isEqual=isObject?Object(util_["getValueByPath"])(cachedOption.value,this.valueKey)===Object(util_["getValueByPath"])(value,this.valueKey):cachedOption.value===value;if(isEqual){option=cachedOption;break;}}if(option)return option;var label=!isObject&&!isNull&&!isUndefined?String(value):'';var newOption={value:value,currentLabel:label};if(this.multiple){newOption.hitState=false;}return newOption;},setSelected:function setSelected(){var _this8=this;if(!this.multiple){var option=this.getOption(this.value);if(option.created){this.createdLabel=option.currentLabel;this.createdSelected=true;}else{this.createdSelected=false;}this.selectedLabel=option.currentLabel;this.selected=option;if(this.filterable)this.query=this.selectedLabel;return;}var result=[];if(Array.isArray(this.value)){this.value.forEach(function(value){result.push(_this8.getOption(value));});}this.selected=result;this.$nextTick(function(){_this8.resetInputHeight();});},handleFocus:function handleFocus(event){if(!this.softFocus){if(this.automaticDropdown||this.filterable){if(this.filterable&&!this.visible){this.menuVisibleOnFocus=true;}this.visible=true;}this.$emit('focus',event);}else{this.softFocus=false;}},blur:function blur(){this.visible=false;this.$refs.reference.blur();},handleBlur:function handleBlur(event){var _this9=this;setTimeout(function(){if(_this9.isSilentBlur){_this9.isSilentBlur=false;}else{_this9.$emit('blur',event);}},50);this.softFocus=false;},handleClearClick:function handleClearClick(event){this.deleteSelected(event);},doDestroy:function doDestroy(){this.$refs.popper&&this.$refs.popper.doDestroy();},handleClose:function handleClose(){this.visible=false;},toggleLastOptionHitState:function toggleLastOptionHitState(hit){if(!Array.isArray(this.selected))return;var option=this.selected[this.selected.length-1];if(!option)return;if(hit===true||hit===false){option.hitState=hit;return hit;}option.hitState=!option.hitState;return option.hitState;},deletePrevTag:function deletePrevTag(e){if(e.target.value.length<=0&&!this.toggleLastOptionHitState()){var value=this.value.slice();value.pop();this.$emit('input',value);this.emitChange(value);}},managePlaceholder:function managePlaceholder(){if(this.currentPlaceholder!==''){this.currentPlaceholder=this.$refs.input.value?'':this.cachedPlaceHolder;}},resetInputState:function resetInputState(e){if(e.keyCode!==8)this.toggleLastOptionHitState(false);this.inputLength=this.$refs.input.value.length*15+20;this.resetInputHeight();},resetInputHeight:function resetInputHeight(){var _this10=this;if(this.collapseTags&&!this.filterable)return;this.$nextTick(function(){if(!_this10.$refs.reference)return;var inputChildNodes=_this10.$refs.reference.$el.childNodes;var input=[].filter.call(inputChildNodes,function(item){return item.tagName==='INPUT';})[0];var tags=_this10.$refs.tags;var tagsHeight=tags?Math.round(tags.getBoundingClientRect().height):0;var sizeInMap=_this10.initialInputHeight||40;input.style.height=_this10.selected.length===0?sizeInMap+'px':Math.max(tags?tagsHeight+(tagsHeight>sizeInMap?6:0):0,sizeInMap)+'px';if(_this10.visible&&_this10.emptyText!==false){_this10.broadcast('ElSelectDropdown','updatePopper');}});},resetHoverIndex:function resetHoverIndex(){var _this11=this;setTimeout(function(){if(!_this11.multiple){_this11.hoverIndex=_this11.options.indexOf(_this11.selected);}else{if(_this11.selected.length>0){_this11.hoverIndex=Math.min.apply(null,_this11.selected.map(function(item){return _this11.options.indexOf(item);}));}else{_this11.hoverIndex=-1;}}},300);},handleOptionSelect:function handleOptionSelect(option,byClick){var _this12=this;if(this.multiple){var value=(this.value||[]).slice();var optionIndex=this.getValueIndex(value,option.value);if(optionIndex>-1){value.splice(optionIndex,1);}else if(this.multipleLimit<=0||value.length<this.multipleLimit){value.push(option.value);}this.$emit('input',value);this.emitChange(value);if(option.created){this.query='';this.handleQueryChange('');this.inputLength=20;}if(this.filterable)this.$refs.input.focus();}else{this.$emit('input',option.value);this.emitChange(option.value);this.visible=false;}this.isSilentBlur=byClick;this.setSoftFocus();if(this.visible)return;this.$nextTick(function(){_this12.scrollToOption(option);});},setSoftFocus:function setSoftFocus(){this.softFocus=true;var input=this.$refs.input||this.$refs.reference;if(input){input.focus();}},getValueIndex:function getValueIndex(){var arr=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var value=arguments[1];var isObject=Object.prototype.toString.call(value).toLowerCase()==='[object object]';if(!isObject){return arr.indexOf(value);}else{var valueKey=this.valueKey;var index=-1;arr.some(function(item,i){if(Object(util_["getValueByPath"])(item,valueKey)===Object(util_["getValueByPath"])(value,valueKey)){index=i;return true;}return false;});return index;}},toggleMenu:function toggleMenu(){if(!this.selectDisabled){if(this.menuVisibleOnFocus){this.menuVisibleOnFocus=false;}else{this.visible=!this.visible;}if(this.visible){(this.$refs.input||this.$refs.reference).focus();}}},selectOption:function selectOption(){if(!this.visible){this.toggleMenu();}else{if(this.options[this.hoverIndex]){this.handleOptionSelect(this.options[this.hoverIndex]);}}},deleteSelected:function deleteSelected(event){event.stopPropagation();var value=this.multiple?[]:'';this.$emit('input',value);this.emitChange(value);this.visible=false;this.$emit('clear');},deleteTag:function deleteTag(event,tag){var index=this.selected.indexOf(tag);if(index>-1&&!this.selectDisabled){var value=this.value.slice();value.splice(index,1);this.$emit('input',value);this.emitChange(value);this.$emit('remove-tag',tag.value);}event.stopPropagation();},onInputChange:function onInputChange(){if(this.filterable&&this.query!==this.selectedLabel){this.query=this.selectedLabel;this.handleQueryChange(this.query);}},onOptionDestroy:function onOptionDestroy(index){if(index>-1){this.optionsCount--;this.filteredOptionsCount--;this.options.splice(index,1);}},resetInputWidth:function resetInputWidth(){this.inputWidth=this.$refs.reference.$el.getBoundingClientRect().width;},handleResize:function handleResize(){this.resetInputWidth();if(this.multiple)this.resetInputHeight();},checkDefaultFirstOption:function checkDefaultFirstOption(){this.hoverIndex=-1;// highlight the created option
var hasCreated=false;for(var i=this.options.length-1;i>=0;i--){if(this.options[i].created){hasCreated=true;this.hoverIndex=i;break;}}if(hasCreated)return;for(var _i=0;_i!==this.options.length;++_i){var option=this.options[_i];if(this.query){// highlight first options that passes the filter
if(!option.disabled&&!option.groupDisabled&&option.visible){this.hoverIndex=_i;break;}}else{// highlight currently selected option
if(option.itemSelected){this.hoverIndex=_i;break;}}}},getValueKey:function getValueKey(item){if(Object.prototype.toString.call(item.value).toLowerCase()!=='[object object]'){return item.value;}else{return Object(util_["getValueByPath"])(item.value,this.valueKey);}}},created:function created(){var _this13=this;this.cachedPlaceHolder=this.currentPlaceholder=this.propPlaceholder;if(this.multiple&&!Array.isArray(this.value)){this.$emit('input',[]);}if(!this.multiple&&Array.isArray(this.value)){this.$emit('input','');}this.debouncedOnInputChange=debounce_default()(this.debounce,function(){_this13.onInputChange();});this.debouncedQueryChange=debounce_default()(this.debounce,function(e){_this13.handleQueryChange(e.target.value);});this.$on('handleOptionClick',this.handleOptionSelect);this.$on('setSelected',this.setSelected);},mounted:function mounted(){var _this14=this;if(this.multiple&&Array.isArray(this.value)&&this.value.length>0){this.currentPlaceholder='';}Object(resize_event_["addResizeListener"])(this.$el,this.handleResize);var reference=this.$refs.reference;if(reference&&reference.$el){var sizeMap={medium:36,small:32,mini:28};var input=reference.$el.querySelector('input');this.initialInputHeight=input.getBoundingClientRect().height||sizeMap[this.selectSize];}if(this.remote&&this.multiple){this.resetInputHeight();}this.$nextTick(function(){if(reference&&reference.$el){_this14.inputWidth=reference.$el.getBoundingClientRect().width;}});this.setSelected();},beforeDestroy:function beforeDestroy(){if(this.$el&&this.handleResize)Object(resize_event_["removeResizeListener"])(this.$el,this.handleResize);}};// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
/* harmony default export */var src_selectvue_type_script_lang_js_=selectvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/select.vue
/* normalize component */var select_component=normalizeComponent(src_selectvue_type_script_lang_js_,selectvue_type_template_id_0e4aade6_render,selectvue_type_template_id_0e4aade6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var select_api;}select_component.options.__file="packages/select/src/select.vue";/* harmony default export */var src_select=select_component.exports;// CONCATENATED MODULE: ./packages/select/index.js
/* istanbul ignore next */src_select.install=function(Vue){Vue.component(src_select.name,src_select);};/* harmony default export */var packages_select=src_select;// CONCATENATED MODULE: ./packages/option/index.js
/* istanbul ignore next */src_option.install=function(Vue){Vue.component(src_option.name,src_option);};/* harmony default export */var packages_option=src_option;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
var option_groupvue_type_template_id_6685e5de_render=function option_groupvue_type_template_id_6685e5de_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("ul",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-select-group__wrap"},[_c("li",{staticClass:"el-select-group__title"},[_vm._v(_vm._s(_vm.label))]),_c("li",[_c("ul",{staticClass:"el-select-group"},[_vm._t("default")],2)])]);};var option_groupvue_type_template_id_6685e5de_staticRenderFns=[];option_groupvue_type_template_id_6685e5de_render._withStripped=true;// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=template&id=6685e5de&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option-group.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var option_groupvue_type_script_lang_js_={mixins:[emitter_default.a],name:'ElOptionGroup',componentName:'ElOptionGroup',props:{label:String,disabled:{type:Boolean,default:false}},data:function data(){return{visible:true};},watch:{disabled:function disabled(val){this.broadcast('ElOption','handleGroupDisabled',val);}},methods:{queryChange:function queryChange(){this.visible=this.$children&&Array.isArray(this.$children)&&this.$children.some(function(option){return option.visible===true;});}},created:function created(){this.$on('queryChange',this.queryChange);},mounted:function mounted(){if(this.disabled){this.broadcast('ElOption','handleGroupDisabled',this.disabled);}}};// CONCATENATED MODULE: ./packages/select/src/option-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_option_groupvue_type_script_lang_js_=option_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/select/src/option-group.vue
/* normalize component */var option_group_component=normalizeComponent(src_option_groupvue_type_script_lang_js_,option_groupvue_type_template_id_6685e5de_render,option_groupvue_type_template_id_6685e5de_staticRenderFns,false,null,null,null);/* hot reload */if(false){var option_group_api;}option_group_component.options.__file="packages/select/src/option-group.vue";/* harmony default export */var option_group=option_group_component.exports;// CONCATENATED MODULE: ./packages/option-group/index.js
/* istanbul ignore next */option_group.install=function(Vue){Vue.component(option_group.name,option_group);};/* harmony default export */var packages_option_group=option_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var buttonvue_type_template_id_ca859fb4_render=function buttonvue_type_template_id_ca859fb4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("button",{staticClass:"el-button",class:[_vm.type?"el-button--"+_vm.type:"",_vm.buttonSize?"el-button--"+_vm.buttonSize:"",{"is-disabled":_vm.buttonDisabled,"is-loading":_vm.loading,"is-plain":_vm.plain,"is-round":_vm.round,"is-circle":_vm.circle}],attrs:{disabled:_vm.buttonDisabled||_vm.loading,autofocus:_vm.autofocus,type:_vm.nativeType},on:{click:_vm.handleClick}},[_vm.loading?_c("i",{staticClass:"el-icon-loading"}):_vm._e(),_vm.icon&&!_vm.loading?_c("i",{class:_vm.icon}):_vm._e(),_vm.$slots.default?_c("span",[_vm._t("default")],2):_vm._e()]);};var buttonvue_type_template_id_ca859fb4_staticRenderFns=[];buttonvue_type_template_id_ca859fb4_render._withStripped=true;// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var buttonvue_type_script_lang_js_={name:'ElButton',inject:{elForm:{default:''},elFormItem:{default:''}},props:{type:{type:String,default:'default'},size:String,icon:{type:String,default:''},nativeType:{type:String,default:'button'},loading:Boolean,disabled:Boolean,plain:Boolean,autofocus:Boolean,round:Boolean,circle:Boolean},computed:{_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},buttonSize:function buttonSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},buttonDisabled:function buttonDisabled(){return this.$options.propsData.hasOwnProperty('disabled')?this.disabled:(this.elForm||{}).disabled;}},methods:{handleClick:function handleClick(evt){this.$emit('click',evt);}}};// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
/* harmony default export */var src_buttonvue_type_script_lang_js_=buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/button/src/button.vue
/* normalize component */var button_component=normalizeComponent(src_buttonvue_type_script_lang_js_,buttonvue_type_template_id_ca859fb4_render,buttonvue_type_template_id_ca859fb4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var button_api;}button_component.options.__file="packages/button/src/button.vue";/* harmony default export */var src_button=button_component.exports;// CONCATENATED MODULE: ./packages/button/index.js
/* istanbul ignore next */src_button.install=function(Vue){Vue.component(src_button.name,src_button);};/* harmony default export */var packages_button=src_button;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
var button_groupvue_type_template_id_3d8661d0_render=function button_groupvue_type_template_id_3d8661d0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-button-group"},[_vm._t("default")],2);};var button_groupvue_type_template_id_3d8661d0_staticRenderFns=[];button_groupvue_type_template_id_3d8661d0_render._withStripped=true;// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var button_groupvue_type_script_lang_js_={name:'ElButtonGroup'};// CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
/* harmony default export */var src_button_groupvue_type_script_lang_js_=button_groupvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/button/src/button-group.vue
/* normalize component */var button_group_component=normalizeComponent(src_button_groupvue_type_script_lang_js_,button_groupvue_type_template_id_3d8661d0_render,button_groupvue_type_template_id_3d8661d0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var button_group_api;}button_group_component.options.__file="packages/button/src/button-group.vue";/* harmony default export */var button_group=button_group_component.exports;// CONCATENATED MODULE: ./packages/button-group/index.js
/* istanbul ignore next */button_group.install=function(Vue){Vue.component(button_group.name,button_group);};/* harmony default export */var packages_button_group=button_group;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=template&id=493fe34e&
var tablevue_type_template_id_493fe34e_render=function tablevue_type_template_id_493fe34e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-table",class:[{"el-table--fit":_vm.fit,"el-table--striped":_vm.stripe,"el-table--border":_vm.border||_vm.isGroup,"el-table--hidden":_vm.isHidden,"el-table--group":_vm.isGroup,"el-table--fluid-height":_vm.maxHeight,"el-table--scrollable-x":_vm.layout.scrollX,"el-table--scrollable-y":_vm.layout.scrollY,"el-table--enable-row-hover":!_vm.store.states.isComplex,"el-table--enable-row-transition":(_vm.store.states.data||[]).length!==0&&(_vm.store.states.data||[]).length<100},_vm.tableSize?"el-table--"+_vm.tableSize:""],on:{mouseleave:function mouseleave($event){_vm.handleMouseLeave($event);}}},[_c("div",{ref:"hiddenColumns",staticClass:"hidden-columns"},[_vm._t("default")],2),_vm.showHeader?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleHeaderFooterMousewheel,expression:"handleHeaderFooterMousewheel"}],ref:"headerWrapper",staticClass:"el-table__header-wrapper"},[_c("table-header",{ref:"tableHeader",style:{width:_vm.layout.bodyWidth?_vm.layout.bodyWidth+"px":""},attrs:{store:_vm.store,border:_vm.border,"default-sort":_vm.defaultSort}})],1):_vm._e(),_c("div",{ref:"bodyWrapper",staticClass:"el-table__body-wrapper",class:[_vm.layout.scrollX?"is-scrolling-"+_vm.scrollPosition:"is-scrolling-none"],style:[_vm.bodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{context:_vm.context,store:_vm.store,stripe:_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,highlight:_vm.highlightCurrentRow}}),!_vm.data||_vm.data.length===0?_c("div",{ref:"emptyBlock",staticClass:"el-table__empty-block",style:_vm.emptyBlockStyle},[_c("span",{staticClass:"el-table__empty-text"},[_vm._t("empty",[_vm._v(_vm._s(_vm.emptyText||_vm.t("el.table.emptyText")))])],2)]):_vm._e(),_vm.$slots.append?_c("div",{ref:"appendWrapper",staticClass:"el-table__append-wrapper"},[_vm._t("append")],2):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"},{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleHeaderFooterMousewheel,expression:"handleHeaderFooterMousewheel"}],ref:"footerWrapper",staticClass:"el-table__footer-wrapper"},[_c("table-footer",{style:{width:_vm.layout.bodyWidth?_vm.layout.bodyWidth+"px":""},attrs:{store:_vm.store,border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,"default-sort":_vm.defaultSort}})],1):_vm._e(),_vm.fixedColumns.length>0?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleFixedMousewheel,expression:"handleFixedMousewheel"}],ref:"fixedWrapper",staticClass:"el-table__fixed",style:[{width:_vm.layout.fixedWidth?_vm.layout.fixedWidth+"px":""},_vm.fixedHeight]},[_vm.showHeader?_c("div",{ref:"fixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c("table-header",{ref:"fixedTableHeader",style:{width:_vm.bodyWidth},attrs:{fixed:"left",border:_vm.border,store:_vm.store}})],1):_vm._e(),_c("div",{ref:"fixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:[{top:_vm.layout.headerHeight+"px"},_vm.fixedBodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{fixed:"left",store:_vm.store,stripe:_vm.stripe,highlight:_vm.highlightCurrentRow,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle}}),_vm.$slots.append?_c("div",{staticClass:"el-table__append-gutter",style:{height:_vm.layout.appendHeight+"px"}}):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"}],ref:"fixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c("table-footer",{style:{width:_vm.bodyWidth},attrs:{fixed:"left",border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,store:_vm.store}})],1):_vm._e()]):_vm._e(),_vm.rightFixedColumns.length>0?_c("div",{directives:[{name:"mousewheel",rawName:"v-mousewheel",value:_vm.handleFixedMousewheel,expression:"handleFixedMousewheel"}],ref:"rightFixedWrapper",staticClass:"el-table__fixed-right",style:[{width:_vm.layout.rightFixedWidth?_vm.layout.rightFixedWidth+"px":"",right:_vm.layout.scrollY?(_vm.border?_vm.layout.gutterWidth:_vm.layout.gutterWidth||0)+"px":""},_vm.fixedHeight]},[_vm.showHeader?_c("div",{ref:"rightFixedHeaderWrapper",staticClass:"el-table__fixed-header-wrapper"},[_c("table-header",{ref:"rightFixedTableHeader",style:{width:_vm.bodyWidth},attrs:{fixed:"right",border:_vm.border,store:_vm.store}})],1):_vm._e(),_c("div",{ref:"rightFixedBodyWrapper",staticClass:"el-table__fixed-body-wrapper",style:[{top:_vm.layout.headerHeight+"px"},_vm.fixedBodyHeight]},[_c("table-body",{style:{width:_vm.bodyWidth},attrs:{fixed:"right",store:_vm.store,stripe:_vm.stripe,"row-class-name":_vm.rowClassName,"row-style":_vm.rowStyle,highlight:_vm.highlightCurrentRow}}),_vm.$slots.append?_c("div",{staticClass:"el-table__append-gutter",style:{height:_vm.layout.appendHeight+"px"}}):_vm._e()],1),_vm.showSummary?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.data&&_vm.data.length>0,expression:"data && data.length > 0"}],ref:"rightFixedFooterWrapper",staticClass:"el-table__fixed-footer-wrapper"},[_c("table-footer",{style:{width:_vm.bodyWidth},attrs:{fixed:"right",border:_vm.border,"sum-text":_vm.sumText||_vm.t("el.table.sumText"),"summary-method":_vm.summaryMethod,store:_vm.store}})],1):_vm._e()]):_vm._e(),_vm.rightFixedColumns.length>0?_c("div",{ref:"rightFixedPatch",staticClass:"el-table__fixed-right-patch",style:{width:_vm.layout.scrollY?_vm.layout.gutterWidth+"px":"0",height:_vm.layout.headerHeight+"px"}}):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.resizeProxyVisible,expression:"resizeProxyVisible"}],ref:"resizeProxy",staticClass:"el-table__column-resize-proxy"})]);};var tablevue_type_template_id_493fe34e_staticRenderFns=[];tablevue_type_template_id_493fe34e_render._withStripped=true;// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=template&id=493fe34e&
// EXTERNAL MODULE: external "element-ui/lib/checkbox"
var checkbox_=__webpack_require__(14);var checkbox_default=/*#__PURE__*/__webpack_require__.n(checkbox_);// EXTERNAL MODULE: external "throttle-debounce"
var external_throttle_debounce_=__webpack_require__(35);// EXTERNAL MODULE: external "normalize-wheel"
var external_normalize_wheel_=__webpack_require__(38);var external_normalize_wheel_default=/*#__PURE__*/__webpack_require__.n(external_normalize_wheel_);// CONCATENATED MODULE: ./src/directives/mousewheel.js
var isFirefox=typeof navigator!=='undefined'&&navigator.userAgent.toLowerCase().indexOf('firefox')>-1;var mousewheel_mousewheel=function mousewheel(element,callback){if(element&&element.addEventListener){element.addEventListener(isFirefox?'DOMMouseScroll':'mousewheel',function(event){var normalized=external_normalize_wheel_default()(event);callback&&callback.apply(this,[event,normalized]);});}};/* harmony default export */var directives_mousewheel={bind:function bind(el,binding){mousewheel_mousewheel(el,binding.value);}};// EXTERNAL MODULE: external "vue"
var external_vue_=__webpack_require__(6);var external_vue_default=/*#__PURE__*/__webpack_require__.n(external_vue_);// CONCATENATED MODULE: ./packages/table/src/util.js
var util_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var getCell=function getCell(event){var cell=event.target;while(cell&&cell.tagName.toUpperCase()!=='HTML'){if(cell.tagName.toUpperCase()==='TD'){return cell;}cell=cell.parentNode;}return null;};var util_isObject=function isObject(obj){return obj!==null&&(typeof obj==='undefined'?'undefined':util_typeof(obj))==='object';};var util_orderBy=function orderBy(array,sortKey,reverse,sortMethod,sortBy){if(!sortKey&&!sortMethod&&(!sortBy||Array.isArray(sortBy)&&!sortBy.length)){return array;}if(typeof reverse==='string'){reverse=reverse==='descending'?-1:1;}else{reverse=reverse&&reverse<0?-1:1;}var getKey=sortMethod?null:function(value,index){if(sortBy){if(!Array.isArray(sortBy)){sortBy=[sortBy];}return sortBy.map(function(by){if(typeof by==='string'){return Object(util_["getValueByPath"])(value,by);}else{return by(value,index,array);}});}if(sortKey!=='$key'){if(util_isObject(value)&&'$value'in value)value=value.$value;}return[util_isObject(value)?Object(util_["getValueByPath"])(value,sortKey):value];};var compare=function compare(a,b){if(sortMethod){return sortMethod(a.value,b.value);}for(var i=0,len=a.key.length;i<len;i++){if(a.key[i]<b.key[i]){return-1;}if(a.key[i]>b.key[i]){return 1;}}return 0;};return array.map(function(value,index){return{value:value,index:index,key:getKey?getKey(value,index):null};}).sort(function(a,b){var order=compare(a,b);if(!order){// make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
order=a.index-b.index;}return order*reverse;}).map(function(item){return item.value;});};var getColumnById=function getColumnById(table,columnId){var column=null;table.columns.forEach(function(item){if(item.id===columnId){column=item;}});return column;};var getColumnByKey=function getColumnByKey(table,columnKey){var column=null;for(var i=0;i<table.columns.length;i++){var item=table.columns[i];if(item.columnKey===columnKey){column=item;break;}}return column;};var getColumnByCell=function getColumnByCell(table,cell){var matches=(cell.className||'').match(/el-table_[^\s]+/gm);if(matches){return getColumnById(table,matches[0]);}return null;};var getRowIdentity=function getRowIdentity(row,rowKey){if(!row)throw new Error('row is required when get row identity');if(typeof rowKey==='string'){if(rowKey.indexOf('.')<0){return row[rowKey];}var key=rowKey.split('.');var current=row;for(var i=0;i<key.length;i++){current=current[key[i]];}return current;}else if(typeof rowKey==='function'){return rowKey.call(null,row);}};var getKeysMap=function getKeysMap(array,rowKey){var arrayMap={};(array||[]).forEach(function(row,index){arrayMap[getRowIdentity(row,rowKey)]={row:row,index:index};});return arrayMap;};function hasOwn(obj,key){return Object.prototype.hasOwnProperty.call(obj,key);}function mergeOptions(defaults,config){var options={};var key=void 0;for(key in defaults){options[key]=defaults[key];}for(key in config){if(hasOwn(config,key)){var value=config[key];if(typeof value!=='undefined'){options[key]=value;}}}return options;}function parseWidth(width){if(width!==undefined){width=parseInt(width,10);if(isNaN(width)){width=null;}}return width;}function parseMinWidth(minWidth){if(typeof minWidth!=='undefined'){minWidth=parseWidth(minWidth);if(isNaN(minWidth)){minWidth=80;}}return minWidth;};function parseHeight(height){if(typeof height==='number'){return height;}if(typeof height==='string'){if(/^\d+(?:px)?$/.test(height)){return parseInt(height,10);}else{return height;}}return null;}// https://github.com/reduxjs/redux/blob/master/src/compose.js
function compose(){for(var _len=arguments.length,funcs=Array(_len),_key=0;_key<_len;_key++){funcs[_key]=arguments[_key];}if(funcs.length===0){return function(arg){return arg;};}if(funcs.length===1){return funcs[0];}return funcs.reduce(function(a,b){return function(){return a(b.apply(undefined,arguments));};});}function toggleRowStatus(statusArr,row,newVal){var changed=false;var index=statusArr.indexOf(row);var included=index!==-1;var addRow=function addRow(){statusArr.push(row);changed=true;};var removeRow=function removeRow(){statusArr.splice(index,1);changed=true;};if(typeof newVal==='boolean'){if(newVal&&!included){addRow();}else if(!newVal&&included){removeRow();}}else{if(included){removeRow();}else{addRow();}}return changed;}function walkTreeNode(root,cb){var childrenKey=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'children';var lazyKey=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'hasChildren';var isNil=function isNil(array){return!(Array.isArray(array)&&array.length);};function _walker(parent,children,level){cb(parent,children,level);children.forEach(function(item){if(item[lazyKey]){cb(item,null,level+1);return;}var children=item[childrenKey];if(!isNil(children)){_walker(item,children,level+1);}});}root.forEach(function(item){if(item[lazyKey]){cb(item,null,0);return;}var children=item[childrenKey];if(!isNil(children)){_walker(item,children,0);}});}// CONCATENATED MODULE: ./packages/table/src/store/expand.js
/* harmony default export */var expand={data:function data(){return{states:{defaultExpandAll:false,expandRows:[]}};},methods:{updateExpandRows:function updateExpandRows(){var _states=this.states,_states$data=_states.data,data=_states$data===undefined?[]:_states$data,rowKey=_states.rowKey,defaultExpandAll=_states.defaultExpandAll,expandRows=_states.expandRows;if(defaultExpandAll){this.states.expandRows=data.slice();}else if(rowKey){// TODO：这里的代码可以优化
var expandRowsMap=getKeysMap(expandRows,rowKey);this.states.expandRows=data.reduce(function(prev,row){var rowId=getRowIdentity(row,rowKey);var rowInfo=expandRowsMap[rowId];if(rowInfo){prev.push(row);}return prev;},[]);}else{this.states.expandRows=[];}},toggleRowExpansion:function toggleRowExpansion(row,expanded){var changed=toggleRowStatus(this.states.expandRows,row,expanded);if(changed){this.table.$emit('expand-change',row,this.states.expandRows.slice());this.scheduleLayout();}},setExpandRowKeys:function setExpandRowKeys(rowKeys){this.assertRowKey();// TODO：这里的代码可以优化
var _states2=this.states,data=_states2.data,rowKey=_states2.rowKey;var keysMap=getKeysMap(data,rowKey);this.states.expandRows=rowKeys.reduce(function(prev,cur){var info=keysMap[cur];if(info){prev.push(info.row);}return prev;},[]);},isRowExpanded:function isRowExpanded(row){var _states3=this.states,_states3$expandRows=_states3.expandRows,expandRows=_states3$expandRows===undefined?[]:_states3$expandRows,rowKey=_states3.rowKey;if(rowKey){var expandMap=getKeysMap(expandRows,rowKey);return!!expandMap[getRowIdentity(row,rowKey)];}return expandRows.indexOf(row)!==-1;}}};// CONCATENATED MODULE: ./packages/table/src/store/current.js
/* harmony default export */var store_current={data:function data(){return{states:{// 不可响应的，设置 currentRowKey 时，data 不一定存在，也许无法算出正确的 currentRow
// 把该值缓存一下，当用户点击修改 currentRow 时，把该值重置为 null
_currentRowKey:null,currentRow:null}};},methods:{setCurrentRowKey:function setCurrentRowKey(key){this.assertRowKey();this.states._currentRowKey=key;this.setCurrentRowByKey(key);},restoreCurrentRowKey:function restoreCurrentRowKey(){this.states._currentRowKey=null;},setCurrentRowByKey:function setCurrentRowByKey(key){var states=this.states;var _states$data=states.data,data=_states$data===undefined?[]:_states$data,rowKey=states.rowKey;var currentRow=null;if(rowKey){currentRow=Object(util_["arrayFind"])(data,function(item){return getRowIdentity(item,rowKey)===key;});}states.currentRow=currentRow;},updateCurrentRow:function updateCurrentRow(currentRow){var states=this.states,table=this.table;var oldCurrentRow=states.currentRow;if(currentRow&&currentRow!==oldCurrentRow){states.currentRow=currentRow;table.$emit('current-change',currentRow,oldCurrentRow);return;}if(!currentRow&&oldCurrentRow){states.currentRow=null;table.$emit('current-change',null,oldCurrentRow);}},updateCurrentRowData:function updateCurrentRowData(){var states=this.states,table=this.table;var rowKey=states.rowKey,_currentRowKey=states._currentRowKey;// data 为 null 时，解构时的默认值会被忽略
var data=states.data||[];var oldCurrentRow=states.currentRow;// 当 currentRow 不在 data 中时尝试更新数据
if(data.indexOf(oldCurrentRow)===-1&&oldCurrentRow){if(rowKey){var currentRowKey=getRowIdentity(oldCurrentRow,rowKey);this.setCurrentRowByKey(currentRowKey);}else{states.currentRow=null;}if(states.currentRow===null){table.$emit('current-change',null,oldCurrentRow);}}else if(_currentRowKey){// 把初始时下设置的 rowKey 转化成 rowData
this.setCurrentRowByKey(_currentRowKey);this.restoreCurrentRowKey();}}}};// CONCATENATED MODULE: ./packages/table/src/store/tree.js
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var tree={data:function data(){return{states:{// defaultExpandAll 存在于 expand.js 中，这里不重复添加
// 在展开行中，expandRowKeys 会被转化成 expandRows，expandRowKeys 这个属性只是记录了 TreeTable 行的展开
// TODO: 拆分为独立的 TreeTable，统一用法
expandRowKeys:[],treeData:{},indent:16,lazy:false,lazyTreeNodeMap:{},lazyColumnIdentifier:'hasChildren',childrenColumnName:'children'}};},computed:{// 嵌入型的数据，watch 无法是检测到变化 https://github.com/ElemeFE/element/issues/14998
// TODO: 使用 computed 解决该问题，是否会造成性能问题？
// @return { id: { level, children } }
normalizedData:function normalizedData(){if(!this.states.rowKey)return{};var data=this.states.data||[];return this.normalize(data);},// @return { id: { children } }
// 针对懒加载的情形，不处理嵌套数据
normalizedLazyNode:function normalizedLazyNode(){var _states=this.states,rowKey=_states.rowKey,lazyTreeNodeMap=_states.lazyTreeNodeMap,lazyColumnIdentifier=_states.lazyColumnIdentifier;var keys=Object.keys(lazyTreeNodeMap);var res={};if(!keys.length)return res;keys.forEach(function(key){if(lazyTreeNodeMap[key].length){var item={children:[]};lazyTreeNodeMap[key].forEach(function(row){var currentRowKey=getRowIdentity(row,rowKey);item.children.push(currentRowKey);if(row[lazyColumnIdentifier]&&!res[currentRowKey]){res[currentRowKey]={children:[]};}});res[key]=item;}});return res;}},watch:{normalizedData:'updateTreeData',normalizedLazyNode:'updateTreeData'},methods:{normalize:function normalize(data){var _states2=this.states,childrenColumnName=_states2.childrenColumnName,lazyColumnIdentifier=_states2.lazyColumnIdentifier,rowKey=_states2.rowKey,lazy=_states2.lazy;var res={};walkTreeNode(data,function(parent,children,level){var parentId=getRowIdentity(parent,rowKey);if(Array.isArray(children)){res[parentId]={children:children.map(function(row){return getRowIdentity(row,rowKey);}),level:level};}else if(lazy){// 当 children 不存在且 lazy 为 true，该节点即为懒加载的节点
res[parentId]={children:[],lazy:true,level:level};}},childrenColumnName,lazyColumnIdentifier);return res;},updateTreeData:function updateTreeData(){var nested=this.normalizedData;var normalizedLazyNode=this.normalizedLazyNode;var keys=Object.keys(nested);var newTreeData={};if(keys.length){var _states3=this.states,oldTreeData=_states3.treeData,defaultExpandAll=_states3.defaultExpandAll,expandRowKeys=_states3.expandRowKeys,lazy=_states3.lazy;var rootLazyRowKeys=[];var getExpanded=function getExpanded(oldValue,key){var included=defaultExpandAll||expandRowKeys&&expandRowKeys.indexOf(key)!==-1;return!!(oldValue&&oldValue.expanded||included);};// 合并 expanded 与 display，确保数据刷新后，状态不变
keys.forEach(function(key){var oldValue=oldTreeData[key];var newValue=_extends({},nested[key]);newValue.expanded=getExpanded(oldValue,key);if(newValue.lazy){var _ref=oldValue||{},_ref$loaded=_ref.loaded,loaded=_ref$loaded===undefined?false:_ref$loaded,_ref$loading=_ref.loading,loading=_ref$loading===undefined?false:_ref$loading;newValue.loaded=!!loaded;newValue.loading=!!loading;rootLazyRowKeys.push(key);}newTreeData[key]=newValue;});// 根据懒加载数据更新 treeData
var lazyKeys=Object.keys(normalizedLazyNode);if(lazy&&lazyKeys.length&&rootLazyRowKeys.length){lazyKeys.forEach(function(key){var oldValue=oldTreeData[key];var lazyNodeChildren=normalizedLazyNode[key].children;if(rootLazyRowKeys.indexOf(key)!==-1){// 懒加载的 root 节点，更新一下原有的数据，原来的 children 一定是空数组
if(newTreeData[key].children.length!==0){throw new Error('[ElTable]children must be an empty array.');}newTreeData[key].children=lazyNodeChildren;}else{var _ref2=oldValue||{},_ref2$loaded=_ref2.loaded,loaded=_ref2$loaded===undefined?false:_ref2$loaded,_ref2$loading=_ref2.loading,loading=_ref2$loading===undefined?false:_ref2$loading;newTreeData[key]={lazy:true,loaded:!!loaded,loading:!!loading,expanded:getExpanded(oldValue,key),children:lazyNodeChildren,level:''};}});}}this.states.treeData=newTreeData;this.updateTableScrollY();},updateTreeExpandKeys:function updateTreeExpandKeys(value){this.states.expandRowKeys=value;this.updateTreeData();},toggleTreeExpansion:function toggleTreeExpansion(row,expanded){this.assertRowKey();var _states4=this.states,rowKey=_states4.rowKey,treeData=_states4.treeData;var id=getRowIdentity(row,rowKey);var data=id&&treeData[id];if(id&&data&&'expanded'in data){var oldExpanded=data.expanded;expanded=typeof expanded==='undefined'?!data.expanded:expanded;treeData[id].expanded=expanded;if(oldExpanded!==expanded){this.table.$emit('expand-change',row,expanded);}this.updateTableScrollY();}},loadOrToggle:function loadOrToggle(row){this.assertRowKey();var _states5=this.states,lazy=_states5.lazy,treeData=_states5.treeData,rowKey=_states5.rowKey;var id=getRowIdentity(row,rowKey);var data=treeData[id];if(lazy&&data&&'loaded'in data&&!data.loaded){this.loadData(row,id,data);}else{this.toggleTreeExpansion(row);}},loadData:function loadData(row,key,treeNode){var _this=this;var load=this.table.load;var rawTreeData=this.states.treeData;if(load&&!rawTreeData[key].loaded){rawTreeData[key].loading=true;load(row,treeNode,function(data){if(!Array.isArray(data)){throw new Error('[ElTable] data must be an array');}var _states6=_this.states,lazyTreeNodeMap=_states6.lazyTreeNodeMap,treeData=_states6.treeData;treeData[key].loading=false;treeData[key].loaded=true;treeData[key].expanded=true;if(data.length){_this.$set(lazyTreeNodeMap,key,data);}_this.table.$emit('expand-change',row,true);});}}}};// CONCATENATED MODULE: ./packages/table/src/store/watcher.js
var watcher_sortData=function sortData(data,states){var sortingColumn=states.sortingColumn;if(!sortingColumn||typeof sortingColumn.sortable==='string'){return data;}return util_orderBy(data,states.sortProp,states.sortOrder,sortingColumn.sortMethod,sortingColumn.sortBy);};var doFlattenColumns=function doFlattenColumns(columns){var result=[];columns.forEach(function(column){if(column.children){result.push.apply(result,doFlattenColumns(column.children));}else{result.push(column);}});return result;};/* harmony default export */var watcher=external_vue_default.a.extend({data:function data(){return{states:{// 3.0 版本后要求必须设置该属性
rowKey:null,// 渲染的数据来源，是对 table 中的 data 过滤排序后的结果
data:[],// 是否包含固定列
isComplex:false,// 列
_columns:[],// 不可响应的
originColumns:[],columns:[],fixedColumns:[],rightFixedColumns:[],leafColumns:[],fixedLeafColumns:[],rightFixedLeafColumns:[],leafColumnsLength:0,fixedLeafColumnsLength:0,rightFixedLeafColumnsLength:0,// 选择
isAllSelected:false,selection:[],reserveSelection:false,selectOnIndeterminate:false,selectable:null,// 过滤
filters:{},// 不可响应的
filteredData:null,// 排序
sortingColumn:null,sortProp:null,sortOrder:null,hoverRow:null}};},mixins:[expand,store_current,tree],methods:{// 检查 rowKey 是否存在
assertRowKey:function assertRowKey(){var rowKey=this.states.rowKey;if(!rowKey)throw new Error('[ElTable] prop row-key is required');},// 更新列
updateColumns:function updateColumns(){var states=this.states;var _columns=states._columns||[];states.fixedColumns=_columns.filter(function(column){return column.fixed===true||column.fixed==='left';});states.rightFixedColumns=_columns.filter(function(column){return column.fixed==='right';});if(states.fixedColumns.length>0&&_columns[0]&&_columns[0].type==='selection'&&!_columns[0].fixed){_columns[0].fixed=true;states.fixedColumns.unshift(_columns[0]);}var notFixedColumns=_columns.filter(function(column){return!column.fixed;});states.originColumns=[].concat(states.fixedColumns).concat(notFixedColumns).concat(states.rightFixedColumns);var leafColumns=doFlattenColumns(notFixedColumns);var fixedLeafColumns=doFlattenColumns(states.fixedColumns);var rightFixedLeafColumns=doFlattenColumns(states.rightFixedColumns);states.leafColumnsLength=leafColumns.length;states.fixedLeafColumnsLength=fixedLeafColumns.length;states.rightFixedLeafColumnsLength=rightFixedLeafColumns.length;states.columns=[].concat(fixedLeafColumns).concat(leafColumns).concat(rightFixedLeafColumns);states.isComplex=states.fixedColumns.length>0||states.rightFixedColumns.length>0;},// 更新 DOM
scheduleLayout:function scheduleLayout(needUpdateColumns){if(needUpdateColumns){this.updateColumns();}this.table.debouncedUpdateLayout();},// 选择
isSelected:function isSelected(row){var _states$selection=this.states.selection,selection=_states$selection===undefined?[]:_states$selection;return selection.indexOf(row)>-1;},clearSelection:function clearSelection(){var states=this.states;states.isAllSelected=false;var oldSelection=states.selection;if(oldSelection.length){states.selection=[];this.table.$emit('selection-change',[]);}},cleanSelection:function cleanSelection(){var states=this.states;var data=states.data,rowKey=states.rowKey,selection=states.selection;var deleted=void 0;if(rowKey){deleted=[];var selectedMap=getKeysMap(selection,rowKey);var dataMap=getKeysMap(data,rowKey);for(var key in selectedMap){if(selectedMap.hasOwnProperty(key)&&!dataMap[key]){deleted.push(selectedMap[key].row);}}}else{deleted=selection.filter(function(item){return data.indexOf(item)===-1;});}if(deleted.length){var newSelection=selection.filter(function(item){return deleted.indexOf(item)===-1;});states.selection=newSelection;this.table.$emit('selection-change',newSelection.slice());}},toggleRowSelection:function toggleRowSelection(row,selected){var emitChange=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var changed=toggleRowStatus(this.states.selection,row,selected);if(changed){var newSelection=(this.states.selection||[]).slice();// 调用 API 修改选中值，不触发 select 事件
if(emitChange){this.table.$emit('select',newSelection,row);}this.table.$emit('selection-change',newSelection);}},_toggleAllSelection:function _toggleAllSelection(){var states=this.states;var _states$data=states.data,data=_states$data===undefined?[]:_states$data,selection=states.selection;// when only some rows are selected (but not all), select or deselect all of them
// depending on the value of selectOnIndeterminate
var value=states.selectOnIndeterminate?!states.isAllSelected:!(states.isAllSelected||selection.length);states.isAllSelected=value;var selectionChanged=false;data.forEach(function(row,index){if(states.selectable){if(states.selectable.call(null,row,index)&&toggleRowStatus(selection,row,value)){selectionChanged=true;}}else{if(toggleRowStatus(selection,row,value)){selectionChanged=true;}}});if(selectionChanged){this.table.$emit('selection-change',selection?selection.slice():[]);}this.table.$emit('select-all',selection);},updateSelectionByRowKey:function updateSelectionByRowKey(){var states=this.states;var selection=states.selection,rowKey=states.rowKey,data=states.data;var selectedMap=getKeysMap(selection,rowKey);data.forEach(function(row){var rowId=getRowIdentity(row,rowKey);var rowInfo=selectedMap[rowId];if(rowInfo){selection[rowInfo.index]=row;}});},updateAllSelected:function updateAllSelected(){var states=this.states;var selection=states.selection,rowKey=states.rowKey,selectable=states.selectable;// data 为 null 时，解构时的默认值会被忽略
var data=states.data||[];if(data.length===0){states.isAllSelected=false;return;}var selectedMap=void 0;if(rowKey){selectedMap=getKeysMap(selection,rowKey);}var isSelected=function isSelected(row){if(selectedMap){return!!selectedMap[getRowIdentity(row,rowKey)];}else{return selection.indexOf(row)!==-1;}};var isAllSelected=true;var selectedCount=0;for(var i=0,j=data.length;i<j;i++){var item=data[i];var isRowSelectable=selectable&&selectable.call(null,item,i);if(!isSelected(item)){if(!selectable||isRowSelectable){isAllSelected=false;break;}}else{selectedCount++;}}if(selectedCount===0)isAllSelected=false;states.isAllSelected=isAllSelected;},// 过滤与排序
updateFilters:function updateFilters(columns,values){if(!Array.isArray(columns)){columns=[columns];}var states=this.states;var filters={};columns.forEach(function(col){states.filters[col.id]=values;filters[col.columnKey||col.id]=values;});return filters;},updateSort:function updateSort(column,prop,order){if(this.states.sortingColumn&&this.states.sortingColumn!==column){this.states.sortingColumn.order=null;}this.states.sortingColumn=column;this.states.sortProp=prop;this.states.sortOrder=order;},execFilter:function execFilter(){var _this=this;var states=this.states;var _data=states._data,filters=states.filters;var data=_data;Object.keys(filters).forEach(function(columnId){var values=states.filters[columnId];if(!values||values.length===0)return;var column=getColumnById(_this.states,columnId);if(column&&column.filterMethod){data=data.filter(function(row){return values.some(function(value){return column.filterMethod.call(null,value,row,column);});});}});states.filteredData=data;},execSort:function execSort(){var states=this.states;states.data=watcher_sortData(states.filteredData,states);},// 根据 filters 与 sort 去过滤 data
execQuery:function execQuery(ignore){if(!(ignore&&ignore.filter)){this.execFilter();}this.execSort();},clearFilter:function clearFilter(columnKeys){var states=this.states;var _table$$refs=this.table.$refs,tableHeader=_table$$refs.tableHeader,fixedTableHeader=_table$$refs.fixedTableHeader,rightFixedTableHeader=_table$$refs.rightFixedTableHeader;var panels={};if(tableHeader)panels=merge_default()(panels,tableHeader.filterPanels);if(fixedTableHeader)panels=merge_default()(panels,fixedTableHeader.filterPanels);if(rightFixedTableHeader)panels=merge_default()(panels,rightFixedTableHeader.filterPanels);var keys=Object.keys(panels);if(!keys.length)return;if(typeof columnKeys==='string'){columnKeys=[columnKeys];}if(Array.isArray(columnKeys)){var columns=columnKeys.map(function(key){return getColumnByKey(states,key);});keys.forEach(function(key){var column=columns.find(function(col){return col.id===key;});if(column){// TODO: 优化这里的代码
panels[key].filteredValue=[];}});this.commit('filterChange',{column:columns,values:[],silent:true,multi:true});}else{keys.forEach(function(key){// TODO: 优化这里的代码
panels[key].filteredValue=[];});states.filters={};this.commit('filterChange',{column:{},values:[],silent:true});}},clearSort:function clearSort(){var states=this.states;if(!states.sortingColumn)return;this.updateSort(null,null,null);this.commit('changeSortCondition',{silent:true});},// 适配层，expand-row-keys 在 Expand 与 TreeTable 中都有使用
setExpandRowKeysAdapter:function setExpandRowKeysAdapter(val){// 这里会触发额外的计算，但为了兼容性，暂时这么做
this.setExpandRowKeys(val);this.updateTreeExpandKeys(val);},// 展开行与 TreeTable 都要使用
toggleRowExpansionAdapter:function toggleRowExpansionAdapter(row,expanded){var hasExpandColumn=this.states.columns.some(function(_ref){var type=_ref.type;return type==='expand';});if(hasExpandColumn){this.toggleRowExpansion(row,expanded);}else{this.toggleTreeExpansion(row,expanded);}}}});// CONCATENATED MODULE: ./packages/table/src/store/index.js
watcher.prototype.mutations={setData:function setData(states,data){var dataInstanceChanged=states._data!==data;states._data=data;this.execQuery();// 数据变化，更新部分数据。
// 没有使用 computed，而是手动更新部分数据 https://github.com/vuejs/vue/issues/6660#issuecomment-331417140
this.updateCurrentRowData();this.updateExpandRows();if(states.reserveSelection){this.assertRowKey();this.updateSelectionByRowKey();}else{if(dataInstanceChanged){this.clearSelection();}else{this.cleanSelection();}}this.updateAllSelected();this.updateTableScrollY();},insertColumn:function insertColumn(states,column,index,parent){var array=states._columns;if(parent){array=parent.children;if(!array)array=parent.children=[];}if(typeof index!=='undefined'){array.splice(index,0,column);}else{array.push(column);}if(column.type==='selection'){states.selectable=column.selectable;states.reserveSelection=column.reserveSelection;}if(this.table.$ready){this.updateColumns();// hack for dynamics insert column
this.scheduleLayout();}},removeColumn:function removeColumn(states,column,parent){var array=states._columns;if(parent){array=parent.children;if(!array)array=parent.children=[];}if(array){array.splice(array.indexOf(column),1);}if(this.table.$ready){this.updateColumns();// hack for dynamics remove column
this.scheduleLayout();}},sort:function sort(states,options){var prop=options.prop,order=options.order,init=options.init;if(prop){var column=Object(util_["arrayFind"])(states.columns,function(column){return column.property===prop;});if(column){column.order=order;this.updateSort(column,prop,order);this.commit('changeSortCondition',{init:init});}}},changeSortCondition:function changeSortCondition(states,options){// 修复 pr https://github.com/ElemeFE/element/pull/15012 导致的 bug
var column=states.sortingColumn,prop=states.sortProp,order=states.sortOrder;if(order===null){states.sortingColumn=null;states.sortProp=null;}var ingore={filter:true};this.execQuery(ingore);if(!options||!(options.silent||options.init)){this.table.$emit('sort-change',{column:column,prop:prop,order:order});}this.updateTableScrollY();},filterChange:function filterChange(states,options){var column=options.column,values=options.values,silent=options.silent;var newFilters=this.updateFilters(column,values);this.execQuery();if(!silent){this.table.$emit('filter-change',newFilters);}this.updateTableScrollY();},toggleAllSelection:function toggleAllSelection(){this.toggleAllSelection();},rowSelectedChanged:function rowSelectedChanged(states,row){this.toggleRowSelection(row);this.updateAllSelected();},setHoverRow:function setHoverRow(states,row){states.hoverRow=row;},setCurrentRow:function setCurrentRow(states,row){this.updateCurrentRow(row);}};watcher.prototype.commit=function(name){var mutations=this.mutations;if(mutations[name]){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}mutations[name].apply(this,[this.states].concat(args));}else{throw new Error('Action not found: '+name);}};watcher.prototype.updateTableScrollY=function(){external_vue_default.a.nextTick(this.table.updateScrollY);};/* harmony default export */var src_store=watcher;// CONCATENATED MODULE: ./packages/table/src/store/helper.js
function createStore(table){var initialState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(!table){throw new Error('Table is required.');}var store=new src_store();store.table=table;// fix https://github.com/ElemeFE/element/issues/14075
// related pr https://github.com/ElemeFE/element/pull/14146
store.toggleAllSelection=debounce_default()(10,store._toggleAllSelection);Object.keys(initialState).forEach(function(key){store.states[key]=initialState[key];});return store;}function mapStates(mapper){var res={};Object.keys(mapper).forEach(function(key){var value=mapper[key];var fn=void 0;if(typeof value==='string'){fn=function fn(){return this.store.states[value];};}else if(typeof value==='function'){fn=function fn(){return value.call(this,this.store.states);};}else{console.error('invalid value type');}if(fn){res[key]=fn;}});return res;};// EXTERNAL MODULE: external "element-ui/lib/utils/scrollbar-width"
var scrollbar_width_=__webpack_require__(30);var scrollbar_width_default=/*#__PURE__*/__webpack_require__.n(scrollbar_width_);// CONCATENATED MODULE: ./packages/table/src/table-layout.js
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var table_layout_TableLayout=function(){function TableLayout(options){_classCallCheck(this,TableLayout);this.observers=[];this.table=null;this.store=null;this.columns=null;this.fit=true;this.showHeader=true;this.height=null;this.scrollX=false;this.scrollY=false;this.bodyWidth=null;this.fixedWidth=null;this.rightFixedWidth=null;this.tableHeight=null;this.headerHeight=44;// Table Header Height
this.appendHeight=0;// Append Slot Height
this.footerHeight=44;// Table Footer Height
this.viewportHeight=null;// Table Height - Scroll Bar Height
this.bodyHeight=null;// Table Height - Table Header Height
this.fixedBodyHeight=null;// Table Height - Table Header Height - Scroll Bar Height
this.gutterWidth=scrollbar_width_default()();for(var name in options){if(options.hasOwnProperty(name)){this[name]=options[name];}}if(!this.table){throw new Error('table is required for Table Layout');}if(!this.store){throw new Error('store is required for Table Layout');}}TableLayout.prototype.updateScrollY=function updateScrollY(){var height=this.height;if(height===null)return false;var bodyWrapper=this.table.bodyWrapper;if(this.table.$el&&bodyWrapper){var body=bodyWrapper.querySelector('.el-table__body');var prevScrollY=this.scrollY;var scrollY=body.offsetHeight>this.bodyHeight;this.scrollY=scrollY;return prevScrollY!==scrollY;}return false;};TableLayout.prototype.setHeight=function setHeight(value){var _this=this;var prop=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'height';if(external_vue_default.a.prototype.$isServer)return;var el=this.table.$el;value=parseHeight(value);this.height=value;if(!el&&(value||value===0))return external_vue_default.a.nextTick(function(){return _this.setHeight(value,prop);});if(typeof value==='number'){el.style[prop]=value+'px';this.updateElsHeight();}else if(typeof value==='string'){el.style[prop]=value;this.updateElsHeight();}};TableLayout.prototype.setMaxHeight=function setMaxHeight(value){this.setHeight(value,'max-height');};TableLayout.prototype.getFlattenColumns=function getFlattenColumns(){var flattenColumns=[];var columns=this.table.columns;columns.forEach(function(column){if(column.isColumnGroup){flattenColumns.push.apply(flattenColumns,column.columns);}else{flattenColumns.push(column);}});return flattenColumns;};TableLayout.prototype.updateElsHeight=function updateElsHeight(){var _this2=this;if(!this.table.$ready)return external_vue_default.a.nextTick(function(){return _this2.updateElsHeight();});var _table$$refs=this.table.$refs,headerWrapper=_table$$refs.headerWrapper,appendWrapper=_table$$refs.appendWrapper,footerWrapper=_table$$refs.footerWrapper;this.appendHeight=appendWrapper?appendWrapper.offsetHeight:0;if(this.showHeader&&!headerWrapper)return;// fix issue (https://github.com/ElemeFE/element/pull/16956)
var headerTrElm=headerWrapper?headerWrapper.querySelector('.el-table__header tr'):null;var noneHeader=this.headerDisplayNone(headerTrElm);var headerHeight=this.headerHeight=!this.showHeader?0:headerWrapper.offsetHeight;if(this.showHeader&&!noneHeader&&headerWrapper.offsetWidth>0&&(this.table.columns||[]).length>0&&headerHeight<2){return external_vue_default.a.nextTick(function(){return _this2.updateElsHeight();});}var tableHeight=this.tableHeight=this.table.$el.clientHeight;var footerHeight=this.footerHeight=footerWrapper?footerWrapper.offsetHeight:0;if(this.height!==null){this.bodyHeight=tableHeight-headerHeight-footerHeight+(footerWrapper?1:0);}this.fixedBodyHeight=this.scrollX?this.bodyHeight-this.gutterWidth:this.bodyHeight;var noData=!(this.store.states.data&&this.store.states.data.length);this.viewportHeight=this.scrollX?tableHeight-(noData?0:this.gutterWidth):tableHeight;this.updateScrollY();this.notifyObservers('scrollable');};TableLayout.prototype.headerDisplayNone=function headerDisplayNone(elm){if(!elm)return true;var headerChild=elm;while(headerChild.tagName!=='DIV'){if(getComputedStyle(headerChild).display==='none'){return true;}headerChild=headerChild.parentElement;}return false;};TableLayout.prototype.updateColumnsWidth=function updateColumnsWidth(){if(external_vue_default.a.prototype.$isServer)return;var fit=this.fit;var bodyWidth=this.table.$el.clientWidth;var bodyMinWidth=0;var flattenColumns=this.getFlattenColumns();var flexColumns=flattenColumns.filter(function(column){return typeof column.width!=='number';});flattenColumns.forEach(function(column){// Clean those columns whose width changed from flex to unflex
if(typeof column.width==='number'&&column.realWidth)column.realWidth=null;});if(flexColumns.length>0&&fit){flattenColumns.forEach(function(column){bodyMinWidth+=column.width||column.minWidth||80;});var scrollYWidth=this.scrollY?this.gutterWidth:0;if(bodyMinWidth<=bodyWidth-scrollYWidth){// DON'T HAVE SCROLL BAR
this.scrollX=false;var totalFlexWidth=bodyWidth-scrollYWidth-bodyMinWidth;if(flexColumns.length===1){flexColumns[0].realWidth=(flexColumns[0].minWidth||80)+totalFlexWidth;}else{var allColumnsWidth=flexColumns.reduce(function(prev,column){return prev+(column.minWidth||80);},0);var flexWidthPerPixel=totalFlexWidth/allColumnsWidth;var noneFirstWidth=0;flexColumns.forEach(function(column,index){if(index===0)return;var flexWidth=Math.floor((column.minWidth||80)*flexWidthPerPixel);noneFirstWidth+=flexWidth;column.realWidth=(column.minWidth||80)+flexWidth;});flexColumns[0].realWidth=(flexColumns[0].minWidth||80)+totalFlexWidth-noneFirstWidth;}}else{// HAVE HORIZONTAL SCROLL BAR
this.scrollX=true;flexColumns.forEach(function(column){column.realWidth=column.minWidth;});}this.bodyWidth=Math.max(bodyMinWidth,bodyWidth);this.table.resizeState.width=this.bodyWidth;}else{flattenColumns.forEach(function(column){if(!column.width&&!column.minWidth){column.realWidth=80;}else{column.realWidth=column.width||column.minWidth;}bodyMinWidth+=column.realWidth;});this.scrollX=bodyMinWidth>bodyWidth;this.bodyWidth=bodyMinWidth;}var fixedColumns=this.store.states.fixedColumns;if(fixedColumns.length>0){var fixedWidth=0;fixedColumns.forEach(function(column){fixedWidth+=column.realWidth||column.width;});this.fixedWidth=fixedWidth;}var rightFixedColumns=this.store.states.rightFixedColumns;if(rightFixedColumns.length>0){var rightFixedWidth=0;rightFixedColumns.forEach(function(column){rightFixedWidth+=column.realWidth||column.width;});this.rightFixedWidth=rightFixedWidth;}this.notifyObservers('columns');};TableLayout.prototype.addObserver=function addObserver(observer){this.observers.push(observer);};TableLayout.prototype.removeObserver=function removeObserver(observer){var index=this.observers.indexOf(observer);if(index!==-1){this.observers.splice(index,1);}};TableLayout.prototype.notifyObservers=function notifyObservers(event){var _this3=this;var observers=this.observers;observers.forEach(function(observer){switch(event){case'columns':observer.onColumnsChange(_this3);break;case'scrollable':observer.onScrollableChange(_this3);break;default:throw new Error('Table Layout don\'t have event '+event+'.');}});};return TableLayout;}();/* harmony default export */var table_layout=table_layout_TableLayout;// CONCATENATED MODULE: ./packages/table/src/layout-observer.js
/* harmony default export */var layout_observer={created:function created(){this.tableLayout.addObserver(this);},destroyed:function destroyed(){this.tableLayout.removeObserver(this);},computed:{tableLayout:function tableLayout(){var layout=this.layout;if(!layout&&this.table){layout=this.table.layout;}if(!layout){throw new Error('Can not find table layout.');}return layout;}},mounted:function mounted(){this.onColumnsChange(this.tableLayout);this.onScrollableChange(this.tableLayout);},updated:function updated(){if(this.__updated__)return;this.onColumnsChange(this.tableLayout);this.onScrollableChange(this.tableLayout);this.__updated__=true;},methods:{onColumnsChange:function onColumnsChange(layout){var cols=this.$el.querySelectorAll('colgroup > col');if(!cols.length)return;var flattenColumns=layout.getFlattenColumns();var columnsMap={};flattenColumns.forEach(function(column){columnsMap[column.id]=column;});for(var i=0,j=cols.length;i<j;i++){var col=cols[i];var name=col.getAttribute('name');var column=columnsMap[name];if(column){col.setAttribute('width',column.realWidth||column.width);}}},onScrollableChange:function onScrollableChange(layout){var cols=this.$el.querySelectorAll('colgroup > col[name=gutter]');for(var i=0,j=cols.length;i<j;i++){var col=cols[i];col.setAttribute('width',layout.scrollY?layout.gutterWidth:'0');}var ths=this.$el.querySelectorAll('th.gutter');for(var _i=0,_j=ths.length;_i<_j;_i++){var th=ths[_i];th.style.width=layout.scrollY?layout.gutterWidth+'px':'0';th.style.display=layout.scrollY?'':'none';}}}};// CONCATENATED MODULE: ./packages/table/src/table-row.js
var table_row_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_row={name:'ElTableRow',props:['columns','row','index','isSelected','isExpanded','store','context','firstDefaultColumnIndex','treeRowData','treeIndent','columnsHidden','getSpan','getColspanRealWidth','getCellStyle','getCellClass','handleCellMouseLeave','handleCellMouseEnter','fixed'],components:{ElCheckbox:checkbox_default.a},render:function render(){var _this=this;var h=arguments[0];var columns=this.columns,row=this.row,$index=this.index,store=this.store,context=this.context,firstDefaultColumnIndex=this.firstDefaultColumnIndex,treeRowData=this.treeRowData,treeIndent=this.treeIndent,_columnsHidden=this.columnsHidden,columnsHidden=_columnsHidden===undefined?[]:_columnsHidden,isSelected=this.isSelected,isExpanded=this.isExpanded;return h('tr',[columns.map(function(column,cellIndex){var _getSpan=_this.getSpan(row,column,$index,cellIndex),rowspan=_getSpan.rowspan,colspan=_getSpan.colspan;if(!rowspan||!colspan){return null;}var columnData=table_row_extends({},column);columnData.realWidth=_this.getColspanRealWidth(columns,colspan,cellIndex);var data={store:store,isSelected:isSelected,isExpanded:isExpanded,_self:context,column:columnData,row:row,$index:$index};if(cellIndex===firstDefaultColumnIndex&&treeRowData){data.treeNode={indent:treeRowData.level*treeIndent,level:treeRowData.level};if(typeof treeRowData.expanded==='boolean'){data.treeNode.expanded=treeRowData.expanded;// 表明是懒加载
if('loading'in treeRowData){data.treeNode.loading=treeRowData.loading;}if('noLazyChildren'in treeRowData){data.treeNode.noLazyChildren=treeRowData.noLazyChildren;}}}return h('td',{style:_this.getCellStyle($index,cellIndex,row,column),'class':_this.getCellClass($index,cellIndex,row,column),attrs:{rowspan:rowspan,colspan:colspan},on:{'mouseenter':function mouseenter($event){return _this.handleCellMouseEnter($event,row);},'mouseleave':_this.handleCellMouseLeave}},[column.renderCell.call(_this._renderProxy,_this.$createElement,data,columnsHidden[cellIndex])]);})]);}};// CONCATENATED MODULE: ./packages/table/src/table-body.js
var table_body_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var table_body_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_body={name:'ElTableBody',mixins:[layout_observer],components:{ElCheckbox:checkbox_default.a,ElTooltip:tooltip_default.a,TableRow:table_row},props:{store:{required:true},stripe:Boolean,context:{},rowClassName:[String,Function],rowStyle:[Object,Function],fixed:String,highlight:Boolean},render:function render(h){var _this=this;var data=this.data||[];return h('table',{'class':'el-table__body',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});})]),h('tbody',[data.reduce(function(acc,row){return acc.concat(_this.wrappedRowRender(row,acc.length));},[]),h('el-tooltip',{attrs:{effect:this.table.tooltipEffect,placement:'top',content:this.tooltipContent},ref:'tooltip'})])]);},computed:table_body_extends({table:function table(){return this.$parent;}},mapStates({data:'data',columns:'columns',treeIndent:'indent',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;},hasExpandColumn:function hasExpandColumn(states){return states.columns.some(function(_ref){var type=_ref.type;return type==='expand';});}}),{columnsHidden:function columnsHidden(){var _this2=this;return this.columns.map(function(column,index){return _this2.isColumnHidden(index);});},firstDefaultColumnIndex:function firstDefaultColumnIndex(){return Object(util_["arrayFindIndex"])(this.columns,function(_ref2){var type=_ref2.type;return type==='default';});}}),watch:{// don't trigger getter of currentRow in getCellClass. see https://jsfiddle.net/oe2b4hqt/
// update DOM manually. see https://github.com/ElemeFE/element/pull/13954/files#diff-9b450c00d0a9dec0ffad5a3176972e40
'store.states.hoverRow':function storeStatesHoverRow(newVal,oldVal){var _this3=this;if(!this.store.states.isComplex||this.$isServer)return;var raf=window.requestAnimationFrame;if(!raf){raf=function raf(fn){return setTimeout(fn,16);};}raf(function(){var rows=_this3.$el.querySelectorAll('.el-table__row');var oldRow=rows[oldVal];var newRow=rows[newVal];if(oldRow){Object(dom_["removeClass"])(oldRow,'hover-row');}if(newRow){Object(dom_["addClass"])(newRow,'hover-row');}});}},data:function data(){return{tooltipContent:''};},created:function created(){this.activateTooltip=debounce_default()(50,function(tooltip){return tooltip.handleShowPopper();});},methods:{getKeyOfRow:function getKeyOfRow(row,index){var rowKey=this.table.rowKey;if(rowKey){return getRowIdentity(row,rowKey);}return index;},isColumnHidden:function isColumnHidden(index){if(this.fixed===true||this.fixed==='left'){return index>=this.leftFixedLeafCount;}else if(this.fixed==='right'){return index<this.columnsCount-this.rightFixedLeafCount;}else{return index<this.leftFixedLeafCount||index>=this.columnsCount-this.rightFixedLeafCount;}},getSpan:function getSpan(row,column,rowIndex,columnIndex){var rowspan=1;var colspan=1;var fn=this.table.spanMethod;if(typeof fn==='function'){var result=fn({row:row,column:column,rowIndex:rowIndex,columnIndex:columnIndex});if(Array.isArray(result)){rowspan=result[0];colspan=result[1];}else if((typeof result==='undefined'?'undefined':table_body_typeof(result))==='object'){rowspan=result.rowspan;colspan=result.colspan;}}return{rowspan:rowspan,colspan:colspan};},getRowStyle:function getRowStyle(row,rowIndex){var rowStyle=this.table.rowStyle;if(typeof rowStyle==='function'){return rowStyle.call(null,{row:row,rowIndex:rowIndex});}return rowStyle||null;},getRowClass:function getRowClass(row,rowIndex){var classes=['el-table__row'];if(this.table.highlightCurrentRow&&row===this.store.states.currentRow){classes.push('current-row');}if(this.stripe&&rowIndex%2===1){classes.push('el-table__row--striped');}var rowClassName=this.table.rowClassName;if(typeof rowClassName==='string'){classes.push(rowClassName);}else if(typeof rowClassName==='function'){classes.push(rowClassName.call(null,{row:row,rowIndex:rowIndex}));}if(this.store.states.expandRows.indexOf(row)>-1){classes.push('expanded');}return classes;},getCellStyle:function getCellStyle(rowIndex,columnIndex,row,column){var cellStyle=this.table.cellStyle;if(typeof cellStyle==='function'){return cellStyle.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column});}return cellStyle;},getCellClass:function getCellClass(rowIndex,columnIndex,row,column){var classes=[column.id,column.align,column.className];if(this.isColumnHidden(columnIndex)){classes.push('is-hidden');}var cellClassName=this.table.cellClassName;if(typeof cellClassName==='string'){classes.push(cellClassName);}else if(typeof cellClassName==='function'){classes.push(cellClassName.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column}));}classes.push('el-table__cell');return classes.join(' ');},getColspanRealWidth:function getColspanRealWidth(columns,colspan,index){if(colspan<1){return columns[index].realWidth;}var widthArr=columns.map(function(_ref3){var realWidth=_ref3.realWidth;return realWidth;}).slice(index,index+colspan);return widthArr.reduce(function(acc,width){return acc+width;},-1);},handleCellMouseEnter:function handleCellMouseEnter(event,row){var table=this.table;var cell=getCell(event);if(cell){var column=getColumnByCell(table,cell);var hoverState=table.hoverState={cell:cell,column:column,row:row};table.$emit('cell-mouse-enter',hoverState.row,hoverState.column,hoverState.cell,event);}// 判断是否text-overflow, 如果是就显示tooltip
var cellChild=event.target.querySelector('.cell');if(!(Object(dom_["hasClass"])(cellChild,'el-tooltip')&&cellChild.childNodes.length)){return;}// use range width instead of scrollWidth to determine whether the text is overflowing
// to address a potential FireFox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1074543#c3
var range=document.createRange();range.setStart(cellChild,0);range.setEnd(cellChild,cellChild.childNodes.length);var rangeWidth=range.getBoundingClientRect().width;var padding=(parseInt(Object(dom_["getStyle"])(cellChild,'paddingLeft'),10)||0)+(parseInt(Object(dom_["getStyle"])(cellChild,'paddingRight'),10)||0);if((rangeWidth+padding>cellChild.offsetWidth||cellChild.scrollWidth>cellChild.offsetWidth)&&this.$refs.tooltip){var tooltip=this.$refs.tooltip;// TODO 会引起整个 Table 的重新渲染，需要优化
this.tooltipContent=cell.innerText||cell.textContent;tooltip.referenceElm=cell;tooltip.$refs.popper&&(tooltip.$refs.popper.style.display='none');tooltip.doDestroy();tooltip.setExpectedState(true);this.activateTooltip(tooltip);}},handleCellMouseLeave:function handleCellMouseLeave(event){var tooltip=this.$refs.tooltip;if(tooltip){tooltip.setExpectedState(false);tooltip.handleClosePopper();}var cell=getCell(event);if(!cell)return;var oldHoverState=this.table.hoverState||{};this.table.$emit('cell-mouse-leave',oldHoverState.row,oldHoverState.column,oldHoverState.cell,event);},handleMouseEnter:debounce_default()(30,function(index){this.store.commit('setHoverRow',index);}),handleMouseLeave:debounce_default()(30,function(){this.store.commit('setHoverRow',null);}),handleContextMenu:function handleContextMenu(event,row){this.handleEvent(event,row,'contextmenu');},handleDoubleClick:function handleDoubleClick(event,row){this.handleEvent(event,row,'dblclick');},handleClick:function handleClick(event,row){this.store.commit('setCurrentRow',row);this.handleEvent(event,row,'click');},handleEvent:function handleEvent(event,row,name){var table=this.table;var cell=getCell(event);var column=void 0;if(cell){column=getColumnByCell(table,cell);if(column){table.$emit('cell-'+name,row,column,cell,event);}}table.$emit('row-'+name,row,column,event);},rowRender:function rowRender(row,$index,treeRowData){var _this4=this;var h=this.$createElement;var treeIndent=this.treeIndent,columns=this.columns,firstDefaultColumnIndex=this.firstDefaultColumnIndex;var rowClasses=this.getRowClass(row,$index);var display=true;if(treeRowData){rowClasses.push('el-table__row--level-'+treeRowData.level);display=treeRowData.display;}// 指令 v-show 会覆盖 row-style 中 display
// 使用 :style 代替 v-show https://github.com/ElemeFE/element/issues/16995
var displayStyle=display?null:{display:'none'};return h(table_row,{style:[displayStyle,this.getRowStyle(row,$index)],'class':rowClasses,key:this.getKeyOfRow(row,$index),nativeOn:{'dblclick':function dblclick($event){return _this4.handleDoubleClick($event,row);},'click':function click($event){return _this4.handleClick($event,row);},'contextmenu':function contextmenu($event){return _this4.handleContextMenu($event,row);},'mouseenter':function mouseenter(_){return _this4.handleMouseEnter($index);},'mouseleave':this.handleMouseLeave},attrs:{columns:columns,row:row,index:$index,store:this.store,context:this.context||this.table.$vnode.context,firstDefaultColumnIndex:firstDefaultColumnIndex,treeRowData:treeRowData,treeIndent:treeIndent,columnsHidden:this.columnsHidden,getSpan:this.getSpan,getColspanRealWidth:this.getColspanRealWidth,getCellStyle:this.getCellStyle,getCellClass:this.getCellClass,handleCellMouseEnter:this.handleCellMouseEnter,handleCellMouseLeave:this.handleCellMouseLeave,isSelected:this.store.isSelected(row),isExpanded:this.store.states.expandRows.indexOf(row)>-1,fixed:this.fixed}});},wrappedRowRender:function wrappedRowRender(row,$index){var _this5=this;var h=this.$createElement;var store=this.store;var isRowExpanded=store.isRowExpanded,assertRowKey=store.assertRowKey;var _store$states=store.states,treeData=_store$states.treeData,lazyTreeNodeMap=_store$states.lazyTreeNodeMap,childrenColumnName=_store$states.childrenColumnName,rowKey=_store$states.rowKey;if(this.hasExpandColumn&&isRowExpanded(row)){var renderExpanded=this.table.renderExpanded;var tr=this.rowRender(row,$index);if(!renderExpanded){console.error('[Element Error]renderExpanded is required.');return tr;}// 使用二维数组，避免修改 $index
return[[tr,h('tr',{key:'expanded-row__'+tr.key},[h('td',{attrs:{colspan:this.columnsCount},'class':'el-table__cell el-table__expanded-cell'},[renderExpanded(this.$createElement,{row:row,$index:$index,store:this.store})])])]];}else if(Object.keys(treeData).length){assertRowKey();// TreeTable 时，rowKey 必须由用户设定，不使用 getKeyOfRow 计算
// 在调用 rowRender 函数时，仍然会计算 rowKey，不太好的操作
var key=getRowIdentity(row,rowKey);var cur=treeData[key];var treeRowData=null;if(cur){treeRowData={expanded:cur.expanded,level:cur.level,display:true};if(typeof cur.lazy==='boolean'){if(typeof cur.loaded==='boolean'&&cur.loaded){treeRowData.noLazyChildren=!(cur.children&&cur.children.length);}treeRowData.loading=cur.loading;}}var tmp=[this.rowRender(row,$index,treeRowData)];// 渲染嵌套数据
if(cur){// currentRow 记录的是 index，所以还需主动增加 TreeTable 的 index
var i=0;var traverse=function traverse(children,parent){if(!(children&&children.length&&parent))return;children.forEach(function(node){// 父节点的 display 状态影响子节点的显示状态
var innerTreeRowData={display:parent.display&&parent.expanded,level:parent.level+1};var childKey=getRowIdentity(node,rowKey);if(childKey===undefined||childKey===null){throw new Error('for nested data item, row-key is required.');}cur=table_body_extends({},treeData[childKey]);// 对于当前节点，分成有无子节点两种情况。
// 如果包含子节点的，设置 expanded 属性。
// 对于它子节点的 display 属性由它本身的 expanded 与 display 共同决定。
if(cur){innerTreeRowData.expanded=cur.expanded;// 懒加载的某些节点，level 未知
cur.level=cur.level||innerTreeRowData.level;cur.display=!!(cur.expanded&&innerTreeRowData.display);if(typeof cur.lazy==='boolean'){if(typeof cur.loaded==='boolean'&&cur.loaded){innerTreeRowData.noLazyChildren=!(cur.children&&cur.children.length);}innerTreeRowData.loading=cur.loading;}}i++;tmp.push(_this5.rowRender(node,$index+i,innerTreeRowData));if(cur){var _nodes=lazyTreeNodeMap[childKey]||node[childrenColumnName];traverse(_nodes,cur);}});};// 对于 root 节点，display 一定为 true
cur.display=true;var nodes=lazyTreeNodeMap[key]||row[childrenColumnName];traverse(nodes,cur);}return tmp;}else{return this.rowRender(row,$index);}}}};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
var filter_panelvue_type_template_id_7f2c919f_render=function filter_panelvue_type_template_id_7f2c919f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"}},[_vm.multiple?_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleOutsideClick,expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-table-filter"},[_c("div",{staticClass:"el-table-filter__content"},[_c("el-scrollbar",{attrs:{"wrap-class":"el-table-filter__wrap"}},[_c("el-checkbox-group",{staticClass:"el-table-filter__checkbox-group",model:{value:_vm.filteredValue,callback:function callback($$v){_vm.filteredValue=$$v;},expression:"filteredValue"}},_vm._l(_vm.filters,function(filter){return _c("el-checkbox",{key:filter.value,attrs:{label:filter.value}},[_vm._v(_vm._s(filter.text))]);}),1)],1)],1),_c("div",{staticClass:"el-table-filter__bottom"},[_c("button",{class:{"is-disabled":_vm.filteredValue.length===0},attrs:{disabled:_vm.filteredValue.length===0},on:{click:_vm.handleConfirm}},[_vm._v(_vm._s(_vm.t("el.table.confirmFilter")))]),_c("button",{on:{click:_vm.handleReset}},[_vm._v(_vm._s(_vm.t("el.table.resetFilter")))])])]):_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleOutsideClick,expression:"handleOutsideClick"},{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-table-filter"},[_c("ul",{staticClass:"el-table-filter__list"},[_c("li",{staticClass:"el-table-filter__list-item",class:{"is-active":_vm.filterValue===undefined||_vm.filterValue===null},on:{click:function click($event){_vm.handleSelect(null);}}},[_vm._v(_vm._s(_vm.t("el.table.clearFilter")))]),_vm._l(_vm.filters,function(filter){return _c("li",{key:filter.value,staticClass:"el-table-filter__list-item",class:{"is-active":_vm.isActive(filter)},attrs:{label:filter.value},on:{click:function click($event){_vm.handleSelect(filter.value);}}},[_vm._v(_vm._s(filter.text))]);})],2)])]);};var filter_panelvue_type_template_id_7f2c919f_staticRenderFns=[];filter_panelvue_type_template_id_7f2c919f_render._withStripped=true;// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=template&id=7f2c919f&
// CONCATENATED MODULE: ./packages/table/src/dropdown.js
var dropdowns=[];!external_vue_default.a.prototype.$isServer&&document.addEventListener('click',function(event){dropdowns.forEach(function(dropdown){var target=event.target;if(!dropdown||!dropdown.$el)return;if(target===dropdown.$el||dropdown.$el.contains(target)){return;}dropdown.handleOutsideClick&&dropdown.handleOutsideClick(event);});});/* harmony default export */var src_dropdown={open:function open(instance){if(instance){dropdowns.push(instance);}},close:function close(instance){var index=dropdowns.indexOf(instance);if(index!==-1){dropdowns.splice(instance,1);}}};// EXTERNAL MODULE: external "element-ui/lib/checkbox-group"
var checkbox_group_=__webpack_require__(31);var checkbox_group_default=/*#__PURE__*/__webpack_require__.n(checkbox_group_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var filter_panelvue_type_script_lang_js_={name:'ElTableFilterPanel',mixins:[vue_popper_default.a,locale_default.a],directives:{Clickoutside:clickoutside_default.a},components:{ElCheckbox:checkbox_default.a,ElCheckboxGroup:checkbox_group_default.a,ElScrollbar:scrollbar_default.a},props:{placement:{type:String,default:'bottom-end'}},methods:{isActive:function isActive(filter){return filter.value===this.filterValue;},handleOutsideClick:function handleOutsideClick(){var _this=this;setTimeout(function(){_this.showPopper=false;},16);},handleConfirm:function handleConfirm(){this.confirmFilter(this.filteredValue);this.handleOutsideClick();},handleReset:function handleReset(){this.filteredValue=[];this.confirmFilter(this.filteredValue);this.handleOutsideClick();},handleSelect:function handleSelect(filterValue){this.filterValue=filterValue;if(typeof filterValue!=='undefined'&&filterValue!==null){this.confirmFilter(this.filteredValue);}else{this.confirmFilter([]);}this.handleOutsideClick();},confirmFilter:function confirmFilter(filteredValue){this.table.store.commit('filterChange',{column:this.column,values:filteredValue});this.table.store.updateAllSelected();}},data:function data(){return{table:null,cell:null,column:null};},computed:{filters:function filters(){return this.column&&this.column.filters;},filterValue:{get:function get(){return(this.column.filteredValue||[])[0];},set:function set(value){if(this.filteredValue){if(typeof value!=='undefined'&&value!==null){this.filteredValue.splice(0,1,value);}else{this.filteredValue.splice(0,1);}}}},filteredValue:{get:function get(){if(this.column){return this.column.filteredValue||[];}return[];},set:function set(value){if(this.column){this.column.filteredValue=value;}}},multiple:function multiple(){if(this.column){return this.column.filterMultiple;}return true;}},mounted:function mounted(){var _this2=this;this.popperElm=this.$el;this.referenceElm=this.cell;this.table.bodyWrapper.addEventListener('scroll',function(){_this2.updatePopper();});this.$watch('showPopper',function(value){if(_this2.column)_this2.column.filterOpened=value;if(value){src_dropdown.open(_this2);}else{src_dropdown.close(_this2);}});},watch:{showPopper:function showPopper(val){if(val===true&&parseInt(this.popperJS._popper.style.zIndex,10)<popup_["PopupManager"].zIndex){this.popperJS._popper.style.zIndex=popup_["PopupManager"].nextZIndex();}}}};// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_filter_panelvue_type_script_lang_js_=filter_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/table/src/filter-panel.vue
/* normalize component */var filter_panel_component=normalizeComponent(src_filter_panelvue_type_script_lang_js_,filter_panelvue_type_template_id_7f2c919f_render,filter_panelvue_type_template_id_7f2c919f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var filter_panel_api;}filter_panel_component.options.__file="packages/table/src/filter-panel.vue";/* harmony default export */var filter_panel=filter_panel_component.exports;// CONCATENATED MODULE: ./packages/table/src/table-header.js
var table_header_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var getAllColumns=function getAllColumns(columns){var result=[];columns.forEach(function(column){if(column.children){result.push(column);result.push.apply(result,getAllColumns(column.children));}else{result.push(column);}});return result;};var convertToRows=function convertToRows(originColumns){var maxLevel=1;var traverse=function traverse(column,parent){if(parent){column.level=parent.level+1;if(maxLevel<column.level){maxLevel=column.level;}}if(column.children){var colSpan=0;column.children.forEach(function(subColumn){traverse(subColumn,column);colSpan+=subColumn.colSpan;});column.colSpan=colSpan;}else{column.colSpan=1;}};originColumns.forEach(function(column){column.level=1;traverse(column);});var rows=[];for(var i=0;i<maxLevel;i++){rows.push([]);}var allColumns=getAllColumns(originColumns);allColumns.forEach(function(column){if(!column.children){column.rowSpan=maxLevel-column.level+1;}else{column.rowSpan=1;}rows[column.level-1].push(column);});return rows;};/* harmony default export */var table_header={name:'ElTableHeader',mixins:[layout_observer],render:function render(h){var _this=this;var originColumns=this.store.states.originColumns;var columnRows=convertToRows(originColumns,this.columns);// 是否拥有多级表头
var isGroup=columnRows.length>1;if(isGroup)this.$parent.isGroup=true;return h('table',{'class':'el-table__header',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});}),this.hasGutter?h('col',{attrs:{name:'gutter'}}):'']),h('thead',{'class':[{'is-group':isGroup,'has-gutter':this.hasGutter}]},[this._l(columnRows,function(columns,rowIndex){return h('tr',{style:_this.getHeaderRowStyle(rowIndex),'class':_this.getHeaderRowClass(rowIndex)},[columns.map(function(column,cellIndex){return h('th',{attrs:{colspan:column.colSpan,rowspan:column.rowSpan},on:{'mousemove':function mousemove($event){return _this.handleMouseMove($event,column);},'mouseout':_this.handleMouseOut,'mousedown':function mousedown($event){return _this.handleMouseDown($event,column);},'click':function click($event){return _this.handleHeaderClick($event,column);},'contextmenu':function contextmenu($event){return _this.handleHeaderContextMenu($event,column);}},style:_this.getHeaderCellStyle(rowIndex,cellIndex,columns,column),'class':_this.getHeaderCellClass(rowIndex,cellIndex,columns,column),key:column.id},[h('div',{'class':['cell',column.filteredValue&&column.filteredValue.length>0?'highlight':'',column.labelClassName]},[column.renderHeader?column.renderHeader.call(_this._renderProxy,h,{column:column,$index:cellIndex,store:_this.store,_self:_this.$parent.$vnode.context}):column.label,column.sortable?h('span',{'class':'caret-wrapper',on:{'click':function click($event){return _this.handleSortClick($event,column);}}},[h('i',{'class':'sort-caret ascending',on:{'click':function click($event){return _this.handleSortClick($event,column,'ascending');}}}),h('i',{'class':'sort-caret descending',on:{'click':function click($event){return _this.handleSortClick($event,column,'descending');}}})]):'',column.filterable?h('span',{'class':'el-table__column-filter-trigger',on:{'click':function click($event){return _this.handleFilterClick($event,column);}}},[h('i',{'class':['el-icon-arrow-down',column.filterOpened?'el-icon-arrow-up':'']})]):''])]);}),_this.hasGutter?h('th',{'class':'el-table__cell gutter'}):'']);})])]);},props:{fixed:String,store:{required:true},border:Boolean,defaultSort:{type:Object,default:function _default(){return{prop:'',order:''};}}},components:{ElCheckbox:checkbox_default.a},computed:table_header_extends({table:function table(){return this.$parent;},hasGutter:function hasGutter(){return!this.fixed&&this.tableLayout.gutterWidth;}},mapStates({columns:'columns',isAllSelected:'isAllSelected',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;}})),created:function created(){this.filterPanels={};},mounted:function mounted(){var _this2=this;// nextTick 是有必要的 https://github.com/ElemeFE/element/pull/11311
this.$nextTick(function(){var _defaultSort=_this2.defaultSort,prop=_defaultSort.prop,order=_defaultSort.order;var init=true;_this2.store.commit('sort',{prop:prop,order:order,init:init});});},beforeDestroy:function beforeDestroy(){var panels=this.filterPanels;for(var prop in panels){if(panels.hasOwnProperty(prop)&&panels[prop]){panels[prop].$destroy(true);}}},methods:{isCellHidden:function isCellHidden(index,columns){var start=0;for(var i=0;i<index;i++){start+=columns[i].colSpan;}var after=start+columns[index].colSpan-1;if(this.fixed===true||this.fixed==='left'){return after>=this.leftFixedLeafCount;}else if(this.fixed==='right'){return start<this.columnsCount-this.rightFixedLeafCount;}else{return after<this.leftFixedLeafCount||start>=this.columnsCount-this.rightFixedLeafCount;}},getHeaderRowStyle:function getHeaderRowStyle(rowIndex){var headerRowStyle=this.table.headerRowStyle;if(typeof headerRowStyle==='function'){return headerRowStyle.call(null,{rowIndex:rowIndex});}return headerRowStyle;},getHeaderRowClass:function getHeaderRowClass(rowIndex){var classes=[];var headerRowClassName=this.table.headerRowClassName;if(typeof headerRowClassName==='string'){classes.push(headerRowClassName);}else if(typeof headerRowClassName==='function'){classes.push(headerRowClassName.call(null,{rowIndex:rowIndex}));}return classes.join(' ');},getHeaderCellStyle:function getHeaderCellStyle(rowIndex,columnIndex,row,column){var headerCellStyle=this.table.headerCellStyle;if(typeof headerCellStyle==='function'){return headerCellStyle.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column});}return headerCellStyle;},getHeaderCellClass:function getHeaderCellClass(rowIndex,columnIndex,row,column){var classes=[column.id,column.order,column.headerAlign,column.className,column.labelClassName];if(rowIndex===0&&this.isCellHidden(columnIndex,row)){classes.push('is-hidden');}if(!column.children){classes.push('is-leaf');}if(column.sortable){classes.push('is-sortable');}var headerCellClassName=this.table.headerCellClassName;if(typeof headerCellClassName==='string'){classes.push(headerCellClassName);}else if(typeof headerCellClassName==='function'){classes.push(headerCellClassName.call(null,{rowIndex:rowIndex,columnIndex:columnIndex,row:row,column:column}));}classes.push('el-table__cell');return classes.join(' ');},toggleAllSelection:function toggleAllSelection(){this.store.commit('toggleAllSelection');},handleFilterClick:function handleFilterClick(event,column){event.stopPropagation();var target=event.target;var cell=target.tagName==='TH'?target:target.parentNode;if(Object(dom_["hasClass"])(cell,'noclick'))return;cell=cell.querySelector('.el-table__column-filter-trigger')||cell;var table=this.$parent;var filterPanel=this.filterPanels[column.id];if(filterPanel&&column.filterOpened){filterPanel.showPopper=false;return;}if(!filterPanel){filterPanel=new external_vue_default.a(filter_panel);this.filterPanels[column.id]=filterPanel;if(column.filterPlacement){filterPanel.placement=column.filterPlacement;}filterPanel.table=table;filterPanel.cell=cell;filterPanel.column=column;!this.$isServer&&filterPanel.$mount(document.createElement('div'));}setTimeout(function(){filterPanel.showPopper=true;},16);},handleHeaderClick:function handleHeaderClick(event,column){if(!column.filters&&column.sortable){this.handleSortClick(event,column);}else if(column.filterable&&!column.sortable){this.handleFilterClick(event,column);}this.$parent.$emit('header-click',column,event);},handleHeaderContextMenu:function handleHeaderContextMenu(event,column){this.$parent.$emit('header-contextmenu',column,event);},handleMouseDown:function handleMouseDown(event,column){var _this3=this;if(this.$isServer)return;if(column.children&&column.children.length>0)return;/* istanbul ignore if */if(this.draggingColumn&&this.border){this.dragging=true;this.$parent.resizeProxyVisible=true;var table=this.$parent;var tableEl=table.$el;var tableLeft=tableEl.getBoundingClientRect().left;var columnEl=this.$el.querySelector('th.'+column.id);var columnRect=columnEl.getBoundingClientRect();var minLeft=columnRect.left-tableLeft+30;Object(dom_["addClass"])(columnEl,'noclick');this.dragState={startMouseLeft:event.clientX,startLeft:columnRect.right-tableLeft,startColumnLeft:columnRect.left-tableLeft,tableLeft:tableLeft};var resizeProxy=table.$refs.resizeProxy;resizeProxy.style.left=this.dragState.startLeft+'px';document.onselectstart=function(){return false;};document.ondragstart=function(){return false;};var handleMouseMove=function handleMouseMove(event){var deltaLeft=event.clientX-_this3.dragState.startMouseLeft;var proxyLeft=_this3.dragState.startLeft+deltaLeft;resizeProxy.style.left=Math.max(minLeft,proxyLeft)+'px';};var handleMouseUp=function handleMouseUp(){if(_this3.dragging){var _dragState=_this3.dragState,startColumnLeft=_dragState.startColumnLeft,startLeft=_dragState.startLeft;var finalLeft=parseInt(resizeProxy.style.left,10);var columnWidth=finalLeft-startColumnLeft;column.width=column.realWidth=columnWidth;table.$emit('header-dragend',column.width,startLeft-startColumnLeft,column,event);_this3.store.scheduleLayout();document.body.style.cursor='';_this3.dragging=false;_this3.draggingColumn=null;_this3.dragState={};table.resizeProxyVisible=false;}document.removeEventListener('mousemove',handleMouseMove);document.removeEventListener('mouseup',handleMouseUp);document.onselectstart=null;document.ondragstart=null;setTimeout(function(){Object(dom_["removeClass"])(columnEl,'noclick');},0);};document.addEventListener('mousemove',handleMouseMove);document.addEventListener('mouseup',handleMouseUp);}},handleMouseMove:function handleMouseMove(event,column){if(column.children&&column.children.length>0)return;var target=event.target;while(target&&target.tagName!=='TH'){target=target.parentNode;}if(!column||!column.resizable)return;if(!this.dragging&&this.border){var rect=target.getBoundingClientRect();var bodyStyle=document.body.style;if(rect.width>12&&rect.right-event.pageX<8){bodyStyle.cursor='col-resize';if(Object(dom_["hasClass"])(target,'is-sortable')){target.style.cursor='col-resize';}this.draggingColumn=column;}else if(!this.dragging){bodyStyle.cursor='';if(Object(dom_["hasClass"])(target,'is-sortable')){target.style.cursor='pointer';}this.draggingColumn=null;}}},handleMouseOut:function handleMouseOut(){if(this.$isServer)return;document.body.style.cursor='';},toggleOrder:function toggleOrder(_ref){var order=_ref.order,sortOrders=_ref.sortOrders;if(order==='')return sortOrders[0];var index=sortOrders.indexOf(order||null);return sortOrders[index>sortOrders.length-2?0:index+1];},handleSortClick:function handleSortClick(event,column,givenOrder){event.stopPropagation();var order=column.order===givenOrder?null:givenOrder||this.toggleOrder(column);var target=event.target;while(target&&target.tagName!=='TH'){target=target.parentNode;}if(target&&target.tagName==='TH'){if(Object(dom_["hasClass"])(target,'noclick')){Object(dom_["removeClass"])(target,'noclick');return;}}if(!column.sortable)return;var states=this.store.states;var sortProp=states.sortProp;var sortOrder=void 0;var sortingColumn=states.sortingColumn;if(sortingColumn!==column||sortingColumn===column&&sortingColumn.order===null){if(sortingColumn){sortingColumn.order=null;}states.sortingColumn=column;sortProp=column.property;}if(!order){sortOrder=column.order=null;}else{sortOrder=column.order=order;}states.sortProp=sortProp;states.sortOrder=sortOrder;this.store.commit('changeSortCondition');}},data:function data(){return{draggingColumn:null,dragging:false,dragState:{}};}};// CONCATENATED MODULE: ./packages/table/src/table-footer.js
var table_footer_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var table_footer={name:'ElTableFooter',mixins:[layout_observer],render:function render(h){var _this=this;var sums=[];if(this.summaryMethod){sums=this.summaryMethod({columns:this.columns,data:this.store.states.data});}else{this.columns.forEach(function(column,index){if(index===0){sums[index]=_this.sumText;return;}var values=_this.store.states.data.map(function(item){return Number(item[column.property]);});var precisions=[];var notNumber=true;values.forEach(function(value){if(!isNaN(value)){notNumber=false;var decimal=(''+value).split('.')[1];precisions.push(decimal?decimal.length:0);}});var precision=Math.max.apply(null,precisions);if(!notNumber){sums[index]=values.reduce(function(prev,curr){var value=Number(curr);if(!isNaN(value)){return parseFloat((prev+curr).toFixed(Math.min(precision,20)));}else{return prev;}},0);}else{sums[index]='';}});}return h('table',{'class':'el-table__footer',attrs:{cellspacing:'0',cellpadding:'0',border:'0'}},[h('colgroup',[this.columns.map(function(column){return h('col',{attrs:{name:column.id},key:column.id});}),this.hasGutter?h('col',{attrs:{name:'gutter'}}):'']),h('tbody',{'class':[{'has-gutter':this.hasGutter}]},[h('tr',[this.columns.map(function(column,cellIndex){return h('td',{key:cellIndex,attrs:{colspan:column.colSpan,rowspan:column.rowSpan},'class':[].concat(_this.getRowClasses(column,cellIndex),['el-table__cell'])},[h('div',{'class':['cell',column.labelClassName]},[sums[cellIndex]])]);}),this.hasGutter?h('th',{'class':'el-table__cell gutter'}):''])])]);},props:{fixed:String,store:{required:true},summaryMethod:Function,sumText:String,border:Boolean,defaultSort:{type:Object,default:function _default(){return{prop:'',order:''};}}},computed:table_footer_extends({table:function table(){return this.$parent;},hasGutter:function hasGutter(){return!this.fixed&&this.tableLayout.gutterWidth;}},mapStates({columns:'columns',isAllSelected:'isAllSelected',leftFixedLeafCount:'fixedLeafColumnsLength',rightFixedLeafCount:'rightFixedLeafColumnsLength',columnsCount:function columnsCount(states){return states.columns.length;},leftFixedCount:function leftFixedCount(states){return states.fixedColumns.length;},rightFixedCount:function rightFixedCount(states){return states.rightFixedColumns.length;}})),methods:{isCellHidden:function isCellHidden(index,columns,column){if(this.fixed===true||this.fixed==='left'){return index>=this.leftFixedLeafCount;}else if(this.fixed==='right'){var before=0;for(var i=0;i<index;i++){before+=columns[i].colSpan;}return before<this.columnsCount-this.rightFixedLeafCount;}else if(!this.fixed&&column.fixed){// hide cell when footer instance is not fixed and column is fixed
return true;}else{return index<this.leftFixedCount||index>=this.columnsCount-this.rightFixedCount;}},getRowClasses:function getRowClasses(column,cellIndex){var classes=[column.id,column.align,column.labelClassName];if(column.className){classes.push(column.className);}if(this.isCellHidden(cellIndex,this.columns,column)){classes.push('is-hidden');}if(!column.children){classes.push('is-leaf');}return classes;}}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/table/src/table.vue?vue&type=script&lang=js&
var tablevue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var tableIdSeed=1;/* harmony default export */var tablevue_type_script_lang_js_={name:'ElTable',mixins:[locale_default.a,migrating_default.a],directives:{Mousewheel:directives_mousewheel},props:{data:{type:Array,default:function _default(){return[];}},size:String,width:[String,Number],height:[String,Number],maxHeight:[String,Number],fit:{type:Boolean,default:true},stripe:Boolean,border:Boolean,rowKey:[String,Function],context:{},showHeader:{type:Boolean,default:true},showSummary:Boolean,sumText:String,summaryMethod:Function,rowClassName:[String,Function],rowStyle:[Object,Function],cellClassName:[String,Function],cellStyle:[Object,Function],headerRowClassName:[String,Function],headerRowStyle:[Object,Function],headerCellClassName:[String,Function],headerCellStyle:[Object,Function],highlightCurrentRow:Boolean,currentRowKey:[String,Number],emptyText:String,expandRowKeys:Array,defaultExpandAll:Boolean,defaultSort:Object,tooltipEffect:String,spanMethod:Function,selectOnIndeterminate:{type:Boolean,default:true},indent:{type:Number,default:16},treeProps:{type:Object,default:function _default(){return{hasChildren:'hasChildren',children:'children'};}},lazy:Boolean,load:Function},components:{TableHeader:table_header,TableFooter:table_footer,TableBody:table_body,ElCheckbox:checkbox_default.a},methods:{getMigratingConfig:function getMigratingConfig(){return{events:{expand:'expand is renamed to expand-change'}};},setCurrentRow:function setCurrentRow(row){this.store.commit('setCurrentRow',row);},toggleRowSelection:function toggleRowSelection(row,selected){this.store.toggleRowSelection(row,selected,false);this.store.updateAllSelected();},toggleRowExpansion:function toggleRowExpansion(row,expanded){this.store.toggleRowExpansionAdapter(row,expanded);},clearSelection:function clearSelection(){this.store.clearSelection();},clearFilter:function clearFilter(columnKeys){this.store.clearFilter(columnKeys);},clearSort:function clearSort(){this.store.clearSort();},handleMouseLeave:function handleMouseLeave(){this.store.commit('setHoverRow',null);if(this.hoverState)this.hoverState=null;},updateScrollY:function updateScrollY(){var changed=this.layout.updateScrollY();if(changed){this.layout.notifyObservers('scrollable');this.layout.updateColumnsWidth();}},handleFixedMousewheel:function handleFixedMousewheel(event,data){var bodyWrapper=this.bodyWrapper;if(Math.abs(data.spinY)>0){var currentScrollTop=bodyWrapper.scrollTop;if(data.pixelY<0&&currentScrollTop!==0){event.preventDefault();}if(data.pixelY>0&&bodyWrapper.scrollHeight-bodyWrapper.clientHeight>currentScrollTop){event.preventDefault();}bodyWrapper.scrollTop+=Math.ceil(data.pixelY/5);}else{bodyWrapper.scrollLeft+=Math.ceil(data.pixelX/5);}},handleHeaderFooterMousewheel:function handleHeaderFooterMousewheel(event,data){var pixelX=data.pixelX,pixelY=data.pixelY;if(Math.abs(pixelX)>=Math.abs(pixelY)){this.bodyWrapper.scrollLeft+=data.pixelX/5;}},// TODO 使用 CSS transform
syncPostion:function syncPostion(){var _bodyWrapper=this.bodyWrapper,scrollLeft=_bodyWrapper.scrollLeft,scrollTop=_bodyWrapper.scrollTop,offsetWidth=_bodyWrapper.offsetWidth,scrollWidth=_bodyWrapper.scrollWidth;var _$refs=this.$refs,headerWrapper=_$refs.headerWrapper,footerWrapper=_$refs.footerWrapper,fixedBodyWrapper=_$refs.fixedBodyWrapper,rightFixedBodyWrapper=_$refs.rightFixedBodyWrapper;if(headerWrapper)headerWrapper.scrollLeft=scrollLeft;if(footerWrapper)footerWrapper.scrollLeft=scrollLeft;if(fixedBodyWrapper)fixedBodyWrapper.scrollTop=scrollTop;if(rightFixedBodyWrapper)rightFixedBodyWrapper.scrollTop=scrollTop;var maxScrollLeftPosition=scrollWidth-offsetWidth-1;if(scrollLeft>=maxScrollLeftPosition){this.scrollPosition='right';}else if(scrollLeft===0){this.scrollPosition='left';}else{this.scrollPosition='middle';}},throttleSyncPostion:Object(external_throttle_debounce_["throttle"])(16,function(){this.syncPostion();}),onScroll:function onScroll(evt){var raf=window.requestAnimationFrame;if(!raf){this.throttleSyncPostion();}else{raf(this.syncPostion);}},bindEvents:function bindEvents(){this.bodyWrapper.addEventListener('scroll',this.onScroll,{passive:true});if(this.fit){Object(resize_event_["addResizeListener"])(this.$el,this.resizeListener);}},unbindEvents:function unbindEvents(){this.bodyWrapper.removeEventListener('scroll',this.onScroll,{passive:true});if(this.fit){Object(resize_event_["removeResizeListener"])(this.$el,this.resizeListener);}},resizeListener:function resizeListener(){if(!this.$ready)return;var shouldUpdateLayout=false;var el=this.$el;var _resizeState=this.resizeState,oldWidth=_resizeState.width,oldHeight=_resizeState.height;var width=el.offsetWidth;if(oldWidth!==width){shouldUpdateLayout=true;}var height=el.offsetHeight;if((this.height||this.shouldUpdateHeight)&&oldHeight!==height){shouldUpdateLayout=true;}if(shouldUpdateLayout){this.resizeState.width=width;this.resizeState.height=height;this.doLayout();}},doLayout:function doLayout(){if(this.shouldUpdateHeight){this.layout.updateElsHeight();}this.layout.updateColumnsWidth();},sort:function sort(prop,order){this.store.commit('sort',{prop:prop,order:order});},toggleAllSelection:function toggleAllSelection(){this.store.commit('toggleAllSelection');}},computed:tablevue_type_script_lang_js_extends({tableSize:function tableSize(){return this.size||(this.$ELEMENT||{}).size;},bodyWrapper:function bodyWrapper(){return this.$refs.bodyWrapper;},shouldUpdateHeight:function shouldUpdateHeight(){return this.height||this.maxHeight||this.fixedColumns.length>0||this.rightFixedColumns.length>0;},bodyWidth:function bodyWidth(){var _layout=this.layout,bodyWidth=_layout.bodyWidth,scrollY=_layout.scrollY,gutterWidth=_layout.gutterWidth;return bodyWidth?bodyWidth-(scrollY?gutterWidth:0)+'px':'';},bodyHeight:function bodyHeight(){var _layout2=this.layout,_layout2$headerHeight=_layout2.headerHeight,headerHeight=_layout2$headerHeight===undefined?0:_layout2$headerHeight,bodyHeight=_layout2.bodyHeight,_layout2$footerHeight=_layout2.footerHeight,footerHeight=_layout2$footerHeight===undefined?0:_layout2$footerHeight;if(this.height){return{height:bodyHeight?bodyHeight+'px':''};}else if(this.maxHeight){var maxHeight=parseHeight(this.maxHeight);if(typeof maxHeight==='number'){return{'max-height':maxHeight-footerHeight-(this.showHeader?headerHeight:0)+'px'};}}return{};},fixedBodyHeight:function fixedBodyHeight(){if(this.height){return{height:this.layout.fixedBodyHeight?this.layout.fixedBodyHeight+'px':''};}else if(this.maxHeight){var maxHeight=parseHeight(this.maxHeight);if(typeof maxHeight==='number'){maxHeight=this.layout.scrollX?maxHeight-this.layout.gutterWidth:maxHeight;if(this.showHeader){maxHeight-=this.layout.headerHeight;}maxHeight-=this.layout.footerHeight;return{'max-height':maxHeight+'px'};}}return{};},fixedHeight:function fixedHeight(){if(this.maxHeight){if(this.showSummary){return{bottom:0};}return{bottom:this.layout.scrollX&&this.data.length?this.layout.gutterWidth+'px':''};}else{if(this.showSummary){return{height:this.layout.tableHeight?this.layout.tableHeight+'px':''};}return{height:this.layout.viewportHeight?this.layout.viewportHeight+'px':''};}},emptyBlockStyle:function emptyBlockStyle(){if(this.data&&this.data.length)return null;var height='100%';if(this.layout.appendHeight){height='calc(100% - '+this.layout.appendHeight+'px)';}return{width:this.bodyWidth,height:height};}},mapStates({selection:'selection',columns:'columns',tableData:'data',fixedColumns:'fixedColumns',rightFixedColumns:'rightFixedColumns'})),watch:{height:{immediate:true,handler:function handler(value){this.layout.setHeight(value);}},maxHeight:{immediate:true,handler:function handler(value){this.layout.setMaxHeight(value);}},currentRowKey:{immediate:true,handler:function handler(value){if(!this.rowKey)return;this.store.setCurrentRowKey(value);}},data:{immediate:true,handler:function handler(value){this.store.commit('setData',value);}},expandRowKeys:{immediate:true,handler:function handler(newVal){if(newVal){this.store.setExpandRowKeysAdapter(newVal);}}}},created:function created(){var _this=this;this.tableId='el-table_'+tableIdSeed++;this.debouncedUpdateLayout=Object(external_throttle_debounce_["debounce"])(50,function(){return _this.doLayout();});},mounted:function mounted(){var _this2=this;this.bindEvents();this.store.updateColumns();this.doLayout();this.resizeState={width:this.$el.offsetWidth,height:this.$el.offsetHeight};// init filters
this.store.states.columns.forEach(function(column){if(column.filteredValue&&column.filteredValue.length){_this2.store.commit('filterChange',{column:column,values:column.filteredValue,silent:true});}});this.$ready=true;},destroyed:function destroyed(){this.unbindEvents();},data:function data(){var _treeProps=this.treeProps,_treeProps$hasChildre=_treeProps.hasChildren,hasChildren=_treeProps$hasChildre===undefined?'hasChildren':_treeProps$hasChildre,_treeProps$children=_treeProps.children,children=_treeProps$children===undefined?'children':_treeProps$children;this.store=createStore(this,{rowKey:this.rowKey,defaultExpandAll:this.defaultExpandAll,selectOnIndeterminate:this.selectOnIndeterminate,// TreeTable 的相关配置
indent:this.indent,lazy:this.lazy,lazyColumnIdentifier:hasChildren,childrenColumnName:children});var layout=new table_layout({store:this.store,table:this,fit:this.fit,showHeader:this.showHeader});return{layout:layout,isHidden:false,renderExpanded:null,resizeProxyVisible:false,resizeState:{width:null,height:null},// 是否拥有多级表头
isGroup:false,scrollPosition:'left'};}};// CONCATENATED MODULE: ./packages/table/src/table.vue?vue&type=script&lang=js&
/* harmony default export */var src_tablevue_type_script_lang_js_=tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/table/src/table.vue
/* normalize component */var table_component=normalizeComponent(src_tablevue_type_script_lang_js_,tablevue_type_template_id_493fe34e_render,tablevue_type_template_id_493fe34e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var table_api;}table_component.options.__file="packages/table/src/table.vue";/* harmony default export */var src_table=table_component.exports;// CONCATENATED MODULE: ./packages/table/index.js
/* istanbul ignore next */src_table.install=function(Vue){Vue.component(src_table.name,src_table);};/* harmony default export */var packages_table=src_table;// CONCATENATED MODULE: ./packages/table/src/config.js
var cellStarts={default:{order:''},selection:{width:48,minWidth:48,realWidth:48,order:'',className:'el-table-column--selection'},expand:{width:48,minWidth:48,realWidth:48,order:''},index:{width:48,minWidth:48,realWidth:48,order:''}};// 这些选项不应该被覆盖
var cellForced={selection:{renderHeader:function renderHeader(h,_ref){var store=_ref.store;return h('el-checkbox',{attrs:{disabled:store.states.data&&store.states.data.length===0,indeterminate:store.states.selection.length>0&&!this.isAllSelected,value:this.isAllSelected},on:{'input':this.toggleAllSelection}});},renderCell:function renderCell(h,_ref2){var row=_ref2.row,column=_ref2.column,isSelected=_ref2.isSelected,store=_ref2.store,$index=_ref2.$index;return h('el-checkbox',{nativeOn:{'click':function click(event){return event.stopPropagation();}},attrs:{value:isSelected,disabled:column.selectable?!column.selectable.call(null,row,$index):false},on:{'input':function input(){store.commit('rowSelectedChanged',row);}}});},sortable:false,resizable:false},index:{renderHeader:function renderHeader(h,_ref3){var column=_ref3.column;return column.label||'#';},renderCell:function renderCell(h,_ref4){var $index=_ref4.$index,column=_ref4.column;var i=$index+1;var index=column.index;if(typeof index==='number'){i=$index+index;}else if(typeof index==='function'){i=index($index);}return h('div',[i]);},sortable:false},expand:{renderHeader:function renderHeader(h,_ref5){var column=_ref5.column;return column.label||'';},renderCell:function renderCell(h,_ref6){var row=_ref6.row,store=_ref6.store,isExpanded=_ref6.isExpanded;var classes=['el-table__expand-icon'];if(isExpanded){classes.push('el-table__expand-icon--expanded');}var callback=function callback(e){e.stopPropagation();store.toggleRowExpansion(row);};return h('div',{'class':classes,on:{'click':callback}},[h('i',{'class':'el-icon el-icon-arrow-right'})]);},sortable:false,resizable:false,className:'el-table__expand-column'}};function defaultRenderCell(h,_ref7){var row=_ref7.row,column=_ref7.column,$index=_ref7.$index;var property=column.property;var value=property&&Object(util_["getPropByPath"])(row,property).v;if(column&&column.formatter){return column.formatter(row,column,value,$index);}return value;}function treeCellPrefix(h,_ref8){var row=_ref8.row,treeNode=_ref8.treeNode,store=_ref8.store;if(!treeNode)return null;var ele=[];var callback=function callback(e){e.stopPropagation();store.loadOrToggle(row);};if(treeNode.indent){ele.push(h('span',{'class':'el-table__indent',style:{'padding-left':treeNode.indent+'px'}}));}if(typeof treeNode.expanded==='boolean'&&!treeNode.noLazyChildren){var expandClasses=['el-table__expand-icon',treeNode.expanded?'el-table__expand-icon--expanded':''];var iconClasses=['el-icon-arrow-right'];if(treeNode.loading){iconClasses=['el-icon-loading'];}ele.push(h('div',{'class':expandClasses,on:{'click':callback}},[h('i',{'class':iconClasses})]));}else{ele.push(h('span',{'class':'el-table__placeholder'}));}return ele;}// CONCATENATED MODULE: ./packages/table/src/table-column.js
var table_column_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var columnIdSeed=1;/* harmony default export */var table_column={name:'ElTableColumn',props:{type:{type:String,default:'default'},label:String,className:String,labelClassName:String,property:String,prop:String,width:{},minWidth:{},renderHeader:Function,sortable:{type:[Boolean,String],default:false},sortMethod:Function,sortBy:[String,Function,Array],resizable:{type:Boolean,default:true},columnKey:String,align:String,headerAlign:String,showTooltipWhenOverflow:Boolean,showOverflowTooltip:Boolean,fixed:[Boolean,String],formatter:Function,selectable:Function,reserveSelection:Boolean,filterMethod:Function,filteredValue:Array,filters:Array,filterPlacement:String,filterMultiple:{type:Boolean,default:true},index:[Number,Function],sortOrders:{type:Array,default:function _default(){return['ascending','descending',null];},validator:function validator(val){return val.every(function(order){return['ascending','descending',null].indexOf(order)>-1;});}}},data:function data(){return{isSubColumn:false,columns:[]};},computed:{owner:function owner(){var parent=this.$parent;while(parent&&!parent.tableId){parent=parent.$parent;}return parent;},columnOrTableParent:function columnOrTableParent(){var parent=this.$parent;while(parent&&!parent.tableId&&!parent.columnId){parent=parent.$parent;}return parent;},realWidth:function realWidth(){return parseWidth(this.width);},realMinWidth:function realMinWidth(){return parseMinWidth(this.minWidth);},realAlign:function realAlign(){return this.align?'is-'+this.align:null;},realHeaderAlign:function realHeaderAlign(){return this.headerAlign?'is-'+this.headerAlign:this.realAlign;}},methods:{getPropsData:function getPropsData(){var _this=this;for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}return props.reduce(function(prev,cur){if(Array.isArray(cur)){cur.forEach(function(key){prev[key]=_this[key];});}return prev;},{});},getColumnElIndex:function getColumnElIndex(children,child){return[].indexOf.call(children,child);},setColumnWidth:function setColumnWidth(column){if(this.realWidth){column.width=this.realWidth;}if(this.realMinWidth){column.minWidth=this.realMinWidth;}if(!column.minWidth){column.minWidth=80;}column.realWidth=column.width===undefined?column.minWidth:column.width;return column;},setColumnForcedProps:function setColumnForcedProps(column){// 对于特定类型的 column，某些属性不允许设置
var type=column.type;var source=cellForced[type]||{};Object.keys(source).forEach(function(prop){var value=source[prop];if(value!==undefined){column[prop]=prop==='className'?column[prop]+' '+value:value;}});return column;},setColumnRenders:function setColumnRenders(column){var _this2=this;var h=this.$createElement;// renderHeader 属性不推荐使用。
if(this.renderHeader){console.warn('[Element Warn][TableColumn]Comparing to render-header, scoped-slot header is easier to use. We recommend users to use scoped-slot header.');}else if(column.type!=='selection'){column.renderHeader=function(h,scope){var renderHeader=_this2.$scopedSlots.header;return renderHeader?renderHeader(scope):column.label;};}var originRenderCell=column.renderCell;// TODO: 这里的实现调整
if(column.type==='expand'){// 对于展开行，renderCell 不允许配置的。在上一步中已经设置过，这里需要简单封装一下。
column.renderCell=function(h,data){return h('div',{'class':'cell'},[originRenderCell(h,data)]);};this.owner.renderExpanded=function(h,data){return _this2.$scopedSlots.default?_this2.$scopedSlots.default(data):_this2.$slots.default;};}else{originRenderCell=originRenderCell||defaultRenderCell;// 对 renderCell 进行包装
column.renderCell=function(h,data){var children=null;if(_this2.$scopedSlots.default){children=_this2.$scopedSlots.default(data);}else{children=originRenderCell(h,data);}var prefix=treeCellPrefix(h,data);var props={class:'cell',style:{}};if(column.showOverflowTooltip){props.class+=' el-tooltip';props.style={width:(data.column.realWidth||data.column.width)-1+'px'};}return h('div',props,[prefix,children]);};}return column;},registerNormalWatchers:function registerNormalWatchers(){var _this3=this;var props=['label','property','filters','filterMultiple','sortable','index','formatter','className','labelClassName','showOverflowTooltip'];// 一些属性具有别名
var aliases={prop:'property',realAlign:'align',realHeaderAlign:'headerAlign',realWidth:'width'};var allAliases=props.reduce(function(prev,cur){prev[cur]=cur;return prev;},aliases);Object.keys(allAliases).forEach(function(key){var columnKey=aliases[key];_this3.$watch(key,function(newVal){_this3.columnConfig[columnKey]=newVal;});});},registerComplexWatchers:function registerComplexWatchers(){var _this4=this;var props=['fixed'];var aliases={realWidth:'width',realMinWidth:'minWidth'};var allAliases=props.reduce(function(prev,cur){prev[cur]=cur;return prev;},aliases);Object.keys(allAliases).forEach(function(key){var columnKey=aliases[key];_this4.$watch(key,function(newVal){_this4.columnConfig[columnKey]=newVal;var updateColumns=columnKey==='fixed';_this4.owner.store.scheduleLayout(updateColumns);});});}},components:{ElCheckbox:checkbox_default.a},beforeCreate:function beforeCreate(){this.row={};this.column={};this.$index=0;this.columnId='';},created:function created(){var parent=this.columnOrTableParent;this.isSubColumn=this.owner!==parent;this.columnId=(parent.tableId||parent.columnId)+'_column_'+columnIdSeed++;var type=this.type||'default';var sortable=this.sortable===''?true:this.sortable;var defaults=table_column_extends({},cellStarts[type],{id:this.columnId,type:type,property:this.prop||this.property,align:this.realAlign,headerAlign:this.realHeaderAlign,showOverflowTooltip:this.showOverflowTooltip||this.showTooltipWhenOverflow,// filter 相关属性
filterable:this.filters||this.filterMethod,filteredValue:[],filterPlacement:'',isColumnGroup:false,filterOpened:false,// sort 相关属性
sortable:sortable,// index 列
index:this.index});var basicProps=['columnKey','label','className','labelClassName','type','renderHeader','formatter','fixed','resizable'];var sortProps=['sortMethod','sortBy','sortOrders'];var selectProps=['selectable','reserveSelection'];var filterProps=['filterMethod','filters','filterMultiple','filterOpened','filteredValue','filterPlacement'];var column=this.getPropsData(basicProps,sortProps,selectProps,filterProps);column=mergeOptions(defaults,column);// 注意 compose 中函数执行的顺序是从右到左
var chains=compose(this.setColumnRenders,this.setColumnWidth,this.setColumnForcedProps);column=chains(column);this.columnConfig=column;// 注册 watcher
this.registerNormalWatchers();this.registerComplexWatchers();},mounted:function mounted(){var owner=this.owner;var parent=this.columnOrTableParent;var children=this.isSubColumn?parent.$el.children:parent.$refs.hiddenColumns.children;var columnIndex=this.getColumnElIndex(children,this.$el);owner.store.commit('insertColumn',this.columnConfig,columnIndex,this.isSubColumn?parent.columnConfig:null);},destroyed:function destroyed(){if(!this.$parent)return;var parent=this.$parent;this.owner.store.commit('removeColumn',this.columnConfig,this.isSubColumn?parent.columnConfig:null);},render:function render(h){// slots 也要渲染，需要计算合并表头
return h('div',this.$slots.default);}};// CONCATENATED MODULE: ./packages/table-column/index.js
/* istanbul ignore next */table_column.install=function(Vue){Vue.component(table_column.name,table_column);};/* harmony default export */var packages_table_column=table_column;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
var pickervue_type_template_id_79ae069f_render=function pickervue_type_template_id_79ae069f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return!_vm.ranged?_c("el-input",_vm._b({directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor",class:"el-date-editor--"+_vm.type,attrs:{readonly:!_vm.editable||_vm.readonly||_vm.type==="dates"||_vm.type==="week",disabled:_vm.pickerDisabled,size:_vm.pickerSize,name:_vm.name,placeholder:_vm.placeholder,value:_vm.displayValue,validateEvent:false},on:{focus:_vm.handleFocus,input:function input(value){return _vm.userInput=value;},change:_vm.handleChange},nativeOn:{keydown:function keydown($event){return _vm.handleKeydown($event);},mouseenter:function mouseenter($event){return _vm.handleMouseEnter($event);},mouseleave:function mouseleave($event){_vm.showClose=false;}}},"el-input",_vm.firstInputId,false),[_c("i",{staticClass:"el-input__icon",class:_vm.triggerClass,attrs:{slot:"prefix"},on:{click:_vm.handleFocus},slot:"prefix"}),_vm.haveTrigger?_c("i",{staticClass:"el-input__icon",class:[_vm.showClose?""+_vm.clearIcon:""],attrs:{slot:"suffix"},on:{click:_vm.handleClickIcon},slot:"suffix"}):_vm._e()]):_c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleClose,expression:"handleClose"}],ref:"reference",staticClass:"el-date-editor el-range-editor el-input__inner",class:["el-date-editor--"+_vm.type,_vm.pickerSize?"el-range-editor--"+_vm.pickerSize:"",_vm.pickerDisabled?"is-disabled":"",_vm.pickerVisible?"is-active":""],on:{click:_vm.handleRangeClick,mouseenter:_vm.handleMouseEnter,mouseleave:function mouseleave($event){_vm.showClose=false;},keydown:_vm.handleKeydown}},[_c("i",{class:["el-input__icon","el-range__icon",_vm.triggerClass]}),_c("input",_vm._b({staticClass:"el-range-input",attrs:{autocomplete:"off",placeholder:_vm.startPlaceholder,disabled:_vm.pickerDisabled,readonly:!_vm.editable||_vm.readonly,name:_vm.name&&_vm.name[0]},domProps:{value:_vm.displayValue&&_vm.displayValue[0]},on:{input:_vm.handleStartInput,change:_vm.handleStartChange,focus:_vm.handleFocus}},"input",_vm.firstInputId,false)),_vm._t("range-separator",[_c("span",{staticClass:"el-range-separator"},[_vm._v(_vm._s(_vm.rangeSeparator))])]),_c("input",_vm._b({staticClass:"el-range-input",attrs:{autocomplete:"off",placeholder:_vm.endPlaceholder,disabled:_vm.pickerDisabled,readonly:!_vm.editable||_vm.readonly,name:_vm.name&&_vm.name[1]},domProps:{value:_vm.displayValue&&_vm.displayValue[1]},on:{input:_vm.handleEndInput,change:_vm.handleEndChange,focus:_vm.handleFocus}},"input",_vm.secondInputId,false)),_vm.haveTrigger?_c("i",{staticClass:"el-input__icon el-range__close-icon",class:[_vm.showClose?""+_vm.clearIcon:""],on:{click:_vm.handleClickIcon}}):_vm._e()],2);};var pickervue_type_template_id_79ae069f_staticRenderFns=[];pickervue_type_template_id_79ae069f_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=template&id=79ae069f&
// EXTERNAL MODULE: external "element-ui/lib/utils/date-util"
var date_util_=__webpack_require__(0);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var NewPopper={props:{appendToBody:vue_popper_default.a.props.appendToBody,offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,arrowOffset:vue_popper_default.a.props.arrowOffset,placement:vue_popper_default.a.props.placement,transformOrigin:vue_popper_default.a.props.transformOrigin},methods:vue_popper_default.a.methods,data:function data(){return merge_default()({visibleArrow:true},vue_popper_default.a.data);},beforeDestroy:vue_popper_default.a.beforeDestroy};var DEFAULT_FORMATS={date:'yyyy-MM-dd',month:'yyyy-MM',datetime:'yyyy-MM-dd HH:mm:ss',time:'HH:mm:ss',week:'yyyywWW',timerange:'HH:mm:ss',daterange:'yyyy-MM-dd',monthrange:'yyyy-MM',datetimerange:'yyyy-MM-dd HH:mm:ss',year:'yyyy'};var HAVE_TRIGGER_TYPES=['date','datetime','time','time-select','week','month','year','daterange','monthrange','timerange','datetimerange','dates'];var pickervue_type_script_lang_js_DATE_FORMATTER=function DATE_FORMATTER(value,format){if(format==='timestamp')return value.getTime();return Object(date_util_["formatDate"])(value,format);};var pickervue_type_script_lang_js_DATE_PARSER=function DATE_PARSER(text,format){if(format==='timestamp')return new Date(Number(text));return Object(date_util_["parseDate"])(text,format);};var RANGE_FORMATTER=function RANGE_FORMATTER(value,format){if(Array.isArray(value)&&value.length===2){var start=value[0];var end=value[1];if(start&&end){return[pickervue_type_script_lang_js_DATE_FORMATTER(start,format),pickervue_type_script_lang_js_DATE_FORMATTER(end,format)];}}return'';};var RANGE_PARSER=function RANGE_PARSER(array,format,separator){if(!Array.isArray(array)){array=array.split(separator);}if(array.length===2){var range1=array[0];var range2=array[1];return[pickervue_type_script_lang_js_DATE_PARSER(range1,format),pickervue_type_script_lang_js_DATE_PARSER(range2,format)];}return[];};var TYPE_VALUE_RESOLVER_MAP={default:{formatter:function formatter(value){if(!value)return'';return''+value;},parser:function parser(text){if(text===undefined||text==='')return null;return text;}},week:{formatter:function formatter(value,format){var week=Object(date_util_["getWeekNumber"])(value);var month=value.getMonth();var trueDate=new Date(value);if(week===1&&month===11){trueDate.setHours(0,0,0,0);trueDate.setDate(trueDate.getDate()+3-(trueDate.getDay()+6)%7);}var date=Object(date_util_["formatDate"])(trueDate,format);date=/WW/.test(date)?date.replace(/WW/,week<10?'0'+week:week):date.replace(/W/,week);return date;},parser:function parser(text,format){// parse as if a normal date
return TYPE_VALUE_RESOLVER_MAP.date.parser(text,format);}},date:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},datetime:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},daterange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},monthrange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},datetimerange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},timerange:{formatter:RANGE_FORMATTER,parser:RANGE_PARSER},time:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},month:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},year:{formatter:pickervue_type_script_lang_js_DATE_FORMATTER,parser:pickervue_type_script_lang_js_DATE_PARSER},number:{formatter:function formatter(value){if(!value)return'';return''+value;},parser:function parser(text){var result=Number(text);if(!isNaN(text)){return result;}else{return null;}}},dates:{formatter:function formatter(value,format){return value.map(function(date){return pickervue_type_script_lang_js_DATE_FORMATTER(date,format);});},parser:function parser(value,format){return(typeof value==='string'?value.split(', '):value).map(function(date){return date instanceof Date?date:pickervue_type_script_lang_js_DATE_PARSER(date,format);});}}};var PLACEMENT_MAP={left:'bottom-start',center:'bottom',right:'bottom-end'};var parseAsFormatAndType=function parseAsFormatAndType(value,customFormat,type){var rangeSeparator=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'-';if(!value)return null;var parser=(TYPE_VALUE_RESOLVER_MAP[type]||TYPE_VALUE_RESOLVER_MAP['default']).parser;var format=customFormat||DEFAULT_FORMATS[type];return parser(value,format,rangeSeparator);};var formatAsFormatAndType=function formatAsFormatAndType(value,customFormat,type){if(!value)return null;var formatter=(TYPE_VALUE_RESOLVER_MAP[type]||TYPE_VALUE_RESOLVER_MAP['default']).formatter;var format=customFormat||DEFAULT_FORMATS[type];return formatter(value,format);};/*
 * Considers:
 *   1. Date object
 *   2. date string
 *   3. array of 1 or 2
 */var valueEquals=function valueEquals(a,b){// considers Date object and string
var dateEquals=function dateEquals(a,b){var aIsDate=a instanceof Date;var bIsDate=b instanceof Date;if(aIsDate&&bIsDate){return a.getTime()===b.getTime();}if(!aIsDate&&!bIsDate){return a===b;}return false;};var aIsArray=a instanceof Array;var bIsArray=b instanceof Array;if(aIsArray&&bIsArray){if(a.length!==b.length){return false;}return a.every(function(item,index){return dateEquals(item,b[index]);});}if(!aIsArray&&!bIsArray){return dateEquals(a,b);}return false;};var isString=function isString(val){return typeof val==='string'||val instanceof String;};var pickervue_type_script_lang_js_validator=function validator(val){// either: String, Array of String, null / undefined
return val===null||val===undefined||isString(val)||Array.isArray(val)&&val.length===2&&val.every(isString);};/* harmony default export */var pickervue_type_script_lang_js_={mixins:[emitter_default.a,NewPopper],inject:{elForm:{default:''},elFormItem:{default:''}},props:{size:String,format:String,valueFormat:String,readonly:Boolean,placeholder:String,startPlaceholder:String,endPlaceholder:String,prefixIcon:String,clearIcon:{type:String,default:'el-icon-circle-close'},name:{default:'',validator:pickervue_type_script_lang_js_validator},disabled:Boolean,clearable:{type:Boolean,default:true},id:{default:'',validator:pickervue_type_script_lang_js_validator},popperClass:String,editable:{type:Boolean,default:true},align:{type:String,default:'left'},value:{},defaultValue:{},defaultTime:{},rangeSeparator:{default:'-'},pickerOptions:{},unlinkPanels:Boolean,validateEvent:{type:Boolean,default:true}},components:{ElInput:input_default.a},directives:{Clickoutside:clickoutside_default.a},data:function data(){return{pickerVisible:false,showClose:false,userInput:null,valueOnOpen:null,// value when picker opens, used to determine whether to emit change
unwatchPickerOptions:null};},watch:{pickerVisible:function pickerVisible(val){if(this.readonly||this.pickerDisabled)return;if(val){this.showPicker();this.valueOnOpen=Array.isArray(this.value)?[].concat(this.value):this.value;}else{this.hidePicker();this.emitChange(this.value);this.userInput=null;if(this.validateEvent){this.dispatch('ElFormItem','el.form.blur');}this.$emit('blur',this);this.blur();}},parsedValue:{immediate:true,handler:function handler(val){if(this.picker){this.picker.value=val;}}},defaultValue:function defaultValue(val){// NOTE: should eventually move to jsx style picker + panel ?
if(this.picker){this.picker.defaultValue=val;}},value:function value(val,oldVal){if(!valueEquals(val,oldVal)&&!this.pickerVisible&&this.validateEvent){this.dispatch('ElFormItem','el.form.change',val);}}},computed:{ranged:function ranged(){return this.type.indexOf('range')>-1;},reference:function reference(){var reference=this.$refs.reference;return reference.$el||reference;},refInput:function refInput(){if(this.reference){return[].slice.call(this.reference.querySelectorAll('input'));}return[];},valueIsEmpty:function valueIsEmpty(){var val=this.value;if(Array.isArray(val)){for(var i=0,len=val.length;i<len;i++){if(val[i]){return false;}}}else{if(val){return false;}}return true;},triggerClass:function triggerClass(){return this.prefixIcon||(this.type.indexOf('time')!==-1?'el-icon-time':'el-icon-date');},selectionMode:function selectionMode(){if(this.type==='week'){return'week';}else if(this.type==='month'){return'month';}else if(this.type==='year'){return'year';}else if(this.type==='dates'){return'dates';}return'day';},haveTrigger:function haveTrigger(){if(typeof this.showTrigger!=='undefined'){return this.showTrigger;}return HAVE_TRIGGER_TYPES.indexOf(this.type)!==-1;},displayValue:function displayValue(){var formattedValue=formatAsFormatAndType(this.parsedValue,this.format,this.type,this.rangeSeparator);if(Array.isArray(this.userInput)){return[this.userInput[0]||formattedValue&&formattedValue[0]||'',this.userInput[1]||formattedValue&&formattedValue[1]||''];}else if(this.userInput!==null){return this.userInput;}else if(formattedValue){return this.type==='dates'?formattedValue.join(', '):formattedValue;}else{return'';}},parsedValue:function parsedValue(){if(!this.value)return this.value;// component value is not set
if(this.type==='time-select')return this.value;// time-select does not require parsing, this might change in next major version
var valueIsDateObject=Object(date_util_["isDateObject"])(this.value)||Array.isArray(this.value)&&this.value.every(date_util_["isDateObject"]);if(valueIsDateObject){return this.value;}if(this.valueFormat){return parseAsFormatAndType(this.value,this.valueFormat,this.type,this.rangeSeparator)||this.value;}// NOTE: deal with common but incorrect usage, should remove in next major version
// user might provide string / timestamp without value-format, coerce them into date (or array of date)
return Array.isArray(this.value)?this.value.map(function(val){return new Date(val);}):new Date(this.value);},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},pickerSize:function pickerSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},pickerDisabled:function pickerDisabled(){return this.disabled||(this.elForm||{}).disabled;},firstInputId:function firstInputId(){var obj={};var id=void 0;if(this.ranged){id=this.id&&this.id[0];}else{id=this.id;}if(id)obj.id=id;return obj;},secondInputId:function secondInputId(){var obj={};var id=void 0;if(this.ranged){id=this.id&&this.id[1];}if(id)obj.id=id;return obj;}},created:function created(){// vue-popper
this.popperOptions={boundariesPadding:0,gpuAcceleration:false};this.placement=PLACEMENT_MAP[this.align]||PLACEMENT_MAP.left;this.$on('fieldReset',this.handleFieldReset);},methods:{focus:function focus(){if(!this.ranged){this.$refs.reference.focus();}else{this.handleFocus();}},blur:function blur(){this.refInput.forEach(function(input){return input.blur();});},// {parse, formatTo} Value deals maps component value with internal Date
parseValue:function parseValue(value){var isParsed=Object(date_util_["isDateObject"])(value)||Array.isArray(value)&&value.every(date_util_["isDateObject"]);if(this.valueFormat&&!isParsed){return parseAsFormatAndType(value,this.valueFormat,this.type,this.rangeSeparator)||value;}else{return value;}},formatToValue:function formatToValue(date){var isFormattable=Object(date_util_["isDateObject"])(date)||Array.isArray(date)&&date.every(date_util_["isDateObject"]);if(this.valueFormat&&isFormattable){return formatAsFormatAndType(date,this.valueFormat,this.type,this.rangeSeparator);}else{return date;}},// {parse, formatTo} String deals with user input
parseString:function parseString(value){var type=Array.isArray(value)?this.type:this.type.replace('range','');return parseAsFormatAndType(value,this.format,type);},formatToString:function formatToString(value){var type=Array.isArray(value)?this.type:this.type.replace('range','');return formatAsFormatAndType(value,this.format,type);},handleMouseEnter:function handleMouseEnter(){if(this.readonly||this.pickerDisabled)return;if(!this.valueIsEmpty&&this.clearable){this.showClose=true;}},handleChange:function handleChange(){if(this.userInput){var value=this.parseString(this.displayValue);if(value){this.picker.value=value;if(this.isValidValue(value)){this.emitInput(value);this.userInput=null;}}}if(this.userInput===''){this.emitInput(null);this.emitChange(null);this.userInput=null;}},handleStartInput:function handleStartInput(event){if(this.userInput){this.userInput=[event.target.value,this.userInput[1]];}else{this.userInput=[event.target.value,null];}},handleEndInput:function handleEndInput(event){if(this.userInput){this.userInput=[this.userInput[0],event.target.value];}else{this.userInput=[null,event.target.value];}},handleStartChange:function handleStartChange(event){var value=this.parseString(this.userInput&&this.userInput[0]);if(value){this.userInput=[this.formatToString(value),this.displayValue[1]];var newValue=[value,this.picker.value&&this.picker.value[1]];this.picker.value=newValue;if(this.isValidValue(newValue)){this.emitInput(newValue);this.userInput=null;}}},handleEndChange:function handleEndChange(event){var value=this.parseString(this.userInput&&this.userInput[1]);if(value){this.userInput=[this.displayValue[0],this.formatToString(value)];var newValue=[this.picker.value&&this.picker.value[0],value];this.picker.value=newValue;if(this.isValidValue(newValue)){this.emitInput(newValue);this.userInput=null;}}},handleClickIcon:function handleClickIcon(event){if(this.readonly||this.pickerDisabled)return;if(this.showClose){this.valueOnOpen=this.value;event.stopPropagation();this.emitInput(null);this.emitChange(null);this.showClose=false;if(this.picker&&typeof this.picker.handleClear==='function'){this.picker.handleClear();}}else{this.pickerVisible=!this.pickerVisible;}},handleClose:function handleClose(){if(!this.pickerVisible)return;this.pickerVisible=false;if(this.type==='dates'){// restore to former value
var oldValue=parseAsFormatAndType(this.valueOnOpen,this.valueFormat,this.type,this.rangeSeparator)||this.valueOnOpen;this.emitInput(oldValue);}},handleFieldReset:function handleFieldReset(initialValue){this.userInput=initialValue===''?null:initialValue;},handleFocus:function handleFocus(){var type=this.type;if(HAVE_TRIGGER_TYPES.indexOf(type)!==-1&&!this.pickerVisible){this.pickerVisible=true;}this.$emit('focus',this);},handleKeydown:function handleKeydown(event){var _this=this;var keyCode=event.keyCode;// ESC
if(keyCode===27){this.pickerVisible=false;event.stopPropagation();return;}// Tab
if(keyCode===9){if(!this.ranged){this.handleChange();this.pickerVisible=this.picker.visible=false;this.blur();event.stopPropagation();}else{// user may change focus between two input
setTimeout(function(){if(_this.refInput.indexOf(document.activeElement)===-1){_this.pickerVisible=false;_this.blur();event.stopPropagation();}},0);}return;}// Enter
if(keyCode===13){if(this.userInput===''||this.isValidValue(this.parseString(this.displayValue))){this.handleChange();this.pickerVisible=this.picker.visible=false;this.blur();}event.stopPropagation();return;}// if user is typing, do not let picker handle key input
if(this.userInput){event.stopPropagation();return;}// delegate other keys to panel
if(this.picker&&this.picker.handleKeydown){this.picker.handleKeydown(event);}},handleRangeClick:function handleRangeClick(){var type=this.type;if(HAVE_TRIGGER_TYPES.indexOf(type)!==-1&&!this.pickerVisible){this.pickerVisible=true;}this.$emit('focus',this);},hidePicker:function hidePicker(){if(this.picker){this.picker.resetView&&this.picker.resetView();this.pickerVisible=this.picker.visible=false;this.destroyPopper();}},showPicker:function showPicker(){var _this2=this;if(this.$isServer)return;if(!this.picker){this.mountPicker();}this.pickerVisible=this.picker.visible=true;this.updatePopper();this.picker.value=this.parsedValue;this.picker.resetView&&this.picker.resetView();this.$nextTick(function(){_this2.picker.adjustSpinners&&_this2.picker.adjustSpinners();});},mountPicker:function mountPicker(){var _this3=this;this.picker=new external_vue_default.a(this.panel).$mount();this.picker.defaultValue=this.defaultValue;this.picker.defaultTime=this.defaultTime;this.picker.popperClass=this.popperClass;this.popperElm=this.picker.$el;this.picker.width=this.reference.getBoundingClientRect().width;this.picker.showTime=this.type==='datetime'||this.type==='datetimerange';this.picker.selectionMode=this.selectionMode;this.picker.unlinkPanels=this.unlinkPanels;this.picker.arrowControl=this.arrowControl||this.timeArrowControl||false;this.$watch('format',function(format){_this3.picker.format=format;});var updateOptions=function updateOptions(){var options=_this3.pickerOptions;if(options&&options.selectableRange){var ranges=options.selectableRange;var parser=TYPE_VALUE_RESOLVER_MAP.datetimerange.parser;var format=DEFAULT_FORMATS.timerange;ranges=Array.isArray(ranges)?ranges:[ranges];_this3.picker.selectableRange=ranges.map(function(range){return parser(range,format,_this3.rangeSeparator);});}for(var option in options){if(options.hasOwnProperty(option)&&// 忽略 time-picker 的该配置项
option!=='selectableRange'){_this3.picker[option]=options[option];}}// main format must prevail over undocumented pickerOptions.format
if(_this3.format){_this3.picker.format=_this3.format;}};updateOptions();this.unwatchPickerOptions=this.$watch('pickerOptions',function(){return updateOptions();},{deep:true});this.$el.appendChild(this.picker.$el);this.picker.resetView&&this.picker.resetView();this.picker.$on('dodestroy',this.doDestroy);this.picker.$on('pick',function(){var date=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var visible=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;_this3.userInput=null;_this3.pickerVisible=_this3.picker.visible=visible;_this3.emitInput(date);_this3.picker.resetView&&_this3.picker.resetView();});this.picker.$on('select-range',function(start,end,pos){if(_this3.refInput.length===0)return;if(!pos||pos==='min'){_this3.refInput[0].setSelectionRange(start,end);_this3.refInput[0].focus();}else if(pos==='max'){_this3.refInput[1].setSelectionRange(start,end);_this3.refInput[1].focus();}});},unmountPicker:function unmountPicker(){if(this.picker){this.picker.$destroy();this.picker.$off();if(typeof this.unwatchPickerOptions==='function'){this.unwatchPickerOptions();}this.picker.$el.parentNode.removeChild(this.picker.$el);}},emitChange:function emitChange(val){// determine user real change only
if(!valueEquals(val,this.valueOnOpen)){this.$emit('change',val);this.valueOnOpen=val;if(this.validateEvent){this.dispatch('ElFormItem','el.form.change',val);}}},emitInput:function emitInput(val){var formatted=this.formatToValue(val);if(!valueEquals(this.value,formatted)){this.$emit('input',formatted);}},isValidValue:function isValidValue(value){if(!this.picker){this.mountPicker();}if(this.picker.isValidValue){return value&&this.picker.isValidValue(value);}else{return true;}}}};// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue?vue&type=script&lang=js&
/* harmony default export */var src_pickervue_type_script_lang_js_=pickervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/picker.vue
/* normalize component */var picker_component=normalizeComponent(src_pickervue_type_script_lang_js_,pickervue_type_template_id_79ae069f_render,pickervue_type_template_id_79ae069f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var picker_api;}picker_component.options.__file="packages/date-picker/src/picker.vue";/* harmony default export */var picker=picker_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
var datevue_type_template_id_2440d4ea_render=function datevue_type_template_id_2440d4ea_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-enter":_vm.handleEnter,"after-leave":_vm.handleLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts,"has-time":_vm.showTime},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_vm.showTime?_c("div",{staticClass:"el-date-picker__time-header"},[_c("span",{staticClass:"el-date-picker__editor-wrap"},[_c("el-input",{attrs:{placeholder:_vm.t("el.datepicker.selectDate"),value:_vm.visibleDate,size:"small"},on:{input:function input(val){return _vm.userInputDate=val;},change:_vm.handleVisibleDateChange}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleTimePickClose,expression:"handleTimePickClose"}],staticClass:"el-date-picker__editor-wrap"},[_c("el-input",{ref:"input",attrs:{placeholder:_vm.t("el.datepicker.selectTime"),value:_vm.visibleTime,size:"small"},on:{focus:function focus($event){_vm.timePickerVisible=true;},input:function input(val){return _vm.userInputTime=val;},change:_vm.handleVisibleTimeChange}}),_c("time-picker",{ref:"timepicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.timePickerVisible},on:{pick:_vm.handleTimePick,mounted:_vm.proxyTimePickerDataProperties}})],1)]):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView!=="time",expression:"currentView !== 'time'"}],staticClass:"el-date-picker__header",class:{"el-date-picker__header--bordered":_vm.currentView==="year"||_vm.currentView==="month"}},[_c("button",{staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left",attrs:{type:"button","aria-label":_vm.t("el.datepicker.prevYear")},on:{click:_vm.prevYear}}),_c("button",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left",attrs:{type:"button","aria-label":_vm.t("el.datepicker.prevMonth")},on:{click:_vm.prevMonth}}),_c("span",{staticClass:"el-date-picker__header-label",attrs:{role:"button"},on:{click:_vm.showYearPicker}},[_vm._v(_vm._s(_vm.yearLabel))]),_c("span",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-date-picker__header-label",class:{active:_vm.currentView==="month"},attrs:{role:"button"},on:{click:_vm.showMonthPicker}},[_vm._v(_vm._s(_vm.t("el.datepicker.month"+(_vm.month+1))))]),_c("button",{staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right",attrs:{type:"button","aria-label":_vm.t("el.datepicker.nextYear")},on:{click:_vm.nextYear}}),_c("button",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],staticClass:"el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right",attrs:{type:"button","aria-label":_vm.t("el.datepicker.nextMonth")},on:{click:_vm.nextMonth}})]),_c("div",{staticClass:"el-picker-panel__content"},[_c("date-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="date",expression:"currentView === 'date'"}],attrs:{"selection-mode":_vm.selectionMode,"first-day-of-week":_vm.firstDayOfWeek,value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"cell-class-name":_vm.cellClassName,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleDatePick}}),_c("year-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="year",expression:"currentView === 'year'"}],attrs:{value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleYearPick}}),_c("month-table",{directives:[{name:"show",rawName:"v-show",value:_vm.currentView==="month",expression:"currentView === 'month'"}],attrs:{value:_vm.value,"default-value":_vm.defaultValue?new Date(_vm.defaultValue):null,date:_vm.date,"disabled-date":_vm.disabledDate},on:{pick:_vm.handleMonthPick}})],1)])],2),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.footerVisible&&_vm.currentView==="date",expression:"footerVisible && currentView === 'date'"}],staticClass:"el-picker-panel__footer"},[_c("el-button",{directives:[{name:"show",rawName:"v-show",value:_vm.selectionMode!=="dates",expression:"selectionMode !== 'dates'"}],staticClass:"el-picker-panel__link-btn",attrs:{size:"mini",type:"text"},on:{click:_vm.changeToNow}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.now"))+"\n      ")]),_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{plain:"",size:"mini"},on:{click:_vm.confirm}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.confirm"))+"\n      ")])],1)])]);};var datevue_type_template_id_2440d4ea_staticRenderFns=[];datevue_type_template_id_2440d4ea_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=template&id=2440d4ea&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
var timevue_type_template_id_3d939089_render=function timevue_type_template_id_3d939089_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-time-panel el-popper",class:_vm.popperClass},[_c("div",{staticClass:"el-time-panel__content",class:{"has-seconds":_vm.showSeconds}},[_c("time-spinner",{ref:"spinner",attrs:{"arrow-control":_vm.useArrow,"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,date:_vm.date},on:{change:_vm.handleChange,"select-range":_vm.setSelectionRange}})],1),_c("div",{staticClass:"el-time-panel__footer"},[_c("button",{staticClass:"el-time-panel__btn cancel",attrs:{type:"button"},on:{click:_vm.handleCancel}},[_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]),_c("button",{staticClass:"el-time-panel__btn",class:{confirm:!_vm.disabled},attrs:{type:"button"},on:{click:function click($event){_vm.handleConfirm();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))])])])]);};var timevue_type_template_id_3d939089_staticRenderFns=[];timevue_type_template_id_3d939089_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=template&id=3d939089&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
var time_spinnervue_type_template_id_1facadeb_render=function time_spinnervue_type_template_id_1facadeb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-time-spinner",class:{"has-seconds":_vm.showSeconds}},[!_vm.arrowControl?[_c("el-scrollbar",{ref:"hours",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("hours");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("hours");}}},_vm._l(_vm.hoursList,function(disabled,hour){return _c("li",{key:hour,staticClass:"el-time-spinner__item",class:{active:hour===_vm.hours,disabled:disabled},on:{click:function click($event){_vm.handleClick("hours",{value:hour,disabled:disabled});}}},[_vm._v(_vm._s(("0"+(_vm.amPmMode?hour%12||12:hour)).slice(-2))+_vm._s(_vm.amPm(hour)))]);}),0),_c("el-scrollbar",{ref:"minutes",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("minutes");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("minutes");}}},_vm._l(_vm.minutesList,function(enabled,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:key===_vm.minutes,disabled:!enabled},on:{click:function click($event){_vm.handleClick("minutes",{value:key,disabled:false});}}},[_vm._v(_vm._s(("0"+key).slice(-2)))]);}),0),_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.showSeconds,expression:"showSeconds"}],ref:"seconds",staticClass:"el-time-spinner__wrapper",attrs:{"wrap-style":"max-height: inherit;","view-class":"el-time-spinner__list",noresize:"",tag:"ul"},nativeOn:{mouseenter:function mouseenter($event){_vm.emitSelectRange("seconds");},mousemove:function mousemove($event){_vm.adjustCurrentSpinner("seconds");}}},_vm._l(60,function(second,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:key===_vm.seconds},on:{click:function click($event){_vm.handleClick("seconds",{value:key,disabled:false});}}},[_vm._v(_vm._s(("0"+key).slice(-2)))]);}),0)]:_vm._e(),_vm.arrowControl?[_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("hours");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"hours",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowHourList,function(hour,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:hour===_vm.hours,disabled:_vm.hoursList[hour]}},[_vm._v(_vm._s(hour===undefined?"":("0"+(_vm.amPmMode?hour%12||12:hour)).slice(-2)+_vm.amPm(hour)))]);}),0)]),_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("minutes");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"minutes",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowMinuteList,function(minute,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:minute===_vm.minutes}},[_vm._v("\n          "+_vm._s(minute===undefined?"":("0"+minute).slice(-2))+"\n        ")]);}),0)]),_vm.showSeconds?_c("div",{staticClass:"el-time-spinner__wrapper is-arrow",on:{mouseenter:function mouseenter($event){_vm.emitSelectRange("seconds");}}},[_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.decrease,expression:"decrease"}],staticClass:"el-time-spinner__arrow el-icon-arrow-up"}),_c("i",{directives:[{name:"repeat-click",rawName:"v-repeat-click",value:_vm.increase,expression:"increase"}],staticClass:"el-time-spinner__arrow el-icon-arrow-down"}),_c("ul",{ref:"seconds",staticClass:"el-time-spinner__list"},_vm._l(_vm.arrowSecondList,function(second,key){return _c("li",{key:key,staticClass:"el-time-spinner__item",class:{active:second===_vm.seconds}},[_vm._v("\n          "+_vm._s(second===undefined?"":("0"+second).slice(-2))+"\n        ")]);}),0)]):_vm._e()]:_vm._e()],2);};var time_spinnervue_type_template_id_1facadeb_staticRenderFns=[];time_spinnervue_type_template_id_1facadeb_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=template&id=1facadeb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var time_spinnervue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},directives:{repeatClick:repeat_click},props:{date:{},defaultValue:{},// reserved for future use
showSeconds:{type:Boolean,default:true},arrowControl:Boolean,amPmMode:{type:String,default:''// 'a': am/pm; 'A': AM/PM
}},computed:{hours:function hours(){return this.date.getHours();},minutes:function minutes(){return this.date.getMinutes();},seconds:function seconds(){return this.date.getSeconds();},hoursList:function hoursList(){return Object(date_util_["getRangeHours"])(this.selectableRange);},minutesList:function minutesList(){return Object(date_util_["getRangeMinutes"])(this.selectableRange,this.hours);},arrowHourList:function arrowHourList(){var hours=this.hours;return[hours>0?hours-1:undefined,hours,hours<23?hours+1:undefined];},arrowMinuteList:function arrowMinuteList(){var minutes=this.minutes;return[minutes>0?minutes-1:undefined,minutes,minutes<59?minutes+1:undefined];},arrowSecondList:function arrowSecondList(){var seconds=this.seconds;return[seconds>0?seconds-1:undefined,seconds,seconds<59?seconds+1:undefined];}},data:function data(){return{selectableRange:[],currentScrollbar:null};},mounted:function mounted(){var _this=this;this.$nextTick(function(){!_this.arrowControl&&_this.bindScrollEvent();});},methods:{increase:function increase(){this.scrollDown(1);},decrease:function decrease(){this.scrollDown(-1);},modifyDateField:function modifyDateField(type,value){switch(type){case'hours':this.$emit('change',Object(date_util_["modifyTime"])(this.date,value,this.minutes,this.seconds));break;case'minutes':this.$emit('change',Object(date_util_["modifyTime"])(this.date,this.hours,value,this.seconds));break;case'seconds':this.$emit('change',Object(date_util_["modifyTime"])(this.date,this.hours,this.minutes,value));break;}},handleClick:function handleClick(type,_ref){var value=_ref.value,disabled=_ref.disabled;if(!disabled){this.modifyDateField(type,value);this.emitSelectRange(type);this.adjustSpinner(type,value);}},emitSelectRange:function emitSelectRange(type){if(type==='hours'){this.$emit('select-range',0,2);}else if(type==='minutes'){this.$emit('select-range',3,5);}else if(type==='seconds'){this.$emit('select-range',6,8);}this.currentScrollbar=type;},bindScrollEvent:function bindScrollEvent(){var _this2=this;var bindFunction=function bindFunction(type){_this2.$refs[type].wrap.onscroll=function(e){// TODO: scroll is emitted when set scrollTop programatically
// should find better solutions in the future!
_this2.handleScroll(type,e);};};bindFunction('hours');bindFunction('minutes');bindFunction('seconds');},handleScroll:function handleScroll(type){var value=Math.min(Math.round((this.$refs[type].wrap.scrollTop-(this.scrollBarHeight(type)*0.5-10)/this.typeItemHeight(type)+3)/this.typeItemHeight(type)),type==='hours'?23:59);this.modifyDateField(type,value);},// NOTE: used by datetime / date-range panel
//       renamed from adjustScrollTop
//       should try to refactory it
adjustSpinners:function adjustSpinners(){this.adjustSpinner('hours',this.hours);this.adjustSpinner('minutes',this.minutes);this.adjustSpinner('seconds',this.seconds);},adjustCurrentSpinner:function adjustCurrentSpinner(type){this.adjustSpinner(type,this[type]);},adjustSpinner:function adjustSpinner(type,value){if(this.arrowControl)return;var el=this.$refs[type].wrap;if(el){el.scrollTop=Math.max(0,value*this.typeItemHeight(type));}},scrollDown:function scrollDown(step){var _this3=this;if(!this.currentScrollbar){this.emitSelectRange('hours');}var label=this.currentScrollbar;var hoursList=this.hoursList;var now=this[label];if(this.currentScrollbar==='hours'){var total=Math.abs(step);step=step>0?1:-1;var length=hoursList.length;while(length--&&total){now=(now+step+hoursList.length)%hoursList.length;if(hoursList[now]){continue;}total--;}if(hoursList[now])return;}else{now=(now+step+60)%60;}this.modifyDateField(label,now);this.adjustSpinner(label,now);this.$nextTick(function(){return _this3.emitSelectRange(_this3.currentScrollbar);});},amPm:function amPm(hour){var shouldShowAmPm=this.amPmMode.toLowerCase()==='a';if(!shouldShowAmPm)return'';var isCapital=this.amPmMode==='A';var content=hour<12?' am':' pm';if(isCapital)content=content.toUpperCase();return content;},typeItemHeight:function typeItemHeight(type){return this.$refs[type].$el.querySelector('li').offsetHeight;},scrollBarHeight:function scrollBarHeight(type){return this.$refs[type].$el.offsetHeight;}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue?vue&type=script&lang=js&
/* harmony default export */var basic_time_spinnervue_type_script_lang_js_=time_spinnervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/time-spinner.vue
/* normalize component */var time_spinner_component=normalizeComponent(basic_time_spinnervue_type_script_lang_js_,time_spinnervue_type_template_id_1facadeb_render,time_spinnervue_type_template_id_1facadeb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_spinner_api;}time_spinner_component.options.__file="packages/date-picker/src/basic/time-spinner.vue";/* harmony default export */var time_spinner=time_spinner_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var timevue_type_script_lang_js_={mixins:[locale_default.a],components:{TimeSpinner:time_spinner},props:{visible:Boolean,timeArrowControl:Boolean},watch:{visible:function visible(val){var _this=this;if(val){this.oldValue=this.value;this.$nextTick(function(){return _this.$refs.spinner.emitSelectRange('hours');});}else{this.needInitAdjust=true;}},value:function value(newVal){var _this2=this;var date=void 0;if(newVal instanceof Date){date=Object(date_util_["limitTimeRange"])(newVal,this.selectableRange,this.format);}else if(!newVal){date=this.defaultValue?new Date(this.defaultValue):new Date();}this.date=date;if(this.visible&&this.needInitAdjust){this.$nextTick(function(_){return _this2.adjustSpinners();});this.needInitAdjust=false;}},selectableRange:function selectableRange(val){this.$refs.spinner.selectableRange=val;},defaultValue:function defaultValue(val){if(!Object(date_util_["isDate"])(this.value)){this.date=val?new Date(val):new Date();}}},data:function data(){return{popperClass:'',format:'HH:mm:ss',value:'',defaultValue:null,date:new Date(),oldValue:new Date(),selectableRange:[],selectionRange:[0,2],disabled:false,arrowControl:false,needInitAdjust:true};},computed:{showSeconds:function showSeconds(){return(this.format||'').indexOf('ss')!==-1;},useArrow:function useArrow(){return this.arrowControl||this.timeArrowControl||false;},amPmMode:function amPmMode(){if((this.format||'').indexOf('A')!==-1)return'A';if((this.format||'').indexOf('a')!==-1)return'a';return'';}},methods:{handleCancel:function handleCancel(){this.$emit('pick',this.oldValue,false);},handleChange:function handleChange(date){// this.visible avoids edge cases, when use scrolls during panel closing animation
if(this.visible){this.date=Object(date_util_["clearMilliseconds"])(date);// if date is out of range, do not emit
if(this.isValidValue(this.date)){this.$emit('pick',this.date,true);}}},setSelectionRange:function setSelectionRange(start,end){this.$emit('select-range',start,end);this.selectionRange=[start,end];},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var first=arguments[1];if(first)return;var date=Object(date_util_["clearMilliseconds"])(Object(date_util_["limitTimeRange"])(this.date,this.selectableRange,this.format));this.$emit('pick',date,visible,first);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var mapping={38:-1,40:1,37:-1,39:1};// Left or Right
if(keyCode===37||keyCode===39){var step=mapping[keyCode];this.changeSelectionRange(step);event.preventDefault();return;}// Up or Down
if(keyCode===38||keyCode===40){var _step=mapping[keyCode];this.$refs.spinner.scrollDown(_step);event.preventDefault();return;}},isValidValue:function isValidValue(date){return Object(date_util_["timeWithinRange"])(date,this.selectableRange,this.format);},adjustSpinners:function adjustSpinners(){return this.$refs.spinner.adjustSpinners();},changeSelectionRange:function changeSelectionRange(step){var list=[0,3].concat(this.showSeconds?[6]:[]);var mapping=['hours','minutes'].concat(this.showSeconds?['seconds']:[]);var index=list.indexOf(this.selectionRange[0]);var next=(index+step+list.length)%list.length;this.$refs.spinner.emitSelectRange(mapping[next]);}},mounted:function mounted(){var _this3=this;this.$nextTick(function(){return _this3.handleConfirm(true,true);});this.$emit('mounted');}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue?vue&type=script&lang=js&
/* harmony default export */var panel_timevue_type_script_lang_js_=timevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time.vue
/* normalize component */var time_component=normalizeComponent(panel_timevue_type_script_lang_js_,timevue_type_template_id_3d939089_render,timevue_type_template_id_3d939089_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_api;}time_component.options.__file="packages/date-picker/src/panel/time.vue";/* harmony default export */var panel_time=time_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
var year_tablevue_type_template_id_c86ab5e0_render=function year_tablevue_type_template_id_c86ab5e0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-year-table",on:{click:_vm.handleYearTableClick}},[_c("tbody",[_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+0)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+1)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+1))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+2)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+2))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+3)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+3))])])]),_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+4)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+4))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+5)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+5))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+6)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+6))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+7)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+7))])])]),_c("tr",[_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+8)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+8))])]),_c("td",{staticClass:"available",class:_vm.getCellStyle(_vm.startYear+9)},[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.startYear+9))])]),_c("td"),_c("td")])])]);};var year_tablevue_type_template_id_c86ab5e0_staticRenderFns=[];year_tablevue_type_template_id_c86ab5e0_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=template&id=c86ab5e0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var year_tablevue_type_script_lang_js_datesInYear=function datesInYear(year){var numOfDays=Object(date_util_["getDayCountOfYear"])(year);var firstDay=new Date(year,0,1);return Object(date_util_["range"])(numOfDays).map(function(n){return Object(date_util_["nextDate"])(firstDay,n);});};/* harmony default export */var year_tablevue_type_script_lang_js_={props:{disabledDate:{},value:{},defaultValue:{validator:function validator(val){// null or valid Date Object
return val===null||val instanceof Date&&Object(date_util_["isDate"])(val);}},date:{}},computed:{startYear:function startYear(){return Math.floor(this.date.getFullYear()/10)*10;}},methods:{getCellStyle:function getCellStyle(year){var style={};var today=new Date();style.disabled=typeof this.disabledDate==='function'?year_tablevue_type_script_lang_js_datesInYear(year).every(this.disabledDate):false;style.current=Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value),function(date){return date.getFullYear()===year;})>=0;style.today=today.getFullYear()===year;style.default=this.defaultValue&&this.defaultValue.getFullYear()===year;return style;},handleYearTableClick:function handleYearTableClick(event){var target=event.target;if(target.tagName==='A'){if(Object(dom_["hasClass"])(target.parentNode,'disabled'))return;var year=target.textContent||target.innerText;this.$emit('pick',Number(year));}}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_year_tablevue_type_script_lang_js_=year_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/year-table.vue
/* normalize component */var year_table_component=normalizeComponent(basic_year_tablevue_type_script_lang_js_,year_tablevue_type_template_id_c86ab5e0_render,year_tablevue_type_template_id_c86ab5e0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var year_table_api;}year_table_component.options.__file="packages/date-picker/src/basic/year-table.vue";/* harmony default export */var year_table=year_table_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
var month_tablevue_type_template_id_654d4f42_render=function month_tablevue_type_template_id_654d4f42_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-month-table",on:{click:_vm.handleMonthTableClick,mousemove:_vm.handleMouseMove}},[_c("tbody",_vm._l(_vm.rows,function(row,key){return _c("tr",{key:key},_vm._l(row,function(cell,key){return _c("td",{key:key,class:_vm.getCellStyle(cell)},[_c("div",[_c("a",{staticClass:"cell"},[_vm._v(_vm._s(_vm.t("el.datepicker.months."+_vm.months[cell.text])))])])]);}),0);}),0)]);};var month_tablevue_type_template_id_654d4f42_staticRenderFns=[];month_tablevue_type_template_id_654d4f42_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=template&id=654d4f42&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var month_tablevue_type_script_lang_js_datesInMonth=function datesInMonth(year,month){var numOfDays=Object(date_util_["getDayCountOfMonth"])(year,month);var firstDay=new Date(year,month,1);return Object(date_util_["range"])(numOfDays).map(function(n){return Object(date_util_["nextDate"])(firstDay,n);});};var clearDate=function clearDate(date){return new Date(date.getFullYear(),date.getMonth());};var getMonthTimestamp=function getMonthTimestamp(time){if(typeof time==='number'||typeof time==='string'){return clearDate(new Date(time)).getTime();}else if(time instanceof Date){return clearDate(time).getTime();}else{return NaN;}};/* harmony default export */var month_tablevue_type_script_lang_js_={props:{disabledDate:{},value:{},selectionMode:{default:'month'},minDate:{},maxDate:{},defaultValue:{validator:function validator(val){// null or valid Date Object
return val===null||Object(date_util_["isDate"])(val)||Array.isArray(val)&&val.every(date_util_["isDate"]);}},date:{},rangeState:{default:function _default(){return{endDate:null,selecting:false};}}},mixins:[locale_default.a],watch:{'rangeState.endDate':function rangeStateEndDate(newVal){this.markRange(this.minDate,newVal);},minDate:function minDate(newVal,oldVal){if(getMonthTimestamp(newVal)!==getMonthTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}},maxDate:function maxDate(newVal,oldVal){if(getMonthTimestamp(newVal)!==getMonthTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}}},data:function data(){return{months:['jan','feb','mar','apr','may','jun','jul','aug','sep','oct','nov','dec'],tableRows:[[],[],[]],lastRow:null,lastColumn:null};},methods:{cellMatchesDate:function cellMatchesDate(cell,date){var value=new Date(date);return this.date.getFullYear()===value.getFullYear()&&Number(cell.text)===value.getMonth();},getCellStyle:function getCellStyle(cell){var _this=this;var style={};var year=this.date.getFullYear();var today=new Date();var month=cell.text;var defaultValue=this.defaultValue?Array.isArray(this.defaultValue)?this.defaultValue:[this.defaultValue]:[];style.disabled=typeof this.disabledDate==='function'?month_tablevue_type_script_lang_js_datesInMonth(year,month).every(this.disabledDate):false;style.current=Object(util_["arrayFindIndex"])(Object(util_["coerceTruthyValueToArray"])(this.value),function(date){return date.getFullYear()===year&&date.getMonth()===month;})>=0;style.today=today.getFullYear()===year&&today.getMonth()===month;style.default=defaultValue.some(function(date){return _this.cellMatchesDate(cell,date);});if(cell.inRange){style['in-range']=true;if(cell.start){style['start-date']=true;}if(cell.end){style['end-date']=true;}}return style;},getMonthOfCell:function getMonthOfCell(month){var year=this.date.getFullYear();return new Date(year,month,1);},markRange:function markRange(minDate,maxDate){minDate=getMonthTimestamp(minDate);maxDate=getMonthTimestamp(maxDate)||minDate;var _ref=[Math.min(minDate,maxDate),Math.max(minDate,maxDate)];minDate=_ref[0];maxDate=_ref[1];var rows=this.rows;for(var i=0,k=rows.length;i<k;i++){var row=rows[i];for(var j=0,l=row.length;j<l;j++){var cell=row[j];var index=i*4+j;var time=new Date(this.date.getFullYear(),index).getTime();cell.inRange=minDate&&time>=minDate&&time<=maxDate;cell.start=minDate&&time===minDate;cell.end=maxDate&&time===maxDate;}}},handleMouseMove:function handleMouseMove(event){if(!this.rangeState.selecting)return;var target=event.target;if(target.tagName==='A'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex;var column=target.cellIndex;// can not select disabled date
if(this.rows[row][column].disabled)return;// only update rangeState when mouse moves to a new cell
// this avoids frequent Date object creation and improves performance
if(row!==this.lastRow||column!==this.lastColumn){this.lastRow=row;this.lastColumn=column;this.$emit('changerange',{minDate:this.minDate,maxDate:this.maxDate,rangeState:{selecting:true,endDate:this.getMonthOfCell(row*4+column)}});}},handleMonthTableClick:function handleMonthTableClick(event){var target=event.target;if(target.tagName==='A'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;if(Object(dom_["hasClass"])(target,'disabled'))return;var column=target.cellIndex;var row=target.parentNode.rowIndex;var month=row*4+column;var newDate=this.getMonthOfCell(month);if(this.selectionMode==='range'){if(!this.rangeState.selecting){this.$emit('pick',{minDate:newDate,maxDate:null});this.rangeState.selecting=true;}else{if(newDate>=this.minDate){this.$emit('pick',{minDate:this.minDate,maxDate:newDate});}else{this.$emit('pick',{minDate:newDate,maxDate:this.minDate});}this.rangeState.selecting=false;}}else{this.$emit('pick',month);}}},computed:{rows:function rows(){var _this2=this;// TODO: refactory rows / getCellClasses
var rows=this.tableRows;var disabledDate=this.disabledDate;var selectedDate=[];var now=getMonthTimestamp(new Date());for(var i=0;i<3;i++){var row=rows[i];var _loop=function _loop(j){var cell=row[j];if(!cell){cell={row:i,column:j,type:'normal',inRange:false,start:false,end:false};}cell.type='normal';var index=i*4+j;var time=new Date(_this2.date.getFullYear(),index).getTime();cell.inRange=time>=getMonthTimestamp(_this2.minDate)&&time<=getMonthTimestamp(_this2.maxDate);cell.start=_this2.minDate&&time===getMonthTimestamp(_this2.minDate);cell.end=_this2.maxDate&&time===getMonthTimestamp(_this2.maxDate);var isToday=time===now;if(isToday){cell.type='today';}cell.text=index;var cellDate=new Date(time);cell.disabled=typeof disabledDate==='function'&&disabledDate(cellDate);cell.selected=Object(util_["arrayFind"])(selectedDate,function(date){return date.getTime()===cellDate.getTime();});_this2.$set(row,j,cell);};for(var j=0;j<4;j++){_loop(j);}}return rows;}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_month_tablevue_type_script_lang_js_=month_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/month-table.vue
/* normalize component */var month_table_component=normalizeComponent(basic_month_tablevue_type_script_lang_js_,month_tablevue_type_template_id_654d4f42_render,month_tablevue_type_template_id_654d4f42_staticRenderFns,false,null,null,null);/* hot reload */if(false){var month_table_api;}month_table_component.options.__file="packages/date-picker/src/basic/month-table.vue";/* harmony default export */var month_table=month_table_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
var date_tablevue_type_template_id_5d1f3341_render=function date_tablevue_type_template_id_5d1f3341_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("table",{staticClass:"el-date-table",class:{"is-week-mode":_vm.selectionMode==="week"},attrs:{cellspacing:"0",cellpadding:"0"},on:{click:_vm.handleClick,mousemove:_vm.handleMouseMove}},[_c("tbody",[_c("tr",[_vm.showWeekNumber?_c("th",[_vm._v(_vm._s(_vm.t("el.datepicker.week")))]):_vm._e(),_vm._l(_vm.WEEKS,function(week,key){return _c("th",{key:key},[_vm._v(_vm._s(_vm.t("el.datepicker.weeks."+week)))]);})],2),_vm._l(_vm.rows,function(row,key){return _c("tr",{key:key,staticClass:"el-date-table__row",class:{current:_vm.isWeekActive(row[1])}},_vm._l(row,function(cell,key){return _c("td",{key:key,class:_vm.getCellClasses(cell)},[_c("div",[_c("span",[_vm._v("\n          "+_vm._s(cell.text)+"\n        ")])])]);}),0);})],2)]);};var date_tablevue_type_template_id_5d1f3341_staticRenderFns=[];date_tablevue_type_template_id_5d1f3341_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=template&id=5d1f3341&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _WEEKS=['sun','mon','tue','wed','thu','fri','sat'];var date_tablevue_type_script_lang_js_getDateTimestamp=function getDateTimestamp(time){if(typeof time==='number'||typeof time==='string'){return Object(date_util_["clearTime"])(new Date(time)).getTime();}else if(time instanceof Date){return Object(date_util_["clearTime"])(time).getTime();}else{return NaN;}};// remove the first element that satisfies `pred` from arr
// return a new array if modification occurs
// return the original array otherwise
var date_tablevue_type_script_lang_js_removeFromArray=function removeFromArray(arr,pred){var idx=typeof pred==='function'?Object(util_["arrayFindIndex"])(arr,pred):arr.indexOf(pred);return idx>=0?[].concat(arr.slice(0,idx),arr.slice(idx+1)):arr;};/* harmony default export */var date_tablevue_type_script_lang_js_={mixins:[locale_default.a],props:{firstDayOfWeek:{default:7,type:Number,validator:function validator(val){return val>=1&&val<=7;}},value:{},defaultValue:{validator:function validator(val){// either: null, valid Date object, Array of valid Date objects
return val===null||Object(date_util_["isDate"])(val)||Array.isArray(val)&&val.every(date_util_["isDate"]);}},date:{},selectionMode:{default:'day'},showWeekNumber:{type:Boolean,default:false},disabledDate:{},cellClassName:{},minDate:{},maxDate:{},rangeState:{default:function _default(){return{endDate:null,selecting:false};}}},computed:{offsetDay:function offsetDay(){var week=this.firstDayOfWeek;// 周日为界限，左右偏移的天数，3217654 例如周一就是 -1，目的是调整前两行日期的位置
return week>3?7-week:-week;},WEEKS:function WEEKS(){var week=this.firstDayOfWeek;return _WEEKS.concat(_WEEKS).slice(week,week+7);},year:function year(){return this.date.getFullYear();},month:function month(){return this.date.getMonth();},startDate:function startDate(){return Object(date_util_["getStartDateOfMonth"])(this.year,this.month);},rows:function rows(){var _this=this;// TODO: refactory rows / getCellClasses
var date=new Date(this.year,this.month,1);var day=Object(date_util_["getFirstDayOfMonth"])(date);// day of first day
var dateCountOfMonth=Object(date_util_["getDayCountOfMonth"])(date.getFullYear(),date.getMonth());var dateCountOfLastMonth=Object(date_util_["getDayCountOfMonth"])(date.getFullYear(),date.getMonth()===0?11:date.getMonth()-1);day=day===0?7:day;var offset=this.offsetDay;var rows=this.tableRows;var count=1;var startDate=this.startDate;var disabledDate=this.disabledDate;var cellClassName=this.cellClassName;var selectedDate=this.selectionMode==='dates'?Object(util_["coerceTruthyValueToArray"])(this.value):[];var now=date_tablevue_type_script_lang_js_getDateTimestamp(new Date());for(var i=0;i<6;i++){var row=rows[i];if(this.showWeekNumber){if(!row[0]){row[0]={type:'week',text:Object(date_util_["getWeekNumber"])(Object(date_util_["nextDate"])(startDate,i*7+1))};}}var _loop=function _loop(j){var cell=row[_this.showWeekNumber?j+1:j];if(!cell){cell={row:i,column:j,type:'normal',inRange:false,start:false,end:false};}cell.type='normal';var index=i*7+j;var time=Object(date_util_["nextDate"])(startDate,index-offset).getTime();cell.inRange=time>=date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate)&&time<=date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);cell.start=_this.minDate&&time===date_tablevue_type_script_lang_js_getDateTimestamp(_this.minDate);cell.end=_this.maxDate&&time===date_tablevue_type_script_lang_js_getDateTimestamp(_this.maxDate);var isToday=time===now;if(isToday){cell.type='today';}if(i>=0&&i<=1){var numberOfDaysFromPreviousMonth=day+offset<0?7+day+offset:day+offset;if(j+i*7>=numberOfDaysFromPreviousMonth){cell.text=count++;}else{cell.text=dateCountOfLastMonth-(numberOfDaysFromPreviousMonth-j%7)+1+i*7;cell.type='prev-month';}}else{if(count<=dateCountOfMonth){cell.text=count++;}else{cell.text=count++-dateCountOfMonth;cell.type='next-month';}}var cellDate=new Date(time);cell.disabled=typeof disabledDate==='function'&&disabledDate(cellDate);cell.selected=Object(util_["arrayFind"])(selectedDate,function(date){return date.getTime()===cellDate.getTime();});cell.customClass=typeof cellClassName==='function'&&cellClassName(cellDate);_this.$set(row,_this.showWeekNumber?j+1:j,cell);};for(var j=0;j<7;j++){_loop(j);}if(this.selectionMode==='week'){var start=this.showWeekNumber?1:0;var end=this.showWeekNumber?7:6;var isWeekActive=this.isWeekActive(row[start+1]);row[start].inRange=isWeekActive;row[start].start=isWeekActive;row[end].inRange=isWeekActive;row[end].end=isWeekActive;}}return rows;}},watch:{'rangeState.endDate':function rangeStateEndDate(newVal){this.markRange(this.minDate,newVal);},minDate:function minDate(newVal,oldVal){if(date_tablevue_type_script_lang_js_getDateTimestamp(newVal)!==date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}},maxDate:function maxDate(newVal,oldVal){if(date_tablevue_type_script_lang_js_getDateTimestamp(newVal)!==date_tablevue_type_script_lang_js_getDateTimestamp(oldVal)){this.markRange(this.minDate,this.maxDate);}}},data:function data(){return{tableRows:[[],[],[],[],[],[]],lastRow:null,lastColumn:null};},methods:{cellMatchesDate:function cellMatchesDate(cell,date){var value=new Date(date);return this.year===value.getFullYear()&&this.month===value.getMonth()&&Number(cell.text)===value.getDate();},getCellClasses:function getCellClasses(cell){var _this2=this;var selectionMode=this.selectionMode;var defaultValue=this.defaultValue?Array.isArray(this.defaultValue)?this.defaultValue:[this.defaultValue]:[];var classes=[];if((cell.type==='normal'||cell.type==='today')&&!cell.disabled){classes.push('available');if(cell.type==='today'){classes.push('today');}}else{classes.push(cell.type);}if(cell.type==='normal'&&defaultValue.some(function(date){return _this2.cellMatchesDate(cell,date);})){classes.push('default');}if(selectionMode==='day'&&(cell.type==='normal'||cell.type==='today')&&this.cellMatchesDate(cell,this.value)){classes.push('current');}if(cell.inRange&&(cell.type==='normal'||cell.type==='today'||this.selectionMode==='week')){classes.push('in-range');if(cell.start){classes.push('start-date');}if(cell.end){classes.push('end-date');}}if(cell.disabled){classes.push('disabled');}if(cell.selected){classes.push('selected');}if(cell.customClass){classes.push(cell.customClass);}return classes.join(' ');},getDateOfCell:function getDateOfCell(row,column){var offsetFromStart=row*7+(column-(this.showWeekNumber?1:0))-this.offsetDay;return Object(date_util_["nextDate"])(this.startDate,offsetFromStart);},isWeekActive:function isWeekActive(cell){if(this.selectionMode!=='week')return false;var newDate=new Date(this.year,this.month,1);var year=newDate.getFullYear();var month=newDate.getMonth();if(cell.type==='prev-month'){newDate.setMonth(month===0?11:month-1);newDate.setFullYear(month===0?year-1:year);}if(cell.type==='next-month'){newDate.setMonth(month===11?0:month+1);newDate.setFullYear(month===11?year+1:year);}newDate.setDate(parseInt(cell.text,10));if(Object(date_util_["isDate"])(this.value)){var dayOffset=(this.value.getDay()-this.firstDayOfWeek+7)%7-1;var weekDate=Object(date_util_["prevDate"])(this.value,dayOffset);return weekDate.getTime()===newDate.getTime();}return false;},markRange:function markRange(minDate,maxDate){minDate=date_tablevue_type_script_lang_js_getDateTimestamp(minDate);maxDate=date_tablevue_type_script_lang_js_getDateTimestamp(maxDate)||minDate;var _ref=[Math.min(minDate,maxDate),Math.max(minDate,maxDate)];minDate=_ref[0];maxDate=_ref[1];var startDate=this.startDate;var rows=this.rows;for(var i=0,k=rows.length;i<k;i++){var row=rows[i];for(var j=0,l=row.length;j<l;j++){if(this.showWeekNumber&&j===0)continue;var _cell=row[j];var index=i*7+j+(this.showWeekNumber?-1:0);var time=Object(date_util_["nextDate"])(startDate,index-this.offsetDay).getTime();_cell.inRange=minDate&&time>=minDate&&time<=maxDate;_cell.start=minDate&&time===minDate;_cell.end=maxDate&&time===maxDate;}}},handleMouseMove:function handleMouseMove(event){if(!this.rangeState.selecting)return;var target=event.target;if(target.tagName==='SPAN'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex-1;var column=target.cellIndex;// can not select disabled date
if(this.rows[row][column].disabled)return;// only update rangeState when mouse moves to a new cell
// this avoids frequent Date object creation and improves performance
if(row!==this.lastRow||column!==this.lastColumn){this.lastRow=row;this.lastColumn=column;this.$emit('changerange',{minDate:this.minDate,maxDate:this.maxDate,rangeState:{selecting:true,endDate:this.getDateOfCell(row,column)}});}},handleClick:function handleClick(event){var target=event.target;if(target.tagName==='SPAN'){target=target.parentNode.parentNode;}if(target.tagName==='DIV'){target=target.parentNode;}if(target.tagName!=='TD')return;var row=target.parentNode.rowIndex-1;var column=this.selectionMode==='week'?1:target.cellIndex;var cell=this.rows[row][column];if(cell.disabled||cell.type==='week')return;var newDate=this.getDateOfCell(row,column);if(this.selectionMode==='range'){if(!this.rangeState.selecting){this.$emit('pick',{minDate:newDate,maxDate:null});this.rangeState.selecting=true;}else{if(newDate>=this.minDate){this.$emit('pick',{minDate:this.minDate,maxDate:newDate});}else{this.$emit('pick',{minDate:newDate,maxDate:this.minDate});}this.rangeState.selecting=false;}}else if(this.selectionMode==='day'){this.$emit('pick',newDate);}else if(this.selectionMode==='week'){var weekNumber=Object(date_util_["getWeekNumber"])(newDate);var value=newDate.getFullYear()+'w'+weekNumber;this.$emit('pick',{year:newDate.getFullYear(),week:weekNumber,value:value,date:newDate});}else if(this.selectionMode==='dates'){var _value=this.value||[];var newValue=cell.selected?date_tablevue_type_script_lang_js_removeFromArray(_value,function(date){return date.getTime()===newDate.getTime();}):[].concat(_value,[newDate]);this.$emit('pick',newValue);}}}};// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var basic_date_tablevue_type_script_lang_js_=date_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/basic/date-table.vue
/* normalize component */var date_table_component=normalizeComponent(basic_date_tablevue_type_script_lang_js_,date_tablevue_type_template_id_5d1f3341_render,date_tablevue_type_template_id_5d1f3341_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_table_api;}date_table_component.options.__file="packages/date-picker/src/basic/date-table.vue";/* harmony default export */var date_table=date_table_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var datevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},watch:{showTime:function showTime(val){var _this=this;/* istanbul ignore if */if(!val)return;this.$nextTick(function(_){var inputElm=_this.$refs.input.$el;if(inputElm){_this.pickerWidth=inputElm.getBoundingClientRect().width+10;}});},value:function value(val){if(this.selectionMode==='dates'&&this.value)return;if(Object(date_util_["isDate"])(val)){this.date=new Date(val);}else{this.date=this.getDefaultValue();}},defaultValue:function defaultValue(val){if(!Object(date_util_["isDate"])(this.value)){this.date=val?new Date(val):new Date();}},timePickerVisible:function timePickerVisible(val){var _this2=this;if(val)this.$nextTick(function(){return _this2.$refs.timepicker.adjustSpinners();});},selectionMode:function selectionMode(newVal){if(newVal==='month'){/* istanbul ignore next */if(this.currentView!=='year'||this.currentView!=='month'){this.currentView='month';}}else if(newVal==='dates'){this.currentView='date';}}},methods:{proxyTimePickerDataProperties:function proxyTimePickerDataProperties(){var _this3=this;var format=function format(timeFormat){_this3.$refs.timepicker.format=timeFormat;};var value=function value(_value){_this3.$refs.timepicker.value=_value;};var date=function date(_date){_this3.$refs.timepicker.date=_date;};var selectableRange=function selectableRange(_selectableRange){_this3.$refs.timepicker.selectableRange=_selectableRange;};this.$watch('value',value);this.$watch('date',date);this.$watch('selectableRange',selectableRange);format(this.timeFormat);value(this.value);date(this.date);selectableRange(this.selectableRange);},handleClear:function handleClear(){this.date=this.getDefaultValue();this.$emit('pick',null);},emit:function emit(value){var _this4=this;for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}if(!value){this.$emit.apply(this,['pick',value].concat(args));}else if(Array.isArray(value)){var dates=value.map(function(date){return _this4.showTime?Object(date_util_["clearMilliseconds"])(date):Object(date_util_["clearTime"])(date);});this.$emit.apply(this,['pick',dates].concat(args));}else{this.$emit.apply(this,['pick',this.showTime?Object(date_util_["clearMilliseconds"])(value):Object(date_util_["clearTime"])(value)].concat(args));}this.userInputDate=null;this.userInputTime=null;},// resetDate() {
//   this.date = new Date(this.date);
// },
showMonthPicker:function showMonthPicker(){this.currentView='month';},showYearPicker:function showYearPicker(){this.currentView='year';},// XXX: 没用到
// handleLabelClick() {
//   if (this.currentView === 'date') {
//     this.showMonthPicker();
//   } else if (this.currentView === 'month') {
//     this.showYearPicker();
//   }
// },
prevMonth:function prevMonth(){this.date=Object(date_util_["prevMonth"])(this.date);},nextMonth:function nextMonth(){this.date=Object(date_util_["nextMonth"])(this.date);},prevYear:function prevYear(){if(this.currentView==='year'){this.date=Object(date_util_["prevYear"])(this.date,10);}else{this.date=Object(date_util_["prevYear"])(this.date);}},nextYear:function nextYear(){if(this.currentView==='year'){this.date=Object(date_util_["nextYear"])(this.date,10);}else{this.date=Object(date_util_["nextYear"])(this.date);}},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},handleTimePick:function handleTimePick(value,visible,first){if(Object(date_util_["isDate"])(value)){var newDate=this.value?Object(date_util_["modifyTime"])(this.value,value.getHours(),value.getMinutes(),value.getSeconds()):Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(),this.defaultTime);this.date=newDate;this.emit(this.date,true);}else{this.emit(value,true);}if(!first){this.timePickerVisible=visible;}},handleTimePickClose:function handleTimePickClose(){this.timePickerVisible=false;},handleMonthPick:function handleMonthPick(month){if(this.selectionMode==='month'){this.date=Object(date_util_["modifyDate"])(this.date,this.year,month,1);this.emit(this.date);}else{this.date=Object(date_util_["changeYearMonthAndClampDate"])(this.date,this.year,month);// TODO: should emit intermediate value ??
// this.emit(this.date);
this.currentView='date';}},handleDatePick:function handleDatePick(value){if(this.selectionMode==='day'){var newDate=this.value?Object(date_util_["modifyDate"])(this.value,value.getFullYear(),value.getMonth(),value.getDate()):Object(date_util_["modifyWithTimeString"])(value,this.defaultTime);// change default time while out of selectableRange
if(!this.checkDateWithinRange(newDate)){newDate=Object(date_util_["modifyDate"])(this.selectableRange[0][0],value.getFullYear(),value.getMonth(),value.getDate());}this.date=newDate;this.emit(this.date,this.showTime);}else if(this.selectionMode==='week'){this.emit(value.date);}else if(this.selectionMode==='dates'){this.emit(value,true);// set false to keep panel open
}},handleYearPick:function handleYearPick(year){if(this.selectionMode==='year'){this.date=Object(date_util_["modifyDate"])(this.date,year,0,1);this.emit(this.date);}else{this.date=Object(date_util_["changeYearMonthAndClampDate"])(this.date,year,this.month);// TODO: should emit intermediate value ??
// this.emit(this.date, true);
this.currentView='month';}},changeToNow:function changeToNow(){// NOTE: not a permanent solution
//       consider disable "now" button in the future
if((!this.disabledDate||!this.disabledDate(new Date()))&&this.checkDateWithinRange(new Date())){this.date=new Date();this.emit(this.date);}},confirm:function confirm(){if(this.selectionMode==='dates'){this.emit(this.value);}else{// value were emitted in handle{Date,Time}Pick, nothing to update here
// deal with the scenario where: user opens the picker, then confirm without doing anything
var value=this.value?this.value:Object(date_util_["modifyWithTimeString"])(this.getDefaultValue(),this.defaultTime);this.date=new Date(value);// refresh date
this.emit(value);}},resetView:function resetView(){if(this.selectionMode==='month'){this.currentView='month';}else if(this.selectionMode==='year'){this.currentView='year';}else{this.currentView='date';}},handleEnter:function handleEnter(){document.body.addEventListener('keydown',this.handleKeydown);},handleLeave:function handleLeave(){this.$emit('dodestroy');document.body.removeEventListener('keydown',this.handleKeydown);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var list=[38,40,37,39];if(this.visible&&!this.timePickerVisible){if(list.indexOf(keyCode)!==-1){this.handleKeyControl(keyCode);event.stopPropagation();event.preventDefault();}if(keyCode===13&&this.userInputDate===null&&this.userInputTime===null){// Enter
this.emit(this.date,false);}}},handleKeyControl:function handleKeyControl(keyCode){var mapping={'year':{38:-4,40:4,37:-1,39:1,offset:function offset(date,step){return date.setFullYear(date.getFullYear()+step);}},'month':{38:-4,40:4,37:-1,39:1,offset:function offset(date,step){return date.setMonth(date.getMonth()+step);}},'week':{38:-1,40:1,37:-1,39:1,offset:function offset(date,step){return date.setDate(date.getDate()+step*7);}},'day':{38:-7,40:7,37:-1,39:1,offset:function offset(date,step){return date.setDate(date.getDate()+step);}}};var mode=this.selectionMode;var year=3.1536e10;var now=this.date.getTime();var newDate=new Date(this.date.getTime());while(Math.abs(now-newDate.getTime())<=year){var map=mapping[mode];map.offset(newDate,map[keyCode]);if(typeof this.disabledDate==='function'&&this.disabledDate(newDate)){continue;}this.date=newDate;this.$emit('pick',newDate,true);break;}},handleVisibleTimeChange:function handleVisibleTimeChange(value){var time=Object(date_util_["parseDate"])(value,this.timeFormat);if(time&&this.checkDateWithinRange(time)){this.date=Object(date_util_["modifyDate"])(time,this.year,this.month,this.monthDate);this.userInputTime=null;this.$refs.timepicker.value=this.date;this.timePickerVisible=false;this.emit(this.date,true);}},handleVisibleDateChange:function handleVisibleDateChange(value){var date=Object(date_util_["parseDate"])(value,this.dateFormat);if(date){if(typeof this.disabledDate==='function'&&this.disabledDate(date)){return;}this.date=Object(date_util_["modifyTime"])(date,this.date.getHours(),this.date.getMinutes(),this.date.getSeconds());this.userInputDate=null;this.resetView();this.emit(this.date,true);}},isValidValue:function isValidValue(value){return value&&!isNaN(value)&&(typeof this.disabledDate==='function'?!this.disabledDate(value):true)&&this.checkDateWithinRange(value);},getDefaultValue:function getDefaultValue(){// if default-value is set, return it
// otherwise, return now (the moment this method gets called)
return this.defaultValue?new Date(this.defaultValue):new Date();},checkDateWithinRange:function checkDateWithinRange(date){return this.selectableRange.length>0?Object(date_util_["timeWithinRange"])(date,this.selectableRange,this.format||'HH:mm:ss'):true;}},components:{TimePicker:panel_time,YearTable:year_table,MonthTable:month_table,DateTable:date_table,ElInput:input_default.a,ElButton:button_default.a},data:function data(){return{popperClass:'',date:new Date(),value:'',defaultValue:null,// use getDefaultValue() for time computation
defaultTime:null,showTime:false,selectionMode:'day',shortcuts:'',visible:false,currentView:'date',disabledDate:'',cellClassName:'',selectableRange:[],firstDayOfWeek:7,showWeekNumber:false,timePickerVisible:false,format:'',arrowControl:false,userInputDate:null,userInputTime:null};},computed:{year:function year(){return this.date.getFullYear();},month:function month(){return this.date.getMonth();},week:function week(){return Object(date_util_["getWeekNumber"])(this.date);},monthDate:function monthDate(){return this.date.getDate();},footerVisible:function footerVisible(){return this.showTime||this.selectionMode==='dates';},visibleTime:function visibleTime(){if(this.userInputTime!==null){return this.userInputTime;}else{return Object(date_util_["formatDate"])(this.value||this.defaultValue,this.timeFormat);}},visibleDate:function visibleDate(){if(this.userInputDate!==null){return this.userInputDate;}else{return Object(date_util_["formatDate"])(this.value||this.defaultValue,this.dateFormat);}},yearLabel:function yearLabel(){var yearTranslation=this.t('el.datepicker.year');if(this.currentView==='year'){var startYear=Math.floor(this.year/10)*10;if(yearTranslation){return startYear+' '+yearTranslation+' - '+(startYear+9)+' '+yearTranslation;}return startYear+' - '+(startYear+9);}return this.year+' '+yearTranslation;},timeFormat:function timeFormat(){if(this.format){return Object(date_util_["extractTimeFormat"])(this.format);}else{return'HH:mm:ss';}},dateFormat:function dateFormat(){if(this.format){return Object(date_util_["extractDateFormat"])(this.format);}else{return'yyyy-MM-dd';}}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue?vue&type=script&lang=js&
/* harmony default export */var panel_datevue_type_script_lang_js_=datevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date.vue
/* normalize component */var date_component=normalizeComponent(panel_datevue_type_script_lang_js_,datevue_type_template_id_2440d4ea_render,datevue_type_template_id_2440d4ea_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_api;}date_component.options.__file="packages/date-picker/src/panel/date.vue";/* harmony default export */var panel_date=date_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
var date_rangevue_type_template_id_2652849a_render=function date_rangevue_type_template_id_2652849a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts,"has-time":_vm.showTime},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_vm.showTime?_c("div",{staticClass:"el-date-range-picker__time-header"},[_c("span",{staticClass:"el-date-range-picker__editors-wrap"},[_c("span",{staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{ref:"minInput",staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.startDate"),value:_vm.minVisibleDate},on:{input:function input(val){return _vm.handleDateInput(val,"min");},change:function change(val){return _vm.handleDateChange(val,"min");}}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleMinTimeClose,expression:"handleMinTimeClose"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.startTime"),value:_vm.minVisibleTime},on:{focus:function focus($event){_vm.minTimePickerVisible=true;},input:function input(val){return _vm.handleTimeInput(val,"min");},change:function change(val){return _vm.handleTimeChange(val,"min");}}}),_c("time-picker",{ref:"minTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.minTimePickerVisible},on:{pick:_vm.handleMinTimePick,mounted:function mounted($event){_vm.$refs.minTimePicker.format=_vm.timeFormat;}}})],1)]),_c("span",{staticClass:"el-icon-arrow-right"}),_c("span",{staticClass:"el-date-range-picker__editors-wrap is-right"},[_c("span",{staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.endDate"),value:_vm.maxVisibleDate,readonly:!_vm.minDate},on:{input:function input(val){return _vm.handleDateInput(val,"max");},change:function change(val){return _vm.handleDateChange(val,"max");}}})],1),_c("span",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.handleMaxTimeClose,expression:"handleMaxTimeClose"}],staticClass:"el-date-range-picker__time-picker-wrap"},[_c("el-input",{staticClass:"el-date-range-picker__editor",attrs:{size:"small",disabled:_vm.rangeState.selecting,placeholder:_vm.t("el.datepicker.endTime"),value:_vm.maxVisibleTime,readonly:!_vm.minDate},on:{focus:function focus($event){_vm.minDate&&(_vm.maxTimePickerVisible=true);},input:function input(val){return _vm.handleTimeInput(val,"max");},change:function change(val){return _vm.handleTimeChange(val,"max");}}}),_c("time-picker",{ref:"maxTimePicker",attrs:{"time-arrow-control":_vm.arrowControl,visible:_vm.maxTimePickerVisible},on:{pick:_vm.handleMaxTimePick,mounted:function mounted($event){_vm.$refs.maxTimePicker.format=_vm.timeFormat;}}})],1)])]):_vm._e(),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c("div",{staticClass:"el-date-range-picker__header"},[_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevYear}}),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevMonth}}),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.leftNextYear}}):_vm._e(),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",class:{"is-disabled":!_vm.enableMonthArrow},attrs:{type:"button",disabled:!_vm.enableMonthArrow},on:{click:_vm.leftNextMonth}}):_vm._e(),_c("div",[_vm._v(_vm._s(_vm.leftLabel))])]),_c("date-table",{attrs:{"selection-mode":"range",date:_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"cell-class-name":_vm.cellClassName,"first-day-of-week":_vm.firstDayOfWeek},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c("div",{staticClass:"el-date-range-picker__header"},[_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.rightPrevYear}}):_vm._e(),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-left",class:{"is-disabled":!_vm.enableMonthArrow},attrs:{type:"button",disabled:!_vm.enableMonthArrow},on:{click:_vm.rightPrevMonth}}):_vm._e(),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextYear}}),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextMonth}}),_c("div",[_vm._v(_vm._s(_vm.rightLabel))])]),_c("date-table",{attrs:{"selection-mode":"range",date:_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate,"cell-class-name":_vm.cellClassName,"first-day-of-week":_vm.firstDayOfWeek},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1)])],2),_vm.showTime?_c("div",{staticClass:"el-picker-panel__footer"},[_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{size:"mini",type:"text"},on:{click:_vm.handleClear}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.clear"))+"\n      ")]),_c("el-button",{staticClass:"el-picker-panel__link-btn",attrs:{plain:"",size:"mini",disabled:_vm.btnDisabled},on:{click:function click($event){_vm.handleConfirm(false);}}},[_vm._v("\n        "+_vm._s(_vm.t("el.datepicker.confirm"))+"\n      ")])],1):_vm._e()])]);};var date_rangevue_type_template_id_2652849a_staticRenderFns=[];date_rangevue_type_template_id_2652849a_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=template&id=2652849a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var date_rangevue_type_script_lang_js_calcDefaultValue=function calcDefaultValue(defaultValue){if(Array.isArray(defaultValue)){return[new Date(defaultValue[0]),new Date(defaultValue[1])];}else if(defaultValue){return[new Date(defaultValue),Object(date_util_["nextDate"])(new Date(defaultValue),1)];}else{return[new Date(),Object(date_util_["nextDate"])(new Date(),1)];}};/* harmony default export */var date_rangevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},computed:{btnDisabled:function btnDisabled(){return!(this.minDate&&this.maxDate&&!this.selecting&&this.isValidValue([this.minDate,this.maxDate]));},leftLabel:function leftLabel(){return this.leftDate.getFullYear()+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+(this.leftDate.getMonth()+1));},rightLabel:function rightLabel(){return this.rightDate.getFullYear()+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+(this.rightDate.getMonth()+1));},leftYear:function leftYear(){return this.leftDate.getFullYear();},leftMonth:function leftMonth(){return this.leftDate.getMonth();},leftMonthDate:function leftMonthDate(){return this.leftDate.getDate();},rightYear:function rightYear(){return this.rightDate.getFullYear();},rightMonth:function rightMonth(){return this.rightDate.getMonth();},rightMonthDate:function rightMonthDate(){return this.rightDate.getDate();},minVisibleDate:function minVisibleDate(){if(this.dateUserInput.min!==null)return this.dateUserInput.min;if(this.minDate)return Object(date_util_["formatDate"])(this.minDate,this.dateFormat);return'';},maxVisibleDate:function maxVisibleDate(){if(this.dateUserInput.max!==null)return this.dateUserInput.max;if(this.maxDate||this.minDate)return Object(date_util_["formatDate"])(this.maxDate||this.minDate,this.dateFormat);return'';},minVisibleTime:function minVisibleTime(){if(this.timeUserInput.min!==null)return this.timeUserInput.min;if(this.minDate)return Object(date_util_["formatDate"])(this.minDate,this.timeFormat);return'';},maxVisibleTime:function maxVisibleTime(){if(this.timeUserInput.max!==null)return this.timeUserInput.max;if(this.maxDate||this.minDate)return Object(date_util_["formatDate"])(this.maxDate||this.minDate,this.timeFormat);return'';},timeFormat:function timeFormat(){if(this.format){return Object(date_util_["extractTimeFormat"])(this.format);}else{return'HH:mm:ss';}},dateFormat:function dateFormat(){if(this.format){return Object(date_util_["extractDateFormat"])(this.format);}else{return'yyyy-MM-dd';}},enableMonthArrow:function enableMonthArrow(){var nextMonth=(this.leftMonth+1)%12;var yearOffset=this.leftMonth+1>=12?1:0;return this.unlinkPanels&&new Date(this.leftYear+yearOffset,nextMonth)<new Date(this.rightYear,this.rightMonth);},enableYearArrow:function enableYearArrow(){return this.unlinkPanels&&this.rightYear*12+this.rightMonth-(this.leftYear*12+this.leftMonth+1)>=12;}},data:function data(){return{popperClass:'',value:[],defaultValue:null,defaultTime:null,minDate:'',maxDate:'',leftDate:new Date(),rightDate:Object(date_util_["nextMonth"])(new Date()),rangeState:{endDate:null,selecting:false,row:null,column:null},showTime:false,shortcuts:'',visible:'',disabledDate:'',cellClassName:'',firstDayOfWeek:7,minTimePickerVisible:false,maxTimePickerVisible:false,format:'',arrowControl:false,unlinkPanels:false,dateUserInput:{min:null,max:null},timeUserInput:{min:null,max:null}};},watch:{minDate:function minDate(val){var _this=this;this.dateUserInput.min=null;this.timeUserInput.min=null;this.$nextTick(function(){if(_this.$refs.maxTimePicker&&_this.maxDate&&_this.maxDate<_this.minDate){var format='HH:mm:ss';_this.$refs.maxTimePicker.selectableRange=[[Object(date_util_["parseDate"])(Object(date_util_["formatDate"])(_this.minDate,format),format),Object(date_util_["parseDate"])('23:59:59',format)]];}});if(val&&this.$refs.minTimePicker){this.$refs.minTimePicker.date=val;this.$refs.minTimePicker.value=val;}},maxDate:function maxDate(val){this.dateUserInput.max=null;this.timeUserInput.max=null;if(val&&this.$refs.maxTimePicker){this.$refs.maxTimePicker.date=val;this.$refs.maxTimePicker.value=val;}},minTimePickerVisible:function minTimePickerVisible(val){var _this2=this;if(val){this.$nextTick(function(){_this2.$refs.minTimePicker.date=_this2.minDate;_this2.$refs.minTimePicker.value=_this2.minDate;_this2.$refs.minTimePicker.adjustSpinners();});}},maxTimePickerVisible:function maxTimePickerVisible(val){var _this3=this;if(val){this.$nextTick(function(){_this3.$refs.maxTimePicker.date=_this3.maxDate;_this3.$refs.maxTimePicker.value=_this3.maxDate;_this3.$refs.maxTimePicker.adjustSpinners();});}},value:function value(newVal){if(!newVal){this.minDate=null;this.maxDate=null;}else if(Array.isArray(newVal)){this.minDate=Object(date_util_["isDate"])(newVal[0])?new Date(newVal[0]):null;this.maxDate=Object(date_util_["isDate"])(newVal[1])?new Date(newVal[1]):null;if(this.minDate){this.leftDate=this.minDate;if(this.unlinkPanels&&this.maxDate){var minDateYear=this.minDate.getFullYear();var minDateMonth=this.minDate.getMonth();var maxDateYear=this.maxDate.getFullYear();var maxDateMonth=this.maxDate.getMonth();this.rightDate=minDateYear===maxDateYear&&minDateMonth===maxDateMonth?Object(date_util_["nextMonth"])(this.maxDate):this.maxDate;}else{this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}else{this.leftDate=date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}},defaultValue:function defaultValue(val){if(!Array.isArray(this.value)){var _calcDefaultValue=date_rangevue_type_script_lang_js_calcDefaultValue(val),left=_calcDefaultValue[0],right=_calcDefaultValue[1];this.leftDate=left;this.rightDate=val&&val[1]&&this.unlinkPanels?right:Object(date_util_["nextMonth"])(this.leftDate);}}},methods:{handleClear:function handleClear(){this.minDate=null;this.maxDate=null;this.leftDate=date_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);this.$emit('pick',null);},handleChangeRange:function handleChangeRange(val){this.minDate=val.minDate;this.maxDate=val.maxDate;this.rangeState=val.rangeState;},handleDateInput:function handleDateInput(value,type){this.dateUserInput[type]=value;if(value.length!==this.dateFormat.length)return;var parsedValue=Object(date_util_["parseDate"])(value,this.dateFormat);if(parsedValue){if(typeof this.disabledDate==='function'&&this.disabledDate(new Date(parsedValue))){return;}if(type==='min'){this.minDate=Object(date_util_["modifyDate"])(this.minDate||new Date(),parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());this.leftDate=new Date(parsedValue);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}}else{this.maxDate=Object(date_util_["modifyDate"])(this.maxDate||new Date(),parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());this.rightDate=new Date(parsedValue);if(!this.unlinkPanels){this.leftDate=Object(date_util_["prevMonth"])(parsedValue);}}}},handleDateChange:function handleDateChange(value,type){var parsedValue=Object(date_util_["parseDate"])(value,this.dateFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyDate"])(this.minDate,parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());if(this.minDate>this.maxDate){this.maxDate=this.minDate;}}else{this.maxDate=Object(date_util_["modifyDate"])(this.maxDate,parsedValue.getFullYear(),parsedValue.getMonth(),parsedValue.getDate());if(this.maxDate<this.minDate){this.minDate=this.maxDate;}}}},handleTimeInput:function handleTimeInput(value,type){var _this4=this;this.timeUserInput[type]=value;if(value.length!==this.timeFormat.length)return;var parsedValue=Object(date_util_["parseDate"])(value,this.timeFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyTime"])(this.minDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());this.$nextTick(function(_){return _this4.$refs.minTimePicker.adjustSpinners();});}else{this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());this.$nextTick(function(_){return _this4.$refs.maxTimePicker.adjustSpinners();});}}},handleTimeChange:function handleTimeChange(value,type){var parsedValue=Object(date_util_["parseDate"])(value,this.timeFormat);if(parsedValue){if(type==='min'){this.minDate=Object(date_util_["modifyTime"])(this.minDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());if(this.minDate>this.maxDate){this.maxDate=this.minDate;}this.$refs.minTimePicker.value=this.minDate;this.minTimePickerVisible=false;}else{this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,parsedValue.getHours(),parsedValue.getMinutes(),parsedValue.getSeconds());if(this.maxDate<this.minDate){this.minDate=this.maxDate;}this.$refs.maxTimePicker.value=this.minDate;this.maxTimePickerVisible=false;}}},handleRangePick:function handleRangePick(val){var _this5=this;var close=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var defaultTime=this.defaultTime||[];var minDate=Object(date_util_["modifyWithTimeString"])(val.minDate,defaultTime[0]);var maxDate=Object(date_util_["modifyWithTimeString"])(val.maxDate,defaultTime[1]);if(this.maxDate===maxDate&&this.minDate===minDate){return;}this.onPick&&this.onPick(val);this.maxDate=maxDate;this.minDate=minDate;// workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
setTimeout(function(){_this5.maxDate=maxDate;_this5.minDate=minDate;},10);if(!close||this.showTime)return;this.handleConfirm();},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},handleMinTimePick:function handleMinTimePick(value,visible,first){this.minDate=this.minDate||new Date();if(value){this.minDate=Object(date_util_["modifyTime"])(this.minDate,value.getHours(),value.getMinutes(),value.getSeconds());}if(!first){this.minTimePickerVisible=visible;}if(!this.maxDate||this.maxDate&&this.maxDate.getTime()<this.minDate.getTime()){this.maxDate=new Date(this.minDate);}},handleMinTimeClose:function handleMinTimeClose(){this.minTimePickerVisible=false;},handleMaxTimePick:function handleMaxTimePick(value,visible,first){if(this.maxDate&&value){this.maxDate=Object(date_util_["modifyTime"])(this.maxDate,value.getHours(),value.getMinutes(),value.getSeconds());}if(!first){this.maxTimePickerVisible=visible;}if(this.maxDate&&this.minDate&&this.minDate.getTime()>this.maxDate.getTime()){this.minDate=new Date(this.maxDate);}},handleMaxTimeClose:function handleMaxTimeClose(){this.maxTimePickerVisible=false;},// leftPrev*, rightNext* need to take care of `unlinkPanels`
leftPrevYear:function leftPrevYear(){this.leftDate=Object(date_util_["prevYear"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}},leftPrevMonth:function leftPrevMonth(){this.leftDate=Object(date_util_["prevMonth"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}},rightNextYear:function rightNextYear(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}else{this.rightDate=Object(date_util_["nextYear"])(this.rightDate);}},rightNextMonth:function rightNextMonth(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextMonth"])(this.leftDate);this.rightDate=Object(date_util_["nextMonth"])(this.leftDate);}else{this.rightDate=Object(date_util_["nextMonth"])(this.rightDate);}},// leftNext*, rightPrev* are called when `unlinkPanels` is true
leftNextYear:function leftNextYear(){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);},leftNextMonth:function leftNextMonth(){this.leftDate=Object(date_util_["nextMonth"])(this.leftDate);},rightPrevYear:function rightPrevYear(){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);},rightPrevMonth:function rightPrevMonth(){this.rightDate=Object(date_util_["prevMonth"])(this.rightDate);},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.isValidValue([this.minDate,this.maxDate])){this.$emit('pick',[this.minDate,this.maxDate],visible);}},isValidValue:function isValidValue(value){return Array.isArray(value)&&value&&value[0]&&value[1]&&Object(date_util_["isDate"])(value[0])&&Object(date_util_["isDate"])(value[1])&&value[0].getTime()<=value[1].getTime()&&(typeof this.disabledDate==='function'?!this.disabledDate(value[0])&&!this.disabledDate(value[1]):true);},resetView:function resetView(){// NOTE: this is a hack to reset {min, max}Date on picker open.
// TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
//       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
if(this.minDate&&this.maxDate==null)this.rangeState.selecting=false;this.minDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[0]):null;this.maxDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[1]):null;}},components:{TimePicker:panel_time,DateTable:date_table,ElInput:input_default.a,ElButton:button_default.a}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_date_rangevue_type_script_lang_js_=date_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/date-range.vue
/* normalize component */var date_range_component=normalizeComponent(panel_date_rangevue_type_script_lang_js_,date_rangevue_type_template_id_2652849a_render,date_rangevue_type_template_id_2652849a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var date_range_api;}date_range_component.options.__file="packages/date-picker/src/panel/date-range.vue";/* harmony default export */var date_range=date_range_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
var month_rangevue_type_template_id_f2645fb8_render=function month_rangevue_type_template_id_f2645fb8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-picker-panel el-date-range-picker el-popper",class:[{"has-sidebar":_vm.$slots.sidebar||_vm.shortcuts},_vm.popperClass]},[_c("div",{staticClass:"el-picker-panel__body-wrapper"},[_vm._t("sidebar"),_vm.shortcuts?_c("div",{staticClass:"el-picker-panel__sidebar"},_vm._l(_vm.shortcuts,function(shortcut,key){return _c("button",{key:key,staticClass:"el-picker-panel__shortcut",attrs:{type:"button"},on:{click:function click($event){_vm.handleShortcutClick(shortcut);}}},[_vm._v(_vm._s(shortcut.text))]);}),0):_vm._e(),_c("div",{staticClass:"el-picker-panel__body"},[_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-left"},[_c("div",{staticClass:"el-date-range-picker__header"},[_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",attrs:{type:"button"},on:{click:_vm.leftPrevYear}}),_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.leftNextYear}}):_vm._e(),_c("div",[_vm._v(_vm._s(_vm.leftLabel))])]),_c("month-table",{attrs:{"selection-mode":"range",date:_vm.leftDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1),_c("div",{staticClass:"el-picker-panel__content el-date-range-picker__content is-right"},[_c("div",{staticClass:"el-date-range-picker__header"},[_vm.unlinkPanels?_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-left",class:{"is-disabled":!_vm.enableYearArrow},attrs:{type:"button",disabled:!_vm.enableYearArrow},on:{click:_vm.rightPrevYear}}):_vm._e(),_c("button",{staticClass:"el-picker-panel__icon-btn el-icon-d-arrow-right",attrs:{type:"button"},on:{click:_vm.rightNextYear}}),_c("div",[_vm._v(_vm._s(_vm.rightLabel))])]),_c("month-table",{attrs:{"selection-mode":"range",date:_vm.rightDate,"default-value":_vm.defaultValue,"min-date":_vm.minDate,"max-date":_vm.maxDate,"range-state":_vm.rangeState,"disabled-date":_vm.disabledDate},on:{changerange:_vm.handleChangeRange,pick:_vm.handleRangePick}})],1)])],2)])]);};var month_rangevue_type_template_id_f2645fb8_staticRenderFns=[];month_rangevue_type_template_id_f2645fb8_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=template&id=f2645fb8&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var month_rangevue_type_script_lang_js_calcDefaultValue=function calcDefaultValue(defaultValue){if(Array.isArray(defaultValue)){return[new Date(defaultValue[0]),new Date(defaultValue[1])];}else if(defaultValue){return[new Date(defaultValue),Object(date_util_["nextMonth"])(new Date(defaultValue))];}else{return[new Date(),Object(date_util_["nextMonth"])(new Date())];}};/* harmony default export */var month_rangevue_type_script_lang_js_={mixins:[locale_default.a],directives:{Clickoutside:clickoutside_default.a},computed:{btnDisabled:function btnDisabled(){return!(this.minDate&&this.maxDate&&!this.selecting&&this.isValidValue([this.minDate,this.maxDate]));},leftLabel:function leftLabel(){return this.leftDate.getFullYear()+' '+this.t('el.datepicker.year');},rightLabel:function rightLabel(){return this.rightDate.getFullYear()+' '+this.t('el.datepicker.year');},leftYear:function leftYear(){return this.leftDate.getFullYear();},rightYear:function rightYear(){return this.rightDate.getFullYear()===this.leftDate.getFullYear()?this.leftDate.getFullYear()+1:this.rightDate.getFullYear();},enableYearArrow:function enableYearArrow(){return this.unlinkPanels&&this.rightYear>this.leftYear+1;}},data:function data(){return{popperClass:'',value:[],defaultValue:null,defaultTime:null,minDate:'',maxDate:'',leftDate:new Date(),rightDate:Object(date_util_["nextYear"])(new Date()),rangeState:{endDate:null,selecting:false,row:null,column:null},shortcuts:'',visible:'',disabledDate:'',format:'',arrowControl:false,unlinkPanels:false};},watch:{value:function value(newVal){if(!newVal){this.minDate=null;this.maxDate=null;}else if(Array.isArray(newVal)){this.minDate=Object(date_util_["isDate"])(newVal[0])?new Date(newVal[0]):null;this.maxDate=Object(date_util_["isDate"])(newVal[1])?new Date(newVal[1]):null;if(this.minDate){this.leftDate=this.minDate;if(this.unlinkPanels&&this.maxDate){var minDateYear=this.minDate.getFullYear();var maxDateYear=this.maxDate.getFullYear();this.rightDate=minDateYear===maxDateYear?Object(date_util_["nextYear"])(this.maxDate):this.maxDate;}else{this.rightDate=Object(date_util_["nextYear"])(this.leftDate);}}else{this.leftDate=month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextYear"])(this.leftDate);}}},defaultValue:function defaultValue(val){if(!Array.isArray(this.value)){var _calcDefaultValue=month_rangevue_type_script_lang_js_calcDefaultValue(val),left=_calcDefaultValue[0],right=_calcDefaultValue[1];this.leftDate=left;this.rightDate=val&&val[1]&&left.getFullYear()!==right.getFullYear()&&this.unlinkPanels?right:Object(date_util_["nextYear"])(this.leftDate);}}},methods:{handleClear:function handleClear(){this.minDate=null;this.maxDate=null;this.leftDate=month_rangevue_type_script_lang_js_calcDefaultValue(this.defaultValue)[0];this.rightDate=Object(date_util_["nextYear"])(this.leftDate);this.$emit('pick',null);},handleChangeRange:function handleChangeRange(val){this.minDate=val.minDate;this.maxDate=val.maxDate;this.rangeState=val.rangeState;},handleRangePick:function handleRangePick(val){var _this=this;var close=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var defaultTime=this.defaultTime||[];var minDate=Object(date_util_["modifyWithTimeString"])(val.minDate,defaultTime[0]);var maxDate=Object(date_util_["modifyWithTimeString"])(val.maxDate,defaultTime[1]);if(this.maxDate===maxDate&&this.minDate===minDate){return;}this.onPick&&this.onPick(val);this.maxDate=maxDate;this.minDate=minDate;// workaround for https://github.com/ElemeFE/element/issues/7539, should remove this block when we don't have to care about Chromium 55 - 57
setTimeout(function(){_this.maxDate=maxDate;_this.minDate=minDate;},10);if(!close)return;this.handleConfirm();},handleShortcutClick:function handleShortcutClick(shortcut){if(shortcut.onClick){shortcut.onClick(this);}},// leftPrev*, rightNext* need to take care of `unlinkPanels`
leftPrevYear:function leftPrevYear(){this.leftDate=Object(date_util_["prevYear"])(this.leftDate);if(!this.unlinkPanels){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);}},rightNextYear:function rightNextYear(){if(!this.unlinkPanels){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);}this.rightDate=Object(date_util_["nextYear"])(this.rightDate);},// leftNext*, rightPrev* are called when `unlinkPanels` is true
leftNextYear:function leftNextYear(){this.leftDate=Object(date_util_["nextYear"])(this.leftDate);},rightPrevYear:function rightPrevYear(){this.rightDate=Object(date_util_["prevYear"])(this.rightDate);},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.isValidValue([this.minDate,this.maxDate])){this.$emit('pick',[this.minDate,this.maxDate],visible);}},isValidValue:function isValidValue(value){return Array.isArray(value)&&value&&value[0]&&value[1]&&Object(date_util_["isDate"])(value[0])&&Object(date_util_["isDate"])(value[1])&&value[0].getTime()<=value[1].getTime()&&(typeof this.disabledDate==='function'?!this.disabledDate(value[0])&&!this.disabledDate(value[1]):true);},resetView:function resetView(){// NOTE: this is a hack to reset {min, max}Date on picker open.
// TODO: correct way of doing so is to refactor {min, max}Date to be dependent on value and internal selection state
//       an alternative would be resetView whenever picker becomes visible, should also investigate date-panel's resetView
this.minDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[0]):null;this.maxDate=this.value&&Object(date_util_["isDate"])(this.value[0])?new Date(this.value[1]):null;}},components:{MonthTable:month_table,ElInput:input_default.a,ElButton:button_default.a}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_month_rangevue_type_script_lang_js_=month_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/month-range.vue
/* normalize component */var month_range_component=normalizeComponent(panel_month_rangevue_type_script_lang_js_,month_rangevue_type_template_id_f2645fb8_render,month_rangevue_type_template_id_f2645fb8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var month_range_api;}month_range_component.options.__file="packages/date-picker/src/panel/month-range.vue";/* harmony default export */var month_range=month_range_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/date-picker.js
var date_picker_getPanel=function getPanel(type){if(type==='daterange'||type==='datetimerange'){return date_range;}else if(type==='monthrange'){return month_range;}return panel_date;};/* harmony default export */var date_picker={mixins:[picker],name:'ElDatePicker',props:{type:{type:String,default:'date'},timeArrowControl:Boolean},watch:{type:function type(_type){if(this.picker){this.unmountPicker();this.panel=date_picker_getPanel(_type);this.mountPicker();}else{this.panel=date_picker_getPanel(_type);}}},created:function created(){this.panel=date_picker_getPanel(this.type);}};// CONCATENATED MODULE: ./packages/date-picker/index.js
/* istanbul ignore next */date_picker.install=function install(Vue){Vue.component(date_picker.name,date_picker);};/* harmony default export */var packages_date_picker=date_picker;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
var time_selectvue_type_template_id_51ab9320_render=function time_selectvue_type_template_id_51ab9320_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"before-enter":_vm.handleMenuEnter,"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],ref:"popper",staticClass:"el-picker-panel time-select el-popper",class:_vm.popperClass,style:{width:_vm.width+"px"}},[_c("el-scrollbar",{attrs:{noresize:"","wrap-class":"el-picker-panel__content"}},_vm._l(_vm.items,function(item){return _c("div",{key:item.value,staticClass:"time-select-item",class:{selected:_vm.value===item.value,disabled:item.disabled,default:item.value===_vm.defaultValue},attrs:{disabled:item.disabled},on:{click:function click($event){_vm.handleClick(item);}}},[_vm._v(_vm._s(item.value))]);}),0)],1)]);};var time_selectvue_type_template_id_51ab9320_staticRenderFns=[];time_selectvue_type_template_id_51ab9320_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=template&id=51ab9320&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var parseTime=function parseTime(time){var values=(time||'').split(':');if(values.length>=2){var hours=parseInt(values[0],10);var minutes=parseInt(values[1],10);return{hours:hours,minutes:minutes};}/* istanbul ignore next */return null;};var compareTime=function compareTime(time1,time2){var value1=parseTime(time1);var value2=parseTime(time2);var minutes1=value1.minutes+value1.hours*60;var minutes2=value2.minutes+value2.hours*60;if(minutes1===minutes2){return 0;}return minutes1>minutes2?1:-1;};var formatTime=function formatTime(time){return(time.hours<10?'0'+time.hours:time.hours)+':'+(time.minutes<10?'0'+time.minutes:time.minutes);};var nextTime=function nextTime(time,step){var timeValue=parseTime(time);var stepValue=parseTime(step);var next={hours:timeValue.hours,minutes:timeValue.minutes};next.minutes+=stepValue.minutes;next.hours+=stepValue.hours;next.hours+=Math.floor(next.minutes/60);next.minutes=next.minutes%60;return formatTime(next);};/* harmony default export */var time_selectvue_type_script_lang_js_={components:{ElScrollbar:scrollbar_default.a},watch:{value:function value(val){var _this=this;if(!val)return;this.$nextTick(function(){return _this.scrollToOption();});}},methods:{handleClick:function handleClick(item){if(!item.disabled){this.$emit('pick',item.value);}},handleClear:function handleClear(){this.$emit('pick',null);},scrollToOption:function scrollToOption(){var selector=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'.selected';var menu=this.$refs.popper.querySelector('.el-picker-panel__content');scroll_into_view_default()(menu,menu.querySelector(selector));},handleMenuEnter:function handleMenuEnter(){var _this2=this;var selected=this.items.map(function(item){return item.value;}).indexOf(this.value)!==-1;var hasDefault=this.items.map(function(item){return item.value;}).indexOf(this.defaultValue)!==-1;var option=selected&&'.selected'||hasDefault&&'.default'||'.time-select-item:not(.disabled)';this.$nextTick(function(){return _this2.scrollToOption(option);});},scrollDown:function scrollDown(step){var items=this.items;var length=items.length;var total=items.length;var index=items.map(function(item){return item.value;}).indexOf(this.value);while(total--){index=(index+step+length)%length;if(!items[index].disabled){this.$emit('pick',items[index].value,true);return;}}},isValidValue:function isValidValue(date){return this.items.filter(function(item){return!item.disabled;}).map(function(item){return item.value;}).indexOf(date)!==-1;},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;if(keyCode===38||keyCode===40){var mapping={40:1,38:-1};var offset=mapping[keyCode.toString()];this.scrollDown(offset);event.stopPropagation();return;}}},data:function data(){return{popperClass:'',start:'09:00',end:'18:00',step:'00:30',value:'',defaultValue:'',visible:false,minTime:'',maxTime:'',width:0};},computed:{items:function items(){var start=this.start;var end=this.end;var step=this.step;var result=[];if(start&&end&&step){var current=start;while(compareTime(current,end)<=0){result.push({value:current,disabled:compareTime(current,this.minTime||'-1:-1')<=0||compareTime(current,this.maxTime||'100:100')>=0});current=nextTime(current,step);}}return result;}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue?vue&type=script&lang=js&
/* harmony default export */var panel_time_selectvue_type_script_lang_js_=time_selectvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-select.vue
/* normalize component */var time_select_component=normalizeComponent(panel_time_selectvue_type_script_lang_js_,time_selectvue_type_template_id_51ab9320_render,time_selectvue_type_template_id_51ab9320_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_select_api;}time_select_component.options.__file="packages/date-picker/src/panel/time-select.vue";/* harmony default export */var time_select=time_select_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-select.js
/* harmony default export */var picker_time_select={mixins:[picker],name:'ElTimeSelect',componentName:'ElTimeSelect',props:{type:{type:String,default:'time-select'}},beforeCreate:function beforeCreate(){this.panel=time_select;}};// CONCATENATED MODULE: ./packages/time-select/index.js
/* istanbul ignore next */picker_time_select.install=function(Vue){Vue.component(picker_time_select.name,picker_time_select);};/* harmony default export */var packages_time_select=picker_time_select;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
var time_rangevue_type_template_id_fb28660e_render=function time_rangevue_type_template_id_fb28660e_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":function afterLeave($event){_vm.$emit("dodestroy");}}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-time-range-picker el-picker-panel el-popper",class:_vm.popperClass},[_c("div",{staticClass:"el-time-range-picker__content"},[_c("div",{staticClass:"el-time-range-picker__cell"},[_c("div",{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t("el.datepicker.startTime")))]),_c("div",{staticClass:"el-time-range-picker__body el-time-panel__content",class:{"has-seconds":_vm.showSeconds,"is-arrow":_vm.arrowControl}},[_c("time-spinner",{ref:"minSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,date:_vm.minDate},on:{change:_vm.handleMinChange,"select-range":_vm.setMinSelectionRange}})],1)]),_c("div",{staticClass:"el-time-range-picker__cell"},[_c("div",{staticClass:"el-time-range-picker__header"},[_vm._v(_vm._s(_vm.t("el.datepicker.endTime")))]),_c("div",{staticClass:"el-time-range-picker__body el-time-panel__content",class:{"has-seconds":_vm.showSeconds,"is-arrow":_vm.arrowControl}},[_c("time-spinner",{ref:"maxSpinner",attrs:{"show-seconds":_vm.showSeconds,"am-pm-mode":_vm.amPmMode,"arrow-control":_vm.arrowControl,date:_vm.maxDate},on:{change:_vm.handleMaxChange,"select-range":_vm.setMaxSelectionRange}})],1)])]),_c("div",{staticClass:"el-time-panel__footer"},[_c("button",{staticClass:"el-time-panel__btn cancel",attrs:{type:"button"},on:{click:function click($event){_vm.handleCancel();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.cancel")))]),_c("button",{staticClass:"el-time-panel__btn confirm",attrs:{type:"button",disabled:_vm.btnDisabled},on:{click:function click($event){_vm.handleConfirm();}}},[_vm._v(_vm._s(_vm.t("el.datepicker.confirm")))])])])]);};var time_rangevue_type_template_id_fb28660e_staticRenderFns=[];time_rangevue_type_template_id_fb28660e_render._withStripped=true;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=template&id=fb28660e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MIN_TIME=Object(date_util_["parseDate"])('00:00:00','HH:mm:ss');var MAX_TIME=Object(date_util_["parseDate"])('23:59:59','HH:mm:ss');var time_rangevue_type_script_lang_js_minTimeOfDay=function minTimeOfDay(date){return Object(date_util_["modifyDate"])(MIN_TIME,date.getFullYear(),date.getMonth(),date.getDate());};var time_rangevue_type_script_lang_js_maxTimeOfDay=function maxTimeOfDay(date){return Object(date_util_["modifyDate"])(MAX_TIME,date.getFullYear(),date.getMonth(),date.getDate());};// increase time by amount of milliseconds, but within the range of day
var advanceTime=function advanceTime(date,amount){return new Date(Math.min(date.getTime()+amount,time_rangevue_type_script_lang_js_maxTimeOfDay(date).getTime()));};/* harmony default export */var time_rangevue_type_script_lang_js_={mixins:[locale_default.a],components:{TimeSpinner:time_spinner},computed:{showSeconds:function showSeconds(){return(this.format||'').indexOf('ss')!==-1;},offset:function offset(){return this.showSeconds?11:8;},spinner:function spinner(){return this.selectionRange[0]<this.offset?this.$refs.minSpinner:this.$refs.maxSpinner;},btnDisabled:function btnDisabled(){return this.minDate.getTime()>this.maxDate.getTime();},amPmMode:function amPmMode(){if((this.format||'').indexOf('A')!==-1)return'A';if((this.format||'').indexOf('a')!==-1)return'a';return'';}},data:function data(){return{popperClass:'',minDate:new Date(),maxDate:new Date(),value:[],oldValue:[new Date(),new Date()],defaultValue:null,format:'HH:mm:ss',visible:false,selectionRange:[0,2],arrowControl:false};},watch:{value:function value(_value){if(Array.isArray(_value)){this.minDate=new Date(_value[0]);this.maxDate=new Date(_value[1]);}else{if(Array.isArray(this.defaultValue)){this.minDate=new Date(this.defaultValue[0]);this.maxDate=new Date(this.defaultValue[1]);}else if(this.defaultValue){this.minDate=new Date(this.defaultValue);this.maxDate=advanceTime(new Date(this.defaultValue),60*60*1000);}else{this.minDate=new Date();this.maxDate=advanceTime(new Date(),60*60*1000);}}},visible:function visible(val){var _this=this;if(val){this.oldValue=this.value;this.$nextTick(function(){return _this.$refs.minSpinner.emitSelectRange('hours');});}}},methods:{handleClear:function handleClear(){this.$emit('pick',null);},handleCancel:function handleCancel(){this.$emit('pick',this.oldValue);},handleMinChange:function handleMinChange(date){this.minDate=Object(date_util_["clearMilliseconds"])(date);this.handleChange();},handleMaxChange:function handleMaxChange(date){this.maxDate=Object(date_util_["clearMilliseconds"])(date);this.handleChange();},handleChange:function handleChange(){if(this.isValidValue([this.minDate,this.maxDate])){this.$refs.minSpinner.selectableRange=[[time_rangevue_type_script_lang_js_minTimeOfDay(this.minDate),this.maxDate]];this.$refs.maxSpinner.selectableRange=[[this.minDate,time_rangevue_type_script_lang_js_maxTimeOfDay(this.maxDate)]];this.$emit('pick',[this.minDate,this.maxDate],true);}},setMinSelectionRange:function setMinSelectionRange(start,end){this.$emit('select-range',start,end,'min');this.selectionRange=[start,end];},setMaxSelectionRange:function setMaxSelectionRange(start,end){this.$emit('select-range',start,end,'max');this.selectionRange=[start+this.offset,end+this.offset];},handleConfirm:function handleConfirm(){var visible=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var minSelectableRange=this.$refs.minSpinner.selectableRange;var maxSelectableRange=this.$refs.maxSpinner.selectableRange;this.minDate=Object(date_util_["limitTimeRange"])(this.minDate,minSelectableRange,this.format);this.maxDate=Object(date_util_["limitTimeRange"])(this.maxDate,maxSelectableRange,this.format);this.$emit('pick',[this.minDate,this.maxDate],visible);},adjustSpinners:function adjustSpinners(){this.$refs.minSpinner.adjustSpinners();this.$refs.maxSpinner.adjustSpinners();},changeSelectionRange:function changeSelectionRange(step){var list=this.showSeconds?[0,3,6,11,14,17]:[0,3,8,11];var mapping=['hours','minutes'].concat(this.showSeconds?['seconds']:[]);var index=list.indexOf(this.selectionRange[0]);var next=(index+step+list.length)%list.length;var half=list.length/2;if(next<half){this.$refs.minSpinner.emitSelectRange(mapping[next]);}else{this.$refs.maxSpinner.emitSelectRange(mapping[next-half]);}},isValidValue:function isValidValue(date){return Array.isArray(date)&&Object(date_util_["timeWithinRange"])(this.minDate,this.$refs.minSpinner.selectableRange)&&Object(date_util_["timeWithinRange"])(this.maxDate,this.$refs.maxSpinner.selectableRange);},handleKeydown:function handleKeydown(event){var keyCode=event.keyCode;var mapping={38:-1,40:1,37:-1,39:1};// Left or Right
if(keyCode===37||keyCode===39){var step=mapping[keyCode];this.changeSelectionRange(step);event.preventDefault();return;}// Up or Down
if(keyCode===38||keyCode===40){var _step=mapping[keyCode];this.spinner.scrollDown(_step);event.preventDefault();return;}}}};// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue?vue&type=script&lang=js&
/* harmony default export */var panel_time_rangevue_type_script_lang_js_=time_rangevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/date-picker/src/panel/time-range.vue
/* normalize component */var time_range_component=normalizeComponent(panel_time_rangevue_type_script_lang_js_,time_rangevue_type_template_id_fb28660e_render,time_rangevue_type_template_id_fb28660e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var time_range_api;}time_range_component.options.__file="packages/date-picker/src/panel/time-range.vue";/* harmony default export */var time_range=time_range_component.exports;// CONCATENATED MODULE: ./packages/date-picker/src/picker/time-picker.js
/* harmony default export */var time_picker={mixins:[picker],name:'ElTimePicker',props:{isRange:Boolean,arrowControl:Boolean},data:function data(){return{type:''};},watch:{isRange:function isRange(_isRange){if(this.picker){this.unmountPicker();this.type=_isRange?'timerange':'time';this.panel=_isRange?time_range:panel_time;this.mountPicker();}else{this.type=_isRange?'timerange':'time';this.panel=_isRange?time_range:panel_time;}}},created:function created(){this.type=this.isRange?'timerange':'time';this.panel=this.isRange?time_range:panel_time;}};// CONCATENATED MODULE: ./packages/time-picker/index.js
/* istanbul ignore next */time_picker.install=function(Vue){Vue.component(time_picker.name,time_picker);};/* harmony default export */var packages_time_picker=time_picker;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
var mainvue_type_template_id_52060272_render=function mainvue_type_template_id_52060272_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",[_c("transition",{attrs:{name:_vm.transition},on:{"after-enter":_vm.handleAfterEnter,"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:!_vm.disabled&&_vm.showPopper,expression:"!disabled && showPopper"}],ref:"popper",staticClass:"el-popover el-popper",class:[_vm.popperClass,_vm.content&&"el-popover--plain"],style:{width:_vm.width+"px"},attrs:{role:"tooltip",id:_vm.tooltipId,"aria-hidden":_vm.disabled||!_vm.showPopper?"true":"false"}},[_vm.title?_c("div",{staticClass:"el-popover__title",domProps:{textContent:_vm._s(_vm.title)}}):_vm._e(),_vm._t("default",[_vm._v(_vm._s(_vm.content))])],2)]),_c("span",{ref:"wrapper",staticClass:"el-popover__reference-wrapper"},[_vm._t("reference")],2)],1);};var mainvue_type_template_id_52060272_staticRenderFns=[];mainvue_type_template_id_52060272_render._withStripped=true;// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var mainvue_type_script_lang_js_={name:'ElPopover',mixins:[vue_popper_default.a],props:{trigger:{type:String,default:'click',validator:function validator(value){return['click','focus','hover','manual'].indexOf(value)>-1;}},openDelay:{type:Number,default:0},closeDelay:{type:Number,default:200},title:String,disabled:Boolean,content:String,reference:{},popperClass:String,width:{},visibleArrow:{default:true},arrowOffset:{type:Number,default:0},transition:{type:String,default:'fade-in-linear'},tabindex:{type:Number,default:0}},computed:{tooltipId:function tooltipId(){return'el-popover-'+Object(util_["generateId"])();}},watch:{showPopper:function showPopper(val){if(this.disabled){return;}val?this.$emit('show'):this.$emit('hide');}},mounted:function mounted(){var _this=this;var reference=this.referenceElm=this.reference||this.$refs.reference;var popper=this.popper||this.$refs.popper;if(!reference&&this.$refs.wrapper.children){reference=this.referenceElm=this.$refs.wrapper.children[0];}// 可访问性
if(reference){Object(dom_["addClass"])(reference,'el-popover__reference');reference.setAttribute('aria-describedby',this.tooltipId);reference.setAttribute('tabindex',this.tabindex);// tab序列
popper.setAttribute('tabindex',0);if(this.trigger!=='click'){Object(dom_["on"])(reference,'focusin',function(){_this.handleFocus();var instance=reference.__vue__;if(instance&&typeof instance.focus==='function'){instance.focus();}});Object(dom_["on"])(popper,'focusin',this.handleFocus);Object(dom_["on"])(reference,'focusout',this.handleBlur);Object(dom_["on"])(popper,'focusout',this.handleBlur);}Object(dom_["on"])(reference,'keydown',this.handleKeydown);Object(dom_["on"])(reference,'click',this.handleClick);}if(this.trigger==='click'){Object(dom_["on"])(reference,'click',this.doToggle);Object(dom_["on"])(document,'click',this.handleDocumentClick);}else if(this.trigger==='hover'){Object(dom_["on"])(reference,'mouseenter',this.handleMouseEnter);Object(dom_["on"])(popper,'mouseenter',this.handleMouseEnter);Object(dom_["on"])(reference,'mouseleave',this.handleMouseLeave);Object(dom_["on"])(popper,'mouseleave',this.handleMouseLeave);}else if(this.trigger==='focus'){if(this.tabindex<0){console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');}if(reference.querySelector('input, textarea')){Object(dom_["on"])(reference,'focusin',this.doShow);Object(dom_["on"])(reference,'focusout',this.doClose);}else{Object(dom_["on"])(reference,'mousedown',this.doShow);Object(dom_["on"])(reference,'mouseup',this.doClose);}}},beforeDestroy:function beforeDestroy(){this.cleanup();},deactivated:function deactivated(){this.cleanup();},methods:{doToggle:function doToggle(){this.showPopper=!this.showPopper;},doShow:function doShow(){this.showPopper=true;},doClose:function doClose(){this.showPopper=false;},handleFocus:function handleFocus(){Object(dom_["addClass"])(this.referenceElm,'focusing');if(this.trigger==='click'||this.trigger==='focus')this.showPopper=true;},handleClick:function handleClick(){Object(dom_["removeClass"])(this.referenceElm,'focusing');},handleBlur:function handleBlur(){Object(dom_["removeClass"])(this.referenceElm,'focusing');if(this.trigger==='click'||this.trigger==='focus')this.showPopper=false;},handleMouseEnter:function handleMouseEnter(){var _this2=this;clearTimeout(this._timer);if(this.openDelay){this._timer=setTimeout(function(){_this2.showPopper=true;},this.openDelay);}else{this.showPopper=true;}},handleKeydown:function handleKeydown(ev){if(ev.keyCode===27&&this.trigger!=='manual'){// esc
this.doClose();}},handleMouseLeave:function handleMouseLeave(){var _this3=this;clearTimeout(this._timer);if(this.closeDelay){this._timer=setTimeout(function(){_this3.showPopper=false;},this.closeDelay);}else{this.showPopper=false;}},handleDocumentClick:function handleDocumentClick(e){var reference=this.reference||this.$refs.reference;var popper=this.popper||this.$refs.popper;if(!reference&&this.$refs.wrapper.children){reference=this.referenceElm=this.$refs.wrapper.children[0];}if(!this.$el||!reference||this.$el.contains(e.target)||reference.contains(e.target)||!popper||popper.contains(e.target))return;this.showPopper=false;},handleAfterEnter:function handleAfterEnter(){this.$emit('after-enter');},handleAfterLeave:function handleAfterLeave(){this.$emit('after-leave');this.doDestroy();},cleanup:function cleanup(){if(this.openDelay||this.closeDelay){clearTimeout(this._timer);}}},destroyed:function destroyed(){var reference=this.reference;Object(dom_["off"])(reference,'click',this.doToggle);Object(dom_["off"])(reference,'mouseup',this.doClose);Object(dom_["off"])(reference,'mousedown',this.doShow);Object(dom_["off"])(reference,'focusin',this.doShow);Object(dom_["off"])(reference,'focusout',this.doClose);Object(dom_["off"])(reference,'mousedown',this.doShow);Object(dom_["off"])(reference,'mouseup',this.doClose);Object(dom_["off"])(reference,'mouseleave',this.handleMouseLeave);Object(dom_["off"])(reference,'mouseenter',this.handleMouseEnter);Object(dom_["off"])(document,'click',this.handleDocumentClick);}};// CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var src_mainvue_type_script_lang_js_=mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/popover/src/main.vue
/* normalize component */var main_component=normalizeComponent(src_mainvue_type_script_lang_js_,mainvue_type_template_id_52060272_render,mainvue_type_template_id_52060272_staticRenderFns,false,null,null,null);/* hot reload */if(false){var main_api;}main_component.options.__file="packages/popover/src/main.vue";/* harmony default export */var main=main_component.exports;// CONCATENATED MODULE: ./packages/popover/src/directive.js
var getReference=function getReference(el,binding,vnode){var _ref=binding.expression?binding.value:binding.arg;var popper=vnode.context.$refs[_ref];if(popper){if(Array.isArray(popper)){popper[0].$refs.reference=el;}else{popper.$refs.reference=el;}}};/* harmony default export */var directive={bind:function bind(el,binding,vnode){getReference(el,binding,vnode);},inserted:function inserted(el,binding,vnode){getReference(el,binding,vnode);}};// CONCATENATED MODULE: ./packages/popover/index.js
external_vue_default.a.directive('popover',directive);/* istanbul ignore next */main.install=function(Vue){Vue.directive('popover',directive);Vue.component(main.name,main);};main.directive=directive;/* harmony default export */var popover=main;// CONCATENATED MODULE: ./packages/tooltip/src/main.js
/* harmony default export */var src_main={name:'ElTooltip',mixins:[vue_popper_default.a],props:{openDelay:{type:Number,default:0},disabled:Boolean,manual:Boolean,effect:{type:String,default:'dark'},arrowOffset:{type:Number,default:0},popperClass:String,content:String,visibleArrow:{default:true},transition:{type:String,default:'el-fade-in-linear'},popperOptions:{default:function _default(){return{boundariesPadding:10,gpuAcceleration:false};}},enterable:{type:Boolean,default:true},hideAfter:{type:Number,default:0},tabindex:{type:Number,default:0}},data:function data(){return{tooltipId:'el-tooltip-'+Object(util_["generateId"])(),timeoutPending:null,focusing:false};},beforeCreate:function beforeCreate(){var _this=this;if(this.$isServer)return;this.popperVM=new external_vue_default.a({data:{node:''},render:function render(h){return this.node;}}).$mount();this.debounceClose=debounce_default()(200,function(){return _this.handleClosePopper();});},render:function render(h){var _this2=this;if(this.popperVM){this.popperVM.node=h('transition',{attrs:{name:this.transition},on:{'afterLeave':this.doDestroy}},[h('div',{on:{'mouseleave':function mouseleave(){_this2.setExpectedState(false);_this2.debounceClose();},'mouseenter':function mouseenter(){_this2.setExpectedState(true);}},ref:'popper',attrs:{role:'tooltip',id:this.tooltipId,'aria-hidden':this.disabled||!this.showPopper?'true':'false'},directives:[{name:'show',value:!this.disabled&&this.showPopper}],'class':['el-tooltip__popper','is-'+this.effect,this.popperClass]},[this.$slots.content||this.content])]);}var firstElement=this.getFirstElement();if(!firstElement)return null;var data=firstElement.data=firstElement.data||{};data.staticClass=this.addTooltipClass(data.staticClass);return firstElement;},mounted:function mounted(){var _this3=this;this.referenceElm=this.$el;if(this.$el.nodeType===1){this.$el.setAttribute('aria-describedby',this.tooltipId);this.$el.setAttribute('tabindex',this.tabindex);Object(dom_["on"])(this.referenceElm,'mouseenter',this.show);Object(dom_["on"])(this.referenceElm,'mouseleave',this.hide);Object(dom_["on"])(this.referenceElm,'focus',function(){if(!_this3.$slots.default||!_this3.$slots.default.length){_this3.handleFocus();return;}var instance=_this3.$slots.default[0].componentInstance;if(instance&&instance.focus){instance.focus();}else{_this3.handleFocus();}});Object(dom_["on"])(this.referenceElm,'blur',this.handleBlur);Object(dom_["on"])(this.referenceElm,'click',this.removeFocusing);}// fix issue https://github.com/ElemeFE/element/issues/14424
if(this.value&&this.popperVM){this.popperVM.$nextTick(function(){if(_this3.value){_this3.updatePopper();}});}},watch:{focusing:function focusing(val){if(val){Object(dom_["addClass"])(this.referenceElm,'focusing');}else{Object(dom_["removeClass"])(this.referenceElm,'focusing');}}},methods:{show:function show(){this.setExpectedState(true);this.handleShowPopper();},hide:function hide(){this.setExpectedState(false);this.debounceClose();},handleFocus:function handleFocus(){this.focusing=true;this.show();},handleBlur:function handleBlur(){this.focusing=false;this.hide();},removeFocusing:function removeFocusing(){this.focusing=false;},addTooltipClass:function addTooltipClass(prev){if(!prev){return'el-tooltip';}else{return'el-tooltip '+prev.replace('el-tooltip','');}},handleShowPopper:function handleShowPopper(){var _this4=this;if(!this.expectedState||this.manual)return;clearTimeout(this.timeout);this.timeout=setTimeout(function(){_this4.showPopper=true;},this.openDelay);if(this.hideAfter>0){this.timeoutPending=setTimeout(function(){_this4.showPopper=false;},this.hideAfter);}},handleClosePopper:function handleClosePopper(){if(this.enterable&&this.expectedState||this.manual)return;clearTimeout(this.timeout);if(this.timeoutPending){clearTimeout(this.timeoutPending);}this.showPopper=false;if(this.disabled){this.doDestroy();}},setExpectedState:function setExpectedState(expectedState){if(expectedState===false){clearTimeout(this.timeoutPending);}this.expectedState=expectedState;},getFirstElement:function getFirstElement(){var slots=this.$slots.default;if(!Array.isArray(slots))return null;var element=null;for(var index=0;index<slots.length;index++){if(slots[index]&&slots[index].tag){element=slots[index];break;};}return element;}},beforeDestroy:function beforeDestroy(){this.popperVM&&this.popperVM.$destroy();},destroyed:function destroyed(){var reference=this.referenceElm;if(reference.nodeType===1){Object(dom_["off"])(reference,'mouseenter',this.show);Object(dom_["off"])(reference,'mouseleave',this.hide);Object(dom_["off"])(reference,'focus',this.handleFocus);Object(dom_["off"])(reference,'blur',this.handleBlur);Object(dom_["off"])(reference,'click',this.removeFocusing);}}};// CONCATENATED MODULE: ./packages/tooltip/index.js
/* istanbul ignore next */src_main.install=function(Vue){Vue.component(src_main.name,src_main);};/* harmony default export */var packages_tooltip=src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
var mainvue_type_template_id_6b29b012_render=function mainvue_type_template_id_6b29b012_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"msgbox-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-message-box__wrapper",attrs:{tabindex:"-1",role:"dialog","aria-modal":"true","aria-label":_vm.title||"dialog"},on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{staticClass:"el-message-box",class:[_vm.customClass,_vm.center&&"el-message-box--center"]},[_vm.title!==null?_c("div",{staticClass:"el-message-box__header"},[_c("div",{staticClass:"el-message-box__title"},[_vm.icon&&_vm.center?_c("div",{class:["el-message-box__status",_vm.icon]}):_vm._e(),_c("span",[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-message-box__headerbtn",attrs:{type:"button","aria-label":"Close"},on:{click:function click($event){_vm.handleAction(_vm.distinguishCancelAndClose?"close":"cancel");},keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction(_vm.distinguishCancelAndClose?"close":"cancel");}}},[_c("i",{staticClass:"el-message-box__close el-icon-close"})]):_vm._e()]):_vm._e(),_c("div",{staticClass:"el-message-box__content"},[_c("div",{staticClass:"el-message-box__container"},[_vm.icon&&!_vm.center&&_vm.message!==""?_c("div",{class:["el-message-box__status",_vm.icon]}):_vm._e(),_vm.message!==""?_c("div",{staticClass:"el-message-box__message"},[_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",[_vm._v(_vm._s(_vm.message))]):_c("p",{domProps:{innerHTML:_vm._s(_vm.message)}})])],2):_vm._e()]),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showInput,expression:"showInput"}],staticClass:"el-message-box__input"},[_c("el-input",{ref:"input",attrs:{type:_vm.inputType,placeholder:_vm.inputPlaceholder},nativeOn:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleInputEnter($event);}},model:{value:_vm.inputValue,callback:function callback($$v){_vm.inputValue=$$v;},expression:"inputValue"}}),_c("div",{staticClass:"el-message-box__errormsg",style:{visibility:!!_vm.editorErrorMessage?"visible":"hidden"}},[_vm._v(_vm._s(_vm.editorErrorMessage))])],1)]),_c("div",{staticClass:"el-message-box__btns"},[_vm.showCancelButton?_c("el-button",{class:[_vm.cancelButtonClasses],attrs:{loading:_vm.cancelButtonLoading,round:_vm.roundButton,size:"small"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction("cancel");}},nativeOn:{click:function click($event){_vm.handleAction("cancel");}}},[_vm._v("\n          "+_vm._s(_vm.cancelButtonText||_vm.t("el.messagebox.cancel"))+"\n        ")]):_vm._e(),_c("el-button",{directives:[{name:"show",rawName:"v-show",value:_vm.showConfirmButton,expression:"showConfirmButton"}],ref:"confirm",class:[_vm.confirmButtonClasses],attrs:{loading:_vm.confirmButtonLoading,round:_vm.roundButton,size:"small"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}_vm.handleAction("confirm");}},nativeOn:{click:function click($event){_vm.handleAction("confirm");}}},[_vm._v("\n          "+_vm._s(_vm.confirmButtonText||_vm.t("el.messagebox.confirm"))+"\n        ")])],1)])])]);};var mainvue_type_template_id_6b29b012_staticRenderFns=[];mainvue_type_template_id_6b29b012_render._withStripped=true;// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=template&id=6b29b012&
// EXTERNAL MODULE: external "element-ui/lib/locale"
var lib_locale_=__webpack_require__(12);var lib_locale_default=/*#__PURE__*/__webpack_require__.n(lib_locale_);// EXTERNAL MODULE: external "element-ui/lib/utils/aria-dialog"
var aria_dialog_=__webpack_require__(39);var aria_dialog_default=/*#__PURE__*/__webpack_require__.n(aria_dialog_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message-box/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var messageBox=void 0;var typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var message_box_src_mainvue_type_script_lang_js_={mixins:[popup_default.a,locale_default.a],props:{modal:{default:true},lockScroll:{default:true},showClose:{type:Boolean,default:true},closeOnClickModal:{default:true},closeOnPressEscape:{default:true},closeOnHashChange:{default:true},center:{default:false,type:Boolean},roundButton:{default:false,type:Boolean}},components:{ElInput:input_default.a,ElButton:button_default.a},computed:{icon:function icon(){var type=this.type,iconClass=this.iconClass;return iconClass||(type&&typeMap[type]?'el-icon-'+typeMap[type]:'');},confirmButtonClasses:function confirmButtonClasses(){return'el-button--primary '+this.confirmButtonClass;},cancelButtonClasses:function cancelButtonClasses(){return''+this.cancelButtonClass;}},methods:{getSafeClose:function getSafeClose(){var _this=this;var currentId=this.uid;return function(){_this.$nextTick(function(){if(currentId===_this.uid)_this.doClose();});};},doClose:function doClose(){var _this2=this;if(!this.visible)return;this.visible=false;this._closing=true;this.onClose&&this.onClose();messageBox.closeDialog();// 解绑
if(this.lockScroll){setTimeout(this.restoreBodyStyle,200);}this.opened=false;this.doAfterClose();setTimeout(function(){if(_this2.action)_this2.callback(_this2.action,_this2);});},handleWrapperClick:function handleWrapperClick(){if(this.closeOnClickModal){this.handleAction(this.distinguishCancelAndClose?'close':'cancel');}},handleInputEnter:function handleInputEnter(){if(this.inputType!=='textarea'){return this.handleAction('confirm');}},handleAction:function handleAction(action){if(this.$type==='prompt'&&action==='confirm'&&!this.validate()){return;}this.action=action;if(typeof this.beforeClose==='function'){this.close=this.getSafeClose();this.beforeClose(action,this,this.close);}else{this.doClose();}},validate:function validate(){if(this.$type==='prompt'){var inputPattern=this.inputPattern;if(inputPattern&&!inputPattern.test(this.inputValue||'')){this.editorErrorMessage=this.inputErrorMessage||Object(lib_locale_["t"])('el.messagebox.error');Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}var inputValidator=this.inputValidator;if(typeof inputValidator==='function'){var validateResult=inputValidator(this.inputValue);if(validateResult===false){this.editorErrorMessage=this.inputErrorMessage||Object(lib_locale_["t"])('el.messagebox.error');Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}if(typeof validateResult==='string'){this.editorErrorMessage=validateResult;Object(dom_["addClass"])(this.getInputElement(),'invalid');return false;}}}this.editorErrorMessage='';Object(dom_["removeClass"])(this.getInputElement(),'invalid');return true;},getFirstFocus:function getFirstFocus(){var btn=this.$el.querySelector('.el-message-box__btns .el-button');var title=this.$el.querySelector('.el-message-box__btns .el-message-box__title');return btn||title;},getInputElement:function getInputElement(){var inputRefs=this.$refs.input.$refs;return inputRefs.input||inputRefs.textarea;},handleClose:function handleClose(){this.handleAction('close');}},watch:{inputValue:{immediate:true,handler:function handler(val){var _this3=this;this.$nextTick(function(_){if(_this3.$type==='prompt'&&val!==null){_this3.validate();}});}},visible:function visible(val){var _this4=this;if(val){this.uid++;if(this.$type==='alert'||this.$type==='confirm'){this.$nextTick(function(){_this4.$refs.confirm.$el.focus();});}this.focusAfterClosed=document.activeElement;messageBox=new aria_dialog_default.a(this.$el,this.focusAfterClosed,this.getFirstFocus());}// prompt
if(this.$type!=='prompt')return;if(val){setTimeout(function(){if(_this4.$refs.input&&_this4.$refs.input.$el){_this4.getInputElement().focus();}},500);}else{this.editorErrorMessage='';Object(dom_["removeClass"])(this.getInputElement(),'invalid');}}},mounted:function mounted(){var _this5=this;this.$nextTick(function(){if(_this5.closeOnHashChange){window.addEventListener('hashchange',_this5.close);}});},beforeDestroy:function beforeDestroy(){if(this.closeOnHashChange){window.removeEventListener('hashchange',this.close);}setTimeout(function(){messageBox.closeDialog();});},data:function data(){return{uid:1,title:undefined,message:'',type:'',iconClass:'',customClass:'',showInput:false,inputValue:null,inputPlaceholder:'',inputType:'text',inputPattern:null,inputValidator:null,inputErrorMessage:'',showConfirmButton:true,showCancelButton:false,action:'',confirmButtonText:'',cancelButtonText:'',confirmButtonLoading:false,cancelButtonLoading:false,confirmButtonClass:'',confirmButtonDisabled:false,cancelButtonClass:'',editorErrorMessage:null,callback:null,dangerouslyUseHTMLString:false,focusAfterClosed:null,isOnComposition:false,distinguishCancelAndClose:false};}};// CONCATENATED MODULE: ./packages/message-box/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_message_box_src_mainvue_type_script_lang_js_=message_box_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/message-box/src/main.vue
/* normalize component */var src_main_component=normalizeComponent(packages_message_box_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6b29b012_render,mainvue_type_template_id_6b29b012_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_main_api;}src_main_component.options.__file="packages/message-box/src/main.vue";/* harmony default export */var message_box_src_main=src_main_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/vdom"
var vdom_=__webpack_require__(22);// CONCATENATED MODULE: ./packages/message-box/src/main.js
var main_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};var main_defaults={title:null,message:'',type:'',iconClass:'',showInput:false,showClose:true,modalFade:true,lockScroll:true,closeOnClickModal:true,closeOnPressEscape:true,closeOnHashChange:true,inputValue:null,inputPlaceholder:'',inputType:'text',inputPattern:null,inputValidator:null,inputErrorMessage:'',showConfirmButton:true,showCancelButton:false,confirmButtonPosition:'right',confirmButtonHighlight:false,cancelButtonHighlight:false,confirmButtonText:'',cancelButtonText:'',confirmButtonClass:'',cancelButtonClass:'',customClass:'',beforeClose:null,dangerouslyUseHTMLString:false,center:false,roundButton:false,distinguishCancelAndClose:false};var MessageBoxConstructor=external_vue_default.a.extend(message_box_src_main);var currentMsg=void 0,main_instance=void 0;var msgQueue=[];var defaultCallback=function defaultCallback(action){if(currentMsg){var callback=currentMsg.callback;if(typeof callback==='function'){if(main_instance.showInput){callback(main_instance.inputValue,action);}else{callback(action);}}if(currentMsg.resolve){if(action==='confirm'){if(main_instance.showInput){currentMsg.resolve({value:main_instance.inputValue,action:action});}else{currentMsg.resolve(action);}}else if(currentMsg.reject&&(action==='cancel'||action==='close')){currentMsg.reject(action);}}}};var initInstance=function initInstance(){main_instance=new MessageBoxConstructor({el:document.createElement('div')});main_instance.callback=defaultCallback;};var main_showNextMsg=function showNextMsg(){if(!main_instance){initInstance();}main_instance.action='';if(!main_instance.visible||main_instance.closeTimer){if(msgQueue.length>0){currentMsg=msgQueue.shift();var options=currentMsg.options;for(var prop in options){if(options.hasOwnProperty(prop)){main_instance[prop]=options[prop];}}if(options.callback===undefined){main_instance.callback=defaultCallback;}var oldCb=main_instance.callback;main_instance.callback=function(action,instance){oldCb(action,instance);showNextMsg();};if(Object(vdom_["isVNode"])(main_instance.message)){main_instance.$slots.default=[main_instance.message];main_instance.message=null;}else{delete main_instance.$slots.default;}['modal','showClose','closeOnClickModal','closeOnPressEscape','closeOnHashChange'].forEach(function(prop){if(main_instance[prop]===undefined){main_instance[prop]=true;}});document.body.appendChild(main_instance.$el);external_vue_default.a.nextTick(function(){main_instance.visible=true;});}}};var main_MessageBox=function MessageBox(options,callback){if(external_vue_default.a.prototype.$isServer)return;if(typeof options==='string'||Object(vdom_["isVNode"])(options)){options={message:options};if(typeof arguments[1]==='string'){options.title=arguments[1];}}else if(options.callback&&!callback){callback=options.callback;}if(typeof Promise!=='undefined'){return new Promise(function(resolve,reject){// eslint-disable-line
msgQueue.push({options:merge_default()({},main_defaults,MessageBox.defaults,options),callback:callback,resolve:resolve,reject:reject});main_showNextMsg();});}else{msgQueue.push({options:merge_default()({},main_defaults,MessageBox.defaults,options),callback:callback});main_showNextMsg();}};main_MessageBox.setDefaults=function(defaults){main_MessageBox.defaults=defaults;};main_MessageBox.alert=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,$type:'alert',closeOnPressEscape:false,closeOnClickModal:false},options));};main_MessageBox.confirm=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,$type:'confirm',showCancelButton:true},options));};main_MessageBox.prompt=function(message,title,options){if((typeof title==='undefined'?'undefined':main_typeof(title))==='object'){options=title;title='';}else if(title===undefined){title='';}return main_MessageBox(merge_default()({title:title,message:message,showCancelButton:true,showInput:true,$type:'prompt'},options));};main_MessageBox.close=function(){main_instance.doClose();main_instance.visible=false;msgQueue=[];currentMsg=null;};/* harmony default export */var packages_message_box_src_main=main_MessageBox;// CONCATENATED MODULE: ./packages/message-box/index.js
/* harmony default export */var message_box=packages_message_box_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
var breadcrumbvue_type_template_id_4b464c06_render=function breadcrumbvue_type_template_id_4b464c06_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-breadcrumb",attrs:{"aria-label":"Breadcrumb",role:"navigation"}},[_vm._t("default")],2);};var breadcrumbvue_type_template_id_4b464c06_staticRenderFns=[];breadcrumbvue_type_template_id_4b464c06_render._withStripped=true;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=template&id=4b464c06&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var breadcrumbvue_type_script_lang_js_={name:'ElBreadcrumb',props:{separator:{type:String,default:'/'},separatorClass:{type:String,default:''}},provide:function provide(){return{elBreadcrumb:this};},mounted:function mounted(){var items=this.$el.querySelectorAll('.el-breadcrumb__item');if(items.length){items[items.length-1].setAttribute('aria-current','page');}}};// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue?vue&type=script&lang=js&
/* harmony default export */var src_breadcrumbvue_type_script_lang_js_=breadcrumbvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb.vue
/* normalize component */var breadcrumb_component=normalizeComponent(src_breadcrumbvue_type_script_lang_js_,breadcrumbvue_type_template_id_4b464c06_render,breadcrumbvue_type_template_id_4b464c06_staticRenderFns,false,null,null,null);/* hot reload */if(false){var breadcrumb_api;}breadcrumb_component.options.__file="packages/breadcrumb/src/breadcrumb.vue";/* harmony default export */var breadcrumb=breadcrumb_component.exports;// CONCATENATED MODULE: ./packages/breadcrumb/index.js
/* istanbul ignore next */breadcrumb.install=function(Vue){Vue.component(breadcrumb.name,breadcrumb);};/* harmony default export */var packages_breadcrumb=breadcrumb;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
var breadcrumb_itemvue_type_template_id_fcf9eaac_render=function breadcrumb_itemvue_type_template_id_fcf9eaac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",{staticClass:"el-breadcrumb__item"},[_c("span",{ref:"link",class:["el-breadcrumb__inner",_vm.to?"is-link":""],attrs:{role:"link"}},[_vm._t("default")],2),_vm.separatorClass?_c("i",{staticClass:"el-breadcrumb__separator",class:_vm.separatorClass}):_c("span",{staticClass:"el-breadcrumb__separator",attrs:{role:"presentation"}},[_vm._v(_vm._s(_vm.separator))])]);};var breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns=[];breadcrumb_itemvue_type_template_id_fcf9eaac_render._withStripped=true;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=template&id=fcf9eaac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var breadcrumb_itemvue_type_script_lang_js_={name:'ElBreadcrumbItem',props:{to:{},replace:Boolean},data:function data(){return{separator:'',separatorClass:''};},inject:['elBreadcrumb'],mounted:function mounted(){var _this=this;this.separator=this.elBreadcrumb.separator;this.separatorClass=this.elBreadcrumb.separatorClass;var link=this.$refs.link;link.setAttribute('role','link');link.addEventListener('click',function(_){var to=_this.to,$router=_this.$router;if(!to||!$router)return;_this.replace?$router.replace(to):$router.push(to);});}};// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_breadcrumb_itemvue_type_script_lang_js_=breadcrumb_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/breadcrumb/src/breadcrumb-item.vue
/* normalize component */var breadcrumb_item_component=normalizeComponent(src_breadcrumb_itemvue_type_script_lang_js_,breadcrumb_itemvue_type_template_id_fcf9eaac_render,breadcrumb_itemvue_type_template_id_fcf9eaac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var breadcrumb_item_api;}breadcrumb_item_component.options.__file="packages/breadcrumb/src/breadcrumb-item.vue";/* harmony default export */var breadcrumb_item=breadcrumb_item_component.exports;// CONCATENATED MODULE: ./packages/breadcrumb-item/index.js
/* istanbul ignore next */breadcrumb_item.install=function(Vue){Vue.component(breadcrumb_item.name,breadcrumb_item);};/* harmony default export */var packages_breadcrumb_item=breadcrumb_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
var formvue_type_template_id_a1b5ff34_render=function formvue_type_template_id_a1b5ff34_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("form",{staticClass:"el-form",class:[_vm.labelPosition?"el-form--label-"+_vm.labelPosition:"",{"el-form--inline":_vm.inline}]},[_vm._t("default")],2);};var formvue_type_template_id_a1b5ff34_staticRenderFns=[];formvue_type_template_id_a1b5ff34_render._withStripped=true;// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=template&id=a1b5ff34&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var formvue_type_script_lang_js_={name:'ElForm',componentName:'ElForm',provide:function provide(){return{elForm:this};},props:{model:Object,rules:Object,labelPosition:String,labelWidth:String,labelSuffix:{type:String,default:''},inline:Boolean,inlineMessage:Boolean,statusIcon:Boolean,showMessage:{type:Boolean,default:true},size:String,disabled:Boolean,validateOnRuleChange:{type:Boolean,default:true},hideRequiredAsterisk:{type:Boolean,default:false}},watch:{rules:function rules(){// remove then add event listeners on form-item after form rules change
this.fields.forEach(function(field){field.removeValidateEvents();field.addValidateEvents();});if(this.validateOnRuleChange){this.validate(function(){});}}},computed:{autoLabelWidth:function autoLabelWidth(){if(!this.potentialLabelWidthArr.length)return 0;var max=Math.max.apply(Math,this.potentialLabelWidthArr);return max?max+'px':'';}},data:function data(){return{fields:[],potentialLabelWidthArr:[]// use this array to calculate auto width
};},created:function created(){var _this=this;this.$on('el.form.addField',function(field){if(field){_this.fields.push(field);}});/* istanbul ignore next */this.$on('el.form.removeField',function(field){if(field.prop){_this.fields.splice(_this.fields.indexOf(field),1);}});},methods:{resetFields:function resetFields(){if(!this.model){console.warn('[Element Warn][Form]model is required for resetFields to work.');return;}this.fields.forEach(function(field){field.resetField();});},clearValidate:function clearValidate(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var fields=props.length?typeof props==='string'?this.fields.filter(function(field){return props===field.prop;}):this.fields.filter(function(field){return props.indexOf(field.prop)>-1;}):this.fields;fields.forEach(function(field){field.clearValidate();});},validate:function validate(callback){var _this2=this;if(!this.model){console.warn('[Element Warn][Form]model is required for validate to work!');return;}var promise=void 0;// if no callback, return promise
if(typeof callback!=='function'&&window.Promise){promise=new window.Promise(function(resolve,reject){callback=function callback(valid,invalidFields){valid?resolve(valid):reject(invalidFields);};});}var valid=true;var count=0;// 如果需要验证的fields为空，调用验证时立刻返回callback
if(this.fields.length===0&&callback){callback(true);}var invalidFields={};this.fields.forEach(function(field){field.validate('',function(message,field){if(message){valid=false;}invalidFields=merge_default()({},invalidFields,field);if(typeof callback==='function'&&++count===_this2.fields.length){callback(valid,invalidFields);}});});if(promise){return promise;}},validateField:function validateField(props,cb){props=[].concat(props);var fields=this.fields.filter(function(field){return props.indexOf(field.prop)!==-1;});if(!fields.length){console.warn('[Element Warn]please pass correct props!');return;}fields.forEach(function(field){field.validate('',cb);});},getLabelWidthIndex:function getLabelWidthIndex(width){var index=this.potentialLabelWidthArr.indexOf(width);// it's impossible
if(index===-1){throw new Error('[ElementForm]unpected width ',width);}return index;},registerLabelWidth:function registerLabelWidth(val,oldVal){if(val&&oldVal){var index=this.getLabelWidthIndex(oldVal);this.potentialLabelWidthArr.splice(index,1,val);}else if(val){this.potentialLabelWidthArr.push(val);}},deregisterLabelWidth:function deregisterLabelWidth(val){var index=this.getLabelWidthIndex(val);this.potentialLabelWidthArr.splice(index,1);}}};// CONCATENATED MODULE: ./packages/form/src/form.vue?vue&type=script&lang=js&
/* harmony default export */var src_formvue_type_script_lang_js_=formvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/form.vue
/* normalize component */var form_component=normalizeComponent(src_formvue_type_script_lang_js_,formvue_type_template_id_a1b5ff34_render,formvue_type_template_id_a1b5ff34_staticRenderFns,false,null,null,null);/* hot reload */if(false){var form_api;}form_component.options.__file="packages/form/src/form.vue";/* harmony default export */var src_form=form_component.exports;// CONCATENATED MODULE: ./packages/form/index.js
/* istanbul ignore next */src_form.install=function(Vue){Vue.component(src_form.name,src_form);};/* harmony default export */var packages_form=src_form;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
var form_itemvue_type_template_id_b6f3db6c_render=function form_itemvue_type_template_id_b6f3db6c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-form-item",class:[{"el-form-item--feedback":_vm.elForm&&_vm.elForm.statusIcon,"is-error":_vm.validateState==="error","is-validating":_vm.validateState==="validating","is-success":_vm.validateState==="success","is-required":_vm.isRequired||_vm.required,"is-no-asterisk":_vm.elForm&&_vm.elForm.hideRequiredAsterisk},_vm.sizeClass?"el-form-item--"+_vm.sizeClass:""]},[_c("label-wrap",{attrs:{"is-auto-width":_vm.labelStyle&&_vm.labelStyle.width==="auto","update-all":_vm.form.labelWidth==="auto"}},[_vm.label||_vm.$slots.label?_c("label",{staticClass:"el-form-item__label",style:_vm.labelStyle,attrs:{for:_vm.labelFor}},[_vm._t("label",[_vm._v(_vm._s(_vm.label+_vm.form.labelSuffix))])],2):_vm._e()]),_c("div",{staticClass:"el-form-item__content",style:_vm.contentStyle},[_vm._t("default"),_c("transition",{attrs:{name:"el-zoom-in-top"}},[_vm.validateState==="error"&&_vm.showMessage&&_vm.form.showMessage?_vm._t("error",[_c("div",{staticClass:"el-form-item__error",class:{"el-form-item__error--inline":typeof _vm.inlineMessage==="boolean"?_vm.inlineMessage:_vm.elForm&&_vm.elForm.inlineMessage||false}},[_vm._v("\n          "+_vm._s(_vm.validateMessage)+"\n        ")])],{error:_vm.validateMessage}):_vm._e()],2)],2)],1);};var form_itemvue_type_template_id_b6f3db6c_staticRenderFns=[];form_itemvue_type_template_id_b6f3db6c_render._withStripped=true;// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=template&id=b6f3db6c&
// EXTERNAL MODULE: external "async-validator"
var external_async_validator_=__webpack_require__(40);var external_async_validator_default=/*#__PURE__*/__webpack_require__.n(external_async_validator_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
/* harmony default export */var label_wrapvue_type_script_lang_js_={props:{isAutoWidth:Boolean,updateAll:Boolean},inject:['elForm','elFormItem'],render:function render(){var h=arguments[0];var slots=this.$slots.default;if(!slots)return null;if(this.isAutoWidth){var autoLabelWidth=this.elForm.autoLabelWidth;var style={};if(autoLabelWidth&&autoLabelWidth!=='auto'){var marginLeft=parseInt(autoLabelWidth,10)-this.computedWidth;if(marginLeft){style.marginLeft=marginLeft+'px';}}return h('div',{'class':'el-form-item__label-wrap',style:style},[slots]);}else{return slots[0];}},methods:{getLabelWidth:function getLabelWidth(){if(this.$el&&this.$el.firstElementChild){var computedWidth=window.getComputedStyle(this.$el.firstElementChild).width;return Math.ceil(parseFloat(computedWidth));}else{return 0;}},updateLabelWidth:function updateLabelWidth(){var action=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'update';if(this.$slots.default&&this.isAutoWidth&&this.$el.firstElementChild){if(action==='update'){this.computedWidth=this.getLabelWidth();}else if(action==='remove'){this.elForm.deregisterLabelWidth(this.computedWidth);}}}},watch:{computedWidth:function computedWidth(val,oldVal){if(this.updateAll){this.elForm.registerLabelWidth(val,oldVal);this.elFormItem.updateComputedLabelWidth(val);}}},data:function data(){return{computedWidth:0};},mounted:function mounted(){this.updateLabelWidth('update');},updated:function updated(){this.updateLabelWidth('update');},beforeDestroy:function beforeDestroy(){this.updateLabelWidth('remove');}};// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue?vue&type=script&lang=js&
/* harmony default export */var src_label_wrapvue_type_script_lang_js_=label_wrapvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/label-wrap.vue
var label_wrap_render,label_wrap_staticRenderFns;/* normalize component */var label_wrap_component=normalizeComponent(src_label_wrapvue_type_script_lang_js_,label_wrap_render,label_wrap_staticRenderFns,false,null,null,null);/* hot reload */if(false){var label_wrap_api;}label_wrap_component.options.__file="packages/form/src/label-wrap.vue";/* harmony default export */var label_wrap=label_wrap_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/form/src/form-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var form_itemvue_type_script_lang_js_={name:'ElFormItem',componentName:'ElFormItem',mixins:[emitter_default.a],provide:function provide(){return{elFormItem:this};},inject:['elForm'],props:{label:String,labelWidth:String,prop:String,required:{type:Boolean,default:undefined},rules:[Object,Array],error:String,validateStatus:String,for:String,inlineMessage:{type:[String,Boolean],default:''},showMessage:{type:Boolean,default:true},size:String},components:{// use this component to calculate auto width
LabelWrap:label_wrap},watch:{error:{immediate:true,handler:function handler(value){this.validateMessage=value;this.validateState=value?'error':'';}},validateStatus:function validateStatus(value){this.validateState=value;},rules:function rules(value){if((!value||value.length===0)&&this.required===undefined){this.clearValidate();}}},computed:{labelFor:function labelFor(){return this.for||this.prop;},labelStyle:function labelStyle(){var ret={};if(this.form.labelPosition==='top')return ret;var labelWidth=this.labelWidth||this.form.labelWidth;if(labelWidth){ret.width=labelWidth;}return ret;},contentStyle:function contentStyle(){var ret={};var label=this.label;if(this.form.labelPosition==='top'||this.form.inline)return ret;if(!label&&!this.labelWidth&&this.isNested)return ret;var labelWidth=this.labelWidth||this.form.labelWidth;if(labelWidth==='auto'){if(this.labelWidth==='auto'){ret.marginLeft=this.computedLabelWidth;}else if(this.form.labelWidth==='auto'){ret.marginLeft=this.elForm.autoLabelWidth;}}else{ret.marginLeft=labelWidth;}return ret;},form:function form(){var parent=this.$parent;var parentName=parent.$options.componentName;while(parentName!=='ElForm'){if(parentName==='ElFormItem'){this.isNested=true;}parent=parent.$parent;parentName=parent.$options.componentName;}return parent;},fieldValue:function fieldValue(){var model=this.form.model;if(!model||!this.prop){return;}var path=this.prop;if(path.indexOf(':')!==-1){path=path.replace(/:/,'.');}return Object(util_["getPropByPath"])(model,path,true).v;},isRequired:function isRequired(){var rules=this.getRules();var isRequired=false;if(rules&&rules.length){rules.every(function(rule){if(rule.required){isRequired=true;return false;}return true;});}return isRequired;},_formSize:function _formSize(){return this.elForm.size;},elFormItemSize:function elFormItemSize(){return this.size||this._formSize;},sizeClass:function sizeClass(){return this.elFormItemSize||(this.$ELEMENT||{}).size;}},data:function data(){return{validateState:'',validateMessage:'',validateDisabled:false,validator:{},isNested:false,computedLabelWidth:''};},methods:{validate:function validate(trigger){var _this=this;var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:util_["noop"];this.validateDisabled=false;var rules=this.getFilteredRule(trigger);if((!rules||rules.length===0)&&this.required===undefined){callback();return true;}this.validateState='validating';var descriptor={};if(rules&&rules.length>0){rules.forEach(function(rule){delete rule.trigger;});}descriptor[this.prop]=rules;var validator=new external_async_validator_default.a(descriptor);var model={};model[this.prop]=this.fieldValue;validator.validate(model,{firstFields:true},function(errors,invalidFields){_this.validateState=!errors?'success':'error';_this.validateMessage=errors?errors[0].message:'';callback(_this.validateMessage,invalidFields);_this.elForm&&_this.elForm.$emit('validate',_this.prop,!errors,_this.validateMessage||null);});},clearValidate:function clearValidate(){this.validateState='';this.validateMessage='';this.validateDisabled=false;},resetField:function resetField(){var _this2=this;this.validateState='';this.validateMessage='';var model=this.form.model;var value=this.fieldValue;var path=this.prop;if(path.indexOf(':')!==-1){path=path.replace(/:/,'.');}var prop=Object(util_["getPropByPath"])(model,path,true);this.validateDisabled=true;if(Array.isArray(value)){prop.o[prop.k]=[].concat(this.initialValue);}else{prop.o[prop.k]=this.initialValue;}// reset validateDisabled after onFieldChange triggered
this.$nextTick(function(){_this2.validateDisabled=false;});this.broadcast('ElTimeSelect','fieldReset',this.initialValue);},getRules:function getRules(){var formRules=this.form.rules;var selfRules=this.rules;var requiredRule=this.required!==undefined?{required:!!this.required}:[];var prop=Object(util_["getPropByPath"])(formRules,this.prop||'');formRules=formRules?prop.o[this.prop||'']||prop.v:[];return[].concat(selfRules||formRules||[]).concat(requiredRule);},getFilteredRule:function getFilteredRule(trigger){var rules=this.getRules();return rules.filter(function(rule){if(!rule.trigger||trigger==='')return true;if(Array.isArray(rule.trigger)){return rule.trigger.indexOf(trigger)>-1;}else{return rule.trigger===trigger;}}).map(function(rule){return merge_default()({},rule);});},onFieldBlur:function onFieldBlur(){this.validate('blur');},onFieldChange:function onFieldChange(){if(this.validateDisabled){this.validateDisabled=false;return;}this.validate('change');},updateComputedLabelWidth:function updateComputedLabelWidth(width){this.computedLabelWidth=width?width+'px':'';},addValidateEvents:function addValidateEvents(){var rules=this.getRules();if(rules.length||this.required!==undefined){this.$on('el.form.blur',this.onFieldBlur);this.$on('el.form.change',this.onFieldChange);}},removeValidateEvents:function removeValidateEvents(){this.$off();}},mounted:function mounted(){if(this.prop){this.dispatch('ElForm','el.form.addField',[this]);var initialValue=this.fieldValue;if(Array.isArray(initialValue)){initialValue=[].concat(initialValue);}Object.defineProperty(this,'initialValue',{value:initialValue});this.addValidateEvents();}},beforeDestroy:function beforeDestroy(){this.dispatch('ElForm','el.form.removeField',[this]);}};// CONCATENATED MODULE: ./packages/form/src/form-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_form_itemvue_type_script_lang_js_=form_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/form/src/form-item.vue
/* normalize component */var form_item_component=normalizeComponent(src_form_itemvue_type_script_lang_js_,form_itemvue_type_template_id_b6f3db6c_render,form_itemvue_type_template_id_b6f3db6c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var form_item_api;}form_item_component.options.__file="packages/form/src/form-item.vue";/* harmony default export */var form_item=form_item_component.exports;// CONCATENATED MODULE: ./packages/form-item/index.js
/* istanbul ignore next */form_item.install=function(Vue){Vue.component(form_item.name,form_item);};/* harmony default export */var packages_form_item=form_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
var tab_barvue_type_template_id_2031f33a_render=function tab_barvue_type_template_id_2031f33a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-tabs__active-bar",class:"is-"+_vm.rootTabs.tabPosition,style:_vm.barStyle});};var tab_barvue_type_template_id_2031f33a_staticRenderFns=[];tab_barvue_type_template_id_2031f33a_render._withStripped=true;// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=template&id=2031f33a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
//
//
//
/* harmony default export */var tab_barvue_type_script_lang_js_={name:'TabBar',props:{tabs:Array},inject:['rootTabs'],computed:{barStyle:{get:function get(){var _this=this;var style={};var offset=0;var tabSize=0;var sizeName=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'width':'height';var sizeDir=sizeName==='width'?'x':'y';var firstUpperCase=function firstUpperCase(str){return str.toLowerCase().replace(/( |^)[a-z]/g,function(L){return L.toUpperCase();});};this.tabs.every(function(tab,index){var $el=Object(util_["arrayFind"])(_this.$parent.$refs.tabs||[],function(t){return t.id.replace('tab-','')===tab.paneName;});if(!$el){return false;}if(!tab.active){offset+=$el['client'+firstUpperCase(sizeName)];return true;}else{tabSize=$el['client'+firstUpperCase(sizeName)];var tabStyles=window.getComputedStyle($el);if(sizeName==='width'&&_this.tabs.length>1){tabSize-=parseFloat(tabStyles.paddingLeft)+parseFloat(tabStyles.paddingRight);}if(sizeName==='width'){offset+=parseFloat(tabStyles.paddingLeft);}return false;}});var transform='translate'+firstUpperCase(sizeDir)+'('+offset+'px)';style[sizeName]=tabSize+'px';style.transform=transform;style.msTransform=transform;style.webkitTransform=transform;return style;}}}};// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_barvue_type_script_lang_js_=tab_barvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-bar.vue
/* normalize component */var tab_bar_component=normalizeComponent(src_tab_barvue_type_script_lang_js_,tab_barvue_type_template_id_2031f33a_render,tab_barvue_type_template_id_2031f33a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_bar_api;}tab_bar_component.options.__file="packages/tabs/src/tab-bar.vue";/* harmony default export */var tab_bar=tab_bar_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
function noop(){}var tab_navvue_type_script_lang_js_firstUpperCase=function firstUpperCase(str){return str.toLowerCase().replace(/( |^)[a-z]/g,function(L){return L.toUpperCase();});};/* harmony default export */var tab_navvue_type_script_lang_js_={name:'TabNav',components:{TabBar:tab_bar},inject:['rootTabs'],props:{panes:Array,currentName:String,editable:Boolean,onTabClick:{type:Function,default:noop},onTabRemove:{type:Function,default:noop},type:String,stretch:Boolean},data:function data(){return{scrollable:false,navOffset:0,isFocus:false,focusable:true};},computed:{navStyle:function navStyle(){var dir=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'X':'Y';return{transform:'translate'+dir+'(-'+this.navOffset+'px)'};},sizeName:function sizeName(){return['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'width':'height';}},methods:{scrollPrev:function scrollPrev(){var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var currentOffset=this.navOffset;if(!currentOffset)return;var newOffset=currentOffset>containerSize?currentOffset-containerSize:0;this.navOffset=newOffset;},scrollNext:function scrollNext(){var navSize=this.$refs.nav['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(this.sizeName)];var currentOffset=this.navOffset;if(navSize-currentOffset<=containerSize)return;var newOffset=navSize-currentOffset>containerSize*2?currentOffset+containerSize:navSize-containerSize;this.navOffset=newOffset;},scrollToActiveTab:function scrollToActiveTab(){if(!this.scrollable)return;var nav=this.$refs.nav;var activeTab=this.$el.querySelector('.is-active');if(!activeTab)return;var navScroll=this.$refs.navScroll;var isHorizontal=['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1;var activeTabBounding=activeTab.getBoundingClientRect();var navScrollBounding=navScroll.getBoundingClientRect();var maxOffset=isHorizontal?nav.offsetWidth-navScrollBounding.width:nav.offsetHeight-navScrollBounding.height;var currentOffset=this.navOffset;var newOffset=currentOffset;if(isHorizontal){if(activeTabBounding.left<navScrollBounding.left){newOffset=currentOffset-(navScrollBounding.left-activeTabBounding.left);}if(activeTabBounding.right>navScrollBounding.right){newOffset=currentOffset+activeTabBounding.right-navScrollBounding.right;}}else{if(activeTabBounding.top<navScrollBounding.top){newOffset=currentOffset-(navScrollBounding.top-activeTabBounding.top);}if(activeTabBounding.bottom>navScrollBounding.bottom){newOffset=currentOffset+(activeTabBounding.bottom-navScrollBounding.bottom);}}newOffset=Math.max(newOffset,0);this.navOffset=Math.min(newOffset,maxOffset);},update:function update(){if(!this.$refs.nav)return;var sizeName=this.sizeName;var navSize=this.$refs.nav['offset'+tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];var containerSize=this.$refs.navScroll['offset'+tab_navvue_type_script_lang_js_firstUpperCase(sizeName)];var currentOffset=this.navOffset;if(containerSize<navSize){var _currentOffset=this.navOffset;this.scrollable=this.scrollable||{};this.scrollable.prev=_currentOffset;this.scrollable.next=_currentOffset+containerSize<navSize;if(navSize-_currentOffset<containerSize){this.navOffset=navSize-containerSize;}}else{this.scrollable=false;if(currentOffset>0){this.navOffset=0;}}},changeTab:function changeTab(e){var keyCode=e.keyCode;var nextIndex=void 0;var currentIndex=void 0,tabList=void 0;if([37,38,39,40].indexOf(keyCode)!==-1){// 左右上下键更换tab
tabList=e.currentTarget.querySelectorAll('[role=tab]');currentIndex=Array.prototype.indexOf.call(tabList,e.target);}else{return;}if(keyCode===37||keyCode===38){// left
if(currentIndex===0){// first
nextIndex=tabList.length-1;}else{nextIndex=currentIndex-1;}}else{// right
if(currentIndex<tabList.length-1){// not last
nextIndex=currentIndex+1;}else{nextIndex=0;}}tabList[nextIndex].focus();// 改变焦点元素
tabList[nextIndex].click();// 选中下一个tab
this.setFocus();},setFocus:function setFocus(){if(this.focusable){this.isFocus=true;}},removeFocus:function removeFocus(){this.isFocus=false;},visibilityChangeHandler:function visibilityChangeHandler(){var _this=this;var visibility=document.visibilityState;if(visibility==='hidden'){this.focusable=false;}else if(visibility==='visible'){setTimeout(function(){_this.focusable=true;},50);}},windowBlurHandler:function windowBlurHandler(){this.focusable=false;},windowFocusHandler:function windowFocusHandler(){var _this2=this;setTimeout(function(){_this2.focusable=true;},50);}},updated:function updated(){this.update();},render:function render(h){var _this3=this;var type=this.type,panes=this.panes,editable=this.editable,stretch=this.stretch,onTabClick=this.onTabClick,onTabRemove=this.onTabRemove,navStyle=this.navStyle,scrollable=this.scrollable,scrollNext=this.scrollNext,scrollPrev=this.scrollPrev,changeTab=this.changeTab,setFocus=this.setFocus,removeFocus=this.removeFocus;var scrollBtn=scrollable?[h('span',{'class':['el-tabs__nav-prev',scrollable.prev?'':'is-disabled'],on:{'click':scrollPrev}},[h('i',{'class':'el-icon-arrow-left'})]),h('span',{'class':['el-tabs__nav-next',scrollable.next?'':'is-disabled'],on:{'click':scrollNext}},[h('i',{'class':'el-icon-arrow-right'})])]:null;var tabs=this._l(panes,function(pane,index){var _ref;var tabName=pane.name||pane.index||index;var closable=pane.isClosable||editable;pane.index=''+index;var btnClose=closable?h('span',{'class':'el-icon-close',on:{'click':function click(ev){onTabRemove(pane,ev);}}}):null;var tabLabelContent=pane.$slots.label||pane.label;var tabindex=pane.active?0:-1;return h('div',{'class':(_ref={'el-tabs__item':true},_ref['is-'+_this3.rootTabs.tabPosition]=true,_ref['is-active']=pane.active,_ref['is-disabled']=pane.disabled,_ref['is-closable']=closable,_ref['is-focus']=_this3.isFocus,_ref),attrs:{id:'tab-'+tabName,'aria-controls':'pane-'+tabName,role:'tab','aria-selected':pane.active,tabindex:tabindex},key:'tab-'+tabName,ref:'tabs',refInFor:true,on:{'focus':function focus(){setFocus();},'blur':function blur(){removeFocus();},'click':function click(ev){removeFocus();onTabClick(pane,tabName,ev);},'keydown':function keydown(ev){if(closable&&(ev.keyCode===46||ev.keyCode===8)){onTabRemove(pane,ev);}}}},[tabLabelContent,btnClose]);});return h('div',{'class':['el-tabs__nav-wrap',scrollable?'is-scrollable':'','is-'+this.rootTabs.tabPosition]},[scrollBtn,h('div',{'class':['el-tabs__nav-scroll'],ref:'navScroll'},[h('div',{'class':['el-tabs__nav','is-'+this.rootTabs.tabPosition,stretch&&['top','bottom'].indexOf(this.rootTabs.tabPosition)!==-1?'is-stretch':''],ref:'nav',style:navStyle,attrs:{role:'tablist'},on:{'keydown':changeTab}},[!type?h('tab-bar',{attrs:{tabs:panes}}):null,tabs])])]);},mounted:function mounted(){var _this4=this;Object(resize_event_["addResizeListener"])(this.$el,this.update);document.addEventListener('visibilitychange',this.visibilityChangeHandler);window.addEventListener('blur',this.windowBlurHandler);window.addEventListener('focus',this.windowFocusHandler);setTimeout(function(){_this4.scrollToActiveTab();},0);},beforeDestroy:function beforeDestroy(){if(this.$el&&this.update)Object(resize_event_["removeResizeListener"])(this.$el,this.update);document.removeEventListener('visibilitychange',this.visibilityChangeHandler);window.removeEventListener('blur',this.windowBlurHandler);window.removeEventListener('focus',this.windowFocusHandler);}};// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_navvue_type_script_lang_js_=tab_navvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-nav.vue
var tab_nav_render,tab_nav_staticRenderFns;/* normalize component */var tab_nav_component=normalizeComponent(src_tab_navvue_type_script_lang_js_,tab_nav_render,tab_nav_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_nav_api;}tab_nav_component.options.__file="packages/tabs/src/tab-nav.vue";/* harmony default export */var tab_nav=tab_nav_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
/* harmony default export */var tabsvue_type_script_lang_js_={name:'ElTabs',components:{TabNav:tab_nav},props:{type:String,activeName:String,closable:Boolean,addable:Boolean,value:{},editable:Boolean,tabPosition:{type:String,default:'top'},beforeLeave:Function,stretch:Boolean},provide:function provide(){return{rootTabs:this};},data:function data(){return{currentName:this.value||this.activeName,panes:[]};},watch:{activeName:function activeName(value){this.setCurrentName(value);},value:function value(_value){this.setCurrentName(_value);},currentName:function currentName(value){var _this=this;if(this.$refs.nav){this.$nextTick(function(){_this.$refs.nav.$nextTick(function(_){_this.$refs.nav.scrollToActiveTab();});});}}},methods:{calcPaneInstances:function calcPaneInstances(){var _this2=this;var isForceUpdate=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;if(this.$slots.default){var paneSlots=this.$slots.default.filter(function(vnode){return vnode.tag&&vnode.componentOptions&&vnode.componentOptions.Ctor.options.name==='ElTabPane';});// update indeed
var panes=paneSlots.map(function(_ref){var componentInstance=_ref.componentInstance;return componentInstance;});var panesChanged=!(panes.length===this.panes.length&&panes.every(function(pane,index){return pane===_this2.panes[index];}));if(isForceUpdate||panesChanged){this.panes=panes;}}else if(this.panes.length!==0){this.panes=[];}},handleTabClick:function handleTabClick(tab,tabName,event){if(tab.disabled)return;this.setCurrentName(tabName);this.$emit('tab-click',tab,event);},handleTabRemove:function handleTabRemove(pane,ev){if(pane.disabled)return;ev.stopPropagation();this.$emit('edit',pane.name,'remove');this.$emit('tab-remove',pane.name);},handleTabAdd:function handleTabAdd(){this.$emit('edit',null,'add');this.$emit('tab-add');},setCurrentName:function setCurrentName(value){var _this3=this;var changeCurrentName=function changeCurrentName(){_this3.currentName=value;_this3.$emit('input',value);};if(this.currentName!==value&&this.beforeLeave){var before=this.beforeLeave(value,this.currentName);if(before&&before.then){before.then(function(){changeCurrentName();_this3.$refs.nav&&_this3.$refs.nav.removeFocus();},function(){// https://github.com/ElemeFE/element/pull/14816
// ignore promise rejection in `before-leave` hook
});}else if(before!==false){changeCurrentName();}}else{changeCurrentName();}}},render:function render(h){var _ref2;var type=this.type,handleTabClick=this.handleTabClick,handleTabRemove=this.handleTabRemove,handleTabAdd=this.handleTabAdd,currentName=this.currentName,panes=this.panes,editable=this.editable,addable=this.addable,tabPosition=this.tabPosition,stretch=this.stretch;var newButton=editable||addable?h('span',{'class':'el-tabs__new-tab',on:{'click':handleTabAdd,'keydown':function keydown(ev){if(ev.keyCode===13){handleTabAdd();}}},attrs:{tabindex:'0'}},[h('i',{'class':'el-icon-plus'})]):null;var navData={props:{currentName:currentName,onTabClick:handleTabClick,onTabRemove:handleTabRemove,editable:editable,type:type,panes:panes,stretch:stretch},ref:'nav'};var header=h('div',{'class':['el-tabs__header','is-'+tabPosition]},[newButton,h('tab-nav',navData)]);var panels=h('div',{'class':'el-tabs__content'},[this.$slots.default]);return h('div',{'class':(_ref2={'el-tabs':true,'el-tabs--card':type==='card'},_ref2['el-tabs--'+tabPosition]=true,_ref2['el-tabs--border-card']=type==='border-card',_ref2)},[tabPosition!=='bottom'?[header,panels]:[panels,header]]);},created:function created(){if(!this.currentName){this.setCurrentName('0');}this.$on('tab-nav-update',this.calcPaneInstances.bind(null,true));},mounted:function mounted(){this.calcPaneInstances();},updated:function updated(){this.calcPaneInstances();}};// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue?vue&type=script&lang=js&
/* harmony default export */var src_tabsvue_type_script_lang_js_=tabsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tabs.vue
var tabs_render,tabs_staticRenderFns;/* normalize component */var tabs_component=normalizeComponent(src_tabsvue_type_script_lang_js_,tabs_render,tabs_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tabs_api;}tabs_component.options.__file="packages/tabs/src/tabs.vue";/* harmony default export */var tabs=tabs_component.exports;// CONCATENATED MODULE: ./packages/tabs/index.js
/* istanbul ignore next */tabs.install=function(Vue){Vue.component(tabs.name,tabs);};/* harmony default export */var packages_tabs=tabs;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
var tab_panevue_type_template_id_9145a070_render=function tab_panevue_type_template_id_9145a070_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return!_vm.lazy||_vm.loaded||_vm.active?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.active,expression:"active"}],staticClass:"el-tab-pane",attrs:{role:"tabpanel","aria-hidden":!_vm.active,id:"pane-"+_vm.paneName,"aria-labelledby":"tab-"+_vm.paneName}},[_vm._t("default")],2):_vm._e();};var tab_panevue_type_template_id_9145a070_staticRenderFns=[];tab_panevue_type_template_id_9145a070_render._withStripped=true;// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=template&id=9145a070&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var tab_panevue_type_script_lang_js_={name:'ElTabPane',componentName:'ElTabPane',props:{label:String,labelContent:Function,name:String,closable:Boolean,disabled:Boolean,lazy:Boolean},data:function data(){return{index:null,loaded:false};},computed:{isClosable:function isClosable(){return this.closable||this.$parent.closable;},active:function active(){var active=this.$parent.currentName===(this.name||this.index);if(active){this.loaded=true;}return active;},paneName:function paneName(){return this.name||this.index;}},updated:function updated(){this.$parent.$emit('tab-nav-update');}};// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue?vue&type=script&lang=js&
/* harmony default export */var src_tab_panevue_type_script_lang_js_=tab_panevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tabs/src/tab-pane.vue
/* normalize component */var tab_pane_component=normalizeComponent(src_tab_panevue_type_script_lang_js_,tab_panevue_type_template_id_9145a070_render,tab_panevue_type_template_id_9145a070_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tab_pane_api;}tab_pane_component.options.__file="packages/tabs/src/tab-pane.vue";/* harmony default export */var tab_pane=tab_pane_component.exports;// CONCATENATED MODULE: ./packages/tab-pane/index.js
/* istanbul ignore next */tab_pane.install=function(Vue){Vue.component(tab_pane.name,tab_pane);};/* harmony default export */var packages_tab_pane=tab_pane;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&
/* harmony default export */var tagvue_type_script_lang_js_={name:'ElTag',props:{text:String,closable:Boolean,type:String,hit:Boolean,disableTransitions:Boolean,color:String,size:String,effect:{type:String,default:'light',validator:function validator(val){return['dark','light','plain'].indexOf(val)!==-1;}}},methods:{handleClose:function handleClose(event){event.stopPropagation();this.$emit('close',event);},handleClick:function handleClick(event){this.$emit('click',event);}},computed:{tagSize:function tagSize(){return this.size||(this.$ELEMENT||{}).size;}},render:function render(h){var type=this.type,tagSize=this.tagSize,hit=this.hit,effect=this.effect;var classes=['el-tag',type?'el-tag--'+type:'',tagSize?'el-tag--'+tagSize:'',effect?'el-tag--'+effect:'',hit&&'is-hit'];var tagEl=h('span',{'class':classes,style:{backgroundColor:this.color},on:{'click':this.handleClick}},[this.$slots.default,this.closable&&h('i',{'class':'el-tag__close el-icon-close',on:{'click':this.handleClose}})]);return this.disableTransitions?tagEl:h('transition',{attrs:{name:'el-zoom-in-center'}},[tagEl]);}};// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
/* harmony default export */var src_tagvue_type_script_lang_js_=tagvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tag/src/tag.vue
var tag_render,tag_staticRenderFns;/* normalize component */var tag_component=normalizeComponent(src_tagvue_type_script_lang_js_,tag_render,tag_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tag_api;}tag_component.options.__file="packages/tag/src/tag.vue";/* harmony default export */var src_tag=tag_component.exports;// CONCATENATED MODULE: ./packages/tag/index.js
/* istanbul ignore next */src_tag.install=function(Vue){Vue.component(src_tag.name,src_tag);};/* harmony default export */var packages_tag=src_tag;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
var treevue_type_template_id_547575a6_render=function treevue_type_template_id_547575a6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-tree",class:{"el-tree--highlight-current":_vm.highlightCurrent,"is-dragging":!!_vm.dragState.draggingNode,"is-drop-not-allow":!_vm.dragState.allowDrop,"is-drop-inner":_vm.dragState.dropType==="inner"},attrs:{role:"tree"}},[_vm._l(_vm.root.childNodes,function(child){return _c("el-tree-node",{key:_vm.getNodeKey(child),attrs:{node:child,props:_vm.props,"render-after-expand":_vm.renderAfterExpand,"show-checkbox":_vm.showCheckbox,"render-content":_vm.renderContent},on:{"node-expand":_vm.handleNodeExpand}});}),_vm.isEmpty?_c("div",{staticClass:"el-tree__empty-block"},[_c("span",{staticClass:"el-tree__empty-text"},[_vm._v(_vm._s(_vm.emptyText))])]):_vm._e(),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.dragState.showDropIndicator,expression:"dragState.showDropIndicator"}],ref:"dropIndicator",staticClass:"el-tree__drop-indicator"})],2);};var treevue_type_template_id_547575a6_staticRenderFns=[];treevue_type_template_id_547575a6_render._withStripped=true;// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=template&id=547575a6&
// CONCATENATED MODULE: ./packages/tree/src/model/util.js
var NODE_KEY='$treeNodeId';var markNodeData=function markNodeData(node,data){if(!data||data[NODE_KEY])return;Object.defineProperty(data,NODE_KEY,{value:node.id,enumerable:false,configurable:false,writable:false});};var util_getNodeKey=function getNodeKey(key,data){if(!key)return data[NODE_KEY];return data[key];};var findNearestComponent=function findNearestComponent(element,componentName){var target=element;while(target&&target.tagName!=='BODY'){if(target.__vue__&&target.__vue__.$options.name===componentName){return target.__vue__;}target=target.parentNode;}return null;};// CONCATENATED MODULE: ./packages/tree/src/model/node.js
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function node_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var getChildState=function getChildState(node){var all=true;var none=true;var allWithoutDisable=true;for(var i=0,j=node.length;i<j;i++){var n=node[i];if(n.checked!==true||n.indeterminate){all=false;if(!n.disabled){allWithoutDisable=false;}}if(n.checked!==false||n.indeterminate){none=false;}}return{all:all,none:none,allWithoutDisable:allWithoutDisable,half:!all&&!none};};var reInitChecked=function reInitChecked(node){if(node.childNodes.length===0)return;var _getChildState=getChildState(node.childNodes),all=_getChildState.all,none=_getChildState.none,half=_getChildState.half;if(all){node.checked=true;node.indeterminate=false;}else if(half){node.checked=false;node.indeterminate=true;}else if(none){node.checked=false;node.indeterminate=false;}var parent=node.parent;if(!parent||parent.level===0)return;if(!node.store.checkStrictly){reInitChecked(parent);}};var getPropertyFromData=function getPropertyFromData(node,prop){var props=node.store.props;var data=node.data||{};var config=props[prop];if(typeof config==='function'){return config(data,node);}else if(typeof config==='string'){return data[config];}else if(typeof config==='undefined'){var dataProp=data[prop];return dataProp===undefined?'':dataProp;}};var nodeIdSeed=0;var node_Node=function(){function Node(options){node_classCallCheck(this,Node);this.id=nodeIdSeed++;this.text=null;this.checked=false;this.indeterminate=false;this.data=null;this.expanded=false;this.parent=null;this.visible=true;this.isCurrent=false;for(var name in options){if(options.hasOwnProperty(name)){this[name]=options[name];}}// internal
this.level=0;this.loaded=false;this.childNodes=[];this.loading=false;if(this.parent){this.level=this.parent.level+1;}var store=this.store;if(!store){throw new Error('[Node]store is required!');}store.registerNode(this);var props=store.props;if(props&&typeof props.isLeaf!=='undefined'){var isLeaf=getPropertyFromData(this,'isLeaf');if(typeof isLeaf==='boolean'){this.isLeafByUser=isLeaf;}}if(store.lazy!==true&&this.data){this.setData(this.data);if(store.defaultExpandAll){this.expanded=true;}}else if(this.level>0&&store.lazy&&store.defaultExpandAll){this.expand();}if(!Array.isArray(this.data)){markNodeData(this,this.data);}if(!this.data)return;var defaultExpandedKeys=store.defaultExpandedKeys;var key=store.key;if(key&&defaultExpandedKeys&&defaultExpandedKeys.indexOf(this.key)!==-1){this.expand(null,store.autoExpandParent);}if(key&&store.currentNodeKey!==undefined&&this.key===store.currentNodeKey){store.currentNode=this;store.currentNode.isCurrent=true;}if(store.lazy){store._initDefaultCheckedNode(this);}this.updateLeafState();}Node.prototype.setData=function setData(data){if(!Array.isArray(data)){markNodeData(this,data);}this.data=data;this.childNodes=[];var children=void 0;if(this.level===0&&this.data instanceof Array){children=this.data;}else{children=getPropertyFromData(this,'children')||[];}for(var i=0,j=children.length;i<j;i++){this.insertChild({data:children[i]});}};Node.prototype.contains=function contains(target){var deep=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var walk=function walk(parent){var children=parent.childNodes||[];var result=false;for(var i=0,j=children.length;i<j;i++){var child=children[i];if(child===target||deep&&walk(child)){result=true;break;}}return result;};return walk(this);};Node.prototype.remove=function remove(){var parent=this.parent;if(parent){parent.removeChild(this);}};Node.prototype.insertChild=function insertChild(child,index,batch){if(!child)throw new Error('insertChild error: child is required.');if(!(child instanceof Node)){if(!batch){var children=this.getChildren(true)||[];if(children.indexOf(child.data)===-1){if(typeof index==='undefined'||index<0){children.push(child.data);}else{children.splice(index,0,child.data);}}}merge_default()(child,{parent:this,store:this.store});child=new Node(child);}child.level=this.level+1;if(typeof index==='undefined'||index<0){this.childNodes.push(child);}else{this.childNodes.splice(index,0,child);}this.updateLeafState();};Node.prototype.insertBefore=function insertBefore(child,ref){var index=void 0;if(ref){index=this.childNodes.indexOf(ref);}this.insertChild(child,index);};Node.prototype.insertAfter=function insertAfter(child,ref){var index=void 0;if(ref){index=this.childNodes.indexOf(ref);if(index!==-1)index+=1;}this.insertChild(child,index);};Node.prototype.removeChild=function removeChild(child){var children=this.getChildren()||[];var dataIndex=children.indexOf(child.data);if(dataIndex>-1){children.splice(dataIndex,1);}var index=this.childNodes.indexOf(child);if(index>-1){this.store&&this.store.deregisterNode(child);child.parent=null;this.childNodes.splice(index,1);}this.updateLeafState();};Node.prototype.removeChildByData=function removeChildByData(data){var targetNode=null;for(var i=0;i<this.childNodes.length;i++){if(this.childNodes[i].data===data){targetNode=this.childNodes[i];break;}}if(targetNode){this.removeChild(targetNode);}};Node.prototype.expand=function expand(callback,expandParent){var _this=this;var done=function done(){if(expandParent){var parent=_this.parent;while(parent.level>0){parent.expanded=true;parent=parent.parent;}}_this.expanded=true;if(callback)callback();};if(this.shouldLoadData()){this.loadData(function(data){if(data instanceof Array){if(_this.checked){_this.setChecked(true,true);}else if(!_this.store.checkStrictly){reInitChecked(_this);}done();}});}else{done();}};Node.prototype.doCreateChildren=function doCreateChildren(array){var _this2=this;var defaultProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};array.forEach(function(item){_this2.insertChild(merge_default()({data:item},defaultProps),undefined,true);});};Node.prototype.collapse=function collapse(){this.expanded=false;};Node.prototype.shouldLoadData=function shouldLoadData(){return this.store.lazy===true&&this.store.load&&!this.loaded;};Node.prototype.updateLeafState=function updateLeafState(){if(this.store.lazy===true&&this.loaded!==true&&typeof this.isLeafByUser!=='undefined'){this.isLeaf=this.isLeafByUser;return;}var childNodes=this.childNodes;if(!this.store.lazy||this.store.lazy===true&&this.loaded===true){this.isLeaf=!childNodes||childNodes.length===0;return;}this.isLeaf=false;};Node.prototype.setChecked=function setChecked(value,deep,recursion,passValue){var _this3=this;this.indeterminate=value==='half';this.checked=value===true;if(this.store.checkStrictly)return;if(!(this.shouldLoadData()&&!this.store.checkDescendants)){var _getChildState2=getChildState(this.childNodes),all=_getChildState2.all,allWithoutDisable=_getChildState2.allWithoutDisable;if(!this.isLeaf&&!all&&allWithoutDisable){this.checked=false;value=false;}var handleDescendants=function handleDescendants(){if(deep){var childNodes=_this3.childNodes;for(var i=0,j=childNodes.length;i<j;i++){var child=childNodes[i];passValue=passValue||value!==false;var isCheck=child.disabled?child.checked:passValue;child.setChecked(isCheck,deep,true,passValue);}var _getChildState3=getChildState(childNodes),half=_getChildState3.half,_all=_getChildState3.all;if(!_all){_this3.checked=_all;_this3.indeterminate=half;}}};if(this.shouldLoadData()){// Only work on lazy load data.
this.loadData(function(){handleDescendants();reInitChecked(_this3);},{checked:value!==false});return;}else{handleDescendants();}}var parent=this.parent;if(!parent||parent.level===0)return;if(!recursion){reInitChecked(parent);}};Node.prototype.getChildren=function getChildren(){var forceInit=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;// this is data
if(this.level===0)return this.data;var data=this.data;if(!data)return null;var props=this.store.props;var children='children';if(props){children=props.children||'children';}if(data[children]===undefined){data[children]=null;}if(forceInit&&!data[children]){data[children]=[];}return data[children];};Node.prototype.updateChildren=function updateChildren(){var _this4=this;var newData=this.getChildren()||[];var oldData=this.childNodes.map(function(node){return node.data;});var newDataMap={};var newNodes=[];newData.forEach(function(item,index){var key=item[NODE_KEY];var isNodeExists=!!key&&Object(util_["arrayFindIndex"])(oldData,function(data){return data[NODE_KEY]===key;})>=0;if(isNodeExists){newDataMap[key]={index:index,data:item};}else{newNodes.push({index:index,data:item});}});if(!this.store.lazy){oldData.forEach(function(item){if(!newDataMap[item[NODE_KEY]])_this4.removeChildByData(item);});}newNodes.forEach(function(_ref){var index=_ref.index,data=_ref.data;_this4.insertChild({data:data},index);});this.updateLeafState();};Node.prototype.loadData=function loadData(callback){var _this5=this;var defaultProps=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(this.store.lazy===true&&this.store.load&&!this.loaded&&(!this.loading||Object.keys(defaultProps).length)){this.loading=true;var resolve=function resolve(children){_this5.loaded=true;_this5.loading=false;_this5.childNodes=[];_this5.doCreateChildren(children,defaultProps);_this5.updateLeafState();if(callback){callback.call(_this5,children);}};this.store.load(this,resolve);}else{if(callback){callback.call(this);}}};_createClass(Node,[{key:'label',get:function get(){return getPropertyFromData(this,'label');}},{key:'key',get:function get(){var nodeKey=this.store.key;if(this.data)return this.data[nodeKey];return null;}},{key:'disabled',get:function get(){return getPropertyFromData(this,'disabled');}},{key:'nextSibling',get:function get(){var parent=this.parent;if(parent){var index=parent.childNodes.indexOf(this);if(index>-1){return parent.childNodes[index+1];}}return null;}},{key:'previousSibling',get:function get(){var parent=this.parent;if(parent){var index=parent.childNodes.indexOf(this);if(index>-1){return index>0?parent.childNodes[index-1]:null;}}return null;}}]);return Node;}();/* harmony default export */var model_node=node_Node;// CONCATENATED MODULE: ./packages/tree/src/model/tree-store.js
var tree_store_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};function tree_store_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var tree_store_TreeStore=function(){function TreeStore(options){var _this=this;tree_store_classCallCheck(this,TreeStore);this.currentNode=null;this.currentNodeKey=null;for(var option in options){if(options.hasOwnProperty(option)){this[option]=options[option];}}this.nodesMap={};this.root=new model_node({data:this.data,store:this});if(this.lazy&&this.load){var loadFn=this.load;loadFn(this.root,function(data){_this.root.doCreateChildren(data);_this._initDefaultCheckedNodes();});}else{this._initDefaultCheckedNodes();}}TreeStore.prototype.filter=function filter(value){var filterNodeMethod=this.filterNodeMethod;var lazy=this.lazy;var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){child.visible=filterNodeMethod.call(child,value,child.data,child);traverse(child);});if(!node.visible&&childNodes.length){var allHidden=true;allHidden=!childNodes.some(function(child){return child.visible;});if(node.root){node.root.visible=allHidden===false;}else{node.visible=allHidden===false;}}if(!value)return;if(node.visible&&!node.isLeaf&&!lazy)node.expand();};traverse(this);};TreeStore.prototype.setData=function setData(newVal){var instanceChanged=newVal!==this.root.data;if(instanceChanged){this.root.setData(newVal);this._initDefaultCheckedNodes();}else{this.root.updateChildren();}};TreeStore.prototype.getNode=function getNode(data){if(data instanceof model_node)return data;var key=(typeof data==='undefined'?'undefined':tree_store_typeof(data))!=='object'?data:util_getNodeKey(this.key,data);return this.nodesMap[key]||null;};TreeStore.prototype.insertBefore=function insertBefore(data,refData){var refNode=this.getNode(refData);refNode.parent.insertBefore({data:data},refNode);};TreeStore.prototype.insertAfter=function insertAfter(data,refData){var refNode=this.getNode(refData);refNode.parent.insertAfter({data:data},refNode);};TreeStore.prototype.remove=function remove(data){var node=this.getNode(data);if(node&&node.parent){if(node===this.currentNode){this.currentNode=null;}node.parent.removeChild(node);}};TreeStore.prototype.append=function append(data,parentData){var parentNode=parentData?this.getNode(parentData):this.root;if(parentNode){parentNode.insertChild({data:data});}};TreeStore.prototype._initDefaultCheckedNodes=function _initDefaultCheckedNodes(){var _this2=this;var defaultCheckedKeys=this.defaultCheckedKeys||[];var nodesMap=this.nodesMap;defaultCheckedKeys.forEach(function(checkedKey){var node=nodesMap[checkedKey];if(node){node.setChecked(true,!_this2.checkStrictly);}});};TreeStore.prototype._initDefaultCheckedNode=function _initDefaultCheckedNode(node){var defaultCheckedKeys=this.defaultCheckedKeys||[];if(defaultCheckedKeys.indexOf(node.key)!==-1){node.setChecked(true,!this.checkStrictly);}};TreeStore.prototype.setDefaultCheckedKey=function setDefaultCheckedKey(newVal){if(newVal!==this.defaultCheckedKeys){this.defaultCheckedKeys=newVal;this._initDefaultCheckedNodes();}};TreeStore.prototype.registerNode=function registerNode(node){var key=this.key;if(!key||!node||!node.data)return;var nodeKey=node.key;if(nodeKey!==undefined)this.nodesMap[node.key]=node;};TreeStore.prototype.deregisterNode=function deregisterNode(node){var _this3=this;var key=this.key;if(!key||!node||!node.data)return;node.childNodes.forEach(function(child){_this3.deregisterNode(child);});delete this.nodesMap[node.key];};TreeStore.prototype.getCheckedNodes=function getCheckedNodes(){var leafOnly=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var includeHalfChecked=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var checkedNodes=[];var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){if((child.checked||includeHalfChecked&&child.indeterminate)&&(!leafOnly||leafOnly&&child.isLeaf)){checkedNodes.push(child.data);}traverse(child);});};traverse(this);return checkedNodes;};TreeStore.prototype.getCheckedKeys=function getCheckedKeys(){var _this4=this;var leafOnly=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return this.getCheckedNodes(leafOnly).map(function(data){return(data||{})[_this4.key];});};TreeStore.prototype.getHalfCheckedNodes=function getHalfCheckedNodes(){var nodes=[];var traverse=function traverse(node){var childNodes=node.root?node.root.childNodes:node.childNodes;childNodes.forEach(function(child){if(child.indeterminate){nodes.push(child.data);}traverse(child);});};traverse(this);return nodes;};TreeStore.prototype.getHalfCheckedKeys=function getHalfCheckedKeys(){var _this5=this;return this.getHalfCheckedNodes().map(function(data){return(data||{})[_this5.key];});};TreeStore.prototype._getAllNodes=function _getAllNodes(){var allNodes=[];var nodesMap=this.nodesMap;for(var nodeKey in nodesMap){if(nodesMap.hasOwnProperty(nodeKey)){allNodes.push(nodesMap[nodeKey]);}}return allNodes;};TreeStore.prototype.updateChildren=function updateChildren(key,data){var node=this.nodesMap[key];if(!node)return;var childNodes=node.childNodes;for(var i=childNodes.length-1;i>=0;i--){var child=childNodes[i];this.remove(child.data);}for(var _i=0,j=data.length;_i<j;_i++){var _child=data[_i];this.append(_child,node.data);}};TreeStore.prototype._setCheckedKeys=function _setCheckedKeys(key){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var checkedKeys=arguments[2];var allNodes=this._getAllNodes().sort(function(a,b){return b.level-a.level;});var cache=Object.create(null);var keys=Object.keys(checkedKeys);allNodes.forEach(function(node){return node.setChecked(false,false);});for(var i=0,j=allNodes.length;i<j;i++){var node=allNodes[i];var nodeKey=node.data[key].toString();var checked=keys.indexOf(nodeKey)>-1;if(!checked){if(node.checked&&!cache[nodeKey]){node.setChecked(false,false);}continue;}var parent=node.parent;while(parent&&parent.level>0){cache[parent.data[key]]=true;parent=parent.parent;}if(node.isLeaf||this.checkStrictly){node.setChecked(true,false);continue;}node.setChecked(true,true);if(leafOnly){(function(){node.setChecked(false,false);var traverse=function traverse(node){var childNodes=node.childNodes;childNodes.forEach(function(child){if(!child.isLeaf){child.setChecked(false,false);}traverse(child);});};traverse(node);})();}}};TreeStore.prototype.setCheckedNodes=function setCheckedNodes(array){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var key=this.key;var checkedKeys={};array.forEach(function(item){checkedKeys[(item||{})[key]]=true;});this._setCheckedKeys(key,leafOnly,checkedKeys);};TreeStore.prototype.setCheckedKeys=function setCheckedKeys(keys){var leafOnly=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;this.defaultCheckedKeys=keys;var key=this.key;var checkedKeys={};keys.forEach(function(key){checkedKeys[key]=true;});this._setCheckedKeys(key,leafOnly,checkedKeys);};TreeStore.prototype.setDefaultExpandedKeys=function setDefaultExpandedKeys(keys){var _this6=this;keys=keys||[];this.defaultExpandedKeys=keys;keys.forEach(function(key){var node=_this6.getNode(key);if(node)node.expand(null,_this6.autoExpandParent);});};TreeStore.prototype.setChecked=function setChecked(data,checked,deep){var node=this.getNode(data);if(node){node.setChecked(!!checked,deep);}};TreeStore.prototype.getCurrentNode=function getCurrentNode(){return this.currentNode;};TreeStore.prototype.setCurrentNode=function setCurrentNode(currentNode){var prevCurrentNode=this.currentNode;if(prevCurrentNode){prevCurrentNode.isCurrent=false;}this.currentNode=currentNode;this.currentNode.isCurrent=true;};TreeStore.prototype.setUserCurrentNode=function setUserCurrentNode(node){var key=node[this.key];var currNode=this.nodesMap[key];this.setCurrentNode(currNode);};TreeStore.prototype.setCurrentNodeKey=function setCurrentNodeKey(key){if(key===null||key===undefined){this.currentNode&&(this.currentNode.isCurrent=false);this.currentNode=null;return;}var node=this.getNode(key);if(node){this.setCurrentNode(node);}};return TreeStore;}();/* harmony default export */var tree_store=tree_store_TreeStore;;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
var tree_nodevue_type_template_id_3ba3ef0e_render=function tree_nodevue_type_template_id_3ba3ef0e_render(){var this$1=this;var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.node.visible,expression:"node.visible"}],ref:"node",staticClass:"el-tree-node",class:{"is-expanded":_vm.expanded,"is-current":_vm.node.isCurrent,"is-hidden":!_vm.node.visible,"is-focusable":!_vm.node.disabled,"is-checked":!_vm.node.disabled&&_vm.node.checked},attrs:{role:"treeitem",tabindex:"-1","aria-expanded":_vm.expanded,"aria-disabled":_vm.node.disabled,"aria-checked":_vm.node.checked,draggable:_vm.tree.draggable},on:{click:function click($event){$event.stopPropagation();return _vm.handleClick($event);},contextmenu:function contextmenu($event){return this$1.handleContextMenu($event);},dragstart:function dragstart($event){$event.stopPropagation();return _vm.handleDragStart($event);},dragover:function dragover($event){$event.stopPropagation();return _vm.handleDragOver($event);},dragend:function dragend($event){$event.stopPropagation();return _vm.handleDragEnd($event);},drop:function drop($event){$event.stopPropagation();return _vm.handleDrop($event);}}},[_c("div",{staticClass:"el-tree-node__content",style:{"padding-left":(_vm.node.level-1)*_vm.tree.indent+"px"}},[_c("span",{class:[{"is-leaf":_vm.node.isLeaf,expanded:!_vm.node.isLeaf&&_vm.expanded},"el-tree-node__expand-icon",_vm.tree.iconClass?_vm.tree.iconClass:"el-icon-caret-right"],on:{click:function click($event){$event.stopPropagation();return _vm.handleExpandIconClick($event);}}}),_vm.showCheckbox?_c("el-checkbox",{attrs:{indeterminate:_vm.node.indeterminate,disabled:!!_vm.node.disabled},on:{change:_vm.handleCheckChange},nativeOn:{click:function click($event){$event.stopPropagation();}},model:{value:_vm.node.checked,callback:function callback($$v){_vm.$set(_vm.node,"checked",$$v);},expression:"node.checked"}}):_vm._e(),_vm.node.loading?_c("span",{staticClass:"el-tree-node__loading-icon el-icon-loading"}):_vm._e(),_c("node-content",{attrs:{node:_vm.node}})],1),_c("el-collapse-transition",[!_vm.renderAfterExpand||_vm.childNodeRendered?_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.expanded,expression:"expanded"}],staticClass:"el-tree-node__children",attrs:{role:"group","aria-expanded":_vm.expanded}},_vm._l(_vm.node.childNodes,function(child){return _c("el-tree-node",{key:_vm.getNodeKey(child),attrs:{"render-content":_vm.renderContent,"render-after-expand":_vm.renderAfterExpand,"show-checkbox":_vm.showCheckbox,node:child},on:{"node-expand":_vm.handleChildNodeExpand}});}),1):_vm._e()])],1);};var tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns=[];tree_nodevue_type_template_id_3ba3ef0e_render._withStripped=true;// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=template&id=3ba3ef0e&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var tree_nodevue_type_script_lang_js_={name:'ElTreeNode',componentName:'ElTreeNode',mixins:[emitter_default.a],props:{node:{default:function _default(){return{};}},props:{},renderContent:Function,renderAfterExpand:{type:Boolean,default:true},showCheckbox:{type:Boolean,default:false}},components:{ElCollapseTransition:collapse_transition_default.a,ElCheckbox:checkbox_default.a,NodeContent:{props:{node:{required:true}},render:function render(h){var parent=this.$parent;var tree=parent.tree;var node=this.node;var data=node.data,store=node.store;return parent.renderContent?parent.renderContent.call(parent._renderProxy,h,{_self:tree.$vnode.context,node:node,data:data,store:store}):tree.$scopedSlots.default?tree.$scopedSlots.default({node:node,data:data}):h('span',{'class':'el-tree-node__label'},[node.label]);}}},data:function data(){return{tree:null,expanded:false,childNodeRendered:false,oldChecked:null,oldIndeterminate:null};},watch:{'node.indeterminate':function nodeIndeterminate(val){this.handleSelectChange(this.node.checked,val);},'node.checked':function nodeChecked(val){this.handleSelectChange(val,this.node.indeterminate);},'node.expanded':function nodeExpanded(val){var _this=this;this.$nextTick(function(){return _this.expanded=val;});if(val){this.childNodeRendered=true;}}},methods:{getNodeKey:function getNodeKey(node){return util_getNodeKey(this.tree.nodeKey,node.data);},handleSelectChange:function handleSelectChange(checked,indeterminate){if(this.oldChecked!==checked&&this.oldIndeterminate!==indeterminate){this.tree.$emit('check-change',this.node.data,checked,indeterminate);}this.oldChecked=checked;this.indeterminate=indeterminate;},handleClick:function handleClick(){var store=this.tree.store;store.setCurrentNode(this.node);this.tree.$emit('current-change',store.currentNode?store.currentNode.data:null,store.currentNode);this.tree.currentNode=this;if(this.tree.expandOnClickNode){this.handleExpandIconClick();}if(this.tree.checkOnClickNode&&!this.node.disabled){this.handleCheckChange(null,{target:{checked:!this.node.checked}});}this.tree.$emit('node-click',this.node.data,this.node,this);},handleContextMenu:function handleContextMenu(event){if(this.tree._events['node-contextmenu']&&this.tree._events['node-contextmenu'].length>0){event.stopPropagation();event.preventDefault();}this.tree.$emit('node-contextmenu',event,this.node.data,this.node,this);},handleExpandIconClick:function handleExpandIconClick(){if(this.node.isLeaf)return;if(this.expanded){this.tree.$emit('node-collapse',this.node.data,this.node,this);this.node.collapse();}else{this.node.expand();this.$emit('node-expand',this.node.data,this.node,this);}},handleCheckChange:function handleCheckChange(value,ev){var _this2=this;this.node.setChecked(ev.target.checked,!this.tree.checkStrictly);this.$nextTick(function(){var store=_this2.tree.store;_this2.tree.$emit('check',_this2.node.data,{checkedNodes:store.getCheckedNodes(),checkedKeys:store.getCheckedKeys(),halfCheckedNodes:store.getHalfCheckedNodes(),halfCheckedKeys:store.getHalfCheckedKeys()});});},handleChildNodeExpand:function handleChildNodeExpand(nodeData,node,instance){this.broadcast('ElTreeNode','tree-node-expand',node);this.tree.$emit('node-expand',nodeData,node,instance);},handleDragStart:function handleDragStart(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-start',event,this);},handleDragOver:function handleDragOver(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-over',event,this);event.preventDefault();},handleDrop:function handleDrop(event){event.preventDefault();},handleDragEnd:function handleDragEnd(event){if(!this.tree.draggable)return;this.tree.$emit('tree-node-drag-end',event,this);}},created:function created(){var _this3=this;var parent=this.$parent;if(parent.isTree){this.tree=parent;}else{this.tree=parent.tree;}var tree=this.tree;if(!tree){console.warn('Can not find node\'s tree.');}var props=tree.props||{};var childrenKey=props['children']||'children';this.$watch('node.data.'+childrenKey,function(){_this3.node.updateChildren();});if(this.node.expanded){this.expanded=true;this.childNodeRendered=true;}if(this.tree.accordion){this.$on('tree-node-expand',function(node){if(_this3.node!==node){_this3.node.collapse();}});}}};// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue?vue&type=script&lang=js&
/* harmony default export */var src_tree_nodevue_type_script_lang_js_=tree_nodevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tree/src/tree-node.vue
/* normalize component */var tree_node_component=normalizeComponent(src_tree_nodevue_type_script_lang_js_,tree_nodevue_type_template_id_3ba3ef0e_render,tree_nodevue_type_template_id_3ba3ef0e_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tree_node_api;}tree_node_component.options.__file="packages/tree/src/tree-node.vue";/* harmony default export */var tree_node=tree_node_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tree/src/tree.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var treevue_type_script_lang_js_={name:'ElTree',mixins:[emitter_default.a],components:{ElTreeNode:tree_node},data:function data(){return{store:null,root:null,currentNode:null,treeItems:null,checkboxItems:[],dragState:{showDropIndicator:false,draggingNode:null,dropNode:null,allowDrop:true}};},props:{data:{type:Array},emptyText:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.tree.emptyText');}},renderAfterExpand:{type:Boolean,default:true},nodeKey:String,checkStrictly:Boolean,defaultExpandAll:Boolean,expandOnClickNode:{type:Boolean,default:true},checkOnClickNode:Boolean,checkDescendants:{type:Boolean,default:false},autoExpandParent:{type:Boolean,default:true},defaultCheckedKeys:Array,defaultExpandedKeys:Array,currentNodeKey:[String,Number],renderContent:Function,showCheckbox:{type:Boolean,default:false},draggable:{type:Boolean,default:false},allowDrag:Function,allowDrop:Function,props:{default:function _default(){return{children:'children',label:'label',disabled:'disabled'};}},lazy:{type:Boolean,default:false},highlightCurrent:Boolean,load:Function,filterNodeMethod:Function,accordion:Boolean,indent:{type:Number,default:18},iconClass:String},computed:{children:{set:function set(value){this.data=value;},get:function get(){return this.data;}},treeItemArray:function treeItemArray(){return Array.prototype.slice.call(this.treeItems);},isEmpty:function isEmpty(){var childNodes=this.root.childNodes;return!childNodes||childNodes.length===0||childNodes.every(function(_ref){var visible=_ref.visible;return!visible;});}},watch:{defaultCheckedKeys:function defaultCheckedKeys(newVal){this.store.setDefaultCheckedKey(newVal);},defaultExpandedKeys:function defaultExpandedKeys(newVal){this.store.defaultExpandedKeys=newVal;this.store.setDefaultExpandedKeys(newVal);},data:function data(newVal){this.store.setData(newVal);},checkboxItems:function checkboxItems(val){Array.prototype.forEach.call(val,function(checkbox){checkbox.setAttribute('tabindex',-1);});},checkStrictly:function checkStrictly(newVal){this.store.checkStrictly=newVal;}},methods:{filter:function filter(value){if(!this.filterNodeMethod)throw new Error('[Tree] filterNodeMethod is required when filter');this.store.filter(value);},getNodeKey:function getNodeKey(node){return util_getNodeKey(this.nodeKey,node.data);},getNodePath:function getNodePath(data){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in getNodePath');var node=this.store.getNode(data);if(!node)return[];var path=[node.data];var parent=node.parent;while(parent&&parent!==this.root){path.push(parent.data);parent=parent.parent;}return path.reverse();},getCheckedNodes:function getCheckedNodes(leafOnly,includeHalfChecked){return this.store.getCheckedNodes(leafOnly,includeHalfChecked);},getCheckedKeys:function getCheckedKeys(leafOnly){return this.store.getCheckedKeys(leafOnly);},getCurrentNode:function getCurrentNode(){var currentNode=this.store.getCurrentNode();return currentNode?currentNode.data:null;},getCurrentKey:function getCurrentKey(){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in getCurrentKey');var currentNode=this.getCurrentNode();return currentNode?currentNode[this.nodeKey]:null;},setCheckedNodes:function setCheckedNodes(nodes,leafOnly){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCheckedNodes');this.store.setCheckedNodes(nodes,leafOnly);},setCheckedKeys:function setCheckedKeys(keys,leafOnly){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCheckedKeys');this.store.setCheckedKeys(keys,leafOnly);},setChecked:function setChecked(data,checked,deep){this.store.setChecked(data,checked,deep);},getHalfCheckedNodes:function getHalfCheckedNodes(){return this.store.getHalfCheckedNodes();},getHalfCheckedKeys:function getHalfCheckedKeys(){return this.store.getHalfCheckedKeys();},setCurrentNode:function setCurrentNode(node){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCurrentNode');this.store.setUserCurrentNode(node);},setCurrentKey:function setCurrentKey(key){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in setCurrentKey');this.store.setCurrentNodeKey(key);},getNode:function getNode(data){return this.store.getNode(data);},remove:function remove(data){this.store.remove(data);},append:function append(data,parentNode){this.store.append(data,parentNode);},insertBefore:function insertBefore(data,refNode){this.store.insertBefore(data,refNode);},insertAfter:function insertAfter(data,refNode){this.store.insertAfter(data,refNode);},handleNodeExpand:function handleNodeExpand(nodeData,node,instance){this.broadcast('ElTreeNode','tree-node-expand',node);this.$emit('node-expand',nodeData,node,instance);},updateKeyChildren:function updateKeyChildren(key,data){if(!this.nodeKey)throw new Error('[Tree] nodeKey is required in updateKeyChild');this.store.updateChildren(key,data);},initTabIndex:function initTabIndex(){this.treeItems=this.$el.querySelectorAll('.is-focusable[role=treeitem]');this.checkboxItems=this.$el.querySelectorAll('input[type=checkbox]');var checkedItem=this.$el.querySelectorAll('.is-checked[role=treeitem]');if(checkedItem.length){checkedItem[0].setAttribute('tabindex',0);return;}this.treeItems[0]&&this.treeItems[0].setAttribute('tabindex',0);},handleKeydown:function handleKeydown(ev){var currentItem=ev.target;if(currentItem.className.indexOf('el-tree-node')===-1)return;var keyCode=ev.keyCode;this.treeItems=this.$el.querySelectorAll('.is-focusable[role=treeitem]');var currentIndex=this.treeItemArray.indexOf(currentItem);var nextIndex=void 0;if([38,40].indexOf(keyCode)>-1){// up、down
ev.preventDefault();if(keyCode===38){// up
nextIndex=currentIndex!==0?currentIndex-1:0;}else{nextIndex=currentIndex<this.treeItemArray.length-1?currentIndex+1:0;}this.treeItemArray[nextIndex].focus();// 选中
}if([37,39].indexOf(keyCode)>-1){// left、right 展开
ev.preventDefault();currentItem.click();// 选中
}var hasInput=currentItem.querySelector('[type="checkbox"]');if([13,32].indexOf(keyCode)>-1&&hasInput){// space enter选中checkbox
ev.preventDefault();hasInput.click();}}},created:function created(){var _this=this;this.isTree=true;this.store=new tree_store({key:this.nodeKey,data:this.data,lazy:this.lazy,props:this.props,load:this.load,currentNodeKey:this.currentNodeKey,checkStrictly:this.checkStrictly,checkDescendants:this.checkDescendants,defaultCheckedKeys:this.defaultCheckedKeys,defaultExpandedKeys:this.defaultExpandedKeys,autoExpandParent:this.autoExpandParent,defaultExpandAll:this.defaultExpandAll,filterNodeMethod:this.filterNodeMethod});this.root=this.store.root;var dragState=this.dragState;this.$on('tree-node-drag-start',function(event,treeNode){if(typeof _this.allowDrag==='function'&&!_this.allowDrag(treeNode.node)){event.preventDefault();return false;}event.dataTransfer.effectAllowed='move';// wrap in try catch to address IE's error when first param is 'text/plain'
try{// setData is required for draggable to work in FireFox
// the content has to be '' so dragging a node out of the tree won't open a new tab in FireFox
event.dataTransfer.setData('text/plain','');}catch(e){}dragState.draggingNode=treeNode;_this.$emit('node-drag-start',treeNode.node,event);});this.$on('tree-node-drag-over',function(event,treeNode){var dropNode=findNearestComponent(event.target,'ElTreeNode');var oldDropNode=dragState.dropNode;if(oldDropNode&&oldDropNode!==dropNode){Object(dom_["removeClass"])(oldDropNode.$el,'is-drop-inner');}var draggingNode=dragState.draggingNode;if(!draggingNode||!dropNode)return;var dropPrev=true;var dropInner=true;var dropNext=true;var userAllowDropInner=true;if(typeof _this.allowDrop==='function'){dropPrev=_this.allowDrop(draggingNode.node,dropNode.node,'prev');userAllowDropInner=dropInner=_this.allowDrop(draggingNode.node,dropNode.node,'inner');dropNext=_this.allowDrop(draggingNode.node,dropNode.node,'next');}event.dataTransfer.dropEffect=dropInner?'move':'none';if((dropPrev||dropInner||dropNext)&&oldDropNode!==dropNode){if(oldDropNode){_this.$emit('node-drag-leave',draggingNode.node,oldDropNode.node,event);}_this.$emit('node-drag-enter',draggingNode.node,dropNode.node,event);}if(dropPrev||dropInner||dropNext){dragState.dropNode=dropNode;}if(dropNode.node.nextSibling===draggingNode.node){dropNext=false;}if(dropNode.node.previousSibling===draggingNode.node){dropPrev=false;}if(dropNode.node.contains(draggingNode.node,false)){dropInner=false;}if(draggingNode.node===dropNode.node||draggingNode.node.contains(dropNode.node)){dropPrev=false;dropInner=false;dropNext=false;}var targetPosition=dropNode.$el.getBoundingClientRect();var treePosition=_this.$el.getBoundingClientRect();var dropType=void 0;var prevPercent=dropPrev?dropInner?0.25:dropNext?0.45:1:-1;var nextPercent=dropNext?dropInner?0.75:dropPrev?0.55:0:1;var indicatorTop=-9999;var distance=event.clientY-targetPosition.top;if(distance<targetPosition.height*prevPercent){dropType='before';}else if(distance>targetPosition.height*nextPercent){dropType='after';}else if(dropInner){dropType='inner';}else{dropType='none';}var iconPosition=dropNode.$el.querySelector('.el-tree-node__expand-icon').getBoundingClientRect();var dropIndicator=_this.$refs.dropIndicator;if(dropType==='before'){indicatorTop=iconPosition.top-treePosition.top;}else if(dropType==='after'){indicatorTop=iconPosition.bottom-treePosition.top;}dropIndicator.style.top=indicatorTop+'px';dropIndicator.style.left=iconPosition.right-treePosition.left+'px';if(dropType==='inner'){Object(dom_["addClass"])(dropNode.$el,'is-drop-inner');}else{Object(dom_["removeClass"])(dropNode.$el,'is-drop-inner');}dragState.showDropIndicator=dropType==='before'||dropType==='after';dragState.allowDrop=dragState.showDropIndicator||userAllowDropInner;dragState.dropType=dropType;_this.$emit('node-drag-over',draggingNode.node,dropNode.node,event);});this.$on('tree-node-drag-end',function(event){var draggingNode=dragState.draggingNode,dropType=dragState.dropType,dropNode=dragState.dropNode;event.preventDefault();event.dataTransfer.dropEffect='move';if(draggingNode&&dropNode){var draggingNodeCopy={data:draggingNode.node.data};if(dropType!=='none'){draggingNode.node.remove();}if(dropType==='before'){dropNode.node.parent.insertBefore(draggingNodeCopy,dropNode.node);}else if(dropType==='after'){dropNode.node.parent.insertAfter(draggingNodeCopy,dropNode.node);}else if(dropType==='inner'){dropNode.node.insertChild(draggingNodeCopy);}if(dropType!=='none'){_this.store.registerNode(draggingNodeCopy);}Object(dom_["removeClass"])(dropNode.$el,'is-drop-inner');_this.$emit('node-drag-end',draggingNode.node,dropNode.node,dropType,event);if(dropType!=='none'){_this.$emit('node-drop',draggingNode.node,dropNode.node,dropType,event);}}if(draggingNode&&!dropNode){_this.$emit('node-drag-end',draggingNode.node,null,dropType,event);}dragState.showDropIndicator=false;dragState.draggingNode=null;dragState.dropNode=null;dragState.allowDrop=true;});},mounted:function mounted(){this.initTabIndex();this.$el.addEventListener('keydown',this.handleKeydown);},updated:function updated(){this.treeItems=this.$el.querySelectorAll('[role=treeitem]');this.checkboxItems=this.$el.querySelectorAll('input[type=checkbox]');}};// CONCATENATED MODULE: ./packages/tree/src/tree.vue?vue&type=script&lang=js&
/* harmony default export */var src_treevue_type_script_lang_js_=treevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/tree/src/tree.vue
/* normalize component */var tree_component=normalizeComponent(src_treevue_type_script_lang_js_,treevue_type_template_id_547575a6_render,treevue_type_template_id_547575a6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var tree_api;}tree_component.options.__file="packages/tree/src/tree.vue";/* harmony default export */var src_tree=tree_component.exports;// CONCATENATED MODULE: ./packages/tree/index.js
/* istanbul ignore next */src_tree.install=function(Vue){Vue.component(src_tree.name,src_tree);};/* harmony default export */var packages_tree=src_tree;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
var mainvue_type_template_id_6e53341b_render=function mainvue_type_template_id_6e53341b_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-alert-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-alert",class:[_vm.typeClass,_vm.center?"is-center":"","is-"+_vm.effect],attrs:{role:"alert"}},[_vm.showIcon?_c("i",{staticClass:"el-alert__icon",class:[_vm.iconClass,_vm.isBigIcon]}):_vm._e(),_c("div",{staticClass:"el-alert__content"},[_vm.title||_vm.$slots.title?_c("span",{staticClass:"el-alert__title",class:[_vm.isBoldTitle]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm.$slots.default&&!_vm.description?_c("p",{staticClass:"el-alert__description"},[_vm._t("default")],2):_vm._e(),_vm.description&&!_vm.$slots.default?_c("p",{staticClass:"el-alert__description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c("i",{directives:[{name:"show",rawName:"v-show",value:_vm.closable,expression:"closable"}],staticClass:"el-alert__closebtn",class:{"is-customed":_vm.closeText!=="","el-icon-close":_vm.closeText===""},on:{click:function click($event){_vm.close();}}},[_vm._v(_vm._s(_vm.closeText))])])])]);};var mainvue_type_template_id_6e53341b_staticRenderFns=[];mainvue_type_template_id_6e53341b_render._withStripped=true;// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=template&id=6e53341b&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/alert/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var TYPE_CLASSES_MAP={'success':'el-icon-success','warning':'el-icon-warning','error':'el-icon-error'};/* harmony default export */var alert_src_mainvue_type_script_lang_js_={name:'ElAlert',props:{title:{type:String,default:''},description:{type:String,default:''},type:{type:String,default:'info'},closable:{type:Boolean,default:true},closeText:{type:String,default:''},showIcon:Boolean,center:Boolean,effect:{type:String,default:'light',validator:function validator(value){return['light','dark'].indexOf(value)!==-1;}}},data:function data(){return{visible:true};},methods:{close:function close(){this.visible=false;this.$emit('close');}},computed:{typeClass:function typeClass(){return'el-alert--'+this.type;},iconClass:function iconClass(){return TYPE_CLASSES_MAP[this.type]||'el-icon-info';},isBigIcon:function isBigIcon(){return this.description||this.$slots.default?'is-big':'';},isBoldTitle:function isBoldTitle(){return this.description||this.$slots.default?'is-bold':'';}}};// CONCATENATED MODULE: ./packages/alert/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_alert_src_mainvue_type_script_lang_js_=alert_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/alert/src/main.vue
/* normalize component */var alert_src_main_component=normalizeComponent(packages_alert_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6e53341b_render,mainvue_type_template_id_6e53341b_staticRenderFns,false,null,null,null);/* hot reload */if(false){var alert_src_main_api;}alert_src_main_component.options.__file="packages/alert/src/main.vue";/* harmony default export */var alert_src_main=alert_src_main_component.exports;// CONCATENATED MODULE: ./packages/alert/index.js
/* istanbul ignore next */alert_src_main.install=function(Vue){Vue.component(alert_src_main.name,alert_src_main);};/* harmony default export */var packages_alert=alert_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
var mainvue_type_template_id_43dbc3d8_render=function mainvue_type_template_id_43dbc3d8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-notification-fade"}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],class:["el-notification",_vm.customClass,_vm.horizontalClass],style:_vm.positionStyle,attrs:{role:"alert"},on:{mouseenter:function mouseenter($event){_vm.clearTimer();},mouseleave:function mouseleave($event){_vm.startTimer();},click:_vm.click}},[_vm.type||_vm.iconClass?_c("i",{staticClass:"el-notification__icon",class:[_vm.typeClass,_vm.iconClass]}):_vm._e(),_c("div",{staticClass:"el-notification__group",class:{"is-with-icon":_vm.typeClass||_vm.iconClass}},[_c("h2",{staticClass:"el-notification__title",domProps:{textContent:_vm._s(_vm.title)}}),_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.message,expression:"message"}],staticClass:"el-notification__content"},[_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",[_vm._v(_vm._s(_vm.message))]):_c("p",{domProps:{innerHTML:_vm._s(_vm.message)}})])],2),_vm.showClose?_c("div",{staticClass:"el-notification__closeBtn el-icon-close",on:{click:function click($event){$event.stopPropagation();return _vm.close($event);}}}):_vm._e()])])]);};var mainvue_type_template_id_43dbc3d8_staticRenderFns=[];mainvue_type_template_id_43dbc3d8_render._withStripped=true;// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=template&id=43dbc3d8&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/notification/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var mainvue_type_script_lang_js_typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var notification_src_mainvue_type_script_lang_js_={data:function data(){return{visible:false,title:'',message:'',duration:4500,type:'',showClose:true,customClass:'',iconClass:'',onClose:null,onClick:null,closed:false,verticalOffset:0,timer:null,dangerouslyUseHTMLString:false,position:'top-right'};},computed:{typeClass:function typeClass(){return this.type&&mainvue_type_script_lang_js_typeMap[this.type]?'el-icon-'+mainvue_type_script_lang_js_typeMap[this.type]:'';},horizontalClass:function horizontalClass(){return this.position.indexOf('right')>-1?'right':'left';},verticalProperty:function verticalProperty(){return /^top-/.test(this.position)?'top':'bottom';},positionStyle:function positionStyle(){var _ref;return _ref={},_ref[this.verticalProperty]=this.verticalOffset+'px',_ref;}},watch:{closed:function closed(newVal){if(newVal){this.visible=false;this.$el.addEventListener('transitionend',this.destroyElement);}}},methods:{destroyElement:function destroyElement(){this.$el.removeEventListener('transitionend',this.destroyElement);this.$destroy(true);this.$el.parentNode.removeChild(this.$el);},click:function click(){if(typeof this.onClick==='function'){this.onClick();}},close:function close(){this.closed=true;if(typeof this.onClose==='function'){this.onClose();}},clearTimer:function clearTimer(){clearTimeout(this.timer);},startTimer:function startTimer(){var _this=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this.closed){_this.close();}},this.duration);}},keydown:function keydown(e){if(e.keyCode===46||e.keyCode===8){this.clearTimer();// detele 取消倒计时
}else if(e.keyCode===27){// esc关闭消息
if(!this.closed){this.close();}}else{this.startTimer();// 恢复倒计时
}}},mounted:function mounted(){var _this2=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this2.closed){_this2.close();}},this.duration);}document.addEventListener('keydown',this.keydown);},beforeDestroy:function beforeDestroy(){document.removeEventListener('keydown',this.keydown);}};// CONCATENATED MODULE: ./packages/notification/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_notification_src_mainvue_type_script_lang_js_=notification_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/notification/src/main.vue
/* normalize component */var notification_src_main_component=normalizeComponent(packages_notification_src_mainvue_type_script_lang_js_,mainvue_type_template_id_43dbc3d8_render,mainvue_type_template_id_43dbc3d8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var notification_src_main_api;}notification_src_main_component.options.__file="packages/notification/src/main.vue";/* harmony default export */var notification_src_main=notification_src_main_component.exports;// CONCATENATED MODULE: ./packages/notification/src/main.js
var NotificationConstructor=external_vue_default.a.extend(notification_src_main);var src_main_instance=void 0;var instances=[];var seed=1;var main_Notification=function Notification(options){if(external_vue_default.a.prototype.$isServer)return;options=merge_default()({},options);var userOnClose=options.onClose;var id='notification_'+seed++;var position=options.position||'top-right';options.onClose=function(){Notification.close(id,userOnClose);};src_main_instance=new NotificationConstructor({data:options});if(Object(vdom_["isVNode"])(options.message)){src_main_instance.$slots.default=[options.message];options.message='REPLACED_BY_VNODE';}src_main_instance.id=id;src_main_instance.$mount();document.body.appendChild(src_main_instance.$el);src_main_instance.visible=true;src_main_instance.dom=src_main_instance.$el;src_main_instance.dom.style.zIndex=popup_["PopupManager"].nextZIndex();var verticalOffset=options.offset||0;instances.filter(function(item){return item.position===position;}).forEach(function(item){verticalOffset+=item.$el.offsetHeight+16;});verticalOffset+=16;src_main_instance.verticalOffset=verticalOffset;instances.push(src_main_instance);return src_main_instance;};['success','warning','info','error'].forEach(function(type){main_Notification[type]=function(options){if(typeof options==='string'||Object(vdom_["isVNode"])(options)){options={message:options};}options.type=type;return main_Notification(options);};});main_Notification.close=function(id,userOnClose){var index=-1;var len=instances.length;var instance=instances.filter(function(instance,i){if(instance.id===id){index=i;return true;}return false;})[0];if(!instance)return;if(typeof userOnClose==='function'){userOnClose(instance);}instances.splice(index,1);if(len<=1)return;var position=instance.position;var removedHeight=instance.dom.offsetHeight;for(var i=index;i<len-1;i++){if(instances[i].position===position){instances[i].dom.style[instance.verticalProperty]=parseInt(instances[i].dom.style[instance.verticalProperty],10)-removedHeight-16+'px';}}};main_Notification.closeAll=function(){for(var i=instances.length-1;i>=0;i--){instances[i].close();}};/* harmony default export */var packages_notification_src_main=main_Notification;// CONCATENATED MODULE: ./packages/notification/index.js
/* harmony default export */var notification=packages_notification_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=template&id=32708644&
var mainvue_type_template_id_32708644_render=function mainvue_type_template_id_32708644_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-slider",class:{"is-vertical":_vm.vertical,"el-slider--with-input":_vm.showInput},attrs:{role:"slider","aria-valuemin":_vm.min,"aria-valuemax":_vm.max,"aria-orientation":_vm.vertical?"vertical":"horizontal","aria-disabled":_vm.sliderDisabled}},[_vm.showInput&&!_vm.range?_c("el-input-number",{ref:"input",staticClass:"el-slider__input",attrs:{step:_vm.step,disabled:_vm.sliderDisabled,controls:_vm.showInputControls,min:_vm.min,max:_vm.max,debounce:_vm.debounce,size:_vm.inputSize},on:{change:_vm.emitChange},model:{value:_vm.firstValue,callback:function callback($$v){_vm.firstValue=$$v;},expression:"firstValue"}}):_vm._e(),_c("div",{ref:"slider",staticClass:"el-slider__runway",class:{"show-input":_vm.showInput,disabled:_vm.sliderDisabled},style:_vm.runwayStyle,on:{click:_vm.onSliderClick}},[_c("div",{staticClass:"el-slider__bar",style:_vm.barStyle}),_c("slider-button",{ref:"button1",attrs:{vertical:_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:_vm.firstValue,callback:function callback($$v){_vm.firstValue=$$v;},expression:"firstValue"}}),_vm.range?_c("slider-button",{ref:"button2",attrs:{vertical:_vm.vertical,"tooltip-class":_vm.tooltipClass},model:{value:_vm.secondValue,callback:function callback($$v){_vm.secondValue=$$v;},expression:"secondValue"}}):_vm._e(),_vm._l(_vm.stops,function(item,key){return _vm.showStops?_c("div",{key:key,staticClass:"el-slider__stop",style:_vm.getStopStyle(item)}):_vm._e();}),_vm.markList.length>0?[_c("div",_vm._l(_vm.markList,function(item,key){return _c("div",{key:key,staticClass:"el-slider__stop el-slider__marks-stop",style:_vm.getStopStyle(item.position)});}),0),_c("div",{staticClass:"el-slider__marks"},_vm._l(_vm.markList,function(item,key){return _c("slider-marker",{key:key,style:_vm.getStopStyle(item.position),attrs:{mark:item.mark}});}),1)]:_vm._e()],2)],1);};var mainvue_type_template_id_32708644_staticRenderFns=[];mainvue_type_template_id_32708644_render._withStripped=true;// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=template&id=32708644&
// EXTERNAL MODULE: external "element-ui/lib/input-number"
var input_number_=__webpack_require__(41);var input_number_default=/*#__PURE__*/__webpack_require__.n(input_number_);// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
var buttonvue_type_template_id_e72d2ad2_render=function buttonvue_type_template_id_e72d2ad2_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{ref:"button",staticClass:"el-slider__button-wrapper",class:{hover:_vm.hovering,dragging:_vm.dragging},style:_vm.wrapperStyle,attrs:{tabindex:"0"},on:{mouseenter:_vm.handleMouseEnter,mouseleave:_vm.handleMouseLeave,mousedown:_vm.onButtonDown,touchstart:_vm.onButtonDown,focus:_vm.handleMouseEnter,blur:_vm.handleMouseLeave,keydown:[function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){return null;}if("button"in $event&&$event.button!==0){return null;}return _vm.onLeftKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){return null;}if("button"in $event&&$event.button!==2){return null;}return _vm.onRightKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){return null;}$event.preventDefault();return _vm.onLeftKeyDown($event);},function($event){if(!("button"in $event)&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){return null;}$event.preventDefault();return _vm.onRightKeyDown($event);}]}},[_c("el-tooltip",{ref:"tooltip",attrs:{placement:"top","popper-class":_vm.tooltipClass,disabled:!_vm.showTooltip}},[_c("span",{attrs:{slot:"content"},slot:"content"},[_vm._v(_vm._s(_vm.formatValue))]),_c("div",{staticClass:"el-slider__button",class:{hover:_vm.hovering,dragging:_vm.dragging}})])],1);};var buttonvue_type_template_id_e72d2ad2_staticRenderFns=[];buttonvue_type_template_id_e72d2ad2_render._withStripped=true;// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=template&id=e72d2ad2&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var slider_src_buttonvue_type_script_lang_js_={name:'ElSliderButton',components:{ElTooltip:tooltip_default.a},props:{value:{type:Number,default:0},vertical:{type:Boolean,default:false},tooltipClass:String},data:function data(){return{hovering:false,dragging:false,isClick:false,startX:0,currentX:0,startY:0,currentY:0,startPosition:0,newPosition:null,oldValue:this.value};},computed:{disabled:function disabled(){return this.$parent.sliderDisabled;},max:function max(){return this.$parent.max;},min:function min(){return this.$parent.min;},step:function step(){return this.$parent.step;},showTooltip:function showTooltip(){return this.$parent.showTooltip;},precision:function precision(){return this.$parent.precision;},currentPosition:function currentPosition(){return(this.value-this.min)/(this.max-this.min)*100+'%';},enableFormat:function enableFormat(){return this.$parent.formatTooltip instanceof Function;},formatValue:function formatValue(){return this.enableFormat&&this.$parent.formatTooltip(this.value)||this.value;},wrapperStyle:function wrapperStyle(){return this.vertical?{bottom:this.currentPosition}:{left:this.currentPosition};}},watch:{dragging:function dragging(val){this.$parent.dragging=val;}},methods:{displayTooltip:function displayTooltip(){this.$refs.tooltip&&(this.$refs.tooltip.showPopper=true);},hideTooltip:function hideTooltip(){this.$refs.tooltip&&(this.$refs.tooltip.showPopper=false);},handleMouseEnter:function handleMouseEnter(){this.hovering=true;this.displayTooltip();},handleMouseLeave:function handleMouseLeave(){this.hovering=false;this.hideTooltip();},onButtonDown:function onButtonDown(event){if(this.disabled)return;event.preventDefault();this.onDragStart(event);window.addEventListener('mousemove',this.onDragging);window.addEventListener('touchmove',this.onDragging);window.addEventListener('mouseup',this.onDragEnd);window.addEventListener('touchend',this.onDragEnd);window.addEventListener('contextmenu',this.onDragEnd);},onLeftKeyDown:function onLeftKeyDown(){if(this.disabled)return;this.newPosition=parseFloat(this.currentPosition)-this.step/(this.max-this.min)*100;this.setPosition(this.newPosition);this.$parent.emitChange();},onRightKeyDown:function onRightKeyDown(){if(this.disabled)return;this.newPosition=parseFloat(this.currentPosition)+this.step/(this.max-this.min)*100;this.setPosition(this.newPosition);this.$parent.emitChange();},onDragStart:function onDragStart(event){this.dragging=true;this.isClick=true;if(event.type==='touchstart'){event.clientY=event.touches[0].clientY;event.clientX=event.touches[0].clientX;}if(this.vertical){this.startY=event.clientY;}else{this.startX=event.clientX;}this.startPosition=parseFloat(this.currentPosition);this.newPosition=this.startPosition;},onDragging:function onDragging(event){if(this.dragging){this.isClick=false;this.displayTooltip();this.$parent.resetSize();var diff=0;if(event.type==='touchmove'){event.clientY=event.touches[0].clientY;event.clientX=event.touches[0].clientX;}if(this.vertical){this.currentY=event.clientY;diff=(this.startY-this.currentY)/this.$parent.sliderSize*100;}else{this.currentX=event.clientX;diff=(this.currentX-this.startX)/this.$parent.sliderSize*100;}this.newPosition=this.startPosition+diff;this.setPosition(this.newPosition);}},onDragEnd:function onDragEnd(){var _this=this;if(this.dragging){/*
         * 防止在 mouseup 后立即触发 click，导致滑块有几率产生一小段位移
         * 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
         */setTimeout(function(){_this.dragging=false;_this.hideTooltip();if(!_this.isClick){_this.setPosition(_this.newPosition);_this.$parent.emitChange();}},0);window.removeEventListener('mousemove',this.onDragging);window.removeEventListener('touchmove',this.onDragging);window.removeEventListener('mouseup',this.onDragEnd);window.removeEventListener('touchend',this.onDragEnd);window.removeEventListener('contextmenu',this.onDragEnd);}},setPosition:function setPosition(newPosition){var _this2=this;if(newPosition===null||isNaN(newPosition))return;if(newPosition<0){newPosition=0;}else if(newPosition>100){newPosition=100;}var lengthPerStep=100/((this.max-this.min)/this.step);var steps=Math.round(newPosition/lengthPerStep);var value=steps*lengthPerStep*(this.max-this.min)*0.01+this.min;value=parseFloat(value.toFixed(this.precision));this.$emit('input',value);this.$nextTick(function(){_this2.displayTooltip();_this2.$refs.tooltip&&_this2.$refs.tooltip.updatePopper();});if(!this.dragging&&this.value!==this.oldValue){this.oldValue=this.value;}}}};// CONCATENATED MODULE: ./packages/slider/src/button.vue?vue&type=script&lang=js&
/* harmony default export */var packages_slider_src_buttonvue_type_script_lang_js_=slider_src_buttonvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/slider/src/button.vue
/* normalize component */var src_button_component=normalizeComponent(packages_slider_src_buttonvue_type_script_lang_js_,buttonvue_type_template_id_e72d2ad2_render,buttonvue_type_template_id_e72d2ad2_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_button_api;}src_button_component.options.__file="packages/slider/src/button.vue";/* harmony default export */var slider_src_button=src_button_component.exports;// CONCATENATED MODULE: ./packages/slider/src/marker.js
/* harmony default export */var marker={name:'ElMarker',props:{mark:{type:[String,Object]}},render:function render(){var h=arguments[0];var label=typeof this.mark==='string'?this.mark:this.mark.label;return h('div',{'class':'el-slider__marks-text',style:this.mark.style||{}},[label]);}};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/slider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var slider_src_mainvue_type_script_lang_js_={name:'ElSlider',mixins:[emitter_default.a],inject:{elForm:{default:''}},props:{min:{type:Number,default:0},max:{type:Number,default:100},step:{type:Number,default:1},value:{type:[Number,Array],default:0},showInput:{type:Boolean,default:false},showInputControls:{type:Boolean,default:true},inputSize:{type:String,default:'small'},showStops:{type:Boolean,default:false},showTooltip:{type:Boolean,default:true},formatTooltip:Function,disabled:{type:Boolean,default:false},range:{type:Boolean,default:false},vertical:{type:Boolean,default:false},height:{type:String},debounce:{type:Number,default:300},label:{type:String},tooltipClass:String,marks:Object},components:{ElInputNumber:input_number_default.a,SliderButton:slider_src_button,SliderMarker:marker},data:function data(){return{firstValue:null,secondValue:null,oldValue:null,dragging:false,sliderSize:1};},watch:{value:function value(val,oldVal){if(this.dragging||Array.isArray(val)&&Array.isArray(oldVal)&&val.every(function(item,index){return item===oldVal[index];})){return;}this.setValues();},dragging:function dragging(val){if(!val){this.setValues();}},firstValue:function firstValue(val){if(this.range){this.$emit('input',[this.minValue,this.maxValue]);}else{this.$emit('input',val);}},secondValue:function secondValue(){if(this.range){this.$emit('input',[this.minValue,this.maxValue]);}},min:function min(){this.setValues();},max:function max(){this.setValues();}},methods:{valueChanged:function valueChanged(){var _this=this;if(this.range){return![this.minValue,this.maxValue].every(function(item,index){return item===_this.oldValue[index];});}else{return this.value!==this.oldValue;}},setValues:function setValues(){if(this.min>this.max){console.error('[Element Error][Slider]min should not be greater than max.');return;}var val=this.value;if(this.range&&Array.isArray(val)){if(val[1]<this.min){this.$emit('input',[this.min,this.min]);}else if(val[0]>this.max){this.$emit('input',[this.max,this.max]);}else if(val[0]<this.min){this.$emit('input',[this.min,val[1]]);}else if(val[1]>this.max){this.$emit('input',[val[0],this.max]);}else{this.firstValue=val[0];this.secondValue=val[1];if(this.valueChanged()){this.dispatch('ElFormItem','el.form.change',[this.minValue,this.maxValue]);this.oldValue=val.slice();}}}else if(!this.range&&typeof val==='number'&&!isNaN(val)){if(val<this.min){this.$emit('input',this.min);}else if(val>this.max){this.$emit('input',this.max);}else{this.firstValue=val;if(this.valueChanged()){this.dispatch('ElFormItem','el.form.change',val);this.oldValue=val;}}}},setPosition:function setPosition(percent){var targetValue=this.min+percent*(this.max-this.min)/100;if(!this.range){this.$refs.button1.setPosition(percent);return;}var button=void 0;if(Math.abs(this.minValue-targetValue)<Math.abs(this.maxValue-targetValue)){button=this.firstValue<this.secondValue?'button1':'button2';}else{button=this.firstValue>this.secondValue?'button1':'button2';}this.$refs[button].setPosition(percent);},onSliderClick:function onSliderClick(event){if(this.sliderDisabled||this.dragging)return;this.resetSize();if(this.vertical){var sliderOffsetBottom=this.$refs.slider.getBoundingClientRect().bottom;this.setPosition((sliderOffsetBottom-event.clientY)/this.sliderSize*100);}else{var sliderOffsetLeft=this.$refs.slider.getBoundingClientRect().left;this.setPosition((event.clientX-sliderOffsetLeft)/this.sliderSize*100);}this.emitChange();},resetSize:function resetSize(){if(this.$refs.slider){this.sliderSize=this.$refs.slider['client'+(this.vertical?'Height':'Width')];}},emitChange:function emitChange(){var _this2=this;this.$nextTick(function(){_this2.$emit('change',_this2.range?[_this2.minValue,_this2.maxValue]:_this2.value);});},getStopStyle:function getStopStyle(position){return this.vertical?{'bottom':position+'%'}:{'left':position+'%'};}},computed:{stops:function stops(){var _this3=this;if(!this.showStops||this.min>this.max)return[];if(this.step===0){false&&false;return[];}var stopCount=(this.max-this.min)/this.step;var stepWidth=100*this.step/(this.max-this.min);var result=[];for(var i=1;i<stopCount;i++){result.push(i*stepWidth);}if(this.range){return result.filter(function(step){return step<100*(_this3.minValue-_this3.min)/(_this3.max-_this3.min)||step>100*(_this3.maxValue-_this3.min)/(_this3.max-_this3.min);});}else{return result.filter(function(step){return step>100*(_this3.firstValue-_this3.min)/(_this3.max-_this3.min);});}},markList:function markList(){var _this4=this;if(!this.marks){return[];}var marksKeys=Object.keys(this.marks);return marksKeys.map(parseFloat).sort(function(a,b){return a-b;}).filter(function(point){return point<=_this4.max&&point>=_this4.min;}).map(function(point){return{point:point,position:(point-_this4.min)*100/(_this4.max-_this4.min),mark:_this4.marks[point]};});},minValue:function minValue(){return Math.min(this.firstValue,this.secondValue);},maxValue:function maxValue(){return Math.max(this.firstValue,this.secondValue);},barSize:function barSize(){return this.range?100*(this.maxValue-this.minValue)/(this.max-this.min)+'%':100*(this.firstValue-this.min)/(this.max-this.min)+'%';},barStart:function barStart(){return this.range?100*(this.minValue-this.min)/(this.max-this.min)+'%':'0%';},precision:function precision(){var precisions=[this.min,this.max,this.step].map(function(item){var decimal=(''+item).split('.')[1];return decimal?decimal.length:0;});return Math.max.apply(null,precisions);},runwayStyle:function runwayStyle(){return this.vertical?{height:this.height}:{};},barStyle:function barStyle(){return this.vertical?{height:this.barSize,bottom:this.barStart}:{width:this.barSize,left:this.barStart};},sliderDisabled:function sliderDisabled(){return this.disabled||(this.elForm||{}).disabled;}},mounted:function mounted(){var valuetext=void 0;if(this.range){if(Array.isArray(this.value)){this.firstValue=Math.max(this.min,this.value[0]);this.secondValue=Math.min(this.max,this.value[1]);}else{this.firstValue=this.min;this.secondValue=this.max;}this.oldValue=[this.firstValue,this.secondValue];valuetext=this.firstValue+'-'+this.secondValue;}else{if(typeof this.value!=='number'||isNaN(this.value)){this.firstValue=this.min;}else{this.firstValue=Math.min(this.max,Math.max(this.min,this.value));}this.oldValue=this.firstValue;valuetext=this.firstValue;}this.$el.setAttribute('aria-valuetext',valuetext);// label screen reader
this.$el.setAttribute('aria-label',this.label?this.label:'slider between '+this.min+' and '+this.max);this.resetSize();window.addEventListener('resize',this.resetSize);},beforeDestroy:function beforeDestroy(){window.removeEventListener('resize',this.resetSize);}};// CONCATENATED MODULE: ./packages/slider/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_slider_src_mainvue_type_script_lang_js_=slider_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/slider/src/main.vue
/* normalize component */var slider_src_main_component=normalizeComponent(packages_slider_src_mainvue_type_script_lang_js_,mainvue_type_template_id_32708644_render,mainvue_type_template_id_32708644_staticRenderFns,false,null,null,null);/* hot reload */if(false){var slider_src_main_api;}slider_src_main_component.options.__file="packages/slider/src/main.vue";/* harmony default export */var slider_src_main=slider_src_main_component.exports;// CONCATENATED MODULE: ./packages/slider/index.js
/* istanbul ignore next */slider_src_main.install=function(Vue){Vue.component(slider_src_main.name,slider_src_main);};/* harmony default export */var slider=slider_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
var loadingvue_type_template_id_eee0a7ac_render=function loadingvue_type_template_id_eee0a7ac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-loading-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-loading-mask",class:[_vm.customClass,{"is-fullscreen":_vm.fullscreen}],style:{backgroundColor:_vm.background||""}},[_c("div",{staticClass:"el-loading-spinner"},[!_vm.spinner?_c("svg",{staticClass:"circular",attrs:{viewBox:"25 25 50 50"}},[_c("circle",{staticClass:"path",attrs:{cx:"50",cy:"50",r:"20",fill:"none"}})]):_c("i",{class:_vm.spinner}),_vm.text?_c("p",{staticClass:"el-loading-text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])]);};var loadingvue_type_template_id_eee0a7ac_staticRenderFns=[];loadingvue_type_template_id_eee0a7ac_render._withStripped=true;// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=template&id=eee0a7ac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/loading/src/loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var loadingvue_type_script_lang_js_={data:function data(){return{text:null,spinner:null,background:null,fullscreen:true,visible:false,customClass:''};},methods:{handleAfterLeave:function handleAfterLeave(){this.$emit('after-leave');},setText:function setText(text){this.text=text;}}};// CONCATENATED MODULE: ./packages/loading/src/loading.vue?vue&type=script&lang=js&
/* harmony default export */var src_loadingvue_type_script_lang_js_=loadingvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/loading/src/loading.vue
/* normalize component */var loading_component=normalizeComponent(src_loadingvue_type_script_lang_js_,loadingvue_type_template_id_eee0a7ac_render,loadingvue_type_template_id_eee0a7ac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var loading_api;}loading_component.options.__file="packages/loading/src/loading.vue";/* harmony default export */var loading=loading_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/after-leave"
var after_leave_=__webpack_require__(32);var after_leave_default=/*#__PURE__*/__webpack_require__.n(after_leave_);// CONCATENATED MODULE: ./packages/loading/src/directive.js
var Mask=external_vue_default.a.extend(loading);var loadingDirective={};loadingDirective.install=function(Vue){if(Vue.prototype.$isServer)return;var toggleLoading=function toggleLoading(el,binding){if(binding.value){Vue.nextTick(function(){if(binding.modifiers.fullscreen){el.originalPosition=Object(dom_["getStyle"])(document.body,'position');el.originalOverflow=Object(dom_["getStyle"])(document.body,'overflow');el.maskStyle.zIndex=popup_["PopupManager"].nextZIndex();Object(dom_["addClass"])(el.mask,'is-fullscreen');insertDom(document.body,el,binding);}else{Object(dom_["removeClass"])(el.mask,'is-fullscreen');if(binding.modifiers.body){el.originalPosition=Object(dom_["getStyle"])(document.body,'position');['top','left'].forEach(function(property){var scroll=property==='top'?'scrollTop':'scrollLeft';el.maskStyle[property]=el.getBoundingClientRect()[property]+document.body[scroll]+document.documentElement[scroll]-parseInt(Object(dom_["getStyle"])(document.body,'margin-'+property),10)+'px';});['height','width'].forEach(function(property){el.maskStyle[property]=el.getBoundingClientRect()[property]+'px';});insertDom(document.body,el,binding);}else{el.originalPosition=Object(dom_["getStyle"])(el,'position');insertDom(el,el,binding);}}});}else{after_leave_default()(el.instance,function(_){if(!el.instance.hiding)return;el.domVisible=false;var target=binding.modifiers.fullscreen||binding.modifiers.body?document.body:el;Object(dom_["removeClass"])(target,'el-loading-parent--relative');Object(dom_["removeClass"])(target,'el-loading-parent--hidden');el.instance.hiding=false;},300,true);el.instance.visible=false;el.instance.hiding=true;}};var insertDom=function insertDom(parent,el,binding){if(!el.domVisible&&Object(dom_["getStyle"])(el,'display')!=='none'&&Object(dom_["getStyle"])(el,'visibility')!=='hidden'){Object.keys(el.maskStyle).forEach(function(property){el.mask.style[property]=el.maskStyle[property];});if(el.originalPosition!=='absolute'&&el.originalPosition!=='fixed'){Object(dom_["addClass"])(parent,'el-loading-parent--relative');}if(binding.modifiers.fullscreen&&binding.modifiers.lock){Object(dom_["addClass"])(parent,'el-loading-parent--hidden');}el.domVisible=true;parent.appendChild(el.mask);Vue.nextTick(function(){if(el.instance.hiding){el.instance.$emit('after-leave');}else{el.instance.visible=true;}});el.domInserted=true;}else if(el.domVisible&&el.instance.hiding===true){el.instance.visible=true;el.instance.hiding=false;}};Vue.directive('loading',{bind:function bind(el,binding,vnode){var textExr=el.getAttribute('element-loading-text');var spinnerExr=el.getAttribute('element-loading-spinner');var backgroundExr=el.getAttribute('element-loading-background');var customClassExr=el.getAttribute('element-loading-custom-class');var vm=vnode.context;var mask=new Mask({el:document.createElement('div'),data:{text:vm&&vm[textExr]||textExr,spinner:vm&&vm[spinnerExr]||spinnerExr,background:vm&&vm[backgroundExr]||backgroundExr,customClass:vm&&vm[customClassExr]||customClassExr,fullscreen:!!binding.modifiers.fullscreen}});el.instance=mask;el.mask=mask.$el;el.maskStyle={};binding.value&&toggleLoading(el,binding);},update:function update(el,binding){el.instance.setText(el.getAttribute('element-loading-text'));if(binding.oldValue!==binding.value){toggleLoading(el,binding);}},unbind:function unbind(el,binding){if(el.domInserted){el.mask&&el.mask.parentNode&&el.mask.parentNode.removeChild(el.mask);toggleLoading(el,{value:false,modifiers:binding.modifiers});}el.instance&&el.instance.$destroy();}});};/* harmony default export */var src_directive=loadingDirective;// CONCATENATED MODULE: ./packages/loading/src/index.js
var LoadingConstructor=external_vue_default.a.extend(loading);var src_defaults={text:null,fullscreen:true,body:false,lock:false,customClass:''};var fullscreenLoading=void 0;LoadingConstructor.prototype.originalPosition='';LoadingConstructor.prototype.originalOverflow='';LoadingConstructor.prototype.close=function(){var _this=this;if(this.fullscreen){fullscreenLoading=undefined;}after_leave_default()(this,function(_){var target=_this.fullscreen||_this.body?document.body:_this.target;Object(dom_["removeClass"])(target,'el-loading-parent--relative');Object(dom_["removeClass"])(target,'el-loading-parent--hidden');if(_this.$el&&_this.$el.parentNode){_this.$el.parentNode.removeChild(_this.$el);}_this.$destroy();},300);this.visible=false;};var src_addStyle=function addStyle(options,parent,instance){var maskStyle={};if(options.fullscreen){instance.originalPosition=Object(dom_["getStyle"])(document.body,'position');instance.originalOverflow=Object(dom_["getStyle"])(document.body,'overflow');maskStyle.zIndex=popup_["PopupManager"].nextZIndex();}else if(options.body){instance.originalPosition=Object(dom_["getStyle"])(document.body,'position');['top','left'].forEach(function(property){var scroll=property==='top'?'scrollTop':'scrollLeft';maskStyle[property]=options.target.getBoundingClientRect()[property]+document.body[scroll]+document.documentElement[scroll]+'px';});['height','width'].forEach(function(property){maskStyle[property]=options.target.getBoundingClientRect()[property]+'px';});}else{instance.originalPosition=Object(dom_["getStyle"])(parent,'position');}Object.keys(maskStyle).forEach(function(property){instance.$el.style[property]=maskStyle[property];});};var src_Loading=function Loading(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(external_vue_default.a.prototype.$isServer)return;options=merge_default()({},src_defaults,options);if(typeof options.target==='string'){options.target=document.querySelector(options.target);}options.target=options.target||document.body;if(options.target!==document.body){options.fullscreen=false;}else{options.body=true;}if(options.fullscreen&&fullscreenLoading){return fullscreenLoading;}var parent=options.body?document.body:options.target;var instance=new LoadingConstructor({el:document.createElement('div'),data:options});src_addStyle(options,parent,instance);if(instance.originalPosition!=='absolute'&&instance.originalPosition!=='fixed'){Object(dom_["addClass"])(parent,'el-loading-parent--relative');}if(options.fullscreen&&options.lock){Object(dom_["addClass"])(parent,'el-loading-parent--hidden');}parent.appendChild(instance.$el);external_vue_default.a.nextTick(function(){instance.visible=true;});if(options.fullscreen){fullscreenLoading=instance;}return instance;};/* harmony default export */var src=src_Loading;// CONCATENATED MODULE: ./packages/loading/index.js
/* harmony default export */var packages_loading={install:function install(Vue){Vue.use(src_directive);Vue.prototype.$loading=src;},directive:src_directive,service:src};// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
var iconvue_type_template_id_cb3fe7f4_render=function iconvue_type_template_id_cb3fe7f4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("i",{class:"el-icon-"+_vm.name});};var iconvue_type_template_id_cb3fe7f4_staticRenderFns=[];iconvue_type_template_id_cb3fe7f4_render._withStripped=true;// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=template&id=cb3fe7f4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/icon/src/icon.vue?vue&type=script&lang=js&
//
//
//
//
/* harmony default export */var iconvue_type_script_lang_js_={name:'ElIcon',props:{name:String}};// CONCATENATED MODULE: ./packages/icon/src/icon.vue?vue&type=script&lang=js&
/* harmony default export */var src_iconvue_type_script_lang_js_=iconvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/icon/src/icon.vue
/* normalize component */var icon_component=normalizeComponent(src_iconvue_type_script_lang_js_,iconvue_type_template_id_cb3fe7f4_render,iconvue_type_template_id_cb3fe7f4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_api;}icon_component.options.__file="packages/icon/src/icon.vue";/* harmony default export */var icon=icon_component.exports;// CONCATENATED MODULE: ./packages/icon/index.js
/* istanbul ignore next */icon.install=function(Vue){Vue.component(icon.name,icon);};/* harmony default export */var packages_icon=icon;// CONCATENATED MODULE: ./packages/row/src/row.js
/* harmony default export */var src_row={name:'ElRow',componentName:'ElRow',props:{tag:{type:String,default:'div'},gutter:Number,type:String,justify:{type:String,default:'start'},align:String},computed:{style:function style(){var ret={};if(this.gutter){ret.marginLeft='-'+this.gutter/2+'px';ret.marginRight=ret.marginLeft;}return ret;}},render:function render(h){return h(this.tag,{class:['el-row',this.justify!=='start'?'is-justify-'+this.justify:'',this.align?'is-align-'+this.align:'',{'el-row--flex':this.type==='flex'}],style:this.style},this.$slots.default);}};// CONCATENATED MODULE: ./packages/row/index.js
/* istanbul ignore next */src_row.install=function(Vue){Vue.component(src_row.name,src_row);};/* harmony default export */var packages_row=src_row;// CONCATENATED MODULE: ./packages/col/src/col.js
var col_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};/* harmony default export */var col={name:'ElCol',props:{span:{type:Number,default:24},tag:{type:String,default:'div'},offset:Number,pull:Number,push:Number,xs:[Number,Object],sm:[Number,Object],md:[Number,Object],lg:[Number,Object],xl:[Number,Object]},computed:{gutter:function gutter(){var parent=this.$parent;while(parent&&parent.$options.componentName!=='ElRow'){parent=parent.$parent;}return parent?parent.gutter:0;}},render:function render(h){var _this=this;var classList=[];var style={};if(this.gutter){style.paddingLeft=this.gutter/2+'px';style.paddingRight=style.paddingLeft;}['span','offset','pull','push'].forEach(function(prop){if(_this[prop]||_this[prop]===0){classList.push(prop!=='span'?'el-col-'+prop+'-'+_this[prop]:'el-col-'+_this[prop]);}});['xs','sm','md','lg','xl'].forEach(function(size){if(typeof _this[size]==='number'){classList.push('el-col-'+size+'-'+_this[size]);}else if(col_typeof(_this[size])==='object'){var props=_this[size];Object.keys(props).forEach(function(prop){classList.push(prop!=='span'?'el-col-'+size+'-'+prop+'-'+props[prop]:'el-col-'+size+'-'+props[prop]);});}});return h(this.tag,{class:['el-col',classList],style:style},this.$slots.default);}};// CONCATENATED MODULE: ./packages/col/index.js
/* istanbul ignore next */col.install=function(Vue){Vue.component(col.name,col);};/* harmony default export */var packages_col=col;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
var upload_listvue_type_template_id_173fedf5_render=function upload_listvue_type_template_id_173fedf5_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition-group",{class:["el-upload-list","el-upload-list--"+_vm.listType,{"is-disabled":_vm.disabled}],attrs:{tag:"ul",name:"el-list"}},_vm._l(_vm.files,function(file){return _c("li",{key:file.uid,class:["el-upload-list__item","is-"+file.status,_vm.focusing?"focusing":""],attrs:{tabindex:"0"},on:{keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}!_vm.disabled&&_vm.$emit("remove",file);},focus:function focus($event){_vm.focusing=true;},blur:function blur($event){_vm.focusing=false;},click:function click($event){_vm.focusing=false;}}},[_vm._t("default",[file.status!=="uploading"&&["picture-card","picture"].indexOf(_vm.listType)>-1?_c("img",{staticClass:"el-upload-list__item-thumbnail",attrs:{src:file.url,alt:""}}):_vm._e(),_c("a",{staticClass:"el-upload-list__item-name",on:{click:function click($event){_vm.handleClick(file);}}},[_c("i",{staticClass:"el-icon-document"}),_vm._v(_vm._s(file.name)+"\n      ")]),_c("label",{staticClass:"el-upload-list__item-status-label"},[_c("i",{class:{"el-icon-upload-success":true,"el-icon-circle-check":_vm.listType==="text","el-icon-check":["picture-card","picture"].indexOf(_vm.listType)>-1}})]),!_vm.disabled?_c("i",{staticClass:"el-icon-close",on:{click:function click($event){_vm.$emit("remove",file);}}}):_vm._e(),!_vm.disabled?_c("i",{staticClass:"el-icon-close-tip"},[_vm._v(_vm._s(_vm.t("el.upload.deleteTip")))]):_vm._e(),file.status==="uploading"?_c("el-progress",{attrs:{type:_vm.listType==="picture-card"?"circle":"line","stroke-width":_vm.listType==="picture-card"?6:2,percentage:_vm.parsePercentage(file.percentage)}}):_vm._e(),_vm.listType==="picture-card"?_c("span",{staticClass:"el-upload-list__item-actions"},[_vm.handlePreview&&_vm.listType==="picture-card"?_c("span",{staticClass:"el-upload-list__item-preview",on:{click:function click($event){_vm.handlePreview(file);}}},[_c("i",{staticClass:"el-icon-zoom-in"})]):_vm._e(),!_vm.disabled?_c("span",{staticClass:"el-upload-list__item-delete",on:{click:function click($event){_vm.$emit("remove",file);}}},[_c("i",{staticClass:"el-icon-delete"})]):_vm._e()]):_vm._e()],{file:file})],2);}),0);};var upload_listvue_type_template_id_173fedf5_staticRenderFns=[];upload_listvue_type_template_id_173fedf5_render._withStripped=true;// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=template&id=173fedf5&
// EXTERNAL MODULE: external "element-ui/lib/progress"
var progress_=__webpack_require__(33);var progress_default=/*#__PURE__*/__webpack_require__.n(progress_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var upload_listvue_type_script_lang_js_={name:'ElUploadList',mixins:[locale_default.a],data:function data(){return{focusing:false};},components:{ElProgress:progress_default.a},props:{files:{type:Array,default:function _default(){return[];}},disabled:{type:Boolean,default:false},handlePreview:Function,listType:String},methods:{parsePercentage:function parsePercentage(val){return parseInt(val,10);},handleClick:function handleClick(file){this.handlePreview&&this.handlePreview(file);}}};// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue?vue&type=script&lang=js&
/* harmony default export */var src_upload_listvue_type_script_lang_js_=upload_listvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload-list.vue
/* normalize component */var upload_list_component=normalizeComponent(src_upload_listvue_type_script_lang_js_,upload_listvue_type_template_id_173fedf5_render,upload_listvue_type_template_id_173fedf5_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_list_api;}upload_list_component.options.__file="packages/upload/src/upload-list.vue";/* harmony default export */var upload_list=upload_list_component.exports;// EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
var external_babel_helper_vue_jsx_merge_props_=__webpack_require__(24);var external_babel_helper_vue_jsx_merge_props_default=/*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);// CONCATENATED MODULE: ./packages/upload/src/ajax.js
function getError(action,option,xhr){var msg=void 0;if(xhr.response){msg=''+(xhr.response.error||xhr.response);}else if(xhr.responseText){msg=''+xhr.responseText;}else{msg='fail to post '+action+' '+xhr.status;}var err=new Error(msg);err.status=xhr.status;err.method='post';err.url=action;return err;}function getBody(xhr){var text=xhr.responseText||xhr.response;if(!text){return text;}try{return JSON.parse(text);}catch(e){return text;}}function upload(option){if(typeof XMLHttpRequest==='undefined'){return;}var xhr=new XMLHttpRequest();var action=option.action;if(xhr.upload){xhr.upload.onprogress=function progress(e){if(e.total>0){e.percent=e.loaded/e.total*100;}option.onProgress(e);};}var formData=new FormData();if(option.data){Object.keys(option.data).forEach(function(key){formData.append(key,option.data[key]);});}formData.append(option.filename,option.file,option.file.name);xhr.onerror=function error(e){option.onError(e);};xhr.onload=function onload(){if(xhr.status<200||xhr.status>=300){return option.onError(getError(action,option,xhr));}option.onSuccess(getBody(xhr));};xhr.open('post',action,true);if(option.withCredentials&&'withCredentials'in xhr){xhr.withCredentials=true;}var headers=option.headers||{};for(var item in headers){if(headers.hasOwnProperty(item)&&headers[item]!==null){xhr.setRequestHeader(item,headers[item]);}}xhr.send(formData);return xhr;}// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
var upload_draggervue_type_template_id_7ebbf219_render=function upload_draggervue_type_template_id_7ebbf219_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-upload-dragger",class:{"is-dragover":_vm.dragover},on:{drop:function drop($event){$event.preventDefault();return _vm.onDrop($event);},dragover:function dragover($event){$event.preventDefault();return _vm.onDragover($event);},dragleave:function dragleave($event){$event.preventDefault();_vm.dragover=false;}}},[_vm._t("default")],2);};var upload_draggervue_type_template_id_7ebbf219_staticRenderFns=[];upload_draggervue_type_template_id_7ebbf219_render._withStripped=true;// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=template&id=7ebbf219&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var upload_draggervue_type_script_lang_js_={name:'ElUploadDrag',props:{disabled:Boolean},inject:{uploader:{default:''}},data:function data(){return{dragover:false};},methods:{onDragover:function onDragover(){if(!this.disabled){this.dragover=true;}},onDrop:function onDrop(e){if(this.disabled||!this.uploader)return;var accept=this.uploader.accept;this.dragover=false;if(!accept){this.$emit('file',e.dataTransfer.files);return;}this.$emit('file',[].slice.call(e.dataTransfer.files).filter(function(file){var type=file.type,name=file.name;var extension=name.indexOf('.')>-1?'.'+name.split('.').pop():'';var baseType=type.replace(/\/.*$/,'');return accept.split(',').map(function(type){return type.trim();}).filter(function(type){return type;}).some(function(acceptedType){if(/\..+$/.test(acceptedType)){return extension===acceptedType;}if(/\/\*$/.test(acceptedType)){return baseType===acceptedType.replace(/\/\*$/,'');}if(/^[^\/]+\/[^\/]+$/.test(acceptedType)){return type===acceptedType;}return false;});}));}}};// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue?vue&type=script&lang=js&
/* harmony default export */var src_upload_draggervue_type_script_lang_js_=upload_draggervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload-dragger.vue
/* normalize component */var upload_dragger_component=normalizeComponent(src_upload_draggervue_type_script_lang_js_,upload_draggervue_type_template_id_7ebbf219_render,upload_draggervue_type_template_id_7ebbf219_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_dragger_api;}upload_dragger_component.options.__file="packages/upload/src/upload-dragger.vue";/* harmony default export */var upload_dragger=upload_dragger_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/upload.vue?vue&type=script&lang=js&
/* harmony default export */var uploadvue_type_script_lang_js_={inject:['uploader'],components:{UploadDragger:upload_dragger},props:{type:String,action:{type:String,required:true},name:{type:String,default:'file'},data:Object,headers:Object,withCredentials:Boolean,multiple:Boolean,accept:String,onStart:Function,onProgress:Function,onSuccess:Function,onError:Function,beforeUpload:Function,drag:Boolean,onPreview:{type:Function,default:function _default(){}},onRemove:{type:Function,default:function _default(){}},fileList:Array,autoUpload:Boolean,listType:String,httpRequest:{type:Function,default:upload},disabled:Boolean,limit:Number,onExceed:Function},data:function data(){return{mouseover:false,reqs:{}};},methods:{isImage:function isImage(str){return str.indexOf('image')!==-1;},handleChange:function handleChange(ev){var files=ev.target.files;if(!files)return;this.uploadFiles(files);},uploadFiles:function uploadFiles(files){var _this=this;if(this.limit&&this.fileList.length+files.length>this.limit){this.onExceed&&this.onExceed(files,this.fileList);return;}var postFiles=Array.prototype.slice.call(files);if(!this.multiple){postFiles=postFiles.slice(0,1);}if(postFiles.length===0){return;}postFiles.forEach(function(rawFile){_this.onStart(rawFile);if(_this.autoUpload)_this.upload(rawFile);});},upload:function upload(rawFile){var _this2=this;this.$refs.input.value=null;if(!this.beforeUpload){return this.post(rawFile);}var before=this.beforeUpload(rawFile);if(before&&before.then){before.then(function(processedFile){var fileType=Object.prototype.toString.call(processedFile);if(fileType==='[object File]'||fileType==='[object Blob]'){if(fileType==='[object Blob]'){processedFile=new File([processedFile],rawFile.name,{type:rawFile.type});}for(var p in rawFile){if(rawFile.hasOwnProperty(p)){processedFile[p]=rawFile[p];}}_this2.post(processedFile);}else{_this2.post(rawFile);}},function(){_this2.onRemove(null,rawFile);});}else if(before!==false){this.post(rawFile);}else{this.onRemove(null,rawFile);}},abort:function abort(file){var reqs=this.reqs;if(file){var uid=file;if(file.uid)uid=file.uid;if(reqs[uid]){reqs[uid].abort();}}else{Object.keys(reqs).forEach(function(uid){if(reqs[uid])reqs[uid].abort();delete reqs[uid];});}},post:function post(rawFile){var _this3=this;var uid=rawFile.uid;var options={headers:this.headers,withCredentials:this.withCredentials,file:rawFile,data:this.data,filename:this.name,action:this.action,onProgress:function onProgress(e){_this3.onProgress(e,rawFile);},onSuccess:function onSuccess(res){_this3.onSuccess(res,rawFile);delete _this3.reqs[uid];},onError:function onError(err){_this3.onError(err,rawFile);delete _this3.reqs[uid];}};var req=this.httpRequest(options);this.reqs[uid]=req;if(req&&req.then){req.then(options.onSuccess,options.onError);}},handleClick:function handleClick(){if(!this.disabled){this.$refs.input.value=null;this.$refs.input.click();}},handleKeydown:function handleKeydown(e){if(e.target!==e.currentTarget)return;if(e.keyCode===13||e.keyCode===32){this.handleClick();}}},render:function render(h){var handleClick=this.handleClick,drag=this.drag,name=this.name,handleChange=this.handleChange,multiple=this.multiple,accept=this.accept,listType=this.listType,uploadFiles=this.uploadFiles,disabled=this.disabled,handleKeydown=this.handleKeydown;var data={class:{'el-upload':true},on:{click:handleClick,keydown:handleKeydown}};data.class['el-upload--'+listType]=true;return h('div',external_babel_helper_vue_jsx_merge_props_default()([data,{attrs:{tabindex:'0'}}]),[drag?h('upload-dragger',{attrs:{disabled:disabled},on:{'file':uploadFiles}},[this.$slots.default]):this.$slots.default,h('input',{'class':'el-upload__input',attrs:{type:'file',name:name,multiple:multiple,accept:accept},ref:'input',on:{'change':handleChange}})]);}};// CONCATENATED MODULE: ./packages/upload/src/upload.vue?vue&type=script&lang=js&
/* harmony default export */var src_uploadvue_type_script_lang_js_=uploadvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/upload.vue
var upload_render,upload_staticRenderFns;/* normalize component */var upload_component=normalizeComponent(src_uploadvue_type_script_lang_js_,upload_render,upload_staticRenderFns,false,null,null,null);/* hot reload */if(false){var upload_api;}upload_component.options.__file="packages/upload/src/upload.vue";/* harmony default export */var src_upload=upload_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/upload/src/index.vue?vue&type=script&lang=js&
function srcvue_type_script_lang_js_noop(){}/* harmony default export */var srcvue_type_script_lang_js_={name:'ElUpload',mixins:[migrating_default.a],components:{ElProgress:progress_default.a,UploadList:upload_list,Upload:src_upload},provide:function provide(){return{uploader:this};},inject:{elForm:{default:''}},props:{action:{type:String,required:true},headers:{type:Object,default:function _default(){return{};}},data:Object,multiple:Boolean,name:{type:String,default:'file'},drag:Boolean,dragger:Boolean,withCredentials:Boolean,showFileList:{type:Boolean,default:true},accept:String,type:{type:String,default:'select'},beforeUpload:Function,beforeRemove:Function,onRemove:{type:Function,default:srcvue_type_script_lang_js_noop},onChange:{type:Function,default:srcvue_type_script_lang_js_noop},onPreview:{type:Function},onSuccess:{type:Function,default:srcvue_type_script_lang_js_noop},onProgress:{type:Function,default:srcvue_type_script_lang_js_noop},onError:{type:Function,default:srcvue_type_script_lang_js_noop},fileList:{type:Array,default:function _default(){return[];}},autoUpload:{type:Boolean,default:true},listType:{type:String,default:'text'// text,picture,picture-card
},httpRequest:Function,disabled:Boolean,limit:Number,onExceed:{type:Function,default:srcvue_type_script_lang_js_noop}},data:function data(){return{uploadFiles:[],dragOver:false,draging:false,tempIndex:1};},computed:{uploadDisabled:function uploadDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{listType:function listType(type){if(type==='picture-card'||type==='picture'){this.uploadFiles=this.uploadFiles.map(function(file){if(!file.url&&file.raw){try{file.url=URL.createObjectURL(file.raw);}catch(err){console.error('[Element Error][Upload]',err);}}return file;});}},fileList:{immediate:true,handler:function handler(fileList){var _this=this;this.uploadFiles=fileList.map(function(item){item.uid=item.uid||Date.now()+_this.tempIndex++;item.status=item.status||'success';return item;});}}},methods:{handleStart:function handleStart(rawFile){rawFile.uid=Date.now()+this.tempIndex++;var file={status:'ready',name:rawFile.name,size:rawFile.size,percentage:0,uid:rawFile.uid,raw:rawFile};if(this.listType==='picture-card'||this.listType==='picture'){try{file.url=URL.createObjectURL(rawFile);}catch(err){console.error('[Element Error][Upload]',err);return;}}this.uploadFiles.push(file);this.onChange(file,this.uploadFiles);},handleProgress:function handleProgress(ev,rawFile){var file=this.getFile(rawFile);this.onProgress(ev,file,this.uploadFiles);file.status='uploading';file.percentage=ev.percent||0;},handleSuccess:function handleSuccess(res,rawFile){var file=this.getFile(rawFile);if(file){file.status='success';file.response=res;this.onSuccess(res,file,this.uploadFiles);this.onChange(file,this.uploadFiles);}},handleError:function handleError(err,rawFile){var file=this.getFile(rawFile);var fileList=this.uploadFiles;file.status='fail';fileList.splice(fileList.indexOf(file),1);this.onError(err,file,this.uploadFiles);this.onChange(file,this.uploadFiles);},handleRemove:function handleRemove(file,raw){var _this2=this;if(raw){file=this.getFile(raw);}var doRemove=function doRemove(){_this2.abort(file);var fileList=_this2.uploadFiles;fileList.splice(fileList.indexOf(file),1);_this2.onRemove(file,fileList);};if(!this.beforeRemove){doRemove();}else if(typeof this.beforeRemove==='function'){var before=this.beforeRemove(file,this.uploadFiles);if(before&&before.then){before.then(function(){doRemove();},srcvue_type_script_lang_js_noop);}else if(before!==false){doRemove();}}},getFile:function getFile(rawFile){var fileList=this.uploadFiles;var target=void 0;fileList.every(function(item){target=rawFile.uid===item.uid?item:null;return!target;});return target;},abort:function abort(file){this.$refs['upload-inner'].abort(file);},clearFiles:function clearFiles(){this.uploadFiles=[];},submit:function submit(){var _this3=this;this.uploadFiles.filter(function(file){return file.status==='ready';}).forEach(function(file){_this3.$refs['upload-inner'].upload(file.raw);});},getMigratingConfig:function getMigratingConfig(){return{props:{'default-file-list':'default-file-list is renamed to file-list.','show-upload-list':'show-upload-list is renamed to show-file-list.','thumbnail-mode':'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'}};}},beforeDestroy:function beforeDestroy(){this.uploadFiles.forEach(function(file){if(file.url&&file.url.indexOf('blob:')===0){URL.revokeObjectURL(file.url);}});},render:function render(h){var _this4=this;var uploadList=void 0;if(this.showFileList){uploadList=h(upload_list,{attrs:{disabled:this.uploadDisabled,listType:this.listType,files:this.uploadFiles,handlePreview:this.onPreview},on:{'remove':this.handleRemove}},[function(props){if(_this4.$scopedSlots.file){return _this4.$scopedSlots.file({file:props.file});}}]);}var uploadData={props:{type:this.type,drag:this.drag,action:this.action,multiple:this.multiple,'before-upload':this.beforeUpload,'with-credentials':this.withCredentials,headers:this.headers,name:this.name,data:this.data,accept:this.accept,fileList:this.uploadFiles,autoUpload:this.autoUpload,listType:this.listType,disabled:this.uploadDisabled,limit:this.limit,'on-exceed':this.onExceed,'on-start':this.handleStart,'on-progress':this.handleProgress,'on-success':this.handleSuccess,'on-error':this.handleError,'on-preview':this.onPreview,'on-remove':this.handleRemove,'http-request':this.httpRequest},ref:'upload-inner'};var trigger=this.$slots.trigger||this.$slots.default;var uploadComponent=h('upload',uploadData,[trigger]);return h('div',[this.listType==='picture-card'?uploadList:'',this.$slots.trigger?[uploadComponent,this.$slots.default]:uploadComponent,this.$slots.tip,this.listType!=='picture-card'?uploadList:'']);}};// CONCATENATED MODULE: ./packages/upload/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var upload_srcvue_type_script_lang_js_=srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/upload/src/index.vue
var src_render,src_staticRenderFns;/* normalize component */var upload_src_component=normalizeComponent(upload_srcvue_type_script_lang_js_,src_render,src_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_api;}upload_src_component.options.__file="packages/upload/src/index.vue";/* harmony default export */var upload_src=upload_src_component.exports;// CONCATENATED MODULE: ./packages/upload/index.js
/* istanbul ignore next */upload_src.install=function(Vue){Vue.component(upload_src.name,upload_src);};/* harmony default export */var packages_upload=upload_src;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
var progressvue_type_template_id_229ee406_render=function progressvue_type_template_id_229ee406_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-progress",class:["el-progress--"+_vm.type,_vm.status?"is-"+_vm.status:"",{"el-progress--without-text":!_vm.showText,"el-progress--text-inside":_vm.textInside}],attrs:{role:"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[_vm.type==="line"?_c("div",{staticClass:"el-progress-bar"},[_c("div",{staticClass:"el-progress-bar__outer",style:{height:_vm.strokeWidth+"px"}},[_c("div",{staticClass:"el-progress-bar__inner",style:_vm.barStyle},[_vm.showText&&_vm.textInside?_c("div",{staticClass:"el-progress-bar__innerText"},[_vm._v(_vm._s(_vm.content))]):_vm._e()])])]):_c("div",{staticClass:"el-progress-circle",style:{height:_vm.width+"px",width:_vm.width+"px"}},[_c("svg",{attrs:{viewBox:"0 0 100 100"}},[_c("path",{staticClass:"el-progress-circle__track",style:_vm.trailPathStyle,attrs:{d:_vm.trackPath,stroke:"#e5e9f2","stroke-width":_vm.relativeStrokeWidth,fill:"none"}}),_c("path",{staticClass:"el-progress-circle__path",style:_vm.circlePathStyle,attrs:{d:_vm.trackPath,stroke:_vm.stroke,fill:"none","stroke-linecap":_vm.strokeLinecap,"stroke-width":_vm.percentage?_vm.relativeStrokeWidth:0}})])]),_vm.showText&&!_vm.textInside?_c("div",{staticClass:"el-progress__text",style:{fontSize:_vm.progressTextSize+"px"}},[!_vm.status?[_vm._v(_vm._s(_vm.content))]:_c("i",{class:_vm.iconClass})],2):_vm._e()]);};var progressvue_type_template_id_229ee406_staticRenderFns=[];progressvue_type_template_id_229ee406_render._withStripped=true;// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var progressvue_type_script_lang_js_={name:'ElProgress',props:{type:{type:String,default:'line',validator:function validator(val){return['line','circle','dashboard'].indexOf(val)>-1;}},percentage:{type:Number,default:0,required:true,validator:function validator(val){return val>=0&&val<=100;}},status:{type:String,validator:function validator(val){return['success','exception','warning'].indexOf(val)>-1;}},strokeWidth:{type:Number,default:6},strokeLinecap:{type:String,default:'round'},textInside:{type:Boolean,default:false},width:{type:Number,default:126},showText:{type:Boolean,default:true},color:{type:[String,Array,Function],default:''},format:Function},computed:{barStyle:function barStyle(){var style={};style.width=this.percentage+'%';style.backgroundColor=this.getCurrentColor(this.percentage);return style;},relativeStrokeWidth:function relativeStrokeWidth(){return(this.strokeWidth/this.width*100).toFixed(1);},radius:function radius(){if(this.type==='circle'||this.type==='dashboard'){return parseInt(50-parseFloat(this.relativeStrokeWidth)/2,10);}else{return 0;}},trackPath:function trackPath(){var radius=this.radius;var isDashboard=this.type==='dashboard';return'\n        M 50 50\n        m 0 '+(isDashboard?'':'-')+radius+'\n        a '+radius+' '+radius+' 0 1 1 0 '+(isDashboard?'-':'')+radius*2+'\n        a '+radius+' '+radius+' 0 1 1 0 '+(isDashboard?'':'-')+radius*2+'\n        ';},perimeter:function perimeter(){return 2*Math.PI*this.radius;},rate:function rate(){return this.type==='dashboard'?0.75:1;},strokeDashoffset:function strokeDashoffset(){var offset=-1*this.perimeter*(1-this.rate)/2;return offset+'px';},trailPathStyle:function trailPathStyle(){return{strokeDasharray:this.perimeter*this.rate+'px, '+this.perimeter+'px',strokeDashoffset:this.strokeDashoffset};},circlePathStyle:function circlePathStyle(){return{strokeDasharray:this.perimeter*this.rate*(this.percentage/100)+'px, '+this.perimeter+'px',strokeDashoffset:this.strokeDashoffset,transition:'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'};},stroke:function stroke(){var ret=void 0;if(this.color){ret=this.getCurrentColor(this.percentage);}else{switch(this.status){case'success':ret='#13ce66';break;case'exception':ret='#ff4949';break;case'warning':ret='#e6a23c';break;default:ret='#20a0ff';}}return ret;},iconClass:function iconClass(){if(this.status==='warning'){return'el-icon-warning';}if(this.type==='line'){return this.status==='success'?'el-icon-circle-check':'el-icon-circle-close';}else{return this.status==='success'?'el-icon-check':'el-icon-close';}},progressTextSize:function progressTextSize(){return this.type==='line'?12+this.strokeWidth*0.4:this.width*0.111111+2;},content:function content(){if(typeof this.format==='function'){return this.format(this.percentage)||'';}else{return this.percentage+'%';}}},methods:{getCurrentColor:function getCurrentColor(percentage){if(typeof this.color==='function'){return this.color(percentage);}else if(typeof this.color==='string'){return this.color;}else{return this.getLevelColor(percentage);}},getLevelColor:function getLevelColor(percentage){var colorArray=this.getColorArray().sort(function(a,b){return a.percentage-b.percentage;});for(var i=0;i<colorArray.length;i++){if(colorArray[i].percentage>percentage){return colorArray[i].color;}}return colorArray[colorArray.length-1].color;},getColorArray:function getColorArray(){var color=this.color;var span=100/color.length;return color.map(function(seriesColor,index){if(typeof seriesColor==='string'){return{color:seriesColor,percentage:(index+1)*span};}return seriesColor;});}}};// CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
/* harmony default export */var src_progressvue_type_script_lang_js_=progressvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/progress/src/progress.vue
/* normalize component */var progress_component=normalizeComponent(src_progressvue_type_script_lang_js_,progressvue_type_template_id_229ee406_render,progressvue_type_template_id_229ee406_staticRenderFns,false,null,null,null);/* hot reload */if(false){var progress_api;}progress_component.options.__file="packages/progress/src/progress.vue";/* harmony default export */var progress=progress_component.exports;// CONCATENATED MODULE: ./packages/progress/index.js
/* istanbul ignore next */progress.install=function(Vue){Vue.component(progress.name,progress);};/* harmony default export */var packages_progress=progress;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
var spinnervue_type_template_id_697b8538_render=function spinnervue_type_template_id_697b8538_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("span",{staticClass:"el-spinner"},[_c("svg",{staticClass:"el-spinner-inner",style:{width:_vm.radius/2+"px",height:_vm.radius/2+"px"},attrs:{viewBox:"0 0 50 50"}},[_c("circle",{staticClass:"path",attrs:{cx:"25",cy:"25",r:"20",fill:"none",stroke:_vm.strokeColor,"stroke-width":_vm.strokeWidth}})])]);};var spinnervue_type_template_id_697b8538_staticRenderFns=[];spinnervue_type_template_id_697b8538_render._withStripped=true;// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=template&id=697b8538&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
/* harmony default export */var spinnervue_type_script_lang_js_={name:'ElSpinner',props:{type:String,radius:{type:Number,default:100},strokeWidth:{type:Number,default:5},strokeColor:{type:String,default:'#efefef'}}};// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue?vue&type=script&lang=js&
/* harmony default export */var src_spinnervue_type_script_lang_js_=spinnervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/spinner/src/spinner.vue
/* normalize component */var spinner_component=normalizeComponent(src_spinnervue_type_script_lang_js_,spinnervue_type_template_id_697b8538_render,spinnervue_type_template_id_697b8538_staticRenderFns,false,null,null,null);/* hot reload */if(false){var spinner_api;}spinner_component.options.__file="packages/spinner/src/spinner.vue";/* harmony default export */var spinner=spinner_component.exports;// CONCATENATED MODULE: ./packages/spinner/index.js
/* istanbul ignore next */spinner.install=function(Vue){Vue.component(spinner.name,spinner);};/* harmony default export */var packages_spinner=spinner;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=template&id=455b9f60&
var mainvue_type_template_id_455b9f60_render=function mainvue_type_template_id_455b9f60_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-message-fade"},on:{"after-leave":_vm.handleAfterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],class:["el-message",_vm.type&&!_vm.iconClass?"el-message--"+_vm.type:"",_vm.center?"is-center":"",_vm.showClose?"is-closable":"",_vm.customClass],style:_vm.positionStyle,attrs:{role:"alert"},on:{mouseenter:_vm.clearTimer,mouseleave:_vm.startTimer}},[_vm.iconClass?_c("i",{class:_vm.iconClass}):_c("i",{class:_vm.typeClass}),_vm._t("default",[!_vm.dangerouslyUseHTMLString?_c("p",{staticClass:"el-message__content"},[_vm._v(_vm._s(_vm.message))]):_c("p",{staticClass:"el-message__content",domProps:{innerHTML:_vm._s(_vm.message)}})]),_vm.showClose?_c("i",{staticClass:"el-message__closeBtn el-icon-close",on:{click:_vm.close}}):_vm._e()],2)]);};var mainvue_type_template_id_455b9f60_staticRenderFns=[];mainvue_type_template_id_455b9f60_render._withStripped=true;// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=template&id=455b9f60&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/message/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var src_mainvue_type_script_lang_js_typeMap={success:'success',info:'info',warning:'warning',error:'error'};/* harmony default export */var message_src_mainvue_type_script_lang_js_={data:function data(){return{visible:false,message:'',duration:3000,type:'info',iconClass:'',customClass:'',onClose:null,showClose:false,closed:false,verticalOffset:20,timer:null,dangerouslyUseHTMLString:false,center:false};},computed:{typeClass:function typeClass(){return this.type&&!this.iconClass?'el-message__icon el-icon-'+src_mainvue_type_script_lang_js_typeMap[this.type]:'';},positionStyle:function positionStyle(){return{'top':this.verticalOffset+'px'};}},watch:{closed:function closed(newVal){if(newVal){this.visible=false;}}},methods:{handleAfterLeave:function handleAfterLeave(){this.$destroy(true);this.$el.parentNode.removeChild(this.$el);},close:function close(){this.closed=true;if(typeof this.onClose==='function'){this.onClose(this);}},clearTimer:function clearTimer(){clearTimeout(this.timer);},startTimer:function startTimer(){var _this=this;if(this.duration>0){this.timer=setTimeout(function(){if(!_this.closed){_this.close();}},this.duration);}},keydown:function keydown(e){if(e.keyCode===27){// esc关闭消息
if(!this.closed){this.close();}}}},mounted:function mounted(){this.startTimer();document.addEventListener('keydown',this.keydown);},beforeDestroy:function beforeDestroy(){document.removeEventListener('keydown',this.keydown);}};// CONCATENATED MODULE: ./packages/message/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_message_src_mainvue_type_script_lang_js_=message_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/message/src/main.vue
/* normalize component */var message_src_main_component=normalizeComponent(packages_message_src_mainvue_type_script_lang_js_,mainvue_type_template_id_455b9f60_render,mainvue_type_template_id_455b9f60_staticRenderFns,false,null,null,null);/* hot reload */if(false){var message_src_main_api;}message_src_main_component.options.__file="packages/message/src/main.vue";/* harmony default export */var message_src_main=message_src_main_component.exports;// EXTERNAL MODULE: external "element-ui/lib/utils/types"
var types_=__webpack_require__(16);// CONCATENATED MODULE: ./packages/message/src/main.js
var main_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var MessageConstructor=external_vue_default.a.extend(message_src_main);var message_src_main_instance=void 0;var main_instances=[];var main_seed=1;var main_Message=function Message(options){if(external_vue_default.a.prototype.$isServer)return;options=options||{};if(typeof options==='string'){options={message:options};}var userOnClose=options.onClose;var id='message_'+main_seed++;options.onClose=function(){Message.close(id,userOnClose);};message_src_main_instance=new MessageConstructor({data:options});message_src_main_instance.id=id;if(Object(vdom_["isVNode"])(message_src_main_instance.message)){message_src_main_instance.$slots.default=[message_src_main_instance.message];message_src_main_instance.message=null;}message_src_main_instance.$mount();document.body.appendChild(message_src_main_instance.$el);var verticalOffset=options.offset||20;main_instances.forEach(function(item){verticalOffset+=item.$el.offsetHeight+16;});message_src_main_instance.verticalOffset=verticalOffset;message_src_main_instance.visible=true;message_src_main_instance.$el.style.zIndex=popup_["PopupManager"].nextZIndex();main_instances.push(message_src_main_instance);return message_src_main_instance;};['success','warning','info','error'].forEach(function(type){main_Message[type]=function(options){if(Object(types_["isObject"])(options)&&!Object(vdom_["isVNode"])(options)){return main_Message(main_extends({},options,{type:type}));}return main_Message({type:type,message:options});};});main_Message.close=function(id,userOnClose){var len=main_instances.length;var index=-1;var removedHeight=void 0;for(var i=0;i<len;i++){if(id===main_instances[i].id){removedHeight=main_instances[i].$el.offsetHeight;index=i;if(typeof userOnClose==='function'){userOnClose(main_instances[i]);}main_instances.splice(i,1);break;}}if(len<=1||index===-1||index>main_instances.length-1)return;for(var _i=index;_i<len-1;_i++){var dom=main_instances[_i].$el;dom.style['top']=parseInt(dom.style['top'],10)-removedHeight-16+'px';}};main_Message.closeAll=function(){for(var i=main_instances.length-1;i>=0;i--){main_instances[i].close();}};/* harmony default export */var packages_message_src_main=main_Message;// CONCATENATED MODULE: ./packages/message/index.js
/* harmony default export */var packages_message=packages_message_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
var mainvue_type_template_id_7ccb6598_render=function mainvue_type_template_id_7ccb6598_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-badge"},[_vm._t("default"),_c("transition",{attrs:{name:"el-zoom-in-center"}},[_c("sup",{directives:[{name:"show",rawName:"v-show",value:!_vm.hidden&&(_vm.content||_vm.content===0||_vm.isDot),expression:"!hidden && (content || content === 0 || isDot)"}],staticClass:"el-badge__content",class:[_vm.type?"el-badge__content--"+_vm.type:null,{"is-fixed":_vm.$slots.default,"is-dot":_vm.isDot}],domProps:{textContent:_vm._s(_vm.content)}})])],2);};var mainvue_type_template_id_7ccb6598_staticRenderFns=[];mainvue_type_template_id_7ccb6598_render._withStripped=true;// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=template&id=7ccb6598&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/badge/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var badge_src_mainvue_type_script_lang_js_={name:'ElBadge',props:{value:[String,Number],max:Number,isDot:Boolean,hidden:Boolean,type:{type:String,validator:function validator(val){return['primary','success','warning','info','danger'].indexOf(val)>-1;}}},computed:{content:function content(){if(this.isDot)return;var value=this.value;var max=this.max;if(typeof value==='number'&&typeof max==='number'){return max<value?max+'+':value;}return value;}}};// CONCATENATED MODULE: ./packages/badge/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_badge_src_mainvue_type_script_lang_js_=badge_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/badge/src/main.vue
/* normalize component */var badge_src_main_component=normalizeComponent(packages_badge_src_mainvue_type_script_lang_js_,mainvue_type_template_id_7ccb6598_render,mainvue_type_template_id_7ccb6598_staticRenderFns,false,null,null,null);/* hot reload */if(false){var badge_src_main_api;}badge_src_main_component.options.__file="packages/badge/src/main.vue";/* harmony default export */var badge_src_main=badge_src_main_component.exports;// CONCATENATED MODULE: ./packages/badge/index.js
/* istanbul ignore next */badge_src_main.install=function(Vue){Vue.component(badge_src_main.name,badge_src_main);};/* harmony default export */var badge=badge_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
var mainvue_type_template_id_59a4a40f_render=function mainvue_type_template_id_59a4a40f_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-card",class:_vm.shadow?"is-"+_vm.shadow+"-shadow":"is-always-shadow"},[_vm.$slots.header||_vm.header?_c("div",{staticClass:"el-card__header"},[_vm._t("header",[_vm._v(_vm._s(_vm.header))])],2):_vm._e(),_c("div",{staticClass:"el-card__body",style:_vm.bodyStyle},[_vm._t("default")],2)]);};var mainvue_type_template_id_59a4a40f_staticRenderFns=[];mainvue_type_template_id_59a4a40f_render._withStripped=true;// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=template&id=59a4a40f&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/card/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var card_src_mainvue_type_script_lang_js_={name:'ElCard',props:{header:{},bodyStyle:{},shadow:{type:String}}};// CONCATENATED MODULE: ./packages/card/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_card_src_mainvue_type_script_lang_js_=card_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/card/src/main.vue
/* normalize component */var card_src_main_component=normalizeComponent(packages_card_src_mainvue_type_script_lang_js_,mainvue_type_template_id_59a4a40f_render,mainvue_type_template_id_59a4a40f_staticRenderFns,false,null,null,null);/* hot reload */if(false){var card_src_main_api;}card_src_main_component.options.__file="packages/card/src/main.vue";/* harmony default export */var card_src_main=card_src_main_component.exports;// CONCATENATED MODULE: ./packages/card/index.js
/* istanbul ignore next */card_src_main.install=function(Vue){Vue.component(card_src_main.name,card_src_main);};/* harmony default export */var card=card_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=template&id=ada57782&
var mainvue_type_template_id_ada57782_render=function mainvue_type_template_id_ada57782_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-rate",attrs:{role:"slider","aria-valuenow":_vm.currentValue,"aria-valuetext":_vm.text,"aria-valuemin":"0","aria-valuemax":_vm.max,tabindex:"0"},on:{keydown:_vm.handleKey}},[_vm._l(_vm.max,function(item,key){return _c("span",{key:key,staticClass:"el-rate__item",style:{cursor:_vm.rateDisabled?"auto":"pointer"},on:{mousemove:function mousemove($event){_vm.setCurrentValue(item,$event);},mouseleave:_vm.resetCurrentValue,click:function click($event){_vm.selectValue(item);}}},[_c("i",{staticClass:"el-rate__icon",class:[_vm.classes[item-1],{hover:_vm.hoverIndex===item}],style:_vm.getIconStyle(item)},[_vm.showDecimalIcon(item)?_c("i",{staticClass:"el-rate__decimal",class:_vm.decimalIconClass,style:_vm.decimalStyle}):_vm._e()])]);}),_vm.showText||_vm.showScore?_c("span",{staticClass:"el-rate__text",style:{color:_vm.textColor}},[_vm._v(_vm._s(_vm.text))]):_vm._e()],2);};var mainvue_type_template_id_ada57782_staticRenderFns=[];mainvue_type_template_id_ada57782_render._withStripped=true;// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=template&id=ada57782&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/rate/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var rate_src_mainvue_type_script_lang_js_={name:'ElRate',mixins:[migrating_default.a],inject:{elForm:{default:''}},data:function data(){return{pointerAtLeftHalf:true,currentValue:this.value,hoverIndex:-1};},props:{value:{type:Number,default:0},lowThreshold:{type:Number,default:2},highThreshold:{type:Number,default:4},max:{type:Number,default:5},colors:{type:[Array,Object],default:function _default(){return['#F7BA2A','#F7BA2A','#F7BA2A'];}},voidColor:{type:String,default:'#C6D1DE'},disabledVoidColor:{type:String,default:'#EFF2F7'},iconClasses:{type:[Array,Object],default:function _default(){return['el-icon-star-on','el-icon-star-on','el-icon-star-on'];}},voidIconClass:{type:String,default:'el-icon-star-off'},disabledVoidIconClass:{type:String,default:'el-icon-star-on'},disabled:{type:Boolean,default:false},allowHalf:{type:Boolean,default:false},showText:{type:Boolean,default:false},showScore:{type:Boolean,default:false},textColor:{type:String,default:'#1f2d3d'},texts:{type:Array,default:function _default(){return['极差','失望','一般','满意','惊喜'];}},scoreTemplate:{type:String,default:'{value}'}},computed:{text:function text(){var result='';if(this.showScore){result=this.scoreTemplate.replace(/\{\s*value\s*\}/,this.rateDisabled?this.value:this.currentValue);}else if(this.showText){result=this.texts[Math.ceil(this.currentValue)-1];}return result;},decimalStyle:function decimalStyle(){var width='';if(this.rateDisabled){width=this.valueDecimal+'%';}else if(this.allowHalf){width='50%';}return{color:this.activeColor,width:width};},valueDecimal:function valueDecimal(){return this.value*100-Math.floor(this.value)*100;},classMap:function classMap(){var _ref;return Array.isArray(this.iconClasses)?(_ref={},_ref[this.lowThreshold]=this.iconClasses[0],_ref[this.highThreshold]={value:this.iconClasses[1],excluded:true},_ref[this.max]=this.iconClasses[2],_ref):this.iconClasses;},decimalIconClass:function decimalIconClass(){return this.getValueFromMap(this.value,this.classMap);},voidClass:function voidClass(){return this.rateDisabled?this.disabledVoidIconClass:this.voidIconClass;},activeClass:function activeClass(){return this.getValueFromMap(this.currentValue,this.classMap);},colorMap:function colorMap(){var _ref2;return Array.isArray(this.colors)?(_ref2={},_ref2[this.lowThreshold]=this.colors[0],_ref2[this.highThreshold]={value:this.colors[1],excluded:true},_ref2[this.max]=this.colors[2],_ref2):this.colors;},activeColor:function activeColor(){return this.getValueFromMap(this.currentValue,this.colorMap);},classes:function classes(){var result=[];var i=0;var threshold=this.currentValue;if(this.allowHalf&&this.currentValue!==Math.floor(this.currentValue)){threshold--;}for(;i<threshold;i++){result.push(this.activeClass);}for(;i<this.max;i++){result.push(this.voidClass);}return result;},rateDisabled:function rateDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{value:function value(val){this.currentValue=val;this.pointerAtLeftHalf=this.value!==Math.floor(this.value);}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'text-template':'text-template is renamed to score-template.'}};},getValueFromMap:function getValueFromMap(value,map){var matchedKeys=Object.keys(map).filter(function(key){var val=map[key];var excluded=Object(types_["isObject"])(val)?val.excluded:false;return excluded?value<key:value<=key;}).sort(function(a,b){return a-b;});var matchedValue=map[matchedKeys[0]];return Object(types_["isObject"])(matchedValue)?matchedValue.value:matchedValue||'';},showDecimalIcon:function showDecimalIcon(item){var showWhenDisabled=this.rateDisabled&&this.valueDecimal>0&&item-1<this.value&&item>this.value;/* istanbul ignore next */var showWhenAllowHalf=this.allowHalf&&this.pointerAtLeftHalf&&item-0.5<=this.currentValue&&item>this.currentValue;return showWhenDisabled||showWhenAllowHalf;},getIconStyle:function getIconStyle(item){var voidColor=this.rateDisabled?this.disabledVoidColor:this.voidColor;return{color:item<=this.currentValue?this.activeColor:voidColor};},selectValue:function selectValue(value){if(this.rateDisabled){return;}if(this.allowHalf&&this.pointerAtLeftHalf){this.$emit('input',this.currentValue);this.$emit('change',this.currentValue);}else{this.$emit('input',value);this.$emit('change',value);}},handleKey:function handleKey(e){if(this.rateDisabled){return;}var currentValue=this.currentValue;var keyCode=e.keyCode;if(keyCode===38||keyCode===39){// left / down
if(this.allowHalf){currentValue+=0.5;}else{currentValue+=1;}e.stopPropagation();e.preventDefault();}else if(keyCode===37||keyCode===40){if(this.allowHalf){currentValue-=0.5;}else{currentValue-=1;}e.stopPropagation();e.preventDefault();}currentValue=currentValue<0?0:currentValue;currentValue=currentValue>this.max?this.max:currentValue;this.$emit('input',currentValue);this.$emit('change',currentValue);},setCurrentValue:function setCurrentValue(value,event){if(this.rateDisabled){return;}/* istanbul ignore if */if(this.allowHalf){var target=event.target;if(Object(dom_["hasClass"])(target,'el-rate__item')){target=target.querySelector('.el-rate__icon');}if(Object(dom_["hasClass"])(target,'el-rate__decimal')){target=target.parentNode;}this.pointerAtLeftHalf=event.offsetX*2<=target.clientWidth;this.currentValue=this.pointerAtLeftHalf?value-0.5:value;}else{this.currentValue=value;}this.hoverIndex=value;},resetCurrentValue:function resetCurrentValue(){if(this.rateDisabled){return;}if(this.allowHalf){this.pointerAtLeftHalf=this.value!==Math.floor(this.value);}this.currentValue=this.value;this.hoverIndex=-1;}},created:function created(){if(!this.value){this.$emit('input',0);}}};// CONCATENATED MODULE: ./packages/rate/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_rate_src_mainvue_type_script_lang_js_=rate_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/rate/src/main.vue
/* normalize component */var rate_src_main_component=normalizeComponent(packages_rate_src_mainvue_type_script_lang_js_,mainvue_type_template_id_ada57782_render,mainvue_type_template_id_ada57782_staticRenderFns,false,null,null,null);/* hot reload */if(false){var rate_src_main_api;}rate_src_main_component.options.__file="packages/rate/src/main.vue";/* harmony default export */var rate_src_main=rate_src_main_component.exports;// CONCATENATED MODULE: ./packages/rate/index.js
/* istanbul ignore next */rate_src_main.install=function(Vue){Vue.component(rate_src_main.name,rate_src_main);};/* harmony default export */var rate=rate_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
var stepsvue_type_template_id_3c6b6dc0_render=function stepsvue_type_template_id_3c6b6dc0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-steps",class:[!_vm.simple&&"el-steps--"+_vm.direction,_vm.simple&&"el-steps--simple"]},[_vm._t("default")],2);};var stepsvue_type_template_id_3c6b6dc0_staticRenderFns=[];stepsvue_type_template_id_3c6b6dc0_render._withStripped=true;// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=template&id=3c6b6dc0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/steps.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var stepsvue_type_script_lang_js_={name:'ElSteps',mixins:[migrating_default.a],props:{space:[Number,String],active:Number,direction:{type:String,default:'horizontal'},alignCenter:Boolean,simple:Boolean,finishStatus:{type:String,default:'finish'},processStatus:{type:String,default:'process'}},data:function data(){return{steps:[],stepOffset:0};},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'center':'center is removed.'}};}},watch:{active:function active(newVal,oldVal){this.$emit('change',newVal,oldVal);},steps:function steps(_steps){_steps.forEach(function(child,index){child.index=index;});}}};// CONCATENATED MODULE: ./packages/steps/src/steps.vue?vue&type=script&lang=js&
/* harmony default export */var src_stepsvue_type_script_lang_js_=stepsvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/steps/src/steps.vue
/* normalize component */var steps_component=normalizeComponent(src_stepsvue_type_script_lang_js_,stepsvue_type_template_id_3c6b6dc0_render,stepsvue_type_template_id_3c6b6dc0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var steps_api;}steps_component.options.__file="packages/steps/src/steps.vue";/* harmony default export */var steps=steps_component.exports;// CONCATENATED MODULE: ./packages/steps/index.js
/* istanbul ignore next */steps.install=function(Vue){Vue.component(steps.name,steps);};/* harmony default export */var packages_steps=steps;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
var stepvue_type_template_id_f414a87a_render=function stepvue_type_template_id_f414a87a_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-step",class:[!_vm.isSimple&&"is-"+_vm.$parent.direction,_vm.isSimple&&"is-simple",_vm.isLast&&!_vm.space&&!_vm.isCenter&&"is-flex",_vm.isCenter&&!_vm.isVertical&&!_vm.isSimple&&"is-center"],style:_vm.style},[_c("div",{staticClass:"el-step__head",class:"is-"+_vm.currentStatus},[_c("div",{staticClass:"el-step__line",style:_vm.isLast?"":{marginRight:_vm.$parent.stepOffset+"px"}},[_c("i",{staticClass:"el-step__line-inner",style:_vm.lineStyle})]),_c("div",{staticClass:"el-step__icon",class:"is-"+(_vm.icon?"icon":"text")},[_vm.currentStatus!=="success"&&_vm.currentStatus!=="error"?_vm._t("icon",[_vm.icon?_c("i",{staticClass:"el-step__icon-inner",class:[_vm.icon]}):_vm._e(),!_vm.icon&&!_vm.isSimple?_c("div",{staticClass:"el-step__icon-inner"},[_vm._v(_vm._s(_vm.index+1))]):_vm._e()]):_c("i",{staticClass:"el-step__icon-inner is-status",class:["el-icon-"+(_vm.currentStatus==="success"?"check":"close")]})],2)]),_c("div",{staticClass:"el-step__main"},[_c("div",{ref:"title",staticClass:"el-step__title",class:["is-"+_vm.currentStatus]},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm.isSimple?_c("div",{staticClass:"el-step__arrow"}):_c("div",{staticClass:"el-step__description",class:["is-"+_vm.currentStatus]},[_vm._t("description",[_vm._v(_vm._s(_vm.description))])],2)])]);};var stepvue_type_template_id_f414a87a_staticRenderFns=[];stepvue_type_template_id_f414a87a_render._withStripped=true;// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=template&id=f414a87a&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/steps/src/step.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var stepvue_type_script_lang_js_={name:'ElStep',props:{title:String,icon:String,description:String,status:String},data:function data(){return{index:-1,lineStyle:{},internalStatus:''};},beforeCreate:function beforeCreate(){this.$parent.steps.push(this);},beforeDestroy:function beforeDestroy(){var steps=this.$parent.steps;var index=steps.indexOf(this);if(index>=0){steps.splice(index,1);}},computed:{currentStatus:function currentStatus(){return this.status||this.internalStatus;},prevStatus:function prevStatus(){var prevStep=this.$parent.steps[this.index-1];return prevStep?prevStep.currentStatus:'wait';},isCenter:function isCenter(){return this.$parent.alignCenter;},isVertical:function isVertical(){return this.$parent.direction==='vertical';},isSimple:function isSimple(){return this.$parent.simple;},isLast:function isLast(){var parent=this.$parent;return parent.steps[parent.steps.length-1]===this;},stepsCount:function stepsCount(){return this.$parent.steps.length;},space:function space(){var isSimple=this.isSimple,space=this.$parent.space;return isSimple?'':space;},style:function style(){var style={};var parent=this.$parent;var len=parent.steps.length;var space=typeof this.space==='number'?this.space+'px':this.space?this.space:100/(len-(this.isCenter?0:1))+'%';style.flexBasis=space;if(this.isVertical)return style;if(this.isLast){style.maxWidth=100/this.stepsCount+'%';}else{style.marginRight=-this.$parent.stepOffset+'px';}return style;}},methods:{updateStatus:function updateStatus(val){var prevChild=this.$parent.$children[this.index-1];if(val>this.index){this.internalStatus=this.$parent.finishStatus;}else if(val===this.index&&this.prevStatus!=='error'){this.internalStatus=this.$parent.processStatus;}else{this.internalStatus='wait';}if(prevChild)prevChild.calcProgress(this.internalStatus);},calcProgress:function calcProgress(status){var step=100;var style={};style.transitionDelay=150*this.index+'ms';if(status===this.$parent.processStatus){step=this.currentStatus!=='error'?0:0;}else if(status==='wait'){step=0;style.transitionDelay=-150*this.index+'ms';}style.borderWidth=step&&!this.isSimple?'1px':0;this.$parent.direction==='vertical'?style.height=step+'%':style.width=step+'%';this.lineStyle=style;}},mounted:function mounted(){var _this=this;var unwatch=this.$watch('index',function(val){_this.$watch('$parent.active',_this.updateStatus,{immediate:true});_this.$watch('$parent.processStatus',function(){var activeIndex=_this.$parent.active;_this.updateStatus(activeIndex);},{immediate:true});unwatch();});}};// CONCATENATED MODULE: ./packages/steps/src/step.vue?vue&type=script&lang=js&
/* harmony default export */var src_stepvue_type_script_lang_js_=stepvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/steps/src/step.vue
/* normalize component */var step_component=normalizeComponent(src_stepvue_type_script_lang_js_,stepvue_type_template_id_f414a87a_render,stepvue_type_template_id_f414a87a_staticRenderFns,false,null,null,null);/* hot reload */if(false){var step_api;}step_component.options.__file="packages/steps/src/step.vue";/* harmony default export */var step=step_component.exports;// CONCATENATED MODULE: ./packages/step/index.js
/* istanbul ignore next */step.install=function(Vue){Vue.component(step.name,step);};/* harmony default export */var packages_step=step;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
var mainvue_type_template_id_5d5d1482_render=function mainvue_type_template_id_5d5d1482_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:_vm.carouselClasses,on:{mouseenter:function mouseenter($event){$event.stopPropagation();return _vm.handleMouseEnter($event);},mouseleave:function mouseleave($event){$event.stopPropagation();return _vm.handleMouseLeave($event);}}},[_c("div",{staticClass:"el-carousel__container",style:{height:_vm.height}},[_vm.arrowDisplay?_c("transition",{attrs:{name:"carousel-arrow-left"}},[_c("button",{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow==="always"||_vm.hover)&&(_vm.loop||_vm.activeIndex>0),expression:"(arrow === 'always' || hover) && (loop || activeIndex > 0)"}],staticClass:"el-carousel__arrow el-carousel__arrow--left",attrs:{type:"button"},on:{mouseenter:function mouseenter($event){_vm.handleButtonEnter("left");},mouseleave:_vm.handleButtonLeave,click:function click($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex-1);}}},[_c("i",{staticClass:"el-icon-arrow-left"})])]):_vm._e(),_vm.arrowDisplay?_c("transition",{attrs:{name:"carousel-arrow-right"}},[_c("button",{directives:[{name:"show",rawName:"v-show",value:(_vm.arrow==="always"||_vm.hover)&&(_vm.loop||_vm.activeIndex<_vm.items.length-1),expression:"(arrow === 'always' || hover) && (loop || activeIndex < items.length - 1)"}],staticClass:"el-carousel__arrow el-carousel__arrow--right",attrs:{type:"button"},on:{mouseenter:function mouseenter($event){_vm.handleButtonEnter("right");},mouseleave:_vm.handleButtonLeave,click:function click($event){$event.stopPropagation();_vm.throttledArrowClick(_vm.activeIndex+1);}}},[_c("i",{staticClass:"el-icon-arrow-right"})])]):_vm._e(),_vm._t("default")],2),_vm.indicatorPosition!=="none"?_c("ul",{class:_vm.indicatorsClasses},_vm._l(_vm.items,function(item,index){return _c("li",{key:index,class:["el-carousel__indicator","el-carousel__indicator--"+_vm.direction,{"is-active":index===_vm.activeIndex}],on:{mouseenter:function mouseenter($event){_vm.throttledIndicatorHover(index);},click:function click($event){$event.stopPropagation();_vm.handleIndicatorClick(index);}}},[_c("button",{staticClass:"el-carousel__button"},[_vm.hasLabel?_c("span",[_vm._v(_vm._s(item.label))]):_vm._e()])]);}),0):_vm._e()]);};var mainvue_type_template_id_5d5d1482_staticRenderFns=[];mainvue_type_template_id_5d5d1482_render._withStripped=true;// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=template&id=5d5d1482&
// EXTERNAL MODULE: external "throttle-debounce/throttle"
var throttle_=__webpack_require__(25);var throttle_default=/*#__PURE__*/__webpack_require__.n(throttle_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var carousel_src_mainvue_type_script_lang_js_={name:'ElCarousel',props:{initialIndex:{type:Number,default:0},height:String,trigger:{type:String,default:'hover'},autoplay:{type:Boolean,default:true},interval:{type:Number,default:3000},indicatorPosition:String,indicator:{type:Boolean,default:true},arrow:{type:String,default:'hover'},type:String,loop:{type:Boolean,default:true},direction:{type:String,default:'horizontal',validator:function validator(val){return['horizontal','vertical'].indexOf(val)!==-1;}}},data:function data(){return{items:[],activeIndex:-1,containerWidth:0,timer:null,hover:false};},computed:{arrowDisplay:function arrowDisplay(){return this.arrow!=='never'&&this.direction!=='vertical';},hasLabel:function hasLabel(){return this.items.some(function(item){return item.label.toString().length>0;});},carouselClasses:function carouselClasses(){var classes=['el-carousel','el-carousel--'+this.direction];if(this.type==='card'){classes.push('el-carousel--card');}return classes;},indicatorsClasses:function indicatorsClasses(){var classes=['el-carousel__indicators','el-carousel__indicators--'+this.direction];if(this.hasLabel){classes.push('el-carousel__indicators--labels');}if(this.indicatorPosition==='outside'||this.type==='card'){classes.push('el-carousel__indicators--outside');}return classes;}},watch:{items:function items(val){if(val.length>0)this.setActiveItem(this.initialIndex);},activeIndex:function activeIndex(val,oldVal){this.resetItemPosition(oldVal);if(oldVal>-1){this.$emit('change',val,oldVal);}},autoplay:function autoplay(val){val?this.startTimer():this.pauseTimer();},loop:function loop(){this.setActiveItem(this.activeIndex);},interval:function interval(){this.pauseTimer();this.startTimer();}},methods:{handleMouseEnter:function handleMouseEnter(){this.hover=true;this.pauseTimer();},handleMouseLeave:function handleMouseLeave(){this.hover=false;this.startTimer();},itemInStage:function itemInStage(item,index){var length=this.items.length;if(index===length-1&&item.inStage&&this.items[0].active||item.inStage&&this.items[index+1]&&this.items[index+1].active){return'left';}else if(index===0&&item.inStage&&this.items[length-1].active||item.inStage&&this.items[index-1]&&this.items[index-1].active){return'right';}return false;},handleButtonEnter:function handleButtonEnter(arrow){var _this=this;if(this.direction==='vertical')return;this.items.forEach(function(item,index){if(arrow===_this.itemInStage(item,index)){item.hover=true;}});},handleButtonLeave:function handleButtonLeave(){if(this.direction==='vertical')return;this.items.forEach(function(item){item.hover=false;});},updateItems:function updateItems(){this.items=this.$children.filter(function(child){return child.$options.name==='ElCarouselItem';});},resetItemPosition:function resetItemPosition(oldIndex){var _this2=this;this.items.forEach(function(item,index){item.translateItem(index,_this2.activeIndex,oldIndex);});},playSlides:function playSlides(){if(this.activeIndex<this.items.length-1){this.activeIndex++;}else if(this.loop){this.activeIndex=0;}},pauseTimer:function pauseTimer(){if(this.timer){clearInterval(this.timer);this.timer=null;}},startTimer:function startTimer(){if(this.interval<=0||!this.autoplay||this.timer)return;this.timer=setInterval(this.playSlides,this.interval);},resetTimer:function resetTimer(){this.pauseTimer();this.startTimer();},setActiveItem:function setActiveItem(index){if(typeof index==='string'){var filteredItems=this.items.filter(function(item){return item.name===index;});if(filteredItems.length>0){index=this.items.indexOf(filteredItems[0]);}}index=Number(index);if(isNaN(index)||index!==Math.floor(index)){console.warn('[Element Warn][Carousel]index must be an integer.');return;}var length=this.items.length;var oldIndex=this.activeIndex;if(index<0){this.activeIndex=this.loop?length-1:0;}else if(index>=length){this.activeIndex=this.loop?0:length-1;}else{this.activeIndex=index;}if(oldIndex===this.activeIndex){this.resetItemPosition(oldIndex);}this.resetTimer();},prev:function prev(){this.setActiveItem(this.activeIndex-1);},next:function next(){this.setActiveItem(this.activeIndex+1);},handleIndicatorClick:function handleIndicatorClick(index){this.activeIndex=index;},handleIndicatorHover:function handleIndicatorHover(index){if(this.trigger==='hover'&&index!==this.activeIndex){this.activeIndex=index;}}},created:function created(){var _this3=this;this.throttledArrowClick=throttle_default()(300,true,function(index){_this3.setActiveItem(index);});this.throttledIndicatorHover=throttle_default()(300,function(index){_this3.handleIndicatorHover(index);});},mounted:function mounted(){var _this4=this;this.updateItems();this.$nextTick(function(){Object(resize_event_["addResizeListener"])(_this4.$el,_this4.resetItemPosition);if(_this4.initialIndex<_this4.items.length&&_this4.initialIndex>=0){_this4.activeIndex=_this4.initialIndex;}_this4.startTimer();});},beforeDestroy:function beforeDestroy(){if(this.$el)Object(resize_event_["removeResizeListener"])(this.$el,this.resetItemPosition);this.pauseTimer();}};// CONCATENATED MODULE: ./packages/carousel/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_carousel_src_mainvue_type_script_lang_js_=carousel_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/carousel/src/main.vue
/* normalize component */var carousel_src_main_component=normalizeComponent(packages_carousel_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5d5d1482_render,mainvue_type_template_id_5d5d1482_staticRenderFns,false,null,null,null);/* hot reload */if(false){var carousel_src_main_api;}carousel_src_main_component.options.__file="packages/carousel/src/main.vue";/* harmony default export */var carousel_src_main=carousel_src_main_component.exports;// CONCATENATED MODULE: ./packages/carousel/index.js
/* istanbul ignore next */carousel_src_main.install=function(Vue){Vue.component(carousel_src_main.name,carousel_src_main);};/* harmony default export */var carousel=carousel_src_main;// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
var BAR_MAP={vertical:{offset:'offsetHeight',scroll:'scrollTop',scrollSize:'scrollHeight',size:'height',key:'vertical',axis:'Y',client:'clientY',direction:'top'},horizontal:{offset:'offsetWidth',scroll:'scrollLeft',scrollSize:'scrollWidth',size:'width',key:'horizontal',axis:'X',client:'clientX',direction:'left'}};function renderThumbStyle(_ref){var move=_ref.move,size=_ref.size,bar=_ref.bar;var style={};var translate='translate'+bar.axis+'('+move+'%)';style[bar.size]=size;style.transform=translate;style.msTransform=translate;style.webkitTransform=translate;return style;};// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js
/* istanbul ignore next *//* harmony default export */var src_bar={name:'Bar',props:{vertical:Boolean,size:String,move:Number},computed:{bar:function bar(){return BAR_MAP[this.vertical?'vertical':'horizontal'];},wrap:function wrap(){return this.$parent.wrap;}},render:function render(h){var size=this.size,move=this.move,bar=this.bar;return h('div',{'class':['el-scrollbar__bar','is-'+bar.key],on:{'mousedown':this.clickTrackHandler}},[h('div',{ref:'thumb','class':'el-scrollbar__thumb',on:{'mousedown':this.clickThumbHandler},style:renderThumbStyle({size:size,move:move,bar:bar})})]);},methods:{clickThumbHandler:function clickThumbHandler(e){// prevent click event of right button
if(e.ctrlKey||e.button===2){return;}this.startDrag(e);this[this.bar.axis]=e.currentTarget[this.bar.offset]-(e[this.bar.client]-e.currentTarget.getBoundingClientRect()[this.bar.direction]);},clickTrackHandler:function clickTrackHandler(e){var offset=Math.abs(e.target.getBoundingClientRect()[this.bar.direction]-e[this.bar.client]);var thumbHalf=this.$refs.thumb[this.bar.offset]/2;var thumbPositionPercentage=(offset-thumbHalf)*100/this.$el[this.bar.offset];this.wrap[this.bar.scroll]=thumbPositionPercentage*this.wrap[this.bar.scrollSize]/100;},startDrag:function startDrag(e){e.stopImmediatePropagation();this.cursorDown=true;Object(dom_["on"])(document,'mousemove',this.mouseMoveDocumentHandler);Object(dom_["on"])(document,'mouseup',this.mouseUpDocumentHandler);document.onselectstart=function(){return false;};},mouseMoveDocumentHandler:function mouseMoveDocumentHandler(e){if(this.cursorDown===false)return;var prevPage=this[this.bar.axis];if(!prevPage)return;var offset=(this.$el.getBoundingClientRect()[this.bar.direction]-e[this.bar.client])*-1;var thumbClickPosition=this.$refs.thumb[this.bar.offset]-prevPage;var thumbPositionPercentage=(offset-thumbClickPosition)*100/this.$el[this.bar.offset];this.wrap[this.bar.scroll]=thumbPositionPercentage*this.wrap[this.bar.scrollSize]/100;},mouseUpDocumentHandler:function mouseUpDocumentHandler(e){this.cursorDown=false;this[this.bar.axis]=0;Object(dom_["off"])(document,'mousemove',this.mouseMoveDocumentHandler);document.onselectstart=null;}},destroyed:function destroyed(){Object(dom_["off"])(document,'mouseup',this.mouseUpDocumentHandler);}};// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js
/* istanbul ignore next *//* harmony default export */var scrollbar_src_main={name:'ElScrollbar',components:{Bar:src_bar},props:{native:Boolean,wrapStyle:{},wrapClass:{},viewClass:{},viewStyle:{},noresize:Boolean,// 如果 container 尺寸不会发生变化，最好设置它可以优化性能
tag:{type:String,default:'div'}},data:function data(){return{sizeWidth:'0',sizeHeight:'0',moveX:0,moveY:0};},computed:{wrap:function wrap(){return this.$refs.wrap;}},render:function render(h){var gutter=scrollbar_width_default()();var style=this.wrapStyle;if(gutter){var gutterWith='-'+gutter+'px';var gutterStyle='margin-bottom: '+gutterWith+'; margin-right: '+gutterWith+';';if(Array.isArray(this.wrapStyle)){style=Object(util_["toObject"])(this.wrapStyle);style.marginRight=style.marginBottom=gutterWith;}else if(typeof this.wrapStyle==='string'){style+=gutterStyle;}else{style=gutterStyle;}}var view=h(this.tag,{class:['el-scrollbar__view',this.viewClass],style:this.viewStyle,ref:'resize'},this.$slots.default);var wrap=h('div',{ref:'wrap',style:style,on:{'scroll':this.handleScroll},'class':[this.wrapClass,'el-scrollbar__wrap',gutter?'':'el-scrollbar__wrap--hidden-default']},[[view]]);var nodes=void 0;if(!this.native){nodes=[wrap,h(src_bar,{attrs:{move:this.moveX,size:this.sizeWidth}}),h(src_bar,{attrs:{vertical:true,move:this.moveY,size:this.sizeHeight}})];}else{nodes=[h('div',{ref:'wrap','class':[this.wrapClass,'el-scrollbar__wrap'],style:style},[[view]])];}return h('div',{class:'el-scrollbar'},nodes);},methods:{handleScroll:function handleScroll(){var wrap=this.wrap;this.moveY=wrap.scrollTop*100/wrap.clientHeight;this.moveX=wrap.scrollLeft*100/wrap.clientWidth;},update:function update(){var heightPercentage=void 0,widthPercentage=void 0;var wrap=this.wrap;if(!wrap)return;heightPercentage=wrap.clientHeight*100/wrap.scrollHeight;widthPercentage=wrap.clientWidth*100/wrap.scrollWidth;this.sizeHeight=heightPercentage<100?heightPercentage+'%':'';this.sizeWidth=widthPercentage<100?widthPercentage+'%':'';}},mounted:function mounted(){if(this.native)return;this.$nextTick(this.update);!this.noresize&&Object(resize_event_["addResizeListener"])(this.$refs.resize,this.update);},beforeDestroy:function beforeDestroy(){if(this.native)return;!this.noresize&&Object(resize_event_["removeResizeListener"])(this.$refs.resize,this.update);}};// CONCATENATED MODULE: ./packages/scrollbar/index.js
/* istanbul ignore next */scrollbar_src_main.install=function(Vue){Vue.component(scrollbar_src_main.name,scrollbar_src_main);};/* harmony default export */var scrollbar=scrollbar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
var itemvue_type_template_id_1801ae19_render=function itemvue_type_template_id_1801ae19_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.ready,expression:"ready"}],staticClass:"el-carousel__item",class:{"is-active":_vm.active,"el-carousel__item--card":_vm.$parent.type==="card","is-in-stage":_vm.inStage,"is-hover":_vm.hover,"is-animating":_vm.animating},style:_vm.itemStyle,on:{click:_vm.handleItemClick}},[_vm.$parent.type==="card"?_c("div",{directives:[{name:"show",rawName:"v-show",value:!_vm.active,expression:"!active"}],staticClass:"el-carousel__mask"}):_vm._e(),_vm._t("default")],2);};var itemvue_type_template_id_1801ae19_staticRenderFns=[];itemvue_type_template_id_1801ae19_render._withStripped=true;// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=template&id=1801ae19&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/carousel/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var CARD_SCALE=0.83;/* harmony default export */var itemvue_type_script_lang_js_={name:'ElCarouselItem',props:{name:String,label:{type:[String,Number],default:''}},data:function data(){return{hover:false,translate:0,scale:1,active:false,ready:false,inStage:false,animating:false};},methods:{processIndex:function processIndex(index,activeIndex,length){if(activeIndex===0&&index===length-1){return-1;}else if(activeIndex===length-1&&index===0){return length;}else if(index<activeIndex-1&&activeIndex-index>=length/2){return length+1;}else if(index>activeIndex+1&&index-activeIndex>=length/2){return-2;}return index;},calcCardTranslate:function calcCardTranslate(index,activeIndex){var parentWidth=this.$parent.$el.offsetWidth;if(this.inStage){return parentWidth*((2-CARD_SCALE)*(index-activeIndex)+1)/4;}else if(index<activeIndex){return-(1+CARD_SCALE)*parentWidth/4;}else{return(3+CARD_SCALE)*parentWidth/4;}},calcTranslate:function calcTranslate(index,activeIndex,isVertical){var distance=this.$parent.$el[isVertical?'offsetHeight':'offsetWidth'];return distance*(index-activeIndex);},translateItem:function translateItem(index,activeIndex,oldIndex){var parentType=this.$parent.type;var parentDirection=this.parentDirection;var length=this.$parent.items.length;if(parentType!=='card'&&oldIndex!==undefined){this.animating=index===activeIndex||index===oldIndex;}if(index!==activeIndex&&length>2&&this.$parent.loop){index=this.processIndex(index,activeIndex,length);}if(parentType==='card'){if(parentDirection==='vertical'){console.warn('[Element Warn][Carousel]vertical direction is not supported in card mode');}this.inStage=Math.round(Math.abs(index-activeIndex))<=1;this.active=index===activeIndex;this.translate=this.calcCardTranslate(index,activeIndex);this.scale=this.active?1:CARD_SCALE;}else{this.active=index===activeIndex;var isVertical=parentDirection==='vertical';this.translate=this.calcTranslate(index,activeIndex,isVertical);this.scale=1;}this.ready=true;},handleItemClick:function handleItemClick(){var parent=this.$parent;if(parent&&parent.type==='card'){var index=parent.items.indexOf(this);parent.setActiveItem(index);}}},computed:{parentDirection:function parentDirection(){return this.$parent.direction;},itemStyle:function itemStyle(){var translateType=this.parentDirection==='vertical'?'translateY':'translateX';var value=translateType+'('+this.translate+'px) scale('+this.scale+')';var style={transform:value};return Object(util_["autoprefixer"])(style);}},created:function created(){this.$parent&&this.$parent.updateItems();},destroyed:function destroyed(){this.$parent&&this.$parent.updateItems();}};// CONCATENATED MODULE: ./packages/carousel/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var src_itemvue_type_script_lang_js_=itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/carousel/src/item.vue
/* normalize component */var item_component=normalizeComponent(src_itemvue_type_script_lang_js_,itemvue_type_template_id_1801ae19_render,itemvue_type_template_id_1801ae19_staticRenderFns,false,null,null,null);/* hot reload */if(false){var item_api;}item_component.options.__file="packages/carousel/src/item.vue";/* harmony default export */var src_item=item_component.exports;// CONCATENATED MODULE: ./packages/carousel-item/index.js
/* istanbul ignore next */src_item.install=function(Vue){Vue.component(src_item.name,src_item);};/* harmony default export */var carousel_item=src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
var collapsevue_type_template_id_461d57f4_render=function collapsevue_type_template_id_461d57f4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-collapse",attrs:{role:"tablist","aria-multiselectable":"true"}},[_vm._t("default")],2);};var collapsevue_type_template_id_461d57f4_staticRenderFns=[];collapsevue_type_template_id_461d57f4_render._withStripped=true;// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=template&id=461d57f4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
//
//
//
//
//
/* harmony default export */var collapsevue_type_script_lang_js_={name:'ElCollapse',componentName:'ElCollapse',props:{accordion:Boolean,value:{type:[Array,String,Number],default:function _default(){return[];}}},data:function data(){return{activeNames:[].concat(this.value)};},provide:function provide(){return{collapse:this};},watch:{value:function value(_value){this.activeNames=[].concat(_value);}},methods:{setActiveNames:function setActiveNames(activeNames){activeNames=[].concat(activeNames);var value=this.accordion?activeNames[0]:activeNames;this.activeNames=activeNames;this.$emit('input',value);this.$emit('change',value);},handleItemClick:function handleItemClick(item){if(this.accordion){this.setActiveNames((this.activeNames[0]||this.activeNames[0]===0)&&this.activeNames[0]===item.name?'':item.name);}else{var activeNames=this.activeNames.slice(0);var index=activeNames.indexOf(item.name);if(index>-1){activeNames.splice(index,1);}else{activeNames.push(item.name);}this.setActiveNames(activeNames);}}},created:function created(){this.$on('item-click',this.handleItemClick);}};// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue?vue&type=script&lang=js&
/* harmony default export */var src_collapsevue_type_script_lang_js_=collapsevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/collapse/src/collapse.vue
/* normalize component */var collapse_component=normalizeComponent(src_collapsevue_type_script_lang_js_,collapsevue_type_template_id_461d57f4_render,collapsevue_type_template_id_461d57f4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var collapse_api;}collapse_component.options.__file="packages/collapse/src/collapse.vue";/* harmony default export */var collapse=collapse_component.exports;// CONCATENATED MODULE: ./packages/collapse/index.js
/* istanbul ignore next */collapse.install=function(Vue){Vue.component(collapse.name,collapse);};/* harmony default export */var packages_collapse=collapse;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
var collapse_itemvue_type_template_id_2d05faac_render=function collapse_itemvue_type_template_id_2d05faac_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-collapse-item",class:{"is-active":_vm.isActive,"is-disabled":_vm.disabled}},[_c("div",{attrs:{role:"tab","aria-expanded":_vm.isActive,"aria-controls":"el-collapse-content-"+_vm.id,"aria-describedby":"el-collapse-content-"+_vm.id}},[_c("div",{staticClass:"el-collapse-item__header",class:{focusing:_vm.focusing,"is-active":_vm.isActive},attrs:{role:"button",id:"el-collapse-head-"+_vm.id,tabindex:_vm.disabled?undefined:0},on:{click:_vm.handleHeaderClick,keyup:function keyup($event){if(!("button"in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}$event.stopPropagation();return _vm.handleEnterClick($event);},focus:_vm.handleFocus,blur:function blur($event){_vm.focusing=false;}}},[_vm._t("title",[_vm._v(_vm._s(_vm.title))]),_c("i",{staticClass:"el-collapse-item__arrow el-icon-arrow-right",class:{"is-active":_vm.isActive}})],2)]),_c("el-collapse-transition",[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.isActive,expression:"isActive"}],staticClass:"el-collapse-item__wrap",attrs:{role:"tabpanel","aria-hidden":!_vm.isActive,"aria-labelledby":"el-collapse-head-"+_vm.id,id:"el-collapse-content-"+_vm.id}},[_c("div",{staticClass:"el-collapse-item__content"},[_vm._t("default")],2)])])],1);};var collapse_itemvue_type_template_id_2d05faac_staticRenderFns=[];collapse_itemvue_type_template_id_2d05faac_render._withStripped=true;// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=template&id=2d05faac&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var collapse_itemvue_type_script_lang_js_={name:'ElCollapseItem',componentName:'ElCollapseItem',mixins:[emitter_default.a],components:{ElCollapseTransition:collapse_transition_default.a},data:function data(){return{contentWrapStyle:{height:'auto',display:'block'},contentHeight:0,focusing:false,isClick:false,id:Object(util_["generateId"])()};},inject:['collapse'],props:{title:String,name:{type:[String,Number],default:function _default(){return this._uid;}},disabled:Boolean},computed:{isActive:function isActive(){return this.collapse.activeNames.indexOf(this.name)>-1;}},methods:{handleFocus:function handleFocus(){var _this=this;setTimeout(function(){if(!_this.isClick){_this.focusing=true;}else{_this.isClick=false;}},50);},handleHeaderClick:function handleHeaderClick(){if(this.disabled)return;this.dispatch('ElCollapse','item-click',this);this.focusing=false;this.isClick=true;},handleEnterClick:function handleEnterClick(){this.dispatch('ElCollapse','item-click',this);}}};// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue?vue&type=script&lang=js&
/* harmony default export */var src_collapse_itemvue_type_script_lang_js_=collapse_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/collapse/src/collapse-item.vue
/* normalize component */var collapse_item_component=normalizeComponent(src_collapse_itemvue_type_script_lang_js_,collapse_itemvue_type_template_id_2d05faac_render,collapse_itemvue_type_template_id_2d05faac_staticRenderFns,false,null,null,null);/* hot reload */if(false){var collapse_item_api;}collapse_item_component.options.__file="packages/collapse/src/collapse-item.vue";/* harmony default export */var collapse_item=collapse_item_component.exports;// CONCATENATED MODULE: ./packages/collapse-item/index.js
/* istanbul ignore next */collapse_item.install=function(Vue){Vue.component(collapse_item.name,collapse_item);};/* harmony default export */var packages_collapse_item=collapse_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
var cascadervue_type_template_id_032537a6_render=function cascadervue_type_template_id_032537a6_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:function value(){return _vm.toggleDropDownVisible(false);},expression:"() => toggleDropDownVisible(false)"}],ref:"reference",class:["el-cascader",_vm.realSize&&"el-cascader--"+_vm.realSize,{"is-disabled":_vm.isDisabled}],on:{mouseenter:function mouseenter($event){_vm.inputHover=true;},mouseleave:function mouseleave($event){_vm.inputHover=false;},click:function click(){return _vm.toggleDropDownVisible(_vm.readonly?undefined:true);},keydown:_vm.handleKeyDown}},[_c("el-input",{ref:"input",class:{"is-focus":_vm.dropDownVisible},attrs:{size:_vm.realSize,placeholder:_vm.placeholder,readonly:_vm.readonly,disabled:_vm.isDisabled,"validate-event":false},on:{focus:_vm.handleFocus,blur:_vm.handleBlur,input:_vm.handleInput},model:{value:_vm.multiple?_vm.presentText:_vm.inputValue,callback:function callback($$v){_vm.multiple?_vm.presentText:_vm.inputValue=$$v;},expression:"multiple ? presentText : inputValue"}},[_c("template",{slot:"suffix"},[_vm.clearBtnVisible?_c("i",{key:"clear",staticClass:"el-input__icon el-icon-circle-close",on:{click:function click($event){$event.stopPropagation();return _vm.handleClear($event);}}}):_c("i",{key:"arrow-down",class:["el-input__icon","el-icon-arrow-down",_vm.dropDownVisible&&"is-reverse"],on:{click:function click($event){$event.stopPropagation();_vm.toggleDropDownVisible();}}})])],2),_vm.multiple?_c("div",{staticClass:"el-cascader__tags"},[_vm._l(_vm.presentTags,function(tag){return _c("el-tag",{key:tag.key,attrs:{type:"info",size:_vm.tagSize,hit:tag.hitState,closable:tag.closable,"disable-transitions":""},on:{close:function close($event){_vm.deleteTag(tag);}}},[_c("span",[_vm._v(_vm._s(tag.text))])]);}),_vm.filterable&&!_vm.isDisabled?_c("input",{directives:[{name:"model",rawName:"v-model.trim",value:_vm.inputValue,expression:"inputValue",modifiers:{trim:true}}],staticClass:"el-cascader__search-input",attrs:{type:"text",placeholder:_vm.presentTags.length?"":_vm.placeholder},domProps:{value:_vm.inputValue},on:{input:[function($event){if($event.target.composing){return;}_vm.inputValue=$event.target.value.trim();},function(e){return _vm.handleInput(_vm.inputValue,e);}],click:function click($event){$event.stopPropagation();_vm.toggleDropDownVisible(true);},keydown:function keydown($event){if(!("button"in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key,["Backspace","Delete","Del"])){return null;}return _vm.handleDelete($event);},blur:function blur($event){_vm.$forceUpdate();}}}):_vm._e()],2):_vm._e(),_c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.handleDropdownLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.dropDownVisible,expression:"dropDownVisible"}],ref:"popper",class:["el-popper","el-cascader__dropdown",_vm.popperClass]},[_c("el-cascader-panel",{directives:[{name:"show",rawName:"v-show",value:!_vm.filtering,expression:"!filtering"}],ref:"panel",attrs:{options:_vm.options,props:_vm.config,border:false,"render-label":_vm.$scopedSlots.default},on:{"expand-change":_vm.handleExpandChange,close:function close($event){_vm.toggleDropDownVisible(false);}},model:{value:_vm.checkedValue,callback:function callback($$v){_vm.checkedValue=$$v;},expression:"checkedValue"}}),_vm.filterable?_c("el-scrollbar",{directives:[{name:"show",rawName:"v-show",value:_vm.filtering,expression:"filtering"}],ref:"suggestionPanel",staticClass:"el-cascader__suggestion-panel",attrs:{tag:"ul","view-class":"el-cascader__suggestion-list"},nativeOn:{keydown:function keydown($event){return _vm.handleSuggestionKeyDown($event);}}},[_vm.suggestions.length?_vm._l(_vm.suggestions,function(item,index){return _c("li",{key:item.uid,class:["el-cascader__suggestion-item",item.checked&&"is-checked"],attrs:{tabindex:-1},on:{click:function click($event){_vm.handleSuggestionClick(index);}}},[_c("span",[_vm._v(_vm._s(item.text))]),item.checked?_c("i",{staticClass:"el-icon-check"}):_vm._e()]);}):_vm._t("empty",[_c("li",{staticClass:"el-cascader__empty-text"},[_vm._v(_vm._s(_vm.t("el.cascader.noMatch")))])])],2):_vm._e()],1)])],1);};var cascadervue_type_template_id_032537a6_staticRenderFns=[];cascadervue_type_template_id_032537a6_render._withStripped=true;// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=template&id=032537a6&
// EXTERNAL MODULE: external "element-ui/lib/cascader-panel"
var cascader_panel_=__webpack_require__(42);var cascader_panel_default=/*#__PURE__*/__webpack_require__.n(cascader_panel_);// EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
var aria_utils_=__webpack_require__(34);var aria_utils_default=/*#__PURE__*/__webpack_require__.n(aria_utils_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var KeyCode=aria_utils_default.a.keys;var MigratingProps={expandTrigger:{newProp:'expandTrigger',type:String},changeOnSelect:{newProp:'checkStrictly',type:Boolean},hoverThreshold:{newProp:'hoverThreshold',type:Number}};var PopperMixin={props:{placement:{type:String,default:'bottom-start'},appendToBody:vue_popper_default.a.props.appendToBody,visibleArrow:{type:Boolean,default:true},arrowOffset:vue_popper_default.a.props.arrowOffset,offset:vue_popper_default.a.props.offset,boundariesPadding:vue_popper_default.a.props.boundariesPadding,popperOptions:vue_popper_default.a.props.popperOptions,transformOrigin:vue_popper_default.a.props.transformOrigin},methods:vue_popper_default.a.methods,data:vue_popper_default.a.data,beforeDestroy:vue_popper_default.a.beforeDestroy};var InputSizeMap={medium:36,small:32,mini:28};/* harmony default export */var cascadervue_type_script_lang_js_={name:'ElCascader',directives:{Clickoutside:clickoutside_default.a},mixins:[PopperMixin,emitter_default.a,locale_default.a,migrating_default.a],inject:{elForm:{default:''},elFormItem:{default:''}},components:{ElInput:input_default.a,ElTag:tag_default.a,ElScrollbar:scrollbar_default.a,ElCascaderPanel:cascader_panel_default.a},props:{value:{},options:Array,props:Object,size:String,placeholder:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.cascader.placeholder');}},disabled:Boolean,clearable:Boolean,filterable:Boolean,filterMethod:Function,separator:{type:String,default:' / '},showAllLevels:{type:Boolean,default:true},collapseTags:Boolean,debounce:{type:Number,default:300},beforeFilter:{type:Function,default:function _default(){return function(){};}},popperClass:String},data:function data(){return{dropDownVisible:false,checkedValue:this.value,inputHover:false,inputValue:null,presentText:null,presentTags:[],checkedNodes:[],filtering:false,suggestions:[],inputInitialHeight:0,pressDeleteCount:0};},computed:{realSize:function realSize(){var _elFormItemSize=(this.elFormItem||{}).elFormItemSize;return this.size||_elFormItemSize||(this.$ELEMENT||{}).size;},tagSize:function tagSize(){return['small','mini'].indexOf(this.realSize)>-1?'mini':'small';},isDisabled:function isDisabled(){return this.disabled||(this.elForm||{}).disabled;},config:function config(){var config=this.props||{};var $attrs=this.$attrs;Object.keys(MigratingProps).forEach(function(oldProp){var _MigratingProps$oldPr=MigratingProps[oldProp],newProp=_MigratingProps$oldPr.newProp,type=_MigratingProps$oldPr.type;var oldValue=$attrs[oldProp]||$attrs[Object(util_["kebabCase"])(oldProp)];if(Object(shared_["isDef"])(oldProp)&&!Object(shared_["isDef"])(config[newProp])){if(type===Boolean&&oldValue===''){oldValue=true;}config[newProp]=oldValue;}});return config;},multiple:function multiple(){return this.config.multiple;},leafOnly:function leafOnly(){return!this.config.checkStrictly;},readonly:function readonly(){return!this.filterable||this.multiple;},clearBtnVisible:function clearBtnVisible(){if(!this.clearable||this.isDisabled||this.filtering||!this.inputHover){return false;}return this.multiple?!!this.checkedNodes.filter(function(node){return!node.isDisabled;}).length:!!this.presentText;},panel:function panel(){return this.$refs.panel;}},watch:{disabled:function disabled(){this.computePresentContent();},value:function value(val){if(!Object(util_["isEqual"])(val,this.checkedValue)){this.checkedValue=val;this.computePresentContent();}},checkedValue:function checkedValue(val){var value=this.value,dropDownVisible=this.dropDownVisible;var _config=this.config,checkStrictly=_config.checkStrictly,multiple=_config.multiple;if(!Object(util_["isEqual"])(val,value)||Object(types_["isUndefined"])(value)){this.computePresentContent();// hide dropdown when single mode
if(!multiple&&!checkStrictly&&dropDownVisible){this.toggleDropDownVisible(false);}this.$emit('input',val);this.$emit('change',val);this.dispatch('ElFormItem','el.form.change',[val]);}},options:{handler:function handler(){this.$nextTick(this.computePresentContent);},deep:true},presentText:function presentText(val){this.inputValue=val;},presentTags:function presentTags(val,oldVal){if(this.multiple&&(val.length||oldVal.length)){this.$nextTick(this.updateStyle);}},filtering:function filtering(val){this.$nextTick(this.updatePopper);}},mounted:function mounted(){var _this=this;var input=this.$refs.input;if(input&&input.$el){this.inputInitialHeight=input.$el.offsetHeight||InputSizeMap[this.realSize]||40;}if(!this.isEmptyValue(this.value)){this.computePresentContent();}this.filterHandler=debounce_default()(this.debounce,function(){var inputValue=_this.inputValue;if(!inputValue){_this.filtering=false;return;}var before=_this.beforeFilter(inputValue);if(before&&before.then){before.then(_this.getSuggestions);}else if(before!==false){_this.getSuggestions();}else{_this.filtering=false;}});Object(resize_event_["addResizeListener"])(this.$el,this.updateStyle);},beforeDestroy:function beforeDestroy(){Object(resize_event_["removeResizeListener"])(this.$el,this.updateStyle);},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'expand-trigger':'expand-trigger is removed, use `props.expandTrigger` instead.','change-on-select':'change-on-select is removed, use `props.checkStrictly` instead.','hover-threshold':'hover-threshold is removed, use `props.hoverThreshold` instead'},events:{'active-item-change':'active-item-change is renamed to expand-change'}};},toggleDropDownVisible:function toggleDropDownVisible(visible){var _this2=this;if(this.isDisabled)return;var dropDownVisible=this.dropDownVisible;var input=this.$refs.input;visible=Object(shared_["isDef"])(visible)?visible:!dropDownVisible;if(visible!==dropDownVisible){this.dropDownVisible=visible;if(visible){this.$nextTick(function(){_this2.updatePopper();_this2.panel.scrollIntoView();});}input.$refs.input.setAttribute('aria-expanded',visible);this.$emit('visible-change',visible);}},handleDropdownLeave:function handleDropdownLeave(){this.filtering=false;this.inputValue=this.presentText;this.doDestroy();},handleKeyDown:function handleKeyDown(event){switch(event.keyCode){case KeyCode.enter:this.toggleDropDownVisible();break;case KeyCode.down:this.toggleDropDownVisible(true);this.focusFirstNode();event.preventDefault();break;case KeyCode.esc:case KeyCode.tab:this.toggleDropDownVisible(false);break;}},handleFocus:function handleFocus(e){this.$emit('focus',e);},handleBlur:function handleBlur(e){this.$emit('blur',e);},handleInput:function handleInput(val,event){!this.dropDownVisible&&this.toggleDropDownVisible(true);if(event&&event.isComposing)return;if(val){this.filterHandler();}else{this.filtering=false;}},handleClear:function handleClear(){this.presentText='';this.panel.clearCheckedNodes();},handleExpandChange:function handleExpandChange(value){this.$nextTick(this.updatePopper.bind(this));this.$emit('expand-change',value);this.$emit('active-item-change',value);// Deprecated
},focusFirstNode:function focusFirstNode(){var _this3=this;this.$nextTick(function(){var filtering=_this3.filtering;var _$refs=_this3.$refs,popper=_$refs.popper,suggestionPanel=_$refs.suggestionPanel;var firstNode=null;if(filtering&&suggestionPanel){firstNode=suggestionPanel.$el.querySelector('.el-cascader__suggestion-item');}else{var firstMenu=popper.querySelector('.el-cascader-menu');firstNode=firstMenu.querySelector('.el-cascader-node[tabindex="-1"]');}if(firstNode){firstNode.focus();!filtering&&firstNode.click();}});},computePresentContent:function computePresentContent(){var _this4=this;// nextTick is required, because checked nodes may not change right now
this.$nextTick(function(){if(_this4.config.multiple){_this4.computePresentTags();_this4.presentText=_this4.presentTags.length?' ':null;}else{_this4.computePresentText();}});},isEmptyValue:function isEmptyValue(val){var multiple=this.multiple;var emitPath=this.panel.config.emitPath;if(multiple||emitPath){return Object(util_["isEmpty"])(val);}return false;},computePresentText:function computePresentText(){var checkedValue=this.checkedValue,config=this.config;if(!this.isEmptyValue(checkedValue)){var node=this.panel.getNodeByValue(checkedValue);if(node&&(config.checkStrictly||node.isLeaf)){this.presentText=node.getText(this.showAllLevels,this.separator);return;}}this.presentText=null;},computePresentTags:function computePresentTags(){var isDisabled=this.isDisabled,leafOnly=this.leafOnly,showAllLevels=this.showAllLevels,separator=this.separator,collapseTags=this.collapseTags;var checkedNodes=this.getCheckedNodes(leafOnly);var tags=[];var genTag=function genTag(node){return{node:node,key:node.uid,text:node.getText(showAllLevels,separator),hitState:false,closable:!isDisabled&&!node.isDisabled};};if(checkedNodes.length){var first=checkedNodes[0],rest=checkedNodes.slice(1);var restCount=rest.length;tags.push(genTag(first));if(restCount){if(collapseTags){tags.push({key:-1,text:'+ '+restCount,closable:false});}else{rest.forEach(function(node){return tags.push(genTag(node));});}}}this.checkedNodes=checkedNodes;this.presentTags=tags;},getSuggestions:function getSuggestions(){var _this5=this;var filterMethod=this.filterMethod;if(!Object(types_["isFunction"])(filterMethod)){filterMethod=function filterMethod(node,keyword){return node.text.includes(keyword);};}var suggestions=this.panel.getFlattedNodes(this.leafOnly).filter(function(node){if(node.isDisabled)return false;node.text=node.getText(_this5.showAllLevels,_this5.separator)||'';return filterMethod(node,_this5.inputValue);});if(this.multiple){this.presentTags.forEach(function(tag){tag.hitState=false;});}else{suggestions.forEach(function(node){node.checked=Object(util_["isEqual"])(_this5.checkedValue,node.getValueByOption());});}this.filtering=true;this.suggestions=suggestions;this.$nextTick(this.updatePopper);},handleSuggestionKeyDown:function handleSuggestionKeyDown(event){var keyCode=event.keyCode,target=event.target;switch(keyCode){case KeyCode.enter:target.click();break;case KeyCode.up:var prev=target.previousElementSibling;prev&&prev.focus();break;case KeyCode.down:var next=target.nextElementSibling;next&&next.focus();break;case KeyCode.esc:case KeyCode.tab:this.toggleDropDownVisible(false);break;}},handleDelete:function handleDelete(){var inputValue=this.inputValue,pressDeleteCount=this.pressDeleteCount,presentTags=this.presentTags;var lastIndex=presentTags.length-1;var lastTag=presentTags[lastIndex];this.pressDeleteCount=inputValue?0:pressDeleteCount+1;if(!lastTag)return;if(this.pressDeleteCount){if(lastTag.hitState){this.deleteTag(lastTag);}else{lastTag.hitState=true;}}},handleSuggestionClick:function handleSuggestionClick(index){var multiple=this.multiple;var targetNode=this.suggestions[index];if(multiple){var checked=targetNode.checked;targetNode.doCheck(!checked);this.panel.calculateMultiCheckedValue();}else{this.checkedValue=targetNode.getValueByOption();this.toggleDropDownVisible(false);}},deleteTag:function deleteTag(tag){var checkedValue=this.checkedValue;var current=tag.node.getValueByOption();var val=checkedValue.find(function(n){return Object(util_["isEqual"])(n,current);});this.checkedValue=checkedValue.filter(function(n){return!Object(util_["isEqual"])(n,current);});this.$emit('remove-tag',val);},updateStyle:function updateStyle(){var $el=this.$el,inputInitialHeight=this.inputInitialHeight;if(this.$isServer||!$el)return;var suggestionPanel=this.$refs.suggestionPanel;var inputInner=$el.querySelector('.el-input__inner');if(!inputInner)return;var tags=$el.querySelector('.el-cascader__tags');var suggestionPanelEl=null;if(suggestionPanel&&(suggestionPanelEl=suggestionPanel.$el)){var suggestionList=suggestionPanelEl.querySelector('.el-cascader__suggestion-list');suggestionList.style.minWidth=inputInner.offsetWidth+'px';}if(tags){var offsetHeight=Math.round(tags.getBoundingClientRect().height);var height=Math.max(offsetHeight+6,inputInitialHeight)+'px';inputInner.style.height=height;if(this.dropDownVisible){this.updatePopper();}}},/**
     * public methods
    */getCheckedNodes:function getCheckedNodes(leafOnly){return this.panel.getCheckedNodes(leafOnly);}}};// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascadervue_type_script_lang_js_=cascadervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader/src/cascader.vue
/* normalize component */var cascader_component=normalizeComponent(src_cascadervue_type_script_lang_js_,cascadervue_type_template_id_032537a6_render,cascadervue_type_template_id_032537a6_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_api;}cascader_component.options.__file="packages/cascader/src/cascader.vue";/* harmony default export */var cascader=cascader_component.exports;// CONCATENATED MODULE: ./packages/cascader/index.js
/* istanbul ignore next */cascader.install=function(Vue){Vue.component(cascader.name,cascader);};/* harmony default export */var packages_cascader=cascader;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
var mainvue_type_template_id_55c8ade7_render=function mainvue_type_template_id_55c8ade7_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:_vm.hide,expression:"hide"}],class:["el-color-picker",_vm.colorDisabled?"is-disabled":"",_vm.colorSize?"el-color-picker--"+_vm.colorSize:""]},[_vm.colorDisabled?_c("div",{staticClass:"el-color-picker__mask"}):_vm._e(),_c("div",{staticClass:"el-color-picker__trigger",on:{click:_vm.handleTrigger}},[_c("span",{staticClass:"el-color-picker__color",class:{"is-alpha":_vm.showAlpha}},[_c("span",{staticClass:"el-color-picker__color-inner",style:{backgroundColor:_vm.displayedColor}}),!_vm.value&&!_vm.showPanelColor?_c("span",{staticClass:"el-color-picker__empty el-icon-close"}):_vm._e()]),_c("span",{directives:[{name:"show",rawName:"v-show",value:_vm.value||_vm.showPanelColor,expression:"value || showPanelColor"}],staticClass:"el-color-picker__icon el-icon-arrow-down"})]),_c("picker-dropdown",{ref:"dropdown",class:["el-color-picker__panel",_vm.popperClass||""],attrs:{color:_vm.color,"show-alpha":_vm.showAlpha,predefine:_vm.predefine},on:{pick:_vm.confirmValue,clear:_vm.clearValue},model:{value:_vm.showPicker,callback:function callback($$v){_vm.showPicker=$$v;},expression:"showPicker"}})],1);};var mainvue_type_template_id_55c8ade7_staticRenderFns=[];mainvue_type_template_id_55c8ade7_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=template&id=55c8ade7&
// CONCATENATED MODULE: ./packages/color-picker/src/color.js
var color_typeof=typeof Symbol==="function"&&_typeof2(Symbol.iterator)==="symbol"?function(obj){return typeof obj==='undefined'?'undefined':_typeof2(obj);}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj==='undefined'?'undefined':_typeof2(obj);};function color_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var hsv2hsl=function hsv2hsl(hue,sat,val){return[hue,sat*val/((hue=(2-sat)*val)<1?hue:2-hue)||0,hue/2];};// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
var isOnePointZero=function isOnePointZero(n){return typeof n==='string'&&n.indexOf('.')!==-1&&parseFloat(n)===1;};var isPercentage=function isPercentage(n){return typeof n==='string'&&n.indexOf('%')!==-1;};// Take input from [0, n] and return it as [0, 1]
var bound01=function bound01(value,max){if(isOnePointZero(value))value='100%';var processPercent=isPercentage(value);value=Math.min(max,Math.max(0,parseFloat(value)));// Automatically convert percentage into number
if(processPercent){value=parseInt(value*max,10)/100;}// Handle floating point rounding errors
if(Math.abs(value-max)<0.000001){return 1;}// Convert into [0, 1] range if it isn't already
return value%max/parseFloat(max);};var INT_HEX_MAP={10:'A',11:'B',12:'C',13:'D',14:'E',15:'F'};var toHex=function toHex(_ref){var r=_ref.r,g=_ref.g,b=_ref.b;var hexOne=function hexOne(value){value=Math.min(Math.round(value),255);var high=Math.floor(value/16);var low=value%16;return''+(INT_HEX_MAP[high]||high)+(INT_HEX_MAP[low]||low);};if(isNaN(r)||isNaN(g)||isNaN(b))return'';return'#'+hexOne(r)+hexOne(g)+hexOne(b);};var HEX_INT_MAP={A:10,B:11,C:12,D:13,E:14,F:15};var parseHexChannel=function parseHexChannel(hex){if(hex.length===2){return(HEX_INT_MAP[hex[0].toUpperCase()]||+hex[0])*16+(HEX_INT_MAP[hex[1].toUpperCase()]||+hex[1]);}return HEX_INT_MAP[hex[1].toUpperCase()]||+hex[1];};var hsl2hsv=function hsl2hsv(hue,sat,light){sat=sat/100;light=light/100;var smin=sat;var lmin=Math.max(light,0.01);var sv=void 0;var v=void 0;light*=2;sat*=light<=1?light:2-light;smin*=lmin<=1?lmin:2-lmin;v=(light+sat)/2;sv=light===0?2*smin/(lmin+smin):2*sat/(light+sat);return{h:hue,s:sv*100,v:v*100};};// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
var rgb2hsv=function rgb2hsv(r,g,b){r=bound01(r,255);g=bound01(g,255);b=bound01(b,255);var max=Math.max(r,g,b);var min=Math.min(r,g,b);var h=void 0,s=void 0;var v=max;var d=max-min;s=max===0?0:d/max;if(max===min){h=0;// achromatic
}else{switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;}h/=6;}return{h:h*360,s:s*100,v:v*100};};// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
var hsv2rgb=function hsv2rgb(h,s,v){h=bound01(h,360)*6;s=bound01(s,100);v=bound01(v,100);var i=Math.floor(h);var f=h-i;var p=v*(1-s);var q=v*(1-f*s);var t=v*(1-(1-f)*s);var mod=i%6;var r=[v,q,p,p,t,v][mod];var g=[t,v,v,q,p,p][mod];var b=[p,p,t,v,v,q][mod];return{r:Math.round(r*255),g:Math.round(g*255),b:Math.round(b*255)};};var Color=function(){function Color(options){color_classCallCheck(this,Color);this._hue=0;this._saturation=100;this._value=100;this._alpha=100;this.enableAlpha=false;this.format='hex';this.value='';options=options||{};for(var option in options){if(options.hasOwnProperty(option)){this[option]=options[option];}}this.doOnChange();}Color.prototype.set=function set(prop,value){if(arguments.length===1&&(typeof prop==='undefined'?'undefined':color_typeof(prop))==='object'){for(var p in prop){if(prop.hasOwnProperty(p)){this.set(p,prop[p]);}}return;}this['_'+prop]=value;this.doOnChange();};Color.prototype.get=function get(prop){return this['_'+prop];};Color.prototype.toRgb=function toRgb(){return hsv2rgb(this._hue,this._saturation,this._value);};Color.prototype.fromString=function fromString(value){var _this=this;if(!value){this._hue=0;this._saturation=100;this._value=100;this.doOnChange();return;}var fromHSV=function fromHSV(h,s,v){_this._hue=Math.max(0,Math.min(360,h));_this._saturation=Math.max(0,Math.min(100,s));_this._value=Math.max(0,Math.min(100,v));_this.doOnChange();};if(value.indexOf('hsl')!==-1){var parts=value.replace(/hsla|hsl|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(parts.length===4){this._alpha=Math.floor(parseFloat(parts[3])*100);}else if(parts.length===3){this._alpha=100;}if(parts.length>=3){var _hsl2hsv=hsl2hsv(parts[0],parts[1],parts[2]),h=_hsl2hsv.h,s=_hsl2hsv.s,v=_hsl2hsv.v;fromHSV(h,s,v);}}else if(value.indexOf('hsv')!==-1){var _parts=value.replace(/hsva|hsv|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(_parts.length===4){this._alpha=Math.floor(parseFloat(_parts[3])*100);}else if(_parts.length===3){this._alpha=100;}if(_parts.length>=3){fromHSV(_parts[0],_parts[1],_parts[2]);}}else if(value.indexOf('rgb')!==-1){var _parts2=value.replace(/rgba|rgb|\(|\)/gm,'').split(/\s|,/g).filter(function(val){return val!=='';}).map(function(val,index){return index>2?parseFloat(val):parseInt(val,10);});if(_parts2.length===4){this._alpha=Math.floor(parseFloat(_parts2[3])*100);}else if(_parts2.length===3){this._alpha=100;}if(_parts2.length>=3){var _rgb2hsv=rgb2hsv(_parts2[0],_parts2[1],_parts2[2]),_h=_rgb2hsv.h,_s=_rgb2hsv.s,_v=_rgb2hsv.v;fromHSV(_h,_s,_v);}}else if(value.indexOf('#')!==-1){var hex=value.replace('#','').trim();if(!/^(?:[0-9a-fA-F]{3}){1,2}|[0-9a-fA-F]{8}$/.test(hex))return;var r=void 0,g=void 0,b=void 0;if(hex.length===3){r=parseHexChannel(hex[0]+hex[0]);g=parseHexChannel(hex[1]+hex[1]);b=parseHexChannel(hex[2]+hex[2]);}else if(hex.length===6||hex.length===8){r=parseHexChannel(hex.substring(0,2));g=parseHexChannel(hex.substring(2,4));b=parseHexChannel(hex.substring(4,6));}if(hex.length===8){this._alpha=Math.floor(parseHexChannel(hex.substring(6))/255*100);}else if(hex.length===3||hex.length===6){this._alpha=100;}var _rgb2hsv2=rgb2hsv(r,g,b),_h2=_rgb2hsv2.h,_s2=_rgb2hsv2.s,_v2=_rgb2hsv2.v;fromHSV(_h2,_s2,_v2);}};Color.prototype.compare=function compare(color){return Math.abs(color._hue-this._hue)<2&&Math.abs(color._saturation-this._saturation)<1&&Math.abs(color._value-this._value)<1&&Math.abs(color._alpha-this._alpha)<1;};Color.prototype.doOnChange=function doOnChange(){var _hue=this._hue,_saturation=this._saturation,_value=this._value,_alpha=this._alpha,format=this.format;if(this.enableAlpha){switch(format){case'hsl':var hsl=hsv2hsl(_hue,_saturation/100,_value/100);this.value='hsla('+_hue+', '+Math.round(hsl[1]*100)+'%, '+Math.round(hsl[2]*100)+'%, '+_alpha/100+')';break;case'hsv':this.value='hsva('+_hue+', '+Math.round(_saturation)+'%, '+Math.round(_value)+'%, '+_alpha/100+')';break;default:var _hsv2rgb=hsv2rgb(_hue,_saturation,_value),r=_hsv2rgb.r,g=_hsv2rgb.g,b=_hsv2rgb.b;this.value='rgba('+r+', '+g+', '+b+', '+_alpha/100+')';}}else{switch(format){case'hsl':var _hsl=hsv2hsl(_hue,_saturation/100,_value/100);this.value='hsl('+_hue+', '+Math.round(_hsl[1]*100)+'%, '+Math.round(_hsl[2]*100)+'%)';break;case'hsv':this.value='hsv('+_hue+', '+Math.round(_saturation)+'%, '+Math.round(_value)+'%)';break;case'rgb':var _hsv2rgb2=hsv2rgb(_hue,_saturation,_value),_r=_hsv2rgb2.r,_g=_hsv2rgb2.g,_b=_hsv2rgb2.b;this.value='rgb('+_r+', '+_g+', '+_b+')';break;default:this.value=toHex(hsv2rgb(_hue,_saturation,_value));}}};return Color;}();/* harmony default export */var src_color=Color;;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
var picker_dropdownvue_type_template_id_06601625_render=function picker_dropdownvue_type_template_id_06601625_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-zoom-in-top"},on:{"after-leave":_vm.doDestroy}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.showPopper,expression:"showPopper"}],staticClass:"el-color-dropdown"},[_c("div",{staticClass:"el-color-dropdown__main-wrapper"},[_c("hue-slider",{ref:"hue",staticStyle:{float:"right"},attrs:{color:_vm.color,vertical:""}}),_c("sv-panel",{ref:"sl",attrs:{color:_vm.color}})],1),_vm.showAlpha?_c("alpha-slider",{ref:"alpha",attrs:{color:_vm.color}}):_vm._e(),_vm.predefine?_c("predefine",{attrs:{color:_vm.color,colors:_vm.predefine}}):_vm._e(),_c("div",{staticClass:"el-color-dropdown__btns"},[_c("span",{staticClass:"el-color-dropdown__value"},[_c("el-input",{attrs:{"validate-event":false,size:"mini"},on:{blur:_vm.handleConfirm},nativeOn:{keyup:function keyup($event){if(!("button"in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){return null;}return _vm.handleConfirm($event);}},model:{value:_vm.customInput,callback:function callback($$v){_vm.customInput=$$v;},expression:"customInput"}})],1),_c("el-button",{staticClass:"el-color-dropdown__link-btn",attrs:{size:"mini",type:"text"},on:{click:function click($event){_vm.$emit("clear");}}},[_vm._v("\n        "+_vm._s(_vm.t("el.colorpicker.clear"))+"\n      ")]),_c("el-button",{staticClass:"el-color-dropdown__btn",attrs:{plain:"",size:"mini"},on:{click:_vm.confirmValue}},[_vm._v("\n        "+_vm._s(_vm.t("el.colorpicker.confirm"))+"\n      ")])],1)],1)]);};var picker_dropdownvue_type_template_id_06601625_staticRenderFns=[];picker_dropdownvue_type_template_id_06601625_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=template&id=06601625&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
var sv_panelvue_type_template_id_d8583596_render=function sv_panelvue_type_template_id_d8583596_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-svpanel",style:{backgroundColor:_vm.background}},[_c("div",{staticClass:"el-color-svpanel__white"}),_c("div",{staticClass:"el-color-svpanel__black"}),_c("div",{staticClass:"el-color-svpanel__cursor",style:{top:_vm.cursorTop+"px",left:_vm.cursorLeft+"px"}},[_c("div")])]);};var sv_panelvue_type_template_id_d8583596_staticRenderFns=[];sv_panelvue_type_template_id_d8583596_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=template&id=d8583596&
// CONCATENATED MODULE: ./packages/color-picker/src/draggable.js
var isDragging=false;/* harmony default export */var draggable=function draggable(element,options){if(external_vue_default.a.prototype.$isServer)return;var moveFn=function moveFn(event){if(options.drag){options.drag(event);}};var upFn=function upFn(event){document.removeEventListener('mousemove',moveFn);document.removeEventListener('mouseup',upFn);document.onselectstart=null;document.ondragstart=null;isDragging=false;if(options.end){options.end(event);}};element.addEventListener('mousedown',function(event){if(isDragging)return;document.onselectstart=function(){return false;};document.ondragstart=function(){return false;};document.addEventListener('mousemove',moveFn);document.addEventListener('mouseup',upFn);isDragging=true;if(options.start){options.start(event);}});};// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var sv_panelvue_type_script_lang_js_={name:'el-sl-panel',props:{color:{required:true}},computed:{colorValue:function colorValue(){var hue=this.color.get('hue');var value=this.color.get('value');return{hue:hue,value:value};}},watch:{colorValue:function colorValue(){this.update();}},methods:{update:function update(){var saturation=this.color.get('saturation');var value=this.color.get('value');var el=this.$el;var width=el.clientWidth,height=el.clientHeight;this.cursorLeft=saturation*width/100;this.cursorTop=(100-value)*height/100;this.background='hsl('+this.color.get('hue')+', 100%, 50%)';},handleDrag:function handleDrag(event){var el=this.$el;var rect=el.getBoundingClientRect();var left=event.clientX-rect.left;var top=event.clientY-rect.top;left=Math.max(0,left);left=Math.min(left,rect.width);top=Math.max(0,top);top=Math.min(top,rect.height);this.cursorLeft=left;this.cursorTop=top;this.color.set({saturation:left/rect.width*100,value:100-top/rect.height*100});}},mounted:function mounted(){var _this=this;draggable(this.$el,{drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}});this.update();},data:function data(){return{cursorTop:0,cursorLeft:0,background:'hsl(0, 100%, 50%)'};}};// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue?vue&type=script&lang=js&
/* harmony default export */var components_sv_panelvue_type_script_lang_js_=sv_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/sv-panel.vue
/* normalize component */var sv_panel_component=normalizeComponent(components_sv_panelvue_type_script_lang_js_,sv_panelvue_type_template_id_d8583596_render,sv_panelvue_type_template_id_d8583596_staticRenderFns,false,null,null,null);/* hot reload */if(false){var sv_panel_api;}sv_panel_component.options.__file="packages/color-picker/src/components/sv-panel.vue";/* harmony default export */var sv_panel=sv_panel_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
var hue_slidervue_type_template_id_5cdc43b1_render=function hue_slidervue_type_template_id_5cdc43b1_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-hue-slider",class:{"is-vertical":_vm.vertical}},[_c("div",{ref:"bar",staticClass:"el-color-hue-slider__bar",on:{click:_vm.handleClick}}),_c("div",{ref:"thumb",staticClass:"el-color-hue-slider__thumb",style:{left:_vm.thumbLeft+"px",top:_vm.thumbTop+"px"}})]);};var hue_slidervue_type_template_id_5cdc43b1_staticRenderFns=[];hue_slidervue_type_template_id_5cdc43b1_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=template&id=5cdc43b1&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var hue_slidervue_type_script_lang_js_={name:'el-color-hue-slider',props:{color:{required:true},vertical:Boolean},data:function data(){return{thumbLeft:0,thumbTop:0};},computed:{hueValue:function hueValue(){var hue=this.color.get('hue');return hue;}},watch:{hueValue:function hueValue(){this.update();}},methods:{handleClick:function handleClick(event){var thumb=this.$refs.thumb;var target=event.target;if(target!==thumb){this.handleDrag(event);}},handleDrag:function handleDrag(event){var rect=this.$el.getBoundingClientRect();var thumb=this.$refs.thumb;var hue=void 0;if(!this.vertical){var left=event.clientX-rect.left;left=Math.min(left,rect.width-thumb.offsetWidth/2);left=Math.max(thumb.offsetWidth/2,left);hue=Math.round((left-thumb.offsetWidth/2)/(rect.width-thumb.offsetWidth)*360);}else{var top=event.clientY-rect.top;top=Math.min(top,rect.height-thumb.offsetHeight/2);top=Math.max(thumb.offsetHeight/2,top);hue=Math.round((top-thumb.offsetHeight/2)/(rect.height-thumb.offsetHeight)*360);}this.color.set('hue',hue);},getThumbLeft:function getThumbLeft(){if(this.vertical)return 0;var el=this.$el;var hue=this.color.get('hue');if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(hue*(el.offsetWidth-thumb.offsetWidth/2)/360);},getThumbTop:function getThumbTop(){if(!this.vertical)return 0;var el=this.$el;var hue=this.color.get('hue');if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(hue*(el.offsetHeight-thumb.offsetHeight/2)/360);},update:function update(){this.thumbLeft=this.getThumbLeft();this.thumbTop=this.getThumbTop();}},mounted:function mounted(){var _this=this;var _$refs=this.$refs,bar=_$refs.bar,thumb=_$refs.thumb;var dragConfig={drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}};draggable(bar,dragConfig);draggable(thumb,dragConfig);this.update();}};// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue?vue&type=script&lang=js&
/* harmony default export */var components_hue_slidervue_type_script_lang_js_=hue_slidervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/hue-slider.vue
/* normalize component */var hue_slider_component=normalizeComponent(components_hue_slidervue_type_script_lang_js_,hue_slidervue_type_template_id_5cdc43b1_render,hue_slidervue_type_template_id_5cdc43b1_staticRenderFns,false,null,null,null);/* hot reload */if(false){var hue_slider_api;}hue_slider_component.options.__file="packages/color-picker/src/components/hue-slider.vue";/* harmony default export */var hue_slider=hue_slider_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
var alpha_slidervue_type_template_id_068c66cb_render=function alpha_slidervue_type_template_id_068c66cb_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-alpha-slider",class:{"is-vertical":_vm.vertical}},[_c("div",{ref:"bar",staticClass:"el-color-alpha-slider__bar",style:{background:_vm.background},on:{click:_vm.handleClick}}),_c("div",{ref:"thumb",staticClass:"el-color-alpha-slider__thumb",style:{left:_vm.thumbLeft+"px",top:_vm.thumbTop+"px"}})]);};var alpha_slidervue_type_template_id_068c66cb_staticRenderFns=[];alpha_slidervue_type_template_id_068c66cb_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=template&id=068c66cb&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var alpha_slidervue_type_script_lang_js_={name:'el-color-alpha-slider',props:{color:{required:true},vertical:Boolean},watch:{'color._alpha':function color_alpha(){this.update();},'color.value':function colorValue(){this.update();}},methods:{handleClick:function handleClick(event){var thumb=this.$refs.thumb;var target=event.target;if(target!==thumb){this.handleDrag(event);}},handleDrag:function handleDrag(event){var rect=this.$el.getBoundingClientRect();var thumb=this.$refs.thumb;if(!this.vertical){var left=event.clientX-rect.left;left=Math.max(thumb.offsetWidth/2,left);left=Math.min(left,rect.width-thumb.offsetWidth/2);this.color.set('alpha',Math.round((left-thumb.offsetWidth/2)/(rect.width-thumb.offsetWidth)*100));}else{var top=event.clientY-rect.top;top=Math.max(thumb.offsetHeight/2,top);top=Math.min(top,rect.height-thumb.offsetHeight/2);this.color.set('alpha',Math.round((top-thumb.offsetHeight/2)/(rect.height-thumb.offsetHeight)*100));}},getThumbLeft:function getThumbLeft(){if(this.vertical)return 0;var el=this.$el;var alpha=this.color._alpha;if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(alpha*(el.offsetWidth-thumb.offsetWidth/2)/100);},getThumbTop:function getThumbTop(){if(!this.vertical)return 0;var el=this.$el;var alpha=this.color._alpha;if(!el)return 0;var thumb=this.$refs.thumb;return Math.round(alpha*(el.offsetHeight-thumb.offsetHeight/2)/100);},getBackground:function getBackground(){if(this.color&&this.color.value){var _color$toRgb=this.color.toRgb(),r=_color$toRgb.r,g=_color$toRgb.g,b=_color$toRgb.b;return'linear-gradient(to right, rgba('+r+', '+g+', '+b+', 0) 0%, rgba('+r+', '+g+', '+b+', 1) 100%)';}return null;},update:function update(){this.thumbLeft=this.getThumbLeft();this.thumbTop=this.getThumbTop();this.background=this.getBackground();}},data:function data(){return{thumbLeft:0,thumbTop:0,background:null};},mounted:function mounted(){var _this=this;var _$refs=this.$refs,bar=_$refs.bar,thumb=_$refs.thumb;var dragConfig={drag:function drag(event){_this.handleDrag(event);},end:function end(event){_this.handleDrag(event);}};draggable(bar,dragConfig);draggable(thumb,dragConfig);this.update();}};// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue?vue&type=script&lang=js&
/* harmony default export */var components_alpha_slidervue_type_script_lang_js_=alpha_slidervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/alpha-slider.vue
/* normalize component */var alpha_slider_component=normalizeComponent(components_alpha_slidervue_type_script_lang_js_,alpha_slidervue_type_template_id_068c66cb_render,alpha_slidervue_type_template_id_068c66cb_staticRenderFns,false,null,null,null);/* hot reload */if(false){var alpha_slider_api;}alpha_slider_component.options.__file="packages/color-picker/src/components/alpha-slider.vue";/* harmony default export */var alpha_slider=alpha_slider_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
var predefinevue_type_template_id_06e03093_render=function predefinevue_type_template_id_06e03093_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-color-predefine"},[_c("div",{staticClass:"el-color-predefine__colors"},_vm._l(_vm.rgbaColors,function(item,index){return _c("div",{key:_vm.colors[index],staticClass:"el-color-predefine__color-selector",class:{selected:item.selected,"is-alpha":item._alpha<100},on:{click:function click($event){_vm.handleSelect(index);}}},[_c("div",{style:{"background-color":item.value}})]);}),0)]);};var predefinevue_type_template_id_06e03093_staticRenderFns=[];predefinevue_type_template_id_06e03093_render._withStripped=true;// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=template&id=06e03093&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var predefinevue_type_script_lang_js_={props:{colors:{type:Array,required:true},color:{required:true}},data:function data(){return{rgbaColors:this.parseColors(this.colors,this.color)};},methods:{handleSelect:function handleSelect(index){this.color.fromString(this.colors[index]);},parseColors:function parseColors(colors,color){return colors.map(function(value){var c=new src_color();c.enableAlpha=true;c.format='rgba';c.fromString(value);c.selected=c.value===color.value;return c;});}},watch:{'$parent.currentColor':function $parentCurrentColor(val){var color=new src_color();color.fromString(val);this.rgbaColors.forEach(function(item){item.selected=color.compare(item);});},colors:function colors(newVal){this.rgbaColors=this.parseColors(newVal,this.color);},color:function color(newVal){this.rgbaColors=this.parseColors(this.colors,newVal);}}};// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue?vue&type=script&lang=js&
/* harmony default export */var components_predefinevue_type_script_lang_js_=predefinevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/predefine.vue
/* normalize component */var predefine_component=normalizeComponent(components_predefinevue_type_script_lang_js_,predefinevue_type_template_id_06e03093_render,predefinevue_type_template_id_06e03093_staticRenderFns,false,null,null,null);/* hot reload */if(false){var predefine_api;}predefine_component.options.__file="packages/color-picker/src/components/predefine.vue";/* harmony default export */var predefine=predefine_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var picker_dropdownvue_type_script_lang_js_={name:'el-color-picker-dropdown',mixins:[vue_popper_default.a,locale_default.a],components:{SvPanel:sv_panel,HueSlider:hue_slider,AlphaSlider:alpha_slider,ElInput:input_default.a,ElButton:button_default.a,Predefine:predefine},props:{color:{required:true},showAlpha:Boolean,predefine:Array},data:function data(){return{customInput:''};},computed:{currentColor:function currentColor(){var parent=this.$parent;return!parent.value&&!parent.showPanelColor?'':parent.color.value;}},methods:{confirmValue:function confirmValue(){this.$emit('pick');},handleConfirm:function handleConfirm(){this.color.fromString(this.customInput);}},mounted:function mounted(){this.$parent.popperElm=this.popperElm=this.$el;this.referenceElm=this.$parent.$el;},watch:{showPopper:function showPopper(val){var _this=this;if(val===true){this.$nextTick(function(){var _$refs=_this.$refs,sl=_$refs.sl,hue=_$refs.hue,alpha=_$refs.alpha;sl&&sl.update();hue&&hue.update();alpha&&alpha.update();});}},currentColor:{immediate:true,handler:function handler(val){this.customInput=val;}}}};// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue?vue&type=script&lang=js&
/* harmony default export */var components_picker_dropdownvue_type_script_lang_js_=picker_dropdownvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/components/picker-dropdown.vue
/* normalize component */var picker_dropdown_component=normalizeComponent(components_picker_dropdownvue_type_script_lang_js_,picker_dropdownvue_type_template_id_06601625_render,picker_dropdownvue_type_template_id_06601625_staticRenderFns,false,null,null,null);/* hot reload */if(false){var picker_dropdown_api;}picker_dropdown_component.options.__file="packages/color-picker/src/components/picker-dropdown.vue";/* harmony default export */var picker_dropdown=picker_dropdown_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/color-picker/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var color_picker_src_mainvue_type_script_lang_js_={name:'ElColorPicker',mixins:[emitter_default.a],props:{value:String,showAlpha:Boolean,colorFormat:String,disabled:Boolean,size:String,popperClass:String,predefine:Array},inject:{elForm:{default:''},elFormItem:{default:''}},directives:{Clickoutside:clickoutside_default.a},computed:{displayedColor:function displayedColor(){if(!this.value&&!this.showPanelColor){return'transparent';}return this.displayedRgb(this.color,this.showAlpha);},_elFormItemSize:function _elFormItemSize(){return(this.elFormItem||{}).elFormItemSize;},colorSize:function colorSize(){return this.size||this._elFormItemSize||(this.$ELEMENT||{}).size;},colorDisabled:function colorDisabled(){return this.disabled||(this.elForm||{}).disabled;}},watch:{value:function value(val){if(!val){this.showPanelColor=false;}else if(val&&val!==this.color.value){this.color.fromString(val);}},color:{deep:true,handler:function handler(){this.showPanelColor=true;}},displayedColor:function displayedColor(val){if(!this.showPicker)return;var currentValueColor=new src_color({enableAlpha:this.showAlpha,format:this.colorFormat});currentValueColor.fromString(this.value);var currentValueColorRgb=this.displayedRgb(currentValueColor,this.showAlpha);if(val!==currentValueColorRgb){this.$emit('active-change',val);}}},methods:{handleTrigger:function handleTrigger(){if(this.colorDisabled)return;this.showPicker=!this.showPicker;},confirmValue:function confirmValue(){var value=this.color.value;this.$emit('input',value);this.$emit('change',value);this.dispatch('ElFormItem','el.form.change',value);this.showPicker=false;},clearValue:function clearValue(){this.$emit('input',null);this.$emit('change',null);if(this.value!==null){this.dispatch('ElFormItem','el.form.change',null);}this.showPanelColor=false;this.showPicker=false;this.resetColor();},hide:function hide(){this.showPicker=false;this.resetColor();},resetColor:function resetColor(){var _this=this;this.$nextTick(function(_){if(_this.value){_this.color.fromString(_this.value);}else{_this.showPanelColor=false;}});},displayedRgb:function displayedRgb(color,showAlpha){if(!(color instanceof src_color)){throw Error('color should be instance of Color Class');}var _color$toRgb=color.toRgb(),r=_color$toRgb.r,g=_color$toRgb.g,b=_color$toRgb.b;return showAlpha?'rgba('+r+', '+g+', '+b+', '+color.get('alpha')/100+')':'rgb('+r+', '+g+', '+b+')';}},mounted:function mounted(){var value=this.value;if(value){this.color.fromString(value);}this.popperElm=this.$refs.dropdown.$el;},data:function data(){var color=new src_color({enableAlpha:this.showAlpha,format:this.colorFormat});return{color:color,showPicker:false,showPanelColor:false};},components:{PickerDropdown:picker_dropdown}};// CONCATENATED MODULE: ./packages/color-picker/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_color_picker_src_mainvue_type_script_lang_js_=color_picker_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/color-picker/src/main.vue
/* normalize component */var color_picker_src_main_component=normalizeComponent(packages_color_picker_src_mainvue_type_script_lang_js_,mainvue_type_template_id_55c8ade7_render,mainvue_type_template_id_55c8ade7_staticRenderFns,false,null,null,null);/* hot reload */if(false){var color_picker_src_main_api;}color_picker_src_main_component.options.__file="packages/color-picker/src/main.vue";/* harmony default export */var color_picker_src_main=color_picker_src_main_component.exports;// CONCATENATED MODULE: ./packages/color-picker/index.js
/* istanbul ignore next */color_picker_src_main.install=function(Vue){Vue.component(color_picker_src_main.name,color_picker_src_main);};/* harmony default export */var color_picker=color_picker_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
var mainvue_type_template_id_5c654dd8_render=function mainvue_type_template_id_5c654dd8_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-transfer"},[_c("transfer-panel",_vm._b({ref:"leftPanel",attrs:{data:_vm.sourceData,title:_vm.titles[0]||_vm.t("el.transfer.titles.0"),"default-checked":_vm.leftDefaultChecked,placeholder:_vm.filterPlaceholder||_vm.t("el.transfer.filterPlaceholder")},on:{"checked-change":_vm.onSourceCheckedChange}},"transfer-panel",_vm.$props,false),[_vm._t("left-footer")],2),_c("div",{staticClass:"el-transfer__buttons"},[_c("el-button",{class:["el-transfer__button",_vm.hasButtonTexts?"is-with-texts":""],attrs:{type:"primary",disabled:_vm.rightChecked.length===0},nativeOn:{click:function click($event){return _vm.addToLeft($event);}}},[_c("i",{staticClass:"el-icon-arrow-left"}),_vm.buttonTexts[0]!==undefined?_c("span",[_vm._v(_vm._s(_vm.buttonTexts[0]))]):_vm._e()]),_c("el-button",{class:["el-transfer__button",_vm.hasButtonTexts?"is-with-texts":""],attrs:{type:"primary",disabled:_vm.leftChecked.length===0},nativeOn:{click:function click($event){return _vm.addToRight($event);}}},[_vm.buttonTexts[1]!==undefined?_c("span",[_vm._v(_vm._s(_vm.buttonTexts[1]))]):_vm._e(),_c("i",{staticClass:"el-icon-arrow-right"})])],1),_c("transfer-panel",_vm._b({ref:"rightPanel",attrs:{data:_vm.targetData,title:_vm.titles[1]||_vm.t("el.transfer.titles.1"),"default-checked":_vm.rightDefaultChecked,placeholder:_vm.filterPlaceholder||_vm.t("el.transfer.filterPlaceholder")},on:{"checked-change":_vm.onTargetCheckedChange}},"transfer-panel",_vm.$props,false),[_vm._t("right-footer")],2)],1);};var mainvue_type_template_id_5c654dd8_staticRenderFns=[];mainvue_type_template_id_5c654dd8_render._withStripped=true;// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=template&id=5c654dd8&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
var transfer_panelvue_type_template_id_2ddab8bd_render=function transfer_panelvue_type_template_id_2ddab8bd_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-transfer-panel"},[_c("p",{staticClass:"el-transfer-panel__header"},[_c("el-checkbox",{attrs:{indeterminate:_vm.isIndeterminate},on:{change:_vm.handleAllCheckedChange},model:{value:_vm.allChecked,callback:function callback($$v){_vm.allChecked=$$v;},expression:"allChecked"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c("span",[_vm._v(_vm._s(_vm.checkedSummary))])])],1),_c("div",{class:["el-transfer-panel__body",_vm.hasFooter?"is-with-footer":""]},[_vm.filterable?_c("el-input",{staticClass:"el-transfer-panel__filter",attrs:{size:"small",placeholder:_vm.placeholder},nativeOn:{mouseenter:function mouseenter($event){_vm.inputHover=true;},mouseleave:function mouseleave($event){_vm.inputHover=false;}},model:{value:_vm.query,callback:function callback($$v){_vm.query=$$v;},expression:"query"}},[_c("i",{class:["el-input__icon","el-icon-"+_vm.inputIcon],attrs:{slot:"prefix"},on:{click:_vm.clearQuery},slot:"prefix"})]):_vm._e(),_c("el-checkbox-group",{directives:[{name:"show",rawName:"v-show",value:!_vm.hasNoMatch&&_vm.data.length>0,expression:"!hasNoMatch && data.length > 0"}],staticClass:"el-transfer-panel__list",class:{"is-filterable":_vm.filterable},model:{value:_vm.checked,callback:function callback($$v){_vm.checked=$$v;},expression:"checked"}},_vm._l(_vm.filteredData,function(item){return _c("el-checkbox",{key:item[_vm.keyProp],staticClass:"el-transfer-panel__item",attrs:{label:item[_vm.keyProp],disabled:item[_vm.disabledProp]}},[_c("option-content",{attrs:{option:item}})],1);}),1),_c("p",{directives:[{name:"show",rawName:"v-show",value:_vm.hasNoMatch,expression:"hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t("el.transfer.noMatch")))]),_c("p",{directives:[{name:"show",rawName:"v-show",value:_vm.data.length===0&&!_vm.hasNoMatch,expression:"data.length === 0 && !hasNoMatch"}],staticClass:"el-transfer-panel__empty"},[_vm._v(_vm._s(_vm.t("el.transfer.noData")))])],1),_vm.hasFooter?_c("p",{staticClass:"el-transfer-panel__footer"},[_vm._t("default")],2):_vm._e()]);};var transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns=[];transfer_panelvue_type_template_id_2ddab8bd_render._withStripped=true;// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=template&id=2ddab8bd&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var transfer_panelvue_type_script_lang_js_={mixins:[locale_default.a],name:'ElTransferPanel',componentName:'ElTransferPanel',components:{ElCheckboxGroup:checkbox_group_default.a,ElCheckbox:checkbox_default.a,ElInput:input_default.a,OptionContent:{props:{option:Object},render:function render(h){var getParent=function getParent(vm){if(vm.$options.componentName==='ElTransferPanel'){return vm;}else if(vm.$parent){return getParent(vm.$parent);}else{return vm;}};var panel=getParent(this);var transfer=panel.$parent||panel;return panel.renderContent?panel.renderContent(h,this.option):transfer.$scopedSlots.default?transfer.$scopedSlots.default({option:this.option}):h('span',[this.option[panel.labelProp]||this.option[panel.keyProp]]);}}},props:{data:{type:Array,default:function _default(){return[];}},renderContent:Function,placeholder:String,title:String,filterable:Boolean,format:Object,filterMethod:Function,defaultChecked:Array,props:Object},data:function data(){return{checked:[],allChecked:false,query:'',inputHover:false,checkChangeByUser:true};},watch:{checked:function checked(val,oldVal){this.updateAllChecked();if(this.checkChangeByUser){var movedKeys=val.concat(oldVal).filter(function(v){return val.indexOf(v)===-1||oldVal.indexOf(v)===-1;});this.$emit('checked-change',val,movedKeys);}else{this.$emit('checked-change',val);this.checkChangeByUser=true;}},data:function data(){var _this=this;var checked=[];var filteredDataKeys=this.filteredData.map(function(item){return item[_this.keyProp];});this.checked.forEach(function(item){if(filteredDataKeys.indexOf(item)>-1){checked.push(item);}});this.checkChangeByUser=false;this.checked=checked;},checkableData:function checkableData(){this.updateAllChecked();},defaultChecked:{immediate:true,handler:function handler(val,oldVal){var _this2=this;if(oldVal&&val.length===oldVal.length&&val.every(function(item){return oldVal.indexOf(item)>-1;}))return;var checked=[];var checkableDataKeys=this.checkableData.map(function(item){return item[_this2.keyProp];});val.forEach(function(item){if(checkableDataKeys.indexOf(item)>-1){checked.push(item);}});this.checkChangeByUser=false;this.checked=checked;}}},computed:{filteredData:function filteredData(){var _this3=this;return this.data.filter(function(item){if(typeof _this3.filterMethod==='function'){return _this3.filterMethod(_this3.query,item);}else{var label=item[_this3.labelProp]||item[_this3.keyProp].toString();return label.toLowerCase().indexOf(_this3.query.toLowerCase())>-1;}});},checkableData:function checkableData(){var _this4=this;return this.filteredData.filter(function(item){return!item[_this4.disabledProp];});},checkedSummary:function checkedSummary(){var checkedLength=this.checked.length;var dataLength=this.data.length;var _format=this.format,noChecked=_format.noChecked,hasChecked=_format.hasChecked;if(noChecked&&hasChecked){return checkedLength>0?hasChecked.replace(/\${checked}/g,checkedLength).replace(/\${total}/g,dataLength):noChecked.replace(/\${total}/g,dataLength);}else{return checkedLength+'/'+dataLength;}},isIndeterminate:function isIndeterminate(){var checkedLength=this.checked.length;return checkedLength>0&&checkedLength<this.checkableData.length;},hasNoMatch:function hasNoMatch(){return this.query.length>0&&this.filteredData.length===0;},inputIcon:function inputIcon(){return this.query.length>0&&this.inputHover?'circle-close':'search';},labelProp:function labelProp(){return this.props.label||'label';},keyProp:function keyProp(){return this.props.key||'key';},disabledProp:function disabledProp(){return this.props.disabled||'disabled';},hasFooter:function hasFooter(){return!!this.$slots.default;}},methods:{updateAllChecked:function updateAllChecked(){var _this5=this;var checkableDataKeys=this.checkableData.map(function(item){return item[_this5.keyProp];});this.allChecked=checkableDataKeys.length>0&&checkableDataKeys.every(function(item){return _this5.checked.indexOf(item)>-1;});},handleAllCheckedChange:function handleAllCheckedChange(value){var _this6=this;this.checked=value?this.checkableData.map(function(item){return item[_this6.keyProp];}):[];},clearQuery:function clearQuery(){if(this.inputIcon==='circle-close'){this.query='';}}}};// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_transfer_panelvue_type_script_lang_js_=transfer_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/transfer/src/transfer-panel.vue
/* normalize component */var transfer_panel_component=normalizeComponent(src_transfer_panelvue_type_script_lang_js_,transfer_panelvue_type_template_id_2ddab8bd_render,transfer_panelvue_type_template_id_2ddab8bd_staticRenderFns,false,null,null,null);/* hot reload */if(false){var transfer_panel_api;}transfer_panel_component.options.__file="packages/transfer/src/transfer-panel.vue";/* harmony default export */var transfer_panel=transfer_panel_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/transfer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var transfer_src_mainvue_type_script_lang_js_={name:'ElTransfer',mixins:[emitter_default.a,locale_default.a,migrating_default.a],components:{TransferPanel:transfer_panel,ElButton:button_default.a},props:{data:{type:Array,default:function _default(){return[];}},titles:{type:Array,default:function _default(){return[];}},buttonTexts:{type:Array,default:function _default(){return[];}},filterPlaceholder:{type:String,default:''},filterMethod:Function,leftDefaultChecked:{type:Array,default:function _default(){return[];}},rightDefaultChecked:{type:Array,default:function _default(){return[];}},renderContent:Function,value:{type:Array,default:function _default(){return[];}},format:{type:Object,default:function _default(){return{};}},filterable:Boolean,props:{type:Object,default:function _default(){return{label:'label',key:'key',disabled:'disabled'};}},targetOrder:{type:String,default:'original'}},data:function data(){return{leftChecked:[],rightChecked:[]};},computed:{dataObj:function dataObj(){var key=this.props.key;return this.data.reduce(function(o,cur){return(o[cur[key]]=cur)&&o;},{});},sourceData:function sourceData(){var _this=this;return this.data.filter(function(item){return _this.value.indexOf(item[_this.props.key])===-1;});},targetData:function targetData(){var _this2=this;if(this.targetOrder==='original'){return this.data.filter(function(item){return _this2.value.indexOf(item[_this2.props.key])>-1;});}else{return this.value.reduce(function(arr,cur){var val=_this2.dataObj[cur];if(val){arr.push(val);}return arr;},[]);}},hasButtonTexts:function hasButtonTexts(){return this.buttonTexts.length===2;}},watch:{value:function value(val){this.dispatch('ElFormItem','el.form.change',val);}},methods:{getMigratingConfig:function getMigratingConfig(){return{props:{'footer-format':'footer-format is renamed to format.'}};},onSourceCheckedChange:function onSourceCheckedChange(val,movedKeys){this.leftChecked=val;if(movedKeys===undefined)return;this.$emit('left-check-change',val,movedKeys);},onTargetCheckedChange:function onTargetCheckedChange(val,movedKeys){this.rightChecked=val;if(movedKeys===undefined)return;this.$emit('right-check-change',val,movedKeys);},addToLeft:function addToLeft(){var currentValue=this.value.slice();this.rightChecked.forEach(function(item){var index=currentValue.indexOf(item);if(index>-1){currentValue.splice(index,1);}});this.$emit('input',currentValue);this.$emit('change',currentValue,'left',this.rightChecked);},addToRight:function addToRight(){var _this3=this;var currentValue=this.value.slice();var itemsToBeMoved=[];var key=this.props.key;this.data.forEach(function(item){var itemKey=item[key];if(_this3.leftChecked.indexOf(itemKey)>-1&&_this3.value.indexOf(itemKey)===-1){itemsToBeMoved.push(itemKey);}});currentValue=this.targetOrder==='unshift'?itemsToBeMoved.concat(currentValue):currentValue.concat(itemsToBeMoved);this.$emit('input',currentValue);this.$emit('change',currentValue,'right',this.leftChecked);},clearQuery:function clearQuery(which){if(which==='left'){this.$refs.leftPanel.query='';}else if(which==='right'){this.$refs.rightPanel.query='';}}}};// CONCATENATED MODULE: ./packages/transfer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_transfer_src_mainvue_type_script_lang_js_=transfer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/transfer/src/main.vue
/* normalize component */var transfer_src_main_component=normalizeComponent(packages_transfer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5c654dd8_render,mainvue_type_template_id_5c654dd8_staticRenderFns,false,null,null,null);/* hot reload */if(false){var transfer_src_main_api;}transfer_src_main_component.options.__file="packages/transfer/src/main.vue";/* harmony default export */var transfer_src_main=transfer_src_main_component.exports;// CONCATENATED MODULE: ./packages/transfer/index.js
/* istanbul ignore next */transfer_src_main.install=function(Vue){Vue.component(transfer_src_main.name,transfer_src_main);};/* harmony default export */var transfer=transfer_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
var mainvue_type_template_id_5bf181d4_render=function mainvue_type_template_id_5bf181d4_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("section",{staticClass:"el-container",class:{"is-vertical":_vm.isVertical}},[_vm._t("default")],2);};var mainvue_type_template_id_5bf181d4_staticRenderFns=[];mainvue_type_template_id_5bf181d4_render._withStripped=true;// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=template&id=5bf181d4&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/container/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var container_src_mainvue_type_script_lang_js_={name:'ElContainer',componentName:'ElContainer',props:{direction:String},computed:{isVertical:function isVertical(){if(this.direction==='vertical'){return true;}else if(this.direction==='horizontal'){return false;}return this.$slots&&this.$slots.default?this.$slots.default.some(function(vnode){var tag=vnode.componentOptions&&vnode.componentOptions.tag;return tag==='el-header'||tag==='el-footer';}):false;}}};// CONCATENATED MODULE: ./packages/container/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_container_src_mainvue_type_script_lang_js_=container_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/container/src/main.vue
/* normalize component */var container_src_main_component=normalizeComponent(packages_container_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5bf181d4_render,mainvue_type_template_id_5bf181d4_staticRenderFns,false,null,null,null);/* hot reload */if(false){var container_src_main_api;}container_src_main_component.options.__file="packages/container/src/main.vue";/* harmony default export */var container_src_main=container_src_main_component.exports;// CONCATENATED MODULE: ./packages/container/index.js
/* istanbul ignore next */container_src_main.install=function(Vue){Vue.component(container_src_main.name,container_src_main);};/* harmony default export */var packages_container=container_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
var mainvue_type_template_id_2b296ab2_render=function mainvue_type_template_id_2b296ab2_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("header",{staticClass:"el-header",style:{height:_vm.height}},[_vm._t("default")],2);};var mainvue_type_template_id_2b296ab2_staticRenderFns=[];mainvue_type_template_id_2b296ab2_render._withStripped=true;// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=template&id=2b296ab2&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var header_src_mainvue_type_script_lang_js_={name:'ElHeader',componentName:'ElHeader',props:{height:{type:String,default:'60px'}}};// CONCATENATED MODULE: ./packages/header/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_header_src_mainvue_type_script_lang_js_=header_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/header/src/main.vue
/* normalize component */var header_src_main_component=normalizeComponent(packages_header_src_mainvue_type_script_lang_js_,mainvue_type_template_id_2b296ab2_render,mainvue_type_template_id_2b296ab2_staticRenderFns,false,null,null,null);/* hot reload */if(false){var header_src_main_api;}header_src_main_component.options.__file="packages/header/src/main.vue";/* harmony default export */var header_src_main=header_src_main_component.exports;// CONCATENATED MODULE: ./packages/header/index.js
/* istanbul ignore next */header_src_main.install=function(Vue){Vue.component(header_src_main.name,header_src_main);};/* harmony default export */var header=header_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
var mainvue_type_template_id_03411dbf_render=function mainvue_type_template_id_03411dbf_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("aside",{staticClass:"el-aside",style:{width:_vm.width}},[_vm._t("default")],2);};var mainvue_type_template_id_03411dbf_staticRenderFns=[];mainvue_type_template_id_03411dbf_render._withStripped=true;// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=template&id=03411dbf&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/aside/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var aside_src_mainvue_type_script_lang_js_={name:'ElAside',componentName:'ElAside',props:{width:{type:String,default:'300px'}}};// CONCATENATED MODULE: ./packages/aside/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_aside_src_mainvue_type_script_lang_js_=aside_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/aside/src/main.vue
/* normalize component */var aside_src_main_component=normalizeComponent(packages_aside_src_mainvue_type_script_lang_js_,mainvue_type_template_id_03411dbf_render,mainvue_type_template_id_03411dbf_staticRenderFns,false,null,null,null);/* hot reload */if(false){var aside_src_main_api;}aside_src_main_component.options.__file="packages/aside/src/main.vue";/* harmony default export */var aside_src_main=aside_src_main_component.exports;// CONCATENATED MODULE: ./packages/aside/index.js
/* istanbul ignore next */aside_src_main.install=function(Vue){Vue.component(aside_src_main.name,aside_src_main);};/* harmony default export */var aside=aside_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
var mainvue_type_template_id_2a3a7406_render=function mainvue_type_template_id_2a3a7406_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("main",{staticClass:"el-main"},[_vm._t("default")],2);};var mainvue_type_template_id_2a3a7406_staticRenderFns=[];mainvue_type_template_id_2a3a7406_render._withStripped=true;// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=template&id=2a3a7406&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/main/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var main_src_mainvue_type_script_lang_js_={name:'ElMain',componentName:'ElMain'};// CONCATENATED MODULE: ./packages/main/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_main_src_mainvue_type_script_lang_js_=main_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/main/src/main.vue
/* normalize component */var main_src_main_component=normalizeComponent(packages_main_src_mainvue_type_script_lang_js_,mainvue_type_template_id_2a3a7406_render,mainvue_type_template_id_2a3a7406_staticRenderFns,false,null,null,null);/* hot reload */if(false){var main_src_main_api;}main_src_main_component.options.__file="packages/main/src/main.vue";/* harmony default export */var main_src_main=main_src_main_component.exports;// CONCATENATED MODULE: ./packages/main/index.js
/* istanbul ignore next */main_src_main.install=function(Vue){Vue.component(main_src_main.name,main_src_main);};/* harmony default export */var packages_main=main_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=template&id=80210338&
var mainvue_type_template_id_80210338_render=function mainvue_type_template_id_80210338_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("footer",{staticClass:"el-footer",style:{height:_vm.height}},[_vm._t("default")],2);};var mainvue_type_template_id_80210338_staticRenderFns=[];mainvue_type_template_id_80210338_render._withStripped=true;// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=template&id=80210338&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/footer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */var footer_src_mainvue_type_script_lang_js_={name:'ElFooter',componentName:'ElFooter',props:{height:{type:String,default:'60px'}}};// CONCATENATED MODULE: ./packages/footer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_footer_src_mainvue_type_script_lang_js_=footer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/footer/src/main.vue
/* normalize component */var footer_src_main_component=normalizeComponent(packages_footer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_80210338_render,mainvue_type_template_id_80210338_staticRenderFns,false,null,null,null);/* hot reload */if(false){var footer_src_main_api;}footer_src_main_component.options.__file="packages/footer/src/main.vue";/* harmony default export */var footer_src_main=footer_src_main_component.exports;// CONCATENATED MODULE: ./packages/footer/index.js
/* istanbul ignore next */footer_src_main.install=function(Vue){Vue.component(footer_src_main.name,footer_src_main);};/* harmony default export */var footer=footer_src_main;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var timeline_src_mainvue_type_script_lang_js_={name:'ElTimeline',props:{reverse:{type:Boolean,default:false}},provide:function provide(){return{timeline:this};},render:function render(){var h=arguments[0];var reverse=this.reverse;var classes={'el-timeline':true,'is-reverse':reverse};var slots=this.$slots.default||[];if(reverse){slots=slots.reverse();}return h('ul',{'class':classes},[slots]);}};// CONCATENATED MODULE: ./packages/timeline/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_timeline_src_mainvue_type_script_lang_js_=timeline_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/timeline/src/main.vue
var main_render,main_staticRenderFns;/* normalize component */var timeline_src_main_component=normalizeComponent(packages_timeline_src_mainvue_type_script_lang_js_,main_render,main_staticRenderFns,false,null,null,null);/* hot reload */if(false){var timeline_src_main_api;}timeline_src_main_component.options.__file="packages/timeline/src/main.vue";/* harmony default export */var timeline_src_main=timeline_src_main_component.exports;// CONCATENATED MODULE: ./packages/timeline/index.js
/* istanbul ignore next */timeline_src_main.install=function(Vue){Vue.component(timeline_src_main.name,timeline_src_main);};/* harmony default export */var timeline=timeline_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
var itemvue_type_template_id_61a69e50_render=function itemvue_type_template_id_61a69e50_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("li",{staticClass:"el-timeline-item"},[_c("div",{staticClass:"el-timeline-item__tail"}),!_vm.$slots.dot?_c("div",{staticClass:"el-timeline-item__node",class:["el-timeline-item__node--"+(_vm.size||""),"el-timeline-item__node--"+(_vm.type||"")],style:{backgroundColor:_vm.color}},[_vm.icon?_c("i",{staticClass:"el-timeline-item__icon",class:_vm.icon}):_vm._e()]):_vm._e(),_vm.$slots.dot?_c("div",{staticClass:"el-timeline-item__dot"},[_vm._t("dot")],2):_vm._e(),_c("div",{staticClass:"el-timeline-item__wrapper"},[!_vm.hideTimestamp&&_vm.placement==="top"?_c("div",{staticClass:"el-timeline-item__timestamp is-top"},[_vm._v("\n      "+_vm._s(_vm.timestamp)+"\n    ")]):_vm._e(),_c("div",{staticClass:"el-timeline-item__content"},[_vm._t("default")],2),!_vm.hideTimestamp&&_vm.placement==="bottom"?_c("div",{staticClass:"el-timeline-item__timestamp is-bottom"},[_vm._v("\n      "+_vm._s(_vm.timestamp)+"\n    ")]):_vm._e()])]);};var itemvue_type_template_id_61a69e50_staticRenderFns=[];itemvue_type_template_id_61a69e50_render._withStripped=true;// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=template&id=61a69e50&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/timeline/src/item.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var timeline_src_itemvue_type_script_lang_js_={name:'ElTimelineItem',inject:['timeline'],props:{timestamp:String,hideTimestamp:{type:Boolean,default:false},placement:{type:String,default:'bottom'},type:String,color:String,size:{type:String,default:'normal'},icon:String}};// CONCATENATED MODULE: ./packages/timeline/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var packages_timeline_src_itemvue_type_script_lang_js_=timeline_src_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/timeline/src/item.vue
/* normalize component */var src_item_component=normalizeComponent(packages_timeline_src_itemvue_type_script_lang_js_,itemvue_type_template_id_61a69e50_render,itemvue_type_template_id_61a69e50_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_item_api;}src_item_component.options.__file="packages/timeline/src/item.vue";/* harmony default export */var timeline_src_item=src_item_component.exports;// CONCATENATED MODULE: ./packages/timeline-item/index.js
/* istanbul ignore next */timeline_src_item.install=function(Vue){Vue.component(timeline_src_item.name,timeline_src_item);};/* harmony default export */var timeline_item=timeline_src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
var mainvue_type_template_id_01cf3b65_render=function mainvue_type_template_id_01cf3b65_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("a",_vm._b({class:["el-link",_vm.type?"el-link--"+_vm.type:"",_vm.disabled&&"is-disabled",_vm.underline&&!_vm.disabled&&"is-underline"],attrs:{href:_vm.disabled?null:_vm.href},on:{click:_vm.handleClick}},"a",_vm.$attrs,false),[_vm.icon?_c("i",{class:_vm.icon}):_vm._e(),_vm.$slots.default?_c("span",{staticClass:"el-link--inner"},[_vm._t("default")],2):_vm._e(),_vm.$slots.icon?[_vm.$slots.icon?_vm._t("icon"):_vm._e()]:_vm._e()],2);};var mainvue_type_template_id_01cf3b65_staticRenderFns=[];mainvue_type_template_id_01cf3b65_render._withStripped=true;// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=template&id=01cf3b65&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/link/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var link_src_mainvue_type_script_lang_js_={name:'ElLink',props:{type:{type:String,default:'default'},underline:{type:Boolean,default:true},disabled:Boolean,href:String,icon:String},methods:{handleClick:function handleClick(event){if(!this.disabled){if(!this.href){this.$emit('click',event);}}}}};// CONCATENATED MODULE: ./packages/link/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_link_src_mainvue_type_script_lang_js_=link_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/link/src/main.vue
/* normalize component */var link_src_main_component=normalizeComponent(packages_link_src_mainvue_type_script_lang_js_,mainvue_type_template_id_01cf3b65_render,mainvue_type_template_id_01cf3b65_staticRenderFns,false,null,null,null);/* hot reload */if(false){var link_src_main_api;}link_src_main_component.options.__file="packages/link/src/main.vue";/* harmony default export */var link_src_main=link_src_main_component.exports;// CONCATENATED MODULE: ./packages/link/index.js
/* istanbul ignore next */link_src_main.install=function(Vue){Vue.component(link_src_main.name,link_src_main);};/* harmony default export */var packages_link=link_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
var mainvue_type_template_id_7fa02a7e_functional_true_render=function mainvue_type_template_id_7fa02a7e_functional_true_render(_h,_vm){var _c=_vm._c;return _c("div",_vm._g(_vm._b({class:[_vm.data.staticClass,"el-divider","el-divider--"+_vm.props.direction]},"div",_vm.data.attrs,false),_vm.listeners),[_vm.slots().default&&_vm.props.direction!=="vertical"?_c("div",{class:["el-divider__text","is-"+_vm.props.contentPosition]},[_vm._t("default")],2):_vm._e()]);};var mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns=[];mainvue_type_template_id_7fa02a7e_functional_true_render._withStripped=true;// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=template&id=7fa02a7e&functional=true&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/divider/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var divider_src_mainvue_type_script_lang_js_={name:'ElDivider',props:{direction:{type:String,default:'horizontal',validator:function validator(val){return['horizontal','vertical'].indexOf(val)!==-1;}},contentPosition:{type:String,default:'center',validator:function validator(val){return['left','center','right'].indexOf(val)!==-1;}}}};// CONCATENATED MODULE: ./packages/divider/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_divider_src_mainvue_type_script_lang_js_=divider_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/divider/src/main.vue
/* normalize component */var divider_src_main_component=normalizeComponent(packages_divider_src_mainvue_type_script_lang_js_,mainvue_type_template_id_7fa02a7e_functional_true_render,mainvue_type_template_id_7fa02a7e_functional_true_staticRenderFns,true,null,null,null);/* hot reload */if(false){var divider_src_main_api;}divider_src_main_component.options.__file="packages/divider/src/main.vue";/* harmony default export */var divider_src_main=divider_src_main_component.exports;// CONCATENATED MODULE: ./packages/divider/index.js
/* istanbul ignore next */divider_src_main.install=function(Vue){Vue.component(divider_src_main.name,divider_src_main);};/* harmony default export */var divider=divider_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
var mainvue_type_template_id_44d84a7c_render=function mainvue_type_template_id_44d84a7c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-image"},[_vm.loading?_vm._t("placeholder",[_c("div",{staticClass:"el-image__placeholder"})]):_vm.error?_vm._t("error",[_c("div",{staticClass:"el-image__error"},[_vm._v(_vm._s(_vm.t("el.image.error")))])]):_c("img",_vm._g(_vm._b({staticClass:"el-image__inner",class:{"el-image__inner--center":_vm.alignCenter,"el-image__preview":_vm.preview},style:_vm.imageStyle,attrs:{src:_vm.src},on:{click:_vm.clickHandler}},"img",_vm.$attrs,false),_vm.$listeners)),_vm.preview?[_vm.showViewer?_c("image-viewer",{attrs:{"z-index":_vm.zIndex,"initial-index":_vm.imageIndex,"on-close":_vm.closeViewer,"url-list":_vm.previewSrcList}}):_vm._e()]:_vm._e()],2);};var mainvue_type_template_id_44d84a7c_staticRenderFns=[];mainvue_type_template_id_44d84a7c_render._withStripped=true;// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=template&id=44d84a7c&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
var image_viewervue_type_template_id_5e73b307_render=function image_viewervue_type_template_id_5e73b307_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"viewer-fade"}},[_c("div",{ref:"el-image-viewer__wrapper",staticClass:"el-image-viewer__wrapper",style:{"z-index":_vm.viewerZIndex},attrs:{tabindex:"-1"}},[_c("div",{staticClass:"el-image-viewer__mask",on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleMaskClick($event);}}}),_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__close",on:{click:_vm.hide}},[_c("i",{staticClass:"el-icon-close"})]),!_vm.isSingle?[_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__prev",class:{"is-disabled":!_vm.infinite&&_vm.isFirst},on:{click:_vm.prev}},[_c("i",{staticClass:"el-icon-arrow-left"})]),_c("span",{staticClass:"el-image-viewer__btn el-image-viewer__next",class:{"is-disabled":!_vm.infinite&&_vm.isLast},on:{click:_vm.next}},[_c("i",{staticClass:"el-icon-arrow-right"})])]:_vm._e(),_c("div",{staticClass:"el-image-viewer__btn el-image-viewer__actions"},[_c("div",{staticClass:"el-image-viewer__actions__inner"},[_c("i",{staticClass:"el-icon-zoom-out",on:{click:function click($event){_vm.handleActions("zoomOut");}}}),_c("i",{staticClass:"el-icon-zoom-in",on:{click:function click($event){_vm.handleActions("zoomIn");}}}),_c("i",{staticClass:"el-image-viewer__actions__divider"}),_c("i",{class:_vm.mode.icon,on:{click:_vm.toggleMode}}),_c("i",{staticClass:"el-image-viewer__actions__divider"}),_c("i",{staticClass:"el-icon-refresh-left",on:{click:function click($event){_vm.handleActions("anticlocelise");}}}),_c("i",{staticClass:"el-icon-refresh-right",on:{click:function click($event){_vm.handleActions("clocelise");}}})])]),_c("div",{staticClass:"el-image-viewer__canvas"},_vm._l(_vm.urlList,function(url,i){return i===_vm.index?_c("img",{key:url,ref:"img",refInFor:true,staticClass:"el-image-viewer__img",style:_vm.imgStyle,attrs:{src:_vm.currentImg},on:{load:_vm.handleImgLoad,error:_vm.handleImgError,mousedown:_vm.handleMouseDown}}):_vm._e();}),0)],2)]);};var image_viewervue_type_template_id_5e73b307_staticRenderFns=[];image_viewervue_type_template_id_5e73b307_render._withStripped=true;// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=template&id=5e73b307&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
var image_viewervue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Mode={CONTAIN:{name:'contain',icon:'el-icon-full-screen'},ORIGINAL:{name:'original',icon:'el-icon-c-scale-to-original'}};var mousewheelEventName=Object(util_["isFirefox"])()?'DOMMouseScroll':'mousewheel';/* harmony default export */var image_viewervue_type_script_lang_js_={name:'elImageViewer',props:{urlList:{type:Array,default:function _default(){return[];}},zIndex:{type:Number,default:2000},onSwitch:{type:Function,default:function _default(){}},onClose:{type:Function,default:function _default(){}},initialIndex:{type:Number,default:0},appendToBody:{type:Boolean,default:true},maskClosable:{type:Boolean,default:true}},data:function data(){return{index:this.initialIndex,isShow:false,infinite:true,loading:false,mode:Mode.CONTAIN,transform:{scale:1,deg:0,offsetX:0,offsetY:0,enableTransition:false}};},computed:{isSingle:function isSingle(){return this.urlList.length<=1;},isFirst:function isFirst(){return this.index===0;},isLast:function isLast(){return this.index===this.urlList.length-1;},currentImg:function currentImg(){return this.urlList[this.index];},imgStyle:function imgStyle(){var _transform=this.transform,scale=_transform.scale,deg=_transform.deg,offsetX=_transform.offsetX,offsetY=_transform.offsetY,enableTransition=_transform.enableTransition;var style={transform:'scale('+scale+') rotate('+deg+'deg)',transition:enableTransition?'transform .3s':'','margin-left':offsetX+'px','margin-top':offsetY+'px'};if(this.mode===Mode.CONTAIN){style.maxWidth=style.maxHeight='100%';}return style;},viewerZIndex:function viewerZIndex(){var nextZIndex=popup_["PopupManager"].nextZIndex();return this.zIndex>nextZIndex?this.zIndex:nextZIndex;}},watch:{index:{handler:function handler(val){this.reset();this.onSwitch(val);}},currentImg:function currentImg(val){var _this=this;this.$nextTick(function(_){var $img=_this.$refs.img[0];if(!$img.complete){_this.loading=true;}});}},methods:{hide:function hide(){this.deviceSupportUninstall();this.onClose();},deviceSupportInstall:function deviceSupportInstall(){var _this2=this;this._keyDownHandler=function(e){e.stopPropagation();var keyCode=e.keyCode;switch(keyCode){// ESC
case 27:_this2.hide();break;// SPACE
case 32:_this2.toggleMode();break;// LEFT_ARROW
case 37:_this2.prev();break;// UP_ARROW
case 38:_this2.handleActions('zoomIn');break;// RIGHT_ARROW
case 39:_this2.next();break;// DOWN_ARROW
case 40:_this2.handleActions('zoomOut');break;}};this._mouseWheelHandler=Object(util_["rafThrottle"])(function(e){var delta=e.wheelDelta?e.wheelDelta:-e.detail;if(delta>0){_this2.handleActions('zoomIn',{zoomRate:0.015,enableTransition:false});}else{_this2.handleActions('zoomOut',{zoomRate:0.015,enableTransition:false});}});Object(dom_["on"])(document,'keydown',this._keyDownHandler);Object(dom_["on"])(document,mousewheelEventName,this._mouseWheelHandler);},deviceSupportUninstall:function deviceSupportUninstall(){Object(dom_["off"])(document,'keydown',this._keyDownHandler);Object(dom_["off"])(document,mousewheelEventName,this._mouseWheelHandler);this._keyDownHandler=null;this._mouseWheelHandler=null;},handleImgLoad:function handleImgLoad(e){this.loading=false;},handleImgError:function handleImgError(e){this.loading=false;e.target.alt='加载失败';},handleMouseDown:function handleMouseDown(e){var _this3=this;if(this.loading||e.button!==0)return;var _transform2=this.transform,offsetX=_transform2.offsetX,offsetY=_transform2.offsetY;var startX=e.pageX;var startY=e.pageY;this._dragHandler=Object(util_["rafThrottle"])(function(ev){_this3.transform.offsetX=offsetX+ev.pageX-startX;_this3.transform.offsetY=offsetY+ev.pageY-startY;});Object(dom_["on"])(document,'mousemove',this._dragHandler);Object(dom_["on"])(document,'mouseup',function(ev){Object(dom_["off"])(document,'mousemove',_this3._dragHandler);});e.preventDefault();},handleMaskClick:function handleMaskClick(){if(this.maskClosable){this.hide();}},reset:function reset(){this.transform={scale:1,deg:0,offsetX:0,offsetY:0,enableTransition:false};},toggleMode:function toggleMode(){if(this.loading)return;var modeNames=Object.keys(Mode);var modeValues=Object.values(Mode);var index=modeValues.indexOf(this.mode);var nextIndex=(index+1)%modeNames.length;this.mode=Mode[modeNames[nextIndex]];this.reset();},prev:function prev(){if(this.isFirst&&!this.infinite)return;var len=this.urlList.length;this.index=(this.index-1+len)%len;},next:function next(){if(this.isLast&&!this.infinite)return;var len=this.urlList.length;this.index=(this.index+1)%len;},handleActions:function handleActions(action){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(this.loading)return;var _zoomRate$rotateDeg$e=image_viewervue_type_script_lang_js_extends({zoomRate:0.2,rotateDeg:90,enableTransition:true},options),zoomRate=_zoomRate$rotateDeg$e.zoomRate,rotateDeg=_zoomRate$rotateDeg$e.rotateDeg,enableTransition=_zoomRate$rotateDeg$e.enableTransition;var transform=this.transform;switch(action){case'zoomOut':if(transform.scale>0.2){transform.scale=parseFloat((transform.scale-zoomRate).toFixed(3));}break;case'zoomIn':transform.scale=parseFloat((transform.scale+zoomRate).toFixed(3));break;case'clocelise':transform.deg+=rotateDeg;break;case'anticlocelise':transform.deg-=rotateDeg;break;}transform.enableTransition=enableTransition;}},mounted:function mounted(){this.deviceSupportInstall();if(this.appendToBody){document.body.appendChild(this.$el);}// add tabindex then wrapper can be focusable via Javascript
// focus wrapper so arrow key can't cause inner scroll behavior underneath
this.$refs['el-image-viewer__wrapper'].focus();},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue?vue&type=script&lang=js&
/* harmony default export */var src_image_viewervue_type_script_lang_js_=image_viewervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/image/src/image-viewer.vue
/* normalize component */var image_viewer_component=normalizeComponent(src_image_viewervue_type_script_lang_js_,image_viewervue_type_template_id_5e73b307_render,image_viewervue_type_template_id_5e73b307_staticRenderFns,false,null,null,null);/* hot reload */if(false){var image_viewer_api;}image_viewer_component.options.__file="packages/image/src/image-viewer.vue";/* harmony default export */var image_viewer=image_viewer_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/image/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var isSupportObjectFit=function isSupportObjectFit(){return document.documentElement.style.objectFit!==undefined;};var ObjectFit={NONE:'none',CONTAIN:'contain',COVER:'cover',FILL:'fill',SCALE_DOWN:'scale-down'};var prevOverflow='';/* harmony default export */var image_src_mainvue_type_script_lang_js_={name:'ElImage',mixins:[locale_default.a],inheritAttrs:false,components:{ImageViewer:image_viewer},props:{src:String,fit:String,lazy:Boolean,scrollContainer:{},previewSrcList:{type:Array,default:function _default(){return[];}},zIndex:{type:Number,default:2000}},data:function data(){return{loading:true,error:false,show:!this.lazy,imageWidth:0,imageHeight:0,showViewer:false};},computed:{imageStyle:function imageStyle(){var fit=this.fit;if(!this.$isServer&&fit){return isSupportObjectFit()?{'object-fit':fit}:this.getImageStyle(fit);}return{};},alignCenter:function alignCenter(){return!this.$isServer&&!isSupportObjectFit()&&this.fit!==ObjectFit.FILL;},preview:function preview(){var previewSrcList=this.previewSrcList;return Array.isArray(previewSrcList)&&previewSrcList.length>0;},imageIndex:function imageIndex(){var previewIndex=0;var srcIndex=this.previewSrcList.indexOf(this.src);if(srcIndex>=0){previewIndex=srcIndex;}return previewIndex;}},watch:{src:function src(val){this.show&&this.loadImage();},show:function show(val){val&&this.loadImage();}},mounted:function mounted(){if(this.lazy){this.addLazyLoadListener();}else{this.loadImage();}},beforeDestroy:function beforeDestroy(){this.lazy&&this.removeLazyLoadListener();},methods:{loadImage:function loadImage(){var _this=this;if(this.$isServer)return;// reset status
this.loading=true;this.error=false;var img=new Image();img.onload=function(e){return _this.handleLoad(e,img);};img.onerror=this.handleError.bind(this);// bind html attrs
// so it can behave consistently
Object.keys(this.$attrs).forEach(function(key){var value=_this.$attrs[key];img.setAttribute(key,value);});img.src=this.src;},handleLoad:function handleLoad(e,img){this.imageWidth=img.width;this.imageHeight=img.height;this.loading=false;this.error=false;},handleError:function handleError(e){this.loading=false;this.error=true;this.$emit('error',e);},handleLazyLoad:function handleLazyLoad(){if(Object(dom_["isInContainer"])(this.$el,this._scrollContainer)){this.show=true;this.removeLazyLoadListener();}},addLazyLoadListener:function addLazyLoadListener(){if(this.$isServer)return;var scrollContainer=this.scrollContainer;var _scrollContainer=null;if(Object(types_["isHtmlElement"])(scrollContainer)){_scrollContainer=scrollContainer;}else if(Object(types_["isString"])(scrollContainer)){_scrollContainer=document.querySelector(scrollContainer);}else{_scrollContainer=Object(dom_["getScrollContainer"])(this.$el);}if(_scrollContainer){this._scrollContainer=_scrollContainer;this._lazyLoadHandler=throttle_default()(200,this.handleLazyLoad);Object(dom_["on"])(_scrollContainer,'scroll',this._lazyLoadHandler);this.handleLazyLoad();}},removeLazyLoadListener:function removeLazyLoadListener(){var _scrollContainer=this._scrollContainer,_lazyLoadHandler=this._lazyLoadHandler;if(this.$isServer||!_scrollContainer||!_lazyLoadHandler)return;Object(dom_["off"])(_scrollContainer,'scroll',_lazyLoadHandler);this._scrollContainer=null;this._lazyLoadHandler=null;},/**
     * simulate object-fit behavior to compatible with IE11 and other browsers which not support object-fit
     */getImageStyle:function getImageStyle(fit){var imageWidth=this.imageWidth,imageHeight=this.imageHeight;var _$el=this.$el,containerWidth=_$el.clientWidth,containerHeight=_$el.clientHeight;if(!imageWidth||!imageHeight||!containerWidth||!containerHeight)return{};var imageAspectRatio=imageWidth/imageHeight;var containerAspectRatio=containerWidth/containerHeight;if(fit===ObjectFit.SCALE_DOWN){var isSmaller=imageWidth<containerWidth&&imageHeight<containerHeight;fit=isSmaller?ObjectFit.NONE:ObjectFit.CONTAIN;}switch(fit){case ObjectFit.NONE:return{width:'auto',height:'auto'};case ObjectFit.CONTAIN:return imageAspectRatio<containerAspectRatio?{width:'auto'}:{height:'auto'};case ObjectFit.COVER:return imageAspectRatio<containerAspectRatio?{height:'auto'}:{width:'auto'};default:return{};}},clickHandler:function clickHandler(){// don't show viewer when preview is false
if(!this.preview){return;}// prevent body scroll
prevOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.showViewer=true;},closeViewer:function closeViewer(){document.body.style.overflow=prevOverflow;this.showViewer=false;}}};// CONCATENATED MODULE: ./packages/image/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_image_src_mainvue_type_script_lang_js_=image_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/image/src/main.vue
/* normalize component */var image_src_main_component=normalizeComponent(packages_image_src_mainvue_type_script_lang_js_,mainvue_type_template_id_44d84a7c_render,mainvue_type_template_id_44d84a7c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var image_src_main_api;}image_src_main_component.options.__file="packages/image/src/main.vue";/* harmony default export */var image_src_main=image_src_main_component.exports;// CONCATENATED MODULE: ./packages/image/index.js
/* istanbul ignore next */image_src_main.install=function(Vue){Vue.component(image_src_main.name,image_src_main);};/* harmony default export */var packages_image=image_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
var mainvue_type_template_id_6d9756be_render=function mainvue_type_template_id_6d9756be_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-calendar"},[_c("div",{staticClass:"el-calendar__header"},[_c("div",{staticClass:"el-calendar__title"},[_vm._v("\n      "+_vm._s(_vm.i18nDate)+"\n    ")]),_vm.validatedRange.length===0?_c("div",{staticClass:"el-calendar__button-group"},[_c("el-button-group",[_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("prev-month");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.prevMonth"))+"\n        ")]),_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("today");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.today"))+"\n        ")]),_c("el-button",{attrs:{type:"plain",size:"mini"},on:{click:function click($event){_vm.selectDate("next-month");}}},[_vm._v("\n          "+_vm._s(_vm.t("el.datepicker.nextMonth"))+"\n        ")])],1)],1):_vm._e()]),_vm.validatedRange.length===0?_c("div",{key:"no-range",staticClass:"el-calendar__body"},[_c("date-table",{attrs:{date:_vm.date,"selected-day":_vm.realSelectedDay,"first-day-of-week":_vm.realFirstDayOfWeek},on:{pick:_vm.pickDay}})],1):_c("div",{key:"has-range",staticClass:"el-calendar__body"},_vm._l(_vm.validatedRange,function(range,index){return _c("date-table",{key:index,attrs:{date:range[0],"selected-day":_vm.realSelectedDay,range:range,"hide-header":index!==0,"first-day-of-week":_vm.realFirstDayOfWeek},on:{pick:_vm.pickDay}});}),1)]);};var mainvue_type_template_id_6d9756be_staticRenderFns=[];mainvue_type_template_id_6d9756be_render._withStripped=true;// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=template&id=6d9756be&
// EXTERNAL MODULE: external "element-ui/lib/utils/date"
var date_=__webpack_require__(20);var date_default=/*#__PURE__*/__webpack_require__.n(date_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var src_date_tablevue_type_script_lang_js_={props:{selectedDay:String,// formated date yyyy-MM-dd
range:{type:Array,validator:function validator(val){if(!(val&&val.length))return true;var start=val[0],end=val[1];return Object(date_util_["validateRangeInOneMonth"])(start,end);}},date:Date,hideHeader:Boolean,firstDayOfWeek:Number},inject:['elCalendar'],methods:{toNestedArr:function toNestedArr(days){return Object(date_util_["range"])(days.length/7).map(function(_,index){var start=index*7;return days.slice(start,start+7);});},getFormateDate:function getFormateDate(day,type){if(!day||['prev','current','next'].indexOf(type)===-1){throw new Error('invalid day or type');}var prefix=this.curMonthDatePrefix;if(type==='prev'){prefix=this.prevMonthDatePrefix;}else if(type==='next'){prefix=this.nextMonthDatePrefix;}day=('00'+day).slice(-2);return prefix+'-'+day;},getCellClass:function getCellClass(_ref){var text=_ref.text,type=_ref.type;var classes=[type];if(type==='current'){var date=this.getFormateDate(text,type);if(date===this.selectedDay){classes.push('is-selected');}if(date===this.formatedToday){classes.push('is-today');}}return classes;},pickDay:function pickDay(_ref2){var text=_ref2.text,type=_ref2.type;var date=this.getFormateDate(text,type);this.$emit('pick',date);},cellRenderProxy:function cellRenderProxy(_ref3){var text=_ref3.text,type=_ref3.type;var h=this.$createElement;var render=this.elCalendar.$scopedSlots.dateCell;if(!render)return h('span',[text]);var day=this.getFormateDate(text,type);var date=new Date(day);var data={isSelected:this.selectedDay===day,type:type+'-month',day:day};return render({date:date,data:data});}},computed:{WEEK_DAYS:function WEEK_DAYS(){return Object(date_util_["getI18nSettings"])().dayNames;},prevMonthDatePrefix:function prevMonthDatePrefix(){var temp=new Date(this.date.getTime());temp.setDate(0);return date_default.a.format(temp,'yyyy-MM');},curMonthDatePrefix:function curMonthDatePrefix(){return date_default.a.format(this.date,'yyyy-MM');},nextMonthDatePrefix:function nextMonthDatePrefix(){var temp=new Date(this.date.getFullYear(),this.date.getMonth()+1,1);return date_default.a.format(temp,'yyyy-MM');},formatedToday:function formatedToday(){return this.elCalendar.formatedToday;},isInRange:function isInRange(){return this.range&&this.range.length;},rows:function rows(){var days=[];// if range exists, should render days in range.
if(this.isInRange){var _range=this.range,start=_range[0],end=_range[1];var currentMonthRange=Object(date_util_["range"])(end.getDate()-start.getDate()+1).map(function(_,index){return{text:start.getDate()+index,type:'current'};});var remaining=currentMonthRange.length%7;remaining=remaining===0?0:7-remaining;var nextMonthRange=Object(date_util_["range"])(remaining).map(function(_,index){return{text:index+1,type:'next'};});days=currentMonthRange.concat(nextMonthRange);}else{var date=this.date;var firstDay=Object(date_util_["getFirstDayOfMonth"])(date);firstDay=firstDay===0?7:firstDay;var firstDayOfWeek=typeof this.firstDayOfWeek==='number'?this.firstDayOfWeek:1;var offset=(7+firstDay-firstDayOfWeek)%7;var prevMonthDays=Object(date_util_["getPrevMonthLastDays"])(date,offset).map(function(day){return{text:day,type:'prev'};});var currentMonthDays=Object(date_util_["getMonthDays"])(date).map(function(day){return{text:day,type:'current'};});days=[].concat(prevMonthDays,currentMonthDays);var nextMonthDays=Object(date_util_["range"])(42-days.length).map(function(_,index){return{text:index+1,type:'next'};});days=days.concat(nextMonthDays);}return this.toNestedArr(days);},weekDays:function weekDays(){var start=this.firstDayOfWeek;var WEEK_DAYS=this.WEEK_DAYS;if(typeof start!=='number'||start===0){return WEEK_DAYS.slice();}else{return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0,start));}}},render:function render(){var _this=this;var h=arguments[0];var thead=this.hideHeader?null:h('thead',[this.weekDays.map(function(day){return h('th',{key:day},[day]);})]);return h('table',{'class':{'el-calendar-table':true,'is-range':this.isInRange},attrs:{cellspacing:'0',cellpadding:'0'}},[thead,h('tbody',[this.rows.map(function(row,index){return h('tr',{'class':{'el-calendar-table__row':true,'el-calendar-table__row--hide-border':index===0&&_this.hideHeader},key:index},[row.map(function(cell,key){return h('td',{key:key,'class':_this.getCellClass(cell),on:{'click':_this.pickDay.bind(_this,cell)}},[h('div',{'class':'el-calendar-day'},[_this.cellRenderProxy(cell)])]);})]);})])]);}};// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue?vue&type=script&lang=js&
/* harmony default export */var calendar_src_date_tablevue_type_script_lang_js_=src_date_tablevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/calendar/src/date-table.vue
var date_table_render,date_table_staticRenderFns;/* normalize component */var src_date_table_component=normalizeComponent(calendar_src_date_tablevue_type_script_lang_js_,date_table_render,date_table_staticRenderFns,false,null,null,null);/* hot reload */if(false){var src_date_table_api;}src_date_table_component.options.__file="packages/calendar/src/date-table.vue";/* harmony default export */var src_date_table=src_date_table_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/calendar/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var validTypes=['prev-month','today','next-month'];var weekDays=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];var oneDay=86400000;/* harmony default export */var calendar_src_mainvue_type_script_lang_js_={name:'ElCalendar',mixins:[locale_default.a],components:{DateTable:src_date_table,ElButton:button_default.a,ElButtonGroup:button_group_default.a},props:{value:[Date,String,Number],range:{type:Array,validator:function validator(range){if(Array.isArray(range)){return range.length===2&&range.every(function(item){return typeof item==='string'||typeof item==='number'||item instanceof Date;});}else{return true;}}},firstDayOfWeek:{type:Number,default:1}},provide:function provide(){return{elCalendar:this};},methods:{pickDay:function pickDay(day){this.realSelectedDay=day;},selectDate:function selectDate(type){if(validTypes.indexOf(type)===-1){throw new Error('invalid type '+type);}var day='';if(type==='prev-month'){day=this.prevMonthDatePrefix+'-01';}else if(type==='next-month'){day=this.nextMonthDatePrefix+'-01';}else{day=this.formatedToday;}if(day===this.formatedDate)return;this.pickDay(day);},toDate:function toDate(val){if(!val){throw new Error('invalid val');}return val instanceof Date?val:new Date(val);},rangeValidator:function rangeValidator(date,isStart){var firstDayOfWeek=this.realFirstDayOfWeek;var expected=isStart?firstDayOfWeek:firstDayOfWeek===0?6:firstDayOfWeek-1;var message=(isStart?'start':'end')+' of range should be '+weekDays[expected]+'.';if(date.getDay()!==expected){console.warn('[ElementCalendar]',message,'Invalid range will be ignored.');return false;}return true;}},computed:{prevMonthDatePrefix:function prevMonthDatePrefix(){var temp=new Date(this.date.getTime());temp.setDate(0);return date_default.a.format(temp,'yyyy-MM');},curMonthDatePrefix:function curMonthDatePrefix(){return date_default.a.format(this.date,'yyyy-MM');},nextMonthDatePrefix:function nextMonthDatePrefix(){var temp=new Date(this.date.getFullYear(),this.date.getMonth()+1,1);return date_default.a.format(temp,'yyyy-MM');},formatedDate:function formatedDate(){return date_default.a.format(this.date,'yyyy-MM-dd');},i18nDate:function i18nDate(){var year=this.date.getFullYear();var month=this.date.getMonth()+1;return year+' '+this.t('el.datepicker.year')+' '+this.t('el.datepicker.month'+month);},formatedToday:function formatedToday(){return date_default.a.format(this.now,'yyyy-MM-dd');},realSelectedDay:{get:function get(){if(!this.value)return this.selectedDay;return this.formatedDate;},set:function set(val){this.selectedDay=val;var date=new Date(val);this.$emit('input',date);}},date:function date(){if(!this.value){if(this.realSelectedDay){var d=this.selectedDay.split('-');return new Date(d[0],d[1]-1,d[2]);}else if(this.validatedRange.length){return this.validatedRange[0][0];}return this.now;}else{return this.toDate(this.value);}},// if range is valid, we get a two-digit array
validatedRange:function validatedRange(){var _this=this;var range=this.range;if(!range)return[];range=range.reduce(function(prev,val,index){var date=_this.toDate(val);if(_this.rangeValidator(date,index===0)){prev=prev.concat(date);}return prev;},[]);if(range.length===2){var _range=range,start=_range[0],end=_range[1];if(start>end){console.warn('[ElementCalendar]end time should be greater than start time');return[];}// start time and end time in one month
if(Object(date_util_["validateRangeInOneMonth"])(start,end)){return[[start,end]];}var data=[];var startDay=new Date(start.getFullYear(),start.getMonth()+1,1);var lastDay=this.toDate(startDay.getTime()-oneDay);if(!Object(date_util_["validateRangeInOneMonth"])(startDay,end)){console.warn('[ElementCalendar]start time and end time interval must not exceed two months');return[];}// 第一个月的时间范围
data.push([start,lastDay]);// 下一月的时间范围，需要计算一下该月的第一个周起始日
var firstDayOfWeek=this.realFirstDayOfWeek;var nextMontFirstDay=startDay.getDay();var interval=0;if(nextMontFirstDay!==firstDayOfWeek){if(firstDayOfWeek===0){interval=7-nextMontFirstDay;}else{interval=firstDayOfWeek-nextMontFirstDay;interval=interval>0?interval:7+interval;}}startDay=this.toDate(startDay.getTime()+interval*oneDay);if(startDay.getDate()<end.getDate()){data.push([startDay,end]);}return data;}return[];},realFirstDayOfWeek:function realFirstDayOfWeek(){if(this.firstDayOfWeek<1||this.firstDayOfWeek>6){return 0;}return Math.floor(this.firstDayOfWeek);}},data:function data(){return{selectedDay:'',now:new Date()};}};// CONCATENATED MODULE: ./packages/calendar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_calendar_src_mainvue_type_script_lang_js_=calendar_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/calendar/src/main.vue
/* normalize component */var calendar_src_main_component=normalizeComponent(packages_calendar_src_mainvue_type_script_lang_js_,mainvue_type_template_id_6d9756be_render,mainvue_type_template_id_6d9756be_staticRenderFns,false,null,null,null);/* hot reload */if(false){var calendar_src_main_api;}calendar_src_main_component.options.__file="packages/calendar/src/main.vue";/* harmony default export */var calendar_src_main=calendar_src_main_component.exports;// CONCATENATED MODULE: ./packages/calendar/index.js
/* istanbul ignore next */calendar_src_main.install=function(Vue){Vue.component(calendar_src_main.name,calendar_src_main);};/* harmony default export */var calendar=calendar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
var mainvue_type_template_id_257dd4a9_render=function mainvue_type_template_id_257dd4a9_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-fade-in"}},[_vm.visible?_c("div",{staticClass:"el-backtop",style:{right:_vm.styleRight,bottom:_vm.styleBottom},on:{click:function click($event){$event.stopPropagation();return _vm.handleClick($event);}}},[_vm._t("default",[_c("el-icon",{attrs:{name:"caret-top"}})])],2):_vm._e()]);};var mainvue_type_template_id_257dd4a9_staticRenderFns=[];mainvue_type_template_id_257dd4a9_render._withStripped=true;// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=template&id=257dd4a9&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/backtop/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var cubic=function cubic(value){return Math.pow(value,3);};var easeInOutCubic=function easeInOutCubic(value){return value<0.5?cubic(value*2)/2:1-cubic((1-value)*2)/2;};/* harmony default export */var backtop_src_mainvue_type_script_lang_js_={name:'ElBacktop',props:{visibilityHeight:{type:Number,default:200},target:[String],right:{type:Number,default:40},bottom:{type:Number,default:40}},data:function data(){return{el:null,container:null,visible:false};},computed:{styleBottom:function styleBottom(){return this.bottom+'px';},styleRight:function styleRight(){return this.right+'px';}},mounted:function mounted(){this.init();this.throttledScrollHandler=throttle_default()(300,this.onScroll);this.container.addEventListener('scroll',this.throttledScrollHandler);},methods:{init:function init(){this.container=document;this.el=document.documentElement;if(this.target){this.el=document.querySelector(this.target);if(!this.el){throw new Error('target is not existed: '+this.target);}this.container=this.el;}},onScroll:function onScroll(){var scrollTop=this.el.scrollTop;this.visible=scrollTop>=this.visibilityHeight;},handleClick:function handleClick(e){this.scrollToTop();this.$emit('click',e);},scrollToTop:function scrollToTop(){var el=this.el;var beginTime=Date.now();var beginValue=el.scrollTop;var rAF=window.requestAnimationFrame||function(func){return setTimeout(func,16);};var frameFunc=function frameFunc(){var progress=(Date.now()-beginTime)/500;if(progress<1){el.scrollTop=beginValue*(1-easeInOutCubic(progress));rAF(frameFunc);}else{el.scrollTop=0;}};rAF(frameFunc);}},beforeDestroy:function beforeDestroy(){this.container.removeEventListener('scroll',this.throttledScrollHandler);}};// CONCATENATED MODULE: ./packages/backtop/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_backtop_src_mainvue_type_script_lang_js_=backtop_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/backtop/src/main.vue
/* normalize component */var backtop_src_main_component=normalizeComponent(packages_backtop_src_mainvue_type_script_lang_js_,mainvue_type_template_id_257dd4a9_render,mainvue_type_template_id_257dd4a9_staticRenderFns,false,null,null,null);/* hot reload */if(false){var backtop_src_main_api;}backtop_src_main_component.options.__file="packages/backtop/src/main.vue";/* harmony default export */var backtop_src_main=backtop_src_main_component.exports;// CONCATENATED MODULE: ./packages/backtop/index.js
/* istanbul ignore next */backtop_src_main.install=function(Vue){Vue.component(backtop_src_main.name,backtop_src_main);};/* harmony default export */var backtop=backtop_src_main;// CONCATENATED MODULE: ./packages/infinite-scroll/src/main.js
var getStyleComputedProperty=function getStyleComputedProperty(element,property){if(element===window){element=document.documentElement;}if(element.nodeType!==1){return[];}// NOTE: 1 DOM access here
var css=window.getComputedStyle(element,null);return property?css[property]:css;};var entries=function entries(obj){return Object.keys(obj||{}).map(function(key){return[key,obj[key]];});};var getPositionSize=function getPositionSize(el,prop){return el===window||el===document?document.documentElement[prop]:el[prop];};var getOffsetHeight=function getOffsetHeight(el){return getPositionSize(el,'offsetHeight');};var getClientHeight=function getClientHeight(el){return getPositionSize(el,'clientHeight');};var scope='ElInfiniteScroll';var attributes={delay:{type:Number,default:200},distance:{type:Number,default:0},disabled:{type:Boolean,default:false},immediate:{type:Boolean,default:true}};var main_getScrollOptions=function getScrollOptions(el,vm){if(!Object(types_["isHtmlElement"])(el))return{};return entries(attributes).reduce(function(map,_ref){var key=_ref[0],option=_ref[1];var type=option.type,defaultValue=option.default;var value=el.getAttribute('infinite-scroll-'+key);value=Object(types_["isUndefined"])(vm[value])?value:vm[value];switch(type){case Number:value=Number(value);value=Number.isNaN(value)?defaultValue:value;break;case Boolean:value=Object(types_["isDefined"])(value)?value==='false'?false:Boolean(value):defaultValue;break;default:value=type(value);}map[key]=value;return map;},{});};var getElementTop=function getElementTop(el){return el.getBoundingClientRect().top;};var main_handleScroll=function handleScroll(cb){var _scope=this[scope],el=_scope.el,vm=_scope.vm,container=_scope.container,observer=_scope.observer;var _getScrollOptions=main_getScrollOptions(el,vm),distance=_getScrollOptions.distance,disabled=_getScrollOptions.disabled;if(disabled)return;var containerInfo=container.getBoundingClientRect();if(!containerInfo.width&&!containerInfo.height)return;var shouldTrigger=false;if(container===el){// be aware of difference between clientHeight & offsetHeight & window.getComputedStyle().height
var scrollBottom=container.scrollTop+getClientHeight(container);shouldTrigger=container.scrollHeight-scrollBottom<=distance;}else{var heightBelowTop=getOffsetHeight(el)+getElementTop(el)-getElementTop(container);var offsetHeight=getOffsetHeight(container);var borderBottom=Number.parseFloat(getStyleComputedProperty(container,'borderBottomWidth'));shouldTrigger=heightBelowTop-offsetHeight+borderBottom<=distance;}if(shouldTrigger&&Object(types_["isFunction"])(cb)){cb.call(vm);}else if(observer){observer.disconnect();this[scope].observer=null;}};/* harmony default export */var infinite_scroll_src_main={name:'InfiniteScroll',inserted:function inserted(el,binding,vnode){var cb=binding.value;var vm=vnode.context;// only include vertical scroll
var container=Object(dom_["getScrollContainer"])(el,true);var _getScrollOptions2=main_getScrollOptions(el,vm),delay=_getScrollOptions2.delay,immediate=_getScrollOptions2.immediate;var onScroll=debounce_default()(delay,main_handleScroll.bind(el,cb));el[scope]={el:el,vm:vm,container:container,onScroll:onScroll};if(container){container.addEventListener('scroll',onScroll);if(immediate){var observer=el[scope].observer=new MutationObserver(onScroll);observer.observe(container,{childList:true,subtree:true});onScroll();}}},unbind:function unbind(el){var _el$scope=el[scope],container=_el$scope.container,onScroll=_el$scope.onScroll;if(container){container.removeEventListener('scroll',onScroll);}}};// CONCATENATED MODULE: ./packages/infinite-scroll/index.js
/* istanbul ignore next */infinite_scroll_src_main.install=function(Vue){Vue.directive(infinite_scroll_src_main.name,infinite_scroll_src_main);};/* harmony default export */var infinite_scroll=infinite_scroll_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
var mainvue_type_template_id_5070954c_render=function mainvue_type_template_id_5070954c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-page-header"},[_c("div",{staticClass:"el-page-header__left",on:{click:function click($event){_vm.$emit("back");}}},[_c("i",{staticClass:"el-icon-back"}),_c("div",{staticClass:"el-page-header__title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2)]),_c("div",{staticClass:"el-page-header__content"},[_vm._t("content",[_vm._v(_vm._s(_vm.content))])],2)]);};var mainvue_type_template_id_5070954c_staticRenderFns=[];mainvue_type_template_id_5070954c_render._withStripped=true;// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=template&id=5070954c&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/page-header/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var page_header_src_mainvue_type_script_lang_js_={name:'ElPageHeader',props:{title:{type:String,default:function _default(){return Object(lib_locale_["t"])('el.pageHeader.title');}},content:String}};// CONCATENATED MODULE: ./packages/page-header/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_page_header_src_mainvue_type_script_lang_js_=page_header_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/page-header/src/main.vue
/* normalize component */var page_header_src_main_component=normalizeComponent(packages_page_header_src_mainvue_type_script_lang_js_,mainvue_type_template_id_5070954c_render,mainvue_type_template_id_5070954c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var page_header_src_main_api;}page_header_src_main_component.options.__file="packages/page-header/src/main.vue";/* harmony default export */var page_header_src_main=page_header_src_main_component.exports;// CONCATENATED MODULE: ./packages/page-header/index.js
/* istanbul ignore next */page_header_src_main.install=function(Vue){Vue.component(page_header_src_main.name,page_header_src_main);};/* harmony default export */var page_header=page_header_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
var cascader_panelvue_type_template_id_34932346_render=function cascader_panelvue_type_template_id_34932346_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-cascader-panel",_vm.border&&"is-bordered"],on:{keydown:_vm.handleKeyDown}},_vm._l(_vm.menus,function(menu,index){return _c("cascader-menu",{key:index,ref:"menu",refInFor:true,attrs:{index:index,nodes:menu}});}),1);};var cascader_panelvue_type_template_id_34932346_staticRenderFns=[];cascader_panelvue_type_template_id_34932346_render._withStripped=true;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
// EXTERNAL MODULE: external "element-ui/lib/radio"
var radio_=__webpack_require__(43);var radio_default=/*#__PURE__*/__webpack_require__.n(radio_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
var stopPropagation=function stopPropagation(e){return e.stopPropagation();};/* harmony default export */var cascader_nodevue_type_script_lang_js_={inject:['panel'],components:{ElCheckbox:checkbox_default.a,ElRadio:radio_default.a},props:{node:{required:true},nodeId:String},computed:{config:function config(){return this.panel.config;},isLeaf:function isLeaf(){return this.node.isLeaf;},isDisabled:function isDisabled(){return this.node.isDisabled;},checkedValue:function checkedValue(){return this.panel.checkedValue;},isChecked:function isChecked(){return this.node.isSameNode(this.checkedValue);},inActivePath:function inActivePath(){return this.isInPath(this.panel.activePath);},inCheckedPath:function inCheckedPath(){var _this=this;if(!this.config.checkStrictly)return false;return this.panel.checkedNodePaths.some(function(checkedPath){return _this.isInPath(checkedPath);});},value:function value(){return this.node.getValueByOption();}},methods:{handleExpand:function handleExpand(){var _this2=this;var panel=this.panel,node=this.node,isDisabled=this.isDisabled,config=this.config;var multiple=config.multiple,checkStrictly=config.checkStrictly;if(!checkStrictly&&isDisabled||node.loading)return;if(config.lazy&&!node.loaded){panel.lazyLoad(node,function(){// do not use cached leaf value here, invoke this.isLeaf to get new value.
var isLeaf=_this2.isLeaf;if(!isLeaf)_this2.handleExpand();if(multiple){// if leaf sync checked state, else clear checked state
var checked=isLeaf?node.checked:false;_this2.handleMultiCheckChange(checked);}});}else{panel.handleExpand(node);}},handleCheckChange:function handleCheckChange(){var panel=this.panel,value=this.value,node=this.node;panel.handleCheckChange(value);panel.handleExpand(node);},handleMultiCheckChange:function handleMultiCheckChange(checked){this.node.doCheck(checked);this.panel.calculateMultiCheckedValue();},isInPath:function isInPath(pathNodes){var node=this.node;var selectedPathNode=pathNodes[node.level-1]||{};return selectedPathNode.uid===node.uid;},renderPrefix:function renderPrefix(h){var isLeaf=this.isLeaf,isChecked=this.isChecked,config=this.config;var checkStrictly=config.checkStrictly,multiple=config.multiple;if(multiple){return this.renderCheckbox(h);}else if(checkStrictly){return this.renderRadio(h);}else if(isLeaf&&isChecked){return this.renderCheckIcon(h);}return null;},renderPostfix:function renderPostfix(h){var node=this.node,isLeaf=this.isLeaf;if(node.loading){return this.renderLoadingIcon(h);}else if(!isLeaf){return this.renderExpandIcon(h);}return null;},renderCheckbox:function renderCheckbox(h){var node=this.node,config=this.config,isDisabled=this.isDisabled;var events={on:{change:this.handleMultiCheckChange},nativeOn:{}};if(config.checkStrictly){// when every node is selectable, click event should not trigger expand event.
events.nativeOn.click=stopPropagation;}return h('el-checkbox',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{value:node.checked,indeterminate:node.indeterminate,disabled:isDisabled}},events]));},renderRadio:function renderRadio(h){var checkedValue=this.checkedValue,value=this.value,isDisabled=this.isDisabled;// to keep same reference if value cause radio's checked state is calculated by reference comparision;
if(Object(util_["isEqual"])(value,checkedValue)){value=checkedValue;}return h('el-radio',{attrs:{value:checkedValue,label:value,disabled:isDisabled},on:{'change':this.handleCheckChange},nativeOn:{'click':stopPropagation}},[h('span')]);},renderCheckIcon:function renderCheckIcon(h){return h('i',{'class':'el-icon-check el-cascader-node__prefix'});},renderLoadingIcon:function renderLoadingIcon(h){return h('i',{'class':'el-icon-loading el-cascader-node__postfix'});},renderExpandIcon:function renderExpandIcon(h){return h('i',{'class':'el-icon-arrow-right el-cascader-node__postfix'});},renderContent:function renderContent(h){var panel=this.panel,node=this.node;var render=panel.renderLabelFn;var vnode=render?render({node:node,data:node.data}):null;return h('span',{'class':'el-cascader-node__label'},[vnode||node.label]);}},render:function render(h){var _this3=this;var inActivePath=this.inActivePath,inCheckedPath=this.inCheckedPath,isChecked=this.isChecked,isLeaf=this.isLeaf,isDisabled=this.isDisabled,config=this.config,nodeId=this.nodeId;var expandTrigger=config.expandTrigger,checkStrictly=config.checkStrictly,multiple=config.multiple;var disabled=!checkStrictly&&isDisabled;var events={on:{}};if(expandTrigger==='click'){events.on.click=this.handleExpand;}else{events.on.mouseenter=function(e){_this3.handleExpand();_this3.$emit('expand',e);};events.on.focus=function(e){_this3.handleExpand();_this3.$emit('expand',e);};}if(isLeaf&&!isDisabled&&!checkStrictly&&!multiple){events.on.click=this.handleCheckChange;}return h('li',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{role:'menuitem',id:nodeId,'aria-expanded':inActivePath,tabindex:disabled?null:-1},'class':{'el-cascader-node':true,'is-selectable':checkStrictly,'in-active-path':inActivePath,'in-checked-path':inCheckedPath,'is-active':isChecked,'is-disabled':disabled}},events]),[this.renderPrefix(h),this.renderContent(h),this.renderPostfix(h)]);}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_nodevue_type_script_lang_js_=cascader_nodevue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
var cascader_node_render,cascader_node_staticRenderFns;/* normalize component */var cascader_node_component=normalizeComponent(src_cascader_nodevue_type_script_lang_js_,cascader_node_render,cascader_node_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_node_api;}cascader_node_component.options.__file="packages/cascader-panel/src/cascader-node.vue";/* harmony default export */var cascader_node=cascader_node_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
/* harmony default export */var cascader_menuvue_type_script_lang_js_={name:'ElCascaderMenu',mixins:[locale_default.a],inject:['panel'],components:{ElScrollbar:scrollbar_default.a,CascaderNode:cascader_node},props:{nodes:{type:Array,required:true},index:Number},data:function data(){return{activeNode:null,hoverTimer:null,id:Object(util_["generateId"])()};},computed:{isEmpty:function isEmpty(){return!this.nodes.length;},menuId:function menuId(){return'cascader-menu-'+this.id+'-'+this.index;}},methods:{handleExpand:function handleExpand(e){this.activeNode=e.target;},handleMouseMove:function handleMouseMove(e){var activeNode=this.activeNode,hoverTimer=this.hoverTimer;var hoverZone=this.$refs.hoverZone;if(!activeNode||!hoverZone)return;if(activeNode.contains(e.target)){clearTimeout(hoverTimer);var _$el$getBoundingClien=this.$el.getBoundingClientRect(),left=_$el$getBoundingClien.left;var startX=e.clientX-left;var _$el=this.$el,offsetWidth=_$el.offsetWidth,offsetHeight=_$el.offsetHeight;var top=activeNode.offsetTop;var bottom=top+activeNode.offsetHeight;hoverZone.innerHTML='\n          <path style="pointer-events: auto;" fill="transparent" d="M'+startX+' '+top+' L'+offsetWidth+' 0 V'+top+' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M'+startX+' '+bottom+' L'+offsetWidth+' '+offsetHeight+' V'+bottom+' Z" />\n        ';}else if(!hoverTimer){this.hoverTimer=setTimeout(this.clearHoverZone,this.panel.config.hoverThreshold);}},clearHoverZone:function clearHoverZone(){var hoverZone=this.$refs.hoverZone;if(!hoverZone)return;hoverZone.innerHTML='';},renderEmptyText:function renderEmptyText(h){return h('div',{'class':'el-cascader-menu__empty-text'},[this.t('el.cascader.noData')]);},renderNodeList:function renderNodeList(h){var menuId=this.menuId;var isHoverMenu=this.panel.isHoverMenu;var events={on:{}};if(isHoverMenu){events.on.expand=this.handleExpand;}var nodes=this.nodes.map(function(node,index){var hasChildren=node.hasChildren;return h('cascader-node',external_babel_helper_vue_jsx_merge_props_default()([{key:node.uid,attrs:{node:node,'node-id':menuId+'-'+index,'aria-haspopup':hasChildren,'aria-owns':hasChildren?menuId:null}},events]));});return[].concat(nodes,[isHoverMenu?h('svg',{ref:'hoverZone','class':'el-cascader-menu__hover-zone'}):null]);}},render:function render(h){var isEmpty=this.isEmpty,menuId=this.menuId;var events={nativeOn:{}};// optimize hover to expand experience (#8010)
if(this.panel.isHoverMenu){events.nativeOn.mousemove=this.handleMouseMove;// events.nativeOn.mouseleave = this.clearHoverZone;
}return h('el-scrollbar',external_babel_helper_vue_jsx_merge_props_default()([{attrs:{tag:'ul',role:'menu',id:menuId,'wrap-class':'el-cascader-menu__wrap','view-class':{'el-cascader-menu__list':true,'is-empty':isEmpty}},'class':'el-cascader-menu'},events]),[isEmpty?this.renderEmptyText(h):this.renderNodeList(h)]);}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_menuvue_type_script_lang_js_=cascader_menuvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
var cascader_menu_render,cascader_menu_staticRenderFns;/* normalize component */var cascader_menu_component=normalizeComponent(src_cascader_menuvue_type_script_lang_js_,cascader_menu_render,cascader_menu_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_menu_api;}cascader_menu_component.options.__file="packages/cascader-panel/src/cascader-menu.vue";/* harmony default export */var cascader_menu=cascader_menu_component.exports;// CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
var node_createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function src_node_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var uid=0;var src_node_Node=function(){function Node(data,config,parentNode){src_node_classCallCheck(this,Node);this.data=data;this.config=config;this.parent=parentNode||null;this.level=!this.parent?1:this.parent.level+1;this.uid=uid++;this.initState();this.initChildren();}Node.prototype.initState=function initState(){var _config=this.config,valueKey=_config.value,labelKey=_config.label;this.value=this.data[valueKey];this.label=this.data[labelKey];this.pathNodes=this.calculatePathNodes();this.path=this.pathNodes.map(function(node){return node.value;});this.pathLabels=this.pathNodes.map(function(node){return node.label;});// lazy load
this.loading=false;this.loaded=false;};Node.prototype.initChildren=function initChildren(){var _this=this;var config=this.config;var childrenKey=config.children;var childrenData=this.data[childrenKey];this.hasChildren=Array.isArray(childrenData);this.children=(childrenData||[]).map(function(child){return new Node(child,config,_this);});};Node.prototype.calculatePathNodes=function calculatePathNodes(){var nodes=[this];var parent=this.parent;while(parent){nodes.unshift(parent);parent=parent.parent;}return nodes;};Node.prototype.getPath=function getPath(){return this.path;};Node.prototype.getValue=function getValue(){return this.value;};Node.prototype.getValueByOption=function getValueByOption(){return this.config.emitPath?this.getPath():this.getValue();};Node.prototype.getText=function getText(allLevels,separator){return allLevels?this.pathLabels.join(separator):this.label;};Node.prototype.isSameNode=function isSameNode(checkedValue){var value=this.getValueByOption();return this.config.multiple&&Array.isArray(checkedValue)?checkedValue.some(function(val){return Object(util_["isEqual"])(val,value);}):Object(util_["isEqual"])(checkedValue,value);};Node.prototype.broadcast=function broadcast(event){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}var handlerName='onParent'+Object(util_["capitalize"])(event);this.children.forEach(function(child){if(child){// bottom up
child.broadcast.apply(child,[event].concat(args));child[handlerName]&&child[handlerName].apply(child,args);}});};Node.prototype.emit=function emit(event){var parent=this.parent;var handlerName='onChild'+Object(util_["capitalize"])(event);if(parent){for(var _len2=arguments.length,args=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){args[_key2-1]=arguments[_key2];}parent[handlerName]&&parent[handlerName].apply(parent,args);parent.emit.apply(parent,[event].concat(args));}};Node.prototype.onParentCheck=function onParentCheck(checked){if(!this.isDisabled){this.setCheckState(checked);}};Node.prototype.onChildCheck=function onChildCheck(){var children=this.children;var validChildren=children.filter(function(child){return!child.isDisabled;});var checked=validChildren.length?validChildren.every(function(child){return child.checked;}):false;this.setCheckState(checked);};Node.prototype.setCheckState=function setCheckState(checked){var totalNum=this.children.length;var checkedNum=this.children.reduce(function(c,p){var num=p.checked?1:p.indeterminate?0.5:0;return c+num;},0);this.checked=checked;this.indeterminate=checkedNum!==totalNum&&checkedNum>0;};Node.prototype.syncCheckState=function syncCheckState(checkedValue){var value=this.getValueByOption();var checked=this.isSameNode(checkedValue,value);this.doCheck(checked);};Node.prototype.doCheck=function doCheck(checked){if(this.checked!==checked){if(this.config.checkStrictly){this.checked=checked;}else{// bottom up to unify the calculation of the indeterminate state
this.broadcast('check',checked);this.setCheckState(checked);this.emit('check');}}};node_createClass(Node,[{key:'isDisabled',get:function get(){var data=this.data,parent=this.parent,config=this.config;var disabledKey=config.disabled;var checkStrictly=config.checkStrictly;return data[disabledKey]||!checkStrictly&&parent&&parent.isDisabled;}},{key:'isLeaf',get:function get(){var data=this.data,loaded=this.loaded,hasChildren=this.hasChildren,children=this.children;var _config2=this.config,lazy=_config2.lazy,leafKey=_config2.leaf;if(lazy){var isLeaf=Object(shared_["isDef"])(data[leafKey])?data[leafKey]:loaded?!children.length:false;this.hasChildren=!isLeaf;return isLeaf;}return!hasChildren;}}]);return Node;}();/* harmony default export */var src_node=src_node_Node;// CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
function store_classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var flatNodes=function flatNodes(data,leafOnly){return data.reduce(function(res,node){if(node.isLeaf){res.push(node);}else{!leafOnly&&res.push(node);res=res.concat(flatNodes(node.children,leafOnly));}return res;},[]);};var store_Store=function(){function Store(data,config){store_classCallCheck(this,Store);this.config=config;this.initNodes(data);}Store.prototype.initNodes=function initNodes(data){var _this=this;data=Object(util_["coerceTruthyValueToArray"])(data);this.nodes=data.map(function(nodeData){return new src_node(nodeData,_this.config);});this.flattedNodes=this.getFlattedNodes(false,false);this.leafNodes=this.getFlattedNodes(true,false);};Store.prototype.appendNode=function appendNode(nodeData,parentNode){var node=new src_node(nodeData,this.config,parentNode);var children=parentNode?parentNode.children:this.nodes;children.push(node);};Store.prototype.appendNodes=function appendNodes(nodeDataList,parentNode){var _this2=this;nodeDataList=Object(util_["coerceTruthyValueToArray"])(nodeDataList);nodeDataList.forEach(function(nodeData){return _this2.appendNode(nodeData,parentNode);});};Store.prototype.getNodes=function getNodes(){return this.nodes;};Store.prototype.getFlattedNodes=function getFlattedNodes(leafOnly){var cached=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var cachedNodes=leafOnly?this.leafNodes:this.flattedNodes;return cached?cachedNodes:flatNodes(this.nodes,leafOnly);};Store.prototype.getNodeByValue=function getNodeByValue(value){var nodes=this.getFlattedNodes(false,!this.config.lazy).filter(function(node){return Object(util_["valueEquals"])(node.path,value)||node.value===value;});return nodes&&nodes.length?nodes[0]:null;};return Store;}();/* harmony default export */var cascader_panel_src_store=store_Store;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
var cascader_panelvue_type_script_lang_js_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var cascader_panelvue_type_script_lang_js_KeyCode=aria_utils_default.a.keys;var DefaultProps={expandTrigger:'click',// or hover
multiple:false,checkStrictly:false,// whether all nodes can be selected
emitPath:true,// wether to emit an array of all levels value in which node is located
lazy:false,lazyLoad:util_["noop"],value:'value',label:'label',children:'children',leaf:'leaf',disabled:'disabled',hoverThreshold:500};var cascader_panelvue_type_script_lang_js_isLeaf=function isLeaf(el){return!el.getAttribute('aria-owns');};var getSibling=function getSibling(el,distance){var parentNode=el.parentNode;if(parentNode){var siblings=parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');var index=Array.prototype.indexOf.call(siblings,el);return siblings[index+distance]||null;}return null;};var getMenuIndex=function getMenuIndex(el,distance){if(!el)return;var pieces=el.id.split('-');return Number(pieces[pieces.length-2]);};var focusNode=function focusNode(el){if(!el)return;el.focus();!cascader_panelvue_type_script_lang_js_isLeaf(el)&&el.click();};var checkNode=function checkNode(el){if(!el)return;var input=el.querySelector('input');if(input){input.click();}else if(cascader_panelvue_type_script_lang_js_isLeaf(el)){el.click();}};/* harmony default export */var cascader_panelvue_type_script_lang_js_={name:'ElCascaderPanel',components:{CascaderMenu:cascader_menu},props:{value:{},options:Array,props:Object,border:{type:Boolean,default:true},renderLabel:Function},provide:function provide(){return{panel:this};},data:function data(){return{checkedValue:null,checkedNodePaths:[],store:[],menus:[],activePath:[],loadCount:0};},computed:{config:function config(){return merge_default()(cascader_panelvue_type_script_lang_js_extends({},DefaultProps),this.props||{});},multiple:function multiple(){return this.config.multiple;},checkStrictly:function checkStrictly(){return this.config.checkStrictly;},leafOnly:function leafOnly(){return!this.checkStrictly;},isHoverMenu:function isHoverMenu(){return this.config.expandTrigger==='hover';},renderLabelFn:function renderLabelFn(){return this.renderLabel||this.$scopedSlots.default;}},watch:{value:function value(){this.syncCheckedValue();this.checkStrictly&&this.calculateCheckedNodePaths();},options:{handler:function handler(){this.initStore();},immediate:true,deep:true},checkedValue:function checkedValue(val){if(!Object(util_["isEqual"])(val,this.value)){this.checkStrictly&&this.calculateCheckedNodePaths();this.$emit('input',val);this.$emit('change',val);}}},mounted:function mounted(){if(!this.isEmptyValue(this.value)){this.syncCheckedValue();}},methods:{initStore:function initStore(){var config=this.config,options=this.options;if(config.lazy&&Object(util_["isEmpty"])(options)){this.lazyLoad();}else{this.store=new cascader_panel_src_store(options,config);this.menus=[this.store.getNodes()];this.syncMenuState();}},syncCheckedValue:function syncCheckedValue(){var value=this.value,checkedValue=this.checkedValue;if(!Object(util_["isEqual"])(value,checkedValue)){this.activePath=[];this.checkedValue=value;this.syncMenuState();}},syncMenuState:function syncMenuState(){var multiple=this.multiple,checkStrictly=this.checkStrictly;this.syncActivePath();multiple&&this.syncMultiCheckState();checkStrictly&&this.calculateCheckedNodePaths();this.$nextTick(this.scrollIntoView);},syncMultiCheckState:function syncMultiCheckState(){var _this=this;var nodes=this.getFlattedNodes(this.leafOnly);nodes.forEach(function(node){node.syncCheckState(_this.checkedValue);});},isEmptyValue:function isEmptyValue(val){var multiple=this.multiple,config=this.config;var emitPath=config.emitPath;if(multiple||emitPath){return Object(util_["isEmpty"])(val);}return false;},syncActivePath:function syncActivePath(){var _this2=this;var store=this.store,multiple=this.multiple,activePath=this.activePath,checkedValue=this.checkedValue;if(!Object(util_["isEmpty"])(activePath)){var nodes=activePath.map(function(node){return _this2.getNodeByValue(node.getValue());});this.expandNodes(nodes);}else if(!this.isEmptyValue(checkedValue)){var value=multiple?checkedValue[0]:checkedValue;var checkedNode=this.getNodeByValue(value)||{};var _nodes=(checkedNode.pathNodes||[]).slice(0,-1);this.expandNodes(_nodes);}else{this.activePath=[];this.menus=[store.getNodes()];}},expandNodes:function expandNodes(nodes){var _this3=this;nodes.forEach(function(node){return _this3.handleExpand(node,true/* silent */);});},calculateCheckedNodePaths:function calculateCheckedNodePaths(){var _this4=this;var checkedValue=this.checkedValue,multiple=this.multiple;var checkedValues=multiple?Object(util_["coerceTruthyValueToArray"])(checkedValue):[checkedValue];this.checkedNodePaths=checkedValues.map(function(v){var checkedNode=_this4.getNodeByValue(v);return checkedNode?checkedNode.pathNodes:[];});},handleKeyDown:function handleKeyDown(e){var target=e.target,keyCode=e.keyCode;switch(keyCode){case cascader_panelvue_type_script_lang_js_KeyCode.up:var prev=getSibling(target,-1);focusNode(prev);break;case cascader_panelvue_type_script_lang_js_KeyCode.down:var next=getSibling(target,1);focusNode(next);break;case cascader_panelvue_type_script_lang_js_KeyCode.left:var preMenu=this.$refs.menu[getMenuIndex(target)-1];if(preMenu){var expandedNode=preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');focusNode(expandedNode);}break;case cascader_panelvue_type_script_lang_js_KeyCode.right:var nextMenu=this.$refs.menu[getMenuIndex(target)+1];if(nextMenu){var firstNode=nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');focusNode(firstNode);}break;case cascader_panelvue_type_script_lang_js_KeyCode.enter:checkNode(target);break;case cascader_panelvue_type_script_lang_js_KeyCode.esc:case cascader_panelvue_type_script_lang_js_KeyCode.tab:this.$emit('close');break;default:return;}},handleExpand:function handleExpand(node,silent){var activePath=this.activePath;var level=node.level;var path=activePath.slice(0,level-1);var menus=this.menus.slice(0,level);if(!node.isLeaf){path.push(node);menus.push(node.children);}this.activePath=path;this.menus=menus;if(!silent){var pathValues=path.map(function(node){return node.getValue();});var activePathValues=activePath.map(function(node){return node.getValue();});if(!Object(util_["valueEquals"])(pathValues,activePathValues)){this.$emit('active-item-change',pathValues);// Deprecated
this.$emit('expand-change',pathValues);}}},handleCheckChange:function handleCheckChange(value){this.checkedValue=value;},lazyLoad:function lazyLoad(node,onFullfiled){var _this5=this;var config=this.config;if(!node){node=node||{root:true,level:0};this.store=new cascader_panel_src_store([],config);this.menus=[this.store.getNodes()];}node.loading=true;var resolve=function resolve(dataList){var parent=node.root?null:node;dataList&&dataList.length&&_this5.store.appendNodes(dataList,parent);node.loading=false;node.loaded=true;// dispose default value on lazy load mode
if(Array.isArray(_this5.checkedValue)){var nodeValue=_this5.checkedValue[_this5.loadCount++];var valueKey=_this5.config.value;var leafKey=_this5.config.leaf;if(Array.isArray(dataList)&&dataList.filter(function(item){return item[valueKey]===nodeValue;}).length>0){var checkedNode=_this5.store.getNodeByValue(nodeValue);if(!checkedNode.data[leafKey]){_this5.lazyLoad(checkedNode,function(){_this5.handleExpand(checkedNode);});}if(_this5.loadCount===_this5.checkedValue.length){_this5.$parent.computePresentText();}}}onFullfiled&&onFullfiled(dataList);};config.lazyLoad(node,resolve);},/**
     * public methods
    */calculateMultiCheckedValue:function calculateMultiCheckedValue(){this.checkedValue=this.getCheckedNodes(this.leafOnly).map(function(node){return node.getValueByOption();});},scrollIntoView:function scrollIntoView(){if(this.$isServer)return;var menus=this.$refs.menu||[];menus.forEach(function(menu){var menuElement=menu.$el;if(menuElement){var container=menuElement.querySelector('.el-scrollbar__wrap');var activeNode=menuElement.querySelector('.el-cascader-node.is-active')||menuElement.querySelector('.el-cascader-node.in-active-path');scroll_into_view_default()(container,activeNode);}});},getNodeByValue:function getNodeByValue(val){return this.store.getNodeByValue(val);},getFlattedNodes:function getFlattedNodes(leafOnly){var cached=!this.config.lazy;return this.store.getFlattedNodes(leafOnly,cached);},getCheckedNodes:function getCheckedNodes(leafOnly){var checkedValue=this.checkedValue,multiple=this.multiple;if(multiple){var nodes=this.getFlattedNodes(leafOnly);return nodes.filter(function(node){return node.checked;});}else{return this.isEmptyValue(checkedValue)?[]:[this.getNodeByValue(checkedValue)];}},clearCheckedNodes:function clearCheckedNodes(){var config=this.config,leafOnly=this.leafOnly;var multiple=config.multiple,emitPath=config.emitPath;if(multiple){this.getCheckedNodes(leafOnly).filter(function(node){return!node.isDisabled;}).forEach(function(node){return node.doCheck(false);});this.calculateMultiCheckedValue();}else{this.checkedValue=emitPath?[]:null;}}}};// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
/* harmony default export */var src_cascader_panelvue_type_script_lang_js_=cascader_panelvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue
/* normalize component */var cascader_panel_component=normalizeComponent(src_cascader_panelvue_type_script_lang_js_,cascader_panelvue_type_template_id_34932346_render,cascader_panelvue_type_template_id_34932346_staticRenderFns,false,null,null,null);/* hot reload */if(false){var cascader_panel_api;}cascader_panel_component.options.__file="packages/cascader-panel/src/cascader-panel.vue";/* harmony default export */var cascader_panel=cascader_panel_component.exports;// CONCATENATED MODULE: ./packages/cascader-panel/index.js
/* istanbul ignore next */cascader_panel.install=function(Vue){Vue.component(cascader_panel.name,cascader_panel);};/* harmony default export */var packages_cascader_panel=cascader_panel;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/avatar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var avatar_src_mainvue_type_script_lang_js_={name:'ElAvatar',props:{size:{type:[Number,String],validator:function validator(val){if(typeof val==='string'){return['large','medium','small'].includes(val);}return typeof val==='number';}},shape:{type:String,default:'circle',validator:function validator(val){return['circle','square'].includes(val);}},icon:String,src:String,alt:String,srcSet:String,error:Function,fit:{type:String,default:'cover'}},data:function data(){return{isImageExist:true};},computed:{avatarClass:function avatarClass(){var size=this.size,icon=this.icon,shape=this.shape;var classList=['el-avatar'];if(size&&typeof size==='string'){classList.push('el-avatar--'+size);}if(icon){classList.push('el-avatar--icon');}if(shape){classList.push('el-avatar--'+shape);}return classList.join(' ');}},methods:{handleError:function handleError(){var error=this.error;var errorFlag=error?error():undefined;if(errorFlag!==false){this.isImageExist=false;}},renderAvatar:function renderAvatar(){var h=this.$createElement;var icon=this.icon,src=this.src,alt=this.alt,isImageExist=this.isImageExist,srcSet=this.srcSet,fit=this.fit;if(isImageExist&&src){return h('img',{attrs:{src:src,alt:alt,srcSet:srcSet},on:{'error':this.handleError},style:{'object-fit':fit}});}if(icon){return h('i',{'class':icon});}return this.$slots.default;}},render:function render(){var h=arguments[0];var avatarClass=this.avatarClass,size=this.size;var sizeStyle=typeof size==='number'?{height:size+'px',width:size+'px',lineHeight:size+'px'}:{};return h('span',{'class':avatarClass,style:sizeStyle},[this.renderAvatar()]);}};// CONCATENATED MODULE: ./packages/avatar/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_avatar_src_mainvue_type_script_lang_js_=avatar_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/avatar/src/main.vue
var src_main_render,src_main_staticRenderFns;/* normalize component */var avatar_src_main_component=normalizeComponent(packages_avatar_src_mainvue_type_script_lang_js_,src_main_render,src_main_staticRenderFns,false,null,null,null);/* hot reload */if(false){var avatar_src_main_api;}avatar_src_main_component.options.__file="packages/avatar/src/main.vue";/* harmony default export */var avatar_src_main=avatar_src_main_component.exports;// CONCATENATED MODULE: ./packages/avatar/index.js
/* istanbul ignore next */avatar_src_main.install=function(Vue){Vue.component(avatar_src_main.name,avatar_src_main);};/* harmony default export */var avatar=avatar_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
var mainvue_type_template_id_a4885264_render=function mainvue_type_template_id_a4885264_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("transition",{attrs:{name:"el-drawer-fade"},on:{"after-enter":_vm.afterEnter,"after-leave":_vm.afterLeave}},[_c("div",{directives:[{name:"show",rawName:"v-show",value:_vm.visible,expression:"visible"}],staticClass:"el-drawer__wrapper",attrs:{tabindex:"-1"}},[_c("div",{staticClass:"el-drawer__container",class:_vm.visible&&"el-drawer__open",attrs:{role:"document",tabindex:"-1"},on:{click:function click($event){if($event.target!==$event.currentTarget){return null;}return _vm.handleWrapperClick($event);}}},[_c("div",{ref:"drawer",staticClass:"el-drawer",class:[_vm.direction,_vm.customClass],style:_vm.isHorizontal?"width: "+_vm.drawerSize:"height: "+_vm.drawerSize,attrs:{"aria-modal":"true","aria-labelledby":"el-drawer__title","aria-label":_vm.title,role:"dialog",tabindex:"-1"}},[_vm.withHeader?_c("header",{staticClass:"el-drawer__header",attrs:{id:"el-drawer__title"}},[_vm._t("title",[_c("span",{attrs:{role:"heading",title:_vm.title}},[_vm._v(_vm._s(_vm.title))])]),_vm.showClose?_c("button",{staticClass:"el-drawer__close-btn",attrs:{"aria-label":"close "+(_vm.title||"drawer"),type:"button"},on:{click:_vm.closeDrawer}},[_c("i",{staticClass:"el-dialog__close el-icon el-icon-close"})]):_vm._e()],2):_vm._e(),_vm.rendered?_c("section",{staticClass:"el-drawer__body"},[_vm._t("default")],2):_vm._e()])])])]);};var mainvue_type_template_id_a4885264_staticRenderFns=[];mainvue_type_template_id_a4885264_render._withStripped=true;// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=template&id=a4885264&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/drawer/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var drawer_src_mainvue_type_script_lang_js_={name:'ElDrawer',mixins:[popup_default.a,emitter_default.a],props:{appendToBody:{type:Boolean,default:false},beforeClose:{type:Function},customClass:{type:String,default:''},closeOnPressEscape:{type:Boolean,default:true},destroyOnClose:{type:Boolean,default:false},modal:{type:Boolean,default:true},direction:{type:String,default:'rtl',validator:function validator(val){return['ltr','rtl','ttb','btt'].indexOf(val)!==-1;}},modalAppendToBody:{type:Boolean,default:true},showClose:{type:Boolean,default:true},size:{type:[Number,String],default:'30%'},title:{type:String,default:''},visible:{type:Boolean},wrapperClosable:{type:Boolean,default:true},withHeader:{type:Boolean,default:true}},computed:{isHorizontal:function isHorizontal(){return this.direction==='rtl'||this.direction==='ltr';},drawerSize:function drawerSize(){return typeof this.size==='number'?this.size+'px':this.size;}},data:function data(){return{closed:false,prevActiveElement:null};},watch:{visible:function visible(val){var _this=this;if(val){this.closed=false;this.$emit('open');if(this.appendToBody){document.body.appendChild(this.$el);}this.prevActiveElement=document.activeElement;}else{if(!this.closed){this.$emit('close');if(this.destroyOnClose===true){this.rendered=false;}}this.$nextTick(function(){if(_this.prevActiveElement){_this.prevActiveElement.focus();}});}}},methods:{afterEnter:function afterEnter(){this.$emit('opened');},afterLeave:function afterLeave(){this.$emit('closed');},hide:function hide(cancel){if(cancel!==false){this.$emit('update:visible',false);this.$emit('close');if(this.destroyOnClose===true){this.rendered=false;}this.closed=true;}},handleWrapperClick:function handleWrapperClick(){if(this.wrapperClosable){this.closeDrawer();}},closeDrawer:function closeDrawer(){if(typeof this.beforeClose==='function'){this.beforeClose(this.hide);}else{this.hide();}},handleClose:function handleClose(){// This method here will be called by PopupManger, when the `closeOnPressEscape` was set to true
// pressing `ESC` will call this method, and also close the drawer.
// This method also calls `beforeClose` if there was one.
this.closeDrawer();}},mounted:function mounted(){if(this.visible){this.rendered=true;this.open();if(this.appendToBody){document.body.appendChild(this.$el);}}},destroyed:function destroyed(){// if appendToBody is true, remove DOM node after destroy
if(this.appendToBody&&this.$el&&this.$el.parentNode){this.$el.parentNode.removeChild(this.$el);}}};// CONCATENATED MODULE: ./packages/drawer/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_drawer_src_mainvue_type_script_lang_js_=drawer_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/drawer/src/main.vue
/* normalize component */var drawer_src_main_component=normalizeComponent(packages_drawer_src_mainvue_type_script_lang_js_,mainvue_type_template_id_a4885264_render,mainvue_type_template_id_a4885264_staticRenderFns,false,null,null,null);/* hot reload */if(false){var drawer_src_main_api;}drawer_src_main_component.options.__file="packages/drawer/src/main.vue";/* harmony default export */var drawer_src_main=drawer_src_main_component.exports;// CONCATENATED MODULE: ./packages/drawer/index.js
/* istanbul ignore next */drawer_src_main.install=function(Vue){Vue.component(drawer_src_main.name,drawer_src_main);};/* harmony default export */var drawer=drawer_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
var mainvue_type_template_id_048de730_render=function mainvue_type_template_id_048de730_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("el-popover",_vm._b({attrs:{trigger:"click"},model:{value:_vm.visible,callback:function callback($$v){_vm.visible=$$v;},expression:"visible"}},"el-popover",_vm.$attrs,false),[_c("div",{staticClass:"el-popconfirm"},[_c("p",{staticClass:"el-popconfirm__main"},[!_vm.hideIcon?_c("i",{staticClass:"el-popconfirm__icon",class:_vm.icon,style:{color:_vm.iconColor}}):_vm._e(),_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_c("div",{staticClass:"el-popconfirm__action"},[_c("el-button",{attrs:{size:"mini",type:_vm.cancelButtonType},on:{click:_vm.cancel}},[_vm._v("\n        "+_vm._s(_vm.displayCancelButtonText)+"\n      ")]),_c("el-button",{attrs:{size:"mini",type:_vm.confirmButtonType},on:{click:_vm.confirm}},[_vm._v("\n        "+_vm._s(_vm.displayConfirmButtonText)+"\n      ")])],1)]),_vm._t("reference",null,{slot:"reference"})],2);};var mainvue_type_template_id_048de730_staticRenderFns=[];mainvue_type_template_id_048de730_render._withStripped=true;// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=template&id=048de730&
// EXTERNAL MODULE: external "element-ui/lib/popover"
var popover_=__webpack_require__(44);var popover_default=/*#__PURE__*/__webpack_require__.n(popover_);// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var popconfirm_src_mainvue_type_script_lang_js_={name:'ElPopconfirm',props:{title:{type:String},confirmButtonText:{type:String},cancelButtonText:{type:String},confirmButtonType:{type:String,default:'primary'},cancelButtonType:{type:String,default:'text'},icon:{type:String,default:'el-icon-question'},iconColor:{type:String,default:'#f90'},hideIcon:{type:Boolean,default:false}},components:{ElPopover:popover_default.a,ElButton:button_default.a},data:function data(){return{visible:false};},computed:{displayConfirmButtonText:function displayConfirmButtonText(){return this.confirmButtonText||Object(lib_locale_["t"])('el.popconfirm.confirmButtonText');},displayCancelButtonText:function displayCancelButtonText(){return this.cancelButtonText||Object(lib_locale_["t"])('el.popconfirm.cancelButtonText');}},methods:{confirm:function confirm(){this.visible=false;this.$emit('confirm');},cancel:function cancel(){this.visible=false;this.$emit('cancel');}}};// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue?vue&type=script&lang=js&
/* harmony default export */var packages_popconfirm_src_mainvue_type_script_lang_js_=popconfirm_src_mainvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/popconfirm/src/main.vue
/* normalize component */var popconfirm_src_main_component=normalizeComponent(packages_popconfirm_src_mainvue_type_script_lang_js_,mainvue_type_template_id_048de730_render,mainvue_type_template_id_048de730_staticRenderFns,false,null,null,null);/* hot reload */if(false){var popconfirm_src_main_api;}popconfirm_src_main_component.options.__file="packages/popconfirm/src/main.vue";/* harmony default export */var popconfirm_src_main=popconfirm_src_main_component.exports;// CONCATENATED MODULE: ./packages/popconfirm/index.js
/* istanbul ignore next */popconfirm_src_main.install=function(Vue){Vue.component(popconfirm_src_main.name,popconfirm_src_main);};/* harmony default export */var popconfirm=popconfirm_src_main;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/index.vue?vue&type=template&id=7f659269&
var srcvue_type_template_id_7f659269_render=function srcvue_type_template_id_7f659269_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",[_vm.uiLoading?[_c("div",_vm._b({class:["el-skeleton",_vm.animated?"is-animated":""]},"div",_vm.$attrs,false),[_vm._l(_vm.count,function(i){return[_vm.loading?_vm._t("template",_vm._l(_vm.rows,function(item){return _c("el-skeleton-item",{key:i+"-"+item,class:{"el-skeleton__paragraph":item!==1,"is-first":item===1,"is-last":item===_vm.rows&&_vm.rows>1},attrs:{variant:"p"}});})):_vm._e()];})],2)]:[_vm._t("default",null,null,_vm.$attrs)]],2);};var srcvue_type_template_id_7f659269_staticRenderFns=[];srcvue_type_template_id_7f659269_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/index.vue?vue&type=template&id=7f659269&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/index.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var skeleton_srcvue_type_script_lang_js_={name:'ElSkeleton',props:{animated:{type:Boolean,default:false},count:{type:Number,default:1},rows:{type:Number,default:4},loading:{type:Boolean,default:true},throttle:{type:Number,default:0}},watch:{loading:{handler:function handler(loading){var _this=this;if(this.throttle<=0){this.uiLoading=loading;return;}if(loading){clearTimeout(this.timeoutHandle);this.timeoutHandle=setTimeout(function(){_this.uiLoading=_this.loading;},this.throttle);}else{this.uiLoading=loading;}},immediate:true}},data:function data(){return{uiLoading:this.throttle<=0?this.loading:false};}};// CONCATENATED MODULE: ./packages/skeleton/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_skeleton_srcvue_type_script_lang_js_=skeleton_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/index.vue
/* normalize component */var skeleton_src_component=normalizeComponent(packages_skeleton_srcvue_type_script_lang_js_,srcvue_type_template_id_7f659269_render,srcvue_type_template_id_7f659269_staticRenderFns,false,null,null,null);/* hot reload */if(false){var skeleton_src_api;}skeleton_src_component.options.__file="packages/skeleton/src/index.vue";/* harmony default export */var skeleton_src=skeleton_src_component.exports;// CONCATENATED MODULE: ./packages/skeleton/index.js
/* istanbul ignore next */skeleton_src.install=function(Vue){Vue.component(skeleton_src.name,skeleton_src);};/* harmony default export */var skeleton=skeleton_src;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/item.vue?vue&type=template&id=4bc8804c&
var itemvue_type_template_id_4bc8804c_render=function itemvue_type_template_id_4bc8804c_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{class:["el-skeleton__item","el-skeleton__"+_vm.variant]},[_vm.variant==="image"?_c("img-placeholder"):_vm._e()],1);};var itemvue_type_template_id_4bc8804c_staticRenderFns=[];itemvue_type_template_id_4bc8804c_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/item.vue?vue&type=template&id=4bc8804c&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/img-placeholder.vue?vue&type=template&id=1b2cb5c0&
var img_placeholdervue_type_template_id_1b2cb5c0_render=function img_placeholdervue_type_template_id_1b2cb5c0_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 1024 1024",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M64 896V128h896v768H64z m64-128l192-192 116.352 116.352L640 448l256 307.2V192H128v576z m224-480a96 96 0 1 1-0.064 192.064A96 96 0 0 1 352 288z"}})]);};var img_placeholdervue_type_template_id_1b2cb5c0_staticRenderFns=[];img_placeholdervue_type_template_id_1b2cb5c0_render._withStripped=true;// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue?vue&type=template&id=1b2cb5c0&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/img-placeholder.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var img_placeholdervue_type_script_lang_js_={name:'ImgPlaceholder'};// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue?vue&type=script&lang=js&
/* harmony default export */var src_img_placeholdervue_type_script_lang_js_=img_placeholdervue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/img-placeholder.vue
/* normalize component */var img_placeholder_component=normalizeComponent(src_img_placeholdervue_type_script_lang_js_,img_placeholdervue_type_template_id_1b2cb5c0_render,img_placeholdervue_type_template_id_1b2cb5c0_staticRenderFns,false,null,null,null);/* hot reload */if(false){var img_placeholder_api;}img_placeholder_component.options.__file="packages/skeleton/src/img-placeholder.vue";/* harmony default export */var img_placeholder=img_placeholder_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/skeleton/src/item.vue?vue&type=script&lang=js&
var _components;//
//
//
//
//
//
/* harmony default export */var skeleton_src_itemvue_type_script_lang_js_={name:'ElSkeletonItem',props:{variant:{type:String,default:'text'}},components:(_components={},_components[img_placeholder.name]=img_placeholder,_components)};// CONCATENATED MODULE: ./packages/skeleton/src/item.vue?vue&type=script&lang=js&
/* harmony default export */var packages_skeleton_src_itemvue_type_script_lang_js_=skeleton_src_itemvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/skeleton/src/item.vue
/* normalize component */var skeleton_src_item_component=normalizeComponent(packages_skeleton_src_itemvue_type_script_lang_js_,itemvue_type_template_id_4bc8804c_render,itemvue_type_template_id_4bc8804c_staticRenderFns,false,null,null,null);/* hot reload */if(false){var skeleton_src_item_api;}skeleton_src_item_component.options.__file="packages/skeleton/src/item.vue";/* harmony default export */var skeleton_src_item=skeleton_src_item_component.exports;// CONCATENATED MODULE: ./packages/skeleton-item/index.js
/* istanbul ignore next */skeleton_src_item.install=function(Vue){Vue.component(skeleton_src_item.name,skeleton_src_item);};/* harmony default export */var skeleton_item=skeleton_src_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/index.vue?vue&type=template&id=347ced91&
var srcvue_type_template_id_347ced91_render=function srcvue_type_template_id_347ced91_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-empty"},[_c("div",{staticClass:"el-empty__image",style:_vm.imageStyle},[_vm.image?_c("img",{attrs:{src:_vm.image,ondragstart:"return false"}}):_vm._t("image",[_c("img-empty")])],2),_c("div",{staticClass:"el-empty__description"},[_vm.$slots.description?_vm._t("description"):_c("p",[_vm._v(_vm._s(_vm.emptyDescription))])],2),_vm.$slots.default?_c("div",{staticClass:"el-empty__bottom"},[_vm._t("default")],2):_vm._e()]);};var srcvue_type_template_id_347ced91_staticRenderFns=[];srcvue_type_template_id_347ced91_render._withStripped=true;// CONCATENATED MODULE: ./packages/empty/src/index.vue?vue&type=template&id=347ced91&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/img-empty.vue?vue&type=template&id=42918b82&
var img_emptyvue_type_template_id_42918b82_render=function img_emptyvue_type_template_id_42918b82_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 79 86",version:"1.1",xmlns:"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c("defs",[_c("linearGradient",{attrs:{id:"linearGradient-1-"+_vm.id,x1:"38.8503086%",y1:"0%",x2:"61.1496914%",y2:"100%"}},[_c("stop",{attrs:{"stop-color":"#FCFCFD",offset:"0%"}}),_c("stop",{attrs:{"stop-color":"#EEEFF3",offset:"100%"}})],1),_c("linearGradient",{attrs:{id:"linearGradient-2-"+_vm.id,x1:"0%",y1:"9.5%",x2:"100%",y2:"90.5%"}},[_c("stop",{attrs:{"stop-color":"#FCFCFD",offset:"0%"}}),_c("stop",{attrs:{"stop-color":"#E9EBEF",offset:"100%"}})],1),_c("rect",{attrs:{id:"path-3-"+_vm.id,x:"0",y:"0",width:"17",height:"36"}})],1),_c("g",{attrs:{id:"Illustrations",stroke:"none","stroke-width":"1",fill:"none","fill-rule":"evenodd"}},[_c("g",{attrs:{id:"B-type",transform:"translate(-1268.000000, -535.000000)"}},[_c("g",{attrs:{id:"Group-2",transform:"translate(1268.000000, 535.000000)"}},[_c("path",{attrs:{id:"Oval-Copy-2",d:"M39.5,86 C61.3152476,86 79,83.9106622 79,81.3333333 C79,78.7560045 57.3152476,78 35.5,78 C13.6847524,78 0,78.7560045 0,81.3333333 C0,83.9106622 17.6847524,86 39.5,86 Z",fill:"#F7F8FC"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-14",fill:"#E5E7E9",transform:"translate(27.500000, 51.500000) scale(1, -1) translate(-27.500000, -51.500000) ",points:"13 58 53 58 42 45 2 45"}}),_c("g",{attrs:{id:"Group-Copy",transform:"translate(34.500000, 31.500000) scale(-1, 1) rotate(-25.000000) translate(-34.500000, -31.500000) translate(7.000000, 10.000000)"}},[_c("polygon",{attrs:{id:"Rectangle-Copy-10",fill:"#E5E7E9",transform:"translate(11.500000, 5.000000) scale(1, -1) translate(-11.500000, -5.000000) ",points:"2.84078316e-14 3 18 3 23 7 5 7"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-11",fill:"#EDEEF2",points:"-3.69149156e-15 7 38 7 38 43 -3.69149156e-15 43"}}),_c("rect",{attrs:{id:"Rectangle-Copy-12",fill:"url(#linearGradient-1-"+_vm.id+")",transform:"translate(46.500000, 25.000000) scale(-1, 1) translate(-46.500000, -25.000000) ",x:"38",y:"7",width:"17",height:"36"}}),_c("polygon",{attrs:{id:"Rectangle-Copy-13",fill:"#F8F9FB",transform:"translate(39.500000, 3.500000) scale(-1, 1) translate(-39.500000, -3.500000) ",points:"24 7 41 7 55 -3.63806207e-12 38 -3.63806207e-12"}})]),_c("rect",{attrs:{id:"Rectangle-Copy-15",fill:"url(#linearGradient-2-"+_vm.id+")",x:"13",y:"45",width:"40",height:"36"}}),_c("g",{attrs:{id:"Rectangle-Copy-17",transform:"translate(53.000000, 45.000000)"}},[_c("mask",{attrs:{id:"mask-4-"+_vm.id,fill:"white"}},[_c("use",{attrs:{"xlink:href":"#path-3-"+_vm.id}})]),_c("use",{attrs:{id:"Mask",fill:"#E0E3E9",transform:"translate(8.500000, 18.000000) scale(-1, 1) translate(-8.500000, -18.000000) ","xlink:href":"#path-3-"+_vm.id}}),_c("polygon",{attrs:{id:"Rectangle-Copy",fill:"#D5D7DE",mask:"url(#mask-4-"+_vm.id+")",transform:"translate(12.000000, 9.000000) scale(-1, 1) translate(-12.000000, -9.000000) ",points:"7 0 24 0 20 18 -1.70530257e-13 16"}})]),_c("polygon",{attrs:{id:"Rectangle-Copy-18",fill:"#F8F9FB",transform:"translate(66.000000, 51.500000) scale(-1, 1) translate(-66.000000, -51.500000) ",points:"62 45 79 45 70 58 53 58"}})])])])]);};var img_emptyvue_type_template_id_42918b82_staticRenderFns=[];img_emptyvue_type_template_id_42918b82_render._withStripped=true;// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue?vue&type=template&id=42918b82&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/img-empty.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var img_emptyvue_type_script_lang_js_id=0;/* harmony default export */var img_emptyvue_type_script_lang_js_={name:'ImgEmpty',data:function data(){return{id:++img_emptyvue_type_script_lang_js_id};}};// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue?vue&type=script&lang=js&
/* harmony default export */var src_img_emptyvue_type_script_lang_js_=img_emptyvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/empty/src/img-empty.vue
/* normalize component */var img_empty_component=normalizeComponent(src_img_emptyvue_type_script_lang_js_,img_emptyvue_type_template_id_42918b82_render,img_emptyvue_type_template_id_42918b82_staticRenderFns,false,null,null,null);/* hot reload */if(false){var img_empty_api;}img_empty_component.options.__file="packages/empty/src/img-empty.vue";/* harmony default export */var img_empty=img_empty_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/index.vue?vue&type=script&lang=js&
var srcvue_type_script_lang_js_components;//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */var empty_srcvue_type_script_lang_js_={name:'ElEmpty',components:(srcvue_type_script_lang_js_components={},srcvue_type_script_lang_js_components[img_empty.name]=img_empty,srcvue_type_script_lang_js_components),props:{image:{type:String,default:''},imageSize:Number,description:{type:String,default:''}},computed:{emptyDescription:function emptyDescription(){return this.description||Object(lib_locale_["t"])('el.empty.description');},imageStyle:function imageStyle(){return{width:this.imageSize?this.imageSize+'px':''};}}};// CONCATENATED MODULE: ./packages/empty/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_empty_srcvue_type_script_lang_js_=empty_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/empty/src/index.vue
/* normalize component */var empty_src_component=normalizeComponent(packages_empty_srcvue_type_script_lang_js_,srcvue_type_template_id_347ced91_render,srcvue_type_template_id_347ced91_staticRenderFns,false,null,null,null);/* hot reload */if(false){var empty_src_api;}empty_src_component.options.__file="packages/empty/src/index.vue";/* harmony default export */var empty_src=empty_src_component.exports;// CONCATENATED MODULE: ./packages/empty/index.js
empty_src.install=function(Vue){Vue.component(empty_src.name,empty_src);};/* harmony default export */var empty=empty_src;// CONCATENATED MODULE: ./packages/descriptions/src/descriptions-row.js
var descriptions_row_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/* harmony default export */var descriptions_row={name:'ElDescriptionsRow',props:{row:{type:Array}},inject:['elDescriptions'],render:function render(h){var elDescriptions=this.elDescriptions;var row=(this.row||[]).map(function(item){return descriptions_row_extends({},item,{label:item.slots.label||item.props.label},['labelClassName','contentClassName','labelStyle','contentStyle'].reduce(function(res,key){res[key]=item.props[key]||elDescriptions[key];return res;},{}));});if(elDescriptions.direction==='vertical'){return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref;return h('th',{'class':(_ref={'el-descriptions-item__cell':true,'el-descriptions-item__label':true,'has-colon':elDescriptions.border?false:elDescriptions.colon,'is-bordered-label':elDescriptions.border},_ref[item.labelClassName]=true,_ref),style:item.labelStyle,attrs:{colSpan:item.props.span}},[item.label]);})]),h('tr',{'class':'el-descriptions-row'},[row.map(function(item){return h('td',{'class':['el-descriptions-item__cell','el-descriptions-item__content',item.contentClassName],style:item.contentStyle,attrs:{colSpan:item.props.span}},[item.slots.default]);})])]);}if(elDescriptions.border){return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref2;return[h('th',{'class':(_ref2={'el-descriptions-item__cell':true,'el-descriptions-item__label':true,'is-bordered-label':elDescriptions.border},_ref2[item.labelClassName]=true,_ref2),style:item.labelStyle,attrs:{colSpan:'1'}},[item.label]),h('td',{'class':['el-descriptions-item__cell','el-descriptions-item__content',item.contentClassName],style:item.contentStyle,attrs:{colSpan:item.props.span*2-1}},[item.slots.default])];})])]);}return h('tbody',[h('tr',{'class':'el-descriptions-row'},[row.map(function(item){var _ref3;return h('td',{'class':'el-descriptions-item el-descriptions-item__cell',attrs:{colSpan:item.props.span}},[h('div',{'class':'el-descriptions-item__container'},[h('span',{'class':(_ref3={'el-descriptions-item__label':true,'has-colon':elDescriptions.colon},_ref3[item.labelClassName]=true,_ref3),style:item.labelStyle},[item.label]),h('span',{'class':['el-descriptions-item__content',item.contentClassName],style:item.contentStyle},[item.slots.default])])]);})])]);}};// CONCATENATED MODULE: ./packages/descriptions/src/index.js
var src_extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var src_components;/* harmony default export */var descriptions_src={name:'ElDescriptions',components:(src_components={},src_components[descriptions_row.name]=descriptions_row,src_components),props:{border:{type:Boolean,default:false},column:{type:Number,default:3},direction:{type:String,default:'horizontal'},size:{type:String// validator: isValidComponentSize,
},title:{type:String,default:''},extra:{type:String,default:''},labelStyle:{type:Object},contentStyle:{type:Object},labelClassName:{type:String,default:''},contentClassName:{type:String,default:''},colon:{type:Boolean,default:true}},computed:{descriptionsSize:function descriptionsSize(){return this.size||(this.$ELEMENT||{}).size;}},provide:function provide(){return{elDescriptions:this};},methods:{getOptionProps:function getOptionProps(vnode){if(vnode.componentOptions){var componentOptions=vnode.componentOptions;var _componentOptions$pro=componentOptions.propsData,propsData=_componentOptions$pro===undefined?{}:_componentOptions$pro,_componentOptions$Cto=componentOptions.Ctor,Ctor=_componentOptions$Cto===undefined?{}:_componentOptions$Cto;var props=(Ctor.options||{}).props||{};var res={};for(var k in props){var v=props[k];var defaultValue=v.default;if(defaultValue!==undefined){res[k]=Object(types_["isFunction"])(defaultValue)?defaultValue.call(vnode):defaultValue;}}return src_extends({},res,propsData);}return{};},getSlots:function getSlots(vnode){var _this=this;var componentOptions=vnode.componentOptions||{};var children=vnode.children||componentOptions.children||[];var slots={};children.forEach(function(child){if(!_this.isEmptyElement(child)){var name=child.data&&child.data.slot||'default';slots[name]=slots[name]||[];if(child.tag==='template'){slots[name].push(child.children);}else{slots[name].push(child);}}});return src_extends({},slots);},isEmptyElement:function isEmptyElement(c){return!(c.tag||c.text&&c.text.trim()!=='');},filledNode:function filledNode(node,span,count){var isLast=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;if(!node.props){node.props={};}if(span>count){node.props.span=count;}if(isLast){// set the max span, cause of the last td
node.props.span=count;}return node;},getRows:function getRows(){var _this2=this;var children=(this.$slots.default||[]).filter(function(vnode){return vnode.tag&&vnode.componentOptions&&vnode.componentOptions.Ctor.options.name==='ElDescriptionsItem';});var nodes=children.map(function(vnode){return{props:_this2.getOptionProps(vnode),slots:_this2.getSlots(vnode),vnode:vnode};});var rows=[];var temp=[];var count=this.column;nodes.forEach(function(node,index){var span=node.props.span||1;if(index===children.length-1){temp.push(_this2.filledNode(node,span,count,true));rows.push(temp);return;}if(span<count){count-=span;temp.push(node);}else{temp.push(_this2.filledNode(node,span,count));rows.push(temp);count=_this2.column;temp=[];}});return rows;}},render:function render(){var h=arguments[0];var title=this.title,extra=this.extra,border=this.border,descriptionsSize=this.descriptionsSize,$slots=this.$slots;var rows=this.getRows();return h('div',{'class':'el-descriptions'},[title||extra||$slots.title||$slots.extra?h('div',{'class':'el-descriptions__header'},[h('div',{'class':'el-descriptions__title'},[$slots.title?$slots.title:title]),h('div',{'class':'el-descriptions__extra'},[$slots.extra?$slots.extra:extra])]):null,h('div',{'class':'el-descriptions__body'},[h('table',{'class':['el-descriptions__table',{'is-bordered':border},descriptionsSize?'el-descriptions--'+descriptionsSize:'']},[rows.map(function(row){return h(descriptions_row,{attrs:{row:row}});})])])]);}};// CONCATENATED MODULE: ./packages/descriptions/index.js
/* istanbul ignore next */descriptions_src.install=function install(Vue){Vue.component(descriptions_src.name,descriptions_src);};/* harmony default export */var descriptions=descriptions_src;// CONCATENATED MODULE: ./packages/descriptions/src/descriptions-item.js
/* harmony default export */var descriptions_item={name:'ElDescriptionsItem',props:{label:{type:String,default:''},span:{type:Number,default:1},contentClassName:{type:String,default:''},contentStyle:{type:Object},labelClassName:{type:String,default:''},labelStyle:{type:Object}},render:function render(){return null;}};// CONCATENATED MODULE: ./packages/descriptions-item/index.js
/* istanbul ignore next */descriptions_item.install=function install(Vue){Vue.component(descriptions_item.name,descriptions_item);};/* harmony default export */var packages_descriptions_item=descriptions_item;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/index.vue?vue&type=template&id=3408b139&
var srcvue_type_template_id_3408b139_render=function srcvue_type_template_id_3408b139_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div",{staticClass:"el-result"},[_c("div",{staticClass:"el-result__icon"},[_vm._t("icon",[_c(_vm.iconElement,{tag:"component",class:_vm.iconElement})])],2),_vm.title||_vm.$slots.title?_c("div",{staticClass:"el-result__title"},[_vm._t("title",[_c("p",[_vm._v(_vm._s(_vm.title))])])],2):_vm._e(),_vm.subTitle||_vm.$slots.subTitle?_c("div",{staticClass:"el-result__subtitle"},[_vm._t("subTitle",[_c("p",[_vm._v(_vm._s(_vm.subTitle))])])],2):_vm._e(),_vm.$slots.extra?_c("div",{staticClass:"el-result__extra"},[_vm._t("extra")],2):_vm._e()]);};var srcvue_type_template_id_3408b139_staticRenderFns=[];srcvue_type_template_id_3408b139_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/index.vue?vue&type=template&id=3408b139&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-success.vue?vue&type=template&id=18119418&
var icon_successvue_type_template_id_18119418_render=function icon_successvue_type_template_id_18119418_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M34.5548098,16.4485711 C33.9612228,15.8504763 32.9988282,15.8504763 32.4052412,16.4485711 L32.4052412,16.4485711 L21.413757,27.5805811 L21.413757,27.5805811 L21.4034642,27.590855 C21.0097542,27.9781674 20.3766105,27.9729811 19.9892981,27.5792711 L19.9892981,27.5792711 L15.5947588,23.1121428 C15.0011718,22.514048 14.0387772,22.514048 13.4451902,23.1121428 C12.8516033,23.7102376 12.8516033,24.6799409 13.4451902,25.2780357 L13.4451902,25.2780357 L19.6260786,31.5514289 C20.2196656,32.1495237 21.1820602,32.1495237 21.7756472,31.5514289 L21.7756472,31.5514289 L34.5548098,18.614464 C35.1483967,18.0163692 35.1483967,17.0466659 34.5548098,16.4485711 Z"}})]);};var icon_successvue_type_template_id_18119418_staticRenderFns=[];icon_successvue_type_template_id_18119418_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-success.vue?vue&type=template&id=18119418&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-success.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var icon_successvue_type_script_lang_js_={name:'IconSuccess'};// CONCATENATED MODULE: ./packages/result/src/icon-success.vue?vue&type=script&lang=js&
/* harmony default export */var src_icon_successvue_type_script_lang_js_=icon_successvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/icon-success.vue
/* normalize component */var icon_success_component=normalizeComponent(src_icon_successvue_type_script_lang_js_,icon_successvue_type_template_id_18119418_render,icon_successvue_type_template_id_18119418_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_success_api;}icon_success_component.options.__file="packages/result/src/icon-success.vue";/* harmony default export */var icon_success=icon_success_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-error.vue?vue&type=template&id=21199246&
var icon_errorvue_type_template_id_21199246_render=function icon_errorvue_type_template_id_21199246_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M32.57818,15.42182 C32.0157534,14.8593933 31.1038797,14.8593933 30.541453,15.42182 L30.541453,15.42182 L24.0006789,21.9625941 L17.458547,15.42182 C16.8961203,14.8593933 15.9842466,14.8593933 15.42182,15.42182 C14.8593933,15.9842466 14.8593933,16.8961203 15.42182,17.458547 L15.42182,17.458547 L21.9639519,23.9993211 L15.42182,30.541453 C14.8593933,31.1038797 14.8593933,32.0157534 15.42182,32.57818 C15.9842466,33.1406067 16.8961203,33.1406067 17.458547,32.57818 L17.458547,32.57818 L24.0006789,26.0360481 L30.541453,32.57818 C31.1038797,33.1406067 32.0157534,33.1406067 32.57818,32.57818 C33.1406067,32.0157534 33.1406067,31.1038797 32.57818,30.541453 L32.57818,30.541453 L26.0374059,23.9993211 L32.57818,17.458547 C33.1406067,16.8961203 33.1406067,15.9842466 32.57818,15.42182 Z"}})]);};var icon_errorvue_type_template_id_21199246_staticRenderFns=[];icon_errorvue_type_template_id_21199246_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-error.vue?vue&type=template&id=21199246&
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-error.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */var icon_errorvue_type_script_lang_js_={name:'IconError'};// CONCATENATED MODULE: ./packages/result/src/icon-error.vue?vue&type=script&lang=js&
/* harmony default export */var src_icon_errorvue_type_script_lang_js_=icon_errorvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/icon-error.vue
/* normalize component */var icon_error_component=normalizeComponent(src_icon_errorvue_type_script_lang_js_,icon_errorvue_type_template_id_21199246_render,icon_errorvue_type_template_id_21199246_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_error_api;}icon_error_component.options.__file="packages/result/src/icon-error.vue";/* harmony default export */var icon_error=icon_error_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-warning.vue?vue&type=template&id=46fe8f31&
var icon_warningvue_type_template_id_46fe8f31_render=function icon_warningvue_type_template_id_46fe8f31_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,31 C22.8954305,31 22,31.8954305 22,33 C22,34.1045695 22.8954305,35 24,35 C25.1045695,35 26,34.1045695 26,33 C26,31.8954305 25.1045695,31 24,31 Z M24,14 C23.1715729,14 22.5,14.6715729 22.5,15.5 L22.5,15.5 L22.5,27.5 C22.5,28.3284271 23.1715729,29 24,29 C24.8284271,29 25.5,28.3284271 25.5,27.5 L25.5,27.5 L25.5,15.5 C25.5,14.6715729 24.8284271,14 24,14 Z"}})]);};var icon_warningvue_type_template_id_46fe8f31_staticRenderFns=[];icon_warningvue_type_template_id_46fe8f31_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue?vue&type=template&id=46fe8f31&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-warning.vue?vue&type=script&lang=ts&
/* harmony default export */var icon_warningvue_type_script_lang_ts_={name:'IconWarning'};// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue?vue&type=script&lang=ts&
/* harmony default export */var src_icon_warningvue_type_script_lang_ts_=icon_warningvue_type_script_lang_ts_;// CONCATENATED MODULE: ./packages/result/src/icon-warning.vue
/* normalize component */var icon_warning_component=normalizeComponent(src_icon_warningvue_type_script_lang_ts_,icon_warningvue_type_template_id_46fe8f31_render,icon_warningvue_type_template_id_46fe8f31_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_warning_api;}icon_warning_component.options.__file="packages/result/src/icon-warning.vue";/* harmony default export */var icon_warning=icon_warning_component.exports;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-info.vue?vue&type=template&id=19e3de69&
var icon_infovue_type_template_id_19e3de69_render=function icon_infovue_type_template_id_19e3de69_render(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("svg",{attrs:{viewBox:"0 0 48 48",xmlns:"http://www.w3.org/2000/svg"}},[_c("path",{attrs:{d:"M24,4 C35.045695,4 44,12.954305 44,24 C44,35.045695 35.045695,44 24,44 C12.954305,44 4,35.045695 4,24 C4,12.954305 12.954305,4 24,4 Z M24,19 L21,19 C20.1715729,19 19.5,19.6715729 19.5,20.5 C19.5,21.3284271 20.1715729,22 21,22 L21,22 L22.5,22 L22.5,31 L21,31 C20.1715729,31 19.5,31.6715729 19.5,32.5 C19.5,33.3284271 20.1715729,34 21,34 L21,34 L27,34 C27.8284271,34 28.5,33.3284271 28.5,32.5 C28.5,31.6715729 27.8284271,31 27,31 L27,31 L25.5,31 L25.5,20.5 C25.5,19.6715729 24.8284271,19 24,19 L24,19 Z M24,13 C22.8954305,13 22,13.8954305 22,15 C22,16.1045695 22.8954305,17 24,17 C25.1045695,17 26,16.1045695 26,15 C26,13.8954305 25.1045695,13 24,13 Z"}})]);};var icon_infovue_type_template_id_19e3de69_staticRenderFns=[];icon_infovue_type_template_id_19e3de69_render._withStripped=true;// CONCATENATED MODULE: ./packages/result/src/icon-info.vue?vue&type=template&id=19e3de69&
// CONCATENATED MODULE: ./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/icon-info.vue?vue&type=script&lang=ts&
/* harmony default export */var icon_infovue_type_script_lang_ts_={name:'IconInfo'};// CONCATENATED MODULE: ./packages/result/src/icon-info.vue?vue&type=script&lang=ts&
/* harmony default export */var src_icon_infovue_type_script_lang_ts_=icon_infovue_type_script_lang_ts_;// CONCATENATED MODULE: ./packages/result/src/icon-info.vue
/* normalize component */var icon_info_component=normalizeComponent(src_icon_infovue_type_script_lang_ts_,icon_infovue_type_template_id_19e3de69_render,icon_infovue_type_template_id_19e3de69_staticRenderFns,false,null,null,null);/* hot reload */if(false){var icon_info_api;}icon_info_component.options.__file="packages/result/src/icon-info.vue";/* harmony default export */var icon_info=icon_info_component.exports;// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/result/src/index.vue?vue&type=script&lang=js&
var result_srcvue_type_script_lang_js_components;//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var IconMap={success:'icon-success',warning:'icon-warning',error:'icon-error',info:'icon-info'};/* harmony default export */var result_srcvue_type_script_lang_js_={name:'ElResult',components:(result_srcvue_type_script_lang_js_components={},result_srcvue_type_script_lang_js_components[icon_success.name]=icon_success,result_srcvue_type_script_lang_js_components[icon_error.name]=icon_error,result_srcvue_type_script_lang_js_components[icon_warning.name]=icon_warning,result_srcvue_type_script_lang_js_components[icon_info.name]=icon_info,result_srcvue_type_script_lang_js_components),props:{title:{type:String,default:''},subTitle:{type:String,default:''},icon:{type:String,default:'info'}},computed:{iconElement:function iconElement(){var icon=this.icon;return icon&&IconMap[icon]?IconMap[icon]:'icon-info';}}};// CONCATENATED MODULE: ./packages/result/src/index.vue?vue&type=script&lang=js&
/* harmony default export */var packages_result_srcvue_type_script_lang_js_=result_srcvue_type_script_lang_js_;// CONCATENATED MODULE: ./packages/result/src/index.vue
/* normalize component */var result_src_component=normalizeComponent(packages_result_srcvue_type_script_lang_js_,srcvue_type_template_id_3408b139_render,srcvue_type_template_id_3408b139_staticRenderFns,false,null,null,null);/* hot reload */if(false){var result_src_api;}result_src_component.options.__file="packages/result/src/index.vue";/* harmony default export */var result_src=result_src_component.exports;// CONCATENATED MODULE: ./packages/result/index.js
/* istanbul ignore next */result_src.install=function(Vue){Vue.component(result_src.name,result_src);};/* harmony default export */var result=result_src;// CONCATENATED MODULE: ./src/index.js
/* Automatically generated by './build/bin/build-entry.js' */var components=[packages_pagination,dialog,packages_autocomplete,packages_dropdown,packages_dropdown_menu,packages_dropdown_item,packages_menu,packages_submenu,packages_menu_item,packages_menu_item_group,packages_input,packages_input_number,packages_radio,packages_radio_group,packages_radio_button,packages_checkbox,packages_checkbox_button,packages_checkbox_group,packages_switch,packages_select,packages_option,packages_option_group,packages_button,packages_button_group,packages_table,packages_table_column,packages_date_picker,packages_time_select,packages_time_picker,popover,packages_tooltip,packages_breadcrumb,packages_breadcrumb_item,packages_form,packages_form_item,packages_tabs,packages_tab_pane,packages_tag,packages_tree,packages_alert,slider,packages_icon,packages_row,packages_col,packages_upload,packages_progress,packages_spinner,badge,card,rate,packages_steps,packages_step,carousel,scrollbar,carousel_item,packages_collapse,packages_collapse_item,packages_cascader,color_picker,transfer,packages_container,header,aside,packages_main,footer,timeline,timeline_item,packages_link,divider,packages_image,calendar,backtop,page_header,packages_cascader_panel,avatar,drawer,popconfirm,skeleton,skeleton_item,empty,descriptions,packages_descriptions_item,result,collapse_transition_default.a];var src_install=function install(Vue){var opts=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};lib_locale_default.a.use(opts.locale);lib_locale_default.a.i18n(opts.i18n);components.forEach(function(component){Vue.component(component.name,component);});Vue.use(infinite_scroll);Vue.use(packages_loading.directive);Vue.prototype.$ELEMENT={size:opts.size||'',zIndex:opts.zIndex||2000};Vue.prototype.$loading=packages_loading.service;Vue.prototype.$msgbox=message_box;Vue.prototype.$alert=message_box.alert;Vue.prototype.$confirm=message_box.confirm;Vue.prototype.$prompt=message_box.prompt;Vue.prototype.$notify=notification;Vue.prototype.$message=packages_message;};/* istanbul ignore if */if(typeof window!=='undefined'&&window.Vue){src_install(window.Vue);}/* harmony default export */var src_0=__webpack_exports__["default"]={version:'2.15.9',locale:lib_locale_default.a.use,i18n:lib_locale_default.a.i18n,install:src_install,CollapseTransition:collapse_transition_default.a,Loading:packages_loading,Pagination:packages_pagination,Dialog:dialog,Autocomplete:packages_autocomplete,Dropdown:packages_dropdown,DropdownMenu:packages_dropdown_menu,DropdownItem:packages_dropdown_item,Menu:packages_menu,Submenu:packages_submenu,MenuItem:packages_menu_item,MenuItemGroup:packages_menu_item_group,Input:packages_input,InputNumber:packages_input_number,Radio:packages_radio,RadioGroup:packages_radio_group,RadioButton:packages_radio_button,Checkbox:packages_checkbox,CheckboxButton:packages_checkbox_button,CheckboxGroup:packages_checkbox_group,Switch:packages_switch,Select:packages_select,Option:packages_option,OptionGroup:packages_option_group,Button:packages_button,ButtonGroup:packages_button_group,Table:packages_table,TableColumn:packages_table_column,DatePicker:packages_date_picker,TimeSelect:packages_time_select,TimePicker:packages_time_picker,Popover:popover,Tooltip:packages_tooltip,MessageBox:message_box,Breadcrumb:packages_breadcrumb,BreadcrumbItem:packages_breadcrumb_item,Form:packages_form,FormItem:packages_form_item,Tabs:packages_tabs,TabPane:packages_tab_pane,Tag:packages_tag,Tree:packages_tree,Alert:packages_alert,Notification:notification,Slider:slider,Icon:packages_icon,Row:packages_row,Col:packages_col,Upload:packages_upload,Progress:packages_progress,Spinner:packages_spinner,Message:packages_message,Badge:badge,Card:card,Rate:rate,Steps:packages_steps,Step:packages_step,Carousel:carousel,Scrollbar:scrollbar,CarouselItem:carousel_item,Collapse:packages_collapse,CollapseItem:packages_collapse_item,Cascader:packages_cascader,ColorPicker:color_picker,Transfer:transfer,Container:packages_container,Header:header,Aside:aside,Main:packages_main,Footer:footer,Timeline:timeline,TimelineItem:timeline_item,Link:packages_link,Divider:divider,Image:packages_image,Calendar:calendar,Backtop:backtop,InfiniteScroll:infinite_scroll,PageHeader:page_header,CascaderPanel:packages_cascader_panel,Avatar:avatar,Drawer:drawer,Popconfirm:popconfirm,Skeleton:skeleton,SkeletonItem:skeleton_item,Empty:empty,Descriptions:descriptions,DescriptionsItem:packages_descriptions_item,Result:result};/***/}]/******/)["default"];

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* Modified from https://github.com/taylorhakes/fecha
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Taylor Hakes
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 *     The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 *     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 *     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 *     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/*eslint-disable*/
// 把 YYYY-MM-DD 改成了 yyyy-MM-dd

(function (main) {
  'use strict';

  /**
   * Parse or format dates
   * @class fecha
   */

  var fecha = {};
  var token = /d{1,4}|M{1,4}|yy(?:yy)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
  var twoDigits = '\\d\\d?';
  var threeDigits = '\\d{3}';
  var fourDigits = '\\d{4}';
  var word = '[^\\s]+';
  var literal = /\[([^]*?)\]/gm;
  var noop = function noop() {};

  function regexEscape(str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, '\\$&');
  }

  function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
      newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
  }

  function monthUpdate(arrName) {
    return function (d, v, i18n) {
      var index = i18n[arrName].indexOf(v.charAt(0).toUpperCase() + v.substr(1).toLowerCase());
      if (~index) {
        d.month = index;
      }
    };
  }

  function pad(val, len) {
    val = String(val);
    len = len || 2;
    while (val.length < len) {
      val = '0' + val;
    }
    return val;
  }

  var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var monthNamesShort = shorten(monthNames, 3);
  var dayNamesShort = shorten(dayNames, 3);
  fecha.i18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ['am', 'pm'],
    DoFn: function DoFn(D) {
      return D + ['th', 'st', 'nd', 'rd'][D % 10 > 3 ? 0 : (D - D % 10 !== 10) * D % 10];
    }
  };

  var formatFlags = {
    D: function D(dateObj) {
      return dateObj.getDay();
    },
    DD: function DD(dateObj) {
      return pad(dateObj.getDay());
    },
    Do: function Do(dateObj, i18n) {
      return i18n.DoFn(dateObj.getDate());
    },
    d: function d(dateObj) {
      return dateObj.getDate();
    },
    dd: function dd(dateObj) {
      return pad(dateObj.getDate());
    },
    ddd: function ddd(dateObj, i18n) {
      return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function dddd(dateObj, i18n) {
      return i18n.dayNames[dateObj.getDay()];
    },
    M: function M(dateObj) {
      return dateObj.getMonth() + 1;
    },
    MM: function MM(dateObj) {
      return pad(dateObj.getMonth() + 1);
    },
    MMM: function MMM(dateObj, i18n) {
      return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function MMMM(dateObj, i18n) {
      return i18n.monthNames[dateObj.getMonth()];
    },
    yy: function yy(dateObj) {
      return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    yyyy: function yyyy(dateObj) {
      return pad(dateObj.getFullYear(), 4);
    },
    h: function h(dateObj) {
      return dateObj.getHours() % 12 || 12;
    },
    hh: function hh(dateObj) {
      return pad(dateObj.getHours() % 12 || 12);
    },
    H: function H(dateObj) {
      return dateObj.getHours();
    },
    HH: function HH(dateObj) {
      return pad(dateObj.getHours());
    },
    m: function m(dateObj) {
      return dateObj.getMinutes();
    },
    mm: function mm(dateObj) {
      return pad(dateObj.getMinutes());
    },
    s: function s(dateObj) {
      return dateObj.getSeconds();
    },
    ss: function ss(dateObj) {
      return pad(dateObj.getSeconds());
    },
    S: function S(dateObj) {
      return Math.round(dateObj.getMilliseconds() / 100);
    },
    SS: function SS(dateObj) {
      return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function SSS(dateObj) {
      return pad(dateObj.getMilliseconds(), 3);
    },
    a: function a(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function A(dateObj, i18n) {
      return dateObj.getHours() < 12 ? i18n.amPm[0].toUpperCase() : i18n.amPm[1].toUpperCase();
    },
    ZZ: function ZZ(dateObj) {
      var o = dateObj.getTimezoneOffset();
      return (o > 0 ? '-' : '+') + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4);
    }
  };

  var parseFlags = {
    d: [twoDigits, function (d, v) {
      d.day = v;
    }],
    Do: [twoDigits + word, function (d, v) {
      d.day = parseInt(v, 10);
    }],
    M: [twoDigits, function (d, v) {
      d.month = v - 1;
    }],
    yy: [twoDigits, function (d, v) {
      var da = new Date(),
          cent = +('' + da.getFullYear()).substr(0, 2);
      d.year = '' + (v > 68 ? cent - 1 : cent) + v;
    }],
    h: [twoDigits, function (d, v) {
      d.hour = v;
    }],
    m: [twoDigits, function (d, v) {
      d.minute = v;
    }],
    s: [twoDigits, function (d, v) {
      d.second = v;
    }],
    yyyy: [fourDigits, function (d, v) {
      d.year = v;
    }],
    S: ['\\d', function (d, v) {
      d.millisecond = v * 100;
    }],
    SS: ['\\d{2}', function (d, v) {
      d.millisecond = v * 10;
    }],
    SSS: [threeDigits, function (d, v) {
      d.millisecond = v;
    }],
    D: [twoDigits, noop],
    ddd: [word, noop],
    MMM: [word, monthUpdate('monthNamesShort')],
    MMMM: [word, monthUpdate('monthNames')],
    a: [word, function (d, v, i18n) {
      var val = v.toLowerCase();
      if (val === i18n.amPm[0]) {
        d.isPm = false;
      } else if (val === i18n.amPm[1]) {
        d.isPm = true;
      }
    }],
    ZZ: ['[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z', function (d, v) {
      var parts = (v + '').match(/([+-]|\d\d)/gi),
          minutes;

      if (parts) {
        minutes = +(parts[1] * 60) + parseInt(parts[2], 10);
        d.timezoneOffset = parts[0] === '+' ? minutes : -minutes;
      }
    }]
  };
  parseFlags.dd = parseFlags.d;
  parseFlags.dddd = parseFlags.ddd;
  parseFlags.DD = parseFlags.D;
  parseFlags.mm = parseFlags.m;
  parseFlags.hh = parseFlags.H = parseFlags.HH = parseFlags.h;
  parseFlags.MM = parseFlags.M;
  parseFlags.ss = parseFlags.s;
  parseFlags.A = parseFlags.a;

  // Some common format strings
  fecha.masks = {
    default: 'ddd MMM dd yyyy HH:mm:ss',
    shortDate: 'M/D/yy',
    mediumDate: 'MMM d, yyyy',
    longDate: 'MMMM d, yyyy',
    fullDate: 'dddd, MMMM d, yyyy',
    shortTime: 'HH:mm',
    mediumTime: 'HH:mm:ss',
    longTime: 'HH:mm:ss.SSS'
  };

  /***
   * Format a date
   * @method format
   * @param {Date|number} dateObj
   * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
   */
  fecha.format = function (dateObj, mask, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof dateObj === 'number') {
      dateObj = new Date(dateObj);
    }

    if (Object.prototype.toString.call(dateObj) !== '[object Date]' || isNaN(dateObj.getTime())) {
      throw new Error('Invalid Date in fecha.format');
    }

    mask = fecha.masks[mask] || mask || fecha.masks['default'];

    var literals = [];

    // Make literals inactive by replacing them with ??
    mask = mask.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
      return $0 in formatFlags ? formatFlags[$0](dateObj, i18n) : $0.slice(1, $0.length - 1);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () {
      return literals.shift();
    });
  };

  /**
   * Parse a date string into an object, changes - into /
   * @method parse
   * @param {string} dateStr Date string
   * @param {string} format Date parse format
   * @returns {Date|boolean}
   */
  fecha.parse = function (dateStr, format, i18nSettings) {
    var i18n = i18nSettings || fecha.i18n;

    if (typeof format !== 'string') {
      throw new Error('Invalid format in fecha.parse');
    }

    format = fecha.masks[format] || format;

    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
      return null;
    }

    var dateInfo = {};
    var parseInfo = [];
    var literals = [];
    format = format.replace(literal, function ($0, $1) {
      literals.push($1);
      return '@@@';
    });
    var newFormat = regexEscape(format).replace(token, function ($0) {
      if (parseFlags[$0]) {
        var info = parseFlags[$0];
        parseInfo.push(info[1]);
        return '(' + info[0] + ')';
      }

      return $0;
    });
    newFormat = newFormat.replace(/@@@/g, function () {
      return literals.shift();
    });
    var matches = dateStr.match(new RegExp(newFormat, 'i'));
    if (!matches) {
      return null;
    }

    for (var i = 1; i < matches.length; i++) {
      parseInfo[i - 1](dateInfo, matches[i], i18n);
    }

    var today = new Date();
    if (dateInfo.isPm === true && dateInfo.hour != null && +dateInfo.hour !== 12) {
      dateInfo.hour = +dateInfo.hour + 12;
    } else if (dateInfo.isPm === false && +dateInfo.hour === 12) {
      dateInfo.hour = 0;
    }

    var date;
    if (dateInfo.timezoneOffset != null) {
      dateInfo.minute = +(dateInfo.minute || 0) - +dateInfo.timezoneOffset;
      date = new Date(Date.UTC(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0));
    } else {
      date = new Date(dateInfo.year || today.getFullYear(), dateInfo.month || 0, dateInfo.day || 1, dateInfo.hour || 0, dateInfo.minute || 0, dateInfo.second || 0, dateInfo.millisecond || 0);
    }
    return date;
  };

  /* istanbul ignore next */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = fecha;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fecha;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {
    main.fecha = fecha;
  }
})(undefined);

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;
exports.isDefined = exports.isUndefined = exports.isFunction = undefined;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.isString = isString;
exports.isObject = isObject;
exports.isHtmlElement = isHtmlElement;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
}

function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

function isHtmlElement(node) {
  return node && node.nodeType === Node.ELEMENT_NODE;
}

/**
 *  - Inspired:
 *    https://github.com/jashkenas/underscore/blob/master/modules/isFunction.js
 */
var isFunction = function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
};

if (typeof /./ !== 'function' && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) !== 'object' && (_vue2.default.prototype.$isServer || typeof document.childNodes !== 'function')) {
  exports.isFunction = isFunction = function isFunction(obj) {
    return typeof obj === 'function' || false;
  };
}

exports.isFunction = isFunction;
var isUndefined = exports.isUndefined = function isUndefined(val) {
  return val === void 0;
};

var isDefined = exports.isDefined = function isDefined(val) {
  return val !== undefined && val !== null;
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.PopupManager = undefined;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _merge = __webpack_require__(100);

var _merge2 = _interopRequireDefault(_merge);

var _popupManager = __webpack_require__(1208);

var _popupManager2 = _interopRequireDefault(_popupManager);

var _scrollbarWidth = __webpack_require__(147);

var _scrollbarWidth2 = _interopRequireDefault(_scrollbarWidth);

var _dom = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var idSeed = 1;

var scrollBarWidth = void 0;

exports.default = {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    _popupManager2.default.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    _popupManager2.default.deregister(this._popupId);
    _popupManager2.default.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },

  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          _vue2.default.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = (0, _merge2.default)({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        _popupManager2.default.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          _popupManager2.default.closeModal(this._popupId);
          this._closing = false;
        }
        _popupManager2.default.openModal(this._popupId, _popupManager2.default.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !(0, _dom.hasClass)(document.body, 'el-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt((0, _dom.getStyle)(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = (0, _scrollbarWidth2.default)();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = (0, _dom.getStyle)(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          (0, _dom.addClass)(document.body, 'el-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = _popupManager2.default.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      _popupManager2.default.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        (0, _dom.removeClass)(document.body, 'el-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
};
exports.PopupManager = _popupManager2.default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _util = __webpack_require__(38);

/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from 'element-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
exports.default = {
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      propName = (0, _util.kebabCase)(propName); // compatible with camel case
      if (props[propName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      eventName = (0, _util.kebabCase)(eventName); // compatible with camel case
      if (events[eventName]) {
        console.warn('[Element Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var nodeList = [];
var ctx = '@@clickoutsideContext';

var startClick = void 0;
var seed = 0;

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mousedown', function (e) {
  return startClick = e;
});

!_vue2.default.prototype.$isServer && (0, _dom.on)(document, 'mouseup', function (e) {
  nodeList.forEach(function (node) {
    return node[ctx].documentHandler(e, startClick);
  });
});

function createDocumentHandler(el, binding, vnode) {
  return function () {
    var mouseup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var mousedown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!vnode || !vnode.context || !mouseup.target || !mousedown.target || el.contains(mouseup.target) || el.contains(mousedown.target) || el === mouseup.target || vnode.context.popperElm && (vnode.context.popperElm.contains(mouseup.target) || vnode.context.popperElm.contains(mousedown.target))) return;

    if (binding.expression && el[ctx].methodName && vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
exports.default = {
  bind: function bind(el, binding, vnode) {
    nodeList.push(el);
    var id = seed++;
    el[ctx] = {
      id: id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },
  update: function update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },
  unbind: function unbind(el) {
    var len = nodeList.length;

    for (var i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 90);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/90:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("label", {
        staticClass: "el-checkbox",
        class: [_vm.border && _vm.checkboxSize ? "el-checkbox--" + _vm.checkboxSize : "", { "is-disabled": _vm.isDisabled }, { "is-bordered": _vm.border }, { "is-checked": _vm.isChecked }],
        attrs: { id: _vm.id }
      }, [_c("span", {
        staticClass: "el-checkbox__input",
        class: {
          "is-disabled": _vm.isDisabled,
          "is-checked": _vm.isChecked,
          "is-indeterminate": _vm.indeterminate,
          "is-focus": _vm.focus
        },
        attrs: {
          tabindex: _vm.indeterminate ? 0 : false,
          role: _vm.indeterminate ? "checkbox" : false,
          "aria-checked": _vm.indeterminate ? "mixed" : false
        }
      }, [_c("span", { staticClass: "el-checkbox__inner" }), _vm.trueLabel || _vm.falseLabel ? _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        staticClass: "el-checkbox__original",
        attrs: {
          type: "checkbox",
          "aria-hidden": _vm.indeterminate ? "true" : "false",
          name: _vm.name,
          disabled: _vm.isDisabled,
          "true-value": _vm.trueLabel,
          "false-value": _vm.falseLabel
        },
        domProps: {
          checked: Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm._q(_vm.model, _vm.trueLabel)
        },
        on: {
          change: [function ($event) {
            var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? _vm.trueLabel : _vm.falseLabel;
            if (Array.isArray($$a)) {
              var $$v = null,
                  $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.model = $$c;
            }
          }, _vm.handleChange],
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          }
        }
      }) : _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        staticClass: "el-checkbox__original",
        attrs: {
          type: "checkbox",
          "aria-hidden": _vm.indeterminate ? "true" : "false",
          disabled: _vm.isDisabled,
          name: _vm.name
        },
        domProps: {
          value: _vm.label,
          checked: Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : _vm.model
        },
        on: {
          change: [function ($event) {
            var $$a = _vm.model,
                $$el = $event.target,
                $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = _vm.label,
                  $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.model = $$a.concat([$$v]));
              } else {
                $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.model = $$c;
            }
          }, _vm.handleChange],
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          }
        }
      })]), _vm.$slots.default || _vm.label ? _c("span", { staticClass: "el-checkbox__label" }, [_vm._t("default"), !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=template&id=d0387074&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var checkboxvue_type_script_lang_js_ = {
      name: 'ElCheckbox',

      mixins: [emitter_default.a],

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      componentName: 'ElCheckbox',

      data: function data() {
        return {
          selfModel: false,
          focus: false,
          isLimitExceeded: false
        };
      },

      computed: {
        model: {
          get: function get() {
            return this.isGroup ? this.store : this.value !== undefined ? this.value : this.selfModel;
          },
          set: function set(val) {
            if (this.isGroup) {
              this.isLimitExceeded = false;
              this._checkboxGroup.min !== undefined && val.length < this._checkboxGroup.min && (this.isLimitExceeded = true);

              this._checkboxGroup.max !== undefined && val.length > this._checkboxGroup.max && (this.isLimitExceeded = true);

              this.isLimitExceeded === false && this.dispatch('ElCheckboxGroup', 'input', [val]);
            } else {
              this.$emit('input', val);
              this.selfModel = val;
            }
          }
        },

        isChecked: function isChecked() {
          if ({}.toString.call(this.model) === '[object Boolean]') {
            return this.model;
          } else if (Array.isArray(this.model)) {
            return this.model.indexOf(this.label) > -1;
          } else if (this.model !== null && this.model !== undefined) {
            return this.model === this.trueLabel;
          }
        },
        isGroup: function isGroup() {
          var parent = this.$parent;
          while (parent) {
            if (parent.$options.componentName !== 'ElCheckboxGroup') {
              parent = parent.$parent;
            } else {
              this._checkboxGroup = parent;
              return true;
            }
          }
          return false;
        },
        store: function store() {
          return this._checkboxGroup ? this._checkboxGroup.value : this.value;
        },

        /* used to make the isDisabled judgment under max/min props */
        isLimitDisabled: function isLimitDisabled() {
          var _checkboxGroup = this._checkboxGroup,
              max = _checkboxGroup.max,
              min = _checkboxGroup.min;

          return !!(max || min) && this.model.length >= max && !this.isChecked || this.model.length <= min && this.isChecked;
        },
        isDisabled: function isDisabled() {
          return this.isGroup ? this._checkboxGroup.disabled || this.disabled || (this.elForm || {}).disabled || this.isLimitDisabled : this.disabled || (this.elForm || {}).disabled;
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        checkboxSize: function checkboxSize() {
          var temCheckboxSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          return this.isGroup ? this._checkboxGroup.checkboxGroupSize || temCheckboxSize : temCheckboxSize;
        }
      },

      props: {
        value: {},
        label: {},
        indeterminate: Boolean,
        disabled: Boolean,
        checked: Boolean,
        name: String,
        trueLabel: [String, Number],
        falseLabel: [String, Number],
        id: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
        controls: String, /* 当indeterminate为真时，为controls提供相关连的checkbox的id，表明元素间的控制关系*/
        border: Boolean,
        size: String
      },

      methods: {
        addToStore: function addToStore() {
          if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
            this.model.push(this.label);
          } else {
            this.model = this.trueLabel || true;
          }
        },
        handleChange: function handleChange(ev) {
          var _this = this;

          if (this.isLimitExceeded) return;
          var value = void 0;
          if (ev.target.checked) {
            value = this.trueLabel === undefined ? true : this.trueLabel;
          } else {
            value = this.falseLabel === undefined ? false : this.falseLabel;
          }
          this.$emit('change', value, ev);
          this.$nextTick(function () {
            if (_this.isGroup) {
              _this.dispatch('ElCheckboxGroup', 'change', [_this._checkboxGroup.value]);
            }
          });
        }
      },

      created: function created() {
        this.checked && this.addToStore();
      },
      mounted: function mounted() {
        // 为indeterminate元素 添加aria-controls 属性
        if (this.indeterminate) {
          this.$el.setAttribute('aria-controls', this.controls);
        }
      },

      watch: {
        value: function value(_value) {
          this.dispatch('ElFormItem', 'el.form.change', _value);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue?vue&type=script&lang=js&
    /* harmony default export */var src_checkboxvue_type_script_lang_js_ = checkboxvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_checkboxvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/checkbox/src/checkbox.vue";
    /* harmony default export */var src_checkbox = component.exports;
    // CONCATENATED MODULE: ./packages/checkbox/index.js


    /* istanbul ignore next */
    src_checkbox.install = function (Vue) {
      Vue.component(src_checkbox.name, src_checkbox);
    };

    /* harmony default export */var packages_checkbox = __webpack_exports__["default"] = src_checkbox;

    /***/
  }

  /******/ });

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var throttle = __webpack_require__(150);
var debounce = __webpack_require__(102);

module.exports = {
	throttle: throttle,
	debounce: debounce
};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/;

module.exports = function mergeJSXProps(objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp;
    for (key in b) {
      aa = a[key];
      bb = b[key];
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa;
            a[key] = aa = {};
            aa[temp] = true;
          }
          if (typeof bb === 'string') {
            temp = bb;
            b[key] = bb = {};
            bb[temp] = true;
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey]);
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb);
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb);
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey];
          }
        }
      } else {
        a[key] = b[key];
      }
    }
    return a;
  }, {});
};

function mergeFn(a, b) {
  return function () {
    a && a.apply(this, arguments);
    b && b.apply(this, arguments);
  };
}

/***/ }),
/* 294 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 130);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/130:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&

    /* harmony default export */var tagvue_type_script_lang_js_ = {
      name: 'ElTag',
      props: {
        text: String,
        closable: Boolean,
        type: String,
        hit: Boolean,
        disableTransitions: Boolean,
        color: String,
        size: String,
        effect: {
          type: String,
          default: 'light',
          validator: function validator(val) {
            return ['dark', 'light', 'plain'].indexOf(val) !== -1;
          }
        }
      },
      methods: {
        handleClose: function handleClose(event) {
          event.stopPropagation();
          this.$emit('close', event);
        },
        handleClick: function handleClick(event) {
          this.$emit('click', event);
        }
      },
      computed: {
        tagSize: function tagSize() {
          return this.size || (this.$ELEMENT || {}).size;
        }
      },
      render: function render(h) {
        var type = this.type,
            tagSize = this.tagSize,
            hit = this.hit,
            effect = this.effect;

        var classes = ['el-tag', type ? 'el-tag--' + type : '', tagSize ? 'el-tag--' + tagSize : '', effect ? 'el-tag--' + effect : '', hit && 'is-hit'];
        var tagEl = h('span', {
          'class': classes,
          style: { backgroundColor: this.color },
          on: {
            'click': this.handleClick
          }
        }, [this.$slots.default, this.closable && h('i', { 'class': 'el-tag__close el-icon-close', on: {
            'click': this.handleClose
          }
        })]);

        return this.disableTransitions ? tagEl : h('transition', {
          attrs: { name: 'el-zoom-in-center' }
        }, [tagEl]);
      }
    };
    // CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
    /* harmony default export */var src_tagvue_type_script_lang_js_ = tagvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/tag/src/tag.vue
    var render, staticRenderFns;

    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_tagvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/tag/src/tag.vue";
    /* harmony default export */var tag = component.exports;
    // CONCATENATED MODULE: ./packages/tag/index.js


    /* istanbul ignore next */
    tag.install = function (Vue) {
      Vue.component(tag.name, tag);
    };

    /* harmony default export */var packages_tag = __webpack_exports__["default"] = tag;

    /***/
  }

  /******/ });

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1228);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(62) && !__webpack_require__(80)(function () {
  return Object.defineProperty(__webpack_require__(297)('div'), 'a', { get: function get() {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(79);
var document = __webpack_require__(48).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(63);
var toIObject = __webpack_require__(71);
var arrayIndexOf = __webpack_require__(1234)(false);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) {
    if (key != IE_PROTO) has(O, key) && result.push(key);
  } // Don't enum bug & hidden keys
  while (names.length > i) {
    if (has(O, key = names[i++])) {
      ~arrayIndexOf(result, key) || result.push(key);
    }
  }return result;
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(300);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 300 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(106);
var $export = __webpack_require__(155);
var redefine = __webpack_require__(302);
var hide = __webpack_require__(69);
var Iterators = __webpack_require__(164);
var $iterCreate = __webpack_require__(1241);
var setToStringTag = __webpack_require__(165);
var getPrototypeOf = __webpack_require__(1244);
var ITERATOR = __webpack_require__(72)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function returnThis() {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function getMethod(kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(69);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(103);
var dPs = __webpack_require__(1242);
var enumBugKeys = __webpack_require__(161);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var Empty = function Empty() {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var _createDict = function createDict() {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(297)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1243).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  _createDict = iframeDocument.F;
  while (i--) {
    delete _createDict[PROTOTYPE][enumBugKeys[i]];
  }return _createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = _createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(298);
var hiddenKeys = __webpack_require__(161).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);


/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || __WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */](value, type || rule.type))) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.required, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 87);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/87:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("label", {
        staticClass: "el-radio",
        class: [_vm.border && _vm.radioSize ? "el-radio--" + _vm.radioSize : "", { "is-disabled": _vm.isDisabled }, { "is-focus": _vm.focus }, { "is-bordered": _vm.border }, { "is-checked": _vm.model === _vm.label }],
        attrs: {
          role: "radio",
          "aria-checked": _vm.model === _vm.label,
          "aria-disabled": _vm.isDisabled,
          tabindex: _vm.tabIndex
        },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.model = _vm.isDisabled ? _vm.model : _vm.label;
          }
        }
      }, [_c("span", {
        staticClass: "el-radio__input",
        class: {
          "is-disabled": _vm.isDisabled,
          "is-checked": _vm.model === _vm.label
        }
      }, [_c("span", { staticClass: "el-radio__inner" }), _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.model,
          expression: "model"
        }],
        ref: "radio",
        staticClass: "el-radio__original",
        attrs: {
          type: "radio",
          "aria-hidden": "true",
          name: _vm.name,
          disabled: _vm.isDisabled,
          tabindex: "-1",
          autocomplete: "off"
        },
        domProps: {
          value: _vm.label,
          checked: _vm._q(_vm.model, _vm.label)
        },
        on: {
          focus: function focus($event) {
            _vm.focus = true;
          },
          blur: function blur($event) {
            _vm.focus = false;
          },
          change: [function ($event) {
            _vm.model = _vm.label;
          }, _vm.handleChange]
        }
      })]), _c("span", {
        staticClass: "el-radio__label",
        on: {
          keydown: function keydown($event) {
            $event.stopPropagation();
          }
        }
      }, [_vm._t("default"), !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()], 2)]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=template&id=69cd6268&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/radio/src/radio.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var radiovue_type_script_lang_js_ = {
      name: 'ElRadio',

      mixins: [emitter_default.a],

      inject: {
        elForm: {
          default: ''
        },

        elFormItem: {
          default: ''
        }
      },

      componentName: 'ElRadio',

      props: {
        value: {},
        label: {},
        disabled: Boolean,
        name: String,
        border: Boolean,
        size: String
      },

      data: function data() {
        return {
          focus: false
        };
      },

      computed: {
        isGroup: function isGroup() {
          var parent = this.$parent;
          while (parent) {
            if (parent.$options.componentName !== 'ElRadioGroup') {
              parent = parent.$parent;
            } else {
              this._radioGroup = parent;
              return true;
            }
          }
          return false;
        },

        model: {
          get: function get() {
            return this.isGroup ? this._radioGroup.value : this.value;
          },
          set: function set(val) {
            if (this.isGroup) {
              this.dispatch('ElRadioGroup', 'input', [val]);
            } else {
              this.$emit('input', val);
            }
            this.$refs.radio && (this.$refs.radio.checked = this.model === this.label);
          }
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        radioSize: function radioSize() {
          var temRadioSize = this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
          return this.isGroup ? this._radioGroup.radioGroupSize || temRadioSize : temRadioSize;
        },
        isDisabled: function isDisabled() {
          return this.isGroup ? this._radioGroup.disabled || this.disabled || (this.elForm || {}).disabled : this.disabled || (this.elForm || {}).disabled;
        },
        tabIndex: function tabIndex() {
          return this.isDisabled || this.isGroup && this.model !== this.label ? -1 : 0;
        }
      },

      methods: {
        handleChange: function handleChange() {
          var _this = this;

          this.$nextTick(function () {
            _this.$emit('change', _this.model);
            _this.isGroup && _this.dispatch('ElRadioGroup', 'handleChange', _this.model);
          });
        }
      }
    };
    // CONCATENATED MODULE: ./packages/radio/src/radio.vue?vue&type=script&lang=js&
    /* harmony default export */var src_radiovue_type_script_lang_js_ = radiovue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/radio/src/radio.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_radiovue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/radio/src/radio.vue";
    /* harmony default export */var src_radio = component.exports;
    // CONCATENATED MODULE: ./packages/radio/index.js


    /* istanbul ignore next */
    src_radio.install = function (Vue) {
      Vue.component(src_radio.name, src_radio);
    };

    /* harmony default export */var packages_radio = __webpack_exports__["default"] = src_radio;

    /***/
  }

  /******/ });

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return signupProps; });
var signupProps = {
    id: 0,
    first_name: '',
    last_name: '',
    brand_name: '',
    country_id: null,
    email_address: '',
    password: '',
    confirm_password: '',
    confirmation_code: '',
    tailoring_category: null
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return barcodeLabelContentProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return barcodeLabelProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dataProps; });
var _dataProps;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var barcodeLabelContentProps = {
    key: 0,
    content_type: 0, //text or qr tag
    content: '',
    align: 0, //left, center, right
    column: 0, //first, second, third
    qr_width: 50,
    qr_top_margin: -50,
    font_bold: false
};

var barcodeLabelProps = {
    label_size: { width: 0, height: 0, column_count: 1, font_size: 12, code_type: 0 /*0=qr code, 1=2D code */, left_margin: 0, top_margin: 0 },
    preview: '',
    header_logo: '',
    footer_logo: '',
    label_contents: [JSON.parse(JSON.stringify(barcodeLabelContentProps))]
};

var dataProps = (_dataProps = {
    id: 0,
    sms_config: '',
    use_own_email: false,
    email_config: {
        host: '',
        port: '',
        username: '',
        password: '',
        from_name: '',
        from_email: '',
        reply_to_email: ''
    },
    email_address_required_in_customer_form: false,
    sales_order_required_for_tailoring: false,
    sales_inclusive_of_tax: false,
    disable_back_dated_entry: false,
    default_gift_card_validity: 180,
    loyalty_point_ratio: 100,

    sms_api_id: '',
    sms_api_password: '',
    whatsapp_access_token: '',
    whatsapp_end_point: '',
    max_discount_allowed: 0,

    default_print_measurement_with_work_order: true,
    default_print_styling_with_work_order: true,
    default_print_style_choice_image_with_work_order: false,
    default_print_customer_profile_with_work_order: true,
    default_print_sample_image_with_work_order: true,
    work_order_print_horizontal: true,
    work_order_print_qc_note: true,
    default_print_customer_name_on_work_order: true,
    sale_delivery_on_full_payment: true,
    customer_is_common_to_all_stores: true,

    ip_based_restriction: false,
    ip_addresses: [],
    customer_address_required_in_customer_form: false,
    print_delivery_wo_tag_together: false,

    enable_e_payment: false,
    stripe_api_secret_key: '',
    tax_return_on_order: true,

    payment_mode: 0,
    razor_pay_api_key: '',
    razor_pay_api_secret: '',

    sale_tag_required: false,
    customer_tag_required: false,

    whats_app_number: '',
    whats_app_api_key: '',
    display_stitching_fabric_breakup: false,
    convert_invoice_on_full_payment: true,
    horizontal_measurement_form: false,
    horizontal_style_sheet: false,

    shipment_track_enable: false,
    shipment_track_api_key: '',
    can_assign_production_work_freely: false,
    customer_anniversary_dates_required: false,
    print_process_list: false,
    enable_direct_delivery: false,
    allow_negative_stock_sale: false,
    allow_stock_fabric_po: false,
    customer_photo_required: false,
    show_sales_shipping_and_handling: true,
    close_option_sale_category_browsing: false,
    sale_category_required_retail_sale: true,
    print_both_sale_number: false,
    enable_walk_in_customer: false,
    display_fabric_info_regular_sale_print: true,
    print_thermal_wo: false,
    print_tailor_name_on_wo: false,
    hide_fabric_consumption_sale_order: false,
    enable_work_order_translation: false,
    display_separate_sale_order_item_list: false,
    google_sync_code: '',

    print_a5_wo: false,
    print_sale_item_notes: false,
    enable_tally: false,

    wo_image_size: '400px',
    wo_fabric_image_size: '100px',

    fabric_sku_prefix: '',
    fabric_sku_start_number: 0,
    ready_sku_prefix: '',
    ready_sku_start_number: 0,
    stitching_sku_prefix: '',
    stitching_sku_start_number: 0,
    equipment_sku_prefix: '',
    equipment_sku_start_number: 0,
    default_customer_salutation: null,
    production_capacity_calculator: false,
    minimum_sales_payment_before_confirmation: 0,
    production_supervisor_can_edit_trial_date: false,
    production_supervisor_can_accept_trial_requests: false
}, _defineProperty(_dataProps, 'sms_api_id', ''), _defineProperty(_dataProps, 'sms_api_password', ''), _defineProperty(_dataProps, 'sms_custom_api', ''), _defineProperty(_dataProps, 'customer_measurement_required', true), _defineProperty(_dataProps, 'sale_print_customer_mobile_number', true), _defineProperty(_dataProps, 'production_assign_work_order_rack_number', false), _defineProperty(_dataProps, 'work_order_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'work_order_delivery_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'production_item_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'inventory_stock_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'inventory_sale_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'inventory_sale_ready_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'work_order_dryclean_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _defineProperty(_dataProps, 'work_order_washable_label', JSON.parse(JSON.stringify(barcodeLabelProps))), _dataProps);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    key: 0,
    id: 0,
    tax_name: '',
    tax_percent: 0,
    applicable_on_sale_invoice: true,
    gst_india: false,
    deductible: false,
    fixed: false,
    inter_state: 0, //0=inter state, 1= intra state
    tally_sub_group_id: null
};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return timingListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return eStoreTopProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return eStoreSocialMediaProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return eStoreAboutUsProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return eStoreShipmentMethodProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return eStoreBannersProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return eStoreImprintProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return eStoreZohoProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var timingListProps = {
    key: 0,
    id: 0,
    day_number: 0,
    working_day: true,
    store_opens_at_hour: null,
    store_opens_at_minute: null,
    store_opens_at_am_pm: null,
    store_closes_at_hour: null,
    store_closes_at_minute: null,
    store_closes_at_am_pm: null
};

var eStoreTopProps = {
    key: 0,
    menu_id: 0,
    menu_name: '',
    source_id: 0,
    source_name: '',
    hidden: false
};

var eStoreSocialMediaProps = [{ site_name: 'Facebook', link: '', icon: 'fa-brands fa-facebook-f', blank_target: true, display: false }, { site_name: 'Twitter', link: '', icon: 'fa-brands fa-twitter', blank_target: true, display: false }, { site_name: 'Instagram', link: '', icon: 'fa-brands fa-instagram', blank_target: true, display: false }];

var eStoreAboutUsProps = {
    heading: '',
    sub_heading: '',
    content: '<section class="mt-3 py-5 bg-light">\n' + '<div class="container align-center">\n\n' + '<div class="row">\n' + '<div class="col-sm-12">\n' + '<p class="heading-2 lh-1">ABOUT TITLE</p>	\n' + '<p class="heading-3-thin mt-2">SUB_TITLE</p>\n\n\n' + '</div>\n' + '</div>\n' + '</div>\n' + '</section>\n\n' + '<section class=" py-5">\n' + '<div class="container align-center">\n' + '<span class="content-text">ABOUT CONTENT</span>\n\n' + '</div>\n' + '</section>'
};

var eStoreShipmentMethodProp = {
    key: 0,
    label: '',
    currency_id: 0,
    cost: 0,
    display_to_self_country: true
};

var eStoreBannersProp = {
    key: 0,
    button_label: '',
    button_target: '',
    image: ''
};

var eStoreImprintProp = {
    key: 0,
    image_path: '',
    link: '',
    description: ''
};

var eStoreZohoProp = {
    key: 0,
    id: 0,
    store_label: '',
    tax_intent: { value: '', list: ['TAXABLE', 'NON_TAXABLE', 'EXPORT', 'EXEMPT'] },
    zoho_org_id: '',
    zoho_org_name: '',
    zoho_branch_id: '',
    zoho_branch_name: '',
    zoho_warehouse_id: '',
    zoho_warehouse_name: '',
    is_active: true,
    zoho_bank_id: '',
    zoho_bank_name: '',
    zoho_payment_id: '',
    zoho_payment_name: '',
    eta_order_prefix: ''
};

var dataProps = {
    id: 0,
    legal_name: '',
    brand_name: '',
    locality_name: '',
    address: '',
    city_id: null,
    province_id: null,
    country_id: null,
    postal_code: '',
    contact_number: '',
    email_address: '',
    website: '',
    retail: true,
    warehouse: true,
    warehouse_id: 0,
    factory: true,
    brand_logo: '',
    sales_invoice_footer_notes: '',
    default_print_measurement_with_work_order: true,
    default_print_styling_with_work_order: true,
    default_print_style_choice_image_with_work_order: false,
    default_print_customer_profile_with_work_order: true,
    default_print_sample_image_with_work_order: true,
    sale_print_header_footer: true,
    sale_print_header_margin: 3,
    default_sale_print_paper_size: 0,
    work_order_print_horizontal: true,
    work_order_print_qc_note: true,
    default_print_customer_name_on_work_order: true,
    auto_generate_order_number: true,
    order_number_prefix: 'OR-1000',
    order_number_start_number: 1,
    auto_generate_invoice_number: true,
    invoice_number_prefix: 'INV-1000',
    invoice_number_start_number: 1,
    charge_sale_tax: false,
    tax_list_id: null,
    tax_registration_number: '',
    sales_estimate_footer_notes: '',
    sales_order_footer_notes: '',
    sale_order_print_label: 'SALE ORDER',
    po_footer_notes: '',
    external_sourcing_footer_notes: '',
    factory_id: 0,
    biometric_machine_id: '',
    biometric_auth_token: '',
    whats_app_api_key: '',
    e_store: false,
    default_sales_currency: null,
    shop_timing_list: [JSON.parse(JSON.stringify(timingListProps))],
    deleted_timing_items: [],

    e_store_logo: '',
    e_store_about_us: JSON.parse(JSON.stringify(eStoreAboutUsProps)),
    e_store_domain_name: '',
    e_store_menu_top_list: [JSON.parse(JSON.stringify(eStoreTopProps))],
    e_store_menu_bottom_list: [JSON.parse(JSON.stringify(eStoreTopProps))],
    e_store_footer_copright_information: '',
    e_store_social_media_link_list: JSON.parse(JSON.stringify(eStoreSocialMediaProps)),
    e_store_newsletter_subscription_heading: '',
    e_store_privacy_policy: '',
    e_store_cancellation_policy: '',
    e_store_job_opening: '',
    e_store_dedicated_subscription_page: '',

    e_store_b2b: false,
    e_payment_mode_id: null,

    e_store_shipment_method_list: [JSON.parse(JSON.stringify(eStoreShipmentMethodProp))],
    e_store_banners: JSON.parse(JSON.stringify(eStoreBannersProp)),

    e_store_imprint: [JSON.parse(JSON.stringify(eStoreImprintProp))],
    sms_sender_id: '',
    e_com_access_token: '',

    zoho_store_routing: [JSON.parse(JSON.stringify(eStoreZohoProp))],
    deleted_zoho_store_routing: []

    /*CREATE TABLE tenant_zoho_store_routes (
      id int NOT NULL AUTO_INCREMENT,
      eta_store_id int NOT NULL,
      tax_intent enum('TAXABLE','NON_TAXABLE','EXPORT','EXEMPT') NOT NULL,
      zoho_org_id varchar(50) NOT NULL,
      zoho_org_name varchar(100) DEFAULT NULL,
      zoho_branch_id varchar(50) DEFAULT NULL,
      zoho_branch_name varchar(100) DEFAULT NULL,
      zoho_warehouse_id varchar(50) DEFAULT NULL,
      zoho_warehouse_name varchar(100) DEFAULT NULL,
      is_active tinyint(1) DEFAULT '1',
      zoho_bank_id text,
      zoho_bank_name text,
      zoho_payment_id text,
      zoho_payment_name text,
      eta_order_prefix text COMMENT 'this decides which eta order goes to which zoho store',
      PRIMARY KEY (id),
      UNIQUE KEY uniq_route (eta_store_id,tax_intent)
    ) ENGINE=InnoDB DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_0900_ai_ci;
    */

};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    category_name: '',
    default_for_appointments: false
};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    team_name: '',
    additional_notes: '',
    profile_photo: ''
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    category_name: ''
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    tag_name: ''
};

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    tag_name: ''
};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    tag_name: ''
};

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    trigger_point: null,
    subject: '',
    email_body: '',
    sms_body: '',
    whatsapp_template_name: '',
    whatsapp_broadcast_name: '',
    whatsapp_variables: null,
    sms_entity_id: '',
    sms_template_id: '',
    send_sms: true,
    send_whatsapp: true
};

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export accessModuleList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var accessModuleList = {
    id: 0,
    module_id: 0,
    has_sub_menu: false,
    parent_menu_id: 0,
    can_view: true,
    can_add: true,
    can_edit: true,
    can_delete: true,
    allow_limited_list_view: false,
    allow_full_data_search: false,
    require_approval_when_appropriate: false,
    require_approval_when_appropriate_from_user_group_id: false
};

var dataProps = {
    id: 0,
    group_name: '',
    get_daily_sale_alert: false,
    get_daily_inventory_re_order_level_alert: false,
    get_customer_balance: false,
    get_next_days_promise: false,
    get_database_backup_15_day: false,
    get_document_expiry_reminder: false,
    get_leave_application_alert: false,
    get_purchase_order_approval_request_alert: false,
    get_stock_check_list_approval_alert: false,
    get_vendor_payment_reminder: false,
    override_sales_discount: false,
    redeem_sale_discount_coupon: false,
    enable_sale_delivery_on_partial_payment: false,
    can_view_cost_sheet: false,
    email_master_data: false,
    hide_inventory_cost_price: false,
    can_approve_purchase_request: false,
    get_stock_alert: false,
    daily_inventory_re_order_level_alert_stores: [],

    access_module_list: [],
    temp_access_module_list: []
};

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return subItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return qualityItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var subItemProps = {
    key: 0,
    id: 0,
    sub_category_name: '',
    piece_rate: 0,
    trial_type_price_list: [],
    trial_finish_rate: 0,
    production_buffer_days: 0
};

var qualityItemProps = {
    key: 0,
    id: 0,
    quality_point: ''
};

var dataProps = {
    id: 0,
    category_name: '',
    piece_rate: 0,
    type: 0,
    production_buffer_days: 0,
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: [],
    trial_type_price_list: [],
    trial_finish_rate: 0,

    quality_point_list: [JSON.parse(JSON.stringify(qualityItemProps))],
    deleted_quality_point_list_items: []
};

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    collection_name: ''
};

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fabricConsumptionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var fabricConsumptionProps = {
    key: 0,
    fabric_width_list: []
};

var dataProps = {
    id: 0,
    size_name: '',
    tailoring_category_id: 0,

    fabric_consumption_list: [JSON.parse(JSON.stringify(fabricConsumptionProps))],
    delete_fabric_consumption_list: []
};

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return measurementDropDownListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return measurementListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var measurementDropDownListProps = {
    key: 0,
    id: 0,
    measurement_value: '',
    measurement_instruction_image: ''
};

var measurementListProps = {
    sl_no: 0,
    id: 0,
    measurement_name: '',
    measurement_value_fixed: false, //single-line, dropdown-list
    measurement_instruction_image: '',
    is_common: false,
    category_name_list: [],
    measurement_drop_down_list: [JSON.parse(JSON.stringify(measurementDropDownListProps))],
    deleted_measurement_drop_down_list_items: []
};

var dataProps = {
    category_id: null,
    measurement_list: [JSON.parse(JSON.stringify(measurementListProps))],
    deleted_measurement_list_items: []
};

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return optionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return qualityItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return subProcessListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var optionProps = {
    key: 0,
    id: 0,
    option_name: '',
    extra_charge: 0,
    image: ''
};

var qualityItemProps = {
    key: 0,
    id: 0,
    quality_point: ''
};

var subProcessListProps = {
    key: 0,
    id: 0,
    default_choice: true,
    process_name: ''
};

var dataProps = {
    id: 0,
    process_name: '',
    is_cut_order_generated_at_this_stage: false,
    print_instruction_image_with_work_order: false,
    instruction_image: '',
    intructions: '',
    is_piece_rate_approval_required: false,
    is_extra_chargeable: false,
    extra_charge: 0,
    production_capacity_parameter: false,
    default_choice: true,
    alteration_process: false,
    transfer_to_factory_at_this_stage: false,
    restart_this_process_after_trial: false,
    trial_after_this_process: true,
    option_list: [JSON.parse(JSON.stringify(optionProps))],
    deleted_option_list_items: [],
    category_list: [],
    quality_point_list: [JSON.parse(JSON.stringify(qualityItemProps))],
    deleted_quality_point_list_items: [],
    enable_customer_notification_on_start: false,
    enable_customer_notification_on_finish: false,
    can_add_as_add_on: false,
    sub_process_allowed: false,
    sub_process_list: [JSON.parse(JSON.stringify(subProcessListProps))],
    delete_sub_process_list_items: []
};

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return customChoiceOptionListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customChoiceListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return styleChoiceOptionListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return styleChoiceListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return comboProductListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return imageListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fabricConsumptionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return estoreVariationProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dataProps; });
var customChoiceOptionListProps = {
    key: 0,
    style_option_id: null,
    charge_extra: false,
    charges: 0,
    can_choose_different_fabric: false,
    customise_option_fabric_categories: [],
    required_fabric_unit: 0,
    picture_path: '',
    is_default: false
};

var customChoiceListProps = {
    key: 0,
    id: 0,
    style_name: '',
    display_picture: '',
    picture_path: '',
    style_options: [JSON.parse(JSON.stringify(customChoiceOptionListProps))],
    delete_option_list: []
};

var styleChoiceOptionListProps = {
    key: 0,
    id: 0,
    option_name: '',
    option_name_translation: '',
    charge_extra: false,
    fixed_charge: false,
    charge_type: 0,
    charge_range: [0, 0],
    charges: 0,
    can_choose_different_fabric: false,
    required_fabric_unit: 0,
    charge_extra_for_fabric_as_per_price_of_fabric: false,
    picture_path: '',
    is_default: false,
    is_editable: false
};

var styleChoiceListProps = {
    key: 0,
    id: 0,
    style_name: '',
    style_name_translation: '',
    sl_no: 0,
    material: false,
    option_list: [JSON.parse(JSON.stringify(styleChoiceOptionListProps))],
    delete_option_list: []
};

var comboProductListProps = {
    id: 0,
    tailoring_id: 0
};

var imageListProps = {
    key: 0,
    id: 0,
    image_path: '',
    print_with_wo: false,
    use_as_profile_picture: true
};

var fabricConsumptionProps = {
    key: 0,
    size_id: null,
    fabric_width_list: []
};

var estoreVariationProps = {
    key: 0,
    fabric_id: null,
    fabric_details: { id: 0, sku_code: '' },
    sale_price: 0,
    image_list: []
};

var dataProps = {
    id: 0,
    active: true,
    template_name: '',
    description: '',
    base_sales_price: 0,
    is_combination_item: false,
    use_same_fabric_for_all_item: true,
    is_fabric_required: true,
    is_fabric_optional: false,
    fabric_unit_remain_flat: false,
    required_fabric_unit: 0,
    fabric_sales_price_remains_flat: false,
    hsn_sac_code: '',
    show_item_breakup_in_invoice: false,
    tailoring_tax_percent: 0,
    tailoring_and_fabric_tax_percent: 0,
    category_id: null,
    sub_category_id: null,
    collection_id: null,
    print_on_invoice: 0,
    profile_photo: '',
    alteration_item: false,
    discount_percent: 0,
    production_buffer_days: 0,
    customise_option_fabric_categories: [],
    pre_define_measurement_on_size: false,

    estore_available: false,
    estore_placement: 0,
    estore_title: '',
    estore_sub_title: '',
    estore_other_detail: '',
    estore_overview: '',
    estore_variation_list: [JSON.parse(JSON.stringify(estoreVariationProps))],
    alteration_garment: false,

    combination_item_list: [],
    delete_combination_item_list: [],

    style_choice_list: [JSON.parse(JSON.stringify(styleChoiceListProps))],
    delete_style_choice_list: [],

    custom_choice_list: [JSON.parse(JSON.stringify(customChoiceListProps))],
    delete_custom_choice_list: [],
    is_self_customisation_allowed: false,

    fabric_consumption_list: [JSON.parse(JSON.stringify(fabricConsumptionProps))],
    delete_fabric_consumption_list: [],
    trial_finish_rate: 0,
    trial_type_price_list: [],

    image_list: [JSON.parse(JSON.stringify(imageListProps))],
    delete_image_list: [],
    store_id: 0,
    production_capacity: 0,
    production_process_days: 0,

    fabric_id: 0,
    fabric_name: '',
    pre_define_production: false,
    pre_define_measurement_list: false,
    measurement_chart: [],
    final_measurement_chart: [],

    production_process_list: [],
    final_production_process_list: []
};

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    leave_name: '',
    maximum_paid_leave_allowed: 0,
    how_many_allowed_at_a_time: 1,
    must_apply_before_x_number_of_days: 1,
    pay_cut_percent: 0,
    extra_pay_percent: 0,
    allowed_per_month: 0
};

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    overtime_name: '',
    duration_minute_start_range: 0,
    duration_minute_end_range: 60,
    overtime_type: 0, //normal, weekday off overtime, holiday overtime
    in_time_late_buffer: 0,
    man_hours: 0
};

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    holiday_date: '',
    holiday_name: '',
    holiday_type: true,
    applicable_to_production_as_well: true,
    applied_to_religion: 0
};

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    designation_name: '',
    job_description: ''
};

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return overtimeListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return productionPieceRateListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var overtimeListProps = {
    key: 0,
    id: 0,
    overtime_id: null,
    overtime_pay_amount: 0
};

var productionPieceRateListProps = {
    key: 0,
    id: 0,
    tailoring_category_id: null,
    tailoring_sub_category_id: null,
    tailoring_item_id: null,
    piece_rate_type: 0, //fixed or percent of stitching price
    trial_finish_rate: 0,
    half_finish_rate: 0,
    piece_rate: 0,
    alteration_rate: 0,
    trial_type_price_list: [],
    master_rate: true,
    required_minutes: 0,
    required_minutes_trial: 0
};

var dataProps = {
    id: 0,
    active: true,
    staff_type: 0, //0=regular employee, 1=contractor
    is_sales_person: false,
    is_system_user: false,
    is_production_member: false,
    is_a_production_supervisor: false,
    staff_name: '',
    alias_name: '',
    present_address: '',
    permanent_address: '',
    contact_number: '',
    email_address: '',
    can_take_measurement: false,
    can_assist_trial: false,
    date_of_joining: new Date(),
    designation_id: null,
    fixed_salary: 0,
    deduction_per_day: 0,
    additional_notes: '',
    current_store_id: null,
    profile_photo: '',
    recommended_by: '',
    in_time: '',
    out_time: '',
    hour_rate: 0,
    discount_cap: 0,

    user_id: 0,
    user_name: '',
    user_password: '',
    user_group_id: null,
    user_access_store: [],
    ip_restriction_not_applied: false,
    religion: 0,
    is_qc_manager: false,

    overtime_list: [JSON.parse(JSON.stringify(overtimeListProps))],
    deleted_overtime_list: [],

    production_process_list: [],
    tax_list: [],
    lunch_start_time: '',
    lunch_end_time: '',
    account_sub_category_id: null,
    kra: '',
    supervising_process_id: 0,
    bank_detail: '',
    bank_code: '',
    bank_name: '',
    bank_account_number: '',
    account_related_sub_category_id: null,

    production_piece_rate_list: [JSON.parse(JSON.stringify(productionPieceRateListProps))],
    deleted_production_piece_rate_list: [],
    allowed_to_mo_order: true
};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    store_id: null,
    salutation_id: null,
    full_name: '',
    email_address: '',
    mobile_number_calling_code: '',
    mobile_number: '',
    alternative_mobile_number_calling_code: '',
    alternative_mobile_number: '',
    landline_calling_code: '',
    landline_number: '',
    address: '',
    city_id: null,
    province_id: null,
    postal_code: '',
    country_id: null,
    additional_notes: '',
    profile_photo: '',
    display_online: false,
    tag_list: []
};

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return teamListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var teamListProps = {
    key: 0,
    id: 0,
    staff_id: null,
    team_leader: false
};

var dataProps = {
    team_id: null,
    store_id: null,
    team_list: [JSON.parse(JSON.stringify(teamListProps))],
    deleted_team_list_items: []
};

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    staff_id: null,
    leave_id: null,
    date_range: '',
    reason_for_leave: '',
    leave_status: 0,
    status_updated_by_staff_id: 0,
    status_updater_notes: '',
    paid_leave: false
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export listProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var listProps = {
    key: 0,
    id: 0,
    staff_id: 0,
    staff_name: '',
    absent: false,
    weekday_off: false,
    on_leave_id: 0,
    leave_name: '',
    holiday_id: 0,
    holiday_name: '',
    in_time: '',
    out_time: ''
};

var dataProps = {
    entry_date: new Date(),
    store_id: null,
    list: []
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    bank_name: '',
    account_number: '',
    tally_sub_group_id: null,
    zoho_bank_account_id: null
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    mode_name: '',
    show_tender_amount_field: false,
    linked_bank_account_id: null,
    e_payment_mode: false,
    default_payment_mode: false
};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    target_currency_id: null,
    rate: 0
};

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var subItemProps = {
    key: 0,
    id: 0,
    sub_category_name: '',
    tally_sub_group_id: null
};

var dataProps = {
    id: 0,
    category_name: '',
    tally_group_id: null,
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: []
};

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return taxListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var taxListProps = {
    key: 0,
    id: 0,
    tax_id: null,
    tax_percent: 0,
    tax_amount: 0
};

var dataProps = {
    id: 0,
    store_id: null,
    home_currency_id: 0,
    currency_id: null,
    exchange_rate: 1,
    journal_date: new Date(),
    additional_notes: '',
    account_sub_category_id: null,
    expense_by_staff_id: null,
    sub_amount: 0,
    tax_amount: 0,
    adjustment: 0,
    net_total: 0,
    bank_id: null,
    biller_id: 0,
    expense_bill_id: 0,

    tax_list: [JSON.parse(JSON.stringify(taxListProps))],
    deleted_tax_list: []
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    from_store_id: null,
    to_store_id: null,
    entry_date: new Date(),
    from_bank_id: null,
    to_bank_id: null,
    additional_notes: '',
    amount: 0,
    issued_to_staff_id: null,
    issued_by_staff_id: null
};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return priceItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var priceItemProps = {
    key: 0,
    id: 0,
    tailoring_item_sub_category_id: null,
    price: 0
};

var dataProps = {
    id: 0,
    price_category_name: '',
    price_category_list: [JSON.parse(JSON.stringify(priceItemProps))]
};

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var subItemProps = {
    key: 0,
    id: 0,
    sub_variant_name: ''
};

var dataProps = {
    id: 0,
    variant_name: '',
    sub_item_list: [JSON.parse(JSON.stringify(subItemProps))],
    deleted_sub_item_list_items: []
};

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paymentTermListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var paymentTermListProps = {
    key: 0,
    id: 0,
    day_count: 0,
    percent_of_amount: 0
};

var dataProps = {
    id: 0,
    trackable_item_vendor: true,
    vendor_name: '',
    brand_name: '',
    contact_person_name: '',
    contact_number: '',
    email_address: '',
    tax_information: '',
    address: '',
    city_id: null,
    province_id: null,
    postal_code: '',
    country_id: null,
    bank_detail: '',
    additional_notes: '',
    billing_currency_id: null,
    account_sub_category_id: null,
    account_related_sub_category_id: null,

    payment_term_list: []
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return variantListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return otherVariantListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return logProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return imageListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return estorePriceVariationSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return estorePriceVariation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return estoreDownloadable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var variantListProps = {
    key: 0,
    id: 0,
    variant_sub_item_id: null,
    other_variations: []
};

var otherVariantListProps = {
    key: 0,
    sku_code: '',
    other_variations: []
};

var logProps = {
    id: 0,
    service_date: '',
    activity_type: 0,
    supervised_by_staff_id: null,
    service_done_by_contact_id: null,
    notes: '',
    image: ''
};

var imageListProps = {
    key: 0,
    id: 0,
    image_path: '',
    display_online: true,
    default_online_thumbnail: false,
    default_online_thumbnail_hover: false
};

var estorePriceVariationSource = {
    key: 0,
    source_name: '',
    source_link: '',
    source_self: true
};

var estorePriceVariation = {
    key: 0,
    variation_title: '',
    variation_source: [JSON.parse(JSON.stringify(estorePriceVariationSource))],
    price: 0,
    price_currency_id: 0,
    coming_soon: false,
    display_to_self_country: true,
    loading: false
};

var estoreDownloadable = {
    key: 0,
    source_name: '',
    source_link: ''
};

var dataProps = {
    id: 0,
    item_type: 0,
    fabric_cut_length: false,
    fabric_can_be_sold_as_retail: true,
    auto_generated_sku_code: 0,
    sku_code: '',
    sub_category_id: null,
    article_name: '',
    composition: '',
    design_description: '',
    unit_of_measurement_id: null,
    cost_price: 0,
    sale_price: 0,
    reorder_level: 0,
    fabric_width_id: null,
    fabric_price_category_id: null,
    style_number: '',
    fabric_gsm_id: null,
    hsn_sac_code: '',
    tax_percent: 0,
    profile_photo: '',
    most_popular: false,
    brand_name: '',
    trade_name: '',
    shade_number: '',
    rack_id: [],
    account_sub_category_id: null,
    issued_to: 0,
    caretaker_id: 0,
    purchase_date: '',
    warranty_expiry_date: '',
    log_list: [],
    stitching_rate_flat: false,
    discount_percent: 0,
    flat_price: 0,
    store_id: 0,
    length: '',
    width: '',
    height: '',
    default_retail_fabric_unit: 0,
    copies: 0,
    cluster_id: null,
    alteration_allowed: false,
    alteration_tailoring_item_id: 0,
    default_tailoring_consumption: 0,
    collection_id: null,

    estore_available: false,
    estore_price_variation: [JSON.parse(JSON.stringify(estorePriceVariation))],
    estore_product_variation: [],
    estore_title: '',
    estore_sub_title: '',
    estore_overview: '',
    estore_other_detail: '',
    estore_downloable: [JSON.parse(JSON.stringify(estoreDownloadable))],
    estore_stylist_names: [], //fetch from contacts
    estore_price_variation_available: false,
    estore_placement: 0,
    estore_featuring_title: '',
    estore_featuring_content: '',

    estore_preview_title1: '',
    estore_preview_title2: '',
    estore_preview_title3: '',
    estore_preview_content: '',
    profit_percent: 0,
    vendor_id: null,

    variant_item_id: 0,
    other_variations: [JSON.parse(JSON.stringify(otherVariantListProps))],
    image_list: [JSON.parse(JSON.stringify(imageListProps))],
    delete_image_list: [],
    variant_list: [JSON.parse(JSON.stringify(variantListProps))],
    other_variation_item_list: []
};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    description: '',
    qty: 1,
    unit_rate: 0,
    request_for_material_id: 0,
    external_number: '',
    sale_number: '',
    item_edit: 0
};

var dataProps = {
    id: 0,
    vendor_id: null,
    store_id: null,
    po_number: null,
    po_date: new Date(),
    expected_delivery_date: new Date(),
    home_currency_id: 0,
    billing_currency_id: null,
    exchange_rate: 0,
    shipment_address: '',
    additional_notes: '',
    status: 0,

    generated_by_staff_id: 0,
    approved_by_staff_id: 0,
    approval_notes: '',
    approval_date: new Date(),
    estimated_total_cost: 0,
    order_from_store_id: null,
    ordered_from: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return paymentTermListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var paymentTermListProps = {
    key: 0,
    payment_date: new Date(),
    amount: 0
};

var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    description: '',
    qty: 1,
    unit_rate: 0,
    discount_amount: 0,
    sub_total: 0,
    tax_percent: 0,
    tax_amount: 0,
    net_total: 0,
    item_edit: 0
};

var dataProps = {
    id: 0,
    vendor_id: null,
    store_id: null,
    home_currency_id: 0,
    billing_currency_id: 0,
    exchange_rate: 0,
    purchase_order_id: 0,
    purchase_order_number: '',
    bill_number: '',
    bill_date: new Date(),
    sub_total: 0,
    discount_amount: 0,
    taxable_total: 0,
    tax_amount: 0,
    reverse_charge_applicable: false,
    gst_type: 0,
    shipping_and_handling: 0,
    tax_percent_on_shipping: 0,
    adjustment: 0,
    net_total: 0,
    total_paid: 0,
    additional_notes: '',
    account_sub_category_id: null,
    zoho_store_id: null,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    payment_term: [JSON.parse(JSON.stringify(paymentTermListProps))],
    tax_list: []
};

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    store_id: null,
    vendor_id: null,
    purchase_bill_id: 0,
    payment_date: new Date(),
    additional_notes: '',
    paid_amount: 0,
    redeemed_amount: 0,
    advance_payment: false,
    bank_id: null
};

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    description: '',
    qty: 1,
    unit_rate: 0,
    item_edit: 0
};

var dataProps = {
    id: 0,
    from_store_id: null,
    to_store_id: null,
    transfer_number: null,
    transfer_date: new Date(),
    generated_by_staff_id: null,
    status: 0, //draft, dispatched, accepted, canceled

    dispatch_date: new Date(),
    dispatch_by_staff_id: null,
    dispatch_notes: '',
    delivered_by_staff_id: null,

    accept_date: new Date(),
    accept_by_staff_id: null,
    accept_notes: '',

    total_cost: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return termListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    qty: 1,
    unit_sale_price: 0,
    returned_status: false,
    return_notes: '',
    return_date: new Date(),
    accepted_by_staff_id: null,
    item_edit: 0
};

var termListProps = {
    key: 0,
    id: 0,
    term_text: ''
};

var dataProps = {
    id: 0,
    store_id: null,
    challan_number: null,
    sourcing_date: new Date(),
    expected_return_date: new Date(),
    contact_id: null,
    sourced_by_staff_id: null,
    delivered_by_staff_id: null,
    delivery_notes: '',
    additional_notes: '',
    status: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    term_list: [JSON.parse(JSON.stringify(termListProps))]
};

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    physical_stock_in_hand: 0,
    system_stock_in_hand: 0,
    adjustment_qty: 0,
    item_edit: 0
};

var dataProps = {
    id: 0,
    store_id: null,
    stock_update_date: new Date(),
    generated_by_staff_id: 0,
    approved_by_staff_id: 0,
    approval_notes: '',
    status: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export measurementProfileValueListProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return measurementProfileListProps; });
/* unused harmony export measurementCategoryProfileListProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return photoListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addressProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return discussionProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dataProps; });
var measurementProfileValueListProps = {
    key: 0,
    id: 0,
    measurement_id: 0,
    measurement_value: ''
};

var measurementProfileListProps = {
    key: 0,
    registration_date: new Date(),
    id: 0,
    size_id: null,
    measurement_type: 0, //body measurement, ready measurement
    notes: '',
    measured_by_staff_id: null,
    measurement_field_list: []
};

var measurementCategoryProfileListProps = {
    tailoring_category_id: null,
    profile_list: []
    /*
    //profile_list//
    created_at: '',
    id: 0,
    size_id: null,
    measurement_type: 0,//body measurement, ready measurement
    measurement_field_list: []
    */
};var photoListProps = {
    key: 0,
    id: 0,
    photo_path: ''
};

var addressProps = {
    key: 0,
    id: 0,
    contact_name: '',
    address: '',
    address2: '',
    city_id: null,
    province_id: null,
    country_id: null,
    postal_code: '',
    contact_number: '',
    address_digital_map_location: '',
    address_label: '',
    edit_mode: true
};

var discussionProps = {
    id: 0,
    description: '',
    source: '',
    created_at: new Date(),
    staff_name: ''
};

var dataProps = {
    id: 0,
    type_of_customer: 0, //individual, business
    tag_list: [],
    customer_code: null,
    company_name: '',
    salutation_id: 1,
    customer_name: '',
    primary_mobile_number_calling_code: null,
    primary_mobile_number: '',
    secondary_mobile_number_calling_code: null,
    secondary_mobile_number: '',
    email_address: '',
    send_alert: true,
    tax_registration_number: '',
    profile_photo: '',
    store_id: 0,

    address: '',
    address2: '',
    city_id: null,
    province_id: null,
    country_id: null,
    postal_code: '',
    billing_currency_id: null,
    address_digital_map_location: '',

    married: false,
    date_of_marriage: '',
    date_of_birth: '',

    gender: null, //male, female, other
    age: 0,
    additional_notes: '',

    old_weight: '',
    new_weight: '',
    height: '',
    assigned_to_staff_id: null,

    photo_list: [JSON.parse(JSON.stringify(photoListProps))],
    measurement_profile_list: [],
    temp_measurement_profile_list: [],
    update_master_msmt: false,

    show_master_sheet: true,
    measurement_master_size_id: null,
    measurement_master_measured_by_staff_id: null,
    measurement_master_sheet: [],
    search_key: '',
    google_etag: [],
    google_resource_name: '',

    discussion_list: [JSON.parse(JSON.stringify(discussionProps))],

    address_list: [JSON.parse(JSON.stringify(addressProps))],
    delete_address_list: [],
    loading_measurements: false
};

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    selected: false,
    key: 0,
    sl_no: 0,
    id: 0,

    tailoring_item_id: 0,
    size_id: 0,
    tailoring_detail: null,
    tailoring_qty: 1,
    is_combination_tailoring_item: false,
    combination_item_list: [],
    tailoring_trial_required: false,
    fabric_id: 0,
    fabric_detail: null,
    fabric_unit_qty: 0,
    sale_category_id: 0,
    wo_processing: false,
    work_order: [],
    work_order_id: 0,

    retail_item_id: 0,
    retail_detail: null,
    retail_qty: 1,

    tailoring_unit_rate: 0,
    tailoring_unit_discount_amount: 0,
    extra_charge_unit_rate: 0,
    extra_charge_unit_discount_amount: 0,
    extra_charge_description: '',
    fabric_unit_rate: 0,
    fabric_actual_rate: 0,
    fabric_price_fixed: false,
    fabric_unit_discount_amount: 0,

    retail_unit_rate: 0,
    retail_unit_discount_amount: 0,

    purchase_request_id: 0,
    purchase_request_qty: 0,
    purchase_request_description: '',

    sub_total: 0,

    discount_percent: 0,
    discount_amount: 0,

    taxable_total: 0,

    show_item_breakup_in_invoice: false,
    tailoring_tax_percent: 0,
    fabric_tax_percent: 0,
    tailoring_tax_amount: 0,
    fabric_tax_amount: 0,

    tax_percent: 0,
    tax_amount: 0,
    net_total: 0,

    alter_net_total: 0,
    is_cancelled: 0,
    extra_amount: 0,
    extra_amount_reason: '',

    store_id: 0,
    notes: '',

    canceled_sale_id: 0

};

var dataProps = {
    id: 0,
    walk_in_customer: false,
    sale_type: 0, //estimate, order, invoice, mo
    mo_type: 0,
    sale_number: null,
    external_number: '',

    sale_date: new Date(),
    delivery_date: new Date(),
    trial_required: false,
    trial_date: "",

    customer_id: null,
    paying_customer_id: null,
    paying_customer_detail: { id: 0, customer_name: '', profile_photo: '' },
    sale_person_staff_id: null,
    store_id: null,

    additional_notes: '',
    total_qty: 0,
    sub_total: 0,
    discount_percent: 0,
    discount_amount: 0,
    taxable_total: 0,

    gst_type: 0, //cgst + sgst or igst
    tax_id: 0,
    tax_detail: null,

    total_tax: 0,
    shipping_and_handling: 0,
    adjustment: 0,
    net_total: 0,

    total_paid: 0,
    sale_status: 0,
    balance: 0,

    advance_amount: 0,
    advance_payment_mode_id: null,
    tender_amount: 0,

    discount_coupon_id: 0,
    discount_coupon_code: '',
    discount_coupon_percent: 0,
    discount_coupon_fixed_amount: 0,
    billing_currency_id: null,
    exchange_rate: 0,
    invoice_ids: [],
    round_off: false,
    e_cart_id: 0,
    delivery_mode_id: null,

    cancel_original_sale_ref_id: 0,

    item_list_loading: false,

    tag_list: [],
    item_list: [],
    deleted_item_list: []
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    store_id: null,
    customer_id: null,
    sale_id: 0,
    payment_date: new Date(),
    additional_notes: '',
    paid_amount: 0,
    redeemed_amount: 0,
    advance_payment: false,
    payment_mode_id: null,
    gift_card_id: null,
    adjustment: 0,
    image_path: ''
};

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    voucher_number: null,
    external_number: '',
    store_id: null,
    customer_id: null,
    sale_person_staff_id: null,
    message: '',
    sale_date: new Date(),
    expiry_date: new Date(),
    amount: 0,
    payment_mode_id: null,
    redeem_customer_payment_id: 0
};

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    item_detail: null
};

var dataProps = {
    id: 0,
    challan_number: null,
    challan_date: new Date(),
    delivered_by_staff_id: null,
    notes: '',
    personal_remarks: '',
    customer_id: null,
    salutation_name: null,
    customer_name: null,
    approved_by_staff_id: null,
    shipment_partner_id: null,
    mail_customer: false,
    customer_shipping_address_id: 0,
    photo: '',
    otp: '',
    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    pending_list: []
};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return navProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return plannerProps; });
var navProps = {
    page_number: 1,
    had_results: false,
    limit: 10,
    total: 0,
    sort_column_name: 'appointment_date', //'t2.appointment_date',
    sort_direction: 0,
    search_term: '',

    list_type: '',
    process_id: 0,
    workshop_id: 0,
    customer_id: null,
    multi_store_search: false,
    pending_approval: false,
    custom_batch: false,
    store_list: [],
    date_range: ['', ''],
    search_term_array: []
};

var plannerProps = {
    dynamic_tab: {
        active_tab: '1',
        visible: false,
        label: ''
    },
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.appointment_date',
        sort_direction: 0,
        search_term: '',
        search_term_array: []
    },
    list: null,
    search_type: 0,
    store_id: null,
    planner_type: 2, //weekly, monthly, all
    start_date: null,
    end_date: null,
    date_range: ['', ''],
    do_not_mutate_date: false,
    nav_type: '+',
    date_label: ''
};

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    inventory_item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    qty: 1,
    notes: '',
    item_edit: 0
};

var dataProps = {
    id: 0,
    store_id: null,
    challan_number: null,
    issue_date: new Date(),
    issued_to_staff_id: null,
    issued_by_staff_id: null,
    production_id: null,
    tailoring_item_id: null,
    work_order_number: '',
    notes: '',

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    item_detail: null
};

var dataProps = {
    id: 0,
    from_store_id: null,
    to_store_id: null,
    transfer_number: null,
    transfer_date: new Date(),
    generated_by_staff_id: null,
    status: 0, //draft, dispatched, accepted, canceled

    dispatch_date: new Date(),
    dispatch_by_staff_id: null,
    dispatch_notes: '',

    accept_date: new Date(),
    accept_by_staff_id: null,
    accept_notes: '',

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    work_order_number: null,
    production_work_log_id: 0,
    work_order_process_id: 0,
    sub_tailoring_item_id: 0,
    tailoring_item_id: 0,
    finished: false
};

var dataProps = {
    id: 0,
    store_id: null,
    challan_number: null,
    sourcing_date: new Date(),
    expected_return_date: new Date(),
    staff_id: null,
    sourced_by_staff_id: null,
    notes: '',
    status: 0,
    process_id: null,

    item_list: []
};

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    description: '',
    qty: 1,
    conversion_qty: 1,
    item_edit: 0
};

var dataProps = {
    id: 0,
    store_id: null,
    challan_number: null,
    transaction_date: new Date(),
    additional_notes: '',
    source_item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    item_edit: false,
    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    coupon_code: '',
    discount_percent: 0,
    active: true,
    active_date_range: ['', ''],
    eligible_store_id: 0,
    discount_fixed_amount: 0,
    maximum_count: 0
};

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productionCapacityListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var productionCapacityListProps = {
    sl_no: 0,
    id: 0,
    store_id: null,
    capacity_per_day: 0
};

var dataProps = {
    category_id: null,
    capacity_list: [JSON.parse(JSON.stringify(productionCapacityListProps))],
    deleted_capacity_list_items: []
};

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    staff_id: null,
    voucher_number: '',
    date_of_loan: new Date(),
    notes: '',
    repayment_starts_from: new Date(),
    repayment_amount: 0,
    loan_amount: 0,
    loan_balance: 0,
    store_id: null,
    bank_id: null,
    repayment_list: []
};

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    tax_id: 0,
    entry_type: 0,
    description: '',
    amount: 0,
    remarks: '',
    read_only: false
};

var dataProps = {
    id: 0,
    staff_id: null,
    store_id: null,
    payroll_number: null,
    payment_date: new Date(),
    payroll_period: ['', ''],
    notes: '',
    total_payable: 0,
    status: 0,
    bank_id: null,

    //misc
    deduction_per_day: 0,
    hour_rate: 0,
    in_time: "",
    out_time: "",
    overtime_list: [],
    //end

    production_work_list: [],
    attendance_list: [],
    sales_commission_list: [],
    loan_repayment_list: [],
    payroll_item_list: []
};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    rack_name: '',
    description: ''
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return measurementDropDownListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return measurementListProps; });
var measurementDropDownListProps = {
    key: 0,
    id: 0,
    measurement_value: '',
    measurement_instruction_image: ''
};

var measurementListProps = {
    sl_no: 0,
    id: 0,
    measurement_name: '',
    measurement_name_translation: '',
    measurement_value_fixed: false, //single-line, dropdown-list
    measurement_instruction_image: '',
    category_id_list: [],
    measurement_drop_down_list: [JSON.parse(JSON.stringify(measurementDropDownListProps))],
    deleted_measurement_drop_down_list_items: []
};

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export logProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var logProps = {
    id: 0,
    service_date: '',
    activity_type: 0,
    supervised_by_staff_id: null,
    service_done_by_contact_id: null,
    notes: '',
    image: ''
};

var dataProps = {
    id: 0,
    asset_number: '',
    model_number: '',
    asset_name: '',
    description: '',
    issued_to: null,
    caretaker_id: null,
    service_interval: [],
    store_id: null,
    profile_photo: '',
    purchase_date: '',
    warranty_active: true,
    warranty_expiry_date: '',

    log_list: []
};

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    key: 0,
    id: 0,
    category_id: null,
    title: '',
    title_prefix: '',
    task_date: new Date(),
    task_time: '',
    assigned_to_staff_id: null,
    created_by_staff_id: null,
    description: '',
    internal_notes: '',
    reminder_1: 0,
    reminder_2: 0,
    notify_followers: false,
    priority: 0,
    status: 0,
    task_type: 0,
    revised: false,
    revision_count: 0,
    document: '',
    followers: []
};

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    partner_name: '',
    tracking_url: '',
    domestic_rate: 0,
    international_rate: 0
};

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    cluster_name: ''
};

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return paymentTermListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var paymentTermListProps = {
    key: 0,
    payment_date: new Date(),
    amount: 0
};

var itemListProps = {
    key: 0,
    id: 0,
    description: '',
    tax_id: 0,
    qty: 1,
    unit_rate: 0,
    sub_total: 0,
    tax_percent: 0,
    tax_amount: 0,
    net_total: 0,
    item_edit: 0
};

var dataProps = {
    id: 0,
    vendor_id: null,
    store_id: null,
    home_currency_id: 0,
    billing_currency_id: 0,
    exchange_rate: 0,
    purchase_order_id: 0,
    purchase_order_number: '',
    bill_number: '',
    bill_date: new Date(),
    sub_total: 0,
    discount_amount: 0,
    taxable_total: 0,
    tax_deduction: 0,
    tax_percent: 0,
    tax_amount: 0,
    reverse_charge_applicable: false,
    gst_type: 0,
    shipping_and_handling: 0,
    adjustment: 0,
    net_total: 0,
    total_paid: 0,
    additional_notes: '',
    expense_sub_category_id: null,
    tax_id: null,

    item_list: [JSON.parse(JSON.stringify(itemListProps))],
    payment_term: [JSON.parse(JSON.stringify(paymentTermListProps))],
    tax_list: []
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    template_name: '',
    subject: '',
    matter: ''
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '' },
    description: '',
    qty: 1,
    unit_rate: 0,
    item_edit: 0
};

var dataProps = {
    id: 0,
    store_id: null,
    additional_notes: '',
    generated_by_staff_id: 0,
    estimated_total_cost: 0,

    item_list: [JSON.parse(JSON.stringify(itemListProps))]
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataProps */
var dataProps = {
    id: 0,
    from_store_id: null,
    to_store_id: null,
    entry_date: new Date(),
    from_bank_id: null,
    to_bank_id: null,
    additional_notes: '',
    amount: 0,
    issued_to_staff_id: null,
    issued_by_staff_id: null
};

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    store_id: null,
    section_name: '',
    news_title: '',
    news_sub_title: '',
    news_preview: '',
    news_detail: '',
    image: '',
    active: true
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    id: 0,
    item_id: null,
    item_detail: { id: 0, sku_code: '', article_name: '', unit_name: '', profile_photo: '' },
    set_as_main_item: false,
    item_edit: 0
};

var dataProps = {
    id: 0,
    catalog_number: 0,
    store_id: null,
    catalog_title: '',
    display_type: 1, //public, private
    customer_id: null,
    customer_detail: { customer_name: '', profile_photo: '' },
    description: '',
    image: '',
    internal_notes: '',

    item_list: []
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    trial_type: '',
    remarks: ''
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    status: 0,
    campaign_title: '',
    schedule_date: '',
    store_id: null,
    email_subject: '',
    email_message: '',
    whatsapp_message: '',
    whatsapp_attachment: '',
    sms: '',
    sms_template_id: '',
    sms_entity_id: '',
    customer_list: [],
    internal_remarks: '',
    nav: {
        search_term: '',
        search_criteria: []
    }
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    category_name: '',
    remarks: '',
    active: true
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    id: 0,
    category_id: null,
    sl_no: 0,
    applicable_stores: []
};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basicCartVariantProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customChoiceFabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return footerNoteProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dataProps; });
var basicCartVariantProps = {
   key: 0,
   item_id: null,
   item_detail: { id: 0, profile_photo: '', sku_code: '', article_name: '', unit_name: '' },
   photo_list: []
};

var customChoiceFabric = {
   key: 0,
   suggested_fabric: [],
   style_option_id: 0
};

var footerNoteProps = {
   key: 0,
   title: '',
   description: ''
};

var dataProps = {
   id: 0,
   active: true,
   inventory_item: { id: null, sku_code: '', article_name: '', photo_list: [] },

   category_id_list: [],

   listing_title: '',
   listing_price: 0,
   listing_discounted_price: 0,

   basic_cart_selection_variant_id: 0,
   basic_cart_selection_item_list: [],

   other_selection_variant_id: 0,
   other_selection_variant_item_list: [],

   look_book_item_list: [],

   can_customise: false,
   customise_tailoring_optional: true,

   customise_tailoring_item_template: { id: null, template_name: '', style_choice_list: [], custom_choice_list: [] },
   default_stitching_fabric: { id: 0, sku_code: '', article_name: '' },
   suggested_base_fabric: [],
   custom_choise_fabric: [],

   footer_note_list: [JSON.parse(JSON.stringify(footerNoteProps))],
   applicable_stores: []
};

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return itemListProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return featureItemProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var itemListProps = {
    key: 0,
    item_id: null,
    item_detail: { id: 0, profile_photo: '', sku_code: '', article_name: '', unit_name: '' },
    link: '',
    title: '',
    image_path: ''
};

var featureItemProps = {
    key: 0,
    title: '',
    link: '',
    item_list: []
};

var dataProps = {
    id: 0,
    home_page_banner_type: 0, //dual pane, slider, single banner

    dual_pane_items: [JSON.parse(JSON.stringify(itemListProps)), JSON.parse(JSON.stringify(itemListProps))],
    slider_items: [JSON.parse(JSON.stringify(itemListProps))],
    single_banner_item: JSON.parse(JSON.stringify(itemListProps)),

    show_feature_list: false,
    feature_list_items: [JSON.parse(JSON.stringify(featureItemProps))],
    applicable_stores: []
};

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    sale_id: 0,
    tailoring_item: { id: 0, detail: null },
    fabric: { id: 0, detail: null },
    customer: { id: 0, detail: null },
    store_id: null,
    sales_man_id: 0
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof2(exports)) === 'object' && ( false ? 'undefined' : _typeof2(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof2(exports)) === 'object') exports["Quill"] = factory();else root["Quill"] = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 109);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var container_1 = __webpack_require__(17);
      var format_1 = __webpack_require__(18);
      var leaf_1 = __webpack_require__(19);
      var scroll_1 = __webpack_require__(45);
      var inline_1 = __webpack_require__(46);
      var block_1 = __webpack_require__(47);
      var embed_1 = __webpack_require__(48);
      var text_1 = __webpack_require__(49);
      var attributor_1 = __webpack_require__(12);
      var class_1 = __webpack_require__(32);
      var style_1 = __webpack_require__(33);
      var store_1 = __webpack_require__(31);
      var Registry = __webpack_require__(1);
      var Parchment = {
        Scope: Registry.Scope,
        create: Registry.create,
        find: Registry.find,
        query: Registry.query,
        register: Registry.register,
        Container: container_1.default,
        Format: format_1.default,
        Leaf: leaf_1.default,
        Embed: embed_1.default,
        Scroll: scroll_1.default,
        Block: block_1.default,
        Inline: inline_1.default,
        Text: text_1.default,
        Attributor: {
          Attribute: attributor_1.default,
          Class: class_1.default,
          Style: style_1.default,
          Store: store_1.default
        }
      };
      exports.default = Parchment;

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var ParchmentError = /** @class */function (_super) {
        __extends(ParchmentError, _super);
        function ParchmentError(message) {
          var _this = this;
          message = '[Parchment] ' + message;
          _this = _super.call(this, message) || this;
          _this.message = message;
          _this.name = _this.constructor.name;
          return _this;
        }
        return ParchmentError;
      }(Error);
      exports.ParchmentError = ParchmentError;
      var attributes = {};
      var classes = {};
      var tags = {};
      var types = {};
      exports.DATA_KEY = '__blot';
      var Scope;
      (function (Scope) {
        Scope[Scope["TYPE"] = 3] = "TYPE";
        Scope[Scope["LEVEL"] = 12] = "LEVEL";
        Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
        Scope[Scope["BLOT"] = 14] = "BLOT";
        Scope[Scope["INLINE"] = 7] = "INLINE";
        Scope[Scope["BLOCK"] = 11] = "BLOCK";
        Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
        Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
        Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
        Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
        Scope[Scope["ANY"] = 15] = "ANY";
      })(Scope = exports.Scope || (exports.Scope = {}));
      function create(input, value) {
        var match = query(input);
        if (match == null) {
          throw new ParchmentError("Unable to create " + input + " blot");
        }
        var BlotClass = match;
        var node =
        // @ts-ignore
        input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
        return new BlotClass(node, value);
      }
      exports.create = create;
      function find(node, bubble) {
        if (bubble === void 0) {
          bubble = false;
        }
        if (node == null) return null;
        // @ts-ignore
        if (node[exports.DATA_KEY] != null) return node[exports.DATA_KEY].blot;
        if (bubble) return find(node.parentNode, bubble);
        return null;
      }
      exports.find = find;
      function query(query, scope) {
        if (scope === void 0) {
          scope = Scope.ANY;
        }
        var match;
        if (typeof query === 'string') {
          match = types[query] || attributes[query];
          // @ts-ignore
        } else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
          match = types['text'];
        } else if (typeof query === 'number') {
          if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
          } else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
          }
        } else if (query instanceof HTMLElement) {
          var names = (query.getAttribute('class') || '').split(/\s+/);
          for (var i in names) {
            match = classes[names[i]];
            if (match) break;
          }
          match = match || tags[query.tagName];
        }
        if (match == null) return null;
        // @ts-ignore
        if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope) return match;
        return null;
      }
      exports.query = query;
      function register() {
        var Definitions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          Definitions[_i] = arguments[_i];
        }
        if (Definitions.length > 1) {
          return Definitions.map(function (d) {
            return register(d);
          });
        }
        var Definition = Definitions[0];
        if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
          throw new ParchmentError('Invalid definition');
        } else if (Definition.blotName === 'abstract') {
          throw new ParchmentError('Cannot register abstract class');
        }
        types[Definition.blotName || Definition.attrName] = Definition;
        if (typeof Definition.keyName === 'string') {
          attributes[Definition.keyName] = Definition;
        } else {
          if (Definition.className != null) {
            classes[Definition.className] = Definition;
          }
          if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
              Definition.tagName = Definition.tagName.map(function (tagName) {
                return tagName.toUpperCase();
              });
            } else {
              Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
              if (tags[tag] == null || Definition.className == null) {
                tags[tag] = Definition;
              }
            });
          }
        }
        return Definition;
      }
      exports.register = register;

      /***/
    },
    /* 2 */
    /***/function (module, exports, __webpack_require__) {

      var diff = __webpack_require__(51);
      var equal = __webpack_require__(11);
      var extend = __webpack_require__(3);
      var op = __webpack_require__(20);

      var NULL_CHARACTER = String.fromCharCode(0); // Placeholder char for embed in diff()


      var Delta = function Delta(ops) {
        // Assume we are given a well formed ops
        if (Array.isArray(ops)) {
          this.ops = ops;
        } else if (ops != null && Array.isArray(ops.ops)) {
          this.ops = ops.ops;
        } else {
          this.ops = [];
        }
      };

      Delta.prototype.insert = function (text, attributes) {
        var newOp = {};
        if (text.length === 0) return this;
        newOp.insert = text;
        if (attributes != null && (typeof attributes === 'undefined' ? 'undefined' : _typeof2(attributes)) === 'object' && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }
        return this.push(newOp);
      };

      Delta.prototype['delete'] = function (length) {
        if (length <= 0) return this;
        return this.push({ 'delete': length });
      };

      Delta.prototype.retain = function (length, attributes) {
        if (length <= 0) return this;
        var newOp = { retain: length };
        if (attributes != null && (typeof attributes === 'undefined' ? 'undefined' : _typeof2(attributes)) === 'object' && Object.keys(attributes).length > 0) {
          newOp.attributes = attributes;
        }
        return this.push(newOp);
      };

      Delta.prototype.push = function (newOp) {
        var index = this.ops.length;
        var lastOp = this.ops[index - 1];
        newOp = extend(true, {}, newOp);
        if ((typeof lastOp === 'undefined' ? 'undefined' : _typeof2(lastOp)) === 'object') {
          if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
            this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
            return this;
          }
          // Since it does not matter if we insert before or after deleting at the same index,
          // always prefer to insert first
          if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
            index -= 1;
            lastOp = this.ops[index - 1];
            if ((typeof lastOp === 'undefined' ? 'undefined' : _typeof2(lastOp)) !== 'object') {
              this.ops.unshift(newOp);
              return this;
            }
          }
          if (equal(newOp.attributes, lastOp.attributes)) {
            if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
              this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
              if (_typeof2(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
              return this;
            } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
              this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
              if (_typeof2(newOp.attributes) === 'object') this.ops[index - 1].attributes = newOp.attributes;
              return this;
            }
          }
        }
        if (index === this.ops.length) {
          this.ops.push(newOp);
        } else {
          this.ops.splice(index, 0, newOp);
        }
        return this;
      };

      Delta.prototype.chop = function () {
        var lastOp = this.ops[this.ops.length - 1];
        if (lastOp && lastOp.retain && !lastOp.attributes) {
          this.ops.pop();
        }
        return this;
      };

      Delta.prototype.filter = function (predicate) {
        return this.ops.filter(predicate);
      };

      Delta.prototype.forEach = function (predicate) {
        this.ops.forEach(predicate);
      };

      Delta.prototype.map = function (predicate) {
        return this.ops.map(predicate);
      };

      Delta.prototype.partition = function (predicate) {
        var passed = [],
            failed = [];
        this.forEach(function (op) {
          var target = predicate(op) ? passed : failed;
          target.push(op);
        });
        return [passed, failed];
      };

      Delta.prototype.reduce = function (predicate, initial) {
        return this.ops.reduce(predicate, initial);
      };

      Delta.prototype.changeLength = function () {
        return this.reduce(function (length, elem) {
          if (elem.insert) {
            return length + op.length(elem);
          } else if (elem.delete) {
            return length - elem.delete;
          }
          return length;
        }, 0);
      };

      Delta.prototype.length = function () {
        return this.reduce(function (length, elem) {
          return length + op.length(elem);
        }, 0);
      };

      Delta.prototype.slice = function (start, end) {
        start = start || 0;
        if (typeof end !== 'number') end = Infinity;
        var ops = [];
        var iter = op.iterator(this.ops);
        var index = 0;
        while (index < end && iter.hasNext()) {
          var nextOp;
          if (index < start) {
            nextOp = iter.next(start - index);
          } else {
            nextOp = iter.next(end - index);
            ops.push(nextOp);
          }
          index += op.length(nextOp);
        }
        return new Delta(ops);
      };

      Delta.prototype.compose = function (other) {
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var ops = [];
        var firstOther = otherIter.peek();
        if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
          var firstLeft = firstOther.retain;
          while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
            firstLeft -= thisIter.peekLength();
            ops.push(thisIter.next());
          }
          if (firstOther.retain - firstLeft > 0) {
            otherIter.next(firstOther.retain - firstLeft);
          }
        }
        var delta = new Delta(ops);
        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (otherIter.peekType() === 'insert') {
            delta.push(otherIter.next());
          } else if (thisIter.peekType() === 'delete') {
            delta.push(thisIter.next());
          } else {
            var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length);
            var otherOp = otherIter.next(length);
            if (typeof otherOp.retain === 'number') {
              var newOp = {};
              if (typeof thisOp.retain === 'number') {
                newOp.retain = length;
              } else {
                newOp.insert = thisOp.insert;
              }
              // Preserve null when composing with a retain, otherwise remove it for inserts
              var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
              if (attributes) newOp.attributes = attributes;
              delta.push(newOp);

              // Optimization if rest of other is just retain
              if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                var rest = new Delta(thisIter.rest());
                return delta.concat(rest).chop();
              }

              // Other op should be delete, we could be an insert or retain
              // Insert + delete cancels out
            } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
              delta.push(otherOp);
            }
          }
        }
        return delta.chop();
      };

      Delta.prototype.concat = function (other) {
        var delta = new Delta(this.ops.slice());
        if (other.ops.length > 0) {
          delta.push(other.ops[0]);
          delta.ops = delta.ops.concat(other.ops.slice(1));
        }
        return delta;
      };

      Delta.prototype.diff = function (other, index) {
        if (this.ops === other.ops) {
          return new Delta();
        }
        var strings = [this, other].map(function (delta) {
          return delta.map(function (op) {
            if (op.insert != null) {
              return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
            }
            var prep = delta === other ? 'on' : 'with';
            throw new Error('diff() called ' + prep + ' non-document');
          }).join('');
        });
        var delta = new Delta();
        var diffResult = diff(strings[0], strings[1], index);
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        diffResult.forEach(function (component) {
          var length = component[1].length;
          while (length > 0) {
            var opLength = 0;
            switch (component[0]) {
              case diff.INSERT:
                opLength = Math.min(otherIter.peekLength(), length);
                delta.push(otherIter.next(opLength));
                break;
              case diff.DELETE:
                opLength = Math.min(length, thisIter.peekLength());
                thisIter.next(opLength);
                delta['delete'](opLength);
                break;
              case diff.EQUAL:
                opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                var thisOp = thisIter.next(opLength);
                var otherOp = otherIter.next(opLength);
                if (equal(thisOp.insert, otherOp.insert)) {
                  delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                } else {
                  delta.push(otherOp)['delete'](opLength);
                }
                break;
            }
            length -= opLength;
          }
        });
        return delta.chop();
      };

      Delta.prototype.eachLine = function (predicate, newline) {
        newline = newline || '\n';
        var iter = op.iterator(this.ops);
        var line = new Delta();
        var i = 0;
        while (iter.hasNext()) {
          if (iter.peekType() !== 'insert') return;
          var thisOp = iter.peek();
          var start = op.length(thisOp) - iter.peekLength();
          var index = typeof thisOp.insert === 'string' ? thisOp.insert.indexOf(newline, start) - start : -1;
          if (index < 0) {
            line.push(iter.next());
          } else if (index > 0) {
            line.push(iter.next(index));
          } else {
            if (predicate(line, iter.next(1).attributes || {}, i) === false) {
              return;
            }
            i += 1;
            line = new Delta();
          }
        }
        if (line.length() > 0) {
          predicate(line, {}, i);
        }
      };

      Delta.prototype.transform = function (other, priority) {
        priority = !!priority;
        if (typeof other === 'number') {
          return this.transformPosition(other, priority);
        }
        var thisIter = op.iterator(this.ops);
        var otherIter = op.iterator(other.ops);
        var delta = new Delta();
        while (thisIter.hasNext() || otherIter.hasNext()) {
          if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
            delta.retain(op.length(thisIter.next()));
          } else if (otherIter.peekType() === 'insert') {
            delta.push(otherIter.next());
          } else {
            var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
            var thisOp = thisIter.next(length);
            var otherOp = otherIter.next(length);
            if (thisOp['delete']) {
              // Our delete either makes their delete redundant or removes their retain
              continue;
            } else if (otherOp['delete']) {
              delta.push(otherOp);
            } else {
              // We retain either their retain or insert
              delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
            }
          }
        }
        return delta.chop();
      };

      Delta.prototype.transformPosition = function (index, priority) {
        priority = !!priority;
        var thisIter = op.iterator(this.ops);
        var offset = 0;
        while (thisIter.hasNext() && offset <= index) {
          var length = thisIter.peekLength();
          var nextType = thisIter.peekType();
          thisIter.next();
          if (nextType === 'delete') {
            index -= Math.min(length, index - offset);
            continue;
          } else if (nextType === 'insert' && (offset < index || !priority)) {
            index += length;
          }
          offset += length;
        }
        return index;
      };

      module.exports = Delta;

      /***/
    },
    /* 3 */
    /***/function (module, exports) {

      'use strict';

      var hasOwn = Object.prototype.hasOwnProperty;
      var toStr = Object.prototype.toString;
      var defineProperty = Object.defineProperty;
      var gOPD = Object.getOwnPropertyDescriptor;

      var isArray = function isArray(arr) {
        if (typeof Array.isArray === 'function') {
          return Array.isArray(arr);
        }

        return toStr.call(arr) === '[object Array]';
      };

      var isPlainObject = function isPlainObject(obj) {
        if (!obj || toStr.call(obj) !== '[object Object]') {
          return false;
        }

        var hasOwnConstructor = hasOwn.call(obj, 'constructor');
        var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
        // Not own constructor property must be Object
        if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
          return false;
        }

        // Own properties are enumerated firstly, so to speed up,
        // if last one is own, then all properties are own.
        var key;
        for (key in obj) {/**/}

        return typeof key === 'undefined' || hasOwn.call(obj, key);
      };

      // If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
      var setProperty = function setProperty(target, options) {
        if (defineProperty && options.name === '__proto__') {
          defineProperty(target, options.name, {
            enumerable: true,
            configurable: true,
            value: options.newValue,
            writable: true
          });
        } else {
          target[options.name] = options.newValue;
        }
      };

      // Return undefined instead of __proto__ if '__proto__' is not an own property
      var getProperty = function getProperty(obj, name) {
        if (name === '__proto__') {
          if (!hasOwn.call(obj, name)) {
            return void 0;
          } else if (gOPD) {
            // In early versions of node, obj['__proto__'] is buggy when obj has
            // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
            return gOPD(obj, name).value;
          }
        }

        return obj[name];
      };

      module.exports = function extend() {
        var options, name, src, copy, copyIsArray, clone;
        var target = arguments[0];
        var i = 1;
        var length = arguments.length;
        var deep = false;

        // Handle a deep copy situation
        if (typeof target === 'boolean') {
          deep = target;
          target = arguments[1] || {};
          // skip the boolean and the target
          i = 2;
        }
        if (target == null || (typeof target === 'undefined' ? 'undefined' : _typeof2(target)) !== 'object' && typeof target !== 'function') {
          target = {};
        }

        for (; i < length; ++i) {
          options = arguments[i];
          // Only deal with non-null/undefined values
          if (options != null) {
            // Extend the base object
            for (name in options) {
              src = getProperty(target, name);
              copy = getProperty(options, name);

              // Prevent never-ending loop
              if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                  if (copyIsArray) {
                    copyIsArray = false;
                    clone = src && isArray(src) ? src : [];
                  } else {
                    clone = src && isPlainObject(src) ? src : {};
                  }

                  // Never move original objects, clone them
                  setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

                  // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') {
                  setProperty(target, { name: name, newValue: copy });
                }
              }
            }
          }
        }

        // Return the modified object
        return target;
      };

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var NEWLINE_LENGTH = 1;

      var BlockEmbed = function (_Parchment$Embed) {
        _inherits(BlockEmbed, _Parchment$Embed);

        function BlockEmbed() {
          _classCallCheck(this, BlockEmbed);

          return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
        }

        _createClass(BlockEmbed, [{
          key: 'attach',
          value: function attach() {
            _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
            this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
          }
        }, {
          key: 'delta',
          value: function delta() {
            return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
            if (attribute != null) {
              this.attributes.attribute(attribute, value);
            }
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            this.format(name, value);
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (typeof value === 'string' && value.endsWith('\n')) {
              var block = _parchment2.default.create(Block.blotName);
              this.parent.insertBefore(block, index === 0 ? this : this.next);
              block.insertAt(0, value.slice(0, -1));
            } else {
              _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
            }
          }
        }]);

        return BlockEmbed;
      }(_parchment2.default.Embed);

      BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
      // It is important for cursor behavior BlockEmbeds use tags that are block level elements


      var Block = function (_Parchment$Block) {
        _inherits(Block, _Parchment$Block);

        function Block(domNode) {
          _classCallCheck(this, Block);

          var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

          _this2.cache = {};
          return _this2;
        }

        _createClass(Block, [{
          key: 'delta',
          value: function delta() {
            if (this.cache.delta == null) {
              this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
                if (leaf.length() === 0) {
                  return delta;
                } else {
                  return delta.insert(leaf.value(), bubbleFormats(leaf));
                }
              }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
            }
            return this.cache.delta;
          }
        }, {
          key: 'deleteAt',
          value: function deleteAt(index, length) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
            this.cache = {};
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (length <= 0) return;
            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
              if (index + length === this.length()) {
                this.format(name, value);
              }
            } else {
              _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
            }
            this.cache = {};
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
            if (value.length === 0) return;
            var lines = value.split('\n');
            var text = lines.shift();
            if (text.length > 0) {
              if (index < this.length() - 1 || this.children.tail == null) {
                _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
              } else {
                this.children.tail.insertAt(this.children.tail.length(), text);
              }
              this.cache = {};
            }
            var block = this;
            lines.reduce(function (index, line) {
              block = block.split(index, true);
              block.insertAt(0, line);
              return line.length;
            }, index + text.length);
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            var head = this.children.head;
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
            if (head instanceof _break2.default) {
              head.remove();
            }
            this.cache = {};
          }
        }, {
          key: 'length',
          value: function length() {
            if (this.cache.length == null) {
              this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
            }
            return this.cache.length;
          }
        }, {
          key: 'moveChildren',
          value: function moveChildren(target, ref) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
            this.cache = {};
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
            this.cache = {};
          }
        }, {
          key: 'path',
          value: function path(index) {
            return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
          }
        }, {
          key: 'removeChild',
          value: function removeChild(child) {
            _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
            this.cache = {};
          }
        }, {
          key: 'split',
          value: function split(index) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
              var clone = this.clone();
              if (index === 0) {
                this.parent.insertBefore(clone, this);
                return this;
              } else {
                this.parent.insertBefore(clone, this.next);
                return clone;
              }
            } else {
              var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
              this.cache = {};
              return next;
            }
          }
        }]);

        return Block;
      }(_parchment2.default.Block);

      Block.blotName = 'block';
      Block.tagName = 'P';
      Block.defaultChild = 'break';
      Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

      function bubbleFormats(blot) {
        var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (blot == null) return formats;
        if (typeof blot.formats === 'function') {
          formats = (0, _extend2.default)(formats, blot.formats());
        }
        if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
          return formats;
        }
        return bubbleFormats(blot.parent, formats);
      }

      exports.bubbleFormats = bubbleFormats;
      exports.BlockEmbed = BlockEmbed;
      exports.default = Block;

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.overload = exports.expandConfig = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      __webpack_require__(50);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _editor = __webpack_require__(14);

      var _editor2 = _interopRequireDefault(_editor);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _selection = __webpack_require__(15);

      var _selection2 = _interopRequireDefault(_selection);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)('quill');

      var Quill = function () {
        _createClass(Quill, null, [{
          key: 'debug',
          value: function debug(limit) {
            if (limit === true) {
              limit = 'log';
            }
            _logger2.default.level(limit);
          }
        }, {
          key: 'find',
          value: function find(node) {
            return node.__quill || _parchment2.default.find(node);
          }
        }, {
          key: 'import',
          value: function _import(name) {
            if (this.imports[name] == null) {
              debug.error('Cannot import ' + name + '. Are you sure it was registered?');
            }
            return this.imports[name];
          }
        }, {
          key: 'register',
          value: function register(path, target) {
            var _this = this;

            var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            if (typeof path !== 'string') {
              var name = path.attrName || path.blotName;
              if (typeof name === 'string') {
                // register(Blot | Attributor, overwrite)
                this.register('formats/' + name, path, target);
              } else {
                Object.keys(path).forEach(function (key) {
                  _this.register(key, path[key], target);
                });
              }
            } else {
              if (this.imports[path] != null && !overwrite) {
                debug.warn('Overwriting ' + path + ' with', target);
              }
              this.imports[path] = target;
              if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
                _parchment2.default.register(target);
              } else if (path.startsWith('modules') && typeof target.register === 'function') {
                target.register();
              }
            }
          }
        }]);

        function Quill(container) {
          var _this2 = this;

          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          _classCallCheck(this, Quill);

          this.options = expandConfig(container, options);
          this.container = this.options.container;
          if (this.container == null) {
            return debug.error('Invalid Quill container', container);
          }
          if (this.options.debug) {
            Quill.debug(this.options.debug);
          }
          var html = this.container.innerHTML.trim();
          this.container.classList.add('ql-container');
          this.container.innerHTML = '';
          this.container.__quill = this;
          this.root = this.addContainer('ql-editor');
          this.root.classList.add('ql-blank');
          this.root.setAttribute('data-gramm', false);
          this.scrollingContainer = this.options.scrollingContainer || this.root;
          this.emitter = new _emitter4.default();
          this.scroll = _parchment2.default.create(this.root, {
            emitter: this.emitter,
            whitelist: this.options.formats
          });
          this.editor = new _editor2.default(this.scroll);
          this.selection = new _selection2.default(this.scroll, this.emitter);
          this.theme = new this.options.theme(this, this.options);
          this.keyboard = this.theme.addModule('keyboard');
          this.clipboard = this.theme.addModule('clipboard');
          this.history = this.theme.addModule('history');
          this.theme.init();
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
            if (type === _emitter4.default.events.TEXT_CHANGE) {
              _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
            var range = _this2.selection.lastRange;
            var index = range && range.length === 0 ? range.index : undefined;
            modify.call(_this2, function () {
              return _this2.editor.update(null, mutations, index);
            }, source);
          });
          var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
          this.setContents(contents);
          this.history.clear();
          if (this.options.placeholder) {
            this.root.setAttribute('data-placeholder', this.options.placeholder);
          }
          if (this.options.readOnly) {
            this.disable();
          }
        }

        _createClass(Quill, [{
          key: 'addContainer',
          value: function addContainer(container) {
            var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (typeof container === 'string') {
              var className = container;
              container = document.createElement('div');
              container.classList.add(className);
            }
            this.container.insertBefore(container, refNode);
            return container;
          }
        }, {
          key: 'blur',
          value: function blur() {
            this.selection.setRange(null);
          }
        }, {
          key: 'deleteText',
          value: function deleteText(index, length, source) {
            var _this3 = this;

            var _overload = overload(index, length, source);

            var _overload2 = _slicedToArray(_overload, 4);

            index = _overload2[0];
            length = _overload2[1];
            source = _overload2[3];

            return modify.call(this, function () {
              return _this3.editor.deleteText(index, length);
            }, source, index, -1 * length);
          }
        }, {
          key: 'disable',
          value: function disable() {
            this.enable(false);
          }
        }, {
          key: 'enable',
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.scroll.enable(enabled);
            this.container.classList.toggle('ql-disabled', !enabled);
          }
        }, {
          key: 'focus',
          value: function focus() {
            var scrollTop = this.scrollingContainer.scrollTop;
            this.selection.focus();
            this.scrollingContainer.scrollTop = scrollTop;
            this.scrollIntoView();
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            var _this4 = this;

            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              var range = _this4.getSelection(true);
              var change = new _quillDelta2.default();
              if (range == null) {
                return change;
              } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
              } else if (range.length === 0) {
                _this4.selection.format(name, value);
                return change;
              } else {
                change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
              }
              _this4.setSelection(range, _emitter4.default.sources.SILENT);
              return change;
            }, source);
          }
        }, {
          key: 'formatLine',
          value: function formatLine(index, length, name, value, source) {
            var _this5 = this;

            var formats = void 0;

            var _overload3 = overload(index, length, name, value, source);

            var _overload4 = _slicedToArray(_overload3, 4);

            index = _overload4[0];
            length = _overload4[1];
            formats = _overload4[2];
            source = _overload4[3];

            return modify.call(this, function () {
              return _this5.editor.formatLine(index, length, formats);
            }, source, index, 0);
          }
        }, {
          key: 'formatText',
          value: function formatText(index, length, name, value, source) {
            var _this6 = this;

            var formats = void 0;

            var _overload5 = overload(index, length, name, value, source);

            var _overload6 = _slicedToArray(_overload5, 4);

            index = _overload6[0];
            length = _overload6[1];
            formats = _overload6[2];
            source = _overload6[3];

            return modify.call(this, function () {
              return _this6.editor.formatText(index, length, formats);
            }, source, index, 0);
          }
        }, {
          key: 'getBounds',
          value: function getBounds(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var bounds = void 0;
            if (typeof index === 'number') {
              bounds = this.selection.getBounds(index, length);
            } else {
              bounds = this.selection.getBounds(index.index, index.length);
            }
            var containerBounds = this.container.getBoundingClientRect();
            return {
              bottom: bounds.bottom - containerBounds.top,
              height: bounds.height,
              left: bounds.left - containerBounds.left,
              right: bounds.right - containerBounds.left,
              top: bounds.top - containerBounds.top,
              width: bounds.width
            };
          }
        }, {
          key: 'getContents',
          value: function getContents() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

            var _overload7 = overload(index, length);

            var _overload8 = _slicedToArray(_overload7, 2);

            index = _overload8[0];
            length = _overload8[1];

            return this.editor.getContents(index, length);
          }
        }, {
          key: 'getFormat',
          value: function getFormat() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (typeof index === 'number') {
              return this.editor.getFormat(index, length);
            } else {
              return this.editor.getFormat(index.index, index.length);
            }
          }
        }, {
          key: 'getIndex',
          value: function getIndex(blot) {
            return blot.offset(this.scroll);
          }
        }, {
          key: 'getLength',
          value: function getLength() {
            return this.scroll.length();
          }
        }, {
          key: 'getLeaf',
          value: function getLeaf(index) {
            return this.scroll.leaf(index);
          }
        }, {
          key: 'getLine',
          value: function getLine(index) {
            return this.scroll.line(index);
          }
        }, {
          key: 'getLines',
          value: function getLines() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

            if (typeof index !== 'number') {
              return this.scroll.lines(index.index, index.length);
            } else {
              return this.scroll.lines(index, length);
            }
          }
        }, {
          key: 'getModule',
          value: function getModule(name) {
            return this.theme.modules[name];
          }
        }, {
          key: 'getSelection',
          value: function getSelection() {
            var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (focus) this.focus();
            this.update(); // Make sure we access getRange with editor in consistent state
            return this.selection.getRange()[0];
          }
        }, {
          key: 'getText',
          value: function getText() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

            var _overload9 = overload(index, length);

            var _overload10 = _slicedToArray(_overload9, 2);

            index = _overload10[0];
            length = _overload10[1];

            return this.editor.getText(index, length);
          }
        }, {
          key: 'hasFocus',
          value: function hasFocus() {
            return this.selection.hasFocus();
          }
        }, {
          key: 'insertEmbed',
          value: function insertEmbed(index, embed, value) {
            var _this7 = this;

            var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

            return modify.call(this, function () {
              return _this7.editor.insertEmbed(index, embed, value);
            }, source, index);
          }
        }, {
          key: 'insertText',
          value: function insertText(index, text, name, value, source) {
            var _this8 = this;

            var formats = void 0;

            var _overload11 = overload(index, 0, name, value, source);

            var _overload12 = _slicedToArray(_overload11, 4);

            index = _overload12[0];
            formats = _overload12[2];
            source = _overload12[3];

            return modify.call(this, function () {
              return _this8.editor.insertText(index, text, formats);
            }, source, index, text.length);
          }
        }, {
          key: 'isEnabled',
          value: function isEnabled() {
            return !this.container.classList.contains('ql-disabled');
          }
        }, {
          key: 'off',
          value: function off() {
            return this.emitter.off.apply(this.emitter, arguments);
          }
        }, {
          key: 'on',
          value: function on() {
            return this.emitter.on.apply(this.emitter, arguments);
          }
        }, {
          key: 'once',
          value: function once() {
            return this.emitter.once.apply(this.emitter, arguments);
          }
        }, {
          key: 'pasteHTML',
          value: function pasteHTML(index, html, source) {
            this.clipboard.dangerouslyPasteHTML(index, html, source);
          }
        }, {
          key: 'removeFormat',
          value: function removeFormat(index, length, source) {
            var _this9 = this;

            var _overload13 = overload(index, length, source);

            var _overload14 = _slicedToArray(_overload13, 4);

            index = _overload14[0];
            length = _overload14[1];
            source = _overload14[3];

            return modify.call(this, function () {
              return _this9.editor.removeFormat(index, length);
            }, source, index);
          }
        }, {
          key: 'scrollIntoView',
          value: function scrollIntoView() {
            this.selection.scrollIntoView(this.scrollingContainer);
          }
        }, {
          key: 'setContents',
          value: function setContents(delta) {
            var _this10 = this;

            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);
              var length = _this10.getLength();
              var deleted = _this10.editor.deleteText(0, length);
              var applied = _this10.editor.applyDelta(delta);
              var lastOp = applied.ops[applied.ops.length - 1];
              if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
                _this10.editor.deleteText(_this10.getLength() - 1, 1);
                applied.delete(1);
              }
              var ret = deleted.compose(applied);
              return ret;
            }, source);
          }
        }, {
          key: 'setSelection',
          value: function setSelection(index, length, source) {
            if (index == null) {
              this.selection.setRange(null, length || Quill.sources.API);
            } else {
              var _overload15 = overload(index, length, source);

              var _overload16 = _slicedToArray(_overload15, 4);

              index = _overload16[0];
              length = _overload16[1];
              source = _overload16[3];

              this.selection.setRange(new _selection.Range(index, length), source);
              if (source !== _emitter4.default.sources.SILENT) {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }
          }
        }, {
          key: 'setText',
          value: function setText(text) {
            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            var delta = new _quillDelta2.default().insert(text);
            return this.setContents(delta, source);
          }
        }, {
          key: 'update',
          value: function update() {
            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

            var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
            this.selection.update(source);
            return change;
          }
        }, {
          key: 'updateContents',
          value: function updateContents(delta) {
            var _this11 = this;

            var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

            return modify.call(this, function () {
              delta = new _quillDelta2.default(delta);
              return _this11.editor.applyDelta(delta, source);
            }, source, true);
          }
        }]);

        return Quill;
      }();

      Quill.DEFAULTS = {
        bounds: null,
        formats: null,
        modules: {},
        placeholder: '',
        readOnly: false,
        scrollingContainer: null,
        strict: true,
        theme: 'default'
      };
      Quill.events = _emitter4.default.events;
      Quill.sources = _emitter4.default.sources;
      // eslint-disable-next-line no-undef
      Quill.version = false ? 'dev' : "1.3.7";

      Quill.imports = {
        'delta': _quillDelta2.default,
        'parchment': _parchment2.default,
        'core/module': _module2.default,
        'core/theme': _theme2.default
      };

      function expandConfig(container, userConfig) {
        userConfig = (0, _extend2.default)(true, {
          container: container,
          modules: {
            clipboard: true,
            keyboard: true,
            history: true
          }
        }, userConfig);
        if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
          userConfig.theme = _theme2.default;
        } else {
          userConfig.theme = Quill.import('themes/' + userConfig.theme);
          if (userConfig.theme == null) {
            throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
          }
        }
        var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
        [themeConfig, userConfig].forEach(function (config) {
          config.modules = config.modules || {};
          Object.keys(config.modules).forEach(function (module) {
            if (config.modules[module] === true) {
              config.modules[module] = {};
            }
          });
        });
        var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
        var moduleConfig = moduleNames.reduce(function (config, name) {
          var moduleClass = Quill.import('modules/' + name);
          if (moduleClass == null) {
            debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
          } else {
            config[name] = moduleClass.DEFAULTS || {};
          }
          return config;
        }, {});
        // Special case toolbar shorthand
        if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
          userConfig.modules.toolbar = {
            container: userConfig.modules.toolbar
          };
        }
        userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
        ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
          if (typeof userConfig[key] === 'string') {
            userConfig[key] = document.querySelector(userConfig[key]);
          }
        });
        userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
          if (userConfig.modules[name]) {
            config[name] = userConfig.modules[name];
          }
          return config;
        }, {});
        return userConfig;
      }

      // Handle selection preservation and TEXT_CHANGE emission
      // common to modification APIs
      function modify(modifier, source, index, shift) {
        if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
          return new _quillDelta2.default();
        }
        var range = index == null ? null : this.getSelection();
        var oldDelta = this.editor.delta;
        var change = modifier();
        if (range != null) {
          if (index === true) index = range.index;
          if (shift == null) {
            range = shiftRange(range, change, source);
          } else if (shift !== 0) {
            range = shiftRange(range, index, shift, source);
          }
          this.setSelection(range, _emitter4.default.sources.SILENT);
        }
        if (change.length() > 0) {
          var _emitter;

          var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
          (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
          if (source !== _emitter4.default.sources.SILENT) {
            var _emitter2;

            (_emitter2 = this.emitter).emit.apply(_emitter2, args);
          }
        }
        return change;
      }

      function overload(index, length, name, value, source) {
        var formats = {};
        if (typeof index.index === 'number' && typeof index.length === 'number') {
          // Allow for throwaway end (used by insertText/insertEmbed)
          if (typeof length !== 'number') {
            source = value, value = name, name = length, length = index.length, index = index.index;
          } else {
            length = index.length, index = index.index;
          }
        } else if (typeof length !== 'number') {
          source = value, value = name, name = length, length = 0;
        }
        // Handle format being object, two format name/value strings or excluded
        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
          formats = name;
          source = value;
        } else if (typeof name === 'string') {
          if (value != null) {
            formats[name] = value;
          } else {
            source = name;
          }
        }
        // Handle optional source
        source = source || _emitter4.default.sources.API;
        return [index, length, formats, source];
      }

      function shiftRange(range, index, length, source) {
        if (range == null) return null;
        var start = void 0,
            end = void 0;
        if (index instanceof _quillDelta2.default) {
          var _map = [range.index, range.index + range.length].map(function (pos) {
            return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
          });

          var _map2 = _slicedToArray(_map, 2);

          start = _map2[0];
          end = _map2[1];
        } else {
          var _map3 = [range.index, range.index + range.length].map(function (pos) {
            if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
            if (length >= 0) {
              return pos + length;
            } else {
              return Math.max(index, pos + length);
            }
          });

          var _map4 = _slicedToArray(_map3, 2);

          start = _map4[0];
          end = _map4[1];
        }
        return new _selection.Range(start, end - start);
      }

      exports.expandConfig = expandConfig;
      exports.overload = overload;
      exports.default = Quill;

      /***/
    },
    /* 6 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Inline = function (_Parchment$Inline) {
        _inherits(Inline, _Parchment$Inline);

        function Inline() {
          _classCallCheck(this, Inline);

          return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
        }

        _createClass(Inline, [{
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
              var blot = this.isolate(index, length);
              if (value) {
                blot.wrap(name, value);
              }
            } else {
              _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
            if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
              var parent = this.parent.isolate(this.offset(), this.length());
              this.moveChildren(parent);
              parent.wrap(this);
            }
          }
        }], [{
          key: 'compare',
          value: function compare(self, other) {
            var selfIndex = Inline.order.indexOf(self);
            var otherIndex = Inline.order.indexOf(other);
            if (selfIndex >= 0 || otherIndex >= 0) {
              return selfIndex - otherIndex;
            } else if (self === other) {
              return 0;
            } else if (self < other) {
              return -1;
            } else {
              return 1;
            }
          }
        }]);

        return Inline;
      }(_parchment2.default.Inline);

      Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
      // Lower index means deeper in the DOM tree, since not found (-1) is for embeds
      Inline.order = ['cursor', 'inline', // Must be lower
      'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
      ];

      exports.default = Inline;

      /***/
    },
    /* 7 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TextBlot = function (_Parchment$Text) {
        _inherits(TextBlot, _Parchment$Text);

        function TextBlot() {
          _classCallCheck(this, TextBlot);

          return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
        }

        return TextBlot;
      }(_parchment2.default.Text);

      exports.default = TextBlot;

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _eventemitter = __webpack_require__(54);

      var _eventemitter2 = _interopRequireDefault(_eventemitter);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:events');

      var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

      EVENTS.forEach(function (eventName) {
        document.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
            // TODO use WeakMap
            if (node.__quill && node.__quill.emitter) {
              var _node$__quill$emitter;

              (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
            }
          });
        });
      });

      var Emitter = function (_EventEmitter) {
        _inherits(Emitter, _EventEmitter);

        function Emitter() {
          _classCallCheck(this, Emitter);

          var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

          _this.listeners = {};
          _this.on('error', debug.error);
          return _this;
        }

        _createClass(Emitter, [{
          key: 'emit',
          value: function emit() {
            debug.log.apply(debug, arguments);
            _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
          }
        }, {
          key: 'handleDOM',
          value: function handleDOM(event) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (this.listeners[event.type] || []).forEach(function (_ref) {
              var node = _ref.node,
                  handler = _ref.handler;

              if (event.target === node || node.contains(event.target)) {
                handler.apply(undefined, [event].concat(args));
              }
            });
          }
        }, {
          key: 'listenDOM',
          value: function listenDOM(eventName, node, handler) {
            if (!this.listeners[eventName]) {
              this.listeners[eventName] = [];
            }
            this.listeners[eventName].push({ node: node, handler: handler });
          }
        }]);

        return Emitter;
      }(_eventemitter2.default);

      Emitter.events = {
        EDITOR_CHANGE: 'editor-change',
        SCROLL_BEFORE_UPDATE: 'scroll-before-update',
        SCROLL_OPTIMIZE: 'scroll-optimize',
        SCROLL_UPDATE: 'scroll-update',
        SELECTION_CHANGE: 'selection-change',
        TEXT_CHANGE: 'text-change'
      };
      Emitter.sources = {
        API: 'api',
        SILENT: 'silent',
        USER: 'user'
      };

      exports.default = Emitter;

      /***/
    },
    /* 9 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Module = function Module(quill) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Module);

        this.quill = quill;
        this.options = options;
      };

      Module.DEFAULTS = {};

      exports.default = Module;

      /***/
    },
    /* 10 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var levels = ['error', 'warn', 'log', 'info'];
      var level = 'warn';

      function debug(method) {
        if (levels.indexOf(method) <= levels.indexOf(level)) {
          var _console;

          for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
        }
      }

      function namespace(ns) {
        return levels.reduce(function (logger, method) {
          logger[method] = debug.bind(console, method, ns);
          return logger;
        }, {});
      }

      debug.level = namespace.level = function (newLevel) {
        level = newLevel;
      };

      exports.default = namespace;

      /***/
    },
    /* 11 */
    /***/function (module, exports, __webpack_require__) {

      var pSlice = Array.prototype.slice;
      var objectKeys = __webpack_require__(52);
      var isArguments = __webpack_require__(53);

      var deepEqual = module.exports = function (actual, expected, opts) {
        if (!opts) opts = {};
        // 7.1. All identical values are equivalent, as determined by ===.
        if (actual === expected) {
          return true;
        } else if (actual instanceof Date && expected instanceof Date) {
          return actual.getTime() === expected.getTime();

          // 7.3. Other pairs that do not both pass typeof value == 'object',
          // equivalence is determined by ==.
        } else if (!actual || !expected || (typeof actual === 'undefined' ? 'undefined' : _typeof2(actual)) != 'object' && (typeof expected === 'undefined' ? 'undefined' : _typeof2(expected)) != 'object') {
          return opts.strict ? actual === expected : actual == expected;

          // 7.4. For all other Object pairs, including Array objects, equivalence is
          // determined by having the same number of owned properties (as verified
          // with Object.prototype.hasOwnProperty.call), the same set of keys
          // (although not necessarily the same order), equivalent values for every
          // corresponding key, and an identical 'prototype' property. Note: this
          // accounts for both named and indexed properties on Arrays.
        } else {
          return objEquiv(actual, expected, opts);
        }
      };

      function isUndefinedOrNull(value) {
        return value === null || value === undefined;
      }

      function isBuffer(x) {
        if (!x || (typeof x === 'undefined' ? 'undefined' : _typeof2(x)) !== 'object' || typeof x.length !== 'number') return false;
        if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
          return false;
        }
        if (x.length > 0 && typeof x[0] !== 'number') return false;
        return true;
      }

      function objEquiv(a, b, opts) {
        var i, key;
        if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) return false;
        // an identical 'prototype' property.
        if (a.prototype !== b.prototype) return false;
        //~~~I've managed to break Object.keys through screwy arguments passing.
        //   Converting to array solves the problem.
        if (isArguments(a)) {
          if (!isArguments(b)) {
            return false;
          }
          a = pSlice.call(a);
          b = pSlice.call(b);
          return deepEqual(a, b, opts);
        }
        if (isBuffer(a)) {
          if (!isBuffer(b)) {
            return false;
          }
          if (a.length !== b.length) return false;
          for (i = 0; i < a.length; i++) {
            if (a[i] !== b[i]) return false;
          }
          return true;
        }
        try {
          var ka = objectKeys(a),
              kb = objectKeys(b);
        } catch (e) {
          //happens when one is a string literal and the other isn't
          return false;
        }
        // having the same number of owned properties (keys incorporates
        // hasOwnProperty)
        if (ka.length != kb.length) return false;
        //the same set of keys (although not necessarily the same order),
        ka.sort();
        kb.sort();
        //~~~cheap key test
        for (i = ka.length - 1; i >= 0; i--) {
          if (ka[i] != kb[i]) return false;
        }
        //equivalent values for every corresponding key, and
        //~~~possibly expensive deep test
        for (i = ka.length - 1; i >= 0; i--) {
          key = ka[i];
          if (!deepEqual(a[key], b[key], opts)) return false;
        }
        return (typeof a === 'undefined' ? 'undefined' : _typeof2(a)) === (typeof b === 'undefined' ? 'undefined' : _typeof2(b));
      }

      /***/
    },
    /* 12 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var Registry = __webpack_require__(1);
      var Attributor = /** @class */function () {
        function Attributor(attrName, keyName, options) {
          if (options === void 0) {
            options = {};
          }
          this.attrName = attrName;
          this.keyName = keyName;
          var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
          if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
          } else {
            this.scope = Registry.Scope.ATTRIBUTE;
          }
          if (options.whitelist != null) this.whitelist = options.whitelist;
        }
        Attributor.keys = function (node) {
          return [].map.call(node.attributes, function (item) {
            return item.name;
          });
        };
        Attributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          node.setAttribute(this.keyName, value);
          return true;
        };
        Attributor.prototype.canAdd = function (node, value) {
          var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
          if (match == null) return false;
          if (this.whitelist == null) return true;
          if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
          } else {
            return this.whitelist.indexOf(value) > -1;
          }
        };
        Attributor.prototype.remove = function (node) {
          node.removeAttribute(this.keyName);
        };
        Attributor.prototype.value = function (node) {
          var value = node.getAttribute(this.keyName);
          if (this.canAdd(node, value) && value) {
            return value;
          }
          return '';
        };
        return Attributor;
      }();
      exports.default = Attributor;

      /***/
    },
    /* 13 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.Code = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Code = function (_Inline) {
        _inherits(Code, _Inline);

        function Code() {
          _classCallCheck(this, Code);

          return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
        }

        return Code;
      }(_inline2.default);

      Code.blotName = 'code';
      Code.tagName = 'CODE';

      var CodeBlock = function (_Block) {
        _inherits(CodeBlock, _Block);

        function CodeBlock() {
          _classCallCheck(this, CodeBlock);

          return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
        }

        _createClass(CodeBlock, [{
          key: 'delta',
          value: function delta() {
            var _this3 = this;

            var text = this.domNode.textContent;
            if (text.endsWith('\n')) {
              // Should always be true
              text = text.slice(0, -1);
            }
            return text.split('\n').reduce(function (delta, frag) {
              return delta.insert(frag).insert('\n', _this3.formats());
            }, new _quillDelta2.default());
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            if (name === this.statics.blotName && value) return;

            var _descendant = this.descendant(_text2.default, this.length() - 1),
                _descendant2 = _slicedToArray(_descendant, 1),
                text = _descendant2[0];

            if (text != null) {
              text.deleteAt(text.length() - 1, 1);
            }
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, name, value) {
            if (length === 0) return;
            if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
              return;
            }
            var nextNewline = this.newlineIndex(index);
            if (nextNewline < 0 || nextNewline >= index + length) return;
            var prevNewline = this.newlineIndex(index, true) + 1;
            var isolateLength = nextNewline - prevNewline + 1;
            var blot = this.isolate(prevNewline, isolateLength);
            var next = blot.next;
            blot.format(name, value);
            if (next instanceof CodeBlock) {
              next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
            }
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null) return;

            var _descendant3 = this.descendant(_text2.default, index),
                _descendant4 = _slicedToArray(_descendant3, 2),
                text = _descendant4[0],
                offset = _descendant4[1];

            text.insertAt(offset, value);
          }
        }, {
          key: 'length',
          value: function length() {
            var length = this.domNode.textContent.length;
            if (!this.domNode.textContent.endsWith('\n')) {
              return length + 1;
            }
            return length;
          }
        }, {
          key: 'newlineIndex',
          value: function newlineIndex(searchIndex) {
            var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (!reverse) {
              var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
              return offset > -1 ? searchIndex + offset : -1;
            } else {
              return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            if (!this.domNode.textContent.endsWith('\n')) {
              this.appendChild(_parchment2.default.create('text', '\n'));
            }
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
            var next = this.next;
            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
              next.optimize(context);
              next.moveChildren(this);
              next.remove();
            }
          }
        }, {
          key: 'replace',
          value: function replace(target) {
            _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
            [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
              var blot = _parchment2.default.find(node);
              if (blot == null) {
                node.parentNode.removeChild(node);
              } else if (blot instanceof _parchment2.default.Embed) {
                blot.remove();
              } else {
                blot.unwrap();
              }
            });
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
            domNode.setAttribute('spellcheck', false);
            return domNode;
          }
        }, {
          key: 'formats',
          value: function formats() {
            return true;
          }
        }]);

        return CodeBlock;
      }(_block2.default);

      CodeBlock.blotName = 'code-block';
      CodeBlock.tagName = 'PRE';
      CodeBlock.TAB = '  ';

      exports.Code = Code;
      exports.default = CodeBlock;

      /***/
    },
    /* 14 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _cursor = __webpack_require__(24);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var ASCII = /^[ -~]*$/;

      var Editor = function () {
        function Editor(scroll) {
          _classCallCheck(this, Editor);

          this.scroll = scroll;
          this.delta = this.getDelta();
        }

        _createClass(Editor, [{
          key: 'applyDelta',
          value: function applyDelta(delta) {
            var _this = this;

            var consumeNextNewline = false;
            this.scroll.update();
            var scrollLength = this.scroll.length();
            this.scroll.batchStart();
            delta = normalizeDelta(delta);
            delta.reduce(function (index, op) {
              var length = op.retain || op.delete || op.insert.length || 1;
              var attributes = op.attributes || {};
              if (op.insert != null) {
                if (typeof op.insert === 'string') {
                  var text = op.insert;
                  if (text.endsWith('\n') && consumeNextNewline) {
                    consumeNextNewline = false;
                    text = text.slice(0, -1);
                  }
                  if (index >= scrollLength && !text.endsWith('\n')) {
                    consumeNextNewline = true;
                  }
                  _this.scroll.insertAt(index, text);

                  var _scroll$line = _this.scroll.line(index),
                      _scroll$line2 = _slicedToArray(_scroll$line, 2),
                      line = _scroll$line2[0],
                      offset = _scroll$line2[1];

                  var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
                  if (line instanceof _block2.default) {
                    var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                        _line$descendant2 = _slicedToArray(_line$descendant, 1),
                        leaf = _line$descendant2[0];

                    formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                  }
                  attributes = _op2.default.attributes.diff(formats, attributes) || {};
                } else if (_typeof(op.insert) === 'object') {
                  var key = Object.keys(op.insert)[0]; // There should only be one key
                  if (key == null) return index;
                  _this.scroll.insertAt(index, key, op.insert[key]);
                }
                scrollLength += length;
              }
              Object.keys(attributes).forEach(function (name) {
                _this.scroll.formatAt(index, length, name, attributes[name]);
              });
              return index + length;
            }, 0);
            delta.reduce(function (index, op) {
              if (typeof op.delete === 'number') {
                _this.scroll.deleteAt(index, op.delete);
                return index;
              }
              return index + (op.retain || op.insert.length || 1);
            }, 0);
            this.scroll.batchEnd();
            return this.update(delta);
          }
        }, {
          key: 'deleteText',
          value: function deleteText(index, length) {
            this.scroll.deleteAt(index, length);
            return this.update(new _quillDelta2.default().retain(index).delete(length));
          }
        }, {
          key: 'formatLine',
          value: function formatLine(index, length) {
            var _this2 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            this.scroll.update();
            Object.keys(formats).forEach(function (format) {
              if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
              var lines = _this2.scroll.lines(index, Math.max(length, 1));
              var lengthRemaining = length;
              lines.forEach(function (line) {
                var lineLength = line.length();
                if (!(line instanceof _code2.default)) {
                  line.format(format, formats[format]);
                } else {
                  var codeIndex = index - line.offset(_this2.scroll);
                  var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                  line.formatAt(codeIndex, codeLength, format, formats[format]);
                }
                lengthRemaining -= lineLength;
              });
            });
            this.scroll.optimize();
            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'formatText',
          value: function formatText(index, length) {
            var _this3 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            Object.keys(formats).forEach(function (format) {
              _this3.scroll.formatAt(index, length, format, formats[format]);
            });
            return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'getContents',
          value: function getContents(index, length) {
            return this.delta.slice(index, index + length);
          }
        }, {
          key: 'getDelta',
          value: function getDelta() {
            return this.scroll.lines().reduce(function (delta, line) {
              return delta.concat(line.delta());
            }, new _quillDelta2.default());
          }
        }, {
          key: 'getFormat',
          value: function getFormat(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var lines = [],
                leaves = [];
            if (length === 0) {
              this.scroll.path(index).forEach(function (path) {
                var _path = _slicedToArray(path, 1),
                    blot = _path[0];

                if (blot instanceof _block2.default) {
                  lines.push(blot);
                } else if (blot instanceof _parchment2.default.Leaf) {
                  leaves.push(blot);
                }
              });
            } else {
              lines = this.scroll.lines(index, length);
              leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
            }
            var formatsArr = [lines, leaves].map(function (blots) {
              if (blots.length === 0) return {};
              var formats = (0, _block.bubbleFormats)(blots.shift());
              while (Object.keys(formats).length > 0) {
                var blot = blots.shift();
                if (blot == null) return formats;
                formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
              }
              return formats;
            });
            return _extend2.default.apply(_extend2.default, formatsArr);
          }
        }, {
          key: 'getText',
          value: function getText(index, length) {
            return this.getContents(index, length).filter(function (op) {
              return typeof op.insert === 'string';
            }).map(function (op) {
              return op.insert;
            }).join('');
          }
        }, {
          key: 'insertEmbed',
          value: function insertEmbed(index, embed, value) {
            this.scroll.insertAt(index, embed, value);
            return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
          }
        }, {
          key: 'insertText',
          value: function insertText(index, text) {
            var _this4 = this;

            var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            this.scroll.insertAt(index, text);
            Object.keys(formats).forEach(function (format) {
              _this4.scroll.formatAt(index, text.length, format, formats[format]);
            });
            return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
          }
        }, {
          key: 'isBlank',
          value: function isBlank() {
            if (this.scroll.children.length == 0) return true;
            if (this.scroll.children.length > 1) return false;
            var block = this.scroll.children.head;
            if (block.statics.blotName !== _block2.default.blotName) return false;
            if (block.children.length > 1) return false;
            return block.children.head instanceof _break2.default;
          }
        }, {
          key: 'removeFormat',
          value: function removeFormat(index, length) {
            var text = this.getText(index, length);

            var _scroll$line3 = this.scroll.line(index + length),
                _scroll$line4 = _slicedToArray(_scroll$line3, 2),
                line = _scroll$line4[0],
                offset = _scroll$line4[1];

            var suffixLength = 0,
                suffix = new _quillDelta2.default();
            if (line != null) {
              if (!(line instanceof _code2.default)) {
                suffixLength = line.length() - offset;
              } else {
                suffixLength = line.newlineIndex(offset) - offset + 1;
              }
              suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
            }
            var contents = this.getContents(index, length + suffixLength);
            var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
            var delta = new _quillDelta2.default().retain(index).concat(diff);
            return this.applyDelta(delta);
          }
        }, {
          key: 'update',
          value: function update(change) {
            var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
            var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            var oldDelta = this.delta;
            if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
              // Optimization for character changes
              var textBlot = _parchment2.default.find(mutations[0].target);
              var formats = (0, _block.bubbleFormats)(textBlot);
              var index = textBlot.offset(this.scroll);
              var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
              var oldText = new _quillDelta2.default().insert(oldValue);
              var newText = new _quillDelta2.default().insert(textBlot.value());
              var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
              change = diffDelta.reduce(function (delta, op) {
                if (op.insert) {
                  return delta.insert(op.insert, formats);
                } else {
                  return delta.push(op);
                }
              }, new _quillDelta2.default());
              this.delta = oldDelta.compose(change);
            } else {
              this.delta = this.getDelta();
              if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                change = oldDelta.diff(this.delta, cursorIndex);
              }
            }
            return change;
          }
        }]);

        return Editor;
      }();

      function combineFormats(formats, combined) {
        return Object.keys(combined).reduce(function (merged, name) {
          if (formats[name] == null) return merged;
          if (combined[name] === formats[name]) {
            merged[name] = combined[name];
          } else if (Array.isArray(combined[name])) {
            if (combined[name].indexOf(formats[name]) < 0) {
              merged[name] = combined[name].concat([formats[name]]);
            }
          } else {
            merged[name] = [combined[name], formats[name]];
          }
          return merged;
        }, {});
      }

      function normalizeDelta(delta) {
        return delta.reduce(function (delta, op) {
          if (op.insert === 1) {
            var attributes = (0, _clone2.default)(op.attributes);
            delete attributes['image'];
            return delta.insert({ image: op.attributes.image }, attributes);
          }
          if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
            op = (0, _clone2.default)(op);
            if (op.attributes.list) {
              op.attributes.list = 'ordered';
            } else {
              op.attributes.list = 'bullet';
              delete op.attributes.bullet;
            }
          }
          if (typeof op.insert === 'string') {
            var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
            return delta.insert(text, op.attributes);
          }
          return delta.push(op);
        }, new _quillDelta2.default());
      }

      exports.default = Editor;

      /***/
    },
    /* 15 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.Range = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _emitter3 = __webpack_require__(8);

      var _emitter4 = _interopRequireDefault(_emitter3);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }return arr2;
        } else {
          return Array.from(arr);
        }
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var debug = (0, _logger2.default)('quill:selection');

      var Range = function Range(index) {
        var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, Range);

        this.index = index;
        this.length = length;
      };

      var Selection = function () {
        function Selection(scroll, emitter) {
          var _this = this;

          _classCallCheck(this, Selection);

          this.emitter = emitter;
          this.scroll = scroll;
          this.composing = false;
          this.mouseDown = false;
          this.root = this.scroll.domNode;
          this.cursor = _parchment2.default.create('cursor', this);
          // savedRange is last non-null range
          this.lastRange = this.savedRange = new Range(0, 0);
          this.handleComposition();
          this.handleDragging();
          this.emitter.listenDOM('selectionchange', document, function () {
            if (!_this.mouseDown) {
              setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
            }
          });
          this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
            if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
              _this.update(_emitter4.default.sources.SILENT);
            }
          });
          this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
            if (!_this.hasFocus()) return;
            var native = _this.getNativeRange();
            if (native == null) return;
            if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
            // TODO unclear if this has negative side effects
            _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
              try {
                _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
              } catch (ignored) {}
            });
          });
          this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
            if (context.range) {
              var _context$range = context.range,
                  startNode = _context$range.startNode,
                  startOffset = _context$range.startOffset,
                  endNode = _context$range.endNode,
                  endOffset = _context$range.endOffset;

              _this.setNativeRange(startNode, startOffset, endNode, endOffset);
            }
          });
          this.update(_emitter4.default.sources.SILENT);
        }

        _createClass(Selection, [{
          key: 'handleComposition',
          value: function handleComposition() {
            var _this2 = this;

            this.root.addEventListener('compositionstart', function () {
              _this2.composing = true;
            });
            this.root.addEventListener('compositionend', function () {
              _this2.composing = false;
              if (_this2.cursor.parent) {
                var range = _this2.cursor.restore();
                if (!range) return;
                setTimeout(function () {
                  _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                }, 1);
              }
            });
          }
        }, {
          key: 'handleDragging',
          value: function handleDragging() {
            var _this3 = this;

            this.emitter.listenDOM('mousedown', document.body, function () {
              _this3.mouseDown = true;
            });
            this.emitter.listenDOM('mouseup', document.body, function () {
              _this3.mouseDown = false;
              _this3.update(_emitter4.default.sources.USER);
            });
          }
        }, {
          key: 'focus',
          value: function focus() {
            if (this.hasFocus()) return;
            this.root.focus();
            this.setRange(this.savedRange);
          }
        }, {
          key: 'format',
          value: function format(_format, value) {
            if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
            this.scroll.update();
            var nativeRange = this.getNativeRange();
            if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
            if (nativeRange.start.node !== this.cursor.textNode) {
              var blot = _parchment2.default.find(nativeRange.start.node, false);
              if (blot == null) return;
              // TODO Give blot ability to not split
              if (blot instanceof _parchment2.default.Leaf) {
                var after = blot.split(nativeRange.start.offset);
                blot.parent.insertBefore(this.cursor, after);
              } else {
                blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
              }
              this.cursor.attach();
            }
            this.cursor.format(_format, value);
            this.scroll.optimize();
            this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
            this.update();
          }
        }, {
          key: 'getBounds',
          value: function getBounds(index) {
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            var scrollLength = this.scroll.length();
            index = Math.min(index, scrollLength - 1);
            length = Math.min(index + length, scrollLength - 1) - index;
            var node = void 0,
                _scroll$leaf = this.scroll.leaf(index),
                _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
                leaf = _scroll$leaf2[0],
                offset = _scroll$leaf2[1];
            if (leaf == null) return null;

            var _leaf$position = leaf.position(offset, true);

            var _leaf$position2 = _slicedToArray(_leaf$position, 2);

            node = _leaf$position2[0];
            offset = _leaf$position2[1];

            var range = document.createRange();
            if (length > 0) {
              range.setStart(node, offset);

              var _scroll$leaf3 = this.scroll.leaf(index + length);

              var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

              leaf = _scroll$leaf4[0];
              offset = _scroll$leaf4[1];

              if (leaf == null) return null;

              var _leaf$position3 = leaf.position(offset, true);

              var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

              node = _leaf$position4[0];
              offset = _leaf$position4[1];

              range.setEnd(node, offset);
              return range.getBoundingClientRect();
            } else {
              var side = 'left';
              var rect = void 0;
              if (node instanceof Text) {
                if (offset < node.data.length) {
                  range.setStart(node, offset);
                  range.setEnd(node, offset + 1);
                } else {
                  range.setStart(node, offset - 1);
                  range.setEnd(node, offset);
                  side = 'right';
                }
                rect = range.getBoundingClientRect();
              } else {
                rect = leaf.domNode.getBoundingClientRect();
                if (offset > 0) side = 'right';
              }
              return {
                bottom: rect.top + rect.height,
                height: rect.height,
                left: rect[side],
                right: rect[side],
                top: rect.top,
                width: 0
              };
            }
          }
        }, {
          key: 'getNativeRange',
          value: function getNativeRange() {
            var selection = document.getSelection();
            if (selection == null || selection.rangeCount <= 0) return null;
            var nativeRange = selection.getRangeAt(0);
            if (nativeRange == null) return null;
            var range = this.normalizeNative(nativeRange);
            debug.info('getNativeRange', range);
            return range;
          }
        }, {
          key: 'getRange',
          value: function getRange() {
            var normalized = this.getNativeRange();
            if (normalized == null) return [null, null];
            var range = this.normalizedToRange(normalized);
            return [range, normalized];
          }
        }, {
          key: 'hasFocus',
          value: function hasFocus() {
            return document.activeElement === this.root;
          }
        }, {
          key: 'normalizedToRange',
          value: function normalizedToRange(range) {
            var _this4 = this;

            var positions = [[range.start.node, range.start.offset]];
            if (!range.native.collapsed) {
              positions.push([range.end.node, range.end.offset]);
            }
            var indexes = positions.map(function (position) {
              var _position = _slicedToArray(position, 2),
                  node = _position[0],
                  offset = _position[1];

              var blot = _parchment2.default.find(node, true);
              var index = blot.offset(_this4.scroll);
              if (offset === 0) {
                return index;
              } else if (blot instanceof _parchment2.default.Container) {
                return index + blot.length();
              } else {
                return index + blot.index(node, offset);
              }
            });
            var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
            var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
            return new Range(start, end - start);
          }
        }, {
          key: 'normalizeNative',
          value: function normalizeNative(nativeRange) {
            if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
              return null;
            }
            var range = {
              start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
              end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
              native: nativeRange
            };
            [range.start, range.end].forEach(function (position) {
              var node = position.node,
                  offset = position.offset;
              while (!(node instanceof Text) && node.childNodes.length > 0) {
                if (node.childNodes.length > offset) {
                  node = node.childNodes[offset];
                  offset = 0;
                } else if (node.childNodes.length === offset) {
                  node = node.lastChild;
                  offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                } else {
                  break;
                }
              }
              position.node = node, position.offset = offset;
            });
            return range;
          }
        }, {
          key: 'rangeToNative',
          value: function rangeToNative(range) {
            var _this5 = this;

            var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
            var args = [];
            var scrollLength = this.scroll.length();
            indexes.forEach(function (index, i) {
              index = Math.min(scrollLength - 1, index);
              var node = void 0,
                  _scroll$leaf5 = _this5.scroll.leaf(index),
                  _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
                  leaf = _scroll$leaf6[0],
                  offset = _scroll$leaf6[1];
              var _leaf$position5 = leaf.position(offset, i !== 0);

              var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

              node = _leaf$position6[0];
              offset = _leaf$position6[1];

              args.push(node, offset);
            });
            if (args.length < 2) {
              args = args.concat(args);
            }
            return args;
          }
        }, {
          key: 'scrollIntoView',
          value: function scrollIntoView(scrollingContainer) {
            var range = this.lastRange;
            if (range == null) return;
            var bounds = this.getBounds(range.index, range.length);
            if (bounds == null) return;
            var limit = this.scroll.length() - 1;

            var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
                _scroll$line2 = _slicedToArray(_scroll$line, 1),
                first = _scroll$line2[0];

            var last = first;
            if (range.length > 0) {
              var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

              var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

              last = _scroll$line4[0];
            }
            if (first == null || last == null) return;
            var scrollBounds = scrollingContainer.getBoundingClientRect();
            if (bounds.top < scrollBounds.top) {
              scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
            } else if (bounds.bottom > scrollBounds.bottom) {
              scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
            }
          }
        }, {
          key: 'setNativeRange',
          value: function setNativeRange(startNode, startOffset) {
            var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
            var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
            var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

            debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
            if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
              return;
            }
            var selection = document.getSelection();
            if (selection == null) return;
            if (startNode != null) {
              if (!this.hasFocus()) this.root.focus();
              var native = (this.getNativeRange() || {}).native;
              if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

                if (startNode.tagName == "BR") {
                  startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                  startNode = startNode.parentNode;
                }
                if (endNode.tagName == "BR") {
                  endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                  endNode = endNode.parentNode;
                }
                var range = document.createRange();
                range.setStart(startNode, startOffset);
                range.setEnd(endNode, endOffset);
                selection.removeAllRanges();
                selection.addRange(range);
              }
            } else {
              selection.removeAllRanges();
              this.root.blur();
              document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
            }
          }
        }, {
          key: 'setRange',
          value: function setRange(range) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

            if (typeof force === 'string') {
              source = force;
              force = false;
            }
            debug.info('setRange', range);
            if (range != null) {
              var args = this.rangeToNative(range);
              this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
            } else {
              this.setNativeRange(null);
            }
            this.update(source);
          }
        }, {
          key: 'update',
          value: function update() {
            var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

            var oldRange = this.lastRange;

            var _getRange = this.getRange(),
                _getRange2 = _slicedToArray(_getRange, 2),
                lastRange = _getRange2[0],
                nativeRange = _getRange2[1];

            this.lastRange = lastRange;
            if (this.lastRange != null) {
              this.savedRange = this.lastRange;
            }
            if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
              var _emitter;

              if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                this.cursor.restore();
              }
              var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
              (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
              if (source !== _emitter4.default.sources.SILENT) {
                var _emitter2;

                (_emitter2 = this.emitter).emit.apply(_emitter2, args);
              }
            }
          }
        }]);

        return Selection;
      }();

      function contains(parent, descendant) {
        try {
          // Firefox inserts inaccessible nodes around video elements
          descendant.parentNode;
        } catch (e) {
          return false;
        }
        // IE11 has bug with Text nodes
        // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
        if (descendant instanceof Text) {
          descendant = descendant.parentNode;
        }
        return parent.contains(descendant);
      }

      exports.Range = Range;
      exports.default = Selection;

      /***/
    },
    /* 16 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Break = function (_Parchment$Embed) {
        _inherits(Break, _Parchment$Embed);

        function Break() {
          _classCallCheck(this, Break);

          return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
        }

        _createClass(Break, [{
          key: 'insertInto',
          value: function insertInto(parent, ref) {
            if (parent.children.length === 0) {
              _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
            } else {
              this.remove();
            }
          }
        }, {
          key: 'length',
          value: function length() {
            return 0;
          }
        }, {
          key: 'value',
          value: function value() {
            return '';
          }
        }], [{
          key: 'value',
          value: function value() {
            return undefined;
          }
        }]);

        return Break;
      }(_parchment2.default.Embed);

      Break.blotName = 'break';
      Break.tagName = 'BR';

      exports.default = Break;

      /***/
    },
    /* 17 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var linked_list_1 = __webpack_require__(44);
      var shadow_1 = __webpack_require__(30);
      var Registry = __webpack_require__(1);
      var ContainerBlot = /** @class */function (_super) {
        __extends(ContainerBlot, _super);
        function ContainerBlot(domNode) {
          var _this = _super.call(this, domNode) || this;
          _this.build();
          return _this;
        }
        ContainerBlot.prototype.appendChild = function (other) {
          this.insertBefore(other);
        };
        ContainerBlot.prototype.attach = function () {
          _super.prototype.attach.call(this);
          this.children.forEach(function (child) {
            child.attach();
          });
        };
        ContainerBlot.prototype.build = function () {
          var _this = this;
          this.children = new linked_list_1.default();
          // Need to be reversed for if DOM nodes already in order
          [].slice.call(this.domNode.childNodes).reverse().forEach(function (node) {
            try {
              var child = makeBlot(node);
              _this.insertBefore(child, _this.children.head || undefined);
            } catch (err) {
              if (err instanceof Registry.ParchmentError) return;else throw err;
            }
          });
        };
        ContainerBlot.prototype.deleteAt = function (index, length) {
          if (index === 0 && length === this.length()) {
            return this.remove();
          }
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
          });
        };
        ContainerBlot.prototype.descendant = function (criteria, index) {
          var _a = this.children.find(index),
              child = _a[0],
              offset = _a[1];
          if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
            return [child, offset];
          } else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
          } else {
            return [null, -1];
          }
        };
        ContainerBlot.prototype.descendants = function (criteria, index, length) {
          if (index === void 0) {
            index = 0;
          }
          if (length === void 0) {
            length = Number.MAX_VALUE;
          }
          var descendants = [];
          var lengthLeft = length;
          this.children.forEachAt(index, length, function (child, index, length) {
            if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
              descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
              descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
          });
          return descendants;
        };
        ContainerBlot.prototype.detach = function () {
          this.children.forEach(function (child) {
            child.detach();
          });
          _super.prototype.detach.call(this);
        };
        ContainerBlot.prototype.formatAt = function (index, length, name, value) {
          this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
          });
        };
        ContainerBlot.prototype.insertAt = function (index, value, def) {
          var _a = this.children.find(index),
              child = _a[0],
              offset = _a[1];
          if (child) {
            child.insertAt(offset, value, def);
          } else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
          }
        };
        ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
          if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function (child) {
            return childBlot instanceof child;
          })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
          }
          childBlot.insertInto(this, refBlot);
        };
        ContainerBlot.prototype.length = function () {
          return this.children.reduce(function (memo, child) {
            return memo + child.length();
          }, 0);
        };
        ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
          this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
          });
        };
        ContainerBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
              var child = Registry.create(this.statics.defaultChild);
              this.appendChild(child);
              child.optimize(context);
            } else {
              this.remove();
            }
          }
        };
        ContainerBlot.prototype.path = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var _a = this.children.find(index, inclusive),
              child = _a[0],
              offset = _a[1];
          var position = [[this, index]];
          if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
          } else if (child != null) {
            position.push([child, offset]);
          }
          return position;
        };
        ContainerBlot.prototype.removeChild = function (child) {
          this.children.remove(child);
        };
        ContainerBlot.prototype.replace = function (target) {
          if (target instanceof ContainerBlot) {
            target.moveChildren(this);
          }
          _super.prototype.replace.call(this, target);
        };
        ContainerBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = this.clone();
          this.parent.insertBefore(after, this.next);
          this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
          });
          return after;
        };
        ContainerBlot.prototype.unwrap = function () {
          this.moveChildren(this.parent, this.next);
          this.remove();
        };
        ContainerBlot.prototype.update = function (mutations, context) {
          var _this = this;
          var addedNodes = [];
          var removedNodes = [];
          mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
              addedNodes.push.apply(addedNodes, mutation.addedNodes);
              removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
          });
          removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
            // @ts-ignore
            node.tagName !== 'IFRAME' && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
              return;
            }
            var blot = Registry.find(node);
            if (blot == null) return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
              blot.detach();
            }
          });
          addedNodes.filter(function (node) {
            return node.parentNode == _this.domNode;
          }).sort(function (a, b) {
            if (a === b) return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
              return 1;
            }
            return -1;
          }).forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
              refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
              if (blot.parent != null) {
                blot.parent.removeChild(_this);
              }
              _this.insertBefore(blot, refBlot || undefined);
            }
          });
        };
        return ContainerBlot;
      }(shadow_1.default);
      function makeBlot(node) {
        var blot = Registry.find(node);
        if (blot == null) {
          try {
            blot = Registry.create(node);
          } catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
              // @ts-ignore
              blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
              node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
          }
        }
        return blot;
      }
      exports.default = ContainerBlot;

      /***/
    },
    /* 18 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      var store_1 = __webpack_require__(31);
      var container_1 = __webpack_require__(17);
      var Registry = __webpack_require__(1);
      var FormatBlot = /** @class */function (_super) {
        __extends(FormatBlot, _super);
        function FormatBlot(domNode) {
          var _this = _super.call(this, domNode) || this;
          _this.attributes = new store_1.default(_this.domNode);
          return _this;
        }
        FormatBlot.formats = function (domNode) {
          if (typeof this.tagName === 'string') {
            return true;
          } else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
          }
          return undefined;
        };
        FormatBlot.prototype.format = function (name, value) {
          var format = Registry.query(name);
          if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
          } else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
              this.replaceWith(name, value);
            }
          }
        };
        FormatBlot.prototype.formats = function () {
          var formats = this.attributes.values();
          var format = this.statics.formats(this.domNode);
          if (format != null) {
            formats[this.statics.blotName] = format;
          }
          return formats;
        };
        FormatBlot.prototype.replaceWith = function (name, value) {
          var replacement = _super.prototype.replaceWith.call(this, name, value);
          this.attributes.copy(replacement);
          return replacement;
        };
        FormatBlot.prototype.update = function (mutations, context) {
          var _this = this;
          _super.prototype.update.call(this, mutations, context);
          if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
          })) {
            this.attributes.build();
          }
        };
        FormatBlot.prototype.wrap = function (name, value) {
          var wrapper = _super.prototype.wrap.call(this, name, value);
          if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
          }
          return wrapper;
        };
        return FormatBlot;
      }(container_1.default);
      exports.default = FormatBlot;

      /***/
    },
    /* 19 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var shadow_1 = __webpack_require__(30);
      var Registry = __webpack_require__(1);
      var LeafBlot = /** @class */function (_super) {
        __extends(LeafBlot, _super);
        function LeafBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        LeafBlot.value = function (domNode) {
          return true;
        };
        LeafBlot.prototype.index = function (node, offset) {
          if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
          }
          return -1;
        };
        LeafBlot.prototype.position = function (index, inclusive) {
          var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
          if (index > 0) offset += 1;
          return [this.parent.domNode, offset];
        };
        LeafBlot.prototype.value = function () {
          var _a;
          return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
        };
        LeafBlot.scope = Registry.Scope.INLINE_BLOT;
        return LeafBlot;
      }(shadow_1.default);
      exports.default = LeafBlot;

      /***/
    },
    /* 20 */
    /***/function (module, exports, __webpack_require__) {

      var equal = __webpack_require__(11);
      var extend = __webpack_require__(3);

      var lib = {
        attributes: {
          compose: function compose(a, b, keepNull) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') a = {};
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') b = {};
            var attributes = extend(true, {}, b);
            if (!keepNull) {
              attributes = Object.keys(attributes).reduce(function (copy, key) {
                if (attributes[key] != null) {
                  copy[key] = attributes[key];
                }
                return copy;
              }, {});
            }
            for (var key in a) {
              if (a[key] !== undefined && b[key] === undefined) {
                attributes[key] = a[key];
              }
            }
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          },

          diff: function diff(a, b) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') a = {};
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') b = {};
            var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
              if (!equal(a[key], b[key])) {
                attributes[key] = b[key] === undefined ? null : b[key];
              }
              return attributes;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          },

          transform: function transform(a, b, priority) {
            if ((typeof a === 'undefined' ? 'undefined' : _typeof2(a)) !== 'object') return b;
            if ((typeof b === 'undefined' ? 'undefined' : _typeof2(b)) !== 'object') return undefined;
            if (!priority) return b; // b simply overwrites us without priority
            var attributes = Object.keys(b).reduce(function (attributes, key) {
              if (a[key] === undefined) attributes[key] = b[key]; // null is a valid value
              return attributes;
            }, {});
            return Object.keys(attributes).length > 0 ? attributes : undefined;
          }
        },

        iterator: function iterator(ops) {
          return new Iterator(ops);
        },

        length: function length(op) {
          if (typeof op['delete'] === 'number') {
            return op['delete'];
          } else if (typeof op.retain === 'number') {
            return op.retain;
          } else {
            return typeof op.insert === 'string' ? op.insert.length : 1;
          }
        }
      };

      function Iterator(ops) {
        this.ops = ops;
        this.index = 0;
        this.offset = 0;
      };

      Iterator.prototype.hasNext = function () {
        return this.peekLength() < Infinity;
      };

      Iterator.prototype.next = function (length) {
        if (!length) length = Infinity;
        var nextOp = this.ops[this.index];
        if (nextOp) {
          var offset = this.offset;
          var opLength = lib.length(nextOp);
          if (length >= opLength - offset) {
            length = opLength - offset;
            this.index += 1;
            this.offset = 0;
          } else {
            this.offset += length;
          }
          if (typeof nextOp['delete'] === 'number') {
            return { 'delete': length };
          } else {
            var retOp = {};
            if (nextOp.attributes) {
              retOp.attributes = nextOp.attributes;
            }
            if (typeof nextOp.retain === 'number') {
              retOp.retain = length;
            } else if (typeof nextOp.insert === 'string') {
              retOp.insert = nextOp.insert.substr(offset, length);
            } else {
              // offset should === 0, length should === 1
              retOp.insert = nextOp.insert;
            }
            return retOp;
          }
        } else {
          return { retain: Infinity };
        }
      };

      Iterator.prototype.peek = function () {
        return this.ops[this.index];
      };

      Iterator.prototype.peekLength = function () {
        if (this.ops[this.index]) {
          // Should never return 0 if our index is being managed correctly
          return lib.length(this.ops[this.index]) - this.offset;
        } else {
          return Infinity;
        }
      };

      Iterator.prototype.peekType = function () {
        if (this.ops[this.index]) {
          if (typeof this.ops[this.index]['delete'] === 'number') {
            return 'delete';
          } else if (typeof this.ops[this.index].retain === 'number') {
            return 'retain';
          } else {
            return 'insert';
          }
        }
        return 'retain';
      };

      Iterator.prototype.rest = function () {
        if (!this.hasNext()) {
          return [];
        } else if (this.offset === 0) {
          return this.ops.slice(this.index);
        } else {
          var offset = this.offset;
          var index = this.index;
          var next = this.next();
          var rest = this.ops.slice(this.index);
          this.offset = offset;
          this.index = index;
          return [next].concat(rest);
        }
      };

      module.exports = lib;

      /***/
    },
    /* 21 */
    /***/function (module, exports) {

      var clone = function () {
        'use strict';

        function _instanceof(obj, type) {
          return type != null && obj instanceof type;
        }

        var nativeMap;
        try {
          nativeMap = Map;
        } catch (_) {
          // maybe a reference error because no `Map`. Give it a dummy value that no
          // value will ever be an instanceof.
          nativeMap = function nativeMap() {};
        }

        var nativeSet;
        try {
          nativeSet = Set;
        } catch (_) {
          nativeSet = function nativeSet() {};
        }

        var nativePromise;
        try {
          nativePromise = Promise;
        } catch (_) {
          nativePromise = function nativePromise() {};
        }

        /**
         * Clones (copies) an Object using deep copying.
         *
         * This function supports circular references by default, but if you are certain
         * there are no circular references in your object, you can save some CPU time
         * by calling clone(obj, false).
         *
         * Caution: if `circular` is false and `parent` contains circular references,
         * your program may enter an infinite loop and crash.
         *
         * @param `parent` - the object to be cloned
         * @param `circular` - set to true if the object to be cloned may contain
         *    circular references. (optional - true by default)
         * @param `depth` - set to a number if the object is only to be cloned to
         *    a particular depth. (optional - defaults to Infinity)
         * @param `prototype` - sets the prototype to be used when cloning an object.
         *    (optional - defaults to parent prototype).
         * @param `includeNonEnumerable` - set to true if the non-enumerable properties
         *    should be cloned as well. Non-enumerable properties on the prototype
         *    chain will be ignored. (optional - false by default)
        */
        function clone(parent, circular, depth, prototype, includeNonEnumerable) {
          if ((typeof circular === 'undefined' ? 'undefined' : _typeof2(circular)) === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            includeNonEnumerable = circular.includeNonEnumerable;
            circular = circular.circular;
          }
          // maintain two arrays for circular references, where corresponding parents
          // and children have the same index
          var allParents = [];
          var allChildren = [];

          var useBuffer = typeof Buffer != 'undefined';

          if (typeof circular == 'undefined') circular = true;

          if (typeof depth == 'undefined') depth = Infinity;

          // recurse this function so we don't reset allParents and allChildren
          function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;

            if (depth === 0) return parent;

            var child;
            var proto;
            if ((typeof parent === 'undefined' ? 'undefined' : _typeof2(parent)) != 'object') {
              return parent;
            }

            if (_instanceof(parent, nativeMap)) {
              child = new nativeMap();
            } else if (_instanceof(parent, nativeSet)) {
              child = new nativeSet();
            } else if (_instanceof(parent, nativePromise)) {
              child = new nativePromise(function (resolve, reject) {
                parent.then(function (value) {
                  resolve(_clone(value, depth - 1));
                }, function (err) {
                  reject(_clone(err, depth - 1));
                });
              });
            } else if (clone.__isArray(parent)) {
              child = [];
            } else if (clone.__isRegExp(parent)) {
              child = new RegExp(parent.source, __getRegExpFlags(parent));
              if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) {
              child = new Date(parent.getTime());
            } else if (useBuffer && Buffer.isBuffer(parent)) {
              if (Buffer.allocUnsafe) {
                // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
              } else {
                // Older Node.js versions
                child = new Buffer(parent.length);
              }
              parent.copy(child);
              return child;
            } else if (_instanceof(parent, Error)) {
              child = Object.create(parent);
            } else {
              if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
              } else {
                child = Object.create(prototype);
                proto = prototype;
              }
            }

            if (circular) {
              var index = allParents.indexOf(parent);

              if (index != -1) {
                return allChildren[index];
              }
              allParents.push(parent);
              allChildren.push(child);
            }

            if (_instanceof(parent, nativeMap)) {
              parent.forEach(function (value, key) {
                var keyChild = _clone(key, depth - 1);
                var valueChild = _clone(value, depth - 1);
                child.set(keyChild, valueChild);
              });
            }
            if (_instanceof(parent, nativeSet)) {
              parent.forEach(function (value) {
                var entryChild = _clone(value, depth - 1);
                child.add(entryChild);
              });
            }

            for (var i in parent) {
              var attrs;
              if (proto) {
                attrs = Object.getOwnPropertyDescriptor(proto, i);
              }

              if (attrs && attrs.set == null) {
                continue;
              }
              child[i] = _clone(parent[i], depth - 1);
            }

            if (Object.getOwnPropertySymbols) {
              var symbols = Object.getOwnPropertySymbols(parent);
              for (var i = 0; i < symbols.length; i++) {
                // Don't need to worry about cloning a symbol because it is a primitive,
                // like a number or string.
                var symbol = symbols[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
                if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                  continue;
                }
                child[symbol] = _clone(parent[symbol], depth - 1);
                if (!descriptor.enumerable) {
                  Object.defineProperty(child, symbol, {
                    enumerable: false
                  });
                }
              }
            }

            if (includeNonEnumerable) {
              var allPropertyNames = Object.getOwnPropertyNames(parent);
              for (var i = 0; i < allPropertyNames.length; i++) {
                var propertyName = allPropertyNames[i];
                var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
                if (descriptor && descriptor.enumerable) {
                  continue;
                }
                child[propertyName] = _clone(parent[propertyName], depth - 1);
                Object.defineProperty(child, propertyName, {
                  enumerable: false
                });
              }
            }

            return child;
          }

          return _clone(parent, depth);
        }

        /**
         * Simple flat clone using prototype, accepts only objects, usefull for property
         * override on FLAT configuration object (no nested props).
         *
         * USE WITH CAUTION! This may not behave as you wish if you do not know how this
         * works.
         */
        clone.clonePrototype = function clonePrototype(parent) {
          if (parent === null) return null;

          var c = function c() {};
          c.prototype = parent;
          return new c();
        };

        // private utility functions

        function __objToStr(o) {
          return Object.prototype.toString.call(o);
        }
        clone.__objToStr = __objToStr;

        function __isDate(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object Date]';
        }
        clone.__isDate = __isDate;

        function __isArray(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object Array]';
        }
        clone.__isArray = __isArray;

        function __isRegExp(o) {
          return (typeof o === 'undefined' ? 'undefined' : _typeof2(o)) === 'object' && __objToStr(o) === '[object RegExp]';
        }
        clone.__isRegExp = __isRegExp;

        function __getRegExpFlags(re) {
          var flags = '';
          if (re.global) flags += 'g';
          if (re.ignoreCase) flags += 'i';
          if (re.multiline) flags += 'm';
          return flags;
        }
        clone.__getRegExpFlags = __getRegExpFlags;

        return clone;
      }();

      if ((typeof module === 'undefined' ? 'undefined' : _typeof2(module)) === 'object' && module.exports) {
        module.exports = clone;
      }

      /***/
    },
    /* 22 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      function isLine(blot) {
        return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
      }

      var Scroll = function (_Parchment$Scroll) {
        _inherits(Scroll, _Parchment$Scroll);

        function Scroll(domNode, config) {
          _classCallCheck(this, Scroll);

          var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

          _this.emitter = config.emitter;
          if (Array.isArray(config.whitelist)) {
            _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
              whitelist[format] = true;
              return whitelist;
            }, {});
          }
          // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
          _this.domNode.addEventListener('DOMNodeInserted', function () {});
          _this.optimize();
          _this.enable();
          return _this;
        }

        _createClass(Scroll, [{
          key: 'batchStart',
          value: function batchStart() {
            this.batch = true;
          }
        }, {
          key: 'batchEnd',
          value: function batchEnd() {
            this.batch = false;
            this.optimize();
          }
        }, {
          key: 'deleteAt',
          value: function deleteAt(index, length) {
            var _line = this.line(index),
                _line2 = _slicedToArray(_line, 2),
                first = _line2[0],
                offset = _line2[1];

            var _line3 = this.line(index + length),
                _line4 = _slicedToArray(_line3, 1),
                last = _line4[0];

            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
            if (last != null && first !== last && offset > 0) {
              if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                this.optimize();
                return;
              }
              if (first instanceof _code2.default) {
                var newlineIndex = first.newlineIndex(first.length(), true);
                if (newlineIndex > -1) {
                  first = first.split(newlineIndex + 1);
                  if (first === last) {
                    this.optimize();
                    return;
                  }
                }
              } else if (last instanceof _code2.default) {
                var _newlineIndex = last.newlineIndex(0);
                if (_newlineIndex > -1) {
                  last.split(_newlineIndex + 1);
                }
              }
              var ref = last.children.head instanceof _break2.default ? null : last.children.head;
              first.moveChildren(last, ref);
              first.remove();
            }
            this.optimize();
          }
        }, {
          key: 'enable',
          value: function enable() {
            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.domNode.setAttribute('contenteditable', enabled);
          }
        }, {
          key: 'formatAt',
          value: function formatAt(index, length, format, value) {
            if (this.whitelist != null && !this.whitelist[format]) return;
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
            this.optimize();
          }
        }, {
          key: 'insertAt',
          value: function insertAt(index, value, def) {
            if (def != null && this.whitelist != null && !this.whitelist[value]) return;
            if (index >= this.length()) {
              if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                var blot = _parchment2.default.create(this.statics.defaultChild);
                this.appendChild(blot);
                if (def == null && value.endsWith('\n')) {
                  value = value.slice(0, -1);
                }
                blot.insertAt(0, value, def);
              } else {
                var embed = _parchment2.default.create(value, def);
                this.appendChild(embed);
              }
            } else {
              _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
            }
            this.optimize();
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
              var wrapper = _parchment2.default.create(this.statics.defaultChild);
              wrapper.appendChild(blot);
              blot = wrapper;
            }
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
          }
        }, {
          key: 'leaf',
          value: function leaf(index) {
            return this.path(index).pop() || [null, -1];
          }
        }, {
          key: 'line',
          value: function line(index) {
            if (index === this.length()) {
              return this.line(index - 1);
            }
            return this.descendant(isLine, index);
          }
        }, {
          key: 'lines',
          value: function lines() {
            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

            var getLines = function getLines(blot, index, length) {
              var lines = [],
                  lengthLeft = length;
              blot.children.forEachAt(index, length, function (child, index, length) {
                if (isLine(child)) {
                  lines.push(child);
                } else if (child instanceof _parchment2.default.Container) {
                  lines = lines.concat(getLines(child, index, lengthLeft));
                }
                lengthLeft -= length;
              });
              return lines;
            };
            return getLines(this, index, length);
          }
        }, {
          key: 'optimize',
          value: function optimize() {
            var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            if (this.batch === true) return;
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
            }
          }
        }, {
          key: 'path',
          value: function path(index) {
            return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
          }
        }, {
          key: 'update',
          value: function update(mutations) {
            if (this.batch === true) return;
            var source = _emitter2.default.sources.USER;
            if (typeof mutations === 'string') {
              source = mutations;
            }
            if (!Array.isArray(mutations)) {
              mutations = this.observer.takeRecords();
            }
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
            }
            _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
            if (mutations.length > 0) {
              this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
            }
          }
        }]);

        return Scroll;
      }(_parchment2.default.Scroll);

      Scroll.blotName = 'scroll';
      Scroll.className = 'ql-editor';
      Scroll.tagName = 'DIV';
      Scroll.defaultChild = 'block';
      Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

      exports.default = Scroll;

      /***/
    },
    /* 23 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SHORTKEY = exports.default = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _clone = __webpack_require__(21);

      var _clone2 = _interopRequireDefault(_clone);

      var _deepEqual = __webpack_require__(11);

      var _deepEqual2 = _interopRequireDefault(_deepEqual);

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _op = __webpack_require__(20);

      var _op2 = _interopRequireDefault(_op);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:keyboard');

      var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

      var Keyboard = function (_Module) {
        _inherits(Keyboard, _Module);

        _createClass(Keyboard, null, [{
          key: 'match',
          value: function match(evt, binding) {
            binding = normalize(binding);
            if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
              return !!binding[key] !== evt[key] && binding[key] !== null;
            })) {
              return false;
            }
            return binding.key === (evt.which || evt.keyCode);
          }
        }]);

        function Keyboard(quill, options) {
          _classCallCheck(this, Keyboard);

          var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

          _this.bindings = {};
          Object.keys(_this.options.bindings).forEach(function (name) {
            if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
              return;
            }
            if (_this.options.bindings[name]) {
              _this.addBinding(_this.options.bindings[name]);
            }
          });
          _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
          _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
          if (/Firefox/i.test(navigator.userAgent)) {
            // Need to handle delete and backspace for Firefox in the general case #1171
            _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
            _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
          } else {
            _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
            _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
          }
          _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
          _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
          _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
          _this.listen();
          return _this;
        }

        _createClass(Keyboard, [{
          key: 'addBinding',
          value: function addBinding(key) {
            var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var binding = normalize(key);
            if (binding == null || binding.key == null) {
              return debug.warn('Attempted to add invalid keyboard binding', binding);
            }
            if (typeof context === 'function') {
              context = { handler: context };
            }
            if (typeof handler === 'function') {
              handler = { handler: handler };
            }
            binding = (0, _extend2.default)(binding, context, handler);
            this.bindings[binding.key] = this.bindings[binding.key] || [];
            this.bindings[binding.key].push(binding);
          }
        }, {
          key: 'listen',
          value: function listen() {
            var _this2 = this;

            this.quill.root.addEventListener('keydown', function (evt) {
              if (evt.defaultPrevented) return;
              var which = evt.which || evt.keyCode;
              var bindings = (_this2.bindings[which] || []).filter(function (binding) {
                return Keyboard.match(evt, binding);
              });
              if (bindings.length === 0) return;
              var range = _this2.quill.getSelection();
              if (range == null || !_this2.quill.hasFocus()) return;

              var _quill$getLine = _this2.quill.getLine(range.index),
                  _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
                  line = _quill$getLine2[0],
                  offset = _quill$getLine2[1];

              var _quill$getLeaf = _this2.quill.getLeaf(range.index),
                  _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
                  leafStart = _quill$getLeaf2[0],
                  offsetStart = _quill$getLeaf2[1];

              var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
                  _ref2 = _slicedToArray(_ref, 2),
                  leafEnd = _ref2[0],
                  offsetEnd = _ref2[1];

              var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
              var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
              var curContext = {
                collapsed: range.length === 0,
                empty: range.length === 0 && line.length() <= 1,
                format: _this2.quill.getFormat(range),
                offset: offset,
                prefix: prefixText,
                suffix: suffixText
              };
              var prevented = bindings.some(function (binding) {
                if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
                if (binding.empty != null && binding.empty !== curContext.empty) return false;
                if (binding.offset != null && binding.offset !== curContext.offset) return false;
                if (Array.isArray(binding.format)) {
                  // any format is present
                  if (binding.format.every(function (name) {
                    return curContext.format[name] == null;
                  })) {
                    return false;
                  }
                } else if (_typeof(binding.format) === 'object') {
                  // all formats must match
                  if (!Object.keys(binding.format).every(function (name) {
                    if (binding.format[name] === true) return curContext.format[name] != null;
                    if (binding.format[name] === false) return curContext.format[name] == null;
                    return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                  })) {
                    return false;
                  }
                }
                if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
                if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
                return binding.handler.call(_this2, range, curContext) !== true;
              });
              if (prevented) {
                evt.preventDefault();
              }
            });
          }
        }]);

        return Keyboard;
      }(_module2.default);

      Keyboard.keys = {
        BACKSPACE: 8,
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        DELETE: 46
      };

      Keyboard.DEFAULTS = {
        bindings: {
          'bold': makeFormatHandler('bold'),
          'italic': makeFormatHandler('italic'),
          'underline': makeFormatHandler('underline'),
          'indent': {
            // highlight tab or tab at beginning of list, indent or blockquote
            key: Keyboard.keys.TAB,
            format: ['blockquote', 'indent', 'list'],
            handler: function handler(range, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format('indent', '+1', _quill2.default.sources.USER);
            }
          },
          'outdent': {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            format: ['blockquote', 'indent', 'list'],
            // highlight tab or tab at beginning of list, indent or blockquote
            handler: function handler(range, context) {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format('indent', '-1', _quill2.default.sources.USER);
            }
          },
          'outdent backspace': {
            key: Keyboard.keys.BACKSPACE,
            collapsed: true,
            shiftKey: null,
            metaKey: null,
            ctrlKey: null,
            altKey: null,
            format: ['indent', 'list'],
            offset: 0,
            handler: function handler(range, context) {
              if (context.format.indent != null) {
                this.quill.format('indent', '-1', _quill2.default.sources.USER);
              } else if (context.format.list != null) {
                this.quill.format('list', false, _quill2.default.sources.USER);
              }
            }
          },
          'indent code-block': makeCodeBlockHandler(true),
          'outdent code-block': makeCodeBlockHandler(false),
          'remove tab': {
            key: Keyboard.keys.TAB,
            shiftKey: true,
            collapsed: true,
            prefix: /\t$/,
            handler: function handler(range) {
              this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
            }
          },
          'tab': {
            key: Keyboard.keys.TAB,
            handler: function handler(range) {
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
            }
          },
          'list empty enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['list'],
            empty: true,
            handler: function handler(range, context) {
              this.quill.format('list', false, _quill2.default.sources.USER);
              if (context.format.indent) {
                this.quill.format('indent', false, _quill2.default.sources.USER);
              }
            }
          },
          'checklist enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: { list: 'checked' },
            handler: function handler(range) {
              var _quill$getLine3 = this.quill.getLine(range.index),
                  _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
                  line = _quill$getLine4[0],
                  offset = _quill$getLine4[1];

              var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
              var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          'header enter': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['header'],
            suffix: /^$/,
            handler: function handler(range, context) {
              var _quill$getLine5 = this.quill.getLine(range.index),
                  _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
                  line = _quill$getLine6[0],
                  offset = _quill$getLine6[1];

              var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
              this.quill.scrollIntoView();
            }
          },
          'list autofill': {
            key: ' ',
            collapsed: true,
            format: { list: false },
            prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
            handler: function handler(range, context) {
              var length = context.prefix.length;

              var _quill$getLine7 = this.quill.getLine(range.index),
                  _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
                  line = _quill$getLine8[0],
                  offset = _quill$getLine8[1];

              if (offset > length) return true;
              var value = void 0;
              switch (context.prefix.trim()) {
                case '[]':case '[ ]':
                  value = 'unchecked';
                  break;
                case '[x]':
                  value = 'checked';
                  break;
                case '-':case '*':
                  value = 'bullet';
                  break;
                default:
                  value = 'ordered';
              }
              this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
              this.quill.history.cutoff();
              var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
              this.quill.updateContents(delta, _quill2.default.sources.USER);
              this.quill.history.cutoff();
              this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
            }
          },
          'code exit': {
            key: Keyboard.keys.ENTER,
            collapsed: true,
            format: ['code-block'],
            prefix: /\n\n$/,
            suffix: /^\s+$/,
            handler: function handler(range) {
              var _quill$getLine9 = this.quill.getLine(range.index),
                  _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
                  line = _quill$getLine10[0],
                  offset = _quill$getLine10[1];

              var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
              this.quill.updateContents(delta, _quill2.default.sources.USER);
            }
          },
          'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
          'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
          'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
          'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
        }
      };

      function makeEmbedArrowHandler(key, shiftKey) {
        var _ref3;

        var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
        return _ref3 = {
          key: key,
          shiftKey: shiftKey,
          altKey: null
        }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
          var index = range.index;
          if (key === Keyboard.keys.RIGHT) {
            index += range.length + 1;
          }

          var _quill$getLeaf3 = this.quill.getLeaf(index),
              _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
              leaf = _quill$getLeaf4[0];

          if (!(leaf instanceof _parchment2.default.Embed)) return true;
          if (key === Keyboard.keys.LEFT) {
            if (shiftKey) {
              this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
            }
          } else {
            if (shiftKey) {
              this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
            } else {
              this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
            }
          }
          return false;
        }), _ref3;
      }

      function handleBackspace(range, context) {
        if (range.index === 0 || this.quill.getLength() <= 1) return;

        var _quill$getLine11 = this.quill.getLine(range.index),
            _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
            line = _quill$getLine12[0];

        var formats = {};
        if (context.offset === 0) {
          var _quill$getLine13 = this.quill.getLine(range.index - 1),
              _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
              prev = _quill$getLine14[0];

          if (prev != null && prev.length() > 1) {
            var curFormats = line.formats();
            var prevFormats = this.quill.getFormat(range.index - 1, 1);
            formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
          }
        }
        // Check for astral symbols
        var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
        this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
        }
        this.quill.focus();
      }

      function handleDelete(range, context) {
        // Check for astral symbols
        var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
        if (range.index >= this.quill.getLength() - length) return;
        var formats = {},
            nextLength = 0;

        var _quill$getLine15 = this.quill.getLine(range.index),
            _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
            line = _quill$getLine16[0];

        if (context.offset >= line.length() - 1) {
          var _quill$getLine17 = this.quill.getLine(range.index + 1),
              _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
              next = _quill$getLine18[0];

          if (next) {
            var curFormats = line.formats();
            var nextFormats = this.quill.getFormat(range.index, 1);
            formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
            nextLength = next.length();
          }
        }
        this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
        }
      }

      function handleDeleteRange(range) {
        var lines = this.quill.getLines(range);
        var formats = {};
        if (lines.length > 1) {
          var firstFormats = lines[0].formats();
          var lastFormats = lines[lines.length - 1].formats();
          formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
        }
        this.quill.deleteText(range, _quill2.default.sources.USER);
        if (Object.keys(formats).length > 0) {
          this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
        }
        this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
        this.quill.focus();
      }

      function handleEnter(range, context) {
        var _this3 = this;

        if (range.length > 0) {
          this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
        }
        var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
          if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
            lineFormats[format] = context.format[format];
          }
          return lineFormats;
        }, {});
        this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
        // Earlier scroll.deleteAt might have messed up our selection,
        // so insertText's built in selection preservation is not reliable
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.focus();
        Object.keys(context.format).forEach(function (name) {
          if (lineFormats[name] != null) return;
          if (Array.isArray(context.format[name])) return;
          if (name === 'link') return;
          _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
        });
      }

      function makeCodeBlockHandler(indent) {
        return {
          key: Keyboard.keys.TAB,
          shiftKey: !indent,
          format: { 'code-block': true },
          handler: function handler(range) {
            var CodeBlock = _parchment2.default.query('code-block');
            var index = range.index,
                length = range.length;

            var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
                _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
                block = _quill$scroll$descend2[0],
                offset = _quill$scroll$descend2[1];

            if (block == null) return;
            var scrollIndex = this.quill.getIndex(block);
            var start = block.newlineIndex(offset, true) + 1;
            var end = block.newlineIndex(scrollIndex + offset + length);
            var lines = block.domNode.textContent.slice(start, end).split('\n');
            offset = 0;
            lines.forEach(function (line, i) {
              if (indent) {
                block.insertAt(start + offset, CodeBlock.TAB);
                offset += CodeBlock.TAB.length;
                if (i === 0) {
                  index += CodeBlock.TAB.length;
                } else {
                  length += CodeBlock.TAB.length;
                }
              } else if (line.startsWith(CodeBlock.TAB)) {
                block.deleteAt(start + offset, CodeBlock.TAB.length);
                offset -= CodeBlock.TAB.length;
                if (i === 0) {
                  index -= CodeBlock.TAB.length;
                } else {
                  length -= CodeBlock.TAB.length;
                }
              }
              offset += line.length + 1;
            });
            this.quill.update(_quill2.default.sources.USER);
            this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
          }
        };
      }

      function makeFormatHandler(format) {
        return {
          key: format[0].toUpperCase(),
          shortKey: true,
          handler: function handler(range, context) {
            this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
          }
        };
      }

      function normalize(binding) {
        if (typeof binding === 'string' || typeof binding === 'number') {
          return normalize({ key: binding });
        }
        if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
          binding = (0, _clone2.default)(binding, false);
        }
        if (typeof binding.key === 'string') {
          if (Keyboard.keys[binding.key.toUpperCase()] != null) {
            binding.key = Keyboard.keys[binding.key.toUpperCase()];
          } else if (binding.key.length === 1) {
            binding.key = binding.key.toUpperCase().charCodeAt(0);
          } else {
            return null;
          }
        }
        if (binding.shortKey) {
          binding[SHORTKEY] = binding.shortKey;
          delete binding.shortKey;
        }
        return binding;
      }

      exports.default = Keyboard;
      exports.SHORTKEY = SHORTKEY;

      /***/
    },
    /* 24 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Cursor = function (_Parchment$Embed) {
        _inherits(Cursor, _Parchment$Embed);

        _createClass(Cursor, null, [{
          key: 'value',
          value: function value() {
            return undefined;
          }
        }]);

        function Cursor(domNode, selection) {
          _classCallCheck(this, Cursor);

          var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

          _this.selection = selection;
          _this.textNode = document.createTextNode(Cursor.CONTENTS);
          _this.domNode.appendChild(_this.textNode);
          _this._length = 0;
          return _this;
        }

        _createClass(Cursor, [{
          key: 'detach',
          value: function detach() {
            // super.detach() will also clear domNode.__blot
            if (this.parent != null) this.parent.removeChild(this);
          }
        }, {
          key: 'format',
          value: function format(name, value) {
            if (this._length !== 0) {
              return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
            }
            var target = this,
                index = 0;
            while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
              index += target.offset(target.parent);
              target = target.parent;
            }
            if (target != null) {
              this._length = Cursor.CONTENTS.length;
              target.optimize();
              target.formatAt(index, Cursor.CONTENTS.length, name, value);
              this._length = 0;
            }
          }
        }, {
          key: 'index',
          value: function index(node, offset) {
            if (node === this.textNode) return 0;
            return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
          }
        }, {
          key: 'length',
          value: function length() {
            return this._length;
          }
        }, {
          key: 'position',
          value: function position() {
            return [this.textNode, this.textNode.data.length];
          }
        }, {
          key: 'remove',
          value: function remove() {
            _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
            this.parent = null;
          }
        }, {
          key: 'restore',
          value: function restore() {
            if (this.selection.composing || this.parent == null) return;
            var textNode = this.textNode;
            var range = this.selection.getNativeRange();
            var restoreText = void 0,
                start = void 0,
                end = void 0;
            if (range != null && range.start.node === textNode && range.end.node === textNode) {
              var _ref = [textNode, range.start.offset, range.end.offset];
              restoreText = _ref[0];
              start = _ref[1];
              end = _ref[2];
            }
            // Link format will insert text outside of anchor tag
            while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
              this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
            }
            if (this.textNode.data !== Cursor.CONTENTS) {
              var text = this.textNode.data.split(Cursor.CONTENTS).join('');
              if (this.next instanceof _text2.default) {
                restoreText = this.next.domNode;
                this.next.insertAt(0, text);
                this.textNode.data = Cursor.CONTENTS;
              } else {
                this.textNode.data = text;
                this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                this.textNode = document.createTextNode(Cursor.CONTENTS);
                this.domNode.appendChild(this.textNode);
              }
            }
            this.remove();
            if (start != null) {
              var _map = [start, end].map(function (offset) {
                return Math.max(0, Math.min(restoreText.data.length, offset - 1));
              });

              var _map2 = _slicedToArray(_map, 2);

              start = _map2[0];
              end = _map2[1];

              return {
                startNode: restoreText,
                startOffset: start,
                endNode: restoreText,
                endOffset: end
              };
            }
          }
        }, {
          key: 'update',
          value: function update(mutations, context) {
            var _this2 = this;

            if (mutations.some(function (mutation) {
              return mutation.type === 'characterData' && mutation.target === _this2.textNode;
            })) {
              var range = this.restore();
              if (range) context.range = range;
            }
          }
        }, {
          key: 'value',
          value: function value() {
            return '';
          }
        }]);

        return Cursor;
      }(_parchment2.default.Embed);

      Cursor.blotName = 'cursor';
      Cursor.className = 'ql-cursor';
      Cursor.tagName = 'span';
      Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


      exports.default = Cursor;

      /***/
    },
    /* 25 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Container = function (_Parchment$Container) {
        _inherits(Container, _Parchment$Container);

        function Container() {
          _classCallCheck(this, Container);

          return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
        }

        return Container;
      }(_parchment2.default.Container);

      Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

      exports.default = Container;

      /***/
    },
    /* 26 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorAttributor = function (_Parchment$Attributor) {
        _inherits(ColorAttributor, _Parchment$Attributor);

        function ColorAttributor() {
          _classCallCheck(this, ColorAttributor);

          return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
        }

        _createClass(ColorAttributor, [{
          key: 'value',
          value: function value(domNode) {
            var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
            if (!value.startsWith('rgb(')) return value;
            value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
            return '#' + value.split(',').map(function (component) {
              return ('00' + parseInt(component).toString(16)).slice(-2);
            }).join('');
          }
        }]);

        return ColorAttributor;
      }(_parchment2.default.Attributor.Style);

      var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
        scope: _parchment2.default.Scope.INLINE
      });
      var ColorStyle = new ColorAttributor('color', 'color', {
        scope: _parchment2.default.Scope.INLINE
      });

      exports.ColorAttributor = ColorAttributor;
      exports.ColorClass = ColorClass;
      exports.ColorStyle = ColorStyle;

      /***/
    },
    /* 27 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.sanitize = exports.default = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Link = function (_Inline) {
        _inherits(Link, _Inline);

        function Link() {
          _classCallCheck(this, Link);

          return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
        }

        _createClass(Link, [{
          key: 'format',
          value: function format(name, value) {
            if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
            value = this.constructor.sanitize(value);
            this.domNode.setAttribute('href', value);
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
            value = this.sanitize(value);
            node.setAttribute('href', value);
            node.setAttribute('rel', 'noopener noreferrer');
            node.setAttribute('target', '_blank');
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return domNode.getAttribute('href');
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
          }
        }]);

        return Link;
      }(_inline2.default);

      Link.blotName = 'link';
      Link.tagName = 'A';
      Link.SANITIZED_URL = 'about:blank';
      Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

      function _sanitize(url, protocols) {
        var anchor = document.createElement('a');
        anchor.href = url;
        var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
        return protocols.indexOf(protocol) > -1;
      }

      exports.default = Link;
      exports.sanitize = _sanitize;

      /***/
    },
    /* 28 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      var _dropdown = __webpack_require__(107);

      var _dropdown2 = _interopRequireDefault(_dropdown);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var optionsCounter = 0;

      function toggleAriaAttribute(element, attribute) {
        element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
      }

      var Picker = function () {
        function Picker(select) {
          var _this = this;

          _classCallCheck(this, Picker);

          this.select = select;
          this.container = document.createElement('span');
          this.buildPicker();
          this.select.style.display = 'none';
          this.select.parentNode.insertBefore(this.container, this.select);

          this.label.addEventListener('mousedown', function () {
            _this.togglePicker();
          });
          this.label.addEventListener('keydown', function (event) {
            switch (event.keyCode) {
              // Allows the "Enter" key to open the picker
              case _keyboard2.default.keys.ENTER:
                _this.togglePicker();
                break;

              // Allows the "Escape" key to close the picker
              case _keyboard2.default.keys.ESCAPE:
                _this.escape();
                event.preventDefault();
                break;
              default:
            }
          });
          this.select.addEventListener('change', this.update.bind(this));
        }

        _createClass(Picker, [{
          key: 'togglePicker',
          value: function togglePicker() {
            this.container.classList.toggle('ql-expanded');
            // Toggle aria-expanded and aria-hidden to make the picker accessible
            toggleAriaAttribute(this.label, 'aria-expanded');
            toggleAriaAttribute(this.options, 'aria-hidden');
          }
        }, {
          key: 'buildItem',
          value: function buildItem(option) {
            var _this2 = this;

            var item = document.createElement('span');
            item.tabIndex = '0';
            item.setAttribute('role', 'button');

            item.classList.add('ql-picker-item');
            if (option.hasAttribute('value')) {
              item.setAttribute('data-value', option.getAttribute('value'));
            }
            if (option.textContent) {
              item.setAttribute('data-label', option.textContent);
            }
            item.addEventListener('click', function () {
              _this2.selectItem(item, true);
            });
            item.addEventListener('keydown', function (event) {
              switch (event.keyCode) {
                // Allows the "Enter" key to select an item
                case _keyboard2.default.keys.ENTER:
                  _this2.selectItem(item, true);
                  event.preventDefault();
                  break;

                // Allows the "Escape" key to close the picker
                case _keyboard2.default.keys.ESCAPE:
                  _this2.escape();
                  event.preventDefault();
                  break;
                default:
              }
            });

            return item;
          }
        }, {
          key: 'buildLabel',
          value: function buildLabel() {
            var label = document.createElement('span');
            label.classList.add('ql-picker-label');
            label.innerHTML = _dropdown2.default;
            label.tabIndex = '0';
            label.setAttribute('role', 'button');
            label.setAttribute('aria-expanded', 'false');
            this.container.appendChild(label);
            return label;
          }
        }, {
          key: 'buildOptions',
          value: function buildOptions() {
            var _this3 = this;

            var options = document.createElement('span');
            options.classList.add('ql-picker-options');

            // Don't want screen readers to read this until options are visible
            options.setAttribute('aria-hidden', 'true');
            options.tabIndex = '-1';

            // Need a unique id for aria-controls
            options.id = 'ql-picker-options-' + optionsCounter;
            optionsCounter += 1;
            this.label.setAttribute('aria-controls', options.id);

            this.options = options;

            [].slice.call(this.select.options).forEach(function (option) {
              var item = _this3.buildItem(option);
              options.appendChild(item);
              if (option.selected === true) {
                _this3.selectItem(item);
              }
            });
            this.container.appendChild(options);
          }
        }, {
          key: 'buildPicker',
          value: function buildPicker() {
            var _this4 = this;

            [].slice.call(this.select.attributes).forEach(function (item) {
              _this4.container.setAttribute(item.name, item.value);
            });
            this.container.classList.add('ql-picker');
            this.label = this.buildLabel();
            this.buildOptions();
          }
        }, {
          key: 'escape',
          value: function escape() {
            var _this5 = this;

            // Close menu and return focus to trigger label
            this.close();
            // Need setTimeout for accessibility to ensure that the browser executes
            // focus on the next process thread and after any DOM content changes
            setTimeout(function () {
              return _this5.label.focus();
            }, 1);
          }
        }, {
          key: 'close',
          value: function close() {
            this.container.classList.remove('ql-expanded');
            this.label.setAttribute('aria-expanded', 'false');
            this.options.setAttribute('aria-hidden', 'true');
          }
        }, {
          key: 'selectItem',
          value: function selectItem(item) {
            var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var selected = this.container.querySelector('.ql-selected');
            if (item === selected) return;
            if (selected != null) {
              selected.classList.remove('ql-selected');
            }
            if (item == null) return;
            item.classList.add('ql-selected');
            this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
            if (item.hasAttribute('data-value')) {
              this.label.setAttribute('data-value', item.getAttribute('data-value'));
            } else {
              this.label.removeAttribute('data-value');
            }
            if (item.hasAttribute('data-label')) {
              this.label.setAttribute('data-label', item.getAttribute('data-label'));
            } else {
              this.label.removeAttribute('data-label');
            }
            if (trigger) {
              if (typeof Event === 'function') {
                this.select.dispatchEvent(new Event('change'));
              } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
                // IE11
                var event = document.createEvent('Event');
                event.initEvent('change', true, true);
                this.select.dispatchEvent(event);
              }
              this.close();
            }
          }
        }, {
          key: 'update',
          value: function update() {
            var option = void 0;
            if (this.select.selectedIndex > -1) {
              var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
              option = this.select.options[this.select.selectedIndex];
              this.selectItem(item);
            } else {
              this.selectItem(null);
            }
            var isActive = option != null && option !== this.select.querySelector('option[selected]');
            this.label.classList.toggle('ql-active', isActive);
          }
        }]);

        return Picker;
      }();

      exports.default = Picker;

      /***/
    },
    /* 29 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _break = __webpack_require__(16);

      var _break2 = _interopRequireDefault(_break);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      var _cursor = __webpack_require__(24);

      var _cursor2 = _interopRequireDefault(_cursor);

      var _embed = __webpack_require__(35);

      var _embed2 = _interopRequireDefault(_embed);

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      var _scroll = __webpack_require__(22);

      var _scroll2 = _interopRequireDefault(_scroll);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      var _clipboard = __webpack_require__(55);

      var _clipboard2 = _interopRequireDefault(_clipboard);

      var _history = __webpack_require__(42);

      var _history2 = _interopRequireDefault(_history);

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      _quill2.default.register({
        'blots/block': _block2.default,
        'blots/block/embed': _block.BlockEmbed,
        'blots/break': _break2.default,
        'blots/container': _container2.default,
        'blots/cursor': _cursor2.default,
        'blots/embed': _embed2.default,
        'blots/inline': _inline2.default,
        'blots/scroll': _scroll2.default,
        'blots/text': _text2.default,

        'modules/clipboard': _clipboard2.default,
        'modules/history': _history2.default,
        'modules/keyboard': _keyboard2.default
      });

      _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

      exports.default = _quill2.default;

      /***/
    },
    /* 30 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var Registry = __webpack_require__(1);
      var ShadowBlot = /** @class */function () {
        function ShadowBlot(domNode) {
          this.domNode = domNode;
          // @ts-ignore
          this.domNode[Registry.DATA_KEY] = { blot: this };
        }
        Object.defineProperty(ShadowBlot.prototype, "statics", {
          // Hack for accessing inherited static methods
          get: function get() {
            return this.constructor;
          },
          enumerable: true,
          configurable: true
        });
        ShadowBlot.create = function (value) {
          if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
          }
          var node;
          if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
              value = value.toUpperCase();
              if (parseInt(value).toString() === value) {
                value = parseInt(value);
              }
            }
            if (typeof value === 'number') {
              node = document.createElement(this.tagName[value - 1]);
            } else if (this.tagName.indexOf(value) > -1) {
              node = document.createElement(value);
            } else {
              node = document.createElement(this.tagName[0]);
            }
          } else {
            node = document.createElement(this.tagName);
          }
          if (this.className) {
            node.classList.add(this.className);
          }
          return node;
        };
        ShadowBlot.prototype.attach = function () {
          if (this.parent != null) {
            this.scroll = this.parent.scroll;
          }
        };
        ShadowBlot.prototype.clone = function () {
          var domNode = this.domNode.cloneNode(false);
          return Registry.create(domNode);
        };
        ShadowBlot.prototype.detach = function () {
          if (this.parent != null) this.parent.removeChild(this);
          // @ts-ignore
          delete this.domNode[Registry.DATA_KEY];
        };
        ShadowBlot.prototype.deleteAt = function (index, length) {
          var blot = this.isolate(index, length);
          blot.remove();
        };
        ShadowBlot.prototype.formatAt = function (index, length, name, value) {
          var blot = this.isolate(index, length);
          if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
          } else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
          }
        };
        ShadowBlot.prototype.insertAt = function (index, value, def) {
          var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
          var ref = this.split(index);
          this.parent.insertBefore(blot, ref);
        };
        ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
          if (refBlot === void 0) {
            refBlot = null;
          }
          if (this.parent != null) {
            this.parent.children.remove(this);
          }
          var refDomNode = null;
          parentBlot.children.insertBefore(this, refBlot);
          if (refBlot != null) {
            refDomNode = refBlot.domNode;
          }
          if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
          }
          this.parent = parentBlot;
          this.attach();
        };
        ShadowBlot.prototype.isolate = function (index, length) {
          var target = this.split(index);
          target.split(length);
          return target;
        };
        ShadowBlot.prototype.length = function () {
          return 1;
        };
        ShadowBlot.prototype.offset = function (root) {
          if (root === void 0) {
            root = this.parent;
          }
          if (this.parent == null || this == root) return 0;
          return this.parent.children.offset(this) + this.parent.offset(root);
        };
        ShadowBlot.prototype.optimize = function (context) {
          // TODO clean up once we use WeakMap
          // @ts-ignore
          if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
          }
        };
        ShadowBlot.prototype.remove = function () {
          if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
          }
          this.detach();
        };
        ShadowBlot.prototype.replace = function (target) {
          if (target.parent == null) return;
          target.parent.insertBefore(this, target.next);
          target.remove();
        };
        ShadowBlot.prototype.replaceWith = function (name, value) {
          var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
          replacement.replace(this);
          return replacement;
        };
        ShadowBlot.prototype.split = function (index, force) {
          return index === 0 ? this : this.next;
        };
        ShadowBlot.prototype.update = function (mutations, context) {
          // Nothing to do by default
        };
        ShadowBlot.prototype.wrap = function (name, value) {
          var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
          if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
          }
          wrapper.appendChild(this);
          return wrapper;
        };
        ShadowBlot.blotName = 'abstract';
        return ShadowBlot;
      }();
      exports.default = ShadowBlot;

      /***/
    },
    /* 31 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      var class_1 = __webpack_require__(32);
      var style_1 = __webpack_require__(33);
      var Registry = __webpack_require__(1);
      var AttributorStore = /** @class */function () {
        function AttributorStore(domNode) {
          this.attributes = {};
          this.domNode = domNode;
          this.build();
        }
        AttributorStore.prototype.attribute = function (attribute, value) {
          // verb
          if (value) {
            if (attribute.add(this.domNode, value)) {
              if (attribute.value(this.domNode) != null) {
                this.attributes[attribute.attrName] = attribute;
              } else {
                delete this.attributes[attribute.attrName];
              }
            }
          } else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
          }
        };
        AttributorStore.prototype.build = function () {
          var _this = this;
          this.attributes = {};
          var attributes = attributor_1.default.keys(this.domNode);
          var classes = class_1.default.keys(this.domNode);
          var styles = style_1.default.keys(this.domNode);
          attributes.concat(classes).concat(styles).forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
              _this.attributes[attr.attrName] = attr;
            }
          });
        };
        AttributorStore.prototype.copy = function (target) {
          var _this = this;
          Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
          });
        };
        AttributorStore.prototype.move = function (target) {
          var _this = this;
          this.copy(target);
          Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
          });
          this.attributes = {};
        };
        AttributorStore.prototype.values = function () {
          var _this = this;
          return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
          }, {});
        };
        return AttributorStore;
      }();
      exports.default = AttributorStore;

      /***/
    },
    /* 32 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      function match(node, prefix) {
        var className = node.getAttribute('class') || '';
        return className.split(/\s+/).filter(function (name) {
          return name.indexOf(prefix + "-") === 0;
        });
      }
      var ClassAttributor = /** @class */function (_super) {
        __extends(ClassAttributor, _super);
        function ClassAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        ClassAttributor.keys = function (node) {
          return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name.split('-').slice(0, -1).join('-');
          });
        };
        ClassAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          this.remove(node);
          node.classList.add(this.keyName + "-" + value);
          return true;
        };
        ClassAttributor.prototype.remove = function (node) {
          var matches = match(node, this.keyName);
          matches.forEach(function (name) {
            node.classList.remove(name);
          });
          if (node.classList.length === 0) {
            node.removeAttribute('class');
          }
        };
        ClassAttributor.prototype.value = function (node) {
          var result = match(node, this.keyName)[0] || '';
          var value = result.slice(this.keyName.length + 1); // +1 for hyphen
          return this.canAdd(node, value) ? value : '';
        };
        return ClassAttributor;
      }(attributor_1.default);
      exports.default = ClassAttributor;

      /***/
    },
    /* 33 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var attributor_1 = __webpack_require__(12);
      function camelize(name) {
        var parts = name.split('-');
        var rest = parts.slice(1).map(function (part) {
          return part[0].toUpperCase() + part.slice(1);
        }).join('');
        return parts[0] + rest;
      }
      var StyleAttributor = /** @class */function (_super) {
        __extends(StyleAttributor, _super);
        function StyleAttributor() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        StyleAttributor.keys = function (node) {
          return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
          });
        };
        StyleAttributor.prototype.add = function (node, value) {
          if (!this.canAdd(node, value)) return false;
          // @ts-ignore
          node.style[camelize(this.keyName)] = value;
          return true;
        };
        StyleAttributor.prototype.remove = function (node) {
          // @ts-ignore
          node.style[camelize(this.keyName)] = '';
          if (!node.getAttribute('style')) {
            node.removeAttribute('style');
          }
        };
        StyleAttributor.prototype.value = function (node) {
          // @ts-ignore
          var value = node.style[camelize(this.keyName)];
          return this.canAdd(node, value) ? value : '';
        };
        return StyleAttributor;
      }(attributor_1.default);
      exports.default = StyleAttributor;

      /***/
    },
    /* 34 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Theme = function () {
        function Theme(quill, options) {
          _classCallCheck(this, Theme);

          this.quill = quill;
          this.options = options;
          this.modules = {};
        }

        _createClass(Theme, [{
          key: 'init',
          value: function init() {
            var _this = this;

            Object.keys(this.options.modules).forEach(function (name) {
              if (_this.modules[name] == null) {
                _this.addModule(name);
              }
            });
          }
        }, {
          key: 'addModule',
          value: function addModule(name) {
            var moduleClass = this.quill.constructor.import('modules/' + name);
            this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
            return this.modules[name];
          }
        }]);

        return Theme;
      }();

      Theme.DEFAULTS = {
        modules: {}
      };
      Theme.themes = {
        'default': Theme
      };

      exports.default = Theme;

      /***/
    },
    /* 35 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _text = __webpack_require__(7);

      var _text2 = _interopRequireDefault(_text);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var GUARD_TEXT = '\uFEFF';

      var Embed = function (_Parchment$Embed) {
        _inherits(Embed, _Parchment$Embed);

        function Embed(node) {
          _classCallCheck(this, Embed);

          var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

          _this.contentNode = document.createElement('span');
          _this.contentNode.setAttribute('contenteditable', false);
          [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
            _this.contentNode.appendChild(childNode);
          });
          _this.leftGuard = document.createTextNode(GUARD_TEXT);
          _this.rightGuard = document.createTextNode(GUARD_TEXT);
          _this.domNode.appendChild(_this.leftGuard);
          _this.domNode.appendChild(_this.contentNode);
          _this.domNode.appendChild(_this.rightGuard);
          return _this;
        }

        _createClass(Embed, [{
          key: 'index',
          value: function index(node, offset) {
            if (node === this.leftGuard) return 0;
            if (node === this.rightGuard) return 1;
            return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
          }
        }, {
          key: 'restore',
          value: function restore(node) {
            var range = void 0,
                textNode = void 0;
            var text = node.data.split(GUARD_TEXT).join('');
            if (node === this.leftGuard) {
              if (this.prev instanceof _text2.default) {
                var prevLength = this.prev.length();
                this.prev.insertAt(prevLength, text);
                range = {
                  startNode: this.prev.domNode,
                  startOffset: prevLength + text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this);
                range = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            } else if (node === this.rightGuard) {
              if (this.next instanceof _text2.default) {
                this.next.insertAt(0, text);
                range = {
                  startNode: this.next.domNode,
                  startOffset: text.length
                };
              } else {
                textNode = document.createTextNode(text);
                this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                range = {
                  startNode: textNode,
                  startOffset: text.length
                };
              }
            }
            node.data = GUARD_TEXT;
            return range;
          }
        }, {
          key: 'update',
          value: function update(mutations, context) {
            var _this2 = this;

            mutations.forEach(function (mutation) {
              if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                var range = _this2.restore(mutation.target);
                if (range) context.range = range;
              }
            });
          }
        }]);

        return Embed;
      }(_parchment2.default.Embed);

      exports.default = Embed;

      /***/
    },
    /* 36 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ['right', 'center', 'justify']
      };

      var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
      var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
      var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

      exports.AlignAttribute = AlignAttribute;
      exports.AlignClass = AlignClass;
      exports.AlignStyle = AlignStyle;

      /***/
    },
    /* 37 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.BackgroundStyle = exports.BackgroundClass = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _color = __webpack_require__(26);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
        scope: _parchment2.default.Scope.INLINE
      });
      var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
        scope: _parchment2.default.Scope.INLINE
      });

      exports.BackgroundClass = BackgroundClass;
      exports.BackgroundStyle = BackgroundStyle;

      /***/
    },
    /* 38 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var config = {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: ['rtl']
      };

      var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
      var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
      var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

      exports.DirectionAttribute = DirectionAttribute;
      exports.DirectionClass = DirectionClass;
      exports.DirectionStyle = DirectionStyle;

      /***/
    },
    /* 39 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.FontClass = exports.FontStyle = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var config = {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['serif', 'monospace']
      };

      var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

      var FontStyleAttributor = function (_Parchment$Attributor) {
        _inherits(FontStyleAttributor, _Parchment$Attributor);

        function FontStyleAttributor() {
          _classCallCheck(this, FontStyleAttributor);

          return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
        }

        _createClass(FontStyleAttributor, [{
          key: 'value',
          value: function value(node) {
            return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
          }
        }]);

        return FontStyleAttributor;
      }(_parchment2.default.Attributor.Style);

      var FontStyle = new FontStyleAttributor('font', 'font-family', config);

      exports.FontStyle = FontStyle;
      exports.FontClass = FontClass;

      /***/
    },
    /* 40 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.SizeStyle = exports.SizeClass = undefined;

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['small', 'large', 'huge']
      });
      var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
        scope: _parchment2.default.Scope.INLINE,
        whitelist: ['10px', '18px', '32px']
      });

      exports.SizeClass = SizeClass;
      exports.SizeStyle = SizeStyle;

      /***/
    },
    /* 41 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      module.exports = {
        'align': {
          '': __webpack_require__(76),
          'center': __webpack_require__(77),
          'right': __webpack_require__(78),
          'justify': __webpack_require__(79)
        },
        'background': __webpack_require__(80),
        'blockquote': __webpack_require__(81),
        'bold': __webpack_require__(82),
        'clean': __webpack_require__(83),
        'code': __webpack_require__(58),
        'code-block': __webpack_require__(58),
        'color': __webpack_require__(84),
        'direction': {
          '': __webpack_require__(85),
          'rtl': __webpack_require__(86)
        },
        'float': {
          'center': __webpack_require__(87),
          'full': __webpack_require__(88),
          'left': __webpack_require__(89),
          'right': __webpack_require__(90)
        },
        'formula': __webpack_require__(91),
        'header': {
          '1': __webpack_require__(92),
          '2': __webpack_require__(93)
        },
        'italic': __webpack_require__(94),
        'image': __webpack_require__(95),
        'indent': {
          '+1': __webpack_require__(96),
          '-1': __webpack_require__(97)
        },
        'link': __webpack_require__(98),
        'list': {
          'ordered': __webpack_require__(99),
          'bullet': __webpack_require__(100),
          'check': __webpack_require__(101)
        },
        'script': {
          'sub': __webpack_require__(102),
          'super': __webpack_require__(103)
        },
        'strike': __webpack_require__(104),
        'underline': __webpack_require__(105),
        'video': __webpack_require__(106)
      };

      /***/
    },
    /* 42 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getLastChangeIndex = exports.default = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var History = function (_Module) {
        _inherits(History, _Module);

        function History(quill, options) {
          _classCallCheck(this, History);

          var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

          _this.lastRecorded = 0;
          _this.ignoreChange = false;
          _this.clear();
          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
            if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
            if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
              _this.record(delta, oldDelta);
            } else {
              _this.transform(delta);
            }
          });
          _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
          _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
          if (/Win/i.test(navigator.platform)) {
            _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
          }
          return _this;
        }

        _createClass(History, [{
          key: 'change',
          value: function change(source, dest) {
            if (this.stack[source].length === 0) return;
            var delta = this.stack[source].pop();
            this.stack[dest].push(delta);
            this.lastRecorded = 0;
            this.ignoreChange = true;
            this.quill.updateContents(delta[source], _quill2.default.sources.USER);
            this.ignoreChange = false;
            var index = getLastChangeIndex(delta[source]);
            this.quill.setSelection(index);
          }
        }, {
          key: 'clear',
          value: function clear() {
            this.stack = { undo: [], redo: [] };
          }
        }, {
          key: 'cutoff',
          value: function cutoff() {
            this.lastRecorded = 0;
          }
        }, {
          key: 'record',
          value: function record(changeDelta, oldDelta) {
            if (changeDelta.ops.length === 0) return;
            this.stack.redo = [];
            var undoDelta = this.quill.getContents().diff(oldDelta);
            var timestamp = Date.now();
            if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
              var delta = this.stack.undo.pop();
              undoDelta = undoDelta.compose(delta.undo);
              changeDelta = delta.redo.compose(changeDelta);
            } else {
              this.lastRecorded = timestamp;
            }
            this.stack.undo.push({
              redo: changeDelta,
              undo: undoDelta
            });
            if (this.stack.undo.length > this.options.maxStack) {
              this.stack.undo.shift();
            }
          }
        }, {
          key: 'redo',
          value: function redo() {
            this.change('redo', 'undo');
          }
        }, {
          key: 'transform',
          value: function transform(delta) {
            this.stack.undo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
            this.stack.redo.forEach(function (change) {
              change.undo = delta.transform(change.undo, true);
              change.redo = delta.transform(change.redo, true);
            });
          }
        }, {
          key: 'undo',
          value: function undo() {
            this.change('undo', 'redo');
          }
        }]);

        return History;
      }(_module2.default);

      History.DEFAULTS = {
        delay: 1000,
        maxStack: 100,
        userOnly: false
      };

      function endsWithNewlineChange(delta) {
        var lastOp = delta.ops[delta.ops.length - 1];
        if (lastOp == null) return false;
        if (lastOp.insert != null) {
          return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
        }
        if (lastOp.attributes != null) {
          return Object.keys(lastOp.attributes).some(function (attr) {
            return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
          });
        }
        return false;
      }

      function getLastChangeIndex(delta) {
        var deleteLength = delta.reduce(function (length, op) {
          length += op.delete || 0;
          return length;
        }, 0);
        var changeIndex = delta.length() - deleteLength;
        if (endsWithNewlineChange(delta)) {
          changeIndex -= 1;
        }
        return changeIndex;
      }

      exports.default = History;
      exports.getLastChangeIndex = getLastChangeIndex;

      /***/
    },
    /* 43 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BaseTooltip = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _keyboard = __webpack_require__(23);

      var _keyboard2 = _interopRequireDefault(_keyboard);

      var _theme = __webpack_require__(34);

      var _theme2 = _interopRequireDefault(_theme);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ALIGNS = [false, 'center', 'right', 'justify'];

      var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

      var FONTS = [false, 'serif', 'monospace'];

      var HEADERS = ['1', '2', '3', false];

      var SIZES = ['small', false, 'large', 'huge'];

      var BaseTheme = function (_Theme) {
        _inherits(BaseTheme, _Theme);

        function BaseTheme(quill, options) {
          _classCallCheck(this, BaseTheme);

          var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

          var listener = function listener(e) {
            if (!document.body.contains(quill.root)) {
              return document.body.removeEventListener('click', listener);
            }
            if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
              _this.tooltip.hide();
            }
            if (_this.pickers != null) {
              _this.pickers.forEach(function (picker) {
                if (!picker.container.contains(e.target)) {
                  picker.close();
                }
              });
            }
          };
          quill.emitter.listenDOM('click', document.body, listener);
          return _this;
        }

        _createClass(BaseTheme, [{
          key: 'addModule',
          value: function addModule(name) {
            var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
            if (name === 'toolbar') {
              this.extendToolbar(module);
            }
            return module;
          }
        }, {
          key: 'buildButtons',
          value: function buildButtons(buttons, icons) {
            buttons.forEach(function (button) {
              var className = button.getAttribute('class') || '';
              className.split(/\s+/).forEach(function (name) {
                if (!name.startsWith('ql-')) return;
                name = name.slice('ql-'.length);
                if (icons[name] == null) return;
                if (name === 'direction') {
                  button.innerHTML = icons[name][''] + icons[name]['rtl'];
                } else if (typeof icons[name] === 'string') {
                  button.innerHTML = icons[name];
                } else {
                  var value = button.value || '';
                  if (value != null && icons[name][value]) {
                    button.innerHTML = icons[name][value];
                  }
                }
              });
            });
          }
        }, {
          key: 'buildPickers',
          value: function buildPickers(selects, icons) {
            var _this2 = this;

            this.pickers = selects.map(function (select) {
              if (select.classList.contains('ql-align')) {
                if (select.querySelector('option') == null) {
                  fillSelect(select, ALIGNS);
                }
                return new _iconPicker2.default(select, icons.align);
              } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
                var format = select.classList.contains('ql-background') ? 'background' : 'color';
                if (select.querySelector('option') == null) {
                  fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
                }
                return new _colorPicker2.default(select, icons[format]);
              } else {
                if (select.querySelector('option') == null) {
                  if (select.classList.contains('ql-font')) {
                    fillSelect(select, FONTS);
                  } else if (select.classList.contains('ql-header')) {
                    fillSelect(select, HEADERS);
                  } else if (select.classList.contains('ql-size')) {
                    fillSelect(select, SIZES);
                  }
                }
                return new _picker2.default(select);
              }
            });
            var update = function update() {
              _this2.pickers.forEach(function (picker) {
                picker.update();
              });
            };
            this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
          }
        }]);

        return BaseTheme;
      }(_theme2.default);

      BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              formula: function formula() {
                this.quill.theme.tooltip.edit('formula');
              },
              image: function image() {
                var _this3 = this;

                var fileInput = this.container.querySelector('input.ql-image[type=file]');
                if (fileInput == null) {
                  fileInput = document.createElement('input');
                  fileInput.setAttribute('type', 'file');
                  fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                  fileInput.classList.add('ql-image');
                  fileInput.addEventListener('change', function () {
                    if (fileInput.files != null && fileInput.files[0] != null) {
                      var reader = new FileReader();
                      reader.onload = function (e) {
                        var range = _this3.quill.getSelection(true);
                        _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                        _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                        fileInput.value = "";
                      };
                      reader.readAsDataURL(fileInput.files[0]);
                    }
                  });
                  this.container.appendChild(fileInput);
                }
                fileInput.click();
              },
              video: function video() {
                this.quill.theme.tooltip.edit('video');
              }
            }
          }
        }
      });

      var BaseTooltip = function (_Tooltip) {
        _inherits(BaseTooltip, _Tooltip);

        function BaseTooltip(quill, boundsContainer) {
          _classCallCheck(this, BaseTooltip);

          var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

          _this4.textbox = _this4.root.querySelector('input[type="text"]');
          _this4.listen();
          return _this4;
        }

        _createClass(BaseTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this5 = this;

            this.textbox.addEventListener('keydown', function (event) {
              if (_keyboard2.default.match(event, 'enter')) {
                _this5.save();
                event.preventDefault();
              } else if (_keyboard2.default.match(event, 'escape')) {
                _this5.cancel();
                event.preventDefault();
              }
            });
          }
        }, {
          key: 'cancel',
          value: function cancel() {
            this.hide();
          }
        }, {
          key: 'edit',
          value: function edit() {
            var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
            var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.root.classList.remove('ql-hidden');
            this.root.classList.add('ql-editing');
            if (preview != null) {
              this.textbox.value = preview;
            } else if (mode !== this.root.getAttribute('data-mode')) {
              this.textbox.value = '';
            }
            this.position(this.quill.getBounds(this.quill.selection.savedRange));
            this.textbox.select();
            this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
            this.root.setAttribute('data-mode', mode);
          }
        }, {
          key: 'restoreFocus',
          value: function restoreFocus() {
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.quill.focus();
            this.quill.scrollingContainer.scrollTop = scrollTop;
          }
        }, {
          key: 'save',
          value: function save() {
            var value = this.textbox.value;
            switch (this.root.getAttribute('data-mode')) {
              case 'link':
                {
                  var scrollTop = this.quill.root.scrollTop;
                  if (this.linkRange) {
                    this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
                    delete this.linkRange;
                  } else {
                    this.restoreFocus();
                    this.quill.format('link', value, _emitter2.default.sources.USER);
                  }
                  this.quill.root.scrollTop = scrollTop;
                  break;
                }
              case 'video':
                {
                  value = extractVideoUrl(value);
                } // eslint-disable-next-line no-fallthrough
              case 'formula':
                {
                  if (!value) break;
                  var range = this.quill.getSelection(true);
                  if (range != null) {
                    var index = range.index + range.length;
                    this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
                    if (this.root.getAttribute('data-mode') === 'formula') {
                      this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
                    }
                    this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                  }
                  break;
                }
              default:
            }
            this.textbox.value = '';
            this.hide();
          }
        }]);

        return BaseTooltip;
      }(_tooltip2.default);

      function extractVideoUrl(url) {
        var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
        if (match) {
          return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
        }
        if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
          // eslint-disable-line no-cond-assign
          return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
        }
        return url;
      }

      function fillSelect(select, values) {
        var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        values.forEach(function (value) {
          var option = document.createElement('option');
          if (value === defaultValue) {
            option.setAttribute('selected', 'selected');
          } else {
            option.setAttribute('value', value);
          }
          select.appendChild(option);
        });
      }

      exports.BaseTooltip = BaseTooltip;
      exports.default = BaseTheme;

      /***/
    },
    /* 44 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", { value: true });
      var LinkedList = /** @class */function () {
        function LinkedList() {
          this.head = this.tail = null;
          this.length = 0;
        }
        LinkedList.prototype.append = function () {
          var nodes = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
          }
          this.insertBefore(nodes[0], null);
          if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
          }
        };
        LinkedList.prototype.contains = function (node) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            if (cur === node) return true;
          }
          return false;
        };
        LinkedList.prototype.insertBefore = function (node, refNode) {
          if (!node) return;
          node.next = refNode;
          if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
              refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
              this.head = node;
            }
          } else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
          } else {
            node.prev = null;
            this.head = this.tail = node;
          }
          this.length += 1;
        };
        LinkedList.prototype.offset = function (target) {
          var index = 0,
              cur = this.head;
          while (cur != null) {
            if (cur === target) return index;
            index += cur.length();
            cur = cur.next;
          }
          return -1;
        };
        LinkedList.prototype.remove = function (node) {
          if (!this.contains(node)) return;
          if (node.prev != null) node.prev.next = node.next;
          if (node.next != null) node.next.prev = node.prev;
          if (node === this.head) this.head = node.next;
          if (node === this.tail) this.tail = node.prev;
          this.length -= 1;
        };
        LinkedList.prototype.iterator = function (curNode) {
          if (curNode === void 0) {
            curNode = this.head;
          }
          // TODO use yield when we can
          return function () {
            var ret = curNode;
            if (curNode != null) curNode = curNode.next;
            return ret;
          };
        };
        LinkedList.prototype.find = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          var cur,
              next = this.iterator();
          while (cur = next()) {
            var length = cur.length();
            if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) {
              return [cur, index];
            }
            index -= length;
          }
          return [null, 0];
        };
        LinkedList.prototype.forEach = function (callback) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            callback(cur);
          }
        };
        LinkedList.prototype.forEachAt = function (index, length, callback) {
          if (length <= 0) return;
          var _a = this.find(index),
              startNode = _a[0],
              offset = _a[1];
          var cur,
              curIndex = index - offset,
              next = this.iterator(startNode);
          while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
              callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            } else {
              callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
          }
        };
        LinkedList.prototype.map = function (callback) {
          return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
          }, []);
        };
        LinkedList.prototype.reduce = function (callback, memo) {
          var cur,
              next = this.iterator();
          while (cur = next()) {
            memo = callback(memo, cur);
          }
          return memo;
        };
        return LinkedList;
      }();
      exports.default = LinkedList;

      /***/
    },
    /* 45 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var container_1 = __webpack_require__(17);
      var Registry = __webpack_require__(1);
      var OBSERVER_CONFIG = {
        attributes: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
      };
      var MAX_OPTIMIZE_ITERATIONS = 100;
      var ScrollBlot = /** @class */function (_super) {
        __extends(ScrollBlot, _super);
        function ScrollBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.scroll = _this;
          _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
          });
          _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
          _this.attach();
          return _this;
        }
        ScrollBlot.prototype.detach = function () {
          _super.prototype.detach.call(this);
          this.observer.disconnect();
        };
        ScrollBlot.prototype.deleteAt = function (index, length) {
          this.update();
          if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
              child.remove();
            });
          } else {
            _super.prototype.deleteAt.call(this, index, length);
          }
        };
        ScrollBlot.prototype.formatAt = function (index, length, name, value) {
          this.update();
          _super.prototype.formatAt.call(this, index, length, name, value);
        };
        ScrollBlot.prototype.insertAt = function (index, value, def) {
          this.update();
          _super.prototype.insertAt.call(this, index, value, def);
        };
        ScrollBlot.prototype.optimize = function (mutations, context) {
          var _this = this;
          if (mutations === void 0) {
            mutations = [];
          }
          if (context === void 0) {
            context = {};
          }
          _super.prototype.optimize.call(this, context);
          // We must modify mutations directly, cannot make copy and then modify
          var records = [].slice.call(this.observer.takeRecords());
          // Array.push currently seems to be implemented by a non-tail recursive function
          // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
          while (records.length > 0) {
            mutations.push(records.pop());
          } // TODO use WeakMap
          var mark = function mark(blot, markParent) {
            if (markParent === void 0) {
              markParent = true;
            }
            if (blot == null || blot === _this) return;
            if (blot.domNode.parentNode == null) return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent) mark(blot.parent);
          };
          var optimize = function optimize(blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY].mutations == null) {
              return;
            }
            if (blot instanceof container_1.default) {
              blot.children.forEach(optimize);
            }
            blot.optimize(context);
          };
          var remaining = mutations;
          for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
              throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
              var blot = Registry.find(mutation.target, true);
              if (blot == null) return;
              if (blot.domNode === mutation.target) {
                if (mutation.type === 'childList') {
                  mark(Registry.find(mutation.previousSibling, false));
                  [].forEach.call(mutation.addedNodes, function (node) {
                    var child = Registry.find(node, false);
                    mark(child, false);
                    if (child instanceof container_1.default) {
                      child.children.forEach(function (grandChild) {
                        mark(grandChild, false);
                      });
                    }
                  });
                } else if (mutation.type === 'attributes') {
                  mark(blot.prev);
                }
              }
              mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0) {
              mutations.push(records.pop());
            }
          }
        };
        ScrollBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (context === void 0) {
            context = {};
          }
          mutations = mutations || this.observer.takeRecords();
          // TODO use WeakMap
          mutations.map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null) return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations = [mutation];
              return blot;
            } else {
              // @ts-ignore
              blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
              return null;
            }
          }).forEach(function (blot) {
            if (blot == null || blot === _this ||
            //@ts-ignore
            blot.domNode[Registry.DATA_KEY] == null) return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
          });
          // @ts-ignore
          if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
          }
          this.optimize(mutations, context);
        };
        ScrollBlot.blotName = 'scroll';
        ScrollBlot.defaultChild = 'block';
        ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
        ScrollBlot.tagName = 'DIV';
        return ScrollBlot;
      }(container_1.default);
      exports.default = ScrollBlot;

      /***/
    },
    /* 46 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var format_1 = __webpack_require__(18);
      var Registry = __webpack_require__(1);
      // Shallow object comparison
      function isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        // @ts-ignore
        for (var prop in obj1) {
          // @ts-ignore
          if (obj1[prop] !== obj2[prop]) return false;
        }
        return true;
      }
      var InlineBlot = /** @class */function (_super) {
        __extends(InlineBlot, _super);
        function InlineBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        InlineBlot.formats = function (domNode) {
          if (domNode.tagName === InlineBlot.tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        InlineBlot.prototype.format = function (name, value) {
          var _this = this;
          if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
              if (!(child instanceof format_1.default)) {
                child = child.wrap(InlineBlot.blotName, true);
              }
              _this.attributes.copy(child);
            });
            this.unwrap();
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        InlineBlot.prototype.formatAt = function (index, length, name, value) {
          if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        InlineBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          var formats = this.formats();
          if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
          }
          var next = this.next;
          if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
          }
        };
        InlineBlot.blotName = 'inline';
        InlineBlot.scope = Registry.Scope.INLINE_BLOT;
        InlineBlot.tagName = 'SPAN';
        return InlineBlot;
      }(format_1.default);
      exports.default = InlineBlot;

      /***/
    },
    /* 47 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var format_1 = __webpack_require__(18);
      var Registry = __webpack_require__(1);
      var BlockBlot = /** @class */function (_super) {
        __extends(BlockBlot, _super);
        function BlockBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        BlockBlot.formats = function (domNode) {
          var tagName = Registry.query(BlockBlot.blotName).tagName;
          if (domNode.tagName === tagName) return undefined;
          return _super.formats.call(this, domNode);
        };
        BlockBlot.prototype.format = function (name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
          } else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
          } else {
            _super.prototype.format.call(this, name, value);
          }
        };
        BlockBlot.prototype.formatAt = function (index, length, name, value) {
          if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        BlockBlot.prototype.insertAt = function (index, value, def) {
          if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
          } else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
          }
        };
        BlockBlot.prototype.update = function (mutations, context) {
          if (navigator.userAgent.match(/Trident/)) {
            this.build();
          } else {
            _super.prototype.update.call(this, mutations, context);
          }
        };
        BlockBlot.blotName = 'block';
        BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
        BlockBlot.tagName = 'P';
        return BlockBlot;
      }(format_1.default);
      exports.default = BlockBlot;

      /***/
    },
    /* 48 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var leaf_1 = __webpack_require__(19);
      var EmbedBlot = /** @class */function (_super) {
        __extends(EmbedBlot, _super);
        function EmbedBlot() {
          return _super !== null && _super.apply(this, arguments) || this;
        }
        EmbedBlot.formats = function (domNode) {
          return undefined;
        };
        EmbedBlot.prototype.format = function (name, value) {
          // super.formatAt wraps, which is what we want in general,
          // but this allows subclasses to overwrite for formats
          // that just apply to particular embeds
          _super.prototype.formatAt.call(this, 0, this.length(), name, value);
        };
        EmbedBlot.prototype.formatAt = function (index, length, name, value) {
          if (index === 0 && length === this.length()) {
            this.format(name, value);
          } else {
            _super.prototype.formatAt.call(this, index, length, name, value);
          }
        };
        EmbedBlot.prototype.formats = function () {
          return this.statics.formats(this.domNode);
        };
        return EmbedBlot;
      }(leaf_1.default);
      exports.default = EmbedBlot;

      /***/
    },
    /* 49 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var __extends = this && this.__extends || function () {
        var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
          d.__proto__ = b;
        } || function (d, b) {
          for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
          }
        };
        return function (d, b) {
          extendStatics(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      Object.defineProperty(exports, "__esModule", { value: true });
      var leaf_1 = __webpack_require__(19);
      var Registry = __webpack_require__(1);
      var TextBlot = /** @class */function (_super) {
        __extends(TextBlot, _super);
        function TextBlot(node) {
          var _this = _super.call(this, node) || this;
          _this.text = _this.statics.value(_this.domNode);
          return _this;
        }
        TextBlot.create = function (value) {
          return document.createTextNode(value);
        };
        TextBlot.value = function (domNode) {
          var text = domNode.data;
          // @ts-ignore
          if (text['normalize']) text = text['normalize']();
          return text;
        };
        TextBlot.prototype.deleteAt = function (index, length) {
          this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
        };
        TextBlot.prototype.index = function (node, offset) {
          if (this.domNode === node) {
            return offset;
          }
          return -1;
        };
        TextBlot.prototype.insertAt = function (index, value, def) {
          if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
          } else {
            _super.prototype.insertAt.call(this, index, value, def);
          }
        };
        TextBlot.prototype.length = function () {
          return this.text.length;
        };
        TextBlot.prototype.optimize = function (context) {
          _super.prototype.optimize.call(this, context);
          this.text = this.statics.value(this.domNode);
          if (this.text.length === 0) {
            this.remove();
          } else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
          }
        };
        TextBlot.prototype.position = function (index, inclusive) {
          if (inclusive === void 0) {
            inclusive = false;
          }
          return [this.domNode, index];
        };
        TextBlot.prototype.split = function (index, force) {
          if (force === void 0) {
            force = false;
          }
          if (!force) {
            if (index === 0) return this;
            if (index === this.length()) return this.next;
          }
          var after = Registry.create(this.domNode.splitText(index));
          this.parent.insertBefore(after, this.next);
          this.text = this.statics.value(this.domNode);
          return after;
        };
        TextBlot.prototype.update = function (mutations, context) {
          var _this = this;
          if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
          })) {
            this.text = this.statics.value(this.domNode);
          }
        };
        TextBlot.prototype.value = function () {
          return this.text;
        };
        TextBlot.blotName = 'text';
        TextBlot.scope = Registry.Scope.INLINE_BLOT;
        return TextBlot;
      }(leaf_1.default);
      exports.default = TextBlot;

      /***/
    },
    /* 50 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      var elem = document.createElement('div');
      elem.classList.toggle('test-class', false);
      if (elem.classList.contains('test-class')) {
        var _toggle = DOMTokenList.prototype.toggle;
        DOMTokenList.prototype.toggle = function (token, force) {
          if (arguments.length > 1 && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };
      }

      if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
          position = position || 0;
          return this.substr(position, searchString.length) === searchString;
        };
      }

      if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (searchString, position) {
          var subjectString = this.toString();
          if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
          }
          position -= searchString.length;
          var lastIndex = subjectString.indexOf(searchString, position);
          return lastIndex !== -1 && lastIndex === position;
        };
      }

      if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
          value: function value(predicate) {
            if (this === null) {
              throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
              throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
              value = list[i];
              if (predicate.call(thisArg, value, i, list)) {
                return value;
              }
            }
            return undefined;
          }
        });
      }

      document.addEventListener("DOMContentLoaded", function () {
        // Disable resizing in Firefox
        document.execCommand("enableObjectResizing", false, false);
        // Disable automatic linkifying in IE11
        document.execCommand("autoUrlDetect", false, false);
      });

      /***/
    },
    /* 51 */
    /***/function (module, exports) {

      /**
       * This library modifies the diff-patch-match library by Neil Fraser
       * by removing the patch and match functionality and certain advanced
       * options in the diff function. The original license is as follows:
       *
       * ===
       *
       * Diff Match and Patch
       *
       * Copyright 2006 Google Inc.
       * http://code.google.com/p/google-diff-match-patch/
       *
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       *   http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       */

      /**
       * The data structure representing a diff is an array of tuples:
       * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
       * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
       */
      var DIFF_DELETE = -1;
      var DIFF_INSERT = 1;
      var DIFF_EQUAL = 0;

      /**
       * Find the differences between two texts.  Simplifies the problem by stripping
       * any common prefix or suffix off the texts before diffing.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @param {Int} cursor_pos Expected edit position in text1 (optional)
       * @return {Array} Array of diff tuples.
       */
      function diff_main(text1, text2, cursor_pos) {
        // Check for equality (speedup).
        if (text1 == text2) {
          if (text1) {
            return [[DIFF_EQUAL, text1]];
          }
          return [];
        }

        // Check cursor_pos within bounds
        if (cursor_pos < 0 || text1.length < cursor_pos) {
          cursor_pos = null;
        }

        // Trim off common prefix (speedup).
        var commonlength = diff_commonPrefix(text1, text2);
        var commonprefix = text1.substring(0, commonlength);
        text1 = text1.substring(commonlength);
        text2 = text2.substring(commonlength);

        // Trim off common suffix (speedup).
        commonlength = diff_commonSuffix(text1, text2);
        var commonsuffix = text1.substring(text1.length - commonlength);
        text1 = text1.substring(0, text1.length - commonlength);
        text2 = text2.substring(0, text2.length - commonlength);

        // Compute the diff on the middle block.
        var diffs = diff_compute_(text1, text2);

        // Restore the prefix and suffix.
        if (commonprefix) {
          diffs.unshift([DIFF_EQUAL, commonprefix]);
        }
        if (commonsuffix) {
          diffs.push([DIFF_EQUAL, commonsuffix]);
        }
        diff_cleanupMerge(diffs);
        if (cursor_pos != null) {
          diffs = fix_cursor(diffs, cursor_pos);
        }
        diffs = fix_emoji(diffs);
        return diffs;
      };

      /**
       * Find the differences between two texts.  Assumes that the texts do not
       * have any common prefix or suffix.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @return {Array} Array of diff tuples.
       */
      function diff_compute_(text1, text2) {
        var diffs;

        if (!text1) {
          // Just add some text (speedup).
          return [[DIFF_INSERT, text2]];
        }

        if (!text2) {
          // Just delete some text (speedup).
          return [[DIFF_DELETE, text1]];
        }

        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        var i = longtext.indexOf(shorttext);
        if (i != -1) {
          // Shorter text is inside the longer text (speedup).
          diffs = [[DIFF_INSERT, longtext.substring(0, i)], [DIFF_EQUAL, shorttext], [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
          // Swap insertions for deletions if diff is reversed.
          if (text1.length > text2.length) {
            diffs[0][0] = diffs[2][0] = DIFF_DELETE;
          }
          return diffs;
        }

        if (shorttext.length == 1) {
          // Single character string.
          // After the previous speedup, the character can't be an equality.
          return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
        }

        // Check to see if the problem can be split in two.
        var hm = diff_halfMatch_(text1, text2);
        if (hm) {
          // A half-match was found, sort out the return data.
          var text1_a = hm[0];
          var text1_b = hm[1];
          var text2_a = hm[2];
          var text2_b = hm[3];
          var mid_common = hm[4];
          // Send both pairs off for separate processing.
          var diffs_a = diff_main(text1_a, text2_a);
          var diffs_b = diff_main(text1_b, text2_b);
          // Merge the results.
          return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
        }

        return diff_bisect_(text1, text2);
      };

      /**
       * Find the 'middle snake' of a diff, split the problem in two
       * and return the recursively constructed diff.
       * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @return {Array} Array of diff tuples.
       * @private
       */
      function diff_bisect_(text1, text2) {
        // Cache the text lengths to prevent multiple calls.
        var text1_length = text1.length;
        var text2_length = text2.length;
        var max_d = Math.ceil((text1_length + text2_length) / 2);
        var v_offset = max_d;
        var v_length = 2 * max_d;
        var v1 = new Array(v_length);
        var v2 = new Array(v_length);
        // Setting all elements to -1 is faster in Chrome & Firefox than mixing
        // integers and undefined.
        for (var x = 0; x < v_length; x++) {
          v1[x] = -1;
          v2[x] = -1;
        }
        v1[v_offset + 1] = 0;
        v2[v_offset + 1] = 0;
        var delta = text1_length - text2_length;
        // If the total number of characters is odd, then the front path will collide
        // with the reverse path.
        var front = delta % 2 != 0;
        // Offsets for start and end of k loop.
        // Prevents mapping of space beyond the grid.
        var k1start = 0;
        var k1end = 0;
        var k2start = 0;
        var k2end = 0;
        for (var d = 0; d < max_d; d++) {
          // Walk the front path one step.
          for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
              x1 = v1[k1_offset + 1];
            } else {
              x1 = v1[k1_offset - 1] + 1;
            }
            var y1 = x1 - k1;
            while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)) {
              x1++;
              y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) {
              // Ran off the right of the graph.
              k1end += 2;
            } else if (y1 > text2_length) {
              // Ran off the bottom of the graph.
              k1start += 2;
            } else if (front) {
              var k2_offset = v_offset + delta - k1;
              if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                // Mirror x2 onto top-left coordinate system.
                var x2 = text1_length - v2[k2_offset];
                if (x1 >= x2) {
                  // Overlap detected.
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }

          // Walk the reverse path one step.
          for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
              x2 = v2[k2_offset + 1];
            } else {
              x2 = v2[k2_offset - 1] + 1;
            }
            var y2 = x2 - k2;
            while (x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)) {
              x2++;
              y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) {
              // Ran off the left of the graph.
              k2end += 2;
            } else if (y2 > text2_length) {
              // Ran off the top of the graph.
              k2start += 2;
            } else if (!front) {
              var k1_offset = v_offset + delta - k2;
              if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                var x1 = v1[k1_offset];
                var y1 = v_offset + x1 - k1_offset;
                // Mirror x2 onto top-left coordinate system.
                x2 = text1_length - x2;
                if (x1 >= x2) {
                  // Overlap detected.
                  return diff_bisectSplit_(text1, text2, x1, y1);
                }
              }
            }
          }
        }
        // Diff took too long and hit the deadline or
        // number of diffs equals number of characters, no commonality at all.
        return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
      };

      /**
       * Given the location of the 'middle snake', split the diff in two parts
       * and recurse.
       * @param {string} text1 Old string to be diffed.
       * @param {string} text2 New string to be diffed.
       * @param {number} x Index of split point in text1.
       * @param {number} y Index of split point in text2.
       * @return {Array} Array of diff tuples.
       */
      function diff_bisectSplit_(text1, text2, x, y) {
        var text1a = text1.substring(0, x);
        var text2a = text2.substring(0, y);
        var text1b = text1.substring(x);
        var text2b = text2.substring(y);

        // Compute both diffs serially.
        var diffs = diff_main(text1a, text2a);
        var diffsb = diff_main(text1b, text2b);

        return diffs.concat(diffsb);
      };

      /**
       * Determine the common prefix of two strings.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {number} The number of characters common to the start of each
       *     string.
       */
      function diff_commonPrefix(text1, text2) {
        // Quick check for common null cases.
        if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
          return 0;
        }
        // Binary search.
        // Performance analysis: http://neil.fraser.name/news/2007/10/09/
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerstart = 0;
        while (pointermin < pointermid) {
          if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
          } else {
            pointermax = pointermid;
          }
          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
      };

      /**
       * Determine the common suffix of two strings.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {number} The number of characters common to the end of each string.
       */
      function diff_commonSuffix(text1, text2) {
        // Quick check for common null cases.
        if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
          return 0;
        }
        // Binary search.
        // Performance analysis: http://neil.fraser.name/news/2007/10/09/
        var pointermin = 0;
        var pointermax = Math.min(text1.length, text2.length);
        var pointermid = pointermax;
        var pointerend = 0;
        while (pointermin < pointermid) {
          if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
          } else {
            pointermax = pointermid;
          }
          pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
        }
        return pointermid;
      };

      /**
       * Do the two texts share a substring which is at least half the length of the
       * longer text?
       * This speedup can produce non-minimal diffs.
       * @param {string} text1 First string.
       * @param {string} text2 Second string.
       * @return {Array.<string>} Five element Array, containing the prefix of
       *     text1, the suffix of text1, the prefix of text2, the suffix of
       *     text2 and the common middle.  Or null if there was no match.
       */
      function diff_halfMatch_(text1, text2) {
        var longtext = text1.length > text2.length ? text1 : text2;
        var shorttext = text1.length > text2.length ? text2 : text1;
        if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
          return null; // Pointless.
        }

        /**
         * Does a substring of shorttext exist within longtext such that the substring
         * is at least half the length of longtext?
         * Closure, but does not reference any external variables.
         * @param {string} longtext Longer string.
         * @param {string} shorttext Shorter string.
         * @param {number} i Start index of quarter length substring within longtext.
         * @return {Array.<string>} Five element Array, containing the prefix of
         *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
         *     of shorttext and the common middle.  Or null if there was no match.
         * @private
         */
        function diff_halfMatchI_(longtext, shorttext, i) {
          // Start with a 1/4 length substring at position i as a seed.
          var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
          var j = -1;
          var best_common = '';
          var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
          while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
            var prefixLength = diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
              best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
              best_longtext_a = longtext.substring(0, i - suffixLength);
              best_longtext_b = longtext.substring(i + prefixLength);
              best_shorttext_a = shorttext.substring(0, j - suffixLength);
              best_shorttext_b = shorttext.substring(j + prefixLength);
            }
          }
          if (best_common.length * 2 >= longtext.length) {
            return [best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b, best_common];
          } else {
            return null;
          }
        }

        // First check if the second quarter is the seed for a half-match.
        var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
        // Check again based on the third quarter.
        var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
        var hm;
        if (!hm1 && !hm2) {
          return null;
        } else if (!hm2) {
          hm = hm1;
        } else if (!hm1) {
          hm = hm2;
        } else {
          // Both matched.  Select the longest.
          hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
        }

        // A half-match was found, sort out the return data.
        var text1_a, text1_b, text2_a, text2_b;
        if (text1.length > text2.length) {
          text1_a = hm[0];
          text1_b = hm[1];
          text2_a = hm[2];
          text2_b = hm[3];
        } else {
          text2_a = hm[0];
          text2_b = hm[1];
          text1_a = hm[2];
          text1_b = hm[3];
        }
        var mid_common = hm[4];
        return [text1_a, text1_b, text2_a, text2_b, mid_common];
      };

      /**
       * Reorder and merge like edit sections.  Merge equalities.
       * Any edit section can move as long as it doesn't cross an equality.
       * @param {Array} diffs Array of diff tuples.
       */
      function diff_cleanupMerge(diffs) {
        diffs.push([DIFF_EQUAL, '']); // Add a dummy entry at the end.
        var pointer = 0;
        var count_delete = 0;
        var count_insert = 0;
        var text_delete = '';
        var text_insert = '';
        var commonlength;
        while (pointer < diffs.length) {
          switch (diffs[pointer][0]) {
            case DIFF_INSERT:
              count_insert++;
              text_insert += diffs[pointer][1];
              pointer++;
              break;
            case DIFF_DELETE:
              count_delete++;
              text_delete += diffs[pointer][1];
              pointer++;
              break;
            case DIFF_EQUAL:
              // Upon reaching an equality, check for prior redundancies.
              if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                  // Factor out any common prefixies.
                  commonlength = diff_commonPrefix(text_insert, text_delete);
                  if (commonlength !== 0) {
                    if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) {
                      diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                    } else {
                      diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                      pointer++;
                    }
                    text_insert = text_insert.substring(commonlength);
                    text_delete = text_delete.substring(commonlength);
                  }
                  // Factor out any common suffixies.
                  commonlength = diff_commonSuffix(text_insert, text_delete);
                  if (commonlength !== 0) {
                    diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                    text_insert = text_insert.substring(0, text_insert.length - commonlength);
                    text_delete = text_delete.substring(0, text_delete.length - commonlength);
                  }
                }
                // Delete the offending records and add the merged ones.
                if (count_delete === 0) {
                  diffs.splice(pointer - count_insert, count_delete + count_insert, [DIFF_INSERT, text_insert]);
                } else if (count_insert === 0) {
                  diffs.splice(pointer - count_delete, count_delete + count_insert, [DIFF_DELETE, text_delete]);
                } else {
                  diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
                }
                pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
              } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
              } else {
                pointer++;
              }
              count_insert = 0;
              count_delete = 0;
              text_delete = '';
              text_insert = '';
              break;
          }
        }
        if (diffs[diffs.length - 1][1] === '') {
          diffs.pop(); // Remove the dummy entry at the end.
        }

        // Second pass: look for single edits surrounded on both sides by equalities
        // which can be shifted sideways to eliminate an equality.
        // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
        var changes = false;
        pointer = 1;
        // Intentionally ignore the first and last element (don't need checking).
        while (pointer < diffs.length - 1) {
          if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
              // Shift the edit over the previous equality.
              diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
              diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
              diffs.splice(pointer - 1, 1);
              changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
              // Shift the edit over the next equality.
              diffs[pointer - 1][1] += diffs[pointer + 1][1];
              diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
              diffs.splice(pointer + 1, 1);
              changes = true;
            }
          }
          pointer++;
        }
        // If shifts were made, the diff needs reordering and another shift sweep.
        if (changes) {
          diff_cleanupMerge(diffs);
        }
      };

      var diff = diff_main;
      diff.INSERT = DIFF_INSERT;
      diff.DELETE = DIFF_DELETE;
      diff.EQUAL = DIFF_EQUAL;

      module.exports = diff;

      /*
       * Modify a diff such that the cursor position points to the start of a change:
       * E.g.
       *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
       *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
       *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
       *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
       *
       * @param {Array} diffs Array of diff tuples
       * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
       * @return {Array} A tuple [cursor location in the modified diff, modified diff]
       */
      function cursor_normalize_diff(diffs, cursor_pos) {
        if (cursor_pos === 0) {
          return [DIFF_EQUAL, diffs];
        }
        for (var current_pos = 0, i = 0; i < diffs.length; i++) {
          var d = diffs[i];
          if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
            var next_pos = current_pos + d[1].length;
            if (cursor_pos === next_pos) {
              return [i + 1, diffs];
            } else if (cursor_pos < next_pos) {
              // copy to prevent side effects
              diffs = diffs.slice();
              // split d into two diff changes
              var split_pos = cursor_pos - current_pos;
              var d_left = [d[0], d[1].slice(0, split_pos)];
              var d_right = [d[0], d[1].slice(split_pos)];
              diffs.splice(i, 1, d_left, d_right);
              return [i + 1, diffs];
            } else {
              current_pos = next_pos;
            }
          }
        }
        throw new Error('cursor_pos is out of bounds!');
      }

      /*
       * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
       *
       * Case 1)
       *   Check if a naive shift is possible:
       *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
       *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
       * Case 2)
       *   Check if the following shifts are possible:
       *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
       *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
       *         ^            ^
       *         d          d_next
       *
       * @param {Array} diffs Array of diff tuples
       * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
       * @return {Array} Array of diff tuples
       */
      function fix_cursor(diffs, cursor_pos) {
        var norm = cursor_normalize_diff(diffs, cursor_pos);
        var ndiffs = norm[1];
        var cursor_pointer = norm[0];
        var d = ndiffs[cursor_pointer];
        var d_next = ndiffs[cursor_pointer + 1];

        if (d == null) {
          // Text was deleted from end of original string,
          // cursor is now out of bounds in new string
          return diffs;
        } else if (d[0] !== DIFF_EQUAL) {
          // A modification happened at the cursor location.
          // This is the expected outcome, so we can return the original diff.
          return diffs;
        } else {
          if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
            // Case 1)
            // It is possible to perform a naive shift
            ndiffs.splice(cursor_pointer, 2, d_next, d);
            return merge_tuples(ndiffs, cursor_pointer, 2);
          } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
            // Case 2)
            // d[1] is a prefix of d_next[1]
            // We can assume that d_next[0] !== 0, since d[0] === 0
            // Shift edit locations..
            ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
            var suffix = d_next[1].slice(d[1].length);
            if (suffix.length > 0) {
              ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
            }
            return merge_tuples(ndiffs, cursor_pointer, 3);
          } else {
            // Not possible to perform any modification
            return diffs;
          }
        }
      }

      /*
       * Check diff did not split surrogate pairs.
       * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
       *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
       *
       * @param {Array} diffs Array of diff tuples
       * @return {Array} Array of diff tuples
       */
      function fix_emoji(diffs) {
        var compact = false;
        var starts_with_pair_end = function starts_with_pair_end(str) {
          return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
        };
        var ends_with_pair_start = function ends_with_pair_start(str) {
          return str.charCodeAt(str.length - 1) >= 0xD800 && str.charCodeAt(str.length - 1) <= 0xDBFF;
        };
        for (var i = 2; i < diffs.length; i += 1) {
          if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
            compact = true;

            diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
            diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];

            diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
          }
        }
        if (!compact) {
          return diffs;
        }
        var fixed_diffs = [];
        for (var i = 0; i < diffs.length; i += 1) {
          if (diffs[i][1].length > 0) {
            fixed_diffs.push(diffs[i]);
          }
        }
        return fixed_diffs;
      }

      /*
       * Try to merge tuples with their neigbors in a given range.
       * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
       *
       * @param {Array} diffs Array of diff tuples.
       * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
       * @param {Int} length Number of consecutive elements to check.
       * @return {Array} Array of merged diff tuples.
       */
      function merge_tuples(diffs, start, length) {
        // Check from (start-1) to (start+length).
        for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
          if (i + 1 < diffs.length) {
            var left_d = diffs[i];
            var right_d = diffs[i + 1];
            if (left_d[0] === right_d[1]) {
              diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
            }
          }
        }
        return diffs;
      }

      /***/
    },
    /* 52 */
    /***/function (module, exports) {

      exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;

      exports.shim = shim;
      function shim(obj) {
        var keys = [];
        for (var key in obj) {
          keys.push(key);
        }return keys;
      }

      /***/
    },
    /* 53 */
    /***/function (module, exports) {

      var supportsArgumentsClass = function () {
        return Object.prototype.toString.call(arguments);
      }() == '[object Arguments]';

      exports = module.exports = supportsArgumentsClass ? supported : unsupported;

      exports.supported = supported;
      function supported(object) {
        return Object.prototype.toString.call(object) == '[object Arguments]';
      };

      exports.unsupported = unsupported;
      function unsupported(object) {
        return object && (typeof object === 'undefined' ? 'undefined' : _typeof2(object)) == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
      };

      /***/
    },
    /* 54 */
    /***/function (module, exports) {

      'use strict';

      var has = Object.prototype.hasOwnProperty,
          prefix = '~';

      /**
       * Constructor to create a storage for our `EE` objects.
       * An `Events` instance is a plain object whose properties are event names.
       *
       * @constructor
       * @api private
       */
      function Events() {}

      //
      // We try to not inherit from `Object.prototype`. In some engines creating an
      // instance in this way is faster than calling `Object.create(null)` directly.
      // If `Object.create(null)` is not supported we prefix the event names with a
      // character to make sure that the built-in object properties are not
      // overridden or used as an attack vector.
      //
      if (Object.create) {
        Events.prototype = Object.create(null);

        //
        // This hack is needed because the `__proto__` property is still inherited in
        // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
        //
        if (!new Events().__proto__) prefix = false;
      }

      /**
       * Representation of a single event listener.
       *
       * @param {Function} fn The listener function.
       * @param {Mixed} context The context to invoke the listener with.
       * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
       * @constructor
       * @api private
       */
      function EE(fn, context, once) {
        this.fn = fn;
        this.context = context;
        this.once = once || false;
      }

      /**
       * Minimal `EventEmitter` interface that is molded against the Node.js
       * `EventEmitter` interface.
       *
       * @constructor
       * @api public
       */
      function EventEmitter() {
        this._events = new Events();
        this._eventsCount = 0;
      }

      /**
       * Return an array listing the events for which the emitter has registered
       * listeners.
       *
       * @returns {Array}
       * @api public
       */
      EventEmitter.prototype.eventNames = function eventNames() {
        var names = [],
            events,
            name;

        if (this._eventsCount === 0) return names;

        for (name in events = this._events) {
          if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
        }

        if (Object.getOwnPropertySymbols) {
          return names.concat(Object.getOwnPropertySymbols(events));
        }

        return names;
      };

      /**
       * Return the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Boolean} exists Only check if there are listeners.
       * @returns {Array|Boolean}
       * @api public
       */
      EventEmitter.prototype.listeners = function listeners(event, exists) {
        var evt = prefix ? prefix + event : event,
            available = this._events[evt];

        if (exists) return !!available;
        if (!available) return [];
        if (available.fn) return [available.fn];

        for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
          ee[i] = available[i].fn;
        }

        return ee;
      };

      /**
       * Calls each of the listeners registered for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @returns {Boolean} `true` if the event had listeners, else `false`.
       * @api public
       */
      EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
        var evt = prefix ? prefix + event : event;

        if (!this._events[evt]) return false;

        var listeners = this._events[evt],
            len = arguments.length,
            args,
            i;

        if (listeners.fn) {
          if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

          switch (len) {
            case 1:
              return listeners.fn.call(listeners.context), true;
            case 2:
              return listeners.fn.call(listeners.context, a1), true;
            case 3:
              return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
              return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
              return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
          }

          for (i = 1, args = new Array(len - 1); i < len; i++) {
            args[i - 1] = arguments[i];
          }

          listeners.fn.apply(listeners.context, args);
        } else {
          var length = listeners.length,
              j;

          for (i = 0; i < length; i++) {
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

            switch (len) {
              case 1:
                listeners[i].fn.call(listeners[i].context);break;
              case 2:
                listeners[i].fn.call(listeners[i].context, a1);break;
              case 3:
                listeners[i].fn.call(listeners[i].context, a1, a2);break;
              case 4:
                listeners[i].fn.call(listeners[i].context, a1, a2, a3);break;
              default:
                if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                  args[j - 1] = arguments[j];
                }

                listeners[i].fn.apply(listeners[i].context, args);
            }
          }
        }

        return true;
      };

      /**
       * Add a listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.on = function on(event, fn, context) {
        var listener = new EE(fn, context || this),
            evt = prefix ? prefix + event : event;

        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

        return this;
      };

      /**
       * Add a one-time listener for a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn The listener function.
       * @param {Mixed} [context=this] The context to invoke the listener with.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.once = function once(event, fn, context) {
        var listener = new EE(fn, context || this, true),
            evt = prefix ? prefix + event : event;

        if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];

        return this;
      };

      /**
       * Remove the listeners of a given event.
       *
       * @param {String|Symbol} event The event name.
       * @param {Function} fn Only remove the listeners that match this function.
       * @param {Mixed} context Only remove the listeners that have this context.
       * @param {Boolean} once Only remove one-time listeners.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
        var evt = prefix ? prefix + event : event;

        if (!this._events[evt]) return this;
        if (!fn) {
          if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          return this;
        }

        var listeners = this._events[evt];

        if (listeners.fn) {
          if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          for (var i = 0, events = [], length = listeners.length; i < length; i++) {
            if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
              events.push(listeners[i]);
            }
          }

          //
          // Reset the array, or remove it completely if we have no more listeners.
          //
          if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
        }

        return this;
      };

      /**
       * Remove all listeners, or those of the specified event.
       *
       * @param {String|Symbol} [event] The event name.
       * @returns {EventEmitter} `this`.
       * @api public
       */
      EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
        var evt;

        if (event) {
          evt = prefix ? prefix + event : event;
          if (this._events[evt]) {
            if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
          }
        } else {
          this._events = new Events();
          this._eventsCount = 0;
        }

        return this;
      };

      //
      // Alias methods names because people roll like that.
      //
      EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
      EventEmitter.prototype.addListener = EventEmitter.prototype.on;

      //
      // This function doesn't apply anymore.
      //
      EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
        return this;
      };

      //
      // Expose the prefix.
      //
      EventEmitter.prefixed = prefix;

      //
      // Allow `EventEmitter` to be imported as module namespace.
      //
      EventEmitter.EventEmitter = EventEmitter;

      //
      // Expose the module.
      //
      if ('undefined' !== typeof module) {
        module.exports = EventEmitter;
      }

      /***/
    },
    /* 55 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

      var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
      };

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend2 = __webpack_require__(3);

      var _extend3 = _interopRequireDefault(_extend2);

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _align = __webpack_require__(36);

      var _background = __webpack_require__(37);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _color = __webpack_require__(26);

      var _direction = __webpack_require__(38);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:clipboard');

      var DOM_KEY = '__ql-matcher';

      var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

      var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});

      var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
        memo[attr.keyName] = attr;
        return memo;
      }, {});

      var Clipboard = function (_Module) {
        _inherits(Clipboard, _Module);

        function Clipboard(quill, options) {
          _classCallCheck(this, Clipboard);

          var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

          _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
          _this.container = _this.quill.addContainer('ql-clipboard');
          _this.container.setAttribute('contenteditable', true);
          _this.container.setAttribute('tabindex', -1);
          _this.matchers = [];
          CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                selector = _ref2[0],
                matcher = _ref2[1];

            if (!options.matchVisual && matcher === matchSpacing) return;
            _this.addMatcher(selector, matcher);
          });
          return _this;
        }

        _createClass(Clipboard, [{
          key: 'addMatcher',
          value: function addMatcher(selector, matcher) {
            this.matchers.push([selector, matcher]);
          }
        }, {
          key: 'convert',
          value: function convert(html) {
            if (typeof html === 'string') {
              this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
              return this.convert();
            }
            var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
            if (formats[_code2.default.blotName]) {
              var text = this.container.innerText;
              this.container.innerHTML = '';
              return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
            }

            var _prepareMatching = this.prepareMatching(),
                _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
                elementMatchers = _prepareMatching2[0],
                textMatchers = _prepareMatching2[1];

            var delta = traverse(this.container, elementMatchers, textMatchers);
            // Remove trailing newline
            if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
              delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
            }
            debug.log('convert', this.container.innerHTML, delta);
            this.container.innerHTML = '';
            return delta;
          }
        }, {
          key: 'dangerouslyPasteHTML',
          value: function dangerouslyPasteHTML(index, html) {
            var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

            if (typeof index === 'string') {
              this.quill.setContents(this.convert(index), html);
              this.quill.setSelection(0, _quill2.default.sources.SILENT);
            } else {
              var paste = this.convert(html);
              this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
              this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
            }
          }
        }, {
          key: 'onPaste',
          value: function onPaste(e) {
            var _this2 = this;

            if (e.defaultPrevented || !this.quill.isEnabled()) return;
            var range = this.quill.getSelection();
            var delta = new _quillDelta2.default().retain(range.index);
            var scrollTop = this.quill.scrollingContainer.scrollTop;
            this.container.focus();
            this.quill.selection.update(_quill2.default.sources.SILENT);
            setTimeout(function () {
              delta = delta.concat(_this2.convert()).delete(range.length);
              _this2.quill.updateContents(delta, _quill2.default.sources.USER);
              // range.length contributes to delta.length()
              _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
              _this2.quill.scrollingContainer.scrollTop = scrollTop;
              _this2.quill.focus();
            }, 1);
          }
        }, {
          key: 'prepareMatching',
          value: function prepareMatching() {
            var _this3 = this;

            var elementMatchers = [],
                textMatchers = [];
            this.matchers.forEach(function (pair) {
              var _pair = _slicedToArray(pair, 2),
                  selector = _pair[0],
                  matcher = _pair[1];

              switch (selector) {
                case Node.TEXT_NODE:
                  textMatchers.push(matcher);
                  break;
                case Node.ELEMENT_NODE:
                  elementMatchers.push(matcher);
                  break;
                default:
                  [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
                    // TODO use weakmap
                    node[DOM_KEY] = node[DOM_KEY] || [];
                    node[DOM_KEY].push(matcher);
                  });
                  break;
              }
            });
            return [elementMatchers, textMatchers];
          }
        }]);

        return Clipboard;
      }(_module2.default);

      Clipboard.DEFAULTS = {
        matchers: [],
        matchVisual: true
      };

      function applyFormat(delta, format, value) {
        if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
          return Object.keys(format).reduce(function (delta, key) {
            return applyFormat(delta, key, format[key]);
          }, delta);
        } else {
          return delta.reduce(function (delta, op) {
            if (op.attributes && op.attributes[format]) {
              return delta.push(op);
            } else {
              return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
            }
          }, new _quillDelta2.default());
        }
      }

      function computeStyle(node) {
        if (node.nodeType !== Node.ELEMENT_NODE) return {};
        var DOM_KEY = '__ql-computed-style';
        return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
      }

      function deltaEndsWith(delta, text) {
        var endText = "";
        for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
          var op = delta.ops[i];
          if (typeof op.insert !== 'string') break;
          endText = op.insert + endText;
        }
        return endText.slice(-1 * text.length) === text;
      }

      function isLine(node) {
        if (node.childNodes.length === 0) return false; // Exclude embed blocks
        var style = computeStyle(node);
        return ['block', 'list-item'].indexOf(style.display) > -1;
      }

      function traverse(node, elementMatchers, textMatchers) {
        // Post-order
        if (node.nodeType === node.TEXT_NODE) {
          return textMatchers.reduce(function (delta, matcher) {
            return matcher(node, delta);
          }, new _quillDelta2.default());
        } else if (node.nodeType === node.ELEMENT_NODE) {
          return [].reduce.call(node.childNodes || [], function (delta, childNode) {
            var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
            if (childNode.nodeType === node.ELEMENT_NODE) {
              childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
                return matcher(childNode, childrenDelta);
              }, childrenDelta);
              childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
                return matcher(childNode, childrenDelta);
              }, childrenDelta);
            }
            return delta.concat(childrenDelta);
          }, new _quillDelta2.default());
        } else {
          return new _quillDelta2.default();
        }
      }

      function matchAlias(format, node, delta) {
        return applyFormat(delta, format, true);
      }

      function matchAttributor(node, delta) {
        var attributes = _parchment2.default.Attributor.Attribute.keys(node);
        var classes = _parchment2.default.Attributor.Class.keys(node);
        var styles = _parchment2.default.Attributor.Style.keys(node);
        var formats = {};
        attributes.concat(classes).concat(styles).forEach(function (name) {
          var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
          if (attr != null) {
            formats[attr.attrName] = attr.value(node);
            if (formats[attr.attrName]) return;
          }
          attr = ATTRIBUTE_ATTRIBUTORS[name];
          if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            formats[attr.attrName] = attr.value(node) || undefined;
          }
          attr = STYLE_ATTRIBUTORS[name];
          if (attr != null && (attr.attrName === name || attr.keyName === name)) {
            attr = STYLE_ATTRIBUTORS[name];
            formats[attr.attrName] = attr.value(node) || undefined;
          }
        });
        if (Object.keys(formats).length > 0) {
          delta = applyFormat(delta, formats);
        }
        return delta;
      }

      function matchBlot(node, delta) {
        var match = _parchment2.default.query(node);
        if (match == null) return delta;
        if (match.prototype instanceof _parchment2.default.Embed) {
          var embed = {};
          var value = match.value(node);
          if (value != null) {
            embed[match.blotName] = value;
            delta = new _quillDelta2.default().insert(embed, match.formats(node));
          }
        } else if (typeof match.formats === 'function') {
          delta = applyFormat(delta, match.blotName, match.formats(node));
        }
        return delta;
      }

      function matchBreak(node, delta) {
        if (!deltaEndsWith(delta, '\n')) {
          delta.insert('\n');
        }
        return delta;
      }

      function matchIgnore() {
        return new _quillDelta2.default();
      }

      function matchIndent(node, delta) {
        var match = _parchment2.default.query(node);
        if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
          return delta;
        }
        var indent = -1,
            parent = node.parentNode;
        while (!parent.classList.contains('ql-clipboard')) {
          if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
            indent += 1;
          }
          parent = parent.parentNode;
        }
        if (indent <= 0) return delta;
        return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
      }

      function matchNewline(node, delta) {
        if (!deltaEndsWith(delta, '\n')) {
          if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
            delta.insert('\n');
          }
        }
        return delta;
      }

      function matchSpacing(node, delta) {
        if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
          var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
          if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
            delta.insert('\n');
          }
        }
        return delta;
      }

      function matchStyles(node, delta) {
        var formats = {};
        var style = node.style || {};
        if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
          formats.italic = true;
        }
        if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
          formats.bold = true;
        }
        if (Object.keys(formats).length > 0) {
          delta = applyFormat(delta, formats);
        }
        if (parseFloat(style.textIndent || 0) > 0) {
          // Could be 0.5in
          delta = new _quillDelta2.default().insert('\t').concat(delta);
        }
        return delta;
      }

      function matchText(node, delta) {
        var text = node.data;
        // Word represents empty line with <o:p>&nbsp;</o:p>
        if (node.parentNode.tagName === 'O:P') {
          return delta.insert(text.trim());
        }
        if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
          return delta;
        }
        if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
          // eslint-disable-next-line func-style
          var replacer = function replacer(collapse, match) {
            match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
            return match.length < 1 && collapse ? ' ' : match;
          };
          text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
          text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
          if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
            text = text.replace(/^\s+/, replacer.bind(replacer, false));
          }
          if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
            text = text.replace(/\s+$/, replacer.bind(replacer, false));
          }
        }
        return delta.insert(text);
      }

      exports.default = Clipboard;
      exports.matchAttributor = matchAttributor;
      exports.matchBlot = matchBlot;
      exports.matchNewline = matchNewline;
      exports.matchSpacing = matchSpacing;
      exports.matchText = matchText;

      /***/
    },
    /* 56 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Bold = function (_Inline) {
        _inherits(Bold, _Inline);

        function Bold() {
          _classCallCheck(this, Bold);

          return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
        }

        _createClass(Bold, [{
          key: 'optimize',
          value: function optimize(context) {
            _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
            if (this.domNode.tagName !== this.statics.tagName[0]) {
              this.replaceWith(this.statics.blotName);
            }
          }
        }], [{
          key: 'create',
          value: function create() {
            return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
          }
        }, {
          key: 'formats',
          value: function formats() {
            return true;
          }
        }]);

        return Bold;
      }(_inline2.default);

      Bold.blotName = 'bold';
      Bold.tagName = ['STRONG', 'B'];

      exports.default = Bold;

      /***/
    },
    /* 57 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.addControls = exports.default = undefined;

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _quillDelta = __webpack_require__(2);

      var _quillDelta2 = _interopRequireDefault(_quillDelta);

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _logger = __webpack_require__(10);

      var _logger2 = _interopRequireDefault(_logger);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var debug = (0, _logger2.default)('quill:toolbar');

      var Toolbar = function (_Module) {
        _inherits(Toolbar, _Module);

        function Toolbar(quill, options) {
          _classCallCheck(this, Toolbar);

          var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

          if (Array.isArray(_this.options.container)) {
            var container = document.createElement('div');
            addControls(container, _this.options.container);
            quill.container.parentNode.insertBefore(container, quill.container);
            _this.container = container;
          } else if (typeof _this.options.container === 'string') {
            _this.container = document.querySelector(_this.options.container);
          } else {
            _this.container = _this.options.container;
          }
          if (!(_this.container instanceof HTMLElement)) {
            var _ret;

            return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
          }
          _this.container.classList.add('ql-toolbar');
          _this.controls = [];
          _this.handlers = {};
          Object.keys(_this.options.handlers).forEach(function (format) {
            _this.addHandler(format, _this.options.handlers[format]);
          });
          [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
            _this.attach(input);
          });
          _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
            if (type === _quill2.default.events.SELECTION_CHANGE) {
              _this.update(range);
            }
          });
          _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            var _this$quill$selection = _this.quill.selection.getRange(),
                _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
                range = _this$quill$selection2[0]; // quill.getSelection triggers update


            _this.update(range);
          });
          return _this;
        }

        _createClass(Toolbar, [{
          key: 'addHandler',
          value: function addHandler(format, handler) {
            this.handlers[format] = handler;
          }
        }, {
          key: 'attach',
          value: function attach(input) {
            var _this2 = this;

            var format = [].find.call(input.classList, function (className) {
              return className.indexOf('ql-') === 0;
            });
            if (!format) return;
            format = format.slice('ql-'.length);
            if (input.tagName === 'BUTTON') {
              input.setAttribute('type', 'button');
            }
            if (this.handlers[format] == null) {
              if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                debug.warn('ignoring attaching to disabled format', format, input);
                return;
              }
              if (_parchment2.default.query(format) == null) {
                debug.warn('ignoring attaching to nonexistent format', format, input);
                return;
              }
            }
            var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
            input.addEventListener(eventName, function (e) {
              var value = void 0;
              if (input.tagName === 'SELECT') {
                if (input.selectedIndex < 0) return;
                var selected = input.options[input.selectedIndex];
                if (selected.hasAttribute('selected')) {
                  value = false;
                } else {
                  value = selected.value || false;
                }
              } else {
                if (input.classList.contains('ql-active')) {
                  value = false;
                } else {
                  value = input.value || !input.hasAttribute('value');
                }
                e.preventDefault();
              }
              _this2.quill.focus();

              var _quill$selection$getR = _this2.quill.selection.getRange(),
                  _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
                  range = _quill$selection$getR2[0];

              if (_this2.handlers[format] != null) {
                _this2.handlers[format].call(_this2, value);
              } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                value = prompt('Enter ' + format);
                if (!value) return;
                _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
              } else {
                _this2.quill.format(format, value, _quill2.default.sources.USER);
              }
              _this2.update(range);
            });
            // TODO use weakmap
            this.controls.push([format, input]);
          }
        }, {
          key: 'update',
          value: function update(range) {
            var formats = range == null ? {} : this.quill.getFormat(range);
            this.controls.forEach(function (pair) {
              var _pair = _slicedToArray(pair, 2),
                  format = _pair[0],
                  input = _pair[1];

              if (input.tagName === 'SELECT') {
                var option = void 0;
                if (range == null) {
                  option = null;
                } else if (formats[format] == null) {
                  option = input.querySelector('option[selected]');
                } else if (!Array.isArray(formats[format])) {
                  var value = formats[format];
                  if (typeof value === 'string') {
                    value = value.replace(/\"/g, '\\"');
                  }
                  option = input.querySelector('option[value="' + value + '"]');
                }
                if (option == null) {
                  input.value = ''; // TODO make configurable?
                  input.selectedIndex = -1;
                } else {
                  option.selected = true;
                }
              } else {
                if (range == null) {
                  input.classList.remove('ql-active');
                } else if (input.hasAttribute('value')) {
                  // both being null should match (default values)
                  // '1' should match with 1 (headers)
                  var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
                  input.classList.toggle('ql-active', isActive);
                } else {
                  input.classList.toggle('ql-active', formats[format] != null);
                }
              }
            });
          }
        }]);

        return Toolbar;
      }(_module2.default);

      Toolbar.DEFAULTS = {};

      function addButton(container, format, value) {
        var input = document.createElement('button');
        input.setAttribute('type', 'button');
        input.classList.add('ql-' + format);
        if (value != null) {
          input.value = value;
        }
        container.appendChild(input);
      }

      function addControls(container, groups) {
        if (!Array.isArray(groups[0])) {
          groups = [groups];
        }
        groups.forEach(function (controls) {
          var group = document.createElement('span');
          group.classList.add('ql-formats');
          controls.forEach(function (control) {
            if (typeof control === 'string') {
              addButton(group, control);
            } else {
              var format = Object.keys(control)[0];
              var value = control[format];
              if (Array.isArray(value)) {
                addSelect(group, format, value);
              } else {
                addButton(group, format, value);
              }
            }
          });
          container.appendChild(group);
        });
      }

      function addSelect(container, format, values) {
        var input = document.createElement('select');
        input.classList.add('ql-' + format);
        values.forEach(function (value) {
          var option = document.createElement('option');
          if (value !== false) {
            option.setAttribute('value', value);
          } else {
            option.setAttribute('selected', 'selected');
          }
          input.appendChild(option);
        });
        container.appendChild(input);
      }

      Toolbar.DEFAULTS = {
        container: null,
        handlers: {
          clean: function clean() {
            var _this3 = this;

            var range = this.quill.getSelection();
            if (range == null) return;
            if (range.length == 0) {
              var formats = this.quill.getFormat();
              Object.keys(formats).forEach(function (name) {
                // Clean functionality in existing apps only clean inline formats
                if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
                  _this3.quill.format(name, false);
                }
              });
            } else {
              this.quill.removeFormat(range, _quill2.default.sources.USER);
            }
          },
          direction: function direction(value) {
            var align = this.quill.getFormat()['align'];
            if (value === 'rtl' && align == null) {
              this.quill.format('align', 'right', _quill2.default.sources.USER);
            } else if (!value && align === 'right') {
              this.quill.format('align', false, _quill2.default.sources.USER);
            }
            this.quill.format('direction', value, _quill2.default.sources.USER);
          },
          indent: function indent(value) {
            var range = this.quill.getSelection();
            var formats = this.quill.getFormat(range);
            var indent = parseInt(formats.indent || 0);
            if (value === '+1' || value === '-1') {
              var modifier = value === '+1' ? 1 : -1;
              if (formats.direction === 'rtl') modifier *= -1;
              this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
            }
          },
          link: function link(value) {
            if (value === true) {
              value = prompt('Enter link URL:');
            }
            this.quill.format('link', value, _quill2.default.sources.USER);
          },
          list: function list(value) {
            var range = this.quill.getSelection();
            var formats = this.quill.getFormat(range);
            if (value === 'check') {
              if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
                this.quill.format('list', false, _quill2.default.sources.USER);
              } else {
                this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
              }
            } else {
              this.quill.format('list', value, _quill2.default.sources.USER);
            }
          }
        }
      };

      exports.default = Toolbar;
      exports.addControls = addControls;

      /***/
    },
    /* 58 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

      /***/
    },
    /* 59 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ColorPicker = function (_Picker) {
        _inherits(ColorPicker, _Picker);

        function ColorPicker(select, label) {
          _classCallCheck(this, ColorPicker);

          var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

          _this.label.innerHTML = label;
          _this.container.classList.add('ql-color-picker');
          [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
            item.classList.add('ql-primary');
          });
          return _this;
        }

        _createClass(ColorPicker, [{
          key: 'buildItem',
          value: function buildItem(option) {
            var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
            item.style.backgroundColor = option.getAttribute('value') || '';
            return item;
          }
        }, {
          key: 'selectItem',
          value: function selectItem(item, trigger) {
            _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
            var colorLabel = this.label.querySelector('.ql-color-label');
            var value = item ? item.getAttribute('data-value') || '' : '';
            if (colorLabel) {
              if (colorLabel.tagName === 'line') {
                colorLabel.style.stroke = value;
              } else {
                colorLabel.style.fill = value;
              }
            }
          }
        }]);

        return ColorPicker;
      }(_picker2.default);

      exports.default = ColorPicker;

      /***/
    },
    /* 60 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IconPicker = function (_Picker) {
        _inherits(IconPicker, _Picker);

        function IconPicker(select, icons) {
          _classCallCheck(this, IconPicker);

          var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

          _this.container.classList.add('ql-icon-picker');
          [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
            item.innerHTML = icons[item.getAttribute('data-value') || ''];
          });
          _this.defaultItem = _this.container.querySelector('.ql-selected');
          _this.selectItem(_this.defaultItem);
          return _this;
        }

        _createClass(IconPicker, [{
          key: 'selectItem',
          value: function selectItem(item, trigger) {
            _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
            item = item || this.defaultItem;
            this.label.innerHTML = item.innerHTML;
          }
        }]);

        return IconPicker;
      }(_picker2.default);

      exports.default = IconPicker;

      /***/
    },
    /* 61 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      var Tooltip = function () {
        function Tooltip(quill, boundsContainer) {
          var _this = this;

          _classCallCheck(this, Tooltip);

          this.quill = quill;
          this.boundsContainer = boundsContainer || document.body;
          this.root = quill.addContainer('ql-tooltip');
          this.root.innerHTML = this.constructor.TEMPLATE;
          if (this.quill.root === this.quill.scrollingContainer) {
            this.quill.root.addEventListener('scroll', function () {
              _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
            });
          }
          this.hide();
        }

        _createClass(Tooltip, [{
          key: 'hide',
          value: function hide() {
            this.root.classList.add('ql-hidden');
          }
        }, {
          key: 'position',
          value: function position(reference) {
            var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
            // root.scrollTop should be 0 if scrollContainer !== root
            var top = reference.bottom + this.quill.root.scrollTop;
            this.root.style.left = left + 'px';
            this.root.style.top = top + 'px';
            this.root.classList.remove('ql-flip');
            var containerBounds = this.boundsContainer.getBoundingClientRect();
            var rootBounds = this.root.getBoundingClientRect();
            var shift = 0;
            if (rootBounds.right > containerBounds.right) {
              shift = containerBounds.right - rootBounds.right;
              this.root.style.left = left + shift + 'px';
            }
            if (rootBounds.left < containerBounds.left) {
              shift = containerBounds.left - rootBounds.left;
              this.root.style.left = left + shift + 'px';
            }
            if (rootBounds.bottom > containerBounds.bottom) {
              var height = rootBounds.bottom - rootBounds.top;
              var verticalShift = reference.bottom - reference.top + height;
              this.root.style.top = top - verticalShift + 'px';
              this.root.classList.add('ql-flip');
            }
            return shift;
          }
        }, {
          key: 'show',
          value: function show() {
            this.root.classList.remove('ql-editing');
            this.root.classList.remove('ql-hidden');
          }
        }]);

        return Tooltip;
      }();

      exports.default = Tooltip;

      /***/
    },
    /* 62 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;_e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }return _arr;
        }return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

      var SnowTheme = function (_BaseTheme) {
        _inherits(SnowTheme, _BaseTheme);

        function SnowTheme(quill, options) {
          _classCallCheck(this, SnowTheme);

          if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
            options.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

          _this.quill.container.classList.add('ql-snow');
          return _this;
        }

        _createClass(SnowTheme, [{
          key: 'extendToolbar',
          value: function extendToolbar(toolbar) {
            toolbar.container.classList.add('ql-snow');
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
            this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
            if (toolbar.container.querySelector('.ql-link')) {
              this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
                toolbar.handlers['link'].call(toolbar, !context.format.link);
              });
            }
          }
        }]);

        return SnowTheme;
      }(_base2.default);

      SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (value) {
                  var range = this.quill.getSelection();
                  if (range == null || range.length == 0) return;
                  var preview = this.quill.getText(range);
                  if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
                    preview = 'mailto:' + preview;
                  }
                  var tooltip = this.quill.theme.tooltip;
                  tooltip.edit('link', preview);
                } else {
                  this.quill.format('link', false);
                }
              }
            }
          }
        }
      });

      var SnowTooltip = function (_BaseTooltip) {
        _inherits(SnowTooltip, _BaseTooltip);

        function SnowTooltip(quill, bounds) {
          _classCallCheck(this, SnowTooltip);

          var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

          _this2.preview = _this2.root.querySelector('a.ql-preview');
          return _this2;
        }

        _createClass(SnowTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this3 = this;

            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
            this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
              if (_this3.root.classList.contains('ql-editing')) {
                _this3.save();
              } else {
                _this3.edit('link', _this3.preview.textContent);
              }
              event.preventDefault();
            });
            this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
              if (_this3.linkRange != null) {
                var range = _this3.linkRange;
                _this3.restoreFocus();
                _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
                delete _this3.linkRange;
              }
              event.preventDefault();
              _this3.hide();
            });
            this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
              if (range == null) return;
              if (range.length === 0 && source === _emitter2.default.sources.USER) {
                var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
                    _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
                    link = _quill$scroll$descend2[0],
                    offset = _quill$scroll$descend2[1];

                if (link != null) {
                  _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                  var preview = _link2.default.formats(link.domNode);
                  _this3.preview.textContent = preview;
                  _this3.preview.setAttribute('href', preview);
                  _this3.show();
                  _this3.position(_this3.quill.getBounds(_this3.linkRange));
                  return;
                }
              } else {
                delete _this3.linkRange;
              }
              _this3.hide();
            });
          }
        }, {
          key: 'show',
          value: function show() {
            _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
            this.root.removeAttribute('data-mode');
          }
        }]);

        return SnowTooltip;
      }(_base.BaseTooltip);

      SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

      exports.default = SnowTheme;

      /***/
    },
    /* 63 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _core = __webpack_require__(29);

      var _core2 = _interopRequireDefault(_core);

      var _align = __webpack_require__(36);

      var _direction = __webpack_require__(38);

      var _indent = __webpack_require__(64);

      var _blockquote = __webpack_require__(65);

      var _blockquote2 = _interopRequireDefault(_blockquote);

      var _header = __webpack_require__(66);

      var _header2 = _interopRequireDefault(_header);

      var _list = __webpack_require__(67);

      var _list2 = _interopRequireDefault(_list);

      var _background = __webpack_require__(37);

      var _color = __webpack_require__(26);

      var _font = __webpack_require__(39);

      var _size = __webpack_require__(40);

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      var _italic = __webpack_require__(68);

      var _italic2 = _interopRequireDefault(_italic);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      var _script = __webpack_require__(69);

      var _script2 = _interopRequireDefault(_script);

      var _strike = __webpack_require__(70);

      var _strike2 = _interopRequireDefault(_strike);

      var _underline = __webpack_require__(71);

      var _underline2 = _interopRequireDefault(_underline);

      var _image = __webpack_require__(72);

      var _image2 = _interopRequireDefault(_image);

      var _video = __webpack_require__(73);

      var _video2 = _interopRequireDefault(_video);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      var _formula = __webpack_require__(74);

      var _formula2 = _interopRequireDefault(_formula);

      var _syntax = __webpack_require__(75);

      var _syntax2 = _interopRequireDefault(_syntax);

      var _toolbar = __webpack_require__(57);

      var _toolbar2 = _interopRequireDefault(_toolbar);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      var _picker = __webpack_require__(28);

      var _picker2 = _interopRequireDefault(_picker);

      var _colorPicker = __webpack_require__(59);

      var _colorPicker2 = _interopRequireDefault(_colorPicker);

      var _iconPicker = __webpack_require__(60);

      var _iconPicker2 = _interopRequireDefault(_iconPicker);

      var _tooltip = __webpack_require__(61);

      var _tooltip2 = _interopRequireDefault(_tooltip);

      var _bubble = __webpack_require__(108);

      var _bubble2 = _interopRequireDefault(_bubble);

      var _snow = __webpack_require__(62);

      var _snow2 = _interopRequireDefault(_snow);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      _core2.default.register({
        'attributors/attribute/direction': _direction.DirectionAttribute,

        'attributors/class/align': _align.AlignClass,
        'attributors/class/background': _background.BackgroundClass,
        'attributors/class/color': _color.ColorClass,
        'attributors/class/direction': _direction.DirectionClass,
        'attributors/class/font': _font.FontClass,
        'attributors/class/size': _size.SizeClass,

        'attributors/style/align': _align.AlignStyle,
        'attributors/style/background': _background.BackgroundStyle,
        'attributors/style/color': _color.ColorStyle,
        'attributors/style/direction': _direction.DirectionStyle,
        'attributors/style/font': _font.FontStyle,
        'attributors/style/size': _size.SizeStyle
      }, true);

      _core2.default.register({
        'formats/align': _align.AlignClass,
        'formats/direction': _direction.DirectionClass,
        'formats/indent': _indent.IndentClass,

        'formats/background': _background.BackgroundStyle,
        'formats/color': _color.ColorStyle,
        'formats/font': _font.FontClass,
        'formats/size': _size.SizeClass,

        'formats/blockquote': _blockquote2.default,
        'formats/code-block': _code2.default,
        'formats/header': _header2.default,
        'formats/list': _list2.default,

        'formats/bold': _bold2.default,
        'formats/code': _code.Code,
        'formats/italic': _italic2.default,
        'formats/link': _link2.default,
        'formats/script': _script2.default,
        'formats/strike': _strike2.default,
        'formats/underline': _underline2.default,

        'formats/image': _image2.default,
        'formats/video': _video2.default,

        'formats/list/item': _list.ListItem,

        'modules/formula': _formula2.default,
        'modules/syntax': _syntax2.default,
        'modules/toolbar': _toolbar2.default,

        'themes/bubble': _bubble2.default,
        'themes/snow': _snow2.default,

        'ui/icons': _icons2.default,
        'ui/picker': _picker2.default,
        'ui/icon-picker': _iconPicker2.default,
        'ui/color-picker': _colorPicker2.default,
        'ui/tooltip': _tooltip2.default
      }, true);

      exports.default = _core2.default;

      /***/
    },
    /* 64 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.IndentClass = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var IdentAttributor = function (_Parchment$Attributor) {
        _inherits(IdentAttributor, _Parchment$Attributor);

        function IdentAttributor() {
          _classCallCheck(this, IdentAttributor);

          return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
        }

        _createClass(IdentAttributor, [{
          key: 'add',
          value: function add(node, value) {
            if (value === '+1' || value === '-1') {
              var indent = this.value(node) || 0;
              value = value === '+1' ? indent + 1 : indent - 1;
            }
            if (value === 0) {
              this.remove(node);
              return true;
            } else {
              return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
            }
          }
        }, {
          key: 'canAdd',
          value: function canAdd(node, value) {
            return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
          }
        }, {
          key: 'value',
          value: function value(node) {
            return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
          }
        }]);

        return IdentAttributor;
      }(_parchment2.default.Attributor.Class);

      var IndentClass = new IdentAttributor('indent', 'ql-indent', {
        scope: _parchment2.default.Scope.BLOCK,
        whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
      });

      exports.IndentClass = IndentClass;

      /***/
    },
    /* 65 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Blockquote = function (_Block) {
        _inherits(Blockquote, _Block);

        function Blockquote() {
          _classCallCheck(this, Blockquote);

          return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
        }

        return Blockquote;
      }(_block2.default);

      Blockquote.blotName = 'blockquote';
      Blockquote.tagName = 'blockquote';

      exports.default = Blockquote;

      /***/
    },
    /* 66 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Header = function (_Block) {
        _inherits(Header, _Block);

        function Header() {
          _classCallCheck(this, Header);

          return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
        }

        _createClass(Header, null, [{
          key: 'formats',
          value: function formats(domNode) {
            return this.tagName.indexOf(domNode.tagName) + 1;
          }
        }]);

        return Header;
      }(_block2.default);

      Header.blotName = 'header';
      Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

      exports.default = Header;

      /***/
    },
    /* 67 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.ListItem = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _block = __webpack_require__(4);

      var _block2 = _interopRequireDefault(_block);

      var _container = __webpack_require__(25);

      var _container2 = _interopRequireDefault(_container);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
        } else {
          obj[key] = value;
        }return obj;
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ListItem = function (_Block) {
        _inherits(ListItem, _Block);

        function ListItem() {
          _classCallCheck(this, ListItem);

          return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
        }

        _createClass(ListItem, [{
          key: 'format',
          value: function format(name, value) {
            if (name === List.blotName && !value) {
              this.replaceWith(_parchment2.default.create(this.statics.scope));
            } else {
              _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
            }
          }
        }, {
          key: 'remove',
          value: function remove() {
            if (this.prev == null && this.next == null) {
              this.parent.remove();
            } else {
              _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
            }
          }
        }, {
          key: 'replaceWith',
          value: function replaceWith(name, value) {
            this.parent.isolate(this.offset(this.parent), this.length());
            if (name === this.parent.statics.blotName) {
              this.parent.replaceWith(name, value);
              return this;
            } else {
              this.parent.unwrap();
              return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
            }
          }
        }], [{
          key: 'formats',
          value: function formats(domNode) {
            return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
          }
        }]);

        return ListItem;
      }(_block2.default);

      ListItem.blotName = 'list-item';
      ListItem.tagName = 'LI';

      var List = function (_Container) {
        _inherits(List, _Container);

        _createClass(List, null, [{
          key: 'create',
          value: function create(value) {
            var tagName = value === 'ordered' ? 'OL' : 'UL';
            var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
            if (value === 'checked' || value === 'unchecked') {
              node.setAttribute('data-checked', value === 'checked');
            }
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            if (domNode.tagName === 'OL') return 'ordered';
            if (domNode.tagName === 'UL') {
              if (domNode.hasAttribute('data-checked')) {
                return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
              } else {
                return 'bullet';
              }
            }
            return undefined;
          }
        }]);

        function List(domNode) {
          _classCallCheck(this, List);

          var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

          var listEventHandler = function listEventHandler(e) {
            if (e.target.parentNode !== domNode) return;
            var format = _this2.statics.formats(domNode);
            var blot = _parchment2.default.find(e.target);
            if (format === 'checked') {
              blot.format('list', 'unchecked');
            } else if (format === 'unchecked') {
              blot.format('list', 'checked');
            }
          };

          domNode.addEventListener('touchstart', listEventHandler);
          domNode.addEventListener('mousedown', listEventHandler);
          return _this2;
        }

        _createClass(List, [{
          key: 'format',
          value: function format(name, value) {
            if (this.children.length > 0) {
              this.children.tail.format(name, value);
            }
          }
        }, {
          key: 'formats',
          value: function formats() {
            // We don't inherit from FormatBlot
            return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
          }
        }, {
          key: 'insertBefore',
          value: function insertBefore(blot, ref) {
            if (blot instanceof ListItem) {
              _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
            } else {
              var index = ref == null ? this.length() : ref.offset(this);
              var after = this.split(index);
              after.parent.insertBefore(blot, after);
            }
          }
        }, {
          key: 'optimize',
          value: function optimize(context) {
            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
            var next = this.next;
            if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
              next.moveChildren(this);
              next.remove();
            }
          }
        }, {
          key: 'replace',
          value: function replace(target) {
            if (target.statics.blotName !== this.statics.blotName) {
              var item = _parchment2.default.create(this.statics.defaultChild);
              target.moveChildren(item);
              this.appendChild(item);
            }
            _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
          }
        }]);

        return List;
      }(_container2.default);

      List.blotName = 'list';
      List.scope = _parchment2.default.Scope.BLOCK_BLOT;
      List.tagName = ['OL', 'UL'];
      List.defaultChild = 'list-item';
      List.allowedChildren = [ListItem];

      exports.ListItem = ListItem;
      exports.default = List;

      /***/
    },
    /* 68 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _bold = __webpack_require__(56);

      var _bold2 = _interopRequireDefault(_bold);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Italic = function (_Bold) {
        _inherits(Italic, _Bold);

        function Italic() {
          _classCallCheck(this, Italic);

          return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
        }

        return Italic;
      }(_bold2.default);

      Italic.blotName = 'italic';
      Italic.tagName = ['EM', 'I'];

      exports.default = Italic;

      /***/
    },
    /* 69 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Script = function (_Inline) {
        _inherits(Script, _Inline);

        function Script() {
          _classCallCheck(this, Script);

          return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
        }

        _createClass(Script, null, [{
          key: 'create',
          value: function create(value) {
            if (value === 'super') {
              return document.createElement('sup');
            } else if (value === 'sub') {
              return document.createElement('sub');
            } else {
              return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
            }
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            if (domNode.tagName === 'SUB') return 'sub';
            if (domNode.tagName === 'SUP') return 'super';
            return undefined;
          }
        }]);

        return Script;
      }(_inline2.default);

      Script.blotName = 'script';
      Script.tagName = ['SUB', 'SUP'];

      exports.default = Script;

      /***/
    },
    /* 70 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Strike = function (_Inline) {
        _inherits(Strike, _Inline);

        function Strike() {
          _classCallCheck(this, Strike);

          return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
        }

        return Strike;
      }(_inline2.default);

      Strike.blotName = 'strike';
      Strike.tagName = 'S';

      exports.default = Strike;

      /***/
    },
    /* 71 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _inline = __webpack_require__(6);

      var _inline2 = _interopRequireDefault(_inline);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var Underline = function (_Inline) {
        _inherits(Underline, _Inline);

        function Underline() {
          _classCallCheck(this, Underline);

          return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
        }

        return Underline;
      }(_inline2.default);

      Underline.blotName = 'underline';
      Underline.tagName = 'U';

      exports.default = Underline;

      /***/
    },
    /* 72 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _link = __webpack_require__(27);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ['alt', 'height', 'width'];

      var Image = function (_Parchment$Embed) {
        _inherits(Image, _Parchment$Embed);

        function Image() {
          _classCallCheck(this, Image);

          return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
        }

        _createClass(Image, [{
          key: 'format',
          value: function format(name, value) {
            if (ATTRIBUTES.indexOf(name) > -1) {
              if (value) {
                this.domNode.setAttribute(name, value);
              } else {
                this.domNode.removeAttribute(name);
              }
            } else {
              _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
            }
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
            if (typeof value === 'string') {
              node.setAttribute('src', this.sanitize(value));
            }
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return ATTRIBUTES.reduce(function (formats, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
              }
              return formats;
            }, {});
          }
        }, {
          key: 'match',
          value: function match(url) {
            return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
            );
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('src');
          }
        }]);

        return Image;
      }(_parchment2.default.Embed);

      Image.blotName = 'image';
      Image.tagName = 'IMG';

      exports.default = Image;

      /***/
    },
    /* 73 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _block = __webpack_require__(4);

      var _link = __webpack_require__(27);

      var _link2 = _interopRequireDefault(_link);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var ATTRIBUTES = ['height', 'width'];

      var Video = function (_BlockEmbed) {
        _inherits(Video, _BlockEmbed);

        function Video() {
          _classCallCheck(this, Video);

          return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
        }

        _createClass(Video, [{
          key: 'format',
          value: function format(name, value) {
            if (ATTRIBUTES.indexOf(name) > -1) {
              if (value) {
                this.domNode.setAttribute(name, value);
              } else {
                this.domNode.removeAttribute(name);
              }
            } else {
              _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
            }
          }
        }], [{
          key: 'create',
          value: function create(value) {
            var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
            node.setAttribute('frameborder', '0');
            node.setAttribute('allowfullscreen', true);
            node.setAttribute('src', this.sanitize(value));
            return node;
          }
        }, {
          key: 'formats',
          value: function formats(domNode) {
            return ATTRIBUTES.reduce(function (formats, attribute) {
              if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
              }
              return formats;
            }, {});
          }
        }, {
          key: 'sanitize',
          value: function sanitize(url) {
            return _link2.default.sanitize(url);
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('src');
          }
        }]);

        return Video;
      }(_block.BlockEmbed);

      Video.blotName = 'video';
      Video.className = 'ql-video';
      Video.tagName = 'IFRAME';

      exports.default = Video;

      /***/
    },
    /* 74 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.FormulaBlot = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _embed = __webpack_require__(35);

      var _embed2 = _interopRequireDefault(_embed);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var FormulaBlot = function (_Embed) {
        _inherits(FormulaBlot, _Embed);

        function FormulaBlot() {
          _classCallCheck(this, FormulaBlot);

          return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
        }

        _createClass(FormulaBlot, null, [{
          key: 'create',
          value: function create(value) {
            var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
            if (typeof value === 'string') {
              window.katex.render(value, node, {
                throwOnError: false,
                errorColor: '#f00'
              });
              node.setAttribute('data-value', value);
            }
            return node;
          }
        }, {
          key: 'value',
          value: function value(domNode) {
            return domNode.getAttribute('data-value');
          }
        }]);

        return FormulaBlot;
      }(_embed2.default);

      FormulaBlot.blotName = 'formula';
      FormulaBlot.className = 'ql-formula';
      FormulaBlot.tagName = 'SPAN';

      var Formula = function (_Module) {
        _inherits(Formula, _Module);

        _createClass(Formula, null, [{
          key: 'register',
          value: function register() {
            _quill2.default.register(FormulaBlot, true);
          }
        }]);

        function Formula() {
          _classCallCheck(this, Formula);

          var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

          if (window.katex == null) {
            throw new Error('Formula module requires KaTeX.');
          }
          return _this2;
        }

        return Formula;
      }(_module2.default);

      exports.FormulaBlot = FormulaBlot;
      exports.default = Formula;

      /***/
    },
    /* 75 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.CodeToken = exports.CodeBlock = undefined;

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _parchment = __webpack_require__(0);

      var _parchment2 = _interopRequireDefault(_parchment);

      var _quill = __webpack_require__(5);

      var _quill2 = _interopRequireDefault(_quill);

      var _module = __webpack_require__(9);

      var _module2 = _interopRequireDefault(_module);

      var _code = __webpack_require__(13);

      var _code2 = _interopRequireDefault(_code);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var SyntaxCodeBlock = function (_CodeBlock) {
        _inherits(SyntaxCodeBlock, _CodeBlock);

        function SyntaxCodeBlock() {
          _classCallCheck(this, SyntaxCodeBlock);

          return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
        }

        _createClass(SyntaxCodeBlock, [{
          key: 'replaceWith',
          value: function replaceWith(block) {
            this.domNode.textContent = this.domNode.textContent;
            this.attach();
            _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
          }
        }, {
          key: 'highlight',
          value: function highlight(_highlight) {
            var text = this.domNode.textContent;
            if (this.cachedText !== text) {
              if (text.trim().length > 0 || this.cachedText == null) {
                this.domNode.innerHTML = _highlight(text);
                this.domNode.normalize();
                this.attach();
              }
              this.cachedText = text;
            }
          }
        }]);

        return SyntaxCodeBlock;
      }(_code2.default);

      SyntaxCodeBlock.className = 'ql-syntax';

      var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
        scope: _parchment2.default.Scope.INLINE
      });

      var Syntax = function (_Module) {
        _inherits(Syntax, _Module);

        _createClass(Syntax, null, [{
          key: 'register',
          value: function register() {
            _quill2.default.register(CodeToken, true);
            _quill2.default.register(SyntaxCodeBlock, true);
          }
        }]);

        function Syntax(quill, options) {
          _classCallCheck(this, Syntax);

          var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

          if (typeof _this2.options.highlight !== 'function') {
            throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
          }
          var timer = null;
          _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
              _this2.highlight();
              timer = null;
            }, _this2.options.interval);
          });
          _this2.highlight();
          return _this2;
        }

        _createClass(Syntax, [{
          key: 'highlight',
          value: function highlight() {
            var _this3 = this;

            if (this.quill.selection.composing) return;
            this.quill.update(_quill2.default.sources.USER);
            var range = this.quill.getSelection();
            this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
              code.highlight(_this3.options.highlight);
            });
            this.quill.update(_quill2.default.sources.SILENT);
            if (range != null) {
              this.quill.setSelection(range, _quill2.default.sources.SILENT);
            }
          }
        }]);

        return Syntax;
      }(_module2.default);

      Syntax.DEFAULTS = {
        highlight: function () {
          if (window.hljs == null) return null;
          return function (text) {
            var result = window.hljs.highlightAuto(text);
            return result.value;
          };
        }(),
        interval: 1000
      };

      exports.CodeBlock = SyntaxCodeBlock;
      exports.CodeToken = CodeToken;
      exports.default = Syntax;

      /***/
    },
    /* 76 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 77 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 78 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 79 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

      /***/
    },
    /* 80 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

      /***/
    },
    /* 81 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

      /***/
    },
    /* 82 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

      /***/
    },
    /* 83 */
    /***/function (module, exports) {

      module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

      /***/
    },
    /* 84 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

      /***/
    },
    /* 85 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

      /***/
    },
    /* 86 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

      /***/
    },
    /* 87 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 88 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 89 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

      /***/
    },
    /* 90 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

      /***/
    },
    /* 91 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

      /***/
    },
    /* 92 */
    /***/function (module, exports) {

      module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

      /***/
    },
    /* 93 */
    /***/function (module, exports) {

      module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

      /***/
    },
    /* 94 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

      /***/
    },
    /* 95 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

      /***/
    },
    /* 96 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

      /***/
    },
    /* 97 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

      /***/
    },
    /* 98 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

      /***/
    },
    /* 99 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

      /***/
    },
    /* 100 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

      /***/
    },
    /* 101 */
    /***/function (module, exports) {

      module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

      /***/
    },
    /* 102 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

      /***/
    },
    /* 103 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

      /***/
    },
    /* 104 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

      /***/
    },
    /* 105 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

      /***/
    },
    /* 106 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

      /***/
    },
    /* 107 */
    /***/function (module, exports) {

      module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

      /***/
    },
    /* 108 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = exports.BubbleTooltip = undefined;

      var _get = function get(object, property, receiver) {
        if (object === null) object = Function.prototype;var desc = Object.getOwnPropertyDescriptor(object, property);if (desc === undefined) {
          var parent = Object.getPrototypeOf(object);if (parent === null) {
            return undefined;
          } else {
            return get(parent, property, receiver);
          }
        } else if ("value" in desc) {
          return desc.value;
        } else {
          var getter = desc.get;if (getter === undefined) {
            return undefined;
          }return getter.call(receiver);
        }
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
          }
        }return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
      }();

      var _extend = __webpack_require__(3);

      var _extend2 = _interopRequireDefault(_extend);

      var _emitter = __webpack_require__(8);

      var _emitter2 = _interopRequireDefault(_emitter);

      var _base = __webpack_require__(43);

      var _base2 = _interopRequireDefault(_base);

      var _selection = __webpack_require__(15);

      var _icons = __webpack_require__(41);

      var _icons2 = _interopRequireDefault(_icons);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }return call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === 'undefined' ? 'undefined' : _typeof2(superClass)));
        }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }

      var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

      var BubbleTheme = function (_BaseTheme) {
        _inherits(BubbleTheme, _BaseTheme);

        function BubbleTheme(quill, options) {
          _classCallCheck(this, BubbleTheme);

          if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
            options.modules.toolbar.container = TOOLBAR_CONFIG;
          }

          var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

          _this.quill.container.classList.add('ql-bubble');
          return _this;
        }

        _createClass(BubbleTheme, [{
          key: 'extendToolbar',
          value: function extendToolbar(toolbar) {
            this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
            this.tooltip.root.appendChild(toolbar.container);
            this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
            this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
          }
        }]);

        return BubbleTheme;
      }(_base2.default);

      BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
        modules: {
          toolbar: {
            handlers: {
              link: function link(value) {
                if (!value) {
                  this.quill.format('link', false);
                } else {
                  this.quill.theme.tooltip.edit();
                }
              }
            }
          }
        }
      });

      var BubbleTooltip = function (_BaseTooltip) {
        _inherits(BubbleTooltip, _BaseTooltip);

        function BubbleTooltip(quill, bounds) {
          _classCallCheck(this, BubbleTooltip);

          var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

          _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
            if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
            if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
              _this2.show();
              // Lock our width so we will expand beyond our offsetParent boundaries
              _this2.root.style.left = '0px';
              _this2.root.style.width = '';
              _this2.root.style.width = _this2.root.offsetWidth + 'px';
              var lines = _this2.quill.getLines(range.index, range.length);
              if (lines.length === 1) {
                _this2.position(_this2.quill.getBounds(range));
              } else {
                var lastLine = lines[lines.length - 1];
                var index = _this2.quill.getIndex(lastLine);
                var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                _this2.position(_bounds);
              }
            } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
              _this2.hide();
            }
          });
          return _this2;
        }

        _createClass(BubbleTooltip, [{
          key: 'listen',
          value: function listen() {
            var _this3 = this;

            _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
            this.root.querySelector('.ql-close').addEventListener('click', function () {
              _this3.root.classList.remove('ql-editing');
            });
            this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
              // Let selection be restored by toolbar handlers before repositioning
              setTimeout(function () {
                if (_this3.root.classList.contains('ql-hidden')) return;
                var range = _this3.quill.getSelection();
                if (range != null) {
                  _this3.position(_this3.quill.getBounds(range));
                }
              }, 1);
            });
          }
        }, {
          key: 'cancel',
          value: function cancel() {
            this.show();
          }
        }, {
          key: 'position',
          value: function position(reference) {
            var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
            var arrow = this.root.querySelector('.ql-tooltip-arrow');
            arrow.style.marginLeft = '';
            if (shift === 0) return shift;
            arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
          }
        }]);

        return BubbleTooltip;
      }(_base.BaseTooltip);

      BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

      exports.BubbleTooltip = BubbleTooltip;
      exports.default = BubbleTheme;

      /***/
    },
    /* 109 */
    /***/function (module, exports, __webpack_require__) {

      module.exports = __webpack_require__(63);

      /***/
    }]
    /******/)["default"]
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1609).Buffer, __webpack_require__(68)(module)))

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_web_cam__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_web_cam___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_web_cam__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['image_path', 'image_width', 'file_dialog_id', 'button_style', 'hide_upload', 'align', 'notopmargin', 'allow_pdf'],
    components: { WebCam: __WEBPACK_IMPORTED_MODULE_2_vue_web_cam__["WebCam"] },
    data: function data() {
        return {
            uploaded_image_path: 'https://etacdn.b-cdn.net/website/blank_image.png',
            dialogVisible: false,
            camera_visible: false
        };
    },

    computed: {
        isImage: function isImage() {
            var imagePath = this.getImagePath.toLowerCase();

            if (imagePath.length === 0) {
                return true;
            }
            return imagePath.indexOf('.png') >= 0 || imagePath.indexOf('.jpg') >= 0 || imagePath.indexOf('.jpeg') >= 0 || imagePath.indexOf('.gif') >= 0 || imagePath.indexOf('.svg') >= 0;
        },
        getImagePath: function getImagePath() {

            if (this.image_path != null && this.image_path.length > 0) {
                return this.image_path;
            }
            return this.uploaded_image_path;
        }
    },
    methods: {
        onCapture: function onCapture() {
            this.$refs.webcam.capture();
        },
        getImage: function getImage(data) {
            this.uploaded_image_path = data;
            this.sendImageBack();
        },
        openFileDialog: function openFileDialog() {
            document.getElementById(this.file_dialog_id).click();
        },
        convertJPGtoJPEG: function convertJPGtoJPEG(file) {
            return new Promise(function (resolve, reject) {
                var img = new Image();
                var reader = new FileReader();
                reader.onload = function (e) {
                    img.onload = function () {
                        var canvas = document.createElement("canvas");
                        var ctx = canvas.getContext("2d");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        ctx.drawImage(img, 0, 0);

                        canvas.toBlob(function (blob) {
                            if (!blob) return reject("Conversion failed");

                            var newFile = new File([blob], file.name.replace(/\.jpg$/i, ".jpeg"), { type: "image/jpeg" });
                            resolve(newFile);
                        }, "image/jpeg", 0.92);
                    };
                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        uploadImageToCDN: function uploadImageToCDN() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var formData, file, converted;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:

                                _this.$store.commit('toggleLoadingState', true);
                                formData = new FormData();
                                file = document.getElementById(_this.file_dialog_id).files[0];

                                if (!/\.jpg$/i.test(file.name)) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 6;
                                return _this.convertJPGtoJPEG(file);

                            case 6:
                                converted = _context.sent;

                                formData.append("file", converted);
                                _context.next = 11;
                                break;

                            case 10:
                                formData.append("file", file);

                            case 11:

                                //const newFile = new File([file], file.name.replace(/\.jpg$/i, '.jpeg'), {
                                //  type: file.type === "image/jpg" ? "image/jpeg" : file.type
                                //});

                                //data.append('file', newFile);

                                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/uploadFile/index.php', formData, __WEBPACK_IMPORTED_MODULE_1__store_accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
                                    console.log(JSON.stringify(res.data));
                                    if (res.data.status) {
                                        _this.uploaded_image_path = res.data.image_path;
                                        _this.sendImageBack();
                                    } else {
                                        _this.$store.commit('displayMessageAlert', { message: 'Failed to upload!!!', type: 'Error' });
                                    }
                                }).catch(function (error) {
                                    _this.$store.commit('displayMessageAlert', { message: error, type: 'Error' });
                                }).finally(function () {
                                    _this.$store.commit('toggleLoadingState', false);
                                });

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        sendImageBack: function sendImageBack() {

            this.$emit('uploaded', this.uploaded_image_path);
        }
    }

});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['image_path', 'image_width', 'image_height', 'align', 'notopmargin'],
    data: function data() {
        return {
            uploaded_image_path: 'https://etacdn.b-cdn.net/website/blank_image.png',
            dialogVisible: false
        };
    },

    computed: {
        getImagePath: function getImagePath() {

            if (this.image_path != null && this.image_path.length > 0) {
                return this.image_path;
            }
            return this.uploaded_image_path;
        }
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['dialogVisible', 'src', 'title'],
    data: function data() {
        return {
            printPdf: false
        };
    },

    computed: {
        getDeviceId: function getDeviceId() {
            return this.$store.getters.getDeviceToken;
        },
        getPdfPath: function getPdfPath() {
            return this.master_server_url + 'temp/' + this.$store.getters.getAccessToken + '.pdf';
        },
        isMobileDevice: function isMobileDevice() {
            return this.getDeviceId !== null || __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__["isMobile"];
        }
    },
    methods: {
        handleClose: function handleClose() {
            this.$emit('closePrintWindow');
        },
        onLoadFunc: function onLoadFunc() {
            this.printPdf = true;
            this.$message.closeAll();
        },
        print: function print() {
            printJS({ printable: this.master_server_url + 'temp/' + this.$store.getters.getAccessToken + '.pdf', type: 'pdf', showModal: true });
        }
    },
    mounted: function mounted() {
        this.$message({
            type: 'warning',
            message: 'Please wait while loading...',
            duration: 0
        });
    }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Advanced__ = __webpack_require__(1630);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { Advanced: __WEBPACK_IMPORTED_MODULE_0__Advanced__["a" /* default */] },
    props: ['searchKeys', 'hideAvanced', 'hideSaveOption'],
    data: function data() {
        return {
            search_term: '',
            show_popup: false,
            show_qr_window: false
        };
    },

    methods: {
        onDecode: function onDecode($event) {
            this.search_term = $event;
            this.show_qr_window = false;
            this.searchInIt($event);
        },
        clearSearch: function clearSearch() {
            this.search_term = '';
            this.$emit('searchCustom', { search_term: '', search_term_array: [] });
        },
        closeModal: function closeModal() {
            this.show_popup = false;
        },
        loadAdvanceSearch: function loadAdvanceSearch($event) {
            this.$emit('searchCustom', { search_term: '', search_term_array: $event.search_term_array });
            this.closeModal();
        },
        searchInIt: function searchInIt($event) {
            if ($event.target !== undefined) {
                $event.target.select();
            }
            this.$emit('searchCustom', { search_term: this.search_term, search_term_array: [] });
        }
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var searchTermKey = {
    key: 0,
    column_name: '',
    search_term: '',
    search_term_date: '',
    search_term_date_array: ''
};

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['searchKeys', 'hideSaveOption'],
    data: function data() {
        return {
            search_term_array: [JSON.parse(JSON.stringify(searchTermKey))],
            enable_search_save: false,
            search_name: ''
        };
    },

    computed: {
        getSearchTermArray: function getSearchTermArray() {
            return this.search_term_array;
        },
        getSearchKeys: function getSearchKeys() {
            return this.searchKeys;
        }
    },
    methods: {
        addNewTerm: function addNewTerm() {
            this.search_term_array.push(JSON.parse(JSON.stringify(searchTermKey)));
            this.resetArray();
        },
        removeTerm: function removeTerm(index) {
            if (index === 0) {
                return;
            }
            this.search_term_array.splice(index, 1);
            this.resetArray();
        },
        resetArray: function resetArray() {
            var key = 0;
            this.getSearchTermArray.forEach(function (element) {
                element.key = key;
                key = key + 1;
            });
        },
        searchNow: function searchNow() {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.enable_search_save) {
                                    _context.next = 6;
                                    break;
                                }

                                _context.next = 3;
                                return _this.$store.dispatch('saveMasterSearchQuery', {
                                    page_id: _this.$store.getters.getAccessRights.id,
                                    query_name: _this.search_name,
                                    query_array: JSON.stringify(_this.getSearchTermArray)
                                });

                            case 3:

                                setTimeout(function () {
                                    _this.$emit('loadAdvanceSearch', { search_term_array: _this.getSearchTermArray });
                                }, 1000);

                                _context.next = 7;
                                break;

                            case 6:
                                _this.$emit('loadAdvanceSearch', { search_term_array: _this.getSearchTermArray });

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        applyPreSearch: function applyPreSearch(data) {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _this2.enable_search_save = false;
                                _this2.search_term_array = data.query_array;
                                _context2.next = 4;
                                return _this2.searchNow();

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        deleteSearchTag: function deleteSearchTag(data) {
            /*this.$confirm('Are you sure to remove?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                
            }).catch(() => {
                    
            });*/
            this.$store.dispatch('deleteMasterSearchQuery', { id: data.id, page_id: this.$store.getters.getAccessRights.id });
        }
    },
    mounted: function mounted() {
        this.$store.dispatch('fetchMasterSearchQuery', { page_id: this.$store.getters.getAccessRights.id });
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['dataProps', 'hideTotal'],
    data: function data() {
        return {
            limit: 0
        };
    },

    methods: {
        handleSizeChange: function handleSizeChange($val) {
            var _this = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.limit = parseInt($val);
                                _context.next = 3;
                                return _this.$store.dispatch('updatePageLimit', { limit: _this.limit });

                            case 3:

                                setTimeout(function () {
                                    _this.$emit('navigateButton');
                                }, 1000);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    },
    mounted: function mounted() {
        this.limit = this.$store.getters.getDefaultPageLimit;
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        var currencySymbol = this.getCurrencyFormat.currency_symbol;
        var currency_display = this.currency_display;
        var self = this;
        var ctx = document.getElementById(this.id);
        new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
            type: "bar",
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                scales: {
                    x: {
                        stacked: true
                    },
                    y: {
                        stacked: true,
                        beginAtZero: false,
                        ticks: {
                            callback: function callback(value) {
                                return currency_display && self.getCurrencyFormat.show_million ? currencySymbol + ' ' + self.convertCurrencyToShort(value) : currency_display ? self.formatCurrency(parseFloat(value)) : value.toFixed(2);
                            }
                        }
                    }
                }
            }
        });
    }
});

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function isPM(input) {
            return (/^nm$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4 // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;
});

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
        pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;
});

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;
});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;
});

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '1',
        2: '2',
        3: '3',
        4: '4',
        5: '5',
        6: '6',
        7: '7',
        8: '8',
        9: '9',
        0: '0'
    },
        pluralForm = function pluralForm(n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    },
        plurals = {
        s: ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m: ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h: ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d: ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M: ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y: ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    },
        pluralize = function pluralize(u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    },
        months = ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y')
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;
});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arMa;
});

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM: function isPM(input) {
            return 'م' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;
});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;
});

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays: 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function isPM(input) {
            return (/^(gündüz|axşam)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;
});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort: 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function nextWeek() {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function isPM(input) {
            return (/^(дня|вечара)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;
});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;
});

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০'
    },
        numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত' && hour >= 4 || meridiem === 'দুপুর' && hour < 5 || meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;
});

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '১',
        2: '২',
        3: '৩',
        4: '৪',
        5: '৫',
        6: '৬',
        7: '৭',
        8: '৮',
        9: '৯',
        0: '০'
    },
        numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort: 'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর'
        },
        preparse: function preparse(string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bnBd;
});

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '༡',
        2: '༢',
        3: '༣',
        4: '༤',
        5: '༥',
        6: '༦',
        7: '༧',
        8: '༨',
        9: '༩',
        0: '༠'
    },
        numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort: 'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split('_'),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays: 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ'
        },
        preparse: function preparse(string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'མཚན་མོ' && hour >= 4 || meridiem === 'ཉིན་གུང' && hour < 5 || meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;
});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [/^gen/i, /^c[ʼ\']hwe/i, /^meu/i, /^ebr/i, /^mae/i, /^(mez|eve)/i, /^gou/i, /^eos/i, /^gwe/i, /^her/i, /^du/i, /^ker/i],
        monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [/^sul/i, /^lun/i, /^meurzh/i, /^merc[ʼ\']her/i, /^yaou/i, /^gwener/i, /^sadorn/i],
        shortWeekdaysParse = [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
        minWeekdaysParse = [/^Su/i, /^Lu/i, /^Me([^r]|$)/i, /^Mer/i, /^Ya/i, /^Gw/i, /^Sa/i];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function isPM(token) {
            return token === 'g.m.';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        }
    });

    return br;
});

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;
});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function nextDay() {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [passat a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;
});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = {
        format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        standalone: 'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split('_')
    },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i],

    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss':
                // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY'
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;
});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays: 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;
});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function ordinal(number) {
            var b = number,
                output = '',
                lookup = ['', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
            'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed'];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;
});

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;
});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;
});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;
});

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;
});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['ޖެނުއަރީ', 'ފެބްރުއަރީ', 'މާރިޗު', 'އޭޕްރީލު', 'މޭ', 'ޖޫން', 'ޖުލައި', 'އޯގަސްޓު', 'ސެޕްޓެމްބަރު', 'އޮކްޓޯބަރު', 'ނޮވެމްބަރު', 'ޑިސެމްބަރު'],
        weekdays = ['އާދިއްތަ', 'ހޯމަ', 'އަންގާރަ', 'ބުދަ', 'ބުރާސްފަތި', 'ހުކުރު', 'ހޮނިހިރު'];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM: function isPM(input) {
            return 'މފ' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;
});

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl: 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl: 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function isPM(input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L'
        },
        calendar: function calendar(key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;
});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;
});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;
});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;
});

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;
});

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;
});

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return enIn;
});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;
});

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSg;
});

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function isPM(input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;
});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida'
    });

    return es;
});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;
});

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida'
    });

    return esMx;
});

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        _monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i],
        monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return _monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function lastDay() {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;
});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort: 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays: 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;
});

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort: 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact: true,
        weekdays: 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;
});

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '۱',
        2: '۲',
        3: '۳',
        4: '۴',
        5: '۵',
        6: '۶',
        7: '۷',
        8: '۸',
        9: '۹',
        0: '۰'
    },
        numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysShort: '\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function isPM(input) {
            return (/بعد از ظهر/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;
});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = ['nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden', numbersPast[7], numbersPast[8], numbersPast[9]];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort: 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays: 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;
});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fil;
});

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays: 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;
});

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [/^janv/i, /^févr/i, /^mars/i, /^avr/i, /^mai/i, /^juin/i, /^juil/i, /^août/i, /^sept/i, /^oct/i, /^nov/i, /^déc/i];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;
});

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;
});

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;
});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;
});

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Meitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deireadh Fómhair', 'Samhain', 'Nollaig'],
        monthsShort = ['Ean', 'Feabh', 'Márt', 'Aib', 'Beal', 'Meith', 'Iúil', 'Lún', 'M.F.', 'D.F.', 'Samh', 'Noll'],
        weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Sathairn'],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;
});

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'],
        monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
        weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function ordinal(number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;
});

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort: 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function nextDay() {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function lastDay() {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function lastWeek() {
                return '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;
});

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां']
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone: 'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: 'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]'
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        }
    });

    return gomDeva;
});

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam']
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone: 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split('_'),
            isFormat: /MMMM(\s)+D[oD]?/
        },
        monthsShort: 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3 // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;
});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '૧',
        2: '૨',
        3: '૩',
        4: '૪',
        5: '૫',
        6: '૬',
        7: '૭',
        8: '૮',
        9: '૯',
        0: '૦'
    },
        numberMap = {
        '૧': '1',
        '૨': '2',
        '૩': '3',
        '૪': '4',
        '૫': '5',
        '૬': '6',
        '૭': '7',
        '૮': '8',
        '૯': '9',
        '૦': '0'
    };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function preparse(string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;
});

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort: 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function hh(number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function dd(number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function MM(number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function yy(number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function isPM(input) {
            return (/^(אחה"צ|אחרי הצהריים|בערב)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;
});

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    },
        monthsParse = [/^जन/i, /^फ़र|फर/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सितं|सित/i, /^अक्टू/i, /^नव|नवं/i, /^दिसं|दिस/i],
        shortMonthsParse = [/^जन/i, /^फ़र/i, /^मार्च/i, /^अप्रै/i, /^मई/i, /^जून/i, /^जुल/i, /^अग/i, /^सित/i, /^अक्टू/i, /^नव/i, /^दिस/i];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
            standalone: 'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split('_')
        },
        monthsShort: 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे'
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;
});

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort: 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;
});

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort: 'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function isPM(input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function nextWeek() {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function lastWeek() {
                return week.call(this, false);
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;
});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays: 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function nextWeek() {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function lastWeek() {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function isPM(input) {
            return (/^(ցերեկվա|երեկոյան)$/.test(input)
            );
        },
        meridiem: function meridiem(hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;
});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return id;
});

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays: 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;
});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: function sameDay() {
                return '[Oggi a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextDay: function nextDay() {
                return '[Domani a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            nextWeek: function nextWeek() {
                return 'dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastDay: function lastDay() {
                return '[Ieri a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
            },
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[La scorsa] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                    default:
                        return '[Lo scorso] dddd [a' + (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") + ']LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;
});

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;
});

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [{
            since: '2019-05-01',
            offset: 1,
            name: '令和',
            narrow: '㋿',
            abbr: 'R'
        }, {
            since: '1989-01-08',
            until: '2019-04-30',
            offset: 1,
            name: '平成',
            narrow: '㍻',
            abbr: 'H'
        }, {
            since: '1926-12-25',
            until: '1989-01-07',
            offset: 1,
            name: '昭和',
            narrow: '㍼',
            abbr: 'S'
        }, {
            since: '1912-07-30',
            until: '1926-12-24',
            offset: 1,
            name: '大正',
            narrow: '㍽',
            abbr: 'T'
        }, {
            since: '1873-01-01',
            until: '1912-07-29',
            offset: 6,
            name: '明治',
            narrow: '㍾',
            abbr: 'M'
        }, {
            since: '0001-01-01',
            until: '1873-12-31',
            offset: 1,
            name: '西暦',
            narrow: 'AD',
            abbr: 'AD'
        }, {
            since: '0000-12-31',
            until: -Infinity,
            offset: 1,
            name: '紀元前',
            narrow: 'BC',
            abbr: 'BC'
        }],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function eraYearOrdinalParse(input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM: function isPM(input) {
            return input === '午後';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function lastWeek(now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年'
        }
    });

    return ja;
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L'
        },
        relativeTime: {
            future: function future(s) {
                return s.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/, function ($0, $1, $2) {
                    return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                });
            },
            past: function past(s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function ordinal(number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7
        }
    });

    return ka;
});

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;
});

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '១',
        2: '២',
        3: '៣',
        4: '៤',
        5: '៥',
        6: '៦',
        7: '៧',
        8: '៨',
        9: '៩',
        0: '០'
    },
        numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function isPM(input) {
            return input === 'ល្ងាច';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function preparse(string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;
});

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '೧',
        2: '೨',
        3: '೩',
        4: '೪',
        5: '೫',
        6: '೬',
        7: '೭',
        8: '೮',
        9: '೯',
        0: '೦'
    },
        numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort: 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ'
        },
        preparse: function preparse(string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function ordinal(number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;
});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function isPM(token) {
            return token === '오후';
        },
        meridiem: function meridiem(hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;
});

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '١',
        2: '٢',
        3: '٣',
        4: '٤',
        5: '٥',
        6: '٦',
        7: '٧',
        8: '٨',
        9: '٩',
        0: '٠'
    },
        numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
        months = ['کانونی دووەم', 'شوبات', 'ئازار', 'نیسان', 'ئایار', 'حوزەیران', 'تەمموز', 'ئاب', 'ئەیلوول', 'تشرینی یەكەم', 'تشرینی دووەم', 'كانونی یەکەم'];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays: 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort: 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function isPM(input) {
            return (/ئێواره‌/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ'
        },
        preparse: function preparse(string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;
});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;
});

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function lastWeek() {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;
});

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function isPM(input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function ordinal(number) {
            return 'ທີ່' + number;
        }
    });

    return lo;
});

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function ordinal(number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;
});

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;
});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedjelje] [u] LT', '[prošlog] [ponedjeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srijede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;
});

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;
});

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function ordinal(number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;
});

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort: 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'രാത്രി' && hour >= 4 || meridiem === 'ഉച്ച കഴിഞ്ഞ്' || meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;
});

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort: '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function isPM(input) {
            return input === 'ҮХ';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;
});

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी' || meridiem === 'सायंकाळी' || meridiem === 'रात्री') {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;
});

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;
});

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;
});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays: 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;
});

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '၁',
        2: '၂',
        3: '၃',
        4: '၄',
        5: '၅',
        6: '၆',
        7: '၇',
        8: '၈',
        9: '၉',
        0: '၀'
    },
        numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function preparse(string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;
});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '१',
        2: '२',
        3: '३',
        4: '४',
        5: '५',
        6: '६',
        7: '७',
        8: '८',
        9: '९',
        0: '०'
    },
        numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort: 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function preparse(string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष'
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;
});

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;
});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i],
        monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort: function monthsShort(m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function ordinal(number) {
            return number + (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;
});

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort: 'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;
});

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone: 'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split('_'),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort: 'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split('_'),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm'
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function ordinal(number, period) {
            var output = number === 1 ? 'r' : number === 2 ? 'n' : number === 3 ? 'r' : number === 4 ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4
        }
    });

    return ocLnc;
});

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '੧',
        2: '੨',
        3: '੩',
        4: '੪',
        5: '੫',
        6: '੬',
        7: '੭',
        8: '੮',
        9: '੯',
        0: '੦'
    },
        numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ'
        },
        preparse: function preparse(string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;
});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_'),
        monthsParse = [/^sty/i, /^lut/i, /^mar/i, /^kwi/i, /^maj/i, /^cze/i, /^lip/i, /^sie/i, /^wrz/i, /^paź/i, /^lis/i, /^gru/i];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function months(momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;
});

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;
});

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function lastWeek() {
                return this.day() === 0 || this.day() === 6 ? '[Último] dddd [às] LT' // Saturday + Sunday
                : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida'
    });

    return ptBr;
});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: 'secunde',
            mm: 'minute',
            hh: 'ore',
            dd: 'zile',
            ww: 'săptămâni',
            MM: 'luni',
            yy: 'ani'
        },
            separator = ' ';
        if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort: 'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;
});

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays: {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function lastWeek(now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function isPM(input) {
            return (/^(дня|вечера)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;
});

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['جنوري', 'فيبروري', 'مارچ', 'اپريل', 'مئي', 'جون', 'جولاءِ', 'آگسٽ', 'سيپٽمبر', 'آڪٽوبر', 'نومبر', 'ڊسمبر'],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;
});

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort: 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays: 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;
});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/

    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays: 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function ordinal(number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function isPM(input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;
});

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss':
                // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm':
                // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm':
                // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h':
                // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh':
                // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd':
                // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd':
                // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M':
                // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM':
                // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y':
                // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy':
                // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;
});

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;
});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function isPM(input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;
});

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[prošle] [nedelje] [u] LT', '[prošlog] [ponedeljka] [u] LT', '[prošlog] [utorka] [u] LT', '[prošle] [srede] [u] LT', '[prošlog] [četvrtka] [u] LT', '[prošlog] [petka] [u] LT', '[prošle] [subote] [u] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;
});

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година']
        },
        correctGrammaticalCase: function correctGrammaticalCase(number, wordKey) {
            if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function translate(number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function nextWeek() {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function lastWeek() {
                var lastWeekDays = ['[прошле] [недеље] [у] LT', '[прошлог] [понедељка] [у] LT', '[прошлог] [уторка] [у] LT', '[прошле] [среде] [у] LT', '[прошлог] [четвртка] [у] LT', '[прошлог] [петка] [у] LT', '[прошле] [суботе] [у] LT'];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return srCyrl;
});

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays: 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;
});

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? ':e' : b === 1 ? ':a' : b === 2 ? ':a' : b === 3 ? ':e' : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;
});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;
});

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var symbolMap = {
        1: '௧',
        2: '௨',
        3: '௩',
        4: '௪',
        5: '௫',
        6: '௬',
        7: '௭',
        8: '௮',
        9: '௯',
        0: '௦'
    },
        numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays: 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function ordinal(number) {
            return number + 'வது';
        },
        preparse: function preparse(string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function postformat(string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;
});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort: 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact: true,
        weekdays: 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;
});

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;
});

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split('_'),
            standalone: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_')
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function ordinal(number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;
});

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort: 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function isPM(input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี'
        }
    });

    return th;
});

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy"
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split('_'),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split('_'),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl'
        },
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tk;
});

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;
});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'leS' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'waQ' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'nem' : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = output.indexOf('jaj') !== -1 ? time.slice(0, -3) + 'Hu’' : output.indexOf('jar') !== -1 ? time.slice(0, -3) + 'wen' : output.indexOf('DIS') !== -1 ? time.slice(0, -3) + 'ben' : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor(number % 1000 / 100),
            ten = Math.floor(number % 100 / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort: 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;
});

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı"
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function isPM(input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl'
        },
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;
});

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.

    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function isPM(input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
    }

    return tzl;
});

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;
});

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn'
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;
});

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split('_'),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split('_'),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'يېرىم كېچە' || meridiem === 'سەھەر' || meridiem === 'چۈشتىن بۇرۇن') {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;
});

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            nominative: 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            accusative: 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            genitive: 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        },
            nounCase;

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? 'accusative' : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? 'genitive' : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            standalone: 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function lastWeek() {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function isPM(input) {
            return (/^(дня|вечора)$/.test(input)
            );
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;
});

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var months = ['جنوری', 'فروری', 'مارچ', 'اپریل', 'مئی', 'جون', 'جولائی', 'اگست', 'ستمبر', 'اکتوبر', 'نومبر', 'دسمبر'],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM: function isPM(input) {
            return 'شام' === input;
        },
        meridiem: function meridiem(hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال'
        },
        preparse: function preparse(string) {
            return string.replace(/،/g, ',');
        },
        postformat: function postformat(string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;
});

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;
});

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays: 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm'
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L'
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;
});

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort: 'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split('_'),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function isPM(input) {
            return (/^ch$/i.test(input)
            );
        },
        meridiem: function meridiem(hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function ordinal(number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;
});

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort: 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact: true,
        weekdays: 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10,
                output = ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;
});

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A'
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d'
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;
});

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function nextWeek(now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function lastWeek(now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年'
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;
});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhHk;
});

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhMo;
});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' && "function" === 'function' ? factory(__webpack_require__(0)) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.moment);
})(this, function (moment) {
    'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function meridiemHour(hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function meridiem(hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function ordinal(number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年'
        }
    });

    return zhTw;
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        var currencySymbol = this.getCurrencyFormat.currency_symbol;
        var currency_display = this.currency_display;

        var ctx = document.getElementById(this.id);
        new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
            type: "pie",
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            callback: function callback(value) {
                                return currency_display ? currencySymbol + ' ' + value : value.toFixed(2);
                            }
                        }
                    }
                }
            }
        });
    }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        var currencySymbol = this.getCurrencyFormat.currency_symbol;
        var currency_display = this.currency_display;
        var self = this;
        var ctx = document.getElementById(this.id);
        new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
            type: "bubble",
            data: { datasets: this.datasets }
        });
    }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['id', 'labels', 'datasets', 'currency_display'],
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        var currencySymbol = this.getCurrencyFormat.currency_symbol;
        var currency_display = this.currency_display;
        var self = this;
        var ctx = document.getElementById(this.id);
        new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(ctx, {
            type: "line",
            backgroundColor: 'white',
            data: {
                labels: this.labels,
                datasets: this.datasets
            },
            options: {
                scales: {
                    y: {
                        beginAtZero: false,
                        ticks: {
                            callback: function callback(value) {
                                return currency_display && self.getCurrencyFormat.show_million ? currencySymbol + ' ' + self.convertCurrencyToShort(value) : currency_display ? self.formatCurrency(parseFloat(value)) : value.toFixed(2);
                            }
                        }
                    }
                }
            }
        });
    }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_drawing_canvas__ = __webpack_require__(1659);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['workOrderData', 'sale_item_index'],
  components: {
    VueDrawingCanvas: __WEBPACK_IMPORTED_MODULE_0_vue_drawing_canvas__["a" /* default */]
  },
  data: function data() {
    return {
      image: this.workOrderData.sketch,
      eraser: false,
      line: 1,
      color: '#000000',
      strokeType: 'dash',
      backgroundColor: '#FFFFFF',
      backgroundImage: this.workOrderData.tailoring_flat_image
    };
  },

  computed: {
    getEraser: function getEraser() {
      return this.eraser;
    },
    getColor: function getColor() {
      return this.color;
    },
    getScreenWidth: function getScreenWidth() {
      return window.screen.width;
    },
    getScreenHeight: function getScreenHeight() {
      return window.screen.height;
    }
  },
  methods: {
    toggleEraser: function toggleEraser() {
      this.eraser = !this.eraser;
      if (!this.getEraser) {
        this.color = 'black';
      }
    },
    setImage: function setImage(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var URL;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                URL = window.URL;

                _this.backgroundImage = URL.createObjectURL(event.target.files[0]);
                _context.next = 4;
                return _this.$refs.VueCanvasDrawing.redraw();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    convertImage: function convertImage() {

      var can = document.getElementById('wo_canvas_' + this.sale_item_index + '_' + this.workOrderData.sub_sl_no);
      var ctx = can.getContext('2d');

      ctx.fillRect(50, 50, 50, 50);

      var img = new Image();
      img.src = can.toDataURL();
      this.image = img.src;
      this.workOrderData.sketch = this.image;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    setTimeout(function () {

      if (_this2.workOrderData.sketch.length === 0) {
        if (_this2.workOrderData.tailoring_flat_image.length === 0) {
          _this2.backgroundImage = null;
        }
      } else {
        _this2.backgroundImage = _this2.workOrderData.sketch;
      }
    }, 400);
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Appointments_vue__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_Planner_CustomerList_Index_vue__ = __webpack_require__(540);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['production_calendar'],
    components: { Appointments: __WEBPACK_IMPORTED_MODULE_0__Appointments_vue__["a" /* default */], CustomerList: __WEBPACK_IMPORTED_MODULE_1__views_Planner_CustomerList_Index_vue__["a" /* default */] },
    data: function data() {
        return {
            store_id: null,
            value: new Date(),
            show_appointment: false,
            month_number: '',
            old_month_number: '',
            do_not_show_appointment: false,
            showQuickView: false,
            planner_data_list: [],
            show_planner_window: false,
            colors: ['#a32cc4', '#7a4988', '#a1045a', '#311432', '#630436', '#e2bdf0', '#ff00ff', '#957a81']
        };
    },

    computed: {
        getItemCategory: function getItemCategory() {
            var _this = this;

            var list = JSON.parse(JSON.stringify(this.$store.getters.getItemCategoryList));

            var returnList = [];

            var index = 0;
            list.forEach(function (element) {
                element.color = _this.colors[index];
                index++;

                returnList.push(element);
            });

            return returnList;
        },
        getPlannerDataList: function getPlannerDataList() {
            if (this.$store.getters.getPlannerList !== null) {
                return JSON.parse(JSON.stringify(this.$store.getters.getPlannerList.future_orders));
            }
            return [];
        },
        getFailedList: function getFailedList() {
            return this.getPlannerDataList.filter(function (t) {
                return t.failed;
            });
        },
        getFutureList: function getFutureList() {
            return this.getPlannerDataList.filter(function (t) {
                return !t.failed;
            });
        },
        getCommonPlannerData: function getCommonPlannerData() {
            var _this2 = this;

            var returnList = [];

            this.getFailedList.forEach(function (element) {
                if (_this2.getFutureList[0]) {
                    element.appointment_date = _this2.getFutureList[0].current_date;
                    returnList.push(element);
                }
            });

            this.getFutureList.forEach(function (element) {
                returnList.push(element);
            });

            return returnList;
        },
        getFinalFutureList: function getFinalFutureList() {
            var _this3 = this;

            var returnList = [];
            if (this.getPlannerDataList.length > 0) {

                var list = this.getCommonPlannerData.filter(function (thing, index, self) {
                    return index === self.findIndex(function (t) {
                        return t.appointment_date === thing.appointment_date;
                    });
                });
                /*** ALL FUTURE ***/

                list.forEach(function (element) {

                    var newElement = {
                        date: element.appointment_date,
                        data_list: _this3.getCommonPlannerData.filter(function (t) {
                            return t.appointment_date === element.appointment_date;
                        }),
                        category_list: []
                    };

                    var categoryList = [];
                    _this3.getItemCategory.forEach(function (category) {

                        var categoryFilter = _this3.getCommonPlannerData.filter(function (t) {
                            return (t.category_id === category.id || t.sub_template_category_id === category.id) && t.appointment_date === element.appointment_date;
                        });
                        if (categoryFilter.length > 0) {

                            categoryList.push({
                                id: category.id,
                                qty: categoryFilter.length,
                                color: category.color
                            });
                        }
                    });
                    newElement.category_list = categoryList;
                    returnList.push(newElement);
                });
            }
            return returnList;
        },
        getCurrentMonthTab: function getCurrentMonthTab() {
            return this.month_number;
        },
        getCurrentMonth: function getCurrentMonth() {
            return this.value.getUTCMonth() + 1;
        },
        getSelectedDate: function getSelectedDate() {

            var date = new Date(this.value);

            var month = date.getMonth();

            var day = date.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            var year = date.getFullYear();

            var monthIndex = month + 1;
            if (monthIndex < 10) {
                monthIndex = '0' + monthIndex;
            }
            return [this.masterMonths[month].name + ' ' + day + ' ' + year, date, year + '-' + monthIndex + '-' + day];
        }
    },
    methods: {
        loadData: function loadData() {
            if (this.production_calendar) {
                this.productionLoad();
            } else {
                this.loadCalendar();
            }
        },
        productionLoad: function productionLoad() {

            this.$store.state.production.nav.multi_store_search = false;
            this.$store.state.production.nav.store_list = [];
            this.$store.state.production.nav.pending_approval = false;
            this.$store.state.production.nav.custom_batch = false;
            this.$store.state.production.nav.process_id = 0;
            this.$store.state.production.nav.workshop_id = this.store_id;
            this.$store.state.production.nav.store_id = 0;
            this.$store.state.production.nav.planner = true;

            this.$store.state.production.nav.include_hidden_process = false;
            this.$store.state.production.nav.store_query = true;

            this.$store.dispatch('fetchProductionWorkOrderList', this.$store.state.production.nav);
        },
        loadCalendar: function loadCalendar() {
            this.$store.dispatch('fetchMonthlyAppointments', {
                selected_month: this.getCurrentMonth,
                store_id: this.store_id
            });
        },
        dateChanged: function dateChanged($event) {
            var _this4 = this;

            if (!this.do_not_show_appointment) {
                if (this.production_calendar) {
                    var date = $event[2];

                    var list = this.getFinalFutureList.filter(function (t) {
                        return t.date == date;
                    })[0];
                    this.planner_data_list = list.data_list;

                    setTimeout(function () {
                        _this4.show_planner_window = true;
                    }, 300);
                } else {
                    this.show_appointment = true;
                }
            }
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        this.$store.dispatch('fetchTaskCategoryList');
        this.$store.dispatch('fetchPreferences');
        this.$store.dispatch('fetchProductionStageList');
        this.$store.dispatch('fetchItemCategoryList', { type: 0 });
        this.$store.dispatch('fetchEmployeeMasterList', { store_list: this.$store.getters.getAccessibleStoreList });
        setTimeout(function () {
            if (_this5.$store.getters.getAccessibleStoreList.length > 0) {
                _this5.store_id = _this5.$store.getters.getAccessibleStoreList[0].id;

                _this5.loadData();
            }
        }, 1000);
    },

    watch: {
        getCurrentMonth: function getCurrentMonth(newValue) {
            this.month_number = newValue + '';
            if (this.month_number != this.old_month_number) {
                this.do_not_show_appointment = true;
            }
            this.loadData();
        },
        getSelectedDate: function getSelectedDate(newValue) {
            var currentMonth = new Date(newValue[1]).getMonth() + 1;
            if (this.old_month_number == currentMonth) {
                this.do_not_show_appointment = false;
            } else {
                this.old_month_number = currentMonth;
            }
            this.dateChanged(newValue);
        }
    }

});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_Tasks_TaskForm_vue__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_SaleMaster_QuickDetail_Index_vue__ = __webpack_require__(538);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: { TaskForm: __WEBPACK_IMPORTED_MODULE_0__views_Tasks_TaskForm_vue__["a" /* default */], QuickDetail: __WEBPACK_IMPORTED_MODULE_1__views_SaleMaster_QuickDetail_Index_vue__["a" /* default */] },
    props: ['selected_date', 'store_id'],
    data: function data() {
        return {
            showQuickView: false,
            selected_sale_id: 0
        };
    },

    computed: {
        isTaskFormVisible: function isTaskFormVisible() {
            return this.$store.state.tasks.show_task_form;
        }
    },
    methods: {
        addTask: function addTask() {
            var _this = this;

            this.$store.commit('resetTaskData');
            this.$store.commit('resetTaskGroupData');

            setTimeout(function () {
                _this.$store.state.tasks.props.task_date = _this.selected_date;
                _this.$store.state.tasks.props.task_time = _this.selected_date + ' 10:00:00';
                _this.$store.state.tasks.show_task_form = true;
            }, 400);
        },
        openQuickView: function openQuickView(saleId) {
            this.$store.commit('resetSaleMasterData');
            this.$store.commit('resetCustomerMasterData');
            this.selected_sale_id = saleId;
            this.showQuickView = true;
        }
    },
    mounted: function mounted() {
        this.$store.state.tasks.show_task_form = false;
        this.$store.dispatch('loadAppointmentList', { selected_date: this.selected_date, store_id: this.store_id });
    },

    watch: {
        isTaskFormVisible: function isTaskFormVisible(newValue) {
            if (!newValue) {
                this.$store.dispatch('loadAppointmentList', { selected_date: this.selected_date, store_id: this.store_id });
                this.$emit('loadCalendar');
            }
        }
    }
});

/***/ }),
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkOrderAssignmentHistory_vue__ = __webpack_require__(270);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17f31e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkOrderAssignmentHistory_vue__ = __webpack_require__(1144);
function injectStyle (ssrContext) {
  __webpack_require__(1139)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkOrderAssignmentHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17f31e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkOrderAssignmentHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QCWindow_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fd564e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QCWindow_vue__ = __webpack_require__(1143);
function injectStyle (ssrContext) {
  __webpack_require__(1141)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QCWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12fd564e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QCWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterMeasurementSheet_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01768818_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterMeasurementSheet_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterMeasurementSheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01768818_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterMeasurementSheet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c37edc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1183);
function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c37edc4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailList_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2d3e80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailList_vue__ = __webpack_require__(1186);
function injectStyle (ssrContext) {
  __webpack_require__(1184)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DetailList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c2d3e80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DetailList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8030fd00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1197);
function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8030fd00_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0041ee0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__ = __webpack_require__(1171);
function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0041ee0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(723);
module.exports = __webpack_require__(925);


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(724);

__webpack_require__(921);

__webpack_require__(922);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(725);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(761);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(764);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(772);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(786);
__webpack_require__(787);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(136);
__webpack_require__(829);
__webpack_require__(190);
__webpack_require__(830);
__webpack_require__(191);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(194);
__webpack_require__(196);
__webpack_require__(197);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
__webpack_require__(878);
__webpack_require__(879);
__webpack_require__(880);
__webpack_require__(881);
__webpack_require__(882);
__webpack_require__(883);
__webpack_require__(884);
__webpack_require__(885);
__webpack_require__(886);
__webpack_require__(887);
__webpack_require__(888);
__webpack_require__(889);
__webpack_require__(890);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(906);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
module.exports = __webpack_require__(29);

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(9);
var has = __webpack_require__(25);
var DESCRIPTORS = __webpack_require__(14);
var $export = __webpack_require__(1);
var redefine = __webpack_require__(23);
var META = __webpack_require__(46).KEY;
var $fails = __webpack_require__(10);
var shared = __webpack_require__(73);
var setToStringTag = __webpack_require__(64);
var uid = __webpack_require__(51);
var wks = __webpack_require__(12);
var wksExt = __webpack_require__(172);
var wksDefine = __webpack_require__(117);
var enumKeys = __webpack_require__(727);
var isArray = __webpack_require__(84);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(11);
var toObject = __webpack_require__(16);
var toIObject = __webpack_require__(26);
var toPrimitive = __webpack_require__(34);
var createDesc = __webpack_require__(50);
var _create = __webpack_require__(54);
var gOPNExt = __webpack_require__(175);
var $GOPD = __webpack_require__(27);
var $GOPS = __webpack_require__(83);
var $DP = __webpack_require__(15);
var $keys = __webpack_require__(52);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(55).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(75).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(45)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(22)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(73)('native-function-to-string', Function.toString);

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(52);
var gOPS = __webpack_require__(83);
var pIE = __webpack_require__(75);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(54) });

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperty: __webpack_require__(15).f });

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(14), 'Object', { defineProperties: __webpack_require__(174) });

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(26);
var $getOwnPropertyDescriptor = __webpack_require__(27).f;

__webpack_require__(36)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(16);
var $getPrototypeOf = __webpack_require__(28);

__webpack_require__(36)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(16);
var $keys = __webpack_require__(52);

__webpack_require__(36)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(36)('getOwnPropertyNames', function () {
  return __webpack_require__(175).f;
});

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(46).onFreeze;

__webpack_require__(36)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(46).onFreeze;

__webpack_require__(36)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(11);
var meta = __webpack_require__(46).onFreeze;

__webpack_require__(36)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(11);

__webpack_require__(36)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(11);

__webpack_require__(36)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(11);

__webpack_require__(36)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(1);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(176) });

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { is: __webpack_require__(177) });

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(1);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(121).set });

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()

var classof = __webpack_require__(65);
var test = {};
test[__webpack_require__(12)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(23)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(1);

$export($export.P, 'Function', { bind: __webpack_require__(178) });

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(15).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(14) && dP(FProto, NAME, {
  configurable: true,
  get: function get() {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(11);
var getPrototypeOf = __webpack_require__(28);
var HAS_INSTANCE = __webpack_require__(12)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(15).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
    if (typeof this != 'function' || !isObject(O)) return false;
    if (!isObject(this.prototype)) return O instanceof this;
    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
    while (O = getPrototypeOf(O)) {
      if (this.prototype === O) return true;
    }return false;
  } });

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(180);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(181);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global = __webpack_require__(9);
var has = __webpack_require__(25);
var cof = __webpack_require__(31);
var inheritIfRequired = __webpack_require__(123);
var toPrimitive = __webpack_require__(34);
var fails = __webpack_require__(10);
var gOPN = __webpack_require__(55).f;
var gOPD = __webpack_require__(27).f;
var dP = __webpack_require__(15).f;
var $trim = __webpack_require__(66).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(54)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function toNumber(argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66:case 98:
          radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
        case 79:case 111:
          radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
        default:
          return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      }return parseInt(digits, radix);
    }
  }return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
    // check on 1..constructor(foo) case
    && (BROKEN_COF ? fails(function () {
      proto.valueOf.call(that);
    }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(14) ? gOPN(Base) : (
  // ES3:
  'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
  // ES6 (in case, if modules with ES6 Number statics required before):
  'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(23)(global, NUMBER, $Number);
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toInteger = __webpack_require__(32);
var aNumberValue = __webpack_require__(182);
var repeat = __webpack_require__(124);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function multiply(n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function divide(n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = c % n * 1e7;
  }
};
var numToString = function numToString() {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  }return s;
};
var pow = function pow(x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function log(x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  }return n;
};

$export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !__webpack_require__(10)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    }return m;
  }
});

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $fails = __webpack_require__(10);
var aNumberValue = __webpack_require__(182);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(1);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(1);
var _isFinite = __webpack_require__(9).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', { isInteger: __webpack_require__(183) });

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(1);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(1);
var isInteger = __webpack_require__(183);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(1);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseFloat = __webpack_require__(181);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $parseInt = __webpack_require__(180);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(1);
var log1p = __webpack_require__(184);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
// V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
&& Math.floor($acosh(Number.MAX_VALUE)) == 710
// Tor Browser bug: Math.acosh(Infinity) -> NaN
&& $acosh(Infinity) == Infinity), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(1);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(1);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(1);
var sign = __webpack_require__(125);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(1);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(1);
var $expm1 = __webpack_require__(126);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { fround: __webpack_require__(185) });

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(1);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) {
    // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(1);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { log1p: __webpack_require__(184) });

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', { sign: __webpack_require__(125) });

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(126);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(10)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(1);
var expm1 = __webpack_require__(126);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toAbsoluteIndex = __webpack_require__(53);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) {
    // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
    }return res.join('');
  }
});

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(26);
var toLength = __webpack_require__(13);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    }return res.join('');
  }
});

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()

__webpack_require__(66)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(85)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(127)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $at = __webpack_require__(85)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])


var $export = __webpack_require__(1);
var toLength = __webpack_require__(13);
var context = __webpack_require__(129);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(130)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
  }
});

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__(1);
var context = __webpack_require__(129);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(130)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(124)
});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])


var $export = __webpack_require__(1);
var toLength = __webpack_require__(13);
var context = __webpack_require__(129);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(130)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
  }
});

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)

__webpack_require__(24)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()

__webpack_require__(24)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()

__webpack_require__(24)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()

__webpack_require__(24)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()

__webpack_require__(24)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)

__webpack_require__(24)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)

__webpack_require__(24)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()

__webpack_require__(24)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)

__webpack_require__(24)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()

__webpack_require__(24)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()

__webpack_require__(24)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()

__webpack_require__(24)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()

__webpack_require__(24)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(1);

$export($export.S, 'Date', { now: function now() {
    return new Date().getTime();
  } });

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(34);

$export($export.P + $export.F * __webpack_require__(10)(function () {
  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
      return 1;
    } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(1);
var toISOString = __webpack_require__(804);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

var fails = __webpack_require__(10);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function lz(num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
}) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(23)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(12)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(22)(proto, TO_PRIMITIVE, __webpack_require__(807));

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(34);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(1);

$export($export.S, 'Array', { isArray: __webpack_require__(84) });

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ctx = __webpack_require__(30);
var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var call = __webpack_require__(186);
var isArrayIter = __webpack_require__(131);
var toLength = __webpack_require__(13);
var createProperty = __webpack_require__(132);
var getIterFn = __webpack_require__(133);

$export($export.S + $export.F * !__webpack_require__(87)(function (iter) {
  Array.from(iter);
}), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var createProperty = __webpack_require__(132);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(10)(function () {
  function F() {/* empty */}
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of() /* ...args */{
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) {
      createProperty(result, index, arguments[index++]);
    }result.length = aLen;
    return result;
  }
});

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)

var $export = __webpack_require__(1);
var toIObject = __webpack_require__(26);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(74) != Object || !__webpack_require__(33)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var html = __webpack_require__(120);
var cof = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(53);
var toLength = __webpack_require__(13);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(10)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) {
      cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
    }return cloned;
  }
});

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var toObject = __webpack_require__(16);
var fails = __webpack_require__(10);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(33)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
  }
});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $forEach = __webpack_require__(37)(0);
var STRICT = __webpack_require__(33)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var isArray = __webpack_require__(84);
var SPECIES = __webpack_require__(12)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }return C === undefined ? Array : C;
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $map = __webpack_require__(37)(1);

$export($export.P + $export.F * !__webpack_require__(33)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $filter = __webpack_require__(37)(2);

$export($export.P + $export.F * !__webpack_require__(33)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $some = __webpack_require__(37)(3);

$export($export.P + $export.F * !__webpack_require__(33)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $every = __webpack_require__(37)(4);

$export($export.P + $export.F * !__webpack_require__(33)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $reduce = __webpack_require__(187);

$export($export.P + $export.F * !__webpack_require__(33)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $reduce = __webpack_require__(187);

$export($export.P + $export.F * !__webpack_require__(33)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $indexOf = __webpack_require__(82)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
    // convert -0 to +0
    ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
  }
});

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toIObject = __webpack_require__(26);
var toInteger = __webpack_require__(32);
var toLength = __webpack_require__(13);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(33)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (; index >= 0; index--) {
      if (index in O) if (O[index] === searchElement) return index || 0;
    }return -1;
  }
});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { copyWithin: __webpack_require__(188) });

__webpack_require__(47)('copyWithin');

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(1);

$export($export.P, 'Array', { fill: __webpack_require__(135) });

__webpack_require__(47)('fill');

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $export = __webpack_require__(1);
var $find = __webpack_require__(37)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(47)(KEY);

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $export = __webpack_require__(1);
var $find = __webpack_require__(37)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(47)(KEY);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(56)('Array');

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var inheritIfRequired = __webpack_require__(123);
var dP = __webpack_require__(15).f;
var gOPN = __webpack_require__(55).f;
var isRegExp = __webpack_require__(86);
var $flags = __webpack_require__(76);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(14) && (!CORRECT_NEW || __webpack_require__(10)(function () {
  re2[__webpack_require__(12)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
  };
  var proxy = function proxy(key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function get() {
        return Base[key];
      },
      set: function set(it) {
        Base[key] = it;
      }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) {
    proxy(keys[i++]);
  }proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(23)(global, 'RegExp', $RegExp);
}

__webpack_require__(56)('RegExp');

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(191);
var anObject = __webpack_require__(8);
var $flags = __webpack_require__(76);
var DESCRIPTORS = __webpack_require__(14);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function define(fn) {
  __webpack_require__(23)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(10)(function () {
  return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
})) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
  // FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var toLength = __webpack_require__(13);
var advanceStringIndex = __webpack_require__(138);
var regExpExec = __webpack_require__(88);

// @@match logic
__webpack_require__(89)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
  // `String.prototype.match` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.match
  function match(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  },
  // `RegExp.prototype[@@match]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
  function (regexp) {
    var res = maybeCallNative($match, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    if (!rx.global) return regExpExec(rx, S);
    var fullUnicode = rx.unicode;
    rx.lastIndex = 0;
    var A = [];
    var n = 0;
    var result;
    while ((result = regExpExec(rx, S)) !== null) {
      var matchStr = String(result[0]);
      A[n] = matchStr;
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      n++;
    }
    return n === 0 ? null : A;
  }];
});

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(32);
var advanceStringIndex = __webpack_require__(138);
var regExpExec = __webpack_require__(88);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function maybeToString(it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(89)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
  // `String.prototype.replace` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.replace
  function replace(searchValue, replaceValue) {
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
  },
  // `RegExp.prototype[@@replace]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
  function (regexp, replaceValue) {
    var res = maybeCallNative($replace, regexp, this, replaceValue);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var functionalReplace = typeof replaceValue === 'function';
    if (!functionalReplace) replaceValue = String(replaceValue);
    var global = rx.global;
    if (global) {
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
    }
    var results = [];
    while (true) {
      var result = regExpExec(rx, S);
      if (result === null) break;
      results.push(result);
      if (!global) break;
      var matchStr = String(result[0]);
      if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
    }
    var accumulatedResult = '';
    var nextSourcePosition = 0;
    for (var i = 0; i < results.length; i++) {
      result = results[i];
      var matched = String(result[0]);
      var position = max(min(toInteger(result.index), S.length), 0);
      var captures = [];
      // NOTE: This is equivalent to
      //   captures = result.slice(1).map(maybeToString)
      // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
      // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
      // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
      for (var j = 1; j < result.length; j++) {
        captures.push(maybeToString(result[j]));
      }var namedCaptures = result.groups;
      if (functionalReplace) {
        var replacerArgs = [matched].concat(captures, position, S);
        if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
        var replacement = String(replaceValue.apply(undefined, replacerArgs));
      } else {
        replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
      }
      if (position >= nextSourcePosition) {
        accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
        nextSourcePosition = position + matched.length;
      }
    }
    return accumulatedResult + S.slice(nextSourcePosition);
  }];

  // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$':
          return '$';
        case '&':
          return matched;
        case '`':
          return str.slice(0, position);
        case "'":
          return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default:
          // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(8);
var sameValue = __webpack_require__(177);
var regExpExec = __webpack_require__(88);

// @@search logic
__webpack_require__(89)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
  // `String.prototype.search` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.search
  function search(regexp) {
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  },
  // `RegExp.prototype[@@search]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
  function (regexp) {
    var res = maybeCallNative($search, regexp, this);
    if (res.done) return res.value;
    var rx = anObject(regexp);
    var S = String(this);
    var previousLastIndex = rx.lastIndex;
    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
    var result = regExpExec(rx, S);
    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
    return result === null ? -1 : result.index;
  }];
});

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(86);
var anObject = __webpack_require__(8);
var speciesConstructor = __webpack_require__(77);
var advanceStringIndex = __webpack_require__(138);
var toLength = __webpack_require__(13);
var callRegExpExec = __webpack_require__(88);
var regexpExec = __webpack_require__(137);
var fails = __webpack_require__(10);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () {
  RegExp(MAX_UINT32, 'y');
});

// @@split logic
__webpack_require__(89)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function internalSplit(separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
    // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function internalSplit(separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
  // `String.prototype.split` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.split
  function split(separator, limit) {
    var O = defined(this);
    var splitter = separator == undefined ? undefined : separator[SPLIT];
    return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
  },
  // `RegExp.prototype[@@split]` method
  // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
  //
  // NOTE: This cannot be properly polyfilled in engines that don't support
  // the 'y' flag.
  function (regexp, limit) {
    var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
    if (res.done) return res.value;

    var rx = anObject(regexp);
    var S = String(this);
    var C = speciesConstructor(rx, RegExp);

    var unicodeMatching = rx.unicode;
    var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g');

    // ^(? + rx + ) is needed, in combination with some S slicing, to
    // simulate the 'y' flag.
    var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
    if (lim === 0) return [];
    if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
    var p = 0;
    var q = 0;
    var A = [];
    while (q < S.length) {
      splitter.lastIndex = SUPPORTS_Y ? q : 0;
      var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
      var e;
      if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
        q = advanceStringIndex(S, q, unicodeMatching);
      } else {
        A.push(S.slice(p, q));
        if (A.length === lim) return A;
        for (var i = 1; i <= z.length - 1; i++) {
          A.push(z[i]);
          if (A.length === lim) return A;
        }
        q = p = e;
      }
    }
    A.push(S.slice(p));
    return A;
  }];
});

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(45);
var global = __webpack_require__(9);
var ctx = __webpack_require__(30);
var classof = __webpack_require__(65);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(11);
var aFunction = __webpack_require__(19);
var anInstance = __webpack_require__(57);
var forOf = __webpack_require__(58);
var speciesConstructor = __webpack_require__(77);
var task = __webpack_require__(139).set;
var microtask = __webpack_require__(140)();
var newPromiseCapabilityModule = __webpack_require__(141);
var perform = __webpack_require__(192);
var userAgent = __webpack_require__(90);
var promiseResolve = __webpack_require__(193);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function empty() {/* empty */};
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(12)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise
    // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // we can't detect it synchronously, so just check versions
    && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) {/* empty */}
}();

// helpers
var isThenable = function isThenable(it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function notify(promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function run(reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) {
      run(chain[i++]);
    } // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function onUnhandled(promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    }promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function isUnhandled(promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function onHandleUnhandled(promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function $reject(value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function $resolve(value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = []; // <- awaiting reactions
    this._a = undefined; // <- checked in isUnhandled reactions
    this._s = 0; // <- state
    this._d = false; // <- done
    this._v = undefined; // <- value
    this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false; // <- notify
  };
  Internal.prototype = __webpack_require__(59)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function _catch(onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function OwnPromiseCapability() {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
    return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(64)($Promise, PROMISE);
__webpack_require__(56)(PROMISE);
Wrapper = __webpack_require__(29)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(87)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var weak = __webpack_require__(198);
var validate = __webpack_require__(60);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(91)(WEAK_SET, function (get) {
  return function WeakSet() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var $typed = __webpack_require__(92);
var buffer = __webpack_require__(142);
var anObject = __webpack_require__(8);
var toAbsoluteIndex = __webpack_require__(53);
var toLength = __webpack_require__(13);
var isObject = __webpack_require__(11);
var ArrayBuffer = __webpack_require__(9).ArrayBuffer;
var speciesConstructor = __webpack_require__(77);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(10)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    }return result;
  }
});

__webpack_require__(56)(ARRAY_BUFFER);

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
$export($export.G + $export.W + $export.F * !__webpack_require__(92).ABV, {
  DataView: __webpack_require__(142).DataView
});

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(41)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(1);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(8);
var rApply = (__webpack_require__(9).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(10)(function () {
  rApply(function () {/* empty */});
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(1);
var create = __webpack_require__(54);
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(10);
var bind = __webpack_require__(178);
var rConstruct = (__webpack_require__(9).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() {/* empty */}
  return !(rConstruct(function () {/* empty */}, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () {/* empty */});
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0:
          return new Target();
        case 1:
          return new Target(args[0]);
        case 2:
          return new Target(args[0], args[1]);
        case 3:
          return new Target(args[0], args[1], args[2]);
        case 4:
          return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(15);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var toPrimitive = __webpack_require__(34);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(10)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(1);
var gOPD = __webpack_require__(27).f;
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)

var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var Enumerate = function Enumerate(iterated) {
  this._t = anObject(iterated); // target
  this._i = 0; // next index
  var keys = this._k = []; // keys
  var key;
  for (key in iterated) {
    keys.push(key);
  }
};
__webpack_require__(128)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(1);
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(8);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(27);
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(1);
var getProto = __webpack_require__(28);
var anObject = __webpack_require__(8);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(1);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(200) });

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(1);
var anObject = __webpack_require__(8);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(15);
var gOPD = __webpack_require__(27);
var getPrototypeOf = __webpack_require__(28);
var has = __webpack_require__(25);
var $export = __webpack_require__(1);
var createDesc = __webpack_require__(50);
var anObject = __webpack_require__(8);
var isObject = __webpack_require__(11);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(1);
var setProto = __webpack_require__(121);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes

var $export = __webpack_require__(1);
var $includes = __webpack_require__(82)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(47)('includes');

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap

var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(201);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var aFunction = __webpack_require__(19);
var arraySpeciesCreate = __webpack_require__(134);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(47)('flatMap');

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten

var $export = __webpack_require__(1);
var flattenIntoArray = __webpack_require__(201);
var toObject = __webpack_require__(16);
var toLength = __webpack_require__(13);
var toInteger = __webpack_require__(32);
var arraySpeciesCreate = __webpack_require__(134);

$export($export.P, 'Array', {
  flatten: function flatten() /* depthArg = 1 */{
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(47)('flatten');

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at

var $export = __webpack_require__(1);
var $at = __webpack_require__(85)(true);
var $fails = __webpack_require__(10);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(1);
var $pad = __webpack_require__(202);
var userAgent = __webpack_require__(90);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end

var $export = __webpack_require__(1);
var $pad = __webpack_require__(202);
var userAgent = __webpack_require__(90);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(66)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim

__webpack_require__(66)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/

var $export = __webpack_require__(1);
var defined = __webpack_require__(35);
var toLength = __webpack_require__(13);
var isRegExp = __webpack_require__(86);
var getFlags = __webpack_require__(76);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(128)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117)('asyncIterator');

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117)('observable');

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(1);
var ownKeys = __webpack_require__(200);
var toIObject = __webpack_require__(26);
var gOPD = __webpack_require__(27);
var createProperty = __webpack_require__(132);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $values = __webpack_require__(203)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(1);
var $entries = __webpack_require__(203)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(15);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(14) && $export($export.P + __webpack_require__(93), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var aFunction = __webpack_require__(19);
var $defineProperty = __webpack_require__(15);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(14) && $export($export.P + __webpack_require__(93), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(34);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(93), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $export = __webpack_require__(1);
var toObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(34);
var getPrototypeOf = __webpack_require__(28);
var getOwnPropertyDescriptor = __webpack_require__(27).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(14) && $export($export.P + __webpack_require__(93), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(204)('Map') });

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(1);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(204)('Set') });

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(94)('Map');

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(94)('Set');

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(94)('WeakMap');

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(94)('WeakSet');

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(95)('Map');

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(95)('Set');

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(95)('WeakMap');

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(95)('WeakSet');

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.G, { global: __webpack_require__(9) });

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(1);

$export($export.S, 'System', { global: __webpack_require__(9) });

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(1);
var cof = __webpack_require__(31);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var scale = __webpack_require__(206);
var fround = __webpack_require__(185);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(1);

$export($export.S, 'Math', { scale: __webpack_require__(206) });

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(1);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(1);

$export($export.S, 'Math', { signbit: function signbit(x) {
    // eslint-disable-next-line no-self-compare
    return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
  } });

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally


var $export = __webpack_require__(1);
var core = __webpack_require__(29);
var global = __webpack_require__(9);
var speciesConstructor = __webpack_require__(77);
var promiseResolve = __webpack_require__(193);

$export($export.P + $export.R, 'Promise', { 'finally': function _finally(onFinally) {
    var C = speciesConstructor(this, core.Promise || global.Promise);
    var isFunction = typeof onFinally == 'function';
    return this.then(isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () {
        return x;
      });
    } : onFinally, isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () {
        throw e;
      });
    } : onFinally);
  } });

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try

var $export = __webpack_require__(1);
var newPromiseCapability = __webpack_require__(141);
var perform = __webpack_require__(192);

$export($export.S, 'Promise', { 'try': function _try(callbackfn) {
    var promiseCapability = newPromiseCapability.f(this);
    var result = perform(callbackfn);
    (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
    return promiseCapability.promise;
  } });

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
    ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
  } });

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
    var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
    var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
    if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
    if (metadataMap.size) return true;
    var targetMetadata = store.get(target);
    targetMetadata['delete'](targetKey);
    return !!targetMetadata.size || store['delete'](target);
  } });

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(196);
var from = __webpack_require__(205);
var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(28);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
    return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
    return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
  } });

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var getPrototypeOf = __webpack_require__(28);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
    return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
  } });

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(42);
var anObject = __webpack_require__(8);
var aFunction = __webpack_require__(19);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
    return function decorator(target, targetKey) {
      ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
    };
  } });

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(1);
var microtask = __webpack_require__(140)();
var process = __webpack_require__(9).process;
var isNode = __webpack_require__(31)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable

var $export = __webpack_require__(1);
var global = __webpack_require__(9);
var core = __webpack_require__(29);
var microtask = __webpack_require__(140)();
var OBSERVABLE = __webpack_require__(12)('observable');
var aFunction = __webpack_require__(19);
var anObject = __webpack_require__(8);
var anInstance = __webpack_require__(57);
var redefineAll = __webpack_require__(59);
var hide = __webpack_require__(22);
var forOf = __webpack_require__(58);
var RETURN = forOf.RETURN;

var getMethod = function getMethod(fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function cleanupSubscription(subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function subscriptionClosed(subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function closeSubscription(subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function Subscription(observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
        subscription.unsubscribe();
      };else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  }if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() {
    closeSubscription(this);
  }
});

var SubscriptionObserver = function SubscriptionObserver(subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    }cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      }cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function next(value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) {
      items[i] = arguments[i++];
    }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          }observer.complete();
        }
      });
      return function () {
        done = true;
      };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () {
  return this;
});

$export($export.G, { Observable: $Observable });

__webpack_require__(56)('Observable');

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(9);
var $export = __webpack_require__(1);
var userAgent = __webpack_require__(90);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function wrap(set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(1);
var $task = __webpack_require__(139);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(136);
var getKeys = __webpack_require__(52);
var redefine = __webpack_require__(23);
var global = __webpack_require__(9);
var hide = __webpack_require__(22);
var Iterators = __webpack_require__(67);
var wks = __webpack_require__(12);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) {
      if (!proto[key]) redefine(proto, key, $iterators[key], true);
    }
  }
}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (_typeof(global.process) === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// Among the various tricks for obtaining a reference to the global
// object, this seems to be the most reliable technique that does not
// use indirect eval (which violates Content Security Policy).
(typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40), __webpack_require__(68)(module)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(923);
module.exports = __webpack_require__(29).RegExp.escape;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(1);
var $re = __webpack_require__(924)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) {
    return $re(it);
  } });

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_editor__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__globalComponents__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe__ = __webpack_require__(1670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_v_mask__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vue_composition_api__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_qrcode_reader__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_qrcode_reader__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







//import '../theme/index.css'









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue2_editor__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__globalComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_friendly_iframe___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_v_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__vue_composition_api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_qrcode_reader___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// navigation guards before each
__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    if (localStorage.getItem('accessToken') === null) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
      window.scroll(0, 0);
    }
  } else {
    next(); // make sure to always call next()!
    window.scroll(0, 0);
  }
});

var serverURL = "https://laxmi-sg.easytailorapp.com/api/";
//const serverURL = "https://eta-api-sg.easytailorapp.com/api/";
//const serverURL = "https://suitfreek-sg.easytailorapp.com/api/";
//const serverURL = "https://afdhal-sg.easytailorapp.com/api/";

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.baseURL = serverURL;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  data: function data() {
    return {
      print_process: false,
      master_server_url: serverURL,
      master_report_url: serverURL + 'reports/',
      master_url: serverURL + 'printPDF/?',
      graphColors: ['#A0D2EB', '#E5EAF5', '#D0BDF4', '#8458B3', '#e30ad4', '#DEE500'],
      weekdays: [{ id: 0, dayName: 'Sunday' }, { id: 1, dayName: 'Monday' }, { id: 2, dayName: 'Tuesday' }, { id: 3, dayName: 'Wednesday' }, { id: 4, dayName: 'Thursday' }, { id: 5, dayName: 'Friday' }, { id: 6, dayName: 'Saturday' }],
      masterMonths: [{ id: 0, name: 'January' }, { id: 1, name: 'February' }, { id: 2, name: 'March' }, { id: 3, name: 'April' }, { id: 4, name: 'May' }, { id: 5, name: 'June' }, { id: 6, name: 'July' }, { id: 7, name: 'August' }, { id: 8, name: 'September' }, { id: 9, name: 'October' }, { id: 10, name: 'November' }, { id: 11, name: 'December' }],
      masterMonthShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      currentPopUpAccess: null
    };
  },

  computed: {
    getCurrencyFormat: function getCurrencyFormat() {
      return this.$store.state.master.currency_format;
    },
    getDeletableRows: function getDeletableRows() {
      var checkedRows = [];

      this.dataGrid.checkedRows.forEach(function (element) {
        checkedRows.push(element.id);
      });
      return checkedRows;
    },
    getDataGridPaginationLimit: function getDataGridPaginationLimit() {
      return this.dataGrid.perPage;
    },
    getCurrentDate: function getCurrentDate() {

      var monthNumber = new Date().getMonth() + 1;
      if (monthNumber < 10) {
        monthNumber = "0" + monthNumber;
      }
      return new Date().getFullYear() + '/' + monthNumber + '/' + new Date().getDate();
    }
  },
  methods: {
    sortByNumericPropertyDesc: function sortByNumericPropertyDesc(property) {
      return function (a, b) {
        if (a[property] < b[property]) return 1;else if (a[property] > b[property]) return -1;

        return 0;
      };
    },
    changeDate: function changeDate(value) {
      var $offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;


      var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      var date = new Date(value);
      if ($offset) {
        date = new Date(date.getTime() + Math.abs(date.getTimezoneOffset() * 60000));
      }
      if (value === undefined) {
        return '';
      }
      if (value === null) {
        return '';
      }
      var year = value.substring(0, 4);
      var month = value.substring(5, 7);
      var day = value.substring(8, 10);

      return monthNames[parseInt(month) - 1] + ' ' + day + ' ' + year;
    },
    convertCurrencyToShort: function convertCurrencyToShort(labelValue) {
      var sign = Math.sign(Number(labelValue));
      // Nine Zeroes for Billions
      return Math.abs(Number(labelValue)) >= 1.0e9 ? (sign * (Math.abs(Number(labelValue)) / 1.0e9)).toFixed(2) + "B" : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6 ? (sign * (Math.abs(Number(labelValue)) / 1.0e6)).toFixed(2) + "M" : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3 ? (sign * (Math.abs(Number(labelValue)) / 1.0e3)).toFixed(2) + "K" : Math.abs(Number(labelValue));
    },
    formatCurrency: function formatCurrency(value) {

      var currency = this.getCurrencyFormat.currency_symbol;

      var maxFraction = this.getCurrencyFormat.default_currency_max_fraction;

      var n = value,
          c = maxFraction,
          d = this.getCurrencyFormat.default_currency_decimal_separator,
          t = this.getCurrencyFormat.default_currency_thousand_separator,
          s = n < 0 ? "-" : "",
          i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
          j = (j = i.length) > 3 ? j % 3 : 0;

      if (maxFraction > 0) {
        return currency + " " + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
      } else {
        return currency + " " + s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
      }
    },
    changeFocus: function changeFocus(nextElementId) {
      if (document.getElementById(nextElementId) !== null) {
        document.getElementById(nextElementId).focus();
      }
    },
    invalidEmailAddress: function invalidEmailAddress(emailAddress) {
      if (emailAddress.indexOf('@') === -1 || emailAddress.indexOf('.') === -1) {
        return true;
      }
      return false;
    },
    isDateRangeValid: function isDateRangeValid(startDate, endDate) {
      var fDate = new Date(startDate);
      var lDate = new Date(endDate);
      if (fDate !== lDate) {

        if (fDate <= lDate) {
          return true;
        }
        return false;
      } else {
        return true;
      }
    },
    monthDiff: function monthDiff(d1, d2) {

      if (d1 != null && d2 != null) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months + 1;
      } else {
        return 0;
      }
    },
    dayDiff: function dayDiff(d1, d2) {

      if (d1 != null && d2 != null) {
        return Math.floor((Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate()) - Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate())) / (1000 * 60 * 60 * 24));
      } else {
        return 0;
      }
    },
    checkIfModuleAccessAvailable: function checkIfModuleAccessAvailable(routePath, accessType) {
      var showAlert = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


      var routeIndex = this.$store.getters.getAllMenus.findIndex(function (t) {
        return t.route_path == routePath;
      });
      var routeAccessInfo = this.$store.getters.getAllMenus[routeIndex];
      if (routeIndex >= 0) {
        if (accessType == 'can_view' && routeAccessInfo.can_view) {
          return true;
        } else if (accessType == 'can_add' && routeAccessInfo.can_add) {
          return true;
        } else if (accessType == 'can_edit' && routeAccessInfo.can_edit) {
          return true;
        } else if (accessType == 'can_delete' && routeAccessInfo.can_edit) {
          return true;
        }
        if (accessType != 'can_view' && showAlert) {
          this.$store.commit('displayMessageAlert', { message: 'You do not have access, please contact your administrator.', type: 'Error' });
        }
      }
      return false;
    },
    printWindow: function printWindow(portId) {
      var _this = this;

      this.print_process = true;

      setTimeout(function () {
        var prtHtml = document.getElementById(portId).innerHTML;

        // Get all stylesheets HTML
        var stylesHtml = '';

        var _arr = [].concat(_toConsumableArray(document.querySelectorAll('link[rel="stylesheet"], style')));

        for (var _i = 0; _i < _arr.length; _i++) {
          var node = _arr[_i];
          stylesHtml += node.outerHTML;
        }

        var iframe = document.createElement('iframe');
        iframe.style.display = "none";

        var html = '<!DOCTYPE html>\n              <html>\n              <head>\n                  ' + stylesHtml + '\n              </head>\n              <body>\n                  ' + prtHtml + '\n              </body>\n              </html>';
        document.body.appendChild(iframe);
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(html);

        iframe.contentWindow.print();
        iframe.contentWindow.document.close();
      }, 1000);
      setTimeout(function () {
        _this.print_process = false;
      }, 300);
    }
  }
});

// Debounce directive that works with anchors and emits a DOM CustomEvent 'debounced'
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('debounce-click', {
  bind: function bind(el, binding, vnode) {
    var delay = Number(binding.value) || 300;

    var handler = function handler(event) {
      // For anchors we must prevent immediate navigation.
      if (event && typeof event.preventDefault === 'function') {
        // Only prevent if there's a real href that would navigate
        var href = el.getAttribute && el.getAttribute('href');
        var shouldPreventNav = href && href !== '#' && href.indexOf('javascript:') !== 0;
        if (shouldPreventNav) event.preventDefault();
      }

      // clear previous timer
      if (el._debounceTimer) clearTimeout(el._debounceTimer);

      el._debounceTimer = setTimeout(function () {
        // Dispatch a native DOM CustomEvent so `@debounced` on the element receives it
        // include original event in detail for consumer if needed
        var customEvent = new CustomEvent('debounced', {
          detail: event,
          bubbles: true,
          cancelable: true
        });
        el.dispatchEvent(customEvent);

        // If element is an anchor with a meaningful href, navigate now
        var href = el.getAttribute && el.getAttribute('href');
        var isHref = href && href !== '#' && href.indexOf('javascript:') !== 0;

        if (isHref) {
          var target = el.getAttribute('target');
          if (target === '_blank') {
            window.open(href, '_blank');
          } else {
            // Use location.assign instead of location.href to be slightly cleaner
            window.location.assign(href);
          }
        }

        el._debounceTimer = null;
      }, delay);
    };

    // Save handler for removal later
    el._debounceHandler = handler;
    // passive: false so we can call preventDefault for anchors
    el.addEventListener('click', handler, { passive: false });
  },
  unbind: function unbind(el) {
    if (el._debounceHandler) {
      el.removeEventListener('click', el._debounceHandler);
      delete el._debounceHandler;
    }
    if (el._debounceTimer) {
      clearTimeout(el._debounceTimer);
      delete el._debounceTimer;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40), __webpack_require__(207)))

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf89054_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1000);
function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebf89054_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1e0ed72d", content, true, {});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "body{font-size:13px;font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:#383838;-moz-osx-font-smoothing:#383838;text-align:center;color:#383838}#app{width:100wh}.rowFontSize{font-size:13px}", ""]);

// exports


/***/ }),
/* 930 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles(parentId, list) {
  var styles = [];
  var newStyles = {};
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = item[0];
    var css = item[1];
    var media = item[2];
    var sourceMap = item[3];
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    };
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] });
    } else {
      newStyles[id].parts.push(part);
    }
  }
  return styles;
};

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5d724d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(999);
function injectStyle (ssrContext) {
  __webpack_require__(932)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e5d724d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(933);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("38537178", content, true, {});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__ = __webpack_require__(210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d8cd8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__ = __webpack_require__(997);
function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d8cd8e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(936);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5b82a354", content, true, {});

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("119642c8", content, true, {});

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('img',{style:('width: '+(_vm.days_left ? '100px' : '150px')+';'),attrs:{"alt":"Easy Tailor App Logo","src":__webpack_require__(96)}}),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),(!_vm.days_left)?_c('h1',[_vm._v("\n        Either your account is in dormant state due to long time inactivity or your account has expired.\n    ")]):_c('span',{staticStyle:{"font-size":"24px","font-weight":"bold"}},[_vm._v("\n      Your account expires in "+_vm._s(_vm.days_left)+" days.\n    ")]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n        For further assistance, please contact us by clicking "),_c('a',{attrs:{"href":"https://easytailorapp.com/contactus/"}},[_vm._v("here")]),_vm._v(".\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c32b862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(993);
function injectStyle (ssrContext) {
  __webpack_require__(941)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c32b862_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(942);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("a222f230", content, true, {});

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(944);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("dd28dd44", content, true, {});

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row"}},[_c('el-date-picker',{staticStyle:{"width":"450px"},attrs:{"type":"daterange","align":"right","size":"small","unlink-panels":"","range-separator":"To","start-placeholder":"Start date","end-placeholder":"End date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.inventoryMaster.statement.date_range),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.statement, "date_range", $$v)},expression:"$store.state.inventoryMaster.statement.date_range"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"250px","text-align":"left","margin-left":"20px"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.statement.store_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.statement, "store_id", $$v)},expression:"$store.state.inventoryMaster.statement.store_id"}},[_c('el-option',{attrs:{"label":'All Stores',"value":0}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('All Stores')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getAccessibleStoreList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.store_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.store_name)}})])})],2),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"20px"},attrs:{"type":"primary","size":"small","icon":"el-icon-search"},on:{"click":_vm.loadStatement}},[_vm._v("Search")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"summary-method":_vm.getSummaries,"show-summary":true,"data":_vm.getStatementList}},[_c('el-table-column',{attrs:{"label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.transaction_date_changed)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Transaction"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.purchase_bill_id>0 ? 'Purchase' 
                          : scope.row.intra_branch_transfer_id>0 ? 'Intra-Branch' 
                              : scope.row.sourcing_id>0 ? 'Sourced Out' 
                                  : scope.row.sales_id>0 ? 'Sales' 
                                      : scope.row.stock_check_id>0 ? 'Stock Check' 
                                          : scope.row.production_issue_id>0 ? 'Production Item Issue' 
                                              : scope.row.lost_id>0 ? 'Lost/Damaged' : '')+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Location"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.locality_name !== undefined)?[_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.locality_name)+"\n                ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Description"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.purchase_bill_id>0 ? scope.row.bill_number 
                          : scope.row.intra_branch_transfer_id>0 ? scope.row.from_locality + ' to '+ scope.row.to_locality+' ('+scope.row.transfer_number+')'
                              : scope.row.sourcing_id>0 ? scope.row.full_name 
                                  : scope.row.sales_id>0 ? (scope.row.external_number !== null && scope.row.external_number.length>0) ? scope.row.external_number : scope.row.sale_number_prefix+''+scope.row.sale_number
                                      : scope.row.stock_check_id>0 ? '' 
                                          : scope.row.production_issue_id>0 ? scope.row.item_issue_external_number.length>0 
                                              ? scope.row.item_issue_external_number 
                                                  : scope.row.item_issue_sale_number_prefix+''+_vm.item_issue_scope.row.sale_number 
                                                      : scope.row.opening_stock ? 'Opening' 
                                                          : scope.row.closing_stock ? 'Closing' : '')+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Opening","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.opening_stock)?_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.stock+' '+_vm.getUOM)+"\n                ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Debit","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize",staticStyle:{"color":"red"}},[_vm._v("\n                    "+_vm._s(scope.row.debit_qty>0 ? scope.row.debit_qty+' '+_vm.getUOM : '')+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Credit","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_c('b',[_vm._v(_vm._s(scope.row.credit_qty>0 ? scope.row.credit_qty+' '+_vm.getUOM : ''))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Closing","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.closing_stock)?_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.stock.toFixed(2)+' '+_vm.getUOM)+"\n                ")]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(947);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4053b3d1", content, true, {});

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbde360c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__ = __webpack_require__(951);
function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dbde360c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbde360c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("fae53b14", content, true, {});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'space-between'
    })},[_c('div',{style:({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left'
      })},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Inventory Type")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-radio',{attrs:{"label":1},on:{"change":function($event){return _vm.loadItemCategories(1)}},model:{value:(_vm.$store.state.inventoryMaster.props.item_type),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "item_type", $$v)},expression:"$store.state.inventoryMaster.props.item_type"}},[_vm._v("Fabric")]),_vm._v(" "),_c('el-radio',{attrs:{"label":2},on:{"change":function($event){return _vm.loadItemCategories(2)}},model:{value:(_vm.$store.state.inventoryMaster.props.item_type),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "item_type", $$v)},expression:"$store.state.inventoryMaster.props.item_type"}},[_vm._v("Ready Item")]),_vm._v(" "),_c('el-radio',{attrs:{"label":3},on:{"change":function($event){return _vm.loadItemCategories(3)}},model:{value:(_vm.$store.state.inventoryMaster.props.item_type),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "item_type", $$v)},expression:"$store.state.inventoryMaster.props.item_type"}},[_vm._v("Stitching Material")]),_vm._v(" "),_c('el-radio',{attrs:{"label":4},on:{"change":function($event){return _vm.loadItemCategories(4)}},model:{value:(_vm.$store.state.inventoryMaster.props.item_type),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "item_type", $$v)},expression:"$store.state.inventoryMaster.props.item_type"}},[_vm._v("Equipments")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-checkbox',{attrs:{"disabled":_vm.$store.state.inventoryMaster.props.item_type > 2},model:{value:(_vm.$store.state.inventoryMaster.props.fabric_cut_length),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "fabric_cut_length", $$v)},expression:"$store.state.inventoryMaster.props.fabric_cut_length"}},[_vm._v("Cut-Length "+_vm._s(_vm.$store.state.inventoryMaster.props.item_type == 1 ? 'Fabric' : 'Item'))]),_vm._v(" "),_c('el-checkbox',{attrs:{"disabled":_vm.$store.state.inventoryMaster.props.item_type !== 1},model:{value:(_vm.$store.state.inventoryMaster.props.fabric_can_be_sold_as_retail),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "fabric_can_be_sold_as_retail", $$v)},expression:"$store.state.inventoryMaster.props.fabric_can_be_sold_as_retail"}},[_vm._v("Can Be Sold As Retail?")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-checkbox',{attrs:{"disabled":_vm.$store.state.inventoryMaster.props.item_type !== 2},model:{value:(_vm.$store.state.inventoryMaster.props.most_popular),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "most_popular", $$v)},expression:"$store.state.inventoryMaster.props.most_popular"}},[_vm._v("Most Popular Item")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("SKU#")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"id":"sku_code","size":"small","placeholder":"Leave it blank if not sure"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.sku_code),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "sku_code", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.inventoryMaster.props.sku_code"}})],1),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.item_type === 2)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-checkbox',{model:{value:(_vm.$store.state.inventoryMaster.props.alteration_allowed),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "alteration_allowed", $$v)},expression:"$store.state.inventoryMaster.props.alteration_allowed"}},[_vm._v("Alteration Allowed?")])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.alteration_allowed)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"label"},[_vm._v("Alteration Tailoring Template")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"filterable":"","remote":"","remote-method":_vm.searchSKUCode,"placeholder":"Select"},model:{value:(_vm.$store.state.inventoryMaster.props.alteration_tailoring_item_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "alteration_tailoring_item_id", $$v)},expression:"$store.state.inventoryMaster.props.alteration_tailoring_item_id"}},_vm._l((_vm.$store.getters.getItemAutocompleteList.filter(function (option) {
                      return !option.is_combination_item
                  })),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.template_name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.template_name)}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Category")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"id":"sub_category_id","size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.sub_category_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "sub_category_id", $$v)},expression:"$store.state.inventoryMaster.props.sub_category_id"}},_vm._l((_vm.$store.getters.getItemCategoryList),function(dataGroup){return _c('el-option-group',{key:dataGroup.id},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{staticStyle:{"float":"left","padding-left":"5px"},domProps:{"innerHTML":_vm._s(dataGroup.category_name)}}),_vm._v(" "),_vm._l((dataGroup.sub_category_list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.sub_category_name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.sub_category_name)}})])})],2)])}),1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Collection")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.collection_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "collection_id", $$v)},expression:"$store.state.inventoryMaster.props.collection_id"}},_vm._l((_vm.$store.getters.getTailoringCollectionList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.collection_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(data.collection_name))])])}),1)],1),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.item_type < 3 && _vm.$store.getters.getHandloomClusterList.length>0)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Handloom Cluster")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.cluster_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "cluster_id", $$v)},expression:"$store.state.inventoryMaster.props.cluster_id"}},_vm._l((_vm.$store.getters.getHandloomClusterList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.cluster_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.cluster_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 1)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Fabric Width")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.fabric_width_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "fabric_width_id", $$v)},expression:"$store.state.inventoryMaster.props.fabric_width_id"}},_vm._l((_vm.$store.getters.getFabricWidthList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.width_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.width_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 1)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Width Based Flat Consumption")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.default_tailoring_consumption),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "default_tailoring_consumption", $$v)},expression:"$store.state.inventoryMaster.props.default_tailoring_consumption"}})],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 1)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Fabric Weight")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.fabric_gsm_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "fabric_gsm_id", $$v)},expression:"$store.state.inventoryMaster.props.fabric_gsm_id"}},_vm._l((_vm.$store.getters.getFabricGSMMasterList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.weight_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.weight_name)}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Article Name")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.article_name),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "article_name", $$v)},expression:"$store.state.inventoryMaster.props.article_name"}})],1),_vm._v(" "),(_vm.getItemType <4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Composition")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.composition),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "composition", $$v)},expression:"$store.state.inventoryMaster.props.composition"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v(_vm._s(_vm.getItemType < 4 ? 'Design ' : '')+"Description")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.design_description),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "design_description", $$v)},expression:"$store.state.inventoryMaster.props.design_description"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Unit Of Measurement")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.unit_of_measurement_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "unit_of_measurement_id", $$v)},expression:"$store.state.inventoryMaster.props.unit_of_measurement_id"}},_vm._l((_vm.getUOMList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.unit_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.unit_name)}})])}),1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Re-Order Level")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.reorder_level),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "reorder_level", $$v)},expression:"$store.state.inventoryMaster.props.reorder_level"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Style Number")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.style_number),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "style_number", $$v)},expression:"$store.state.inventoryMaster.props.style_number"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Brand Number")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.brand_name),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "brand_name", $$v)},expression:"$store.state.inventoryMaster.props.brand_name"}})],1),_vm._v(" "),(_vm.getItemType <4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Trade Number/Supplier Ref.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.trade_name),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "trade_name", $$v)},expression:"$store.state.inventoryMaster.props.trade_name"}})],1):_vm._e(),_vm._v(" "),(_vm.getItemType <4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Shade")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.shade_number),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "shade_number", $$v)},expression:"$store.state.inventoryMaster.props.shade_number"}})],1):_vm._e(),_vm._v(" "),(_vm.getItemType <4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Rack/Shelf Number")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":"","multiple":""},model:{value:(_vm.$store.state.inventoryMaster.props.rack_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "rack_id", $$v)},expression:"$store.state.inventoryMaster.props.rack_id"}},_vm._l((_vm.$store.getters.getInventoryRackList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.rack_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.rack_name)}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("From Vendor")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"id":"vendor_id","size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.vendor_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "vendor_id", $$v)},expression:"$store.state.inventoryMaster.props.vendor_id"}},_vm._l((_vm.$store.getters.getVendorMasterList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.vendor_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.vendor_name)}}),_vm._v(" "),_c('span',{staticStyle:{"float":"right"},domProps:{"innerHTML":_vm._s(data.brand_name)}})])}),1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"label"},[_vm._v("Available In Which Location?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"filterable":"","placeholder":"Select"},model:{value:(_vm.$store.state.inventoryMaster.props.store_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "store_id", $$v)},expression:"$store.state.inventoryMaster.props.store_id"}},[_c('el-option',{attrs:{"label":'All Locations',"value":0}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('All Locations')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getAccessibleStoreList.filter(function (t) { return t.retail; })),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.store_name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.store_name)}})])})],2)],1),_vm._v(" "),(_vm.getItemType === 4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Issued To")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"id":'staff_name',"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.issued_to),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "issued_to", $$v)},expression:"$store.state.inventoryMaster.props.issued_to"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Caretaker")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"id":'staff_name',"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.caretaker_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "caretaker_id", $$v)},expression:"$store.state.inventoryMaster.props.caretaker_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.staff_type === 0; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Purchase Date")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.inventoryMaster.props.purchase_date),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "purchase_date", $$v)},expression:"$store.state.inventoryMaster.props.purchase_date"}})],1):_vm._e(),_vm._v(" "),(_vm.getItemType === 4)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Warranty Expiry Date")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.inventoryMaster.props.warranty_expiry_date),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "warranty_expiry_date", $$v)},expression:"$store.state.inventoryMaster.props.warranty_expiry_date"}})],1):_vm._e()]),_vm._v(" "),_c('div',[_c('UploadFile',{attrs:{"image_path":_vm.$store.state.inventoryMaster.props.profile_photo,"image_width":150,"file_dialog_id":'inventoryMaster_photo_file_upload',"button_style":'width: 100px; top: 5px; position: relative;'},on:{"uploaded":function($event){_vm.$store.state.inventoryMaster.props.profile_photo=$event}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAndTax_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ffc32e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAndTax_vue__ = __webpack_require__(955);
function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceAndTax_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ffc32e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceAndTax_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(954);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1a882846", content, true, {});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left'
      })},[(!_vm.$store.getters.getUserGroupAlerts.hide_inventory_cost_price)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"label"},[_vm._v("\n                  Cost Price                    \n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.cost_price),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "cost_price", $$v)},expression:"$store.state.inventoryMaster.props.cost_price"}})],1):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getUserGroupAlerts.hide_inventory_cost_price)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"label"},[_vm._v("\n                  Profit (%)                   \n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()},"blur":_vm.addProfitPercent},model:{value:(_vm.$store.state.inventoryMaster.props.profit_percent),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "profit_percent", $$v)},expression:"$store.state.inventoryMaster.props.profit_percent"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.item_type === 1 
                  && _vm.$store.getters.getFabricPriceSlabList.length > 0)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Fabric Price Category")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.fabric_price_category_id),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "fabric_price_category_id", $$v)},expression:"$store.state.inventoryMaster.props.fabric_price_category_id"}},_vm._l((_vm.$store.getters.getFabricPriceSlabList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.price_category_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.price_category_name)}})])}),1)],1):_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Sales Price")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"number","size":"small"},on:{"blur":function($event){return _vm.caluclateRate('sale_price')},"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.sale_price),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "sale_price", $$v)},expression:"$store.state.inventoryMaster.props.sale_price"}}),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.item_type === 1)?_c('br'):_vm._e(),(_vm.$store.state.inventoryMaster.props.item_type === 1)?_c('br'):_vm._e(),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.item_type === 1)?_c('el-checkbox',{model:{value:(_vm.$store.state.inventoryMaster.props.stitching_rate_flat),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "stitching_rate_flat", $$v)},expression:"$store.state.inventoryMaster.props.stitching_rate_flat"}},[_vm._v("\n                  Sales Price Flat For Stitching\n              ")]):_vm._e(),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.stitching_rate_flat && _vm.$store.state.inventoryMaster.props.fabric_can_be_sold_as_retail)?_c('div',[_c('br'),_vm._v(" "),_c('span',{attrs:{"type":"label"}},[_vm._v("Default Retail Fabric Units")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"number","size":"small"},on:{"blur":function($event){return _vm.caluclateRate('default_retail_fabric_unit')},"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.default_retail_fabric_unit),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "default_retail_fabric_unit", $$v)},expression:"$store.state.inventoryMaster.props.default_retail_fabric_unit"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.stitching_rate_flat)?_c('div',[_c('br'),_vm._v(" "),_c('span',{attrs:{"type":"label"}},[_vm._v("Sales Price/Unit")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"number","size":"small"},on:{"blur":function($event){return _vm.caluclateRate('flat_price')},"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.flat_price),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "flat_price", $$v)},expression:"$store.state.inventoryMaster.props.flat_price"}})],1):_vm._e(),_vm._v(" "),_c('br'),_c('br')],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Discount (%) On Sale")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.discount_percent),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "discount_percent", $$v)},expression:"$store.state.inventoryMaster.props.discount_percent"}})],1),_vm._v(" "),(_vm.$store.getters.isIndiaTax)?_c('div',{staticStyle:{"margin-top":"50px"}},[_c('h1',[_vm._v("GST Settings")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("HSN/SAC Code")]),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"id":"hsnCode","size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.hsn_sac_code),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "hsn_sac_code", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.inventoryMaster.props.hsn_sac_code"}})],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.isIndiaTax)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{staticClass:"label"},[_vm._v("GST (%)")]),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"id":"tailoringTaxPercent","size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.tax_percent),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "tax_percent", $$v)},expression:"$store.state.inventoryMaster.props.tax_percent"}})],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VariantList_vue__ = __webpack_require__(218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326beaae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariantList_vue__ = __webpack_require__(959);
function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VariantList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_326beaae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VariantList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(958);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("277c2752", content, true, {});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.getters.getInventoryMasterDataProps.variant_list}},[_c('el-table-column',{attrs:{"prop":"variant_sub_item_id","label":"Variant Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"id":'variant_sub_item_id_'+scope.row.key,"size":"small","filterable":""},model:{value:(scope.row.variant_sub_item_id),callback:function ($$v) {_vm.$set(scope.row, "variant_sub_item_id", $$v)},expression:"scope.row.variant_sub_item_id"}},_vm._l((_vm.$store.getters.getInventoryVariantList),function(dataGroup){return _c('el-option-group',{key:dataGroup.id},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{staticStyle:{"float":"left","padding-left":"5px"},domProps:{"innerHTML":_vm._s(dataGroup.variant_name)}}),_vm._v(" "),_vm._l((dataGroup.sub_variant_list),function(item){return _c('el-option',{key:item.id,attrs:{"label":dataGroup.variant_name+' -> '+item.sub_variant_name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.sub_variant_name)}})])})],2)])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addNewInventoryMasterVariantListRow')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterVariantListRow', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceLog_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcb90fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceLog_vue__ = __webpack_require__(963);
function injectStyle (ssrContext) {
  __webpack_require__(961)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ServiceLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcb90fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ServiceLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(962);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5d73f3c4", content, true, {});

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.getInventoryMasterDataProps.log_list.length === 0)?_c('el-empty',{attrs:{"description":"No Data"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$store.commit('addNewAssetServiceLogRow')}}},[_vm._v("Add New Service Log")])],1):_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.getters.getInventoryMasterDataProps.log_list}},[_c('el-table-column',{attrs:{"label":"Service Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(scope.row.service_date),callback:function ($$v) {_vm.$set(scope.row, "service_date", $$v)},expression:"scope.row.service_date"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Service Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(scope.row.activity_type),callback:function ($$v) {_vm.$set(scope.row, "activity_type", $$v)},expression:"scope.row.activity_type"}},[_c('el-option',{attrs:{"label":"Maintenance","value":0}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Maintenance')}})]),_vm._v(" "),_c('el-option',{attrs:{"label":"Repair","value":1}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Repair')}})])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Supervised By"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{attrs:{"id":'staff_name',"size":"small","filterable":""},model:{value:(scope.row.supervised_by_staff_id),callback:function ($$v) {_vm.$set(scope.row, "supervised_by_staff_id", $$v)},expression:"scope.row.supervised_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.staff_type === 0; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Service By"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{attrs:{"id":'staff_name',"size":"small","filterable":""},model:{value:(scope.row.service_done_by_contact_id),callback:function ($$v) {_vm.$set(scope.row, "service_done_by_contact_id", $$v)},expression:"scope.row.service_done_by_contact_id"}},_vm._l((_vm.$store.getters.getGenericContactList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.full_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.full_name)}})])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addNewAssetServiceLogRow')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeNewAssetServiceLogRow', scope.row.key)}}},[(scope.row.id === 0)?_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356f8296_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__ = __webpack_require__(967);
function injectStyle (ssrContext) {
  __webpack_require__(965)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_356f8296_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(966);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("70512c79", content, true, {});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.getters.getInventoryMasterDataProps.image_list}},[_c('el-table-column',{attrs:{"prop":"attachment","label":"Upload Image","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('UploadFile',{attrs:{"image_path":scope.row.image_path,"image_width":75,"file_dialog_id":'file_upload'+scope.row.key,"button_style":'width: 100px; top: 5px; position: relative;'},on:{"uploaded":function($event){scope.row.image_path=$event}}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"display_online","label":"Display Online?","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{model:{value:(scope.row.display_online),callback:function ($$v) {_vm.$set(scope.row, "display_online", $$v)},expression:"scope.row.display_online"}},[_vm._v("\n                      Yes\n                  ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"default_online_thumbnail","label":"Show As Thumbnail","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.display_online)?[_c('el-checkbox',{on:{"change":function($event){return _vm.toggleThumnailStatus(scope.row)}},model:{value:(scope.row.default_online_thumbnail),callback:function ($$v) {_vm.$set(scope.row, "default_online_thumbnail", $$v)},expression:"scope.row.default_online_thumbnail"}},[_vm._v("\n                      Yes\n                  ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"default_online_thumbnail_hover","label":"Show As Thumbnail Hover","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.display_online)?[_c('el-checkbox',{on:{"change":function($event){return _vm.toggleThumnailHoverStatus(scope.row)}},model:{value:(scope.row.default_online_thumbnail_hover),callback:function ($$v) {_vm.$set(scope.row, "default_online_thumbnail_hover", $$v)},expression:"scope.row.default_online_thumbnail_hover"}},[_vm._v("\n                      Yes\n                  ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addNewInventoryMasterImageRow')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterImageRow', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cf4422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(987);
function injectStyle (ssrContext) {
  __webpack_require__(969)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23cf4422_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(970);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("670515d4", content, true, {});

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4197b90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__ = __webpack_require__(974);
function injectStyle (ssrContext) {
  __webpack_require__(972)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4197b90_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(973);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("e812a5d6", content, true, {});

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-left":"20px"}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Heading")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"700px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_title),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_title", $$v)},expression:"$store.state.inventoryMaster.props.estore_title"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Sub-Heading")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"700px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_sub_title),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_sub_title", $$v)},expression:"$store.state.inventoryMaster.props.estore_sub_title"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Other Detail")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","type":"textarea","rows":5},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_other_detail),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_other_detail", $$v)},expression:"$store.state.inventoryMaster.props.estore_other_detail"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Featuring Title")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"700px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_featuring_title),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_featuring_title", $$v)},expression:"$store.state.inventoryMaster.props.estore_featuring_title"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Featuring Content")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","type":"textarea","rows":5},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_featuring_content),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_featuring_content", $$v)},expression:"$store.state.inventoryMaster.props.estore_featuring_content"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Overview")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","type":"textarea","rows":10},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_overview),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_overview", $$v)},expression:"$store.state.inventoryMaster.props.estore_overview"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceVariation_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ac7d98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceVariation_vue__ = __webpack_require__(978);
function injectStyle (ssrContext) {
  __webpack_require__(976)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PriceVariation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ac7d98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PriceVariation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(977);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("536644a3", content, true, {});

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-left":"20px"}},[_c('el-checkbox',{model:{value:(_vm.$store.state.inventoryMaster.props.estore_price_variation_available),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_price_variation_available", $$v)},expression:"$store.state.inventoryMaster.props.estore_price_variation_available"}},[_vm._v("\n          Is Price Variations Available?\n      ")]),_vm._v(" "),(_vm.$store.state.inventoryMaster.props.estore_price_variation_available)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.$store.state.inventoryMaster.props.estore_price_variation),function(data,index){return _c('div',{key:index,staticStyle:{"display":"flex","flex-direction":"column","margin-bottom":"30px","border-bottom":"1px solid #000000"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Price Heading")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(data.variation_title),callback:function ($$v) {_vm.$set(data, "variation_title", $$v)},expression:"data.variation_title"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Price (Incl. Taxes)")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('el-checkbox',{staticStyle:{"top":"10px","position":"relative","margin-right":"5px"},model:{value:(data.coming_soon),callback:function ($$v) {_vm.$set(data, "coming_soon", $$v)},expression:"data.coming_soon"}},[_vm._v("\n                                      Coming Soon?\n                                  ")]),_vm._v(" "),(!data.coming_soon)?_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"default-first-option":"","size":"small","filterable":""},model:{value:(data.price_currency_id),callback:function ($$v) {_vm.$set(data, "price_currency_id", $$v)},expression:"data.price_currency_id"}},_vm._l((_vm.$store.getters.getCountryList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.currency_short,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.currency_short)}}),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(data.country_name))])])}),1):_vm._e(),_vm._v(" "),(!data.coming_soon)?_c('el-input',{staticStyle:{"margin-left":"10px","width":"250px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(data.price),callback:function ($$v) {_vm.$set(data, "price", $$v)},expression:"data.price"}}):_vm._e()],1)])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addInventoryMasterPriceVariation')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterPriceVariation', data.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]),_vm._v(" "),(!data.coming_soon)?_c('el-table',{staticStyle:{"width":"100%","margin-top":"30px"},attrs:{"data":data.variation_source,"border":""}},[_c('el-table-column',{attrs:{"prop":"source_link","label":"Source Link"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{model:{value:(scope.row.source_self),callback:function ($$v) {_vm.$set(scope.row, "source_self", $$v)},expression:"scope.row.source_self"}},[_vm._v("\n                  Purchase In Website\n              ")]),_vm._v(" "),(!scope.row.source_self)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.source_link),callback:function ($$v) {_vm.$set(scope.row, "source_link", $$v)},expression:"scope.row.source_link"}}):_vm._e()]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"source_name","label":"Button Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.source_name),callback:function ($$v) {_vm.$set(scope.row, "source_name", $$v)},expression:"scope.row.source_name"}})]}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addInventoryMasterPriceVariation_SubList', data.key)}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterPriceVariation_SubList', {parent_key: data.key, key: scope.row.key})}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}],null,true)})],1):_vm._e()],1)}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloadables_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35213975_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloadables_vue__ = __webpack_require__(982);
function injectStyle (ssrContext) {
  __webpack_require__(980)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloadables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35213975_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloadables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(981);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("28e8501a", content, true, {});

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-left":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.state.inventoryMaster.props.estore_downloable,"border":""}},[_c('el-table-column',{attrs:{"prop":"source_name","label":"Title","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.source_name),callback:function ($$v) {_vm.$set(scope.row, "source_name", $$v)},expression:"scope.row.source_name"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"source_link","label":"Download Link","width":"350"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.source_link),callback:function ($$v) {_vm.$set(scope.row, "source_link", $$v)},expression:"scope.row.source_link"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addInventoryMasterDownloadable')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterDownloadable', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformation_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05149365_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformation_vue__ = __webpack_require__(986);
function injectStyle (ssrContext) {
  __webpack_require__(984)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdditionalInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05149365_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdditionalInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(985);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("63268dff", content, true, {});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","margin-left":"20px"}},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Title")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"700px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_preview_title1),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_preview_title1", $$v)},expression:"$store.state.inventoryMaster.props.estore_preview_title1"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Sub-Title")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"700px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_preview_title2),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_preview_title2", $$v)},expression:"$store.state.inventoryMaster.props.estore_preview_title2"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Description")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","type":"textarea","rows":20},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.inventoryMaster.props.estore_preview_content),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_preview_content", $$v)},expression:"$store.state.inventoryMaster.props.estore_preview_content"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card","tab-position":"left"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"Basics","name":"1"}},[_c('Basic')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Production Variations","name":"2"}},[_c('div',{staticStyle:{"width":"100%","text-align":"left","display":"flex","flex-direction":"column"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Mention Similar SKU Codes")]),_vm._v(" "),_c('el-select',{staticStyle:{"text-align":"left","width":"80%"},attrs:{"placeholder":"search or scan","remote":"","remote-method":_vm.searchSKUCode,"size":"small","multiple":"","default-first-option":"","loading":_vm.getLoading,"filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.estore_product_variation),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_product_variation", $$v)},expression:"$store.state.inventoryMaster.props.estore_product_variation"}},_vm._l((_vm.$store.getters.getInventoryMasterAutocompleteList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.sku_code,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.sku_code+' ('+data.article_name+')')}}),_vm._v(" "),(data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0)?_c('span',{staticStyle:{"float":"right"}},[_c('b',{style:('color: '+(data.closing_stock<0 ? 'red' : 'green'))},[_vm._v(_vm._s(data.closing_stock)+" "+_vm._s(data.unit_name))])]):_vm._e()])}),1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Price Variations","name":"3"}},[_c('PriceVariation')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Downloadables","name":"4"}},[_c('Downloadables')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Stylist Names","name":"5"}},[_c('div',{staticStyle:{"width":"100%","text-align":"left","display":"flex","flex-direction":"column"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Stylist Names")]),_vm._v(" "),_c('el-select',{staticStyle:{"text-align":"left","width":"80%"},attrs:{"placeholder":"type here...","size":"small","multiple":"","filterable":""},model:{value:(_vm.$store.state.inventoryMaster.props.estore_stylist_names),callback:function ($$v) {_vm.$set(_vm.$store.state.inventoryMaster.props, "estore_stylist_names", $$v)},expression:"$store.state.inventoryMaster.props.estore_stylist_names"}},_vm._l((_vm.$store.getters.getGenericContactList.filter(function (t) { return t.display_online === 1; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.full_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.full_name)}})])}),1)],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Additional Information","name":"6"}},[_c('AdditionalInformation')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherVariant_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e8c26a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherVariant_vue__ = __webpack_require__(991);
function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherVariant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30e8c26a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherVariant_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(990);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("c7d70e2c", content, true, {});

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","text-align":"left"}},[(_vm.$store.getters.getInventoryMasterDataProps.other_variation_item_list.length>0 || (_vm.$store.getters.getInventoryMasterDataProps.variant_item_id === 0 
                      && _vm.$store.getters.getInventoryMasterDataProps.variant_list.length>0))?_c('h1',[_vm._v("Other Variations")]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.getters.getInventoryMasterDataProps.other_variation_item_list),function(tag){return _c('el-tag',{key:tag.id,staticStyle:{"margin-right":"10px","cursor":"waiting"}},[_vm._v("\n        "+_vm._s(tag.sku_code)+", "+_vm._s(tag.article_name)+"\n    ")])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.getters.getInventoryMasterDataProps.other_variation_item_list.length>0 
              && _vm.$store.getters.getInventoryMasterDataProps.variant_item_id === 0)?_c('h3',[_vm._v("Create New Variations")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.getInventoryMasterDataProps.variant_item_id === 0 
                      && _vm.$store.getters.getInventoryMasterDataProps.variant_list.length>0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.getters.getInventoryMasterDataProps.other_variations}},[_c('el-table-column',{attrs:{"label":"SKU#","width":"240"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"200px"},attrs:{"size":"small","placeholder":"Leave it blank if not sure"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.sku_code),callback:function ($$v) {_vm.$set(scope.row, "sku_code", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.sku_code"}})]}}],null,false,3254778701)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"other_variations","label":"Variations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"300px"},attrs:{"size":"small","filterable":"","multiple":"","placeholder":"Select"},model:{value:(scope.row.other_variations),callback:function ($$v) {_vm.$set(scope.row, "other_variations", $$v)},expression:"scope.row.other_variations"}},_vm._l((_vm.$store.getters.getInventoryVariantList),function(dataGroup){return _c('el-option-group',{key:dataGroup.id},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{staticStyle:{"float":"left","padding-left":"5px"},domProps:{"innerHTML":_vm._s(dataGroup.variant_name)}}),_vm._v(" "),_vm._l((dataGroup.sub_variant_list),function(item){return _c('el-option',{key:item.id,attrs:{"label":dataGroup.variant_name+' -> '+item.sub_variant_name,"value":item.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.sub_variant_name)}})])})],2)])}),1)]}}],null,false,3469284633)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addNewInventoryMasterOtherVariantListRow')}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeInventoryMasterOtherVariantListRow', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}],null,false,4066486432)})],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[(_vm.$store.getters.getInventoryMasterDataProps.id>0)?_c('el-dropdown',{on:{"command":_vm.handleDropdownCommand}},[_c('el-button',{staticStyle:{"margin-right":"20px"},attrs:{"size":"small"}},[_vm._v("\n              Print Barcode"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"printRetailQr"}},[_vm._v("Retail Item Label")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"printStockQr"}},[_vm._v("Stock Item Label")])],1)],1):_vm._e(),_vm._v(" "),((_vm.$store.getters.getInventoryMasterDataProps.id>0 && _vm.$store.getters.getAccessRights.can_edit) || (_vm.$store.getters.getInventoryMasterDataProps.id === 0 && _vm.$store.getters.getAccessRights.can_add))?_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.submit}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.dispatch('deleteInventoryMasterData', {id: _vm.$store.state.inventoryMaster.props.id, navBack: true, store_list: _vm.$store.getters.getAccessibleStoreList})}}},[(_vm.$store.getters.getInventoryMasterDataProps.id>0 && !_vm.popup && _vm.$store.getters.getAccessRights.can_delete)?_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"slot":"reference","type":"danger","size":"small"},slot:"reference"},[_vm._v("Delete")]):_vm._e()],1),_vm._v(" "),_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.close}},[_vm._v("Go Back")])],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isPrintWindowVisible)?_c('PrintWindow',{attrs:{"title":_vm.getPrintTitle,"src":_vm.getPrintSrc,"dialogVisible":_vm.isPrintWindowVisible},on:{"closePrintWindow":function($event){_vm.showPrintWindow = false}}}):_vm._e(),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"Basic Info.","name":"1"}},[_c('Basic')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Price & Tax","name":"2"}},[_c('PriceAndTax')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Variant List","name":"3"}},[_c('VariantList')],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Images","name":"5"}},[_c('ImageList')],1),_vm._v(" "),(_vm.$store.getters.getInventoryMasterDataProps.item_type === 4)?_c('el-tab-pane',{attrs:{"label":"Service Logs","name":"6"}},[_c('ServiceLog')],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Statement","name":"7"}},[_c('Statement')],1)],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('div',{staticStyle:{"dispaly":"flex","flex-direction":"row"}},[_c('el-radio',{attrs:{"label":0},model:{value:(_vm.search_type),callback:function ($$v) {_vm.search_type=$$v},expression:"search_type"}},[_vm._v("\n              Customers\n          ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1},model:{value:(_vm.search_type),callback:function ($$v) {_vm.search_type=$$v},expression:"search_type"}},[_vm._v("\n              Stock\n          ")])],1),_vm._v(" "),_c('div',{staticStyle:{"dispaly":"flex","flex-direction":"row","margin-top":"20px"}},[_c('el-autocomplete',{staticStyle:{"text-align":"left","width":"90%","margin-top":"0px"},attrs:{"id":"inventory_item_id","fetch-suggestions":_vm.searchSKUCode,"placeholder":_vm.search_type === 1 ? 'Search by SKU#' : 'Search by customer',"trigger-on-focus":true},on:{"select":_vm.loadSearchedItem},model:{value:(_vm.search_text),callback:function ($$v) {_vm.search_text=$$v},expression:"search_text"}}),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.openQRScanner}},[_c('img',{staticStyle:{"top":"0px","position":"relative"},attrs:{"src":"https://etacdn.b-cdn.net/qr-scan.png","width":"5%"}})])],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","width":"100%","text-align":"left"}},[(_vm.$store.state.inventoryMaster.stock_list.length>0)?_c('el-link',{staticStyle:{"width":"100px","margin-bottom":"20px"},on:{"click":_vm.openInventoryWindow}},[_c('b',[_vm._v("View Product")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state.inventoryMaster.stock_list),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"2px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('el-link',{on:{"click":function($event){return _vm.showStatement(data.store_id)}}},[_vm._v("\n                  "+_vm._s(data.store_name)+"\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                  "+_vm._s(data.stock)+"\n              ")])],1)})],2),_vm._v(" "),(_vm.show_qr_window)?_c('el-dialog',{attrs:{"width":"70%","visible":_vm.show_qr_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_qr_window=$event}}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"closed":function($event){_vm.show_qr_window = false}}})],1):_vm._e(),_vm._v(" "),(_vm.show_statement)?_c('el-dialog',{attrs:{"fullscreen":"","visible":_vm.show_statement,"append-to-body":""},on:{"update:visible":function($event){_vm.show_statement=$event}}},[_c('InventoryStatement',{on:{"closed":function($event){_vm.show_statement=false}}})],1):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":'Add/Edit Inventory Article',"fullscreen":"","visible":_vm.showInventoryMaster,"close-on-press-escape":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showInventoryMaster=$event}}},[_c('InventoryMaster',{attrs:{"popup":true},on:{"closed":function($event){_vm.showInventoryMaster = false}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(995);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5df0778f", content, true, {});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'space-between',
        width: '100%'
    })},[_c('div',{style:({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left',
        width: '100%'
      })},[_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('el-radio',{attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"label":0},model:{value:(_vm.$store.state.tasks.props.priority),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "priority", $$v)},expression:"$store.state.tasks.props.priority"}},[_vm._v("Normal")]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"label":1},model:{value:(_vm.$store.state.tasks.props.priority),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "priority", $$v)},expression:"$store.state.tasks.props.priority"}},[_vm._v("Medium")]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"label":2},model:{value:(_vm.$store.state.tasks.props.priority),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "priority", $$v)},expression:"$store.state.tasks.props.priority"}},[_vm._v("Urgent")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Task Title")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{style:({width: _vm.isMobileDevice ? '100%' : '400px'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.tasks.props.title),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "title", $$v)},expression:"$store.state.tasks.props.title"}},[(_vm.$store.state.tasks.props.id === 0)?_c('template',{slot:"prepend"},[(_vm.$store.getters.getCustomerMasterDataProps.id>0 
                              && (_vm.getCurrentPath.indexOf('salesorders')>=0 || _vm.getCurrentPath.indexOf('customers')>=0 || _vm.getCurrentPath.indexOf('productionworkorders')>=0))?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$store.state.tasks.props.title_prefix = _vm.$store.getters.getCustomerMasterDataProps.customer_name)+"\n                      ")]):(_vm.$store.getters.getGenericContactDataProps.id>0 && _vm.getCurrentPath.indexOf('genericcontacts')>=0)?_c('span',[_vm._v("\n                          "+_vm._s(_vm.$store.state.tasks.props.title_prefix = _vm.$store.getters.getGenericContactDataProps.full_name)+"\n                      ")]):_vm._e()]):(_vm.$store.state.tasks.props.id > 0 && _vm.$store.state.tasks.props.title_prefix.length>0)?_c('template',{slot:"prepend"},[_vm._v("\n                      "+_vm._s(_vm.$store.state.tasks.props.title_prefix)+"\n                  ")]):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","width":"100%"}},[_c('el-radio',{attrs:{"label":0},model:{value:(_vm.$store.state.tasks.props.task_type),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "task_type", $$v)},expression:"$store.state.tasks.props.task_type"}},[_vm._v("\n                  Task\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1},model:{value:(_vm.$store.state.tasks.props.task_type),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "task_type", $$v)},expression:"$store.state.tasks.props.task_type"}},[_vm._v("\n                  Appointment\n              ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Task Date"+_vm._s(_vm.$store.state.tasks.props.task_type === 0 ? '' : '/Time'))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.tasks.props.task_type === 0)?_c('el-date-picker',{style:({width: _vm.isMobileDevice ? '100%' : '400px'}),attrs:{"disabled":(_vm.$store.getters.getTaskDataProps.status > 0 || _vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && (_vm.$store.state.tasks.props.id>0 && !_vm.$store.state.tasks.props.revised),"type":'date',"value-format":'yyyy-MM-dd',"format":'MMM dd yyyy'},model:{value:(_vm.$store.state.tasks.props.task_date),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "task_date", $$v)},expression:"$store.state.tasks.props.task_date"}}):_c('el-date-picker',{style:({width: _vm.isMobileDevice ? '100%' : '400px'}),attrs:{"disabled":(_vm.$store.getters.getTaskDataProps.status > 0 || _vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0 && !_vm.$store.state.tasks.props.revised,"type":'datetime',"value-format":'yyyy-MM-dd HH:mm:ss',"format":'MMM dd yyyy hh:mm a'},model:{value:(_vm.$store.state.tasks.props.task_time),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "task_time", $$v)},expression:"$store.state.tasks.props.task_time"}}),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$store.state.tasks.props.id>0 
                      && _vm.$store.getters.getUserInformation.staff_id 
                          === _vm.$store.getters.getTaskDataProps.created_by_staff_id)?_c('el-checkbox',{staticStyle:{"margin-top":"10px"},model:{value:(_vm.$store.state.tasks.props.revised),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "revised", $$v)},expression:"$store.state.tasks.props.revised"}},[_vm._v("\n                  Revise Task Date\n              ")]):_vm._e(),_vm._v(" "),_c('span',{staticStyle:{"color":"red","font-size":"11px"}},[_vm._v("\n                  "+_vm._s(_vm.$store.state.tasks.props.revision_count>0 ? 'Revised '+_vm.$store.state.tasks.props.revision_count+' times.' : '')+"\n              ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Description")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{style:({width: _vm.isMobileDevice ? '100%' : '400px'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"type":"textarea","size":"small","rows":"5"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.tasks.props.description),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "description", $$v)},expression:"$store.state.tasks.props.description"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Category")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('el-select',{style:({width: _vm.isMobileDevice ? '100%' : '400px', textAlign: 'left'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"size":"small","filterable":""},model:{value:(_vm.$store.state.tasks.props.category_id),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "category_id", $$v)},expression:"$store.state.tasks.props.category_id"}},_vm._l((_vm.$store.getters.getTaskCategoryList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.category_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.category_name)}})])}),1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Assigned To")]),_vm._v(" "),_c('br'),_vm._v(" "),( _vm.$store.state.tasks.props.id === 0)?_c('el-autocomplete',{staticClass:"inline-input",style:({width: _vm.isMobileDevice ? '100%' : '400px', textAlign: 'left'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"size":"small","fetch-suggestions":_vm.queryStaffSearch,"trigger-on-focus":true},on:{"select":_vm.loadSelectedStaffName},model:{value:(_vm.staff_name),callback:function ($$v) {_vm.staff_name=$$v},expression:"staff_name"}}):_c('el-select',{style:({width: _vm.isMobileDevice ? '100%' : '400px', textAlign: 'left'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"size":"small","filterable":""},model:{value:(_vm.$store.state.tasks.props.assigned_to_staff_id),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "assigned_to_staff_id", $$v)},expression:"$store.state.tasks.props.assigned_to_staff_id"}},[_c('el-option',{attrs:{"value":0,"label":"Admin"}},[_c('span',{style:('float: left;'),domProps:{"innerHTML":_vm._s('Admin')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.id === _vm.$store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name,"value":data.id}},[_c('span',{style:('float: left; '+(data.id === _vm.$store.getters.getUserInformation.staff_id ? 'font-weight: bold; color: red;' : '')+''),domProps:{"innerHTML":_vm._s(data.id === _vm.$store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name)}})])})],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","width":"100%"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Remarks")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{style:({width: _vm.isMobileDevice ? '100%' : '400px'}),attrs:{"disabled":(_vm.$store.getters.getUserInformation.staff_id !== _vm.$store.getters.getTaskDataProps.created_by_staff_id) && _vm.$store.state.tasks.props.id>0,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.tasks.props.internal_notes),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "internal_notes", $$v)},expression:"$store.state.tasks.props.internal_notes"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('UploadFile',{attrs:{"image_path":_vm.$store.state.tasks.props.document,"image_width":75,"allow_pdf":true,"file_dialog_id":'task_file_upload',"button_style":'width: 100px; top: 5px; position: relative;'},on:{"uploaded":function($event){_vm.$store.state.tasks.props.document=$event}}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('el-radio',{attrs:{"disabled":!(_vm.$store.getters.getUserInformation.staff_id === _vm.$store.getters.getTaskDataProps.assigned_to_staff_id),"label":1,"size":"small"},model:{value:(_vm.$store.state.tasks.props.status),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "status", $$v)},expression:"$store.state.tasks.props.status"}},[_vm._v("\n                  WIP\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":!(_vm.$store.getters.getUserInformation.staff_id === _vm.$store.getters.getTaskDataProps.assigned_to_staff_id),"label":2,"size":"small"},model:{value:(_vm.$store.state.tasks.props.status),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "status", $$v)},expression:"$store.state.tasks.props.status"}},[_vm._v("\n                  Completed\n              ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('el-radio',{attrs:{"label":3,"disabled":!(_vm.$store.getters.getUserInformation.staff_id === _vm.$store.getters.getTaskDataProps.created_by_staff_id),"size":"small"},model:{value:(_vm.$store.state.tasks.props.status),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "status", $$v)},expression:"$store.state.tasks.props.status"}},[_vm._v("\n                  Rejected\n              ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":4,"disabled":!(_vm.$store.getters.getUserInformation.staff_id === _vm.$store.getters.getTaskDataProps.created_by_staff_id),"size":"small"},model:{value:(_vm.$store.state.tasks.props.status),callback:function ($$v) {_vm.$set(_vm.$store.state.tasks.props, "status", $$v)},expression:"$store.state.tasks.props.status"}},[_vm._v("\n                  Approved\n              ")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","width":"100%","text-align":"left"}},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.submitBalance}},[_vm._v("\n                      Submit\n                  ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"center","border":"0px solid #383838"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[(_vm.isProductionOnly && _vm.isMobileDevice)?_c('a',{staticStyle:{"font-size":"24px","color":"black"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleRouteChange('homepage')}}},[_c('img',{staticStyle:{"width":"50px","top":"-5px","position":"relative"},attrs:{"src":__webpack_require__(998),"alt":""}})]):(_vm.isMobileDevice)?_c('a',{staticStyle:{"font-size":"34px","left":"20px","top":"5px","position":"relative","color":"black"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.displayMenu}},[_c('i',{staticClass:"el-icon-menu"})]):_vm._e(),_vm._v(" "),(!_vm.isOnlyOrderProgressWindow)?_c('el-menu',{style:('margin-top: -10px; '+(_vm.isMobileDevice ? 'z-index: 999; position: absolute; top: 80px; left: 0px; width: 300px; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);' : '')),attrs:{"mode":_vm.isMobileDevice ? 'vertical' : 'horizontal'},on:{"select":_vm.handleSelect}},[(_vm.show_menu)?_c('el-menu-item',{attrs:{"index":"homepage"}},[_c('img',{staticStyle:{"width":"50px","top":"-5px","position":"relative"},attrs:{"src":_vm.getTopLogo,"alt":""}})]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.getters.getAccessibleMenu),function(mainMenu,index){return (_vm.show_menu)?_c('el-submenu',{key:index,staticStyle:{"font-size":"12px","font-weight":"500"},attrs:{"index":index+''}},[_c('template',{slot:"title"},[_vm._v(_vm._s(mainMenu.menu_name))]),_vm._v(" "),_vm._l((mainMenu.sub_menu),function(subMenu,subIndex){return (subMenu.has_sub_menu)?_c('el-submenu',{key:subIndex+'_sub',staticStyle:{"text-align":"left"},attrs:{"index":subMenu.id+''}},[_c('template',{slot:"title"},[_vm._v(_vm._s(subMenu.menu_name))]),_vm._v(" "),_vm._l((subMenu.sub_sub_menu),function(subSubMenu,subSubIndex){return ((subSubMenu.id === 204 && !_vm.$store.state.preferences.props.tax_return_on_order) || subSubMenu.id != 204)?_c('el-menu-item',{key:subSubIndex+'_subSub',staticStyle:{"text-align":"left"},attrs:{"router":true,"index":subSubMenu.route_path}},[_c('span',[_vm._v("\n                    "+_vm._s(subSubMenu.menu_name)+" \n                  ")])]):_vm._e()})],2):_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":subMenu.route_path}},[_c('span',[_vm._v("\n                "+_vm._s(subMenu.menu_name)+"\n              ")])])})],2):_vm._e()}),_vm._v(" "),(_vm.show_menu && !_vm.isProductionOnly)?_c('el-submenu',{staticStyle:{"text-align":"left"}},[_c('template',{slot:"title"},[_vm._v("Help")]),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"index":"reachus"}},[_c('a',{staticStyle:{"color":"black"},attrs:{"href":"https://reachus.easytailorapp.com","target":"_blank"}},[_vm._v("Support & Documentation")])]),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"index":"reachus"}},[_c('a',{staticStyle:{"color":"black"},attrs:{"href":"https://billing.stripe.com/p/login/7sIfZha5z92018c9AA","target":"_blank"}},[_vm._v("Billing Portal")])]),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"index":"reachus"}},[_vm._v("Ver. 4.41.7")])],2):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-menu',{staticStyle:{"margin-top":"-10px"},attrs:{"mode":"horizontal"},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"stocksearch"}},[_vm._v("Search "),_c('i',{staticClass:"el-icon-search",staticStyle:{"font-size":"18px","position":"relative"}})]),_vm._v(" "),_c('el-submenu',{staticStyle:{"font-size":"12px","font-weight":"bold","color":"black"},attrs:{"index":'settings'}},[_c('template',{slot:"title"},[_c('img',{staticStyle:{"max-width":"20px","border-radius":"50%"},attrs:{"src":_vm.$store.getters.getUserInformation.profile_photo,"alt":""}}),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(_vm.$store.getters.getUserInformation.name))])]),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":'/tasks'}},[_vm._v("\n            Tasks\n          ")]),_vm._v(" "),(_vm.checkIfModuleAccessAvailable('/salesorders', 'can_view'))?_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":'salesCalendar'}},[_vm._v("\n            Sales Calendar\n          ")]):_vm._e(),_vm._v(" "),(_vm.checkIfModuleAccessAvailable('/productionworkorders', 'can_view'))?_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":'productionCalendar'}},[_vm._v("\n            Production Calendar\n          ")]):_vm._e(),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":'/changepassword'}},[_vm._v("\n            Change Password\n          ")]),_vm._v(" "),_c('el-menu-item',{staticStyle:{"text-align":"left"},attrs:{"router":true,"index":'/logout'}},[_vm._v("\n            Logout\n          ")])],2)],1)],1),_vm._v(" "),(_vm.show_calendar)?_c('el-dialog',{attrs:{"title":'Calendar',"fullscreen":"","visible":_vm.show_calendar,"append-to-body":""},on:{"update:visible":function($event){_vm.show_calendar=$event}}},[_c('TaskCalendar',{attrs:{"production_calendar":_vm.isProductionCalendar}})],1):_vm._e(),_vm._v(" "),(_vm.getDaysLeft<=7)?_c('el-dialog',{attrs:{"width":"600px","visible":_vm.show_renew},on:{"update:visible":function($event){_vm.show_renew=$event}}},[_c('AccountExpired',{attrs:{"days_left":_vm.getDaysLeft}})],1):_vm._e(),_vm._v(" "),(_vm.show_stock_search)?_c('el-dialog',{attrs:{"width":"400px","visible":_vm.show_stock_search},on:{"update:visible":function($event){_vm.show_stock_search=$event}}},[_c('StockCheck',{on:{"closed":function($event){_vm.show_stock_search=false}}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.tasks.show_task_form)?_c('el-dialog',{attrs:{"fullscreen":_vm.isMobileDevice,"title":'New Task',"width":_vm.isMobileDevice ? '100%' : '450px',"visible":_vm.$store.state.tasks.show_task_form,"append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.$store.state.tasks, "show_task_form", $event)}}},[_c('TaskForm')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "eta-small.png?1d99201e72a9a7b892e15ddb5f9f33e4";

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isOnlyOrderProgressWindow)?_c('MainMenu'):_vm._e(),_vm._v(" "),_c('el-breadcrumb',{staticStyle:{"top":"10px","position":"relative","background-color":"#eee","padding":"5px","border-radius":"25px"},attrs:{"separator":""}},[_vm._l((_vm.$store.getters.getBreadcrumbs),function(data,index){return _c('el-breadcrumb-item',{key:index},[_c('span',{staticStyle:{"color":"#383838","font-size":"14px"}},[_vm._v("\n          "+_vm._s(data.crumbName)+"\n        ")])])}),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right","padding-right":"5px","padding-top":"0px"}},[(_vm.$store.getters.getAccessRights.id>0 && !_vm.isOnlyOrderProgressWindow)?_c('a',{staticStyle:{"color":"red"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.saveBookmark}},[_c('i',{class:_vm.isBookmarked ? 'el-icon-star-on' : 'el-icon-star-off'}),_vm._v(" Bookmark"+_vm._s(_vm.isBookmarked ? 'ed' : ''))]):_vm._e(),_vm._v(" "),(_vm.isOnlyOrderProgressWindow)?_c('a',{staticStyle:{"font-weight":"bold","color":"black"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.toggleFullScreen}},[_c('i',{staticClass:"el-icon-full-screen"})]):_vm._e(),_vm._v(" "),(_vm.isOnlyOrderProgressWindow)?_c('a',{staticStyle:{"font-weight":"bold","color":"black","margin-left":"10px"},attrs:{"href":"javascript:void(0)"},on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()])],2),_vm._v(" "),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.getCountryList.length>0)?_c('div',{attrs:{"id":"app"}},[(_vm.isAuthActive)?_c('Header'):_vm._e(),_vm._v(" "),_c('el-container',{staticStyle:{"min-height":"100vh"}},[_c('el-main',[_c('router-view',{staticStyle:{"top":"10px","position":"relative"}})],1),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('el-footer',[(_vm.getCurrentHostName.includes('cloud.easytailor') || _vm.getCurrentHostName.includes('localhost'))?_c('span',{staticStyle:{"font-size":"10px"},domProps:{"innerHTML":_vm._s('2017-'+new Date().getFullYear()+' &copy; Easy Tailor App LLP, All Rights Reserved.')}}):_c('span',{staticStyle:{"font-size":"10px"},domProps:{"innerHTML":_vm._s('Hosted at '+_vm.getCurrentHostName)}})])],1),_vm._v(" "),_c('el-backtop',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('span',{staticStyle:{"font-weight":"bold"}},[_c('i',{staticClass:"el-icon-arrow-up"}),_vm._v(" UP")])])])],1):_c('div',{staticStyle:{"width":"100%","text-align":"center"},attrs:{"id":"app"}},[_c('h1',[_vm._v("Loading...")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);
var bind = __webpack_require__(228);
var Axios = __webpack_require__(1002);
var mergeConfig = __webpack_require__(234);
var defaults = __webpack_require__(97);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(98);
axios.CancelToken = __webpack_require__(1015);
axios.isCancel = __webpack_require__(233);
axios.VERSION = __webpack_require__(235).version;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1016);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(1017);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);
var buildURL = __webpack_require__(229);
var InterceptorManager = __webpack_require__(1003);
var dispatchRequest = __webpack_require__(1004);
var mergeConfig = __webpack_require__(234);
var validator = __webpack_require__(1014);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }

  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);
var transformData = __webpack_require__(1005);
var isCancel = __webpack_require__(233);
var defaults = __webpack_require__(97);
var Cancel = __webpack_require__(98);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(config, config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(config, response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);
var defaults = __webpack_require__(97);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(232);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1010);
var combineURLs = __webpack_require__(1011);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d+\-.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var VERSION = __webpack_require__(235).version;

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
  validators[type] = function validator(thing) {
    return (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function (value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(98);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function (cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function (onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function (resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(20);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
};

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
  * vue-router v3.5.4
  * (c) 2022 Evan You
  * @license MIT
  */
/*  */

function assert(condition, message) {
  if (!condition) {
    throw new Error("[vue-router] " + message);
  }
}

function warn(condition, message) {
  if (!condition) {
    typeof console !== 'undefined' && console.warn("[vue-router] " + message);
  }
}

function extend(a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a;
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function encodeReserveReplacer(c) {
  return '%' + c.charCodeAt(0).toString(16);
};
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function encode(str) {
  return encodeURIComponent(str).replace(encodeReserveRE, encodeReserveReplacer).replace(commaRE, ',');
};

function decode(str) {
  try {
    return decodeURIComponent(str);
  } catch (err) {
    if (false) {
      warn(false, "Error decoding \"" + str + "\". Leaving it intact.");
    }
  }
  return str;
}

function resolveQuery(query, extraQuery, _parseQuery) {
  if (extraQuery === void 0) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value) ? value.map(castQueryParamValue) : castQueryParamValue(value);
  }
  return parsedQuery;
}

var castQueryParamValue = function castQueryParamValue(value) {
  return value == null || (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object' ? value : String(value);
};

function parseQuery(query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res;
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res;
}

function stringifyQuery(obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return '';
    }

    if (val === null) {
      return encode(key);
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return;
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&');
    }

    return encode(key) + '=' + encode(val);
  }).filter(function (x) {
    return x.length > 0;
  }).join('&') : null;
  return res ? "?" + res : '';
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute(record, location, redirectedFrom, router) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || record && record.name,
    meta: record && record.meta || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route);
}

function clone(value) {
  if (Array.isArray(value)) {
    return value.map(clone);
  } else if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res;
  } else {
    return value;
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch(record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res;
}

function getFullPath(ref, _stringifyQuery) {
  var path = ref.path;
  var query = ref.query;if (query === void 0) query = {};
  var hash = ref.hash;if (hash === void 0) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash;
}

function isSameRoute(a, b, onlyPath) {
  if (b === START) {
    return a === b;
  } else if (!b) {
    return false;
  } else if (a.path && b.path) {
    return a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') && (onlyPath || a.hash === b.hash && isObjectEqual(a.query, b.query));
  } else if (a.name && b.name) {
    return a.name === b.name && (onlyPath || a.hash === b.hash && isObjectEqual(a.query, b.query) && isObjectEqual(a.params, b.params));
  } else {
    return false;
  }
}

function isObjectEqual(a, b) {
  if (a === void 0) a = {};
  if (b === void 0) b = {};

  // handle null value #1566
  if (!a || !b) {
    return a === b;
  }
  var aKeys = Object.keys(a).sort();
  var bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  return aKeys.every(function (key, i) {
    var aVal = a[key];
    var bKey = bKeys[i];
    if (bKey !== key) {
      return false;
    }
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) {
      return aVal === bVal;
    }
    // check nested equality
    if ((typeof aVal === "undefined" ? "undefined" : _typeof(aVal)) === 'object' && (typeof bVal === "undefined" ? "undefined" : _typeof(bVal)) === 'object') {
      return isObjectEqual(aVal, bVal);
    }
    return String(aVal) === String(bVal);
  });
}

function isIncludedRoute(current, target) {
  return current.path.replace(trailingSlashRE, '/').indexOf(target.path.replace(trailingSlashRE, '/')) === 0 && (!target.hash || current.hash === target.hash) && queryIncludes(current.query, target.query);
}

function queryIncludes(current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false;
    }
  }
  return true;
}

function handleRouteEntered(route) {
  for (var i = 0; i < route.matched.length; i++) {
    var record = route.matched[i];
    for (var name in record.instances) {
      var instance = record.instances[name];
      var cbs = record.enteredCbs[name];
      if (!instance || !cbs) {
        continue;
      }
      delete record.enteredCbs[name];
      for (var i$1 = 0; i$1 < cbs.length; i$1++) {
        if (!instance._isBeingDestroyed) {
          cbs[i$1](instance);
        }
      }
    }
  }
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render(_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children);
      } else {
        // render previous empty view
        return h();
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h();
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (val && current !== vm || !val && current === vm) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive && vnode.componentInstance && vnode.componentInstance !== matched.instances[name]) {
        matched.instances[name] = vnode.componentInstance;
      }

      // if the route transition has already been confirmed then we weren't
      // able to call the cbs during confirmation as the component was not
      // registered yet, so we call it here.
      handleRouteEntered(route);
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children);
  }
};

function fillPropsinData(component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps(route, config) {
  switch (typeof config === "undefined" ? "undefined" : _typeof(config)) {
    case 'undefined':
      return;
    case 'object':
      return config;
    case 'function':
      return config(route);
    case 'boolean':
      return config ? route.params : undefined;
    default:
      if (false) {
        warn(false, "props in \"" + route.path + "\" is a " + (typeof config === "undefined" ? "undefined" : _typeof(config)) + ", " + "expecting an object, function or boolean.");
      }
  }
}

/*  */

function resolvePath(relative, base, append) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative;
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative;
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/');
}

function parsePath(path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  };
}

function cleanPath(path) {
  return path.replace(/\/(?:\s*\/)+/g, '/');
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options), options);
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (_typeof(tokens[i]) === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options && options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams(path, params, routeMsg) {
  params = params || {};
  try {
    var filler = regexpCompileCache[path] || (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') {
      params[0] = params.pathMatch;
    }

    return filler(params, { pretty: true });
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', "missing param for " + routeMsg + ": " + e.message);
    }
    return '';
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation(raw, current, append, router) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next;
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === 'object') {
      next.params = extend({}, params);
    }
    return next;
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, "path " + current.path);
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next;
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = current && current.path || '/';
  var path = parsedPath.path ? resolvePath(parsedPath.path, basePath, append || next.append) : basePath;

  var query = resolveQuery(parsedPath.query, next.query, router && router.options.parseQuery);

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  };
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function noop() {};

var warnedCustomSlot;
var warnedTagProp;
var warnedEventProp;

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render(h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null ? 'router-link-exact-active' : globalExactActiveClass;
    var activeClass = this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null ? exactActiveClassFallback : this.exactActiveClass;

    var compareTarget = route.redirectedFrom ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router) : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget, this.exactPath);
    classes[activeClass] = this.exact || this.exactPath ? classes[exactActiveClass] : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function handler(e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot = !this.$scopedSlots.$hasNormal && this.$scopedSlots.default && this.$scopedSlots.default({
      href: href,
      route: route,
      navigate: handler,
      isActive: classes[activeClass],
      isExactActive: classes[exactActiveClass]
    });

    if (scopedSlot) {
      if (false) {
        !warnedCustomSlot && warn(false, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n');
        warnedCustomSlot = true;
      }
      if (scopedSlot.length === 1) {
        return scopedSlot[0];
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(false, "<router-link> with to=\"" + this.to + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.");
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot);
      }
    }

    if (false) {
      if ('tag' in this.$options.propsData && !warnedTagProp) {
        warn(false, "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link.");
        warnedTagProp = true;
      }
      if ('event' in this.$options.propsData && !warnedEventProp) {
        warn(false, "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link.");
        warnedEventProp = true;
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = a.data = extend({}, a.data);
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default);
  }
};

function guardEvent(e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
    return;
  }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) {
    return;
  }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) {
    return;
  }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) {
      return;
    }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true;
}

function findAnchor(children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child;
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child;
      }
    }
  }
}

var _Vue;

function install(Vue) {
  if (install.installed && _Vue === Vue) {
    return;
  }
  install.installed = true;

  _Vue = Vue;

  var isDef = function isDef(v) {
    return v !== undefined;
  };

  var registerInstance = function registerInstance(vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = this.$parent && this.$parent._routerRoot || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed() {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get() {
      return this._routerRoot._router;
    }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get() {
      return this._routerRoot._route;
    }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap(routes, oldPathList, oldPathMap, oldNameMap, parentRoute) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route, parentRoute);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
    .filter(function (path) {
      return path && path.charAt(0) !== '*' && path.charAt(0) !== '/';
    });

    if (found.length > 0) {
      var pathNames = found.map(function (path) {
        return "- " + path;
      }).join('\n');
      warn(false, "Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames);
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  };
}

function addRouteRecord(pathList, pathMap, nameMap, route, parent, matchAs) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(typeof route.component !== 'string', "route config \"component\" for path: " + String(path || name) + " cannot be a " + "string id. Use an actual component instead.");

    warn(
    // eslint-disable-next-line no-control-regex
    !/[^\u0000-\u007F]+/.test(path), "Route with path \"" + path + "\" contains unencoded characters, make sure " + "your path is correctly encoded before passing it to the router. Use " + "encodeURI to encode static segments of your path.");
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    alias: route.alias ? typeof route.alias === 'string' ? [route.alias] : route.alias : [],
    instances: {},
    enteredCbs: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null ? {} : route.components ? route.props : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) {
        return (/^\/?$/.test(child.path)
        );
      })) {
        warn(false, "Named Route '" + route.name + "' has a default child route. " + "When navigating to this named route (:to=\"{name: '" + route.name + "'}\"), " + "the default child route will not be rendered. Remove the name from " + "this route and use the name of the default child route for named " + "links instead.");
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs ? cleanPath(matchAs + "/" + child.path) : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(false, "Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.");
        // skip in dev to make it work
        continue;
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(pathList, pathMap, nameMap, aliasRoute, parent, record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(false, "Duplicate named routes definition: " + "{ name: \"" + name + "\", path: \"" + record.path + "\" }");
    }
  }
}

function compileRouteRegex(path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], "Duplicate param keys in route with path: \"" + path + "\"");
      keys[key.name] = true;
    });
  }
  return regex;
}

function normalizePath(path, parent, strict) {
  if (!strict) {
    path = path.replace(/\/$/, '');
  }
  if (path[0] === '/') {
    return path;
  }
  if (parent == null) {
    return path;
  }
  return cleanPath(parent.path + "/" + path);
}

/*  */

function createMatcher(routes, router) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes(routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function addRoute(parentOrRoute, route) {
    var parent = (typeof parentOrRoute === "undefined" ? "undefined" : _typeof(parentOrRoute)) !== 'object' ? nameMap[parentOrRoute] : undefined;
    // $flow-disable-line
    createRouteMap([route || parentOrRoute], pathList, pathMap, nameMap, parent);

    // add aliases of parent
    if (parent && parent.alias.length) {
      createRouteMap(
      // $flow-disable-line route is defined if parent is
      parent.alias.map(function (alias) {
        return { path: alias, children: [route] };
      }), pathList, pathMap, nameMap, parent);
    }
  }

  function getRoutes() {
    return pathList.map(function (path) {
      return pathMap[path];
    });
  }

  function match(raw, currentRoute, redirectedFrom) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, "Route with name '" + name + "' does not exist");
      }
      if (!record) {
        return _createRoute(null, location);
      }
      var paramNames = record.regex.keys.filter(function (key) {
        return !key.optional;
      }).map(function (key) {
        return key.name;
      });

      if (_typeof(location.params) !== 'object') {
        location.params = {};
      }

      if (currentRoute && _typeof(currentRoute.params) === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, "named route \"" + name + "\"");
      return _createRoute(record, location, redirectedFrom);
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom);
        }
      }
    }
    // no match
    return _createRoute(null, location);
  }

  function redirect(record, location) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function' ? originalRedirect(createRoute(record, location, null, router)) : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || (typeof redirect === "undefined" ? "undefined" : _typeof(redirect)) !== 'object') {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, "redirect failed: named route \"" + name + "\" not found.");
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location);
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, "redirect route with path \"" + rawPath + "\"");
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location);
    } else {
      if (false) {
        warn(false, "invalid redirect option: " + JSON.stringify(redirect));
      }
      return _createRoute(null, location);
    }
  }

  function alias(record, location, matchAs) {
    var aliasedPath = fillParams(matchAs, location.params, "aliased route with path \"" + matchAs + "\"");
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location);
    }
    return _createRoute(null, location);
  }

  function _createRoute(record, location, redirectedFrom) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location);
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs);
    }
    return createRoute(record, location, redirectedFrom, router);
  }

  return {
    match: match,
    addRoute: addRoute,
    getRoutes: getRoutes,
    addRoutes: addRoutes
  };
}

function matchRoute(regex, path, params) {
  var m = path.match(regex);

  if (!m) {
    return false;
  } else if (!params) {
    return true;
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = typeof m[i] === 'string' ? decode(m[i]) : m[i];
    }
  }

  return true;
}

function resolveRecordPath(path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true);
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now ? window.performance : Date;

function genStateKey() {
  return Time.now().toFixed(3);
}

var _key = genStateKey();

function getStateKey() {
  return _key;
}

function setStateKey(key) {
  return _key = key;
}

/*  */

var positionStore = Object.create(null);

function setupScroll() {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  };
}

function handleScroll(router, to, from, isPop) {
  if (!router.app) {
    return;
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return;
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(router, to, from, isPop ? position : null);

    if (!shouldScroll) {
      return;
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition(shouldScroll, position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition() {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState(e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition() {
  var key = getStateKey();
  if (key) {
    return positionStore[key];
  }
}

function getElementPosition(el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  };
}

function isValidPosition(obj) {
  return isNumber(obj.x) || isNumber(obj.y);
}

function normalizePosition(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  };
}

function normalizeOffset(obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  };
}

function isNumber(v) {
  return typeof v === 'number';
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition(shouldScroll, position) {
  var isObject = (typeof shouldScroll === "undefined" ? "undefined" : _typeof(shouldScroll)) === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
    ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
    : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset = shouldScroll.offset && _typeof(shouldScroll.offset) === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    // $flow-disable-line
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        left: position.x,
        top: position.y,
        // $flow-disable-line
        behavior: shouldScroll.behavior
      });
    } else {
      window.scrollTo(position.x, position.y);
    }
  }
}

/*  */

var supportsPushState = inBrowser && function () {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
    return false;
  }

  return window.history && typeof window.history.pushState === 'function';
}();

function pushState(url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState(url) {
  pushState(url, true);
}

/*  */

function runQueue(queue, fn, cb) {
  var step = function step(index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError(from, to) {
  return createRouterError(from, to, NavigationFailureType.redirected, "Redirected when going from \"" + from.fullPath + "\" to \"" + stringifyRoute(to) + "\" via a navigation guard.");
}

function createNavigationDuplicatedError(from, to) {
  var error = createRouterError(from, to, NavigationFailureType.duplicated, "Avoided redundant navigation to current location: \"" + from.fullPath + "\".");
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error;
}

function createNavigationCancelledError(from, to) {
  return createRouterError(from, to, NavigationFailureType.cancelled, "Navigation cancelled from \"" + from.fullPath + "\" to \"" + to.fullPath + "\" with a new navigation.");
}

function createNavigationAbortedError(from, to) {
  return createRouterError(from, to, NavigationFailureType.aborted, "Navigation aborted from \"" + from.fullPath + "\" to \"" + to.fullPath + "\" via a navigation guard.");
}

function createRouterError(from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error;
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute(to) {
  if (typeof to === 'string') {
    return to;
  }
  if ('path' in to) {
    return to.path;
  }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) {
      location[key] = to[key];
    }
  });
  return JSON.stringify(location, null, 2);
}

function isError(err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1;
}

function isNavigationFailure(err, errorType) {
  return isError(err) && err._isRouter && (errorType == null || err.type === errorType);
}

/*  */

function resolveAsyncComponents(matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function' ? resolvedDef : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason) ? reason : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) {
      next();
    }
  };
}

function flatMapComponents(matched, fn) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return fn(m.components[key], m.instances[key], m, key);
    });
  }));
}

function flatten(arr) {
  return Array.prototype.concat.apply([], arr);
}

var hasSymbol = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

function isESModule(obj) {
  return obj.__esModule || hasSymbol && obj[Symbol.toStringTag] === 'Module';
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once(fn) {
  var called = false;
  return function () {
    var args = [],
        len = arguments.length;
    while (len--) {
      args[len] = arguments[len];
    }if (called) {
      return;
    }
    called = true;
    return fn.apply(this, args);
  };
}

/*  */

var History = function History(router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen(cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady(cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError(errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo(location, onComplete, onAbort) {
  var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e;
  }
  var prev = this.current;
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();
    this$1.router.afterHooks.forEach(function (hook) {
      hook && hook(route, prev);
    });

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) {
        cb(route);
      });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      // Initial redirection should not mark the history as ready yet
      // because it's triggered by the redirection instead
      // https://github.com/vuejs/vue-router/issues/3225
      // https://github.com/vuejs/vue-router/issues/3331
      if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
        this$1.ready = true;
        this$1.readyErrorCbs.forEach(function (cb) {
          cb(err);
        });
      }
    }
  });
};

History.prototype.confirmTransition = function confirmTransition(route, onComplete, onAbort) {
  var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function abort(err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        if (false) {
          warn(false, 'uncaught error during route navigation:');
        }
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (isSameRoute(route, current) &&
  // in the case the route map has been dynamically appended to
  lastRouteIndex === lastCurrentIndex && route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]) {
    this.ensureURL();
    if (route.hash) {
      handleScroll(this.router, current, route, false);
    }
    return abort(createNavigationDuplicatedError(current, route));
  }

  var ref = resolveQueue(this.current.matched, route.matched);
  var updated = ref.updated;
  var deactivated = ref.deactivated;
  var activated = ref.activated;

  var queue = [].concat(
  // in-component leave guards
  extractLeaveGuards(deactivated),
  // global before hooks
  this.router.beforeHooks,
  // in-component update hooks
  extractUpdateHooks(updated),
  // in-config enter guards
  activated.map(function (m) {
    return m.beforeEnter;
  }),
  // async components
  resolveAsyncComponents(activated));

  var iterator = function iterator(hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route));
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (typeof to === 'string' || (typeof to === "undefined" ? "undefined" : _typeof(to)) === 'object' && (typeof to.path === 'string' || typeof to.name === 'string')) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if ((typeof to === "undefined" ? "undefined" : _typeof(to)) === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route));
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          handleRouteEntered(route);
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute(route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners() {
  // Default implementation is empty
};

History.prototype.teardown = function teardown() {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase(base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = baseEl && baseEl.getAttribute('href') || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '');
}

function resolveQueue(current, next) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break;
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  };
}

function extractGuards(records, name, bind, reverse) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard) ? guard.map(function (guard) {
        return bind(guard, instance, match, key);
      }) : bind(guard, instance, match, key);
    }
  });
  return flatten(reverse ? guards.reverse() : guards);
}

function extractGuard(def, key) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key];
}

function extractLeaveGuards(deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true);
}

function extractUpdateHooks(updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard);
}

function bindGuard(guard, instance) {
  if (instance) {
    return function boundRouteGuard() {
      return guard.apply(instance, arguments);
    };
  }
}

function extractEnterGuards(activated) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key);
  });
}

function bindEnterGuard(guard, match, key) {
  return function routeEnterGuard(to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        if (!match.enteredCbs[key]) {
          match.enteredCbs[key] = [];
        }
        match.enteredCbs[key].push(cb);
      }
      next(cb);
    });
  };
}

/*  */

var HTML5History = /*@__PURE__*/function (History) {
  function HTML5History(router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if (History) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create(History && History.prototype);
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners() {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return;
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function handleRoutingEvent() {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return;
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go(n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL(push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation() {
    return getLocation(this.base);
  };

  return HTML5History;
}(History);

function getLocation(base) {
  var path = window.location.pathname;
  var pathLowerCase = path.toLowerCase();
  var baseLowerCase = base.toLowerCase();
  // base="/a" shouldn't turn path="/app" into "/a/pp"
  // https://github.com/vuejs/vue-router/issues/3555
  // so we ensure the trailing slash in the base
  if (base && (pathLowerCase === baseLowerCase || pathLowerCase.indexOf(cleanPath(baseLowerCase + '/')) === 0)) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash;
}

/*  */

var HashHistory = /*@__PURE__*/function (History) {
  function HashHistory(router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return;
    }
    ensureSlash();
  }

  if (History) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create(History && History.prototype);
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners() {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return;
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function handleRoutingEvent() {
      var current = this$1.current;
      if (!ensureSlash()) {
        return;
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(eventType, handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go(n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL(push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    return getHash();
  };

  return HashHistory;
}(History);

function checkFallback(base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true;
  }
}

function ensureSlash() {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true;
  }
  replaceHash('/' + path);
  return false;
}

function getHash() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) {
    return '';
  }

  href = href.slice(index + 1);

  return href;
}

function getUrl(path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return base + "#" + path;
}

function pushHash(path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash(path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/function (History) {
  function AbstractHistory(router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if (History) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create(History && History.prototype);
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace(location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go(n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return;
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      var prev = this$1.current;
      this$1.index = targetIndex;
      this$1.updateRoute(route);
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });
    }, function (err) {
      if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
        this$1.index = targetIndex;
      }
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation() {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/';
  };

  AbstractHistory.prototype.ensureURL = function ensureURL() {
    // noop
  };

  return AbstractHistory;
}(History);

/*  */

var VueRouter = function VueRouter(options) {
  if (options === void 0) options = {};

  if (false) {
    warn(this instanceof VueRouter, "Router must be called with the new operator.");
  }
  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break;
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break;
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break;
    default:
      if (false) {
        assert(false, "invalid mode: " + mode);
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match(raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom);
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current;
};

VueRouter.prototype.init = function init(app /* Vue component instance */) {
  var this$1 = this;

  "production" !== 'production' && assert(install.installed, "not installed. Make sure to call `Vue.use(VueRouter)` " + "before creating root instance.");

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) {
      this$1.apps.splice(index, 1);
    }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) {
      this$1.app = this$1.apps[0] || null;
    }

    if (!this$1.app) {
      this$1.history.teardown();
    }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return;
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function handleInitialScroll(routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function setupListeners(routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(history.getCurrentLocation(), setupListeners, setupListeners);
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach(fn) {
  return registerHook(this.beforeHooks, fn);
};

VueRouter.prototype.beforeResolve = function beforeResolve(fn) {
  return registerHook(this.resolveHooks, fn);
};

VueRouter.prototype.afterEach = function afterEach(fn) {
  return registerHook(this.afterHooks, fn);
};

VueRouter.prototype.onReady = function onReady(cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError(errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    });
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    });
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go(n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back() {
  this.go(-1);
};

VueRouter.prototype.forward = function forward() {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents(to) {
  var route = to ? to.matched ? to : this.resolve(to).route : this.currentRoute;
  if (!route) {
    return [];
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key];
    });
  }));
};

VueRouter.prototype.resolve = function resolve(to, current, append) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  };
};

VueRouter.prototype.getRoutes = function getRoutes() {
  return this.matcher.getRoutes();
};

VueRouter.prototype.addRoute = function addRoute(parentOrRoute, route) {
  this.matcher.addRoute(parentOrRoute, route);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

VueRouter.prototype.addRoutes = function addRoutes(routes) {
  if (false) {
    warn(false, 'router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead.');
  }
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties(VueRouter.prototype, prototypeAccessors);

function registerHook(list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) {
      list.splice(i, 1);
    }
  };
}

function createHref(base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path;
}

VueRouter.install = install;
VueRouter.version = '3.5.4';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;
VueRouter.START_LOCATION = START;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127a8b8f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1022);
function injectStyle (ssrContext) {
  __webpack_require__(1020)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127a8b8f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1021);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3d20ca4a", content, true, {});

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"width":"150px"},attrs:{"alt":"Easy Tailor App Logo","src":__webpack_require__(96)}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("First Name")]),_vm._v(" "),_c('el-input',{attrs:{"size":"small","id":"firstName"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.signup.props.first_name),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "first_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.signup.props.first_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Last Name")]),_vm._v(" "),_c('el-input',{attrs:{"size":"small","id":"lastName"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.signup.props.last_name),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "last_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.signup.props.last_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Brand Name")]),_vm._v(" "),_c('el-input',{attrs:{"size":"small","id":"brandName"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.signup.props.brand_name),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "brand_name", $$v)},expression:"$store.state.signup.props.brand_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Country")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"size":"small","default-first-option":"","id":"countryId","filterable":""},model:{value:(_vm.$store.state.signup.props.country_id),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "country_id", $$v)},expression:"$store.state.signup.props.country_id"}},_vm._l((_vm.$store.getters.getCountryList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.country_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.country_icon)}}),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(data.country_name))])])}),1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Email Address")]),_vm._v(" "),_c('el-input',{attrs:{"size":"small","id":"emailAddress"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.signup.props.email_address),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "email_address", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.signup.props.email_address"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.checkIfTenantExists}},[_vm._v("Register Account")]),_vm._v(" "),_c('el-link',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Already Have Account?")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step1_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116c9353_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step1_vue__ = __webpack_require__(1026);
function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_116c9353_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4ece2079", content, true, {});

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"width":"150px"},attrs:{"alt":"Easy Tailor App Logo","src":__webpack_require__(96)}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"type":"label"}},[_vm._v("6 Digit Verification Code")]),_vm._v(" "),_c('el-input',{on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.signup.props.confirmation_code),callback:function ($$v) {_vm.$set(_vm.$store.state.signup.props, "confirmation_code", $$v)},expression:"$store.state.signup.props.confirmation_code"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.checkTenantConfirmationCode}},[_vm._v("Submit")]),_vm._v(" "),_c('el-link',{on:{"click":function($event){return _vm.$router.push('/signup')}}},[_vm._v("Go Back")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('b',[_vm._v("We have emailed you a 6 digit verification code. Please check your Spam/Junk folder if the email is not found in your Inbox.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step2_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3207966b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step2_vue__ = __webpack_require__(1030);
function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Step2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3207966b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Step2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1029);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("a524c6a2", content, true, {});

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    Create password after confirmation code verification\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3f2106c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(1034);
function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3f2106c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1033);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3f28ce20", content, true, {});

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"alt":"Easy Tailor App Logo","src":_vm.getTopLogo}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Email Address / User Name")]),_vm._v(" "),_c('el-input',{attrs:{"id":"loginId"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.$store.state.master.login.user_name),callback:function ($$v) {_vm.$set(_vm.$store.state.master.login, "user_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.master.login.user_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"loginPassword","type":"password","show-password":""},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.$store.state.master.login.password),callback:function ($$v) {_vm.$set(_vm.$store.state.master.login, "password", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.master.login.password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.login}},[_vm._v("Login")]),_vm._v(" "),_c('el-link',{on:{"click":function($event){return _vm.$router.push('/forgotpassword')}}},[_vm._v("Forgot Password?")])],1),_vm._v(" "),(!_vm.isMasterLoginHidden)?_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('el-link',{on:{"click":function($event){return _vm.$router.push('/signup')}}},[_vm._v("Register New Account?")])],1):_vm._e(),_vm._v(" "),(!_vm.isMasterLoginHidden)?_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('el-link',{on:{"click":function($event){return _vm.$router.push('/masteraccount')}}},[_vm._v("Master Account")])],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f371810_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChangePassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f371810_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChangePassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1037);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("b39d5458", content, true, {});

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Current Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"current_password","type":"password","show-password":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.current_password),callback:function ($$v) {_vm.current_password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"current_password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("New Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"new_password","type":"password","show-password":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.new_password),callback:function ($$v) {_vm.new_password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"new_password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Confirm Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"loginPassword","type":"password","show-password":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.confirm_password),callback:function ($$v) {_vm.confirm_password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"confirm_password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.changePassword}},[_vm._v("Change Password")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4359337b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(1042);
function injectStyle (ssrContext) {
  __webpack_require__(1040)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4359337b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1041);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("579bcc86", content, true, {});

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"alt":"Easy Tailor App Logo","src":_vm.getTopLogo}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"type":"label"}},[_vm._v("Email Address")]),_vm._v(" "),_c('el-input',{on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.user_name),callback:function ($$v) {_vm.user_name=$$v},expression:"user_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.forgotPassword}},[_vm._v("Submit")]),_vm._v(" "),_c('el-link',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("I Remember My Password")])],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('b',[_vm._v("Please submit your registered email address and submit, we will email you a new password.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterLogin_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49be0e41_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterLogin_vue__ = __webpack_require__(1046);
function injectStyle (ssrContext) {
  __webpack_require__(1044)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MasterLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49be0e41_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MasterLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1045);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("03c858ea", content, true, {});

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"400px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)","padding":"20px","justify-content":"center","align-items":"center"}},[_c('img',{staticStyle:{"width":"150px"},attrs:{"alt":"Easy Tailor App Logo","src":__webpack_require__(96)}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("User Name")]),_vm._v(" "),_c('el-input',{attrs:{"id":"loginId"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.$store.state.master.login.user_name),callback:function ($$v) {_vm.$set(_vm.$store.state.master.login, "user_name", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.master.login.user_name"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"column","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Password")]),_vm._v(" "),_c('el-input',{attrs:{"id":"loginPassword","type":"password","show-password":""},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login.apply(null, arguments)}},model:{value:(_vm.$store.state.master.login.password),callback:function ($$v) {_vm.$set(_vm.$store.state.master.login, "password", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"$store.state.master.login.password"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"space-between","align-items":"space-between"}},[_c('el-button',{attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.login}},[_vm._v("Master Login")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px","display":"flex","flex-direction":"row","width":"80%","justify-content":"flex-start","align-items":"flex-start"}},[_c('el-link',{on:{"click":function($event){return _vm.$router.push('/login')}}},[_vm._v("Go Back")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae82d7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1058);
function injectStyle (ssrContext) {
  __webpack_require__(1048)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fae82d7e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1049);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0f2b5fc4", content, true, {});

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupTask_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42880fbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupTask_vue__ = __webpack_require__(1053);
function injectStyle (ssrContext) {
  __webpack_require__(1051)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupTask_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42880fbe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupTask_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1052);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1dbbc43f", content, true, {});

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.tasks.group_task.length>0)?_c('div',{staticStyle:{"width":"100%","text-align":"right"}},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.submitGroup}},[_vm._v("\n        Submit\n      ")])],1):_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('el-button',{attrs:{"size":"large","type":"primary"},on:{"click":function($event){return _vm.$store.commit('addNewGroupTaskItemRow')}}},[_vm._v("\n        Start Adding Tasks\n      ")])],1),_vm._v(" "),(_vm.$store.state.tasks.group_task.length>0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.state.tasks.group_task}},[_c('el-table-column',{attrs:{"label":"Title"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"id":'task_title_'+scope.row.key,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.title),callback:function ($$v) {_vm.$set(scope.row, "title", $$v)},expression:"scope.row.title"}})]}}],null,false,3264244515)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date/Time","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{attrs:{"type":"datetime","value-format":"yyyy-MM-dd HH:mm:ss","format":"MMM dd yyyy hh:mm a"},model:{value:(scope.row.task_time),callback:function ($$v) {_vm.$set(scope.row, "task_time", $$v)},expression:"scope.row.task_time"}})]}}],null,false,621724900)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Description"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.description),callback:function ($$v) {_vm.$set(scope.row, "description", $$v)},expression:"scope.row.description"}})]}}],null,false,4195621263)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Priority"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(scope.row.priority),callback:function ($$v) {_vm.$set(scope.row, "priority", $$v)},expression:"scope.row.priority"}},[_c('el-option',{attrs:{"label":'Normal',"value":0}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Normal')}})]),_vm._v(" "),_c('el-option',{attrs:{"label":'Medium',"value":1}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Medium')}})]),_vm._v(" "),_c('el-option',{attrs:{"label":'Urgent',"value":2}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Urgent')}})])],1)]}}],null,false,1176214972)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Category"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(scope.row.category_id),callback:function ($$v) {_vm.$set(scope.row, "category_id", $$v)},expression:"scope.row.category_id"}},_vm._l((_vm.$store.getters.getTaskCategoryList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.category_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.category_name)}})])}),1)]}}],null,false,1822551763)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Assigned To"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(scope.row.assigned_to_staff_id),callback:function ($$v) {_vm.$set(scope.row, "assigned_to_staff_id", $$v)},expression:"scope.row.assigned_to_staff_id"}},[_c('el-option',{attrs:{"value":0,"label":"Admin"}},[_c('span',{style:('float: left;'),domProps:{"innerHTML":_vm._s('Admin')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.id === _vm.$store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name,"value":data.id}},[_c('span',{style:('float: left; '+(data.id === _vm.$store.getters.getUserInformation.staff_id ? 'font-weight: bold; color: red;' : '')+''),domProps:{"innerHTML":_vm._s(data.id === _vm.$store.getters.getUserInformation.staff_id ? 'Self' : data.staff_name)}})])})],2)]}}],null,false,1600153903)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[(scope.row.category_id >0 && scope.row.assigned_to_staff_id !== null && scope.row.title.length > 0)?_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.commit('addNewGroupTaskItemRow')}}},[_c('i',{staticClass:"el-icon-circle-plus"})]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeGroupTaskItemRow', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}],null,false,3659820602)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eab2f256_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1057);
function injectStyle (ssrContext) {
  __webpack_require__(1055)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eab2f256_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1056);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("ca65573a", content, true, {});

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(_vm.dataList.length>0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.dataList}},[_c('el-table-column',{attrs:{"prop":"created_at","sortable":"","label":"Assigned On","width":"130"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(_vm.changeDate(scope.row.created_at))+"\n              ")])]}}],null,false,3043467365)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"task_time","sortable":"","label":"Task Date","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(scope.row.task_type === 0 ? _vm.changeDate(scope.row.task_time) : scope.row.task_time_changed)+"\n              ")])]}}],null,false,3476713104)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"revision_count","sortable":"","label":"Revised","width":"170"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[(scope.row.revision_count>0)?_c('span',{staticStyle:{"color":"red","font-size":"11px"}},[_vm._v("\n                  "+_vm._s(scope.row.revision_count)+" times\n                ")]):_vm._e()])]}}],null,false,717022424)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","sortable":"","label":"Title","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(scope.row.title_prefix)+_vm._s(scope.row.title)+"\n              ")])]}}],null,false,2485652661)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"assigned_to_name","sortable":"","label":"Assigned To","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(scope.row.assigned_to_alias_name !== null && scope.row.assigned_to_alias_name.length>0 ? scope.row.assigned_to_alias_name : scope.row.assigned_to_name)+"\n              ")])]}}],null,false,3425113750)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_by_name","sortable":"","label":"Created By","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(scope.row.created_by_alias_name !== null && scope.row.created_by_alias_name.length>0 ? scope.row.created_by_alias_name : scope.row.created_by_name)+"\n              ")])]}}],null,false,390561046)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"priority","sortable":"","label":"Type","align":"center","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.priority === 0 ? 'info' : scope.row.priority === 1 ? 'warning' : scope.row.priority === 2 ? 'danger' : ''}},[_vm._v("\n                "+_vm._s(scope.row.priority === 0 ? 'Normal' : scope.row.priority === 1 ? 'Medium' : scope.row.priority === 2 ? 'Urgent' : '')+"\n              ")])]}}],null,false,3621170054)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","sortable":"","label":"Status","align":"center","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"type":scope.row.status === 0 ? 'info' : scope.row.status === 1 ? 'warning' : scope.row.status === 2 ? 'warning' : scope.row.status === 3 ? 'danger' : 'success'}},[_vm._v("\n                "+_vm._s(scope.row.status === 0 ? 'New' : scope.row.status === 1 ? 'WIP' : scope.row.status === 2 ? 'Completed' : scope.row.status === 3 ? 'Rejected' : 'Accepted')+"\n              ")])]}}],null,false,3725475918)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":(_vm.$store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id) ? 'Edit' : 'View'}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$store.dispatch('fetchTaskData', {id: scope.row.id})}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : (_vm.$store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id) ? 'el-icon-edit' : 'el-icon-view'})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.dispatch('deleteTaskData', {id: scope.row.id})}}},[(_vm.$store.getters.getUserInformation.staff_id === scope.row.created_by_staff_id)?_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])],1)],1)]}}],null,false,3268292769)})],1):_c('el-empty',{attrs:{"description":"No Data"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start","width":"100%"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%","justify-content":"space-between","align-items":"space-between"}},[_c('el-input',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"placeholder":"Search...","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.search_term),callback:function ($$v) {_vm.search_term=$$v},expression:"search_term"}}),_vm._v(" "),_c('div',{staticStyle:{"width":"40%","text-align":"right","margin-top":"17px"}},[_c('el-dropdown',{on:{"command":_vm.openTaskForm}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("\n                          Add Task "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":'single_task'}},[_vm._v("Single Task")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":'group_task'}},[_vm._v("Group Task")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap"}},[_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedCategoryId === -1 ? 'success' : ''},on:{"click":function($event){_vm.selected_category_id = -1}}},[_vm._v("\n                  All Categories ("+_vm._s(_vm.getDataList.length)+")\n              ")]),_vm._v(" "),_vm._l((_vm.$store.getters.getTaskCategoryList),function(data,index){return (_vm.getDataList.filter(function (t) { return t.category_id === data.id; }).length>0)?_c('el-tag',{key:index,staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedCategoryId === data.id ? 'success' : ''},on:{"click":function($event){_vm.selected_category_id = data.id}}},[_vm._v("\n                  "+_vm._s(data.category_name)+" ("+_vm._s(_vm.getDataList.filter(function (t) { return t.category_id === data.id; }).length)+")\n              ")]):_vm._e()})],2),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","margin-top":"20px"}},[_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedPriority === -1 ? 'success' : ''},on:{"click":function($event){_vm.selected_priority = -1}}},[_vm._v("\n                  All Priority ("+_vm._s(_vm.getDataList.length)+")\n              ")]),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.priority === 0; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedPriority === 0 ? 'success' : 'info'},on:{"click":function($event){_vm.selected_priority = 0}}},[_vm._v("\n                  Normal ("+_vm._s(_vm.getDataList.filter(function (t) { return t.priority === 0; }).length)+")\n              ")]):_vm._e(),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.priority === 1; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedPriority === 1 ? 'success' : 'warning'},on:{"click":function($event){_vm.selected_priority = 1}}},[_vm._v("\n                  Medium ("+_vm._s(_vm.getDataList.filter(function (t) { return t.priority === 1; }).length)+")\n              ")]):_vm._e(),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.priority === 2; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedPriority === 2 ? 'success' : 'danger'},on:{"click":function($event){_vm.selected_priority = 2}}},[_vm._v("\n                  Urgent ("+_vm._s(_vm.getDataList.filter(function (t) { return t.priority === 2; }).length)+")\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","margin-top":"20px"}},[_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedStatus === -1 ? 'success' : ''},on:{"click":function($event){_vm.selected_status = -1}}},[_vm._v("\n                  All Status ("+_vm._s(_vm.getDataList.length)+")\n              ")]),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.status === 0; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedStatus === 0 ? 'success' : 'info'},on:{"click":function($event){_vm.selected_status = 0}}},[_vm._v("\n                  New ("+_vm._s(_vm.getDataList.filter(function (t) { return t.status === 0; }).length)+")\n              ")]):_vm._e(),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.status === 1; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedStatus === 1 ? 'success' : 'warning'},on:{"click":function($event){_vm.selected_status = 1}}},[_vm._v("\n                  WIP ("+_vm._s(_vm.getDataList.filter(function (t) { return t.status === 1; }).length)+")\n              ")]):_vm._e(),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.status === 2; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedStatus === 2 ? 'success' : 'danger'},on:{"click":function($event){_vm.selected_status = 2}}},[_vm._v("\n                  Completed ("+_vm._s(_vm.getDataList.filter(function (t) { return t.status === 2; }).length)+")\n              ")]):_vm._e(),_vm._v(" "),(_vm.getDataList.filter(function (t) { return t.status === 3; }).length>0)?_c('el-tag',{staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"type":_vm.getSelectedStatus === 3 ? 'success' : 'danger'},on:{"click":function($event){_vm.selected_status = 3}}},[_vm._v("\n                  Rejected ("+_vm._s(_vm.getDataList.filter(function (t) { return t.status === 3; }).length)+")\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","margin-top":"20px"}},[_c('List',{attrs:{"dataList":_vm.getDisplayList}})],1)]),_vm._v(" "),(_vm.$store.state.tasks.show_task_form)?_c('el-dialog',{attrs:{"fullscreen":_vm.isMobileDevice,"title":_vm.$store.getters.getTaskDataProps.id>0 ? _vm.$store.getters.getTaskDataProps.title : 'New Task',"width":_vm.isMobileDevice ? '100%' : '450px',"visible":_vm.$store.state.tasks.show_task_form,"append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.$store.state.tasks, "show_task_form", $event)}}},[_c('TaskForm',{on:{"closed":_vm.loadList}})],1):_vm._e(),_vm._v(" "),(_vm.$store.state.tasks.show_task_group_form)?_c('el-dialog',{attrs:{"title":'New Group Task',"width":"90%","visible":_vm.$store.state.tasks.show_task_group_form,"append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.$store.state.tasks, "show_task_group_form", $event)}}},[_c('GroupTask',{on:{"closed":_vm.loadList}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1060);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("79fe6504", content, true, {});

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileList_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48820ba8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileList_vue__ = __webpack_require__(1068);
function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48820ba8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1063);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0391f13c", content, true, {});

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementFieldList_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a59ab7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementFieldList_vue__ = __webpack_require__(1067);
function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasurementFieldList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a59ab7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasurementFieldList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("27f050c9", content, true, {});

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-top":"10px"}},[(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('div',{staticStyle:{"margin-right":"20px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Estimated Size")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{attrs:{"disabled":_vm.profile_data.id>0 && !_vm.inline,"size":"small","filterable":""},model:{value:(_vm.profile_data.size_id),callback:function ($$v) {_vm.$set(_vm.profile_data, "size_id", $$v)},expression:"profile_data.size_id"}},_vm._l((_vm.$store.getters.getTailoringSizeList.filter(function (t) { return (t.tailoring_category_id === _vm.item_category_id || t.tailoring_category_id === 0); })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.size_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.size_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('div',{staticStyle:{"margin-right":"20px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Measurement Type")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{attrs:{"disabled":_vm.profile_data.id>0 && !_vm.inline,"size":"small"},model:{value:(_vm.profile_data.measurement_type),callback:function ($$v) {_vm.$set(_vm.profile_data, "measurement_type", $$v)},expression:"profile_data.measurement_type"}},[_c('el-option',{attrs:{"label":'Body',"value":0}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Body')}})]),_vm._v(" "),_c('el-option',{attrs:{"label":'Ready',"value":1}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('Ready')}})])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-right":"20px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Measured By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"disabled":_vm.profile_data.id>0 && !_vm.inline,"size":"small","filterable":""},model:{value:(_vm.profile_data.measured_by_staff_id),callback:function ($$v) {_vm.$set(_vm.profile_data, "measured_by_staff_id", $$v)},expression:"profile_data.measured_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.can_take_measurement; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1),_vm._v(" "),(_vm.inline && _vm.$store.getters.getPreferenceProps.print_tailor_name_on_wo)?_c('div',{staticStyle:{"margin-right":"20px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Tailored By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.profile_data.tailored_by_staff_id),callback:function ($$v) {_vm.$set(_vm.profile_data, "tailored_by_staff_id", $$v)},expression:"profile_data.tailored_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.is_production_member; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Notes/Remarks")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"disabled":_vm.profile_data.id>0 && !_vm.inline,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.profile_data.notes),callback:function ($$v) {_vm.$set(_vm.profile_data, "notes", $$v)},expression:"profile_data.notes"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"border-bottom":"1px solid #e2e2e2"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('div',[_c('br'),_vm._v(" "),(!_vm.$store.state.preferences.props.horizontal_measurement_form)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getMeasurementList}},[_c('el-table-column',{attrs:{"prop":"measurement_name","label":"Measurement Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"measurement_value","label":"Value"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.measurement_value_fixed)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.profile_data.id>0 && !_vm.inline,"size":"small","filterable":""},on:{"blur":function($event){return _vm.addToTrialList(scope.row)},"change":function($event){scope.row.measurement_instruction_image = _vm.data.measurement_instruction_image}},model:{value:(scope.row.measurement_value),callback:function ($$v) {_vm.$set(scope.row, "measurement_value", $$v)},expression:"scope.row.measurement_value"}},_vm._l((scope.row.measurement_drop_down_list),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.measurement_value,"value":data.measurement_value}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.measurement_value)}})])}),1):_c('el-input',{attrs:{"readonly":_vm.profile_data.id>0 && !_vm.inline,"size":"small"},on:{"focus":function($event){return $event.target.select()},"blur":function($event){return _vm.addToTrialList(scope.row)}},model:{value:(scope.row.measurement_value),callback:function ($$v) {_vm.$set(scope.row, "measurement_value", $$v)},expression:"scope.row.measurement_value"}})]}}],null,false,1365429135)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Instructional Image","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('UploadFile',{attrs:{"image_path":scope.row.measurement_instruction_image,"image_width":25,"hide_upload":true}})]}}],null,false,333434367)})],1):_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap"}},_vm._l((_vm.getMeasurementList),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('UploadFile',{attrs:{"image_path":data.measurement_instruction_image,"image_width":25,"hide_upload":true}}),_vm._v(" "),_c('span',[_vm._v("\n                              "+_vm._s(data.measurement_name)+"\n                          ")]),_vm._v(" "),(data.measurement_value_fixed)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"readonly":_vm.profile_data.id>0 && !_vm.inline,"size":"small","filterable":""},on:{"blur":function($event){return _vm.addToTrialList(data)}},model:{value:(data.measurement_value),callback:function ($$v) {_vm.$set(data, "measurement_value", $$v)},expression:"data.measurement_value"}},_vm._l((data.measurement_drop_down_list),function(data1,index1){return _c('el-option',{key:index1+'_option',attrs:{"label":data1.measurement_value,"value":data1.measurement_value}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data1.measurement_value)}})])}),1):_c('el-input',{attrs:{"readonly":_vm.profile_data.id>0 && !_vm.inline,"size":"small"},on:{"focus":function($event){return $event.target.select()},"blur":function($event){return _vm.addToTrialList(data)}},model:{value:(data.measurement_value),callback:function ($$v) {_vm.$set(data, "measurement_value", $$v)},expression:"data.measurement_value"}})],1)])}),0)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.inline)?_c('div',[(_vm.getCustomerTempMeasurementList.profile_list.length === 0)?_c('el-empty',{attrs:{"description":"No Data"}},[_c('el-button',{attrs:{"size":"small"},on:{"click":_vm.addNewMeasurement}},[_vm._v("Add New "+_vm._s(_vm.item_category_name)+" Measurement")])],1):_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"border":"","data":_vm.getCustomerTempMeasurementList.profile_list}},[_c('el-table-column',{attrs:{"prop":"registration_date","label":"Registration Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.id === 0)?_c('el-date-picker',{attrs:{"size":"small","disabled":"","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(scope.row.registration_date),callback:function ($$v) {_vm.$set(scope.row, "registration_date", $$v)},expression:"scope.row.registration_date"}}):_c('div',[_vm._v("\n                          "+_vm._s(scope.row.registration_date_formatted)+"\n                      ")])]}}],null,false,1468241731)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"measurement_field_list","label":"Values","align":"center","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","icon":"el-icon-s-grid"},on:{"click":function($event){return _vm.openMeasurementListPopup(scope.row.key)}}})]}}],null,false,649845050)}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"70"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[((scope.row.id>0 && scope.row.key === 0))?_c('a',{staticStyle:{"cursor":"pointer","font-size":"24px"},on:{"click":function($event){return _vm.$store.commit('addNewCustomerMasterMeasurementProfileListRow', _vm.getCurrentItemCategoryId)}}},[_c('i',{staticClass:"el-icon-circle-plus"})]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.removeList(scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}],null,false,2762117958)})],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.msmt_list_visible,"show-close":false,"append-to-body":"","width":"90%"},on:{"update:visible":function($event){_vm.msmt_list_visible=$event}}},[_c('div',{staticStyle:{"top":"-30px","position":"relative","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('h2',{staticStyle:{"top":"-25px","position":"relative"}},[_vm._v(_vm._s(_vm.item_category_name+' Measurement'))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[(_vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey] !== undefined && _vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey].id === 0)?_c('el-button',{staticStyle:{"width":"100px","height":"30px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.submitMeasurement}},[_vm._v("\n                          Submit\n                      ")]):_vm._e(),_vm._v(" "),_c('el-button',{staticStyle:{"width":"100px","height":"30px"},attrs:{"size":"small","type":"danger"},on:{"click":function($event){_vm.msmt_list_visible = false}}},[_vm._v("\n                          Close\n                      ")])],1)]),_vm._v(" "),_c('div',{staticStyle:{"top":"-50px","position":"relative"}},[(_vm.getMsmtProfileKey>=0 && _vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey] !== undefined)?_c('MeasurementFieldList',{attrs:{"item_category_id":_vm.item_category_id,"profile_data":_vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey],"profile_id":_vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey].id,"measurement_list":_vm.getCustomerTempMeasurementList.profile_list[_vm.getMsmtProfileKey].measurement_field_list}}):_vm._e()],1)])],1)],1):_c('div',[_c('MeasurementFieldList',{attrs:{"inline":_vm.inline,"msmt_form":_vm.msmt_form,"profile_data":_vm.customer_measurement_profile}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1f1fc563", content, true, {});

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","margin-top":"10px","width":"100%"}},[_c('div',{staticStyle:{"margin-top":"10px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Old Weight")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.old_weight),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "old_weight", $$v)},expression:"$store.state.customerMaster.props.old_weight"}},[_c('template',{slot:"append"},[_vm._v("Kg")])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("New Weight")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.new_weight),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "new_weight", $$v)},expression:"$store.state.customerMaster.props.new_weight"}},[_c('template',{slot:"append"},[_vm._v("Kg")])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Height")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"150px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.height),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "height", $$v)},expression:"$store.state.customerMaster.props.height"}},[_c('template',{slot:"append"},[_vm._v("Feets")])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Measured By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.$store.state.customerMaster.props.measurement_master_measured_by_staff_id),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "measurement_master_measured_by_staff_id", $$v)},expression:"$store.state.customerMaster.props.measurement_master_measured_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.can_take_measurement; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1),_vm._v(" "),_vm._l((_vm.getItemList),function(data,index){return _c('div',{key:index,staticStyle:{"margin-top":"10px","margin-left":"10px","text-align":"left"}},[_c('span',{attrs:{"type":"label"}},[_vm._v(_vm._s(data.category_name)+" Size")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100px"},attrs:{"size":"small","filterable":""},model:{value:(data.size_id),callback:function ($$v) {_vm.$set(data, "size_id", $$v)},expression:"data.size_id"}},_vm._l((_vm.$store.getters.getTailoringSizeList.filter(function (t) { return (t.tailoring_category_id === data.category_id || t.tailoring_category_id === 0); })),function(data1,index1){return _c('el-option',{key:index1+'_SIZE',attrs:{"label":data1.size_name,"value":data1.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data1.size_name)}})])}),1)],1)})],2),_vm._v(" "),_c('div',{staticStyle:{"border-bottom":"1px solid #e2e2e2"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getMasterMeasurementSheet}},[_c('el-table-column',{attrs:{"prop":"measurement_name","label":"Measurement Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"measurement_value","label":"Value"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.measurement_value_fixed)?_c('el-select',{staticStyle:{"width":"100%"},attrs:{"size":"small","filterable":""},on:{"change":function($event){scope.row.measurement_instruction_image = _vm.data.measurement_instruction_image}},model:{value:(scope.row.measurement_value),callback:function ($$v) {_vm.$set(scope.row, "measurement_value", $$v)},expression:"scope.row.measurement_value"}},_vm._l((scope.row.measurement_drop_down_list),function(data,index){return (data.measurement_value !== null && data.measurement_value.trim().length > 0)?_c('el-option',{key:index,attrs:{"label":data.measurement_value,"value":data.measurement_value}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.measurement_value)}})]):_vm._e()}),1):_c('el-input',{attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.measurement_value),callback:function ($$v) {_vm.$set(scope.row, "measurement_value", $$v)},expression:"scope.row.measurement_value"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Instructional Image","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('UploadFile',{attrs:{"image_path":scope.row.measurement_instruction_image,"image_width":25,"hide_upload":true}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.item_category_id)?_c('div',{style:({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'space-between',
        flexWrap: 'wrap',
        textAlign: 'left'
      })},[_c('div',{style:({display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexWrap: 'wrap',
        textAlign: 'left', width: '80%'})},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Old Weight")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.old_weight),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "old_weight", $$v)},expression:"$store.state.customerMaster.props.old_weight"}},[_c('template',{slot:"append"},[_vm._v("Kg/Pounds")])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("New Weight")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.new_weight),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "new_weight", $$v)},expression:"$store.state.customerMaster.props.new_weight"}},[_c('template',{slot:"append"},[_vm._v("Kg/Pounds")])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","margin-left":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Height")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.customerMaster.props.height),callback:function ($$v) {_vm.$set(_vm.$store.state.customerMaster.props, "height", $$v)},expression:"$store.state.customerMaster.props.height"}},[_c('template',{slot:"append"},[_vm._v("Feets")])],2)],1)]),_vm._v(" "),_c('div',{staticStyle:{"width":"20%","text-align":"right","margin-top":"20px"}},[(_vm.$store.state.customerMaster.props.id>0)?_c('el-button',{attrs:{"size":"small","type":"primary","loading":_vm.$store.getters.getLoadingState},on:{"click":_vm.loadAllMsmtHistory}},[_vm._v("\n              Load All History\n          ")]):_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})],1)]):_vm._e(),_vm._v(" "),(!_vm.item_category_id)?_c('el-tabs',{staticStyle:{"margin-top":"20px"},attrs:{"tab-position":'left',"type":"border-card"}},_vm._l((_vm.getMeasurementTemplateList),function(data,index){return _c('el-tab-pane',{key:index,attrs:{"label":data.category_name}},[_c('ProfileList',{attrs:{"item_category_id":data.category_id,"item_category_name":data.category_name,"master_measurement_list":data.measurement_list}})],1)}),1):_c('div',[_c('ProfileList',{attrs:{"msmt_form":_vm.msmt_form,"item_category_id":_vm.item_category_id,"inline":true,"customer_measurement_profile":_vm.customer_measurement_profile}})],1),_vm._v(" "),(!_vm.item_category_id)?_c('div',{staticStyle:{"height":"0px"}},[_vm._v("\n      "+_vm._s(_vm.getTempMeasurementProfile)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1074);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7e976c36", content, true, {});

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1076);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("49a32c04", content, true, {});

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFabricQty_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa744f80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFabricQty_vue__ = __webpack_require__(1080);
function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFabricQty_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa744f80_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFabricQty_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1079);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("070fb628", content, true, {});

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"-40px"}},[_c('h2',[_vm._v("Edit Fabric Qty For "+_vm._s(_vm.rowData.tailoring_detail.template_name))])]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.rowData.tailoring_detail.is_combination_item === 1)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_vm._l((_vm.getCombinationItems),function(data,index){return _c('div',{key:index,style:('display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; margin-left: '+(index>0 ? '20px;' : '')+'')},[_c('span',{staticClass:"label"},[_vm._v("\n                  "+_vm._s(data.tailoring_item_name)+"\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"id":'fabric_field_'+index+'_'+(_vm.rowData.sl_no),"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.closeWindow.apply(null, arguments)}},model:{value:(data.fabric_unit_qty),callback:function ($$v) {_vm.$set(data, "fabric_unit_qty", $$v)},expression:"data.fabric_unit_qty"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.rowData.fabric_detail.unit_name))])],2)],1)}),_vm._v(" "),_c('el-button',{staticStyle:{"width":"70px","height":"30px","margin-top":"20px","margin-left":"20px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.closeWindow}},[_vm._v("\n              Ok\n          ")])],2):_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('div',{style:('display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;')},[_c('span',{staticClass:"label"},[_vm._v("\n                  Fabric Qty\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"id":'fabric_field_0_'+(_vm.rowData.sl_no),"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.closeNormal.apply(null, arguments)}},model:{value:(_vm.rowData.fabric_unit_qty),callback:function ($$v) {_vm.$set(_vm.rowData, "fabric_unit_qty", $$v)},expression:"rowData.fabric_unit_qty"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.rowData.fabric_detail.unit_name))])],2)],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"70px","height":"30px","margin-top":"20px","margin-left":"20px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.closeNormal}},[_vm._v("\n              Ok\n          ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPrice_vue__ = __webpack_require__(253);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdfd1eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPrice_vue__ = __webpack_require__(1084);
function injectStyle (ssrContext) {
  __webpack_require__(1082)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditPrice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdfd1eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditPrice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3d51047a", content, true, {});

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"-40px"}},[_c('h2',[_vm._v("Price Break-Up: "+_vm._s(_vm.rowData.tailoring_detail !== null && _vm.rowData.tailoring_item_id.id>0 ? _vm.rowData.tailoring_detail.template_name : _vm.rowData.retail_detail !== null ? (_vm.rowData.retail_detail.sku_code+', '+_vm.rowData.retail_detail.article_name) : ''))])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{style:('border-top: 1px solid #e2e2e2; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;')},[(_vm.rowData.tailoring_item_id>0)?_c('div',{staticStyle:{"padding-bottom":"5px","margin-top":"20px","border-bottom":"1px solid #e2e2e2","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"20%","text-align":"left"}},[_vm._v("\n                          Stitching:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"left"}},[_c('el-input',{staticStyle:{"width":"85%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.tailoring_unit_rate),callback:function ($$v) {_vm.$set(_vm.rowData, "tailoring_unit_rate", $$v)},expression:"rowData.tailoring_unit_rate"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.getCurrencyFormat.currency_symbol))])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                           x "+_vm._s(_vm.rowData.tailoring_qty)+" qty = "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.tailoring_unit_rate)*_vm.rowData.tailoring_qty))+" "),_c('a',{staticStyle:{"color":"red","font-size":"10px","text-decoration":"underline"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.show_tailoring_discount = true}}},[_vm._v("- "+_vm._s(_vm.formatCurrency(_vm.rowData.tailoring_unit_discount_amount)))]),_vm._v(" "),(_vm.show_tailoring_discount)?_c('el-input',{staticStyle:{"width":"85%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.override_sales_discount,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.tailoring_detail.discount_percent),callback:function ($$v) {_vm.$set(_vm.rowData.tailoring_detail, "discount_percent", $$v)},expression:"rowData.tailoring_detail.discount_percent"}},[_c('template',{slot:"append"},[_vm._v("%")])],2):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.rowData.tailoring_item_id>0 && parseFloat(_vm.rowData.extra_charge_unit_rate)>0)?_c('div',{staticStyle:{"padding-bottom":"5px","border-bottom":"1px solid #e2e2e2","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"20%","text-align":"left"}},[_vm._v("\n                          Extras:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"center"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.extra_charge_unit_rate)))+" x "+_vm._s(_vm.rowData.tailoring_qty)+" qty\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.extra_charge_unit_rate)*_vm.rowData.tailoring_qty))+" "),(_vm.rowData.extra_charge_unit_discount_amount>0)?_c('span',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("- "+_vm._s(_vm.formatCurrency(_vm.rowData.extra_charge_unit_discount_amount)))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.rowData.tailoring_item_id>0 && _vm.rowData.fabric_id>0)?_c('div',{staticStyle:{"padding-bottom":"5px","border-bottom":"1px solid #e2e2e2","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"20%","text-align":"left"}},[_vm._v("\n                          Fabric:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"left"}},[_c('el-input',{staticStyle:{"width":"85%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (_vm.rowData.tailoring_detail.fabric_sales_price_remains_flat === 1 
                                  || _vm.rowData.fabric_detail.stitching_rate_flat 
                                      || (_vm.rowData.fabric_detail.fabric_price_category_id !== null && _vm.rowData.fabric_detail.fabric_price_category_id>0)),"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.fabric_unit_rate),callback:function ($$v) {_vm.$set(_vm.rowData, "fabric_unit_rate", $$v)},expression:"rowData.fabric_unit_rate"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.getCurrencyFormat.currency_symbol))])],2)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                          "+_vm._s(_vm.rowData.tailoring_qty)+" x "+_vm._s(_vm.rowData.fabric_unit_qty)+" "+_vm._s(_vm.rowData.fabric_detail.unit_name)+" = "+_vm._s(_vm.formatCurrency((parseFloat(_vm.rowData.fabric_unit_qty)*parseFloat(_vm.rowData.fabric_unit_rate)*_vm.rowData.tailoring_qty)))+" \n                          "),_c('a',{staticStyle:{"color":"red","font-size":"10px","text-decoration":"underline"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.show_fabric_discount = true}}},[_vm._v("- "+_vm._s(_vm.formatCurrency((_vm.rowData.fabric_unit_discount_amount*parseFloat(_vm.rowData.fabric_unit_qty))*_vm.rowData.tailoring_qty)))]),_vm._v(" "),(_vm.show_fabric_discount)?_c('el-input',{staticStyle:{"width":"85%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.override_sales_discount,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.fabric_detail.discount_percent),callback:function ($$v) {_vm.$set(_vm.rowData.fabric_detail, "discount_percent", $$v)},expression:"rowData.fabric_detail.discount_percent"}},[_c('template',{slot:"append"},[_vm._v("%")])],2):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.rowData.retail_item_id>0)?_c('div',{staticStyle:{"padding-bottom":"5px","margin-top":"20px","border-bottom":"1px solid #e2e2e2","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"20%","text-align":"left"}},[_vm._v("\n                          Unit Rate:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"center"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.retail_unit_rate)))+" x "+_vm._s(_vm.rowData.retail_qty)+" "+_vm._s(_vm.rowData.retail_detail.unit_name)+"\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.retail_unit_rate)*_vm.rowData.retail_qty))+" "),(_vm.rowData.retail_unit_discount_amount>0)?_c('span',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("- "+_vm._s(_vm.formatCurrency(_vm.rowData.retail_unit_discount_amount)))]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.rowData.tailoring_item_id>0 && _vm.rowData.fabric_id>0)?_c('div',{staticStyle:{"padding-bottom":"5px","margin-top":"20px","border-bottom":"1px solid #e2e2e2","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_vm._v("\n                          Sub-Total:\n                      ")]),_vm._v(" "),(_vm.rowData.tailoring_item_id>0)?_c('div',{staticStyle:{"width":"45%","text-align":"center"}},[_vm._v("\n                          "+_vm._s(parseFloat(_vm.rowData.tailoring_qty))+" qty\n                      ")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(parseFloat(_vm.rowData.taxable_total)+parseFloat(_vm.rowData.discount_amount)))+" "),(_vm.rowData.discount_amount>0)?_c('span',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("- "+_vm._s(_vm.formatCurrency(_vm.rowData.discount_amount)))]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_vm._v("\n                          Extra Charges:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"type":"number","min":0,"size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.extra_amount),callback:function ($$v) {_vm.$set(_vm.rowData, "extra_amount", $$v)},expression:"rowData.extra_amount"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.getCurrencyFormat.currency_symbol))])],2)],1)]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5px","margin-top":"10px","border-bottom":"1px solid #e2e2e2","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_vm._v("\n                          Reason:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.extra_amount_reason),callback:function ($$v) {_vm.$set(_vm.rowData, "extra_amount_reason", $$v)},expression:"rowData.extra_amount_reason"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left","top":"5px","position":"relative"}},[_vm._v("\n                          Discount:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.override_sales_discount || _vm.$store.getters.getSaleMasterDataProps.discount_coupon_id>0,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.discount_percent),callback:function ($$v) {_vm.$set(_vm.rowData, "discount_percent", $$v)},expression:"rowData.discount_percent"}},[_c('template',{slot:"append"},[_vm._v("%")])],2)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px","margin-bottom":"15px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left","top":"5px","position":"relative"}},[_vm._v("\n                          Discount:\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"75%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"60%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.override_sales_discount || _vm.$store.getters.getSaleMasterDataProps.discount_coupon_id>0,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.discount_amount),callback:function ($$v) {_vm.$set(_vm.rowData, "discount_amount", $$v)},expression:"rowData.discount_amount"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.getCurrencyFormat.currency_symbol))])],2)],1)]),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5px","border-bottom":"1px solid #e2e2e2","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_c('b',[_vm._v(_vm._s(_vm.$store.getters.getSaleMasterDataProps.tax_id>0 ? 'Taxable ' : 'Sub-')+"Total: ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"45%","text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[(!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total)?_c('b',[_vm._v(_vm._s(_vm.formatCurrency((parseFloat(_vm.rowData.taxable_total)))))]):_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"precision":2,"id":'taxable_total_'+_vm.rowData.sl_no,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editNetTotal(1)}},model:{value:(_vm.rowData.taxable_total),callback:function ($$v) {_vm.$set(_vm.rowData, "taxable_total", $$v)},expression:"rowData.taxable_total"}},[_c('el-button',{staticStyle:{"top":"-1px","position":"relative"},attrs:{"slot":"append","disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"size":"small"},on:{"click":function($event){return _vm.editNetTotal(1)}},slot:"append"},[_vm._v("OK")])],1)],1)]),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.tax_id>0)?_c('div',{staticStyle:{"padding-bottom":"5px","border-bottom":"1px solid #e2e2e2","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_vm._v("\n                          "+_vm._s(_vm.$store.getters.isIndiaTax ? 'GST (%)' : _vm.$store.getters.getSaleMasterDataProps.tax_detail.tax_name+' (%)')+":\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"45%","text-align":"center"}},[_vm._v("\n                          "+_vm._s(_vm.rowData.tax_percent)+"%\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency((parseFloat(_vm.rowData.tax_amount))))+"\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"padding-bottom":"5px","border-bottom":"1px solid #e2e2e2","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"25%","text-align":"left"}},[_c('b',[_vm._v("Net Total ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+"):")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"45%","text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"35%","text-align":"right"}},[_c('b',[_vm._v(_vm._s(_vm.formatCurrency((parseFloat(_vm.rowData.net_total)))))])])]),_vm._v(" "),(_vm.getBillingCurrency.length>0)?_c('div',{staticStyle:{"padding-top":"5px","border-bottom":"1px solid #e2e2e2","padding-bottom":"10px","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"45%","text-align":"left","top":"5px","position":"relative"}},[_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v("Override Net Total: ("+_vm._s(_vm.getBillingCurrency[0].currency_short)+")")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"5%","text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"id":'alter_net_total_'+_vm.rowData.sl_no,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editNetTotal.apply(null, arguments)}},model:{value:(_vm.rowData.alter_net_total),callback:function ($$v) {_vm.$set(_vm.rowData, "alter_net_total", $$v)},expression:"rowData.alter_net_total"}},[_c('el-button',{staticStyle:{"top":"-1px","position":"relative"},attrs:{"slot":"append","disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"size":"small"},on:{"click":_vm.editNetTotal},slot:"append"},[_vm._v("OK")])],1)],1)]):_c('div',{staticStyle:{"padding-top":"5px","border-bottom":"1px solid #e2e2e2","padding-bottom":"10px","margin-top":"5px","width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"45%","text-align":"left","top":"5px","position":"relative"}},[_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v("Override Net Total: ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")")])]),_vm._v(" "),_c('div',{staticStyle:{"width":"5%","text-align":"center"}},[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('div',{staticStyle:{"width":"50%","text-align":"right"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"id":'alter_net_total_'+_vm.rowData.sl_no,"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.editNetTotal.apply(null, arguments)}},model:{value:(_vm.rowData.alter_net_total),callback:function ($$v) {_vm.$set(_vm.rowData, "alter_net_total", $$v)},expression:"rowData.alter_net_total"}},[_c('el-button',{staticStyle:{"top":"-1px","position":"relative"},attrs:{"slot":"append","disabled":!_vm.$store.getters.getUserGroupAlerts.alter_net_sale_total || (
                                  (_vm.rowData.tailoring_detail !==null && _vm.rowData.tailoring_detail.discount_percent !== undefined && _vm.rowData.tailoring_detail.discount_percent>0) 
                                  || (_vm.rowData.fabric_detail !==null && _vm.rowData.fabric_detail.discount_percent !== undefined && _vm.rowData.fabric_detail.discount_percent>0) 
                                      || (_vm.rowData.retail_detail !==null && _vm.rowData.retail_detail.discount_percent !== undefined && _vm.rowData.retail_detail.discount_percent>0)),"size":"small"},on:{"click":_vm.editNetTotal},slot:"append"},[_vm._v("OK")])],1)],1)])])]),_vm._v(" "),_c('el-button',{staticStyle:{"width":"70px","height":"30px","margin-top":"20px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.$emit('closed')}}},[_vm._v("\n              Cancel\n          ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseRequest_vue__ = __webpack_require__(254);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a733f01c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseRequest_vue__ = __webpack_require__(1088);
function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PurchaseRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a733f01c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PurchaseRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1087);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("f426c6f4", content, true, {});

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.rowData.tailoring_item_id>0)?_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"-40px"}},[_c('h2',[_vm._v("Material Purchase Request")]),_vm._v(" "),_c('span',[_vm._v("\n              For "+_vm._s(_vm.rowData.tailoring_detail.template_name)+"\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n              Fabric#: "+_vm._s(_vm.rowData.fabric_detail.sku_code)+", "+_vm._s(_vm.rowData.fabric_detail.article_name)+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.rowData.retail_item_id>0)?_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"-40px"}},[_c('h2',[_vm._v("Material Purchase Request")]),_vm._v(" "),_c('span',[_vm._v("\n              Item#: "+_vm._s(_vm.rowData.retail_detail.sku_code)+", "+_vm._s(_vm.rowData.retail_detail.article_name)+"\n          ")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{style:('display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;')},[_c('span',{staticClass:"label"},[_vm._v("\n                  Material Qty\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"readonly":_vm.rowData.purchase_request_id>0,"id":'material_qty',"type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.changeFocus('material_description')}},model:{value:(_vm.rowData.purchase_request_qty),callback:function ($$v) {_vm.$set(_vm.rowData, "purchase_request_qty", $$v)},expression:"rowData.purchase_request_qty"}},[_c('template',{slot:"append"},[_vm._v(_vm._s(_vm.rowData.tailoring_item_id >0 ? _vm.rowData.fabric_detail.unit_name : _vm.rowData.retail_detail.unit_name))])],2)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{style:('display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;')},[_c('span',{staticClass:"label"},[_vm._v("\n                  Description\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"readonly":_vm.rowData.purchase_request_id>0,"id":"material_description","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.$emit('closed')}},model:{value:(_vm.rowData.purchase_request_description),callback:function ($$v) {_vm.$set(_vm.rowData, "purchase_request_description", $$v)},expression:"rowData.purchase_request_description"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"width":"70px","height":"30px","margin-top":"20px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.$emit('closed')}}},[_vm._v("\n              Ok\n          ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1090);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5d0a6e17", content, true, {});

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wrapper_vue__ = __webpack_require__(256);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b87d57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wrapper_vue__ = __webpack_require__(1157);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b87d57_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1093);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("32b0a9d0", content, true, {});

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__ = __webpack_require__(257);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc91f6f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__ = __webpack_require__(1097);
function injectStyle (ssrContext) {
  __webpack_require__(1095)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_History_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bc91f6f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_History_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1096);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3cb6f1e8", content, true, {});

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.workOrderData.work_order_history}},[_c('el-table-column',{attrs:{"prop":"sale_date_changed","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"template_name","label":"Garment Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.template_name)+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"appointment_date_changed","label":"Promise Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"appointment_type","label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.appointment_type === 0 ? 'Delivery' : 'Trial')+"\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":'Download'}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.downloadWorkOrder(scope.row.id)}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-download'})])])],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromiseDetail_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0241f297_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromiseDetail_vue__ = __webpack_require__(1101);
function injectStyle (ssrContext) {
  __webpack_require__(1099)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PromiseDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0241f297_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PromiseDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1100);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("44d4abe8", content, true, {});

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left'
      })},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Customer's Next Visit/Pickup Date?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.workOrderData.appointment_date),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_date", $$v)},expression:"workOrderData.appointment_date"}})],1),_vm._v(" "),_c('el-checkbox',{staticStyle:{"margin-top":"10px","color":"red"},model:{value:(_vm.workOrderData.priority_order),callback:function ($$v) {_vm.$set(_vm.workOrderData, "priority_order", $$v)},expression:"workOrderData.priority_order"}},[_vm._v("Priority Order?")]),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Visit Is For?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-radio',{attrs:{"label":0},on:{"change":_vm.toggleProcessList},model:{value:(_vm.workOrderData.appointment_type),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_type", $$v)},expression:"workOrderData.appointment_type"}},[_vm._v("Delivery")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1},on:{"change":_vm.toggleProcessList},model:{value:(_vm.workOrderData.appointment_type),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_type", $$v)},expression:"workOrderData.appointment_type"}},[_vm._v("Trial")])],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.getTailoringTrialTypeList.length>0 && _vm.workOrderData.appointment_type === 1)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Trial Type")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"size":"small"},model:{value:(_vm.workOrderData.trial_type_id),callback:function ($$v) {_vm.$set(_vm.workOrderData, "trial_type_id", $$v)},expression:"workOrderData.trial_type_id"}},_vm._l((_vm.$store.getters.getTailoringTrialTypeList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.trial_type,"value":data.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("\n                              "+_vm._s(data.trial_type)+"\n                          ")])])}),1)],1):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("To Be Tailored By?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(_vm.workOrderData.customer_measurement_profile.measured_by_staff_id),callback:function ($$v) {_vm.$set(_vm.workOrderData.customer_measurement_profile, "measured_by_staff_id", $$v)},expression:"workOrderData.customer_measurement_profile.measured_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.can_take_measurement; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Special Instructions?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"textarea","rows":"2"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.workOrderData.special_instruction),callback:function ($$v) {_vm.$set(_vm.workOrderData, "special_instruction", $$v)},expression:"workOrderData.special_instruction"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Additional Item Details (If Any)")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.workOrderData.item_details),callback:function ($$v) {_vm.$set(_vm.workOrderData, "item_details", $$v)},expression:"workOrderData.item_details"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Placement Rack No.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.workOrderData.placement_rack_number),callback:function ($$v) {_vm.$set(_vm.workOrderData, "placement_rack_number", $$v)},expression:"workOrderData.placement_rack_number"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Remarks")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"400px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.workOrderData.internal_remarks),callback:function ($$v) {_vm.$set(_vm.workOrderData, "internal_remarks", $$v)},expression:"workOrderData.internal_remarks"}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessList_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364ae969_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessList_vue__ = __webpack_require__(1105);
function injectStyle (ssrContext) {
  __webpack_require__(1103)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-364ae969"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProcessList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_364ae969_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProcessList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1104);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("5d634f76", content, true, {});

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".selectImg[data-v-364ae969]{width:150px;height:150px}", ""]);

// exports


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.process_list}},[_c('el-table-column',{attrs:{"prop":"process_name","label":"Process Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n        "+_vm._s(scope.row.process_name)+" "+_vm._s(scope.row.extra_charge>0 ? '@ '+_vm.formatCurrency(parseFloat(scope.row.extra_charge)) : '')+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"option_list","label":"Options"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.option_list.length>0)?[_c('el-select',{staticStyle:{"width":"200px"},attrs:{"disabled":!scope.row.is_required,"size":"small","filterable":""},model:{value:(scope.row.process_option_id),callback:function ($$v) {_vm.$set(scope.row, "process_option_id", $$v)},expression:"scope.row.process_option_id"}},_vm._l((scope.row.option_list),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.option_name,"value":data.id}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","height":"200px !important"}},[_c('img',{staticClass:"selectImg",staticStyle:{"margin":"5px","height":"200px !important"},attrs:{"src":data.image}}),_vm._v(" "),_c('span',{staticStyle:{"margin":"5px"}},[_vm._v(_vm._s(data.option_name)+" @ "+_vm._s(_vm.formatCurrency(parseFloat(data.extra_charge))))])])])}),1)]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"additional_notes","label":"Remarks"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"disabled":!scope.row.is_required || scope.row.hidden_process >= 0,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.additional_notes),callback:function ($$v) {_vm.$set(scope.row, "additional_notes", $$v)},expression:"scope.row.additional_notes"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Add as Add-On?","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{attrs:{"disabled":!scope.row.add_on_process_eligible},on:{"change":_vm.disableOtherAddOns},model:{value:(scope.row.add_on_process),callback:function ($$v) {_vm.$set(scope.row, "add_on_process", $$v)},expression:"scope.row.add_on_process"}},[_vm._v("\n          Yes\n        ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Sub-Processes","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return _vm._l((scope.row.sub_process_list),function(sub_process){return _c('el-checkbox',{key:sub_process.id,model:{value:(sub_process.is_required),callback:function ($$v) {_vm.$set(sub_process, "is_required", $$v)},expression:"sub_process.is_required"}},[_vm._v("\n          "+_vm._s(sub_process.process_name)+"\n        ")])})}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_required","label":"Required?","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-checkbox',{attrs:{"disabled":scope.row.hidden_process >= 0},model:{value:(scope.row.is_required),callback:function ($$v) {_vm.$set(scope.row, "is_required", $$v)},expression:"scope.row.is_required"}},[_vm._v("\n          Yes\n        ")])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1107);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2251da9e", content, true, {});

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleListOption_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528d2612_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleListOption_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleListOption_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_528d2612_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleListOption_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1110);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0a794b17", content, true, {});

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.style_list[_vm.parentKey].option_list}},[_c('el-table-column',{attrs:{"prop":"option_name","label":"Instructions"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!scope.row.is_editable)?_c('span',[_vm._v("\n                      "+_vm._s(scope.row.option_name)+"\n                  ")]):_c('el-input',{attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.edited_option),callback:function ($$v) {_vm.$set(scope.row, "edited_option", $$v)},expression:"scope.row.edited_option"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"charges","label":"Charges"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.charge_extra)?_c('div',[(scope.row.charge_type <2)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[(scope.row.charge_type === 1)?_c('el-input',{staticStyle:{"width":"80px"},attrs:{"placeholder":"quantity","size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.qty),callback:function ($$v) {_vm.$set(scope.row, "qty", $$v)},expression:"scope.row.qty"}}):_vm._e(),_vm._v(" "),(scope.row.charge_type === 1)?_c('span',{staticStyle:{"margin-left":"5px","margin-right":"5px","margin-top":"5px"}},[_vm._v("\n                          x\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.charge_type <2)?_c('span',{staticStyle:{"margin-top":"5px"}},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(scope.row.charges))+"\n                      ")]):_vm._e()],1):(scope.row.charge_type === 2)?_c('el-select',{attrs:{"filterable":""},model:{value:(scope.row.charges),callback:function ($$v) {_vm.$set(scope.row, "charges", $$v)},expression:"scope.row.charges"}},_vm._l((parseInt(scope.row.charge_range[1])),function(index){return (index>=parseInt(scope.row.charge_range[0]))?_c('el-option',{key:index,attrs:{"value":index,"label":index}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(index))])]):_vm._e()}),1):_c('el-input',{staticStyle:{"width":"150px"},attrs:{"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.charges),callback:function ($$v) {_vm.$set(scope.row, "charges", $$v)},expression:"scope.row.charges"}})],1):_vm._e()]}}])}),_vm._v(" "),(_vm.style_list[_vm.parentKey].option_list.filter(function (t) { return t.picture_path !== null && t.picture_path.length > 0; }).length > 0)?_c('el-table-column',{attrs:{"prop":"picture_path","label":"Sample Image","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('img',{attrs:{"src":scope.row.picture_path,"width":"100px"}})]}}],null,false,3754806975)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [((!scope.row.charge_extra 
                          || (scope.row.charge_extra 
                                  && (_vm.$store.getters.getSaleMasterDataProps.sale_status === 0 
                                  || _vm.checkIfModuleAccessAvailable('/salesorders', 'can_edit', false)))))?_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.selectOption(scope.row)}}},[_vm._v("\n                          Ok\n                      ")])],1):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[(!_vm.$store.state.preferences.props.horizontal_style_sheet)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getStyleList}},[_c('el-table-column',{attrs:{"prop":"style_name","label":"Styling Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Instructions","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.edited_option.length>0)?_c('span',[_vm._v("\n                  "+_vm._s(scope.row.edited_option)+"\n                ")]):_c('span',[_vm._v("\n                  "+_vm._s(scope.row.option_detail.option_name)+"\n                ")])]}}],null,false,3853272152)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Charges","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v("\n                  "+_vm._s(scope.row.extra_charge>0 ? _vm.formatCurrency(parseFloat(scope.row.extra_charge)*parseFloat(scope.row.qty))+' For '+scope.row.extra_charge_notes : '-')+"\n                ")])]}}],null,false,1005077131)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Options","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-button',{attrs:{"size":"small","icon":"el-icon-s-grid"},on:{"click":function($event){return _vm.openOptionPopup(scope.row.key)}}})]}}],null,false,1607497393)})],1):_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","width":"100%"}},_vm._l((_vm.getStyleList),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","width":"200px"}},[_c('span',[_c('b',[_vm._v(_vm._s(data.style_name))])]),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(data.option_detail.option_name)+"\n                          ")]),_vm._v(" "),_c('span',[_vm._v("\n                            "+_vm._s(data.extra_charge>0 ? _vm.formatCurrency(parseFloat(data.extra_charge)*parseFloat(data.qty))+' For '+data.extra_charge_notes : '-')+"\n                          ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","icon":"el-icon-s-grid"},on:{"click":function($event){return _vm.openOptionPopup(data.key)}}})],1)])}),0),_vm._v(" "),_c('el-dialog',{staticStyle:{"text-align":"left"},attrs:{"title":_vm.getOptionWindowTitle,"visible":_vm.showOptionWindow,"width":"70%","append-to-body":""},on:{"update:visible":function($event){_vm.showOptionWindow=$event}}},[_c('StyleListOption',{attrs:{"parentKey":_vm.getParentKey,"style_list":_vm.getStyleList},on:{"close":function($event){_vm.showOptionWindow=false}}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){_vm.showOptionWindow = false}}},[_vm._v("Close")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ffca19c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__ = __webpack_require__(1116);
function injectStyle (ssrContext) {
  __webpack_require__(1114)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImageList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ffca19c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImageList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1115);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d6b2a1b4", content, true, {});

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start","flex-wrap":"wrap"}},_vm._l((_vm.image_list),function(data,index){return _c('div',{key:index,staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","margin":"20px"}},[_c('div',{staticStyle:{"width":"200px","height":"200px"}},[_c('UploadFile',{attrs:{"image_path":data,"image_width":200,"file_dialog_id":'work_order_photo_'+index,"hide_upload":data.length>5,"button_style":'width: 100px; top: 5px; position: relative;'},on:{"uploaded":function($event){return _vm.addNewImage(index, $event)}}})],1),_vm._v(" "),(data.length>5)?_c('el-button',{staticStyle:{"top":"5px","position":"relative"},attrs:{"size":"small","type":"danger"},on:{"click":function($event){return _vm.removeImage(index)}}},[_vm._v("\n              Remove\n          ")]):_vm._e()],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrialWindow_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5c13a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrialWindow_vue__ = __webpack_require__(1120);
function injectStyle (ssrContext) {
  __webpack_require__(1118)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrialWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c5c13a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrialWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1119);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("df309a50", content, true, {});

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.workOrderData.trial_form.take_trial)?_c('el-tabs',{attrs:{"type":"border-card","tab-position":"left"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"Trial Window","name":"1"}},[_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.trialTab),callback:function ($$v) {_vm.trialTab=$$v},expression:"trialTab"}},[_c('el-tab-pane',{attrs:{"label":"Basic","name":"1"}},[_c('div',{staticStyle:{"width":"100%","diplay":"flex","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"text-align":"left","display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Trial Date")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.workOrderData.trial_form.trial_done_date),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "trial_done_date", $$v)},expression:"workOrderData.trial_form.trial_done_date"}})],1),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"label"},[_vm._v("Trial Taken By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"size":"small","filterable":"","placeholder":"Select"},model:{value:(_vm.workOrderData.trial_form.trial_taken_by_staff_id),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "trial_taken_by_staff_id", $$v)},expression:"workOrderData.trial_form.trial_taken_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.can_assist_trial; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"label"},[_vm._v("Trial Assisted By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"size":"small","filterable":"","placeholder":"Select"},model:{value:(_vm.workOrderData.trial_form.trial_assisted_by_staff_id),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "trial_assisted_by_staff_id", $$v)},expression:"workOrderData.trial_form.trial_assisted_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.can_assist_trial; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Trial Notes")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('vue-editor',{staticStyle:{"height":"250px","width":"400px"},attrs:{"editor-toolbar":_vm.customToolbar},model:{value:(_vm.workOrderData.trial_form.trial_notes),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "trial_notes", $$v)},expression:"workOrderData.trial_form.trial_notes"}})],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"70px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Customer's Next Visit Date?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"400px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.workOrderData.appointment_date),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_date", $$v)},expression:"workOrderData.appointment_date"}})],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Visit Is For?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-radio',{attrs:{"label":0},on:{"change":_vm.toggleProcessList},model:{value:(_vm.workOrderData.appointment_type),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_type", $$v)},expression:"workOrderData.appointment_type"}},[_vm._v("Delivery")]),_vm._v(" "),_c('el-radio',{attrs:{"label":1},on:{"change":_vm.toggleProcessList},model:{value:(_vm.workOrderData.appointment_type),callback:function ($$v) {_vm.$set(_vm.workOrderData, "appointment_type", $$v)},expression:"workOrderData.appointment_type"}},[_vm._v("Re-Trial")])],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.appointment_type === 1)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Trial Type")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"size":"small"},model:{value:(_vm.workOrderData.trial_type_id),callback:function ($$v) {_vm.$set(_vm.workOrderData, "trial_type_id", $$v)},expression:"workOrderData.trial_type_id"}},_vm._l((_vm.$store.getters.getTailoringTrialTypeList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.trial_type,"value":data.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("\n                                                      "+_vm._s(data.trial_type)+"\n                                                  ")])])}),1)],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.trial_form.take_trial)?_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Next Process?")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-select',{staticStyle:{"width":"400px"},attrs:{"size":"small","filterable":"","placeholder":"Select"},model:{value:(_vm.workOrderData.trial_form.next_process_id),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "next_process_id", $$v)},expression:"workOrderData.trial_form.next_process_id"}},_vm._l((_vm.workOrderData.process_list.filter(function (t) { return ((t.is_required && t.hidden_process === -1) || t.hidden_process === 2); })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.process_name,"value":data.process_id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.process_name)}})])}),1)],1):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start","flex-wrap":"wrap"}},_vm._l((_vm.workOrderData.trial_form.trial_image_list),function(data,index){return _c('div',{key:index,staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","margin":"20px"}},[_c('div',{staticStyle:{"width":"200px","height":"200px"}},[_c('UploadFile',{attrs:{"image_path":data,"image_width":200,"file_dialog_id":'work_order_photo_trial_'+index,"hide_upload":data.length>5,"button_style":'width: 100px; top: 5px; position: relative;'},on:{"uploaded":function($event){return _vm.addNewImage(index, $event)}}})],1),_vm._v(" "),(data.length>5)?_c('el-button',{staticStyle:{"top":"5px","position":"relative"},attrs:{"size":"small","type":"danger"},on:{"click":function($event){return _vm.removeImage(index)}}},[_vm._v("\n                                          Remove\n                                      ")]):_vm._e()],1)}),0)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Measurements","name":"2"}},[_c('MeasurementForm',{attrs:{"trial_form":true,"msmt_form":_vm.workOrderData.trial_form.measurement_changes,"item_category_id":_vm.workOrderData.category_id,"customer_measurement_profile":_vm.workOrderData.customer_measurement_profile}})],1)],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"disabled":_vm.workOrderData.trial_history.length === 0,"label":"Trial History","name":"2"}},[_c('div',{style:('width: 100%; text-align: left; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start;')},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.workOrderData.trial_history}},[_c('el-table-column',{attrs:{"prop":"trial_done_date_changed","label":"Date"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trial_taken_by","label":"Trial Taken By"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trial_assisted_by","label":"Trial Assisted By"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px"},on:{"click":function($event){return _vm.printTrial(scope.row.id)}}},[_c('i',{class:'el-icon-printer'})])]}}],null,false,392531576)})],1)],1)])],1):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyItems_vue__ = __webpack_require__(265);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_247585aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyItems_vue__ = __webpack_require__(1124);
function injectStyle (ssrContext) {
  __webpack_require__(1122)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CopyItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_247585aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CopyItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1123);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("532a2236", content, true, {});

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getSaleItemList.length>0)?_c('div',[_vm._m(0),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_vm._l((_vm.getSaleItemList),function(data,index){return _c('div',{key:index,staticStyle:{"display":"flex","flex-direction":"column","margin-bottom":"10px"}},[(data.sale_item_id > 0)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-checkbox',{attrs:{"checked":data.selected},on:{"change":function($event){return _vm.selectData(data)}}},[_c('span',{staticStyle:{"margin-left":"10px"}},[_vm._v("\n                      "+_vm._s(data.sl_no+1)+". "+_vm._s(data.tailoring_detail !== undefined ? data.tailoring_detail.template_name : data.template_name)+"                            \n                  ")]),_vm._v(" "),(!data.single_item && data.work_order_id === 0)?_c('span',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("\n                  Please copy the other item from this work-order group to avoid ERROR\n              ")]):_vm._e()])],1):_vm._e()])})],2):_c('div',[_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("Copy this work-order and paste them into the below order items:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('b',[_vm._v("No Items To Copy!!!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerPhotos_vue__ = __webpack_require__(266);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0395b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerPhotos_vue__ = __webpack_require__(1128);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerPhotos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b0395b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerPhotos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1127);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7f83fa33", content, true, {});

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start","flex-wrap":"wrap"}},_vm._l((_vm.image_list),function(data,index){return _c('div',{key:index,staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","margin":"20px"}},[_c('div',{staticStyle:{"width":"200px","height":"200px"}},[_c('UploadFile',{attrs:{"image_path":data.photo_path,"image_width":200,"file_dialog_id":'customer_profile_order_photo_'+index,"hide_upload":true,"button_style":'width: 100px; top: 5px; position: relative;'}})],1)])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayWOLoad_vue__ = __webpack_require__(267);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2926d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayWOLoad_vue__ = __webpack_require__(1132);
function injectStyle (ssrContext) {
  __webpack_require__(1130)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayWOLoad_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c2926d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayWOLoad_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1131);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3a38c99c", content, true, {});

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":_vm.fetchWorkOrderLoad}},[_vm._v("\n        Get Work-Order Load\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex: flex-direction: column","margin-top":"20px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.workOrderData.work_order_load,"default-sort":{prop: 'appointment_date', order: 'ascending'}}},[_c('el-table-column',{attrs:{"prop":"appointment_date","label":"Promise Date","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.appointment_date_changed)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"delivery","label":"Deliveries","align":"center","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.delivery)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"trial","label":"Trials","align":"center","sortable":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.trial)+"\n                ")])]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomStyle_vue__ = __webpack_require__(268);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c394cb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomStyle_vue__ = __webpack_require__(1136);
function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66c394cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomStyle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c394cb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomStyle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("594550e4", content, true, {});

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("\n        "+_vm._s(_vm.customer_style_sheet.style_name)+"\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","width":"100%"}},_vm._l((_vm.customer_style_sheet.style_options.filter(function (t) { return t.is_default; })),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"10px","border":"1px solid #e2e2e2","padding":"20px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","width":"200px"}},[_c('span',[_c('b',[_vm._v(_vm._s(data.master_style_name))])]),_vm._v(" "),_c('span',[_vm._v("\n                        "+_vm._s(data.option_name)+"\n                    ")]),_vm._v(" "),(data.fabric_choices !== null)?_c('span',[(data.fabric_choices.filter(function (t) { return t.selected; }).length>0)?_c('span',[_vm._v("\n                            Fabric: "+_vm._s(data.fabric_choices.filter(function (t) { return t.selected; })[0].sku_code)+", "+_vm._s(data.fabric_choices.filter(function (t) { return t.selected; })[0].article_name)+"\n                        ")]):_vm._e()]):_vm._e()])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1138);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6ff7ec16", content, true, {});

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1140);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("39d47162", content, true, {});

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1142);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("4ae59e40", content, true, {});

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.read_only)?_c('div',{staticStyle:{"width":"100%","text-align":"right","margin-bottom":"10px"}},[(_vm.getQCChart.filter(function (t) { return t.status === 2; }).length>0)?_c('el-button',{attrs:{"size":"small","type":'danger',"disabled":_vm.getQCChart.filter(function (t) { return t.status === 0; }).length > 0},on:{"click":function($event){return _vm.processQC('reject')}}},[_vm._v("\n              Reject\n          ")]):_c('el-button',{attrs:{"size":"small","type":'success',"disabled":_vm.getQCChart.filter(function (t) { return t.status === 0; }).length > 0},on:{"click":function($event){return _vm.processQC('accept')}}},[_vm._v("\n              Accept\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.getQCChart !== null)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getQCChart}},[_c('el-table-column',{attrs:{"prop":"quality_point","label":"Check-Point"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                  "+_vm._s(scope.row.quality_point)+"\n              ")]}}],null,false,367558691)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-radio',{attrs:{"disabled":_vm.read_only,"label":1},model:{value:(scope.row.status),callback:function ($$v) {_vm.$set(scope.row, "status", $$v)},expression:"scope.row.status"}},[_vm._v("\n                      Ok\n                  ")]),_vm._v(" "),_c('el-radio',{attrs:{"disabled":_vm.read_only,"label":2},model:{value:(scope.row.status),callback:function ($$v) {_vm.$set(scope.row, "status", $$v)},expression:"scope.row.status"}},[_vm._v("\n                      Reject\n                  ")])]}}],null,false,2523291384)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"comment","label":"Comment"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.read_only,"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.comment),callback:function ($$v) {_vm.$set(scope.row, "comment", (typeof $$v === 'string'? $$v.trim(): $$v))},expression:"scope.row.comment"}})]}}],null,false,1752309474)})],1):_vm._e(),_vm._v(" "),(!_vm.read_only)?_c('div',{staticStyle:{"width":"100%","text-align":"right","margin-top":"20px"}},[(_vm.getQCChart.filter(function (t) { return t.status === 2; }).length>0)?_c('el-button',{attrs:{"size":"small","type":'danger',"disabled":_vm.getQCChart.filter(function (t) { return t.status === 0; }).length > 0},on:{"click":function($event){return _vm.processQC('reject')}}},[_vm._v("\n              Reject\n          ")]):_c('el-button',{attrs:{"size":"small","type":'success',"disabled":_vm.getQCChart.filter(function (t) { return t.status === 0; }).length > 0},on:{"click":function($event){return _vm.processQC('accept')}}},[_vm._v("\n              Accept\n          ")])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.getters.getLoadingState),expression:"$store.getters.getLoadingState"}],staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","align-items":"space-between","width":"100%"}},[_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.state.production.assignment_history
                      .filter(function (t) { return t.hidden_process === -1 && _vm.$store.state.production.assignment_history.filter(function (t1) { return t1.main_work_log_id === t.id; }).length === 0; })}},[_c('el-table-column',{attrs:{"label":"Staff"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                      "+_vm._s(scope.row.worker_id === 0 ? '-NA-' : scope.row.staff_name)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Process"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(scope.row.process_name)+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s((scope.row.work_status === 0 ? 'Waiting' 
                          : scope.row.work_status === 1 ? 'Assigned' 
                              : scope.row.work_status === 2 ? 'Approval Pending' 
                                  : scope.row.work_status === 3 ? 'Work Rejected' : 'Work Accepted'))+"\n                      ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Started At","width":_vm.$store.getters.getPreferenceProps.enable_work_order_assignment_date_change ? 230 : ''},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status>0)?[(_vm.$store.getters.getPreferenceProps.enable_work_order_assignment_date_change && scope.row.main_work_log_id === 0)?_c('el-date-picker',{attrs:{"type":'datetime',"value-format":'yyyy-MM-dd HH:mm:ss',"format":'MMM dd yyyy hh:mm a'},model:{value:(scope.row.started_at_changed_time),callback:function ($$v) {_vm.$set(scope.row, "started_at_changed_time", $$v)},expression:"scope.row.started_at_changed_time"}}):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(scope.row.started_at_changed_time)+"                            \n                      ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Finished At","width":_vm.$store.getters.getPreferenceProps.enable_work_order_assignment_date_change ? 230 : ''},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status>1)?[(!_vm.$store.getters.getPreferenceProps.enable_work_order_assignment_date_change && scope.row.main_work_log_id === 0)?_c('el-date-picker',{attrs:{"type":'datetime',"value-format":'yyyy-MM-dd HH:mm:ss',"format":'MMM dd yyyy hh:mm a'},model:{value:(scope.row.finished_at_changed_time),callback:function ($$v) {_vm.$set(scope.row, "finished_at_changed_time", $$v)},expression:"scope.row.finished_at_changed_time"}}):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(scope.row.finished_at_changed_time)+"                      \n                      ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t12.default_piece_rate","label":"Piece Rate","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status === 4)?[_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(scope.row.default_piece_rate))+"\n                      ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t12.extra_payment","label":"Adjustment","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status === 4)?[(scope.row.work_status>1 && scope.row.work_status !== 3 && scope.row.payroll_id === 0 && scope.row.main_work_log_id === 0)?_c('el-input',{staticStyle:{"text-align":"center","width":"100px"},attrs:{"size":"small","type":"number","disabled":!_vm.$store.getters.getUserInformation.is_a_production_supervisor},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.extra_payment),callback:function ($$v) {_vm.$set(scope.row, "extra_payment", $$v)},expression:"scope.row.extra_payment"}}):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(scope.row.extra_payment))+"\n                      ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t12.total_piece_rate","label":"Net Piece Rate","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status === 4)?[_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(_vm.formatCurrency(scope.row.total_piece_rate = parseFloat(scope.row.default_piece_rate) + parseFloat(scope.row.extra_payment)))+"\n                      ")])]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t12.remarks","label":"Remarks","align":"left","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.work_status >=1)?[(scope.row.work_status>1 && scope.row.payroll_id === 0 && scope.row.main_work_log_id === 0)?_c('el-input',{staticStyle:{"width":"100%"},attrs:{"size":"small","disabled":!_vm.$store.getters.getUserInformation.is_a_production_supervisor},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.remarks),callback:function ($$v) {_vm.$set(scope.row, "remarks", $$v)},expression:"scope.row.remarks"}}):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                          "+_vm._s(scope.row.remarks)+"\n                      ")])]:undefined}}],null,true)}),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.sale_form_reduced && _vm.$store.getters.getUserInformation.is_a_production_supervisor && _vm.checkIfModuleAccessAvailable('/productionworkorders', 'can_edit'))?_c('el-table-column',{attrs:{"label":"","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.work_status >=1 && scope.row.main_work_log_id === 0)?_c('el-dropdown',{on:{"command":_vm.handleRowDropdownCommand}},[_c('a',[_c('i',{staticClass:"el-icon-setting el-icon--right"}),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[(scope.row.qc_chart !== null && scope.row.qc_chart.length > 0 && scope.row.work_status >1)?_c('el-dropdown-item',{attrs:{"command":{command: 'qcSheet', rowData: scope.row}}},[_vm._v("QC Sheet")]):_vm._e(),_vm._v(" "),(scope.row.work_status === 4)?_c('el-dropdown-item',{attrs:{"command":{command: 'update', rowData: scope.row}}},[_vm._v("Update")]):_vm._e(),_vm._v(" "),(scope.row.work_status === 4)?_c('el-dropdown-item',{attrs:{"command":{command: 'restart', rowData: scope.row}}},[_vm._v("Restart Process")]):_vm._e(),_vm._v(" "),(scope.row.work_status === 1)?_c('el-dropdown-item',{attrs:{"command":{command: 'assignWO', rowData: scope.row}}},[_vm._v("Mark Finished")]):_vm._e()],1)],1):_vm._e()]}}],null,false,3993294790)}):_vm._e()],1)],1)]),_vm._v(" "),(_vm.show_qc_window)?_c('el-dialog',{attrs:{"title":'QC Sheet',"width":"70%","visible":_vm.show_qc_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_qc_window=$event}}},[_c('QCWindow',{attrs:{"row_data":_vm.getRowData,"read_only":true},on:{"closed":function($event){_vm.show_qc_window = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1146);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7afdfd8c", content, true, {});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b8830_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__ = __webpack_require__(1150);
function injectStyle (ssrContext) {
  __webpack_require__(1148)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e7b8830"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e7b8830_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1d134c2d", content, true, {});

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        textAlign: 'left'
      })},[_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(0),_vm._v(" "),_c('div',[_c('el-input',{staticStyle:{"width":"250px"},attrs:{"disabled":"","placeholder":"Auto-Generated","type":"number","size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.productionItemIssue.props.challan_number),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "challan_number", $$v)},expression:"$store.state.productionItemIssue.props.challan_number"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(1),_vm._v(" "),_c('div',[_c('el-select',{staticStyle:{"text-align":"left","width":"250px","margin-top":"0px"},attrs:{"default-first-option":"","placeholder":"order# or work-order number","remote":"","remote-method":_vm.searchWorkOrderAutoComplete,"size":"small","loading":_vm.$store.getters.getLoadingState,"filterable":""},on:{"change":_vm.loadSearchedItem},model:{value:(_vm.$store.state.productionItemIssue.props.work_order_number),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "work_order_number", $$v)},expression:"$store.state.productionItemIssue.props.work_order_number"}},_vm._l((_vm.$store.getters.getProductionWorkOrderAutocompleteList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.work_order_number,"value":data}},[_c('div',[_c('span',{staticStyle:{"float":"left"}},[_vm._v("\n                                  "+_vm._s(data.work_order_number)+"\n                              ")])])])}),1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(2),_vm._v(" "),_c('div',[_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"id":"store_id","size":"small","filterable":""},model:{value:(_vm.$store.state.productionItemIssue.props.store_id),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "store_id", $$v)},expression:"$store.state.productionItemIssue.props.store_id"}},_vm._l((_vm.$store.getters.getAccessibleStoreList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.store_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.store_name)}})])}),1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(3),_vm._v(" "),_c('div',[_c('el-date-picker',{staticStyle:{"width":"250px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.productionItemIssue.props.issue_date),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "issue_date", $$v)},expression:"$store.state.productionItemIssue.props.issue_date"}})],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(4),_vm._v(" "),_c('div',[_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"id":"sourced_by_staff_id","size":"small","filterable":""},model:{value:(_vm.$store.state.productionItemIssue.props.issued_to_staff_id),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "issued_to_staff_id", $$v)},expression:"$store.state.productionItemIssue.props.issued_to_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (t) { return t.active && t.is_production_member; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(5),_vm._v(" "),_c('div',[_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"id":"delivered_by_staff_id","size":"small","filterable":""},model:{value:(_vm.$store.state.productionItemIssue.props.issued_by_staff_id),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "issued_by_staff_id", $$v)},expression:"$store.state.productionItemIssue.props.issued_by_staff_id"}},_vm._l((_vm.$store.getters.getEmployeeMasterList.filter(function (element) { return element.active; })),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)],1)]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._m(6),_vm._v(" "),_c('div',[_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.productionItemIssue.props.notes),callback:function ($$v) {_vm.$set(_vm.$store.state.productionItemIssue.props, "notes", $$v)},expression:"$store.state.productionItemIssue.props.notes"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Reciept #")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Work-Order#")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("From Store")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Date Of Issue")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Issued To Employee")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Issued By Employee")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"175px","top":"5px","position":"relative"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Notes")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemList_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682e6cae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemList_vue__ = __webpack_require__(1154);
function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_682e6cae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1153);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("c2b17dd2", content, true, {});

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"margin-top":"10px","text-align":"left"}},[_c('h2',[_vm._v("Item List")]),_vm._v(" "),_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.$store.state.productionItemIssue.props.item_list}},[_c('el-table-column',{attrs:{"prop":"inventory_item_id","label":"SKU#","width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.item_edit === 0)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('el-select',{staticStyle:{"text-align":"left","width":"80%"},attrs:{"disabled":_vm.$store.getters.getProductionItemIssueDataProps.status > 0,"placeholder":"search or scan","id":'inventory_item_id_'+scope.row.key,"remote":"","remote-method":_vm.searchSKUCode,"size":"small","default-first-option":"","loading":_vm.getLoading,"filterable":""},on:{"change":function($event){return _vm.loadProductDetails(scope.row.key)}},model:{value:(scope.row.inventory_item_id),callback:function ($$v) {_vm.$set(scope.row, "inventory_item_id", $$v)},expression:"scope.row.inventory_item_id"}},_vm._l((_vm.$store.getters.getInventoryMasterAutocompleteList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.sku_code,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.sku_code+' ('+data.article_name+')')}}),_vm._v(" "),(data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0)?_c('span',{staticStyle:{"float":"right"}},[_c('b',{style:('color: '+(data.closing_stock<0 ? 'red' : 'green'))},[_vm._v(_vm._s(data.closing_stock)+" "+_vm._s(data.unit_name))])]):_vm._e()])}),1),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openQRScanner(scope.row.key)}}},[_c('img',{staticStyle:{"top":"3px","position":"relative"},attrs:{"src":"https://etacdn.b-cdn.net/qr-scan.png","width":"25px"}})]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add new inventory item"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px","top":"5px","left":"0px","position":"relative"},on:{"click":function($event){return _vm.checkIfInventoryAddAccessGiven(scope.row.key)}}},[_c('i',{staticClass:"el-icon-circle-plus"})])])],1):_c('div',[_vm._v("\n                  "+_vm._s(scope.row.item_detail.sku_code)+", "+_vm._s(scope.row.item_detail.article_name)+"  \n                  \n                      "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px","margin-left":"10px"},on:{"click":function($event){return _vm.disableEdit(scope.row.key)}}},[_c('sup',[_c('i',{staticClass:"el-icon-error"})])])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"qty","label":'QTY',"align":"center","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"100px","text-align":"center"},attrs:{"disabled":_vm.$store.getters.getProductionItemIssueDataProps.status > 0,"id":'qty_'+scope.row.key,"size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addRow(scope.row.key)}},model:{value:(scope.row.qty),callback:function ($$v) {_vm.$set(scope.row, "qty", $$v)},expression:"scope.row.qty"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"notes","label":'Remarks'},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.notes),callback:function ($$v) {_vm.$set(scope.row, "notes", $$v)},expression:"scope.row.notes"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.addRow(scope.row.key)}}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.commit('removeProductionItemIssueItemListRow', scope.row.key)}}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})])])],1)],1)]}}])})],1)],1)]),_vm._v(" "),(_vm.show_qr_window)?_c('el-dialog',{attrs:{"width":"70%","visible":_vm.show_qr_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_qr_window=$event}}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"closed":function($event){_vm.show_qr_window = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[((_vm.$store.getters.getProductionItemIssueDataProps.id>0 
              && _vm.checkIfModuleAccessAvailable('/issuerawmaterials', 'can_edit')) 
                  || (_vm.$store.getters.getProductionItemIssueDataProps.id === 0 
                      && _vm.$store.getters.getAccessRights.can_add))?_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"loading":_vm.$store.getters.getLoadingState,"type":"primary","size":"small"},on:{"click":_vm.submit}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.dispatch('deleteProductionItemIssueData', {id: _vm.$store.state.productionItemIssue.props.id, navBack: true, store_list: _vm.$store.getters.getAccessibleStoreList})}}},[(_vm.$store.getters.getProductionItemIssueDataProps.id>0 && _vm.$store.getters.getProductionItemIssueDataProps.status === 0 && _vm.$store.getters.getAccessRights.can_delete)?_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"slot":"reference","type":"danger","size":"small"},slot:"reference"},[_vm._v("Delete")]):_vm._e()],1),_vm._v(" "),(_vm.rowData)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.$emit('closed')}}},[_vm._v("Go Back")]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isPrintWindowVisible)?_c('PrintWindow',{attrs:{"title":_vm.getPrintTitle,"src":_vm.getPrintSrc,"dialogVisible":_vm.isPrintWindowVisible},on:{"closePrintWindow":function($event){_vm.showPrintWindow = false}}}):_vm._e(),_vm._v(" "),_c('Basic',{attrs:{"rowData":_vm.rowData}}),_vm._v(" "),(_vm.$store.getters.getProductionItemIssueDataProps.production_id>0 && _vm.$store.getters.getProductionItemIssueDataProps.store_id>0)?_c('ItemList'):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"font-size":"12px"}},[(!_vm.quickView)?_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"0px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('h2',[_vm._v("Production List")])]):_vm._e(),_vm._v(" "),(_vm.$store.getters.getProductionWorkOrderAutocompleteList.length>0)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-input',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"placeholder":"Search...","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.search_term),callback:function ($$v) {_vm.search_term=$$v},expression:"search_term"}}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"default-sort":{prop: 'order_sl_no', order: 'ascending'},"data":_vm.$store.getters.getProductionWorkOrderAutocompleteList
              .filter(function (t) { return (t.work_order_number !== null && t.work_order_number.toLowerCase().match(_vm.search_term.toLowerCase())) || (t.process_name !== null && t.process_name.toLowerCase().match(_vm.search_term.toLowerCase())); })}},[_c('el-table-column',{attrs:{"prop":"work_order_number","label":"Work-Order#"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Promise","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('span',[_vm._v("\n                  "+_vm._s(scope.row.appointment_date_changed)+" "+_vm._s(scope.row.appointment_type === 0 ? '(D)' : '(T)')+"\n                  "),(scope.row.trial_name.length>0)?_c('span',[_c('br'),_vm._v(_vm._s(scope.row.trial_name)+"\n                  ")]):_vm._e()])])]}}],null,false,257813351)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Garment"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.sub_sub_category_id !== null ? scope.row.sub_template_name+' ('+scope.row.template_name+')' : scope.row.template_name)+"\n          ")]}}],null,false,4031361401)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fabric","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('span',[_vm._v("\n                  "+_vm._s(scope.row.sku_code)+", "+_vm._s(scope.row.article_name)+"\n                  ")])])]}}],null,false,1957938856)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Current Location"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.locality_name)+"\n          ")]}}],null,false,2077964108)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Measured By"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.measurement_by_staff_name)+"\n          ")]}}],null,false,3644782642)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"process_name","label":"Current Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{on:{"click":function($event){return _vm.loadProductionWorkHistory(scope.row)}}},[_vm._v("\n                  "+_vm._s(scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : ''))+"\n              ")])]}}],null,false,3331714096)}),_vm._v(" "),(!_vm.calendar_source)?_c('el-table-column',{attrs:{"label":"Labour Paid?","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.payroll_id !== null && scope.row.payroll_id >0)?_c('div',[_c('span',[_vm._v("\n                      Yes (#"+_vm._s(scope.row.payroll_number)+")\n                  ")])]):_vm._e()]}}],null,false,1080033253)}):_vm._e(),_vm._v(" "),(!_vm.calendar_source)?_c('el-table-column',{attrs:{"label":"Delivered?","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.production_id !== null)?_c('div',[_c('span',[_vm._v("\n                      Yes\n                  ")])]):_vm._e()]}}],null,false,4043655292)}):_vm._e(),_vm._v(" "),(!_vm.calendar_source)?_c('el-table-column',{attrs:{"label":"Delivery#","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.production_id !== null)?_c('div',[_c('span',[_vm._v("\n                      #: "+_vm._s(scope.row.challan_number)+"\n                  ")])]):_vm._e()]}}],null,false,2380852958)}):_vm._e(),_vm._v(" "),(!_vm.calendar_source)?_c('el-table-column',{attrs:{"label":"Delivery Date","align":"right"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.production_id !== null)?_c('div',[_c('span',[_vm._v("\n                      "+_vm._s(scope.row.challan_date_changed_time)+"\n                  ")])]):_vm._e()]}}],null,false,4095601319)}):_vm._e(),_vm._v(" "),(!_vm.allow_delivery && !_vm.quickView)?_c('el-table-column',{attrs:{"label":"Put On Hold?","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!scope.row.production_id !== null)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[_c('el-checkbox',{model:{value:(scope.row.on_hold),callback:function ($$v) {_vm.$set(scope.row, "on_hold", $$v)},expression:"scope.row.on_hold"}},[_vm._v("\n                      YES\n                  ")]),_vm._v(" "),(scope.row.on_hold)?_c('el-input',{staticStyle:{"width":"200px","margin-left":"5px"},attrs:{"size":"small","placeholder":"Remarks..."},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.on_hold_remarks),callback:function ($$v) {_vm.$set(scope.row, "on_hold_remarks", $$v)},expression:"scope.row.on_hold_remarks"}}):_vm._e()],1):_vm._e()]}}],null,false,706089581)}):(!_vm.payroll && !_vm.calendar_source)?_c('el-table-column',{attrs:{"fixed":"right","label":"Convert To Inventory","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[(!scope.row.inventory_converted)?_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.convertToInventory(scope.row)}}},[_vm._v("\n                      Convert\n                  ")]):_vm._e(),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.issueRawMaterials(scope.row)}}},[_vm._v("\n                      Issue Materials\n                  ")])],1)]}}],null,false,1442303808)}):_vm._e()],1)],1):_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_vm._v("\n          No Data\n      ")]),_vm._v(" "),(!_vm.allow_delivery && !_vm.quickView)?_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-top":"20px","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[(!_vm.allow_delivery)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.confirmOnHold}},[_vm._v("Hold/Un-Hold Items")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.show_assignment_history)?_c('el-dialog',{attrs:{"title":_vm.getProductionTitle,"fullscreen":"","visible":_vm.show_assignment_history,"append-to-body":""},on:{"update:visible":function($event){_vm.show_assignment_history=$event}}},[_c('WorkOrderAssignmentHistory',{attrs:{"production_id":_vm.getSelectedProductionId},on:{"closed":function($event){_vm.show_assignment_history = false}}})],1):_vm._e(),_vm._v(" "),(_vm.show_item_issue_window)?_c('el-dialog',{attrs:{"fullscreen":"","title":_vm.getProductionTitle,"visible":_vm.show_item_issue_window,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.show_item_issue_window=$event}}},[_c('ProductionItemIssue',{attrs:{"rowData":_vm.getSelectedRowData},on:{"closed":function($event){_vm.show_item_issue_window = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"width":"100%","text-align":"left"}},[(_vm.workOrderData.sale_number !== null)?_c('h1',[_vm._v("Order#: "+_vm._s(_vm.workOrderData.sale_number))]):_vm._e(),_vm._v(" "),_c('el-tabs',{on:{"tab-click":_vm.tabIsClicked},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(_vm.workOrderData.id === 0 && _vm.workOrderData.work_order_history.length>0 && !_vm.$store.getters.getPreferenceProps.sale_form_reduced)?_c('el-tab-pane',{attrs:{"label":'Import From Past',"name":"0"}},[_c('History',{attrs:{"wo_index":_vm.wo_index,"workOrderData":_vm.workOrderData},on:{"swapTab":function($event){_vm.activeTab='1'}}})],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":'Promise Details',"name":"1"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row"}},[_c('div',{staticStyle:{"width":"60%"}},[_c('PromiseDetail',{attrs:{"wo_confirmed":_vm.wo_confirmed,"workOrderData":_vm.workOrderData}})],1),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.work_order_planner_not_required)?_c('div',{staticStyle:{"margin-left":"2%","width":"38%"}},[_c('DisplayWOLoad',{attrs:{"workOrderData":_vm.workOrderData}})],1):_vm._e()])]),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('el-tab-pane',{attrs:{"label":'Measurements',"name":"2"}},[_c('MeasurementForm',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.workOrderData.measurement_loading),expression:"workOrderData.measurement_loading"}],attrs:{"item_category_id":_vm.workOrderData.category_id,"customer_measurement_profile":_vm.workOrderData.customer_measurement_profile}})],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":'Style Choices',"name":"3"}},[(_vm.workOrderData.custom_style_sheet !== null && _vm.workOrderData.custom_style_sheet.id)?_c('div',[_c('CustomStyle',{attrs:{"customer_style_sheet":_vm.workOrderData.custom_style_sheet}})],1):(_vm.workOrderData.style_list.filter(function (t) { return t.material; }).length>0)?_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.activeTab_1),callback:function ($$v) {_vm.activeTab_1=$$v},expression:"activeTab_1"}},[_c('el-tab-pane',{attrs:{"label":'Regular Styles',"name":"1"}},[_c('StyleList',{attrs:{"workOrderData":_vm.workOrderData,"style_list":_vm.workOrderData.style_list.filter(function (t) { return !t.material; })}})],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":'Accessories',"name":"2"}},[_c('StyleList',{attrs:{"style_list":_vm.workOrderData.style_list.filter(function (t) { return t.material; })}})],1)],1):_c('StyleList',{attrs:{"style_list":_vm.workOrderData.style_list}})],1),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.work_order_production_stage_tab_not_required)?_c('el-tab-pane',{attrs:{"label":'Production Stages',"name":"4"}},[_c('ProcessList',{attrs:{"process_list":_vm.workOrderData.process_list}})],1):_vm._e(),_vm._v(" "),(_vm.workOrderData.id>0 && !_vm.shortcut && _vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('el-tab-pane',{attrs:{"disabled":_vm.workOrderData.current_process === -1,"label":'Trial Window',"name":"5"}},[_c('div',{staticStyle:{"text-align":"left"}},[_c('el-checkbox',{attrs:{"size":"small","disabled":!_vm.workOrderData.all_work_orders_in_store},on:{"change":function($event){return _vm.$store.dispatch('lazyLoadWorkOrderSections', {workOrderData: _vm.workOrderData, activeTab: '4'})}},model:{value:(_vm.workOrderData.trial_form.take_trial),callback:function ($$v) {_vm.$set(_vm.workOrderData.trial_form, "take_trial", $$v)},expression:"workOrderData.trial_form.take_trial"}},[_vm._v("\n                      Open Trial Window\n                  ")]),_vm._v(" "),(!_vm.workOrderData.all_work_orders_in_store)?_c('span',{staticStyle:{"color":"red"}},[_c('br'),_vm._v("\n                      Some of the work-orders are not in store yet!!!\n                  ")]):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('TrialWindow',{attrs:{"workOrderData":_vm.workOrderData},on:{"printTrial":_vm.printTrial}})],1):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.work_order_sketch_board_not_required)?_c('el-tab-pane',{attrs:{"label":'Sketch Board',"name":"6"}},[_c('Whiteboard',{attrs:{"sale_item_index":_vm.sale_item_index,"workOrderData":_vm.workOrderData}})],1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":'Images',"name":"7"}},[_c('ImageList',{attrs:{"image_list":_vm.workOrderData.image_list}})],1),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('el-tab-pane',{attrs:{"label":'Profile Images',"name":"8"}},[_c('CustomerPhotos',{attrs:{"image_list":_vm.workOrderData.customer_profile_images}})],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.getPreferenceProps.customer_measurement_required)?_c('el-tab-pane',{attrs:{"label":'Copy WOs',"name":"9"}},[_c('CopyItems',{attrs:{"sale_item_index":_vm.sale_item_index,"workOrderData":_vm.workOrderData}})],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.getWorkOrderDataProps.length>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start","width":"100%"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","width":"100%"}},[_c('div',[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[(_vm.$store.getters.getWorkOrderDataProps[0].id>0 && (_vm.popup || _vm.$store.getters.getWorkOrderDataProps.length === 1))?_c('el-dropdown',{on:{"command":_vm.handleDropdownCommand}},[_c('el-button',{staticStyle:{"margin-right":"20px"},attrs:{"size":"small"}},[_vm._v("\n                  Print/Hold "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":{command: 'printWO', data: _vm.$store.getters.getWorkOrderDataProps[0]},"disabled":!_vm.isWOConfirmed}},[_vm._v("Print Work-Order")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":{command: 'printWOQR', data: _vm.$store.getters.getWorkOrderDataProps[0]},"disabled":!_vm.isWOConfirmed}},[_vm._v("Print QR Tags")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""}}),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":{command: 'viewProductionStatus', data: _vm.$store.getters.getWorkOrderDataProps[0]},"disabled":!_vm.isWOConfirmed}},[_vm._v("View/Hold Production")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.work_order_planner_not_required)?_c('el-button',{attrs:{"size":"small","type":"warning"},on:{"click":function($event){_vm.show_calendar=true}}},[_vm._v("\n            Calendar\n          ")]):_vm._e(),_vm._v(" "),(((_vm.$store.getters.getWorkOrderDataProps[0].id>0
                    && _vm.checkIfModuleAccessAvailable('/manageworkorders', 'can_edit')) 
                        || (_vm.$store.getters.getWorkOrderDataProps[0].id === 0 
                            && _vm.checkIfModuleAccessAvailable('/manageworkorders', 'can_add'))) 
                              && !_vm.shortcut)?_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.submitWorkOrder(1)}}},[((_vm.getSaleItemList !== undefined && _vm.getSaleItemList.id>0) || _vm.$store.getters.getWorkOrderDataProps[0].id>0)?_c('span',[_vm._v("\n                Submit To Production\n              ")]):_c('span',[_vm._v("\n                Save As Draft\n              ")])]):_vm._e(),_vm._v(" "),_c('el-popconfirm',{attrs:{"title":"Are you sure to go back?"},on:{"confirm":_vm.goBack}},[(_vm.popup)?_c('el-button',{attrs:{"slot":"reference","size":"small"},slot:"reference"},[_vm._v("Go Back")]):_vm._e()],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"100vh"}},[(_vm.$store.getters.getWorkOrderDataProps.length === 1)?_c('Wrapper',{attrs:{"wo_index":0,"wo_confirmed":_vm.wo_confirmed,"sale_item_index":_vm.sale_item_index,"workOrderData":_vm.$store.getters.getWorkOrderDataProps[0]},on:{"printTrial":_vm.printTrial}}):_c('el-tabs',{attrs:{"type":"border-card"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.$store.getters.getWorkOrderDataProps),function(data,index){return _c('el-tab-pane',{key:index,attrs:{"name":'tab-'+index+'',"label":data.tailoring_item_name}},[(!_vm.popup && data.id>0)?_c('div',{staticStyle:{"text-align":"right"}},[_c('el-dropdown',{on:{"command":_vm.handleDropdownCommand}},[_c('el-button',{staticStyle:{"margin-right":"20px"},attrs:{"size":"small"}},[_vm._v("\n                          Print/Hold "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":{command: 'printWO', data: data},"disabled":!_vm.isWOConfirmed}},[_vm._v("Print Work-Order")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":{command: 'printWOQR', data: data},"disabled":!_vm.isWOConfirmed}},[_vm._v("Print QR Tags")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""}}),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":{command: 'viewProductionStatus', data: data},"disabled":!_vm.isWOConfirmed}},[_vm._v("View/Hold Production")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('Wrapper',{attrs:{"wo_index":index,"shortcut":_vm.shortcut,"sale_item_index":_vm.sale_item_index,"wo_confirmed":_vm.wo_confirmed,"workOrderData":data},on:{"printTrial":_vm.printTrial}})],1)}),1)],1)]),_vm._v(" "),(_vm.isPrintWindowVisible)?_c('PrintWindow',{attrs:{"title":_vm.getPrintTitle,"src":_vm.getPrintSrc,"dialogVisible":_vm.isPrintWindowVisible},on:{"closePrintWindow":function($event){_vm.showPrintWindow = false}}}):_vm._e(),_vm._v(" "),(_vm.showProductionList)?_c('el-dialog',{attrs:{"width":'95%',"visible":_vm.showProductionList,"append-to-body":""},on:{"update:visible":function($event){_vm.showProductionList=$event}}},[_c('ProductionList',{attrs:{"sale_item_id":_vm.getSaleItemId},on:{"closed":function($event){_vm.showProductionList = false}}})],1):_vm._e(),_vm._v(" "),(_vm.show_calendar)?_c('el-dialog',{attrs:{"title":'Calendar',"width":"80%","visible":_vm.show_calendar,"append-to-body":""},on:{"update:visible":function($event){_vm.show_calendar=$event}}},[_c('TaskCalendar',{attrs:{"production_view":true}})],1):_vm._e()],1):_c('div',[_c('el-container',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(true),expression:"true",modifiers:{"fullscreen":true,"lock":true}}],staticStyle:{"height":"100vh"}},[_vm._v(">\n    "),_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FabricChange_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8b90fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FabricChange_vue__ = __webpack_require__(1162);
function injectStyle (ssrContext) {
  __webpack_require__(1160)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FabricChange_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be8b90fa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FabricChange_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1161);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("ad2cd762", content, true, {});

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({
    marginTop: '-40px',
    width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'})},[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"50%","text-align":"left"}},[_c('h3',[_vm._v(_vm._s(_vm.title))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%"}},[(!_vm.$store.getters.isMobileDevice)?_c('el-select',{staticStyle:{"text-align":"left","width":"500px","margin-top":"10px"},attrs:{"default-first-option":"","placeholder":"scan barcode or type SKU# or article name of the fabric","id":"fabric_item_search_field","remote":"","remote-method":_vm.searchSKUCode,"size":"small","loading":_vm.getLoading,"filterable":""},on:{"change":_vm.loadLocalFabric},model:{value:(_vm.search_text),callback:function ($$v) {_vm.search_text=$$v},expression:"search_text"}},_vm._l((_vm.$store.getters.getInventoryMasterAutocompleteList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.sku_code,"value":data}},[_vm._v("\n              "+_vm._s(data.id)+"\n              "),_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.sku_code+' ('+data.article_name+(data.fabric_cut_length === 0 ? '' : ', Cut-Length')+')')}}),_vm._v(" "),(data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0)?_c('span',{staticStyle:{"float":"right"}},[_c('b',{style:('color: '+(data.closing_stock<0 ? 'red' : 'green'))},[_vm._v(_vm._s(data.closing_stock.toFixed(2))+" "+_vm._s(data.unit_name))])]):_vm._e()])}),1):_c('el-input',{staticStyle:{"width":"60%","text-align":"left"},attrs:{"id":"fabric_item_search_field","placeholder":"type and press ↵ ENTER","size":"small"},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchSKU2.apply(null, arguments)}},model:{value:(_vm.search_text),callback:function ($$v) {_vm.search_text=$$v},expression:"search_text"}}),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add new inventory item"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"26px","top":"10px","position":"relative"},on:{"click":function($event){return _vm.checkIfInventoryAddAccessGiven()}}},[_c('i',{staticClass:"el-icon-circle-plus"})])])],1),_vm._v(" "),(_vm.getFabricInfo === null)?_c('el-empty',{attrs:{"description":"No Data"}}):_vm._e(),_vm._v(" "),(_vm.getFabricInfo !== null)?_c('div',{style:({marginTop: '20px', 
              display: 'flex', 
              flexDirection: 'row', 
              justifyContent: 'flex-start', 
              alignItems: 'flex-start', 
              flexWrap: 'wrap'})},[_c('div',{staticStyle:{"margin":"10px","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)"}},[_c('DisplayImage',{attrs:{"image_width":200,"image_height":200,"image_path":_vm.getFabricInfo.profile_photo}}),_vm._v(" "),_c('span',[_vm._v("\n            SKU#: "+_vm._s(_vm.getFabricInfo.sku_code)+"\n          ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"8px"}},[_vm._v("\n            "+_vm._s(_vm.getFabricInfo.article_name)+"\n          ")]),_vm._v(" "),_c('span',[(_vm.getFabricInfo.closing_stock !== null && _vm.getFabricInfo.closing_stock>0)?_c('span',{staticStyle:{"color":"green"}},[_c('i',{staticClass:"el-icon-box"}),_vm._v(" "+_vm._s(_vm.getFabricInfo.closing_stock.toFixed(2))+" "+_vm._s(_vm.getFabricInfo.unit_name))]):_c('span',[_vm._v("-")])]),_vm._v(" "),(_vm.getFabricInfo.sku_code !== undefined)?_c('span',[_vm._v("\n            "+_vm._s(_vm.formatCurrency(_vm.getFabricInfo.sale_price))+"\n          ")]):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('el-dialog',{attrs:{"title":'Create New Fabric Item',"fullscreen":"","visible":_vm.showInventoryMaster,"close-on-press-escape":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showInventoryMaster=$event}}},[_c('InventoryMaster',{attrs:{"popup":true},on:{"closed":_vm.closeInventoryWindow}})],1),_vm._v(" "),(_vm.show_search_window)?_c('el-dialog',{attrs:{"width":"70%","visible":_vm.show_search_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_search_window=$event}}},[(_vm.$store.getters.getInventoryMasterAutocompleteList.length>0)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.$store.getters.getInventoryMasterAutocompleteList),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"2px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"},on:{"click":function($event){return _vm.loadLocalFabric(data)}}},[_c('div',{staticStyle:{"width":"70%"}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.sku_code+' ('+data.article_name+(data.fabric_cut_length === 0 ? '' : ', Cut-Length')+')')}}),_vm._v(" "),(data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0)?_c('span',{staticStyle:{"float":"right"}},[_c('b',{style:('color: '+(data.closing_stock<0 ? 'red' : 'green'))},[_vm._v(_vm._s(data.closing_stock.toFixed(2))+" "+_vm._s(data.unit_name))])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"30%"}},[_c('el-button',{attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.loadLocalFabric(data)}}},[_vm._v("\n                        Add >>\n                    ")])],1)])}),0):_c('div',[_c('span',[_vm._v("No Data Found")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2110f53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1166);
function injectStyle (ssrContext) {
  __webpack_require__(1164)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2110f53e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1165);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1feaf7f2", content, true, {});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getSaleCostSheet !== null)?_c('div',{staticStyle:{"display":"flex","flex-direction":"column","width":"100%"}},[_c('div',{staticStyle:{"margin":"10px","padding":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                Fabric Cost ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n            ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.saleMaster.sales_cost_sheet.fabric_cost),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.sales_cost_sheet, "fabric_cost", $$v)},expression:"$store.state.saleMaster.sales_cost_sheet.fabric_cost"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","padding":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                Other Material Cost ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.saleMaster.sales_cost_sheet.material_cost),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.sales_cost_sheet, "material_cost", $$v)},expression:"$store.state.saleMaster.sales_cost_sheet.material_cost"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","padding":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                  Piece Rate Worker ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.saleMaster.sales_cost_sheet.piece_rate_total),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.sales_cost_sheet, "piece_rate_total", $$v)},expression:"$store.state.saleMaster.sales_cost_sheet.piece_rate_total"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","padding":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                  Fixed Salary Worker ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.saleMaster.sales_cost_sheet.fixed_salary_rate),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.sales_cost_sheet, "fixed_salary_rate", $$v)},expression:"$store.state.saleMaster.sales_cost_sheet.fixed_salary_rate"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","padding":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                  Markup (%)\n              ")]),_vm._v(" "),_c('el-input',{staticStyle:{"width":"250px"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.$store.state.saleMaster.sales_cost_sheet.markup),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.sales_cost_sheet, "markup", $$v)},expression:"$store.state.saleMaster.sales_cost_sheet.markup"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"10px","padding":"5px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('h4',[_vm._v("\n                Total Cost ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n            ")]),_vm._v(" "),_c('h4',[_vm._v("\n                "+_vm._s(_vm.formatCurrency(_vm.getTotalCost))+"\n            ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px","padding":"5px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('h2',[_vm._v("\n                Estimated Sales Value ("+_vm._s(_vm.getCurrencyFormat.currency_symbol)+")\n            ")]),_vm._v(" "),_c('h2',[_vm._v("\n                "+_vm._s(_vm.formatCurrency(_vm.getTotalSale))+"\n            ")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrialSchedule_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0fae1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrialSchedule_vue__ = __webpack_require__(1170);
function injectStyle (ssrContext) {
  __webpack_require__(1168)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrialSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a0fae1b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrialSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1169);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("2cc5a81f", content, true, {});

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getTrialScheduleList}},[_c('el-table-column',{attrs:{"label":"Schedule Date","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{attrs:{"size":"small","type":"date","disabled":scope.row.trial_id >0,"value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(scope.row.trial_schedule_date),callback:function ($$v) {_vm.$set(scope.row, "trial_schedule_date", $$v)},expression:"scope.row.trial_schedule_date"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Trial Type","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{attrs:{"size":"small"},model:{value:(scope.row.trial_type_id),callback:function ($$v) {_vm.$set(scope.row, "trial_type_id", $$v)},expression:"scope.row.trial_type_id"}},_vm._l((_vm.$store.getters.getTailoringTrialTypeList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.trial_type,"value":data.id}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v("\n                              "+_vm._s(data.trial_type)+"\n                          ")])])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.id>0)?_c('el-tag',{attrs:{"size":"small","type":scope.row.trial_id === 0 ? 'danger' : 'success'}},[_vm._v("\n                  "+_vm._s(scope.row.trial_id === 0 ? 'Pending' : 'Completed')+"\n              ")]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":scope.row.id === 0 ? 'Add' : 'Update'}},[((_vm.$store.getters.getAccessRights.can_add && scope.row.id === 0) || (_vm.$store.getters.getAccessRights.can_edit && scope.row.id > 0 && scope.row.trial_id === 0))?_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},on:{"click":function($event){return _vm.$store.dispatch('saveTrialSchedule', scope.row)}}},[_c('i',{class:scope.row.id === 0 ? 'el-icon-circle-plus' : 'el-icon-document'})]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.$store.dispatch('removeTrialSchedule', scope.row.id)}}},[(_vm.$store.getters.getAccessRights.can_delete && scope.row.trial_id === 0 && scope.row.id > 0)?_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","padding":"10px"}},[_c('div',{staticStyle:{"text-align":"left"}},[_c('div',[_c('el-table',{staticStyle:{"width":"100%","font-size":"12px"},attrs:{"data":_vm.getOrderList}},[_c('el-table-column',{attrs:{"prop":"sl_no","label":"#","width":"50"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v(" \n              "+_vm._s(scope.row.key+1)+".\n          ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tailoring_detail","label":"Order Detail","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.tailoring_item_id>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[(scope.row.tailoring_detail !== null)?_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(scope.row.tailoring_detail.template_name)+"\n                      ")]):_vm._e()])]):(scope.row.retail_item_id>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(scope.row.retail_detail.sku)+_vm._s(scope.row.retail_detail.sku_code)+", "+_vm._s(scope.row.retail_detail.article_name)+"\n                      ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start","flex-wrap":"no-wrap"}},[(scope.row.retail_detail.alteration_allowed)?_c('el-button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.addAlteration(scope.row)}}},[_vm._v("\n                              Alter?\n                          ")]):_vm._e(),_vm._v(" "),(!_vm.quickView 
                              && (scope.row.retail_detail.fabric_cut_length === 1)
                              && (_vm.$store.getters.getSaleMasterDataProps.sale_type === 1 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 3))?_c('el-tag',{staticStyle:{"cursor":"pointer","width":"90px","margin-top":"5px"},attrs:{"size":"small","type":"primary","effect":"plain"},on:{"click":function($event){return _vm.showPurchaseRequestWindow(scope.row)}}},[_vm._v("\n                              PO Request\n                          ")]):_vm._e()],1)])]):_vm._e()]}}])}),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.sale_form_reduced)?_c('el-table-column',{attrs:{"label":"Qty","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.quickView && (_vm.$store.getters.getSaleMasterDataProps.sale_type !== 2))?_c('div',[(scope.row.tailoring_item_id>0)?_c('el-input',{staticStyle:{"width":"70px","text-align":"center"},attrs:{"disabled":(scope.row.work_order.length > 0 || scope.row.work_order_id > 0) && scope.row.id>0 && _vm.$store.getters.getSaleMasterDataProps.sale_status > 0,"id":'sale_qty_'+scope.row.key,"min":"1","size":"small","type":"number"},on:{"focus":function($event){return $event.target.select()},"change":function($event){return _vm.updateQty(scope.row)}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateQty(scope.row)}},model:{value:(scope.row.tailoring_qty),callback:function ($$v) {_vm.$set(scope.row, "tailoring_qty", $$v)},expression:"scope.row.tailoring_qty"}}):_c('el-input',{staticStyle:{"width":"70px","text-align":"center"},attrs:{"disabled":_vm.$store.getters.getSaleMasterDataProps.e_cart_id>0,"id":'sale_qty_'+scope.row.key,"size":"small","type":"number","min":"0"},on:{"focus":function($event){return $event.target.select()},"change":function($event){return _vm.updateQty(scope.row)}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateQty(scope.row)}},model:{value:(scope.row.retail_qty),callback:function ($$v) {_vm.$set(scope.row, "retail_qty", $$v)},expression:"scope.row.retail_qty"}})],1):_c('div',[(scope.row.tailoring_item_id>0)?_c('span',[_vm._v("\n                      "+_vm._s(scope.row.tailoring_qty)+"\n                  ")]):_c('span',[_vm._v("\n                      "+_vm._s(scope.row.retail_qty)+"\n                  ")])])]}}],null,false,3331368325)}):_vm._e(),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.sale_type === 3 || _vm.$store.state.preferences.props.hide_fabric_consumption_sale_order)?_c('el-table-column',{attrs:{"label":"Size","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"115px","text-align":"left"},attrs:{"size":"small","filterable":""},on:{"change":function($event){return _vm.updateFabricQty(scope.row)}},model:{value:(scope.row.size_id),callback:function ($$v) {_vm.$set(scope.row, "size_id", $$v)},expression:"scope.row.size_id"}},_vm._l((_vm.$store.getters.getTailoringSizeList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.size_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.size_name)}})])}),1)]}}],null,false,1677458475)}):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.sale_form_reduced)?_c('el-table-column',{attrs:{"label":"Fabric"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.tailoring_item_id>0 && scope.row.fabric_id>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('el-tag',{staticStyle:{"cursor":"pointer"},attrs:{"size":"small","type":"primary","effect":"plain"},on:{"click":function($event){return _vm.showFabricChangeWindow(scope.row)}}},[_vm._v("\n                          "+_vm._s(scope.row.fabric_detail.sku_code)+"\n                      ")])],1)]):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})])]}}],null,false,582726667)}):_vm._e(),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.sale_form_reduced 
          && !_vm.$store.state.preferences.props.hide_fabric_consumption_sale_order)?_c('el-table-column',{attrs:{"label":"Fabric QTY","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.tailoring_item_id>0 && scope.row.fabric_id>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[(scope.row.fabric_id>0 && !_vm.quickView)?_c('el-tag',{staticStyle:{"cursor":"pointer"},attrs:{"size":"small","type":"primary","effect":"plain"},on:{"click":function($event){return _vm.showFabricQtyEditWindow(scope.row)}}},[_vm._v("\n                              "+_vm._s(scope.row.fabric_unit_qty)+" "+_vm._s(scope.row.fabric_detail.unit_name)+"\n                          ")]):_vm._e(),_vm._v(" "),(scope.row.fabric_id>0 && _vm.quickView)?_c('span',[_vm._v("\n                              "+_vm._s(scope.row.fabric_unit_qty)+" "+_vm._s(scope.row.fabric_detail.unit_name)+"\n                          ")]):_vm._e()],1),_vm._v(" "),(_vm.isRegularOrder 
                          && !_vm.quickView 
                          && scope.row.fabric_id>0 
                          && scope.row.fabric_detail !== null 
                          && (scope.row.fabric_detail.fabric_cut_length === 1 || _vm.$store.state.preferences.props.allow_stock_fabric_po)
                          && (_vm.$store.getters.getSaleMasterDataProps.sale_type === 1 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 3))?_c('el-tag',{staticStyle:{"cursor":"pointer","width":"90px","margin-top":"5px"},attrs:{"size":"small","type":"primary","effect":"plain"},on:{"click":function($event){return _vm.showPurchaseRequestWindow(scope.row)}}},[_vm._v("\n                          PO Request\n                      ")]):_vm._e(),_vm._v(" "),((scope.row.tailoring_detail.fabric_sales_price_remains_flat === 1 
                              || scope.row.fabric_detail.stitching_rate_flat) && scope.row.id === 0)?_c('el-checkbox',{on:{"change":function($event){return _vm.changeFabricRate(scope.row)}},model:{value:(scope.row.fabric_price_fixed),callback:function ($$v) {_vm.$set(scope.row, "fabric_price_fixed", $$v)},expression:"scope.row.fabric_price_fixed"}},[_vm._v("\n                          Enable Flat Rate\n                      ")]):_vm._e()],1)]):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})])]}}],null,false,817185466)}):_vm._e(),_vm._v(" "),((_vm.type === 1 || _vm.type === 0) && (_vm.$store.getters.getSaleMasterDataProps.sale_type === 1 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 3))?_c('el-table-column',{attrs:{"label":"Work Order","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.tailoring_item_id>0)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[(_vm.$store.getters.getSaleMasterDataProps.sale_type > 0 && !_vm.quickView && scope.row.id>0)?_c('el-tag',{style:('margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'),attrs:{"loading":true,"size":"small","type":(scope.row.work_order.length > 0 || scope.row.work_order_id > 0) ? 'success' : 'primary',"effect":'plain'},on:{"click":function($event){return _vm.showWorkOrderWindow(scope.row)}}},[(scope.row.wo_processing)?_c('i',{staticClass:"el-icon-loading",staticStyle:{"color":"black"},attrs:{"title":"Work-order upload is in progress"}}):_vm._e(),_vm._v(" "),(scope.row.wo_processing)?_c('span',[_vm._v("\n                                  ......\n                              ")]):_c('span',[_vm._v("\n                                  "+_vm._s(scope.row.work_order_id > 0 ? 'Open' : scope.row.id >0 ? 'Create' : 'Draft')+"\n                              ")])]):(_vm.getOrderList.filter(function (t) { return t.wo_processing; }).length === 0 && _vm.$store.getters.getSaleMasterDataProps.sale_type > 0 && !_vm.quickView && scope.row.id === 0)?_c('el-tag',{style:('margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'),attrs:{"loading":true,"size":"small","type":'primary',"effect":'plain'},on:{"click":function($event){return _vm.showWorkOrderWindow(scope.row)}}},[_vm._v("                                \n                                  Draft\n                          ")]):_c('el-tag',{style:('margin-left: '+(scope.row.fabric_id>0 ? '5px' : '')+'; cursor: pointer;'),attrs:{"size":"small","type":'primary',"effect":'plain'},on:{"click":function($event){return _vm.showWorkOrderWindow(scope.row)}}},[_vm._v("                                \n                                  "+_vm._s(scope.row.work_order_id > 0 ? 'Open' : scope.row.id >0 ? 'Create' : 'Draft')+"\n                          ")])],1),_vm._v(" "),(!_vm.$store.getters.getPreferenceProps.sale_form_reduced)?_c('el-checkbox',{attrs:{"disabled":scope.row.id > 0},model:{value:(scope.row.tailoring_trial_required),callback:function ($$v) {_vm.$set(scope.row, "tailoring_trial_required", $$v)},expression:"scope.row.tailoring_trial_required"}},[_vm._v("\n                          Trial Required\n                      ")]):_vm._e(),_vm._v(" "),(scope.row.tailoring_trial_required && scope.row.id>0)?_c('a',{staticStyle:{"color":"black"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.openTrialScheduleWindow(scope.row.id)}}},[_c('b',[_vm._v("Schedule Trials")])]):_vm._e()],1)]):_c('div',[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})])]}}],null,false,2266074896)}):_vm._e(),_vm._v(" "),(_vm.$store.getters.getSaleCategoryList.length>1 && !_vm.quickView && (_vm.$store.getters.getSaleMasterDataProps.sale_type === 1))?_c('el-table-column',{attrs:{"prop":"sale_category_id","label":"Sale Category"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [((_vm.$store.state.preferences.props.sale_category_required_retail_sale && scope.row.retail_item_id>0) || scope.row.tailoring_item_id>0)?_c('el-select',{staticStyle:{"width":"115px","text-align":"left"},attrs:{"size":"small","filterable":""},model:{value:(scope.row.sale_category_id),callback:function ($$v) {_vm.$set(scope.row, "sale_category_id", $$v)},expression:"scope.row.sale_category_id"}},_vm._l((_vm.$store.getters.getSaleCategoryList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.category_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.category_name)}})])}),1):_vm._e()]}}],null,false,2228957132)}):_vm._e(),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.tax_id>0 && ((_vm.$store.getters.getSaleMasterDataProps.sale_type === 0 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 1))  && !_vm.quickView)?_c('el-table-column',{attrs:{"prop":"tax_percent","label":(_vm.$store.getters.isIndiaTax ? 'GST (%)' : _vm.$store.getters.getSaleMasterDataProps.tax_detail.tax_name+' (%)'),"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.tax_percent)+" %\n          ")]}}],null,false,3810859953)}):_vm._e(),_vm._v(" "),((_vm.$store.getters.getSaleMasterDataProps.sale_type === 0 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 1 || _vm.$store.getters.getSaleMasterDataProps.sale_type === 2) && !_vm.quickView)?_c('el-table-column',{attrs:{"prop":"unit_rate","label":'Total ('+_vm.getCurrencyFormat.currency_symbol+')',"align":"center","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(!_vm.$store.getters.getPreferenceProps.sale_form_reduced)?_c('div',[(_vm.$store.getters.getSaleMasterDataProps.e_cart_id === 0)?_c('el-tag',{style:('cursor: pointer;'),attrs:{"size":"small","type":'primary',"effect":'plain'},on:{"click":function($event){return _vm.showPriceEditWindow(scope.row)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatCurrency(parseFloat(scope.row.net_total)))}})]):_vm._e()],1):_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatCurrency(parseFloat(scope.row.net_total)))}}),_vm._v(" "),(scope.row.discount_amount>0)?_c('div',[_c('b',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("-"+_vm._s(_vm.formatCurrency(scope.row.discount_amount)))])]):(scope.row.discount_amount === 0 
                  && (scope.row.fabric_unit_discount_amount>0 || scope.row.tailoring_unit_discount_amount>0))?_c('div',[_c('b',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("-"+_vm._s(_vm.formatCurrency((scope.row.fabric_unit_discount_amount*parseFloat(scope.row.fabric_unit_qty)*scope.row.tailoring_qty)+(scope.row.tailoring_unit_discount_amount*scope.row.tailoring_qty))))])]):(scope.row.discount_amount === 0 
                  && (scope.row.retail_unit_discount_amount>0 ))?_c('div',[_c('b',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("-"+_vm._s(_vm.formatCurrency((scope.row.retail_unit_discount_amount))))])]):_vm._e()]}}],null,false,3567446872)}):_vm._e(),_vm._v(" "),((_vm.isRegularOrder || _vm.$store.getters.getSaleMasterDataProps.sale_type === 0) && _vm.quickView)?_c('el-table-column',{attrs:{"prop":"unit_rate","label":'Total ('+_vm.getCurrencyFormat.currency_symbol+')',"align":"center","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"color":"black","text-align":"center","cursor":"pointer"}},[_c('b',[_vm._v(_vm._s(_vm.formatCurrency(parseFloat(scope.row.net_total))))])]),_vm._v(" "),(scope.row.discount_amount>0)?_c('div',[_c('b',{staticStyle:{"color":"red","font-size":"10px"}},[_vm._v("-"+_vm._s(_vm.formatCurrency(scope.row.discount_amount)))])]):_vm._e()]}}],null,false,3100357782)}):_vm._e(),_vm._v(" "),(!_vm.quickView && _vm.$store.getters.getSaleMasterDataProps.e_cart_id === 0)?_c('el-table-column',{attrs:{"label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",staticStyle:{"margin-right":"10px"},attrs:{"effect":"dark","content":"Notes"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openNoteView(scope.row)}}},[_c('i',{class:'el-icon-s-claim',staticStyle:{"font-size":"16px"}})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",staticStyle:{"margin-left":"10px"},attrs:{"effect":"dark","content":"Cost Analysis"}},[(scope.row.id>0 && scope.row.tailoring_item_id>0 && scope.row.work_order_id)?_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openCostSheet(scope.row)}}},[_c('i',{class:'el-icon-pie-chart',staticStyle:{"font-size":"16px"}})]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",staticStyle:{"margin-left":"10px"},attrs:{"effect":"dark","content":"Copy"}},[_c('el-popconfirm',{attrs:{"title":'Are you sure to copy?'},on:{"confirm":function($event){return _vm.copyOrderRow(scope.row)}}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{class:'el-icon-document-copy',staticStyle:{"font-size":"16px"}})])])],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":(scope.row.id>0 
                          && scope.row.tailoring_item_id >0 
                              && _vm.$store.getters.getSaleMasterDataProps.sale_type>0 ? 'Cancel' : 'Delete')}},[_c('el-popconfirm',{attrs:{"title":'Are you sure to '+(scope.row.id>0 
                              && scope.row.tailoring_item_id >0 
                                  && _vm.$store.getters.getSaleMasterDataProps.sale_type>0 ? 'cancel' : 'delete')+' this?'},on:{"confirm":function($event){return _vm.deleteListItem(scope.row)}}},[_c('div',[_vm._v("\n                              Once cancelled cannot be undone.\n                          ")]),_vm._v(" "),((!scope.row.is_cancelled && scope.row.tailoring_item_id >0 && scope.row.work_order_id >= 0) 
                                  || scope.row.retail_item_id>0 
                                      || (scope.row.tailoring_item_id === 0 && scope.row.retail_item_id === 0)
                                          && (
                                              (_vm.$store.getters.getSaleMasterDataProps.id>0 && _vm.$store.getters.getSaleMasterDataProps.sale_status === 1 && _vm.$store.getters.getAccessRights.can_delete) 
                                              || (_vm.$store.getters.getSaleMasterDataProps.id>0 && _vm.$store.getters.getSaleMasterDataProps.sale_status === 0) 
                                              || (_vm.$store.getters.getSaleMasterDataProps.id === 0) 
                                          ))?_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])],1)],1)]}}],null,false,1001411661)}):_vm._e()],1)],1)]),_vm._v(" "),(_vm.getRowData !== null && _vm.showFabricQtyWindow)?_c('el-dialog',{attrs:{"width":"70%","visible":_vm.showFabricQtyWindow,"close-on-press-escape":false,"close-on-click-modal":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showFabricQtyWindow=$event}}},[_c('EditFabricQty',{attrs:{"rowData":_vm.getRowData},on:{"closed":_vm.closeWindow}})],1):_vm._e(),_vm._v(" "),(_vm.getRowData !== null && _vm.showPriceWindow)?_c('el-dialog',{attrs:{"width":"550px","visible":_vm.showPriceWindow,"close-on-press-escape":false,"close-on-click-modal":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showPriceWindow=$event}}},[_c('EditPrice',{attrs:{"rowData":_vm.getRowData},on:{"closed":_vm.closeWindow}})],1):_vm._e(),_vm._v(" "),(_vm.getRowData !== null && _vm.showPurchaseRequest)?_c('el-dialog',{attrs:{"width":"400px","visible":_vm.showPurchaseRequest,"close-on-press-escape":false,"close-on-click-modal":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showPurchaseRequest=$event}}},[_c('PurchaseRequest',{attrs:{"rowData":_vm.getRowData},on:{"closed":_vm.closeWindow}})],1):_vm._e(),_vm._v(" "),(_vm.getRowData !== null && _vm.showWorkOrder)?_c('el-dialog',{attrs:{"title":'Work-Order: '+_vm.getRowData.tailoring_detail.template_name,"fullscreen":"","visible":_vm.showWorkOrder,"close-on-press-escape":false,"close-on-click-modal":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showWorkOrder=$event}}},[_c('WorkOrder',{attrs:{"wo_confirmed":_vm.isWOConfirmed,"popup":true,"sale_item_index":_vm.getRowData.key},on:{"closed":_vm.closeWindow}})],1):_vm._e(),_vm._v(" "),(_vm.showFabric)?_c('el-dialog',{attrs:{"width":"70%","height":"400px","visible":_vm.showFabric,"append-to-body":""},on:{"update:visible":function($event){_vm.showFabric=$event}}},[_c('FabricChange',{attrs:{"title":'Choose Fabric For '+_vm.getRowData.tailoring_detail.template_name,"popup":true,"rowData":_vm.getRowData},on:{"closed":function($event){_vm.showFabric = false}}})],1):_vm._e(),_vm._v(" "),(_vm.cost_sheet_view)?_c('el-dialog',{attrs:{"title":'Cost Sheet',"width":"70%","height":"400px","visible":_vm.cost_sheet_view,"append-to-body":""},on:{"update:visible":function($event){_vm.cost_sheet_view=$event}}},[_c('CostSheet',{attrs:{"rowData":_vm.getRowData}})],1):_vm._e(),_vm._v(" "),(_vm.show_stock_list && !_vm.$store.getters.getLoadingState)?_c('el-dialog',{attrs:{"width":"450px","height":"400px","visible":_vm.show_stock_list,"append-to-body":""},on:{"update:visible":function($event){_vm.show_stock_list=$event}}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},_vm._l((_vm.$store.state.inventoryMaster.stock_list),function(data,index){return _c('div',{key:index,staticStyle:{"margin":"2px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","border-bottom":"1px solid #e2e2e2"}},[_c('span',[_vm._v("\n                      "+_vm._s(data.store_name)+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v("\n                      "+_vm._s(data.stock)+"\n                  ")])])}),0)]):_vm._e(),_vm._v(" "),(_vm.note_window)?_c('el-dialog',{attrs:{"title":'Notes',"width":"450px","height":"400px","visible":_vm.note_window,"append-to-body":""},on:{"update:visible":function($event){_vm.note_window=$event}}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('div',{staticStyle:{"margin-top":"0px"}},[_c('el-input',{staticStyle:{"width":"400px"},attrs:{"type":"textarea","rows":"5"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.rowData.notes),callback:function ($$v) {_vm.$set(_vm.rowData, "notes", $$v)},expression:"rowData.notes"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){_vm.note_window=false}}},[_vm._v("\n                  Ok\n              ")])],1)]):_vm._e(),_vm._v(" "),(_vm.trial_schedule)?_c('el-dialog',{attrs:{"title":'Trial Schedule',"width":"700px","height":"400px","visible":_vm.trial_schedule,"append-to-body":""},on:{"update:visible":function($event){_vm.trial_schedule=$event}}},[_c('TrialSchedule',{attrs:{"selected_list_item_id":_vm.getSelectedListItemId}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1173);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("04ed6a6c", content, true, {});

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243014c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_243014c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("53522e4f", content, true, {});

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters.getCustomerPaymentList.length === 0 && !_vm.readonly)?_c('el-empty',{attrs:{"description":"No Data"}},[(!_vm.$store.getters.getLoadingState && _vm.$store.getters.getAccessRights.can_add)?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.createNew}},[_vm._v("Record New Receipt")]):_vm._e()],1):_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":_vm.popup,"data":_vm.$store.getters.getCustomerPaymentList},on:{"header-click":_vm.headerClick}},[_c('el-table-column',{attrs:{"prop":"t1.payment_date","sortable":"","label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.payment_date_changed_time)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t2.locality_name","sortable":"","label":"Location"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.store_name)+"\n                ")])]}}])}),_vm._v(" "),(!_vm.popup)?_c('el-table-column',{attrs:{"prop":"t4.customer_name","sortable":"","label":"Customer"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.changed_customer_name)+"\n                ")])]}}],null,false,1211731261)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t6.sale_number","sortable":"","label":"Sale#"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                    "+_vm._s(scope.row.sale_number)+"\n                ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t1.paid_amount","sortable":"","label":"Paid Amount","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize",style:('color: '+(parseFloat(scope.row.paid_amount)<0 ? 'red' : '')+';')},[_vm._v("\n                "+_vm._s((scope.row.paid_amount !== 0) ? _vm.formatCurrency(parseFloat(scope.row.paid_amount)) : '')+"                \n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t1.redeemed_amount","sortable":"","label":"Settled","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize",staticStyle:{"color":"red"}},[_vm._v("\n                "+_vm._s(scope.row.redeemed_amount > 0 ? _vm.formatCurrency(parseFloat(scope.row.redeemed_amount)) : '')+"                \n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t1.adjustment","sortable":"","label":"Adjustment","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize",style:('color: red;')},[_vm._v("\n                "+_vm._s((scope.row.adjustment !== 0) ? _vm.formatCurrency(parseFloat(scope.row.adjustment)) : '')+"                \n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"t5.mode_name","sortable":"","label":"Paid Through"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                "+_vm._s(scope.row.redeemed_amount>0 ? 'On-Account' : scope.row.mode_name)+"\n              ")])]}}])}),_vm._v(" "),(!_vm.readonly)?_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":'Email Receipt'}},[_c('a',{staticStyle:{"cursor":"pointer","margin-right":"10px"},on:{"click":function($event){return _vm.printRcpt(scope.row.id, 'email')}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-message'})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":'Print Receipt'}},[_c('a',{staticStyle:{"cursor":"pointer","margin-right":"10px"},on:{"click":function($event){return _vm.printRcpt(scope.row.id, 'print')}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-printer'})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.$store.getters.getAccessRights.can_edit ? 'Edit' : 'View'}},[(scope.row.redeemed_amount === 0)?_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.openForm({ id: scope.row.id, copy: false, navigate: true })}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : _vm.$store.getters.getAccessRights.can_edit ? 'el-icon-edit' : 'el-icon-view'})]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to delete this?"},on:{"confirm":function($event){return _vm.deleteData(scope.row)}}},[(_vm.$store.getters.getAccessRights.can_delete)?_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red"},attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()])],1)],1)]}}],null,false,3200059617)}):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('GridPagination',{attrs:{"dataProps":_vm.$store.state.customerPayment.nav},on:{"navigateButton":_vm.navigateButton}})],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isPrintWindowVisible)?_c('PrintWindow',{attrs:{"title":_vm.getPrintTitle,"src":_vm.getPrintSrc,"dialogVisible":_vm.isPrintWindowVisible},on:{"closePrintWindow":function($event){_vm.showPrintWindow = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start","width":"100%"}},[(_vm.$store.getters.getCustomerPaymentList.length > 0 || _vm.$store.state.customerPayment.nav.had_results)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%","justify-content":"space-between","align-items":"space-between"}},[(!_vm.popup)?_c('SearchField',{attrs:{"searchKeys":_vm.getResultKeys},on:{"searchCustom":_vm.loadList}}):_c('span',[_c('span',{domProps:{"innerHTML":_vm._s('&nbsp;')}})]),_vm._v(" "),(_vm.$store.getters.getAccessRights.can_add 
                          && !_vm.readonly 
                              && (
                                  (_vm.source==='saleOrder' && _vm.$store.getters.getSaleMasterDataProps.balance>0) || _vm.source!=='saleOrder'))?_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.createNew}},[_vm._v("Record New Receipt")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('List',{attrs:{"popup":_vm.popup,"source":_vm.source,"readonly":_vm.readonly,"source_id":_vm.source_id},on:{"openPaymentForm":function($event){return _vm.$emit('openPaymentForm')},"closed":function($event){return _vm.$emit('closed')}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupProductionStatus_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ba155e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupProductionStatus_vue__ = __webpack_require__(1182);
function injectStyle (ssrContext) {
  __webpack_require__(1180)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupProductionStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29ba155e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupProductionStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1181);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("05fde66b", content, true, {});

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getNoWOList.length>0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getNoWOList}},[_c('el-table-column',{attrs:{"label":"Garment"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n         "+_vm._s(scope.row.tailoring_detail.template_name)+"\n      ")]}}],null,false,756751448)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Qty","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(parseInt(scope.row.tailoring_qty)-_vm.getDistinctSaleItemId.filter(function (t) { return t.sale_item_id === scope.row.id; }).length)+"\n      ")]}}],null,false,3683818133)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fabric","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[(scope.row.fabric_id>0 && scope.row.fabric_detail)?_c('span',[_vm._v("\n              "+_vm._s(scope.row.fabric_detail.sku_code)+"\n              ")]):_vm._e()])]}}],null,false,645962213)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"process_name","label":"Current Status"}},[[_vm._v("\n          WO Pending\n      ")]],2)],1):_vm._e(),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getDistinctSingleItemList}},[_c('el-table-column',{attrs:{"label":"Garment"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(scope.row.template_name)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Qty","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.data_list.filter(function (t) { return t.tailoring_item_id === scope.row.tailoring_item_id && t.sub_tailoring_item_id === scope.row.sub_tailoring_item_id && t.process_name == scope.row.process_name && t.delivered === scope.row.delivered && t.fabric_id === scope.row.fabric_id; }).length)+"\n      ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fabric","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('span',[_vm._v("\n              "+_vm._s(scope.row.sku_code)+"\n              ")])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"process_name","label":"Current Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.delivered === 1)?_c('span',[_vm._v("\n              Delivered\n          ")]):_c('span',[_vm._v("\n              "+_vm._s(scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : ''))+"\n          ")])]}}])})],1),_vm._v(" "),(_vm.getDistinctComboItemList.length>0)?_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getDistinctComboItemList}},[_c('el-table-column',{attrs:{"label":"Garment"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n         "+_vm._s(scope.row.sub_template_name)+" ("+_vm._s(scope.row.template_name)+")\n      ")]}}],null,false,3556604618)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Qty","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n          "+_vm._s(_vm.data_list.filter(function (t) { return t.tailoring_item_id === scope.row.tailoring_item_id && t.sub_tailoring_item_id === scope.row.sub_tailoring_item_id && t.process_name == scope.row.process_name && t.delivered === scope.row.delivered && t.fabric_id === scope.row.fabric_id; }).length)+"\n      ")]}}],null,false,3711200672)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Fabric","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('span',[_vm._v("\n              "+_vm._s(scope.row.sku_code)+"\n              ")])])]}}],null,false,930526773)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"process_name","label":"Current Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.delivered === 1)?_c('span',[_vm._v("\n              Delivered\n          ")]):_c('span',[_vm._v("\n              "+_vm._s(scope.row.process_name+' '+(scope.row.hidden_process === -1 ? scope.row.work_order_status : ''))+"\n          ")])]}}],null,false,1539360078)})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.getters.getLoadingState),expression:"$store.getters.getLoadingState"}],staticStyle:{"display":"flex","flex-direction":"column","justify-content":"space-between","align-items":"space-between","width":"100%"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","margin-top":"-40px","text-align":"left"}},[_c('span',[_vm._v("\n                  "+_vm._s(_vm.$store.getters.getSaleMasterDataProps.sale_number_prefix)+_vm._s(_vm.$store.getters.getSaleMasterDataProps.sale_number)+"\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                  "+_vm._s(_vm.$store.getters.getCustomerMasterDataProps.customer_name)+", "+_vm._s(_vm.$store.getters.getUserGroupAlerts.hide_critical_customer_info ? '' : _vm.$store.getters.getCustomerMasterDataProps.primary_mobile_number_calling_code)+"-"+_vm._s(_vm.$store.getters.getCustomerMasterDataProps.primary_mobile_number)+"\n              ")]),_vm._v(" "),(_vm.calendar_source && _vm.isSalesEditAllowed)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-top":"20px"}},[_c('span',{staticStyle:{"margin-top":"5px"}},[_vm._v("\n                      Delivery Date\n                  ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"200px","margin-left":"10px"},attrs:{"size":"small","type":"date","disabled":_vm.$store.getters.getPreferenceProps.disable_back_dated_entry,"value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.saleMaster.props.delivery_date),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.props, "delivery_date", $$v)},expression:"$store.state.saleMaster.props.delivery_date"}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.updateSalesDeliveryDate}},[_vm._v("\n                      Ok\n                  ")])],1):_vm._e(),_vm._v(" "),(_vm.calendar_source && _vm.$store.getters.getSaleMasterDataProps.trial_required && _vm.isSalesEditAllowed)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","margin-top":"20px"}},[_c('span',{staticStyle:{"margin-top":"5px"}},[_vm._v("\n                      Trial Date\n                  ")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"200px","margin-left":"10px"},attrs:{"size":"small","type":"date","disabled":_vm.$store.getters.getPreferenceProps.disable_back_dated_entry,"value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.$store.state.saleMaster.props.trial_date),callback:function ($$v) {_vm.$set(_vm.$store.state.saleMaster.props, "trial_date", $$v)},expression:"$store.state.saleMaster.props.trial_date"}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.updateSalesTrialDate}},[_vm._v("\n                      Ok\n                  ")])],1):_vm._e()]),_vm._v(" "),_c('el-tabs',{staticStyle:{"margin-top":"20px"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":'Order List',"name":"1"}},[_c('OrderList',{attrs:{"quickView":true}})],1),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.id>0)?_c('el-tab-pane',{attrs:{"label":'Payment History',"name":"2"}},[_c('CustomerPaymentList',{attrs:{"popup":true,"readonly":true,"source_id":_vm.$store.getters.getInventoryInvoiceDataProps.id}})],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.id>0)?_c('el-tab-pane',{attrs:{"label":'Production Status',"name":"3"}},[_c('ProductionList',{attrs:{"quickView":true,"allow_delivery":false,"calendar_source":_vm.calendar_source,"payroll":_vm.payroll,"sale_id":_vm.$store.getters.getSaleMasterDataProps.id}})],1):_vm._e(),_vm._v(" "),(_vm.$store.getters.getSaleMasterDataProps.id>0)?_c('el-tab-pane',{attrs:{"label":'Group Production Status',"name":"4"}},[_c('GroupProductionStatus',{attrs:{"data_list":_vm.$store.getters.getProductionWorkOrderAutocompleteList}})],1):_vm._e()],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("74569656", content, true, {});

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.$store.getters.getLoadingState),expression:"$store.getters.getLoadingState"}]},[(!_vm.plannerSource)?_c('div',{staticStyle:{"width":"100%","text-align":"right"}},[_c('el-popconfirm',{attrs:{"title":"Are you sure to notify?"},on:{"confirm":_vm.notifyCustomerReadyItems}},[_c('el-button',{attrs:{"slot":"reference","type":"primary","size":"small"},slot:"reference"},[_vm._v("Notify This Customer")])],1)],1):_vm._e(),_vm._v(" "),(_vm.plannerSource)?_c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%"}},[_c('span',{staticStyle:{"margin-top":"5px"},attrs:{"type":"label"}},[_vm._v("Change Scheduled Date")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"200px","margin-left":"20px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(_vm.appointment_date),callback:function ($$v) {_vm.appointment_date=$$v},expression:"appointment_date"}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"disabled":_vm.getFinalList.filter(function (t) { return t.selected; }).length === 0,"size":"small","type":"primary"},on:{"click":_vm.updateAllPromise}},[_vm._v("\n                  Submit\n              ")])],1),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"font-size":"12px"}},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.getFinalList}},[(_vm.plannerSource)?_c('el-table-column',{attrs:{"width":"40"},scopedSlots:_vm._u([{key:"header",fn:function(scope){return [_c('el-checkbox',{attrs:{"size":"mini"},on:{"change":_vm.selectAllRows},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}}),_vm._v("\n              "+_vm._s(scope.row)+"\n          ")]}},{key:"default",fn:function(scope){return [_c('el-checkbox',{attrs:{"size":"mini"},model:{value:(scope.row.selected),callback:function ($$v) {_vm.$set(scope.row, "selected", $$v)},expression:"scope.row.selected"}})]}}],null,false,1671136339)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"label":"#"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.sale_number)+"-"+_vm._s(scope.row.sl_no)+"-"+_vm._s(scope.row.qty_sl_no)+_vm._s(scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : '')+"\n                  "),_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Add Task"},on:{"click":function($event){_vm.$emit('addTask', {title: scope.row.sale_number+'-'+scope.row.sl_no+'-'+scope.row.qty_sl_no+''+(scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''), description: scope.row.customer_name})}}},[_c('i',{class:'el-icon-date'})])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"template_name","label":"Garment Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.template_name)+"                        \n              ")])]}}])}),_vm._v(" "),(_vm.plannerSource)?_c('el-table-column',{attrs:{"sortable":"","prop":"schedule_date","label":"Scheduled Date","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-popover',{attrs:{"placement":"right","width":"400","content":"Loading...","trigger":"click"}},[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',[_c('b',[_vm._v(_vm._s(scope.row.sale_number)+"-"+_vm._s(scope.row.sl_no)+"-"+_vm._s(scope.row.qty_sl_no)+_vm._s(scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Change Scheduled Date")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"350px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(scope.row.appointment_date),callback:function ($$v) {_vm.$set(scope.row, "appointment_date", $$v)},expression:"scope.row.appointment_date"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Remarks")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"350px","text-align":"left"},attrs:{"placeholder":"Remarks","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateScheduledDate(scope.row)}},model:{value:(scope.row.schedule_notes),callback:function ($$v) {_vm.$set(scope.row, "schedule_notes", $$v)},expression:"scope.row.schedule_notes"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"small","type":'primary'},on:{"click":function($event){return _vm.updateScheduledDate(scope.row)}}},[_vm._v("\n                          Save\n                      ")])],1),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference","size":"small"},slot:"reference"},[_vm._v("\n                      "+_vm._s(scope.row.appointment_date_changed)+"\n                      "+_vm._s(scope.row.appointment_type === 0 ? '(D)' : '(T)')+"\n                  ")])],1)]}}],null,false,2699700598)}):_vm._e(),_vm._v(" "),_vm._l((_vm.getMasterStageList),function(data,index){return _c('el-table-column',{key:index,attrs:{"label":data.process_name,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row[data.process_name] !== undefined && scope.row[data.process_name].is_required === 1)?_c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"},attrs:{"slot":"content"},slot:"content"},[_c('span',{staticStyle:{"font-size":"18px"}},[_c('b',[_vm._v("Completed")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Staff Name:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].staff_name)+"\n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Started At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].started_at)+" \n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Finished At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].finished_at)+" \n                              ")])]),_vm._v(" "),(scope.row[data.process_name].work_staus === 4)?_c('el-tag',{attrs:{"type":"success"}},[_c('i',{staticClass:"el-icon-success"})]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":"Waiting"}},[(scope.row[data.process_name].work_staus === 0)?_c('el-tag',{attrs:{"type":"warning"}},[_c('i',{staticClass:"el-icon-watch"})]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light","content":"Waiting"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"},attrs:{"slot":"content"},slot:"content"},[_c('span',{staticStyle:{"font-size":"18px"}},[_c('b',[_vm._v("In Progress")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Staff Name:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].staff_name)+"\n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Started At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].started_at)+" \n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Finished At:")]),_vm._v(" -\n                              ")])]),_vm._v(" "),(scope.row[data.process_name].work_staus === 1)?_c('el-tag',{attrs:{"type":"info"}},[_c('i',{staticClass:"el-icon-timer"})]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"},attrs:{"slot":"content"},slot:"content"},[_c('span',{staticStyle:{"font-size":"18px"}},[_c('b',[_vm._v("Pending Approval")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Staff Name:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].staff_name)+"\n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Started At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].started_at)+" \n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Finished At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].finished_at)+" \n                              ")])]),_vm._v(" "),(scope.row[data.process_name].work_staus === 2)?_c('el-tag',[_c('i',{staticClass:"el-icon-time"})]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"light"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"},attrs:{"slot":"content"},slot:"content"},[_c('span',{staticStyle:{"font-size":"18px"}},[_c('b',[_vm._v("Work Rejected")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Staff Name:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].staff_name)+"\n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Started At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].started_at)+" \n                              ")]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Finished At:")]),_vm._v(" "+_vm._s(scope.row[data.process_name].finished_at)+" \n                              ")])]),_vm._v(" "),(scope.row[data.process_name].work_staus === 3)?_c('el-tag',{attrs:{"type":"danger"}},[_c('i',{staticClass:"el-icon-circle-close"})]):_vm._e()],1)],1):_c('span',{attrs:{"title":"Not available"}},[_c('i',{staticClass:"el-icon-close"})])]}}],null,true)})})],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1188);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("125eea5a", content, true, {});

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ade94d20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__ = __webpack_require__(1192);
function injectStyle (ssrContext) {
  __webpack_require__(1190)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ade94d20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("238a7e61", content, true, {});

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"width":"40%","text-align":"left"}},[_c('el-input',{staticStyle:{"width":"350px","text-align":"left"},attrs:{"placeholder":"Search...","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()},"clear":_vm.clearSearch},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.search_term = _vm.search_term_1}},model:{value:(_vm.search_term_1),callback:function ($$v) {_vm.search_term_1=$$v},expression:"search_term_1"}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"40%","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[(!_vm.calendar_view && _vm.$store.state.production.planner.search_type <2)?_c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"small","loading":_vm.processing},on:{"click":_vm.updateAllPromises}},[_vm._v("\n                  Update All Promises\n              ")]):_vm._e(),_vm._v(" "),_c('el-dropdown',{on:{"command":_vm.handleDropdownCommand}},[_c('el-button',{staticStyle:{"margin-right":"5px"},attrs:{"size":"small","type":"primary"}},[_vm._v("\n                      Download CSV"),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown","align":"left"},slot:"dropdown"},[_c('el-dropdown-item',{attrs:{"command":"downloadOverview"}},[_vm._v("Overview List")]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"command":"downloadList"}},[_vm._v("Item List")])],1)],1)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"summary-method":_vm.getSummaries,"show-summary":true,"data":_vm.getFinalList.slice((_vm.$store.getters.getDefaultPageLimit*_vm.page_number)-_vm.$store.getters.getDefaultPageLimit, 
              (_vm.$store.getters.getDefaultPageLimit*_vm.page_number)),"default-sort":{prop: 'date', order: 'ascending'}}},[_c('el-table-column',{attrs:{"sortable":"","prop":"customer_code","label":"Cust#","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[(!_vm.calendar_view)?_c('el-link',{staticStyle:{"text-decoration":"underline"},on:{"click":function($event){return _vm.$emit('loadCustomerInvoiceList', 
                  {
                      customer_id: scope.row.customer_id, 
                      label: scope.row.customer_name
                  })}}},[_vm._v("\n                  "+_vm._s(scope.row.customer_code)+"\n              ")]):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.customer_code)+"\n              ")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"customer_name","label":"Customer","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[(!_vm.calendar_view)?_c('el-link',{staticStyle:{"text-decoration":"underline"},on:{"click":function($event){return _vm.$emit('loadCustomerInvoiceList', 
                  {
                      customer_id: scope.row.customer_id, 
                      label: scope.row.customer_name
                  })}}},[_vm._v("\n                  "+_vm._s(scope.row.customer_name)+"\n              ")]):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.customer_name)+"\n              ")])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dd_activity","label":"Activity","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"125px","text-align":"left"},attrs:{"size":"small","filterable":"","allow-create":_vm.$store.getters.getAccessRights.can_add},model:{value:(scope.row.dd_activity),callback:function ($$v) {_vm.$set(scope.row, "dd_activity", $$v)},expression:"scope.row.dd_activity"}},_vm._l((_vm.$store.state.customerMaster.customer_dd.dd_activity),function(data,index){return _c('el-option',{key:index,attrs:{"label":data,"value":data}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data)}})])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dd_status","label":"Status","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"125px","text-align":"left"},attrs:{"size":"small","filterable":"","allow-create":_vm.$store.getters.getAccessRights.can_add},model:{value:(scope.row.dd_status),callback:function ($$v) {_vm.$set(scope.row, "dd_status", $$v)},expression:"scope.row.dd_status"}},_vm._l((_vm.$store.state.customerMaster.customer_dd.dd_status),function(data,index){return _c('el-option',{key:index,attrs:{"label":data,"value":data}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data)}})])}),1)]}}])}),_vm._v(" "),(_vm.$store.state.production.planner.search_type <2)?_c('el-table-column',{attrs:{"sortable":"","prop":"appointment_date","label":"Promise Date","width":"165"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},on:{"change":function($event){return _vm.addToPromiseDateArray(scope.row)}},model:{value:(scope.row.appointment_date),callback:function ($$v) {_vm.$set(scope.row, "appointment_date", $$v)},expression:"scope.row.appointment_date"}})]}}],null,false,1250829974)}):_vm._e(),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dd_sales_coordinator","label":"Coordinator","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-select',{staticStyle:{"width":"125px","text-align":"left"},attrs:{"size":"small"},model:{value:(scope.row.dd_sales_coordinator),callback:function ($$v) {_vm.$set(scope.row, "dd_sales_coordinator", $$v)},expression:"scope.row.dd_sales_coordinator"}},_vm._l((_vm.$store.getters.getEmployeeMasterList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.staff_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.staff_name)}})])}),1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"dd_notes","label":"Notes","width":"250"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-input',{staticStyle:{"width":"225px","text-align":"left"},attrs:{"size":"small"},on:{"focus":function($event){return $event.target.select()}},model:{value:(scope.row.dd_notes),callback:function ($$v) {_vm.$set(scope.row, "dd_notes", $$v)},expression:"scope.row.dd_notes"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Counters","width":(100+(_vm.$store.getters.getItemCategoryList.length*100))}},[_c('el-table-column',{attrs:{"sortable":"","prop":"total_orders","label":"Total","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_c('b',[_vm._v(_vm._s(scope.row.total_orders))]),_vm._v(" "),(scope.row.delivery_ready.length>0)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("\n                      ("+_vm._s(scope.row.delivery_ready.length)+")\n                  ")]):(scope.row.trial_ready.length>0)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("\n                      ("+_vm._s(scope.row.trial_ready.length)+")\n                  ")]):_vm._e()])]}}])}),_vm._v(" "),_vm._l((_vm.$store.getters.getItemCategoryList),function(data,index){return _c('el-table-column',{key:index,attrs:{"sortable":"","label":data.category_name,"align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row[data.category_name] !== undefined)?_c('span',[_c('b',[_vm._v(_vm._s(scope.row[data.category_name].data_list.length))]),_vm._v(" "),(scope.row[data.category_name].data_list.filter(function (t) { return t.hidden_process > 0 && t.work_status===0; }).length)?_c('span',{staticStyle:{"color":"green"}},[_vm._v("\n                          ("+_vm._s(scope.row[data.category_name].data_list.filter(function (t) { return t.hidden_process > 0 && t.work_status===0; }).length)+")\n                      ")]):_vm._e()]):_c('span',[_vm._v("\n                      -\n                  ")])]}}],null,true)})})],2),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"70"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[(!_vm.calendar_view)?_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Add Task"},on:{"click":function($event){return _vm.$emit('addTask', {title: scope.row.customer_name+' Orders', description: 'Pending Orders'})}}},[_c('i',{class:'el-icon-date'})]):_vm._e(),_vm._v(" "),_c('el-tooltip',{staticClass:"item",staticStyle:{"margin-left":"10px"},attrs:{"effect":"dark","content":"View"}},[_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Work Status"},on:{"click":function($event){return _vm.openOrderDetails(scope.row)}}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-s-grid'})])])],1)]}}])})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.page_number,"page-size":_vm.$store.getters.getDefaultPageLimit,"layout":"total, sizes, prev, pager, next","page-sizes":[5, 10, 20, 30, 40, 50, 100],"total":_vm.getFinalList.length},on:{"size-change":_vm.handleSizeChange,"update:currentPage":function($event){_vm.page_number=$event},"update:current-page":function($event){_vm.page_number=$event},"update:pageSize":function($event){return _vm.$set(_vm.$store.getters, "getDefaultPageLimit", $event)},"update:page-size":function($event){return _vm.$set(_vm.$store.getters, "getDefaultPageLimit", $event)}}})],1),_vm._v(" "),(_vm.show_detail_list)?_c('el-dialog',{attrs:{"title":_vm.getSelectedCustomerName,"fullscreen":"","visible":_vm.show_detail_list,"append-to-body":""},on:{"update:visible":function($event){_vm.show_detail_list=$event}}},[_c('DetailList',{attrs:{"plannerSource":true,"searchType":_vm.searchType,"customer_id":_vm.getSelectedCustomerId},on:{"addTask":_vm.addTask,"closed":function($event){_vm.show_detail_list = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be528624_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1196);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be528624_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("d527956e", content, true, {});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.data_list.slice((_vm.$store.getters.getDefaultPageLimit*_vm.page_number)-_vm.$store.getters.getDefaultPageLimit, 
              (_vm.$store.getters.getDefaultPageLimit*_vm.page_number)),"default-sort":{prop: 'appointment_date', order: 'ascending'}}},[_c('el-table-column',{attrs:{"sortable":"","prop":"appointment_date","label":"Promise Date","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(_vm.$store.state.production.planner.search_type <2)?_c('el-popover',{attrs:{"placement":"right","width":"400","content":"Loading...","trigger":"click"}},[_c('br'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"column","justify-content":"flex-start","align-items":"flex-start"}},[_c('span',[_c('b',[_vm._v(_vm._s(scope.row.sale_number)+"-"+_vm._s(scope.row.sl_no)+"-"+_vm._s(scope.row.qty_sl_no)+_vm._s(scope.row.sub_sl_no>0 ? '-'+scope.row.sub_sl_no : ''))])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Change Scheduled Date")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"350px"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(scope.row.appointment_date),callback:function ($$v) {_vm.$set(scope.row, "appointment_date", $$v)},expression:"scope.row.appointment_date"}})],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{attrs:{"type":"label"}},[_vm._v("Remarks")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-input',{staticStyle:{"width":"350px","text-align":"left"},attrs:{"placeholder":"Remarks","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.updateScheduledDate(scope.row)}},model:{value:(scope.row.schedule_notes),callback:function ($$v) {_vm.$set(scope.row, "schedule_notes", $$v)},expression:"scope.row.schedule_notes"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"small","type":'primary'},on:{"click":function($event){return _vm.updateScheduledDate(scope.row)}}},[_vm._v("\n                          Save\n                      ")])],1),_vm._v(" "),_c('el-button',{attrs:{"slot":"reference","size":"small"},slot:"reference"},[_vm._v("\n                      "+_vm._s(scope.row.appointment_date_changed)+"\n                      "+_vm._s(scope.row.appointment_type === 0 ? '(D)' : '(T)')+"\n                  ")])],1):_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.appointment_date_changed)+" "+_vm._s(scope.row.appointment_type === 1 ? '(T)' : '(D)')+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"customer_name","label":"Customer Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.customer_name)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"sale_number","label":"Order#"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{staticClass:"rowFontSize",on:{"click":function($event){return _vm.openWorkOrder(scope.row)}}},[_vm._v("\n                  "+_vm._s(scope.row.work_order_number)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"template_name","label":"Garment Name"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"rowFontSize"},[_vm._v("\n                  "+_vm._s(scope.row.template_name)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"work_order_status","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"size":"small","type":(scope.row.process_name == 'Ready For Delivery' || scope.row.process_name == 'Ready For Trial') ? 'success' 
                      : scope.row.work_status === 0 ? 'info' 
                          : scope.row.work_status === 1 ? 'success' 
                              : scope.row.work_status === 2 ? 'warning' 
                                  : scope.row.work_status === 3 ? 'danger' : '',"effect":"dark"}},[_vm._v("\n                 "+_vm._s(_vm.all_list ? scope.row.process_name+' ' : '')+_vm._s((scope.row.process_name == 'Ready For Delivery' || scope.row.process_name == 'Ready For Trial') ? '' : scope.row.work_order_status)+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"sortable":"","prop":"priority_date","label":"Priority Date","width":"165"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-date-picker',{staticStyle:{"width":"140px"},attrs:{"disabled":!scope.row.added_to_priority,"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},on:{"change":function($event){return _vm.togglePriority(scope.row, false)}},model:{value:(scope.row.priority_date),callback:function ($$v) {_vm.$set(scope.row, "priority_date", $$v)},expression:"scope.row.priority_date"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"","width":"70"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"text-align":"right","display":"flex","flex-direction":"row","justify-content":"flex-end","align-items":"flex-end"}},[(!_vm.calendar_view)?_c('a',{staticStyle:{"cursor":"pointer","margin-right":"20px"},attrs:{"title":scope.row.added_to_priority ? 'Remove From Priority' : 'Add To Priority'},on:{"click":function($event){return _vm.togglePriority(scope.row)}}},[_c('i',{class:'el-icon-warning',style:({color: scope.row.added_to_priority ? 'green' : 'red', fontSize: '16px'})})]):_vm._e(),_vm._v(" "),(!_vm.calendar_view)?_c('a',{staticStyle:{"cursor":"pointer"},attrs:{"title":"Add Task"},on:{"click":function($event){_vm.$emit('addTask', {title: scope.row.customer_name+' ('+scope.row.work_order_number+')', 
                          description: scope.row.process_name+', '+scope.row.work_order_status})}}},[_c('i',{class:'el-icon-date'})]):_vm._e()])]}}])})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.page_number,"page-size":_vm.$store.getters.getDefaultPageLimit,"layout":"total, sizes, prev, pager, next","page-sizes":[5, 10, 20, 30, 40, 50, 100],"total":_vm.data_list.length},on:{"size-change":_vm.handleSizeChange,"update:currentPage":function($event){_vm.page_number=$event},"update:current-page":function($event){_vm.page_number=$event},"update:pageSize":function($event){return _vm.$set(_vm.$store.getters, "getDefaultPageLimit", $event)},"update:page-size":function($event){return _vm.$set(_vm.$store.getters, "getDefaultPageLimit", $event)}}})],1),_vm._v(" "),(_vm.showWorkOrder)?_c('el-dialog',{attrs:{"title":'Work-Order: '+_vm.work_order_title,"fullscreen":"","visible":_vm.showWorkOrder,"close-on-press-escape":false,"close-on-click-modal":false,"append-to-body":"","show-close":false},on:{"update:visible":function($event){_vm.showWorkOrder=$event}}},[_c('WorkOrder',{attrs:{"popup":true,"shortcut":true},on:{"closed":function($event){_vm.showWorkOrder = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tabs',{model:{value:(_vm.active_tab),callback:function ($$v) {_vm.active_tab=$$v},expression:"active_tab"}},[_c('el-tab-pane',{attrs:{"label":"Summary","name":"1"}},[_c('Summary',{attrs:{"calendar_view":_vm.calendar_view,"data_list":_vm.data_list,"searchType":_vm.searchType},on:{"addTask":_vm.addTask,"loadCustomerInvoiceList":_vm.loadCustomerInvoiceList,"navigateMasterProductionQuery":_vm.navigateMasterProductionQuery}})],1),_vm._v(" "),_vm._l((_vm.getCategoryWiseList),function(data,index){return (data.item_list.reduce(function (count, element1) {return count + parseInt(element1.item_list.length);}, 0)>0)?_c('el-tab-pane',{key:index,attrs:{"label":data.category_name,"name":(index+2)+''}},[_c('div',{staticStyle:{"text-align":"right","width":"100%","display":"flex","flex-direction":"row","justify-content":"flex-end"}},[_c('el-select',{staticStyle:{"width":"250px","text-align":"left"},attrs:{"size":"small","placeholder":"Filter by store","filterable":""},model:{value:(_vm.store_id),callback:function ($$v) {_vm.store_id=$$v},expression:"store_id"}},[_c('el-option',{attrs:{"value":0,"label":'All Stores'}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('All Stores')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getAccessibleStoreList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.store_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.store_name)}})])})],2),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":function($event){return _vm.downloadItemCSVList(data.item_list)}}},[_vm._v("\n                          Download CSV\n                      ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.active_tab == (index+2)+'')?_c('el-tabs',{attrs:{"tab-position":'left',"type":"border-card"},model:{value:(_vm.sub_active_tab),callback:function ($$v) {_vm.sub_active_tab=$$v},expression:"sub_active_tab"}},[_c('el-tab-pane',{attrs:{"name":'all_process',"label":'All Items'}},[(_vm.sub_active_tab == 'all_process')?_c('ProcessList',{attrs:{"store_id":_vm.getStoreId,"searchType":_vm.searchType,"calendar_view":_vm.calendar_view,"all_list":true,"data_list":_vm.getCategoryWiseAllItem.filter(function (t) { return _vm.getStoreId > 0 ? t.store_id === _vm.getStoreId : t.store_id>0; })},on:{"addTask":_vm.addTask}}):_vm._e()],1),_vm._v(" "),_vm._l((data.item_list),function(data1,index_1){return (data1.item_list.filter(function (t) { return _vm.getStoreId > 0 ? t.store_id === _vm.getStoreId : t.store_id>0; }).length>0)?_c('el-tab-pane',{key:index_1+'_sub',attrs:{"name":(index_1+1)+'',"label":data1.process_name+' ('+data1.item_list.filter(function (t) { return _vm.getStoreId > 0 ? t.store_id === _vm.getStoreId : t.store_id>0; }).length+')'}},[(_vm.sub_active_tab == (index_1+1)+'')?_c('ProcessList',{attrs:{"store_id":_vm.getStoreId,"searchType":_vm.searchType,"calendar_view":_vm.calendar_view,"data_list":data1.item_list.filter(function (t) { return _vm.getStoreId > 0 ? t.store_id === _vm.getStoreId : t.store_id>0; })},on:{"addTask":_vm.addTask}}):_vm._e()],1):_vm._e()})],2):_vm._e()],1):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_master__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_signup__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_preferences__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_taxSetting__ = __webpack_require__(1294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_shop__ = __webpack_require__(1298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_document__ = __webpack_require__(1302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_taskCategory__ = __webpack_require__(1307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_teamCategory__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_saleCategory__ = __webpack_require__(1315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_customerTag__ = __webpack_require__(1319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_saleTag__ = __webpack_require__(1323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_contactTag__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_communicationTemplate__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_userGroup__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__modules_itemCategory__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_tailoringCollection__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__modules_tailoringSize__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__modules_measurementTemplate__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__modules_productionStage__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__modules_tailoringMaster__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__modules_leaveMaster__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__modules_overtimeMaster__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__modules_holidayMaster__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__modules_designationMaster__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modules_employee__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__modules_genericContact__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__modules_teamList__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__modules_leaveApplication__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__modules_attendanceEntry__ = __webpack_require__(1395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__modules_bankMaster__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__modules_paymentMode__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__modules_currencyExchange__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__modules_expenseCategory__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__modules_expenseJournal__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__modules_contraEntry__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__modules_fabricPriceSlab__ = __webpack_require__(1423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__modules_inventoryVariant__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__modules_vendorMaster__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__modules_inventoryMaster__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__modules_inventoryOrder__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__modules_inventoryInvoice__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__modules_vendorPayment__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__modules_inventoryIntraBranch__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__modules_inventorySourcing__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__modules_inventoryStockCheck__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__modules_customerMaster__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__modules_saleMaster__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__modules_customerPayment__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__modules_workOrder__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__modules_giftCard__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__modules_saleDelivery__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__modules_production__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__modules_productionItemIssue__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__modules_transferWorkOrder__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__modules_productionOutsource__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__modules_inventorySeparation__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__modules_discountCoupon__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__modules_productionCapacity__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__modules_employeeLoan__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__modules_employeePayroll__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__modules_inventoryRack__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__modules_measurementMaster__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__modules_assetMaster__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__modules_bankStatement__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__modules_tasks__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__modules_shipmentPartner__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__modules_handloomCluster__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__modules_expenseBill__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__modules_letterTemplate__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__modules_lostDamaged__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__modules_eStoreOrder__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__modules_news__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__modules_eStoreCatalog__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__modules_dataBackup__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__modules_tailoringTrialType__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__modules_campaign__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__modules_eStoreCategory__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__modules_eStoreTopMenu__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__modules_eStoreProduct__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__modules_eStoreHomePage__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__modules_garmentCustomiser__ = __webpack_require__(1603);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);



















































































/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    garmentCustomiser: __WEBPACK_IMPORTED_MODULE_82__modules_garmentCustomiser__["a" /* default */],
    master: __WEBPACK_IMPORTED_MODULE_2__modules_master__["a" /* default */],
    signup: __WEBPACK_IMPORTED_MODULE_3__modules_signup__["a" /* default */],
    preferences: __WEBPACK_IMPORTED_MODULE_4__modules_preferences__["a" /* default */],
    taxSetting: __WEBPACK_IMPORTED_MODULE_5__modules_taxSetting__["a" /* default */],
    shop: __WEBPACK_IMPORTED_MODULE_6__modules_shop__["a" /* default */],
    document: __WEBPACK_IMPORTED_MODULE_7__modules_document__["a" /* default */],
    taskCategory: __WEBPACK_IMPORTED_MODULE_8__modules_taskCategory__["a" /* default */],
    teamCategory: __WEBPACK_IMPORTED_MODULE_9__modules_teamCategory__["a" /* default */],
    saleCategory: __WEBPACK_IMPORTED_MODULE_10__modules_saleCategory__["a" /* default */],
    customerTag: __WEBPACK_IMPORTED_MODULE_11__modules_customerTag__["a" /* default */],
    saleTag: __WEBPACK_IMPORTED_MODULE_12__modules_saleTag__["a" /* default */],
    contactTag: __WEBPACK_IMPORTED_MODULE_13__modules_contactTag__["a" /* default */],
    communicationTemplate: __WEBPACK_IMPORTED_MODULE_14__modules_communicationTemplate__["a" /* default */],
    userGroup: __WEBPACK_IMPORTED_MODULE_15__modules_userGroup__["a" /* default */],
    itemCategory: __WEBPACK_IMPORTED_MODULE_16__modules_itemCategory__["a" /* default */],
    tailoringCollection: __WEBPACK_IMPORTED_MODULE_17__modules_tailoringCollection__["a" /* default */],
    tailoringSize: __WEBPACK_IMPORTED_MODULE_18__modules_tailoringSize__["a" /* default */],
    measurementTemplate: __WEBPACK_IMPORTED_MODULE_19__modules_measurementTemplate__["a" /* default */],
    productionStage: __WEBPACK_IMPORTED_MODULE_20__modules_productionStage__["a" /* default */],
    tailoringMaster: __WEBPACK_IMPORTED_MODULE_21__modules_tailoringMaster__["a" /* default */],
    leaveMaster: __WEBPACK_IMPORTED_MODULE_22__modules_leaveMaster__["a" /* default */],
    overtimeMaster: __WEBPACK_IMPORTED_MODULE_23__modules_overtimeMaster__["a" /* default */],
    holidayMaster: __WEBPACK_IMPORTED_MODULE_24__modules_holidayMaster__["a" /* default */],
    designationMaster: __WEBPACK_IMPORTED_MODULE_25__modules_designationMaster__["a" /* default */],
    employee: __WEBPACK_IMPORTED_MODULE_26__modules_employee__["a" /* default */],
    genericContact: __WEBPACK_IMPORTED_MODULE_27__modules_genericContact__["a" /* default */],
    teamList: __WEBPACK_IMPORTED_MODULE_28__modules_teamList__["a" /* default */],
    leaveApplication: __WEBPACK_IMPORTED_MODULE_29__modules_leaveApplication__["a" /* default */],
    attendanceEntry: __WEBPACK_IMPORTED_MODULE_30__modules_attendanceEntry__["a" /* default */],
    bankMaster: __WEBPACK_IMPORTED_MODULE_31__modules_bankMaster__["a" /* default */],
    paymentMode: __WEBPACK_IMPORTED_MODULE_32__modules_paymentMode__["a" /* default */],
    currencyExchange: __WEBPACK_IMPORTED_MODULE_33__modules_currencyExchange__["a" /* default */],
    expenseCategory: __WEBPACK_IMPORTED_MODULE_34__modules_expenseCategory__["a" /* default */],
    expenseJournal: __WEBPACK_IMPORTED_MODULE_35__modules_expenseJournal__["a" /* default */],
    contraEntry: __WEBPACK_IMPORTED_MODULE_36__modules_contraEntry__["a" /* default */],
    fabricPriceSlab: __WEBPACK_IMPORTED_MODULE_37__modules_fabricPriceSlab__["a" /* default */],
    inventoryVariant: __WEBPACK_IMPORTED_MODULE_38__modules_inventoryVariant__["a" /* default */],
    vendorMaster: __WEBPACK_IMPORTED_MODULE_39__modules_vendorMaster__["a" /* default */],
    inventoryMaster: __WEBPACK_IMPORTED_MODULE_40__modules_inventoryMaster__["a" /* default */],
    inventoryOrder: __WEBPACK_IMPORTED_MODULE_41__modules_inventoryOrder__["a" /* default */],
    inventoryInvoice: __WEBPACK_IMPORTED_MODULE_42__modules_inventoryInvoice__["a" /* default */],
    vendorPayment: __WEBPACK_IMPORTED_MODULE_43__modules_vendorPayment__["a" /* default */],
    inventoryIntraBranch: __WEBPACK_IMPORTED_MODULE_44__modules_inventoryIntraBranch__["a" /* default */],
    inventorySourcing: __WEBPACK_IMPORTED_MODULE_45__modules_inventorySourcing__["a" /* default */],
    inventoryStockCheck: __WEBPACK_IMPORTED_MODULE_46__modules_inventoryStockCheck__["a" /* default */],
    customerMaster: __WEBPACK_IMPORTED_MODULE_47__modules_customerMaster__["a" /* default */],
    saleMaster: __WEBPACK_IMPORTED_MODULE_48__modules_saleMaster__["a" /* default */],
    customerPayment: __WEBPACK_IMPORTED_MODULE_49__modules_customerPayment__["a" /* default */],
    workOrder: __WEBPACK_IMPORTED_MODULE_50__modules_workOrder__["a" /* default */],
    giftCard: __WEBPACK_IMPORTED_MODULE_51__modules_giftCard__["a" /* default */],
    saleDelivery: __WEBPACK_IMPORTED_MODULE_52__modules_saleDelivery__["a" /* default */],
    production: __WEBPACK_IMPORTED_MODULE_53__modules_production__["a" /* default */],
    productionItemIssue: __WEBPACK_IMPORTED_MODULE_54__modules_productionItemIssue__["a" /* default */],
    transferWorkOrder: __WEBPACK_IMPORTED_MODULE_55__modules_transferWorkOrder__["a" /* default */],
    productionOutsource: __WEBPACK_IMPORTED_MODULE_56__modules_productionOutsource__["a" /* default */],
    inventorySeparation: __WEBPACK_IMPORTED_MODULE_57__modules_inventorySeparation__["a" /* default */],
    discountCoupon: __WEBPACK_IMPORTED_MODULE_58__modules_discountCoupon__["a" /* default */],
    productionCapacity: __WEBPACK_IMPORTED_MODULE_59__modules_productionCapacity__["a" /* default */],
    employeeLoan: __WEBPACK_IMPORTED_MODULE_60__modules_employeeLoan__["a" /* default */],
    employeePayroll: __WEBPACK_IMPORTED_MODULE_61__modules_employeePayroll__["a" /* default */],
    inventoryRack: __WEBPACK_IMPORTED_MODULE_62__modules_inventoryRack__["a" /* default */],
    measurementMaster: __WEBPACK_IMPORTED_MODULE_63__modules_measurementMaster__["a" /* default */],
    assetMaster: __WEBPACK_IMPORTED_MODULE_64__modules_assetMaster__["a" /* default */],
    bankStatement: __WEBPACK_IMPORTED_MODULE_65__modules_bankStatement__["a" /* default */],
    tasks: __WEBPACK_IMPORTED_MODULE_66__modules_tasks__["a" /* default */],
    shipmentPartner: __WEBPACK_IMPORTED_MODULE_67__modules_shipmentPartner__["a" /* default */],
    handloomCluster: __WEBPACK_IMPORTED_MODULE_68__modules_handloomCluster__["a" /* default */],
    expenseBill: __WEBPACK_IMPORTED_MODULE_69__modules_expenseBill__["a" /* default */],
    letterTemplate: __WEBPACK_IMPORTED_MODULE_70__modules_letterTemplate__["a" /* default */],
    lostDamaged: __WEBPACK_IMPORTED_MODULE_71__modules_lostDamaged__["a" /* default */],
    eStoreOrder: __WEBPACK_IMPORTED_MODULE_72__modules_eStoreOrder__["a" /* default */],
    news: __WEBPACK_IMPORTED_MODULE_73__modules_news__["a" /* default */],
    eStoreCatalog: __WEBPACK_IMPORTED_MODULE_74__modules_eStoreCatalog__["a" /* default */],
    dataBackup: __WEBPACK_IMPORTED_MODULE_75__modules_dataBackup__["a" /* default */],
    tailoringTrialType: __WEBPACK_IMPORTED_MODULE_76__modules_tailoringTrialType__["a" /* default */],
    campaign: __WEBPACK_IMPORTED_MODULE_77__modules_campaign__["a" /* default */],
    eStoreCategory: __WEBPACK_IMPORTED_MODULE_78__modules_eStoreCategory__["a" /* default */],
    eStoreTopMenu: __WEBPACK_IMPORTED_MODULE_79__modules_eStoreTopMenu__["a" /* default */],
    eStoreProduct: __WEBPACK_IMPORTED_MODULE_80__modules_eStoreProduct__["a" /* default */],
    eStoreHomePage: __WEBPACK_IMPORTED_MODULE_81__modules_eStoreHomePage__["a" /* default */]
  }
}));

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin(Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if (options === void 0) options = {};

      options.init = options.init ? [vuexInit].concat(options.init) : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit() {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function' ? options.store() : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin(store) {
  if (!devtoolHook) {
    return;
  }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj, cache) {
  if (cache === void 0) cache = [];

  // just return if obj is immutable value
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
    return obj;
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

function isPromise(val) {
  return val && typeof val.then === 'function';
}

function assert(condition, msg) {
  if (!condition) {
    throw new Error("[vuex] " + msg);
  }
}

function partial(fn, arg) {
  return function () {
    return fn(arg);
  };
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module(rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced;
};

Module.prototype.addChild = function addChild(key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild(key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild(key) {
  return this._children[key];
};

Module.prototype.hasChild = function hasChild(key) {
  return key in this._children;
};

Module.prototype.update = function update(rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild(fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter(fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction(fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation(fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties(Module.prototype, prototypeAccessors);

var ModuleCollection = function ModuleCollection(rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get(path) {
  return path.reduce(function (module, key) {
    return module.getChild(key);
  }, this.root);
};

ModuleCollection.prototype.getNamespace = function getNamespace(path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '');
  }, '');
};

ModuleCollection.prototype.update = function update$1(rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
  var this$1 = this;
  if (runtime === void 0) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if (false) {
      console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
    }
    return;
  }

  if (!child.runtime) {
    return;
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered(path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key);
  }

  return false;
};

function update(path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
        }
        return;
      }
      update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
  }
}

var functionAssert = {
  assert: function assert(value) {
    return typeof value === 'function';
  },
  expected: 'function'
};

var objectAssert = {
  assert: function assert(value) {
    return typeof value === 'function' || (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && typeof value.handler === 'function';
  },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule(path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) {
      return;
    }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(assertOptions.assert(value), makeAssertionMessage(path, key, type, value, assertOptions.expected));
    });
  });
}

function makeAssertionMessage(path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + path.join('.') + "\"";
  }
  buf += " is " + JSON.stringify(value) + ".";
  return buf;
}

var Vue; // bind on install

var Store = function Store(options) {
  var this$1 = this;
  if (options === void 0) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins;if (plugins === void 0) plugins = [];
  var strict = options.strict;if (strict === void 0) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch(type, payload) {
    return dispatch.call(store, type, payload);
  };
  this.commit = function boundCommit(type, payload, options) {
    return commit.call(store, type, payload, options);
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) {
    return plugin(this$1);
  });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state;
};

prototypeAccessors$1.state.set = function (v) {
  if (false) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit(_type, _payload, _options) {
  var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
  var type = ref.type;
  var payload = ref.payload;
  var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown mutation type: " + type);
    }
    return;
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator(handler) {
      handler(payload);
    });
  });

  this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
  .forEach(function (sub) {
    return sub(mutation, this$1.state);
  });

  if (false) {
    console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
  }
};

Store.prototype.dispatch = function dispatch(_type, _payload) {
  var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
  var type = ref.type;
  var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error("[vuex] unknown action type: " + type);
    }
    return;
  }

  try {
    this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .filter(function (sub) {
      return sub.before;
    }).forEach(function (sub) {
      return sub.before(action, this$1.state);
    });
  } catch (e) {
    if (false) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1 ? Promise.all(entry.map(function (handler) {
    return handler(payload);
  })) : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.after;
        }).forEach(function (sub) {
          return sub.after(action, this$1.state);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers.filter(function (sub) {
          return sub.error;
        }).forEach(function (sub) {
          return sub.error(action, this$1.state, error);
        });
      } catch (e) {
        if (false) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  });
};

Store.prototype.subscribe = function subscribe(fn, options) {
  return genericSubscribe(fn, this._subscribers, options);
};

Store.prototype.subscribeAction = function subscribeAction(fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options);
};

Store.prototype.watch = function watch(getter, cb, options) {
  var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () {
    return getter(this$1.state, this$1.getters);
  }, cb, options);
};

Store.prototype.replaceState = function replaceState(state) {
  var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule(path, rawModule, options) {
  if (options === void 0) options = {};

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule(path) {
  var this$1 = this;

  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule(path) {
  if (typeof path === 'string') {
    path = [path];
  }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path);
};

Store.prototype.hotUpdate = function hotUpdate(newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit(fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties(Store.prototype, prototypeAccessors$1);

function genericSubscribe(fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend ? subs.unshift(fn) : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  };
}

function resetStore(store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM(store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function get() {
        return store._vm[key];
      },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () {
      return oldVm.$destroy();
    });
  }
}

function installModule(store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && "production" !== 'production') {
      console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if (false) {
        if (moduleName in parentState) {
          console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext(store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
          return;
        }
      }

      return store.dispatch(type, payload);
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
          return;
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace ? function () {
        return store.getters;
      } : function () {
        return makeLocalGetters(store, namespace);
      }
    },
    state: {
      get: function get() {
        return getNestedState(store.state, path);
      }
    }
  });

  return local;
}

function makeLocalGetters(store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) {
        return;
      }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function get() {
          return store.getters[type];
        },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace];
}

function registerMutation(store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler(payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction(store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler(payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err;
      });
    } else {
      return res;
    }
  });
}

function registerGetter(store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error("[vuex] duplicate getter key: " + type);
    }
    return;
  }
  store._wrappedGetters[type] = function wrappedGetter(store) {
    return rawGetter(local.state, // local state
    local.getters, // local getters
    store.state, // root state
    store.getters // root getters
    );
  };
}

function enableStrictMode(store) {
  store._vm.$watch(function () {
    return this._data.$$state;
  }, function () {
    if (false) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState(state, path) {
  return path.reduce(function (state, key) {
    return state[key];
  }, state);
}

function unifyObjectStyle(type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', "expects string as the type, but found " + (typeof type === 'undefined' ? 'undefined' : _typeof(type)) + ".");
  }

  return { type: type, payload: payload, options: options };
}

function install(_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error('[vuex] already installed. Vue.use(Vuex) should be called only once.');
    }
    return;
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState() {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return;
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function' ? val.call(this, state, getters) : state[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return;
        }
        commit = module.context.commit;
      }
      return typeof val === 'function' ? val.apply(this, [commit].concat(args)) : commit.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter() {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return;
      }
      if (false) {
        console.error("[vuex] unknown getter: " + val);
        return;
      }
      return this.$store.getters[val];
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res;
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction() {
      var args = [],
          len = arguments.length;
      while (len--) {
        args[len] = arguments[len];
      } // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return;
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function' ? val.apply(this, [dispatch].concat(args)) : dispatch.apply(this.$store, [val].concat(args));
    };
  });
  return res;
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function createNamespacedHelpers(namespace) {
  return {
    mapState: mapState.bind(null, namespace),
    mapGetters: mapGetters.bind(null, namespace),
    mapMutations: mapMutations.bind(null, namespace),
    mapActions: mapActions.bind(null, namespace)
  };
};

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap(map) {
  if (!isValidMap(map)) {
    return [];
  }
  return Array.isArray(map) ? map.map(function (key) {
    return { key: key, val: key };
  }) : Object.keys(map).map(function (key) {
    return { key: key, val: map[key] };
  });
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap(map) {
  return Array.isArray(map) || isObject(map);
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace(fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map);
  };
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace(store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
  }
  return module;
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger(ref) {
  if (ref === void 0) ref = {};
  var collapsed = ref.collapsed;if (collapsed === void 0) collapsed = true;
  var filter = ref.filter;if (filter === void 0) filter = function filter(mutation, stateBefore, stateAfter) {
    return true;
  };
  var transformer = ref.transformer;if (transformer === void 0) transformer = function transformer(state) {
    return state;
  };
  var mutationTransformer = ref.mutationTransformer;if (mutationTransformer === void 0) mutationTransformer = function mutationTransformer(mut) {
    return mut;
  };
  var actionFilter = ref.actionFilter;if (actionFilter === void 0) actionFilter = function actionFilter(action, state) {
    return true;
  };
  var actionTransformer = ref.actionTransformer;if (actionTransformer === void 0) actionTransformer = function actionTransformer(act) {
    return act;
  };
  var logMutations = ref.logMutations;if (logMutations === void 0) logMutations = true;
  var logActions = ref.logActions;if (logActions === void 0) logActions = true;
  var logger = ref.logger;if (logger === void 0) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return;
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + mutation.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + action.type + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  };
}

function startMessage(logger, message, collapsed) {
  var startMessage = collapsed ? logger.groupCollapsed : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage(logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime() {
  var time = new Date();
  return " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__master_actions__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__master_mutations__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__master_getters__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__master_properties__ = __webpack_require__(1285);






var state = {
    accessToken: null,
    encrypted_key: '',
    trial_account: false,
    custom_domain: '',
    google_sync_enabled: false,
    days_left: 0,
    sms_credit: 0,
    accessibleModules: [],
    userInformation: null,
    country_list: [],
    province_list: [],
    city_list: [],
    tally_group: [],
    tally_sub_group: [],
    e_store_menu_list: [],
    communication_variables: [],
    master_module_list: [],
    fabric_width_list: [],
    store_list: [],
    salutation_list: [],
    uom_list: [],
    fabric_gsm_list: [],
    user_group_alert: null,
    loadingState: true,
    machineId: null,
    breadcrumbs: [{ icon: 'el-icon-s-home', target: '/' }],
    login: {
        user_name: '',
        password: ''
    },
    allow_addition_of_store: 0,
    access_rights: {
        can_view: false,
        can_add: false,
        can_edit: false,
        can_delete: false,
        allow_limited_list_view: false
    },
    currency_format: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__master_properties__["a" /* currencyProps */])),
    default_page_limit: 10,
    max_discount_allowed: 0,
    enable_e_payment: false,
    dashboard: {
        date_range: [new Date(new Date().getFullYear(), new Date().getMonth() - 3, new Date().getDate()), new Date()],
        selected_store_id: 0,
        response: null
    },
    search_query_list: [],
    task_calendar_events: [],
    task_calendar_event_list: [],
    bookmark_list: [],
    master_customer_search_result: null,
    device_token: null,
    tally_import: null,
    shipment_partner_list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__master_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__master_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__master_actions__
});

/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "masterLogin", function() { return masterLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forgotPassword", function() { return forgotPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateGoogleAuthURL", function() { return generateGoogleAuthURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateGoogleAccessToken", function() { return generateGoogleAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkAccessToken", function() { return checkAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initiatePushNotification", function() { return initiatePushNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerOrCheckDevice", function() { return registerOrCheckDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changePassword", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePageLimit", function() { return updatePageLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTallyGroup", function() { return loadTallyGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTallySubGroup", function() { return loadTallySubGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadCountryList", function() { return loadCountryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadProvinceList", function() { return loadProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadCityList", function() { return loadCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadCommunicationVariables", function() { return loadCommunicationVariables; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadMasterModuleList", function() { return loadMasterModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFabricWidthList", function() { return loadFabricWidthList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadShipmentPartner", function() { return loadShipmentPartner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSalutation", function() { return loadSalutation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUOMMasterList", function() { return loadUOMMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFabricGSMList", function() { return loadFabricGSMList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreMenuList", function() { return fetchEStoreMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadDashboard", function() { return loadDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveBookmark", function() { return saveBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBookmarks", function() { return fetchBookmarks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveMasterSearchQuery", function() { return saveMasterSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMasterSearchQuery", function() { return fetchMasterSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMasterSearchQuery", function() { return deleteMasterSearchQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMonthlyAppointments", function() { return fetchMonthlyAppointments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadAppointmentList", function() { return loadAppointmentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyInformation", function() { return copyInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downloadCSV", function() { return downloadCSV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadTallyData", function() { return loadTallyData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pushy_sdk_web__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pushy_sdk_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pushy_sdk_web__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }





var login = function login(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/index.php', payload).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token);
            dispatch('checkAccessToken', { navigate: true });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var masterLogin = function masterLogin(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/appAdmin/masterLogin.php', payload).then(function (res) {

        if (res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token);
            dispatch('checkAccessToken', { navigate: true });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error-1', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-2' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var forgotPassword = function forgotPassword(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/forgotPassword.php', payload).then(function (res) {

        if (res.data.status) {
            commit('displayMessageAlert', { message: res.data.message, type: 'Message', displayHTML: true });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var generateGoogleAuthURL = function generateGoogleAuthURL(_ref4) {
    var commit = _ref4.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/googleSync/contact/generateAuthURL.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            //commit('setGoogleAuthCode', res.data.response)
            var popupWinWidth = 400;
            var popupWinHeight = 400;

            var left = (screen.width - popupWinWidth) / 2;
            var top = (screen.height - popupWinHeight) / 4;

            window.open(res.data.response, "Google Auth", 'resizable=yes, width=' + popupWinWidth + ', height=' + popupWinHeight + ', top=' + top + ', left=' + left);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    });
};

var generateGoogleAccessToken = function generateGoogleAccessToken(_ref5, payload) {
    var commit = _ref5.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/googleSync/contact/generateAccessToken.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displayMessageAlert', { message: "Google contact is now synced, please refresh the app to see the sync status.", type: 'Message', displayHTML: true });
            window.close();
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Message', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    });
};

var checkAccessToken = function checkAccessToken(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    console.log(JSON.stringify(__WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()));
    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/login/checkAccessToken.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('loadCountryList');
        dispatch('loadShipmentPartner');
        dispatch('fetchBookmarks');
        dispatch('loadTallyGroup');
        dispatch('loadTallySubGroup');
        if (res.data.status) {

            var response = res.data;
            response.navigate = payload.navigate;
            if (payload.device_token !== undefined && payload.device_token.length > 5) {
                dispatch('registerOrCheckDevice', { tenant_id: response.tenant_id, user_id: response.user_id, machine_id: payload.device_token });
            } else {
                dispatch('initiatePushNotification', { tenant_id: response.tenant_id, user_id: response.user_id });
            }
            commit('setAccessToken', response);
        } else {
            if (res.data.message !== undefined && res.data.message.length > 0) {
                commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
            }
            dispatch('logout');
        }
    }).catch(function (error) {
        console.log(error);
        //commit('displayMessageAlert', {message: error, type: 'Error-3'})
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var initiatePushNotification = function initiatePushNotification(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;


    /** REGISTER OR CHECK DEVICE **/
    __WEBPACK_IMPORTED_MODULE_2_pushy_sdk_web___default.a.register({ appId: '629d9ae4ca130a4f54f56b2b' }).then(function (deviceToken) {

        __WEBPACK_IMPORTED_MODULE_2_pushy_sdk_web___default.a.setNotificationListener(function (data) {

            commit('displayMessageAlert', { message: data.message, type: 'Alert' });
        });
        localStorage.setItem('device_token_id', deviceToken);
        var deviceTokenPayload = { tenant_id: payload.tenant_id, user_id: payload.user_id, machine_id: deviceToken };
        dispatch('registerOrCheckDevice', deviceTokenPayload);
    }).catch(function (err) {
        //commit('displayMessageAlert', {message: err+' We strongly recommend you to use Chrome, Opera or Mozilla to seamlessly receive alerts on this device. In addition, if you have activated ad-blockers, it may result in non-delivery of alerts on this device.', type: 'Error-Device-Reg'})
        dispatch('registerOrCheckDevice', { tenant_id: payload.tenant_id, user_id: payload.user_id, machine_id: 'NA' });
    });
    /** END **/
};

var registerOrCheckDevice = function registerOrCheckDevice(_ref8, payload) {
    var commit = _ref8.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/registerDevice.php', payload).then(function (res) {

        console.log(JSON.stringify(res.data));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-3' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var changePassword = function changePassword(_ref9, payload) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/changePassword.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('logout');
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updatePageLimit = function updatePageLimit(_ref10, payload) {
    var commit = _ref10.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/preferences/updatePageLimit.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setMasterPageLimit', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/*** MASTER DATA ***/

var loadTallyGroup = function loadTallyGroup(_ref11, payload) {
    var commit = _ref11.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadTallyGroup.php', payload).then(function (res) {

        commit('setTallyGroup', res.data.tally_group_list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadTallySubGroup = function loadTallySubGroup(_ref12) {
    var commit = _ref12.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/masterData/loadTallySubGroup.php').then(function (res) {

        commit('setTallySubGroup', res.data.tally_sub_group_list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadCountryList = function loadCountryList(_ref13) {
    var commit = _ref13.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/masterData/loadCountryList.php').then(function (res) {
        //console.log(JSON.stringify(res.data))
        commit('setCountryList', res.data.country_list);
    }).catch(function (error) {
        console.log(JSON.stringify(error));
        commit('displayMessageAlert', { message: "Error " + error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadProvinceList = function loadProvinceList(_ref14, payload) {
    var commit = _ref14.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadProvinceList.php', payload).then(function (res) {

        commit('setProvinceList', res.data.province_list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadCityList = function loadCityList(_ref15, payload) {
    var commit = _ref15.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadCityList.php', payload).then(function (res) {

        commit('setCityList', res.data.city_list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadCommunicationVariables = function loadCommunicationVariables(_ref16, payload) {
    var commit = _ref16.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadCommunicationVariables.php', payload).then(function (res) {

        commit('setCommunicationList', res.data.communication_variables);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadMasterModuleList = function loadMasterModuleList(_ref17, payload) {
    var commit = _ref17.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadMasterModuleList.php', payload).then(function (res) {

        commit('setMasterModuleList', res.data.module_list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadFabricWidthList = function loadFabricWidthList(_ref18, payload) {
    var commit = _ref18.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadFabricWidthList.php', payload).then(function (res) {

        commit('setFabricWidthList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadShipmentPartner = function loadShipmentPartner(_ref19, payload) {
    var commit = _ref19.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadShipmentPartner.php', payload).then(function (res) {

        commit('setTrackingShipmentPartnerList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadSalutation = function loadSalutation(_ref20, payload) {
    var commit = _ref20.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/masterData/loadSalutation.php', payload).then(function (res) {

        commit('setSalutationList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadUOMMasterList = function loadUOMMasterList(_ref21) {
    var commit = _ref21.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/masterData/loadUOMMasterList.php').then(function (res) {

        commit('setUOMList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadFabricGSMList = function loadFabricGSMList(_ref22) {
    var commit = _ref22.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/masterData/loadFabricGSMList.php').then(function (res) {

        commit('setFabricGSMList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEStoreMenuList = function fetchEStoreMenuList(_ref23) {
    var commit = _ref23.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/masterData/eStoreMenuList.php').then(function (res) {
        commit('setEStoreMenuList', res.data.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadDashboard = function loadDashboard(_ref24, payload) {
    var commit = _ref24.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/dashboard/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setDashboard', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-Dashboard' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var saveBookmark = function saveBookmark(_ref25, payload) {
    var commit = _ref25.commit,
        dispatch = _ref25.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/bookmark/saveBookmark.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('fetchBookmarks');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchBookmarks = function fetchBookmarks(_ref26) {
    var commit = _ref26.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/login/bookmark/fetchBookmarks.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setBookmarkList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var saveMasterSearchQuery = function saveMasterSearchQuery(_ref27, payload) {
    var commit = _ref27.commit,
        dispatch = _ref27.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/saveMasterSearchQuery.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('fetchMasterSearchQuery', { page_id: payload.page_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchMasterSearchQuery = function fetchMasterSearchQuery(_ref28, payload) {
    var commit = _ref28.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/fetchMasterSearchQuery.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setMasterQueryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteMasterSearchQuery = function deleteMasterSearchQuery(_ref29, payload) {
    var commit = _ref29.commit,
        dispatch = _ref29.dispatch;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/login/deleteMasterSearchQuery.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        dispatch('fetchMasterSearchQuery', { page_id: payload.page_id });
        commit('toggleLoadingState', true);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/*** END MASTER DATA ***/

var logout = function logout(_ref30) {
    var commit = _ref30.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/login/logout.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('clearAuthData');
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchMonthlyAppointments = function fetchMonthlyAppointments(_ref31, payload) {
    var commit = _ref31.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/dashboard/taskCalendar.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTaskCalendar', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadAppointmentList = function loadAppointmentList(_ref32, payload) {
    var commit = _ref32.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/dashboard/taskCalendarEventList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTaskCalendarEventList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var copyInformation = function copyInformation(_ref33, payload) {
    var commit = _ref33.commit;


    commit('toggleLoadingState', true);
    /*ipcRenderer.invoke('copyToClipboard', { data: payload }).then( () => {
        commit('displaySuccessNotification', {message: 'Data Copied!!!'});
    })*/
    navigator.clipboard.writeText(payload);
    setTimeout(function () {
        commit('displaySuccessNotification', { message: 'Data Copied!!!' });
    }, 200);

    commit('toggleLoadingState', false);
};

var downloadCSV = function downloadCSV(_ref34, payload) {
    _objectDestructuringEmpty(_ref34);

    var items = payload.data;

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);

    var array = (typeof jsonObject === 'undefined' ? 'undefined' : _typeof(jsonObject)) != 'object' ? JSON.parse(jsonObject) : jsonObject;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ',';

            var strValue = array[i][index];
            //strValue.length>0 ? strValue : ' '

            line += strValue; //.replace(',', ' ');
        }

        str += line + '\r\n';
    }

    var csv = str;

    var uri = 'data:text/csv;charset=utf-8,' + escape(csv);
    var link = document.getElementById('csvLink');
    link.href = uri;
    link.download = payload.title + ".csv";
    link.click();
};

var loadTallyData = function loadTallyData(_ref35, payload) {
    var commit = _ref35.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(payload.url, payload.request, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTallyImport', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-access-token' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Pushy = t() : e.Pushy = t();
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;var o = r[n] = { exports: {}, id: n, loaded: !1 };return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
    }var r = {};return t.m = e, t.c = r, t.p = "build/", t(0);
  }([function (e, t, r) {
    "use strict";
    function n(e) {
      return e && e.__esModule ? e : { default: e };
    }var o = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
      return typeof e === "undefined" ? "undefined" : _typeof(e);
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeof(e);
    },
        i = r(2),
        a = n(i),
        s = r(1),
        u = n(s),
        c = r(3),
        l = n(c),
        f = r(5),
        d = n(f),
        p = { register: function register(e) {
        var t = this;return new d.default(function (r, n) {
          var i, s, c, f, d, p, h, y, m, b, v, g, w;return regeneratorRuntime.async(function (x) {
            for (;;) {
              switch (x.prev = x.next) {case 0:
                  if (e && "object" === ("undefined" == typeof e ? "undefined" : o(e)) || (e = {}), "serviceWorker" in navigator && "PushManager" in window) {
                    x.next = 3;break;
                  }return x.abrupt("return", n(new Error("Web push is not supported by this browser.")));case 3:
                  if ("undefined" != typeof localStorage) {
                    x.next = 5;break;
                  }return x.abrupt("return", n(new Error("Local storage is not supported by this browser.")));case 5:
                  return i = e.serviceWorkerFile || u.default.serviceWorker.fileName, s = { scope: e.serviceWorkerScope || "./" }, c = void 0, x.prev = 8, x.next = 11, regeneratorRuntime.awrap(navigator.serviceWorker.register("/" + i, s));case 11:
                  c = x.sent, x.next = 17;break;case 14:
                  return x.prev = 14, x.t0 = x.catch(8), x.abrupt("return", n(new Error("Failed to load '" + window.location.origin + "/" + i + "': " + x.t0.message, x.t0)));case 17:
                  return x.next = 19, regeneratorRuntime.awrap(navigator.serviceWorker.ready);case 19:
                  return x.next = 21, regeneratorRuntime.awrap(c.pushManager.getSubscription());case 21:
                  if (f = x.sent) {
                    x.next = 37;break;
                  }return d = t.isEnterpriseConfigured() ? u.default.vapidDetails.enterprisePublicKey : u.default.vapidDetails.publicKey, x.prev = 24, x.next = 27, regeneratorRuntime.awrap(c.pushManager.subscribe({ userVisibleOnly: !0, applicationServerKey: l.default.urlB64ToUint8Array(d) }));case 27:
                  f = x.sent, x.next = 35;break;case 30:
                  if (x.prev = 30, x.t1 = x.catch(24), !navigator.brave || x.t1.message.indexOf("push service error") === -1) {
                    x.next = 34;break;
                  }return x.abrupt("return", n(new Error('Please enable "Use Google Services for Push Messaging" in Brave settings to use this feature', x.t1)));case 34:
                  return x.abrupt("return", n(new Error("Failed to subscribe the device: " + x.t1.message, x.t1)));case 35:
                  x.next = 50;break;case 37:
                  if (p = localStorage.getItem(u.default.localStorageKeys.token), h = localStorage.getItem(u.default.localStorageKeys.tokenAuth), y = localStorage.getItem(u.default.localStorageKeys.tokenAppId), p && y && e.appId && "string" == typeof y && y !== e.appId && (p = void 0), !p || !h) {
                    x.next = 50;break;
                  }return x.prev = 42, x.next = 45, regeneratorRuntime.awrap(t.validateDeviceCredentials());case 45:
                  return x.abrupt("return", r(p));case 48:
                  x.prev = 48, x.t2 = x.catch(42);case 50:
                  if (f = JSON.parse(JSON.stringify(f)), m = f.keys.auth, b = f.keys.p256dh, v = f.endpoint, b && m && v) {
                    x.next = 56;break;
                  }return x.abrupt("return", n(new Error("The push subscription is missing a required field.")));case 56:
                  return g = { sdk: u.default.version, platform: u.default.platform, subscription: { endpoint: v, key: b, auth: m } }, e.appId ? g.appId = e.appId : g.app = window.location.hostname, w = void 0, x.prev = 59, x.next = 62, regeneratorRuntime.awrap(a.default.post("/register", g));case 62:
                  w = x.sent, x.next = 68;break;case 65:
                  return x.prev = 65, x.t3 = x.catch(59), x.abrupt("return", n(new Error("The API request failed: " + x.t3.message, x.t3)));case 68:
                  if (w.token && w.auth) {
                    x.next = 70;break;
                  }return x.abrupt("return", n(new Error("An unexpected response was received from the Pushy API.")));case 70:
                  localStorage.setItem(u.default.localStorageKeys.token, w.token), localStorage.setItem(u.default.localStorageKeys.tokenAuth, w.auth), e.appId && localStorage.setItem(u.default.localStorageKeys.tokenAppId, e.appId), r(w.token);case 74:case "end":
                  return x.stop();}
            }
          }, null, t, [[8, 14], [24, 30], [42, 48], [59, 65]]);
        });
      }, setNotificationListener: function setNotificationListener(e) {
        navigator.serviceWorker.addEventListener("message", function (t) {
          t.data && t.data._pushy && e(t.data);
        });
      }, isRegistered: function isRegistered() {
        var e = localStorage.getItem(u.default.localStorageKeys.token),
            t = localStorage.getItem(u.default.localStorageKeys.tokenAuth);return e && t;
      }, subscribe: function subscribe(e) {
        var t = this;return new d.default(function (r, n) {
          var o, i, s, c;return regeneratorRuntime.async(function (t) {
            for (;;) {
              switch (t.prev = t.next) {case 0:
                  if ("undefined" != typeof localStorage) {
                    t.next = 2;break;
                  }return t.abrupt("return", n(new Error("Local storage is not supported by this browser.")));case 2:
                  if (o = localStorage.getItem(u.default.localStorageKeys.token), i = localStorage.getItem(u.default.localStorageKeys.tokenAuth), o && i) {
                    t.next = 6;break;
                  }return t.abrupt("return", n(new Error("This device is not registered to receive push notifications.")));case 6:
                  return "string" == typeof e && (e = [e]), s = { token: o, auth: i, topics: e }, c = void 0, t.prev = 9, t.next = 12, regeneratorRuntime.awrap(a.default.post("/devices/subscribe", s));case 12:
                  c = t.sent, t.next = 18;break;case 15:
                  return t.prev = 15, t.t0 = t.catch(9), t.abrupt("return", n(new Error("The API request failed: " + t.t0.message, t.t0)));case 18:
                  if (c.success) {
                    t.next = 20;break;
                  }return t.abrupt("return", n(new Error("An unexpected response was received from the Pushy API.")));case 20:
                  r();case 21:case "end":
                  return t.stop();}
            }
          }, null, t, [[9, 15]]);
        });
      }, unsubscribe: function unsubscribe(e) {
        var t = this;return new d.default(function (r, n) {
          var o, i, s, c;return regeneratorRuntime.async(function (t) {
            for (;;) {
              switch (t.prev = t.next) {case 0:
                  if ("undefined" != typeof localStorage) {
                    t.next = 2;break;
                  }return t.abrupt("return", n(new Error("Local storage is not supported by this browser.")));case 2:
                  if (o = localStorage.getItem(u.default.localStorageKeys.token), i = localStorage.getItem(u.default.localStorageKeys.tokenAuth), o && i) {
                    t.next = 6;break;
                  }return t.abrupt("return", n(new Error("This device is not registered to receive push notifications.")));case 6:
                  return "string" == typeof e && (e = [e]), s = { token: o, auth: i, topics: e }, c = void 0, t.prev = 9, t.next = 12, regeneratorRuntime.awrap(a.default.post("/devices/unsubscribe", s));case 12:
                  c = t.sent, t.next = 18;break;case 15:
                  return t.prev = 15, t.t0 = t.catch(9), t.abrupt("return", n(new Error("The API request failed: " + t.t0.message, t.t0)));case 18:
                  if (c.success) {
                    t.next = 20;break;
                  }return t.abrupt("return", n(new Error("An unexpected response was received from the Pushy API.")));case 20:
                  r();case 21:case "end":
                  return t.stop();}
            }
          }, null, t, [[9, 15]]);
        });
      }, validateDeviceCredentials: function validateDeviceCredentials() {
        var e = this;return new d.default(function (t, r) {
          var n, o, i, s;return regeneratorRuntime.async(function (c) {
            for (;;) {
              switch (c.prev = c.next) {case 0:
                  if (e.attemptedValidation = !0, "undefined" != typeof localStorage) {
                    c.next = 3;break;
                  }return c.abrupt("return", r(new Error("Local storage is not supported by this browser.")));case 3:
                  if (n = localStorage.getItem(u.default.localStorageKeys.token), o = localStorage.getItem(u.default.localStorageKeys.tokenAuth), n && o) {
                    c.next = 7;break;
                  }return c.abrupt("return", r(new Error("The device is not registered to receive push notifications.")));case 7:
                  return i = { sdk: u.default.version, token: n, auth: o }, s = void 0, c.prev = 9, c.next = 12, regeneratorRuntime.awrap(a.default.post("/devices/auth", i));case 12:
                  s = c.sent, c.next = 18;break;case 15:
                  return c.prev = 15, c.t0 = c.catch(9), c.abrupt("return", r(new Error("The API request failed: " + c.t0.message, c.t0)));case 18:
                  if (s.success) {
                    c.next = 20;break;
                  }return c.abrupt("return", r(new Error("An unexpected response was received from the Pushy API.")));case 20:
                  t();case 21:case "end":
                  return c.stop();}
            }
          }, null, e, [[9, 15]]);
        });
      }, isEnterpriseConfigured: function isEnterpriseConfigured() {
        return void 0 != localStorage.getItem(u.default.localStorageKeys.enterpriseEndpoint);
      }, setEnterpriseConfig: function setEnterpriseConfig(e) {
        "string" == typeof e && "/" === e.substr(-1) && (e = e.substr(0, e.length - 1));var t = localStorage.getItem(u.default.localStorageKeys.enterpriseEndpoint);e != t && (localStorage.removeItem(u.default.localStorageKeys.token), localStorage.removeItem(u.default.localStorageKeys.tokenAuth), localStorage.removeItem(u.default.localStorageKeys.tokenAppId), localStorage.setItem(u.default.localStorageKeys.enterpriseEndpoint, e));
      } };setTimeout(function () {
      p.isRegistered() && (p.attemptedValidation || p.validateDeviceCredentials().catch(function (e) {
        console.error("Device validation failed", e);
      }));
    }, u.default.logic.deviceValidationDelay), e.exports = p;
  }, function (e, t) {
    "use strict";
    e.exports = { version: 1008, platform: "web", api: { endpoint: "https://api.pushy.me", devEndpoint: "http://localhost:3001" }, vapidDetails: { publicKey: "BMHDCTp0zHPUj9snbHxwQZh2ppoypdOpuAQtBjf2Gj9KKwCHCcN_f2GFzwmzohRWYUPVcR0psb5VQTnGy-gY8iE", enterprisePublicKey: "BDZ1EQHwxF3dFQ5LccxKD5rdOPlO5iLLIAbxxm-1fIuMLQQcXa_UUD8CRja_iBmlmlQZsookpGnHaSTsbb-Rglo" }, localStorageKeys: { token: "pushyToken", tokenAuth: "pushyTokenAuth", tokenAppId: "pushyTokenAppId", enterpriseEndpoint: "pushyEnterpriseEndpoint" }, serviceWorker: { fileName: "service-worker.js" }, logic: { deviceValidationDelay: 5e3 } };
  }, function (e, t, r) {
    "use strict";
    function n(e) {
      return e && e.__esModule ? e : { default: e };
    }Object.defineProperty(t, "__esModule", { value: !0 }), r(8);var o = r(1),
        i = n(o);t.default = { get: function get(e, t) {
        return regeneratorRuntime.async(function (r) {
          for (;;) {
            switch (r.prev = r.next) {case 0:
                return r.next = 2, regeneratorRuntime.awrap(this.execute(e, t || {}));case 2:
                return r.abrupt("return", r.sent);case 3:case "end":
                return r.stop();}
          }
        }, null, this);
      }, post: function post(e, t, r) {
        return regeneratorRuntime.async(function (n) {
          for (;;) {
            switch (n.prev = n.next) {case 0:
                return r = r || {}, r.method = "POST", r.body = JSON.stringify(t), r.headers = { "Content-Type": "application/json" }, n.next = 6, regeneratorRuntime.awrap(this.execute(e, r));case 6:
                return n.abrupt("return", n.sent);case 7:case "end":
                return n.stop();}
          }
        }, null, this);
      }, execute: function execute(e, t) {
        var r, n, o, i;return regeneratorRuntime.async(function (a) {
          for (;;) {
            switch (a.prev = a.next) {case 0:
                return r = this.getApiHost() + e, a.next = 3, regeneratorRuntime.awrap(fetch(r, t));case 3:
                if (n = a.sent, !(n.status < 200 || n.status > 299)) {
                  a.next = 10;break;
                }return a.next = 7, regeneratorRuntime.awrap(n.json());case 7:
                throw o = a.sent, i = o.error || "An unknown error occurred", { status: n.status, message: i };case 10:
                return a.next = 12, regeneratorRuntime.awrap(n.json());case 12:
                return a.abrupt("return", a.sent);case 13:case "end":
                return a.stop();}
          }
        }, null, this);
      }, getApiHost: function getApiHost() {
        var e = localStorage.getItem(i.default.localStorageKeys.enterpriseEndpoint);return e || i.default.api.endpoint;
      } };
  }, function (e, t) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { urlB64ToUint8Array: function urlB64ToUint8Array(e) {
        for (var t = "=".repeat((4 - e.length % 4) % 4), r = (e + t).replace(/\-/g, "+").replace(/_/g, "/"), n = window.atob(r), o = new Uint8Array(n.length), i = 0; i < n.length; ++i) {
          o[i] = n.charCodeAt(i);
        }return o;
      } };
  }, function (e, t) {
    function r() {
      throw new Error("setTimeout has not been defined");
    }function n() {
      throw new Error("clearTimeout has not been defined");
    }function o(e) {
      if (l === setTimeout) return setTimeout(e, 0);if ((l === r || !l) && setTimeout) return l = setTimeout, setTimeout(e, 0);try {
        return l(e, 0);
      } catch (t) {
        try {
          return l.call(null, e, 0);
        } catch (t) {
          return l.call(this, e, 0);
        }
      }
    }function i(e) {
      if (f === clearTimeout) return clearTimeout(e);if ((f === n || !f) && clearTimeout) return f = clearTimeout, clearTimeout(e);try {
        return f(e);
      } catch (t) {
        try {
          return f.call(null, e);
        } catch (t) {
          return f.call(this, e);
        }
      }
    }function a() {
      y && p && (y = !1, p.length ? h = p.concat(h) : m = -1, h.length && s());
    }function s() {
      if (!y) {
        var e = o(a);y = !0;for (var t = h.length; t;) {
          for (p = h, h = []; ++m < t;) {
            p && p[m].run();
          }m = -1, t = h.length;
        }p = null, y = !1, i(e);
      }
    }function u(e, t) {
      this.fun = e, this.array = t;
    }function c() {}var l,
        f,
        d = e.exports = {};!function () {
      try {
        l = "function" == typeof setTimeout ? setTimeout : r;
      } catch (e) {
        l = r;
      }try {
        f = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (e) {
        f = n;
      }
    }();var p,
        h = [],
        y = !1,
        m = -1;d.nextTick = function (e) {
      var t = new Array(arguments.length - 1);if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        t[r - 1] = arguments[r];
      }h.push(new u(e, t)), 1 !== h.length || y || o(s);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, d.title = "browser", d.browser = !0, d.env = {}, d.argv = [], d.version = "", d.versions = {}, d.on = c, d.addListener = c, d.once = c, d.off = c, d.removeListener = c, d.removeAllListeners = c, d.emit = c, d.prependListener = c, d.prependOnceListener = c, d.listeners = function (e) {
      return [];
    }, d.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, d.cwd = function () {
      return "/";
    }, d.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, d.umask = function () {
      return 0;
    };
  }, function (e, t, r) {
    (function (t) {
      !function (r) {
        function n() {}function o(e, t) {
          return function () {
            e.apply(t, arguments);
          };
        }function i(e) {
          if ("object" != _typeof(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof e) throw new TypeError("not a function");this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], f(e, this);
        }function a(e, t) {
          for (; 3 === e._state;) {
            e = e._value;
          }return 0 === e._state ? void e._deferreds.push(t) : (e._handled = !0, void i._immediateFn(function () {
            var r = 1 === e._state ? t.onFulfilled : t.onRejected;if (null === r) return void (1 === e._state ? s : u)(t.promise, e._value);var n;try {
              n = r(e._value);
            } catch (e) {
              return void u(t.promise, e);
            }s(t.promise, n);
          }));
        }function s(e, t) {
          try {
            if (t === e) throw new TypeError("A promise cannot be resolved with itself.");if (t && ("object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) || "function" == typeof t)) {
              var r = t.then;if (t instanceof i) return e._state = 3, e._value = t, void c(e);if ("function" == typeof r) return void f(o(r, t), e);
            }e._state = 1, e._value = t, c(e);
          } catch (t) {
            u(e, t);
          }
        }function u(e, t) {
          e._state = 2, e._value = t, c(e);
        }function c(e) {
          2 === e._state && 0 === e._deferreds.length && i._immediateFn(function () {
            e._handled || i._unhandledRejectionFn(e._value);
          });for (var t = 0, r = e._deferreds.length; t < r; t++) {
            a(e, e._deferreds[t]);
          }e._deferreds = null;
        }function l(e, t, r) {
          this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = r;
        }function f(e, t) {
          var r = !1;try {
            e(function (e) {
              r || (r = !0, s(t, e));
            }, function (e) {
              r || (r = !0, u(t, e));
            });
          } catch (e) {
            if (r) return;r = !0, u(t, e);
          }
        }var d = setTimeout;i.prototype.catch = function (e) {
          return this.then(null, e);
        }, i.prototype.then = function (e, t) {
          var r = new this.constructor(n);return a(this, new l(e, t, r)), r;
        }, i.all = function (e) {
          var t = Array.prototype.slice.call(e);return new i(function (e, r) {
            function n(i, a) {
              try {
                if (a && ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) || "function" == typeof a)) {
                  var s = a.then;if ("function" == typeof s) return void s.call(a, function (e) {
                    n(i, e);
                  }, r);
                }t[i] = a, 0 === --o && e(t);
              } catch (e) {
                r(e);
              }
            }if (0 === t.length) return e([]);for (var o = t.length, i = 0; i < t.length; i++) {
              n(i, t[i]);
            }
          });
        }, i.resolve = function (e) {
          return e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.constructor === i ? e : new i(function (t) {
            t(e);
          });
        }, i.reject = function (e) {
          return new i(function (t, r) {
            r(e);
          });
        }, i.race = function (e) {
          return new i(function (t, r) {
            for (var n = 0, o = e.length; n < o; n++) {
              e[n].then(t, r);
            }
          });
        }, i._immediateFn = "function" == typeof t && function (e) {
          t(e);
        } || function (e) {
          d(e, 0);
        }, i._unhandledRejectionFn = function (e) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
        }, i._setImmediateFn = function (e) {
          i._immediateFn = e;
        }, i._setUnhandledRejectionFn = function (e) {
          i._unhandledRejectionFn = e;
        }, "undefined" != typeof e && e.exports ? e.exports = i : r.Promise || (r.Promise = i);
      }(this);
    }).call(t, r(7).setImmediate);
  }, function (e, t, r) {
    (function (e, t) {
      !function (e, r) {
        "use strict";
        function n(e) {
          "function" != typeof e && (e = new Function("" + e));for (var t = new Array(arguments.length - 1), r = 0; r < t.length; r++) {
            t[r] = arguments[r + 1];
          }var n = { callback: e, args: t };return y[h] = n, p(h), h++;
        }function o(e) {
          delete y[e];
        }function i(e) {
          var t = e.callback,
              n = e.args;switch (n.length) {case 0:
              t();break;case 1:
              t(n[0]);break;case 2:
              t(n[0], n[1]);break;case 3:
              t(n[0], n[1], n[2]);break;default:
              t.apply(r, n);}
        }function a(e) {
          if (m) setTimeout(a, 0, e);else {
            var t = y[e];if (t) {
              m = !0;try {
                i(t);
              } finally {
                o(e), m = !1;
              }
            }
          }
        }function s() {
          p = function p(e) {
            t.nextTick(function () {
              a(e);
            });
          };
        }function u() {
          if (e.postMessage && !e.importScripts) {
            var t = !0,
                r = e.onmessage;return e.onmessage = function () {
              t = !1;
            }, e.postMessage("", "*"), e.onmessage = r, t;
          }
        }function c() {
          var t = "setImmediate$" + Math.random() + "$",
              r = function r(_r) {
            _r.source === e && "string" == typeof _r.data && 0 === _r.data.indexOf(t) && a(+_r.data.slice(t.length));
          };e.addEventListener ? e.addEventListener("message", r, !1) : e.attachEvent("onmessage", r), p = function p(r) {
            e.postMessage(t + r, "*");
          };
        }function l() {
          var e = new MessageChannel();e.port1.onmessage = function (e) {
            var t = e.data;a(t);
          }, p = function p(t) {
            e.port2.postMessage(t);
          };
        }function f() {
          var e = b.documentElement;p = function p(t) {
            var r = b.createElement("script");r.onreadystatechange = function () {
              a(t), r.onreadystatechange = null, e.removeChild(r), r = null;
            }, e.appendChild(r);
          };
        }function d() {
          p = function p(e) {
            setTimeout(a, 0, e);
          };
        }if (!e.setImmediate) {
          var p,
              h = 1,
              y = {},
              m = !1,
              b = e.document,
              v = Object.getPrototypeOf && Object.getPrototypeOf(e);v = v && v.setTimeout ? v : e, "[object process]" === {}.toString.call(e.process) ? s() : u() ? c() : e.MessageChannel ? l() : b && "onreadystatechange" in b.createElement("script") ? f() : d(), v.setImmediate = n, v.clearImmediate = o;
        }
      }("undefined" == typeof self ? "undefined" == typeof e ? this : e : self);
    }).call(t, function () {
      return this;
    }(), r(4));
  }, function (e, t, r) {
    function n(e, t) {
      this._id = e, this._clearFn = t;
    }var o = Function.prototype.apply;t.setTimeout = function () {
      return new n(o.call(setTimeout, window, arguments), clearTimeout);
    }, t.setInterval = function () {
      return new n(o.call(setInterval, window, arguments), clearInterval);
    }, t.clearTimeout = t.clearInterval = function (e) {
      e && e.close();
    }, n.prototype.unref = n.prototype.ref = function () {}, n.prototype.close = function () {
      this._clearFn.call(window, this._id);
    }, t.enroll = function (e, t) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = t;
    }, t.unenroll = function (e) {
      clearTimeout(e._idleTimeoutId), e._idleTimeout = -1;
    }, t._unrefActive = t.active = function (e) {
      clearTimeout(e._idleTimeoutId);var t = e._idleTimeout;t >= 0 && (e._idleTimeoutId = setTimeout(function () {
        e._onTimeout && e._onTimeout();
      }, t));
    }, r(6), t.setImmediate = setImmediate, t.clearImmediate = clearImmediate;
  }, function (e, t) {
    !function (e) {
      "use strict";
      function t(e) {
        if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");return e.toLowerCase();
      }function r(e) {
        return "string" != typeof e && (e = String(e)), e;
      }function n(e) {
        var t = { next: function next() {
            var t = e.shift();return { done: void 0 === t, value: t };
          } };return b.iterable && (t[Symbol.iterator] = function () {
          return t;
        }), t;
      }function o(e) {
        this.map = {}, e instanceof o ? e.forEach(function (e, t) {
          this.append(t, e);
        }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
          this.append(t, e[t]);
        }, this);
      }function i(e) {
        return e.bodyUsed ? Promise.reject(new TypeError("Already read")) : void (e.bodyUsed = !0);
      }function a(e) {
        return new Promise(function (t, r) {
          e.onload = function () {
            t(e.result);
          }, e.onerror = function () {
            r(e.error);
          };
        });
      }function s(e) {
        var t = new FileReader(),
            r = a(t);return t.readAsArrayBuffer(e), r;
      }function u(e) {
        var t = new FileReader(),
            r = a(t);return t.readAsText(e), r;
      }function c(e) {
        for (var t = new Uint8Array(e), r = new Array(t.length), n = 0; n < t.length; n++) {
          r[n] = String.fromCharCode(t[n]);
        }return r.join("");
      }function l(e) {
        if (e.slice) return e.slice(0);var t = new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)), t.buffer;
      }function f() {
        return this.bodyUsed = !1, this._initBody = function (e) {
          if (this._bodyInit = e, e) {
            if ("string" == typeof e) this._bodyText = e;else if (b.blob && Blob.prototype.isPrototypeOf(e)) this._bodyBlob = e;else if (b.formData && FormData.prototype.isPrototypeOf(e)) this._bodyFormData = e;else if (b.searchParams && URLSearchParams.prototype.isPrototypeOf(e)) this._bodyText = e.toString();else if (b.arrayBuffer && b.blob && g(e)) this._bodyArrayBuffer = l(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
              if (!b.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(e) && !w(e)) throw new Error("unsupported BodyInit type");this._bodyArrayBuffer = l(e);
            }
          } else this._bodyText = "";this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : b.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
        }, b.blob && (this.blob = function () {
          var e = i(this);if (e) return e;if (this._bodyBlob) return Promise.resolve(this._bodyBlob);if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));if (this._bodyFormData) throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]));
        }, this.arrayBuffer = function () {
          return this._bodyArrayBuffer ? i(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(s);
        }), this.text = function () {
          var e = i(this);if (e) return e;if (this._bodyBlob) return u(this._bodyBlob);if (this._bodyArrayBuffer) return Promise.resolve(c(this._bodyArrayBuffer));if (this._bodyFormData) throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText);
        }, b.formData && (this.formData = function () {
          return this.text().then(h);
        }), this.json = function () {
          return this.text().then(JSON.parse);
        }, this;
      }function d(e) {
        var t = e.toUpperCase();return x.indexOf(t) > -1 ? t : e;
      }function p(e, t) {
        t = t || {};var r = t.body;if ("string" == typeof e) this.url = e;else {
          if (e.bodyUsed) throw new TypeError("Already read");this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new o(e.headers)), this.method = e.method, this.mode = e.mode, r || null == e._bodyInit || (r = e._bodyInit, e.bodyUsed = !0);
        }if (this.credentials = t.credentials || this.credentials || "omit", !t.headers && this.headers || (this.headers = new o(t.headers)), this.method = d(t.method || this.method || "GET"), this.mode = t.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && r) throw new TypeError("Body not allowed for GET or HEAD requests");this._initBody(r);
      }function h(e) {
        var t = new FormData();return e.trim().split("&").forEach(function (e) {
          if (e) {
            var r = e.split("="),
                n = r.shift().replace(/\+/g, " "),
                o = r.join("=").replace(/\+/g, " ");t.append(decodeURIComponent(n), decodeURIComponent(o));
          }
        }), t;
      }function y(e) {
        var t = new o();return e.split("\r\n").forEach(function (e) {
          var r = e.split(":"),
              n = r.shift().trim();if (n) {
            var o = r.join(":").trim();t.append(n, o);
          }
        }), t;
      }function m(e, t) {
        t || (t = {}), this.type = "default", this.status = "status" in t ? t.status : 200, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new o(t.headers), this.url = t.url || "", this._initBody(e);
      }if (!e.fetch) {
        var b = { searchParams: "URLSearchParams" in e, iterable: "Symbol" in e && "iterator" in Symbol, blob: "FileReader" in e && "Blob" in e && function () {
            try {
              return new Blob(), !0;
            } catch (e) {
              return !1;
            }
          }(), formData: "FormData" in e, arrayBuffer: "ArrayBuffer" in e };if (b.arrayBuffer) var v = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
            g = function g(e) {
          return e && DataView.prototype.isPrototypeOf(e);
        },
            w = ArrayBuffer.isView || function (e) {
          return e && v.indexOf(Object.prototype.toString.call(e)) > -1;
        };o.prototype.append = function (e, n) {
          e = t(e), n = r(n);var o = this.map[e];o || (o = [], this.map[e] = o), o.push(n);
        }, o.prototype.delete = function (e) {
          delete this.map[t(e)];
        }, o.prototype.get = function (e) {
          var r = this.map[t(e)];return r ? r[0] : null;
        }, o.prototype.getAll = function (e) {
          return this.map[t(e)] || [];
        }, o.prototype.has = function (e) {
          return this.map.hasOwnProperty(t(e));
        }, o.prototype.set = function (e, n) {
          this.map[t(e)] = [r(n)];
        }, o.prototype.forEach = function (e, t) {
          Object.getOwnPropertyNames(this.map).forEach(function (r) {
            this.map[r].forEach(function (n) {
              e.call(t, n, r, this);
            }, this);
          }, this);
        }, o.prototype.keys = function () {
          var e = [];return this.forEach(function (t, r) {
            e.push(r);
          }), n(e);
        }, o.prototype.values = function () {
          var e = [];return this.forEach(function (t) {
            e.push(t);
          }), n(e);
        }, o.prototype.entries = function () {
          var e = [];return this.forEach(function (t, r) {
            e.push([r, t]);
          }), n(e);
        }, b.iterable && (o.prototype[Symbol.iterator] = o.prototype.entries);var x = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];p.prototype.clone = function () {
          return new p(this, { body: this._bodyInit });
        }, f.call(p.prototype), f.call(m.prototype), m.prototype.clone = function () {
          return new m(this._bodyInit, { status: this.status, statusText: this.statusText, headers: new o(this.headers), url: this.url });
        }, m.error = function () {
          var e = new m(null, { status: 0, statusText: "" });return e.type = "error", e;
        };var _ = [301, 302, 303, 307, 308];m.redirect = function (e, t) {
          if (_.indexOf(t) === -1) throw new RangeError("Invalid status code");return new m(null, { status: t, headers: { location: e } });
        }, e.Headers = o, e.Request = p, e.Response = m, e.fetch = function (e, t) {
          return new Promise(function (r, n) {
            var o = new p(e, t),
                i = new XMLHttpRequest();i.onload = function () {
              var e = { status: i.status, statusText: i.statusText, headers: y(i.getAllResponseHeaders() || "") };e.url = "responseURL" in i ? i.responseURL : e.headers.get("X-Request-URL");var t = "response" in i ? i.response : i.responseText;r(new m(t, e));
            }, i.onerror = function () {
              n(new TypeError("Network request failed"));
            }, i.ontimeout = function () {
              n(new TypeError("Network request failed"));
            }, i.open(o.method, o.url, !0), "include" === o.credentials && (i.withCredentials = !0), "responseType" in i && b.blob && (i.responseType = "blob"), o.headers.forEach(function (e, t) {
              i.setRequestHeader(t, e);
            }), i.send("undefined" == typeof o._bodyInit ? null : o._bodyInit);
          });
        }, e.fetch.polyfill = !0;
      }
    }("undefined" != typeof self ? self : this);
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(143).setImmediate, __webpack_require__(143).clearImmediate, __webpack_require__(68)(module)))

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearAuthData", function() { return clearAuthData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAccessRights", function() { return setAccessRights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAccessToken", function() { return setAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMasterPageLimit", function() { return setMasterPageLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCountryList", function() { return setCountryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreMenuList", function() { return setEStoreMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProvinceList", function() { return setProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCityList", function() { return setCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProvinceList", function() { return resetProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCityList", function() { return resetCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSalutationList", function() { return setSalutationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMachineId", function() { return setMachineId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleLoadingState", function() { return toggleLoadingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayErrorNotification", function() { return displayErrorNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displaySuccessNotification", function() { return displaySuccessNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "displayMessageAlert", function() { return displayMessageAlert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendBreadcrumbs", function() { return appendBreadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCommunicationList", function() { return setCommunicationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMasterModuleList", function() { return setMasterModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFabricWidthList", function() { return setFabricWidthList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrencyProps", function() { return setCurrencyProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUOMList", function() { return setUOMList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFabricGSMList", function() { return setFabricGSMList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDashboard", function() { return setDashboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMasterQueryList", function() { return setMasterQueryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskCalendar", function() { return setTaskCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskCalendarEventList", function() { return setTaskCalendarEventList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBookmarkList", function() { return setBookmarkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDeviceToken", function() { return setDeviceToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTallyGroup", function() { return setTallyGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTallySubGroup", function() { return setTallySubGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTallyImport", function() { return setTallyImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTrackingShipmentPartnerList", function() { return setTrackingShipmentPartnerList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);



var clearAuthData = function clearAuthData(state) {
    //if(state.accessToken !== null) {
    __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/login');
    state.accessToken = null;
    localStorage.removeItem('accessToken');
    window.location.reload();
    //}
    //
};

var setAccessRights = function setAccessRights(state, payload) {
    state.access_rights = payload;
};

var setAccessToken = function setAccessToken(state, payload) {
    //let originalAccessToken = localStorage.getItem('accessToken')

    state.encrypted_key = payload.encrypted_key;
    if (!payload.account_active) {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/accountexpired');
        return;
    }
    state.trial_account = payload.trial_account;
    state.custom_domain = payload.custom_domain;
    state.google_sync_enabled = payload.google_sync_enabled;
    state.sms_credit = payload.sms_credit;
    state.shipment_credit = payload.shipment_credit;
    state.accessToken = payload.access_token;
    state.days_left = payload.days_left;
    localStorage.setItem('accessToken', payload.access_token);
    state.login.user_id = '';
    state.login.password = '';
    state.allow_addition_of_store = payload.allow_addition_of_store;
    state.accessibleModules = payload.accessible_modules;
    state.deviceDevModeActive = payload.device_dev_mode_active;
    state.userInformation = payload.user_information;
    state.store_list = payload.store_access;
    state.user_group_alert = payload.user_group_alert;
    state.currency_format = payload.country_detail;
    state.default_page_limit = payload.default_page_limit;
    state.enable_e_payment = payload.enable_e_payment;

    if (payload.navigate) {
        __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/');
    }

    /*ipcRenderer.invoke('setMainMenu', { menuList: payload.accessible_modules, device_dev_mode_active: payload.device_dev_mode_active, isAuthActive: true }).then( () => {
        
    })*/
};

var setMasterPageLimit = function setMasterPageLimit(state, payload) {
    state.default_page_limit = payload.limit;
};

var setCountryList = function setCountryList(state, payload) {
    state.country_list = payload;
};

var setEStoreMenuList = function setEStoreMenuList(state, payload) {
    state.e_store_menu_list = payload;
};

var setProvinceList = function setProvinceList(state, payload) {
    state.province_list = payload;
};

var setCityList = function setCityList(state, payload) {
    state.city_list = payload;
};

var resetProvinceList = function resetProvinceList(state) {
    state.province_list = [];
};

var resetCityList = function resetCityList(state) {
    state.city_list = [];
};

var setSalutationList = function setSalutationList(state, payload) {
    state.salutation_list = payload;
};

var setMachineId = function setMachineId(state, payload) {
    state.machineId = payload;
};

var toggleLoadingState = function toggleLoadingState(state, payload) {
    state.loadingState = payload;
    //
    if (payload) {
        __WEBPACK_IMPORTED_MODULE_1_element_ui__["Message"].warning({
            message: 'Please wait while processing...',
            duration: 0
        });
    } else {
        __WEBPACK_IMPORTED_MODULE_1_element_ui__["Message"].closeAll();
    }
};

var displayErrorNotification = function displayErrorNotification(state, payload) {

    state.loading = false;

    __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].error({
        title: "Error",
        message: payload.message,
        duration: 2000
    });
};

var displaySuccessNotification = function displaySuccessNotification(state, payload) {

    state.loading = false;

    __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].success({
        title: "Success",
        message: payload.message,
        duration: 2000
    });
};

var displayMessageAlert = function displayMessageAlert(state, payload) {

    state.loading = false;

    __WEBPACK_IMPORTED_MODULE_1_element_ui__["MessageBox"].alert(payload.message, payload.type, {
        dangerouslyUseHTMLString: payload.displayHTML ? true : false
    });
};

var appendBreadcrumbs = function appendBreadcrumbs(state, payload) {
    state.breadcrumbs = [{ icon: 'el-icon-s-home', target: '/' }];
    payload.forEach(function (element) {
        state.breadcrumbs.push(element);
    });
};

var setCommunicationList = function setCommunicationList(state, payload) {

    state.communication_variables = payload;
};

var setMasterModuleList = function setMasterModuleList(state, payload) {
    state.master_module_list = payload;
};

var setFabricWidthList = function setFabricWidthList(state, payload) {
    state.fabric_width_list = payload;
};

var setCurrencyProps = function setCurrencyProps(state, payload) {
    if (payload.type === 1) {
        state.currency_format_1 = payload.format;
    } else if (payload.type === 2) {
        state.currency_format_2 = payload.format;
    }
};

var setUOMList = function setUOMList(state, payload) {
    state.uom_list = payload;
};

var setFabricGSMList = function setFabricGSMList(state, payload) {
    state.fabric_gsm_list = payload;
};

var setDashboard = function setDashboard(state, payload) {
    state.dashboard.response = payload;
};

var setMasterQueryList = function setMasterQueryList(state, payload) {
    state.search_query_list = payload;
};

var setTaskCalendar = function setTaskCalendar(state, payload) {
    state.task_calendar_events = payload;
};

var setTaskCalendarEventList = function setTaskCalendarEventList(state, payload) {
    state.task_calendar_event_list = payload;
};

var setBookmarkList = function setBookmarkList(state, payload) {
    state.bookmark_list = payload;
};

var setDeviceToken = function setDeviceToken(state, payload) {
    state.device_token = payload;
};

var setTallyGroup = function setTallyGroup(state, payload) {
    state.tally_group = payload;
};

var setTallySubGroup = function setTallySubGroup(state, payload) {
    state.tally_sub_group = payload;
};

var setTallyImport = function setTallyImport(state, payload) {
    state.tally_import = payload;
};

var setTrackingShipmentPartnerList = function setTrackingShipmentPartnerList(state, payload) {
    state.shipment_partner_list = payload;
};

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.validateRangeInOneMonth = exports.extractTimeFormat = exports.extractDateFormat = exports.nextYear = exports.prevYear = exports.nextMonth = exports.prevMonth = exports.changeYearMonthAndClampDate = exports.timeWithinRange = exports.limitTimeRange = exports.clearMilliseconds = exports.clearTime = exports.modifyWithTimeString = exports.modifyTime = exports.modifyDate = exports.range = exports.getRangeMinutes = exports.getMonthDays = exports.getPrevMonthLastDays = exports.getRangeHours = exports.getWeekNumber = exports.getStartDateOfMonth = exports.nextDate = exports.prevDate = exports.getFirstDayOfMonth = exports.getDayCountOfYear = exports.getDayCountOfMonth = exports.parseDate = exports.formatDate = exports.isDateObject = exports.isDate = exports.toDate = exports.getI18nSettings = undefined;

var _date = __webpack_require__(286);

var _date2 = _interopRequireDefault(_date);

var _locale = __webpack_require__(145);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var weeks = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

var newArray = function newArray(start, end) {
  var result = [];
  for (var i = start; i <= end; i++) {
    result.push(i);
  }
  return result;
};

var getI18nSettings = exports.getI18nSettings = function getI18nSettings() {
  return {
    dayNamesShort: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    dayNames: weeks.map(function (week) {
      return (0, _locale.t)('el.datepicker.weeks.' + week);
    }),
    monthNamesShort: months.map(function (month) {
      return (0, _locale.t)('el.datepicker.months.' + month);
    }),
    monthNames: months.map(function (month, index) {
      return (0, _locale.t)('el.datepicker.month' + (index + 1));
    }),
    amPm: ['am', 'pm']
  };
};

var toDate = exports.toDate = function toDate(date) {
  return isDate(date) ? new Date(date) : null;
};

var isDate = exports.isDate = function isDate(date) {
  if (date === null || date === undefined) return false;
  if (isNaN(new Date(date).getTime())) return false;
  if (Array.isArray(date)) return false; // deal with `new Date([ new Date() ]) -> new Date()`
  return true;
};

var isDateObject = exports.isDateObject = function isDateObject(val) {
  return val instanceof Date;
};

var formatDate = exports.formatDate = function formatDate(date, format) {
  date = toDate(date);
  if (!date) return '';
  return _date2.default.format(date, format || 'yyyy-MM-dd', getI18nSettings());
};

var parseDate = exports.parseDate = function parseDate(string, format) {
  return _date2.default.parse(string, format || 'yyyy-MM-dd', getI18nSettings());
};

var getDayCountOfMonth = exports.getDayCountOfMonth = function getDayCountOfMonth(year, month) {
  if (month === 3 || month === 5 || month === 8 || month === 10) {
    return 30;
  }

  if (month === 1) {
    if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
      return 29;
    } else {
      return 28;
    }
  }

  return 31;
};

var getDayCountOfYear = exports.getDayCountOfYear = function getDayCountOfYear(year) {
  var isLeapYear = year % 400 === 0 || year % 100 !== 0 && year % 4 === 0;
  return isLeapYear ? 366 : 365;
};

var getFirstDayOfMonth = exports.getFirstDayOfMonth = function getFirstDayOfMonth(date) {
  var temp = new Date(date.getTime());
  temp.setDate(1);
  return temp.getDay();
};

// see: https://stackoverflow.com/questions/3674539/incrementing-a-date-in-javascript
// {prev, next} Date should work for Daylight Saving Time
// Adding 24 * 60 * 60 * 1000 does not work in the above scenario
var prevDate = exports.prevDate = function prevDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount);
};

var nextDate = exports.nextDate = function nextDate(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount);
};

var getStartDateOfMonth = exports.getStartDateOfMonth = function getStartDateOfMonth(year, month) {
  var result = new Date(year, month, 1);
  var day = result.getDay();

  if (day === 0) {
    return prevDate(result, 7);
  } else {
    return prevDate(result, day);
  }
};

var getWeekNumber = exports.getWeekNumber = function getWeekNumber(src) {
  if (!isDate(src)) return null;
  var date = new Date(src.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week 1.
  // Rounding should be fine for Daylight Saving Time. Its shift should never be more than 12 hours.
  return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};

var getRangeHours = exports.getRangeHours = function getRangeHours(ranges) {
  var hours = [];
  var disabledHours = [];

  (ranges || []).forEach(function (range) {
    var value = range.map(function (date) {
      return date.getHours();
    });

    disabledHours = disabledHours.concat(newArray(value[0], value[1]));
  });

  if (disabledHours.length) {
    for (var i = 0; i < 24; i++) {
      hours[i] = disabledHours.indexOf(i) === -1;
    }
  } else {
    for (var _i = 0; _i < 24; _i++) {
      hours[_i] = false;
    }
  }

  return hours;
};

var getPrevMonthLastDays = exports.getPrevMonthLastDays = function getPrevMonthLastDays(date, amount) {
  if (amount <= 0) return [];
  var temp = new Date(date.getTime());
  temp.setDate(0);
  var lastDay = temp.getDate();
  return range(amount).map(function (_, index) {
    return lastDay - (amount - index - 1);
  });
};

var getMonthDays = exports.getMonthDays = function getMonthDays(date) {
  var temp = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  var days = temp.getDate();
  return range(days).map(function (_, index) {
    return index + 1;
  });
};

function setRangeData(arr, start, end, value) {
  for (var i = start; i < end; i++) {
    arr[i] = value;
  }
}

var getRangeMinutes = exports.getRangeMinutes = function getRangeMinutes(ranges, hour) {
  var minutes = new Array(60);

  if (ranges.length > 0) {
    ranges.forEach(function (range) {
      var start = range[0];
      var end = range[1];
      var startHour = start.getHours();
      var startMinute = start.getMinutes();
      var endHour = end.getHours();
      var endMinute = end.getMinutes();
      if (startHour === hour && endHour !== hour) {
        setRangeData(minutes, startMinute, 60, true);
      } else if (startHour === hour && endHour === hour) {
        setRangeData(minutes, startMinute, endMinute + 1, true);
      } else if (startHour !== hour && endHour === hour) {
        setRangeData(minutes, 0, endMinute + 1, true);
      } else if (startHour < hour && endHour > hour) {
        setRangeData(minutes, 0, 60, true);
      }
    });
  } else {
    setRangeData(minutes, 0, 60, true);
  }
  return minutes;
};

var range = exports.range = function range(n) {
  // see https://stackoverflow.com/questions/3746725/create-a-javascript-array-containing-1-n
  return Array.apply(null, { length: n }).map(function (_, n) {
    return n;
  });
};

var modifyDate = exports.modifyDate = function modifyDate(date, y, m, d) {
  return new Date(y, m, d, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
};

var modifyTime = exports.modifyTime = function modifyTime(date, h, m, s) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), h, m, s, date.getMilliseconds());
};

var modifyWithTimeString = exports.modifyWithTimeString = function modifyWithTimeString(date, time) {
  if (date == null || !time) {
    return date;
  }
  time = parseDate(time, 'HH:mm:ss');
  return modifyTime(date, time.getHours(), time.getMinutes(), time.getSeconds());
};

var clearTime = exports.clearTime = function clearTime(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

var clearMilliseconds = exports.clearMilliseconds = function clearMilliseconds(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);
};

var limitTimeRange = exports.limitTimeRange = function limitTimeRange(date, ranges) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HH:mm:ss';

  // TODO: refactory a more elegant solution
  if (ranges.length === 0) return date;
  var normalizeDate = function normalizeDate(date) {
    return _date2.default.parse(_date2.default.format(date, format), format);
  };
  var ndate = normalizeDate(date);
  var nranges = ranges.map(function (range) {
    return range.map(normalizeDate);
  });
  if (nranges.some(function (nrange) {
    return ndate >= nrange[0] && ndate <= nrange[1];
  })) return date;

  var minDate = nranges[0][0];
  var maxDate = nranges[0][0];

  nranges.forEach(function (nrange) {
    minDate = new Date(Math.min(nrange[0], minDate));
    maxDate = new Date(Math.max(nrange[1], minDate));
  });

  var ret = ndate < minDate ? minDate : maxDate;
  // preserve Year/Month/Date
  return modifyDate(ret, date.getFullYear(), date.getMonth(), date.getDate());
};

var timeWithinRange = exports.timeWithinRange = function timeWithinRange(date, selectableRange, format) {
  var limitedDate = limitTimeRange(date, selectableRange, format);
  return limitedDate.getTime() === date.getTime();
};

var changeYearMonthAndClampDate = exports.changeYearMonthAndClampDate = function changeYearMonthAndClampDate(date, year, month) {
  // clamp date to the number of days in `year`, `month`
  // eg: (2010-1-31, 2010, 2) => 2010-2-28
  var monthDate = Math.min(date.getDate(), getDayCountOfMonth(year, month));
  return modifyDate(date, year, month, monthDate);
};

var prevMonth = exports.prevMonth = function prevMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 0 ? changeYearMonthAndClampDate(date, year - 1, 11) : changeYearMonthAndClampDate(date, year, month - 1);
};

var nextMonth = exports.nextMonth = function nextMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return month === 11 ? changeYearMonthAndClampDate(date, year + 1, 0) : changeYearMonthAndClampDate(date, year, month + 1);
};

var prevYear = exports.prevYear = function prevYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year - amount, month);
};

var nextYear = exports.nextYear = function nextYear(date) {
  var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var year = date.getFullYear();
  var month = date.getMonth();
  return changeYearMonthAndClampDate(date, year + amount, month);
};

var extractDateFormat = exports.extractDateFormat = function extractDateFormat(format) {
  return format.replace(/\W?m{1,2}|\W?ZZ/g, '').replace(/\W?h{1,2}|\W?s{1,3}|\W?a/gi, '').trim();
};

var extractTimeFormat = exports.extractTimeFormat = function extractTimeFormat(format) {
  return format.replace(/\W?D{1,2}|\W?Do|\W?d{1,4}|\W?M{1,4}|\W?y{2,4}/g, '').trim();
};

var validateRangeInOneMonth = exports.validateRangeInOneMonth = function validateRangeInOneMonth(start, end) {
  return start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();
};

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      // week: '周次',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '一月',
        feb: '二月',
        mar: '三月',
        apr: '四月',
        may: '五月',
        jun: '六月',
        jul: '七月',
        aug: '八月',
        sep: '九月',
        oct: '十月',
        nov: '十一月',
        dec: '十二月'
      }
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择'
    },
    cascader: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      noData: '暂无数据'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    },
    popconfirm: {
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    },
    empty: {
      description: '暂无数据'
    }
  }
};

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};

function isNonNullObject(value) {
    return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
}

function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);

    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return clone && isMergeableObject(value) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination;
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination;
}

function deepmerge(target, source, optionsArgument) {
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

    if (!sourceAndTargetTypesMatch) {
        return cloneIfNecessary(source, optionsArgument);
    } else if (sourceIsArray) {
        var arrayMerge = options.arrayMerge || defaultArrayMerge;
        return arrayMerge(target, source, optionsArgument);
    } else {
        return mergeObject(target, source, optionsArgument);
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
    });
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.default = function (Vue) {

  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = (0, _util.hasOwn)(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
};

var _util = __webpack_require__(38);

var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _vue = __webpack_require__(18);

var _vue2 = _interopRequireDefault(_vue);

var _dom = __webpack_require__(43);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var hasModal = false;
var hasInitZIndex = false;
var zIndex = void 0;

var getModal = function getModal() {
  if (_vue2.default.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (_vue2.default.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();

    (0, _dom.addClass)(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      (0, _dom.addClass)(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return (0, _dom.addClass)(modalDom, item);
      });
    }
    setTimeout(function () {
      (0, _dom.removeClass)(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return (0, _dom.removeClass)(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        (0, _dom.addClass)(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        (0, _dom.removeClass)(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      zIndex = zIndex || (_vue2.default.prototype.$ELEMENT || {}).zIndex || 2000;
      hasInitZIndex = true;
    }
    return zIndex;
  },
  set: function set(value) {
    zIndex = value;
  }
});

var getTopPopup = function getTopPopup() {
  if (_vue2.default.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!_vue2.default.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

exports.default = PopupManager;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

//
// Cross module loader
// Supported: Node, AMD, Browser globals
//
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.Popper = factory();
    }
})(undefined, function () {

    'use strict';

    var root = window;

    // default options
    var DEFAULTS = {
        // placement of the popper
        placement: 'bottom',

        gpuAcceleration: true,

        // shift popper from its origin by the given amount of pixels (can be negative)
        offset: 0,

        // the element which will act as boundary of the popper
        boundariesElement: 'viewport',

        // amount of pixel used to define a minimum distance between the boundaries and the popper
        boundariesPadding: 5,

        // popper will try to prevent overflow following this order,
        // by default, then, it could overflow on the left and on top of the boundariesElement
        preventOverflowOrder: ['left', 'right', 'top', 'bottom'],

        // the behavior used by flip to change the placement of the popper
        flipBehavior: 'flip',

        arrowElement: '[x-arrow]',

        arrowOffset: 0,

        // list of functions used to modify the offsets before they are applied to the popper
        modifiers: ['shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle'],

        modifiersIgnored: [],

        forceAbsolute: false
    };

    /**
     * Create a new Popper.js instance
     * @constructor Popper
     * @param {HTMLElement} reference - The reference element used to position the popper
     * @param {HTMLElement|Object} popper
     *      The HTML element used as popper, or a configuration used to generate the popper.
     * @param {String} [popper.tagName='div'] The tag name of the generated popper.
     * @param {Array} [popper.classNames=['popper']] Array of classes to apply to the generated popper.
     * @param {Array} [popper.attributes] Array of attributes to apply, specify `attr:value` to assign a value to it.
     * @param {HTMLElement|String} [popper.parent=window.document.body] The parent element, given as HTMLElement or as query string.
     * @param {String} [popper.content=''] The content of the popper, it can be text, html, or node; if it is not text, set `contentType` to `html` or `node`.
     * @param {String} [popper.contentType='text'] If `html`, the `content` will be parsed as HTML. If `node`, it will be appended as-is.
     * @param {String} [popper.arrowTagName='div'] Same as `popper.tagName` but for the arrow element.
     * @param {Array} [popper.arrowClassNames='popper__arrow'] Same as `popper.classNames` but for the arrow element.
     * @param {String} [popper.arrowAttributes=['x-arrow']] Same as `popper.attributes` but for the arrow element.
     * @param {Object} options
     * @param {String} [options.placement=bottom]
     *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -right),
     *      left(-start, -end)`
     *
     * @param {HTMLElement|String} [options.arrowElement='[x-arrow]']
     *      The DOM Node used as arrow for the popper, or a CSS selector used to get the DOM node. It must be child of
     *      its parent Popper. Popper.js will apply to the given element the style required to align the arrow with its
     *      reference element.
     *      By default, it will look for a child node of the popper with the `x-arrow` attribute.
     *
     * @param {Boolean} [options.gpuAcceleration=true]
     *      When this property is set to true, the popper position will be applied using CSS3 translate3d, allowing the
     *      browser to use the GPU to accelerate the rendering.
     *      If set to false, the popper will be placed using `top` and `left` properties, not using the GPU.
     *
     * @param {Number} [options.offset=0]
     *      Amount of pixels the popper will be shifted (can be negative).
     *
     * @param {String|Element} [options.boundariesElement='viewport']
     *      The element which will define the boundaries of the popper position, the popper will never be placed outside
     *      of the defined boundaries (except if `keepTogether` is enabled)
     *
     * @param {Number} [options.boundariesPadding=5]
     *      Additional padding for the boundaries
     *
     * @param {Array} [options.preventOverflowOrder=['left', 'right', 'top', 'bottom']]
     *      Order used when Popper.js tries to avoid overflows from the boundaries, they will be checked in order,
     *      this means that the last ones will never overflow
     *
     * @param {String|Array} [options.flipBehavior='flip']
     *      The behavior used by the `flip` modifier to change the placement of the popper when the latter is trying to
     *      overlap its reference element. Defining `flip` as value, the placement will be flipped on
     *      its axis (`right - left`, `top - bottom`).
     *      You can even pass an array of placements (eg: `['right', 'left', 'top']` ) to manually specify
     *      how alter the placement when a flip is needed. (eg. in the above example, it would first flip from right to left,
     *      then, if even in its new placement, the popper is overlapping its reference element, it will be moved to top)
     *
     * @param {Array} [options.modifiers=[ 'shift', 'offset', 'preventOverflow', 'keepTogether', 'arrow', 'flip', 'applyStyle']]
     *      List of functions used to modify the data before they are applied to the popper, add your custom functions
     *      to this array to edit the offsets and placement.
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Array} [options.modifiersIgnored=[]]
     *      Put here any built-in modifier name you want to exclude from the modifiers list
     *      The function should reflect the @params and @returns of preventOverflow
     *
     * @param {Boolean} [options.removeOnDestroy=false]
     *      Set to true if you want to automatically remove the popper when you call the `destroy` method.
     */
    function Popper(reference, popper, options) {
        this._reference = reference.jquery ? reference[0] : reference;
        this.state = {};

        // if the popper variable is a configuration object, parse it to generate an HTMLElement
        // generate a default popper if is not defined
        var isNotDefined = typeof popper === 'undefined' || popper === null;
        var isConfig = popper && Object.prototype.toString.call(popper) === '[object Object]';
        if (isNotDefined || isConfig) {
            this._popper = this.parse(isConfig ? popper : {});
        }
        // otherwise, use the given HTMLElement as popper
        else {
                this._popper = popper.jquery ? popper[0] : popper;
            }

        // with {} we create a new object with the options inside it
        this._options = Object.assign({}, DEFAULTS, options);

        // refactoring modifiers' list
        this._options.modifiers = this._options.modifiers.map(function (modifier) {
            // remove ignored modifiers
            if (this._options.modifiersIgnored.indexOf(modifier) !== -1) return;

            // set the x-placement attribute before everything else because it could be used to add margins to the popper
            // margins needs to be calculated to get the correct popper offsets
            if (modifier === 'applyStyle') {
                this._popper.setAttribute('x-placement', this._options.placement);
            }

            // return predefined modifier identified by string or keep the custom one
            return this.modifiers[modifier] || modifier;
        }.bind(this));

        // make sure to apply the popper position before any computation
        this.state.position = this._getPosition(this._popper, this._reference);
        setStyle(this._popper, { position: this.state.position, top: 0 });

        // fire the first update to position the popper in the right place
        this.update();

        // setup event listeners, they will take care of update the position in specific situations
        this._setupEventListeners();
        return this;
    }

    //
    // Methods
    //
    /**
     * Destroy the popper
     * @method
     * @memberof Popper
     */
    Popper.prototype.destroy = function () {
        this._popper.removeAttribute('x-placement');
        this._popper.style.left = '';
        this._popper.style.position = '';
        this._popper.style.top = '';
        this._popper.style[getSupportedPropertyName('transform')] = '';
        this._removeEventListeners();

        // remove the popper if user explicity asked for the deletion on destroy
        if (this._options.removeOnDestroy) {
            this._popper.remove();
        }
        return this;
    };

    /**
     * Updates the position of the popper, computing the new offsets and applying the new style
     * @method
     * @memberof Popper
     */
    Popper.prototype.update = function () {
        var data = { instance: this, styles: {} };

        // store placement inside the data object, modifiers will be able to edit `placement` if needed
        // and refer to _originalPlacement to know the original value
        data.placement = this._options.placement;
        data._originalPlacement = this._options.placement;

        // compute the popper and reference offsets and put them inside data.offsets
        data.offsets = this._getOffsets(this._popper, this._reference, data.placement);

        // get boundaries
        data.boundaries = this._getBoundaries(data, this._options.boundariesPadding, this._options.boundariesElement);

        data = this.runModifiers(data, this._options.modifiers);

        if (typeof this.state.updateCallback === 'function') {
            this.state.updateCallback(data);
        }
    };

    /**
     * If a function is passed, it will be executed after the initialization of popper with as first argument the Popper instance.
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onCreate = function (callback) {
        // the createCallbacks return as first argument the popper instance
        callback(this);
        return this;
    };

    /**
     * If a function is passed, it will be executed after each update of popper with as first argument the set of coordinates and informations
     * used to style popper and its arrow.
     * NOTE: it doesn't get fired on the first call of the `Popper.update()` method inside the `Popper` constructor!
     * @method
     * @memberof Popper
     * @param {Function} callback
     */
    Popper.prototype.onUpdate = function (callback) {
        this.state.updateCallback = callback;
        return this;
    };

    /**
     * Helper used to generate poppers from a configuration file
     * @method
     * @memberof Popper
     * @param config {Object} configuration
     * @returns {HTMLElement} popper
     */
    Popper.prototype.parse = function (config) {
        var defaultConfig = {
            tagName: 'div',
            classNames: ['popper'],
            attributes: [],
            parent: root.document.body,
            content: '',
            contentType: 'text',
            arrowTagName: 'div',
            arrowClassNames: ['popper__arrow'],
            arrowAttributes: ['x-arrow']
        };
        config = Object.assign({}, defaultConfig, config);

        var d = root.document;

        var popper = d.createElement(config.tagName);
        addClassNames(popper, config.classNames);
        addAttributes(popper, config.attributes);
        if (config.contentType === 'node') {
            popper.appendChild(config.content.jquery ? config.content[0] : config.content);
        } else if (config.contentType === 'html') {
            popper.innerHTML = config.content;
        } else {
            popper.textContent = config.content;
        }

        if (config.arrowTagName) {
            var arrow = d.createElement(config.arrowTagName);
            addClassNames(arrow, config.arrowClassNames);
            addAttributes(arrow, config.arrowAttributes);
            popper.appendChild(arrow);
        }

        var parent = config.parent.jquery ? config.parent[0] : config.parent;

        // if the given parent is a string, use it to match an element
        // if more than one element is matched, the first one will be used as parent
        // if no elements are matched, the script will throw an error
        if (typeof parent === 'string') {
            parent = d.querySelectorAll(config.parent);
            if (parent.length > 1) {
                console.warn('WARNING: the given `parent` query(' + config.parent + ') matched more than one element, the first one will be used');
            }
            if (parent.length === 0) {
                throw 'ERROR: the given `parent` doesn\'t exists!';
            }
            parent = parent[0];
        }
        // if the given parent is a DOM nodes list or an array of nodes with more than one element,
        // the first one will be used as parent
        if (parent.length > 1 && parent instanceof Element === false) {
            console.warn('WARNING: you have passed as parent a list of elements, the first one will be used');
            parent = parent[0];
        }

        // append the generated popper to its parent
        parent.appendChild(popper);

        return popper;

        /**
         * Adds class names to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} classes
         */
        function addClassNames(element, classNames) {
            classNames.forEach(function (className) {
                element.classList.add(className);
            });
        }

        /**
         * Adds attributes to the given element
         * @function
         * @ignore
         * @param {HTMLElement} target
         * @param {Array} attributes
         * @example
         * addAttributes(element, [ 'data-info:foobar' ]);
         */
        function addAttributes(element, attributes) {
            attributes.forEach(function (attribute) {
                element.setAttribute(attribute.split(':')[0], attribute.split(':')[1] || '');
            });
        }
    };

    /**
     * Helper used to get the position which will be applied to the popper
     * @method
     * @memberof Popper
     * @param config {HTMLElement} popper element
     * @param reference {HTMLElement} reference element
     * @returns {String} position
     */
    Popper.prototype._getPosition = function (popper, reference) {
        var container = getOffsetParent(reference);

        if (this._options.forceAbsolute) {
            return 'absolute';
        }

        // Decide if the popper will be fixed
        // If the reference element is inside a fixed context, the popper will be fixed as well to allow them to scroll together
        var isParentFixed = isFixed(reference, container);
        return isParentFixed ? 'fixed' : 'absolute';
    };

    /**
     * Get offsets to the popper
     * @method
     * @memberof Popper
     * @access private
     * @param {Element} popper - the popper element
     * @param {Element} reference - the reference element (the popper will be relative to this)
     * @returns {Object} An object containing the offsets which will be applied to the popper
     */
    Popper.prototype._getOffsets = function (popper, reference, placement) {
        placement = placement.split('-')[0];
        var popperOffsets = {};

        popperOffsets.position = this.state.position;
        var isParentFixed = popperOffsets.position === 'fixed';

        //
        // Get reference element position
        //
        var referenceOffsets = getOffsetRectRelativeToCustomParent(reference, getOffsetParent(popper), isParentFixed);

        //
        // Get popper sizes
        //
        var popperRect = getOuterSizes(popper);

        //
        // Compute offsets of popper
        //

        // depending by the popper placement we have to compute its offsets slightly differently
        if (['right', 'left'].indexOf(placement) !== -1) {
            popperOffsets.top = referenceOffsets.top + referenceOffsets.height / 2 - popperRect.height / 2;
            if (placement === 'left') {
                popperOffsets.left = referenceOffsets.left - popperRect.width;
            } else {
                popperOffsets.left = referenceOffsets.right;
            }
        } else {
            popperOffsets.left = referenceOffsets.left + referenceOffsets.width / 2 - popperRect.width / 2;
            if (placement === 'top') {
                popperOffsets.top = referenceOffsets.top - popperRect.height;
            } else {
                popperOffsets.top = referenceOffsets.bottom;
            }
        }

        // Add width and height to our offsets object
        popperOffsets.width = popperRect.width;
        popperOffsets.height = popperRect.height;

        return {
            popper: popperOffsets,
            reference: referenceOffsets
        };
    };

    /**
     * Setup needed event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._setupEventListeners = function () {
        // NOTE: 1 DOM access here
        this.state.updateBound = this.update.bind(this);
        root.addEventListener('resize', this.state.updateBound);
        // if the boundariesElement is window we don't need to listen for the scroll event
        if (this._options.boundariesElement !== 'window') {
            var target = getScrollParent(this._reference);
            // here it could be both `body` or `documentElement` thanks to Firefox, we then check both
            if (target === root.document.body || target === root.document.documentElement) {
                target = root;
            }
            target.addEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = target;
        }
    };

    /**
     * Remove event listeners used to update the popper position
     * @method
     * @memberof Popper
     * @access private
     */
    Popper.prototype._removeEventListeners = function () {
        // NOTE: 1 DOM access here
        root.removeEventListener('resize', this.state.updateBound);
        if (this._options.boundariesElement !== 'window' && this.state.scrollTarget) {
            this.state.scrollTarget.removeEventListener('scroll', this.state.updateBound);
            this.state.scrollTarget = null;
        }
        this.state.updateBound = null;
    };

    /**
     * Computed the boundaries limits and return them
     * @method
     * @memberof Popper
     * @access private
     * @param {Object} data - Object containing the property "offsets" generated by `_getOffsets`
     * @param {Number} padding - Boundaries padding
     * @param {Element} boundariesElement - Element used to define the boundaries
     * @returns {Object} Coordinates of the boundaries
     */
    Popper.prototype._getBoundaries = function (data, padding, boundariesElement) {
        // NOTE: 1 DOM access here
        var boundaries = {};
        var width, height;
        if (boundariesElement === 'window') {
            var body = root.document.body,
                html = root.document.documentElement;

            height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
            width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);

            boundaries = {
                top: 0,
                right: width,
                bottom: height,
                left: 0
            };
        } else if (boundariesElement === 'viewport') {
            var offsetParent = getOffsetParent(this._popper);
            var scrollParent = getScrollParent(this._popper);
            var offsetParentRect = getOffsetRect(offsetParent);

            // Thanks the fucking native API, `document.body.scrollTop` & `document.documentElement.scrollTop`
            var getScrollTopValue = function getScrollTopValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollTop, document.body.scrollTop) : element.scrollTop;
            };
            var getScrollLeftValue = function getScrollLeftValue(element) {
                return element == document.body ? Math.max(document.documentElement.scrollLeft, document.body.scrollLeft) : element.scrollLeft;
            };

            // if the popper is fixed we don't have to substract scrolling from the boundaries
            var scrollTop = data.offsets.popper.position === 'fixed' ? 0 : getScrollTopValue(scrollParent);
            var scrollLeft = data.offsets.popper.position === 'fixed' ? 0 : getScrollLeftValue(scrollParent);

            boundaries = {
                top: 0 - (offsetParentRect.top - scrollTop),
                right: root.document.documentElement.clientWidth - (offsetParentRect.left - scrollLeft),
                bottom: root.document.documentElement.clientHeight - (offsetParentRect.top - scrollTop),
                left: 0 - (offsetParentRect.left - scrollLeft)
            };
        } else {
            if (getOffsetParent(this._popper) === boundariesElement) {
                boundaries = {
                    top: 0,
                    left: 0,
                    right: boundariesElement.clientWidth,
                    bottom: boundariesElement.clientHeight
                };
            } else {
                boundaries = getOffsetRect(boundariesElement);
            }
        }
        boundaries.left += padding;
        boundaries.right -= padding;
        boundaries.top = boundaries.top + padding;
        boundaries.bottom = boundaries.bottom - padding;
        return boundaries;
    };

    /**
     * Loop trough the list of modifiers and run them in order, each of them will then edit the data object
     * @method
     * @memberof Popper
     * @access public
     * @param {Object} data
     * @param {Array} modifiers
     * @param {Function} ends
     */
    Popper.prototype.runModifiers = function (data, modifiers, ends) {
        var modifiersToRun = modifiers.slice();
        if (ends !== undefined) {
            modifiersToRun = this._options.modifiers.slice(0, getArrayKeyIndex(this._options.modifiers, ends));
        }

        modifiersToRun.forEach(function (modifier) {
            if (isFunction(modifier)) {
                data = modifier.call(this, data);
            }
        }.bind(this));

        return data;
    };

    /**
     * Helper used to know if the given modifier depends from another one.
     * @method
     * @memberof Popper
     * @param {String} requesting - name of requesting modifier
     * @param {String} requested - name of requested modifier
     * @returns {Boolean}
     */
    Popper.prototype.isModifierRequired = function (requesting, requested) {
        var index = getArrayKeyIndex(this._options.modifiers, requesting);
        return !!this._options.modifiers.slice(0, index).filter(function (modifier) {
            return modifier === requested;
        }).length;
    };

    //
    // Modifiers
    //

    /**
     * Modifiers list
     * @namespace Popper.modifiers
     * @memberof Popper
     * @type {Object}
     */
    Popper.prototype.modifiers = {};

    /**
     * Apply the computed styles to the popper element
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The same data object
     */
    Popper.prototype.modifiers.applyStyle = function (data) {
        // apply the final offsets to the popper
        // NOTE: 1 DOM access here
        var styles = {
            position: data.offsets.popper.position
        };

        // round top and left to avoid blurry text
        var left = Math.round(data.offsets.popper.left);
        var top = Math.round(data.offsets.popper.top);

        // if gpuAcceleration is set to true and transform is supported, we use `translate3d` to apply the position to the popper
        // we automatically use the supported prefixed version if needed
        var prefixedProperty;
        if (this._options.gpuAcceleration && (prefixedProperty = getSupportedPropertyName('transform'))) {
            styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
            styles.top = 0;
            styles.left = 0;
        }
        // othwerise, we use the standard `left` and `top` properties
        else {
                styles.left = left;
                styles.top = top;
            }

        // any property present in `data.styles` will be applied to the popper,
        // in this way we can make the 3rd party modifiers add custom styles to it
        // Be aware, modifiers could override the properties defined in the previous
        // lines of this modifier!
        Object.assign(styles, data.styles);

        setStyle(this._popper, styles);

        // set an attribute which will be useful to style the tooltip (use it to properly position its arrow)
        // NOTE: 1 DOM access here
        this._popper.setAttribute('x-placement', data.placement);

        // if the arrow modifier is required and the arrow style has been computed, apply the arrow style
        if (this.isModifierRequired(this.modifiers.applyStyle, this.modifiers.arrow) && data.offsets.arrow) {
            setStyle(data.arrowElement, data.offsets.arrow);
        }

        return data;
    };

    /**
     * Modifier used to shift the popper on the start or end of its reference element side
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.shift = function (data) {
        var placement = data.placement;
        var basePlacement = placement.split('-')[0];
        var shiftVariation = placement.split('-')[1];

        // if shift shiftVariation is specified, run the modifier
        if (shiftVariation) {
            var reference = data.offsets.reference;
            var popper = getPopperClientRect(data.offsets.popper);

            var shiftOffsets = {
                y: {
                    start: { top: reference.top },
                    end: { top: reference.top + reference.height - popper.height }
                },
                x: {
                    start: { left: reference.left },
                    end: { left: reference.left + reference.width - popper.width }
                }
            };

            var axis = ['bottom', 'top'].indexOf(basePlacement) !== -1 ? 'x' : 'y';

            data.offsets.popper = Object.assign(popper, shiftOffsets[axis][shiftVariation]);
        }

        return data;
    };

    /**
     * Modifier used to make sure the popper does not overflows from it's boundaries
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by `update` method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.preventOverflow = function (data) {
        var order = this._options.preventOverflowOrder;
        var popper = getPopperClientRect(data.offsets.popper);

        var check = {
            left: function left() {
                var left = popper.left;
                if (popper.left < data.boundaries.left) {
                    left = Math.max(popper.left, data.boundaries.left);
                }
                return { left: left };
            },
            right: function right() {
                var left = popper.left;
                if (popper.right > data.boundaries.right) {
                    left = Math.min(popper.left, data.boundaries.right - popper.width);
                }
                return { left: left };
            },
            top: function top() {
                var top = popper.top;
                if (popper.top < data.boundaries.top) {
                    top = Math.max(popper.top, data.boundaries.top);
                }
                return { top: top };
            },
            bottom: function bottom() {
                var top = popper.top;
                if (popper.bottom > data.boundaries.bottom) {
                    top = Math.min(popper.top, data.boundaries.bottom - popper.height);
                }
                return { top: top };
            }
        };

        order.forEach(function (direction) {
            data.offsets.popper = Object.assign(popper, check[direction]());
        });

        return data;
    };

    /**
     * Modifier used to make sure the popper is always near its reference
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.keepTogether = function (data) {
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var f = Math.floor;

        if (popper.right < f(reference.left)) {
            data.offsets.popper.left = f(reference.left) - popper.width;
        }
        if (popper.left > f(reference.right)) {
            data.offsets.popper.left = f(reference.right);
        }
        if (popper.bottom < f(reference.top)) {
            data.offsets.popper.top = f(reference.top) - popper.height;
        }
        if (popper.top > f(reference.bottom)) {
            data.offsets.popper.top = f(reference.bottom);
        }

        return data;
    };

    /**
     * Modifier used to flip the placement of the popper when the latter is starting overlapping its reference element.
     * Requires the `preventOverflow` modifier before it in order to work.
     * **NOTE:** This modifier will run all its previous modifiers everytime it tries to flip the popper!
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.flip = function (data) {
        // check if preventOverflow is in the list of modifiers before the flip modifier.
        // otherwise flip would not work as expected.
        if (!this.isModifierRequired(this.modifiers.flip, this.modifiers.preventOverflow)) {
            console.warn('WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!');
            return data;
        }

        if (data.flipped && data.placement === data._originalPlacement) {
            // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
            return data;
        }

        var placement = data.placement.split('-')[0];
        var placementOpposite = getOppositePlacement(placement);
        var variation = data.placement.split('-')[1] || '';

        var flipOrder = [];
        if (this._options.flipBehavior === 'flip') {
            flipOrder = [placement, placementOpposite];
        } else {
            flipOrder = this._options.flipBehavior;
        }

        flipOrder.forEach(function (step, index) {
            if (placement !== step || flipOrder.length === index + 1) {
                return;
            }

            placement = data.placement.split('-')[0];
            placementOpposite = getOppositePlacement(placement);

            var popperOffsets = getPopperClientRect(data.offsets.popper);

            // this boolean is used to distinguish right and bottom from top and left
            // they need different computations to get flipped
            var a = ['right', 'bottom'].indexOf(placement) !== -1;

            // using Math.floor because the reference offsets may contain decimals we are not going to consider here
            if (a && Math.floor(data.offsets.reference[placement]) > Math.floor(popperOffsets[placementOpposite]) || !a && Math.floor(data.offsets.reference[placement]) < Math.floor(popperOffsets[placementOpposite])) {
                // we'll use this boolean to detect any flip loop
                data.flipped = true;
                data.placement = flipOrder[index + 1];
                if (variation) {
                    data.placement += '-' + variation;
                }
                data.offsets.popper = this._getOffsets(this._popper, this._reference, data.placement).popper;

                data = this.runModifiers(data, this._options.modifiers, this._flip);
            }
        }.bind(this));
        return data;
    };

    /**
     * Modifier used to add an offset to the popper, useful if you more granularity positioning your popper.
     * The offsets will shift the popper on the side of its reference element.
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.offset = function (data) {
        var offset = this._options.offset;
        var popper = data.offsets.popper;

        if (data.placement.indexOf('left') !== -1) {
            popper.top -= offset;
        } else if (data.placement.indexOf('right') !== -1) {
            popper.top += offset;
        } else if (data.placement.indexOf('top') !== -1) {
            popper.left -= offset;
        } else if (data.placement.indexOf('bottom') !== -1) {
            popper.left += offset;
        }
        return data;
    };

    /**
     * Modifier used to move the arrows on the edge of the popper to make sure them are always between the popper and the reference element
     * It will use the CSS outer size of the arrow element to know how many pixels of conjuction are needed
     * @method
     * @memberof Popper.modifiers
     * @argument {Object} data - The data object generated by _update method
     * @returns {Object} The data object, properly modified
     */
    Popper.prototype.modifiers.arrow = function (data) {
        var arrow = this._options.arrowElement;
        var arrowOffset = this._options.arrowOffset;

        // if the arrowElement is a string, suppose it's a CSS selector
        if (typeof arrow === 'string') {
            arrow = this._popper.querySelector(arrow);
        }

        // if arrow element is not found, don't run the modifier
        if (!arrow) {
            return data;
        }

        // the arrow element must be child of its popper
        if (!this._popper.contains(arrow)) {
            console.warn('WARNING: `arrowElement` must be child of its popper element!');
            return data;
        }

        // arrow depends on keepTogether in order to work
        if (!this.isModifierRequired(this.modifiers.arrow, this.modifiers.keepTogether)) {
            console.warn('WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!');
            return data;
        }

        var arrowStyle = {};
        var placement = data.placement.split('-')[0];
        var popper = getPopperClientRect(data.offsets.popper);
        var reference = data.offsets.reference;
        var isVertical = ['left', 'right'].indexOf(placement) !== -1;

        var len = isVertical ? 'height' : 'width';
        var side = isVertical ? 'top' : 'left';
        var translate = isVertical ? 'translateY' : 'translateX';
        var altSide = isVertical ? 'left' : 'top';
        var opSide = isVertical ? 'bottom' : 'right';
        var arrowSize = getOuterSizes(arrow)[len];

        //
        // extends keepTogether behavior making sure the popper and its reference have enough pixels in conjuction
        //

        // top/left side
        if (reference[opSide] - arrowSize < popper[side]) {
            data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowSize);
        }
        // bottom/right side
        if (reference[side] + arrowSize > popper[opSide]) {
            data.offsets.popper[side] += reference[side] + arrowSize - popper[opSide];
        }

        // compute center of the popper
        var center = reference[side] + (arrowOffset || reference[len] / 2 - arrowSize / 2);

        var sideValue = center - popper[side];

        // prevent arrow from being placed not contiguously to its popper
        sideValue = Math.max(Math.min(popper[len] - arrowSize - 8, sideValue), 8);
        arrowStyle[side] = sideValue;
        arrowStyle[altSide] = ''; // make sure to remove any old style from the arrow

        data.offsets.arrow = arrowStyle;
        data.arrowElement = arrow;

        return data;
    };

    //
    // Helpers
    //

    /**
     * Get the outer sizes of the given element (offset size + margins)
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Object} object containing width and height properties
     */
    function getOuterSizes(element) {
        // NOTE: 1 DOM access here
        var _display = element.style.display,
            _visibility = element.style.visibility;
        element.style.display = 'block';element.style.visibility = 'hidden';
        var calcWidthToForceRepaint = element.offsetWidth;

        // original method
        var styles = root.getComputedStyle(element);
        var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
        var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
        var result = { width: element.offsetWidth + y, height: element.offsetHeight + x };

        // reset element styles
        element.style.display = _display;element.style.visibility = _visibility;
        return result;
    }

    /**
     * Get the opposite placement of the given one/
     * @function
     * @ignore
     * @argument {String} placement
     * @returns {String} flipped placement
     */
    function getOppositePlacement(placement) {
        var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
        return placement.replace(/left|right|bottom|top/g, function (matched) {
            return hash[matched];
        });
    }

    /**
     * Given the popper offsets, generate an output similar to getBoundingClientRect
     * @function
     * @ignore
     * @argument {Object} popperOffsets
     * @returns {Object} ClientRect like output
     */
    function getPopperClientRect(popperOffsets) {
        var offsets = Object.assign({}, popperOffsets);
        offsets.right = offsets.left + offsets.width;
        offsets.bottom = offsets.top + offsets.height;
        return offsets;
    }

    /**
     * Given an array and the key to find, returns its index
     * @function
     * @ignore
     * @argument {Array} arr
     * @argument keyToFind
     * @returns index or null
     */
    function getArrayKeyIndex(arr, keyToFind) {
        var i = 0,
            key;
        for (key in arr) {
            if (arr[key] === keyToFind) {
                return i;
            }
            i++;
        }
        return null;
    }

    /**
     * Get CSS computed property of the given element
     * @function
     * @ignore
     * @argument {Eement} element
     * @argument {String} property
     */
    function getStyleComputedProperty(element, property) {
        // NOTE: 1 DOM access here
        var css = root.getComputedStyle(element, null);
        return css[property];
    }

    /**
     * Returns the offset parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getOffsetParent(element) {
        // NOTE: 1 DOM access here
        var offsetParent = element.offsetParent;
        return offsetParent === root.document.body || !offsetParent ? root.document.documentElement : offsetParent;
    }

    /**
     * Returns the scrolling parent of the given element
     * @function
     * @ignore
     * @argument {Element} element
     * @returns {Element} offset parent
     */
    function getScrollParent(element) {
        var parent = element.parentNode;

        if (!parent) {
            return element;
        }

        if (parent === root.document) {
            // Firefox puts the scrollTOp value on `documentElement` instead of `body`, we then check which of them is
            // greater than 0 and return the proper element
            if (root.document.body.scrollTop || root.document.body.scrollLeft) {
                return root.document.body;
            } else {
                return root.document.documentElement;
            }
        }

        // Firefox want us to check `-x` and `-y` variations as well
        if (['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-x')) !== -1 || ['scroll', 'auto'].indexOf(getStyleComputedProperty(parent, 'overflow-y')) !== -1) {
            // If the detected scrollParent is body, we perform an additional check on its parentNode
            // in this way we'll get body if the browser is Chrome-ish, or documentElement otherwise
            // fixes issue #65
            return parent;
        }
        return getScrollParent(element.parentNode);
    }

    /**
     * Check if the given element is fixed or is inside a fixed parent
     * @function
     * @ignore
     * @argument {Element} element
     * @argument {Element} customContainer
     * @returns {Boolean} answer to "isFixed?"
     */
    function isFixed(element) {
        if (element === root.document.body) {
            return false;
        }
        if (getStyleComputedProperty(element, 'position') === 'fixed') {
            return true;
        }
        return element.parentNode ? isFixed(element.parentNode) : element;
    }

    /**
     * Set the style to the given popper
     * @function
     * @ignore
     * @argument {Element} element - Element to apply the style to
     * @argument {Object} styles - Object with a list of properties and values which will be applied to the element
     */
    function setStyle(element, styles) {
        function is_numeric(n) {
            return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
        }
        Object.keys(styles).forEach(function (prop) {
            var unit = '';
            // add unit if the value is numeric and is one of the following
            if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && is_numeric(styles[prop])) {
                unit = 'px';
            }
            element.style[prop] = styles[prop] + unit;
        });
    }

    /**
     * Check if the given variable is a function
     * @function
     * @ignore
     * @argument {*} functionToCheck - variable to check
     * @returns {Boolean} answer to: is a function?
     */
    function isFunction(functionToCheck) {
        var getType = {};
        return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
    }

    /**
     * Get the position of the given element, relative to its offset parent
     * @function
     * @ignore
     * @param {Element} element
     * @return {Object} position - Coordinates of the element and its `scrollTop`
     */
    function getOffsetRect(element) {
        var elementRect = {
            width: element.offsetWidth,
            height: element.offsetHeight,
            left: element.offsetLeft,
            top: element.offsetTop
        };

        elementRect.right = elementRect.left + elementRect.width;
        elementRect.bottom = elementRect.top + elementRect.height;

        // position
        return elementRect;
    }

    /**
     * Get bounding client rect of given element
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @return {Object} client rect
     */
    function getBoundingClientRect(element) {
        var rect = element.getBoundingClientRect();

        // whether the IE version is lower than 11
        var isIE = navigator.userAgent.indexOf("MSIE") != -1;

        // fix ie document bounding top always 0 bug
        var rectTop = isIE && element.tagName === 'HTML' ? -element.scrollTop : rect.top;

        return {
            left: rect.left,
            top: rectTop,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.right - rect.left,
            height: rect.bottom - rectTop
        };
    }

    /**
     * Given an element and one of its parents, return the offset
     * @function
     * @ignore
     * @param {HTMLElement} element
     * @param {HTMLElement} parent
     * @return {Object} rect
     */
    function getOffsetRectRelativeToCustomParent(element, parent, fixed) {
        var elementRect = getBoundingClientRect(element);
        var parentRect = getBoundingClientRect(parent);

        if (fixed) {
            var scrollParent = getScrollParent(parent);
            parentRect.top += scrollParent.scrollTop;
            parentRect.bottom += scrollParent.scrollTop;
            parentRect.left += scrollParent.scrollLeft;
            parentRect.right += scrollParent.scrollLeft;
        }

        var rect = {
            top: elementRect.top - parentRect.top,
            left: elementRect.left - parentRect.left,
            bottom: elementRect.top - parentRect.top + elementRect.height,
            right: elementRect.left - parentRect.left + elementRect.width,
            width: elementRect.width,
            height: elementRect.height
        };
        return rect;
    }

    /**
     * Get the prefixed supported property name
     * @function
     * @ignore
     * @argument {String} property (camelCase)
     * @returns {String} prefixed property (camelCase)
     */
    function getSupportedPropertyName(property) {
        var prefixes = ['', 'ms', 'webkit', 'moz', 'o'];

        for (var i = 0; i < prefixes.length; i++) {
            var toCheck = prefixes[i] ? prefixes[i] + property.charAt(0).toUpperCase() + property.slice(1) : property;
            if (typeof root.document.body.style[toCheck] !== 'undefined') {
                return toCheck;
            }
        }
        return null;
    }

    /**
     * The Object.assign() method is used to copy the values of all enumerable own properties from one or more source
     * objects to a target object. It will return the target object.
     * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
     * Source: https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
     * @function
     * @ignore
     */
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function value(target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }

    return Popper;
});

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 95);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/95:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("button", {
        staticClass: "el-button",
        class: [_vm.type ? "el-button--" + _vm.type : "", _vm.buttonSize ? "el-button--" + _vm.buttonSize : "", {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }],
        attrs: {
          disabled: _vm.buttonDisabled || _vm.loading,
          autofocus: _vm.autofocus,
          type: _vm.nativeType
        },
        on: { click: _vm.handleClick }
      }, [_vm.loading ? _c("i", { staticClass: "el-icon-loading" }) : _vm._e(), _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(), _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */var buttonvue_type_script_lang_js_ = {
      name: 'ElButton',

      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },

      props: {
        type: {
          type: String,
          default: 'default'
        },
        size: String,
        icon: {
          type: String,
          default: ''
        },
        nativeType: {
          type: String,
          default: 'button'
        },
        loading: Boolean,
        disabled: Boolean,
        plain: Boolean,
        autofocus: Boolean,
        round: Boolean,
        circle: Boolean
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        buttonSize: function buttonSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        buttonDisabled: function buttonDisabled() {
          return this.$options.propsData.hasOwnProperty('disabled') ? this.disabled : (this.elForm || {}).disabled;
        }
      },

      methods: {
        handleClick: function handleClick(evt) {
          this.$emit('click', evt);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
    /* harmony default export */var src_buttonvue_type_script_lang_js_ = buttonvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/button/src/button.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_buttonvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/button/src/button.vue";
    /* harmony default export */var src_button = component.exports;
    // CONCATENATED MODULE: ./packages/button/index.js


    /* istanbul ignore next */
    src_button.install = function (Vue) {
      Vue.component(src_button.name, src_button);
    };

    /* harmony default export */var packages_button = __webpack_exports__["default"] = src_button;

    /***/
  }

  /******/ });

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return (/** @class */function () {
            function class_1() {
                this.__entries__ = [];
            }
            Object.defineProperty(class_1.prototype, "size", {
                /**
                 * @returns {boolean}
                 */
                get: function get() {
                    return this.__entries__.length;
                },
                enumerable: true,
                configurable: true
            });
            /**
             * @param {*} key
             * @returns {*}
             */
            class_1.prototype.get = function (key) {
                var index = getIndex(this.__entries__, key);
                var entry = this.__entries__[index];
                return entry && entry[1];
            };
            /**
             * @param {*} key
             * @param {*} value
             * @returns {void}
             */
            class_1.prototype.set = function (key, value) {
                var index = getIndex(this.__entries__, key);
                if (~index) {
                    this.__entries__[index][1] = value;
                } else {
                    this.__entries__.push([key, value]);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.delete = function (key) {
                var entries = this.__entries__;
                var index = getIndex(entries, key);
                if (~index) {
                    entries.splice(index, 1);
                }
            };
            /**
             * @param {*} key
             * @returns {void}
             */
            class_1.prototype.has = function (key) {
                return !!~getIndex(this.__entries__, key);
            };
            /**
             * @returns {void}
             */
            class_1.prototype.clear = function () {
                this.__entries__.splice(0);
            };
            /**
             * @param {Function} callback
             * @param {*} [ctx=null]
             * @returns {void}
             */
            class_1.prototype.forEach = function (callback, ctx) {
                if (ctx === void 0) {
                    ctx = null;
                }
                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                    var entry = _a[_i];
                    callback.call(ctx, entry[1], entry[0]);
                }
            };
            return class_1;
        }()
    );
}();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) {
        return setTimeout(function () {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle(callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName,
            propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = function defineConfigurable(target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
};

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth,
        clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) {
            return target instanceof getWindowOf(target).SVGGraphicsElement;
        };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) {
        return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x,
        y = _a.y,
        width = _a.width,
        height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();

var ResizeObserverEntry = /** @class */function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}();

var ResizeObserverSPI = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
}();

/* harmony default export */ __webpack_exports__["default"] = (index);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _dom = __webpack_require__(43);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Transition = function () {
  function Transition() {
    _classCallCheck(this, Transition);
  }

  Transition.prototype.beforeEnter = function beforeEnter(el) {
    (0, _dom.addClass)(el, 'collapse-transition');
    if (!el.dataset) el.dataset = {};

    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;

    el.style.height = '0';
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
  };

  Transition.prototype.enter = function enter(el) {
    el.dataset.oldOverflow = el.style.overflow;
    if (el.scrollHeight !== 0) {
      el.style.height = el.scrollHeight + 'px';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    } else {
      el.style.height = '';
      el.style.paddingTop = el.dataset.oldPaddingTop;
      el.style.paddingBottom = el.dataset.oldPaddingBottom;
    }

    el.style.overflow = 'hidden';
  };

  Transition.prototype.afterEnter = function afterEnter(el) {
    // for safari: remove class then reset height is necessary
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
  };

  Transition.prototype.beforeLeave = function beforeLeave(el) {
    if (!el.dataset) el.dataset = {};
    el.dataset.oldPaddingTop = el.style.paddingTop;
    el.dataset.oldPaddingBottom = el.style.paddingBottom;
    el.dataset.oldOverflow = el.style.overflow;

    el.style.height = el.scrollHeight + 'px';
    el.style.overflow = 'hidden';
  };

  Transition.prototype.leave = function leave(el) {
    if (el.scrollHeight !== 0) {
      // for safari: add class after set height, or it will jump to zero height suddenly, weired
      (0, _dom.addClass)(el, 'collapse-transition');
      el.style.height = 0;
      el.style.paddingTop = 0;
      el.style.paddingBottom = 0;
    }
  };

  Transition.prototype.afterLeave = function afterLeave(el) {
    (0, _dom.removeClass)(el, 'collapse-transition');
    el.style.height = '';
    el.style.overflow = el.dataset.oldOverflow;
    el.style.paddingTop = el.dataset.oldPaddingTop;
    el.style.paddingBottom = el.dataset.oldPaddingBottom;
  };

  return Transition;
}();

exports.default = {
  name: 'ElCollapseTransition',
  functional: true,
  render: function render(h, _ref) {
    var children = _ref.children;

    var data = {
      on: new Transition()
    };

    return h('transition', data, children);
  }
};

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

exports.isVNode = isVNode;

var _util = __webpack_require__(38);

function isVNode(node) {
  return node !== null && (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === 'object' && (0, _util.hasOwn)(node, 'componentOptions');
};

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 136);
  /******/
}(
/************************************************************************/
/******/{

  /***/136:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // EXTERNAL MODULE: external "throttle-debounce/debounce"
    var debounce_ = __webpack_require__(19);
    var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // EXTERNAL MODULE: external "vue"
    var external_vue_ = __webpack_require__(7);
    var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

    // CONCATENATED MODULE: ./packages/tooltip/src/main.js


    /* harmony default export */var main = {
      name: 'ElTooltip',

      mixins: [vue_popper_default.a],

      props: {
        openDelay: {
          type: Number,
          default: 0
        },
        disabled: Boolean,
        manual: Boolean,
        effect: {
          type: String,
          default: 'dark'
        },
        arrowOffset: {
          type: Number,
          default: 0
        },
        popperClass: String,
        content: String,
        visibleArrow: {
          default: true
        },
        transition: {
          type: String,
          default: 'el-fade-in-linear'
        },
        popperOptions: {
          default: function _default() {
            return {
              boundariesPadding: 10,
              gpuAcceleration: false
            };
          }
        },
        enterable: {
          type: Boolean,
          default: true
        },
        hideAfter: {
          type: Number,
          default: 0
        },
        tabindex: {
          type: Number,
          default: 0
        }
      },

      data: function data() {
        return {
          tooltipId: 'el-tooltip-' + Object(util_["generateId"])(),
          timeoutPending: null,
          focusing: false
        };
      },
      beforeCreate: function beforeCreate() {
        var _this = this;

        if (this.$isServer) return;

        this.popperVM = new external_vue_default.a({
          data: { node: '' },
          render: function render(h) {
            return this.node;
          }
        }).$mount();

        this.debounceClose = debounce_default()(200, function () {
          return _this.handleClosePopper();
        });
      },
      render: function render(h) {
        var _this2 = this;

        if (this.popperVM) {
          this.popperVM.node = h('transition', {
            attrs: {
              name: this.transition
            },
            on: {
              'afterLeave': this.doDestroy
            }
          }, [h('div', {
            on: {
              'mouseleave': function mouseleave() {
                _this2.setExpectedState(false);_this2.debounceClose();
              },
              'mouseenter': function mouseenter() {
                _this2.setExpectedState(true);
              }
            },

            ref: 'popper',
            attrs: { role: 'tooltip',
              id: this.tooltipId,
              'aria-hidden': this.disabled || !this.showPopper ? 'true' : 'false'
            },
            directives: [{
              name: 'show',
              value: !this.disabled && this.showPopper
            }],

            'class': ['el-tooltip__popper', 'is-' + this.effect, this.popperClass] }, [this.$slots.content || this.content])]);
        }

        var firstElement = this.getFirstElement();
        if (!firstElement) return null;

        var data = firstElement.data = firstElement.data || {};
        data.staticClass = this.addTooltipClass(data.staticClass);

        return firstElement;
      },
      mounted: function mounted() {
        var _this3 = this;

        this.referenceElm = this.$el;
        if (this.$el.nodeType === 1) {
          this.$el.setAttribute('aria-describedby', this.tooltipId);
          this.$el.setAttribute('tabindex', this.tabindex);
          Object(dom_["on"])(this.referenceElm, 'mouseenter', this.show);
          Object(dom_["on"])(this.referenceElm, 'mouseleave', this.hide);
          Object(dom_["on"])(this.referenceElm, 'focus', function () {
            if (!_this3.$slots.default || !_this3.$slots.default.length) {
              _this3.handleFocus();
              return;
            }
            var instance = _this3.$slots.default[0].componentInstance;
            if (instance && instance.focus) {
              instance.focus();
            } else {
              _this3.handleFocus();
            }
          });
          Object(dom_["on"])(this.referenceElm, 'blur', this.handleBlur);
          Object(dom_["on"])(this.referenceElm, 'click', this.removeFocusing);
        }
        // fix issue https://github.com/ElemeFE/element/issues/14424
        if (this.value && this.popperVM) {
          this.popperVM.$nextTick(function () {
            if (_this3.value) {
              _this3.updatePopper();
            }
          });
        }
      },

      watch: {
        focusing: function focusing(val) {
          if (val) {
            Object(dom_["addClass"])(this.referenceElm, 'focusing');
          } else {
            Object(dom_["removeClass"])(this.referenceElm, 'focusing');
          }
        }
      },
      methods: {
        show: function show() {
          this.setExpectedState(true);
          this.handleShowPopper();
        },
        hide: function hide() {
          this.setExpectedState(false);
          this.debounceClose();
        },
        handleFocus: function handleFocus() {
          this.focusing = true;
          this.show();
        },
        handleBlur: function handleBlur() {
          this.focusing = false;
          this.hide();
        },
        removeFocusing: function removeFocusing() {
          this.focusing = false;
        },
        addTooltipClass: function addTooltipClass(prev) {
          if (!prev) {
            return 'el-tooltip';
          } else {
            return 'el-tooltip ' + prev.replace('el-tooltip', '');
          }
        },
        handleShowPopper: function handleShowPopper() {
          var _this4 = this;

          if (!this.expectedState || this.manual) return;
          clearTimeout(this.timeout);
          this.timeout = setTimeout(function () {
            _this4.showPopper = true;
          }, this.openDelay);

          if (this.hideAfter > 0) {
            this.timeoutPending = setTimeout(function () {
              _this4.showPopper = false;
            }, this.hideAfter);
          }
        },
        handleClosePopper: function handleClosePopper() {
          if (this.enterable && this.expectedState || this.manual) return;
          clearTimeout(this.timeout);

          if (this.timeoutPending) {
            clearTimeout(this.timeoutPending);
          }
          this.showPopper = false;

          if (this.disabled) {
            this.doDestroy();
          }
        },
        setExpectedState: function setExpectedState(expectedState) {
          if (expectedState === false) {
            clearTimeout(this.timeoutPending);
          }
          this.expectedState = expectedState;
        },
        getFirstElement: function getFirstElement() {
          var slots = this.$slots.default;
          if (!Array.isArray(slots)) return null;
          var element = null;
          for (var index = 0; index < slots.length; index++) {
            if (slots[index] && slots[index].tag) {
              element = slots[index];
              break;
            };
          }
          return element;
        }
      },

      beforeDestroy: function beforeDestroy() {
        this.popperVM && this.popperVM.$destroy();
      },
      destroyed: function destroyed() {
        var reference = this.referenceElm;
        if (reference.nodeType === 1) {
          Object(dom_["off"])(reference, 'mouseenter', this.show);
          Object(dom_["off"])(reference, 'mouseleave', this.hide);
          Object(dom_["off"])(reference, 'focus', this.handleFocus);
          Object(dom_["off"])(reference, 'blur', this.handleBlur);
          Object(dom_["off"])(reference, 'click', this.removeFocusing);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/tooltip/index.js


    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.component(main.name, main);
    };

    /* harmony default export */var tooltip = __webpack_exports__["default"] = main;

    /***/
  },

  /***/19:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(102);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(43);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(99);

    /***/
  },

  /***/7:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(18);

    /***/
  }

  /******/ });

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 96);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/96:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", { staticClass: "el-button-group" }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=template&id=3d8661d0&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button-group.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //

    /* harmony default export */var button_groupvue_type_script_lang_js_ = {
      name: 'ElButtonGroup'
    };
    // CONCATENATED MODULE: ./packages/button/src/button-group.vue?vue&type=script&lang=js&
    /* harmony default export */var src_button_groupvue_type_script_lang_js_ = button_groupvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/button/src/button-group.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_button_groupvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/button/src/button-group.vue";
    /* harmony default export */var button_group = component.exports;
    // CONCATENATED MODULE: ./packages/button-group/index.js


    /* istanbul ignore next */
    button_group.install = function (Vue) {
      Vue.component(button_group.name, button_group);
    };

    /* harmony default export */var packages_button_group = __webpack_exports__["default"] = button_group;

    /***/
  }

  /******/ });

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 92);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/92:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-checkbox-group",
        attrs: { role: "group", "aria-label": "checkbox-group" }
      }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=template&id=7289a290&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&


    /* harmony default export */var checkbox_groupvue_type_script_lang_js_ = {
      name: 'ElCheckboxGroup',

      componentName: 'ElCheckboxGroup',

      mixins: [emitter_default.a],

      inject: {
        elFormItem: {
          default: ''
        }
      },

      props: {
        value: {},
        disabled: Boolean,
        min: Number,
        max: Number,
        size: String,
        fill: String,
        textColor: String
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        checkboxGroupSize: function checkboxGroupSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        }
      },

      watch: {
        value: function value(_value) {
          this.dispatch('ElFormItem', 'el.form.change', [_value]);
        }
      }
    };
    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue?vue&type=script&lang=js&
    /* harmony default export */var src_checkbox_groupvue_type_script_lang_js_ = checkbox_groupvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/checkbox/src/checkbox-group.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_checkbox_groupvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/checkbox/src/checkbox-group.vue";
    /* harmony default export */var checkbox_group = component.exports;
    // CONCATENATED MODULE: ./packages/checkbox-group/index.js


    /* istanbul ignore next */
    checkbox_group.install = function (Vue) {
      Vue.component(checkbox_group.name, checkbox_group);
    };

    /* harmony default export */var packages_checkbox_group = __webpack_exports__["default"] = checkbox_group;

    /***/
  }

  /******/ });

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, callback) {
  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!instance || !callback) throw new Error('instance & callback is required');
  var called = false;
  var afterLeaveCallback = function afterLeaveCallback() {
    if (called) return;
    called = true;
    if (callback) {
      callback.apply(null, arguments);
    }
  };
  if (once) {
    instance.$once('after-leave', afterLeaveCallback);
  } else {
    instance.$on('after-leave', afterLeaveCallback);
  }
  setTimeout(function () {
    afterLeaveCallback();
  }, speed + 100);
};

; /**
   * Bind after-leave event for vue instance. Make sure after-leave is called in any browsers.
   *
   * @param {Vue} instance Vue instance.
   * @param {Function} callback callback of after-leave event
   * @param {Number} speed the speed of transition, default value is 300ms
   * @param {Boolean} once weather bind after-leave once. default value is false.
   */

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 103);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/103:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=template&id=229ee406&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-progress",
        class: ["el-progress--" + _vm.type, _vm.status ? "is-" + _vm.status : "", {
          "el-progress--without-text": !_vm.showText,
          "el-progress--text-inside": _vm.textInside
        }],
        attrs: {
          role: "progressbar",
          "aria-valuenow": _vm.percentage,
          "aria-valuemin": "0",
          "aria-valuemax": "100"
        }
      }, [_vm.type === "line" ? _c("div", { staticClass: "el-progress-bar" }, [_c("div", {
        staticClass: "el-progress-bar__outer",
        style: { height: _vm.strokeWidth + "px" }
      }, [_c("div", {
        staticClass: "el-progress-bar__inner",
        style: _vm.barStyle
      }, [_vm.showText && _vm.textInside ? _c("div", { staticClass: "el-progress-bar__innerText" }, [_vm._v(_vm._s(_vm.content))]) : _vm._e()])])]) : _c("div", {
        staticClass: "el-progress-circle",
        style: { height: _vm.width + "px", width: _vm.width + "px" }
      }, [_c("svg", { attrs: { viewBox: "0 0 100 100" } }, [_c("path", {
        staticClass: "el-progress-circle__track",
        style: _vm.trailPathStyle,
        attrs: {
          d: _vm.trackPath,
          stroke: "#e5e9f2",
          "stroke-width": _vm.relativeStrokeWidth,
          fill: "none"
        }
      }), _c("path", {
        staticClass: "el-progress-circle__path",
        style: _vm.circlePathStyle,
        attrs: {
          d: _vm.trackPath,
          stroke: _vm.stroke,
          fill: "none",
          "stroke-linecap": _vm.strokeLinecap,
          "stroke-width": _vm.percentage ? _vm.relativeStrokeWidth : 0
        }
      })])]), _vm.showText && !_vm.textInside ? _c("div", {
        staticClass: "el-progress__text",
        style: { fontSize: _vm.progressTextSize + "px" }
      }, [!_vm.status ? [_vm._v(_vm._s(_vm.content))] : _c("i", { class: _vm.iconClass })], 2) : _vm._e()]);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=template&id=229ee406&

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/progress/src/progress.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //

    /* harmony default export */var progressvue_type_script_lang_js_ = {
      name: 'ElProgress',
      props: {
        type: {
          type: String,
          default: 'line',
          validator: function validator(val) {
            return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
          }
        },
        percentage: {
          type: Number,
          default: 0,
          required: true,
          validator: function validator(val) {
            return val >= 0 && val <= 100;
          }
        },
        status: {
          type: String,
          validator: function validator(val) {
            return ['success', 'exception', 'warning'].indexOf(val) > -1;
          }
        },
        strokeWidth: {
          type: Number,
          default: 6
        },
        strokeLinecap: {
          type: String,
          default: 'round'
        },
        textInside: {
          type: Boolean,
          default: false
        },
        width: {
          type: Number,
          default: 126
        },
        showText: {
          type: Boolean,
          default: true
        },
        color: {
          type: [String, Array, Function],
          default: ''
        },
        format: Function
      },
      computed: {
        barStyle: function barStyle() {
          var style = {};
          style.width = this.percentage + '%';
          style.backgroundColor = this.getCurrentColor(this.percentage);
          return style;
        },
        relativeStrokeWidth: function relativeStrokeWidth() {
          return (this.strokeWidth / this.width * 100).toFixed(1);
        },
        radius: function radius() {
          if (this.type === 'circle' || this.type === 'dashboard') {
            return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
          } else {
            return 0;
          }
        },
        trackPath: function trackPath() {
          var radius = this.radius;
          var isDashboard = this.type === 'dashboard';
          return '\n        M 50 50\n        m 0 ' + (isDashboard ? '' : '-') + radius + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '-' : '') + radius * 2 + '\n        a ' + radius + ' ' + radius + ' 0 1 1 0 ' + (isDashboard ? '' : '-') + radius * 2 + '\n        ';
        },
        perimeter: function perimeter() {
          return 2 * Math.PI * this.radius;
        },
        rate: function rate() {
          return this.type === 'dashboard' ? 0.75 : 1;
        },
        strokeDashoffset: function strokeDashoffset() {
          var offset = -1 * this.perimeter * (1 - this.rate) / 2;
          return offset + 'px';
        },
        trailPathStyle: function trailPathStyle() {
          return {
            strokeDasharray: this.perimeter * this.rate + 'px, ' + this.perimeter + 'px',
            strokeDashoffset: this.strokeDashoffset
          };
        },
        circlePathStyle: function circlePathStyle() {
          return {
            strokeDasharray: this.perimeter * this.rate * (this.percentage / 100) + 'px, ' + this.perimeter + 'px',
            strokeDashoffset: this.strokeDashoffset,
            transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
          };
        },
        stroke: function stroke() {
          var ret = void 0;
          if (this.color) {
            ret = this.getCurrentColor(this.percentage);
          } else {
            switch (this.status) {
              case 'success':
                ret = '#13ce66';
                break;
              case 'exception':
                ret = '#ff4949';
                break;
              case 'warning':
                ret = '#e6a23c';
                break;
              default:
                ret = '#20a0ff';
            }
          }
          return ret;
        },
        iconClass: function iconClass() {
          if (this.status === 'warning') {
            return 'el-icon-warning';
          }
          if (this.type === 'line') {
            return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
          } else {
            return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
          }
        },
        progressTextSize: function progressTextSize() {
          return this.type === 'line' ? 12 + this.strokeWidth * 0.4 : this.width * 0.111111 + 2;
        },
        content: function content() {
          if (typeof this.format === 'function') {
            return this.format(this.percentage) || '';
          } else {
            return this.percentage + '%';
          }
        }
      },
      methods: {
        getCurrentColor: function getCurrentColor(percentage) {
          if (typeof this.color === 'function') {
            return this.color(percentage);
          } else if (typeof this.color === 'string') {
            return this.color;
          } else {
            return this.getLevelColor(percentage);
          }
        },
        getLevelColor: function getLevelColor(percentage) {
          var colorArray = this.getColorArray().sort(function (a, b) {
            return a.percentage - b.percentage;
          });

          for (var i = 0; i < colorArray.length; i++) {
            if (colorArray[i].percentage > percentage) {
              return colorArray[i].color;
            }
          }
          return colorArray[colorArray.length - 1].color;
        },
        getColorArray: function getColorArray() {
          var color = this.color;
          var span = 100 / color.length;
          return color.map(function (seriesColor, index) {
            if (typeof seriesColor === 'string') {
              return {
                color: seriesColor,
                percentage: (index + 1) * span
              };
            }
            return seriesColor;
          });
        }
      }
    };
    // CONCATENATED MODULE: ./packages/progress/src/progress.vue?vue&type=script&lang=js&
    /* harmony default export */var src_progressvue_type_script_lang_js_ = progressvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/progress/src/progress.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_progressvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/progress/src/progress.vue";
    /* harmony default export */var progress = component.exports;
    // CONCATENATED MODULE: ./packages/progress/index.js


    /* istanbul ignore next */
    progress.install = function (Vue) {
      Vue.component(progress.name, progress);
    };

    /* harmony default export */var packages_progress = __webpack_exports__["default"] = progress;

    /***/
  }

  /******/ });

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 61);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/10:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(148);

    /***/
  },

  /***/12:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(290);

    /***/
  },

  /***/15:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(151);

    /***/
  },

  /***/16:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(149);

    /***/
  },

  /***/19:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(102);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(101);

    /***/
  },

  /***/22:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(152);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/31:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(153);

    /***/
  },

  /***/33:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }],
        staticClass: "el-select-dropdown__item",
        class: {
          selected: _vm.itemSelected,
          "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
          hover: _vm.hover
        },
        on: {
          mouseenter: _vm.hoverItem,
          click: function click($event) {
            $event.stopPropagation();
            return _vm.selectOptionClick($event);
          }
        }
      }, [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var optionvue_type_script_lang_js_ = {
      mixins: [emitter_default.a],

      name: 'ElOption',

      componentName: 'ElOption',

      inject: ['select'],

      props: {
        value: {
          required: true
        },
        label: [String, Number],
        created: Boolean,
        disabled: {
          type: Boolean,
          default: false
        }
      },

      data: function data() {
        return {
          index: -1,
          groupDisabled: false,
          visible: true,
          hitState: false,
          hover: false
        };
      },

      computed: {
        isObject: function isObject() {
          return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
        },
        currentLabel: function currentLabel() {
          return this.label || (this.isObject ? '' : this.value);
        },
        currentValue: function currentValue() {
          return this.value || this.label || '';
        },
        itemSelected: function itemSelected() {
          if (!this.select.multiple) {
            return this.isEqual(this.value, this.select.value);
          } else {
            return this.contains(this.select.value, this.value);
          }
        },
        limitReached: function limitReached() {
          if (this.select.multiple) {
            return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
          } else {
            return false;
          }
        }
      },

      watch: {
        currentLabel: function currentLabel() {
          if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
        },
        value: function value(val, oldVal) {
          var _select = this.select,
              remote = _select.remote,
              valueKey = _select.valueKey;

          if (!this.created && !remote) {
            if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
              return;
            }
            this.dispatch('ElSelect', 'setSelected');
          }
        }
      },

      methods: {
        isEqual: function isEqual(a, b) {
          if (!this.isObject) {
            return a === b;
          } else {
            var valueKey = this.select.valueKey;
            return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
          }
        },
        contains: function contains() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var target = arguments[1];

          if (!this.isObject) {
            return arr && arr.indexOf(target) > -1;
          } else {
            var valueKey = this.select.valueKey;
            return arr && arr.some(function (item) {
              return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
            });
          }
        },
        handleGroupDisabled: function handleGroupDisabled(val) {
          this.groupDisabled = val;
        },
        hoverItem: function hoverItem() {
          if (!this.disabled && !this.groupDisabled) {
            this.select.hoverIndex = this.select.options.indexOf(this);
          }
        },
        selectOptionClick: function selectOptionClick() {
          if (this.disabled !== true && this.groupDisabled !== true) {
            this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
          }
        },
        queryChange: function queryChange(query) {
          this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
          if (!this.visible) {
            this.select.filteredOptionsCount--;
          }
        }
      },

      created: function created() {
        this.select.options.push(this);
        this.select.cachedOptions.push(this);
        this.select.optionsCount++;
        this.select.filteredOptionsCount++;

        this.$on('queryChange', this.queryChange);
        this.$on('handleGroupDisabled', this.handleGroupDisabled);
      },
      beforeDestroy: function beforeDestroy() {
        var _select2 = this.select,
            selected = _select2.selected,
            multiple = _select2.multiple;

        var selectedOptions = multiple ? selected : [selected];
        var index = this.select.cachedOptions.indexOf(this);
        var selectedIndex = selectedOptions.indexOf(this);

        // if option is not selected, remove it from cache
        if (index > -1 && selectedIndex < 0) {
          this.select.cachedOptions.splice(index, 1);
        }
        this.select.onOptionDestroy(this.select.options.indexOf(this));
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
    /* harmony default export */var src_optionvue_type_script_lang_js_ = optionvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/option.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_optionvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/option.vue";
    /* harmony default export */var src_option = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/37:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(294);

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(99);

    /***/
  },

  /***/6:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(146);

    /***/
  },

  /***/61:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        directives: [{
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.handleClose,
          expression: "handleClose"
        }],
        staticClass: "el-select",
        class: [_vm.selectSize ? "el-select--" + _vm.selectSize : ""],
        on: {
          click: function click($event) {
            $event.stopPropagation();
            return _vm.toggleMenu($event);
          }
        }
      }, [_vm.multiple ? _c("div", {
        ref: "tags",
        staticClass: "el-select__tags",
        style: { "max-width": _vm.inputWidth - 32 + "px", width: "100%" }
      }, [_vm.collapseTags && _vm.selected.length ? _c("span", [_c("el-tag", {
        attrs: {
          closable: !_vm.selectDisabled,
          size: _vm.collapseTagSize,
          hit: _vm.selected[0].hitState,
          type: "info",
          "disable-transitions": ""
        },
        on: {
          close: function close($event) {
            _vm.deleteTag($event, _vm.selected[0]);
          }
        }
      }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v(_vm._s(_vm.selected[0].currentLabel))])]), _vm.selected.length > 1 ? _c("el-tag", {
        attrs: {
          closable: false,
          size: _vm.collapseTagSize,
          type: "info",
          "disable-transitions": ""
        }
      }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v("+ " + _vm._s(_vm.selected.length - 1))])]) : _vm._e()], 1) : _vm._e(), !_vm.collapseTags ? _c("transition-group", { on: { "after-leave": _vm.resetInputHeight } }, _vm._l(_vm.selected, function (item) {
        return _c("el-tag", {
          key: _vm.getValueKey(item),
          attrs: {
            closable: !_vm.selectDisabled,
            size: _vm.collapseTagSize,
            hit: item.hitState,
            type: "info",
            "disable-transitions": ""
          },
          on: {
            close: function close($event) {
              _vm.deleteTag($event, item);
            }
          }
        }, [_c("span", { staticClass: "el-select__tags-text" }, [_vm._v(_vm._s(item.currentLabel))])]);
      }), 1) : _vm._e(), _vm.filterable ? _c("input", {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: _vm.query,
          expression: "query"
        }],
        ref: "input",
        staticClass: "el-select__input",
        class: [_vm.selectSize ? "is-" + _vm.selectSize : ""],
        style: {
          "flex-grow": "1",
          width: _vm.inputLength / (_vm.inputWidth - 32) + "%",
          "max-width": _vm.inputWidth - 42 + "px"
        },
        attrs: {
          type: "text",
          disabled: _vm.selectDisabled,
          autocomplete: _vm.autoComplete || _vm.autocomplete
        },
        domProps: { value: _vm.query },
        on: {
          focus: _vm.handleFocus,
          blur: function blur($event) {
            _vm.softFocus = false;
          },
          keyup: _vm.managePlaceholder,
          keydown: [_vm.resetInputState, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.preventDefault();
            _vm.handleNavigate("next");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.preventDefault();
            _vm.handleNavigate("prev");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            $event.preventDefault();
            return _vm.selectOption($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.visible = false;
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
              return null;
            }
            return _vm.deletePrevTag($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
              return null;
            }
            _vm.visible = false;
          }],
          compositionstart: _vm.handleComposition,
          compositionupdate: _vm.handleComposition,
          compositionend: _vm.handleComposition,
          input: [function ($event) {
            if ($event.target.composing) {
              return;
            }
            _vm.query = $event.target.value;
          }, _vm.debouncedQueryChange]
        }
      }) : _vm._e()], 1) : _vm._e(), _c("el-input", {
        ref: "reference",
        class: { "is-focus": _vm.visible },
        attrs: {
          type: "text",
          placeholder: _vm.currentPlaceholder,
          name: _vm.name,
          id: _vm.id,
          autocomplete: _vm.autoComplete || _vm.autocomplete,
          size: _vm.selectSize,
          disabled: _vm.selectDisabled,
          readonly: _vm.readonly,
          "validate-event": false,
          tabindex: _vm.multiple && _vm.filterable ? "-1" : null
        },
        on: {
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          input: _vm.debouncedOnInputChange,
          compositionstart: _vm.handleComposition,
          compositionupdate: _vm.handleComposition,
          compositionend: _vm.handleComposition
        },
        nativeOn: {
          keydown: [function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.handleNavigate("next");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.handleNavigate("prev");
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            $event.preventDefault();
            return _vm.selectOption($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
              return null;
            }
            $event.stopPropagation();
            $event.preventDefault();
            _vm.visible = false;
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
              return null;
            }
            _vm.visible = false;
          }],
          mouseenter: function mouseenter($event) {
            _vm.inputHovering = true;
          },
          mouseleave: function mouseleave($event) {
            _vm.inputHovering = false;
          }
        },
        model: {
          value: _vm.selectedLabel,
          callback: function callback($$v) {
            _vm.selectedLabel = $$v;
          },
          expression: "selectedLabel"
        }
      }, [_vm.$slots.prefix ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2) : _vm._e(), _c("template", { slot: "suffix" }, [_c("i", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.showClose,
          expression: "!showClose"
        }],
        class: ["el-select__caret", "el-input__icon", "el-icon-" + _vm.iconClass]
      }), _vm.showClose ? _c("i", {
        staticClass: "el-select__caret el-input__icon el-icon-circle-close",
        on: { click: _vm.handleClearClick }
      }) : _vm._e()])], 2), _c("transition", {
        attrs: { name: "el-zoom-in-top" },
        on: {
          "before-enter": _vm.handleMenuEnter,
          "after-leave": _vm.doDestroy
        }
      }, [_c("el-select-menu", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible && _vm.emptyText !== false,
          expression: "visible && emptyText !== false"
        }],
        ref: "popper",
        attrs: { "append-to-body": _vm.popperAppendToBody }
      }, [_c("el-scrollbar", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.options.length > 0 && !_vm.loading,
          expression: "options.length > 0 && !loading"
        }],
        ref: "scrollbar",
        class: {
          "is-empty": !_vm.allowCreate && _vm.query && _vm.filteredOptionsCount === 0
        },
        attrs: {
          tag: "ul",
          "wrap-class": "el-select-dropdown__wrap",
          "view-class": "el-select-dropdown__list"
        }
      }, [_vm.showNewOption ? _c("el-option", {
        attrs: { value: _vm.query, created: "" }
      }) : _vm._e(), _vm._t("default")], 2), _vm.emptyText && (!_vm.allowCreate || _vm.loading || _vm.allowCreate && _vm.options.length === 0) ? [_vm.$slots.empty ? _vm._t("empty") : _c("p", { staticClass: "el-select-dropdown__empty" }, [_vm._v("\n          " + _vm._s(_vm.emptyText) + "\n        ")])] : _vm._e()], 2)], 1)], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
    var focus_ = __webpack_require__(22);
    var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
    var locale_ = __webpack_require__(6);
    var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

    // EXTERNAL MODULE: external "element-ui/lib/input"
    var input_ = __webpack_require__(10);
    var input_default = /*#__PURE__*/__webpack_require__.n(input_);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&
    var select_dropdownvue_type_template_id_06828748_render = function select_dropdownvue_type_template_id_06828748_render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        staticClass: "el-select-dropdown el-popper",
        class: [{ "is-multiple": _vm.$parent.multiple }, _vm.popperClass],
        style: { minWidth: _vm.minWidth }
      }, [_vm._t("default")], 2);
    };
    var select_dropdownvue_type_template_id_06828748_staticRenderFns = [];
    select_dropdownvue_type_template_id_06828748_render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=template&id=06828748&

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var select_dropdownvue_type_script_lang_js_ = {
      name: 'ElSelectDropdown',

      componentName: 'ElSelectDropdown',

      mixins: [vue_popper_default.a],

      props: {
        placement: {
          default: 'bottom-start'
        },

        boundariesPadding: {
          default: 0
        },

        popperOptions: {
          default: function _default() {
            return {
              gpuAcceleration: false
            };
          }
        },

        visibleArrow: {
          default: true
        },

        appendToBody: {
          type: Boolean,
          default: true
        }
      },

      data: function data() {
        return {
          minWidth: ''
        };
      },

      computed: {
        popperClass: function popperClass() {
          return this.$parent.popperClass;
        }
      },

      watch: {
        '$parent.inputWidth': function $parentInputWidth() {
          this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px';
        }
      },

      mounted: function mounted() {
        var _this = this;

        this.referenceElm = this.$parent.$refs.reference.$el;
        this.$parent.popperElm = this.popperElm = this.$el;
        this.$on('updatePopper', function () {
          if (_this.$parent.visible) _this.updatePopper();
        });
        this.$on('destroyPopper', this.destroyPopper);
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue?vue&type=script&lang=js&
    /* harmony default export */var src_select_dropdownvue_type_script_lang_js_ = select_dropdownvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/select-dropdown.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_select_dropdownvue_type_script_lang_js_, select_dropdownvue_type_template_id_06828748_render, select_dropdownvue_type_template_id_06828748_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/select-dropdown.vue";
    /* harmony default export */var select_dropdown = component.exports;
    // EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
    var src_option = __webpack_require__(33);

    // EXTERNAL MODULE: external "element-ui/lib/tag"
    var tag_ = __webpack_require__(37);
    var tag_default = /*#__PURE__*/__webpack_require__.n(tag_);

    // EXTERNAL MODULE: external "element-ui/lib/scrollbar"
    var scrollbar_ = __webpack_require__(15);
    var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

    // EXTERNAL MODULE: external "throttle-debounce/debounce"
    var debounce_ = __webpack_require__(19);
    var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/clickoutside"
    var clickoutside_ = __webpack_require__(12);
    var clickoutside_default = /*#__PURE__*/__webpack_require__.n(clickoutside_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/resize-event"
    var resize_event_ = __webpack_require__(16);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
    var scroll_into_view_ = __webpack_require__(31);
    var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./packages/select/src/navigation-mixin.js
    /* harmony default export */var navigation_mixin = {
      data: function data() {
        return {
          hoverOption: -1
        };
      },

      computed: {
        optionsAllDisabled: function optionsAllDisabled() {
          return this.options.filter(function (option) {
            return option.visible;
          }).every(function (option) {
            return option.disabled;
          });
        }
      },

      watch: {
        hoverIndex: function hoverIndex(val) {
          var _this = this;

          if (typeof val === 'number' && val > -1) {
            this.hoverOption = this.options[val] || {};
          }
          this.options.forEach(function (option) {
            option.hover = _this.hoverOption === option;
          });
        }
      },

      methods: {
        navigateOptions: function navigateOptions(direction) {
          var _this2 = this;

          if (!this.visible) {
            this.visible = true;
            return;
          }
          if (this.options.length === 0 || this.filteredOptionsCount === 0) return;
          if (!this.optionsAllDisabled) {
            if (direction === 'next') {
              this.hoverIndex++;
              if (this.hoverIndex === this.options.length) {
                this.hoverIndex = 0;
              }
            } else if (direction === 'prev') {
              this.hoverIndex--;
              if (this.hoverIndex < 0) {
                this.hoverIndex = this.options.length - 1;
              }
            }
            var option = this.options[this.hoverIndex];
            if (option.disabled === true || option.groupDisabled === true || !option.visible) {
              this.navigateOptions(direction);
            }
            this.$nextTick(function () {
              return _this2.scrollToOption(_this2.hoverOption);
            });
          }
        }
      }
    };
    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var selectvue_type_script_lang_js_ = {
      mixins: [emitter_default.a, locale_default.a, focus_default()('reference'), navigation_mixin],

      name: 'ElSelect',

      componentName: 'ElSelect',

      inject: {
        elForm: {
          default: ''
        },

        elFormItem: {
          default: ''
        }
      },

      provide: function provide() {
        return {
          'select': this
        };
      },

      computed: {
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        readonly: function readonly() {
          return !this.filterable || this.multiple || !Object(util_["isIE"])() && !Object(util_["isEdge"])() && !this.visible;
        },
        showClose: function showClose() {
          var hasValue = this.multiple ? Array.isArray(this.value) && this.value.length > 0 : this.value !== undefined && this.value !== null && this.value !== '';
          var criteria = this.clearable && !this.selectDisabled && this.inputHovering && hasValue;
          return criteria;
        },
        iconClass: function iconClass() {
          return this.remote && this.filterable ? '' : this.visible ? 'arrow-up is-reverse' : 'arrow-up';
        },
        debounce: function debounce() {
          return this.remote ? 300 : 0;
        },
        emptyText: function emptyText() {
          if (this.loading) {
            return this.loadingText || this.t('el.select.loading');
          } else {
            if (this.remote && this.query === '' && this.options.length === 0) return false;
            if (this.filterable && this.query && this.options.length > 0 && this.filteredOptionsCount === 0) {
              return this.noMatchText || this.t('el.select.noMatch');
            }
            if (this.options.length === 0) {
              return this.noDataText || this.t('el.select.noData');
            }
          }
          return null;
        },
        showNewOption: function showNewOption() {
          var _this = this;

          var hasExistingOption = this.options.filter(function (option) {
            return !option.created;
          }).some(function (option) {
            return option.currentLabel === _this.query;
          });
          return this.filterable && this.allowCreate && this.query !== '' && !hasExistingOption;
        },
        selectSize: function selectSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        selectDisabled: function selectDisabled() {
          return this.disabled || (this.elForm || {}).disabled;
        },
        collapseTagSize: function collapseTagSize() {
          return ['small', 'mini'].indexOf(this.selectSize) > -1 ? 'mini' : 'small';
        },
        propPlaceholder: function propPlaceholder() {
          return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
        }
      },

      components: {
        ElInput: input_default.a,
        ElSelectMenu: select_dropdown,
        ElOption: src_option["a" /* default */],
        ElTag: tag_default.a,
        ElScrollbar: scrollbar_default.a
      },

      directives: { Clickoutside: clickoutside_default.a },

      props: {
        name: String,
        id: String,
        value: {
          required: true
        },
        autocomplete: {
          type: String,
          default: 'off'
        },
        /** @Deprecated in next major version */
        autoComplete: {
          type: String,
          validator: function validator(val) {
            false && false;
            return true;
          }
        },
        automaticDropdown: Boolean,
        size: String,
        disabled: Boolean,
        clearable: Boolean,
        filterable: Boolean,
        allowCreate: Boolean,
        loading: Boolean,
        popperClass: String,
        remote: Boolean,
        loadingText: String,
        noMatchText: String,
        noDataText: String,
        remoteMethod: Function,
        filterMethod: Function,
        multiple: Boolean,
        multipleLimit: {
          type: Number,
          default: 0
        },
        placeholder: {
          type: String,
          required: false
        },
        defaultFirstOption: Boolean,
        reserveKeyword: Boolean,
        valueKey: {
          type: String,
          default: 'value'
        },
        collapseTags: Boolean,
        popperAppendToBody: {
          type: Boolean,
          default: true
        }
      },

      data: function data() {
        return {
          options: [],
          cachedOptions: [],
          createdLabel: null,
          createdSelected: false,
          selected: this.multiple ? [] : {},
          inputLength: 20,
          inputWidth: 0,
          initialInputHeight: 0,
          cachedPlaceHolder: '',
          optionsCount: 0,
          filteredOptionsCount: 0,
          visible: false,
          softFocus: false,
          selectedLabel: '',
          hoverIndex: -1,
          query: '',
          previousQuery: null,
          inputHovering: false,
          currentPlaceholder: '',
          menuVisibleOnFocus: false,
          isOnComposition: false,
          isSilentBlur: false
        };
      },

      watch: {
        selectDisabled: function selectDisabled() {
          var _this2 = this;

          this.$nextTick(function () {
            _this2.resetInputHeight();
          });
        },
        propPlaceholder: function propPlaceholder(val) {
          this.cachedPlaceHolder = this.currentPlaceholder = val;
        },
        value: function value(val, oldVal) {
          if (this.multiple) {
            this.resetInputHeight();
            if (val && val.length > 0 || this.$refs.input && this.query !== '') {
              this.currentPlaceholder = '';
            } else {
              this.currentPlaceholder = this.cachedPlaceHolder;
            }
            if (this.filterable && !this.reserveKeyword) {
              this.query = '';
              this.handleQueryChange(this.query);
            }
          }
          this.setSelected();
          if (this.filterable && !this.multiple) {
            this.inputLength = 20;
          }
          if (!Object(util_["valueEquals"])(val, oldVal)) {
            this.dispatch('ElFormItem', 'el.form.change', val);
          }
        },
        visible: function visible(val) {
          var _this3 = this;

          if (!val) {
            this.broadcast('ElSelectDropdown', 'destroyPopper');
            if (this.$refs.input) {
              this.$refs.input.blur();
            }
            this.query = '';
            this.previousQuery = null;
            this.selectedLabel = '';
            this.inputLength = 20;
            this.menuVisibleOnFocus = false;
            this.resetHoverIndex();
            this.$nextTick(function () {
              if (_this3.$refs.input && _this3.$refs.input.value === '' && _this3.selected.length === 0) {
                _this3.currentPlaceholder = _this3.cachedPlaceHolder;
              }
            });
            if (!this.multiple) {
              if (this.selected) {
                if (this.filterable && this.allowCreate && this.createdSelected && this.createdLabel) {
                  this.selectedLabel = this.createdLabel;
                } else {
                  this.selectedLabel = this.selected.currentLabel;
                }
                if (this.filterable) this.query = this.selectedLabel;
              }

              if (this.filterable) {
                this.currentPlaceholder = this.cachedPlaceHolder;
              }
            }
          } else {
            this.broadcast('ElSelectDropdown', 'updatePopper');
            if (this.filterable) {
              this.query = this.remote ? '' : this.selectedLabel;
              this.handleQueryChange(this.query);
              if (this.multiple) {
                this.$refs.input.focus();
              } else {
                if (!this.remote) {
                  this.broadcast('ElOption', 'queryChange', '');
                  this.broadcast('ElOptionGroup', 'queryChange');
                }

                if (this.selectedLabel) {
                  this.currentPlaceholder = this.selectedLabel;
                  this.selectedLabel = '';
                }
              }
            }
          }
          this.$emit('visible-change', val);
        },
        options: function options() {
          var _this4 = this;

          if (this.$isServer) return;
          this.$nextTick(function () {
            _this4.broadcast('ElSelectDropdown', 'updatePopper');
          });
          if (this.multiple) {
            this.resetInputHeight();
          }
          var inputs = this.$el.querySelectorAll('input');
          if ([].indexOf.call(inputs, document.activeElement) === -1) {
            this.setSelected();
          }
          if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
            this.checkDefaultFirstOption();
          }
        }
      },

      methods: {
        handleNavigate: function handleNavigate(direction) {
          if (this.isOnComposition) return;

          this.navigateOptions(direction);
        },
        handleComposition: function handleComposition(event) {
          var _this5 = this;

          var text = event.target.value;
          if (event.type === 'compositionend') {
            this.isOnComposition = false;
            this.$nextTick(function (_) {
              return _this5.handleQueryChange(text);
            });
          } else {
            var lastCharacter = text[text.length - 1] || '';
            this.isOnComposition = !Object(shared_["isKorean"])(lastCharacter);
          }
        },
        handleQueryChange: function handleQueryChange(val) {
          var _this6 = this;

          if (this.previousQuery === val || this.isOnComposition) return;
          if (this.previousQuery === null && (typeof this.filterMethod === 'function' || typeof this.remoteMethod === 'function')) {
            this.previousQuery = val;
            return;
          }
          this.previousQuery = val;
          this.$nextTick(function () {
            if (_this6.visible) _this6.broadcast('ElSelectDropdown', 'updatePopper');
          });
          this.hoverIndex = -1;
          if (this.multiple && this.filterable) {
            this.$nextTick(function () {
              var length = _this6.$refs.input.value.length * 15 + 20;
              _this6.inputLength = _this6.collapseTags ? Math.min(50, length) : length;
              _this6.managePlaceholder();
              _this6.resetInputHeight();
            });
          }
          if (this.remote && typeof this.remoteMethod === 'function') {
            this.hoverIndex = -1;
            this.remoteMethod(val);
          } else if (typeof this.filterMethod === 'function') {
            this.filterMethod(val);
            this.broadcast('ElOptionGroup', 'queryChange');
          } else {
            this.filteredOptionsCount = this.optionsCount;
            this.broadcast('ElOption', 'queryChange', val);
            this.broadcast('ElOptionGroup', 'queryChange');
          }
          if (this.defaultFirstOption && (this.filterable || this.remote) && this.filteredOptionsCount) {
            this.checkDefaultFirstOption();
          }
        },
        scrollToOption: function scrollToOption(option) {
          var target = Array.isArray(option) && option[0] ? option[0].$el : option.$el;
          if (this.$refs.popper && target) {
            var menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
            scroll_into_view_default()(menu, target);
          }
          this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();
        },
        handleMenuEnter: function handleMenuEnter() {
          var _this7 = this;

          this.$nextTick(function () {
            return _this7.scrollToOption(_this7.selected);
          });
        },
        emitChange: function emitChange(val) {
          if (!Object(util_["valueEquals"])(this.value, val)) {
            this.$emit('change', val);
          }
        },
        getOption: function getOption(value) {
          var option = void 0;
          var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
          var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
          var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

          for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
            var cachedOption = this.cachedOptions[i];
            var isEqual = isObject ? Object(util_["getValueByPath"])(cachedOption.value, this.valueKey) === Object(util_["getValueByPath"])(value, this.valueKey) : cachedOption.value === value;
            if (isEqual) {
              option = cachedOption;
              break;
            }
          }
          if (option) return option;
          var label = !isObject && !isNull && !isUndefined ? String(value) : '';
          var newOption = {
            value: value,
            currentLabel: label
          };
          if (this.multiple) {
            newOption.hitState = false;
          }
          return newOption;
        },
        setSelected: function setSelected() {
          var _this8 = this;

          if (!this.multiple) {
            var option = this.getOption(this.value);
            if (option.created) {
              this.createdLabel = option.currentLabel;
              this.createdSelected = true;
            } else {
              this.createdSelected = false;
            }
            this.selectedLabel = option.currentLabel;
            this.selected = option;
            if (this.filterable) this.query = this.selectedLabel;
            return;
          }
          var result = [];
          if (Array.isArray(this.value)) {
            this.value.forEach(function (value) {
              result.push(_this8.getOption(value));
            });
          }
          this.selected = result;
          this.$nextTick(function () {
            _this8.resetInputHeight();
          });
        },
        handleFocus: function handleFocus(event) {
          if (!this.softFocus) {
            if (this.automaticDropdown || this.filterable) {
              if (this.filterable && !this.visible) {
                this.menuVisibleOnFocus = true;
              }
              this.visible = true;
            }
            this.$emit('focus', event);
          } else {
            this.softFocus = false;
          }
        },
        blur: function blur() {
          this.visible = false;
          this.$refs.reference.blur();
        },
        handleBlur: function handleBlur(event) {
          var _this9 = this;

          setTimeout(function () {
            if (_this9.isSilentBlur) {
              _this9.isSilentBlur = false;
            } else {
              _this9.$emit('blur', event);
            }
          }, 50);
          this.softFocus = false;
        },
        handleClearClick: function handleClearClick(event) {
          this.deleteSelected(event);
        },
        doDestroy: function doDestroy() {
          this.$refs.popper && this.$refs.popper.doDestroy();
        },
        handleClose: function handleClose() {
          this.visible = false;
        },
        toggleLastOptionHitState: function toggleLastOptionHitState(hit) {
          if (!Array.isArray(this.selected)) return;
          var option = this.selected[this.selected.length - 1];
          if (!option) return;

          if (hit === true || hit === false) {
            option.hitState = hit;
            return hit;
          }

          option.hitState = !option.hitState;
          return option.hitState;
        },
        deletePrevTag: function deletePrevTag(e) {
          if (e.target.value.length <= 0 && !this.toggleLastOptionHitState()) {
            var value = this.value.slice();
            value.pop();
            this.$emit('input', value);
            this.emitChange(value);
          }
        },
        managePlaceholder: function managePlaceholder() {
          if (this.currentPlaceholder !== '') {
            this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
          }
        },
        resetInputState: function resetInputState(e) {
          if (e.keyCode !== 8) this.toggleLastOptionHitState(false);
          this.inputLength = this.$refs.input.value.length * 15 + 20;
          this.resetInputHeight();
        },
        resetInputHeight: function resetInputHeight() {
          var _this10 = this;

          if (this.collapseTags && !this.filterable) return;
          this.$nextTick(function () {
            if (!_this10.$refs.reference) return;
            var inputChildNodes = _this10.$refs.reference.$el.childNodes;
            var input = [].filter.call(inputChildNodes, function (item) {
              return item.tagName === 'INPUT';
            })[0];
            var tags = _this10.$refs.tags;
            var tagsHeight = tags ? Math.round(tags.getBoundingClientRect().height) : 0;
            var sizeInMap = _this10.initialInputHeight || 40;
            input.style.height = _this10.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tagsHeight + (tagsHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
            if (_this10.visible && _this10.emptyText !== false) {
              _this10.broadcast('ElSelectDropdown', 'updatePopper');
            }
          });
        },
        resetHoverIndex: function resetHoverIndex() {
          var _this11 = this;

          setTimeout(function () {
            if (!_this11.multiple) {
              _this11.hoverIndex = _this11.options.indexOf(_this11.selected);
            } else {
              if (_this11.selected.length > 0) {
                _this11.hoverIndex = Math.min.apply(null, _this11.selected.map(function (item) {
                  return _this11.options.indexOf(item);
                }));
              } else {
                _this11.hoverIndex = -1;
              }
            }
          }, 300);
        },
        handleOptionSelect: function handleOptionSelect(option, byClick) {
          var _this12 = this;

          if (this.multiple) {
            var value = (this.value || []).slice();
            var optionIndex = this.getValueIndex(value, option.value);
            if (optionIndex > -1) {
              value.splice(optionIndex, 1);
            } else if (this.multipleLimit <= 0 || value.length < this.multipleLimit) {
              value.push(option.value);
            }
            this.$emit('input', value);
            this.emitChange(value);
            if (option.created) {
              this.query = '';
              this.handleQueryChange('');
              this.inputLength = 20;
            }
            if (this.filterable) this.$refs.input.focus();
          } else {
            this.$emit('input', option.value);
            this.emitChange(option.value);
            this.visible = false;
          }
          this.isSilentBlur = byClick;
          this.setSoftFocus();
          if (this.visible) return;
          this.$nextTick(function () {
            _this12.scrollToOption(option);
          });
        },
        setSoftFocus: function setSoftFocus() {
          this.softFocus = true;
          var input = this.$refs.input || this.$refs.reference;
          if (input) {
            input.focus();
          }
        },
        getValueIndex: function getValueIndex() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var value = arguments[1];

          var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
          if (!isObject) {
            return arr.indexOf(value);
          } else {
            var valueKey = this.valueKey;
            var index = -1;
            arr.some(function (item, i) {
              if (Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(value, valueKey)) {
                index = i;
                return true;
              }
              return false;
            });
            return index;
          }
        },
        toggleMenu: function toggleMenu() {
          if (!this.selectDisabled) {
            if (this.menuVisibleOnFocus) {
              this.menuVisibleOnFocus = false;
            } else {
              this.visible = !this.visible;
            }
            if (this.visible) {
              (this.$refs.input || this.$refs.reference).focus();
            }
          }
        },
        selectOption: function selectOption() {
          if (!this.visible) {
            this.toggleMenu();
          } else {
            if (this.options[this.hoverIndex]) {
              this.handleOptionSelect(this.options[this.hoverIndex]);
            }
          }
        },
        deleteSelected: function deleteSelected(event) {
          event.stopPropagation();
          var value = this.multiple ? [] : '';
          this.$emit('input', value);
          this.emitChange(value);
          this.visible = false;
          this.$emit('clear');
        },
        deleteTag: function deleteTag(event, tag) {
          var index = this.selected.indexOf(tag);
          if (index > -1 && !this.selectDisabled) {
            var value = this.value.slice();
            value.splice(index, 1);
            this.$emit('input', value);
            this.emitChange(value);
            this.$emit('remove-tag', tag.value);
          }
          event.stopPropagation();
        },
        onInputChange: function onInputChange() {
          if (this.filterable && this.query !== this.selectedLabel) {
            this.query = this.selectedLabel;
            this.handleQueryChange(this.query);
          }
        },
        onOptionDestroy: function onOptionDestroy(index) {
          if (index > -1) {
            this.optionsCount--;
            this.filteredOptionsCount--;
            this.options.splice(index, 1);
          }
        },
        resetInputWidth: function resetInputWidth() {
          this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
        },
        handleResize: function handleResize() {
          this.resetInputWidth();
          if (this.multiple) this.resetInputHeight();
        },
        checkDefaultFirstOption: function checkDefaultFirstOption() {
          this.hoverIndex = -1;
          // highlight the created option
          var hasCreated = false;
          for (var i = this.options.length - 1; i >= 0; i--) {
            if (this.options[i].created) {
              hasCreated = true;
              this.hoverIndex = i;
              break;
            }
          }
          if (hasCreated) return;
          for (var _i = 0; _i !== this.options.length; ++_i) {
            var option = this.options[_i];
            if (this.query) {
              // highlight first options that passes the filter
              if (!option.disabled && !option.groupDisabled && option.visible) {
                this.hoverIndex = _i;
                break;
              }
            } else {
              // highlight currently selected option
              if (option.itemSelected) {
                this.hoverIndex = _i;
                break;
              }
            }
          }
        },
        getValueKey: function getValueKey(item) {
          if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
            return item.value;
          } else {
            return Object(util_["getValueByPath"])(item.value, this.valueKey);
          }
        }
      },

      created: function created() {
        var _this13 = this;

        this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;
        if (this.multiple && !Array.isArray(this.value)) {
          this.$emit('input', []);
        }
        if (!this.multiple && Array.isArray(this.value)) {
          this.$emit('input', '');
        }

        this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
          _this13.onInputChange();
        });

        this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
          _this13.handleQueryChange(e.target.value);
        });

        this.$on('handleOptionClick', this.handleOptionSelect);
        this.$on('setSelected', this.setSelected);
      },
      mounted: function mounted() {
        var _this14 = this;

        if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
          this.currentPlaceholder = '';
        }
        Object(resize_event_["addResizeListener"])(this.$el, this.handleResize);

        var reference = this.$refs.reference;
        if (reference && reference.$el) {
          var sizeMap = {
            medium: 36,
            small: 32,
            mini: 28
          };
          var input = reference.$el.querySelector('input');
          this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
        }
        if (this.remote && this.multiple) {
          this.resetInputHeight();
        }
        this.$nextTick(function () {
          if (reference && reference.$el) {
            _this14.inputWidth = reference.$el.getBoundingClientRect().width;
          }
        });
        this.setSelected();
      },
      beforeDestroy: function beforeDestroy() {
        if (this.$el && this.handleResize) Object(resize_event_["removeResizeListener"])(this.$el, this.handleResize);
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
    /* harmony default export */var src_selectvue_type_script_lang_js_ = selectvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/select/src/select.vue


    /* normalize component */

    var select_component = Object(componentNormalizer["a" /* default */])(src_selectvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var select_api;
    }
    select_component.options.__file = "packages/select/src/select.vue";
    /* harmony default export */var src_select = select_component.exports;
    // CONCATENATED MODULE: ./packages/select/index.js


    /* istanbul ignore next */
    src_select.install = function (Vue) {
      Vue.component(src_select.name, src_select);
    };

    /* harmony default export */var packages_select = __webpack_exports__["default"] = src_select;

    /***/
  }

  /******/ });

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 53);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/33:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("li", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }],
        staticClass: "el-select-dropdown__item",
        class: {
          selected: _vm.itemSelected,
          "is-disabled": _vm.disabled || _vm.groupDisabled || _vm.limitReached,
          hover: _vm.hover
        },
        on: {
          mouseenter: _vm.hoverItem,
          click: function click($event) {
            $event.stopPropagation();
            return _vm.selectOptionClick($event);
          }
        }
      }, [_vm._t("default", [_c("span", [_vm._v(_vm._s(_vm.currentLabel))])])], 2);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

    // EXTERNAL MODULE: external "element-ui/lib/mixins/emitter"
    var emitter_ = __webpack_require__(4);
    var emitter_default = /*#__PURE__*/__webpack_require__.n(emitter_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
    var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var optionvue_type_script_lang_js_ = {
      mixins: [emitter_default.a],

      name: 'ElOption',

      componentName: 'ElOption',

      inject: ['select'],

      props: {
        value: {
          required: true
        },
        label: [String, Number],
        created: Boolean,
        disabled: {
          type: Boolean,
          default: false
        }
      },

      data: function data() {
        return {
          index: -1,
          groupDisabled: false,
          visible: true,
          hitState: false,
          hover: false
        };
      },

      computed: {
        isObject: function isObject() {
          return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
        },
        currentLabel: function currentLabel() {
          return this.label || (this.isObject ? '' : this.value);
        },
        currentValue: function currentValue() {
          return this.value || this.label || '';
        },
        itemSelected: function itemSelected() {
          if (!this.select.multiple) {
            return this.isEqual(this.value, this.select.value);
          } else {
            return this.contains(this.select.value, this.value);
          }
        },
        limitReached: function limitReached() {
          if (this.select.multiple) {
            return !this.itemSelected && (this.select.value || []).length >= this.select.multipleLimit && this.select.multipleLimit > 0;
          } else {
            return false;
          }
        }
      },

      watch: {
        currentLabel: function currentLabel() {
          if (!this.created && !this.select.remote) this.dispatch('ElSelect', 'setSelected');
        },
        value: function value(val, oldVal) {
          var _select = this.select,
              remote = _select.remote,
              valueKey = _select.valueKey;

          if (!this.created && !remote) {
            if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
              return;
            }
            this.dispatch('ElSelect', 'setSelected');
          }
        }
      },

      methods: {
        isEqual: function isEqual(a, b) {
          if (!this.isObject) {
            return a === b;
          } else {
            var valueKey = this.select.valueKey;
            return Object(util_["getValueByPath"])(a, valueKey) === Object(util_["getValueByPath"])(b, valueKey);
          }
        },
        contains: function contains() {
          var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var target = arguments[1];

          if (!this.isObject) {
            return arr && arr.indexOf(target) > -1;
          } else {
            var valueKey = this.select.valueKey;
            return arr && arr.some(function (item) {
              return Object(util_["getValueByPath"])(item, valueKey) === Object(util_["getValueByPath"])(target, valueKey);
            });
          }
        },
        handleGroupDisabled: function handleGroupDisabled(val) {
          this.groupDisabled = val;
        },
        hoverItem: function hoverItem() {
          if (!this.disabled && !this.groupDisabled) {
            this.select.hoverIndex = this.select.options.indexOf(this);
          }
        },
        selectOptionClick: function selectOptionClick() {
          if (this.disabled !== true && this.groupDisabled !== true) {
            this.dispatch('ElSelect', 'handleOptionClick', [this, true]);
          }
        },
        queryChange: function queryChange(query) {
          this.visible = new RegExp(Object(util_["escapeRegexpString"])(query), 'i').test(this.currentLabel) || this.created;
          if (!this.visible) {
            this.select.filteredOptionsCount--;
          }
        }
      },

      created: function created() {
        this.select.options.push(this);
        this.select.cachedOptions.push(this);
        this.select.optionsCount++;
        this.select.filteredOptionsCount++;

        this.$on('queryChange', this.queryChange);
        this.$on('handleGroupDisabled', this.handleGroupDisabled);
      },
      beforeDestroy: function beforeDestroy() {
        var _select2 = this.select,
            selected = _select2.selected,
            multiple = _select2.multiple;

        var selectedOptions = multiple ? selected : [selected];
        var index = this.select.cachedOptions.indexOf(this);
        var selectedIndex = selectedOptions.indexOf(this);

        // if option is not selected, remove it from cache
        if (index > -1 && selectedIndex < 0) {
          this.select.cachedOptions.splice(index, 1);
        }
        this.select.onOptionDestroy(this.select.options.indexOf(this));
      }
    };
    // CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
    /* harmony default export */var src_optionvue_type_script_lang_js_ = optionvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/select/src/option.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_optionvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/select/src/option.vue";
    /* harmony default export */var src_option = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/4:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(61);

    /***/
  },

  /***/53:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);
    /* harmony import */var _select_src_option__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33);

    /* istanbul ignore next */
    _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"].install = function (Vue) {
      Vue.component(_select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"].name, _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"]);
    };

    /* harmony default export */__webpack_exports__["default"] = _select_src_option__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"];

    /***/
  }

  /******/ });

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1222);

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */



var UserAgent_DEPRECATED = __webpack_require__(1223);

var isEventSupported = __webpack_require__(1224);

// Reasonable defaults
var PIXEL_STEP = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel( /*object*/event) /*object*/{
  var sX = 0,
      sY = 0,
      // spinX, spinY
  pX = 0,
      pY = 0; // pixelX, pixelY

  // Legacy
  if ('detail' in event) {
    sY = event.detail;
  }
  if ('wheelDelta' in event) {
    sY = -event.wheelDelta / 120;
  }
  if ('wheelDeltaY' in event) {
    sY = -event.wheelDeltaY / 120;
  }
  if ('wheelDeltaX' in event) {
    sX = -event.wheelDeltaX / 120;
  }

  // side scrolling on FF with DOMMouseScroll
  if ('axis' in event && event.axis === event.HORIZONTAL_AXIS) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) {
    pY = event.deltaY;
  }
  if ('deltaX' in event) {
    pX = event.deltaX;
  }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {
      // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {
      // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) {
    sX = pX < 1 ? -1 : 1;
  }
  if (pY && !sY) {
    sY = pY < 1 ? -1 : 1;
  }

  return { spinX: sX,
    spinY: sY,
    pixelX: pX,
    pixelY: pY };
}

/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel.getEventType = function () /*string*/{
  return UserAgent_DEPRECATED.firefox() ? 'DOMMouseScroll' : isEventSupported('wheel') ? 'wheel' : 'mousewheel';
};

module.exports = normalizeWheel;

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!/Win64/.exec(uas);

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : agent[5] ? parseFloat(agent[5]) : NaN;
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function ie() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function ieCompatibilityMode() {
    return _populate() || _ie_real_version > _ie;
  },

  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function ie64() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function firefox() {
    return _populate() || _firefox;
  },

  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function opera() {
    return _populate() || _opera;
  },

  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function webkit() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function safari() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome: function chrome() {
    return _populate() || _chrome;
  },

  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function windows() {
    return _populate() || _windows;
  },

  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function osx() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function linux() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function iphone() {
    return _populate() || _iphone;
  },

  mobile: function mobile() {
    return _populate() || _iphone || _ipad || _android || _mobile;
  },

  nativeApp: function nativeApp() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function android() {
    return _populate() || _android;
  },

  ipad: function ipad() {
    return _populate() || _ipad;
  }
};

module.exports = UserAgent_DEPRECATED;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(1225);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

/*jslint evil: true */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var _ariaUtils = __webpack_require__(154);

var _ariaUtils2 = _interopRequireDefault(_ariaUtils);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * @constructor
 * @desc Dialog object providing modal focus management.
 *
 * Assumptions: The element serving as the dialog container is present in the
 * DOM and hidden. The dialog container has role='dialog'.
 *
 * @param dialogId
 *          The ID of the element serving as the dialog container.
 * @param focusAfterClosed
 *          Either the DOM node or the ID of the DOM node to focus when the
 *          dialog closes.
 * @param focusFirst
 *          Optional parameter containing either the DOM node or the ID of the
 *          DOM node to focus when the dialog opens. If not specified, the
 *          first focusable element in the dialog will receive focus.
 */
var aria = aria || {};
var tabEvent;

aria.Dialog = function (dialog, focusAfterClosed, focusFirst) {
  var _this = this;

  this.dialogNode = dialog;
  if (this.dialogNode === null || this.dialogNode.getAttribute('role') !== 'dialog') {
    throw new Error('Dialog() requires a DOM element with ARIA role of dialog.');
  }

  if (typeof focusAfterClosed === 'string') {
    this.focusAfterClosed = document.getElementById(focusAfterClosed);
  } else if ((typeof focusAfterClosed === 'undefined' ? 'undefined' : _typeof(focusAfterClosed)) === 'object') {
    this.focusAfterClosed = focusAfterClosed;
  } else {
    this.focusAfterClosed = null;
  }

  if (typeof focusFirst === 'string') {
    this.focusFirst = document.getElementById(focusFirst);
  } else if ((typeof focusFirst === 'undefined' ? 'undefined' : _typeof(focusFirst)) === 'object') {
    this.focusFirst = focusFirst;
  } else {
    this.focusFirst = null;
  }

  if (this.focusFirst) {
    this.focusFirst.focus();
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
  }

  this.lastFocus = document.activeElement;
  tabEvent = function tabEvent(e) {
    _this.trapFocus(e);
  };
  this.addListeners();
};

aria.Dialog.prototype.addListeners = function () {
  document.addEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.removeListeners = function () {
  document.removeEventListener('focus', tabEvent, true);
};

aria.Dialog.prototype.closeDialog = function () {
  var _this2 = this;

  this.removeListeners();
  if (this.focusAfterClosed) {
    setTimeout(function () {
      _this2.focusAfterClosed.focus();
    });
  }
};

aria.Dialog.prototype.trapFocus = function (event) {
  if (_ariaUtils2.default.IgnoreUtilFocusChanges) {
    return;
  }
  if (this.dialogNode.contains(event.target)) {
    this.lastFocus = event.target;
  } else {
    _ariaUtils2.default.focusFirstDescendant(this.dialogNode);
    if (this.lastFocus === document.activeElement) {
      _ariaUtils2.default.focusLastDescendant(this.dialogNode);
    }
    this.lastFocus = document.activeElement;
  }
};

exports.default = aria.Dialog;

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator___ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messages__ = __webpack_require__(1280);






/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments[2];

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return;
    }
    function complete(results) {
      var i = void 0;
      var field = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          errors = errors.concat.apply(errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        for (i = 0; i < errors.length; i++) {
          field = errors[i].field;
          fields[field] = fields[field] || [];
          fields[field].push(errors[i]);
        }
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */]) {
        messages = Object(__WEBPACK_IMPORTED_MODULE_4__messages__["b" /* newMessages */])();
      }
      Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* deepMerge */])(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* asyncMap */])(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.fields) === 'object' || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullfield(key, schema) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (errors.length) {
          Object(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* warning */])('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map(Object(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* complementError */])(rule));
            } else if (options.error) {
              errors = [options.error(rule, Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            doIt(errs && errs.length ? errors.concat(errs) : errs);
          });
        }
      }

      var res = rule.validator(rule, data.value, cb, data.source, options);
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !__WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].hasOwnProperty(rule.type)) {
      throw new Error(Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* format */])('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */].required;
    }
    return __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  __WEBPACK_IMPORTED_MODULE_3__validator___["a" /* default */][type] = validator;
};

Schema.messages = __WEBPACK_IMPORTED_MODULE_4__messages__["a" /* messages */];

/* harmony default export */ __webpack_exports__["default"] = (Schema);

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1229), __esModule: true };

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1230);
module.exports = __webpack_require__(78).Object.assign;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(155);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1233) });

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1232);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var DESCRIPTORS = __webpack_require__(62);
var getKeys = __webpack_require__(105);
var gOPS = __webpack_require__(162);
var pIE = __webpack_require__(108);
var toObject = __webpack_require__(163);
var IObject = __webpack_require__(299);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(80)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }return T;
} : $assign;

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(71);
var toLength = __webpack_require__(1235);
var toAbsoluteIndex = __webpack_require__(1236);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) {
      if (IS_INCLUDES || index in O) {
        if (O[index] === el) return IS_INCLUDES || index || 0;
      }
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(158);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(158);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1238), __esModule: true };

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1239);
__webpack_require__(1245);
module.exports = __webpack_require__(166).f('iterator');

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(1240)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(301)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(158);
var defined = __webpack_require__(157);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(303);
var descriptor = __webpack_require__(104);
var setToStringTag = __webpack_require__(165);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(69)(IteratorPrototype, __webpack_require__(72)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(70);
var anObject = __webpack_require__(103);
var getKeys = __webpack_require__(105);

module.exports = __webpack_require__(62) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) {
    dP.f(O, P = keys[i++], Properties[P]);
  }return O;
};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(48).document;
module.exports = document && document.documentElement;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(63);
var toObject = __webpack_require__(163);
var IE_PROTO = __webpack_require__(159)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1246);
var global = __webpack_require__(48);
var hide = __webpack_require__(69);
var Iterators = __webpack_require__(164);
var TO_STRING_TAG = __webpack_require__(72)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(1247);
var step = __webpack_require__(1248);
var Iterators = __webpack_require__(164);
var toIObject = __webpack_require__(71);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(301)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 1247 */
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),
/* 1248 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1250), __esModule: true };

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1251);
__webpack_require__(1257);
__webpack_require__(1258);
__webpack_require__(1259);
module.exports = __webpack_require__(78).Symbol;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var global = __webpack_require__(48);
var has = __webpack_require__(63);
var DESCRIPTORS = __webpack_require__(62);
var $export = __webpack_require__(155);
var redefine = __webpack_require__(302);
var META = __webpack_require__(1252).KEY;
var $fails = __webpack_require__(80);
var shared = __webpack_require__(160);
var setToStringTag = __webpack_require__(165);
var uid = __webpack_require__(107);
var wks = __webpack_require__(72);
var wksExt = __webpack_require__(166);
var wksDefine = __webpack_require__(167);
var enumKeys = __webpack_require__(1253);
var isArray = __webpack_require__(1254);
var anObject = __webpack_require__(103);
var isObject = __webpack_require__(79);
var toObject = __webpack_require__(163);
var toIObject = __webpack_require__(71);
var toPrimitive = __webpack_require__(156);
var createDesc = __webpack_require__(104);
var _create = __webpack_require__(303);
var gOPNExt = __webpack_require__(1255);
var $GOPD = __webpack_require__(1256);
var $GOPS = __webpack_require__(162);
var $DP = __webpack_require__(70);
var $keys = __webpack_require__(105);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function get() {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function wrap(tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
  return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) {
    $defineProperty(it, key = keys[i++], P[key]);
  }return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function _Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function $set(value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(304).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(108).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(106)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
  wks(es6Symbols[j++]);
}for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
  wksDefine(wellKnownSymbols[k++]);
}$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function _for(key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) {
      if (SymbolRegistry[key] === sym) return key;
    }
  },
  useSetter: function useSetter() {
    setter = true;
  },
  useSimple: function useSimple() {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () {
  $GOPS.f(1);
});

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) {
      args.push(arguments[i++]);
    }$replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function replacer(key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(69)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var META = __webpack_require__(107)('meta');
var isObject = __webpack_require__(79);
var has = __webpack_require__(63);
var setDesc = __webpack_require__(70).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(80)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function setMeta(it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function fastKey(it, create) {
  // return primitive with prefix
  if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function getWeak(it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function onFreeze(it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(105);
var gOPS = __webpack_require__(162);
var pIE = __webpack_require__(108);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) {
      if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
  }return result;
};

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(300);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(71);
var gOPN = __webpack_require__(304).f;
var toString = {}.toString;

var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function getWindowNames(it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(108);
var createDesc = __webpack_require__(104);
var toIObject = __webpack_require__(71);
var toPrimitive = __webpack_require__(156);
var has = __webpack_require__(63);
var IE8_DOM_DEFINE = __webpack_require__(296);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(62) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 1257 */
/***/ (function(module, exports) {



/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('asyncIterator');

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(167)('observable');

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__boolean__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__regexp__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__integer__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__float__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__array__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enum__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pattern__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__date__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__required__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type__ = __webpack_require__(1279);















/* harmony default export */ __webpack_exports__["a"] = ({
  string: __WEBPACK_IMPORTED_MODULE_0__string__["a" /* default */],
  method: __WEBPACK_IMPORTED_MODULE_1__method__["a" /* default */],
  number: __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */],
  boolean: __WEBPACK_IMPORTED_MODULE_3__boolean__["a" /* default */],
  regexp: __WEBPACK_IMPORTED_MODULE_4__regexp__["a" /* default */],
  integer: __WEBPACK_IMPORTED_MODULE_5__integer__["a" /* default */],
  float: __WEBPACK_IMPORTED_MODULE_6__float__["a" /* default */],
  array: __WEBPACK_IMPORTED_MODULE_7__array__["a" /* default */],
  object: __WEBPACK_IMPORTED_MODULE_8__object__["a" /* default */],
  'enum': __WEBPACK_IMPORTED_MODULE_9__enum__["a" /* default */],
  pattern: __WEBPACK_IMPORTED_MODULE_10__pattern__["a" /* default */],
  date: __WEBPACK_IMPORTED_MODULE_11__date__["a" /* default */],
  url: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  hex: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  email: __WEBPACK_IMPORTED_MODULE_13__type__["a" /* default */],
  required: __WEBPACK_IMPORTED_MODULE_12__required__["a" /* default */]
});

/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'string');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (string);

/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);


/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.whitespace, rule.fullField));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (whitespace);

/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__required__ = __webpack_require__(305);




/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    Object(__WEBPACK_IMPORTED_MODULE_2__required__["a" /* default */])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) !== rule.type) {
    errors.push(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* format */](options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);


/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (range);

/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);


/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* format */](options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (method);

/***/ }),
/* 1268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (number);

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(21);



/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (boolean);

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (regexp);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (integer);

/***/ }),
/* 1272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (floatFn);

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);


/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, 'array');
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'array')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (array);

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value !== undefined) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (object);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);


var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (value) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (enumerable);

/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string') && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, 'string')) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (pattern);

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (date);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rule___ = __webpack_require__(21);



function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value);
  __WEBPACK_IMPORTED_MODULE_1__rule___["a" /* default */].required(rule, value, source, errors, options, type);
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (required);

/***/ }),
/* 1279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rule___ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(17);



function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType) && !rule.required) {
      return callback();
    }
    __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].required(rule, value, source, errors, options, ruleType);
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* isEmptyValue */])(value, ruleType)) {
      __WEBPACK_IMPORTED_MODULE_0__rule___["a" /* default */].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

/* harmony default export */ __webpack_exports__["a"] = (type);

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = newMessages;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = newMessages();

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 86);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/10:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(148);

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(43);

    /***/
  },

  /***/22:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(152);

    /***/
  },

  /***/30:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
    /* harmony import */var element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__);

    /* harmony default export */__webpack_exports__["a"] = {
      bind: function bind(el, binding, vnode) {
        var interval = null;
        var startTime = void 0;
        var handler = function handler() {
          return vnode.context[binding.expression].apply();
        };
        var clear = function clear() {
          if (Date.now() - startTime < 100) {
            handler();
          }
          clearInterval(interval);
          interval = null;
        };

        Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["on"])(el, 'mousedown', function (e) {
          if (e.button !== 0) return;
          startTime = Date.now();
          Object(element_ui_src_utils_dom__WEBPACK_IMPORTED_MODULE_0__["once"])(document, 'mouseup', clear);
          clearInterval(interval);
          interval = setInterval(handler, 100);
        });
      }
    };

    /***/
  },

  /***/86:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: ["el-input-number", _vm.inputNumberSize ? "el-input-number--" + _vm.inputNumberSize : "", { "is-disabled": _vm.inputNumberDisabled }, { "is-without-controls": !_vm.controls }, { "is-controls-right": _vm.controlsAtRight }],
        on: {
          dragstart: function dragstart($event) {
            $event.preventDefault();
          }
        }
      }, [_vm.controls ? _c("span", {
        directives: [{
          name: "repeat-click",
          rawName: "v-repeat-click",
          value: _vm.decrease,
          expression: "decrease"
        }],
        staticClass: "el-input-number__decrease",
        class: { "is-disabled": _vm.minDisabled },
        attrs: { role: "button" },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            return _vm.decrease($event);
          }
        }
      }, [_c("i", {
        class: "el-icon-" + (_vm.controlsAtRight ? "arrow-down" : "minus")
      })]) : _vm._e(), _vm.controls ? _c("span", {
        directives: [{
          name: "repeat-click",
          rawName: "v-repeat-click",
          value: _vm.increase,
          expression: "increase"
        }],
        staticClass: "el-input-number__increase",
        class: { "is-disabled": _vm.maxDisabled },
        attrs: { role: "button" },
        on: {
          keydown: function keydown($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
              return null;
            }
            return _vm.increase($event);
          }
        }
      }, [_c("i", {
        class: "el-icon-" + (_vm.controlsAtRight ? "arrow-up" : "plus")
      })]) : _vm._e(), _c("el-input", {
        ref: "input",
        attrs: {
          value: _vm.displayValue,
          placeholder: _vm.placeholder,
          disabled: _vm.inputNumberDisabled,
          size: _vm.inputNumberSize,
          max: _vm.max,
          min: _vm.min,
          name: _vm.name,
          label: _vm.label
        },
        on: {
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          input: _vm.handleInput,
          change: _vm.handleInputChange
        },
        nativeOn: {
          keydown: [function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
              return null;
            }
            $event.preventDefault();
            return _vm.increase($event);
          }, function ($event) {
            if (!("button" in $event) && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
              return null;
            }
            $event.preventDefault();
            return _vm.decrease($event);
          }]
        }
      })], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=template&id=42f8cf66&

    // EXTERNAL MODULE: external "element-ui/lib/input"
    var input_ = __webpack_require__(10);
    var input_default = /*#__PURE__*/__webpack_require__.n(input_);

    // EXTERNAL MODULE: external "element-ui/lib/mixins/focus"
    var focus_ = __webpack_require__(22);
    var focus_default = /*#__PURE__*/__webpack_require__.n(focus_);

    // EXTERNAL MODULE: ./src/directives/repeat-click.js
    var repeat_click = __webpack_require__(30);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var input_numbervue_type_script_lang_js_ = {
      name: 'ElInputNumber',
      mixins: [focus_default()('input')],
      inject: {
        elForm: {
          default: ''
        },
        elFormItem: {
          default: ''
        }
      },
      directives: {
        repeatClick: repeat_click["a" /* default */]
      },
      components: {
        ElInput: input_default.a
      },
      props: {
        step: {
          type: Number,
          default: 1
        },
        stepStrictly: {
          type: Boolean,
          default: false
        },
        max: {
          type: Number,
          default: Infinity
        },
        min: {
          type: Number,
          default: -Infinity
        },
        value: {},
        disabled: Boolean,
        size: String,
        controls: {
          type: Boolean,
          default: true
        },
        controlsPosition: {
          type: String,
          default: ''
        },
        name: String,
        label: String,
        placeholder: String,
        precision: {
          type: Number,
          validator: function validator(val) {
            return val >= 0 && val === parseInt(val, 10);
          }
        }
      },
      data: function data() {
        return {
          currentValue: 0,
          userInput: null
        };
      },

      watch: {
        value: {
          immediate: true,
          handler: function handler(value) {
            var newVal = value === undefined ? value : Number(value);
            if (newVal !== undefined) {
              if (isNaN(newVal)) {
                return;
              }

              if (this.stepStrictly) {
                var stepPrecision = this.getPrecision(this.step);
                var precisionFactor = Math.pow(10, stepPrecision);
                newVal = Math.round(newVal / this.step) * precisionFactor * this.step / precisionFactor;
              }

              if (this.precision !== undefined) {
                newVal = this.toPrecision(newVal, this.precision);
              }
            }
            if (newVal >= this.max) newVal = this.max;
            if (newVal <= this.min) newVal = this.min;
            this.currentValue = newVal;
            this.userInput = null;
            this.$emit('input', newVal);
          }
        }
      },
      computed: {
        minDisabled: function minDisabled() {
          return this._decrease(this.value, this.step) < this.min;
        },
        maxDisabled: function maxDisabled() {
          return this._increase(this.value, this.step) > this.max;
        },
        numPrecision: function numPrecision() {
          var value = this.value,
              step = this.step,
              getPrecision = this.getPrecision,
              precision = this.precision;

          var stepPrecision = getPrecision(step);
          if (precision !== undefined) {
            if (stepPrecision > precision) {
              console.warn('[Element Warn][InputNumber]precision should not be less than the decimal places of step');
            }
            return precision;
          } else {
            return Math.max(getPrecision(value), stepPrecision);
          }
        },
        controlsAtRight: function controlsAtRight() {
          return this.controls && this.controlsPosition === 'right';
        },
        _elFormItemSize: function _elFormItemSize() {
          return (this.elFormItem || {}).elFormItemSize;
        },
        inputNumberSize: function inputNumberSize() {
          return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
        },
        inputNumberDisabled: function inputNumberDisabled() {
          return this.disabled || !!(this.elForm || {}).disabled;
        },
        displayValue: function displayValue() {
          if (this.userInput !== null) {
            return this.userInput;
          }

          var currentValue = this.currentValue;

          if (typeof currentValue === 'number') {
            if (this.stepStrictly) {
              var stepPrecision = this.getPrecision(this.step);
              var precisionFactor = Math.pow(10, stepPrecision);
              currentValue = Math.round(currentValue / this.step) * precisionFactor * this.step / precisionFactor;
            }

            if (this.precision !== undefined) {
              currentValue = currentValue.toFixed(this.precision);
            }
          }

          return currentValue;
        }
      },
      methods: {
        toPrecision: function toPrecision(num, precision) {
          if (precision === undefined) precision = this.numPrecision;
          return parseFloat(Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision));
        },
        getPrecision: function getPrecision(value) {
          if (value === undefined) return 0;
          var valueString = value.toString();
          var dotPosition = valueString.indexOf('.');
          var precision = 0;
          if (dotPosition !== -1) {
            precision = valueString.length - dotPosition - 1;
          }
          return precision;
        },
        _increase: function _increase(val, step) {
          if (typeof val !== 'number' && val !== undefined) return this.currentValue;

          var precisionFactor = Math.pow(10, this.numPrecision);
          // Solve the accuracy problem of JS decimal calculation by converting the value to integer.
          return this.toPrecision((precisionFactor * val + precisionFactor * step) / precisionFactor);
        },
        _decrease: function _decrease(val, step) {
          if (typeof val !== 'number' && val !== undefined) return this.currentValue;

          var precisionFactor = Math.pow(10, this.numPrecision);

          return this.toPrecision((precisionFactor * val - precisionFactor * step) / precisionFactor);
        },
        increase: function increase() {
          if (this.inputNumberDisabled || this.maxDisabled) return;
          var value = this.value || 0;
          var newVal = this._increase(value, this.step);
          this.setCurrentValue(newVal);
        },
        decrease: function decrease() {
          if (this.inputNumberDisabled || this.minDisabled) return;
          var value = this.value || 0;
          var newVal = this._decrease(value, this.step);
          this.setCurrentValue(newVal);
        },
        handleBlur: function handleBlur(event) {
          this.$emit('blur', event);
        },
        handleFocus: function handleFocus(event) {
          this.$emit('focus', event);
        },
        setCurrentValue: function setCurrentValue(newVal) {
          var oldVal = this.currentValue;
          if (typeof newVal === 'number' && this.precision !== undefined) {
            newVal = this.toPrecision(newVal, this.precision);
          }
          if (newVal >= this.max) newVal = this.max;
          if (newVal <= this.min) newVal = this.min;
          if (oldVal === newVal) return;
          this.userInput = null;
          this.$emit('input', newVal);
          this.$emit('change', newVal, oldVal);
          this.currentValue = newVal;
        },
        handleInput: function handleInput(value) {
          this.userInput = value;
        },
        handleInputChange: function handleInputChange(value) {
          var newVal = value === '' ? undefined : Number(value);
          if (!isNaN(newVal) || value === '') {
            this.setCurrentValue(newVal);
          }
          this.userInput = null;
        },
        select: function select() {
          this.$refs.input.select();
        }
      },
      mounted: function mounted() {
        var innerInput = this.$refs.input.$refs.input;
        innerInput.setAttribute('role', 'spinbutton');
        innerInput.setAttribute('aria-valuemax', this.max);
        innerInput.setAttribute('aria-valuemin', this.min);
        innerInput.setAttribute('aria-valuenow', this.currentValue);
        innerInput.setAttribute('aria-disabled', this.inputNumberDisabled);
      },
      updated: function updated() {
        if (!this.$refs || !this.$refs.input) return;
        var innerInput = this.$refs.input.$refs.input;
        innerInput.setAttribute('aria-valuenow', this.currentValue);
      }
    };
    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue?vue&type=script&lang=js&
    /* harmony default export */var src_input_numbervue_type_script_lang_js_ = input_numbervue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/input-number/src/input-number.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_input_numbervue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/input-number/src/input-number.vue";
    /* harmony default export */var input_number = component.exports;
    // CONCATENATED MODULE: ./packages/input-number/index.js


    /* istanbul ignore next */
    input_number.install = function (Vue) {
      Vue.component(input_number.name, input_number);
    };

    /* harmony default export */var packages_input_number = __webpack_exports__["default"] = input_number;

    /***/
  }

  /******/ });

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 60);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/15:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(151);

    /***/
  },

  /***/18:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(291);

    /***/
  },

  /***/21:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(101);

    /***/
  },

  /***/26:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(293);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/31:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(153);

    /***/
  },

  /***/40:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(154);

    /***/
  },

  /***/51:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(306);

    /***/
  },

  /***/6:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(146);

    /***/
  },

  /***/60:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&
    var cascader_panelvue_type_template_id_34932346_render = function cascader_panelvue_type_template_id_34932346_render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("div", {
        class: ["el-cascader-panel", _vm.border && "is-bordered"],
        on: { keydown: _vm.handleKeyDown }
      }, _vm._l(_vm.menus, function (menu, index) {
        return _c("cascader-menu", {
          key: index,
          ref: "menu",
          refInFor: true,
          attrs: { index: index, nodes: menu }
        });
      }), 1);
    };
    var staticRenderFns = [];
    cascader_panelvue_type_template_id_34932346_render._withStripped = true;

    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=template&id=34932346&

    // EXTERNAL MODULE: external "babel-helper-vue-jsx-merge-props"
    var external_babel_helper_vue_jsx_merge_props_ = __webpack_require__(26);
    var external_babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(external_babel_helper_vue_jsx_merge_props_);

    // EXTERNAL MODULE: external "element-ui/lib/scrollbar"
    var scrollbar_ = __webpack_require__(15);
    var scrollbar_default = /*#__PURE__*/__webpack_require__.n(scrollbar_);

    // EXTERNAL MODULE: external "element-ui/lib/checkbox"
    var checkbox_ = __webpack_require__(18);
    var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

    // EXTERNAL MODULE: external "element-ui/lib/radio"
    var radio_ = __webpack_require__(51);
    var radio_default = /*#__PURE__*/__webpack_require__.n(radio_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&


    var stopPropagation = function stopPropagation(e) {
      return e.stopPropagation();
    };

    /* harmony default export */var cascader_nodevue_type_script_lang_js_ = {
      inject: ['panel'],

      components: {
        ElCheckbox: checkbox_default.a,
        ElRadio: radio_default.a
      },

      props: {
        node: {
          required: true
        },
        nodeId: String
      },

      computed: {
        config: function config() {
          return this.panel.config;
        },
        isLeaf: function isLeaf() {
          return this.node.isLeaf;
        },
        isDisabled: function isDisabled() {
          return this.node.isDisabled;
        },
        checkedValue: function checkedValue() {
          return this.panel.checkedValue;
        },
        isChecked: function isChecked() {
          return this.node.isSameNode(this.checkedValue);
        },
        inActivePath: function inActivePath() {
          return this.isInPath(this.panel.activePath);
        },
        inCheckedPath: function inCheckedPath() {
          var _this = this;

          if (!this.config.checkStrictly) return false;

          return this.panel.checkedNodePaths.some(function (checkedPath) {
            return _this.isInPath(checkedPath);
          });
        },
        value: function value() {
          return this.node.getValueByOption();
        }
      },

      methods: {
        handleExpand: function handleExpand() {
          var _this2 = this;

          var panel = this.panel,
              node = this.node,
              isDisabled = this.isDisabled,
              config = this.config;
          var multiple = config.multiple,
              checkStrictly = config.checkStrictly;

          if (!checkStrictly && isDisabled || node.loading) return;

          if (config.lazy && !node.loaded) {
            panel.lazyLoad(node, function () {
              // do not use cached leaf value here, invoke this.isLeaf to get new value.
              var isLeaf = _this2.isLeaf;

              if (!isLeaf) _this2.handleExpand();
              if (multiple) {
                // if leaf sync checked state, else clear checked state
                var checked = isLeaf ? node.checked : false;
                _this2.handleMultiCheckChange(checked);
              }
            });
          } else {
            panel.handleExpand(node);
          }
        },
        handleCheckChange: function handleCheckChange() {
          var panel = this.panel,
              value = this.value,
              node = this.node;

          panel.handleCheckChange(value);
          panel.handleExpand(node);
        },
        handleMultiCheckChange: function handleMultiCheckChange(checked) {
          this.node.doCheck(checked);
          this.panel.calculateMultiCheckedValue();
        },
        isInPath: function isInPath(pathNodes) {
          var node = this.node;

          var selectedPathNode = pathNodes[node.level - 1] || {};
          return selectedPathNode.uid === node.uid;
        },
        renderPrefix: function renderPrefix(h) {
          var isLeaf = this.isLeaf,
              isChecked = this.isChecked,
              config = this.config;
          var checkStrictly = config.checkStrictly,
              multiple = config.multiple;

          if (multiple) {
            return this.renderCheckbox(h);
          } else if (checkStrictly) {
            return this.renderRadio(h);
          } else if (isLeaf && isChecked) {
            return this.renderCheckIcon(h);
          }

          return null;
        },
        renderPostfix: function renderPostfix(h) {
          var node = this.node,
              isLeaf = this.isLeaf;

          if (node.loading) {
            return this.renderLoadingIcon(h);
          } else if (!isLeaf) {
            return this.renderExpandIcon(h);
          }

          return null;
        },
        renderCheckbox: function renderCheckbox(h) {
          var node = this.node,
              config = this.config,
              isDisabled = this.isDisabled;

          var events = {
            on: { change: this.handleMultiCheckChange },
            nativeOn: {}
          };

          if (config.checkStrictly) {
            // when every node is selectable, click event should not trigger expand event.
            events.nativeOn.click = stopPropagation;
          }

          return h('el-checkbox', external_babel_helper_vue_jsx_merge_props_default()([{
            attrs: {
              value: node.checked,
              indeterminate: node.indeterminate,
              disabled: isDisabled
            }
          }, events]));
        },
        renderRadio: function renderRadio(h) {
          var checkedValue = this.checkedValue,
              value = this.value,
              isDisabled = this.isDisabled;

          // to keep same reference if value cause radio's checked state is calculated by reference comparision;

          if (Object(util_["isEqual"])(value, checkedValue)) {
            value = checkedValue;
          }

          return h('el-radio', {
            attrs: {
              value: checkedValue,
              label: value,
              disabled: isDisabled
            },
            on: {
              'change': this.handleCheckChange
            },
            nativeOn: {
              'click': stopPropagation
            }
          }, [h('span')]);
        },
        renderCheckIcon: function renderCheckIcon(h) {
          return h('i', { 'class': 'el-icon-check el-cascader-node__prefix' });
        },
        renderLoadingIcon: function renderLoadingIcon(h) {
          return h('i', { 'class': 'el-icon-loading el-cascader-node__postfix' });
        },
        renderExpandIcon: function renderExpandIcon(h) {
          return h('i', { 'class': 'el-icon-arrow-right el-cascader-node__postfix' });
        },
        renderContent: function renderContent(h) {
          var panel = this.panel,
              node = this.node;

          var render = panel.renderLabelFn;
          var vnode = render ? render({ node: node, data: node.data }) : null;

          return h('span', { 'class': 'el-cascader-node__label' }, [vnode || node.label]);
        }
      },

      render: function render(h) {
        var _this3 = this;

        var inActivePath = this.inActivePath,
            inCheckedPath = this.inCheckedPath,
            isChecked = this.isChecked,
            isLeaf = this.isLeaf,
            isDisabled = this.isDisabled,
            config = this.config,
            nodeId = this.nodeId;
        var expandTrigger = config.expandTrigger,
            checkStrictly = config.checkStrictly,
            multiple = config.multiple;

        var disabled = !checkStrictly && isDisabled;
        var events = { on: {} };

        if (expandTrigger === 'click') {
          events.on.click = this.handleExpand;
        } else {
          events.on.mouseenter = function (e) {
            _this3.handleExpand();
            _this3.$emit('expand', e);
          };
          events.on.focus = function (e) {
            _this3.handleExpand();
            _this3.$emit('expand', e);
          };
        }
        if (isLeaf && !isDisabled && !checkStrictly && !multiple) {
          events.on.click = this.handleCheckChange;
        }

        return h('li', external_babel_helper_vue_jsx_merge_props_default()([{
          attrs: {
            role: 'menuitem',
            id: nodeId,
            'aria-expanded': inActivePath,
            tabindex: disabled ? null : -1
          },
          'class': {
            'el-cascader-node': true,
            'is-selectable': checkStrictly,
            'in-active-path': inActivePath,
            'in-checked-path': inCheckedPath,
            'is-active': isChecked,
            'is-disabled': disabled
          }
        }, events]), [this.renderPrefix(h), this.renderContent(h), this.renderPostfix(h)]);
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_nodevue_type_script_lang_js_ = cascader_nodevue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-node.vue
    var cascader_node_render, cascader_node_staticRenderFns;

    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_cascader_nodevue_type_script_lang_js_, cascader_node_render, cascader_node_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/cascader-panel/src/cascader-node.vue";
    /* harmony default export */var cascader_node = component.exports;
    // EXTERNAL MODULE: external "element-ui/lib/mixins/locale"
    var locale_ = __webpack_require__(6);
    var locale_default = /*#__PURE__*/__webpack_require__.n(locale_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&


    /* harmony default export */var cascader_menuvue_type_script_lang_js_ = {
      name: 'ElCascaderMenu',

      mixins: [locale_default.a],

      inject: ['panel'],

      components: {
        ElScrollbar: scrollbar_default.a,
        CascaderNode: cascader_node
      },

      props: {
        nodes: {
          type: Array,
          required: true
        },
        index: Number
      },

      data: function data() {
        return {
          activeNode: null,
          hoverTimer: null,
          id: Object(util_["generateId"])()
        };
      },

      computed: {
        isEmpty: function isEmpty() {
          return !this.nodes.length;
        },
        menuId: function menuId() {
          return 'cascader-menu-' + this.id + '-' + this.index;
        }
      },

      methods: {
        handleExpand: function handleExpand(e) {
          this.activeNode = e.target;
        },
        handleMouseMove: function handleMouseMove(e) {
          var activeNode = this.activeNode,
              hoverTimer = this.hoverTimer;
          var hoverZone = this.$refs.hoverZone;

          if (!activeNode || !hoverZone) return;

          if (activeNode.contains(e.target)) {
            clearTimeout(hoverTimer);

            var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
                left = _$el$getBoundingClien.left;

            var startX = e.clientX - left;
            var _$el = this.$el,
                offsetWidth = _$el.offsetWidth,
                offsetHeight = _$el.offsetHeight;

            var top = activeNode.offsetTop;
            var bottom = top + activeNode.offsetHeight;

            hoverZone.innerHTML = '\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + top + ' L' + offsetWidth + ' 0 V' + top + ' Z" />\n          <path style="pointer-events: auto;" fill="transparent" d="M' + startX + ' ' + bottom + ' L' + offsetWidth + ' ' + offsetHeight + ' V' + bottom + ' Z" />\n        ';
          } else if (!hoverTimer) {
            this.hoverTimer = setTimeout(this.clearHoverZone, this.panel.config.hoverThreshold);
          }
        },
        clearHoverZone: function clearHoverZone() {
          var hoverZone = this.$refs.hoverZone;

          if (!hoverZone) return;
          hoverZone.innerHTML = '';
        },
        renderEmptyText: function renderEmptyText(h) {
          return h('div', { 'class': 'el-cascader-menu__empty-text' }, [this.t('el.cascader.noData')]);
        },
        renderNodeList: function renderNodeList(h) {
          var menuId = this.menuId;
          var isHoverMenu = this.panel.isHoverMenu;

          var events = { on: {} };

          if (isHoverMenu) {
            events.on.expand = this.handleExpand;
          }

          var nodes = this.nodes.map(function (node, index) {
            var hasChildren = node.hasChildren;

            return h('cascader-node', external_babel_helper_vue_jsx_merge_props_default()([{
              key: node.uid,
              attrs: { node: node,
                'node-id': menuId + '-' + index,
                'aria-haspopup': hasChildren,
                'aria-owns': hasChildren ? menuId : null
              }
            }, events]));
          });

          return [].concat(nodes, [isHoverMenu ? h('svg', { ref: 'hoverZone', 'class': 'el-cascader-menu__hover-zone' }) : null]);
        }
      },

      render: function render(h) {
        var isEmpty = this.isEmpty,
            menuId = this.menuId;

        var events = { nativeOn: {} };

        // optimize hover to expand experience (#8010)
        if (this.panel.isHoverMenu) {
          events.nativeOn.mousemove = this.handleMouseMove;
          // events.nativeOn.mouseleave = this.clearHoverZone;
        }

        return h('el-scrollbar', external_babel_helper_vue_jsx_merge_props_default()([{
          attrs: {
            tag: 'ul',
            role: 'menu',
            id: menuId,

            'wrap-class': 'el-cascader-menu__wrap',
            'view-class': {
              'el-cascader-menu__list': true,
              'is-empty': isEmpty
            }
          },
          'class': 'el-cascader-menu' }, events]), [isEmpty ? this.renderEmptyText(h) : this.renderNodeList(h)]);
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_menuvue_type_script_lang_js_ = cascader_menuvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-menu.vue
    var cascader_menu_render, cascader_menu_staticRenderFns;

    /* normalize component */

    var cascader_menu_component = Object(componentNormalizer["a" /* default */])(src_cascader_menuvue_type_script_lang_js_, cascader_menu_render, cascader_menu_staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var cascader_menu_api;
    }
    cascader_menu_component.options.__file = "packages/cascader-panel/src/cascader-menu.vue";
    /* harmony default export */var cascader_menu = cascader_menu_component.exports;
    // EXTERNAL MODULE: external "element-ui/lib/utils/shared"
    var shared_ = __webpack_require__(21);

    // CONCATENATED MODULE: ./packages/cascader-panel/src/node.js
    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
        }
      }return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
      };
    }();

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var uid = 0;

    var node_Node = function () {
      function Node(data, config, parentNode) {
        _classCallCheck(this, Node);

        this.data = data;
        this.config = config;
        this.parent = parentNode || null;
        this.level = !this.parent ? 1 : this.parent.level + 1;
        this.uid = uid++;

        this.initState();
        this.initChildren();
      }

      Node.prototype.initState = function initState() {
        var _config = this.config,
            valueKey = _config.value,
            labelKey = _config.label;

        this.value = this.data[valueKey];
        this.label = this.data[labelKey];
        this.pathNodes = this.calculatePathNodes();
        this.path = this.pathNodes.map(function (node) {
          return node.value;
        });
        this.pathLabels = this.pathNodes.map(function (node) {
          return node.label;
        });

        // lazy load
        this.loading = false;
        this.loaded = false;
      };

      Node.prototype.initChildren = function initChildren() {
        var _this = this;

        var config = this.config;

        var childrenKey = config.children;
        var childrenData = this.data[childrenKey];
        this.hasChildren = Array.isArray(childrenData);
        this.children = (childrenData || []).map(function (child) {
          return new Node(child, config, _this);
        });
      };

      Node.prototype.calculatePathNodes = function calculatePathNodes() {
        var nodes = [this];
        var parent = this.parent;

        while (parent) {
          nodes.unshift(parent);
          parent = parent.parent;
        }

        return nodes;
      };

      Node.prototype.getPath = function getPath() {
        return this.path;
      };

      Node.prototype.getValue = function getValue() {
        return this.value;
      };

      Node.prototype.getValueByOption = function getValueByOption() {
        return this.config.emitPath ? this.getPath() : this.getValue();
      };

      Node.prototype.getText = function getText(allLevels, separator) {
        return allLevels ? this.pathLabels.join(separator) : this.label;
      };

      Node.prototype.isSameNode = function isSameNode(checkedValue) {
        var value = this.getValueByOption();
        return this.config.multiple && Array.isArray(checkedValue) ? checkedValue.some(function (val) {
          return Object(util_["isEqual"])(val, value);
        }) : Object(util_["isEqual"])(checkedValue, value);
      };

      Node.prototype.broadcast = function broadcast(event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var handlerName = 'onParent' + Object(util_["capitalize"])(event);

        this.children.forEach(function (child) {
          if (child) {
            // bottom up
            child.broadcast.apply(child, [event].concat(args));
            child[handlerName] && child[handlerName].apply(child, args);
          }
        });
      };

      Node.prototype.emit = function emit(event) {
        var parent = this.parent;

        var handlerName = 'onChild' + Object(util_["capitalize"])(event);
        if (parent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          parent[handlerName] && parent[handlerName].apply(parent, args);
          parent.emit.apply(parent, [event].concat(args));
        }
      };

      Node.prototype.onParentCheck = function onParentCheck(checked) {
        if (!this.isDisabled) {
          this.setCheckState(checked);
        }
      };

      Node.prototype.onChildCheck = function onChildCheck() {
        var children = this.children;

        var validChildren = children.filter(function (child) {
          return !child.isDisabled;
        });
        var checked = validChildren.length ? validChildren.every(function (child) {
          return child.checked;
        }) : false;

        this.setCheckState(checked);
      };

      Node.prototype.setCheckState = function setCheckState(checked) {
        var totalNum = this.children.length;
        var checkedNum = this.children.reduce(function (c, p) {
          var num = p.checked ? 1 : p.indeterminate ? 0.5 : 0;
          return c + num;
        }, 0);

        this.checked = checked;
        this.indeterminate = checkedNum !== totalNum && checkedNum > 0;
      };

      Node.prototype.syncCheckState = function syncCheckState(checkedValue) {
        var value = this.getValueByOption();
        var checked = this.isSameNode(checkedValue, value);

        this.doCheck(checked);
      };

      Node.prototype.doCheck = function doCheck(checked) {
        if (this.checked !== checked) {
          if (this.config.checkStrictly) {
            this.checked = checked;
          } else {
            // bottom up to unify the calculation of the indeterminate state
            this.broadcast('check', checked);
            this.setCheckState(checked);
            this.emit('check');
          }
        }
      };

      _createClass(Node, [{
        key: 'isDisabled',
        get: function get() {
          var data = this.data,
              parent = this.parent,
              config = this.config;

          var disabledKey = config.disabled;
          var checkStrictly = config.checkStrictly;

          return data[disabledKey] || !checkStrictly && parent && parent.isDisabled;
        }
      }, {
        key: 'isLeaf',
        get: function get() {
          var data = this.data,
              loaded = this.loaded,
              hasChildren = this.hasChildren,
              children = this.children;
          var _config2 = this.config,
              lazy = _config2.lazy,
              leafKey = _config2.leaf;

          if (lazy) {
            var isLeaf = Object(shared_["isDef"])(data[leafKey]) ? data[leafKey] : loaded ? !children.length : false;
            this.hasChildren = !isLeaf;
            return isLeaf;
          }
          return !hasChildren;
        }
      }]);

      return Node;
    }();

    /* harmony default export */var src_node = node_Node;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/store.js
    function store_classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    var flatNodes = function flatNodes(data, leafOnly) {
      return data.reduce(function (res, node) {
        if (node.isLeaf) {
          res.push(node);
        } else {
          !leafOnly && res.push(node);
          res = res.concat(flatNodes(node.children, leafOnly));
        }
        return res;
      }, []);
    };

    var store_Store = function () {
      function Store(data, config) {
        store_classCallCheck(this, Store);

        this.config = config;
        this.initNodes(data);
      }

      Store.prototype.initNodes = function initNodes(data) {
        var _this = this;

        data = Object(util_["coerceTruthyValueToArray"])(data);
        this.nodes = data.map(function (nodeData) {
          return new src_node(nodeData, _this.config);
        });
        this.flattedNodes = this.getFlattedNodes(false, false);
        this.leafNodes = this.getFlattedNodes(true, false);
      };

      Store.prototype.appendNode = function appendNode(nodeData, parentNode) {
        var node = new src_node(nodeData, this.config, parentNode);
        var children = parentNode ? parentNode.children : this.nodes;

        children.push(node);
      };

      Store.prototype.appendNodes = function appendNodes(nodeDataList, parentNode) {
        var _this2 = this;

        nodeDataList = Object(util_["coerceTruthyValueToArray"])(nodeDataList);
        nodeDataList.forEach(function (nodeData) {
          return _this2.appendNode(nodeData, parentNode);
        });
      };

      Store.prototype.getNodes = function getNodes() {
        return this.nodes;
      };

      Store.prototype.getFlattedNodes = function getFlattedNodes(leafOnly) {
        var cached = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        var cachedNodes = leafOnly ? this.leafNodes : this.flattedNodes;
        return cached ? cachedNodes : flatNodes(this.nodes, leafOnly);
      };

      Store.prototype.getNodeByValue = function getNodeByValue(value) {
        var nodes = this.getFlattedNodes(false, !this.config.lazy).filter(function (node) {
          return Object(util_["valueEquals"])(node.path, value) || node.value === value;
        });
        return nodes && nodes.length ? nodes[0] : null;
      };

      return Store;
    }();

    /* harmony default export */var src_store = store_Store;
    // EXTERNAL MODULE: external "element-ui/lib/utils/merge"
    var merge_ = __webpack_require__(9);
    var merge_default = /*#__PURE__*/__webpack_require__.n(merge_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/aria-utils"
    var aria_utils_ = __webpack_require__(40);
    var aria_utils_default = /*#__PURE__*/__webpack_require__.n(aria_utils_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/scroll-into-view"
    var scroll_into_view_ = __webpack_require__(31);
    var scroll_into_view_default = /*#__PURE__*/__webpack_require__.n(scroll_into_view_);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }return target;
    };

    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    var KeyCode = aria_utils_default.a.keys;

    var DefaultProps = {
      expandTrigger: 'click', // or hover
      multiple: false,
      checkStrictly: false, // whether all nodes can be selected
      emitPath: true, // wether to emit an array of all levels value in which node is located
      lazy: false,
      lazyLoad: util_["noop"],
      value: 'value',
      label: 'label',
      children: 'children',
      leaf: 'leaf',
      disabled: 'disabled',
      hoverThreshold: 500
    };

    var cascader_panelvue_type_script_lang_js_isLeaf = function isLeaf(el) {
      return !el.getAttribute('aria-owns');
    };

    var getSibling = function getSibling(el, distance) {
      var parentNode = el.parentNode;

      if (parentNode) {
        var siblings = parentNode.querySelectorAll('.el-cascader-node[tabindex="-1"]');
        var index = Array.prototype.indexOf.call(siblings, el);
        return siblings[index + distance] || null;
      }
      return null;
    };

    var getMenuIndex = function getMenuIndex(el, distance) {
      if (!el) return;
      var pieces = el.id.split('-');
      return Number(pieces[pieces.length - 2]);
    };

    var focusNode = function focusNode(el) {
      if (!el) return;
      el.focus();
      !cascader_panelvue_type_script_lang_js_isLeaf(el) && el.click();
    };

    var checkNode = function checkNode(el) {
      if (!el) return;

      var input = el.querySelector('input');
      if (input) {
        input.click();
      } else if (cascader_panelvue_type_script_lang_js_isLeaf(el)) {
        el.click();
      }
    };

    /* harmony default export */var cascader_panelvue_type_script_lang_js_ = {
      name: 'ElCascaderPanel',

      components: {
        CascaderMenu: cascader_menu
      },

      props: {
        value: {},
        options: Array,
        props: Object,
        border: {
          type: Boolean,
          default: true
        },
        renderLabel: Function
      },

      provide: function provide() {
        return {
          panel: this
        };
      },
      data: function data() {
        return {
          checkedValue: null,
          checkedNodePaths: [],
          store: [],
          menus: [],
          activePath: [],
          loadCount: 0
        };
      },

      computed: {
        config: function config() {
          return merge_default()(_extends({}, DefaultProps), this.props || {});
        },
        multiple: function multiple() {
          return this.config.multiple;
        },
        checkStrictly: function checkStrictly() {
          return this.config.checkStrictly;
        },
        leafOnly: function leafOnly() {
          return !this.checkStrictly;
        },
        isHoverMenu: function isHoverMenu() {
          return this.config.expandTrigger === 'hover';
        },
        renderLabelFn: function renderLabelFn() {
          return this.renderLabel || this.$scopedSlots.default;
        }
      },

      watch: {
        value: function value() {
          this.syncCheckedValue();
          this.checkStrictly && this.calculateCheckedNodePaths();
        },

        options: {
          handler: function handler() {
            this.initStore();
          },
          immediate: true,
          deep: true
        },
        checkedValue: function checkedValue(val) {
          if (!Object(util_["isEqual"])(val, this.value)) {
            this.checkStrictly && this.calculateCheckedNodePaths();
            this.$emit('input', val);
            this.$emit('change', val);
          }
        }
      },

      mounted: function mounted() {
        if (!this.isEmptyValue(this.value)) {
          this.syncCheckedValue();
        }
      },

      methods: {
        initStore: function initStore() {
          var config = this.config,
              options = this.options;

          if (config.lazy && Object(util_["isEmpty"])(options)) {
            this.lazyLoad();
          } else {
            this.store = new src_store(options, config);
            this.menus = [this.store.getNodes()];
            this.syncMenuState();
          }
        },
        syncCheckedValue: function syncCheckedValue() {
          var value = this.value,
              checkedValue = this.checkedValue;

          if (!Object(util_["isEqual"])(value, checkedValue)) {
            this.activePath = [];
            this.checkedValue = value;
            this.syncMenuState();
          }
        },
        syncMenuState: function syncMenuState() {
          var multiple = this.multiple,
              checkStrictly = this.checkStrictly;

          this.syncActivePath();
          multiple && this.syncMultiCheckState();
          checkStrictly && this.calculateCheckedNodePaths();
          this.$nextTick(this.scrollIntoView);
        },
        syncMultiCheckState: function syncMultiCheckState() {
          var _this = this;

          var nodes = this.getFlattedNodes(this.leafOnly);

          nodes.forEach(function (node) {
            node.syncCheckState(_this.checkedValue);
          });
        },
        isEmptyValue: function isEmptyValue(val) {
          var multiple = this.multiple,
              config = this.config;
          var emitPath = config.emitPath;

          if (multiple || emitPath) {
            return Object(util_["isEmpty"])(val);
          }
          return false;
        },
        syncActivePath: function syncActivePath() {
          var _this2 = this;

          var store = this.store,
              multiple = this.multiple,
              activePath = this.activePath,
              checkedValue = this.checkedValue;

          if (!Object(util_["isEmpty"])(activePath)) {
            var nodes = activePath.map(function (node) {
              return _this2.getNodeByValue(node.getValue());
            });
            this.expandNodes(nodes);
          } else if (!this.isEmptyValue(checkedValue)) {
            var value = multiple ? checkedValue[0] : checkedValue;
            var checkedNode = this.getNodeByValue(value) || {};
            var _nodes = (checkedNode.pathNodes || []).slice(0, -1);
            this.expandNodes(_nodes);
          } else {
            this.activePath = [];
            this.menus = [store.getNodes()];
          }
        },
        expandNodes: function expandNodes(nodes) {
          var _this3 = this;

          nodes.forEach(function (node) {
            return _this3.handleExpand(node, true /* silent */);
          });
        },
        calculateCheckedNodePaths: function calculateCheckedNodePaths() {
          var _this4 = this;

          var checkedValue = this.checkedValue,
              multiple = this.multiple;

          var checkedValues = multiple ? Object(util_["coerceTruthyValueToArray"])(checkedValue) : [checkedValue];
          this.checkedNodePaths = checkedValues.map(function (v) {
            var checkedNode = _this4.getNodeByValue(v);
            return checkedNode ? checkedNode.pathNodes : [];
          });
        },
        handleKeyDown: function handleKeyDown(e) {
          var target = e.target,
              keyCode = e.keyCode;

          switch (keyCode) {
            case KeyCode.up:
              var prev = getSibling(target, -1);
              focusNode(prev);
              break;
            case KeyCode.down:
              var next = getSibling(target, 1);
              focusNode(next);
              break;
            case KeyCode.left:
              var preMenu = this.$refs.menu[getMenuIndex(target) - 1];
              if (preMenu) {
                var expandedNode = preMenu.$el.querySelector('.el-cascader-node[aria-expanded="true"]');
                focusNode(expandedNode);
              }
              break;
            case KeyCode.right:
              var nextMenu = this.$refs.menu[getMenuIndex(target) + 1];
              if (nextMenu) {
                var firstNode = nextMenu.$el.querySelector('.el-cascader-node[tabindex="-1"]');
                focusNode(firstNode);
              }
              break;
            case KeyCode.enter:
              checkNode(target);
              break;
            case KeyCode.esc:
            case KeyCode.tab:
              this.$emit('close');
              break;
            default:
              return;
          }
        },
        handleExpand: function handleExpand(node, silent) {
          var activePath = this.activePath;
          var level = node.level;

          var path = activePath.slice(0, level - 1);
          var menus = this.menus.slice(0, level);

          if (!node.isLeaf) {
            path.push(node);
            menus.push(node.children);
          }

          this.activePath = path;
          this.menus = menus;

          if (!silent) {
            var pathValues = path.map(function (node) {
              return node.getValue();
            });
            var activePathValues = activePath.map(function (node) {
              return node.getValue();
            });
            if (!Object(util_["valueEquals"])(pathValues, activePathValues)) {
              this.$emit('active-item-change', pathValues); // Deprecated
              this.$emit('expand-change', pathValues);
            }
          }
        },
        handleCheckChange: function handleCheckChange(value) {
          this.checkedValue = value;
        },
        lazyLoad: function lazyLoad(node, onFullfiled) {
          var _this5 = this;

          var config = this.config;

          if (!node) {
            node = node || { root: true, level: 0 };
            this.store = new src_store([], config);
            this.menus = [this.store.getNodes()];
          }
          node.loading = true;
          var resolve = function resolve(dataList) {
            var parent = node.root ? null : node;
            dataList && dataList.length && _this5.store.appendNodes(dataList, parent);
            node.loading = false;
            node.loaded = true;

            // dispose default value on lazy load mode
            if (Array.isArray(_this5.checkedValue)) {
              var nodeValue = _this5.checkedValue[_this5.loadCount++];
              var valueKey = _this5.config.value;
              var leafKey = _this5.config.leaf;

              if (Array.isArray(dataList) && dataList.filter(function (item) {
                return item[valueKey] === nodeValue;
              }).length > 0) {
                var checkedNode = _this5.store.getNodeByValue(nodeValue);

                if (!checkedNode.data[leafKey]) {
                  _this5.lazyLoad(checkedNode, function () {
                    _this5.handleExpand(checkedNode);
                  });
                }

                if (_this5.loadCount === _this5.checkedValue.length) {
                  _this5.$parent.computePresentText();
                }
              }
            }

            onFullfiled && onFullfiled(dataList);
          };
          config.lazyLoad(node, resolve);
        },

        /**
         * public methods
        */
        calculateMultiCheckedValue: function calculateMultiCheckedValue() {
          this.checkedValue = this.getCheckedNodes(this.leafOnly).map(function (node) {
            return node.getValueByOption();
          });
        },
        scrollIntoView: function scrollIntoView() {
          if (this.$isServer) return;

          var menus = this.$refs.menu || [];
          menus.forEach(function (menu) {
            var menuElement = menu.$el;
            if (menuElement) {
              var container = menuElement.querySelector('.el-scrollbar__wrap');
              var activeNode = menuElement.querySelector('.el-cascader-node.is-active') || menuElement.querySelector('.el-cascader-node.in-active-path');
              scroll_into_view_default()(container, activeNode);
            }
          });
        },
        getNodeByValue: function getNodeByValue(val) {
          return this.store.getNodeByValue(val);
        },
        getFlattedNodes: function getFlattedNodes(leafOnly) {
          var cached = !this.config.lazy;
          return this.store.getFlattedNodes(leafOnly, cached);
        },
        getCheckedNodes: function getCheckedNodes(leafOnly) {
          var checkedValue = this.checkedValue,
              multiple = this.multiple;

          if (multiple) {
            var nodes = this.getFlattedNodes(leafOnly);
            return nodes.filter(function (node) {
              return node.checked;
            });
          } else {
            return this.isEmptyValue(checkedValue) ? [] : [this.getNodeByValue(checkedValue)];
          }
        },
        clearCheckedNodes: function clearCheckedNodes() {
          var config = this.config,
              leafOnly = this.leafOnly;
          var multiple = config.multiple,
              emitPath = config.emitPath;

          if (multiple) {
            this.getCheckedNodes(leafOnly).filter(function (node) {
              return !node.isDisabled;
            }).forEach(function (node) {
              return node.doCheck(false);
            });
            this.calculateMultiCheckedValue();
          } else {
            this.checkedValue = emitPath ? [] : null;
          }
        }
      }
    };
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue?vue&type=script&lang=js&
    /* harmony default export */var src_cascader_panelvue_type_script_lang_js_ = cascader_panelvue_type_script_lang_js_;
    // CONCATENATED MODULE: ./packages/cascader-panel/src/cascader-panel.vue


    /* normalize component */

    var cascader_panel_component = Object(componentNormalizer["a" /* default */])(src_cascader_panelvue_type_script_lang_js_, cascader_panelvue_type_template_id_34932346_render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var cascader_panel_api;
    }
    cascader_panel_component.options.__file = "packages/cascader-panel/src/cascader-panel.vue";
    /* harmony default export */var cascader_panel = cascader_panel_component.exports;
    // CONCATENATED MODULE: ./packages/cascader-panel/index.js


    /* istanbul ignore next */
    cascader_panel.install = function (Vue) {
      Vue.component(cascader_panel.name, cascader_panel);
    };

    /* harmony default export */var packages_cascader_panel = __webpack_exports__["default"] = cascader_panel;

    /***/
  },

  /***/9:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(100);

    /***/
  }

  /******/ });

/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "/dist/";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = 77);
  /******/
}(
/************************************************************************/
/******/{

  /***/0:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, this.$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functioal component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/2:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(43);

    /***/
  },

  /***/3:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(38);

    /***/
  },

  /***/5:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(99);

    /***/
  },

  /***/7:
  /***/function _(module, exports) {

    module.exports = __webpack_require__(18);

    /***/
  },

  /***/77:
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    __webpack_require__.r(__webpack_exports__);

    // CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=template&id=52060272&
    var render = function render() {
      var _vm = this;
      var _h = _vm.$createElement;
      var _c = _vm._self._c || _h;
      return _c("span", [_c("transition", {
        attrs: { name: _vm.transition },
        on: {
          "after-enter": _vm.handleAfterEnter,
          "after-leave": _vm.handleAfterLeave
        }
      }, [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: !_vm.disabled && _vm.showPopper,
          expression: "!disabled && showPopper"
        }],
        ref: "popper",
        staticClass: "el-popover el-popper",
        class: [_vm.popperClass, _vm.content && "el-popover--plain"],
        style: { width: _vm.width + "px" },
        attrs: {
          role: "tooltip",
          id: _vm.tooltipId,
          "aria-hidden": _vm.disabled || !_vm.showPopper ? "true" : "false"
        }
      }, [_vm.title ? _c("div", {
        staticClass: "el-popover__title",
        domProps: { textContent: _vm._s(_vm.title) }
      }) : _vm._e(), _vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2)]), _c("span", { ref: "wrapper", staticClass: "el-popover__reference-wrapper" }, [_vm._t("reference")], 2)], 1);
    };
    var staticRenderFns = [];
    render._withStripped = true;

    // CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=template&id=52060272&

    // EXTERNAL MODULE: external "element-ui/lib/utils/vue-popper"
    var vue_popper_ = __webpack_require__(5);
    var vue_popper_default = /*#__PURE__*/__webpack_require__.n(vue_popper_);

    // EXTERNAL MODULE: external "element-ui/lib/utils/dom"
    var dom_ = __webpack_require__(2);

    // EXTERNAL MODULE: external "element-ui/lib/utils/util"
    var util_ = __webpack_require__(3);

    // CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/main.vue?vue&type=script&lang=js&
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var mainvue_type_script_lang_js_ = {
      name: 'ElPopover',

      mixins: [vue_popper_default.a],

      props: {
        trigger: {
          type: String,
          default: 'click',
          validator: function validator(value) {
            return ['click', 'focus', 'hover', 'manual'].indexOf(value) > -1;
          }
        },
        openDelay: {
          type: Number,
          default: 0
        },
        closeDelay: {
          type: Number,
          default: 200
        },
        title: String,
        disabled: Boolean,
        content: String,
        reference: {},
        popperClass: String,
        width: {},
        visibleArrow: {
          default: true
        },
        arrowOffset: {
          type: Number,
          default: 0
        },
        transition: {
          type: String,
          default: 'fade-in-linear'
        },
        tabindex: {
          type: Number,
          default: 0
        }
      },

      computed: {
        tooltipId: function tooltipId() {
          return 'el-popover-' + Object(util_["generateId"])();
        }
      },
      watch: {
        showPopper: function showPopper(val) {
          if (this.disabled) {
            return;
          }
          val ? this.$emit('show') : this.$emit('hide');
        }
      },

      mounted: function mounted() {
        var _this = this;

        var reference = this.referenceElm = this.reference || this.$refs.reference;
        var popper = this.popper || this.$refs.popper;

        if (!reference && this.$refs.wrapper.children) {
          reference = this.referenceElm = this.$refs.wrapper.children[0];
        }
        // 可访问性
        if (reference) {
          Object(dom_["addClass"])(reference, 'el-popover__reference');
          reference.setAttribute('aria-describedby', this.tooltipId);
          reference.setAttribute('tabindex', this.tabindex); // tab序列
          popper.setAttribute('tabindex', 0);

          if (this.trigger !== 'click') {
            Object(dom_["on"])(reference, 'focusin', function () {
              _this.handleFocus();
              var instance = reference.__vue__;
              if (instance && typeof instance.focus === 'function') {
                instance.focus();
              }
            });
            Object(dom_["on"])(popper, 'focusin', this.handleFocus);
            Object(dom_["on"])(reference, 'focusout', this.handleBlur);
            Object(dom_["on"])(popper, 'focusout', this.handleBlur);
          }
          Object(dom_["on"])(reference, 'keydown', this.handleKeydown);
          Object(dom_["on"])(reference, 'click', this.handleClick);
        }
        if (this.trigger === 'click') {
          Object(dom_["on"])(reference, 'click', this.doToggle);
          Object(dom_["on"])(document, 'click', this.handleDocumentClick);
        } else if (this.trigger === 'hover') {
          Object(dom_["on"])(reference, 'mouseenter', this.handleMouseEnter);
          Object(dom_["on"])(popper, 'mouseenter', this.handleMouseEnter);
          Object(dom_["on"])(reference, 'mouseleave', this.handleMouseLeave);
          Object(dom_["on"])(popper, 'mouseleave', this.handleMouseLeave);
        } else if (this.trigger === 'focus') {
          if (this.tabindex < 0) {
            console.warn('[Element Warn][Popover]a negative taindex means that the element cannot be focused by tab key');
          }
          if (reference.querySelector('input, textarea')) {
            Object(dom_["on"])(reference, 'focusin', this.doShow);
            Object(dom_["on"])(reference, 'focusout', this.doClose);
          } else {
            Object(dom_["on"])(reference, 'mousedown', this.doShow);
            Object(dom_["on"])(reference, 'mouseup', this.doClose);
          }
        }
      },
      beforeDestroy: function beforeDestroy() {
        this.cleanup();
      },
      deactivated: function deactivated() {
        this.cleanup();
      },

      methods: {
        doToggle: function doToggle() {
          this.showPopper = !this.showPopper;
        },
        doShow: function doShow() {
          this.showPopper = true;
        },
        doClose: function doClose() {
          this.showPopper = false;
        },
        handleFocus: function handleFocus() {
          Object(dom_["addClass"])(this.referenceElm, 'focusing');
          if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = true;
        },
        handleClick: function handleClick() {
          Object(dom_["removeClass"])(this.referenceElm, 'focusing');
        },
        handleBlur: function handleBlur() {
          Object(dom_["removeClass"])(this.referenceElm, 'focusing');
          if (this.trigger === 'click' || this.trigger === 'focus') this.showPopper = false;
        },
        handleMouseEnter: function handleMouseEnter() {
          var _this2 = this;

          clearTimeout(this._timer);
          if (this.openDelay) {
            this._timer = setTimeout(function () {
              _this2.showPopper = true;
            }, this.openDelay);
          } else {
            this.showPopper = true;
          }
        },
        handleKeydown: function handleKeydown(ev) {
          if (ev.keyCode === 27 && this.trigger !== 'manual') {
            // esc
            this.doClose();
          }
        },
        handleMouseLeave: function handleMouseLeave() {
          var _this3 = this;

          clearTimeout(this._timer);
          if (this.closeDelay) {
            this._timer = setTimeout(function () {
              _this3.showPopper = false;
            }, this.closeDelay);
          } else {
            this.showPopper = false;
          }
        },
        handleDocumentClick: function handleDocumentClick(e) {
          var reference = this.reference || this.$refs.reference;
          var popper = this.popper || this.$refs.popper;

          if (!reference && this.$refs.wrapper.children) {
            reference = this.referenceElm = this.$refs.wrapper.children[0];
          }
          if (!this.$el || !reference || this.$el.contains(e.target) || reference.contains(e.target) || !popper || popper.contains(e.target)) return;
          this.showPopper = false;
        },
        handleAfterEnter: function handleAfterEnter() {
          this.$emit('after-enter');
        },
        handleAfterLeave: function handleAfterLeave() {
          this.$emit('after-leave');
          this.doDestroy();
        },
        cleanup: function cleanup() {
          if (this.openDelay || this.closeDelay) {
            clearTimeout(this._timer);
          }
        }
      },

      destroyed: function destroyed() {
        var reference = this.reference;

        Object(dom_["off"])(reference, 'click', this.doToggle);
        Object(dom_["off"])(reference, 'mouseup', this.doClose);
        Object(dom_["off"])(reference, 'mousedown', this.doShow);
        Object(dom_["off"])(reference, 'focusin', this.doShow);
        Object(dom_["off"])(reference, 'focusout', this.doClose);
        Object(dom_["off"])(reference, 'mousedown', this.doShow);
        Object(dom_["off"])(reference, 'mouseup', this.doClose);
        Object(dom_["off"])(reference, 'mouseleave', this.handleMouseLeave);
        Object(dom_["off"])(reference, 'mouseenter', this.handleMouseEnter);
        Object(dom_["off"])(document, 'click', this.handleDocumentClick);
      }
    };
    // CONCATENATED MODULE: ./packages/popover/src/main.vue?vue&type=script&lang=js&
    /* harmony default export */var src_mainvue_type_script_lang_js_ = mainvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__(0);

    // CONCATENATED MODULE: ./packages/popover/src/main.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(src_mainvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* hot reload */
    if (false) {
      var api;
    }
    component.options.__file = "packages/popover/src/main.vue";
    /* harmony default export */var main = component.exports;
    // CONCATENATED MODULE: ./packages/popover/src/directive.js
    var getReference = function getReference(el, binding, vnode) {
      var _ref = binding.expression ? binding.value : binding.arg;
      var popper = vnode.context.$refs[_ref];
      if (popper) {
        if (Array.isArray(popper)) {
          popper[0].$refs.reference = el;
        } else {
          popper.$refs.reference = el;
        }
      }
    };

    /* harmony default export */var directive = {
      bind: function bind(el, binding, vnode) {
        getReference(el, binding, vnode);
      },
      inserted: function inserted(el, binding, vnode) {
        getReference(el, binding, vnode);
      }
    };
    // EXTERNAL MODULE: external "vue"
    var external_vue_ = __webpack_require__(7);
    var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

    // CONCATENATED MODULE: ./packages/popover/index.js


    external_vue_default.a.directive('popover', directive);

    /* istanbul ignore next */
    main.install = function (Vue) {
      Vue.directive('popover', directive);
      Vue.component(main.name, main);
    };
    main.directive = directive;

    /* harmony default export */var popover = __webpack_exports__["default"] = main;

    /***/
  }

  /******/ });

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthenticated", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessToken", function() { return getAccessToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessibleMenu", function() { return getAccessibleMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllMenus", function() { return getAllMenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultPageLimit", function() { return getDefaultPageLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessibleStoreList", function() { return getAccessibleStoreList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTrialMasterAccount", function() { return isTrialMasterAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomDomainName", function() { return getCustomDomainName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEPaymentEnabled", function() { return isEPaymentEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEncryptedKey", function() { return getEncryptedKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoadingState", function() { return getLoadingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMachineId", function() { return getMachineId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLoginProps", function() { return getLoginProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBreadcrumbs", function() { return getBreadcrumbs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCountryList", function() { return getCountryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProvinceList", function() { return getProvinceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCityList", function() { return getCityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCommunicationVariableList", function() { return getCommunicationVariableList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMasterModuleList", function() { return getMasterModuleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFabricWidthList", function() { return getFabricWidthList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSalutationList", function() { return getSalutationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserGroupAlerts", function() { return getUserGroupAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserInformation", function() { return getUserInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessRights", function() { return getAccessRights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUOMMasterList", function() { return getUOMMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllowedStores", function() { return getAllowedStores; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFabricGSMMasterList", function() { return getFabricGSMMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDashboardResponse", function() { return getDashboardResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultCountryDetail", function() { return getDefaultCountryDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMasterQueryList", function() { return getMasterQueryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskCalendar", function() { return getTaskCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskCalendarEventList", function() { return getTaskCalendarEventList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSMSCredit", function() { return getSMSCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShipmentCredit", function() { return getShipmentCredit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTrackingShipmentPartnerList", function() { return getTrackingShipmentPartnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreMenuList", function() { return getEStoreMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTenantEncryptedKey", function() { return getTenantEncryptedKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobileDevice", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBookmarkList", function() { return getBookmarkList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDeviceToken", function() { return getDeviceToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTallyGroupList", function() { return getTallyGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTallySubGroupList", function() { return getTallySubGroupList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__);


var isAuthenticated = function isAuthenticated(state) {
    return state.accessToken !== null;
};

var getAccessToken = function getAccessToken(state) {
    return state.accessToken;
};

var getAccessibleMenu = function getAccessibleMenu(state) {
    return state.accessibleModules;
};

var getAllMenus = function getAllMenus(state) {
    var returnArray = [];

    state.accessibleModules.forEach(function (element) {
        element.sub_menu.forEach(function (subMenu) {
            returnArray.push(subMenu);
            if (subMenu.has_sub_menu) {
                if (subMenu.sub_sub_menu) {
                    subMenu.sub_sub_menu.forEach(function (subSubMenu) {
                        returnArray.push(subSubMenu);
                    });
                }
            }
        });
    });

    return returnArray;
};

var getDefaultPageLimit = function getDefaultPageLimit(state) {
    return state.default_page_limit;
};

var getAccessibleStoreList = function getAccessibleStoreList(state) {
    return state.store_list;
};

var isTrialMasterAccount = function isTrialMasterAccount(state) {
    return state.trial_account;
};

var getCustomDomainName = function getCustomDomainName(state) {
    return state.custom_domain;
};

var isEPaymentEnabled = function isEPaymentEnabled(state) {
    return state.enable_e_payment;
};

var getEncryptedKey = function getEncryptedKey(state) {
    return state.encrypted_key;
};

var getLoadingState = function getLoadingState(state) {
    return state.loadingState;
};

var getMachineId = function getMachineId(state) {
    return state.machineId;
};

var getLoginProps = function getLoginProps(state) {
    return {
        user_name: state.login.user_name,
        password: state.login.password,
        machine_id: state.machineId
    };
};

var getBreadcrumbs = function getBreadcrumbs(state) {
    return state.breadcrumbs;
};

var getCountryList = function getCountryList(state) {
    return state.country_list;
};

var getProvinceList = function getProvinceList(state) {
    return state.province_list;
};

var getCityList = function getCityList(state) {
    return state.city_list;
};

var getCommunicationVariableList = function getCommunicationVariableList(state) {
    return state.communication_variables;
};

var getMasterModuleList = function getMasterModuleList(state) {
    return state.master_module_list;
};

var getFabricWidthList = function getFabricWidthList(state) {
    return state.fabric_width_list;
};

var getSalutationList = function getSalutationList(state) {
    return state.salutation_list;
};

var getUserGroupAlerts = function getUserGroupAlerts(state) {
    return state.user_group_alert;
};

var getUserInformation = function getUserInformation(state) {
    return state.userInformation;
};

var getAccessRights = function getAccessRights(state) {
    return state.access_rights;
};

var getUOMMasterList = function getUOMMasterList(state) {
    return state.uom_list;
};

var getAllowedStores = function getAllowedStores(state) {
    return state.allow_addition_of_store;
};

var getFabricGSMMasterList = function getFabricGSMMasterList(state) {
    return state.fabric_gsm_list;
};

var getDashboardResponse = function getDashboardResponse(state) {
    return state.dashboard.response;
};

var getDefaultCountryDetail = function getDefaultCountryDetail(state) {
    return state.currency_format;
};

var getMasterQueryList = function getMasterQueryList(state) {
    return state.search_query_list;
};

var getTaskCalendar = function getTaskCalendar(state) {
    return state.task_calendar_events;
};

var getTaskCalendarEventList = function getTaskCalendarEventList(state) {
    return state.task_calendar_event_list;
};

var getSMSCredit = function getSMSCredit(state) {
    return state.sms_credit;
};

var getShipmentCredit = function getShipmentCredit(state) {
    return state.shipment_credit;
};

var getTrackingShipmentPartnerList = function getTrackingShipmentPartnerList(state) {
    return state.shipment_partner_list;
};

var getEStoreMenuList = function getEStoreMenuList(state) {
    return state.e_store_menu_list;
};

var getTenantEncryptedKey = function getTenantEncryptedKey(state) {
    return state.encrypted_key;
};

var isMobileDevice = function isMobileDevice(state) {
    return __WEBPACK_IMPORTED_MODULE_0_mobile_device_detect__["isMobile"];
};

var getBookmarkList = function getBookmarkList(state) {
    return state.bookmark_list;
};

var getDeviceToken = function getDeviceToken(state) {
    return state.device_token;
};

var getTallyGroupList = function getTallyGroupList(state) {
    return state.tally_group;
};

var getTallySubGroupList = function getTallySubGroupList(state) {
    return state.tally_sub_group;
};

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export authResponseProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currencyProps; });
var authResponseProps = {
    status: false,
    admin: false,
    access_token: '',
    company: {
        name: '', email: ''
    },
    expiration_time: null,
    days_left: 0,
    country_id: 0,
    locale_info: {
        country_code: '',
        calling_code: '',
        currency_code: '',
        max_fraction: 2,
        thousand_separator: ',',
        decimal_separator: '.'
    },
    accessible_branches: [],
    modules: []
};

var currencyProps = {
    country_id: 0,
    country_name: '',
    country_icon: '',
    calling_code: '',
    currency_name: '',
    currency_symbol: '',
    default_currency_max_fraction: 2,
    default_currency_thousand_separator: ',',
    default_currency_decimal_separator: '.'
};

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__signup_actions__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__signup_mutations__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__signup_getters__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signup_properties__ = __webpack_require__(307);






var state = {
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__signup_properties__["a" /* signupProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__signup_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__signup_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__signup_actions__
});

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkIfTenantExists", function() { return checkIfTenantExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkTenantConfirmationCode", function() { return checkTenantConfirmationCode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

//import router from '../../../router'

var checkIfTenantExists = function checkIfTenantExists(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/signup/index.php', payload).then(function (res) {

        if (res.data.status) {
            commit('setTenantSignupId', res.data.tenant_id);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var checkTenantConfirmationCode = function checkTenantConfirmationCode(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/signup/checkTenantConfirmationCode.php', payload).then(function (res) {

        if (res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token);
            dispatch('checkAccessToken', { navigate: true });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTenantSignupId", function() { return setTenantSignupId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__properties__ = __webpack_require__(307);



var setTenantSignupId = function setTenantSignupId(state, payload) {

    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_1__properties__["a" /* signupProps */]));
    state.props.id = payload;
    __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push('/signup/step1');
};

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSignupProps", function() { return getSignupProps; });
var getSignupProps = function getSignupProps(state) {
    return {
        first_name: state.props.first_name,
        last_name: state.props.last_name,
        brand_name: state.props.brand_name,
        country_id: state.props.country_id,
        email_address: state.props.email_address,
        tailoring_category: state.props.tailoring_category
    };
};

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preferences_actions__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__preferences_mutations__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__preferences_getters__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__preferences_properties__ = __webpack_require__(308);






var state = {
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__preferences_properties__["c" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__preferences_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__preferences_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__preferences_actions__
});

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPreferences", function() { return fetchPreferences; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitPreferences", function() { return submitPreferences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchPreferences = function fetchPreferences(_ref) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/preferences/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setPreferenceInformation', res.data.response);
        }

        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitPreferences = function submitPreferences(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/preferences/save.php', payload.preferences, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('submitTaxSetting', payload.taxSetting);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPreferenceInformation", function() { return setPreferenceInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBarcodeLabelPreview", function() { return setBarcodeLabelPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewBarcodeLabelRow", function() { return addNewBarcodeLabelRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeBarcodeLabelRow", function() { return removeBarcodeLabelRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(308);


var setPreferenceInformation = function setPreferenceInformation(state, payload) {

    state.props = payload;
    if (payload.work_order_delivery_label === null || payload.work_order_delivery_label.length === 0) {
        state.props.work_order_delivery_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.inventory_sale_ready_label === null || payload.inventory_sale_ready_label.length === 0) {
        state.props.inventory_sale_ready_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.work_order_delivery_label === null || payload.work_order_delivery_label.length === 0) {
        state.props.work_order_delivery_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.production_item_label === null || payload.production_item_label.length === 0) {
        state.props.production_item_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.inventory_sale_label === null || payload.inventory_sale_label.length === 0) {
        state.props.inventory_sale_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.inventory_stock_label === null || payload.inventory_stock_label.length === 0) {
        state.props.inventory_stock_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.work_order_washable_label === null || payload.work_order_washable_label.length === 0) {
        state.props.work_order_washable_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }
    if (payload.work_order_dryclean_label === null || payload.work_order_dryclean_label.length === 0) {
        state.props.work_order_dryclean_label = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* barcodeLabelProps */]));
    }

    /*CHECK CODE TYPE*/
    if (state.props.work_order_delivery_label.label_size.code_type === undefined) {
        state.props.work_order_delivery_label.label_size.code_type = 0;
    }
    if (state.props.inventory_sale_ready_label.label_size.code_type === undefined) {
        state.props.inventory_sale_ready_label.label_size.code_type = 0;
    }
    if (state.props.work_order_delivery_label.label_size.code_type === undefined) {
        state.props.work_order_delivery_label.label_size.code_type = 0;
    }
    if (state.props.production_item_label.label_size.code_type === undefined) {
        state.props.production_item_label.label_size.code_type = 0;
    }
    if (state.props.inventory_sale_label.label_size.code_type === undefined) {
        state.props.inventory_sale_label.label_size.code_type = 0;
    }
    if (state.props.inventory_stock_label.label_size.code_type === undefined) {
        state.props.inventory_stock_label.label_size.code_type = 0;
    }
    if (state.props.work_order_dryclean_label.label_size.code_type === undefined) {
        state.props.work_order_dryclean_label.label_size.code_type = 0;
    }
    if (state.props.work_order_washable_label.label_size.code_type === undefined) {
        state.props.work_order_washable_label.label_size.code_type = 0;
    }
    /**/

    /*CHECK MARGINS*/
    if (state.props.work_order_delivery_label.label_size.left_margin === undefined) {
        state.props.work_order_delivery_label.label_size.left_margin = 0;
        state.props.work_order_delivery_label.label_size.top_margin = 0;
    }
    if (state.props.inventory_sale_ready_label.label_size.left_margin === undefined) {
        state.props.inventory_sale_ready_label.label_size.left_margin = 0;
        state.props.inventory_sale_ready_label.label_size.top_margin = 0;
    }
    if (state.props.work_order_delivery_label.label_size.left_margin === undefined) {
        state.props.work_order_delivery_label.label_size.left_margin = 0;
        state.props.work_order_delivery_label.label_size.top_margin = 0;
    }
    if (state.props.production_item_label.label_size.left_margin === undefined) {
        state.props.production_item_label.label_size.left_margin = 0;
        state.props.production_item_label.label_size.top_margin = 0;
    }
    if (state.props.inventory_sale_label.label_size.left_margin === undefined) {
        state.props.inventory_sale_label.label_size.left_margin = 0;
        state.props.inventory_sale_label.label_size.top_margin = 0;
    }
    if (state.props.inventory_stock_label.label_size.left_margin === undefined) {
        state.props.inventory_stock_label.label_size.left_margin = 0;
        state.props.inventory_stock_label.label_size.top_margin = 0;
    }
    /**/

    /*CHECK FONT SIZE*/
    if (state.props.work_order_delivery_label.label_size.font_size === undefined) {
        state.props.work_order_delivery_label.label_size.font_size = 12;
    }
    if (state.props.inventory_sale_ready_label.label_size.font_size === undefined) {
        state.props.inventory_sale_ready_label.label_size.font_size = 12;
    }
    if (state.props.work_order_delivery_label.label_size.font_size === undefined) {
        state.props.work_order_delivery_label.label_size.font_size = 12;
    }
    if (state.props.production_item_label.label_size.font_size === undefined) {
        state.props.production_item_label.label_size.font_size = 12;
    }
    if (state.props.inventory_sale_label.label_size.font_size === undefined) {
        state.props.inventory_sale_label.label_size.font_size = 12;
    }
    if (state.props.inventory_stock_label.label_size.font_size === undefined) {
        state.props.inventory_stock_label.label_size.font_size = 12;
    }
    /**/
};

var setBarcodeLabelPreview = function setBarcodeLabelPreview(state, payload) {

    var labelArraySource = null;
    if (payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label;
    } else if (payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label;
    } else if (payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label;
    } else if (payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label;
    } else if (payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label;
    } else if (payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label;
    } else if (payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label;
    }

    var returnData = "";
    returnData = "^XA";
    labelArraySource.label_contents.forEach(function (element) {

        returnData = returnData + "^FO" + element.x_axis + "," + element.y_axis + (element.content_type === 0 ? "^A" + (element.font_bold ? "0, 40" : "1, 30") + "^FD" + element.content : "^BQR,2," + element.qr_height + ",H,2^FDQA," + element.content);

        returnData = returnData + "^FS";
    });
    returnData = returnData + "^XZ";

    labelArraySource.preview = "https://api.labelary.com/v1/printers/8dpmm/labels/" + labelArraySource.label_size.width + "x" + labelArraySource.label_size.height + "/0/" + returnData;
};

var addNewBarcodeLabelRow = function addNewBarcodeLabelRow(state, payload) {

    var key = 0;

    var labelArraySource = null;
    if (payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label;
    } else if (payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label;
    } else if (payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label;
    } else if (payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label;
    } else if (payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label;
    } else if (payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label;
    } else if (payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label;
    }

    labelArraySource.label_contents.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* barcodeLabelContentProps */])));

    labelArraySource.label_contents.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeBarcodeLabelRow = function removeBarcodeLabelRow(state, payload) {

    var key = 0;

    var labelArraySource = null;
    if (payload.type === "retail") {
        labelArraySource = state.props.inventory_sale_label;
    } else if (payload.type === 'stock') {
        labelArraySource = state.props.inventory_stock_label;
    } else if (payload.type === 'workorder') {
        labelArraySource = state.props.work_order_label;
    } else if (payload.type === 'ready_item') {
        labelArraySource = state.props.inventory_sale_ready_label;
    } else if (payload.type === 'workorder_delivery_tag') {
        labelArraySource = state.props.work_order_delivery_label;
    } else if (payload.type === 'workorder_washable') {
        labelArraySource = state.props.work_order_washable_label;
    } else if (payload.type === 'workorder_dryclean') {
        labelArraySource = state.props.work_order_dryclean_label;
    }

    labelArraySource.label_contents.splice(payload.key, 1);

    labelArraySource.label_contents.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreferenceProps", function() { return getPreferenceProps; });
var getPreferenceProps = function getPreferenceProps(state) {
    return state.props;
};

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__taxSetting_actions__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__taxSetting_mutations__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taxSetting_getters__ = __webpack_require__(1297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__taxSetting_properties__ = __webpack_require__(309);






var state = {
    props: [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__taxSetting_properties__["a" /* dataProps */]))],
    deletedItems: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__taxSetting_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__taxSetting_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__taxSetting_actions__
});

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTaxSetting", function() { return fetchTaxSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTaxSetting", function() { return submitTaxSetting; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchTaxSetting = function fetchTaxSetting(_ref) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/taxSetting/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setTaxSetting', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTaxSetting = function submitTaxSetting(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/taxSetting/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Submitted successfully!!!' });
            dispatch('fetchPreferences');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaxSetting", function() { return setTaxSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTaxSettingRow", function() { return addNewTaxSettingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTaxSettingRow", function() { return removeTaxSettingRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(309);


var setTaxSetting = function setTaxSetting(state, payload) {
    state.props = [];
    var key = 0;
    payload.forEach(function (element) {
        element.key = key;
        state.props.push(element);
        key++;
    });
    if (payload.length === 0) {
        state.props.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */])));
    }
};

var addNewTaxSettingRow = function addNewTaxSettingRow(state) {

    var key = 0;
    state.props.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */])));

    state.props.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('tax_name_' + (key - 1)).focus();
    }, 300);
};

var removeTaxSettingRow = function removeTaxSettingRow(state, payload) {

    var key = 0;

    state.deletedItems.push(state.props[payload]);

    state.props.splice(payload, 1);

    state.props.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaxSetting", function() { return getTaxSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIndiaTax", function() { return isIndiaTax; });
var getTaxSetting = function getTaxSetting(state) {
    return state.props;
};

var isIndiaTax = function isIndiaTax(state) {
    var taxList = state.props.filter(function (option) {
        return option.gst_india === true;
    });
    return taxList.length > 0;
};

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shop_actions__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shop_mutations__ = __webpack_require__(1300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shop_getters__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shop_properties__ = __webpack_require__(310);






var state = {
    list: [],
    zoho_branches: [],
    zoho_eta_branches: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__shop_properties__["a" /* dataProps */])),
    store_address: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__shop_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__shop_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__shop_actions__
});

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchShopList", function() { return fetchShopList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchZohoBranchList", function() { return fetchZohoBranchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchZohoETABranchList", function() { return fetchZohoETABranchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadStoreAddress", function() { return loadStoreAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchShopData", function() { return fetchShopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitShopData", function() { return submitShopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteShopData", function() { return deleteShopData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchShopList = function fetchShopList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/shop/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setShopList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchZohoBranchList = function fetchZohoBranchList(_ref2) {
    var commit = _ref2.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/eta-zoho-sync/tools/zoho_discovery.php').then(function (res) {
        commit('setZohoBranches', res.data.organizations);
    }).catch(function (error) {
        //commit('displayMessageAlert', {message: error, type: 'Error'})
        console.log(JSON.stringify(error));
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchZohoETABranchList = function fetchZohoETABranchList(_ref3, payload) {
    var commit = _ref3.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shop/fetchZohoBranches.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setZohoETABranches', res.data.response);
    }).catch(function (error) {
        //commit('displayMessageAlert', {message: error, type: 'Error'})
        console.log(JSON.stringify(error));
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadStoreAddress = function loadStoreAddress(_ref4, payload) {
    var commit = _ref4.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shop/loadStoreAddress.php', { id: payload.id }, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit(payload.target_commit, res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchShopData = function fetchShopData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shop/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setShopData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { store_id: payload.id, copy: payload.copy });

            dispatch('loadProvinceList', res.data.response.country_id);
            dispatch('loadCityList', res.data.response.province_id);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetShopData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitShopData = function submitShopData(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shop/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteShopData = function deleteShopData(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shop/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchShopList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShopList", function() { return setShopList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShopData", function() { return setShopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewShopTimingRow", function() { return addNewShopTimingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeShopTimingRow", function() { return removeShopTimingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreTopMenuRow", function() { return addEStoreTopMenuRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreTopMenuRow", function() { return removeEStoreTopMenuRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreGeneralSettingRow", function() { return addEStoreGeneralSettingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreGeneralSettingRow", function() { return removeEStoreGeneralSettingRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreBrandRow", function() { return addEStoreBrandRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreBrandRow", function() { return removeEStoreBrandRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreBottomMenuRow", function() { return addEStoreBottomMenuRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreBottomMenuRow", function() { return removeEStoreBottomMenuRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortEStoreBottomMenuList", function() { return sortEStoreBottomMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setZohoBranches", function() { return setZohoBranches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetShopData", function() { return resetShopData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewZohoBranchRow", function() { return addNewZohoBranchRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeZohoBranchRow", function() { return removeZohoBranchRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setZohoETABranches", function() { return setZohoETABranches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(310);


var setShopList = function setShopList(state, payload) {
    state.list = payload;
};

var setShopData = function setShopData(state, payload) {
    state.props = payload.response;

    if (state.props.shop_timing_list.length === 0) {
        state.props.shop_timing_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["i" /* timingListProps */]))];
    } else if (payload.copy) {
        state.props.shop_timing_list.forEach(function (element) {
            element.id = 0;
        });
    }
    if (state.props.e_store_menu_top_list === null || state.props.e_store_menu_top_list.length === 0) {
        state.props.e_store_menu_top_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */]))];
    }
    if (state.props.e_store_menu_bottom_list === null || state.props.e_store_menu_bottom_list.length === 0) {
        state.props.e_store_menu_bottom_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */]))];
    }
    if (state.props.e_store_social_media_link_list === null || state.props.e_store_social_media_link_list.length === 0) {
        state.props.e_store_social_media_link_list = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["f" /* eStoreSocialMediaProps */]));
    }

    if (state.props.e_store_shipment_method_list === null || state.props.e_store_shipment_method_list.length === 0) {
        state.props.e_store_shipment_method_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* eStoreShipmentMethodProp */]))];
    }

    if (state.props.e_store_banners === null || state.props.e_store_banners.length === 0) {
        state.props.e_store_banners = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* eStoreBannersProp */]));
    }

    if (state.props.e_store_about_us === null) {
        state.props.e_store_about_us = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* eStoreAboutUsProps */]));
    }

    if (state.props.e_store_imprint === null || state.props.e_store_imprint.length === 0) {
        state.props.e_store_imprint = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* eStoreImprintProp */]))];
    }

    /*if(state.props.zoho_store_routing === null || state.props.zoho_store_routing.length === 0) {
        state.props.zoho_store_routing =[ JSON.parse(JSON.stringify(eStoreZohoProp))]
    }*/

    var key = 0;
    state.props.shop_timing_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    var privacyPolicy = '<section class="py-5">\n' + '<div class="container">	 \n\n' + '<p class="heading-3">Heading</p>\n\n' + '<p class="content-text-small">Content Here</p>\n\n' + '</div>\n' + '</section>';

    if (state.props.e_store_privacy_policy === null || state.props.e_store_privacy_policy.length === 0) {
        state.props.e_store_privacy_policy = privacyPolicy;
    }

    if (state.props.e_store_cancellation_policy === null || state.props.e_store_cancellation_policy.length === 0) {
        state.props.e_store_cancellation_policy = privacyPolicy;
    }

    if (state.props.e_store_job_opening === null || state.props.e_store_job_opening.length === 0) {
        state.props.e_store_job_opening = privacyPolicy;
    }
};

var addNewShopTimingRow = function addNewShopTimingRow(state) {

    var key = 0;
    state.props.shop_timing_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["i" /* timingListProps */])));

    state.props.shop_timing_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('day_name_' + (key - 1)).focus();
    }, 300);
};

var removeShopTimingRow = function removeShopTimingRow(state, payload) {

    var key = 0;

    state.props.deleted_timing_items.push(state.props.shop_timing_list[payload]);

    state.props.shop_timing_list.splice(payload, 1);

    if (state.props.shop_timing_list.length === 0) {
        state.props.shop_timing_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["i" /* timingListProps */]))];
    }

    state.props.shop_timing_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addEStoreTopMenuRow = function addEStoreTopMenuRow(state) {

    var key = 0;
    state.props.e_store_menu_top_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */])));

    state.props.e_store_menu_top_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreTopMenuRow = function removeEStoreTopMenuRow(state, payload) {

    var key = 0;

    state.props.e_store_menu_top_list.splice(payload, 1);

    if (state.props.e_store_menu_top_list.length === 0) {
        state.props.e_store_menu_top_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */]))];
    }

    state.props.e_store_menu_top_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addEStoreGeneralSettingRow = function addEStoreGeneralSettingRow(state) {

    var key = 0;
    state.props.e_store_shipment_method_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* eStoreShipmentMethodProp */])));

    state.props.e_store_shipment_method_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreGeneralSettingRow = function removeEStoreGeneralSettingRow(state, payload) {

    var key = 0;

    state.props.e_store_shipment_method_list.splice(payload, 1);

    if (state.props.e_store_shipment_method_list.length === 0) {
        state.props.e_store_shipment_method_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* eStoreShipmentMethodProp */]))];
    }

    state.props.e_store_shipment_method_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addEStoreBrandRow = function addEStoreBrandRow(state) {

    var key = 0;
    state.props.e_store_imprint.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* eStoreImprintProp */])));

    state.props.e_store_imprint.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreBrandRow = function removeEStoreBrandRow(state, payload) {

    var key = 0;

    state.props.e_store_imprint.splice(payload, 1);

    if (state.props.e_store_imprint.length === 0) {
        state.props.e_store_imprint = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* eStoreImprintProp */]))];
    }

    state.props.e_store_imprint.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/*export const sortEStoreTopMenuList = (state, payload) => {

    let key = (payload.key)

    if(payload.sort == 1) {
        state.props.e_store_menu_top_list[key].key = payload.key+1
        state.props.e_store_menu_top_list[key+1].key = payload.key         
    } else if(payload.sort == 0) {
        state.props.e_store_menu_top_list[key].key = payload.key-1
        state.props.e_store_menu_top_list[key-1].key = payload.key         
    }

    state.props.e_store_menu_top_list = state.props.e_store_menu_top_list.sort( (a,b) => { 
        var x = a.key < b.key? -1:1; 
        return x; 
    });

}*/

var addEStoreBottomMenuRow = function addEStoreBottomMenuRow(state) {

    var key = 0;
    state.props.e_store_menu_bottom_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */])));

    state.props.e_store_menu_bottom_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreBottomMenuRow = function removeEStoreBottomMenuRow(state, payload) {

    var key = 0;

    state.props.e_store_menu_bottom_list.splice(payload, 1);

    if (state.props.e_store_menu_bottom_list.length === 0) {
        state.props.e_store_menu_bottom_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* eStoreTopProps */]))];
    }

    state.props.e_store_menu_bottom_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var sortEStoreBottomMenuList = function sortEStoreBottomMenuList(state, payload) {

    var key = payload.key;

    if (payload.sort == 1) {
        state.props.e_store_menu_bottom_list[key].key = payload.key + 1;
        state.props.e_store_menu_bottom_list[key + 1].key = payload.key;
    } else if (payload.sort == 0) {
        state.props.e_store_menu_bottom_list[key].key = payload.key - 1;
        state.props.e_store_menu_bottom_list[key - 1].key = payload.key;
    }

    state.props.e_store_menu_bottom_list = state.props.e_store_menu_bottom_list.sort(function (a, b) {
        var x = a.key < b.key ? -1 : 1;
        return x;
    });
};

var setZohoBranches = function setZohoBranches(state, payload) {
    state.zoho_branches = payload;
};

var resetShopData = function resetShopData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var addNewZohoBranchRow = function addNewZohoBranchRow(state) {

    var key = 0;
    state.props.zoho_store_routing.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* eStoreZohoProp */])));

    state.props.zoho_store_routing.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeZohoBranchRow = function removeZohoBranchRow(state, payload) {

    var key = 0;

    state.props.deleted_zoho_store_routing.push(state.props.zoho_store_routing[payload]);

    state.props.zoho_store_routing.splice(payload, 1);

    if (state.props.zoho_store_routing.length === 0) {
        state.props.zoho_store_routing = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* eStoreZohoProp */]))];
    }

    state.props.zoho_store_routing.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setZohoETABranches = function setZohoETABranches(state, payload) {
    state.zoho_eta_branches = payload;
};

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShopList", function() { return getShopList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShopDataProps", function() { return getShopDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZohoBranches", function() { return getZohoBranches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZohoETABranches", function() { return getZohoETABranches; });
var getShopList = function getShopList(state) {
    return state.list;
};

var getShopDataProps = function getShopDataProps(state) {
    return state.props;
};

var getZohoBranches = function getZohoBranches(state) {
    return state.zoho_branches;
};

var getZohoETABranches = function getZohoETABranches(state) {
    return state.zoho_eta_branches;
};

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__document_actions__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__document_mutations__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__document_getters__ = __webpack_require__(1306);




//import { dataProps } from './document/properties'

var state = {
    props: [],
    deletedItems: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__document_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__document_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__document_actions__
});

/***/ }),
/* 1303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDocumentList", function() { return fetchDocumentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchDocumentList = function fetchDocumentList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/document/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.try_again) {
            dispatch('fetchDocumentList', payload);
        } else {
            commit('setDocumentList', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDocumentList", function() { return setDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewDocumentRow", function() { return addNewDocumentRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeDocumentRow", function() { return removeDocumentRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetDocumentList", function() { return resetDocumentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(1305);


var setDocumentList = function setDocumentList(state, payload) {
    state.props = [];
    var key = 0;
    payload.forEach(function (element) {
        element.key = key;
        if (payload.copy) {
            element.id = 0;
        }
        state.props.push(element);
        key++;
    });
};

var addNewDocumentRow = function addNewDocumentRow(state) {

    var key = 0;
    state.props.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */])));

    state.props.forEach(function (element) {
        element.key = key;
        key++;
    });
    setTimeout(function () {
        document.getElementById('document_title_' + (key - 1)).focus();
    }, 300);
};

var removeDocumentRow = function removeDocumentRow(state, payload) {

    var key = 0;

    state.deletedItems.push(state.props[payload]);

    state.props.splice(payload, 1);

    state.props.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetDocumentList = function resetDocumentList(state) {
    state.props = [];
};

/***/ }),
/* 1305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataProps; });
var dataProps = {
    key: 0,
    id: 0,
    document_title: '',
    attachment: '',
    expiration_date: new Date(),
    reminder_date: new Date(),
    enable_reminder: false
};

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentList", function() { return getDocumentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentDeletedList", function() { return getDocumentDeletedList; });
var getDocumentList = function getDocumentList(state) {
    return state.props;
};

var getDocumentDeletedList = function getDocumentDeletedList(state) {
    return state.deletedItems;
};

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__taskCategory_actions__ = __webpack_require__(1308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__taskCategory_mutations__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__taskCategory_getters__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__taskCategory_properties__ = __webpack_require__(311);






var state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__taskCategory_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__taskCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__taskCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__taskCategory_actions__
});

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTaskCategoryList", function() { return fetchTaskCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTaskCategoryData", function() { return fetchTaskCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTaskCategoryData", function() { return submitTaskCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTaskCategoryData", function() { return deleteTaskCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTaskCategoryList = function fetchTaskCategoryList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/taskCategory/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTaskCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTaskCategoryData = function fetchTaskCategoryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/taskCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setTaskCategoryData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTaskCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTaskCategoryData = function submitTaskCategoryData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/taskCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTaskCategoryData = function deleteTaskCategoryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/taskCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTaskCategoryList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskCategoryList", function() { return setTaskCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskCategoryData", function() { return setTaskCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTaskCategoryData", function() { return resetTaskCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(311);


var setTaskCategoryList = function setTaskCategoryList(state, payload) {
    state.list = payload;
};

var setTaskCategoryData = function setTaskCategoryData(state, payload) {
    state.props = payload;
};

var resetTaskCategoryData = function resetTaskCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskCategoryList", function() { return getTaskCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskCategoryDataProps", function() { return getTaskCategoryDataProps; });
var getTaskCategoryList = function getTaskCategoryList(state) {
    return state.list;
};

var getTaskCategoryDataProps = function getTaskCategoryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teamCategory_actions__ = __webpack_require__(1312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teamCategory_mutations__ = __webpack_require__(1313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__teamCategory_getters__ = __webpack_require__(1314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamCategory_properties__ = __webpack_require__(312);






var state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__teamCategory_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__teamCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__teamCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__teamCategory_actions__
});

/***/ }),
/* 1312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTeamCategoryList", function() { return fetchTeamCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTeamCategoryData", function() { return fetchTeamCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTeamCategoryData", function() { return submitTeamCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTeamCategoryData", function() { return deleteTeamCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTeamCategoryList = function fetchTeamCategoryList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/teamCategory/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTeamCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTeamCategoryData = function fetchTeamCategoryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setTeamCategoryData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTeamCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTeamCategoryData = function submitTeamCategoryData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTeamCategoryData = function deleteTeamCategoryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTeamCategoryList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTeamCategoryList", function() { return setTeamCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTeamCategoryData", function() { return setTeamCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTeamCategoryData", function() { return resetTeamCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(312);


var setTeamCategoryList = function setTeamCategoryList(state, payload) {
    state.list = payload;
};

var setTeamCategoryData = function setTeamCategoryData(state, payload) {
    state.props = payload;
};

var resetTeamCategoryData = function resetTeamCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeamCategoryList", function() { return getTeamCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeamCategoryDataProps", function() { return getTeamCategoryDataProps; });
var getTeamCategoryList = function getTeamCategoryList(state) {
    return state.list;
};

var getTeamCategoryDataProps = function getTeamCategoryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__saleCategory_actions__ = __webpack_require__(1316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__saleCategory_mutations__ = __webpack_require__(1317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__saleCategory_getters__ = __webpack_require__(1318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saleCategory_properties__ = __webpack_require__(313);






var state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__saleCategory_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__saleCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__saleCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__saleCategory_actions__
});

/***/ }),
/* 1316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleCategoryList", function() { return fetchSaleCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleCategoryData", function() { return fetchSaleCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSaleCategoryData", function() { return submitSaleCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSaleCategoryData", function() { return deleteSaleCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchSaleCategoryList = function fetchSaleCategoryList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/saleCategory/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setSaleCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSaleCategoryData = function fetchSaleCategoryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setSaleCategoryData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetSaleCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitSaleCategoryData = function submitSaleCategoryData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteSaleCategoryData = function deleteSaleCategoryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchSaleCategoryList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleCategoryList", function() { return setSaleCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleCategoryData", function() { return setSaleCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSaleCategoryData", function() { return resetSaleCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(313);


var setSaleCategoryList = function setSaleCategoryList(state, payload) {
    state.list = payload;
};

var setSaleCategoryData = function setSaleCategoryData(state, payload) {
    state.props = payload;
};

var resetSaleCategoryData = function resetSaleCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleCategoryList", function() { return getSaleCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleCategoryDataProps", function() { return getSaleCategoryDataProps; });
var getSaleCategoryList = function getSaleCategoryList(state) {
    return state.list;
};

var getSaleCategoryDataProps = function getSaleCategoryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__customerTag_actions__ = __webpack_require__(1320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customerTag_mutations__ = __webpack_require__(1321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customerTag_getters__ = __webpack_require__(1322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerTag_properties__ = __webpack_require__(314);






var state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__customerTag_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__customerTag_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__customerTag_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__customerTag_actions__
});

/***/ }),
/* 1320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerTagList", function() { return fetchCustomerTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerTagData", function() { return fetchCustomerTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCustomerTagData", function() { return submitCustomerTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerTagData", function() { return deleteCustomerTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchCustomerTagList = function fetchCustomerTagList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/customerTag/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCustomerTagList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerTagData = function fetchCustomerTagData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerTag/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setCustomerTagData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetCustomerTagData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCustomerTagData = function submitCustomerTagData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerTag/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCustomerTagData = function deleteCustomerTagData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerTag/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchCustomerTagList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerTagList", function() { return setCustomerTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerTagData", function() { return setCustomerTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerTagData", function() { return resetCustomerTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(314);


var setCustomerTagList = function setCustomerTagList(state, payload) {
    state.list = payload;
};

var setCustomerTagData = function setCustomerTagData(state, payload) {
    state.props = payload;
};

var resetCustomerTagData = function resetCustomerTagData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTagList", function() { return getCustomerTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerTagDataProps", function() { return getCustomerTagDataProps; });
var getCustomerTagList = function getCustomerTagList(state) {
    return state.list;
};

var getCustomerTagDataProps = function getCustomerTagDataProps(state) {
    return state.props;
};

/***/ }),
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__saleTag_actions__ = __webpack_require__(1324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__saleTag_mutations__ = __webpack_require__(1325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__saleTag_getters__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saleTag_properties__ = __webpack_require__(315);






var state = {
    list: [],
    nav: {
        page_number: 0,
        limit: 50,
        total: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__saleTag_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__saleTag_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__saleTag_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__saleTag_actions__
});

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleTagList", function() { return fetchSaleTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleTagData", function() { return fetchSaleTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSaleTagData", function() { return submitSaleTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSaleTagData", function() { return deleteSaleTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchSaleTagList = function fetchSaleTagList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/saleTag/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setSaleTagList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSaleTagData = function fetchSaleTagData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleTag/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setSaleTagData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetSaleTagData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitSaleTagData = function submitSaleTagData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleTag/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteSaleTagData = function deleteSaleTagData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleTag/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchSaleTagList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleTagList", function() { return setSaleTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleTagData", function() { return setSaleTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSaleTagData", function() { return resetSaleTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(315);


var setSaleTagList = function setSaleTagList(state, payload) {
    state.list = payload;
};

var setSaleTagData = function setSaleTagData(state, payload) {
    state.props = payload;
};

var resetSaleTagData = function resetSaleTagData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleTagList", function() { return getSaleTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleTagDataProps", function() { return getSaleTagDataProps; });
var getSaleTagList = function getSaleTagList(state) {
    return state.list;
};

var getSaleTagDataProps = function getSaleTagDataProps(state) {
    return state.props;
};

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contactTag_actions__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contactTag_mutations__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contactTag_getters__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contactTag_properties__ = __webpack_require__(316);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__contactTag_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__contactTag_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__contactTag_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__contactTag_actions__
});

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchContactTagList", function() { return fetchContactTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchContactTagData", function() { return fetchContactTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitContactTagData", function() { return submitContactTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteContactTagData", function() { return deleteContactTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchContactTagList = function fetchContactTagList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/contactTag/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setContactTagList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchContactTagData = function fetchContactTagData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contactTag/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setContactTagData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetContactTagData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitContactTagData = function submitContactTagData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contactTag/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteContactTagData = function deleteContactTagData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contactTag/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchContactTagList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setContactTagList", function() { return setContactTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setContactTagData", function() { return setContactTagData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetContactTagData", function() { return resetContactTagData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(316);


var setContactTagList = function setContactTagList(state, payload) {
    state.list = payload;
};

var setContactTagData = function setContactTagData(state, payload) {
    state.props = payload;
};

var resetContactTagData = function resetContactTagData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContactTagList", function() { return getContactTagList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContactTagDataProps", function() { return getContactTagDataProps; });
var getContactTagList = function getContactTagList(state) {
    return state.list;
};

var getContactTagDataProps = function getContactTagDataProps(state) {
    return state.props;
};

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__communicationTemplate_actions__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__communicationTemplate_mutations__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__communicationTemplate_getters__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__communicationTemplate_properties__ = __webpack_require__(317);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__communicationTemplate_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__communicationTemplate_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__communicationTemplate_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__communicationTemplate_actions__
});

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCommunicationTemplateList", function() { return fetchCommunicationTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCommunicationTemplateData", function() { return fetchCommunicationTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCommunicationTemplateData", function() { return submitCommunicationTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCommunicationTemplateData", function() { return deleteCommunicationTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchCommunicationTemplateList = function fetchCommunicationTemplateList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/communicationTemplate/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCommunicationTemplateList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCommunicationTemplateData = function fetchCommunicationTemplateData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/communicationTemplate/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setCommunicationTemplateData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetCommunicationTemplateData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCommunicationTemplateData = function submitCommunicationTemplateData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/communicationTemplate/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCommunicationTemplateData = function deleteCommunicationTemplateData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/communicationTemplate/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchCommunicationTemplateList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCommunicationTemplateList", function() { return setCommunicationTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCommunicationTemplateData", function() { return setCommunicationTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCommunicationTemplateData", function() { return resetCommunicationTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(317);


var setCommunicationTemplateList = function setCommunicationTemplateList(state, payload) {
    state.list = payload;
};

var setCommunicationTemplateData = function setCommunicationTemplateData(state, payload) {
    state.props = payload;
};

var resetCommunicationTemplateData = function resetCommunicationTemplateData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCommunicationTemplateList", function() { return getCommunicationTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCommunicationTemplateDataProps", function() { return getCommunicationTemplateDataProps; });
var getCommunicationTemplateList = function getCommunicationTemplateList(state) {
    return state.list;
};

var getCommunicationTemplateDataProps = function getCommunicationTemplateDataProps(state) {
    return state.props;
};

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userGroup_actions__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__userGroup_mutations__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__userGroup_getters__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userGroup_properties__ = __webpack_require__(318);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__userGroup_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__userGroup_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__userGroup_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__userGroup_actions__
});

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserGroupList", function() { return fetchUserGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserGroupData", function() { return fetchUserGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitUserGroupData", function() { return submitUserGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteUserGroupData", function() { return deleteUserGroupData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchUserGroupList = function fetchUserGroupList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/userGroup/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setUserGroupList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchUserGroupData = function fetchUserGroupData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/userGroup/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setUserGroupData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetUserGroupData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitUserGroupData = function submitUserGroupData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/userGroup/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('fetchUserGroupData', { id: payload.id });
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteUserGroupData = function deleteUserGroupData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/userGroup/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchUserGroupList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserGroupList", function() { return setUserGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserGroupData", function() { return setUserGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetUserGroupData", function() { return resetUserGroupData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(318);


var setUserGroupList = function setUserGroupList(state, payload) {
    state.list = payload;
};

var setUserGroupData = function setUserGroupData(state, payload) {
    state.props = payload.response;
    if (payload.copy) {
        state.props.access_module_list.forEach(function (element) {
            element.id = 0;
        });
    }
};

var resetUserGroupData = function resetUserGroupData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserGroupList", function() { return getUserGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserGroupDataProps", function() { return getUserGroupDataProps; });
var getUserGroupList = function getUserGroupList(state) {
    return state.list;
};

var getUserGroupDataProps = function getUserGroupDataProps(state) {
    return state.props;
};

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemCategory_actions__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__itemCategory_mutations__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__itemCategory_getters__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__itemCategory_properties__ = __webpack_require__(319);






var state = {
    list: [],
    fabric_list: [],
    all_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__itemCategory_properties__["a" /* dataProps */])),
    item_type: 0 //tailoring product, fabric, ready to wear, raw material, asset
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__itemCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__itemCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__itemCategory_actions__
});

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchItemCategoryList", function() { return fetchItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllCategoryList", function() { return fetchAllCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllItemCategoryList", function() { return fetchAllItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchItemSubCategoryList", function() { return fetchItemSubCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchItemSubCategoryList_Fabric", function() { return fetchItemSubCategoryList_Fabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchItemCategoryData", function() { return fetchItemCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitItemCategoryData", function() { return submitItemCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteItemCategoryData", function() { return deleteItemCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchItemCategoryList = function fetchItemCategoryList(_ref, payload) {
    var commit = _ref.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setItemCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchAllCategoryList = function fetchAllCategoryList(_ref2) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    console.log("Here");
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/itemCategory/allCategoryList.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setItemCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchAllItemCategoryList = function fetchAllItemCategoryList(_ref3) {
    var commit = _ref3.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/itemCategory/allType.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setAllItemCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchItemSubCategoryList = function fetchItemSubCategoryList(_ref4, payload) {
    var commit = _ref4.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/allSubCategory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setItemCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchItemSubCategoryList_Fabric = function fetchItemSubCategoryList_Fabric(_ref5, payload) {
    var commit = _ref5.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/allSubCategory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setItemCategoryList_Fabric', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchItemCategoryData = function fetchItemCategoryData(_ref6, payload) {
    var commit = _ref6.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setItemCategoryData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetItemCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitItemCategoryData = function submitItemCategoryData(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchItemCategoryData', { id: payload.id });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteItemCategoryData = function deleteItemCategoryData(_ref8, payload) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchItemCategoryList', { type: payload.type });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemCategoryList", function() { return setItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemCategoryList_Fabric", function() { return setItemCategoryList_Fabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAllItemCategoryList", function() { return setAllItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemCategoryData", function() { return setItemCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewSubCategoryItemRow", function() { return addNewSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSubCategoryItemRow", function() { return removeSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewQualityPointItemRow", function() { return addNewQualityPointItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeQualityPointItemRow", function() { return removeQualityPointItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetItemCategoryData", function() { return resetItemCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(319);


var setItemCategoryList = function setItemCategoryList(state, payload) {
    state.list = payload;
};

var setItemCategoryList_Fabric = function setItemCategoryList_Fabric(state, payload) {
    state.fabric_list = payload;
};

var setAllItemCategoryList = function setAllItemCategoryList(state, payload) {
    state.all_list = payload;
};

var setItemCategoryData = function setItemCategoryData(state, payload) {
    state.props = payload.response;

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* subItemProps */]))];
    } else if (payload.copy) {
        state.props.sub_item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    if (state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* qualityItemProps */]))];
    } else if (payload.copy) {
        state.props.quality_point_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    key = 0;
    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewSubCategoryItemRow = function addNewSubCategoryItemRow(state) {

    var key = 0;
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* subItemProps */])));

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('sub_category_name_' + (key - 1)).focus();
    }, 300);
};

var removeSubCategoryItemRow = function removeSubCategoryItemRow(state, payload) {

    var key = 0;

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload]);

    state.props.sub_item_list.splice(payload, 1);

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* subItemProps */]))];
    }

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewQualityPointItemRow = function addNewQualityPointItemRow(state) {

    var key = 0;
    state.props.quality_point_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* qualityItemProps */])));

    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('quality_point_' + (key - 1)).focus();
    }, 300);
};

var removeQualityPointItemRow = function removeQualityPointItemRow(state, payload) {

    var key = 0;

    state.props.deleted_quality_point_list_items.push(state.props.quality_point_list[payload]);

    state.props.quality_point_list.splice(payload, 1);

    if (state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* qualityItemProps */]))];
    }

    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetItemCategoryData = function resetItemCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemCategoryList", function() { return getItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllItemCategoryList", function() { return getAllItemCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemCategoryDataProps", function() { return getItemCategoryDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemCategoryList_Fabric", function() { return getItemCategoryList_Fabric; });
var getItemCategoryList = function getItemCategoryList(state) {
    return state.list;
};

var getAllItemCategoryList = function getAllItemCategoryList(state) {
    return state.all_list;
};

var getItemCategoryDataProps = function getItemCategoryDataProps(state) {
    return state.props;
};

var getItemCategoryList_Fabric = function getItemCategoryList_Fabric(state) {
    return state.fabric_list;
};

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tailoringCollection_actions__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tailoringCollection_mutations__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tailoringCollection_getters__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tailoringCollection_properties__ = __webpack_require__(320);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__tailoringCollection_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__tailoringCollection_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__tailoringCollection_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__tailoringCollection_actions__
});

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringCollectionList", function() { return fetchTailoringCollectionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringCollectionData", function() { return fetchTailoringCollectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTailoringCollectionData", function() { return submitTailoringCollectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTailoringCollectionData", function() { return deleteTailoringCollectionData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTailoringCollectionList = function fetchTailoringCollectionList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tailoringCollection/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTailoringCollectionList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTailoringCollectionData = function fetchTailoringCollectionData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringCollection/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setTailoringCollectionData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTailoringCollectionData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTailoringCollectionData = function submitTailoringCollectionData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringCollection/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTailoringCollectionData = function deleteTailoringCollectionData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringCollection/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTailoringCollectionList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringCollectionList", function() { return setTailoringCollectionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringCollectionData", function() { return setTailoringCollectionData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTailoringCollectionData", function() { return resetTailoringCollectionData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(320);


var setTailoringCollectionList = function setTailoringCollectionList(state, payload) {
    state.list = payload;
};

var setTailoringCollectionData = function setTailoringCollectionData(state, payload) {
    state.props = payload;
};

var resetTailoringCollectionData = function resetTailoringCollectionData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringCollectionList", function() { return getTailoringCollectionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringCollectionDataProps", function() { return getTailoringCollectionDataProps; });
var getTailoringCollectionList = function getTailoringCollectionList(state) {
    return state.list;
};

var getTailoringCollectionDataProps = function getTailoringCollectionDataProps(state) {
    return state.props;
};

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tailoringSize_actions__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tailoringSize_mutations__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tailoringSize_getters__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tailoringSize_properties__ = __webpack_require__(321);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__tailoringSize_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__tailoringSize_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__tailoringSize_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__tailoringSize_actions__
});

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringSizeList", function() { return fetchTailoringSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringSizeData", function() { return fetchTailoringSizeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTailoringSizeData", function() { return submitTailoringSizeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTailoringSizeData", function() { return deleteTailoringSizeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTailoringSizeList = function fetchTailoringSizeList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tailoringSize/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTailoringSizeList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTailoringSizeData = function fetchTailoringSizeData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringSize/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setTailoringSizeData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTailoringSizeData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTailoringSizeData = function submitTailoringSizeData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringSize/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTailoringSizeData = function deleteTailoringSizeData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringSize/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTailoringSizeList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringSizeList", function() { return setTailoringSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringSizeData", function() { return setTailoringSizeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTailoringSizeData", function() { return resetTailoringSizeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringSizeMasterFabricConsumptionRow", function() { return addNewTailoringSizeMasterFabricConsumptionRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringSizeMasterFabricConsumptionRow", function() { return removeTailoringSizeMasterFabricConsumptionRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(321);


var setTailoringSizeList = function setTailoringSizeList(state, payload) {
    state.list = payload;
};

var setTailoringSizeData = function setTailoringSizeData(state, payload) {
    state.props = payload;
    if (state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* fabricConsumptionProps */])));
    }
};

var resetTailoringSizeData = function resetTailoringSizeData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var addNewTailoringSizeMasterFabricConsumptionRow = function addNewTailoringSizeMasterFabricConsumptionRow(state) {

    var key = 0;
    state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* fabricConsumptionProps */])));

    state.props.fabric_consumption_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('size_name_' + (key - 1)).focus();
    }, 300);
};

var removeTailoringSizeMasterFabricConsumptionRow = function removeTailoringSizeMasterFabricConsumptionRow(state, payload) {

    var key = 0;

    state.props.delete_fabric_consumption_list.push(state.props.fabric_consumption_list[payload]);

    state.props.fabric_consumption_list.splice(payload, 1);

    if (state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* fabricConsumptionProps */]))];
    }

    state.props.fabric_consumption_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringSizeList", function() { return getTailoringSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringSizeDataProps", function() { return getTailoringSizeDataProps; });
var getTailoringSizeList = function getTailoringSizeList(state) {
    return state.list;
};

var getTailoringSizeDataProps = function getTailoringSizeDataProps(state) {
    return state.props;
};

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__measurementTemplate_actions__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__measurementTemplate_mutations__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__measurementTemplate_getters__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__measurementTemplate_properties__ = __webpack_require__(322);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__measurementTemplate_properties__["a" /* dataProps */])),
    item_type: 0 //tailoring product, fabric, ready to wear, raw material, asset
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__measurementTemplate_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__measurementTemplate_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__measurementTemplate_actions__
});

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMeasurementTemplateList", function() { return fetchMeasurementTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMeasurementTemplateData", function() { return fetchMeasurementTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitMeasurementTemplateData", function() { return submitMeasurementTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteMeasurementTemplateData", function() { return deleteMeasurementTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchMeasurementTemplateList = function fetchMeasurementTemplateList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/measurementTemplate/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setMeasurementTemplateList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-1' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchMeasurementTemplateData = function fetchMeasurementTemplateData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/measurementTemplate/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setMeasurementTemplateData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetMeasurementTemplateData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitMeasurementTemplateData = function submitMeasurementTemplateData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/measurementTemplate/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteMeasurementTemplateData = function deleteMeasurementTemplateData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/measurementTemplate/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchMeasurementTemplateList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMeasurementTemplateList", function() { return setMeasurementTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMeasurementTemplateData", function() { return setMeasurementTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewMeasurementListItemRow", function() { return addNewMeasurementListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeMeasurementListItemRow", function() { return removeMeasurementListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortMeasurementTemplateList", function() { return sortMeasurementTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewMeasurementListDropDownItemRow", function() { return addNewMeasurementListDropDownItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeMeasurementListDropDownItemRow", function() { return removeMeasurementListDropDownItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetMeasurementTemplateData", function() { return resetMeasurementTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(322);


var setMeasurementTemplateList = function setMeasurementTemplateList(state, payload) {
    state.list = payload;
};

var setMeasurementTemplateData = function setMeasurementTemplateData(state, payload) {
    state.props = payload.response;

    if (state.props.measurement_list.length === 0) {
        state.props.measurement_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* measurementListProps */]))];
    }

    state.props.measurement_list.forEach(function (element) {
        element.measurement_drop_down_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* measurementListProps */]))];
    });

    state.props.measurement_list = state.props.measurement_list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

var addNewMeasurementListItemRow = function addNewMeasurementListItemRow(state) {

    var sl_no = 0;
    state.props.measurement_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* measurementDropDownListProps */])));

    state.props.measurement_list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });

    setTimeout(function () {
        document.getElementById('measurement_name_' + (sl_no - 1)).focus();
    }, 300);
};

var removeMeasurementListItemRow = function removeMeasurementListItemRow(state, payload) {

    var sl_no = 0;

    state.props.deleted_measurement_list_items.push(state.props.measurement_list[payload]);

    state.props.measurement_list.splice(payload, 1);

    if (state.props.measurement_list.length === 0) {
        state.props.measurement_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* measurementListProps */]))];
    }

    state.props.measurement_list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });
};

var sortMeasurementTemplateList = function sortMeasurementTemplateList(state, payload) {

    var key = payload.sl_no;

    if (payload.sort == 1) {
        state.props.measurement_list[key].sl_no = payload.sl_no + 1;
        state.props.measurement_list[key + 1].sl_no = payload.sl_no;
    } else if (payload.sort == 0) {
        state.props.measurement_list[key].sl_no = payload.sl_no - 1;
        state.props.measurement_list[key - 1].sl_no = payload.sl_no;
    }

    state.props.measurement_list = state.props.measurement_list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

var addNewMeasurementListDropDownItemRow = function addNewMeasurementListDropDownItemRow(state, parent_key) {

    var key = 0;
    state.props.measurement_list[parent_key].measurement_drop_down_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* measurementDropDownListProps */])));

    state.props.measurement_list[parent_key].measurement_drop_down_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        //document.getElementById('measurement_value_'+(key-1)).focus()
    }, 300);
};

var removeMeasurementListDropDownItemRow = function removeMeasurementListDropDownItemRow(state, payload) {

    var key = 0;

    state.props.measurement_list[payload.parent_key].deleted_measurement_drop_down_list_items.push(state.props.measurement_list[payload.parent_key].measurement_drop_down_list[payload.key]);

    state.props.measurement_list[payload.parent_key].measurement_drop_down_list.splice(payload.key, 1);

    if (state.props.measurement_list[payload.parent_key].measurement_drop_down_list.length === 0) {
        state.props.measurement_list[payload.parent_key].measurement_drop_down_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* measurementDropDownListProps */]))];
    }

    state.props.measurement_list[payload.parent_key].measurement_drop_down_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetMeasurementTemplateData = function resetMeasurementTemplateData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMeasurementTemplateList", function() { return getMeasurementTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMeasurementTemplateDataProps", function() { return getMeasurementTemplateDataProps; });
var getMeasurementTemplateList = function getMeasurementTemplateList(state) {
    return state.list;
};

var getMeasurementTemplateDataProps = function getMeasurementTemplateDataProps(state) {
    return state.props;
};

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productionStage_actions__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productionStage_mutations__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productionStage_getters__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__productionStage_properties__ = __webpack_require__(323);






var state = {
    list: [],
    all_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__productionStage_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__productionStage_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__productionStage_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__productionStage_actions__
});

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionStageList", function() { return fetchProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllProductionStageList", function() { return fetchAllProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAllProductionStageListWithSubProcess", function() { return fetchAllProductionStageListWithSubProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionStageData", function() { return fetchProductionStageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitProductionStageData", function() { return submitProductionStageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProductionStageData", function() { return deleteProductionStageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProductionStageSlNoData", function() { return updateProductionStageSlNoData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchProductionStageList = function fetchProductionStageList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/productionStage/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionStageList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchAllProductionStageList = function fetchAllProductionStageList(_ref2) {
    var commit = _ref2.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/productionStage/allStages.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionStageAllList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchAllProductionStageListWithSubProcess = function fetchAllProductionStageListWithSubProcess(_ref3) {
    var commit = _ref3.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/productionStage/allStagesWithSubProcess.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionStageAllList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionStageData = function fetchProductionStageData(_ref4, payload) {
    var commit = _ref4.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionStage/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setProductionStageData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetProductionStageData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitProductionStageData = function submitProductionStageData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionStage/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchProductionStageData', { id: payload.id });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteProductionStageData = function deleteProductionStageData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionStage/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchProductionStageList', { type: payload.type });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateProductionStageSlNoData = function updateProductionStageSlNoData(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionStage/updateProductionStageSlNoData.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {}
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-1' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionStageList", function() { return setProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionStageAllList", function() { return setProductionStageAllList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionStageData", function() { return setProductionStageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewProductionOptionItemRow", function() { return addNewProductionOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProductionOptionItemRow", function() { return removeProductionOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewQualityPointItemRow_ProductionStage", function() { return addNewQualityPointItemRow_ProductionStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeQualityPointItemRow_ProductionStage", function() { return removeQualityPointItemRow_ProductionStage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortProductionStageList", function() { return sortProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewProductionSubProcessItemRow", function() { return addNewProductionSubProcessItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProductionSubProcessItemRow", function() { return removeProductionSubProcessItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionStageData", function() { return resetProductionStageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(323);


var setProductionStageList = function setProductionStageList(state, payload) {
    state.list = payload;
};

var setProductionStageAllList = function setProductionStageAllList(state, payload) {
    state.all_list = payload;
};

var setProductionStageData = function setProductionStageData(state, payload) {
    state.props = payload.response;

    if (state.props.option_list.length === 0) {
        state.props.option_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* optionProps */]))];
    } else if (payload.copy) {
        state.props.option_list.forEach(function (element) {
            element.id = 0;
        });
    }

    if (state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* qualityItemProps */]))];
    } else if (payload.copy) {
        state.props.quality_point_list.forEach(function (element) {
            element.id = 0;
        });
    }

    if (state.props.sub_process_list.length === 0) {
        state.props.sub_process_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* subProcessListProps */]))];
    } else if (payload.copy) {
        state.props.sub_process_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.option_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    key = 0;
    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    key = 0;
    state.props.sub_process_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewProductionOptionItemRow = function addNewProductionOptionItemRow(state) {

    var key = 0;
    state.props.option_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* optionProps */])));

    state.props.option_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('option_name_' + (key - 1)).focus();
    }, 300);
};

var removeProductionOptionItemRow = function removeProductionOptionItemRow(state, payload) {

    var key = 0;

    state.props.deleted_option_list_items.push(state.props.option_list[payload]);

    state.props.option_list.splice(payload, 1);

    if (state.props.option_list.length === 0) {
        state.props.option_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* optionProps */]))];
    }

    state.props.option_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewQualityPointItemRow_ProductionStage = function addNewQualityPointItemRow_ProductionStage(state) {

    var key = 0;
    state.props.quality_point_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* qualityItemProps */])));

    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('quality_point_' + (key - 1)).focus();
    }, 300);
};

var removeQualityPointItemRow_ProductionStage = function removeQualityPointItemRow_ProductionStage(state, payload) {

    var key = 0;

    state.props.deleted_quality_point_list_items.push(state.props.quality_point_list[payload]);

    state.props.quality_point_list.splice(payload, 1);

    if (state.props.quality_point_list.length === 0) {
        state.props.quality_point_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* qualityItemProps */]))];
    }

    state.props.quality_point_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var sortProductionStageList = function sortProductionStageList(state, payload) {

    var key = payload.sl_no;

    if (payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no + 1;
        state.list[key + 1].sl_no = payload.sl_no;
    } else if (payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no - 1;
        state.list[key - 1].sl_no = payload.sl_no;
    }

    state.list = state.list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

var addNewProductionSubProcessItemRow = function addNewProductionSubProcessItemRow(state) {

    var key = 0;
    state.props.sub_process_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* subProcessListProps */])));

    state.props.sub_process_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeProductionSubProcessItemRow = function removeProductionSubProcessItemRow(state, payload) {

    var key = 0;

    state.props.delete_sub_process_list_items.push(state.props.sub_process_list[payload]);

    state.props.sub_process_list.splice(payload, 1);

    if (state.props.sub_process_list.length === 0) {
        state.props.sub_process_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* subProcessListProps */]))];
    }

    state.props.sub_process_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetProductionStageData = function resetProductionStageData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionStageList", function() { return getProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionStageDataProps", function() { return getProductionStageDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionStageAllList", function() { return getProductionStageAllList; });
var getProductionStageList = function getProductionStageList(state) {
    return state.list;
};

var getProductionStageDataProps = function getProductionStageDataProps(state) {
    return state.props;
};

var getProductionStageAllList = function getProductionStageAllList(state) {
    return state.all_list;
};

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tailoringMaster_actions__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tailoringMaster_mutations__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tailoringMaster_getters__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tailoringMaster_properties__ = __webpack_require__(324);






var state = {
    list: [],
    nav: {
        page_number: 1,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: [],
        search_type: 0,
        had_results: false
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__tailoringMaster_properties__["d" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__tailoringMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__tailoringMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__tailoringMaster_actions__
});

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringMasterList", function() { return fetchTailoringMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringMasterAutocompleteList", function() { return fetchTailoringMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringItemSubCategoryBased", function() { return fetchTailoringItemSubCategoryBased; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringMasterData", function() { return fetchTailoringMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTailoringMasterData", function() { return submitTailoringMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTailoringMasterData", function() { return deleteTailoringMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchTailoringMasterList = function fetchTailoringMasterList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.try_again) {
            dispatch('fetchTailoringMasterList', payload);
        } else {
            commit('setTailoringMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTailoringMasterAutocompleteList = function fetchTailoringMasterAutocompleteList(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleInventoryMasterLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/autocomplete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (payload.sales_form_request) {
            if (res.data.response.length > 0) {
                commit('setItemAutocompleteList', res.data.response);
            } else {
                dispatch('fetchInventoryMasterAutocompleteList', payload.inventoryPayload);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleInventoryMasterLoadingState', false);
    });
};

var fetchTailoringItemSubCategoryBased = function fetchTailoringItemSubCategoryBased(_ref3, payload) {
    var commit = _ref3.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/fetchTailoringItemSubCategoryBased.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTailoringMasterList', { response: res.data.response });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTailoringMasterData = function fetchTailoringMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (res.data.response.auto_complete_list.length > 0) {
                commit('setItemAutocompleteList', res.data.response.auto_complete_list);
            }

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setTailoringMasterData', { response: res.data.response, copy: payload.copy });
            if (res.data.response.category_id > 0) {
                dispatch('fetchItemCategoryData', { id: res.data.response.category_id });
            }

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTailoringMasterData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-Tailoring' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTailoringMasterData = function submitTailoringMasterData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);
    if (payload.id > 0) {
        setTimeout(function () {
            commit('displayMessageAlert', { message: payload.template_name.trim() + "'s template is submitted, it may take a couple of mins for the update!!!", type: 'Success' });
            commit('toggleLoadingState', false);
        }, 2000);
    }
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            //dispatch('fetchTailoringMasterData', { id: payload.id, copy: false, navigate: false })
            commit('displaySuccessNotification', { message: 'Tailoring template saved successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var deleteTailoringMasterData = function deleteTailoringMasterData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTailoringMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringMasterList", function() { return setTailoringMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringMasterData", function() { return setTailoringMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterCombinationItemRow", function() { return addNewTailoringMasterCombinationItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterCombinationItemRow", function() { return removeTailoringMasterCombinationItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterEStoreVariationRow", function() { return addNewTailoringMasterEStoreVariationRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterEStoreVariationRow", function() { return removeTailoringMasterEStoreVariationRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterImageRow", function() { return addNewTailoringMasterImageRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterImageRow", function() { return removeTailoringMasterImageRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterStyleChoiceRow", function() { return addNewTailoringMasterStyleChoiceRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterStyleChoiceRow", function() { return removeTailoringMasterStyleChoiceRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewStyleChoiceListOptionItemRow", function() { return addNewStyleChoiceListOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeStyleChoiceListOptionItemRow", function() { return removeStyleChoiceListOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterCustomChoiceRow", function() { return addNewTailoringMasterCustomChoiceRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterCustomChoiceRow", function() { return removeTailoringMasterCustomChoiceRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewCustomChoiceListOptionItemRow", function() { return addNewCustomChoiceListOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCustomChoiceListOptionItemRow", function() { return removeCustomChoiceListOptionItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTailoringMasterFabricConsumptionRow", function() { return addNewTailoringMasterFabricConsumptionRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTailoringMasterFabricConsumptionRow", function() { return removeTailoringMasterFabricConsumptionRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortStyleTemplateList", function() { return sortStyleTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTailoringMasterData", function() { return resetTailoringMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(324);


var setTailoringMasterList = function setTailoringMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setTailoringMasterData = function setTailoringMasterData(state, payload) {

    state.props = payload.response;

    if (payload.copy) {
        state.props.image_list.forEach(function (element) {
            element.id = 0;
        });
        state.props.combination_item_list.forEach(function (element) {
            // element.id = 0
        });
        state.props.style_choice_list.forEach(function (element) {
            element.id = 0;
            element.option_list.forEach(function (element1) {
                element1.id = 0;
            });
        });
        state.props.custom_choice_list.forEach(function (element) {
            element.id = 0;
        });
    } else {

        if (state.props.custom_choice_list === null || state.props.custom_choice_list.length === 0) {
            state.props.custom_choice_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* customChoiceListProps */]))];
        }

        if (state.props.estore_variation_list === null || state.props.estore_variation_list.length === 0) {
            state.props.estore_variation_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* estoreVariationProps */]))];
            state.props.estore_variation_list.forEach(function (element) {
                if (element.image_list.length === 0) {
                    element.image_list.push("");
                }
            });
        } else {
            state.props.estore_variation_list.forEach(function (element) {
                if (element.image_list.length === 0) {
                    element.image_list.push("");
                }
            });
        }
    }

    var key = 0;
    state.props.custom_choice_list.forEach(function (el) {
        el.key = key;
        key++;
    });
};

// COMBINATION PROPS //
var addNewTailoringMasterCombinationItemRow = function addNewTailoringMasterCombinationItemRow(state) {

    var key = 0;
    state.props.combination_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* comboProductListProps */])));

    state.props.combination_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeTailoringMasterCombinationItemRow = function removeTailoringMasterCombinationItemRow(state, payload) {

    var key = 0;

    state.props.delete_combination_item_list.push(state.props.combination_item_list[payload]);

    state.props.combination_item_list.splice(payload, 1);

    if (state.props.combination_item_list.length === 0) {
        state.props.combination_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* comboProductListProps */]))];
    }

    state.props.combination_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //
var addNewTailoringMasterEStoreVariationRow = function addNewTailoringMasterEStoreVariationRow(state) {

    var key = 0;
    state.props.estore_variation_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* estoreVariationProps */])));

    state.props.estore_variation_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    state.props.estore_variation_list.forEach(function (element) {
        if (element.image_list.length === 0) {
            element.image_list.push("");
        }
    });
};

var removeTailoringMasterEStoreVariationRow = function removeTailoringMasterEStoreVariationRow(state, payload) {

    var key = 0;

    state.props.estore_variation_list.splice(payload, 1);

    if (state.props.estore_variation_list.length === 0) {
        state.props.estore_variation_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* estoreVariationProps */]))];
    }

    state.props.estore_variation_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// IMAGE PROPS //
var addNewTailoringMasterImageRow = function addNewTailoringMasterImageRow(state) {

    var key = 0;
    state.props.image_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* imageListProps */])));

    state.props.image_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeTailoringMasterImageRow = function removeTailoringMasterImageRow(state, payload) {

    var key = 0;

    state.props.delete_image_list.push(state.props.image_list[payload]);

    state.props.image_list.splice(payload, 1);

    if (state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* imageListProps */]))];
    }

    state.props.image_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //

//STYLE CHOICES//
var addNewTailoringMasterStyleChoiceRow = function addNewTailoringMasterStyleChoiceRow(state) {

    var key = 0;
    state.props.style_choice_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* styleChoiceListProps */])));

    state.props.style_choice_list.forEach(function (element) {
        element.key = key;
        element.sl_no = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('style_name_' + (key - 1)).focus();
    }, 300);
};

var removeTailoringMasterStyleChoiceRow = function removeTailoringMasterStyleChoiceRow(state, payload) {

    var key = 0;

    state.props.delete_style_choice_list.push(state.props.style_choice_list[payload]);

    state.props.style_choice_list.splice(payload, 1);

    if (state.props.style_choice_list.length === 0) {
        state.props.style_choice_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* styleChoiceListProps */]))];
    }

    state.props.style_choice_list.forEach(function (element) {
        element.key = key;
        element.sl_no = key;
        key++;
    });
};
var addNewStyleChoiceListOptionItemRow = function addNewStyleChoiceListOptionItemRow(state, parent_key) {

    var key = 0;
    state.props.style_choice_list[parent_key].option_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["i" /* styleChoiceOptionListProps */])));

    state.props.style_choice_list[parent_key].option_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('style_option_' + (key - 1)).focus();
    }, 300);
};

var removeStyleChoiceListOptionItemRow = function removeStyleChoiceListOptionItemRow(state, payload) {

    var key = 0;

    state.props.style_choice_list[payload.parent_key].delete_option_list.push(state.props.style_choice_list[payload.parent_key].option_list[payload.key]);

    state.props.style_choice_list[payload.parent_key].option_list.splice(payload.key, 1);

    if (state.props.style_choice_list[payload.parent_key].option_list.length === 0) {
        state.props.style_choice_list[payload.parent_key].option_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["i" /* styleChoiceOptionListProps */]))];
    }

    state.props.style_choice_list[payload.parent_key].option_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //

//CUSTOM CHOICES//
var addNewTailoringMasterCustomChoiceRow = function addNewTailoringMasterCustomChoiceRow(state) {

    var key = 0;
    state.props.custom_choice_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* customChoiceListProps */])));

    state.props.custom_choice_list.forEach(function (element) {
        element.key = key;
        element.sl_no = key;
        key++;
    });
};

var removeTailoringMasterCustomChoiceRow = function removeTailoringMasterCustomChoiceRow(state, payload) {

    var key = 0;

    state.props.delete_custom_choice_list.push(state.props.custom_choice_list[payload]);

    state.props.custom_choice_list.splice(payload, 1);

    if (state.props.custom_choice_list.length === 0) {
        state.props.custom_choice_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* customChoiceListProps */]))];
    }

    state.props.custom_choice_list.forEach(function (element) {
        element.key = key;
        element.sl_no = key;
        key++;
    });
};
var addNewCustomChoiceListOptionItemRow = function addNewCustomChoiceListOptionItemRow(state, parent_key) {

    var key = 0;
    state.props.custom_choice_list[parent_key].style_options.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* customChoiceOptionListProps */])));

    state.props.custom_choice_list[parent_key].style_options.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeCustomChoiceListOptionItemRow = function removeCustomChoiceListOptionItemRow(state, payload) {

    var key = 0;

    state.props.custom_choice_list[payload.parent_key].style_options.splice(payload.key, 1);

    if (state.props.custom_choice_list[payload.parent_key].style_options.length === 0) {
        state.props.custom_choice_list[payload.parent_key].style_options = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* customChoiceOptionListProps */]))];
    }

    state.props.custom_choice_list[payload.parent_key].style_options.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //

// SIZE PROPS //
var addNewTailoringMasterFabricConsumptionRow = function addNewTailoringMasterFabricConsumptionRow(state) {

    var key = 0;
    state.props.fabric_consumption_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["f" /* fabricConsumptionProps */])));

    state.props.fabric_consumption_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('size_name_' + (key - 1)).focus();
    }, 300);
};

var removeTailoringMasterFabricConsumptionRow = function removeTailoringMasterFabricConsumptionRow(state, payload) {

    var key = 0;

    state.props.delete_fabric_consumption_list.push(state.props.fabric_consumption_list[payload]);

    state.props.fabric_consumption_list.splice(payload, 1);

    if (state.props.fabric_consumption_list.length === 0) {
        state.props.fabric_consumption_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["f" /* fabricConsumptionProps */]))];
    }

    state.props.fabric_consumption_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //

var sortStyleTemplateList = function sortStyleTemplateList(state, payload) {

    var key = payload.sl_no;

    if (payload.sort == 1) {
        state.props.style_choice_list[key].sl_no = payload.sl_no + 1;
        state.props.style_choice_list[key + 1].sl_no = payload.sl_no;
    } else if (payload.sort == 0) {
        state.props.style_choice_list[key].sl_no = payload.sl_no - 1;
        state.props.style_choice_list[key - 1].sl_no = payload.sl_no;
    }

    state.props.style_choice_list = state.props.style_choice_list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

var resetTailoringMasterData = function resetTailoringMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* dataProps */]));
};

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringMasterList", function() { return getTailoringMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringMasterDataProps", function() { return getTailoringMasterDataProps; });
var getTailoringMasterList = function getTailoringMasterList(state) {
    return state.list;
};

var getTailoringMasterDataProps = function getTailoringMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__leaveMaster_actions__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__leaveMaster_mutations__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__leaveMaster_getters__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__leaveMaster_properties__ = __webpack_require__(325);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__leaveMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__leaveMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__leaveMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__leaveMaster_actions__
});

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLeaveMasterList", function() { return fetchLeaveMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLeaveMasterData", function() { return fetchLeaveMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitLeaveMasterData", function() { return submitLeaveMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteLeaveMasterData", function() { return deleteLeaveMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchLeaveMasterList = function fetchLeaveMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/leaveMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setLeaveMasterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchLeaveMasterData = function fetchLeaveMasterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setLeaveMasterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetLeaveMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitLeaveMasterData = function submitLeaveMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteLeaveMasterData = function deleteLeaveMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchLeaveMasterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLeaveMasterList", function() { return setLeaveMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLeaveMasterData", function() { return setLeaveMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetLeaveMasterData", function() { return resetLeaveMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(325);


var setLeaveMasterList = function setLeaveMasterList(state, payload) {
    state.list = payload;
};

var setLeaveMasterData = function setLeaveMasterData(state, payload) {
    state.props = payload;
};

var resetLeaveMasterData = function resetLeaveMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeaveMasterList", function() { return getLeaveMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeaveMasterDataProps", function() { return getLeaveMasterDataProps; });
var getLeaveMasterList = function getLeaveMasterList(state) {
    return state.list;
};

var getLeaveMasterDataProps = function getLeaveMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overtimeMaster_actions__ = __webpack_require__(1368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overtimeMaster_mutations__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overtimeMaster_getters__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__overtimeMaster_properties__ = __webpack_require__(326);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__overtimeMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__overtimeMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__overtimeMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__overtimeMaster_actions__
});

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOvertimeMasterList", function() { return fetchOvertimeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchOvertimeMasterData", function() { return fetchOvertimeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitOvertimeMasterData", function() { return submitOvertimeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteOvertimeMasterData", function() { return deleteOvertimeMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchOvertimeMasterList = function fetchOvertimeMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/overtimeMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setOvertimeMasterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchOvertimeMasterData = function fetchOvertimeMasterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/overtimeMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setOvertimeMasterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetOvertimeMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitOvertimeMasterData = function submitOvertimeMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/overtimeMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteOvertimeMasterData = function deleteOvertimeMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/overtimeMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchOvertimeMasterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOvertimeMasterList", function() { return setOvertimeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOvertimeMasterData", function() { return setOvertimeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetOvertimeMasterData", function() { return resetOvertimeMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(326);


var setOvertimeMasterList = function setOvertimeMasterList(state, payload) {
    state.list = payload;
};

var setOvertimeMasterData = function setOvertimeMasterData(state, payload) {
    state.props = payload;
};

var resetOvertimeMasterData = function resetOvertimeMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOvertimeMasterList", function() { return getOvertimeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOvertimeMasterDataProps", function() { return getOvertimeMasterDataProps; });
var getOvertimeMasterList = function getOvertimeMasterList(state) {
    return state.list;
};

var getOvertimeMasterDataProps = function getOvertimeMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__holidayMaster_actions__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__holidayMaster_mutations__ = __webpack_require__(1373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__holidayMaster_getters__ = __webpack_require__(1374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__holidayMaster_properties__ = __webpack_require__(327);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__holidayMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__holidayMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__holidayMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__holidayMaster_actions__
});

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHolidayMasterList", function() { return fetchHolidayMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHolidayMasterData", function() { return fetchHolidayMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitHolidayMasterData", function() { return submitHolidayMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteHolidayMasterData", function() { return deleteHolidayMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchHolidayMasterList = function fetchHolidayMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/holidayMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setHolidayMasterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchHolidayMasterData = function fetchHolidayMasterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/holidayMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setHolidayMasterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetHolidayMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitHolidayMasterData = function submitHolidayMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/holidayMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteHolidayMasterData = function deleteHolidayMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/holidayMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchHolidayMasterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHolidayMasterList", function() { return setHolidayMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHolidayMasterData", function() { return setHolidayMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetHolidayMasterData", function() { return resetHolidayMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(327);


var setHolidayMasterList = function setHolidayMasterList(state, payload) {
    state.list = payload;
};

var setHolidayMasterData = function setHolidayMasterData(state, payload) {
    state.props = payload;
};

var resetHolidayMasterData = function resetHolidayMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHolidayMasterList", function() { return getHolidayMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHolidayMasterDataProps", function() { return getHolidayMasterDataProps; });
var getHolidayMasterList = function getHolidayMasterList(state) {
    return state.list;
};

var getHolidayMasterDataProps = function getHolidayMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__designationMaster_actions__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__designationMaster_mutations__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__designationMaster_getters__ = __webpack_require__(1378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__designationMaster_properties__ = __webpack_require__(328);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__designationMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__designationMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__designationMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__designationMaster_actions__
});

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDesignationMasterList", function() { return fetchDesignationMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDesignationMasterData", function() { return fetchDesignationMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitDesignationMasterData", function() { return submitDesignationMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteDesignationMasterData", function() { return deleteDesignationMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchDesignationMasterList = function fetchDesignationMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/designationMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setDesignationMasterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchDesignationMasterData = function fetchDesignationMasterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/designationMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setDesignationMasterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetDesignationMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitDesignationMasterData = function submitDesignationMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/designationMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteDesignationMasterData = function deleteDesignationMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/designationMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchDesignationMasterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDesignationMasterList", function() { return setDesignationMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDesignationMasterData", function() { return setDesignationMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetDesignationMasterData", function() { return resetDesignationMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(328);


var setDesignationMasterList = function setDesignationMasterList(state, payload) {
    state.list = payload;
};

var setDesignationMasterData = function setDesignationMasterData(state, payload) {
    state.props = payload;
};

var resetDesignationMasterData = function resetDesignationMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDesignationMasterList", function() { return getDesignationMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDesignationMasterDataProps", function() { return getDesignationMasterDataProps; });
var getDesignationMasterList = function getDesignationMasterList(state) {
    return state.list;
};

var getDesignationMasterDataProps = function getDesignationMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__employee_actions__ = __webpack_require__(1380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__employee_mutations__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__employee_getters__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employee_properties__ = __webpack_require__(329);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'staff_name',
        sort_direction: 0, search_term: '',
        search_term_array: []
    },
    allocated_production_stage: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__employee_properties__["a" /* dataProps */])),
    statement: {
        date_range: ['', ''],
        list: []
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__employee_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__employee_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__employee_actions__
});

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeeMasterList", function() { return fetchEmployeeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadEmployeeStatement", function() { return loadEmployeeStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeeProductionStageList", function() { return fetchEmployeeProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWorkOrderEmployeeList", function() { return fetchWorkOrderEmployeeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeeMasterData", function() { return fetchEmployeeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEmployeeMasterData", function() { return submitEmployeeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateNewPassword", function() { return generateNewPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEmployeeMasterData", function() { return deleteEmployeeMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEmployeeMasterList = function fetchEmployeeMasterList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            commit('setEmployeeMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var loadEmployeeStatement = function loadEmployeeStatement(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/statement.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEmployeeStatement', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEmployeeProductionStageList = function fetchEmployeeProductionStageList(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/fetchAllocatedProductionStage.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEmployeeProductionStageList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchWorkOrderEmployeeList = function fetchWorkOrderEmployeeList(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/workOrderEmployeeList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEmployeeMasterList', { response: res.data.response, total: 0 });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEmployeeMasterData = function fetchEmployeeMasterData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEmployeeMasterData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { employee_id: payload.id, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEmployeeMasterData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEmployeeMasterData = function submitEmployeeMasterData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('fetchEmployeeMasterData', { id: payload.id });
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var generateNewPassword = function generateNewPassword(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/generateNewPassword.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Password generated successfully!!!' });
            commit('setEmployeeMasterUserPassword', res.data.password);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEmployeeMasterData = function deleteEmployeeMasterData(_ref8, payload) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEmployeeMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeMasterList", function() { return setEmployeeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeStatement", function() { return setEmployeeStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeMasterData", function() { return setEmployeeMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewEmployeeMasterOvertimeListRow", function() { return addNewEmployeeMasterOvertimeListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmployeeMasterOvertimeListRow", function() { return removeEmployeeMasterOvertimeListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewEmployeeMasterProductionPieceRateListRow", function() { return addNewEmployeeMasterProductionPieceRateListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmployeeMasterProductionPieceRateListRow", function() { return removeEmployeeMasterProductionPieceRateListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeMasterUserPassword", function() { return setEmployeeMasterUserPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeProductionStageList", function() { return setEmployeeProductionStageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEmployeeMasterData", function() { return resetEmployeeMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(329);


var setEmployeeMasterList = function setEmployeeMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setEmployeeStatement = function setEmployeeStatement(state, payload) {
    state.statement.list = payload;
};

var setEmployeeMasterData = function setEmployeeMasterData(state, payload) {
    state.props = payload.response;

    if (state.props.overtime_list.length === 0) {
        state.props.overtime_list = [];
    } else if (payload.copy) {
        state.props.overtime_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.overtime_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    if (state.props.production_piece_rate_list.length === 0) {
        state.props.production_piece_rate_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* productionPieceRateListProps */]))];
    } else if (payload.copy) {
        state.props.production_piece_rate_list.forEach(function (element) {
            element.id = 0;
        });
    }

    key = 0;
    state.props.production_piece_rate_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewEmployeeMasterOvertimeListRow = function addNewEmployeeMasterOvertimeListRow(state) {

    var key = 0;
    state.props.overtime_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* overtimeListProps */])));

    state.props.overtime_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('overtime_id_' + (key - 1)).focus();
    }, 300);
};

var removeEmployeeMasterOvertimeListRow = function removeEmployeeMasterOvertimeListRow(state, payload) {

    var key = 0;

    state.props.deleted_overtime_list.push(state.props.overtime_list[payload]);

    state.props.overtime_list.splice(payload, 1);

    if (state.props.overtime_list.length === 0) {
        state.props.overtime_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* overtimeListProps */]))];
    }

    state.props.overtime_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewEmployeeMasterProductionPieceRateListRow = function addNewEmployeeMasterProductionPieceRateListRow(state) {

    var key = 0;
    state.props.production_piece_rate_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* productionPieceRateListProps */])));

    state.props.production_piece_rate_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('category_id_' + (key - 1)).focus();
    }, 300);
};

var removeEmployeeMasterProductionPieceRateListRow = function removeEmployeeMasterProductionPieceRateListRow(state, payload) {

    var key = 0;

    state.props.deleted_production_piece_rate_list.push(state.props.production_piece_rate_list[payload]);

    state.props.production_piece_rate_list.splice(payload, 1);

    if (state.props.production_piece_rate_list.length === 0) {
        state.props.production_piece_rate_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* productionPieceRateListProps */]))];
    }

    state.props.production_piece_rate_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setEmployeeMasterUserPassword = function setEmployeeMasterUserPassword(state, payload) {
    state.props.user_password = payload;
};

var setEmployeeProductionStageList = function setEmployeeProductionStageList(state, payload) {
    state.allocated_production_stage = payload;
};

var resetEmployeeMasterData = function resetEmployeeMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeMasterList", function() { return getEmployeeMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeMasterDataProps", function() { return getEmployeeMasterDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeProductionStageList", function() { return getEmployeeProductionStageList; });
var getEmployeeMasterList = function getEmployeeMasterList(state) {
    return state.list;
};

var getEmployeeMasterDataProps = function getEmployeeMasterDataProps(state) {
    return state.props;
};

var getEmployeeProductionStageList = function getEmployeeProductionStageList(state) {
    return state.allocated_production_stage;
};

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__genericContact_actions__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__genericContact_mutations__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__genericContact_getters__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__genericContact_properties__ = __webpack_require__(330);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__genericContact_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__genericContact_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__genericContact_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__genericContact_actions__
});

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGenericContactList", function() { return fetchGenericContactList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGenericContactData", function() { return fetchGenericContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitGenericContactData", function() { return submitGenericContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteGenericContactData", function() { return deleteGenericContactData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchGenericContactList = function fetchGenericContactList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        commit('toggleLoadingState', false);
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/genericContact/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchGenericContactList', payload);
            } else {
                commit('setGenericContactList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchGenericContactData = function fetchGenericContactData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/genericContact/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setGenericContactData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { contact_id: payload.id, copy: payload.copy });

            dispatch('loadProvinceList', res.data.response.country_id);
            dispatch('loadCityList', res.data.response.province_id);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetGenericContactData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitGenericContactData = function submitGenericContactData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/genericContact/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteGenericContactData = function deleteGenericContactData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/genericContact/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchGenericContactList', { store_list: payload.store_list });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGenericContactList", function() { return setGenericContactList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGenericContactData", function() { return setGenericContactData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetGenericContactData", function() { return resetGenericContactData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(330);


var setGenericContactList = function setGenericContactList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setGenericContactData = function setGenericContactData(state, payload) {
    state.props = payload.response;
};

var resetGenericContactData = function resetGenericContactData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGenericContactList", function() { return getGenericContactList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGenericContactDataProps", function() { return getGenericContactDataProps; });
var getGenericContactList = function getGenericContactList(state) {
    return state.list;
};

var getGenericContactDataProps = function getGenericContactDataProps(state) {
    return state.props;
};

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__teamList_actions__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__teamList_mutations__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__teamList_getters__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamList_properties__ = __webpack_require__(331);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__teamList_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__teamList_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__teamList_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__teamList_actions__
});

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTeamList", function() { return fetchTeamList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTeamData", function() { return fetchTeamData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTeamData", function() { return submitTeamData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTeamData", function() { return deleteTeamData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTeamList = function fetchTeamList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamList/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchTeamList', payload);
            } else {
                commit('setTeamList', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchTeamData = function fetchTeamData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamList/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setTeamData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTeamData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTeamData = function submitTeamData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamList/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTeamData = function deleteTeamData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/teamList/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTeamList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTeamList", function() { return setTeamList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTeamData", function() { return setTeamData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTeamListItemRow", function() { return addNewTeamListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTeamListItemRow", function() { return removeTeamListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTeamData", function() { return resetTeamData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(331);


var setTeamList = function setTeamList(state, payload) {
    state.list = payload;
};

var setTeamData = function setTeamData(state, payload) {
    state.props = payload.response;

    if (state.props.team_list.length === 0) {
        state.props.team_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* teamListProps */]))];
    } else {
        if (payload.copy) {
            state.props.team_list.forEach(function (element) {
                element.id = 0;
            });
        }
    }
};

var addNewTeamListItemRow = function addNewTeamListItemRow(state) {

    var key = 0;
    state.props.team_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* teamListProps */])));

    state.props.team_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('team_name_' + (key - 1)).focus();
    }, 300);
};

var removeTeamListItemRow = function removeTeamListItemRow(state, payload) {

    var key = 0;

    state.props.deleted_team_list_items.push(state.props[payload]);

    state.props.team_list.splice(payload, 1);

    if (state.props.team_list.length === 0) {
        state.props.team_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* teamListProps */]))];
    }

    state.props.team_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetTeamData = function resetTeamData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeamList", function() { return getTeamList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTeamDataProps", function() { return getTeamDataProps; });
var getTeamList = function getTeamList(state) {
    return state.list;
};

var getTeamDataProps = function getTeamDataProps(state) {
    return state.props;
};

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__leaveApplication_actions__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__leaveApplication_mutations__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__leaveApplication_getters__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__leaveApplication_properties__ = __webpack_require__(332);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__leaveApplication_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__leaveApplication_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__leaveApplication_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__leaveApplication_actions__
});

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLeaveApplicationList", function() { return fetchLeaveApplicationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLeaveApplicationData", function() { return fetchLeaveApplicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitLeaveApplicationData", function() { return submitLeaveApplicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteLeaveApplicationData", function() { return deleteLeaveApplicationData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchLeaveApplicationList = function fetchLeaveApplicationList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveApplication/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchLeaveApplicationList', payload);
            } else {
                commit('setLeaveApplicationList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchLeaveApplicationData = function fetchLeaveApplicationData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveApplication/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setLeaveApplicationData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetLeaveApplicationData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitLeaveApplicationData = function submitLeaveApplicationData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveApplication/save.php', payload.data, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteLeaveApplicationData = function deleteLeaveApplicationData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/leaveApplication/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchLeaveApplicationList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLeaveApplicationList", function() { return setLeaveApplicationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLeaveApplicationData", function() { return setLeaveApplicationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetLeaveApplicationData", function() { return resetLeaveApplicationData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(332);


var setLeaveApplicationList = function setLeaveApplicationList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setLeaveApplicationData = function setLeaveApplicationData(state, payload) {
    state.props = payload;
};

var resetLeaveApplicationData = function resetLeaveApplicationData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeaveApplicationList", function() { return getLeaveApplicationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLeaveApplicationDataProps", function() { return getLeaveApplicationDataProps; });
var getLeaveApplicationList = function getLeaveApplicationList(state) {
    return state.list;
};

var getLeaveApplicationDataProps = function getLeaveApplicationDataProps(state) {
    return state.props;
};

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__attendanceEntry_actions__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__attendanceEntry_mutations__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__attendanceEntry_getters__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__attendanceEntry_properties__ = __webpack_require__(333);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'entry_date',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__attendanceEntry_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__attendanceEntry_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__attendanceEntry_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__attendanceEntry_actions__
});

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAttendanceEntryList", function() { return fetchAttendanceEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAttendanceEntryData", function() { return fetchAttendanceEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitAttendanceEntryData", function() { return submitAttendanceEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateAttendance", function() { return updateAttendance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchAttendanceEntryList = function fetchAttendanceEntryList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/attendanceEntry/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchAttendanceEntryList', payload);
            } else {
                commit('setAttendanceEntryList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchAttendanceEntryData = function fetchAttendanceEntryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/attendanceEntry/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setAttendanceEntryData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetAttendanceEntryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitAttendanceEntryData = function submitAttendanceEntryData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/attendanceEntry/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchAttendanceEntryData', {
                entry_date: payload.entry_date,
                store_id: payload.store_id
            });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateAttendance = function updateAttendance(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/attendanceEntry/saveFromPayroll.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });

            if (payload.payroll_id === 0 && payload.payroll_status) {
                dispatch('loadFreshPayrollInformation', {
                    staff_id: payload.staff_id,
                    payroll_period: payload.payroll_period
                });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttendanceEntryList", function() { return setAttendanceEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttendanceEntryData", function() { return setAttendanceEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetAttendanceEntryData", function() { return resetAttendanceEntryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(333);


var setAttendanceEntryList = function setAttendanceEntryList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setAttendanceEntryData = function setAttendanceEntryData(state, payload) {
    state.props = payload.response;
};

var resetAttendanceEntryData = function resetAttendanceEntryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttendanceEntryList", function() { return getAttendanceEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttendanceEntryDataProps", function() { return getAttendanceEntryDataProps; });
var getAttendanceEntryList = function getAttendanceEntryList(state) {
    return state.list;
};

var getAttendanceEntryDataProps = function getAttendanceEntryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bankMaster_actions__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bankMaster_mutations__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bankMaster_getters__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bankMaster_properties__ = __webpack_require__(334);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__bankMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__bankMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__bankMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__bankMaster_actions__
});

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBankMasterList", function() { return fetchBankMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBankMasterData", function() { return fetchBankMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitBankMasterData", function() { return submitBankMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteBankMasterData", function() { return deleteBankMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchBankMasterList = function fetchBankMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/bankMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setBankMasterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchBankMasterData = function fetchBankMasterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setBankMasterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetBankMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitBankMasterData = function submitBankMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteBankMasterData = function deleteBankMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchBankMasterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBankMasterList", function() { return setBankMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBankMasterData", function() { return setBankMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetBankMasterData", function() { return resetBankMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(334);


var setBankMasterList = function setBankMasterList(state, payload) {
    state.list = payload;
};

var setBankMasterData = function setBankMasterData(state, payload) {
    state.props = payload;
};

var resetBankMasterData = function resetBankMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBankMasterList", function() { return getBankMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBankMasterDataProps", function() { return getBankMasterDataProps; });
var getBankMasterList = function getBankMasterList(state) {
    return state.list;
};

var getBankMasterDataProps = function getBankMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__paymentMode_actions__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__paymentMode_mutations__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paymentMode_getters__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paymentMode_properties__ = __webpack_require__(335);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__paymentMode_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__paymentMode_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__paymentMode_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__paymentMode_actions__
});

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPaymentModeList", function() { return fetchPaymentModeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPaymentModeData", function() { return fetchPaymentModeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitPaymentModeData", function() { return submitPaymentModeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deletePaymentModeData", function() { return deletePaymentModeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchPaymentModeList = function fetchPaymentModeList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/paymentMode/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setPaymentModeList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchPaymentModeData = function fetchPaymentModeData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/paymentMode/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setPaymentModeData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetPaymentModeData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitPaymentModeData = function submitPaymentModeData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/paymentMode/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deletePaymentModeData = function deletePaymentModeData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/paymentMode/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchPaymentModeList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPaymentModeList", function() { return setPaymentModeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPaymentModeData", function() { return setPaymentModeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPaymentModeData", function() { return resetPaymentModeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(335);


var setPaymentModeList = function setPaymentModeList(state, payload) {
    state.list = payload;
};

var setPaymentModeData = function setPaymentModeData(state, payload) {
    state.props = payload;
};

var resetPaymentModeData = function resetPaymentModeData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentModeList", function() { return getPaymentModeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPaymentModeDataProps", function() { return getPaymentModeDataProps; });
var getPaymentModeList = function getPaymentModeList(state) {
    return state.list;
};

var getPaymentModeDataProps = function getPaymentModeDataProps(state) {
    return state.props;
};

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__currencyExchange_actions__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__currencyExchange_mutations__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__currencyExchange_getters__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__currencyExchange_properties__ = __webpack_require__(336);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__currencyExchange_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__currencyExchange_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__currencyExchange_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__currencyExchange_actions__
});

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrencyExchangeList", function() { return fetchCurrencyExchangeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrencyExchangeData", function() { return fetchCurrencyExchangeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCurrencyExchangeData", function() { return submitCurrencyExchangeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCurrencyExchangeData", function() { return deleteCurrencyExchangeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchCurrencyExchangeList = function fetchCurrencyExchangeList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/currencyExchange/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCurrencyExchangeList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCurrencyExchangeData = function fetchCurrencyExchangeData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/currencyExchange/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setCurrencyExchangeData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetCurrencyExchangeData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCurrencyExchangeData = function submitCurrencyExchangeData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/currencyExchange/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCurrencyExchangeData = function deleteCurrencyExchangeData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/currencyExchange/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchCurrencyExchangeList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrencyExchangeList", function() { return setCurrencyExchangeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCurrencyExchangeData", function() { return setCurrencyExchangeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCurrencyExchangeData", function() { return resetCurrencyExchangeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(336);


var setCurrencyExchangeList = function setCurrencyExchangeList(state, payload) {
    state.list = payload;
};

var setCurrencyExchangeData = function setCurrencyExchangeData(state, payload) {
    state.props = payload;
};

var resetCurrencyExchangeData = function resetCurrencyExchangeData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrencyExchangeList", function() { return getCurrencyExchangeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrencyExchangeDataProps", function() { return getCurrencyExchangeDataProps; });
var getCurrencyExchangeList = function getCurrencyExchangeList(state) {
    return state.list;
};

var getCurrencyExchangeDataProps = function getCurrencyExchangeDataProps(state) {
    return state.props;
};

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expenseCategory_actions__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expenseCategory_mutations__ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expenseCategory_getters__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expenseCategory_properties__ = __webpack_require__(337);






var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'category_name',
        sort_direction: 0,
        search_term: '',
        search_term_array: [],
        show_all: false
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__expenseCategory_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__expenseCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__expenseCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__expenseCategory_actions__
});

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseCategoryList", function() { return fetchExpenseCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseSubCategoryList", function() { return fetchExpenseSubCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseCategoryData", function() { return fetchExpenseCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitExpenseCategoryData", function() { return submitExpenseCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteExpenseCategoryData", function() { return deleteExpenseCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchExpenseCategoryList = function fetchExpenseCategoryList(_ref, payload) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseCategory/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setExpenseCategoryList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchExpenseSubCategoryList = function fetchExpenseSubCategoryList(_ref2) {
    var commit = _ref2.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/expenseCategory/allSubCategory.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setExpenseCategoryList', { response: res.data.response, total: 0 });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchExpenseCategoryData = function fetchExpenseCategoryData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setExpenseCategoryData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetExpenseCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitExpenseCategoryData = function submitExpenseCategoryData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            //if(payload.id === 0) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            //}
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteExpenseCategoryData = function deleteExpenseCategoryData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchExpenseCategoryList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseCategoryList", function() { return setExpenseCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseCategoryData", function() { return setExpenseCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewExpenseSubCategoryItemRow", function() { return addNewExpenseSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeExpenseSubCategoryItemRow", function() { return removeExpenseSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetExpenseCategoryData", function() { return resetExpenseCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(337);


var setExpenseCategoryList = function setExpenseCategoryList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setExpenseCategoryData = function setExpenseCategoryData(state, payload) {
    state.props = payload.response;

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */]))];
    } else if (payload.copy) {
        state.props.sub_item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewExpenseSubCategoryItemRow = function addNewExpenseSubCategoryItemRow(state) {

    var key = 0;
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */])));

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('sub_category_name_' + (key - 1)).focus();
    }, 300);
};

var removeExpenseSubCategoryItemRow = function removeExpenseSubCategoryItemRow(state, payload) {

    var key = 0;

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload]);

    state.props.sub_item_list.splice(payload, 1);

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */]))];
    }

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetExpenseCategoryData = function resetExpenseCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseCategoryList", function() { return getExpenseCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseCategoryDataProps", function() { return getExpenseCategoryDataProps; });
var getExpenseCategoryList = function getExpenseCategoryList(state) {
    return state.list;
};

var getExpenseCategoryDataProps = function getExpenseCategoryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expenseJournal_actions__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expenseJournal_mutations__ = __webpack_require__(1417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expenseJournal_getters__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expenseJournal_properties__ = __webpack_require__(338);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.journal_date',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__expenseJournal_properties__["a" /* dataProps */])),
    export_expense: [],
    location_id: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__expenseJournal_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__expenseJournal_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__expenseJournal_actions__
});

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseJournalList", function() { return fetchExpenseJournalList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailExpenseJournalList", function() { return emailExpenseJournalList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseJournalData", function() { return fetchExpenseJournalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitExpenseJournalData", function() { return submitExpenseJournalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteExpenseJournalData", function() { return deleteExpenseJournalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareExpenseSheet", function() { return prepareExpenseSheet; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchExpenseJournalList = function fetchExpenseJournalList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseJournal/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchExpenseJournalList', payload);
            } else {
                commit('setExpenseJournalList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var emailExpenseJournalList = function emailExpenseJournalList(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseJournal/emailList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchExpenseJournalData = function fetchExpenseJournalData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseJournal/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setExpenseJournalData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { account_journal_id: payload.id, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetExpenseJournalData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitExpenseJournalData = function submitExpenseJournalData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseJournal/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.group_add) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteExpenseJournalData = function deleteExpenseJournalData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseJournal/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchExpenseJournalList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var prepareExpenseSheet = function prepareExpenseSheet(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/exportModule/expense/prepareSheet.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setExportExpenseData', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseJournalList", function() { return setExpenseJournalList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseJournalData", function() { return setExpenseJournalData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewExpenseJournalTaxListRow", function() { return addNewExpenseJournalTaxListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeExpenseJournalTaxListRow", function() { return removeExpenseJournalTaxListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExportExpenseData", function() { return setExportExpenseData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetExpenseJournalData", function() { return resetExpenseJournalData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(338);


var setExpenseJournalList = function setExpenseJournalList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setExpenseJournalData = function setExpenseJournalData(state, payload) {
    state.props = payload.response;

    if (state.props.tax_list.length === 0) {
        state.props.tax_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* taxListProps */]))];
    }
};

var addNewExpenseJournalTaxListRow = function addNewExpenseJournalTaxListRow(state) {

    var key = 0;
    state.props.tax_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* taxListProps */])));

    state.props.tax_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeExpenseJournalTaxListRow = function removeExpenseJournalTaxListRow(state, payload) {

    var key = 0;

    state.props.deleted_tax_list.push(state.props.tax_list[payload]);

    state.props.tax_list.splice(payload, 1);

    if (state.props.tax_list.length === 0) {
        state.props.tax_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* taxListProps */]))];
    }

    state.props.tax_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setExportExpenseData = function setExportExpenseData(state, payload) {
    state.export_expense = payload;
};

var resetExpenseJournalData = function resetExpenseJournalData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseJournalList", function() { return getExpenseJournalList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseJournalDataProps", function() { return getExpenseJournalDataProps; });
var getExpenseJournalList = function getExpenseJournalList(state) {
    return state.list;
};

var getExpenseJournalDataProps = function getExpenseJournalDataProps(state) {
    return state.props;
};

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__contraEntry_actions__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__contraEntry_mutations__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__contraEntry_getters__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contraEntry_properties__ = __webpack_require__(339);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: [],
        total_amount: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__contraEntry_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__contraEntry_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__contraEntry_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__contraEntry_actions__
});

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchContraEntryList", function() { return fetchContraEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchContraEntryData", function() { return fetchContraEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitContraEntryData", function() { return submitContraEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteContraEntryData", function() { return deleteContraEntryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchContraEntryList = function fetchContraEntryList(_ref, payload) {
    var commit = _ref.commit;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contraEntry/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            var _commit;

            commit('setContraEntryList', (_commit = { response: res.data.response, total: res.data.total, page_number: res.data.page_number }, _defineProperty(_commit, 'page_number', res.data.page_number), _defineProperty(_commit, 'total_amount', res.data.total_amount), _commit));
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchContraEntryData = function fetchContraEntryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contraEntry/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setContraEntryData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetContraEntryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitContraEntryData = function submitContraEntryData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contraEntry/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteContraEntryData = function deleteContraEntryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/contraEntry/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchContraEntryList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setContraEntryList", function() { return setContraEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setContraEntryData", function() { return setContraEntryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetContraEntryData", function() { return resetContraEntryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(339);


var setContraEntryList = function setContraEntryList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    state.nav.total_amount = payload.total_amount;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setContraEntryData = function setContraEntryData(state, payload) {
    state.props = payload;
};

var resetContraEntryData = function resetContraEntryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContraEntryList", function() { return getContraEntryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContraEntryDataProps", function() { return getContraEntryDataProps; });
var getContraEntryList = function getContraEntryList(state) {
    return state.list;
};

var getContraEntryDataProps = function getContraEntryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fabricPriceSlab_actions__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fabricPriceSlab_mutations__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fabricPriceSlab_getters__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fabricPriceSlab_properties__ = __webpack_require__(340);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__fabricPriceSlab_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__fabricPriceSlab_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__fabricPriceSlab_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__fabricPriceSlab_actions__
});

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFabricPriceSlabList", function() { return fetchFabricPriceSlabList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchFabricPriceSlabData", function() { return fetchFabricPriceSlabData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitFabricPriceSlabData", function() { return submitFabricPriceSlabData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteFabricPriceSlabData", function() { return deleteFabricPriceSlabData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchFabricPriceSlabList = function fetchFabricPriceSlabList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/fabricPriceSlab/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setFabricPriceSlabList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchFabricPriceSlabData = function fetchFabricPriceSlabData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/fabricPriceSlab/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setFabricPriceSlabData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetFabricPriceSlabData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitFabricPriceSlabData = function submitFabricPriceSlabData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/fabricPriceSlab/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteFabricPriceSlabData = function deleteFabricPriceSlabData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/fabricPriceSlab/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchFabricPriceSlabList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFabricPriceSlabList", function() { return setFabricPriceSlabList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFabricPriceSlabData", function() { return setFabricPriceSlabData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewFabricPriceSlabItemRow", function() { return addNewFabricPriceSlabItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFabricPriceSlabItemRow", function() { return removeFabricPriceSlabItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFabricPriceSlabData", function() { return resetFabricPriceSlabData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(340);


var setFabricPriceSlabList = function setFabricPriceSlabList(state, payload) {
    state.list = payload;
};

var setFabricPriceSlabData = function setFabricPriceSlabData(state, payload) {
    state.props = payload.response;

    if (state.props.price_category_list.length === 0) {
        state.props.price_category_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* priceItemProps */]))];
    } else if (payload.copy) {
        state.props.price_category_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.price_category_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewFabricPriceSlabItemRow = function addNewFabricPriceSlabItemRow(state) {

    var key = 0;
    state.props.price_category_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* priceItemProps */])));

    state.props.price_category_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('tailoring_item_sub_category_id' + (key - 1)).focus();
    }, 200);
};

var removeFabricPriceSlabItemRow = function removeFabricPriceSlabItemRow(state, payload) {

    var key = 0;

    state.props.price_category_list.splice(payload, 1);

    if (state.props.price_category_list.length === 0) {
        state.props.price_category_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* priceItemProps */]))];
    }

    state.props.price_category_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetFabricPriceSlabData = function resetFabricPriceSlabData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFabricPriceSlabList", function() { return getFabricPriceSlabList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFabricPriceSlabDataProps", function() { return getFabricPriceSlabDataProps; });
var getFabricPriceSlabList = function getFabricPriceSlabList(state) {
    return state.list;
};

var getFabricPriceSlabDataProps = function getFabricPriceSlabDataProps(state) {
    return state.props;
};

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryVariant_actions__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryVariant_mutations__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryVariant_getters__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryVariant_properties__ = __webpack_require__(341);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryVariant_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryVariant_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryVariant_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryVariant_actions__
});

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryVariantList", function() { return fetchInventoryVariantList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryVariantSubCategoryList", function() { return fetchInventoryVariantSubCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryVariantData", function() { return fetchInventoryVariantData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryVariantData", function() { return submitInventoryVariantData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryVariantData", function() { return deleteInventoryVariantData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchInventoryVariantList = function fetchInventoryVariantList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/inventoryVariant/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setInventoryVariantList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryVariantSubCategoryList = function fetchInventoryVariantSubCategoryList(_ref2) {
    var commit = _ref2.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/inventoryVariant/allSubCategory.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setInventoryVariantList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryVariantData = function fetchInventoryVariantData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryVariant/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setInventoryVariantData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryVariantData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryVariantData = function submitInventoryVariantData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryVariant/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryVariantData = function deleteInventoryVariantData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryVariant/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventoryVariantList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryVariantList", function() { return setInventoryVariantList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryVariantData", function() { return setInventoryVariantData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryVariantSubCategoryItemRow", function() { return addNewInventoryVariantSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryVariantSubCategoryItemRow", function() { return removeInventoryVariantSubCategoryItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryVariantData", function() { return resetInventoryVariantData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(341);


var setInventoryVariantList = function setInventoryVariantList(state, payload) {
    state.list = payload;
};

var setInventoryVariantData = function setInventoryVariantData(state, payload) {
    state.props = payload.response;

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */]))];
    } else if (payload.copy) {
        state.props.sub_item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryVariantSubCategoryItemRow = function addNewInventoryVariantSubCategoryItemRow(state) {

    var key = 0;
    state.props.sub_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */])));

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('sub_category_name_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryVariantSubCategoryItemRow = function removeInventoryVariantSubCategoryItemRow(state, payload) {

    var key = 0;

    state.props.deleted_sub_item_list_items.push(state.props.sub_item_list[payload]);

    state.props.sub_item_list.splice(payload, 1);

    if (state.props.sub_item_list.length === 0) {
        state.props.sub_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* subItemProps */]))];
    }

    state.props.sub_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetInventoryVariantData = function resetInventoryVariantData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryVariantList", function() { return getInventoryVariantList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryVariantDataProps", function() { return getInventoryVariantDataProps; });
var getInventoryVariantList = function getInventoryVariantList(state) {
    return state.list;
};

var getInventoryVariantDataProps = function getInventoryVariantDataProps(state) {
    return state.props;
};

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendorMaster_actions__ = __webpack_require__(1432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendorMaster_mutations__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendorMaster_getters__ = __webpack_require__(1434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendorMaster_properties__ = __webpack_require__(342);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'vendor_name',
        sort_direction: 0, search_term: '',
        search_term_array: []
    },
    autocomplete_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__vendorMaster_properties__["a" /* dataProps */])),
    statement: {
        date_range: ['', ''],
        list: []
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__vendorMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__vendorMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__vendorMaster_actions__
});

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchVendorMasterList", function() { return fetchVendorMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadVendorStatement", function() { return loadVendorStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchVendorMasterData", function() { return fetchVendorMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitVendorMasterData", function() { return submitVendorMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteVendorMasterData", function() { return deleteVendorMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchVendorMasterList = function fetchVendorMasterList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setVendorMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadVendorStatement = function loadVendorStatement(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorMaster/statement.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setVendorMasterStatementList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchVendorMasterData = function fetchVendorMasterData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setVendorMasterData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { vendor_id: payload.id, copy: payload.copy });

            dispatch('loadProvinceList', res.data.response.country_id);
            dispatch('loadCityList', res.data.response.province_id);
            commit('resetInventoryInvoiceOutstandingList');

            dispatch('fetchInventoryOrderList', { store_list: payload.store_list, vendor_id: payload.id });
            dispatch('fetchInventoryInvoiceList', { store_list: payload.store_list, vendor_id: payload.id });
            dispatch('fetchVendorPaymentList', { store_list: payload.store_list, vendor_id: payload.id });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetVendorMasterData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitVendorMasterData = function submitVendorMasterData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteVendorMasterData = function deleteVendorMasterData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchVendorMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVendorMasterList", function() { return setVendorMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVendorMasterData", function() { return setVendorMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewVendorMasterPaymentTermRow", function() { return addNewVendorMasterPaymentTermRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeVendorMasterPaymentTermRow", function() { return removeVendorMasterPaymentTermRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetVendorMasterData", function() { return resetVendorMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVendorMasterStatementList", function() { return setVendorMasterStatementList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(342);


var setVendorMasterList = function setVendorMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setVendorMasterData = function setVendorMasterData(state, payload) {
    state.props = payload.response;
    state.statement.list = [];
    if (payload.copy) {
        state.props.payment_term_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.payment_term_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewVendorMasterPaymentTermRow = function addNewVendorMasterPaymentTermRow(state) {

    var key = 0;
    state.props.payment_term_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* paymentTermListProps */])));

    state.props.payment_term_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('day_count_' + (key - 1)).focus();
    }, 300);
};

var removeVendorMasterPaymentTermRow = function removeVendorMasterPaymentTermRow(state, payload) {

    var key = 0;

    state.props.payment_term_list.splice(payload, 1);

    if (state.props.payment_term_list.length === 0) {
        state.props.payment_term_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* paymentTermListProps */]))];
    }

    state.props.payment_term_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetVendorMasterData = function resetVendorMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setVendorMasterStatementList = function setVendorMasterStatementList(state, payload) {
    state.statement.list = payload;
};

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVendorMasterList", function() { return getVendorMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVendorMasterDataProps", function() { return getVendorMasterDataProps; });
var getVendorMasterList = function getVendorMasterList(state) {
    return state.list;
};

var getVendorMasterDataProps = function getVendorMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryMaster_actions__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryMaster_mutations__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryMaster_getters__ = __webpack_require__(1438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryMaster_properties__ = __webpack_require__(343);






var state = {
    list: null,
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryMaster_properties__["a" /* dataProps */])),
    autocomplete_list: [],
    loading: false,
    statement: {
        date_range: ['', ''],
        store_id: null,
        list: []
    },
    import_inventory_discount: [],
    stock_list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryMaster_actions__
});

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryMasterList", function() { return fetchInventoryMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailInventoryList", function() { return emailInventoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryMasterAutocompleteList", function() { return fetchInventoryMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryMasterData", function() { return fetchInventoryMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryMasterData", function() { return submitInventoryMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryMasterData", function() { return deleteInventoryMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadInventoryStatement", function() { return loadInventoryStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareInventoryPriceSheet", function() { return prepareInventoryPriceSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitImportInventoryPriceData", function() { return submitImportInventoryPriceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSingleItemStock", function() { return fetchSingleItemStock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventoryMasterList = function fetchInventoryMasterList(_ref, payload) {
    var commit = _ref.commit;


    //console.log(JSON.stringify(payload))

    //commit('toggleLoadingState', true)
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setInventoryMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var emailInventoryList = function emailInventoryList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/emailInventoryList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryMasterAutocompleteList = function fetchInventoryMasterAutocompleteList(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleInventoryMasterLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/autocomplete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.sales_form_request) {
            commit('setItemAutocompleteList', res.data.response);
        } else {
            commit('setInventoryMasterAutocompleteList', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleInventoryMasterLoadingState', false);
    });
};

var fetchInventoryMasterData = function fetchInventoryMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (res.data.response.auto_complete_list.length > 0) {
                commit('setItemAutocompleteList', res.data.response.auto_complete_list);
            }
            if (res.data.response.auto_complete_list_inventory.length > 0) {
                commit('setInventoryMasterAutocompleteList', res.data.response.auto_complete_list_inventory);
            }
            if (payload.copy) {
                res.data.response.id = 0;
                res.data.response.sku_code = '';
                res.data.response.auto_generated_sku_code = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
                dispatch('fetchItemSubCategoryList', { type: res.data.item_type });
            }

            commit('setInventoryMasterData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryMasterData = function submitInventoryMasterData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.popup) {
                dispatch('fetchInventoryMasterData', { id: res.data.id });
            } else if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
            document.getElementById('sku_code').focus();
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryMasterData = function deleteInventoryMasterData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventoryMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadInventoryStatement = function loadInventoryStatement(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/statement.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setInventoryMasterStatementList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var prepareInventoryPriceSheet = function prepareInventoryPriceSheet(_ref8, payload) {
    var commit = _ref8.commit;


    commit('toggleLoadingState', true);

    if (payload.source == 'stock_check_source') {
        setTimeout(function () {
            commit('toggleLoadingState', false);
            commit('displayMessageAlert', { message: 'The sheet may take some time to get uploaded and process. We will email you once processed.', type: 'Info' });
        }, 2000);
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/exportModule/inventory/prepareSheet.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            if (payload.source) {
                if (payload.source == 'ibt') {
                    commit('setInventoryIntraBranchItemListRow', res.data.response);
                    setTimeout(function () {
                        commit('toggleLoadingState', false);
                    }, 2000);
                } else if (payload.source == 'external_source') {
                    commit('setInventorySourcingItemListRow', res.data.response);
                    setTimeout(function () {
                        commit('toggleLoadingState', false);
                    }, 2000);
                } else if (payload.source == 'stock_check_source') {
                    commit('setInventoryStockCheckItemListRow', res.data.response);
                }
            } else {
                commit('setImportInventoryDiscountData', res.data.response);
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
            commit('toggleLoadingState', false);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var submitImportInventoryPriceData = function submitImportInventoryPriceData(_ref9, payload) {
    var commit = _ref9.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/exportModule/inventory/submitData.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        commit('resetImportInventoryDiscountData', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSingleItemStock = function fetchSingleItemStock(_ref10, payload) {
    var commit = _ref10.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryMaster/fetchSingleItemStock.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setItemStockCheckList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryMasterList", function() { return setInventoryMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryMasterAutocompleteList", function() { return setInventoryMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryMasterAutocompleteList", function() { return resetInventoryMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleInventoryMasterLoadingState", function() { return toggleInventoryMasterLoadingState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryMasterData", function() { return setInventoryMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addInventoryMasterDownloadable", function() { return addInventoryMasterDownloadable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterDownloadable", function() { return removeInventoryMasterDownloadable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addInventoryMasterPriceVariation", function() { return addInventoryMasterPriceVariation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterPriceVariation", function() { return removeInventoryMasterPriceVariation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addInventoryMasterPriceVariation_SubList", function() { return addInventoryMasterPriceVariation_SubList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterPriceVariation_SubList", function() { return removeInventoryMasterPriceVariation_SubList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryMasterVariantListRow", function() { return addNewInventoryMasterVariantListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterVariantListRow", function() { return removeInventoryMasterVariantListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryMasterOtherVariantListRow", function() { return addNewInventoryMasterOtherVariantListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterOtherVariantListRow", function() { return removeInventoryMasterOtherVariantListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewAssetServiceLogRow", function() { return addNewAssetServiceLogRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeNewAssetServiceLogRow", function() { return removeNewAssetServiceLogRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryMasterImageRow", function() { return addNewInventoryMasterImageRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryMasterImageRow", function() { return removeInventoryMasterImageRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemStockCheckList", function() { return setItemStockCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryMasterData", function() { return resetInventoryMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryMasterStatementList", function() { return setInventoryMasterStatementList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setImportInventoryDiscountData", function() { return setImportInventoryDiscountData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetImportInventoryDiscountData", function() { return resetImportInventoryDiscountData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(343);


var setInventoryMasterList = function setInventoryMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventoryMasterAutocompleteList = function setInventoryMasterAutocompleteList(state, payload) {
    state.autocomplete_list = payload;
};

var resetInventoryMasterAutocompleteList = function resetInventoryMasterAutocompleteList(state, payload) {
    state.autocomplete_list = payload;
};

var toggleInventoryMasterLoadingState = function toggleInventoryMasterLoadingState(state, payload) {
    state.loading = payload;
};

var setInventoryMasterData = function setInventoryMasterData(state, payload) {
    state.props = payload.response;
    state.statement.list = [];
    if (state.props.variant_list.length === 0) {
        state.props.variant_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* variantListProps */]))];
    } else if (payload.copy) {
        state.props.variant_list.forEach(function (element) {
            element.id = 0;
        });
    }

    if (state.props.other_variations.length === 0) {
        state.props.other_variations = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* otherVariantListProps */]))];
    }

    if (state.props.estore_downloable.length === 0) {
        state.props.estore_downloable = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* estoreDownloadable */]))];
    } else if (payload.copy) {
        state.props.estore_downloable.forEach(function (element) {
            element.id = 0;
        });
    }
    if (state.props.estore_price_variation.length === 0) {
        state.props.estore_price_variation = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* estorePriceVariation */]))];
    } else if (payload.copy) {
        state.props.estore_price_variation.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.variant_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    if (state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* imageListProps */]))];
    } else if (payload.copy) {
        state.props.image_list.forEach(function (element) {
            element.id = 0;
        });
    }

    key = 0;
    state.props.image_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addInventoryMasterDownloadable = function addInventoryMasterDownloadable(state) {

    var key = 0;
    state.props.estore_downloable.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* estoreDownloadable */])));

    state.props.estore_downloable.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventoryMasterDownloadable = function removeInventoryMasterDownloadable(state, payload) {

    var key = 0;
    state.props.estore_downloable.splice(payload, 1);

    if (state.props.estore_downloable.length === 0) {
        state.props.estore_downloable = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* estoreDownloadable */]))];
    }

    state.props.estore_downloable.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addInventoryMasterPriceVariation = function addInventoryMasterPriceVariation(state) {

    var key = 0;
    state.props.estore_price_variation.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* estorePriceVariation */])));

    state.props.estore_price_variation.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventoryMasterPriceVariation = function removeInventoryMasterPriceVariation(state, payload) {

    var key = 0;
    state.props.estore_price_variation.splice(payload, 1);

    if (state.props.estore_price_variation.length === 0) {
        state.props.estore_price_variation = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* estorePriceVariation */]))];
    }

    state.props.estore_price_variation.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addInventoryMasterPriceVariation_SubList = function addInventoryMasterPriceVariation_SubList(state, payload) {

    var key = 0;
    state.props.estore_price_variation[payload].variation_source.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* estorePriceVariationSource */])));

    state.props.estore_price_variation[payload].variation_source.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventoryMasterPriceVariation_SubList = function removeInventoryMasterPriceVariation_SubList(state, payload) {

    var key = 0;
    state.props.estore_price_variation[payload.parent_key].variation_source.splice(payload.key, 1);

    if (state.props.estore_price_variation[payload.parent_key].variation_source.length === 0) {
        state.props.estore_price_variation[payload.parent_key].variation_source = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* estorePriceVariationSource */]))];
    }

    state.props.estore_price_variation[payload.parent_key].variation_source.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryMasterVariantListRow = function addNewInventoryMasterVariantListRow(state) {

    var key = 0;
    state.props.variant_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* variantListProps */])));

    state.props.variant_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('variant_sub_item_id_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryMasterVariantListRow = function removeInventoryMasterVariantListRow(state, payload) {

    var key = 0;

    state.props.variant_list.splice(payload, 1);

    if (state.props.variant_list.length === 0) {
        state.props.variant_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["h" /* variantListProps */]))];
    }

    state.props.variant_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryMasterOtherVariantListRow = function addNewInventoryMasterOtherVariantListRow(state) {

    var key = 0;
    state.props.other_variations.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* otherVariantListProps */])));

    state.props.other_variations.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventoryMasterOtherVariantListRow = function removeInventoryMasterOtherVariantListRow(state, payload) {

    var key = 0;

    state.props.other_variations.splice(payload, 1);

    if (state.props.other_variations.length === 0) {
        state.props.other_variations = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["g" /* otherVariantListProps */]))];
    }

    state.props.other_variations.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewAssetServiceLogRow = function addNewAssetServiceLogRow(state) {

    var key = 0;
    state.props.log_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["f" /* logProps */])));

    state.props.log_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeNewAssetServiceLogRow = function removeNewAssetServiceLogRow(state, payload) {

    var key = 0;

    state.props.log_list.splice(payload, 1);

    if (state.props.log_list.length === 0) {
        state.props.log_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["f" /* logProps */]))];
    }

    state.props.log_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

// IMAGE PROPS //
var addNewInventoryMasterImageRow = function addNewInventoryMasterImageRow(state) {

    var key = 0;
    state.props.image_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* imageListProps */])));

    state.props.image_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventoryMasterImageRow = function removeInventoryMasterImageRow(state, payload) {

    var key = 0;

    state.props.delete_image_list.push(state.props.image_list[payload]);

    state.props.image_list.splice(payload, 1);

    if (state.props.image_list.length === 0) {
        state.props.image_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* imageListProps */]))];
    }

    state.props.image_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
// END //

var setItemStockCheckList = function setItemStockCheckList(state, payload) {
    state.stock_list = payload;
};

var resetInventoryMasterData = function resetInventoryMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setInventoryMasterStatementList = function setInventoryMasterStatementList(state, payload) {
    state.statement.list = payload;
};

var setImportInventoryDiscountData = function setImportInventoryDiscountData(state, payload) {
    state.import_inventory_discount = payload;
};

var resetImportInventoryDiscountData = function resetImportInventoryDiscountData(state, payload) {
    state.import_inventory_discount = [];
};

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryMasterList", function() { return getInventoryMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryMasterAutocompleteList", function() { return getInventoryMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryMasterDataProps", function() { return getInventoryMasterDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getToggleInventoryMasterLoadingState", function() { return getToggleInventoryMasterLoadingState; });
var getInventoryMasterList = function getInventoryMasterList(state) {
    return state.list;
};

var getInventoryMasterAutocompleteList = function getInventoryMasterAutocompleteList(state) {
    return state.autocomplete_list;
};

var getInventoryMasterDataProps = function getInventoryMasterDataProps(state) {
    return state.props;
};

var getToggleInventoryMasterLoadingState = function getToggleInventoryMasterLoadingState(state, payload) {
    return state.loading;
};

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryOrder_actions__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryOrder_mutations__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryOrder_getters__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryOrder_properties__ = __webpack_require__(344);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryOrder_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryOrder_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryOrder_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryOrder_actions__
});

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryOrderList", function() { return fetchInventoryOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryOrderRequest", function() { return fetchInventoryOrderRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitPurchaseRequestApprove", function() { return submitPurchaseRequestApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryOrderRequest", function() { return deleteInventoryOrderRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryOrderData", function() { return fetchInventoryOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryOrderData", function() { return submitInventoryOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryOrderData", function() { return deleteInventoryOrderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventoryOrderList = function fetchInventoryOrderList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchInventoryOrderList', payload);
            } else {
                commit('setInventoryOrderList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventoryOrderRequest = function fetchInventoryOrderRequest(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/fetchInventoryOrderRequest.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchInventoryOrderRequest', payload);
            } else {
                commit('setInventoryOrderRequestList', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var submitPurchaseRequestApprove = function submitPurchaseRequestApprove(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/submitPurchaseRequestApprove.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        commit('togglePruchaseRequestApprovalStatus', payload.list);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryOrderRequest = function deleteInventoryOrderRequest(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/deleteInventoryOrderRequest.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('fetchInventoryOrderRequest', payload);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryOrderData = function fetchInventoryOrderData(_ref5, payload) {
    var commit = _ref5.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {

            commit('setInventoryOrderData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                setTimeout(function () {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
                }, 200);
                //
            }
        } else {
            commit('resetInventoryOrderData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryOrderData = function submitInventoryOrderData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchInventoryOrderData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryOrderData = function deleteInventoryOrderData(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryOrder/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchInventoryOrderList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryOrderList", function() { return setInventoryOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryOrderRequestList", function() { return setInventoryOrderRequestList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryOrderData", function() { return setInventoryOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryOrderItemListRow", function() { return addNewInventoryOrderItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryOrderItemListRow", function() { return removeInventoryOrderItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPOExchangeRate", function() { return setPOExchangeRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryOrderData", function() { return resetInventoryOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "togglePruchaseRequestApprovalStatus", function() { return togglePruchaseRequestApprovalStatus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(344);


var setInventoryOrderList = function setInventoryOrderList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventoryOrderRequestList = function setInventoryOrderRequestList(state, payload) {
    state.request_list = payload;
};

var setInventoryOrderData = function setInventoryOrderData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var addNewInventoryOrderItemListRow = function addNewInventoryOrderItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        if (document.getElementById('item_id_' + (key - 1))) {
            document.getElementById('item_id_' + (key - 1)).focus();
        }
    }, 300);
};

var removeInventoryOrderItemListRow = function removeInventoryOrderItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPOExchangeRate = function setPOExchangeRate(state, payload) {
    state.props.exchange_rate = payload;
};

var resetInventoryOrderData = function resetInventoryOrderData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var togglePruchaseRequestApprovalStatus = function togglePruchaseRequestApprovalStatus(state, payload) {
    payload.forEach(function (el) {
        var idIndex = state.request_list.findIndex(function (t) {
            return t.id === el.id;
        });
        if (idIndex >= 0) {
            state.request_list[idIndex].approved = el.approved === 1;
            state.request_list[idIndex].selected = false;
        }
    });
};

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryOrderList", function() { return getInventoryOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryOrderDataProps", function() { return getInventoryOrderDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryOrderRequestList", function() { return getInventoryOrderRequestList; });
var getInventoryOrderList = function getInventoryOrderList(state) {
    return state.list;
};

var getInventoryOrderDataProps = function getInventoryOrderDataProps(state) {
    return state.props;
};

var getInventoryOrderRequestList = function getInventoryOrderRequestList(state) {
    return state.request_list;
};

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryInvoice_actions__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryInvoice_mutations__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryInvoice_getters__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryInvoice_properties__ = __webpack_require__(345);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search: ''
    },
    outstanding_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryInvoice_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryInvoice_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryInvoice_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryInvoice_actions__
});

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryInvoiceList", function() { return fetchInventoryInvoiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailInventoryPurchaseList", function() { return emailInventoryPurchaseList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryInvoiceData", function() { return fetchInventoryInvoiceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryInvoiceData", function() { return submitInventoryInvoiceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryInvoiceData", function() { return deleteInventoryInvoiceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitGroupInventoryItems", function() { return submitGroupInventoryItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventoryInvoiceList = function fetchInventoryInvoiceList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        commit('resetInventoryInvoiceOutstandingList');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchInventoryInvoiceList', payload);
            } else {
                if (payload.show_outstanding) {
                    commit('setInventoryInvoiceOutstandingList', res.data.response);
                } else {
                    commit('setInventoryInvoiceList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
                }
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var emailInventoryPurchaseList = function emailInventoryPurchaseList(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/emailInventoryPurchaseList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryInvoiceData = function fetchInventoryInvoiceData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setInventoryInvoiceData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchVendorPaymentList', {
                store_list: [{ store_id: 0 }],
                purchase_bill_id: res.data.response.id
            });
            dispatch('fetchDocumentList', { purchase_bill_id: payload.id, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryInvoiceData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryInvoiceData = function submitInventoryInvoiceData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchInventoryInvoiceData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryInvoiceData = function deleteInventoryInvoiceData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack && !payload.popup) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchInventoryInvoiceList', payload.list);
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitGroupInventoryItems = function submitGroupInventoryItems(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryInvoice/submitGroupInventoryItems.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('addPurchaseInvoiceItems_Bulk', res.data.response);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryInvoiceList", function() { return setInventoryInvoiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryInvoiceOutstandingList", function() { return setInventoryInvoiceOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryInvoiceOutstandingList", function() { return resetInventoryInvoiceOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryInvoiceData", function() { return setInventoryInvoiceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPurchaseInvoiceItems_Bulk", function() { return addPurchaseInvoiceItems_Bulk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryInvoiceItemListRow", function() { return addNewInventoryInvoiceItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryInvoiceItemListRow", function() { return removeInventoryInvoiceItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryInvoicePaymentTermListRow", function() { return addNewInventoryInvoicePaymentTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryInvoicePaymentTermListRow", function() { return removeInventoryInvoicePaymentTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryInvoiceExchangeRate", function() { return setInventoryInvoiceExchangeRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryInvoiceData", function() { return resetInventoryInvoiceData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(345);


var setInventoryInvoiceList = function setInventoryInvoiceList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventoryInvoiceOutstandingList = function setInventoryInvoiceOutstandingList(state, payload) {
    state.outstanding_list = payload;
};

var resetInventoryInvoiceOutstandingList = function resetInventoryInvoiceOutstandingList(state) {
    state.outstanding_list = [];
};

var setInventoryInvoiceData = function setInventoryInvoiceData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var addPurchaseInvoiceItems_Bulk = function addPurchaseInvoiceItems_Bulk(state, payload) {

    payload.forEach(function (element) {

        var unit_rate = parseFloat(element.unit_rate);
        var qty = parseFloat(element.qty);
        var sub_total = unit_rate * qty;
        var tax_percent = parseFloat(element.tax_percent);
        var tax_amount = sub_total * (tax_percent / 100);
        var net_total = sub_total + tax_amount;

        state.props.item_list.push({
            key: 0,
            id: 0,
            item_id: element.id,
            item_detail: { id: element.id, sku_code: element.sku_code, article_name: element.article_name, unit_name: element.unit_name },
            description: '',
            qty: qty,
            unit_rate: unit_rate,
            sub_total: sub_total,
            tax_percent: tax_percent,
            tax_amount: tax_amount,
            net_total: net_total,
            item_edit: 1
        });

        key++;
    });

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryInvoiceItemListRow = function addNewInventoryInvoiceItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryInvoiceItemListRow = function removeInventoryInvoiceItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryInvoicePaymentTermListRow = function addNewInventoryInvoicePaymentTermListRow(state) {

    var key = 0;
    state.props.payment_term.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* paymentTermListProps */])));

    state.props.payment_term.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('payment_term_date_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryInvoicePaymentTermListRow = function removeInventoryInvoicePaymentTermListRow(state, payload) {

    var key = 0;

    state.props.payment_term.splice(payload, 1);

    if (state.props.payment_term.length === 0) {
        state.props.payment_term = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* paymentTermListProps */]))];
    }

    state.props.payment_term.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setInventoryInvoiceExchangeRate = function setInventoryInvoiceExchangeRate(state, payload) {
    state.props.exchange_rate = payload;
};

var resetInventoryInvoiceData = function resetInventoryInvoiceData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryInvoiceList", function() { return getInventoryInvoiceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryInvoiceOutstandingList", function() { return getInventoryInvoiceOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryInvoiceDataProps", function() { return getInventoryInvoiceDataProps; });
var getInventoryInvoiceList = function getInventoryInvoiceList(state) {
    return state.list;
};

var getInventoryInvoiceOutstandingList = function getInventoryInvoiceOutstandingList(state) {
    return state.outstanding_list;
};

var getInventoryInvoiceDataProps = function getInventoryInvoiceDataProps(state) {
    return state.props;
};

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vendorPayment_actions__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vendorPayment_mutations__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vendorPayment_getters__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendorPayment_properties__ = __webpack_require__(346);






var state = {
    list: [],
    settlement_type: 1,
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__vendorPayment_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__vendorPayment_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__vendorPayment_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__vendorPayment_actions__
});

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchVendorPaymentList", function() { return fetchVendorPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchVendorPaymentData", function() { return fetchVendorPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitVendorPaymentData", function() { return submitVendorPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteVendorPaymentData", function() { return deleteVendorPaymentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchVendorPaymentList = function fetchVendorPaymentList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorPayment/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.status) {
                commit('setVendorPaymentList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchVendorPaymentData = function fetchVendorPaymentData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorPayment/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setVendorPaymentData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetVendorPaymentData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitVendorPaymentData = function submitVendorPaymentData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorPayment/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                // router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            commit('resetVendorPaymentPartial');
            dispatch('fetchVendorMasterList');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteVendorPaymentData = function deleteVendorPaymentData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/vendorPayment/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchVendorPaymentList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVendorPaymentList", function() { return setVendorPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVendorPaymentData", function() { return setVendorPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetVendorPaymentPartial", function() { return resetVendorPaymentPartial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetVendorPaymentData", function() { return resetVendorPaymentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(346);


var setVendorPaymentList = function setVendorPaymentList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setVendorPaymentData = function setVendorPaymentData(state, payload) {
    state.props = payload.response;
};

var resetVendorPaymentPartial = function resetVendorPaymentPartial(state) {
    state.props.paid_amount = 0;
    state.props.bank_id = null;
};

var resetVendorPaymentData = function resetVendorPaymentData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVendorPaymentList", function() { return getVendorPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVendorPaymentDataProps", function() { return getVendorPaymentDataProps; });
var getVendorPaymentList = function getVendorPaymentList(state) {
    return state.list;
};

var getVendorPaymentDataProps = function getVendorPaymentDataProps(state) {
    return state.props;
};

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryIntraBranch_actions__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryIntraBranch_mutations__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryIntraBranch_getters__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryIntraBranch_properties__ = __webpack_require__(347);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryIntraBranch_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryIntraBranch_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryIntraBranch_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryIntraBranch_actions__
});

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryIntraBranchList", function() { return fetchInventoryIntraBranchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryIntraBranchData", function() { return fetchInventoryIntraBranchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryIntraBranchData", function() { return submitInventoryIntraBranchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryIntraBranchData", function() { return deleteInventoryIntraBranchData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventoryIntraBranchList = function fetchInventoryIntraBranchList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryIntraBranch/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchInventoryIntraBranchList', payload);
            } else {
                commit('setInventoryIntraBranchList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventoryIntraBranchData = function fetchInventoryIntraBranchData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryIntraBranch/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setInventoryIntraBranchData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryIntraBranchData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryIntraBranchData = function submitInventoryIntraBranchData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryIntraBranch/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchInventoryIntraBranchData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
        dispatch('fetchInventoryIntraBranchData', { id: payload.id });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryIntraBranchData = function deleteInventoryIntraBranchData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryIntraBranch/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventoryIntraBranchList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryIntraBranchList", function() { return setInventoryIntraBranchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryIntraBranchData", function() { return setInventoryIntraBranchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryIntraBranchItemListRow", function() { return setInventoryIntraBranchItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryIntraBranchItemListRow", function() { return addNewInventoryIntraBranchItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryIntraBranchItemListRow", function() { return removeInventoryIntraBranchItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryIntraBranchData", function() { return resetInventoryIntraBranchData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(347);


var setInventoryIntraBranchList = function setInventoryIntraBranchList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventoryIntraBranchData = function setInventoryIntraBranchData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var setInventoryIntraBranchItemListRow = function setInventoryIntraBranchItemListRow(state, payload) {

    var key = 0;
    state.props.item_list = payload;

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryIntraBranchItemListRow = function addNewInventoryIntraBranchItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryIntraBranchItemListRow = function removeInventoryIntraBranchItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetInventoryIntraBranchData = function resetInventoryIntraBranchData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryIntraBranchList", function() { return getInventoryIntraBranchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryIntraBranchDataProps", function() { return getInventoryIntraBranchDataProps; });
var getInventoryIntraBranchList = function getInventoryIntraBranchList(state) {
    return state.list;
};

var getInventoryIntraBranchDataProps = function getInventoryIntraBranchDataProps(state) {
    return state.props;
};

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventorySourcing_actions__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventorySourcing_mutations__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventorySourcing_getters__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventorySourcing_properties__ = __webpack_require__(348);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventorySourcing_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventorySourcing_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventorySourcing_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventorySourcing_actions__
});

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventorySourcingList", function() { return fetchInventorySourcingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventorySourcingData", function() { return fetchInventorySourcingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventorySourcingData", function() { return submitInventorySourcingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventorySourcingData", function() { return deleteInventorySourcingData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventorySourcingList = function fetchInventorySourcingList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySourcing/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchInventorySourcingList', payload);
            } else {
                commit('setInventorySourcingList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventorySourcingData = function fetchInventorySourcingData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySourcing/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setInventorySourcingData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventorySourcingData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventorySourcingData = function submitInventorySourcingData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySourcing/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventorySourcingData', { id: res.data.id });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventorySourcingData = function deleteInventorySourcingData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySourcing/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventorySourcingList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySourcingList", function() { return setInventorySourcingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySourcingData", function() { return setInventorySourcingData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventorySourcingItemListRow", function() { return addNewInventorySourcingItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySourcingItemListRow", function() { return setInventorySourcingItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventorySourcingItemListRow", function() { return removeInventorySourcingItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventorySourcingTermListRow", function() { return addNewInventorySourcingTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventorySourcingTermListRow", function() { return removeInventorySourcingTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventorySourcingData", function() { return resetInventorySourcingData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(348);


var setInventorySourcingList = function setInventorySourcingList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventorySourcingData = function setInventorySourcingData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventorySourcingItemListRow = function addNewInventorySourcingItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var setInventorySourcingItemListRow = function setInventorySourcingItemListRow(state, payload) {

    var key = 0;
    state.props.item_list = payload;

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventorySourcingItemListRow = function removeInventorySourcingItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventorySourcingTermListRow = function addNewInventorySourcingTermListRow(state) {

    var key = 0;
    state.props.term_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* termListProps */])));

    state.props.term_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('term_text_' + (key - 1)).focus();
    }, 300);
};

var removeInventorySourcingTermListRow = function removeInventorySourcingTermListRow(state, payload) {

    var key = 0;

    state.props.term_list.splice(payload, 1);

    if (state.props.term_list.length === 0) {
        state.props.term_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.term_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetInventorySourcingData = function resetInventorySourcingData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventorySourcingList", function() { return getInventorySourcingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventorySourcingDataProps", function() { return getInventorySourcingDataProps; });
var getInventorySourcingList = function getInventorySourcingList(state) {
    return state.list;
};

var getInventorySourcingDataProps = function getInventorySourcingDataProps(state) {
    return state.props;
};

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryStockCheck_actions__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryStockCheck_mutations__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryStockCheck_getters__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryStockCheck_properties__ = __webpack_require__(349);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryStockCheck_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryStockCheck_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryStockCheck_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryStockCheck_actions__
});

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryStockCheckList", function() { return fetchInventoryStockCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryStockCheckData", function() { return fetchInventoryStockCheckData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryStockCheckData", function() { return submitInventoryStockCheckData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryStockCheckData", function() { return deleteInventoryStockCheckData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventoryStockCheckList = function fetchInventoryStockCheckList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryStockCheck/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchInventoryStockCheckList', payload);
            } else {
                commit('setInventoryStockCheckList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventoryStockCheckData = function fetchInventoryStockCheckData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryStockCheck/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setInventoryStockCheckData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryStockCheckData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryStockCheckData = function submitInventoryStockCheckData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryStockCheck/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchInventoryStockCheckData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryStockCheckData = function deleteInventoryStockCheckData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryStockCheck/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventoryStockCheckList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryStockCheckList", function() { return setInventoryStockCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryStockCheckData", function() { return setInventoryStockCheckData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventoryStockCheckItemListRow", function() { return addNewInventoryStockCheckItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventoryStockCheckItemListRow", function() { return removeInventoryStockCheckItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryStockCheckData", function() { return resetInventoryStockCheckData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryStockCheckItemListRow", function() { return setInventoryStockCheckItemListRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(349);


var setInventoryStockCheckList = function setInventoryStockCheckList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventoryStockCheckData = function setInventoryStockCheckData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewInventoryStockCheckItemListRow = function addNewInventoryStockCheckItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeInventoryStockCheckItemListRow = function removeInventoryStockCheckItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetInventoryStockCheckData = function resetInventoryStockCheckData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setInventoryStockCheckItemListRow = function setInventoryStockCheckItemListRow(state, payload) {

    var key = 0;
    state.props.item_list = payload;

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryStockCheckList", function() { return getInventoryStockCheckList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryStockCheckDataProps", function() { return getInventoryStockCheckDataProps; });
var getInventoryStockCheckList = function getInventoryStockCheckList(state) {
    return state.list;
};

var getInventoryStockCheckDataProps = function getInventoryStockCheckDataProps(state) {
    return state.props;
};

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__customerMaster_actions__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customerMaster_mutations__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customerMaster_getters__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerMaster_properties__ = __webpack_require__(350);






var state = {
    list: null,
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    autocomplete_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__customerMaster_properties__["b" /* dataProps */])),
    statement: {
        date_range: ['', ''],
        list: []
    },
    order_list: [],
    customer_dd: {
        dd_activity: [],
        dd_status: [],
        dd_notes: []
    },
    import_customer_list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__customerMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__customerMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__customerMaster_actions__
});

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerMasterList", function() { return fetchCustomerMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerOrderList", function() { return fetchCustomerOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkCustomerMobileExists", function() { return checkCustomerMobileExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkCustomerEmailExists", function() { return checkCustomerEmailExists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadCustomerStatement", function() { return loadCustomerStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerMasterAutocompleteList", function() { return fetchCustomerMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerMasterMeasurementData", function() { return fetchCustomerMasterMeasurementData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerMasterData", function() { return fetchCustomerMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCustomerMasterData", function() { return submitCustomerMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailCustomerList", function() { return emailCustomerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerMasterData", function() { return deleteCustomerMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerDD", function() { return fetchCustomerDD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCustomerDD", function() { return submitCustomerDD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareCustomerImportSheet", function() { return prepareCustomerImportSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitImportCustomerListData", function() { return submitImportCustomerListData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchCustomerMasterList = function fetchCustomerMasterList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCustomerMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerOrderList = function fetchCustomerOrderList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/fetchCustomerOrderList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCustomerMasterOrderList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var checkCustomerMobileExists = function checkCustomerMobileExists(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/checkCustomerMobileExists.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displayMessageAlert', { message: res.data.message, type: 'Warning' });
        } else {
            commit('displaySuccessNotification', { message: 'Mobile number is unique' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var checkCustomerEmailExists = function checkCustomerEmailExists(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/checkCustomerEmailExists.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displayMessageAlert', { message: res.data.message, type: 'Warning' });
        } else {
            commit('displaySuccessNotification', { message: 'Email address is unique' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadCustomerStatement = function loadCustomerStatement(_ref5, payload) {
    var commit = _ref5.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/statement.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCustomerMasterStatementList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerMasterAutocompleteList = function fetchCustomerMasterAutocompleteList(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/autocomplete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setCustomerMasterAutocompleteList', res.data.response);
        if (payload.load_delivery_receipt) {
            setTimeout(function () {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/deliveryreceipts/form/');
            }, 400);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerMasterMeasurementData = function fetchCustomerMasterMeasurementData(_ref7, payload) {
    var commit = _ref7.commit;

    commit('toggleLoadingState', true);
    commit('setLoadingMeasurements');
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/fetchMeasurementData_1.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setCustomerMasterMeasurementData', res.data.response);
        } else {
            commit('resetCustomerMasterMeasurementData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerMasterData = function fetchCustomerMasterData(_ref8, payload) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setCustomerMasterData', { response: res.data.response, copy: payload.copy });

            setTimeout(function () {
                if (payload.fetchMsmt) {
                    dispatch('fetchCustomerMasterMeasurementData', payload);
                }

                if (payload.navigate) {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
                }
                if (payload.navigateSale) {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/salesorders/form');
                }

                dispatch('loadProvinceList', res.data.response.country_id);
                dispatch('loadCityList', res.data.response.province_id);
            }, 300);
        } else {
            commit('resetCustomerMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var submitCustomerMasterData = function submitCustomerMasterData(_ref9, payload) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;


    commit('toggleLoadingState', true);
    if (payload.id > 0) {
        setTimeout(function () {
            //commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            //commit('toggleLoadingState', false)
        }, 2000);
    }
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id > 0) {
                //dispatch('fetchCustomerMasterMeasurementData', {id: res.data.id})
                dispatch('fetchCustomerMasterData', { id: res.data.id, fetchMsmt: true });
            } else {
                dispatch('fetchCustomerMasterData', { id: res.data.id, fetchMsmt: false });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var emailCustomerList = function emailCustomerList(_ref10, payload) {
    var commit = _ref10.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/emailCustomerList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCustomerMasterData = function deleteCustomerMasterData(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchCustomerMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCustomerDD = function fetchCustomerDD(_ref12) {
    var commit = _ref12.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/customerMaster/downloadDD.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setCustomerDD', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCustomerDD = function submitCustomerDD(_ref13, payload) {
    var commit = _ref13.commit,
        dispatch = _ref13.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/saveDD.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchCustomerDD');
        } else {
            commit('displayMessageAlert', { message: 'Error while saving', type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var prepareCustomerImportSheet = function prepareCustomerImportSheet(_ref14, payload) {
    var commit = _ref14.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/exportModule/customer/prepareSheet.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            if (payload.campaign) {
                commit('setCampaignCustomerList', res.data.response);
            } else {
                commit('setCustomerMasterImportListRow', res.data.response);
            }

            setTimeout(function () {
                commit('toggleLoadingState', false);
            }, 2000);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
            commit('toggleLoadingState', false);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var submitImportCustomerListData = function submitImportCustomerListData(_ref15, payload) {
    var commit = _ref15.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/exportModule/customer/submitData.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        commit('resetCustomerMasterImportList', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterList", function() { return setCustomerMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterOrderList", function() { return setCustomerMasterOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterAutocompleteList", function() { return setCustomerMasterAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterData", function() { return setCustomerMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterMeasurementData", function() { return setCustomerMasterMeasurementData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerMasterMeasurementData", function() { return resetCustomerMasterMeasurementData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoadingMeasurements", function() { return setLoadingMeasurements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unSetLoadingMeasurements", function() { return unSetLoadingMeasurements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewCustomerMasterMeasurementProfileListRow", function() { return addNewCustomerMasterMeasurementProfileListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCustomerMasterMeasurementProfileListRow", function() { return removeCustomerMasterMeasurementProfileListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewCustomerMasterPhotoListRow", function() { return addNewCustomerMasterPhotoListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCustomerMasterPhotoListRow", function() { return removeCustomerMasterPhotoListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewAddressListItemRow", function() { return addNewAddressListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeAddressListItemRow", function() { return removeAddressListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterStatementList", function() { return setCustomerMasterStatementList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerDD", function() { return setCustomerDD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerMasterData", function() { return resetCustomerMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerMasterImportListRow", function() { return setCustomerMasterImportListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerMasterImportList", function() { return resetCustomerMasterImportList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(350);


var setCustomerMasterList = function setCustomerMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setCustomerMasterOrderList = function setCustomerMasterOrderList(state, payload) {
    state.order_list = payload;
};

var setCustomerMasterAutocompleteList = function setCustomerMasterAutocompleteList(state, payload) {
    state.autocomplete_list = payload;
};

var setCustomerMasterData = function setCustomerMasterData(state, payload) {
    state.props = payload.response;
    state.statement.list = [];
    if (state.props.photo_list.length === 0) {
        state.props.photo_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* photoListProps */]))];
    } else {
        state.props.photo_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* photoListProps */])));
    }
    if (state.props.address_list.length === 0) {
        state.props.address_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* addressProps */]))];
    }

    if (state.props.discussion_list === null) {
        state.props.discussion_list = [];
    }
    state.props.discussion_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* discussionProps */])));
};

var setCustomerMasterMeasurementData = function setCustomerMasterMeasurementData(state, payload) {
    state.props.loading_measurements = false;

    var responsePayload = JSON.parse(JSON.stringify(payload));

    var distinctTailoringCategoryId = responsePayload.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
            return t.tailoring_category_id === thing.tailoring_category_id;
        });
    });

    var distinctRegistrationDate = responsePayload.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
            return t.registration_date === thing.registration_date;
        });
    });

    var measurement_profile_list = [];

    distinctTailoringCategoryId.forEach(function (tailoringCategory) {

        var profile_list = [];
        var key = 0;

        distinctRegistrationDate.forEach(function (date) {

            var msmtFilterList = responsePayload.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.registration_date === date.registration_date && tailoringCategory.measurement_profile_id === thing.measurement_profile_id && t.tailoring_category_id === tailoringCategory.tailoring_category_id;
                });
            });

            msmtFilterList.forEach(function (profile) {

                var msmtFields = responsePayload.filter(function (t) {
                    return t.measurement_profile_id === profile.measurement_profile_id && t.tailoring_category_id === tailoringCategory.tailoring_category_id;
                });

                var measurement_field_list = [];
                msmtFields.forEach(function (msmt) {
                    measurement_field_list.push(msmt);
                });

                profile_list.push({
                    key: key,
                    id: profile.measurement_profile_id,
                    tailoring_category_id: profile.tailoring_category_id,
                    size_id: profile.size_id,
                    measurement_type: profile.measurement_type,
                    registration_date: profile.registration_date,
                    registration_date_formatted: profile.registration_date_formatted,
                    notes: profile.notes,
                    measured_by_staff_id: profile.measured_by_staff_id,
                    measurement_field_list: measurement_field_list
                });

                key++;
            });
        });

        measurement_profile_list.push({
            tailoring_category_id: tailoringCategory.tailoring_category_id,
            profile_list: profile_list
        });
    });

    state.props.measurement_profile_list = measurement_profile_list;
    state.props.temp_measurement_profile_list = [];

    /*state.props.measurement_profile_list = payload.measurement_profile_list
    state.props.temp_measurement_profile_list = payload.temp_measurement_profile_list*/
};

var resetCustomerMasterMeasurementData = function resetCustomerMasterMeasurementData(state) {
    state.props.loading_measurements = false;
    state.props.measurement_profile_list = [];
    state.props.temp_measurement_profile_list = [];
};

var setLoadingMeasurements = function setLoadingMeasurements(state) {
    state.props.loading_measurements = true;
};

var unSetLoadingMeasurements = function unSetLoadingMeasurements(state) {
    state.props.loading_measurements = false;
};

var addNewCustomerMasterMeasurementProfileListRow = function addNewCustomerMasterMeasurementProfileListRow(state, tailoring_category_id) {

    var listIndex = state.props.temp_measurement_profile_list.findIndex(function (t) {
        return t.tailoring_category_id === tailoring_category_id;
    });
    var key = 0;

    if (listIndex >= 0) {
        state.props.temp_measurement_profile_list[listIndex].profile_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* measurementProfileListProps */])));

        state.props.temp_measurement_profile_list[listIndex].profile_list.forEach(function (element) {
            element.key = key;

            key++;
        });
    }
};

var removeCustomerMasterMeasurementProfileListRow = function removeCustomerMasterMeasurementProfileListRow(state, payload) {

    var listIndex = state.props.temp_measurement_profile_list.findIndex(function (t) {
        return t.tailoring_category_id === payload.tailoring_category_id;
    });

    var key = 0;

    state.props.temp_measurement_profile_list[listIndex].profile_list.splice(payload.key, 1);

    state.props.temp_measurement_profile_list[listIndex].profile_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewCustomerMasterPhotoListRow = function addNewCustomerMasterPhotoListRow(state) {

    var key = 0;
    state.props.photo_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* photoListProps */])));

    state.props.photo_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeCustomerMasterPhotoListRow = function removeCustomerMasterPhotoListRow(state, payload) {

    var key = 0;

    state.props.photo_list.splice(payload, 1);

    if (state.props.photo_list.length === 0) {
        state.props.photo_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["e" /* photoListProps */]))];
    }

    state.props.photo_list.forEach(function (element) {
        element.key = key;
        if (payload === key) {
            element.photo = "";
        }
        key++;
    });
};

var addNewAddressListItemRow = function addNewAddressListItemRow(state) {

    var sl_no = 0;
    state.props.address_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* addressProps */])));

    state.props.address_list.forEach(function (element) {
        element.key = sl_no;
        element.edit_mode = false;
        sl_no++;
    });

    state.props.address_list[state.props.address_list.length - 1].edit_mode = true;

    setTimeout(function () {
        document.getElementById('contact_name_' + (sl_no - 1)).focus();
    }, 300);
};

var removeAddressListItemRow = function removeAddressListItemRow(state, payload) {

    var sl_no = 0;

    state.props.delete_address_list.push(state.props.address_list[payload]);

    state.props.address_list.splice(payload, 1);

    if (state.props.address_list.length === 0) {
        state.props.address_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* addressProps */]))];
    }

    state.props.address_list.forEach(function (element) {
        element.key = sl_no;
        element.edit_mode = false;
        sl_no++;
    });

    state.props.address_list[state.props.address_list.length - 1].edit_mode = true;

    setTimeout(function () {
        document.getElementById('contact_name_' + (sl_no - 1)).focus();
    }, 300);
};

var setCustomerMasterStatementList = function setCustomerMasterStatementList(state, payload) {
    state.statement.list = payload;
};

var setCustomerDD = function setCustomerDD(state, payload) {
    state.customer_dd = payload.response;
};

var resetCustomerMasterData = function resetCustomerMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* dataProps */]));
};

var setCustomerMasterImportListRow = function setCustomerMasterImportListRow(state, payload) {
    state.import_customer_list = payload;
};

var resetCustomerMasterImportList = function resetCustomerMasterImportList(state) {
    state.import_customer_list = [];
};

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerMasterList", function() { return getCustomerMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerMasterDataProps", function() { return getCustomerMasterDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerMasterAutocompleteList", function() { return getCustomerMasterAutocompleteList; });
var getCustomerMasterList = function getCustomerMasterList(state) {
    return state.list;
};

var getCustomerMasterDataProps = function getCustomerMasterDataProps(state) {
    return state.props;
};

var getCustomerMasterAutocompleteList = function getCustomerMasterAutocompleteList(state) {
    return state.autocomplete_list;
};

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__saleMaster_actions__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__saleMaster_mutations__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__saleMaster_getters__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saleMaster_properties__ = __webpack_require__(351);






var state = {
    list: null,
    order_tab: '1',
    showCategoryWindow: false,
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.created_at',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    show_category: [],
    items: {
        total_rows: 0,
        item_sub_category_id: 0,
        item_type: -1,
        offset: 0,
        list: [] //all items         
    },
    fabric: null,
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__saleMaster_properties__["a" /* dataProps */])),
    temp_order_item: null,
    item_autocomplete_list: [],
    sale_type: -1,
    outstanding_list: [],
    print: {
        showPrintWindow: false,
        printSrc: '',
        printTitle: ''
    },
    dummy_list_item: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__saleMaster_properties__["b" /* itemListProps */])),
    showWorkOrder: false,
    selectedRowData: null,
    sales_cost_sheet: [],
    trial_schedule_list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__saleMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__saleMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__saleMaster_actions__
});

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleMasterList", function() { return fetchSaleMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTrialSchedule", function() { return fetchTrialSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saveTrialSchedule", function() { return saveTrialSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitShortcutSale", function() { return submitShortcutSale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTrialSchedule", function() { return removeTrialSchedule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleMasterDataBalance", function() { return fetchSaleMasterDataBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleMasterData", function() { return fetchSaleMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSaleMasterData", function() { return submitSaleMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitRetailDelivery", function() { return submitRetailDelivery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendCustomerOverDueReminder", function() { return sendCustomerOverDueReminder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendSaleOverDueReminder", function() { return sendSaleOverDueReminder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSaleMasterData", function() { return deleteSaleMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadSubCategoryItem", function() { return loadSubCategoryItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "redeemSalesDiscountCoupon", function() { return redeemSalesDiscountCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cancelSalesOrder", function() { return cancelSalesOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSalesInvoice", function() { return createSalesInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCustomerRef", function() { return updateCustomerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExchangeRate", function() { return fetchExchangeRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSalesDeliveryDate", function() { return updateSalesDeliveryDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSalesTrialDate", function() { return updateSalesTrialDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCostSheet", function() { return fetchCostSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSalesOrderWIP", function() { return fetchSalesOrderWIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailSaleList", function() { return emailSaleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "saleDeliveryMarkingShortcut", function() { return saleDeliveryMarkingShortcut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitNewSaleItem", function() { return submitNewSaleItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSalePromiseDateShortcut", function() { return updateSalePromiseDateShortcut; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchSaleMasterList = function fetchSaleMasterList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        commit('resetSaleMasterOutstandingList');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                //dispatch('fetchInventoryInvoiceList', payload)
            } else {
                if (payload.show_outstanding) {
                    commit('setSaleMasterOutstandingList', res.data.response);
                    dispatch('fetchCustomerMasterData', { id: payload.customer_id });
                } else {
                    commit('setSaleMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
                }
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchTrialSchedule = function fetchTrialSchedule(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/fetchTrialSchedule.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setTrialScheduleList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var saveTrialSchedule = function saveTrialSchedule(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/saveTrialSchedule.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('fetchTrialSchedule', { sale_item_id: payload.sale_item_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitShortcutSale = function submitShortcutSale(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/saveShortcut.php', payload.props, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('setSaleShortcutInfo', {
                id: res.data.id,
                sale_number_prefix: res.data.sale_number_prefix,
                sale_number: res.data.sale_number
            });

            if (payload.newSaleItemProps) {
                setTimeout(function () {
                    payload.newSaleItemProps.sale_id = res.data.id;
                    dispatch('submitNewSaleItem', payload.newSaleItemProps);
                }, 100);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var removeTrialSchedule = function removeTrialSchedule(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/removeTrialSchedule.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        dispatch('fetchTrialSchedule', { sale_item_id: payload.sale_item_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSaleMasterDataBalance = function fetchSaleMasterDataBalance(_ref6, payload) {
    var commit = _ref6.commit;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/fetchBalance.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setSaleMasterBalance', res.data.total_paid);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSaleMasterData = function fetchSaleMasterData(_ref7, payload) {
    var commit = _ref7.commit,
        dispatch = _ref7.dispatch;

    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        //console.log(JSON.stringify(res.data));
        //return
        if (res.data.status) {

            dispatch('fetchCustomerPaymentList', {
                store_list: [{ store_id: 0 }],
                sale_id: res.data.response.id
            });

            if (payload.notify_customer) {
                commit('setSaleMailTrigger', { master_url: payload.master_url, access_token: payload.access_token, id: res.data.response.id });
            } else if (payload.print_default_paper) {
                commit('setSalePrintWindow', {
                    sale_id: payload.id,
                    printTitle: payload.default_print_size === 0 ? 'Paper Size: A5' : 'Paper Size: 2 inch Thermal Paper',
                    pageSize: payload.default_print_size === 0 ? 'A5' : payload.default_print_size === 1 ? 'Thermal' : 'A4',
                    access_token: payload.access_token,
                    master_url: payload.master_url
                });
            }

            var customerPayload = { id: res.data.response.customer_id, navigate: false, saleSource: true };
            dispatch('fetchCustomerMasterData', customerPayload);
            if (payload.fabricPriceSlabExists) {
                dispatch('fetchCustomerMasterMeasurementData', customerPayload);
            } else {
                commit('unSetLoadingMeasurements');
            }

            if (res.data.response.paying_customer_id > 0) {
                dispatch('fetchCustomerMasterAutocompleteList', { query: '', customer_code: 0, customer_id: res.data.response.paying_customer_id });
            }

            commit('setSaleMasterData', { response: res.data.response, copy: payload.copy });

            setTimeout(function () {
                commit('editRowCalculations');

                setTimeout(function () {
                    if (payload.navigate) {
                        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
                    }
                }, 300);
            }, 500);
        } else {
            commit('resetSaleMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitSaleMasterData = function submitSaleMasterData(_ref8, payload) {
    var commit = _ref8.commit,
        dispatch = _ref8.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            var printDefaultPaper = false;
            if (res.data.default_print >= 0) {
                printDefaultPaper = true;
            }

            dispatch('fetchSaleMasterData', {
                id: res.data.id,
                print_default_paper: printDefaultPaper,
                default_print_size: res.data.default_print,
                master_url: payload.master_url,
                access_token: payload.access_token,
                notify_customer: payload.notify_customer,
                fabricPriceSlabExists: payload.fabricPriceSlabExists
            });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        //commit('toggleLoadingState', false)
    });
};

var submitRetailDelivery = function submitRetailDelivery(_ref9, payload) {
    var commit = _ref9.commit,
        dispatch = _ref9.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/submitRetailDelivery.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('fetchSaleMasterData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        //commit('toggleLoadingState', false)
    });
};

var sendCustomerOverDueReminder = function sendCustomerOverDueReminder(_ref10, payload) {
    var commit = _ref10.commit,
        dispatch = _ref10.dispatch;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displaySuccessNotification', { message: 'Request submitted successfully!!!' });
        commit('toggleLoadingState', false);
    }, 1000);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerMaster/sendBalanceOverDueReminder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var sendSaleOverDueReminder = function sendSaleOverDueReminder(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displaySuccessNotification', { message: 'Request submitted successfully!!!' });
        commit('toggleLoadingState', false);
    }, 1000);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/sendSaleOverDueReminder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var deleteSaleMasterData = function deleteSaleMasterData(_ref12, payload) {
    var commit = _ref12.commit,
        dispatch = _ref12.dispatch;


    commit('toggleLoadingState', true);

    /*setTimeout(() => {
        if(payload.navBack) {
            router.push('/salesorders', '')
        } else if(payload.popup) {
            //dispatch('fetchSaleMasterList', payload.list)
        } else {
            router.push('/salesorders', '')
            dispatch('fetchSaleMasterList', {nav: payload.nav, sale_type: payload.sale_type, store_list: payload.store_list})
        }
    }, 15000);*/

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/salesorders', '');
            } else if (payload.popup) {
                //dispatch('fetchSaleMasterList', payload.list)
            } else {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/salesorders', '');
                dispatch('fetchSaleMasterList', { nav: payload.nav, sale_type: payload.sale_type, store_list: payload.store_list });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadSubCategoryItem = function loadSubCategoryItem(_ref13, payload) {
    var commit = _ref13.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/itemCategory/loadSubCategoryItem.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (!res.data.status) {
            commit('displayErrorNotification', { message: 'Empty result, no matching data!!!' });
        }
        //document.getElementById('item_search_field').focus()
        commit('setSubCategorySaleItemList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var redeemSalesDiscountCoupon = function redeemSalesDiscountCoupon(_ref14, payload) {
    var commit = _ref14.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/discountCoupon/redeemSalesDiscountCoupon.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setRedeemSalesDiscountCoupon', res.data.response);
            setTimeout(function () {
                commit('editRowCalculations');
            }, 300);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var cancelSalesOrder = function cancelSalesOrder(_ref15, payload) {
    var commit = _ref15.commit,
        dispatch = _ref15.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/cancelSalesOrder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displayMessageAlert', { displayHTML: true, message: "Cancelled the items successfully.", type: 'Success' });
            dispatch('fetchSaleMasterData', { id: res.data.id, navigate: false });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var createSalesInvoice = function createSalesInvoice(_ref16, payload) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/createInvoice.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('fetchSaleMasterData', { id: payload.order_id, navigate: false });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {});
};

var updateCustomerRef = function updateCustomerRef(_ref17, payload) {
    var commit = _ref17.commit,
        dispatch = _ref17.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/updateCustomerRef.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            dispatch('fetchSaleMasterData', { id: payload.id, navigate: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchExchangeRate = function fetchExchangeRate(_ref18, payload) {
    var commit = _ref18.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/fetchExchangeRate.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.source) {
            if (payload.source == 'po') {
                commit('setPOExchangeRate', res.data.response);
            } else if (payload.source == 'pi') {
                commit('setInventoryInvoiceExchangeRate', res.data.response);
            }
        } else {
            commit('setSalesExchangeRate', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateSalesDeliveryDate = function updateSalesDeliveryDate(_ref19, payload) {
    var commit = _ref19.commit,
        dispatch = _ref19.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/updateSalesDeliveryDate.php', payload.data, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('loadAppointmentList', { selected_date: payload.selected_date, store_id: payload.store_id });
        dispatch('fetchMonthlyAppointments', { selected_month: new Date(payload.selected_date).getMonth() + 1, store_id: payload.store_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateSalesTrialDate = function updateSalesTrialDate(_ref20, payload) {
    var commit = _ref20.commit,
        dispatch = _ref20.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/updateSalesTrialDate.php', payload.data, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        dispatch('loadAppointmentList', { selected_date: payload.selected_date, store_id: payload.store_id });
        dispatch('fetchMonthlyAppointments', { selected_month: new Date(payload.selected_date).getMonth() + 1, store_id: payload.store_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCostSheet = function fetchCostSheet(_ref21, payload) {
    var commit = _ref21.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/fetchCostSheet.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setSalesCostSheet', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSalesOrderWIP = function fetchSalesOrderWIP(_ref22, payload) {
    var commit = _ref22.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/fetchSalesOrderWIP.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var emailSaleList = function emailSaleList(_ref23, payload) {
    var commit = _ref23.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/emailSaleList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var saleDeliveryMarkingShortcut = function saleDeliveryMarkingShortcut(_ref24, payload) {
    var commit = _ref24.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/saleDeliveryMarkingShortcut.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitNewSaleItem = function submitNewSaleItem(_ref25, payload) {
    var commit = _ref25.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/submitNewSaleItem.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        payload.id = res.data.list_id;
        payload.sl_no = res.data.sl_no;
        payload.combination_item_list = res.data.combinationItemList;

        commit('mutateSaleOrderItemStatus', payload);
        //dispatch('fetchSaleMasterData', {id: payload.sale_id, navigate: false, fabricPriceSlabExists: payload.fabricPriceSlabExists})
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateSalePromiseDateShortcut = function updateSalePromiseDateShortcut(_ref26, payload) {
    var commit = _ref26.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/updateSalePromiseDateShortcut.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log('promise date updated');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleMasterList", function() { return setSaleMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRedeemSalesDiscountCoupon", function() { return setRedeemSalesDiscountCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOverrideSalesDiscount", function() { return setOverrideSalesDiscount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetRedeemSalesDiscountCoupon", function() { return resetRedeemSalesDiscountCoupon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleMasterOutstandingList", function() { return setSaleMasterOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSaleMasterOutstandingList", function() { return resetSaleMasterOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setItemAutocompleteList", function() { return setItemAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetItemAutocompleteList", function() { return resetItemAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleMasterData", function() { return setSaleMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleMailTrigger", function() { return setSaleMailTrigger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleSaleTaxPlacement", function() { return toggleSaleTaxPlacement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyNewSaleMasterOrderItem", function() { return copyNewSaleMasterOrderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewSaleMasterOrderItem", function() { return addNewSaleMasterOrderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEditNetTotal", function() { return setEditNetTotal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "editRowCalculations", function() { return editRowCalculations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleMasterBalance", function() { return setSaleMasterBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSaleMasterItemListRow", function() { return removeSaleMasterItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubCategorySaleItemList", function() { return setSubCategorySaleItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFabricSaleItemList", function() { return setFabricSaleItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSalesExchangeRate", function() { return setSalesExchangeRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSaleMasterData", function() { return resetSaleMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSalePrintWindow", function() { return setSalePrintWindow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWOProcessing", function() { return setWOProcessing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openWorkOrderPopup", function() { return openWorkOrderPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSalesCostSheet", function() { return setSalesCostSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTrialScheduleList", function() { return setTrialScheduleList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutateSaleOrderItemStatus", function() { return mutateSaleOrderItemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleItemListLoading", function() { return setSaleItemListLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleDataItemList", function() { return setSaleDataItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleShortcutInfo", function() { return setSaleShortcutInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(351);


var setSaleMasterList = function setSaleMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setRedeemSalesDiscountCoupon = function setRedeemSalesDiscountCoupon(state, payload) {
    state.props.discount_coupon_id = payload.id;
    state.props.discount_coupon_percent = payload.discount_percent;
    state.props.discount_coupon_fixed_amount = payload.discount_fixed_amount;

    state.props.item_list.forEach(function (item) {
        item.discount_percent = payload.discount_percent;
        item.discount_amount = payload.discount_fixed_amount;
    });
};

var setOverrideSalesDiscount = function setOverrideSalesDiscount(state, payload) {
    state.props.item_list.forEach(function (item) {
        if (!isNaN(parseFloat(item.net_total)) && parseFloat(item.net_total) > 0) {
            item.discount_percent = payload.discount_percent;
            item.discount_amount = payload.discount_fixed_amount;
        }
    });
};

var resetRedeemSalesDiscountCoupon = function resetRedeemSalesDiscountCoupon(state) {
    state.props.discount_coupon_id = 0;
    state.props.discount_coupon_code = '';
    state.props.discount_coupon_percent = 0;

    state.props.item_list.forEach(function (item) {
        item.discount_percent = 0;
        item.discount_amount = 0;
    });
};

var setSaleMasterOutstandingList = function setSaleMasterOutstandingList(state, payload) {
    state.outstanding_list = payload;
};

var resetSaleMasterOutstandingList = function resetSaleMasterOutstandingList(state) {
    state.outstanding_list = [];
};

var setItemAutocompleteList = function setItemAutocompleteList(state, payload) {
    state.item_autocomplete_list = payload;
};

var resetItemAutocompleteList = function resetItemAutocompleteList(state) {
    state.item_autocomplete_list = [];
};

var setSaleMasterData = function setSaleMasterData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = []; //[JSON.parse(JSON.stringify(itemListProps))]
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
        //
    });
};

var setSaleMailTrigger = function setSaleMailTrigger(state, payload) {
    state.print.printSrc = payload.master_url + '&sale_id=' + payload.id + '&access_token=' + payload.access_token + '&subpage=email&pagesize=';
    state.print.showPrintWindow = true;
};

var toggleSaleTaxPlacement = function toggleSaleTaxPlacement(state) {
    state.props.item_list.forEach(function (element) {

        if (element.id === 0) {
            if (state.props.tax_id === 0) {
                element.tailoring_tax_percent = 0;
                element.fabric_tax_percent = 0;
                element.tax_percent = 0;
            } else {
                if (element.tailoring_item_id > 0) {

                    var tailoringTaxPercent = 0;
                    var fabricTaxPercent = 0;
                    var taxPercent = 0;

                    if (state.props.tax_percent > 0) {
                        element.tailoring_detail.tailoring_and_fabric_tax_percent = state.props.tax_percent;
                        element.fabric_detail.tax_percent = state.props.tax_percent;
                        element.tailoring_detail.tailoring_tax_percent = state.props.tax_percent;

                        tailoringTaxPercent = state.props.tax_percent;
                        fabricTaxPercent = state.props.tax_percent;
                        taxPercent = state.props.tax_percent;
                    } else {
                        taxPercent = parseFloat(element.tailoring_detail.tailoring_and_fabric_tax_percent);

                        var show_item_breakup_in_invoice = element.tailoring_detail.show_item_breakup_in_invoice === 1;
                        if (show_item_breakup_in_invoice) {
                            tailoringTaxPercent = parseFloat(element.tailoring_detail.tailoring_tax_percent);
                            fabricTaxPercent = parseFloat(element.fabric_detail.tax_percent);
                            taxPercent = element.fabric_id > 0 ? (tailoringTaxPercent + fabricTaxPercent) / 2 : tailoringTaxPercent;
                        }
                    }

                    element.tailoring_tax_percent = tailoringTaxPercent;
                    element.fabric_tax_percent = fabricTaxPercent;
                    element.tax_percent = taxPercent;
                } else if (element.retail_item_id > 0) {
                    if (state.props.tax_percent > 0) {
                        element.retail_detail.tax_percent = state.props.tax_percent;
                    }
                    var _taxPercent = parseFloat(element.retail_detail.tax_percent);
                    element.tax_percent = _taxPercent;
                }
            }
        }
    });
};

var copyNewSaleMasterOrderItem = function copyNewSaleMasterOrderItem(state, payload) {

    var props = payload;
    props.id = 0;

    if (props.work_order_id !== null && props.work_order_id !== undefined && props.work_order_id > 0) {
        props.work_order_id = 0;
    }
    props.combination_item_list.forEach(function (item) {
        item.work_order_id = 0;
        item.id = 0;
    });

    var lengthIndex = state.props.item_list.length;
    var slNo = 0;
    if (state.props.item_list[lengthIndex - 1] !== undefined) {
        slNo = state.props.item_list[lengthIndex - 1].sl_no;
    }

    if (lengthIndex > 0) {
        slNo = slNo + 1;
    }

    var key = 0;
    state.props.item_list.push(props);
    lengthIndex = state.props.item_list.length;
    state.props.item_list[lengthIndex - 1].sl_no = slNo;

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('sale_qty_' + (key - 1)).focus();
    }, 300);
};

var addNewSaleMasterOrderItem = function addNewSaleMasterOrderItem(state, payload) {

    var props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]));

    if (payload.item_type === 0) {

        var tailoringUnitSalePrice = parseFloat(payload.selected_item.base_sales_price);
        var fabricUnitQty = isNaN(parseFloat(payload.required_fabric_unit)) ? 0 : parseFloat(payload.required_fabric_unit);
        var fabricUnitSalePrice = isNaN(parseFloat(payload.fabric_sales_price)) ? 0 : parseFloat(payload.fabric_sales_price);

        var taxPercent = parseFloat(payload.selected_item.tailoring_and_fabric_tax_percent);
        var tailoringTaxPercent = 0;
        var fabricTaxPercent = 0;

        var show_item_breakup_in_invoice = payload.selected_item.show_item_breakup_in_invoice === 1;
        if (show_item_breakup_in_invoice) {
            tailoringTaxPercent = parseFloat(payload.selected_item.tailoring_tax_percent);
            fabricTaxPercent = parseFloat(payload.selected_item.selected_fabric.tax_percent);
            taxPercent = payload.selected_item.selected_fabric.id > 0 ? (tailoringTaxPercent + fabricTaxPercent) / 2 : tailoringTaxPercent;
        }

        props.tailoring_item_id = payload.selected_item.id;
        props.tailoring_detail = payload.selected_item;
        props.is_combination_tailoring_item = payload.selected_item.is_combination_item === 1;
        props.combination_item_list = payload.tailoring_combination_item_list;
        props.fabric_id = payload.selected_item.selected_fabric.id;
        props.fabric_detail = payload.selected_item.selected_fabric;
        props.fabric_unit_qty = fabricUnitQty;
        props.tailoring_unit_rate = tailoringUnitSalePrice;
        props.fabric_unit_rate = fabricUnitSalePrice;

        props.show_item_breakup_in_invoice = show_item_breakup_in_invoice;

        props.tailoring_tax_percent = tailoringTaxPercent;
        props.fabric_tax_percent = fabricTaxPercent;
        props.tax_percent = taxPercent;

        props.fabric_actual_rate = isNaN(parseFloat(payload.fabric_actual_rate)) ? 0 : parseFloat(payload.fabric_actual_rate);
        props.fabric_price_fixed = payload.fabric_price_fixed;

        state.order_tab = '1';
    } else if (payload.item_type > 0) {

        var _taxPercent2 = parseFloat(payload.selected_item.tax_percent);

        props.retail_item_id = payload.selected_item.id;
        props.retail_detail = payload.selected_item;
        var retailUnitSalePrice = parseFloat(payload.selected_item.sale_price);

        if (payload.selected_item.default_retail_fabric_unit && payload.selected_item.default_retail_fabric_unit > 0) {
            props.retail_qty = payload.selected_item.default_retail_fabric_unit;
            if (payload.selected_item.flat_price > 0) {
                retailUnitSalePrice = payload.selected_item.flat_price;
            }
        }

        props.retail_unit_rate = retailUnitSalePrice;
        props.tax_percent = _taxPercent2;

        //state.order_tab = '2'
    }

    if (state.props.tax_id === 0) {
        props.tailoring_tax_percent = 0;
        props.fabric_tax_percent = 0;
        props.tax_percent = 0;
    }

    var lengthIndex = state.props.item_list.length;
    var slNo = 0;
    if (state.props.item_list[lengthIndex - 1] !== undefined) {
        slNo = state.props.item_list[lengthIndex - 1].sl_no;
    }

    if (lengthIndex > 0) {
        slNo = slNo + 1;
    }

    var key = 0;
    state.props.item_list.push(props);
    lengthIndex = state.props.item_list.length;
    state.props.item_list[lengthIndex - 1].sl_no = slNo;

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        if (payload.sale_step_post_qty === 2) {
            document.getElementById('item_search_field' + payload.item_type).focus();
            document.getElementById('item_search_field' + payload.item_type).value = '';
        } else {
            if (document.getElementById('sale_qty_' + (key - 1))) {
                document.getElementById('sale_qty_' + (key - 1)).focus();
            }
        }
    }, 300);
};

var setEditNetTotal = function setEditNetTotal(state) {
    /*state.props.item_list.forEach(element => {
        let copy = JSON.parse(JSON.stringify(element))
        element.edit_net_total = copy.net_total
    })*/
};

var editRowCalculations = function editRowCalculations(state) {

    var totalQty = 0;
    var saleSubTotal = 0;
    var saleDiscountAmount = 0;
    var saleTaxableAmount = 0;
    var saleTotalTax = 0;
    var shippingAndHandling = parseFloat(state.props.shipping_and_handling);
    if (isNaN(shippingAndHandling)) {
        shippingAndHandling = 0;
    }
    var adjustment = parseFloat(state.props.adjustment);
    if (isNaN(adjustment)) {
        adjustment = 0;
    }
    var saleNetTotal = 0;

    state.props.item_list.forEach(function (element) {

        //check if net total altered
        var alterNetTotal = parseFloat(element.alter_net_total);
        var netTotal = parseFloat(element.net_total);
        if (alterNetTotal < netTotal && alterNetTotal > 0) {
            element.alter_net_total = 0;
            return;
        }
        var increasePercent = 0;
        if (alterNetTotal > 0) {
            if (netTotal > 0) {
                increasePercent = (alterNetTotal - netTotal) / netTotal * 100;
            }
        }
        //
        var tailoringQty = parseFloat(element.tailoring_qty);
        var tailoringUnitSalePrice = parseFloat(element.tailoring_unit_rate);
        var extraChargeUnitRate = parseFloat(element.extra_charge_unit_rate);
        console.log("1", tailoringUnitSalePrice);
        var fabricUnitQty = parseFloat(element.fabric_unit_qty);
        var fabricUnitSalePrice = parseFloat(element.fabric_unit_rate);

        if (element.fabric_price_fixed && element.fabric_actual_rate !== undefined) {
            fabricUnitSalePrice = (parseFloat(element.fabric_actual_rate) / fabricUnitQty).toFixed(2);
            element.fabric_unit_rate = fabricUnitSalePrice;
        }

        if (fabricUnitSalePrice === 0 && element.tailoring_item_id > 0) {
            if (alterNetTotal > 0) {
                fabricUnitSalePrice = (alterNetTotal / 100 + parseFloat(element.tax_percent)) * 100;
                element.fabric_unit_rate = fabricUnitSalePrice;
            }
        }

        var retailUnitSalePrice = parseFloat(element.retail_unit_rate);
        if (retailUnitSalePrice === 0 && element.retail_item_id > 0) {
            retailUnitSalePrice = (alterNetTotal / 100 + parseFloat(element.tax_percent)) * 100;
            element.retail_unit_rate = retailUnitSalePrice;
        }
        var retailQty = parseFloat(element.retail_qty);

        if (increasePercent > 0) {
            tailoringUnitSalePrice = increasePercent * tailoringUnitSalePrice / 100 + tailoringUnitSalePrice;
            extraChargeUnitRate = increasePercent * extraChargeUnitRate / 100 + extraChargeUnitRate;
            if (element.tailoring_item_id > 0) {
                element.tailoring_unit_rate = tailoringUnitSalePrice;
                element.extra_charge_unit_rate = extraChargeUnitRate;
            } else {
                element.tailoring_unit_rate = 0;
            }

            fabricUnitSalePrice = increasePercent * fabricUnitSalePrice / 100 + fabricUnitSalePrice;
            if (element.tailoring_item_id > 0) {
                element.fabric_unit_rate = fabricUnitSalePrice;
            } else {
                element.fabric_unit_rate = 0;
            }

            retailUnitSalePrice = increasePercent * retailUnitSalePrice / 100 + retailUnitSalePrice;
            if (element.retail_item_id > 0) {
                element.retail_unit_rate = retailUnitSalePrice;
            } else {
                element.retail_unit_rate = 0;
            }

            element.alter_net_total = 0;
            element.discount_percent = 0;
            element.discount_amount = 0;
        }
        console.log("2", tailoringUnitSalePrice);
        var extra_amount = parseFloat(element.extra_amount);
        element.extra_amount = isNaN(extra_amount) ? 0 : extra_amount;
        extra_amount = element.extra_amount;

        var tailoringTotal = tailoringUnitSalePrice * tailoringQty;
        var extraChargeTotal = extraChargeUnitRate * tailoringQty + extra_amount;
        var fabricTotal = fabricUnitQty * fabricUnitSalePrice * tailoringQty;
        var retailTotal = retailQty * retailUnitSalePrice;
        console.log("2.1", tailoringTotal);
        var subTotal = fabricTotal + tailoringTotal + extraChargeTotal + retailTotal;
        element.sub_total = subTotal;
        //calculate taxes
        var discountPercent = parseFloat(element.discount_percent);
        if (isNaN(discountPercent)) {
            discountPercent = 0;
        }
        var discountAmount = parseFloat(element.discount_amount);
        if (isNaN(discountAmount)) {
            discountAmount = 0;
        }
        if (discountPercent > 0) {
            discountAmount = discountPercent * subTotal / 100;
        } else if (discountAmount > 0) {
            discountPercent = parseFloat(((discountAmount - subTotal) / subTotal * 100 + 100).toFixed(2));
            element.discount_percent = 0;
        }
        //end
        /** ITEM LEVEL DISCOUNT **/
        var directTailoringDiscount = 0;
        if (element.tailoring_detail !== null) {
            directTailoringDiscount = element.tailoring_detail.discount_percent ? parseFloat(element.tailoring_detail.discount_percent) : 0;
        }
        directTailoringDiscount = parseFloat((directTailoringDiscount * tailoringTotal / 100).toFixed(2));
        var tailoringDiscountAmount = directTailoringDiscount + parseFloat((discountPercent * tailoringTotal / 100).toFixed(2));
        var extraChargeDiscountAmount = parseFloat((discountPercent * extraChargeTotal / 100).toFixed(2));

        var directFabricDiscount = 0;
        if (element.fabric_detail !== null) {
            directFabricDiscount = element.fabric_detail.discount_percent ? parseFloat(element.fabric_detail.discount_percent) : 0;
        }
        directFabricDiscount = parseFloat((directFabricDiscount * fabricTotal / 100).toFixed(2));
        var fabricDiscountAmount = directFabricDiscount + parseFloat((discountPercent * fabricTotal / 100).toFixed(2));

        var directRetailDiscount = 0;
        if (element.retail_detail !== null) {
            directRetailDiscount = element.retail_detail.discount_percent ? parseFloat(element.retail_detail.discount_percent) : 0;
        }
        directRetailDiscount = parseFloat((directRetailDiscount * retailTotal / 100).toFixed(2));

        var retailDiscountAmount = directRetailDiscount + parseFloat((discountPercent * retailTotal / 100).toFixed(2));
        /** END ITEM LEVEL DISCOUNT **/

        var totalLineDiscount = directFabricDiscount + directTailoringDiscount + directRetailDiscount;

        element.discount_amount = discountAmount;
        element.taxable_total = subTotal - (discountAmount + totalLineDiscount);

        var taxableTotal = parseFloat(element.taxable_total);
        var taxPercent = parseFloat(element.tax_percent);
        var tailoringTaxPercent = 0;
        var fabricTaxPercent = 0;

        element.tailoring_unit_discount_amount = parseFloat((tailoringDiscountAmount / tailoringQty).toFixed(2));
        element.extra_charge_unit_discount_amount = parseFloat((extraChargeDiscountAmount / tailoringQty).toFixed(2));
        element.fabric_unit_discount_amount = parseFloat((fabricDiscountAmount / fabricUnitQty / tailoringQty).toFixed(2));
        element.retail_unit_discount_amount = parseFloat((retailDiscountAmount / retailQty).toFixed(2));

        var tailoringTaxAmount = taxPercent * (tailoringTotal + extraChargeTotal - (tailoringDiscountAmount + extraChargeDiscountAmount)) / 100;

        var fabricTaxAmount = taxPercent * (fabricTotal - fabricDiscountAmount) / 100;
        var retailTaxAmount = taxPercent * (retailTotal - retailDiscountAmount) / 100;

        var show_item_breakup_in_invoice = element.show_item_breakup_in_invoice;
        if (show_item_breakup_in_invoice) {
            tailoringTaxPercent = parseFloat(element.tailoring_tax_percent);
            fabricTaxPercent = parseFloat(element.fabric_tax_percent);
            taxPercent = element.fabric_id > 0 ? (tailoringTaxPercent + fabricTaxPercent) / 2 : tailoringTaxPercent;

            tailoringTaxAmount = tailoringTaxPercent * (tailoringTotal + extraChargeTotal - (tailoringDiscountAmount + extraChargeDiscountAmount)) / 100;
            fabricTaxAmount = fabricTaxPercent * (fabricTotal - fabricDiscountAmount) / 100;
        }
        var taxAmount = tailoringTaxAmount + fabricTaxAmount + retailTaxAmount;

        element.tailoring_tax_amount = tailoringTaxAmount;
        element.fabric_tax_amount = fabricTaxAmount;
        element.tax_amount = taxAmount;

        if (state.props.tax_id === 0) {
            element.tailoring_tax_percent = 0;
            element.fabric_tax_percent = 0;
            element.tax_percent = 0;

            element.tailoring_tax_amount = 0;
            element.fabric_tax_amount = 0;
            element.tax_amount = 0;
        }

        element.net_total = parseFloat((taxableTotal + taxAmount).toFixed(2));

        //let rowData = JSON.parse(JSON.stringify(element))
        //element.edit_net_total = rowData.net_total

        //CALCULATE TOTALS
        if (element.tailoring_item_id > 0) {
            totalQty = totalQty + tailoringQty;
        } else if (element.retail_item_id > 0) {
            totalQty = totalQty + retailQty;
        }
        saleSubTotal = subTotal + saleSubTotal;
        saleDiscountAmount = saleDiscountAmount + (discountAmount + totalLineDiscount);
        saleTaxableAmount = saleTaxableAmount + taxableTotal;
        saleTotalTax = saleTotalTax + taxAmount;
        saleNetTotal = saleNetTotal + parseFloat(element.net_total);
        //END
    });

    //state.order_tab = lastItem

    saleNetTotal = shippingAndHandling + adjustment + saleNetTotal;

    state.props.total_qty = totalQty;
    state.props.net_total = saleNetTotal;
    state.props.sub_total = saleSubTotal;
    state.props.discount_amount = saleDiscountAmount;
    state.props.taxable_total = saleTaxableAmount;
    state.props.total_tax = saleTotalTax;
    state.props.net_total = saleNetTotal;

    var totalPaid = parseFloat(state.props.total_paid);
    var balance = saleNetTotal - totalPaid;
    state.props.balance = balance;
};

var setSaleMasterBalance = function setSaleMasterBalance(state, payload) {
    var saleNetTotal = state.props.net_total;
    state.props.total_paid = payload;
    var totalPaid = parseFloat(state.props.total_paid);
    var balance = saleNetTotal - totalPaid;
    state.props.balance = balance;
};

var removeSaleMasterItemListRow = function removeSaleMasterItemListRow(state, payload) {

    var key = 0;

    state.props.deleted_item_list.push(state.props.item_list[payload]);

    state.props.item_list.splice(payload, 1);

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setSubCategorySaleItemList = function setSubCategorySaleItemList(state, payload) {
    state.items.total_rows = payload.total_rows, state.items.item_sub_category_id = payload.item_sub_category_id, state.items.item_type = payload.item_type, state.items.offset = payload.offset, state.items.list = payload.list;

    if (payload.list.length > 0) {
        state.showCategoryWindow = true;
    }
    state.show_category = [];
};

var setFabricSaleItemList = function setFabricSaleItemList(state, payload) {
    state.fabric.total_rows = payload.total_rows, state.fabric.list = payload.list;
};

var setSalesExchangeRate = function setSalesExchangeRate(state, payload) {
    state.props.exchange_rate = payload;
};

var resetSaleMasterData = function resetSaleMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setSalePrintWindow = function setSalePrintWindow(state, payload) {
    state.print.printTitle = payload.printTitle;
    state.print.printSrc = payload.master_url + '&sale_id=' + payload.sale_id + '&access_token=' + payload.access_token + '&subpage=print&pageSize=' + payload.pageSize;
    state.print.showPrintWindow = true;
};

var setWOProcessing = function setWOProcessing(state, payload) {
    state.props.item_list[payload.index].wo_processing = payload.status;
    if (payload.work_order_id) {
        state.props.item_list[payload.index].work_order_id = payload.work_order_id;
    }
};

var openWorkOrderPopup = function openWorkOrderPopup(state) {
    state.showWorkOrder = true;
};

var setSalesCostSheet = function setSalesCostSheet(state, payload) {
    state.sales_cost_sheet = payload;
};

var setTrialScheduleList = function setTrialScheduleList(state, payload) {
    state.trial_schedule_list = payload;
};

var mutateSaleOrderItemStatus = function mutateSaleOrderItemStatus(state, payload) {
    state.props.item_list[payload.key] = payload;
    state.props.item_list[payload.key].wo_processing = false;
};

var setSaleItemListLoading = function setSaleItemListLoading(state, payload) {
    state.props.item_list_loading = payload;
};

var setSaleDataItemList = function setSaleDataItemList(state, payload) {
    state.props.item_list = payload;
};

var setSaleShortcutInfo = function setSaleShortcutInfo(state, payload) {
    state.props.id = payload.id;
    state.props.sale_number_prefix = payload.sale_number_prefix;
    state.props.sale_number = payload.sale_number;
};

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleMasterList", function() { return getSaleMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleMasterDataProps", function() { return getSaleMasterDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItemAutocompleteList", function() { return getItemAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleMasterOutstandingList", function() { return getSaleMasterOutstandingList; });
var getSaleMasterList = function getSaleMasterList(state) {
    return state.list;
};

var getSaleMasterDataProps = function getSaleMasterDataProps(state) {
    return state.props;
};

var getItemAutocompleteList = function getItemAutocompleteList(state) {
    return state.item_autocomplete_list;
};

var getSaleMasterOutstandingList = function getSaleMasterOutstandingList(state) {
    return state.outstanding_list;
};

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__customerPayment_actions__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__customerPayment_mutations__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__customerPayment_getters__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customerPayment_properties__ = __webpack_require__(352);






var state = {
    list: [],
    settlement_type: 1,
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__customerPayment_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__customerPayment_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__customerPayment_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__customerPayment_actions__
});

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerPaymentList", function() { return fetchCustomerPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCustomerPaymentData", function() { return fetchCustomerPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCustomerPaymentData", function() { return submitCustomerPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCustomerPaymentData", function() { return deleteCustomerPaymentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchCustomerPaymentList = function fetchCustomerPaymentList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerPayment/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.status) {
                commit('setCustomerPaymentList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
                if (payload.fetch_sale_order) {
                    dispatch('fetchSaleMasterDataBalance', { id: payload.sale_id });
                }
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error-1' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchCustomerPaymentData = function fetchCustomerPaymentData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerPayment/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setCustomerPaymentData', { response: res.data.response, copy: payload.copy });
            commit('setCustomerMasterAutocompleteList', [{
                id: res.data.response.customer_id,
                type_of_customer: res.data.response.type_of_customer,
                salutation_name: res.data.response.salutation_name,
                customer_name: res.data.response.customer_name,
                company_name: res.data.response.company_name
            }]);
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetCustomerPaymentData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCustomerPaymentData = function submitCustomerPaymentData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerPayment/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            if (payload.redeemed_amount > 0) {
                dispatch('fetchSaleMasterList', {
                    customer_id: payload.customer_id,
                    show_outstanding: true,
                    store_list: payload.store_list
                });
            }
            commit('resetCustomerPaymentFormpartial');
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCustomerPaymentData = function deleteCustomerPaymentData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/customerPayment/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                if (payload.sale_id > 0) {
                    payload.list.sale_id = payload.sale_id;
                }
                dispatch('fetchCustomerPaymentList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-2' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerPaymentList", function() { return setCustomerPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCustomerPaymentData", function() { return setCustomerPaymentData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerPaymentFormpartial", function() { return resetCustomerPaymentFormpartial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCustomerPaymentData", function() { return resetCustomerPaymentData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(352);


var setCustomerPaymentList = function setCustomerPaymentList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setCustomerPaymentData = function setCustomerPaymentData(state, payload) {
    state.props = payload.response;
};

var resetCustomerPaymentFormpartial = function resetCustomerPaymentFormpartial(state) {
    state.props.paid_amount = 0;
    state.props.payment_mode_id = null;
};

var resetCustomerPaymentData = function resetCustomerPaymentData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerPaymentList", function() { return getCustomerPaymentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomerPaymentDataProps", function() { return getCustomerPaymentDataProps; });
var getCustomerPaymentList = function getCustomerPaymentList(state) {
    return state.list;
};

var getCustomerPaymentDataProps = function getCustomerPaymentDataProps(state) {
    return state.props;
};

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__workOrder_actions__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__workOrder_mutations__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workOrder_getters__ = __webpack_require__(1478);




var state = {
    list: [],
    autocomplete_list: [],
    props: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__workOrder_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__workOrder_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__workOrder_actions__
});

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSingleWorkOrder", function() { return fetchSingleWorkOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWorkOrderAutocompleteList", function() { return fetchWorkOrderAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitWorkOrderData", function() { return submitWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lazyLoadWorkOrderMeasurements", function() { return lazyLoadWorkOrderMeasurements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lazyLoadWorkOrderSections", function() { return lazyLoadWorkOrderSections; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchSingleWorkOrder = function fetchSingleWorkOrder(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    var response = null;
    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/fetchSingleWorkOrder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        console.log(JSON.stringify(res.data));
        response = res.data.response;

        if (payload.download_request) {
            response.forEach(function (element) {
                element.id = 0;
                element.sale_item_id = payload.sale_item_id_copy;
                element.sale_item_sub_id = payload.sale_item_sub_id_copy;
            });
            commit('displaySuccessNotification', { message: 'Data downloaded successfully!!!' });
        }

        commit('setSingleWorkOrderData', { response: response, wo_index: payload.wo_index, shortcut: payload.shortcut });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        setTimeout(function () {
            console.log(JSON.stringify(response));
            if (payload.work_order_id === 0) {
                dispatch('lazyLoadWorkOrderMeasurements', response);
            } else {
                commit('toggleLoadingState', false);
            }
        }, 1000);
    });
};

var fetchWorkOrderAutocompleteList = function fetchWorkOrderAutocompleteList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/fetchWorkOrderAutocompleteList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        var response = [];

        if (res.data.response.production) {
            res.data.response.production.forEach(function (element) {
                element.source = 'production';
                response.push(element);
            });
        }

        if (res.data.response.customer) {
            res.data.response.customer.forEach(function (element) {
                element.source = 'customer';
                response.push(element);
            });
        }

        commit('setWorkOrderAutocompleteList', response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-Work-Order' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitWorkOrderData = function submitWorkOrderData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);
    if (payload.sale_item_index >= 0) {
        commit('setWOProcessing', { index: payload.sale_item_index, status: true });
    }
    setTimeout(function () {
        commit('displaySuccessNotification', { message: 'Work-Order submitted successfully!!!' });
        if (!payload.shortcut) {
            commit('toggleLoadingState', false);
        }
    }, 2000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/submitWorkOrder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            if (payload.sale_item_index >= 0) {
                commit('setWOProcessing', { work_order_id: res.data.work_order_id, index: payload.sale_item_index, status: false });
            }
            if (payload.shortcut) {
                dispatch('fetchSingleWorkOrder', { shortcut: payload.shortcut, work_order_id: payload.work_order_list[0].id, sale_item_id: payload.work_order_list[0].sale_item_id,
                    tailoring_item_id: payload.work_order_list[0].tailoring_item_id, customer_id: payload.work_order_list[0].customer_id });
            }
            //
            if (payload.sale_id) {
                //dispatch('fetchSaleMasterData', {id: payload.sale_id})
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        if (!payload.shortcut) {
            commit('toggleLoadingState', false);
        }
    });
};

var lazyLoadWorkOrderMeasurements = function lazyLoadWorkOrderMeasurements(_ref4, payload) {
    var commit = _ref4.commit;

    commit('toggleLoadingState', true);
    //console.log(JSON.stringify(payload))
    payload.forEach(function (element) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/lazyLoad/index.php', { workOrderData: element, activeTab: '2' }, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            //return
            commit('setLazyLoadWorkOrder', {
                response: res.data.response,
                previousPayload: element,
                activeTab: '2',
                tailoring_item_id: element.tailoring_item_id
            });
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error-Work-Order' });
        }).finally(function () {});
    });

    commit('toggleLoadingState', false);
};

var lazyLoadWorkOrderSections = function lazyLoadWorkOrderSections(_ref5, payload) {
    var commit = _ref5.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/lazyLoad/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        //console.log(JSON.stringify(res.data))
        //return
        commit('setLazyLoadWorkOrder', {
            response: res.data.response,
            previousPayload: payload.workOrderData,
            activeTab: payload.activeTab
        });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error-Work-Order' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderAutocompleteList", function() { return setWorkOrderAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetWorkOrderAutocompleteList", function() { return resetWorkOrderAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSingleWorkOrderData", function() { return setSingleWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderLoad", function() { return setWorkOrderLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSingleWorkOrderData", function() { return resetSingleWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLazyLoadWorkOrder", function() { return setLazyLoadWorkOrder; });
var setWorkOrderAutocompleteList = function setWorkOrderAutocompleteList(state, payload) {
    state.autocomplete_list = payload;
};

var resetWorkOrderAutocompleteList = function resetWorkOrderAutocompleteList(state) {
    state.autocomplete_list = [];
};

var setSingleWorkOrderData = function setSingleWorkOrderData(state, payload) {

    if (payload.wo_index !== undefined) {
        var workOrderHistory = JSON.parse(JSON.stringify(state.props[payload.wo_index].work_order_history));
        state.props[payload.wo_index].special_instruction = payload.response[0].special_instruction;
        state.props[payload.wo_index].internal_remarks = payload.response[0].internal_remarks;
        state.props[payload.wo_index].customer_measurement_profile = payload.response[0].customer_measurement_profile;
        state.props[payload.wo_index].style_list = payload.response[0].style_list;
        state.props[payload.wo_index].process_list = payload.response[0].process_list;
        state.props[payload.wo_index].work_order_history = workOrderHistory;
    } else {
        if (payload.shortcut) {
            payload.response.forEach(function (element) {
                element.trial_form.take_trial = element.trial_history.length > 0;
            });
        }
        state.props = payload.response;
    }
};

var setWorkOrderLoad = function setWorkOrderLoad(state, payload) {
    var list = state.props;
    var listIndex = list.findIndex(function (t) {
        return t.sale_item_id == payload.sale_item_id && t.tailoring_item_id == payload.tailoring_item_id;
    });

    var distinctDates = payload.list.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
            return t.appointment_date === thing.appointment_date;
        });
    });

    var workOrderLoad = [];
    distinctDates.forEach(function (element) {
        workOrderLoad.push({
            appointment_date: element.appointment_date,
            appointment_date_changed: element.appointment_date_changed,
            delivery: payload.list.filter(function (t) {
                return t.appointment_date == element.appointment_date && t.appointment_type === 0;
            }).length,
            trial: payload.list.filter(function (t) {
                return t.appointment_date == element.appointment_date && t.appointment_type === 1;
            }).length
        });
    });

    state.props[listIndex].work_order_load = workOrderLoad;
};

var resetSingleWorkOrderData = function resetSingleWorkOrderData(state) {
    state.props = [];
};

var setLazyLoadWorkOrder = function setLazyLoadWorkOrder(state, payload) {
    var workOrderIndex = state.props.findIndex(function (t) {
        return t.sale_item_id === payload.previousPayload.sale_item_id && t.sale_item_sub_id === payload.previousPayload.sale_item_sub_id;
    });

    if (workOrderIndex >= 0) {
        if (payload.activeTab === '2') {
            state.props[workOrderIndex].customer_measurement_profile = payload.response;
            state.props[workOrderIndex].measurement_loading = false;
            console.log(workOrderIndex, state.props[workOrderIndex].measurement_loading);
        } else if (payload.activeTab === '3') {
            state.props[workOrderIndex].style_list = payload.response;
        } else if (payload.activeTab === '4') {
            state.props[workOrderIndex].process_list = payload.response;
        }
    }
};

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWorkOrderDataProps", function() { return getWorkOrderDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWorkOrderAutocompleteList", function() { return getWorkOrderAutocompleteList; });
var getWorkOrderDataProps = function getWorkOrderDataProps(state) {
    return state.props;
};

var getWorkOrderAutocompleteList = function getWorkOrderAutocompleteList(state) {
    return state.autocomplete_list;
};

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__giftCard_actions__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__giftCard_mutations__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__giftCard_getters__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__giftCard_properties__ = __webpack_require__(353);






var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    autocomplete_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__giftCard_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__giftCard_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__giftCard_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__giftCard_actions__
});

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGiftCardList", function() { return fetchGiftCardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGiftCardAutocompleteList", function() { return fetchGiftCardAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchGiftCardData", function() { return fetchGiftCardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitGiftCardData", function() { return submitGiftCardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteGiftCardData", function() { return deleteGiftCardData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchGiftCardList = function fetchGiftCardList(_ref, payload) {
    var commit = _ref.commit;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        commit('toggleLoadingState', false);
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/giftCard/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.status) {
                commit('setGiftCardList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchGiftCardAutocompleteList = function fetchGiftCardAutocompleteList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/giftCard/autocomplete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setGiftCardAutocompleteList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchGiftCardData = function fetchGiftCardData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/giftCard/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setGiftCardData', { response: res.data.response, copy: payload.copy });
            commit('setCustomerMasterAutocompleteList', [{
                id: res.data.response.customer_id,
                type_of_customer: res.data.response.type_of_customer,
                salutation_name: res.data.response.salutation_name,
                customer_name: res.data.response.customer_name,
                company_name: res.data.response.company_name
            }]);
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetGiftCardData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitGiftCardData = function submitGiftCardData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/giftCard/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteGiftCardData = function deleteGiftCardData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/giftCard/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchGiftCardList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGiftCardList", function() { return setGiftCardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGiftCardData", function() { return setGiftCardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetGiftCardData", function() { return resetGiftCardData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setGiftCardAutocompleteList", function() { return setGiftCardAutocompleteList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(353);


var setGiftCardList = function setGiftCardList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setGiftCardData = function setGiftCardData(state, payload) {
    state.props = payload.response;
};

var resetGiftCardData = function resetGiftCardData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setGiftCardAutocompleteList = function setGiftCardAutocompleteList(state, payload) {
    state.autocomplete_list = payload;
};

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGiftCardList", function() { return getGiftCardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGiftCardDataProps", function() { return getGiftCardDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGiftCardAutocompleteList", function() { return getGiftCardAutocompleteList; });
var getGiftCardList = function getGiftCardList(state) {
    return state.list;
};

var getGiftCardDataProps = function getGiftCardDataProps(state) {
    return state.props;
};

var getGiftCardAutocompleteList = function getGiftCardAutocompleteList(state) {
    return state.autocomplete_list;
};

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__saleDelivery_actions__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__saleDelivery_mutations__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__saleDelivery_getters__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__saleDelivery_properties__ = __webpack_require__(354);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__saleDelivery_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__saleDelivery_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__saleDelivery_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__saleDelivery_actions__
});

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleDeliveryList", function() { return fetchSaleDeliveryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendSaleDeliveryOTP", function() { return sendSaleDeliveryOTP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchSaleDeliveryData", function() { return fetchSaleDeliveryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitSaleDeliveryData", function() { return submitSaleDeliveryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitShipment", function() { return submitShipment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteSaleDeliveryData", function() { return deleteSaleDeliveryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadReadyItemsForDelivery", function() { return loadReadyItemsForDelivery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateSaleDeliveryShipmentDetail", function() { return updateSaleDeliveryShipmentDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchSaleDeliveryList = function fetchSaleDeliveryList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchSaleDeliveryList', payload);
            } else {
                commit('setSaleDeliveryList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var sendSaleDeliveryOTP = function sendSaleDeliveryOTP(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/generateOTP.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setSaleDeliveryOTP', res.data.otp);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchSaleDeliveryData = function fetchSaleDeliveryData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            dispatch('fetchCustomerMasterData', { id: res.data.response.customer_id });
            commit('setSaleDeliveryData', { response: res.data.response, copy: payload.copy });

            setTimeout(function () {
                if (payload.navigate) {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
                }
            }, 1000);
        } else {
            commit('resetSaleDeliveryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitSaleDeliveryData = function submitSaleDeliveryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (!payload.production_work_delivery) {
                dispatch('fetchSaleDeliveryData', { id: res.data.id });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitShipment = function submitShipment(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleMaster/submitShipment.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteSaleDeliveryData = function deleteSaleDeliveryData(_ref6, payload) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchSaleDeliveryList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadReadyItemsForDelivery = function loadReadyItemsForDelivery(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/loadReadyItemsForDelivery.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setLoadReadyItemsForDelivery', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateSaleDeliveryShipmentDetail = function updateSaleDeliveryShipmentDetail(_ref8, payload) {
    var commit = _ref8.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/updateSaleDeliveryShipmentDetail.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleDeliveryList", function() { return setSaleDeliveryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleDeliveryData", function() { return setSaleDeliveryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewSaleDeliveryItemListRow", function() { return addNewSaleDeliveryItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeSaleDeliveryItemListRow", function() { return removeSaleDeliveryItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoadReadyItemsForDelivery", function() { return setLoadReadyItemsForDelivery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSaleDeliveryData", function() { return resetSaleDeliveryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSaleDeliveryOTP", function() { return setSaleDeliveryOTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(354);


var setSaleDeliveryList = function setSaleDeliveryList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setSaleDeliveryData = function setSaleDeliveryData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewSaleDeliveryItemListRow = function addNewSaleDeliveryItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeSaleDeliveryItemListRow = function removeSaleDeliveryItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setLoadReadyItemsForDelivery = function setLoadReadyItemsForDelivery(state, payload) {

    var itemList = JSON.parse(JSON.stringify(payload));

    itemList = itemList.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
            return t.id == thing.id;
        });
    });

    state.props.item_list = [];
    state.props.pending_list = [];
    var key = 0;
    itemList.forEach(function (element) {
        if (element.hidden_process > 0 && element.current_store_id === element.store_id) {
            state.props.item_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                direct_delivery: false,
                item_detail: {
                    sale_number: element.sale_number,
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_status: element.work_status,
                    hidden_process: element.hidden_process,
                    sale_date_changed: element.sale_date_changed,
                    sale_delivery_on_full_payment: element.sale_delivery_on_full_payment,
                    balance: element.balance,
                    fabric_details: element.sku_code + ', ' + element.article_name,
                    current_store_id: element.current_store_id,
                    sale_store_id: element.store_id
                }
            });
            key++;
        }
    });

    key = 0;
    itemList.forEach(function (element) {
        if (element.hidden_process < 0 || element.current_store_id !== element.store_id) {
            state.props.pending_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                direct_delivery: false,
                item_detail: {
                    sale_number: element.sale_number,
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_status: element.work_status,
                    hidden_process: element.hidden_process,
                    sale_date_changed: element.sale_date_changed,
                    fabric_details: element.sku_code + ', ' + element.article_name
                }
            });
            key++;
        }
    });
};

var resetSaleDeliveryData = function resetSaleDeliveryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var setSaleDeliveryOTP = function setSaleDeliveryOTP(state, payload) {
    state.props.otp = payload;
};

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleDeliveryList", function() { return getSaleDeliveryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSaleDeliveryDataProps", function() { return getSaleDeliveryDataProps; });
var getSaleDeliveryList = function getSaleDeliveryList(state) {
    return state.list;
};

var getSaleDeliveryDataProps = function getSaleDeliveryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__production_actions__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__production_mutations__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__production_getters__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__production_properties__ = __webpack_require__(355);






var state = {
    list: null,
    searched: 0,
    worker_history: [],
    ready_orders: [],
    ready_order_detail_list: [],
    nav: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__production_properties__["a" /* navProps */])),
    autocomplete_list: [],
    worker_work_status_list: [],
    process_batch_list: {
        store_id: null,
        process_list: [],
        include_mo_order: false
    },
    assignment_history: [],
    planner: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__production_properties__["b" /* plannerProps */])),
    group_work_order: {
        list: [],
        nav: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__production_properties__["a" /* navProps */]))
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__production_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__production_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__production_actions__
});

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionWorkOrderAutocompleteList", function() { return fetchProductionWorkOrderAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertToInventory", function() { return convertToInventory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "putProductionOrderOnHold", function() { return putProductionOrderOnHold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionWorkerWorkStatus", function() { return fetchProductionWorkerWorkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionProcessBatchList", function() { return fetchProductionProcessBatchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionWorkOrderList", function() { return fetchProductionWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionGroupWorkOrderList", function() { return fetchProductionGroupWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWorkOrderAssignmentHistory", function() { return fetchWorkOrderAssignmentHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateWorkOrderAssignmentHistory", function() { return updateWorkOrderAssignmentHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateFabricQtyFromWorkOrder", function() { return updateFabricQtyFromWorkOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateWorkOrderAssignment", function() { return updateWorkOrderAssignment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWorkerHistory", function() { return fetchWorkerHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadReadyOrders", function() { return loadReadyOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openCustomerOrderDetails_ProductionStageWise", function() { return openCustomerOrderDetails_ProductionStageWise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notifyCustomerForReadyItems", function() { return notifyCustomerForReadyItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateScheduledDate", function() { return updateScheduledDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePriority", function() { return updatePriority; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "restartProductionProcess", function() { return restartProductionProcess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadPlannerData", function() { return loadPlannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "workOrderLoad", function() { return workOrderLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeWorkOrderTrial", function() { return removeWorkOrderTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "markWorkOrderTrial", function() { return markWorkOrderTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "approveWorkOrderTrial", function() { return approveWorkOrderTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailProcessBatch", function() { return emailProcessBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchWorkOrderSubProcessList", function() { return fetchWorkOrderSubProcessList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateWorkOrderAssignmentSubProcess", function() { return updateWorkOrderAssignmentSubProcess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchProductionWorkOrderAutocompleteList = function fetchProductionWorkOrderAutocompleteList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/autocomplete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            var response = [];
            if (res.data.response) {
                response = res.data.response.filter(function (thing, index, self) {
                    return index === self.findIndex(function (t) {
                        return t.id === thing.id;
                    });
                });
            }
            if (res.data.try_again) {} else {
                commit('setProductionAutoCompleteList', response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var convertToInventory = function convertToInventory(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/saleDelivery/convertToInventory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var putProductionOrderOnHold = function putProductionOrderOnHold(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/putProductionOrderOnHold.php', payload.item_list, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            dispatch('fetchProductionWorkOrderAutocompleteList', payload.master_payload);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionWorkerWorkStatus = function fetchProductionWorkerWorkStatus(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workerStatus.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {} else {
                commit('setProductionWorkerWorkStatus', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchProductionProcessBatchList = function fetchProductionProcessBatchList(_ref5, payload) {
    var commit = _ref5.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/processBatch/Index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionProcessBatchList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionWorkOrderList = function fetchProductionWorkOrderList(_ref6, payload) {
    var commit = _ref6.commit;


    if (!payload.order_display_window) {
        commit('toggleLoadingState', true);
    }

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        var _commit;

        //console.log(JSON.stringify(res.data))
        var response = [];
        if (res.data.response) {
            response = res.data.response.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.id === thing.id;
                });
            });
        }
        var store_query = false;
        if (payload.store_query) {
            store_query = payload.store_query;
        }
        commit('setProductionWorkOrderList', (_commit = { response: response, total: res.data.total, page_number: res.data.page_number }, _defineProperty(_commit, 'page_number', res.data.page_number), _defineProperty(_commit, 'store_query', store_query), _commit));
        if (payload.list_type == 'process_batch' && parseInt(payload.page_number) === 1) {
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/processbatch/list?list_type=process_batch&process_id=' + payload.process_id + '&workshop_id=' + payload.workshop_id);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionGroupWorkOrderList = function fetchProductionGroupWorkOrderList(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderGroupList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionGroupWorkOrderList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchWorkOrderAssignmentHistory = function fetchWorkOrderAssignmentHistory(_ref8, payload) {
    var commit = _ref8.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderAssignment/assignmentHistory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data.response));
        commit('setProductionWorkOrderAssignmentHistory', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateWorkOrderAssignmentHistory = function updateWorkOrderAssignmentHistory(_ref9, payload) {
    var commit = _ref9.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderAssignment/updateHistory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        } else {
            commit('displayMessageAlert', { message: 'Error, please try again!!!', type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateFabricQtyFromWorkOrder = function updateFabricQtyFromWorkOrder(_ref10, payload) {
    var commit = _ref10.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/updateFabricQtyFromWorkOrder.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        } else {
            commit('displayMessageAlert', { message: 'Error, please try again!!!', type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateWorkOrderAssignment = function updateWorkOrderAssignment(_ref11, payload) {
    var commit = _ref11.commit,
        dispatch = _ref11.dispatch;


    //console.log(JSON.stringify(payload))
    //return
    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderAssignment/updateAssignment.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        //return
        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.personal_list && payload.personal_list !== null) {
                //dispatch('fetchProductionWorkOrderList', payload.personal_list)
                commit('updateWorkOrderAssignment_WorkStatus', res.data);
            } else {
                if (res.data.production_row === null && payload.listSearch) {
                    dispatch('fetchProductionWorkOrderList', payload.listSearch);
                } else {
                    commit('updateWorkOrderAssignment_WorkStatus', res.data);
                }
            }
        } else {
            commit('displayMessageAlert', { message: 'Error, please try again!!!', type: 'Error' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchWorkerHistory = function fetchWorkerHistory(_ref12, payload) {
    var commit = _ref12.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderAssignment/workerHistory.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionWorkerHistory', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadReadyOrders = function loadReadyOrders(_ref13, payload) {
    var commit = _ref13.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/readyOrders.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setReadyOrderList', res.data.response);

        setTimeout(function () {
            commit('toggleLoadingState', false);
        }, 2000);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        //commit('toggleLoadingState', false)
    });
};

var openCustomerOrderDetails_ProductionStageWise = function openCustomerOrderDetails_ProductionStageWise(_ref14, payload) {
    var commit = _ref14.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/openCustomerOrderDetails_ProductionStageWise.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        var response = [];
        if (res.data.response) {
            response = res.data.response.filter(function (thing, index, self) {
                return index === self.findIndex(function (t) {
                    return t.id === thing.id;
                });
            });
        }
        commit('setReadyOrderList_DetailList', response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var notifyCustomerForReadyItems = function notifyCustomerForReadyItems(_ref15, payload) {
    var commit = _ref15.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/notifyCustomerForReadyItems.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Notified successfully!!!' });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateScheduledDate = function updateScheduledDate(_ref16, payload) {
    var commit = _ref16.commit,
        dispatch = _ref16.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/updateScheduledDate.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('mutate_SetReadyOrderList_DetailList', res.data.response);
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.show_detail) {
                //dispatch('openCustomerOrderDetails_ProductionStageWise', {customer_id: payload.customer_id})
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updatePriority = function updatePriority(_ref17, payload) {
    var commit = _ref17.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/updatePriority.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var restartProductionProcess = function restartProductionProcess(_ref18, payload) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/restartProductionProcess.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('updateWorkOrderAssignment_WorkStatus', res.data);
        dispatch('fetchWorkOrderAssignmentHistory', { production_id: payload.production_id });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadPlannerData = function loadPlannerData(_ref19, payload) {
    var commit = _ref19.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/planner/loadPlannerData.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setLoadPlannerData', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var workOrderLoad = function workOrderLoad(_ref20, payload) {
    var commit = _ref20.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/workOrderLoad.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setWorkOrderLoad', { sale_item_id: payload.sale_item_id, tailoring_item_id: payload.tailoring_item_id, list: res.data.response });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var removeWorkOrderTrial = function removeWorkOrderTrial(_ref21, payload) {
    var commit = _ref21.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/removeWorkOrderTrial.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('unsetWorkOrderTrial', payload.production_id);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var markWorkOrderTrial = function markWorkOrderTrial(_ref22, payload) {
    var commit = _ref22.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/markWorkOrderTrial.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('setWorkOrderTrial', payload);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var approveWorkOrderTrial = function approveWorkOrderTrial(_ref23, payload) {
    var commit = _ref23.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/workOrder/approveWorkOrderTrial.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('setWorkOrderTrialApproval', payload.production_id);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var emailProcessBatch = function emailProcessBatch(_ref24, payload) {
    var commit = _ref24.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes, it may take upto 15 mins or more.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/processBatch/emailProcessBatch.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchWorkOrderSubProcessList = function fetchWorkOrderSubProcessList(_ref25, payload) {
    var commit = _ref25.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/fetchWorkOrderSubProcessList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionWorkSubProcessList', { response: res.data.response, queryPayload: payload });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateWorkOrderAssignmentSubProcess = function updateWorkOrderAssignmentSubProcess(_ref26, payload) {
    var commit = _ref26.commit,
        dispatch = _ref26.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/production/workOrderAssignment/updateAssignmentSubProcess.php', payload.postDataLoad, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        //console.log(JSON.stringify(res.data))
        dispatch('fetchWorkOrderSubProcessList', payload.masterPayload);
        if (payload.postDataLoad.last_sub_process === 1) {
            dispatch('updateWorkOrderAssignment', payload.finalFinishPayload);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        //commit('toggleLoadingState', false)
    });
};

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionAutoCompleteList", function() { return setProductionAutoCompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionWorkerWorkStatus", function() { return setProductionWorkerWorkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionProcessBatchList", function() { return setProductionProcessBatchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionWorkOrderList", function() { return setProductionWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionGroupWorkOrderList", function() { return setProductionGroupWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionWorkOrderAssignmentHistory", function() { return setProductionWorkOrderAssignmentHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateWorkOrderAssignment_WorkStatus", function() { return updateWorkOrderAssignment_WorkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unsetWorkOrderTrial", function() { return unsetWorkOrderTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderTrial", function() { return setWorkOrderTrial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWorkOrderTrialApproval", function() { return setWorkOrderTrialApproval; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionWorkerHistory", function() { return setProductionWorkerHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReadyOrderList", function() { return setReadyOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReadyOrderList_DetailList", function() { return setReadyOrderList_DetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mutate_SetReadyOrderList_DetailList", function() { return mutate_SetReadyOrderList_DetailList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoadPlannerData", function() { return setLoadPlannerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionNavProps", function() { return resetProductionNavProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionList", function() { return resetProductionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionGroupNavProps", function() { return resetProductionGroupNavProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionGroupList", function() { return resetProductionGroupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionAutoCompleteList", function() { return resetProductionAutoCompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionPlanner", function() { return resetProductionPlanner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionWorkSubProcessList", function() { return setProductionWorkSubProcessList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(355);


var setProductionAutoCompleteList = function setProductionAutoCompleteList(state, payload) {
    state.autocomplete_list = payload;
};

var setProductionWorkerWorkStatus = function setProductionWorkerWorkStatus(state, payload) {
    state.worker_work_status_list = payload;
};

var setProductionProcessBatchList = function setProductionProcessBatchList(state, payload) {
    state.process_batch_list.process_list = payload;
};

var setProductionWorkOrderList = function setProductionWorkOrderList(state, payload) {

    //state.searched = 0
    if (payload.store_query) {
        state.planner.list = { future_orders: [] };
        state.planner.list.future_orders = payload.response;
    } else {
        state.list = payload.response;

        if (state.list.filter(function (t) {
            return t.priority_order === 1;
        }).length > 0) {
            state.list = state.list.sort(function (a, b) {
                var x = a.priority_order > b.priority_order ? -1 : 1;
                return x;
            });
        }
    }

    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
};

var setProductionGroupWorkOrderList = function setProductionGroupWorkOrderList(state, payload) {

    state.group_work_order.list = payload.response;

    state.group_work_order.nav.total = payload.total;
    state.group_work_order.nav.page_number = payload.page_number;
};

var setProductionWorkOrderAssignmentHistory = function setProductionWorkOrderAssignmentHistory(state, payload) {
    state.assignment_history = payload;
};

var updateWorkOrderAssignment_WorkStatus = function updateWorkOrderAssignment_WorkStatus(state, payload) {
    var keyIndex = state.list.findIndex(function (t) {
        return t.production_work_log_id === payload.old_work_log_id;
    });
    if (keyIndex >= 0) {
        if (payload.update_finished_item) {
            if (payload.work_status === 4 || payload.work_status === 0) {
                state.list[keyIndex].action_type = 'start';
                state.list[keyIndex].work_status = 0;
                state.list[keyIndex].production_work_log_id = payload.work_log_id;
                state.list[keyIndex].worker_id = null;
                state.list[keyIndex].worker_data = null;
                if (payload.production_row === null) {
                    window.location.reload();
                }
                state.list[keyIndex].work_order_process_id = payload.production_row.work_order_process_id;
                state.list[keyIndex].process_id = payload.production_row.process_id;
                state.list[keyIndex].process_name = payload.production_row.process_name;
                state.list[keyIndex].next_process_id = payload.production_row.next_process_id;
                state.list[keyIndex].next_process_name = payload.production_row.next_process_name;
                state.list[keyIndex].hidden_process = payload.production_row.hidden_process;
            } else if (payload.work_status < 4) {
                state.list[keyIndex].work_status = payload.work_status;
            }
        } else {
            if (payload.work_status === 4) {
                state.list.splice(keyIndex, 1);
            } else {
                state.list[keyIndex].work_status = payload.work_status;
            }
        }
    }
};

var unsetWorkOrderTrial = function unsetWorkOrderTrial(state, payload) {
    var keyIndex = state.list.findIndex(function (t) {
        return t.id === payload;
    });
    if (keyIndex >= 0) {
        state.list[keyIndex].appointment_type = 0;
        state.list[keyIndex].trial_name = '';
        state.list[keyIndex].trial_type_id = 0;
    }
};

var setWorkOrderTrial = function setWorkOrderTrial(state, payload) {

    var keyIndex = state.list.findIndex(function (t) {
        return t.id === payload.production_id;
    });
    if (keyIndex >= 0) {
        state.list[keyIndex].appointment_type = 1;
        state.list[keyIndex].trial_name = payload.trial_name;
        state.list[keyIndex].trial_type_id = payload.trial_type_id;
    }
};

var setWorkOrderTrialApproval = function setWorkOrderTrialApproval(state, payload) {
    var keyIndex = state.list.findIndex(function (t) {
        return t.id === payload;
    });
    if (keyIndex >= 0) {
        state.list[keyIndex].trial_approval_required = 0;
    }
};

var setProductionWorkerHistory = function setProductionWorkerHistory(state, payload) {
    state.worker_history = payload;
};

var setReadyOrderList = function setReadyOrderList(state, payload) {
    state.ready_orders = payload;
};

var setReadyOrderList_DetailList = function setReadyOrderList_DetailList(state, payload) {
    state.ready_order_detail_list = payload;
};

var mutate_SetReadyOrderList_DetailList = function mutate_SetReadyOrderList_DetailList(state, payload) {
    var customerIndex = state.ready_order_detail_list.findIndex(function (t) {
        return t.customer_id === payload.customer_id;
    });
    if (customerIndex >= 0) {
        state.ready_order_detail_list[customerIndex].appointment_date = payload.appointment_date;
        state.ready_order_detail_list[customerIndex].appointment_date_changed = payload.appointment_date_changed;
    }
};

var setLoadPlannerData = function setLoadPlannerData(state, payload) {

    if (state.planner.list === null) {
        state.planner.list = payload.list;
    } else {
        state.planner.list.future_orders = payload.list.future_orders;
    }

    state.planner.start_date = payload.start_date;
    state.planner.end_date = payload.end_date;
    state.planner.date_label = payload.date_label;
};

var resetProductionNavProps = function resetProductionNavProps(state) {
    state.nav = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* navProps */]));
};

var resetProductionList = function resetProductionList(state) {
    state.list = null;
    state.searched = 0;
};

var resetProductionGroupNavProps = function resetProductionGroupNavProps(state) {
    state.group_work_order.nav = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* navProps */]));
    state.group_work_order.nav.sort_column_name = 't5.delivery_date';
    state.group_work_order.nav.sort_direction = 1;
};

var resetProductionGroupList = function resetProductionGroupList(state) {
    state.group_work_order.list = [];
};

var resetProductionAutoCompleteList = function resetProductionAutoCompleteList(state) {
    state.autocomplete_list = [];
};

var resetProductionPlanner = function resetProductionPlanner(state) {
    state.planner = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* plannerProps */]));
};

var setProductionWorkSubProcessList = function setProductionWorkSubProcessList(state, payload) {
    var finalArray = [];

    var productionListIndex = state.list.findIndex(function (t) {
        return t.id === payload.queryPayload.production_id;
    });
    var workLogList = payload.response;
    var mainProcessId = payload.queryPayload.main_process_id;
    var currentStoreId = payload.queryPayload.current_store_id;
    var workOrderProcessCacheList = payload.queryPayload.work_order_process_cache_list;
    var subTailoringItemId = payload.queryPayload.sub_tailoring_item_id;
    var tailoringItemId = payload.queryPayload.tailoring_item_id;

    var findMainProcessElement = workOrderProcessCacheList.filter(function (t) {
        return t.process_id === mainProcessId;
    });
    if (findMainProcessElement.length > 0) {
        var subProcessList = findMainProcessElement[0].sub_process_list;

        subProcessList.filter(function (t) {
            return t.is_required;
        }).forEach(function (element) {

            var logFilter = workLogList.length > 0 ? workLogList.filter(function (t) {
                return t.process_id === element.id;
            }) : [];

            var arrayElement = {
                work_log_id: 0,
                worker_id: null,
                worker_name: '',
                work_status: 0,
                remarks: '',
                started_at: '',
                started_at_changed_time: '',
                finished_at: '',
                finished_at_changed_time: '',
                default_piece_rate: 0,
                extra_payment: 0,
                total_piece_rate: 0,
                payroll_id: 0,
                work_order_process_id: 0,
                process_id: element.id,
                process_name: element.process_name,
                current_store_id: currentStoreId,
                sub_tailoring_item_id: subTailoringItemId,
                tailoring_item_id: tailoringItemId
            };

            if (logFilter.length > 0) {
                arrayElement.work_log_id = logFilter[0].id;
                arrayElement.worker_id = logFilter[0].worker_id;
                arrayElement.worker_name = logFilter[0].staff_name;
                arrayElement.work_status = logFilter[0].work_status;
                arrayElement.remarks = logFilter[0].remarks;
                arrayElement.started_at = logFilter[0].started_at;
                arrayElement.started_at_changed_time = logFilter[0].started_at_changed_time;
                arrayElement.finished_at = logFilter[0].finished_at;
                arrayElement.finished_at_changed_time = logFilter[0].finished_at_changed_time;
                arrayElement.default_piece_rate = logFilter[0].default_piece_rate;
                arrayElement.extra_payment = logFilter[0].extra_payment;
                arrayElement.total_piece_rate = logFilter[0].total_piece_rate;
                arrayElement.payroll_id = logFilter[0].payroll_id;
                arrayElement.work_order_process_id = logFilter[0].work_order_process_id;
            }

            finalArray.push(arrayElement);
        });
        console.log(productionListIndex);
        state.list[productionListIndex].sub_process_list = finalArray;
    }
};

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionWorkOrderAutocompleteList", function() { return getProductionWorkOrderAutocompleteList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionWorkerWorkStatusList", function() { return getProductionWorkerWorkStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionWorkOrderList", function() { return getProductionWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getReadyOrderList", function() { return getReadyOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlannerList", function() { return getPlannerList; });
var getProductionWorkOrderAutocompleteList = function getProductionWorkOrderAutocompleteList(state) {
    return state.autocomplete_list;
};

var getProductionWorkerWorkStatusList = function getProductionWorkerWorkStatusList(state) {
    return state.worker_work_status_list;
};

var getProductionWorkOrderList = function getProductionWorkOrderList(state) {
    return state.list;
};

var getReadyOrderList = function getReadyOrderList(state) {
    return state.ready_orders;
};

var getPlannerList = function getPlannerList(state) {
    return state.planner.list;
};

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productionItemIssue_actions__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productionItemIssue_mutations__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productionItemIssue_getters__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__productionItemIssue_properties__ = __webpack_require__(356);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__productionItemIssue_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__productionItemIssue_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__productionItemIssue_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__productionItemIssue_actions__
});

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionItemIssueData", function() { return fetchProductionItemIssueData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitProductionItemIssueData", function() { return submitProductionItemIssueData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProductionItemIssueData", function() { return deleteProductionItemIssueData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchProductionItemIssueData = function fetchProductionItemIssueData(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionItemIssue/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('setProductionItemIssueData', { response: res.data.response });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitProductionItemIssueData = function submitProductionItemIssueData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionItemIssue/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            //dispatch('fetchProductionItemIssueData', {id: res.data.id})
            commit('setProductionItemIssueID', { id: res.data.id, challan_number: res.data.challan_number });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteProductionItemIssueData = function deleteProductionItemIssueData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionItemIssue/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchProductionItemIssueList', { store_list: payload.store_list });
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionItemIssueList", function() { return setProductionItemIssueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionItemIssueData", function() { return setProductionItemIssueData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionItemIssueID", function() { return setProductionItemIssueID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewProductionItemIssueItemListRow", function() { return addNewProductionItemIssueItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProductionItemIssueItemListRow", function() { return removeProductionItemIssueItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionItemIssueProductionDetail", function() { return setProductionItemIssueProductionDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionItemIssueData", function() { return resetProductionItemIssueData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(356);


var setProductionItemIssueList = function setProductionItemIssueList(state, payload) {
    state.list = payload;
};

var setProductionItemIssueData = function setProductionItemIssueData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setProductionItemIssueID = function setProductionItemIssueID(state, payload) {
    state.props.id = payload.id;
    state.props.challan_number = payload.challan_number;
};

var addNewProductionItemIssueItemListRow = function addNewProductionItemIssueItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('inventory_item_id_' + (key - 1)).focus();
    }, 300);
};

var removeProductionItemIssueItemListRow = function removeProductionItemIssueItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setProductionItemIssueProductionDetail = function setProductionItemIssueProductionDetail(state, payload) {
    state.props.production_id = payload.production_id;
    state.props.work_order_number = payload.work_order_number;
};

var resetProductionItemIssueData = function resetProductionItemIssueData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionItemIssueList", function() { return getProductionItemIssueList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionItemIssueDataProps", function() { return getProductionItemIssueDataProps; });
var getProductionItemIssueList = function getProductionItemIssueList(state) {
    return state.list;
};

var getProductionItemIssueDataProps = function getProductionItemIssueDataProps(state) {
    return state.props;
};

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transferWorkOrder_actions__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transferWorkOrder_mutations__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transferWorkOrder_getters__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transferWorkOrder_properties__ = __webpack_require__(357);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    do_not_load_by_default: false,
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__transferWorkOrder_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__transferWorkOrder_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__transferWorkOrder_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__transferWorkOrder_actions__
});

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTransferWorkOrderList", function() { return fetchTransferWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTransferWorkOrderData", function() { return fetchTransferWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTransferWorkOrderData", function() { return submitTransferWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTransferWorkOrderData", function() { return deleteTransferWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadReadyItemsForTransfer", function() { return loadReadyItemsForTransfer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchTransferWorkOrderList = function fetchTransferWorkOrderList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/transferWorkOrder/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchTransferWorkOrderList', payload);
            } else {
                commit('setTransferWorkOrderList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchTransferWorkOrderData = function fetchTransferWorkOrderData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/transferWorkOrder/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.list_deploy) {
                commit('setTransferWorkOrderList_ItemList', { item_list: res.data.response.item_list, id: payload.id });
            } else {
                commit('setTransferWorkOrderData', { response: res.data.response, copy: payload.copy });
            }

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTransferWorkOrderData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTransferWorkOrderData = function submitTransferWorkOrderData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    //    return
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/transferWorkOrder/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            dispatch('fetchTransferWorkOrderData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
        dispatch('fetchTransferWorkOrderData', { id: payload.id });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTransferWorkOrderData = function deleteTransferWorkOrderData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/transferWorkOrder/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTransferWorkOrderList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadReadyItemsForTransfer = function loadReadyItemsForTransfer(_ref5, payload) {
    var commit = _ref5.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/transferWorkOrder/loadReadyItemsForTransfer.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setLoadReadyItemsForTransfer', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTransferWorkOrderList", function() { return setTransferWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTransferWorkOrderData", function() { return setTransferWorkOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewTransferWorkOrderItemListRow", function() { return addNewTransferWorkOrderItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeTransferWorkOrderItemListRow", function() { return removeTransferWorkOrderItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoadReadyItemsForTransfer", function() { return setLoadReadyItemsForTransfer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTransferWorkOrderList_ItemList", function() { return setTransferWorkOrderList_ItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTransferWorkOrderData", function() { return resetTransferWorkOrderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(357);


var setTransferWorkOrderList = function setTransferWorkOrderList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setTransferWorkOrderData = function setTransferWorkOrderData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewTransferWorkOrderItemListRow = function addNewTransferWorkOrderItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('production_id_' + (key - 1)).focus();
    }, 300);
};

var removeTransferWorkOrderItemListRow = function removeTransferWorkOrderItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setLoadReadyItemsForTransfer = function setLoadReadyItemsForTransfer(state, payload) {

    if (payload !== undefined) {
        state.props.item_list = [];
        var key = 0;
        payload.forEach(function (element) {
            state.props.item_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                item_detail: {
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_order_process_id: element.work_order_process_id,
                    sale_item_id: element.sale_item_id,
                    trial_name: element.trial_name != null ? element.trial_name : '',
                    promise_type: element.appointment_type,
                    appointment_date: element.appointment_date,
                    fabric_id: element.fabric_id,
                    sku_code: element.sku_code,
                    article_name: element.article_name
                }
            });
            key++;
        });
    }
};

var setTransferWorkOrderList_ItemList = function setTransferWorkOrderList_ItemList(state, payload) {
    var itemIndex = state.list.findIndex(function (t) {
        return t.id === payload.id;
    });

    if (itemIndex >= 0) {
        state.list[itemIndex].item_list = payload.item_list;
    }
};

var resetTransferWorkOrderData = function resetTransferWorkOrderData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTransferWorkOrderList", function() { return getTransferWorkOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTransferWorkOrderDataProps", function() { return getTransferWorkOrderDataProps; });
var getTransferWorkOrderList = function getTransferWorkOrderList(state) {
    return state.list;
};

var getTransferWorkOrderDataProps = function getTransferWorkOrderDataProps(state) {
    return state.props;
};

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productionOutsource_actions__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productionOutsource_mutations__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productionOutsource_getters__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__productionOutsource_properties__ = __webpack_require__(358);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__productionOutsource_properties__["a" /* dataProps */])),
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__productionOutsource_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__productionOutsource_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__productionOutsource_actions__
});

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionOutsourceList", function() { return fetchProductionOutsourceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionOutsourceData", function() { return fetchProductionOutsourceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionOutsourceData_ItemList", function() { return fetchProductionOutsourceData_ItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitProductionOutsourceData", function() { return submitProductionOutsourceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProductionOutsourceData", function() { return deleteProductionOutsourceData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchProductionOutsourceList = function fetchProductionOutsourceList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionOutsource/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchProductionOutsourceList', payload);
            } else {
                commit('setProductionOutsourceList', res.data);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchProductionOutsourceData = function fetchProductionOutsourceData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionOutsource/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setProductionOutsourceData', { response: res.data.response });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetProductionOutsourceData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionOutsourceData_ItemList = function fetchProductionOutsourceData_ItemList(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionOutsource/singleItemList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setProductionOutsourceDataItemList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitProductionOutsourceData = function submitProductionOutsourceData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionOutsource/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchProductionOutsourceData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        //commit('toggleLoadingState', false)
    });
};

var deleteProductionOutsourceData = function deleteProductionOutsourceData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionOutsource/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchProductionOutsourceList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionOutsourceList", function() { return setProductionOutsourceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionOutsourceData", function() { return setProductionOutsourceData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionOutsourceDataItemList", function() { return setProductionOutsourceDataItemList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewProductionOutsourceItemListRow", function() { return addNewProductionOutsourceItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProductionOutsourceItemListRow", function() { return removeProductionOutsourceItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionOutsourceItemListKey", function() { return resetProductionOutsourceItemListKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionOutsourceData", function() { return resetProductionOutsourceData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(358);


var setProductionOutsourceList = function setProductionOutsourceList(state, payload) {
    state.list = payload.response;

    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
};

var setProductionOutsourceData = function setProductionOutsourceData(state, payload) {
    state.props = payload.response;
};

var setProductionOutsourceDataItemList = function setProductionOutsourceDataItemList(state, payload) {

    state.props.item_list = payload;
    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewProductionOutsourceItemListRow = function addNewProductionOutsourceItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeProductionOutsourceItemListRow = function removeProductionOutsourceItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetProductionOutsourceItemListKey = function resetProductionOutsourceItemListKey(state) {

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetProductionOutsourceData = function resetProductionOutsourceData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionOutsourceList", function() { return getProductionOutsourceList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionOutsourceDataProps", function() { return getProductionOutsourceDataProps; });
var getProductionOutsourceList = function getProductionOutsourceList(state) {
    return state.list;
};

var getProductionOutsourceDataProps = function getProductionOutsourceDataProps(state) {
    return state.props;
};

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventorySeparation_actions__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventorySeparation_mutations__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventorySeparation_getters__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventorySeparation_properties__ = __webpack_require__(359);






var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventorySeparation_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventorySeparation_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventorySeparation_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventorySeparation_actions__
});

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventorySeparationList", function() { return fetchInventorySeparationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventorySeparationRequest", function() { return fetchInventorySeparationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventorySeparationData", function() { return fetchInventorySeparationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventorySeparationData", function() { return submitInventorySeparationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventorySeparationData", function() { return deleteInventorySeparationData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchInventorySeparationList = function fetchInventorySeparationList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySeparation/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchInventorySeparationList', payload);
            } else {
                commit('setInventorySeparationList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventorySeparationRequest = function fetchInventorySeparationRequest(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySeparation/fetchInventorySeparationRequest.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchInventorySeparationRequest', payload);
            } else {
                commit('setInventorySeparationRequestList', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchInventorySeparationData = function fetchInventorySeparationData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySeparation/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setInventorySeparationData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventorySeparationData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventorySeparationData = function submitInventorySeparationData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySeparation/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventorySeparationData = function deleteInventorySeparationData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventorySeparation/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchInventorySeparationList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySeparationList", function() { return setInventorySeparationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySeparationRequestList", function() { return setInventorySeparationRequestList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventorySeparationData", function() { return setInventorySeparationData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewInventorySeparationItemListRow", function() { return addNewInventorySeparationItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInventorySeparationItemListRow", function() { return removeInventorySeparationItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventorySeparationData", function() { return resetInventorySeparationData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(359);


var setInventorySeparationList = function setInventorySeparationList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setInventorySeparationRequestList = function setInventorySeparationRequestList(state, payload) {
    state.request_list = payload;
};

var setInventorySeparationData = function setInventorySeparationData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var addNewInventorySeparationItemListRow = function addNewInventorySeparationItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeInventorySeparationItemListRow = function removeInventorySeparationItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetInventorySeparationData = function resetInventorySeparationData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventorySeparationList", function() { return getInventorySeparationList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventorySeparationDataProps", function() { return getInventorySeparationDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventorySeparationRequestList", function() { return getInventorySeparationRequestList; });
var getInventorySeparationList = function getInventorySeparationList(state) {
    return state.list;
};

var getInventorySeparationDataProps = function getInventorySeparationDataProps(state) {
    return state.props;
};

var getInventorySeparationRequestList = function getInventorySeparationRequestList(state) {
    return state.request_list;
};

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__discountCoupon_actions__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__discountCoupon_mutations__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__discountCoupon_getters__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__discountCoupon_properties__ = __webpack_require__(360);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__discountCoupon_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__discountCoupon_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__discountCoupon_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__discountCoupon_actions__
});

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDiscountCouponList", function() { return fetchDiscountCouponList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDiscountCouponData", function() { return fetchDiscountCouponData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitDiscountCouponData", function() { return submitDiscountCouponData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteDiscountCouponData", function() { return deleteDiscountCouponData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchDiscountCouponList = function fetchDiscountCouponList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/discountCoupon/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.try_again) {
            dispatch('fetchDiscountCouponList', payload);
        } else {
            commit('setDiscountCouponList', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchDiscountCouponData = function fetchDiscountCouponData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/discountCoupon/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setDiscountCouponData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetDiscountCouponData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitDiscountCouponData = function submitDiscountCouponData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/discountCoupon/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteDiscountCouponData = function deleteDiscountCouponData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/discountCoupon/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchDiscountCouponList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDiscountCouponList", function() { return setDiscountCouponList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDiscountCouponData", function() { return setDiscountCouponData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetDiscountCouponData", function() { return resetDiscountCouponData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(360);


var setDiscountCouponList = function setDiscountCouponList(state, payload) {
    state.list = payload;
};

var setDiscountCouponData = function setDiscountCouponData(state, payload) {
    state.props = payload.response;
};

var resetDiscountCouponData = function resetDiscountCouponData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDiscountCouponList", function() { return getDiscountCouponList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDiscountCouponDataProps", function() { return getDiscountCouponDataProps; });
var getDiscountCouponList = function getDiscountCouponList(state) {
    return state.list;
};

var getDiscountCouponDataProps = function getDiscountCouponDataProps(state) {
    return state.props;
};

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__productionCapacity_actions__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__productionCapacity_mutations__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__productionCapacity_getters__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__productionCapacity_properties__ = __webpack_require__(361);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__productionCapacity_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__productionCapacity_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__productionCapacity_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__productionCapacity_actions__
});

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionCapacityList", function() { return fetchProductionCapacityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProductionCapacityData", function() { return fetchProductionCapacityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitProductionCapacityData", function() { return submitProductionCapacityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteProductionCapacityData", function() { return deleteProductionCapacityData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchProductionCapacityList = function fetchProductionCapacityList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/productionCapacity/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setProductionCapacityList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchProductionCapacityData = function fetchProductionCapacityData(_ref2, payload) {
    var commit = _ref2.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionCapacity/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setProductionCapacityData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetProductionCapacityData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitProductionCapacityData = function submitProductionCapacityData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionCapacity/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteProductionCapacityData = function deleteProductionCapacityData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/productionCapacity/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchProductionCapacityList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionCapacityList", function() { return setProductionCapacityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setProductionCapacityData", function() { return setProductionCapacityData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewProductionCapacityItemRow", function() { return addNewProductionCapacityItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeProductionCapacityItemRow", function() { return removeProductionCapacityItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProductionCapacityData", function() { return resetProductionCapacityData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(361);


var setProductionCapacityList = function setProductionCapacityList(state, payload) {
    state.list = payload;
};

var setProductionCapacityData = function setProductionCapacityData(state, payload) {
    state.props = payload.response;

    if (state.props.capacity_list.length === 0) {
        state.props.capacity_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* productionCapacityListProps */]))];
    }
};

var addNewProductionCapacityItemRow = function addNewProductionCapacityItemRow(state) {

    var sl_no = 0;
    state.props.capacity_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* productionCapacityListProps */])));

    state.props.capacity_list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });
};

var removeProductionCapacityItemRow = function removeProductionCapacityItemRow(state, payload) {

    var sl_no = 0;

    state.props.deleted_capacity_list_items.push(state.props[payload]);

    state.props.capacity_list.splice(payload, 1);

    if (state.props.capacity_list.length === 0) {
        state.props.capacity_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* productionCapacityListProps */]))];
    }

    state.props.capacity_list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });
};

var resetProductionCapacityData = function resetProductionCapacityData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionCapacityList", function() { return getProductionCapacityList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getProductionCapacityDataProps", function() { return getProductionCapacityDataProps; });
var getProductionCapacityList = function getProductionCapacityList(state) {
    return state.list;
};

var getProductionCapacityDataProps = function getProductionCapacityDataProps(state) {
    return state.props;
};

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__employeeLoan_actions__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__employeeLoan_mutations__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__employeeLoan_getters__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employeeLoan_properties__ = __webpack_require__(362);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.date_of_loan',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__employeeLoan_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__employeeLoan_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__employeeLoan_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__employeeLoan_actions__
});

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeeLoanList", function() { return fetchEmployeeLoanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailLoanList", function() { return emailLoanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeeLoanData", function() { return fetchEmployeeLoanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEmployeeLoanData", function() { return submitEmployeeLoanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEmployeeLoanData", function() { return deleteEmployeeLoanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadEmployeeLoanBalance", function() { return loadEmployeeLoanBalance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEmployeeLoanList = function fetchEmployeeLoanList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchEmployeeLoanList', payload);
            } else {
                commit('setEmployeeLoanList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var emailLoanList = function emailLoanList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/emailLoanList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEmployeeLoanData = function fetchEmployeeLoanData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setEmployeeLoanData', { response: res.data.response });
            dispatch('loadEmployeeLoanBalance', { staff_id: res.data.response.staff_id });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEmployeeLoanData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEmployeeLoanData = function submitEmployeeLoanData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        console.log('res.data.response', JSON.stringify(res.data));

        if (res.data.status) {

            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEmployeeLoanData = function deleteEmployeeLoanData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEmployeeLoanList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var loadEmployeeLoanBalance = function loadEmployeeLoanBalance(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeeLoan/loadEmployeeLoanBalance.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEmployeeLoanBalance', res.data.total_balance);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeLoanList", function() { return setEmployeeLoanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeLoanData", function() { return setEmployeeLoanData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeeLoanBalance", function() { return setEmployeeLoanBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEmployeeLoanData", function() { return resetEmployeeLoanData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(362);


var setEmployeeLoanList = function setEmployeeLoanList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setEmployeeLoanData = function setEmployeeLoanData(state, payload) {
    state.props = payload.response;
};

var setEmployeeLoanBalance = function setEmployeeLoanBalance(state, payload) {
    state.props.loan_balance = payload;
};

var resetEmployeeLoanData = function resetEmployeeLoanData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeLoanList", function() { return getEmployeeLoanList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeLoanDataProps", function() { return getEmployeeLoanDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeeLoanBalance", function() { return getEmployeeLoanBalance; });
var getEmployeeLoanList = function getEmployeeLoanList(state) {
    return state.list;
};

var getEmployeeLoanDataProps = function getEmployeeLoanDataProps(state) {
    return state.props;
};

var getEmployeeLoanBalance = function getEmployeeLoanBalance(state) {
    return state.props.loan_balance;
};

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__employeePayroll_actions__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__employeePayroll_mutations__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__employeePayroll_getters__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__employeePayroll_properties__ = __webpack_require__(363);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__employeePayroll_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__employeePayroll_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__employeePayroll_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__employeePayroll_actions__
});

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeePayrollList", function() { return fetchEmployeePayrollList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFreshPayrollInformation", function() { return loadFreshPayrollInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEmployeePayrollData", function() { return fetchEmployeePayrollData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEmployeePayrollData", function() { return submitEmployeePayrollData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEmployeePayrollData", function() { return deleteEmployeePayrollData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "skipProductionWorkFromPayroll", function() { return skipProductionWorkFromPayroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "emailPayrollList", function() { return emailPayrollList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEmployeePayrollList = function fetchEmployeePayrollList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0 && payload.single_payroll == 'NO') {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchEmployeePayrollList', payload);
            } else {
                commit('setEmployeePayrollList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var loadFreshPayrollInformation = function loadFreshPayrollInformation(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/loadFreshPayrollInformation.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setFreshPayrollInformation', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEmployeePayrollData = function fetchEmployeePayrollData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setEmployeePayrollData', { response: res.data.response });

            if (payload.navigate) {
                if (payload.single_payroll) {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/singlepayrollform/');
                } else {
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
                }
            }
        } else {
            commit('resetEmployeePayrollData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEmployeePayrollData = function submitEmployeePayrollData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        console.log(JSON.stringify(res.data));
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchEmployeePayrollData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEmployeePayrollData = function deleteEmployeePayrollData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEmployeePayrollList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var skipProductionWorkFromPayroll = function skipProductionWorkFromPayroll(_ref6, payload) {
    var commit = _ref6.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/skipProductionWorkFromPayroll.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        //commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var emailPayrollList = function emailPayrollList(_ref7, payload) {
    var commit = _ref7.commit;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/employeePayroll/emailPayrollList.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {}).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeePayrollList", function() { return setEmployeePayrollList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEmployeePayrollData", function() { return setEmployeePayrollData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewEmployeePayrollItemListRow", function() { return addNewEmployeePayrollItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmployeePayrollItemListRow", function() { return removeEmployeePayrollItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFreshPayrollInformation", function() { return setFreshPayrollInformation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEmployeePayrollData", function() { return resetEmployeePayrollData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(363);


var setEmployeePayrollList = function setEmployeePayrollList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setEmployeePayrollData = function setEmployeePayrollData(state, payload) {
    state.props = payload.response;

    if (state.props.payroll_item_list.length === 0) {
        state.props.payroll_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }
};

var addNewEmployeePayrollItemListRow = function addNewEmployeePayrollItemListRow(state) {

    var key = 0;
    state.props.payroll_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.payroll_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeEmployeePayrollItemListRow = function removeEmployeePayrollItemListRow(state, payload) {

    var key = 0;

    state.props.payroll_item_list.splice(payload, 1);

    if (state.props.payroll_item_list.length === 0) {
        state.props.payroll_item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.payroll_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setFreshPayrollInformation = function setFreshPayrollInformation(state, payload) {

    state.props.production_work_list = payload.production_logs;
    state.props.attendance_list = payload.attendance;
    state.props.sales_commission_list = payload.sales_commission;
    state.props.loan_repayment_list = payload.loan_repayment;
    state.props.payroll_item_list = payload.particulars;

    state.props.deduction_per_day = payload.deduction_per_day;
    state.props.overtime_list = payload.overtime_list;
};

var resetEmployeePayrollData = function resetEmployeePayrollData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeePayrollList", function() { return getEmployeePayrollList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEmployeePayrollDataProps", function() { return getEmployeePayrollDataProps; });
var getEmployeePayrollList = function getEmployeePayrollList(state) {
    return state.list;
};

var getEmployeePayrollDataProps = function getEmployeePayrollDataProps(state) {
    return state.props;
};

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inventoryRack_actions__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inventoryRack_mutations__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__inventoryRack_getters__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__inventoryRack_properties__ = __webpack_require__(364);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__inventoryRack_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__inventoryRack_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__inventoryRack_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__inventoryRack_actions__
});

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryRackList", function() { return fetchInventoryRackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchInventoryRackData", function() { return fetchInventoryRackData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitInventoryRackData", function() { return submitInventoryRackData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteInventoryRackData", function() { return deleteInventoryRackData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchInventoryRackList = function fetchInventoryRackList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/inventoryRack/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setInventoryRackList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchInventoryRackData = function fetchInventoryRackData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryRack/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setInventoryRackData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetInventoryRackData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitInventoryRackData = function submitInventoryRackData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryRack/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteInventoryRackData = function deleteInventoryRackData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/inventoryRack/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchInventoryRackList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryRackList", function() { return setInventoryRackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setInventoryRackData", function() { return setInventoryRackData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetInventoryRackData", function() { return resetInventoryRackData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(364);


var setInventoryRackList = function setInventoryRackList(state, payload) {
    state.list = payload;
};

var setInventoryRackData = function setInventoryRackData(state, payload) {
    state.props = payload;
};

var resetInventoryRackData = function resetInventoryRackData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryRackList", function() { return getInventoryRackList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInventoryRackDataProps", function() { return getInventoryRackDataProps; });
var getInventoryRackList = function getInventoryRackList(state) {
    return state.list;
};

var getInventoryRackDataProps = function getInventoryRackDataProps(state) {
    return state.props;
};

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__measurementMaster_actions__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__measurementMaster_mutations__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__measurementMaster_getters__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__measurementMaster_properties__ = __webpack_require__(365);






var state = {
    list: [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__measurementMaster_properties__["b" /* measurementListProps */]))],
    deleted_measurement_list_items: [],
    item_type: 0 //tailoring product, fabric, ready to wear, raw material, asset
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__measurementMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__measurementMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__measurementMaster_actions__
});

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchMeasurementMasterList", function() { return fetchMeasurementMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitMeasurementMasterData", function() { return submitMeasurementMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchMeasurementMasterList = function fetchMeasurementMasterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/measurementMaster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('setMeasurementMasterList', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitMeasurementMasterData = function submitMeasurementMasterData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/measurementMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            dispatch('fetchMeasurementMasterList');
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMeasurementMasterList", function() { return setMeasurementMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewMeasurementMasterListItemRow", function() { return addNewMeasurementMasterListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeMeasurementMasterListItemRow", function() { return removeMeasurementMasterListItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortMeasurementMasterList", function() { return sortMeasurementMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewMeasurementMasterListDropDownItemRow", function() { return addNewMeasurementMasterListDropDownItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeMeasurementMasterListDropDownItemRow", function() { return removeMeasurementMasterListDropDownItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetMeasurementMasterData", function() { return resetMeasurementMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(365);


var setMeasurementMasterList = function setMeasurementMasterList(state, payload) {
    state.list = payload;
    state.list.forEach(function (element) {
        if (element.measurement_drop_down_list.length === 0) {
            element.measurement_drop_down_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* measurementDropDownListProps */]))];
        }
    });
};

var addNewMeasurementMasterListItemRow = function addNewMeasurementMasterListItemRow(state) {

    var sl_no = 0;
    state.list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* measurementListProps */])));

    state.list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });

    setTimeout(function () {
        document.getElementById('measurement_name_' + (sl_no - 1)).focus();
    }, 300);
};

var removeMeasurementMasterListItemRow = function removeMeasurementMasterListItemRow(state, payload) {

    var sl_no = 0;

    state.deleted_measurement_list_items.push(state.list[payload]);

    state.list.splice(payload, 1);

    if (state.list.length === 0) {
        state.list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* measurementListProps */]))];
    }

    state.list.forEach(function (element) {
        element.sl_no = sl_no;
        sl_no++;
    });
};

var sortMeasurementMasterList = function sortMeasurementMasterList(state, payload) {

    var key = payload.sl_no;

    if (payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no + 1;
        state.list[key + 1].sl_no = payload.sl_no;
    } else if (payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no - 1;
        state.list[key - 1].sl_no = payload.sl_no;
    }

    state.list = state.list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

var addNewMeasurementMasterListDropDownItemRow = function addNewMeasurementMasterListDropDownItemRow(state, parent_key) {

    var key = 0;
    state.list[parent_key].measurement_drop_down_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* measurementDropDownListProps */])));

    state.list[parent_key].measurement_drop_down_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('measurement_value_' + (key - 1)).focus();
    }, 300);
};

var removeMeasurementMasterListDropDownItemRow = function removeMeasurementMasterListDropDownItemRow(state, payload) {

    var key = 0;

    state.list[payload.parent_key].deleted_measurement_drop_down_list_items.push(state.list[payload.parent_key].measurement_drop_down_list[payload.key]);

    state.list[payload.parent_key].measurement_drop_down_list.splice(payload.key, 1);

    if (state.list[payload.parent_key].measurement_drop_down_list.length === 0) {
        state.list[payload.parent_key].measurement_drop_down_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* measurementDropDownListProps */]))];
    }

    state.list[payload.parent_key].measurement_drop_down_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetMeasurementMasterData = function resetMeasurementMasterData(state) {
    state.props = JSON.parse(JSON.stringify(dataProps));
};

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMeasurementMasterList", function() { return getMeasurementMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMeasurementMasterDataProps", function() { return getMeasurementMasterDataProps; });
var getMeasurementMasterList = function getMeasurementMasterList(state) {
    return state.list;
};

var getMeasurementMasterDataProps = function getMeasurementMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assetMaster_actions__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assetMaster_mutations__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assetMaster_getters__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assetMaster_properties__ = __webpack_require__(366);






var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'asset_name',
        sort_direction: 0, search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__assetMaster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__assetMaster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__assetMaster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__assetMaster_actions__
});

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAssetMasterList", function() { return fetchAssetMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAssetMasterData", function() { return fetchAssetMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitAssetMasterData", function() { return submitAssetMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteAssetMasterData", function() { return deleteAssetMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchAssetMasterList = function fetchAssetMasterList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/assetMaster/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setAssetMasterList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchAssetMasterData = function fetchAssetMasterData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/assetMaster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setAssetMasterData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetAssetMasterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitAssetMasterData = function submitAssetMasterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/assetMaster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteAssetMasterData = function deleteAssetMasterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/assetMaster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchAssetMasterList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAssetMasterList", function() { return setAssetMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAssetMasterData", function() { return setAssetMasterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetAssetMasterData", function() { return resetAssetMasterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(366);


var setAssetMasterList = function setAssetMasterList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setAssetMasterData = function setAssetMasterData(state, payload) {
    state.props = payload.response;
    if (payload.copy) {
        state.props.id = 0;
    }
};

var resetAssetMasterData = function resetAssetMasterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAssetMasterList", function() { return getAssetMasterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAssetMasterDataProps", function() { return getAssetMasterDataProps; });
var getAssetMasterList = function getAssetMasterList(state) {
    return state.list;
};

var getAssetMasterDataProps = function getAssetMasterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bankStatement_actions__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bankStatement_mutations__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bankStatement_getters__ = __webpack_require__(1538);




var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.transaction_date',
        sort_direction: 0,
        date_range: [new Date(), new Date()],
        bank_id: 0,
        store_id: 0
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__bankStatement_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__bankStatement_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__bankStatement_actions__
});

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBankStatementList", function() { return fetchBankStatementList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateBankRecoDate", function() { return updateBankRecoDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitOpeningBalance", function() { return submitOpeningBalance; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchBankStatementList = function fetchBankStatementList(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankStatement/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        commit('setBankStatementList', { response: res.data.response });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var updateBankRecoDate = function updateBankRecoDate(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankStatement/updateBankRecoDate.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitOpeningBalance = function submitOpeningBalance(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/bankStatement/submitOpeningBalance.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setBankStatementList", function() { return setBankStatementList; });

var setBankStatementList = function setBankStatementList(state, payload) {
    state.list = payload.response;
};

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBankStatementList", function() { return getBankStatementList; });
var getBankStatementList = function getBankStatementList(state) {
    return state.list;
};

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tasks_actions__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tasks_mutations__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tasks_getters__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tasks_properties__ = __webpack_require__(367);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__tasks_properties__["a" /* dataProps */])),
    group_task: [],
    show_task_group_form: false,
    show_task_form: false
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__tasks_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__tasks_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__tasks_actions__
});

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTaskList", function() { return fetchTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTaskData", function() { return fetchTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTaskData", function() { return submitTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitGroupTasks", function() { return submitGroupTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTaskData", function() { return deleteTaskData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchTaskList = function fetchTaskList(_ref) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tasks/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        commit('setTaskList', { response: res.data.response });
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTaskData = function fetchTaskData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tasks/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setTaskData', { response: res.data.response });
        } else {
            commit('resetTaskData');
        }
        dispatch('fetchTaxSetting');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTaskData = function submitTaskData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tasks/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (!payload.group_task) {
                commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
                commit('closeTaskModal');
                dispatch('fetchTaskList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitGroupTasks = function submitGroupTasks(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    payload.forEach(function (element) {
        element.group_task = true;
        dispatch('submitTaskData', element);
    });

    setTimeout(function () {
        commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        commit('closeTaskGroupModal');
        dispatch('fetchTaskList');
    }, 1000);
};

var deleteTaskData = function deleteTaskData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tasks/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            dispatch('fetchTaskList');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskList", function() { return setTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTaskData", function() { return setTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTaskData", function() { return resetTaskData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTaskGroupData", function() { return resetTaskGroupData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTaskModal", function() { return closeTaskModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeTaskGroupModal", function() { return closeTaskGroupModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewGroupTaskItemRow", function() { return addNewGroupTaskItemRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeGroupTaskItemRow", function() { return removeGroupTaskItemRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(367);


var setTaskList = function setTaskList(state, payload) {
    state.list = payload.response;
};

var setTaskData = function setTaskData(state, payload) {
    state.props = payload.response;
    state.show_task_form = true;
};

var resetTaskData = function resetTaskData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var resetTaskGroupData = function resetTaskGroupData(state) {
    state.group_task = [];
};

var closeTaskModal = function closeTaskModal(state) {
    state.show_task_form = false;
};

var closeTaskGroupModal = function closeTaskGroupModal(state) {
    state.show_task_group_form = false;
};

var addNewGroupTaskItemRow = function addNewGroupTaskItemRow(state) {

    var key = 0;
    state.group_task.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */])));

    state.group_task.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('task_title_' + (key - 1)).focus();
    }, 300);
};

var removeGroupTaskItemRow = function removeGroupTaskItemRow(state, payload) {

    var key = 0;

    state.group_task.splice(payload, 1);

    if (state.group_task.length === 0) {
        state.group_task = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]))];
    }

    state.group_task.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskList", function() { return getTaskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTaskDataProps", function() { return getTaskDataProps; });
var getTaskList = function getTaskList(state) {
    return state.list;
};

var getTaskDataProps = function getTaskDataProps(state) {
    return state.props;
};

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shipmentPartner_actions__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shipmentPartner_mutations__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shipmentPartner_getters__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shipmentPartner_properties__ = __webpack_require__(368);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__shipmentPartner_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__shipmentPartner_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__shipmentPartner_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__shipmentPartner_actions__
});

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchShipmentPartnerList", function() { return fetchShipmentPartnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchShipmentPartnerData", function() { return fetchShipmentPartnerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitShipmentPartnerData", function() { return submitShipmentPartnerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteShipmentPartnerData", function() { return deleteShipmentPartnerData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchShipmentPartnerList = function fetchShipmentPartnerList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shipmentPartners/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.try_again) {
            dispatch('fetchShipmentPartnerList', payload);
        } else {
            commit('setShipmentPartnerList', res.data.response);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchShipmentPartnerData = function fetchShipmentPartnerData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shipmentPartners/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setShipmentPartnerData', { response: res.data.response, copy: payload.copy });
            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetShipmentPartnerData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitShipmentPartnerData = function submitShipmentPartnerData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shipmentPartners/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteShipmentPartnerData = function deleteShipmentPartnerData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/shipmentPartners/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchShipmentPartnerList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShipmentPartnerList", function() { return setShipmentPartnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setShipmentPartnerData", function() { return setShipmentPartnerData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetShipmentPartnerData", function() { return resetShipmentPartnerData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(368);


var setShipmentPartnerList = function setShipmentPartnerList(state, payload) {
    state.list = payload;
};

var setShipmentPartnerData = function setShipmentPartnerData(state, payload) {
    state.props = payload.response;
};

var resetShipmentPartnerData = function resetShipmentPartnerData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShipmentPartnerList", function() { return getShipmentPartnerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShipmentPartnerDataProps", function() { return getShipmentPartnerDataProps; });
var getShipmentPartnerList = function getShipmentPartnerList(state) {
    return state.list;
};

var getShipmentPartnerDataProps = function getShipmentPartnerDataProps(state) {
    return state.props;
};

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__handloomCluster_actions__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handloomCluster_mutations__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handloomCluster_getters__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handloomCluster_properties__ = __webpack_require__(369);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__handloomCluster_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__handloomCluster_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__handloomCluster_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__handloomCluster_actions__
});

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHandloomClusterList", function() { return fetchHandloomClusterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHandloomClusterData", function() { return fetchHandloomClusterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitHandloomClusterData", function() { return submitHandloomClusterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteHandloomClusterData", function() { return deleteHandloomClusterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchHandloomClusterList = function fetchHandloomClusterList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/handloomCluster/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setHandloomClusterList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchHandloomClusterData = function fetchHandloomClusterData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/handloomCluster/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setHandloomClusterData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetHandloomClusterData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitHandloomClusterData = function submitHandloomClusterData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/handloomCluster/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteHandloomClusterData = function deleteHandloomClusterData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/handloomCluster/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchHandloomClusterList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHandloomClusterList", function() { return setHandloomClusterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setHandloomClusterData", function() { return setHandloomClusterData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetHandloomClusterData", function() { return resetHandloomClusterData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(369);


var setHandloomClusterList = function setHandloomClusterList(state, payload) {
    state.list = payload;
};

var setHandloomClusterData = function setHandloomClusterData(state, payload) {
    state.props = payload;
};

var resetHandloomClusterData = function resetHandloomClusterData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHandloomClusterList", function() { return getHandloomClusterList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHandloomClusterDataProps", function() { return getHandloomClusterDataProps; });
var getHandloomClusterList = function getHandloomClusterList(state) {
    return state.list;
};

var getHandloomClusterDataProps = function getHandloomClusterDataProps(state) {
    return state.props;
};

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__expenseBill_actions__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expenseBill_mutations__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__expenseBill_getters__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__expenseBill_properties__ = __webpack_require__(370);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.bill_date',
        sort_direction: 1, search: ''
    },
    outstanding_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__expenseBill_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__expenseBill_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__expenseBill_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__expenseBill_actions__
});

/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseBillList", function() { return fetchExpenseBillList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchExpenseBillData", function() { return fetchExpenseBillData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitExpenseBillData", function() { return submitExpenseBillData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteExpenseBillData", function() { return deleteExpenseBillData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchExpenseBillList = function fetchExpenseBillList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        commit('resetExpenseBillOutstandingList');
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseBill/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchExpenseBillList', payload);
            } else {
                commit('setExpenseBillList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchExpenseBillData = function fetchExpenseBillData(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseBill/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setExpenseBillData', { response: res.data.response, copy: payload.copy });
            dispatch('fetchDocumentList', { expense_bill_id: payload.id });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetExpenseBillData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitExpenseBillData = function submitExpenseBillData(_ref3, payload) {
    var commit = _ref3.commit,
        dispatch = _ref3.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseBill/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchExpenseBillData', { id: res.data.id });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteExpenseBillData = function deleteExpenseBillData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/expenseBill/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack && !payload.popup) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchExpenseBillList', payload.list);
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseBillList", function() { return setExpenseBillList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseBillOutstandingList", function() { return setExpenseBillOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetExpenseBillOutstandingList", function() { return resetExpenseBillOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpenseBillData", function() { return setExpenseBillData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewExpenseBillItemListRow", function() { return addNewExpenseBillItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeExpenseBillItemListRow", function() { return removeExpenseBillItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewExpenseBillPaymentTermListRow", function() { return addNewExpenseBillPaymentTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeExpenseBillPaymentTermListRow", function() { return removeExpenseBillPaymentTermListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetExpenseBillData", function() { return resetExpenseBillData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(370);


var setExpenseBillList = function setExpenseBillList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setExpenseBillOutstandingList = function setExpenseBillOutstandingList(state, payload) {
    state.outstanding_list = payload;
};

var resetExpenseBillOutstandingList = function resetExpenseBillOutstandingList(state) {
    state.outstanding_list = [];
};

var setExpenseBillData = function setExpenseBillData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var addNewExpenseBillItemListRow = function addNewExpenseBillItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeExpenseBillItemListRow = function removeExpenseBillItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewExpenseBillPaymentTermListRow = function addNewExpenseBillPaymentTermListRow(state) {

    var key = 0;
    state.props.payment_term.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* paymentTermListProps */])));

    state.props.payment_term.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('payment_term_date_' + (key - 1)).focus();
    }, 300);
};

var removeExpenseBillPaymentTermListRow = function removeExpenseBillPaymentTermListRow(state, payload) {

    var key = 0;

    state.props.payment_term.splice(payload, 1);

    if (state.props.payment_term.length === 0) {
        state.props.payment_term = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* paymentTermListProps */]))];
    }

    state.props.payment_term.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetExpenseBillData = function resetExpenseBillData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseBillList", function() { return getExpenseBillList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseBillOutstandingList", function() { return getExpenseBillOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getExpenseBillDataProps", function() { return getExpenseBillDataProps; });
var getExpenseBillList = function getExpenseBillList(state) {
    return state.list;
};

var getExpenseBillOutstandingList = function getExpenseBillOutstandingList(state) {
    return state.outstanding_list;
};

var getExpenseBillDataProps = function getExpenseBillDataProps(state) {
    return state.props;
};

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__letterTemplate_actions__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__letterTemplate_mutations__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__letterTemplate_getters__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__letterTemplate_properties__ = __webpack_require__(371);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__letterTemplate_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__letterTemplate_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__letterTemplate_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__letterTemplate_actions__
});

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLetterTemplateList", function() { return fetchLetterTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLetterTemplateData", function() { return fetchLetterTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitLetterTemplateData", function() { return submitLetterTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteLetterTemplateData", function() { return deleteLetterTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchLetterTemplateList = function fetchLetterTemplateList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/letterTemplate/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setLetterTemplateList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchLetterTemplateData = function fetchLetterTemplateData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/letterTemplate/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setLetterTemplateData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetLetterTemplateData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitLetterTemplateData = function submitLetterTemplateData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/letterTemplate/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteLetterTemplateData = function deleteLetterTemplateData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/letterTemplate/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchLetterTemplateList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLetterTemplateList", function() { return setLetterTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLetterTemplateData", function() { return setLetterTemplateData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetLetterTemplateData", function() { return resetLetterTemplateData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(371);


var setLetterTemplateList = function setLetterTemplateList(state, payload) {
    state.list = payload;
};

var setLetterTemplateData = function setLetterTemplateData(state, payload) {
    state.props = payload;
};

var resetLetterTemplateData = function resetLetterTemplateData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLetterTemplateList", function() { return getLetterTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLetterTemplateDataProps", function() { return getLetterTemplateDataProps; });
var getLetterTemplateList = function getLetterTemplateList(state) {
    return state.list;
};

var getLetterTemplateDataProps = function getLetterTemplateDataProps(state) {
    return state.props;
};

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lostDamaged_actions__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lostDamaged_mutations__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lostDamaged_getters__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lostDamaged_properties__ = __webpack_require__(372);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__lostDamaged_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__lostDamaged_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__lostDamaged_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__lostDamaged_actions__
});

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLostDamagedList", function() { return fetchLostDamagedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLostDamagedRequest", function() { return fetchLostDamagedRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchLostDamagedData", function() { return fetchLostDamagedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitLostDamagedData", function() { return submitLostDamagedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteLostDamagedData", function() { return deleteLostDamagedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchLostDamagedList = function fetchLostDamagedList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/lostDamaged/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchLostDamagedList', payload);
            } else {
                commit('setLostDamagedList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchLostDamagedRequest = function fetchLostDamagedRequest(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/lostDamaged/fetchLostDamagedRequest.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchLostDamagedRequest', payload);
            } else {
                commit('setLostDamagedRequestList', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchLostDamagedData = function fetchLostDamagedData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/lostDamaged/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setLostDamagedData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetLostDamagedData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitLostDamagedData = function submitLostDamagedData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/lostDamaged/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchLostDamagedData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteLostDamagedData = function deleteLostDamagedData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/lostDamaged/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchLostDamagedList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLostDamagedList", function() { return setLostDamagedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLostDamagedRequestList", function() { return setLostDamagedRequestList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLostDamagedData", function() { return setLostDamagedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewLostDamagedItemListRow", function() { return addNewLostDamagedItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeLostDamagedItemListRow", function() { return removeLostDamagedItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetLostDamagedData", function() { return resetLostDamagedData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(372);


var setLostDamagedList = function setLostDamagedList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setLostDamagedRequestList = function setLostDamagedRequestList(state, payload) {
    state.request_list = payload;
};

var setLostDamagedData = function setLostDamagedData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ', \r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

var addNewLostDamagedItemListRow = function addNewLostDamagedItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        document.getElementById('item_id_' + (key - 1)).focus();
    }, 300);
};

var removeLostDamagedItemListRow = function removeLostDamagedItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetLostDamagedData = function resetLostDamagedData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLostDamagedList", function() { return getLostDamagedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLostDamagedDataProps", function() { return getLostDamagedDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLostDamagedRequestList", function() { return getLostDamagedRequestList; });
var getLostDamagedList = function getLostDamagedList(state) {
    return state.list;
};

var getLostDamagedDataProps = function getLostDamagedDataProps(state) {
    return state.props;
};

var getLostDamagedRequestList = function getLostDamagedRequestList(state) {
    return state.request_list;
};

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreOrder_actions__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreOrder_mutations__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreOrder_getters__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreOrder_properties__ = __webpack_require__(373);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.confirmation_date',
        sort_direction: 1,
        search_term: '',
        search_term_array: [],
        total_amount: 0
    },
    props: null
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreOrder_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreOrder_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreOrder_actions__
});

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreOrderList", function() { return fetchEStoreOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreOrderData", function() { return fetchEStoreOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreOrderData", function() { return submitEStoreOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreOrderData", function() { return deleteEStoreOrderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEStoreOrderList = function fetchEStoreOrderList(_ref, payload) {
    var commit = _ref.commit;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreOrder/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            var _commit;

            commit('setEStoreOrderList', (_commit = { response: res.data.response, total: res.data.total, page_number: res.data.page_number }, _defineProperty(_commit, 'page_number', res.data.page_number), _defineProperty(_commit, 'total_amount', res.data.total_amount), _commit));
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchEStoreOrderData = function fetchEStoreOrderData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreOrder/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('setEStoreOrderData', res.data.response);
        } else {
            commit('resetEStoreOrderData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreOrderData = function submitEStoreOrderData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreOrder/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreOrderData = function deleteEStoreOrderData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreOrder/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            dispatch('fetchEStoreOrderList', payload.list);
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreOrderList", function() { return setEStoreOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreOrderData", function() { return setEStoreOrderData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreOrderData", function() { return resetEStoreOrderData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(373);


var setEStoreOrderList = function setEStoreOrderList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    state.nav.total_amount = payload.total_amount;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setEStoreOrderData = function setEStoreOrderData(state, payload) {
    state.props = payload;
};

var resetEStoreOrderData = function resetEStoreOrderData(state) {
    state.props = null;
};

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreOrderList", function() { return getEStoreOrderList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreOrderDataProps", function() { return getEStoreOrderDataProps; });
var getEStoreOrderList = function getEStoreOrderList(state) {
    return state.list;
};

var getEStoreOrderDataProps = function getEStoreOrderDataProps(state) {
    return state.props;
};

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__news_actions__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__news_mutations__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__news_getters__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__news_properties__ = __webpack_require__(374);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: [],
        total_amount: 0
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__news_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__news_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__news_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__news_actions__
});

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNewsList", function() { return fetchNewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNewsData", function() { return fetchNewsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitNewsData", function() { return submitNewsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteNewsData", function() { return deleteNewsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchNewsList = function fetchNewsList(_ref, payload) {
    var commit = _ref.commit;

    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/news/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            var _commit;

            commit('setNewsList', (_commit = { response: res.data.response, total: res.data.total, page_number: res.data.page_number }, _defineProperty(_commit, 'page_number', res.data.page_number), _defineProperty(_commit, 'total_amount', res.data.total_amount), _commit));
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchNewsData = function fetchNewsData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/news/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (payload.copy) {
            res.data.response.id = 0;
            commit('displaySuccessNotification', { message: 'Data copied!!!' });
        }

        if (res.data.status) {

            commit('setNewsData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetNewsData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitNewsData = function submitNewsData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/news/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteNewsData = function deleteNewsData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/news/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchNewsList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewsList", function() { return setNewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setNewsData", function() { return setNewsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetNewsData", function() { return resetNewsData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(374);


var setNewsList = function setNewsList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    state.nav.total_amount = payload.total_amount;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setNewsData = function setNewsData(state, payload) {
    state.props = payload;
};

var resetNewsData = function resetNewsData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewsList", function() { return getNewsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNewsDataProps", function() { return getNewsDataProps; });
var getNewsList = function getNewsList(state) {
    return state.list;
};

var getNewsDataProps = function getNewsDataProps(state) {
    return state.props;
};

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreCatalog_actions__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreCatalog_mutations__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreCatalog_getters__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreCatalog_properties__ = __webpack_require__(375);






var state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1, search_term: '',
        search_term_array: []
    },
    request_list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__eStoreCatalog_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreCatalog_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreCatalog_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreCatalog_actions__
});

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreCatalogList", function() { return fetchEStoreCatalogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreCatalogRequest", function() { return fetchEStoreCatalogRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreCatalogData", function() { return fetchEStoreCatalogData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreCatalogData", function() { return submitEStoreCatalogData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreCatalogData", function() { return deleteEStoreCatalogData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEStoreCatalogList = function fetchEStoreCatalogList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCatalog/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            commit('setEStoreCatalogList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchEStoreCatalogRequest = function fetchEStoreCatalogRequest(_ref2, payload) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCatalog/fetchEStoreCatalogRequest.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
            if (res.data.try_again) {
                dispatch('fetchEStoreCatalogRequest', payload);
            } else {
                commit('setEStoreCatalogRequestList', res.data.response);
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchEStoreCatalogData = function fetchEStoreCatalogData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCatalog/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setEStoreCatalogData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreCatalogData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreCatalogData = function submitEStoreCatalogData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCatalog/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0 && !payload.popup) {
                //router.push(router.currentRoute.fullPath.replace('/form/', ''))
            }
            dispatch('fetchEStoreCatalogData', { id: res.data.id });
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreCatalogData = function deleteEStoreCatalogData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCatalog/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else if (payload.popup) {} else {
                dispatch('fetchEStoreCatalogList', payload.list);
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreCatalogList", function() { return setEStoreCatalogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreCatalogRequestList", function() { return setEStoreCatalogRequestList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreCatalogData", function() { return setEStoreCatalogData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addNewEStoreCatalogItemListRow", function() { return addNewEStoreCatalogItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreCatalogItemListRow", function() { return removeEStoreCatalogItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreCatalogData", function() { return resetEStoreCatalogData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(375);


var setEStoreCatalogList = function setEStoreCatalogList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setEStoreCatalogRequestList = function setEStoreCatalogRequestList(state, payload) {
    state.request_list = payload;
};

var setEStoreCatalogData = function setEStoreCatalogData(state, payload) {
    state.props = payload.response;

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    } else if (payload.copy) {
        state.props.item_list.forEach(function (element) {
            element.id = 0;
        });
    }

    var key = 0;
    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addNewEStoreCatalogItemListRow = function addNewEStoreCatalogItemListRow(state) {

    var key = 0;
    state.props.item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */])));

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });

    setTimeout(function () {
        //document.getElementById('item_id_'+(key-1)).focus()
    }, 300);
};

var removeEStoreCatalogItemListRow = function removeEStoreCatalogItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* itemListProps */]))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var resetEStoreCatalogData = function resetEStoreCatalogData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreCatalogList", function() { return getEStoreCatalogList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreCatalogDataProps", function() { return getEStoreCatalogDataProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreCatalogRequestList", function() { return getEStoreCatalogRequestList; });
var getEStoreCatalogList = function getEStoreCatalogList(state) {
    return state.list;
};

var getEStoreCatalogDataProps = function getEStoreCatalogDataProps(state) {
    return state.props;
};

var getEStoreCatalogRequestList = function getEStoreCatalogRequestList(state) {
    return state.request_list;
};

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dataBackup_actions__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dataBackup_mutations__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataBackup_getters__ = __webpack_require__(1578);




var state = {
    list: []
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__dataBackup_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__dataBackup_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__dataBackup_actions__
});

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDataBackupList", function() { return fetchDataBackupList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchDataBackup", function() { return fetchDataBackup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var fetchDataBackupList = function fetchDataBackupList(_ref) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/dataBackup/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setDataBackupList', res.data);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchDataBackup = function fetchDataBackup(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch;


    commit('toggleLoadingState', true);
    setTimeout(function () {
        commit('displayMessageAlert', { message: 'Admin will receive an email in a few minutes.', type: 'Info' });
        commit('toggleLoadingState', false);
    }, 1000);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/dataBackup/save.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        console.log(JSON.stringify(res.data));
        dispatch('fetchDataBackupList');
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDataBackupList", function() { return setDataBackupList; });
var setDataBackupList = function setDataBackupList(state, payload) {
    state.list = payload.response;
};

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDataBackupList", function() { return getDataBackupList; });
var getDataBackupList = function getDataBackupList(state) {
    return state.list;
};

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tailoringTrialType_actions__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tailoringTrialType_mutations__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tailoringTrialType_getters__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tailoringTrialType_properties__ = __webpack_require__(376);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__tailoringTrialType_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__tailoringTrialType_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__tailoringTrialType_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__tailoringTrialType_actions__
});

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringTrialTypeList", function() { return fetchTailoringTrialTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTailoringTrialTypeData", function() { return fetchTailoringTrialTypeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitTailoringTrialTypeData", function() { return submitTailoringTrialTypeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteTailoringTrialTypeData", function() { return deleteTailoringTrialTypeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchTailoringTrialTypeList = function fetchTailoringTrialTypeList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/tailoringTrialType/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setTailoringTrialTypeList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchTailoringTrialTypeData = function fetchTailoringTrialTypeData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringTrialType/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setTailoringTrialTypeData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetTailoringTrialTypeData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitTailoringTrialTypeData = function submitTailoringTrialTypeData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringTrialType/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteTailoringTrialTypeData = function deleteTailoringTrialTypeData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/tailoringTrialType/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchTailoringTrialTypeList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringTrialTypeList", function() { return setTailoringTrialTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTailoringTrialTypeData", function() { return setTailoringTrialTypeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetTailoringTrialTypeData", function() { return resetTailoringTrialTypeData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(376);


var setTailoringTrialTypeList = function setTailoringTrialTypeList(state, payload) {
    state.list = payload;
};

var setTailoringTrialTypeData = function setTailoringTrialTypeData(state, payload) {
    state.props = payload;
};

var resetTailoringTrialTypeData = function resetTailoringTrialTypeData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringTrialTypeList", function() { return getTailoringTrialTypeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTailoringTrialTypeDataProps", function() { return getTailoringTrialTypeDataProps; });
var getTailoringTrialTypeList = function getTailoringTrialTypeList(state) {
    return state.list;
};

var getTailoringTrialTypeDataProps = function getTailoringTrialTypeDataProps(state) {
    return state.props;
};

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__campaign_actions__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__campaign_mutations__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__campaign_getters__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__campaign_properties__ = __webpack_require__(377);






var state = {
    list: [],
    nav: {
        page_number: 1,
        had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search: ''
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__campaign_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__campaign_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__campaign_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__campaign_actions__
});

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCampaignList", function() { return fetchCampaignList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCampaignCustomerAnalysisList", function() { return fetchCampaignCustomerAnalysisList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCampaignData", function() { return fetchCampaignData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitCampaignData", function() { return submitCampaignData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCampaignData", function() { return deleteCampaignData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchCampaignList = function fetchCampaignList(_ref, payload) {
    var commit = _ref.commit,
        dispatch = _ref.dispatch;


    commit('toggleLoadingState', true);
    if (payload.store_list.length === 0) {
        return false;
    } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/campaign/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

            if (res.data.try_again) {
                dispatch('fetchCampaignList', payload);
            } else {
                commit('setCampaignList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
            }
        }).catch(function (error) {
            commit('displayMessageAlert', { message: error, type: 'Error' });
        }).finally(function () {
            commit('toggleLoadingState', false);
        });
    }
};

var fetchCampaignCustomerAnalysisList = function fetchCampaignCustomerAnalysisList(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/campaign/customerAnalysis.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setCampaignCustomerList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchCampaignData = function fetchCampaignData(_ref3, payload) {
    var commit = _ref3.commit;

    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/campaign/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            commit('setCampaignData', { response: res.data.response, copy: payload.copy });

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetCampaignData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitCampaignData = function submitCampaignData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/campaign/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchCampaignData', { id: res.data.id });
            }
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteCampaignData = function deleteCampaignData(_ref5, payload) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/campaign/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            dispatch('fetchCampaignList', payload.list_query);
        } else {
            commit('displayMessageAlert', { message: res.data.message, type: 'Error', displayHTML: true });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCampaignList", function() { return setCampaignList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCampaignOutstandingList", function() { return setCampaignOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCampaignOutstandingList", function() { return resetCampaignOutstandingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCampaignData", function() { return setCampaignData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPurchaseOrderShippingAddress", function() { return setPurchaseOrderShippingAddress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeCampaignItemListRow", function() { return removeCampaignItemListRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCampaignCustomerList", function() { return setCampaignCustomerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCampaignData", function() { return resetCampaignData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(377);


var setCampaignList = function setCampaignList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
    if (!state.nav.had_results) {
        state.nav.had_results = payload.total > 0;
    }
};

var setCampaignOutstandingList = function setCampaignOutstandingList(state, payload) {
    state.outstanding_list = payload;
};

var resetCampaignOutstandingList = function resetCampaignOutstandingList(state) {
    state.outstanding_list = [];
};

var setCampaignData = function setCampaignData(state, payload) {
    state.props = payload.response;
};

var setPurchaseOrderShippingAddress = function setPurchaseOrderShippingAddress(state, payload) {
    state.props.shipment_address = payload.legal_name + '\r\n' + payload.address + ',\r\n' + payload.city_name + '-' + payload.postal_code + ', ' + payload.province_name + ', ' + payload.country_name + '.\r\n' + payload.contact_number + ', ' + payload.email_address + '.';
};

/*export const addNewCampaignItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}*/

var removeCampaignItemListRow = function removeCampaignItemListRow(state, payload) {

    var key = 0;

    state.props.item_list.splice(payload, 1);

    if (state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))];
    }

    state.props.item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var setCampaignCustomerList = function setCampaignCustomerList(state, payload) {

    var list = payload.filter(function (thing, index, self) {
        return index === self.findIndex(function (t) {
            return t.customer_id === thing.customer_id && t.customer_id > 0;
        });
    });
    payload.filter(function (t) {
        return t.customer_id === 0;
    }).forEach(function (element) {
        list.push(element);
    });

    state.props.customer_list = list;
};

var resetCampaignData = function resetCampaignData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCampaignList", function() { return getCampaignList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCampaignDataProps", function() { return getCampaignDataProps; });
var getCampaignList = function getCampaignList(state) {
    return state.list;
};

var getCampaignDataProps = function getCampaignDataProps(state) {
    return state.props;
};

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreCategory_actions__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreCategory_mutations__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreCategory_getters__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreCategory_properties__ = __webpack_require__(378);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__eStoreCategory_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreCategory_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreCategory_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreCategory_actions__
});

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreCategoryList", function() { return fetchEStoreCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreCategoryData", function() { return fetchEStoreCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreCategoryData", function() { return submitEStoreCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreCategoryData", function() { return deleteEStoreCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchEStoreCategoryList = function fetchEStoreCategoryList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/eStoreCategory/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEStoreCategoryList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEStoreCategoryData = function fetchEStoreCategoryData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCategory/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEStoreCategoryData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreCategoryData = function submitEStoreCategoryData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCategory/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreCategoryData = function deleteEStoreCategoryData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreCategory/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEStoreCategoryList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreCategoryList", function() { return setEStoreCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreCategoryData", function() { return setEStoreCategoryData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreCategoryData", function() { return resetEStoreCategoryData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(378);


var setEStoreCategoryList = function setEStoreCategoryList(state, payload) {
    state.list = payload;
};

var setEStoreCategoryData = function setEStoreCategoryData(state, payload) {
    state.props = payload;
};

var resetEStoreCategoryData = function resetEStoreCategoryData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreCategoryList", function() { return getEStoreCategoryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreCategoryDataProps", function() { return getEStoreCategoryDataProps; });
var getEStoreCategoryList = function getEStoreCategoryList(state) {
    return state.list;
};

var getEStoreCategoryDataProps = function getEStoreCategoryDataProps(state) {
    return state.props;
};

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreTopMenu_actions__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreTopMenu_mutations__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreTopMenu_getters__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreTopMenu_properties__ = __webpack_require__(379);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__eStoreTopMenu_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreTopMenu_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreTopMenu_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreTopMenu_actions__
});

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreTopMenuList", function() { return fetchEStoreTopMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreTopMenuData", function() { return fetchEStoreTopMenuData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreTopMenuData", function() { return submitEStoreTopMenuData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreTopMenuData", function() { return deleteEStoreTopMenuData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchEStoreTopMenuList = function fetchEStoreTopMenuList(_ref) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/eStoreTopMenu/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEStoreTopMenuList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEStoreTopMenuData = function fetchEStoreTopMenuData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreTopMenu/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEStoreTopMenuData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreTopMenuData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreTopMenuData = function submitEStoreTopMenuData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreTopMenu/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreTopMenuData = function deleteEStoreTopMenuData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreTopMenu/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEStoreTopMenuList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreTopMenuList", function() { return setEStoreTopMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreTopMenuData", function() { return setEStoreTopMenuData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreTopMenuData", function() { return resetEStoreTopMenuData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortEStoreTopMenuList", function() { return sortEStoreTopMenuList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(379);


var setEStoreTopMenuList = function setEStoreTopMenuList(state, payload) {
    state.list = payload;
};

var setEStoreTopMenuData = function setEStoreTopMenuData(state, payload) {
    state.props = payload;
};

var resetEStoreTopMenuData = function resetEStoreTopMenuData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

var sortEStoreTopMenuList = function sortEStoreTopMenuList(state, payload) {

    var key = payload.sl_no;

    if (payload.sort == 1) {
        state.list[key].sl_no = payload.sl_no + 1;
        state.list[key + 1].sl_no = payload.sl_no;
    } else if (payload.sort == 0) {
        state.list[key].sl_no = payload.sl_no - 1;
        state.list[key - 1].sl_no = payload.sl_no;
    }

    state.list = state.list.sort(function (a, b) {
        var x = a.sl_no < b.sl_no ? -1 : 1;
        return x;
    });
};

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreTopMenuList", function() { return getEStoreTopMenuList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreTopMenuDataProps", function() { return getEStoreTopMenuDataProps; });
var getEStoreTopMenuList = function getEStoreTopMenuList(state) {
    return state.list;
};

var getEStoreTopMenuDataProps = function getEStoreTopMenuDataProps(state) {
    return state.props;
};

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreProduct_actions__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreProduct_mutations__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreProduct_getters__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreProduct_properties__ = __webpack_require__(380);






var state = {
    list: [],
    nav: {
        page_number: 1,
        limit: 10,
        total: 0,
        sort_column_name: 't1.id',
        sort_direction: 1,
        search_term: '',
        search_term_array: []
    },
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__eStoreProduct_properties__["c" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreProduct_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreProduct_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreProduct_actions__
});

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreProductList", function() { return fetchEStoreProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreProductData", function() { return fetchEStoreProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreProductData", function() { return submitEStoreProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreProductData", function() { return deleteEStoreProductData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var fetchEStoreProductList = function fetchEStoreProductList(_ref, payload) {
    var commit = _ref.commit;


    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreProduct/index.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEStoreProductList', _defineProperty({ response: res.data.response, total: res.data.total, page_number: res.data.page_number }, 'page_number', res.data.page_number));
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEStoreProductData = function fetchEStoreProductData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreProduct/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEStoreProductData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreProductData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreProductData = function submitEStoreProductData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreProduct/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
            if (payload.id === 0) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreProductData = function deleteEStoreProductData(_ref4, payload) {
    var commit = _ref4.commit,
        dispatch = _ref4.dispatch;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreProduct/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEStoreProductList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreProductList", function() { return setEStoreProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreProductData", function() { return setEStoreProductData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataFooterNote", function() { return addEStoreProductDataFooterNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataFooterNote", function() { return removeEStoreProductDataFooterNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataBaseVariant", function() { return addEStoreProductDataBaseVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataBaseVariant", function() { return removeEStoreProductDataBaseVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataOtherVariant", function() { return addEStoreProductDataOtherVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataOtherVariant", function() { return removeEStoreProductDataOtherVariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataLookbook", function() { return addEStoreProductDataLookbook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataLookbook", function() { return removeEStoreProductDataLookbook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataFootNote", function() { return addEStoreProductDataFootNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataFootNote", function() { return removeEStoreProductDataFootNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataFabric", function() { return addEStoreProductDataFabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataFabric", function() { return removeEStoreProductDataFabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataCustomStyleFabric", function() { return addEStoreProductDataCustomStyleFabric; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreProductDataCustomStyleFabricItem", function() { return addEStoreProductDataCustomStyleFabricItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreProductDataCustomStyleFabricItem", function() { return removeEStoreProductDataCustomStyleFabricItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreProductData", function() { return resetEStoreProductData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(380);


var setEStoreProductList = function setEStoreProductList(state, payload) {
    state.list = payload.response;
    state.nav.total = payload.total;
    state.nav.page_number = payload.page_number;
};

var setEStoreProductData = function setEStoreProductData(state, payload) {
    state.props = payload;

    var key = 0;
    state.props.footer_note_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

/* FOOTER NOTE */
var addEStoreProductDataFooterNote = function addEStoreProductDataFooterNote(state) {
    state.props.footer_note_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* footerNoteProps */])));

    var key = 0;
    state.props.footer_note_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataFooterNote = function removeEStoreProductDataFooterNote(state, payload) {
    var key = 0;

    state.props.footer_note_list.splice(payload, 1);

    if (state.props.footer_note_list.length === 0) {
        state.props.footer_note_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* footerNoteProps */]))];
    }

    state.props.footer_note_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END FOOTER NOTE */

/* BASE VARIANT */
var addEStoreProductDataBaseVariant = function addEStoreProductDataBaseVariant(state) {
    state.props.basic_cart_selection_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* basicCartVariantProps */])));

    var key = 0;
    state.props.basic_cart_selection_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataBaseVariant = function removeEStoreProductDataBaseVariant(state, payload) {
    var key = 0;

    state.props.basic_cart_selection_item_list.splice(payload, 1);

    state.props.basic_cart_selection_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END BASE VARIANT */

/* OTHER VARIANT */
var addEStoreProductDataOtherVariant = function addEStoreProductDataOtherVariant(state) {
    state.props.other_selection_variant_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* basicCartVariantProps */])));

    var key = 0;
    state.props.other_selection_variant_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataOtherVariant = function removeEStoreProductDataOtherVariant(state, payload) {
    var key = 0;

    state.props.other_selection_variant_item_list.splice(payload, 1);

    state.props.other_selection_variant_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END OTHER VARIANT */

/* LOOKBOOK */
var addEStoreProductDataLookbook = function addEStoreProductDataLookbook(state) {
    state.props.look_book_item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* basicCartVariantProps */])));

    var key = 0;
    state.props.look_book_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataLookbook = function removeEStoreProductDataLookbook(state, payload) {
    var key = 0;

    state.props.look_book_item_list.splice(payload, 1);

    state.props.look_book_item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END LOOKBOOK */

/* FOOT NOTE */
var addEStoreProductDataFootNote = function addEStoreProductDataFootNote(state) {
    state.props.footer_note_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* footerNoteProps */])));

    var key = 0;
    state.props.footer_note_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataFootNote = function removeEStoreProductDataFootNote(state, payload) {
    var key = 0;

    state.props.footer_note_list.splice(payload, 1);

    if (state.props.footer_note_list.length === 0) {
        state.props.footer_note_list = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["d" /* footerNoteProps */]))];
    }

    state.props.footer_note_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END FOOT NOTE */

/* FABRIC CHOICE */
var addEStoreProductDataFabric = function addEStoreProductDataFabric(state) {
    state.props.suggested_base_fabric.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* basicCartVariantProps */])));

    var key = 0;
    state.props.suggested_base_fabric.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataFabric = function removeEStoreProductDataFabric(state, payload) {
    var key = 0;

    state.props.suggested_base_fabric.splice(payload, 1);
    state.props.suggested_base_fabric.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END FABRIC CHOICE */

/* CUSTOM STYLE FABRIC CHOICE */
var addEStoreProductDataCustomStyleFabric = function addEStoreProductDataCustomStyleFabric(state, payload) {

    state.props.custom_choise_fabric.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* customChoiceFabric */])));
    var totalItem = state.props.custom_choise_fabric.length;
    state.props.custom_choise_fabric[totalItem - 1].style_option_id = payload;

    var key = 0;
    state.props.custom_choise_fabric.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var addEStoreProductDataCustomStyleFabricItem = function addEStoreProductDataCustomStyleFabricItem(state, payload) {
    state.props.custom_choise_fabric[payload].suggested_fabric.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* basicCartVariantProps */])));

    var key = 0;
    state.props.custom_choise_fabric[payload].suggested_fabric.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreProductDataCustomStyleFabricItem = function removeEStoreProductDataCustomStyleFabricItem(state, payload) {
    var key = 0;

    state.props.custom_choise_fabric[payload.parent_key].suggested_fabric.splice(payload.key, 1);

    state.props.custom_choise_fabric[payload.parent_key].suggested_fabric.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END CUSTOM STYLE FABRIC CHOICE */

var resetEStoreProductData = function resetEStoreProductData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* dataProps */]));
};

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreProductList", function() { return getEStoreProductList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreProductDataProps", function() { return getEStoreProductDataProps; });
var getEStoreProductList = function getEStoreProductList(state) {
    return state.list;
};

var getEStoreProductDataProps = function getEStoreProductDataProps(state) {
    return state.props;
};

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eStoreHomePage_actions__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eStoreHomePage_mutations__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eStoreHomePage_getters__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eStoreHomePage_properties__ = __webpack_require__(381);






var state = {
    list: [],
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__eStoreHomePage_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__eStoreHomePage_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__eStoreHomePage_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__eStoreHomePage_actions__
});

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreHomePageList", function() { return fetchEStoreHomePageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchEStoreHomePageData", function() { return fetchEStoreHomePageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitEStoreHomePageData", function() { return submitEStoreHomePageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deleteEStoreHomePageData", function() { return deleteEStoreHomePageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(7);




var fetchEStoreHomePageList = function fetchEStoreHomePageList(_ref) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/eStoreHomePage/index.php', __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        commit('setEStoreHomePageList', res.data.response);
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var fetchEStoreHomePageData = function fetchEStoreHomePageData(_ref2, payload) {
    var commit = _ref2.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreHomePage/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEStoreHomePageData', res.data.response);

            if (payload.navigate) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreCategoryData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var submitEStoreHomePageData = function submitEStoreHomePageData(_ref3, payload) {
    var commit = _ref3.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreHomePage/save.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data submitted successfully!!!' });
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

var deleteEStoreHomePageData = function deleteEStoreHomePageData(_ref4, payload) {
    var commit = _ref4.commit;


    commit('toggleLoadingState', true);

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreHomePage/delete.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {
        if (res.data.status) {
            commit('displaySuccessNotification', { message: 'Data deleted successfully!!!' });
            if (payload.navBack) {
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute.fullPath.replace('/form/', ''));
            } else {
                dispatch('fetchEStoreHomePageList');
            }
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreHomePageList", function() { return setEStoreHomePageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setEStoreHomePageData", function() { return setEStoreHomePageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreHomePageDataSliderItem", function() { return addEStoreHomePageDataSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreHomePageDataSliderItem", function() { return removeEStoreHomePageDataSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreHomePageDataFeaturedItem", function() { return addEStoreHomePageDataFeaturedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreHomePageDataFeaturedItem", function() { return removeEStoreHomePageDataFeaturedItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEStoreHomePageDataFeaturedItemSKU", function() { return addEStoreHomePageDataFeaturedItemSKU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEStoreHomePageDataFeaturedItemSKU", function() { return removeEStoreHomePageDataFeaturedItemSKU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetEStoreHomePageData", function() { return resetEStoreHomePageData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(381);


var setEStoreHomePageList = function setEStoreHomePageList(state, payload) {
    state.list = payload;
};

var setEStoreHomePageData = function setEStoreHomePageData(state, payload) {
    state.props = payload;

    var key = 0;
    state.props.slider_items.forEach(function (element) {
        element.key = key;
        key++;
    });

    key = 0;
    state.props.feature_list_items.forEach(function (element) {
        element.key = key;
        key++;
        var key1 = 0;
        element.item_list.forEach(function (el) {
            el.key = key1;
            key1++;
        });
    });
};

/* SLIDER ITEMS */
var addEStoreHomePageDataSliderItem = function addEStoreHomePageDataSliderItem(state) {
    state.props.slider_items.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* itemListProps */])));

    var key = 0;
    state.props.slider_items.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreHomePageDataSliderItem = function removeEStoreHomePageDataSliderItem(state, payload) {
    var key = 0;

    state.props.slider_items.splice(payload, 1);

    if (state.props.slider_items.length === 0) {
        state.props.slider_items = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* itemListProps */]))];
    }

    state.props.slider_items.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END SLIDER ITEMS */

/* FEATURED ITEMS */
var addEStoreHomePageDataFeaturedItem = function addEStoreHomePageDataFeaturedItem(state) {
    state.props.feature_list_items.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* featureItemProps */])));

    var key = 0;
    state.props.feature_list_items.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreHomePageDataFeaturedItem = function removeEStoreHomePageDataFeaturedItem(state, payload) {
    var key = 0;

    state.props.feature_list_items.splice(payload, 1);

    if (state.props.feature_list_items.length === 0) {
        state.props.feature_list_items = [JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["b" /* featureItemProps */]))];
    }

    state.props.feature_list_items.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END FEATURED ITEMS */

/* FEATURED ITEMS SKU LIST */
var addEStoreHomePageDataFeaturedItemSKU = function addEStoreHomePageDataFeaturedItemSKU(state, payload) {
    console.log(JSON.stringify(payload));
    state.props.feature_list_items[payload.parentKey].item_list.push(JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["c" /* itemListProps */])));

    var key = 0;
    state.props.feature_list_items[payload.parentKey].item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};

var removeEStoreHomePageDataFeaturedItemSKU = function removeEStoreHomePageDataFeaturedItemSKU(state, payload) {
    var key = 0;
    state.props.feature_list_items[payload.parentKey].item_list.splice(payload.key, 1);

    state.props.feature_list_items[payload.parentKey].item_list.forEach(function (element) {
        element.key = key;
        key++;
    });
};
/* END FEATURED ITEMS SKU LIST */

var resetEStoreHomePageData = function resetEStoreHomePageData(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreHomePageList", function() { return getEStoreHomePageList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEStoreHomePageDataProps", function() { return getEStoreHomePageDataProps; });
var getEStoreHomePageList = function getEStoreHomePageList(state) {
    return state.list;
};

var getEStoreHomePageDataProps = function getEStoreHomePageDataProps(state) {
    return state.props;
};

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__garmentCustomiser_actions__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__garmentCustomiser_mutations__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__garmentCustomiser_getters__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__garmentCustomiser_properties__ = __webpack_require__(382);






var state = {
    props: JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_3__garmentCustomiser_properties__["a" /* dataProps */]))
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    getters: __WEBPACK_IMPORTED_MODULE_2__garmentCustomiser_getters__,
    mutations: __WEBPACK_IMPORTED_MODULE_1__garmentCustomiser_mutations__,
    actions: __WEBPACK_IMPORTED_MODULE_0__garmentCustomiser_actions__
});

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submitGarmentCustomiser", function() { return submitGarmentCustomiser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessToken__ = __webpack_require__(3);



var submitGarmentCustomiser = function submitGarmentCustomiser(_ref, payload) {
    var commit = _ref.commit;


    commit('toggleLoadingState', true);
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/eStoreProduct/single.php', payload, __WEBPACK_IMPORTED_MODULE_1__accessToken__["a" /* accessTokenInfo */]()).then(function (res) {

        if (res.data.status) {

            if (payload.copy) {
                res.data.response.id = 0;
                commit('displaySuccessNotification', { message: 'Data copied!!!' });
            }

            commit('setEStoreProductData', res.data.response);

            if (payload.navigate) {
                router.push(router.currentRoute.fullPath + '/form/');
            }
        } else {
            commit('resetEStoreProductData');
        }
    }).catch(function (error) {
        commit('displayMessageAlert', { message: error, type: 'Error' });
    }).finally(function () {
        commit('toggleLoadingState', false);
    });
};

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetGarmentCustomiser", function() { return resetGarmentCustomiser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__properties__ = __webpack_require__(382);


var resetGarmentCustomiser = function resetGarmentCustomiser(state) {
    state.props = JSON.parse(JSON.stringify(__WEBPACK_IMPORTED_MODULE_0__properties__["a" /* dataProps */]));
};

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGarmentCustomiser", function() { return getGarmentCustomiser; });
var getGarmentCustomiser = function getGarmentCustomiser(state) {
    return state.props;
};

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
  el: {
    colorpicker: {
      confirm: 'OK',
      clear: 'Clear'
    },
    datepicker: {
      now: 'Now',
      today: 'Today',
      cancel: 'Cancel',
      clear: 'Clear',
      confirm: 'OK',
      selectDate: 'Select date',
      selectTime: 'Select time',
      startDate: 'Start Date',
      startTime: 'Start Time',
      endDate: 'End Date',
      endTime: 'End Time',
      prevYear: 'Previous Year',
      nextYear: 'Next Year',
      prevMonth: 'Previous Month',
      nextMonth: 'Next Month',
      year: '',
      month1: 'January',
      month2: 'February',
      month3: 'March',
      month4: 'April',
      month5: 'May',
      month6: 'June',
      month7: 'July',
      month8: 'August',
      month9: 'September',
      month10: 'October',
      month11: 'November',
      month12: 'December',
      week: 'week',
      weeks: {
        sun: 'Sun',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat'
      },
      months: {
        jan: 'Jan',
        feb: 'Feb',
        mar: 'Mar',
        apr: 'Apr',
        may: 'May',
        jun: 'Jun',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'Oct',
        nov: 'Nov',
        dec: 'Dec'
      }
    },
    select: {
      loading: 'Loading',
      noMatch: 'No matching data',
      noData: 'No data',
      placeholder: 'Select'
    },
    cascader: {
      noMatch: 'No matching data',
      loading: 'Loading',
      placeholder: 'Select',
      noData: 'No data'
    },
    pagination: {
      goto: 'Go to',
      pagesize: '/page',
      total: 'Total {total}',
      pageClassifier: ''
    },
    messagebox: {
      title: 'Message',
      confirm: 'OK',
      cancel: 'Cancel',
      error: 'Illegal input'
    },
    upload: {
      deleteTip: 'press delete to remove',
      delete: 'Delete',
      preview: 'Preview',
      continue: 'Continue'
    },
    table: {
      emptyText: 'No Data',
      confirmFilter: 'Confirm',
      resetFilter: 'Reset',
      clearFilter: 'All',
      sumText: 'Sum'
    },
    tree: {
      emptyText: 'No Data'
    },
    transfer: {
      noMatch: 'No matching data',
      noData: 'No data',
      titles: ['List 1', 'List 2'], // to be translated
      filterPlaceholder: 'Enter keyword', // to be translated
      noCheckedFormat: '{total} items', // to be translated
      hasCheckedFormat: '{checked}/{total} checked' // to be translated
    },
    image: {
      error: 'FAILED'
    },
    pageHeader: {
      title: 'Back' // to be translated
    },
    popconfirm: {
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    },
    empty: {
      description: 'No Data'
    }
  }
};

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export VueEditor */
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* unused harmony reexport Quill */
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vue2-editor v2.10.3 
 * (c) 2021 David Royer
 * Released under the MIT License.
 */



var defaultToolbar = [[{
  header: [false, 1, 2, 3, 4, 5, 6]
}], ["bold", "italic", "underline", "strike"], // toggled buttons
[{
  align: ""
}, {
  align: "center"
}, {
  align: "right"
}, {
  align: "justify"
}], ["blockquote", "code-block"], [{
  list: "ordered"
}, {
  list: "bullet"
}, {
  list: "check"
}], [{
  indent: "-1"
}, {
  indent: "+1"
}], // outdent/indent
[{
  color: []
}, {
  background: []
}], // dropdown with defaults from theme
["link", "image", "video"], ["clean"] // remove formatting button
];

var oldApi = {
  props: {
    customModules: Array
  },
  methods: {
    registerCustomModules: function registerCustomModules(Quill) {
      if (this.customModules !== undefined) {
        this.customModules.forEach(function (customModule) {
          Quill.register("modules/" + customModule.alias, customModule.module);
        });
      }
    }
  }
};

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && ((typeof call === 'undefined' ? 'undefined' : _typeof2(call)) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 */
function mergeDeep(target, source) {
  var isObject = function isObject(obj) {
    return obj && _typeof(obj) === "object";
  };

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(function (key) {
    var targetValue = target[key];
    var sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}

var BlockEmbed = __WEBPACK_IMPORTED_MODULE_0_quill___default.a.import("blots/block/embed");

var HorizontalRule =
/*#__PURE__*/
function (_BlockEmbed) {
  _inherits(HorizontalRule, _BlockEmbed);

  function HorizontalRule() {
    _classCallCheck(this, HorizontalRule);

    return _possibleConstructorReturn(this, _getPrototypeOf(HorizontalRule).apply(this, arguments));
  }

  return HorizontalRule;
}(BlockEmbed);

HorizontalRule.blotName = "hr";
HorizontalRule.tagName = "hr";
__WEBPACK_IMPORTED_MODULE_0_quill___default.a.register("formats/horizontal", HorizontalRule);

var MarkdownShortcuts =
/*#__PURE__*/
function () {
  function MarkdownShortcuts(quill, options) {
    var _this = this;

    _classCallCheck(this, MarkdownShortcuts);

    this.quill = quill;
    this.options = options;
    this.ignoreTags = ["PRE"];
    this.matches = [{
      name: "header",
      pattern: /^(#){1,6}\s/g,
      action: function action(text, selection, pattern) {
        var match = pattern.exec(text);
        if (!match) return;
        var size = match[0].length; // Need to defer this action https://github.com/quilljs/quill/issues/1134

        setTimeout(function () {
          _this.quill.formatLine(selection.index, 0, "header", size - 1);

          _this.quill.deleteText(selection.index - size, size);
        }, 0);
      }
    }, {
      name: "blockquote",
      pattern: /^(>)\s/g,
      action: function action(_text, selection) {
        // Need to defer this action https://github.com/quilljs/quill/issues/1134
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "blockquote", true);

          _this.quill.deleteText(selection.index - 2, 2);
        }, 0);
      }
    }, {
      name: "code-block",
      pattern: /^`{3}(?:\s|\n)/g,
      action: function action(_text, selection) {
        // Need to defer this action https://github.com/quilljs/quill/issues/1134
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "code-block", true);

          _this.quill.deleteText(selection.index - 4, 4);
        }, 0);
      }
    }, {
      name: "bolditalic",
      pattern: /(?:\*|_){3}(.+?)(?:\*|_){3}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            bold: true,
            italic: true
          });

          _this.quill.format("bold", false);
        }, 0);
      }
    }, {
      name: "bold",
      pattern: /(?:\*|_){2}(.+?)(?:\*|_){2}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            bold: true
          });

          _this.quill.format("bold", false);
        }, 0);
      }
    }, {
      name: "italic",
      pattern: /(?:\*|_){1}(.+?)(?:\*|_){1}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            italic: true
          });

          _this.quill.format("italic", false);
        }, 0);
      }
    }, {
      name: "strikethrough",
      pattern: /(?:~~)(.+?)(?:~~)/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            strike: true
          });

          _this.quill.format("strike", false);
        }, 0);
      }
    }, {
      name: "code",
      pattern: /(?:`)(.+?)(?:`)/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            code: true
          });

          _this.quill.format("code", false);

          _this.quill.insertText(_this.quill.getSelection(), " ");
        }, 0);
      }
    }, {
      name: "hr",
      pattern: /^([-*]\s?){3}/g,
      action: function action(text, selection) {
        var startIndex = selection.index - text.length;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, text.length);

          _this.quill.insertEmbed(startIndex + 1, "hr", true, __WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.USER);

          _this.quill.insertText(startIndex + 2, "\n", __WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.SILENT);

          _this.quill.setSelection(startIndex + 2, __WEBPACK_IMPORTED_MODULE_0_quill___default.a.sources.SILENT);
        }, 0);
      }
    }, {
      name: "asterisk-ul",
      pattern: /^(\*|\+)\s$/g,
      // eslint-disable-next-line no-unused-vars
      action: function action(_text, selection, _pattern) {
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "list", "unordered");

          _this.quill.deleteText(selection.index - 2, 2);
        }, 0);
      }
    }, {
      name: "image",
      pattern: /(?:!\[(.+?)\])(?:\((.+?)\))/g,
      action: function action(text, selection, pattern) {
        var startIndex = text.search(pattern);
        var matchedText = text.match(pattern)[0]; // const hrefText = text.match(/(?:!\[(.*?)\])/g)[0]

        var hrefLink = text.match(/(?:\((.*?)\))/g)[0];
        var start = selection.index - matchedText.length - 1;

        if (startIndex !== -1) {
          setTimeout(function () {
            _this.quill.deleteText(start, matchedText.length);

            _this.quill.insertEmbed(start, "image", hrefLink.slice(1, hrefLink.length - 1));
          }, 0);
        }
      }
    }, {
      name: "link",
      pattern: /(?:\[(.+?)\])(?:\((.+?)\))/g,
      action: function action(text, selection, pattern) {
        var startIndex = text.search(pattern);
        var matchedText = text.match(pattern)[0];
        var hrefText = text.match(/(?:\[(.*?)\])/g)[0];
        var hrefLink = text.match(/(?:\((.*?)\))/g)[0];
        var start = selection.index - matchedText.length - 1;

        if (startIndex !== -1) {
          setTimeout(function () {
            _this.quill.deleteText(start, matchedText.length);

            _this.quill.insertText(start, hrefText.slice(1, hrefText.length - 1), "link", hrefLink.slice(1, hrefLink.length - 1));
          }, 0);
        }
      }
    }]; // Handler that looks for insert deltas that match specific characters
    // eslint-disable-next-line no-unused-vars

    this.quill.on("text-change", function (delta, _oldContents, _source) {
      for (var i = 0; i < delta.ops.length; i++) {
        if (delta.ops[i].hasOwnProperty("insert")) {
          if (delta.ops[i].insert === " ") {
            _this.onSpace();
          } else if (delta.ops[i].insert === "\n") {
            _this.onEnter();
          }
        }
      }
    });
  }

  _createClass(MarkdownShortcuts, [{
    key: "isValid",
    value: function isValid(text, tagName) {
      return typeof text !== "undefined" && text && this.ignoreTags.indexOf(tagName) === -1;
    }
  }, {
    key: "onSpace",
    value: function onSpace() {
      var selection = this.quill.getSelection();
      if (!selection) return;

      var _this$quill$getLine = this.quill.getLine(selection.index),
          _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 2),
          line = _this$quill$getLine2[0],
          offset = _this$quill$getLine2[1];

      var text = line.domNode.textContent;
      var lineStart = selection.index - offset;

      if (this.isValid(text, line.domNode.tagName)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var match = _step.value;
            var matchedText = text.match(match.pattern);

            if (matchedText) {
              // We need to replace only matched text not the whole line
              console.log("matched:", match.name, text);
              match.action(text, selection, match.pattern, lineStart);
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      var selection = this.quill.getSelection();
      if (!selection) return;

      var _this$quill$getLine3 = this.quill.getLine(selection.index),
          _this$quill$getLine4 = _slicedToArray(_this$quill$getLine3, 2),
          line = _this$quill$getLine4[0],
          offset = _this$quill$getLine4[1];

      var text = line.domNode.textContent + " ";
      var lineStart = selection.index - offset;
      selection.length = selection.index++;

      if (this.isValid(text, line.domNode.tagName)) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.matches[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var match = _step2.value;
            var matchedText = text.match(match.pattern);

            if (matchedText) {
              console.log("matched", match.name, text);
              match.action(text, selection, match.pattern, lineStart);
              return;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  }]);

  return MarkdownShortcuts;
}(); // module.exports = MarkdownShortcuts;

//
var script = {
  name: "VueEditor",
  mixins: [oldApi],
  props: {
    id: {
      type: String,
      default: "quill-container"
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    editorToolbar: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editorOptions: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    useCustomImageHandler: {
      type: Boolean,
      default: false
    },
    useMarkdownShortcuts: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      quill: null
    };
  },
  watch: {
    value: function value(val) {
      if (val != this.quill.root.innerHTML && !this.quill.hasFocus()) {
        this.quill.root.innerHTML = val;
      }
    },
    disabled: function disabled(status) {
      this.quill.enable(!status);
    }
  },
  mounted: function mounted() {
    this.registerCustomModules(__WEBPACK_IMPORTED_MODULE_0_quill___default.a);
    this.registerPrototypes();
    this.initializeEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
    delete this.quill;
  },
  methods: {
    initializeEditor: function initializeEditor() {
      this.setupQuillEditor();
      this.checkForCustomImageHandler();
      this.handleInitialContent();
      this.registerEditorEventListeners();
      this.$emit("ready", this.quill);
    },
    setupQuillEditor: function setupQuillEditor() {
      var editorConfig = {
        debug: false,
        modules: this.setModules(),
        theme: "snow",
        placeholder: this.placeholder ? this.placeholder : "",
        readOnly: this.disabled ? this.disabled : false
      };
      this.prepareEditorConfig(editorConfig);
      this.quill = new __WEBPACK_IMPORTED_MODULE_0_quill___default.a(this.$refs.quillContainer, editorConfig);
    },
    setModules: function setModules() {
      var modules = {
        toolbar: this.editorToolbar.length ? this.editorToolbar : defaultToolbar
      };

      if (this.useMarkdownShortcuts) {
        __WEBPACK_IMPORTED_MODULE_0_quill___default.a.register("modules/markdownShortcuts", MarkdownShortcuts, true);
        modules["markdownShortcuts"] = {};
      }

      return modules;
    },
    prepareEditorConfig: function prepareEditorConfig(editorConfig) {
      if (Object.keys(this.editorOptions).length > 0 && this.editorOptions.constructor === Object) {
        if (this.editorOptions.modules && typeof this.editorOptions.modules.toolbar !== "undefined") {
          // We don't want to merge default toolbar with provided toolbar.
          delete editorConfig.modules.toolbar;
        }

        mergeDeep(editorConfig, this.editorOptions);
      }
    },
    registerPrototypes: function registerPrototypes() {
      __WEBPACK_IMPORTED_MODULE_0_quill___default.a.prototype.getHTML = function () {
        return this.container.querySelector(".ql-editor").innerHTML;
      };

      __WEBPACK_IMPORTED_MODULE_0_quill___default.a.prototype.getWordCount = function () {
        return this.container.querySelector(".ql-editor").innerText.length;
      };
    },
    registerEditorEventListeners: function registerEditorEventListeners() {
      this.quill.on("text-change", this.handleTextChange);
      this.quill.on("selection-change", this.handleSelectionChange);
      this.listenForEditorEvent("text-change");
      this.listenForEditorEvent("selection-change");
      this.listenForEditorEvent("editor-change");
    },
    listenForEditorEvent: function listenForEditorEvent(type) {
      var _this = this;

      this.quill.on(type, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this.$emit.apply(_this, [type].concat(args));
      });
    },
    handleInitialContent: function handleInitialContent() {
      if (this.value) this.quill.root.innerHTML = this.value; // Set initial editor content
    },
    handleSelectionChange: function handleSelectionChange(range, oldRange) {
      if (!range && oldRange) this.$emit("blur", this.quill);else if (range && !oldRange) this.$emit("focus", this.quill);
    },
    handleTextChange: function handleTextChange(delta, oldContents) {
      var editorContent = this.quill.getHTML() === "<p><br></p>" ? "" : this.quill.getHTML();
      this.$emit("input", editorContent);
      if (this.useCustomImageHandler) this.handleImageRemoved(delta, oldContents);
    },
    handleImageRemoved: function handleImageRemoved(delta, oldContents) {
      var _this2 = this;

      var currrentContents = this.quill.getContents();
      var deletedContents = currrentContents.diff(oldContents);
      var operations = deletedContents.ops;
      operations.map(function (operation) {
        if (operation.insert && operation.insert.hasOwnProperty("image")) {
          var image = operation.insert.image;

          _this2.$emit("image-removed", image);
        }
      });
    },
    checkForCustomImageHandler: function checkForCustomImageHandler() {
      this.useCustomImageHandler === true ? this.setupCustomImageHandler() : "";
    },
    setupCustomImageHandler: function setupCustomImageHandler() {
      var toolbar = this.quill.getModule("toolbar");
      toolbar.addHandler("image", this.customImageHandler);
    },
    customImageHandler: function customImageHandler() {
      this.$refs.fileInput.click();
    },
    emitImageInfo: function emitImageInfo($event) {
      var resetUploader = function resetUploader() {
        var uploader = document.getElementById("file-upload");
        uploader.value = "";
      };

      var file = $event.target.files[0];
      var Editor = this.quill;
      var range = Editor.getSelection();
      var cursorLocation = range.index;
      this.$emit("image-added", file, Editor, cursorLocation, resetUploader);
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "quillWrapper" }, [_vm._t("toolbar"), _vm._v(" "), _c('div', { ref: "quillContainer", attrs: { "id": _vm.id } }), _vm._v(" "), _vm.useCustomImageHandler ? _c('input', { ref: "fileInput", staticStyle: { "display": "none" }, attrs: { "id": "file-upload", "type": "file", "accept": "image/*" }, on: { "change": function change($event) {
        return _vm.emitImageInfo($event);
      } } }) : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-776e788e_0", { source: "/*!\n * Quill Editor v1.3.6\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li::before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:0;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li::before{content:'\\2022'}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li::before,.ql-editor ul[data-checked=true]>li::before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li::before{content:'\\2611'}.ql-editor ul[data-checked=false]>li::before{content:'\\2610'}.ql-editor li::before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl)::before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl::before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) '. '}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) '. '}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) '. '}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) '. '}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) '. '}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) '. '}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) '. '}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) '. '}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) '. '}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) '. '}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank::before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow .ql-toolbar:after,.ql-snow.ql-toolbar:after{clear:both;content:'';display:table}.ql-snow .ql-toolbar button,.ql-snow.ql-toolbar button{background:0 0;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow .ql-toolbar button svg,.ql-snow.ql-toolbar button svg{float:left;height:100%}.ql-snow .ql-toolbar button:active:hover,.ql-snow.ql-toolbar button:active:hover{outline:0}.ql-snow .ql-toolbar input.ql-image[type=file],.ql-snow.ql-toolbar input.ql-image[type=file]{display:none}.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar button.ql-active,.ql-snow .ql-toolbar button:focus,.ql-snow .ql-toolbar button:hover,.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover{color:#06c}.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow .ql-toolbar button:hover:not(.ql-active),.ql-snow.ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow{box-sizing:border-box}.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:'';display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label::before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item::before,.ql-snow .ql-picker.ql-header .ql-picker-label::before{content:'Normal'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before{content:'Heading 1'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before{content:'Heading 2'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before{content:'Heading 3'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before{content:'Heading 4'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before{content:'Heading 5'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before{content:'Heading 6'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item::before,.ql-snow .ql-picker.ql-font .ql-picker-label::before{content:'Sans Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before{content:'Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before{content:'Monospace'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item::before,.ql-snow .ql-picker.ql-size .ql-picker-label::before{content:'Normal'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before{content:'Small'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before{content:'Large'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before{content:'Huge'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:rgba(0,0,0,.2) 0 2px 8px}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label{border-color:#ccc}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip::before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action::after{border-right:1px solid #ccc;content:'Edit';margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove::before{content:'Remove';margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action::after{border-right:0;content:'Save';padding-right:0}.ql-snow .ql-tooltip[data-mode=link]::before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]::before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]::before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", map: undefined, media: undefined }), inject("data-v-776e788e_1", { source: ".ql-editor{min-height:200px;font-size:16px}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1px!important}.quillWrapper .ql-snow.ql-toolbar{padding-top:8px;padding-bottom:4px}.quillWrapper .ql-snow.ql-toolbar .ql-formats{margin-bottom:10px}.ql-snow .ql-toolbar button svg,.quillWrapper .ql-snow.ql-toolbar button svg{width:22px;height:22px}.quillWrapper .ql-editor ul[data-checked=false]>li::before,.quillWrapper .ql-editor ul[data-checked=true]>li::before{font-size:1.35em;vertical-align:baseline;bottom:-.065em;font-weight:900;color:#222}.quillWrapper .ql-snow .ql-stroke{stroke:rgba(63,63,63,.95);stroke-linecap:square;stroke-linejoin:initial;stroke-width:1.7px}.quillWrapper .ql-picker-label{font-size:15px}.quillWrapper .ql-snow .ql-active .ql-stroke{stroke-width:2.25px}.quillWrapper .ql-toolbar.ql-snow .ql-formats{vertical-align:top}.ql-picker:not(.ql-background){position:relative;top:2px}.ql-picker.ql-color-picker svg{width:22px!important;height:22px!important}.quillWrapper .imageResizeActive img{display:block;cursor:pointer}.quillWrapper .imageResizeActive~div svg{cursor:pointer}", map: undefined, media: undefined });
};
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* style inject SSR */

var VueEditor = normalizeComponent_1({ render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ }, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, browser, undefined);

var version = "2.10.3"; // Declare install function executed by Vue.use()

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component("VueEditor", VueEditor);
}
var VPlugin = {
  install: install,
  version: version,
  Quill: __WEBPACK_IMPORTED_MODULE_0_quill___default.a,
  VueEditor: VueEditor
}; // Auto-install when vue is found (eg. in browser via <script> tag)

var GlobalVue = null;

if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof global !== "undefined") {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(VPlugin);
}
/*************************************************/

/* harmony default export */ __webpack_exports__["a"] = (VPlugin);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1610);
var ieee754 = __webpack_require__(1611);
var isArray = __webpack_require__(1612);

exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined ? global.TYPED_ARRAY_SUPPORT : typedArraySupport();

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength();

function typedArraySupport() {
  try {
    var arr = new Uint8Array(1);
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function foo() {
        return 42;
      } };
    return arr.foo() === 42 && // typed array instances can be augmented
    typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
    arr.subarray(1, 1).byteLength === 0; // ie10 has broken `subarray`
  } catch (e) {
    return false;
  }
}

function kMaxLength() {
  return Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}

function createBuffer(that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length');
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length);
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length);
    }
    that.length = length;
  }

  return that;
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer(arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length);
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error('If encoding is specified then the first argument must be a string');
    }
    return allocUnsafe(this, arg);
  }
  return from(this, arg, encodingOrOffset, length);
}

Buffer.poolSize = 8192; // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype;
  return arr;
};

function from(that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number');
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length);
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset);
  }

  return fromObject(that, value);
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length);
};

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype;
  Buffer.__proto__ = Uint8Array;
  if (typeof Symbol !== 'undefined' && Symbol.species && Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    });
  }
}

function assertSize(size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number');
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative');
  }
}

function alloc(that, size, fill, encoding) {
  assertSize(size);
  if (size <= 0) {
    return createBuffer(that, size);
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string' ? createBuffer(that, size).fill(fill, encoding) : createBuffer(that, size).fill(fill);
  }
  return createBuffer(that, size);
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding);
};

function allocUnsafe(that, size) {
  assertSize(size);
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0;
    }
  }
  return that;
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size);
};

function fromString(that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8';
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding');
  }

  var length = byteLength(string, encoding) | 0;
  that = createBuffer(that, length);

  var actual = that.write(string, encoding);

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
  }

  return that;
}

function fromArrayLike(that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0;
  that = createBuffer(that, length);
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255;
  }
  return that;
}

function fromArrayBuffer(that, array, byteOffset, length) {
  array.byteLength; // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds');
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds');
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array);
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset);
  } else {
    array = new Uint8Array(array, byteOffset, length);
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array;
    that.__proto__ = Buffer.prototype;
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array);
  }
  return that;
}

function fromObject(that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0;
    that = createBuffer(that, len);

    if (that.length === 0) {
      return that;
    }

    obj.copy(that, 0, 0, len);
    return that;
  }

  if (obj) {
    if (typeof ArrayBuffer !== 'undefined' && obj.buffer instanceof ArrayBuffer || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0);
      }
      return fromArrayLike(that, obj);
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data);
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
}

function checked(length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' + 'size: 0x' + kMaxLength().toString(16) + ' bytes');
  }
  return length | 0;
}

function SlowBuffer(length) {
  if (+length != length) {
    // eslint-disable-line eqeqeq
    length = 0;
  }
  return Buffer.alloc(+length);
}

Buffer.isBuffer = function isBuffer(b) {
  return !!(b != null && b._isBuffer);
};

Buffer.compare = function compare(a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers');
  }

  if (a === b) return 0;

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

Buffer.isEncoding = function isEncoding(encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true;
    default:
      return false;
  }
};

Buffer.concat = function concat(list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers');
  }

  if (list.length === 0) {
    return Buffer.alloc(0);
  }

  var i;
  if (length === undefined) {
    length = 0;
    for (i = 0; i < list.length; ++i) {
      length += list[i].length;
    }
  }

  var buffer = Buffer.allocUnsafe(length);
  var pos = 0;
  for (i = 0; i < list.length; ++i) {
    var buf = list[i];
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    buf.copy(buffer, pos);
    pos += buf.length;
  }
  return buffer;
};

function byteLength(string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length;
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength;
  }
  if (typeof string !== 'string') {
    string = '' + string;
  }

  var len = string.length;
  if (len === 0) return 0;

  // Use a for loop to avoid recursion
  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len;
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length;
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2;
      case 'hex':
        return len >>> 1;
      case 'base64':
        return base64ToBytes(string).length;
      default:
        if (loweredCase) return utf8ToBytes(string).length; // assume utf8
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
}
Buffer.byteLength = byteLength;

function slowToString(encoding, start, end) {
  var loweredCase = false;

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0;
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return '';
  }

  if (end === undefined || end > this.length) {
    end = this.length;
  }

  if (end <= 0) {
    return '';
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0;
  start >>>= 0;

  if (end <= start) {
    return '';
  }

  if (!encoding) encoding = 'utf8';

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end);

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end);

      case 'ascii':
        return asciiSlice(this, start, end);

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end);

      case 'base64':
        return base64Slice(this, start, end);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = (encoding + '').toLowerCase();
        loweredCase = true;
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true;

function swap(b, n, m) {
  var i = b[n];
  b[n] = b[m];
  b[m] = i;
}

Buffer.prototype.swap16 = function swap16() {
  var len = this.length;
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits');
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1);
  }
  return this;
};

Buffer.prototype.swap32 = function swap32() {
  var len = this.length;
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits');
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3);
    swap(this, i + 1, i + 2);
  }
  return this;
};

Buffer.prototype.swap64 = function swap64() {
  var len = this.length;
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits');
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7);
    swap(this, i + 1, i + 6);
    swap(this, i + 2, i + 5);
    swap(this, i + 3, i + 4);
  }
  return this;
};

Buffer.prototype.toString = function toString() {
  var length = this.length | 0;
  if (length === 0) return '';
  if (arguments.length === 0) return utf8Slice(this, 0, length);
  return slowToString.apply(this, arguments);
};

Buffer.prototype.equals = function equals(b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
  if (this === b) return true;
  return Buffer.compare(this, b) === 0;
};

Buffer.prototype.inspect = function inspect() {
  var str = '';
  var max = exports.INSPECT_MAX_BYTES;
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ');
    if (this.length > max) str += ' ... ';
  }
  return '<Buffer ' + str + '>';
};

Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer');
  }

  if (start === undefined) {
    start = 0;
  }
  if (end === undefined) {
    end = target ? target.length : 0;
  }
  if (thisStart === undefined) {
    thisStart = 0;
  }
  if (thisEnd === undefined) {
    thisEnd = this.length;
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index');
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0;
  }
  if (thisStart >= thisEnd) {
    return -1;
  }
  if (start >= end) {
    return 1;
  }

  start >>>= 0;
  end >>>= 0;
  thisStart >>>= 0;
  thisEnd >>>= 0;

  if (this === target) return 0;

  var x = thisEnd - thisStart;
  var y = end - start;
  var len = Math.min(x, y);

  var thisCopy = this.slice(thisStart, thisEnd);
  var targetCopy = target.slice(start, end);

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i];
      y = targetCopy[i];
      break;
    }
  }

  if (x < y) return -1;
  if (y < x) return 1;
  return 0;
};

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1;

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset;
    byteOffset = 0;
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff;
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000;
  }
  byteOffset = +byteOffset; // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
  if (byteOffset >= buffer.length) {
    if (dir) return -1;else byteOffset = buffer.length - 1;
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0;else return -1;
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding);
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1;
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
  } else if (typeof val === 'number') {
    val = val & 0xFF; // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir);
  }

  throw new TypeError('val must be string, number or Buffer');
}

function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
  var indexSize = 1;
  var arrLength = arr.length;
  var valLength = val.length;

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase();
    if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1;
      }
      indexSize = 2;
      arrLength /= 2;
      valLength /= 2;
      byteOffset /= 2;
    }
  }

  function read(buf, i) {
    if (indexSize === 1) {
      return buf[i];
    } else {
      return buf.readUInt16BE(i * indexSize);
    }
  }

  var i;
  if (dir) {
    var foundIndex = -1;
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i;
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
      } else {
        if (foundIndex !== -1) i -= i - foundIndex;
        foundIndex = -1;
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
    for (i = byteOffset; i >= 0; i--) {
      var found = true;
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false;
          break;
        }
      }
      if (found) return i;
    }
  }

  return -1;
}

Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1;
};

Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};

Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};

function hexWrite(buf, string, offset, length) {
  offset = Number(offset) || 0;
  var remaining = buf.length - offset;
  if (!length) {
    length = remaining;
  } else {
    length = Number(length);
    if (length > remaining) {
      length = remaining;
    }
  }

  // must be an even number of digits
  var strLen = string.length;
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string');

  if (length > strLen / 2) {
    length = strLen / 2;
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16);
    if (isNaN(parsed)) return i;
    buf[offset + i] = parsed;
  }
  return i;
}

function utf8Write(buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}

function asciiWrite(buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length);
}

function latin1Write(buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length);
}

function base64Write(buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length);
}

function ucs2Write(buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}

Buffer.prototype.write = function write(string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8';
    length = this.length;
    offset = 0;
    // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset;
    length = this.length;
    offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0;
    if (isFinite(length)) {
      length = length | 0;
      if (encoding === undefined) encoding = 'utf8';
    } else {
      encoding = length;
      length = undefined;
    }
    // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
  }

  var remaining = this.length - offset;
  if (length === undefined || length > remaining) length = remaining;

  if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds');
  }

  if (!encoding) encoding = 'utf8';

  var loweredCase = false;
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length);

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length);

      case 'ascii':
        return asciiWrite(this, string, offset, length);

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length);

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length);

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length);

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
        encoding = ('' + encoding).toLowerCase();
        loweredCase = true;
    }
  }
};

Buffer.prototype.toJSON = function toJSON() {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  };
};

function base64Slice(buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf);
  } else {
    return base64.fromByteArray(buf.slice(start, end));
  }
}

function utf8Slice(buf, start, end) {
  end = Math.min(buf.length, end);
  var res = [];

  var i = start;
  while (i < end) {
    var firstByte = buf[i];
    var codePoint = null;
    var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint;

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte;
          }
          break;
        case 2:
          secondByte = buf[i + 1];
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 3:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint;
            }
          }
          break;
        case 4:
          secondByte = buf[i + 1];
          thirdByte = buf[i + 2];
          fourthByte = buf[i + 3];
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint;
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD;
      bytesPerSequence = 1;
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000;
      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
      codePoint = 0xDC00 | codePoint & 0x3FF;
    }

    res.push(codePoint);
    i += bytesPerSequence;
  }

  return decodeCodePointsArray(res);
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000;

function decodeCodePointsArray(codePoints) {
  var len = codePoints.length;
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = '';
  var i = 0;
  while (i < len) {
    res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
  }
  return res;
}

function asciiSlice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F);
  }
  return ret;
}

function latin1Slice(buf, start, end) {
  var ret = '';
  end = Math.min(buf.length, end);

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i]);
  }
  return ret;
}

function hexSlice(buf, start, end) {
  var len = buf.length;

  if (!start || start < 0) start = 0;
  if (!end || end < 0 || end > len) end = len;

  var out = '';
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i]);
  }
  return out;
}

function utf16leSlice(buf, start, end) {
  var bytes = buf.slice(start, end);
  var res = '';
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
  }
  return res;
}

Buffer.prototype.slice = function slice(start, end) {
  var len = this.length;
  start = ~~start;
  end = end === undefined ? len : ~~end;

  if (start < 0) {
    start += len;
    if (start < 0) start = 0;
  } else if (start > len) {
    start = len;
  }

  if (end < 0) {
    end += len;
    if (end < 0) end = 0;
  } else if (end > len) {
    end = len;
  }

  if (end < start) end = start;

  var newBuf;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end);
    newBuf.__proto__ = Buffer.prototype;
  } else {
    var sliceLen = end - start;
    newBuf = new Buffer(sliceLen, undefined);
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start];
    }
  }

  return newBuf;
};

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset(offset, ext, length) {
  if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}

Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }

  return val;
};

Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length);
  }

  var val = this[offset + --byteLength];
  var mul = 1;
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul;
  }

  return val;
};

Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  return this[offset];
};

Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] | this[offset + 1] << 8;
};

Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  return this[offset] << 8 | this[offset + 1];
};

Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};

Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};

Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var val = this[offset];
  var mul = 1;
  var i = 0;
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) checkOffset(offset, byteLength, this.length);

  var i = byteLength;
  var mul = 1;
  var val = this[offset + --i];
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul;
  }
  mul *= 0x80;

  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

  return val;
};

Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length);
  if (!(this[offset] & 0x80)) return this[offset];
  return (0xff - this[offset] + 1) * -1;
};

Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset] | this[offset + 1] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length);
  var val = this[offset + 1] | this[offset] << 8;
  return val & 0x8000 ? val | 0xFFFF0000 : val;
};

Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};

Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);

  return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};

Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, true, 23, 4);
};

Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length);
  return ieee754.read(this, offset, false, 23, 4);
};

Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, true, 52, 8);
};

Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length);
  return ieee754.read(this, offset, false, 52, 8);
};

function checkInt(buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
}

Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var mul = 1;
  var i = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  byteLength = byteLength | 0;
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1;
    checkInt(this, value, offset, byteLength, maxBytes, 0);
  }

  var i = byteLength - 1;
  var mul = 1;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = value / mul & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  this[offset] = value & 0xff;
  return offset + 1;
};

function objectWriteUInt16(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

function objectWriteUInt32(buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1;
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = 0;
  var mul = 1;
  var sub = 0;
  this[offset] = value & 0xFF;
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1);

    checkInt(this, value, offset, byteLength, limit - 1, -limit);
  }

  var i = byteLength - 1;
  var mul = 1;
  var sub = 0;
  this[offset + i] = value & 0xFF;
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1;
    }
    this[offset + i] = (value / mul >> 0) - sub & 0xFF;
  }

  return offset + byteLength;
};

Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80);
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
  if (value < 0) value = 0xff + value + 1;
  this[offset] = value & 0xff;
  return offset + 1;
};

Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
  } else {
    objectWriteUInt16(this, value, offset, true);
  }
  return offset + 2;
};

Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
  } else {
    objectWriteUInt16(this, value, offset, false);
  }
  return offset + 2;
};

Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
  } else {
    objectWriteUInt32(this, value, offset, true);
  }
  return offset + 4;
};

Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
  value = +value;
  offset = offset | 0;
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000);
  if (value < 0) value = 0xffffffff + value + 1;
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
  } else {
    objectWriteUInt32(this, value, offset, false);
  }
  return offset + 4;
};

function checkIEEE754(buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range');
  if (offset < 0) throw new RangeError('Index out of range');
}

function writeFloat(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4);
  return offset + 4;
}

Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert);
};

Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert);
};

function writeDouble(buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308);
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8);
  return offset + 8;
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert);
};

Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert);
};

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
  if (!start) start = 0;
  if (!end && end !== 0) end = this.length;
  if (targetStart >= target.length) targetStart = target.length;
  if (!targetStart) targetStart = 0;
  if (end > 0 && end < start) end = start;

  // Copy 0 bytes; we're done
  if (end === start) return 0;
  if (target.length === 0 || this.length === 0) return 0;

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds');
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds');
  if (end < 0) throw new RangeError('sourceEnd out of bounds');

  // Are we oob?
  if (end > this.length) end = this.length;
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start;
  }

  var len = end - start;
  var i;

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start];
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start];
    }
  } else {
    Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
  }

  return len;
};

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start;
      start = 0;
      end = this.length;
    } else if (typeof end === 'string') {
      encoding = end;
      end = this.length;
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0);
      if (code < 256) {
        val = code;
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string');
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding);
    }
  } else if (typeof val === 'number') {
    val = val & 255;
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index');
  }

  if (end <= start) {
    return this;
  }

  start = start >>> 0;
  end = end === undefined ? this.length : end >>> 0;

  if (!val) val = 0;

  var i;
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val;
    }
  } else {
    var bytes = Buffer.isBuffer(val) ? val : utf8ToBytes(new Buffer(val, encoding).toString());
    var len = bytes.length;
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len];
    }
  }

  return this;
};

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;

function base64clean(str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '');
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return '';
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '=';
  }
  return str;
}

function stringtrim(str) {
  if (str.trim) return str.trim();
  return str.replace(/^\s+|\s+$/g, '');
}

function toHex(n) {
  if (n < 16) return '0' + n.toString(16);
  return n.toString(16);
}

function utf8ToBytes(string, units) {
  units = units || Infinity;
  var codePoint;
  var length = string.length;
  var leadSurrogate = null;
  var bytes = [];

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i);

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
          continue;
        }

        // valid lead
        leadSurrogate = codePoint;

        continue;
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        leadSurrogate = codePoint;
        continue;
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
    }

    leadSurrogate = null;

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break;
      bytes.push(codePoint);
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break;
      bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break;
      bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break;
      bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
    } else {
      throw new Error('Invalid code point');
    }
  }

  return bytes;
}

function asciiToBytes(str) {
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
  }
  return byteArray;
}

function utf16leToBytes(str, units) {
  var c, hi, lo;
  var byteArray = [];
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break;

    c = str.charCodeAt(i);
    hi = c >> 8;
    lo = c % 256;
    byteArray.push(lo);
    byteArray.push(hi);
  }

  return byteArray;
}

function base64ToBytes(str) {
  return base64.toByteArray(base64clean(str));
}

function blitBuffer(src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if (i + offset >= dst.length || i >= src.length) break;
    dst[i + offset] = src[i];
  }
  return i;
}

function isnan(val) {
  return val !== val; // eslint-disable-line no-self-compare
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;

var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;

function getLens(b64) {
  var len = b64.length;

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4');
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=');
  if (validLen === -1) validLen = len;

  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;

  return [validLen, placeHoldersLen];
}

// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}

function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

  var curByte = 0;

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;

  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 0xFF;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 0xFF;
  }

  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 0xFF;
    arr[curByte++] = tmp & 0xFF;
  }

  return arr;
}

function tripletToBase64(num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}

function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
    output.push(tripletToBase64(tmp));
  }
  return output.join('');
}

function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
  var parts = [];
  var maxChunkLength = 16383; // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
  }

  return parts.join('');
}

/***/ }),
/* 1611 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer[offset + i];

  i += d;

  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;

  value = Math.abs(value);

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }

    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128;
};

/***/ }),
/* 1612 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UploadFile_vue__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DisplayImage_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PrintWindow_vue__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SearchField_Index_vue__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GridPagination_vue__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Graphs_Bar_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Graphs_Pie_vue__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Graphs_Bubble_vue__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Graphs_Line_vue__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Whiteboard_vue__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TaskCalendar_Index_vue__ = __webpack_require__(1662);
/**
 * Vuely Global Components
 */
// section tooltip















var GlobalComponents = {
   install: function install(Vue) {
      Vue.component('UploadFile', __WEBPACK_IMPORTED_MODULE_0__components_UploadFile_vue__["a" /* default */]);
      Vue.component('DisplayImage', __WEBPACK_IMPORTED_MODULE_1__components_DisplayImage_vue__["a" /* default */]);
      Vue.component('PrintWindow', __WEBPACK_IMPORTED_MODULE_2__components_PrintWindow_vue__["a" /* default */]);

      Vue.component('SearchField', __WEBPACK_IMPORTED_MODULE_3__components_SearchField_Index_vue__["a" /* default */]);
      Vue.component('GridPagination', __WEBPACK_IMPORTED_MODULE_4__components_GridPagination_vue__["a" /* default */]);

      Vue.component('BarChart', __WEBPACK_IMPORTED_MODULE_5__components_Graphs_Bar_vue__["a" /* default */]);
      Vue.component('PieChart', __WEBPACK_IMPORTED_MODULE_6__components_Graphs_Pie_vue__["a" /* default */]);
      Vue.component('LineChart', __WEBPACK_IMPORTED_MODULE_8__components_Graphs_Line_vue__["a" /* default */]);
      Vue.component('BubbleChart', __WEBPACK_IMPORTED_MODULE_7__components_Graphs_Bubble_vue__["a" /* default */]);

      Vue.component('Whiteboard', __WEBPACK_IMPORTED_MODULE_9__components_Whiteboard_vue__["a" /* default */]);
      Vue.component('TaskCalendar', __WEBPACK_IMPORTED_MODULE_10__components_TaskCalendar_Index_vue__["a" /* default */]);
   }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFile_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd27b68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFile_vue__ = __webpack_require__(1618);
function injectStyle (ssrContext) {
  __webpack_require__(1615)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd27b68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1616);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("71a1a0d8", content, true, {});

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-web-cam"] = t() : e["vue-web-cam"] = t();
}(window, function () {
  return function (e) {
    var t = {};function i(n) {
      if (t[n]) return t[n].exports;var r = t[n] = { i: n, l: !1, exports: {} };return e[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }return i.m = e, i.c = t, i.d = function (e, t, n) {
      i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
    }, i.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    }, i.t = function (e, t) {
      if (1 & t && (e = i(e)), 8 & t) return e;if (4 & t && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e && e.__esModule) return e;var n = Object.create(null);if (i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e) for (var r in e) {
        i.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }return n;
    }, i.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return i.d(t, "a", t), t;
    }, i.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, i.p = "/dist/", i(i.s = 0);
  }([function (e, t, i) {
    "use strict";
    i.r(t);var n = function (e, t, i, n, r, o, a, s) {
      var c,
          d = "function" == typeof e ? e.options : e;if (t && (d.render = t, d.staticRenderFns = i, d._compiled = !0), n && (d.functional = !0), o && (d._scopeId = "data-v-" + o), a ? (c = function c(e) {
        (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), r && r.call(this, e), e && e._registeredComponents && e._registeredComponents.add(a);
      }, d._ssrRegister = c) : r && (c = s ? function () {
        r.call(this, this.$root.$options.shadowRoot);
      } : r), c) if (d.functional) {
        d._injectStyles = c;var u = d.render;d.render = function (e, t) {
          return c.call(t), u(e, t);
        };
      } else {
        var f = d.beforeCreate;d.beforeCreate = f ? [].concat(f, c) : [c];
      }return { exports: e, options: d };
    }({ name: "VueWebCam", props: { width: { type: [Number, String], default: "100%" }, height: { type: [Number, String], default: 500 }, autoplay: { type: Boolean, default: !0 }, screenshotFormat: { type: String, default: "image/jpeg" }, selectFirstDevice: { type: Boolean, default: !1 }, deviceId: { type: String, default: null }, playsinline: { type: Boolean, default: !0 }, resolution: { type: Object, default: null, validator: function validator(e) {
            return e.height && e.width;
          } } }, data: function data() {
        return { source: null, canvas: null, camerasListEmitted: !1, cameras: [] };
      }, watch: { deviceId: function deviceId(e) {
          this.changeCamera(e);
        } }, mounted: function mounted() {
        this.setupMedia();
      }, beforeDestroy: function beforeDestroy() {
        this.stop();
      }, methods: { legacyGetUserMediaSupport: function legacyGetUserMediaSupport() {
          return function (e) {
            var t = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;return t ? new Promise(function (i, n) {
              t.call(navigator, e, i, n);
            }) : Promise.reject(new Error("getUserMedia is not implemented in this browser"));
          };
        }, setupMedia: function setupMedia() {
          void 0 === navigator.mediaDevices && (navigator.mediaDevices = {}), void 0 === navigator.mediaDevices.getUserMedia && (navigator.mediaDevices.getUserMedia = this.legacyGetUserMediaSupport()), this.testMediaAccess();
        }, loadCameras: function loadCameras() {
          var e = this;navigator.mediaDevices.enumerateDevices().then(function (t) {
            for (var i = 0; i !== t.length; ++i) {
              var n = t[i];"videoinput" === n.kind && e.cameras.push(n);
            }
          }).then(function () {
            e.camerasListEmitted || (e.selectFirstDevice && e.cameras.length > 0 && (e.deviceId = e.cameras[0].deviceId), e.$emit("cameras", e.cameras), e.camerasListEmitted = !0);
          }).catch(function (t) {
            return e.$emit("notsupported", t);
          });
        }, changeCamera: function changeCamera(e) {
          this.stop(), this.$emit("camera-change", e), this.loadCamera(e);
        }, loadSrcStream: function loadSrcStream(e) {
          var t = this;"srcObject" in this.$refs.video ? this.$refs.video.srcObject = e : this.source = window.HTMLMediaElement.srcObject(e), this.$refs.video.onloadedmetadata = function () {
            t.$emit("video-live", e);
          }, this.$emit("started", e);
        }, stopStreamedVideo: function stopStreamedVideo(e) {
          var t = this,
              i = e.srcObject;i.getTracks().forEach(function (e) {
            e.stop(), t.$emit("stopped", i), t.$refs.video.srcObject = null, t.source = null;
          });
        }, stop: function stop() {
          null !== this.$refs.video && this.$refs.video.srcObject && this.stopStreamedVideo(this.$refs.video);
        }, start: function start() {
          this.deviceId && this.loadCamera(this.deviceId);
        }, pause: function pause() {
          null !== this.$refs.video && this.$refs.video.srcObject && this.$refs.video.pause();
        }, resume: function resume() {
          null !== this.$refs.video && this.$refs.video.srcObject && this.$refs.video.play();
        }, testMediaAccess: function testMediaAccess() {
          var e = this,
              t = { video: !0 };this.resolution && (t.video = {}, t.video.height = this.resolution.height, t.video.width = this.resolution.width), navigator.mediaDevices.getUserMedia(t).then(function (t) {
            t.getTracks().forEach(function (e) {
              e.stop();
            }), e.loadCameras();
          }).catch(function (t) {
            return e.$emit("error", t);
          });
        }, loadCamera: function loadCamera(e) {
          var t = this,
              i = { video: { deviceId: { exact: e } } };this.resolution && (i.video.height = this.resolution.height, i.video.width = this.resolution.width), navigator.mediaDevices.getUserMedia(i).then(function (e) {
            return t.loadSrcStream(e);
          }).catch(function (e) {
            return t.$emit("error", e);
          });
        }, capture: function capture() {
          return this.getCanvas().toDataURL(this.screenshotFormat);
        }, getCanvas: function getCanvas() {
          var e = this.$refs.video;if (!this.ctx) {
            var t = document.createElement("canvas");t.height = e.videoHeight, t.width = e.videoWidth, this.canvas = t, this.ctx = t.getContext("2d");
          }var i = this.ctx,
              n = this.canvas;return i.drawImage(e, 0, 0, n.width, n.height), n;
        } } }, function () {
      var e = this.$createElement;return (this._self._c || e)("video", { ref: "video", attrs: { width: this.width, height: this.height, src: this.source, autoplay: this.autoplay, playsinline: this.playsinline } });
    }, [], !1, null, null, null).exports;function r(e) {
      e.component("vue-web-cam", n);
    }i.d(t, "version", function () {
      return o;
    }), i.d(t, "WebCam", function () {
      return n;
    }), "undefined" != typeof window && window.Vue && window.Vue.use(r);t.default = r;var o = "__VERSION__";
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:('display: flex; flex-direction: column; justify-content: '+(_vm.align ? _vm.align : 'center')+'; align-items: '+(_vm.align ? _vm.align : 'center')+'; '+(!_vm.notopmargin ? 'top: 0px; ' : '')+'position: relative;;')},[(_vm.isImage)?_c('el-image',{style:('width: '+_vm.image_width+'px;'),attrs:{"src":_vm.getImagePath},on:{"click":function($event){_vm.dialogVisible = true}}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v("\n              Loading"),_c('span',{staticClass:"dot"},[_vm._v("...")])])]):_c('a',{attrs:{"href":_vm.getImagePath,"target":"_blank"}},[_c('img',{style:({width: _vm.image_width+'px'}),attrs:{"src":"https://donquijote.b-cdn.net/eventsonline/pdf.png","alt":""}})]),_vm._v(" "),(!_vm.hide_upload)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"center","align-items":"center"}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"20px"},on:{"click":_vm.openFileDialog}},[_c('i',{class:_vm.$store.getters.getLoadingState ? 'el-icon-loading' : 'el-icon-upload',staticStyle:{"font-size":"24px"}})])]):_vm._e(),_vm._v(" "),(!_vm.hide_upload)?_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":_vm.file_dialog_id,"accept":_vm.allow_pdf ? '*' : 'image/*;capture=camera'},on:{"change":_vm.uploadImageToCDN}}):_vm._e(),_vm._v(" "),(_vm.allow_pdf)?_c('span',{staticStyle:{"top":"5px","position":"relative"}},[_vm._v("\n          If pdf, (max size "),_c('b',[_vm._v("50 mb")]),_vm._v(")\n      ")]):_vm._e()],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"append-to-body":"","width":"70%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.getImagePath,"alt":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayImage_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc8d78e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayImage_vue__ = __webpack_require__(1622);
function injectStyle (ssrContext) {
  __webpack_require__(1620)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DisplayImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dc8d78e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DisplayImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1621);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0d2d9192", content, true, {});

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:('display: flex; flex-direction: column; justify-content: '+(_vm.align ? _vm.align : 'center')+'; align-items: '+(_vm.align ? _vm.align : 'center')+'; '+(!_vm.notopmargin ? 'top: 0px; ' : '')+'position: relative;;')},[_c('el-image',{style:('width: '+_vm.image_width+'px; '+(_vm.image_height && _vm.image_height>0 ? 'height: '+_vm.image_height+'px;' : '')+''),attrs:{"src":_vm.getImagePath.replace('raizzoncdn.online/eta', 'cdn.easytailorapp.com')},on:{"click":function($event){_vm.dialogVisible = true}}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"placeholder"},slot:"placeholder"},[_vm._v("\n              Loading"),_c('span',{staticClass:"dot"},[_vm._v("...")])])])],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"append-to-body":"","width":"70%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"width":"100%","text-align":"center"}},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":_vm.getImagePath,"alt":""}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintWindow_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a274ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintWindow_vue__ = __webpack_require__(1626);
function injectStyle (ssrContext) {
  __webpack_require__(1624)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrintWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76a274ed_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrintWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6ed836d4", content, true, {});

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{attrs:{"fullscreen":true,"visible":_vm.dialogVisible,"width":"70%","show-close":false,"append-to-body":"","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticStyle:{"top":"-30px","position":"relative","text-align":"right","width":"100%","display":"flex","flex-direction":"column"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","width":"100%"}},[_c('h2',{staticStyle:{"top":"-25px","position":"relative"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-button',{staticStyle:{"width":"100px","height":"30px"},attrs:{"size":"small","type":"danger"},on:{"click":_vm.handleClose}},[_vm._v("\n                      Close\n                  ")])],1)]),_vm._v(" "),_c('embed',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"src":_vm.src+''+(_vm.isMobileDevice ? '&mobile_device='+_vm.getDeviceId : '')},on:{"load":_vm.onLoadFunc}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0d19ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1634);
function injectStyle (ssrContext) {
  __webpack_require__(1628)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c0d19ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1629);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("36932618", content, true, {});

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advanced_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a866c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advanced_vue__ = __webpack_require__(1633);
function injectStyle (ssrContext) {
  __webpack_require__(1631)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advanced_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a866c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advanced_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1632);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("3a393f2b", content, true, {});

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[(!_vm.hideSaveOption)?_c('div',{staticStyle:{"width":"100%","text-align":"left","margin-bottom":"20px"}},[_c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_c('el-checkbox',{model:{value:(_vm.enable_search_save),callback:function ($$v) {_vm.enable_search_save=$$v},expression:"enable_search_save"}},[_vm._v("\n                      Save This Search For Future\n                  ")]),_vm._v(" "),(_vm.enable_search_save)?_c('el-input',{staticStyle:{"width":"250px","margin-left":"20px"},attrs:{"size":"small","placeholder":"Search Title"},on:{"focus":function($event){return $event.target.select()}},model:{value:(_vm.search_name),callback:function ($$v) {_vm.search_name=$$v},expression:"search_name"}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),_c('span',{}),_vm._v(" "),(!_vm.hideSaveOption)?_c('div',{staticStyle:{"wdith":"100%","text-align":"left","dispaly":"flex","flex-direction":"row","justify-content":"flex-start","align-items":"flex-start"}},[_vm._l((_vm.$store.getters.getMasterQueryList),function(tag){return _c('el-tag',{key:tag.id,staticStyle:{"margin-right":"10px","cursor":"pointer"},attrs:{"closable":""},on:{"click":function($event){return _vm.applyPreSearch(tag)},"close":function($event){return _vm.deleteSearchTag(tag)}}},[_vm._v("\n                  "+_vm._s(tag.query_name)+"\n              ")])}),_vm._v(" "),_c('br'),_c('br')],2):_vm._e(),_vm._v(" "),_vm._l((_vm.getSearchTermArray),function(data,index){return _c('div',{key:index,staticStyle:{"margin-top":"10px","display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"space-between","width":"90%"}},[_c('el-select',{staticStyle:{"width":"30%"},attrs:{"size":"small","filterable":"","placeholder":"Column Name"},on:{"change":function($event){return _vm.changeFocus('search_term_'+index)}},model:{value:(data.column_name),callback:function ($$v) {_vm.$set(data, "column_name", $$v)},expression:"data.column_name"}},_vm._l((_vm.getSearchKeys),function(item,itemIndex){return _c('el-option',{key:itemIndex+'_0',attrs:{"label":item.label,"value":item.value}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.label)}})])}),1),_vm._v(" "),(_vm.getSearchKeys.findIndex(function (t) { return t.value == data.column_name && t.store_list; })>=0)?_c('div',{staticStyle:{"width":"60%"}},[_c('el-select',{staticStyle:{"width":"95%"},attrs:{"size":"small","placeholder":"Select..."},model:{value:(data.search_term),callback:function ($$v) {_vm.$set(data, "search_term", $$v)},expression:"data.search_term"}},_vm._l((_vm.$store.getters.getAccessibleStoreList),function(item,itemIndex){return _c('el-option',{key:itemIndex,attrs:{"label":item.store_name,"value":_vm.getSearchKeys.filter(function (t) { return t.value == data.column_name && t.store_list && t.id_store; }).length>0 ? item.id : item.store_name}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.store_name)}})])}),1)],1):(_vm.getSearchKeys.findIndex(function (t) { return t.value == data.column_name && t.date_range_field; })>=0)?_c('div',{staticStyle:{"width":"60%"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","align":"right","size":"small","unlink-panels":"","range-separator":"To","start-placeholder":"Start date","end-placeholder":"End date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(data.search_term_date_array),callback:function ($$v) {_vm.$set(data, "search_term_date_array", $$v)},expression:"data.search_term_date_array"}})],1):(_vm.getSearchKeys.findIndex(function (t) { return t.value == data.column_name && t.date_field; })>=0)?_c('div',{staticStyle:{"width":"60%"}},[_c('el-date-picker',{staticStyle:{"width":"95%"},attrs:{"size":"small","type":"date","value-format":"yyyy-MM-dd","format":"MMM dd yyyy"},model:{value:(data.search_term),callback:function ($$v) {_vm.$set(data, "search_term", $$v)},expression:"data.search_term"}})],1):(_vm.getSearchKeys.findIndex(function (t) { return t.value == data.column_name && t.drop_down_values; })>=0)?_c('div',{staticStyle:{"width":"60%"}},[_c('el-select',{staticStyle:{"width":"95%"},attrs:{"size":"small","filterable":"","placeholder":"Select..."},model:{value:(data.search_term),callback:function ($$v) {_vm.$set(data, "search_term", $$v)},expression:"data.search_term"}},_vm._l((_vm.getSearchKeys[_vm.getSearchKeys.findIndex(function (t) { return t.value == data.column_name; })].drop_down_values),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(item.label)}})])}),1)],1):_c('el-input',{staticStyle:{"width":"60%","text-align":"left","margin-left":"20px"},attrs:{"id":'search_term_'+index,"placeholder":"Search term...","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()}},model:{value:(data.search_term),callback:function ($$v) {_vm.$set(data, "search_term", $$v)},expression:"data.search_term"}})],1),_vm._v(" "),_c('div',{staticStyle:{"top":"5px","position":"relative","margin-left":"20px","width":"10%","text-align":"right"}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add"}},[_c('a',{staticStyle:{"cursor":"pointer","font-size":"16px"},attrs:{"title":"Add"},on:{"click":_vm.addNewTerm}},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Delete"}},[_c('a',{staticStyle:{"cursor":"pointer","margin-left":"10px","color":"red","font-size":"16px"},attrs:{"disabled":index === 0},on:{"click":function($event){return _vm.removeTerm(index)}}},[_c('i',{staticClass:"el-icon-delete"})])])],1)])}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","text-align":"center","margin-top":"50px"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.searchNow}},[_vm._v("Search Now")]),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":function($event){return _vm.$emit('loadAdvanceSearch', {search_term_array: []})}}},[_vm._v("Clear")])],1)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","display":"flex","flex-direction":"row"}},[_c('el-input',{staticStyle:{"width":"350px","text-align":"left"},attrs:{"placeholder":"Search...","size":"small","clearable":""},on:{"focus":function($event){return $event.target.select()},"clear":_vm.clearSearch},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.searchInIt.apply(null, arguments)}},model:{value:(_vm.search_term),callback:function ($$v) {_vm.search_term=$$v},expression:"search_term"}},[_c('el-button',{staticStyle:{"font-size":"22px","top":"-1px","position":"relative"},attrs:{"slot":"append","size":"small","icon":"el-icon-refresh"},on:{"click":_vm.clearSearch},slot:"append"}),_vm._v(" "),_c('el-button',{staticStyle:{"width":"50px"},attrs:{"slot":"append","size":"small"},on:{"click":function($event){_vm.show_qr_window=true}},slot:"append"},[_c('img',{staticStyle:{"top":"3px","position":"relative"},attrs:{"src":"https://etacdn.b-cdn.net/qr-scan.png","width":"25px"}})])],1),_vm._v(" "),(_vm.searchKeys.length>0 && !_vm.hideAvanced)?_c('span',{staticStyle:{"top":"5px","left":"10px","position":"relative"}},[_vm._v("\n          or\n      ")]):_vm._e(),_vm._v(" "),(_vm.searchKeys.length>0 && !_vm.hideAvanced)?_c('a',{staticStyle:{"top":"5px","left":"18px","position":"relative","cursor":"pointer","text-decoration":"underline"},on:{"click":function($event){_vm.show_popup = true}}},[_vm._v("Advanced Search")]):_vm._e(),_vm._v(" "),(_vm.show_popup)?_c('el-dialog',{attrs:{"title":'Advanced Search',"visible":_vm.show_popup,"append-to-body":"","width":"70%","show-close":_vm.show_popup},on:{"update:visible":function($event){_vm.show_popup=$event}}},[_c('Advanced',{attrs:{"hideSaveOption":_vm.hideSaveOption,"searchKeys":_vm.searchKeys},on:{"loadAdvanceSearch":_vm.loadAdvanceSearch}})],1):_vm._e(),_vm._v(" "),(_vm.show_qr_window)?_c('el-dialog',{attrs:{"width":"70%","visible":_vm.show_qr_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_qr_window=$event}}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"closed":function($event){_vm.show_qr_window = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridPagination_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0343bfb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridPagination_vue__ = __webpack_require__(1638);
function injectStyle (ssrContext) {
  __webpack_require__(1636)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridPagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0343bfb6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridPagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1637);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6ba207a0", content, true, {});

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.getters.getUserGroupAlerts.show_limited_data_count)?_c('div',{staticStyle:{"text-align":"right"}},[(_vm.hideTotal)?_c('el-pagination',{attrs:{"background":"","small":"","current-page":_vm.dataProps.page_number,"page-size":_vm.limit,"layout":"sizes, prev, pager, next","page-sizes":[5, 10, 20, 30, 40, 50, 100],"total":_vm.dataProps.total},on:{"size-change":_vm.handleSizeChange,"update:currentPage":function($event){return _vm.$set(_vm.dataProps, "page_number", $event)},"update:current-page":function($event){return _vm.$set(_vm.dataProps, "page_number", $event)},"current-change":function($event){return _vm.$emit('navigateButton')},"prev-click":function($event){return _vm.$emit('navigateButton')},"next-click":function($event){return _vm.$emit('navigateButton')},"update:pageSize":function($event){_vm.limit=$event},"update:page-size":function($event){_vm.limit=$event}}}):_c('el-pagination',{attrs:{"background":"","small":"","current-page":_vm.dataProps.page_number,"page-size":_vm.limit,"layout":"total, sizes, prev, pager, next","page-sizes":[5, 10, 20, 30, 40, 50, 100],"total":_vm.dataProps.total},on:{"size-change":_vm.handleSizeChange,"update:currentPage":function($event){return _vm.$set(_vm.dataProps, "page_number", $event)},"update:current-page":function($event){return _vm.$set(_vm.dataProps, "page_number", $event)},"current-change":function($event){return _vm.$emit('navigateButton')},"prev-click":function($event){return _vm.$emit('navigateButton')},"next-click":function($event){return _vm.$emit('navigateButton')},"update:pageSize":function($event){_vm.limit=$event},"update:page-size":function($event){_vm.limit=$event}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4216b62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bar_vue__ = __webpack_require__(1643);
function injectStyle (ssrContext) {
  __webpack_require__(1640)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4216b62_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1641);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("6389bd6b", content, true, {});

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 391,
	"./af.js": 391,
	"./ar": 392,
	"./ar-dz": 393,
	"./ar-dz.js": 393,
	"./ar-kw": 394,
	"./ar-kw.js": 394,
	"./ar-ly": 395,
	"./ar-ly.js": 395,
	"./ar-ma": 396,
	"./ar-ma.js": 396,
	"./ar-sa": 397,
	"./ar-sa.js": 397,
	"./ar-tn": 398,
	"./ar-tn.js": 398,
	"./ar.js": 392,
	"./az": 399,
	"./az.js": 399,
	"./be": 400,
	"./be.js": 400,
	"./bg": 401,
	"./bg.js": 401,
	"./bm": 402,
	"./bm.js": 402,
	"./bn": 403,
	"./bn-bd": 404,
	"./bn-bd.js": 404,
	"./bn.js": 403,
	"./bo": 405,
	"./bo.js": 405,
	"./br": 406,
	"./br.js": 406,
	"./bs": 407,
	"./bs.js": 407,
	"./ca": 408,
	"./ca.js": 408,
	"./cs": 409,
	"./cs.js": 409,
	"./cv": 410,
	"./cv.js": 410,
	"./cy": 411,
	"./cy.js": 411,
	"./da": 412,
	"./da.js": 412,
	"./de": 413,
	"./de-at": 414,
	"./de-at.js": 414,
	"./de-ch": 415,
	"./de-ch.js": 415,
	"./de.js": 413,
	"./dv": 416,
	"./dv.js": 416,
	"./el": 417,
	"./el.js": 417,
	"./en-au": 418,
	"./en-au.js": 418,
	"./en-ca": 419,
	"./en-ca.js": 419,
	"./en-gb": 420,
	"./en-gb.js": 420,
	"./en-ie": 421,
	"./en-ie.js": 421,
	"./en-il": 422,
	"./en-il.js": 422,
	"./en-in": 423,
	"./en-in.js": 423,
	"./en-nz": 424,
	"./en-nz.js": 424,
	"./en-sg": 425,
	"./en-sg.js": 425,
	"./eo": 426,
	"./eo.js": 426,
	"./es": 427,
	"./es-do": 428,
	"./es-do.js": 428,
	"./es-mx": 429,
	"./es-mx.js": 429,
	"./es-us": 430,
	"./es-us.js": 430,
	"./es.js": 427,
	"./et": 431,
	"./et.js": 431,
	"./eu": 432,
	"./eu.js": 432,
	"./fa": 433,
	"./fa.js": 433,
	"./fi": 434,
	"./fi.js": 434,
	"./fil": 435,
	"./fil.js": 435,
	"./fo": 436,
	"./fo.js": 436,
	"./fr": 437,
	"./fr-ca": 438,
	"./fr-ca.js": 438,
	"./fr-ch": 439,
	"./fr-ch.js": 439,
	"./fr.js": 437,
	"./fy": 440,
	"./fy.js": 440,
	"./ga": 441,
	"./ga.js": 441,
	"./gd": 442,
	"./gd.js": 442,
	"./gl": 443,
	"./gl.js": 443,
	"./gom-deva": 444,
	"./gom-deva.js": 444,
	"./gom-latn": 445,
	"./gom-latn.js": 445,
	"./gu": 446,
	"./gu.js": 446,
	"./he": 447,
	"./he.js": 447,
	"./hi": 448,
	"./hi.js": 448,
	"./hr": 449,
	"./hr.js": 449,
	"./hu": 450,
	"./hu.js": 450,
	"./hy-am": 451,
	"./hy-am.js": 451,
	"./id": 452,
	"./id.js": 452,
	"./is": 453,
	"./is.js": 453,
	"./it": 454,
	"./it-ch": 455,
	"./it-ch.js": 455,
	"./it.js": 454,
	"./ja": 456,
	"./ja.js": 456,
	"./jv": 457,
	"./jv.js": 457,
	"./ka": 458,
	"./ka.js": 458,
	"./kk": 459,
	"./kk.js": 459,
	"./km": 460,
	"./km.js": 460,
	"./kn": 461,
	"./kn.js": 461,
	"./ko": 462,
	"./ko.js": 462,
	"./ku": 463,
	"./ku.js": 463,
	"./ky": 464,
	"./ky.js": 464,
	"./lb": 465,
	"./lb.js": 465,
	"./lo": 466,
	"./lo.js": 466,
	"./lt": 467,
	"./lt.js": 467,
	"./lv": 468,
	"./lv.js": 468,
	"./me": 469,
	"./me.js": 469,
	"./mi": 470,
	"./mi.js": 470,
	"./mk": 471,
	"./mk.js": 471,
	"./ml": 472,
	"./ml.js": 472,
	"./mn": 473,
	"./mn.js": 473,
	"./mr": 474,
	"./mr.js": 474,
	"./ms": 475,
	"./ms-my": 476,
	"./ms-my.js": 476,
	"./ms.js": 475,
	"./mt": 477,
	"./mt.js": 477,
	"./my": 478,
	"./my.js": 478,
	"./nb": 479,
	"./nb.js": 479,
	"./ne": 480,
	"./ne.js": 480,
	"./nl": 481,
	"./nl-be": 482,
	"./nl-be.js": 482,
	"./nl.js": 481,
	"./nn": 483,
	"./nn.js": 483,
	"./oc-lnc": 484,
	"./oc-lnc.js": 484,
	"./pa-in": 485,
	"./pa-in.js": 485,
	"./pl": 486,
	"./pl.js": 486,
	"./pt": 487,
	"./pt-br": 488,
	"./pt-br.js": 488,
	"./pt.js": 487,
	"./ro": 489,
	"./ro.js": 489,
	"./ru": 490,
	"./ru.js": 490,
	"./sd": 491,
	"./sd.js": 491,
	"./se": 492,
	"./se.js": 492,
	"./si": 493,
	"./si.js": 493,
	"./sk": 494,
	"./sk.js": 494,
	"./sl": 495,
	"./sl.js": 495,
	"./sq": 496,
	"./sq.js": 496,
	"./sr": 497,
	"./sr-cyrl": 498,
	"./sr-cyrl.js": 498,
	"./sr.js": 497,
	"./ss": 499,
	"./ss.js": 499,
	"./sv": 500,
	"./sv.js": 500,
	"./sw": 501,
	"./sw.js": 501,
	"./ta": 502,
	"./ta.js": 502,
	"./te": 503,
	"./te.js": 503,
	"./tet": 504,
	"./tet.js": 504,
	"./tg": 505,
	"./tg.js": 505,
	"./th": 506,
	"./th.js": 506,
	"./tk": 507,
	"./tk.js": 507,
	"./tl-ph": 508,
	"./tl-ph.js": 508,
	"./tlh": 509,
	"./tlh.js": 509,
	"./tr": 510,
	"./tr.js": 510,
	"./tzl": 511,
	"./tzl.js": 511,
	"./tzm": 512,
	"./tzm-latn": 513,
	"./tzm-latn.js": 513,
	"./tzm.js": 512,
	"./ug-cn": 514,
	"./ug-cn.js": 514,
	"./uk": 515,
	"./uk.js": 515,
	"./ur": 516,
	"./ur.js": 516,
	"./uz": 517,
	"./uz-latn": 518,
	"./uz-latn.js": 518,
	"./uz.js": 517,
	"./vi": 519,
	"./vi.js": 519,
	"./x-pseudo": 520,
	"./x-pseudo.js": 520,
	"./yo": 521,
	"./yo.js": 521,
	"./zh-cn": 522,
	"./zh-cn.js": 522,
	"./zh-hk": 523,
	"./zh-hk.js": 523,
	"./zh-mo": 524,
	"./zh-mo.js": 524,
	"./zh-tw": 525,
	"./zh-tw.js": 525
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1642;

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a2dafc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pie_vue__ = __webpack_require__(1647);
function injectStyle (ssrContext) {
  __webpack_require__(1645)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50a2dafc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1646);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("1decf7b1", content, true, {});

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bubble_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede9b90e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bubble_vue__ = __webpack_require__(1651);
function injectStyle (ssrContext) {
  __webpack_require__(1649)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ede9b90e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1650);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("0648c6ac", content, true, {});

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.datasets)+"\n    "),_c('canvas',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Line_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157da47a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Line_vue__ = __webpack_require__(1655);
function injectStyle (ssrContext) {
  __webpack_require__(1653)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Line_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_157da47a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Line_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1654);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("674f593d", content, true, {});

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.id}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whiteboard_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5263c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whiteboard_vue__ = __webpack_require__(1661);
function injectStyle (ssrContext) {
  __webpack_require__(1657)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d5263c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Whiteboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d5263c3_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Whiteboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1658);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("18c92e86", content, true, {});

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, ".button-container[data-v-4d5263c3]{display:flex;flex-direction:row}.button-container>[data-v-4d5263c3]{margin-top:15px;margin-right:10px}", ""]);

// exports


/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueDrawingCanvas; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_demi__ = __webpack_require__(1660);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



/* eslint-disable no-debugger, no-console */
var VueDrawingCanvas = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["a" /* defineComponent */])({
  name: 'VueDrawingCanvas',
  props: ['strokeType', 'fillShape', 'width', 'height', 'image', 'eraser', 'lineWidth', 'lineCap', 'lineJoin', 'lock', 'backgroundColor', 'backgroundImage', 'watermark', 'saveAs', 'canvasId'],
  data: function data() {
    return {
      loadedImage: null,
      drawing: false,
      context: null,
      images: [],
      strokes: {
        type: '',
        from: {
          x: 0,
          y: 0
        },
        coordinates: [],
        color: '',
        width: '',
        fill: false,
        lineCap: '',
        lineJoin: ''
      },
      guides: [],
      trash: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.setContext();
    this.$nextTick(function () {
      _this.drawInitialImage();
      _this.drawAdditionalImages();
    });
  },


  watch: {
    backgroundImage: function backgroundImage() {
      this.loadedImage = null;
    }
  },
  methods: {
    setContext: function setContext() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var canvas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                canvas = document.querySelector('#' + _this2.canvasId);

                _this2.context = _this2.context ? _this2.context : canvas.getContext('2d');
                _context.next = 4;
                return _this2.setBackground();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    drawInitialImage: function drawInitialImage() {
      if (this.initialImage && this.initialImage.length > 0) {
        // @ts-ignore
        this.images = [].concat(this.images, this.initialImage);
        this.redraw(true);
      }
    },
    drawAdditionalImages: function drawAdditionalImages() {
      var _this3 = this;

      if (this.additionalImages && this.additionalImages.length > 0) {
        var canvas = document.querySelector('#' + this.canvasId);
        this.additionalImages.forEach(function (watermarkObject) {
          _this3.drawWatermark(canvas, _this3.context, watermarkObject);
        });
      }
    },
    clear: function clear() {
      this.context.clearRect(0, 0, Number(this.width), Number(this.height));
    },
    setBackground: function setBackground() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.clear();
                _this4.context.fillStyle = _this4.backgroundColor;
                _this4.context.fillRect(0, 0, Number(_this4.width), Number(_this4.height));
                _context3.next = 5;
                return _this4.$nextTick(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this4.drawBackgroundImage();

                        case 2:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this4);
                })));

              case 5:
                _this4.save();

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    drawBackgroundImage: function drawBackgroundImage() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.loadedImage) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return', new Promise(function (resolve) {
                  if (!_this5.backgroundImage) {
                    resolve();
                    return;
                  }

                  var image = new Image();
                  image.src = _this5.backgroundImage;

                  image.onload = function () {
                    _this5.context.drawImage(image, 0, 0, Number(_this5.width), Number(_this5.height));
                    _this5.loadedImage = image;
                    resolve();
                  };
                }));

              case 4:
                _this5.context.drawImage(_this5.loadedImage, 0, 0, Number(_this5.width), Number(_this5.height));

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getCoordinates: function getCoordinates(event) {
      var x = void 0,
          y = void 0;

      if (event.touches && event.touches.length > 0) {
        var canvas = document.querySelector('#' + this.canvasId);
        var rect = canvas.getBoundingClientRect();
        x = event.touches[0].clientX - rect.left;
        y = event.touches[0].clientY - rect.top;
      } else {
        x = event.offsetX;
        y = event.offsetY;
      }

      return {
        x: x,
        y: y
      };
    },
    startDraw: function startDraw(event) {
      if (!this.lock) {
        this.drawing = true;
        var coordinate = this.getCoordinates(event);
        this.strokes = {
          type: this.eraser ? 'eraser' : this.strokeType,
          from: coordinate,
          coordinates: [],
          color: this.eraser ? this.backgroundColor : this.color,
          width: this.lineWidth,
          fill: this.eraser || this.strokeType === 'dash' || this.strokeType === 'line' ? false : this.fillShape,
          lineCap: this.lineCap,
          lineJoin: this.lineJoin
        };
        this.guides = [];
      }
    },
    draw: function draw(event) {
      if (this.drawing) {
        if (!this.context) {
          this.setContext();
        }

        var coordinate = this.getCoordinates(event);

        if (this.eraser || this.strokeType === 'dash') {
          this.strokes.coordinates.push(coordinate);
          this.drawShape(this.context, this.strokes, false);
        } else {
          switch (this.strokeType) {
            case 'line':
              this.guides = [{
                x: coordinate.x,
                y: coordinate.y
              }];
              break;

            case 'square':
              this.guides = [{
                x: coordinate.x,
                y: this.strokes.from.y
              }, {
                x: coordinate.x,
                y: coordinate.y
              }, {
                x: this.strokes.from.x,
                y: coordinate.y
              }, {
                x: this.strokes.from.x,
                y: this.strokes.from.y
              }];
              break;

            case 'triangle':
              var center = Math.floor((coordinate.x - this.strokes.from.x) / 2) < 0 ? Math.floor((coordinate.x - this.strokes.from.x) / 2) * -1 : Math.floor((coordinate.x - this.strokes.from.x) / 2);
              var width = this.strokes.from.x < coordinate.x ? this.strokes.from.x + center : this.strokes.from.x - center;
              this.guides = [{
                x: coordinate.x,
                y: this.strokes.from.y
              }, {
                x: width,
                y: coordinate.y
              }, {
                x: this.strokes.from.x,
                y: this.strokes.from.y
              }];
              break;

            case 'half_triangle':
              this.guides = [{
                x: coordinate.x,
                y: this.strokes.from.y
              }, {
                x: this.strokes.from.x,
                y: coordinate.y
              }, {
                x: this.strokes.from.x,
                y: this.strokes.from.y
              }];
              break;

            case 'circle':
              var radiusX = this.strokes.from.x - coordinate.x < 0 ? (this.strokes.from.x - coordinate.x) * -1 : this.strokes.from.x - coordinate.x;
              this.guides = [{
                x: this.strokes.from.x > coordinate.x ? this.strokes.from.x - radiusX : this.strokes.from.x + radiusX,
                y: this.strokes.from.y
              }, {
                x: radiusX,
                y: radiusX
              }];
              break;
          }

          this.drawGuide(true);
        }
      }
    },
    drawGuide: function drawGuide(closingPath) {
      var _this6 = this;

      this.redraw(true);
      this.$nextTick(function () {
        _this6.context.strokeStyle = _this6.color;
        _this6.context.lineWidth = 1;
        _this6.context.lineJoin = _this6.lineJoin;
        _this6.context.lineCap = _this6.lineCap;
        _this6.context.beginPath();
        _this6.context.setLineDash([15, 15]);

        if (_this6.strokes.type === 'circle') {
          _this6.context.ellipse(_this6.guides[0].x, _this6.guides[0].y, _this6.guides[1].x, _this6.guides[1].y, 0, 0, Math.PI * 2);
        } else {
          _this6.context.moveTo(_this6.strokes.from.x, _this6.strokes.from.y);
          _this6.guides.forEach(function (coordinate) {
            _this6.context.lineTo(coordinate.x, coordinate.y);
          });

          if (closingPath) {
            _this6.context.closePath();
          }
        }

        _this6.context.stroke();
      });
    },
    drawShape: function drawShape(context, strokes, closingPath) {
      context.strokeStyle = strokes.color;
      context.fillStyle = strokes.color;
      context.lineWidth = strokes.width;
      context.lineJoin = strokes.lineJoin === undefined ? this.lineJoin : strokes.lineJoin;
      context.lineCap = strokes.lineCap === undefined ? this.lineCap : strokes.lineCap;
      context.beginPath();
      context.setLineDash([]);

      if (strokes.type === 'circle') {
        context.ellipse(strokes.coordinates[0].x, strokes.coordinates[0].y, strokes.coordinates[1].x, strokes.coordinates[1].y, 0, 0, Math.PI * 2);
      } else {
        context.moveTo(strokes.from.x, strokes.from.y);
        strokes.coordinates.forEach(function (stroke) {
          context.lineTo(stroke.x, stroke.y);
        });

        if (closingPath) {
          context.closePath();
        }
      }

      if (strokes.fill) {
        context.fill();
      } else {
        context.stroke();
      }
    },
    stopDraw: function stopDraw() {
      if (this.drawing) {
        this.strokes.coordinates = this.guides.length > 0 ? this.guides : this.strokes.coordinates;
        this.images.push(this.strokes);
        this.redraw(true);
        this.drawing = false;
        this.trash = [];
      }
    },
    reset: function reset() {
      if (!this.lock) {
        this.images = [];
        this.strokes = {
          type: '',
          coordinates: [],
          color: '',
          width: '',
          fill: false,
          lineCap: '',
          lineJoin: ''
        };
        this.guides = [];
        this.trash = [];
        this.redraw(true);
      }
    },
    undo: function undo() {
      if (!this.lock) {
        var strokes = this.images.pop();

        if (strokes) {
          this.trash.push(strokes);
          this.redraw(true);
        }
      }
    },
    redo: function redo() {
      if (!this.lock) {
        var strokes = this.trash.pop();

        if (strokes) {
          this.images.push(strokes);
          this.redraw(true);
        }
      }
    },
    redraw: function redraw(output) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                output = typeof output !== 'undefined' ? output : true;
                _context5.next = 3;
                return _this7.setBackground().then(function () {
                  _this7.drawAdditionalImages();
                }).then(function () {
                  var baseCanvas = document.createElement('canvas');
                  var baseCanvasContext = baseCanvas.getContext('2d');
                  baseCanvas.width = Number(_this7.width);
                  baseCanvas.height = Number(_this7.height);

                  if (baseCanvasContext) {
                    _this7.images.forEach(function (stroke) {
                      if (baseCanvasContext) {
                        baseCanvasContext.globalCompositeOperation = stroke.type === 'eraser' ? 'destination-out' : 'source-over';

                        if (stroke.type !== 'circle' || stroke.type === 'circle' && stroke.coordinates.length > 0) {
                          _this7.drawShape(baseCanvasContext, stroke, stroke.type === 'eraser' || stroke.type === 'dash' || stroke.type === 'line' ? false : true);
                        }
                      }
                    });
                    _this7.context.drawImage(baseCanvas, 0, 0, Number(_this7.width), Number(_this7.height));
                  }
                }).then(function () {
                  if (output) {
                    _this7.save();
                  }
                });

              case 3:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    wrapText: function wrapText(context, text, x, y, maxWidth, lineHeight) {
      var newLineRegex = /(\r\n|\n\r|\n|\r)+/g;
      var whitespaceRegex = /\s+/g;
      var lines = text.split(newLineRegex).filter(function (word) {
        return word.length > 0;
      });

      for (var lineNumber = 0; lineNumber < lines.length; lineNumber++) {
        var words = lines[lineNumber].split(whitespaceRegex).filter(function (word) {
          return word.length > 0;
        });
        var line = '';

        for (var n = 0; n < words.length; n++) {
          var testLine = line + words[n] + ' ';
          var metrics = context.measureText(testLine);
          var testWidth = metrics.width;

          if (testWidth > maxWidth && n > 0) {
            if (this.watermark && this.watermark.fontStyle && this.watermark.fontStyle.drawType && this.watermark.fontStyle.drawType === 'stroke') {
              context.strokeText(line, x, y);
            } else {
              context.fillText(line, x, y);
            }

            line = words[n] + ' ';
            y += lineHeight;
          } else {
            line = testLine;
          }
        }

        if (this.watermark && this.watermark.fontStyle && this.watermark.fontStyle.drawType && this.watermark.fontStyle.drawType === 'stroke') {
          context.strokeText(line, x, y);
        } else {
          context.fillText(line, x, y);
        }

        y += words.length > 0 ? lineHeight : 0;
      }
    },
    save: function save() {
      var canvas = document.querySelector('#' + this.canvasId);

      if (this.watermark) {
        var temp = document.createElement('canvas');
        var ctx = temp.getContext('2d');

        if (ctx) {
          temp.width = Number(this.width);
          temp.height = Number(this.height);
          ctx.drawImage(canvas, 0, 0, Number(this.width), Number(this.height));
          this.drawWatermark(temp, ctx, this.watermark);
        }
      } else {
        var _temp = document.createElement('canvas');
        var tempCtx = _temp.getContext('2d');
        var tempWidth = this.outputWidth === undefined ? this.width : this.outputWidth;
        var tempHeight = this.outputHeight === undefined ? this.height : this.outputHeight;
        _temp.width = Number(tempWidth);
        _temp.height = Number(tempHeight);

        if (tempCtx) {
          tempCtx.drawImage(canvas, 0, 0, Number(tempWidth), Number(tempHeight));
          this.$emit('update:image', _temp.toDataURL('image/' + this.saveAs, 1));
          return _temp.toDataURL('image/' + this.saveAs, 1);
        }
      }
    },
    drawWatermark: function drawWatermark(canvas, ctx, watermark) {
      var _this8 = this;

      if (watermark.type === 'Image') {
        var imageWidth = watermark.imageStyle ? watermark.imageStyle.width ? watermark.imageStyle.width : Number(this.width) : Number(this.width);
        var imageHeight = watermark.imageStyle ? watermark.imageStyle.height ? watermark.imageStyle.height : Number(this.height) : Number(this.height);
        var image = new Image();
        image.src = watermark.source;

        image.onload = function () {
          if (watermark && ctx) {
            ctx.drawImage(image, watermark.x, watermark.y, Number(imageWidth), Number(imageHeight));
          }

          var temp = document.createElement('canvas');
          var tempCtx = temp.getContext('2d');
          var tempWidth = _this8.outputWidth === undefined ? _this8.width : _this8.outputWidth;
          var tempHeight = _this8.outputHeight === undefined ? _this8.height : _this8.outputHeight;
          temp.width = Number(tempWidth);
          temp.height = Number(tempHeight);

          if (tempCtx) {
            tempCtx.drawImage(canvas, 0, 0, Number(tempWidth), Number(tempHeight));
            _this8.$emit('update:image', temp.toDataURL('image/' + _this8.saveAs, 1));
            return temp.toDataURL('image/' + _this8.saveAs, 1);
          }
        };
      } else if (watermark.type === 'Text') {
        var font = watermark.fontStyle ? watermark.fontStyle.font ? watermark.fontStyle.font : '20px serif' : '20px serif';
        var align = watermark.fontStyle ? watermark.fontStyle.textAlign ? watermark.fontStyle.textAlign : 'start' : 'start';
        var baseline = watermark.fontStyle ? watermark.fontStyle.textBaseline ? watermark.fontStyle.textBaseline : 'alphabetic' : 'alphabetic';
        var color = watermark.fontStyle ? watermark.fontStyle.color ? watermark.fontStyle.color : '#000000' : '#000000';
        ctx.font = font;
        ctx.textAlign = align;
        ctx.textBaseline = baseline;

        if (watermark.fontStyle && watermark.fontStyle.rotate) {
          var centerX = void 0,
              centerY = void 0;

          if (watermark.fontStyle && watermark.fontStyle.width) {
            centerX = watermark.x + Math.floor(watermark.fontStyle.width / 2);
          } else {
            centerX = watermark.x;
          }

          if (watermark.fontStyle && watermark.fontStyle.lineHeight) {
            centerY = watermark.y + Math.floor(watermark.fontStyle.lineHeight / 2);
          } else {
            centerY = watermark.y;
          }

          ctx.translate(centerX, centerY);
          ctx.rotate(watermark.fontStyle.rotate * Math.PI / 180);
          ctx.translate(centerX * -1, centerY * -1);
        }

        if (watermark.fontStyle && watermark.fontStyle.drawType && watermark.fontStyle.drawType === 'stroke') {
          ctx.strokeStyle = watermark.fontStyle.color;

          if (watermark.fontStyle && watermark.fontStyle.width) {
            this.wrapText(ctx, watermark.source, watermark.x, watermark.y, watermark.fontStyle.width, watermark.fontStyle.lineHeight);
          } else {
            ctx.strokeText(watermark.source, watermark.x, watermark.y);
          }
        } else {
          ctx.fillStyle = color;

          if (watermark.fontStyle && watermark.fontStyle.width) {
            this.wrapText(ctx, watermark.source, watermark.x, watermark.y, watermark.fontStyle.width, watermark.fontStyle.lineHeight);
          } else {
            ctx.fillText(watermark.source, watermark.x, watermark.y);
          }
        }

        var temp = document.createElement('canvas');
        var tempCtx = temp.getContext('2d');
        var tempWidth = this.outputWidth === undefined ? this.width : this.outputWidth;
        var tempHeight = this.outputHeight === undefined ? this.height : this.outputHeight;
        temp.width = Number(tempWidth);
        temp.height = Number(tempHeight);

        if (tempCtx) {
          tempCtx.drawImage(canvas, 0, 0, Number(tempWidth), Number(tempHeight));
          this.$emit('update:image', temp.toDataURL('image/' + this.saveAs, 1));
          return temp.toDataURL('image/' + this.saveAs, 1);
        }
      }
    },
    isEmpty: function isEmpty() {
      return this.images.length > 0 ? false : true;
    },
    getAllStrokes: function getAllStrokes() {
      return this.images;
    }
  },

  render: function render() {
    var _this9 = this;

    if (__WEBPACK_IMPORTED_MODULE_0_vue_demi__["c" /* isVue2 */]) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["b" /* h */])('canvas', {
        attrs: {
          id: this.canvasId,
          width: Number(this.width),
          height: Number(this.height)
        },
        style: {
          'touchAction': 'none'
          // @ts-ignore
        },
        class: this.classes,
        on: {
          mousedown: function mousedown(event) {
            return _this9.startDraw(event);
          },
          mousemove: function mousemove(event) {
            return _this9.draw(event);
          },
          mouseup: function mouseup() {
            return _this9.stopDraw();
          },
          mouseleave: function mouseleave() {
            return _this9.stopDraw();
          },
          touchstart: function touchstart(event) {
            return _this9.startDraw(event);
          },
          touchmove: function touchmove(event) {
            return _this9.draw(event);
          },
          touchend: function touchend() {
            return _this9.stopDraw();
          },
          touchleave: function touchleave() {
            return _this9.stopDraw();
          },
          touchcancel: function touchcancel() {
            return _this9.stopDraw();
          },
          pointerdown: function pointerdown(event) {
            return _this9.startDraw(event);
          },
          pointermove: function pointermove(event) {
            return _this9.draw(event);
          },
          pointerup: function pointerup() {
            return _this9.stopDraw();
          },
          pointerleave: function pointerleave() {
            return _this9.stopDraw();
          },
          pointercancel: function pointercancel() {
            return _this9.stopDraw();
          }
        }
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_vue_demi__["b" /* h */])('canvas', {
      id: this.canvasId,
      height: Number(this.height),
      width: Number(this.width),
      style: {
        'touchAction': 'none'
        // @ts-ignore
      },
      class: this.classes,
      onMousedown: function onMousedown($event) {
        return _this9.startDraw($event);
      },
      onMousemove: function onMousemove($event) {
        return _this9.draw($event);
      },
      onMouseup: function onMouseup() {
        return _this9.stopDraw();
      },
      onMouseleave: function onMouseleave() {
        return _this9.stopDraw();
      },
      onTouchstart: function onTouchstart($event) {
        return _this9.startDraw($event);
      },
      onTouchmove: function onTouchmove($event) {
        return _this9.draw($event);
      },
      onTouchend: function onTouchend() {
        return _this9.stopDraw();
      },
      onTouchleave: function onTouchleave() {
        return _this9.stopDraw();
      },
      onTouchcancel: function onTouchcancel() {
        return _this9.stopDraw();
      },
      onPointerdown: function onPointerdown($event) {
        return _this9.startDraw($event);
      },
      onPointermove: function onPointermove($event) {
        return _this9.draw($event);
      },
      onPointerup: function onPointerup() {
        return _this9.stopDraw();
      },
      onPointerleave: function onPointerleave() {
        return _this9.stopDraw();
      },
      onPointercancel: function onPointercancel() {
        return _this9.stopDraw();
      }
    });
  }
});



/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Vue2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isVue2; });
/* unused harmony export isVue3 */
/* unused harmony export version */
/* unused harmony export install */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__ = __webpack_require__(168);
/* unused harmony reexport EffectScope */
/* unused harmony reexport computed */
/* unused harmony reexport createApp */
/* unused harmony reexport createRef */
/* unused harmony reexport customRef */
/* unused harmony reexport defineAsyncComponent */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["b"]; });
/* unused harmony reexport del */
/* unused harmony reexport effectScope */
/* unused harmony reexport getCurrentInstance */
/* unused harmony reexport getCurrentScope */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["c"]; });
/* unused harmony reexport inject */
/* unused harmony reexport isRaw */
/* unused harmony reexport isReactive */
/* unused harmony reexport isReadonly */
/* unused harmony reexport isRef */
/* unused harmony reexport markRaw */
/* unused harmony reexport nextTick */
/* unused harmony reexport onActivated */
/* unused harmony reexport onBeforeMount */
/* unused harmony reexport onBeforeUnmount */
/* unused harmony reexport onBeforeUpdate */
/* unused harmony reexport onDeactivated */
/* unused harmony reexport onErrorCaptured */
/* unused harmony reexport onMounted */
/* unused harmony reexport onScopeDispose */
/* unused harmony reexport onServerPrefetch */
/* unused harmony reexport onUnmounted */
/* unused harmony reexport onUpdated */
/* unused harmony reexport provide */
/* unused harmony reexport proxyRefs */
/* unused harmony reexport reactive */
/* unused harmony reexport readonly */
/* unused harmony reexport ref */
/* unused harmony reexport set */
/* unused harmony reexport shallowReactive */
/* unused harmony reexport shallowReadonly */
/* unused harmony reexport shallowRef */
/* unused harmony reexport toRaw */
/* unused harmony reexport toRef */
/* unused harmony reexport toRefs */
/* unused harmony reexport triggerRef */
/* unused harmony reexport unref */
/* unused harmony reexport useAttrs */
/* unused harmony reexport useCSSModule */
/* unused harmony reexport useCssModule */
/* unused harmony reexport useSlots */
/* unused harmony reexport warn */
/* unused harmony reexport watch */
/* unused harmony reexport watchEffect */
/* unused harmony reexport watchPostEffect */
/* unused harmony reexport watchSyncEffect */
/* unused harmony reexport Vue */



function install(_vue) {
  _vue = _vue || __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
  if (_vue && !_vue['__composition_api_installed__'])
    _vue.use(__WEBPACK_IMPORTED_MODULE_1__vue_composition_api_dist_vue_composition_api_mjs__["a" /* default */])
}

install(__WEBPACK_IMPORTED_MODULE_0_vue__["default"])

var isVue2 = true
var isVue3 = false
var Vue2 = __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
var version = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].version

/**VCA-EXPORTS**/

/**VCA-EXPORTS**/




/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":function($event){return _vm.$refs.VueCanvasDrawing.undo()}}},[_vm._v("\n      Undo\n    ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{style:({border: '1px solid #383838', width: (_vm.getScreenWidth-100), height: (_vm.getScreenHeight-100)}),attrs:{"id":'wo_canvas_container_'+_vm.sale_item_index+'_'+_vm.workOrderData.sub_sl_no},on:{"click":_vm.convertImage}},[_c('vue-drawing-canvas',{ref:"VueCanvasDrawing",attrs:{"canvasId":'wo_canvas_'+_vm.sale_item_index+'_'+_vm.workOrderData.sub_sl_no,"v-model":_vm.image,"stroke-type":'dash',"fill-shape":false,"eraser":_vm.getEraser,"lineWidth":_vm.line,"lineCap":'round',"lineJoin":'miter',"color":_vm.getColor,"width":(_vm.getScreenWidth-200),"height":(_vm.getScreenHeight),"background-color":_vm.backgroundColor,"background-image":_vm.backgroundImage,"saveAs":"jpeg","styles":{
          'border': 'solid 1px #000'
        },"lock":false}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8abe7624_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(1669);
function injectStyle (ssrContext) {
  __webpack_require__(1663)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8abe7624_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1664);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("53751158", content, true, {});

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1783c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1666)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Appointments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1783c8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Appointments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1667);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(6)("7ca48344", content, true, {});

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"left"}},[_c('div',{staticStyle:{"width":"100%","text-align":"right"}},[_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.addTask}},[_vm._v("\n              Add New Task\n          ")])],1),_vm._v(" "),_c('ul',_vm._l((_vm.$store.getters.getTaskCalendarEventList),function(data,index){return _c('li',{key:index},[(data.sales)?_c('a',{staticStyle:{"text-decoration":"none","color":"#000000"},attrs:{"href":"javascript: void(0)"},on:{"click":function($event){return _vm.openQuickView(data.id)}}},[_c('span',{staticStyle:{"text-decoration":"underline"}},[_vm._v("\n                          "+_vm._s(data.sale_number)+", "+_vm._s(data.customer_name)),_c('br')]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(data.trial_required ? 'Trial Scheduled' : 'Delivery Scheduled')+"\n                      ")])]):(data.task)?_c('a',{staticStyle:{"text-decoration":"none","color":"#000000"},attrs:{"href":"javascript: void(0)"},on:{"click":function($event){return _vm.$store.dispatch('fetchTaskData', {id: data.id})}}},[_c('span',{staticStyle:{"text-decoration":"underline"}},[_vm._v("\n                          "+_vm._s(data.title_prefix)+_vm._s(data.title)),_c('br')]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v("\n                          "+_vm._s(data.task_type === 1 ? 'Appointment At '+data.task_time : '')+"\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"height":"10px"},domProps:{"innerHTML":_vm._s('&nbsp;')}})])}),0),_vm._v(" "),(_vm.$store.state.tasks.show_task_form)?_c('el-dialog',{attrs:{"title":'New Task',"width":"450px","visible":_vm.$store.state.tasks.show_task_form,"append-to-body":""},on:{"update:visible":function($event){return _vm.$set(_vm.$store.state.tasks, "show_task_form", $event)}}},[_c('TaskForm',{on:{"closed":function($event){return _vm.$emit('loadCalendar')}}})],1):_vm._e(),_vm._v(" "),(_vm.showQuickView)?_c('el-dialog',{attrs:{"width":'70%',"visible":_vm.showQuickView,"append-to-body":""},on:{"update:visible":function($event){_vm.showQuickView=$event}}},[_c('QuickDetail',{attrs:{"calendar_source":true,"allow_delivery":false,"selected_date":_vm.selected_date,"store_id":_vm.store_id,"sale_id":_vm.selected_sale_id},on:{"closed":function($event){_vm.showQuickView = false}}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"text-align":"left","width":"100%","display":"flex","flex-direction":"row"}},[_c('el-select',{staticStyle:{"width":"150px","text-align":"left"},attrs:{"size":"small","filterable":"","placeholder":"Select store..."},on:{"change":_vm.loadData},model:{value:(_vm.store_id),callback:function ($$v) {_vm.store_id=$$v},expression:"store_id"}},[_c('el-option',{attrs:{"label":'',"value":-1}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s('')}})]),_vm._v(" "),_vm._l((_vm.$store.getters.getAccessibleStoreList),function(data,index){return _c('el-option',{key:index,attrs:{"label":data.store_name,"value":data.id}},[_c('span',{staticStyle:{"float":"left"},domProps:{"innerHTML":_vm._s(data.store_name)}})])})],2),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"size":"small","type":"primary"},on:{"click":_vm.loadData}},[_vm._v("\n      Search\n    ")])],1),_vm._v(" "),(!_vm.production_calendar)?_c('div',{staticStyle:{"text-align":"left","width":"100%","margin-top":"20px","margin-bottom":"0px"}},[_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"success","effect":"dark"}},[_vm._v("\n        DELIVERIES\n    ")]),_vm._v(" "),_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"warning","effect":"dark"}},[_vm._v("\n        TRIALS\n    ")]),_vm._v(" "),_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"danger","effect":"dark"}},[_vm._v("\n        TASKS\n    ")])],1):_c('div',{staticStyle:{"text-align":"left","width":"100%","margin-top":"20px","margin-bottom":"0px"}},_vm._l((_vm.getItemCategory),function(data,index){return _c('el-tag',{key:index,style:({margin: '2px', color: 'white', backgroundColor: data.color}),attrs:{"size":"small","effect":"plain"}},[_vm._v("\n        "+_vm._s(data.category_name)+"\n    ")])}),1),_vm._v(" "),_c('el-calendar',{scopedSlots:_vm._u([{key:"dateCell",fn:function(ref){
var date = ref.date;
var data = ref.data;
return [_c('div',{class:data.isSelected ? 'is-selected' : '',staticStyle:{"display":"flex","flex-direction":"column"}},[_c('span',[_vm._v(_vm._s(data.day.split('-').slice(2)[0]))]),_vm._v(" "),(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; }).length>0 && !_vm.production_calendar)?_c('div',{staticStyle:{"flex-direction":"row","display":"flex","justify-content":"center","align-items":"center"}},[(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_deliveries>0)?_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"success","effect":"dark"}},[_vm._v("\n              "+_vm._s(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_deliveries>0 ? _vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_deliveries : '')+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_trials>0)?_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"warning","effect":"dark"}},[_vm._v("\n              "+_vm._s(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_trials>0 ? _vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_trials : '')+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_tasks>0)?_c('el-tag',{staticStyle:{"margin":"2px"},attrs:{"size":"small","type":"danger","effect":"dark"}},[_vm._v("\n              "+_vm._s(_vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_tasks>0 ? _vm.$store.getters.getTaskCalendar.filter(function (t) { return t.date == data.day; })[0].total_tasks : '')+"\n          ")]):_vm._e()],1):(_vm.getPlannerDataList.length>0 && _vm.getFinalFutureList.filter(function (t) { return t.date == data.day; }).length>0 && _vm.production_calendar)?_c('div',{staticStyle:{"display":"flex","flex-direction":"row","flex-wrap":"wrap","justify-content":"center","align-items":"center"}},_vm._l((_vm.getItemCategory),function(data1,index){return _c('div',{key:index},[(_vm.getFinalFutureList.filter(function (t) { return t.date == data.day; })[0].category_list.filter(function (t) { return t.id == data1.id; }).length > 0)?_c('el-tag',{style:({margin: '2px', color: 'white', backgroundColor: data1.color}),attrs:{"size":"small","effect":"plain"}},[_vm._v("\n                    "+_vm._s(_vm.getFinalFutureList.filter(function (t) { return t.date == data.day; })[0].category_list.filter(function (t) { return t.id == data1.id; })[0].qty)+"\n                ")]):_vm._e()],1)}),0):_vm._e()])]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),(_vm.show_appointment)?_c('el-dialog',{attrs:{"title":_vm.getSelectedDate[0],"width":"450px","visible":_vm.show_appointment,"append-to-body":""},on:{"update:visible":function($event){_vm.show_appointment=$event}}},[_c('Appointments',{attrs:{"store_id":_vm.store_id,"selected_date":_vm.getSelectedDate[2]},on:{"closed":_vm.loadCalendar,"loadCalendar":_vm.loadCalendar}})],1):_vm._e(),_vm._v(" "),(_vm.show_planner_window)?_c('el-dialog',{attrs:{"title":_vm.getSelectedDate[0],"fullscreen":"","visible":_vm.show_planner_window,"append-to-body":""},on:{"update:visible":function($event){_vm.show_planner_window=$event}}},[_c('CustomerList',{attrs:{"calendar_view":true,"searchType":1,"data_list":_vm.planner_data_list}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * vue-friendly-iframe v0.20.0 (https://github.com/officert/vue-friendly-iframe)
 * (c) 2021 Tim Officer
 * Released under the MIT License.
 */
(function webpackUniversalModuleDefinition(root, factory) {
  if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else {
    var a = factory();
    for (var i in a) {
      ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' ? exports : root)[i] = a[i];
    }
  }
})(typeof self !== 'undefined' ? self : this, function () {
  return (/******/function (modules) {
      // webpackBootstrap
      /******/ // The module cache
      /******/var installedModules = {};
      /******/
      /******/ // The require function
      /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
          /******/return installedModules[moduleId].exports;
          /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
          /******/i: moduleId,
          /******/l: false,
          /******/exports: {}
          /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
      }
      /******/
      /******/
      /******/ // expose the modules object (__webpack_modules__)
      /******/__webpack_require__.m = modules;
      /******/
      /******/ // expose the module cache
      /******/__webpack_require__.c = installedModules;
      /******/
      /******/ // define getter function for harmony exports
      /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
          /******/Object.defineProperty(exports, name, {
            /******/configurable: false,
            /******/enumerable: true,
            /******/get: getter
            /******/ });
          /******/
        }
        /******/
      };
      /******/
      /******/ // getDefaultExport function for compatibility with non-harmony modules
      /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
          return module['default'];
        } :
        /******/function getModuleExports() {
          return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
      };
      /******/
      /******/ // Object.prototype.hasOwnProperty.call
      /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/
      /******/ // __webpack_public_path__
      /******/__webpack_require__.p = "";
      /******/
      /******/ // Load entry module and return exports
      /******/return __webpack_require__(__webpack_require__.s = 0);
      /******/
    }(
    /************************************************************************/
    /******/[
    /* 0 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _FriendlyIframe = __webpack_require__(1);

      var _FriendlyIframe2 = _interopRequireDefault(_FriendlyIframe);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      if (typeof window !== 'undefined' && window.Vue) {
        window.Vue.use({
          install: function install(NewVue) {
            NewVue.component('vue-friendly-iframe', _FriendlyIframe2.default);
          }
        });
      }

      exports.default = {
        install: function install(NewVue) {
          NewVue.component('vue-friendly-iframe', _FriendlyIframe2.default);
        },
        VueFriendlyIframe: _FriendlyIframe2.default
      };
      module.exports = exports['default'];

      /***/
    },
    /* 1 */
    /***/function (module, exports, __webpack_require__) {

      var Component = __webpack_require__(2)(
      /* script */
      __webpack_require__(3),
      /* template */
      __webpack_require__(9),
      /* scopeId */
      null,
      /* cssModules */
      null);

      module.exports = Component.exports;

      /***/
    },
    /* 2 */
    /***/function (module, exports) {

      // this module is a runtime utility for cleaner component module output and will
      // be included in the final webpack user bundle

      module.exports = function normalizeComponent(rawScriptExports, compiledTemplate, scopeId, cssModules) {
        var esModule;
        var scriptExports = rawScriptExports = rawScriptExports || {};

        // ES6 modules interop
        var type = _typeof(rawScriptExports.default);
        if (type === 'object' || type === 'function') {
          esModule = rawScriptExports;
          scriptExports = rawScriptExports.default;
        }

        // Vue.extend constructor export interop
        var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

        // render functions
        if (compiledTemplate) {
          options.render = compiledTemplate.render;
          options.staticRenderFns = compiledTemplate.staticRenderFns;
        }

        // scopedId
        if (scopeId) {
          options._scopeId = scopeId;
        }

        // inject cssModules
        if (cssModules) {
          var computed = Object.create(options.computed || null);
          Object.keys(cssModules).forEach(function (key) {
            var module = cssModules[key];
            computed[key] = function () {
              return module;
            };
          });
          options.computed = computed;
        }

        return {
          esModule: esModule,
          exports: scriptExports,
          options: options
        };
      };

      /***/
    },
    /* 3 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _v = __webpack_require__(4);

      var _v2 = _interopRequireDefault(_v);

      var _utils = __webpack_require__(8);

      var _utils2 = _interopRequireDefault(_utils);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }

      function generateGuid() {
        return (0, _v2.default)();
      }

      exports.default = {
        name: 'friendly-iframe',
        props: {
          src: {
            type: String,
            required: true
          },
          crossorigin: {
            type: String,
            required: false,
            default: 'anonymous'
          },
          target: {
            type: String,
            required: false,
            default: '_parent'
          },
          className: {
            type: String,
            required: false
          },
          allow: {
            type: String,
            required: false
          },
          name: {
            type: String,
            required: false
          },
          title: {
            type: String,
            required: false
          },
          sandbox: {
            type: String,
            required: false
          }
        },
        data: function data() {
          return {
            iframeEl: null,
            iframeLoadedMessage: 'IFRAME_LOADED_' + generateGuid(),
            iframeOnReadyStateChangeMessage: 'IFRAME_ON_READ_STATE_CHANGE_' + generateGuid()
          };
        },

        computed: {},
        watch: {
          src: function src() {
            this.reinitIframe(this);
          }
        },
        methods: {
          removeIframe: function removeIframe() {
            while (this.$el.firstChild) {
              this.$el.removeChild(this.$el.firstChild);
            }
          },
          setIframeUrl: function setIframeUrl() {
            if (this.iframeEl.contentWindow === null) {
              setTimeout(this.setIframeUrl);
              return;
            }
            var iframeDoc = this.iframeEl.contentWindow.document;
            iframeDoc.open().write('\n          <body onload="window.location.replace(\'' + this.src + '\'); parent.postMessage(\'' + this.iframeLoadedMessage + '\', \'*\')"></body>\n          <script>\n            window.document.onreadystatechange = function () {\n              if (window.document.readyState === \'complete\') {\n                parent.postMessage(\'' + this.iframeOnReadyStateChangeMessage + '\', \'*\')\n              }\n            };\n          </script>\n          ');

            iframeDoc.close();
          },

          reinitIframe: _utils2.default.debounce(function (vm) {
            vm.removeIframe();
            vm.initIframe();
          }, 200),
          initIframe: function initIframe() {
            this.iframeEl = document.createElement('iframe');
            this.iframeEl.setAttribute('style', 'visibility: hidden; position: absolute; top: -99999px; border: none;');
            if (this.src) this.iframeEl.setAttribute('iframe-src', this.src);
            if (this.className) this.iframeEl.setAttribute('class', this.className);
            if (this.class) this.iframeEl.setAttribute('class', this.class);
            if (this.crossorigin) this.iframeEl.setAttribute('crossorigin', this.crossorigin);
            if (this.target) this.iframeEl.setAttribute('target', this.target);
            if (this.allow) this.iframeEl.setAttribute('allow', this.allow);
            if (this.name) this.iframeEl.setAttribute('name', this.name);
            if (this.title) this.iframeEl.setAttribute('title', this.title);
            if (this.sandbox) this.iframeEl.setAttribute('sandbox', this.sandbox);

            this.$el.appendChild(this.iframeEl);

            this.setIframeUrl();
          },
          listenForEvents: function listenForEvents() {
            var _this = this;

            var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            var eventer = window[eventMethod];
            var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

            eventer(messageEvent, function (event) {
              if (event.data === _this.iframeLoadedMessage) {
                _this.$emit('iframe-load');

                _this.iframeEl.setAttribute('style', 'visibility: visible; border: none;');
              }

              if (event.data === _this.iframeOnReadyStateChangeMessage) {
                _this.$emit('load');
              }
            }, false);
          }
        },
        mounted: function mounted() {
          this.listenForEvents();

          this.initIframe();
        }
      };
      module.exports = exports['default'];

      /***/
    },
    /* 4 */
    /***/function (module, exports, __webpack_require__) {

      var rng = __webpack_require__(5);
      var bytesToUuid = __webpack_require__(7);

      // **`v1()` - Generate time-based UUID**
      //
      // Inspired by https://github.com/LiosK/UUID.js
      // and http://docs.python.org/library/uuid.html

      // random #'s we need to init node and clockseq
      var _seedBytes = rng();

      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      var _nodeId = [_seedBytes[0] | 0x01, _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]];

      // Per 4.2.2, randomize (14 bit) clockseq
      var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

      // Previous uuid creation time
      var _lastMSecs = 0,
          _lastNSecs = 0;

      // See https://github.com/broofa/node-uuid for API details
      function v1(options, buf, offset) {
        var i = buf && offset || 0;
        var b = buf || [];

        options = options || {};

        var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

        // UUID timestamps are 100 nano-second units since the Gregorian epoch,
        // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
        // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
        // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
        var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

        // Per 4.2.1.2, use count of uuid's generated during the current clock
        // cycle to simulate higher resolution clock
        var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

        // Time since last uuid creation (in msecs)
        var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000;

        // Per 4.2.1.2, Bump clockseq on clock regression
        if (dt < 0 && options.clockseq === undefined) {
          clockseq = clockseq + 1 & 0x3fff;
        }

        // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
        // time interval
        if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
          nsecs = 0;
        }

        // Per 4.2.1.2 Throw error if too many uuids are requested
        if (nsecs >= 10000) {
          throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
        }

        _lastMSecs = msecs;
        _lastNSecs = nsecs;
        _clockseq = clockseq;

        // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
        msecs += 12219292800000;

        // `time_low`
        var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
        b[i++] = tl >>> 24 & 0xff;
        b[i++] = tl >>> 16 & 0xff;
        b[i++] = tl >>> 8 & 0xff;
        b[i++] = tl & 0xff;

        // `time_mid`
        var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
        b[i++] = tmh >>> 8 & 0xff;
        b[i++] = tmh & 0xff;

        // `time_high_and_version`
        b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
        b[i++] = tmh >>> 16 & 0xff;

        // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
        b[i++] = clockseq >>> 8 | 0x80;

        // `clock_seq_low`
        b[i++] = clockseq & 0xff;

        // `node`
        var node = options.node || _nodeId;
        for (var n = 0; n < 6; ++n) {
          b[i + n] = node[n];
        }

        return buf ? buf : bytesToUuid(b);
      }

      module.exports = v1;

      /***/
    },
    /* 5 */
    /***/function (module, exports, __webpack_require__) {

      /* WEBPACK VAR INJECTION */(function (global) {
        // Unique ID creation requires a high quality random # generator.  In the
        // browser this is a little complicated due to unknown quality of Math.random()
        // and inconsistent support for the `crypto` API.  We do the best we can via
        // feature-detection
        var rng;

        var crypto = global.crypto || global.msCrypto; // for IE 11
        if (crypto && crypto.getRandomValues) {
          // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
          var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
          rng = function whatwgRNG() {
            crypto.getRandomValues(rnds8);
            return rnds8;
          };
        }

        if (!rng) {
          // Math.random()-based (RNG)
          //
          // If all else fails, use Math.random().  It's fast, but is of unspecified
          // quality.
          var rnds = new Array(16);
          rng = function rng() {
            for (var i = 0, r; i < 16; i++) {
              if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
              rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
            }

            return rnds;
          };
        }

        module.exports = rng;

        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(6));

      /***/
    },
    /* 6 */
    /***/function (module, exports) {

      var g;

      // This works in non-strict mode
      g = function () {
        return this;
      }();

      try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (1, eval)("this");
      } catch (e) {
        // This works if the window reference is available
        if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === "object") g = window;
      }

      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}

      module.exports = g;

      /***/
    },
    /* 7 */
    /***/function (module, exports) {

      /**
       * Convert array of 16 byte values to UUID string format of the form:
       * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
       */
      var byteToHex = [];
      for (var i = 0; i < 256; ++i) {
        byteToHex[i] = (i + 0x100).toString(16).substr(1);
      }

      function bytesToUuid(buf, offset) {
        var i = offset || 0;
        var bth = byteToHex;
        return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
      }

      module.exports = bytesToUuid;

      /***/
    },
    /* 8 */
    /***/function (module, exports, __webpack_require__) {

      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function debounce(func, wait, immediate) {
        var timeout = void 0;

        return function () {
          var context = this;

          var args = arguments;

          var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };

          var callNow = immediate && !timeout;

          clearTimeout(timeout);

          timeout = setTimeout(later, wait);

          if (callNow) func.apply(context, args);
        };
      }

      exports.default = {
        debounce: debounce
      };
      module.exports = exports["default"];

      /***/
    },
    /* 9 */
    /***/function (module, exports) {

      module.exports = { render: function render() {
          var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
          return _c('div', {
            staticClass: "vue-friendly-iframe"
          });
        }, staticRenderFns: []

        /***/ };
    }]
    /******/)
  );
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(68)(module)))

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VueMaskDirective */
/* unused harmony export VueMaskFilter */
/* unused harmony export VueMaskPlugin */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return plugin; });
var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var placeholderChar = '_';
var strFunction = 'function';

var emptyArray$1 = [];
function convertMaskToPlaceholder() {
  var mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray$1;
  var placeholderChar$1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : placeholderChar;

  if (!isArray(mask)) {
    throw new Error('Text-mask:convertMaskToPlaceholder; The mask property must be an array.');
  }

  if (mask.indexOf(placeholderChar$1) !== -1) {
    throw new Error('Placeholder character must not be used as part of the mask. Please specify a character ' + 'that is not present in your mask as your placeholder character.\n\n' + "The placeholder character that was received is: ".concat(JSON.stringify(placeholderChar$1), "\n\n") + "The mask that was received is: ".concat(JSON.stringify(mask)));
  }

  return mask.map(function (char) {
    return char instanceof RegExp ? placeholderChar$1 : char;
  }).join('');
}
function isArray(value) {
  return Array.isArray && Array.isArray(value) || value instanceof Array;
}
var strCaretTrap = '[]';
function processCaretTraps(mask) {
  var indexes = [];
  var indexOfCaretTrap;

  while (indexOfCaretTrap = mask.indexOf(strCaretTrap), indexOfCaretTrap !== -1) {
    indexes.push(indexOfCaretTrap);
    mask.splice(indexOfCaretTrap, 1);
  }

  return {
    maskWithoutCaretTraps: mask,
    indexes: indexes
  };
}

var emptyArray = [];
var emptyString = '';
function conformToMask() {
  var rawValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyString;
  var mask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isArray(mask)) {
    if (_typeof(mask) === strFunction) {
      mask = mask(rawValue, config);
      mask = processCaretTraps(mask).maskWithoutCaretTraps;
    } else {
      throw new Error('Text-mask:conformToMask; The mask property must be an array.');
    }
  }

  var _config$guide = config.guide,
      guide = _config$guide === void 0 ? true : _config$guide,
      _config$previousConfo = config.previousConformedValue,
      previousConformedValue = _config$previousConfo === void 0 ? emptyString : _config$previousConfo,
      _config$placeholderCh = config.placeholderChar,
      placeholderChar$1 = _config$placeholderCh === void 0 ? placeholderChar : _config$placeholderCh,
      _config$placeholder = config.placeholder,
      placeholder = _config$placeholder === void 0 ? convertMaskToPlaceholder(mask, placeholderChar$1) : _config$placeholder,
      currentCaretPosition = config.currentCaretPosition,
      keepCharPositions = config.keepCharPositions;
  var suppressGuide = guide === false && previousConformedValue !== undefined;
  var rawValueLength = rawValue.length;
  var previousConformedValueLength = previousConformedValue.length;
  var placeholderLength = placeholder.length;
  var maskLength = mask.length;
  var editDistance = rawValueLength - previousConformedValueLength;
  var isAddition = editDistance > 0;
  var indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
  var indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);

  if (keepCharPositions === true && !isAddition) {
    var compensatingPlaceholderChars = emptyString;

    for (var i = indexOfFirstChange; i < indexOfLastChange; i++) {
      if (placeholder[i] === placeholderChar$1) {
        compensatingPlaceholderChars += placeholderChar$1;
      }
    }

    rawValue = rawValue.slice(0, indexOfFirstChange) + compensatingPlaceholderChars + rawValue.slice(indexOfFirstChange, rawValueLength);
  }

  var rawValueArr = rawValue.split(emptyString).map(function (char, i) {
    return {
      char: char,
      isNew: i >= indexOfFirstChange && i < indexOfLastChange
    };
  });

  for (var _i = rawValueLength - 1; _i >= 0; _i--) {
    var char = rawValueArr[_i].char;

    if (char !== placeholderChar$1) {
      var shouldOffset = _i >= indexOfFirstChange && previousConformedValueLength === maskLength;

      if (char === placeholder[shouldOffset ? _i - editDistance : _i]) {
        rawValueArr.splice(_i, 1);
      }
    }
  }

  var conformedValue = emptyString;
  var someCharsRejected = false;

  placeholderLoop: for (var _i2 = 0; _i2 < placeholderLength; _i2++) {
    var charInPlaceholder = placeholder[_i2];

    if (charInPlaceholder === placeholderChar$1) {
      if (rawValueArr.length > 0) {
        while (rawValueArr.length > 0) {
          var _rawValueArr$shift = rawValueArr.shift(),
              rawValueChar = _rawValueArr$shift.char,
              isNew = _rawValueArr$shift.isNew;

          if (rawValueChar === placeholderChar$1 && suppressGuide !== true) {
            conformedValue += placeholderChar$1;
            continue placeholderLoop;
          } else if (mask[_i2].test(rawValueChar)) {
            if (keepCharPositions !== true || isNew === false || previousConformedValue === emptyString || guide === false || !isAddition) {
              conformedValue += rawValueChar;
            } else {
              var rawValueArrLength = rawValueArr.length;
              var indexOfNextAvailablePlaceholderChar = null;

              for (var _i3 = 0; _i3 < rawValueArrLength; _i3++) {
                var charData = rawValueArr[_i3];

                if (charData.char !== placeholderChar$1 && charData.isNew === false) {
                  break;
                }

                if (charData.char === placeholderChar$1) {
                  indexOfNextAvailablePlaceholderChar = _i3;
                  break;
                }
              }

              if (indexOfNextAvailablePlaceholderChar !== null) {
                conformedValue += rawValueChar;
                rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
              } else {
                _i2--;
              }
            }

            continue placeholderLoop;
          } else {
            someCharsRejected = true;
          }
        }
      }

      if (suppressGuide === false) {
        conformedValue += placeholder.substr(_i2, placeholderLength);
      }

      break;
    } else {
      conformedValue += charInPlaceholder;
    }
  }

  if (suppressGuide && isAddition === false) {
    var indexOfLastFilledPlaceholderChar = null;

    for (var _i4 = 0; _i4 < conformedValue.length; _i4++) {
      if (placeholder[_i4] === placeholderChar$1) {
        indexOfLastFilledPlaceholderChar = _i4;
      }
    }

    if (indexOfLastFilledPlaceholderChar !== null) {
      conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
    } else {
      conformedValue = emptyString;
    }
  }

  return {
    conformedValue: conformedValue,
    meta: {
      someCharsRejected: someCharsRejected
    }
  };
}

var NEXT_CHAR_OPTIONAL = {
  __nextCharOptional__: true
};
var defaultMaskReplacers = {
  '#': /\d/,
  A: /[a-z]/i,
  N: /[a-z0-9]/i,
  '?': NEXT_CHAR_OPTIONAL,
  X: /./
};

var stringToRegexp = function stringToRegexp(str) {
  var lastSlash = str.lastIndexOf('/');
  return new RegExp(str.slice(1, lastSlash), str.slice(lastSlash + 1));
};

var makeRegexpOptional = function makeRegexpOptional(charRegexp) {
  return stringToRegexp(charRegexp.toString().replace(/.(\/)[gmiyus]{0,6}$/, function (match) {
    return match.replace('/', '?/');
  }));
};

var escapeIfNeeded = function escapeIfNeeded(char) {
  return '[\\^$.|?*+()'.indexOf(char) > -1 ? "\\".concat(char) : char;
};

var charRegexp = function charRegexp(char) {
  return new RegExp("/[".concat(escapeIfNeeded(char), "]/"));
};

var isRegexp$1 = function isRegexp(entity) {
  return entity instanceof RegExp;
};

var castToRegexp = function castToRegexp(char) {
  return isRegexp$1(char) ? char : charRegexp(char);
};

function maskToRegExpMask(mask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return mask.map(function (char, index, array) {
    var maskChar = maskReplacers[char] || char;
    var previousChar = array[index - 1];
    var previousMaskChar = maskReplacers[previousChar] || previousChar;

    if (maskChar === NEXT_CHAR_OPTIONAL) {
      return null;
    }

    if (previousMaskChar === NEXT_CHAR_OPTIONAL) {
      return makeRegexpOptional(castToRegexp(maskChar));
    }

    return maskChar;
  }).filter(Boolean);
}

function stringMaskToRegExpMask(stringMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  return maskToRegExpMask(stringMask.split(''), maskReplacers);
}
function arrayMaskToRegExpMask(arrayMask) {
  var maskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;
  var flattenedMask = arrayMask.map(function (part) {
    if (part instanceof RegExp) {
      return part;
    }

    if (typeof part === 'string') {
      return part.split('');
    }

    return null;
  }).filter(Boolean).reduce(function (mask, part) {
    return mask.concat(part);
  }, []);
  return maskToRegExpMask(flattenedMask, maskReplacers);
}

var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var queryInputElementInside = function queryInputElementInside(el) {
  return el instanceof HTMLInputElement ? el : el.querySelector('input') || el;
};
var isFunction = function isFunction(val) {
  return typeof val === 'function';
};
var isString = function isString(val) {
  return typeof val === 'string';
};
var isRegexp = function isRegexp(val) {
  return val instanceof RegExp;
};

function parseMask(inputMask, maskReplacers) {
  if (Array.isArray(inputMask)) {
    return arrayMaskToRegExpMask(inputMask, maskReplacers);
  }

  if (isFunction(inputMask)) {
    return inputMask;
  }

  if (isString(inputMask) && inputMask.length > 0) {
    return stringMaskToRegExpMask(inputMask, maskReplacers);
  }

  return inputMask;
}

function createOptions() {
  var elementOptions = new Map();
  var defaultOptions = {
    previousValue: '',
    mask: []
  };

  function get(el) {
    return elementOptions.get(el) || _objectSpread2({}, defaultOptions);
  }

  function partiallyUpdate(el, newOptions) {
    elementOptions.set(el, _objectSpread2(_objectSpread2({}, get(el)), newOptions));
  }

  function remove(el) {
    elementOptions.delete(el);
  }

  return {
    partiallyUpdate: partiallyUpdate,
    remove: remove,
    get: get
  };
}

function extendMaskReplacers(maskReplacers) {
  var baseMaskReplacers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultMaskReplacers;

  if (maskReplacers === null || Array.isArray(maskReplacers) || _typeof(maskReplacers) !== 'object') {
    return baseMaskReplacers;
  }

  return Object.keys(maskReplacers).reduce(function (extendedMaskReplacers, key) {
    var value = maskReplacers[key];

    if (value !== null && !(value instanceof RegExp)) {
      return extendedMaskReplacers;
    }

    return _objectSpread2(_objectSpread2({}, extendedMaskReplacers), {}, _defineProperty({}, key, value));
  }, baseMaskReplacers);
}

var options = createOptions();

function triggerInputUpdate(el) {
  trigger(el, 'input');
}

function updateValue(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var value = el.value;

  var _options$get = options.get(el),
      previousValue = _options$get.previousValue,
      mask = _options$get.mask;

  var isValueChanged = value !== previousValue;
  var isLengthIncreased = value.length > previousValue.length;
  var isUpdateNeeded = value && isValueChanged && isLengthIncreased;

  if ((force || isUpdateNeeded) && mask) {
    var _conformToMask = conformToMask(value, mask, {
      guide: false
    }),
        conformedValue = _conformToMask.conformedValue;

    el.value = conformedValue;
    triggerInputUpdate(el);
  }

  options.partiallyUpdate(el, {
    previousValue: value
  });
}

function updateMask(el, inputMask, maskReplacers) {
  var mask = parseMask(inputMask, maskReplacers);
  options.partiallyUpdate(el, {
    mask: mask
  });
}

function maskToString(mask) {
  var maskArray = Array.isArray(mask) ? mask : [mask];
  var filteredMaskArray = maskArray.filter(function (part) {
    return isString(part) || isRegexp(part);
  });
  return filteredMaskArray.toString();
}

function createDirective() {
  var directiveOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceMaskReplacers = extendMaskReplacers(directiveOptions && directiveOptions.placeholders);
  return {
    bind: function bind(el, _ref) {
      var value = _ref.value;
      el = queryInputElementInside(el);
      updateMask(el, value, instanceMaskReplacers);
      updateValue(el);
    },
    componentUpdated: function componentUpdated(el, _ref2) {
      var value = _ref2.value,
          oldValue = _ref2.oldValue;
      el = queryInputElementInside(el);
      var isMaskChanged = isFunction(value) || maskToString(oldValue) !== maskToString(value);

      if (isMaskChanged) {
        updateMask(el, value, instanceMaskReplacers);
      }

      updateValue(el, isMaskChanged);
    },
    unbind: function unbind(el) {
      el = queryInputElementInside(el);
      options.remove(el);
    }
  };
}
var directive = createDirective();

function createFilter() {
  var filterOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var instanceMaskReplacers = extendMaskReplacers(filterOptions && filterOptions.placeholders);
  return function (value, inputMask) {
    if (!isString(value) && !Number.isFinite(value)) return value;
    var mask = parseMask(inputMask, instanceMaskReplacers);

    var _conformToMask = conformToMask("".concat(value), mask, {
      guide: false
    }),
        conformedValue = _conformToMask.conformedValue;

    return conformedValue;
  };
}
var filter = createFilter();

var plugin = function plugin(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Vue.directive('mask', createDirective(options));
  Vue.filter('VMask', createFilter(options));
};



/***/ }),
/* 1672 */
/***/ (function(module, exports) {

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports =
/******/function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/var installedModules = {};
  /******/
  /******/ // The require function
  /******/function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/if (installedModules[moduleId]) {
      /******/return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/var module = installedModules[moduleId] = {
      /******/i: moduleId,
      /******/l: false,
      /******/exports: {}
      /******/ };
    /******/
    /******/ // Execute the module function
    /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/
    /******/ // Flag the module as loaded
    /******/module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/__webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/__webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/__webpack_require__.d = function (exports, name, getter) {
    /******/if (!__webpack_require__.o(exports, name)) {
      /******/Object.defineProperty(exports, name, { enumerable: true, get: getter });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/__webpack_require__.r = function (exports) {
    /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
      /******/
    }
    /******/Object.defineProperty(exports, '__esModule', { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/__webpack_require__.t = function (value, mode) {
    /******/if (mode & 1) value = __webpack_require__(value);
    /******/if (mode & 8) return value;
    /******/if (mode & 4 && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === 'object' && value && value.__esModule) return value;
    /******/var ns = Object.create(null);
    /******/__webpack_require__.r(ns);
    /******/Object.defineProperty(ns, 'default', { enumerable: true, value: value });
    /******/if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    } /******/return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/__webpack_require__.n = function (module) {
    /******/var getter = module && module.__esModule ?
    /******/function getDefault() {
      return module['default'];
    } :
    /******/function getModuleExports() {
      return module;
    };
    /******/__webpack_require__.d(getter, 'a', getter);
    /******/return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/__webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/__webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/return __webpack_require__(__webpack_require__.s = "fb15");
  /******/
}(
/************************************************************************/
/******/{

  /***/"00ee":
  /***/function ee(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var test = {};

    test[TO_STRING_TAG] = 'z';

    module.exports = String(test) === '[object z]';

    /***/
  },

  /***/"0366":
  /***/function _(module, exports, __webpack_require__) {

    var aFunction = __webpack_require__("1c0b");

    // optional / simple context binding
    module.exports = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 0:
          return function () {
            return fn.call(that);
          };
        case 1:
          return function (a) {
            return fn.call(that, a);
          };
        case 2:
          return function (a, b) {
            return fn.call(that, a, b);
          };
        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
      }
      return function () /* ...args */{
        return fn.apply(that, arguments);
      };
    };

    /***/
  },

  /***/"0538":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var aFunction = __webpack_require__("1c0b");
    var isObject = __webpack_require__("861d");

    var slice = [].slice;
    var factories = {};

    var construct = function construct(C, argsLength, args) {
      if (!(argsLength in factories)) {
        for (var list = [], i = 0; i < argsLength; i++) {
          list[i] = 'a[' + i + ']';
        } // eslint-disable-next-line no-new-func
        factories[argsLength] = Function('C,a', 'return new C(' + list.join(',') + ')');
      }return factories[argsLength](C, args);
    };

    // `Function.prototype.bind` method implementation
    // https://tc39.github.io/ecma262/#sec-function.prototype.bind
    module.exports = Function.bind || function bind(that /* , ...args */) {
      var fn = aFunction(this);
      var partArgs = slice.call(arguments, 1);
      var boundFunction = function bound() /* args... */{
        var args = partArgs.concat(slice.call(arguments));
        return this instanceof boundFunction ? construct(fn, args.length, args) : fn.apply(that, args);
      };
      if (isObject(fn.prototype)) boundFunction.prototype = fn.prototype;
      return boundFunction;
    };

    /***/
  },

  /***/"057f":
  /***/function f(module, exports, __webpack_require__) {

    var toIndexedObject = __webpack_require__("fc6a");
    var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

    var toString = {}.toString;

    var windowNames = (typeof window === 'undefined' ? 'undefined' : _typeof2(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    var getWindowNames = function getWindowNames(it) {
      try {
        return nativeGetOwnPropertyNames(it);
      } catch (error) {
        return windowNames.slice();
      }
    };

    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    module.exports.f = function getOwnPropertyNames(it) {
      return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : nativeGetOwnPropertyNames(toIndexedObject(it));
    };

    /***/
  },

  /***/"06c5":
  /***/function c5(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _unsupportedIterableToArray;
    });
    /* harmony import */var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a630");
    /* harmony import */var core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("fb6a");
    /* harmony import */var core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_slice__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("b0c0");
    /* harmony import */var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("d3b7");
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("25f0");
    /* harmony import */var core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string__WEBPACK_IMPORTED_MODULE_4__);
    /* harmony import */var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
    /* harmony import */var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
    /* harmony import */var _arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("6b75");

    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return Object(_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(_arrayLikeToArray__WEBPACK_IMPORTED_MODULE_6__[/* default */"a"])(o, minLen);
    }

    /***/
  },

  /***/"06cf":
  /***/function cf(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var propertyIsEnumerableModule = __webpack_require__("d1e7");
    var createPropertyDescriptor = __webpack_require__("5c6c");
    var toIndexedObject = __webpack_require__("fc6a");
    var toPrimitive = __webpack_require__("c04e");
    var has = __webpack_require__("5135");
    var IE8_DOM_DEFINE = __webpack_require__("0cfb");

    var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
    exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
      O = toIndexedObject(O);
      P = toPrimitive(P, true);
      if (IE8_DOM_DEFINE) try {
        return nativeGetOwnPropertyDescriptor(O, P);
      } catch (error) {/* empty */}
      if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
    };

    /***/
  },

  /***/"0cfb":
  /***/function cfb(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var fails = __webpack_require__("d039");
    var createElement = __webpack_require__("cc12");

    // Thank's IE8 for his funny defineProperty
    module.exports = !DESCRIPTORS && !fails(function () {
      return Object.defineProperty(createElement('div'), 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });

    /***/
  },

  /***/"0d0e":
  /***/function d0e(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"392d026c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeStream.vue?vue&type=template&id=35411cc1&scoped=true&lang=html&

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "qrcode-stream-wrapper" }, [_c('video', { ref: "video", staticClass: "qrcode-stream-camera", class: { 'qrcode-stream-camera--hidden': !_vm.shouldScan }, attrs: { "autoplay": "", "muted": "", "playsinline": "" }, domProps: { "muted": true } }), _c('canvas', { directives: [{ name: "show", rawName: "v-show", value: !_vm.shouldScan, expression: "!shouldScan" }], ref: "pauseFrame", staticClass: "qrcode-stream-camera" }), _c('canvas', { ref: "trackingLayer", staticClass: "qrcode-stream-overlay" }), _c('div', { staticClass: "qrcode-stream-overlay" }, [_vm._t("default")], 2)]);
    };
    var staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/QrcodeStream.vue?vue&type=template&id=35411cc1&scoped=true&lang=html&

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
    var es_array_includes = __webpack_require__("caad");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
    var es_array_map = __webpack_require__("d81d");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
    var es_object_to_string = __webpack_require__("d3b7");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
    var es_promise = __webpack_require__("e6cf");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
    var es_symbol = __webpack_require__("a4d3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
    var es_array_filter = __webpack_require__("4de4");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
    var es_array_for_each = __webpack_require__("4160");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
    var es_object_get_own_property_descriptor = __webpack_require__("e439");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
    var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
    var es_object_keys = __webpack_require__("b64b");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
    var web_dom_collections_for_each = __webpack_require__("159b");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js


    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);

      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }

      return keys;
    }

    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
          ownKeys(Object(source), true).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }

      return target;
    }
    // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
    var runtime = __webpack_require__("96cf");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
    var asyncToGenerator = __webpack_require__("1da1");

    // EXTERNAL MODULE: ./src/misc/scanner.js
    var scanner = __webpack_require__("a180");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
    var es_array_iterator = __webpack_require__("e260");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
    var es_string_includes = __webpack_require__("2532");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
    var es_string_iterator = __webpack_require__("3ca3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
    var web_dom_collections_iterator = __webpack_require__("ddb0");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
    var web_url = __webpack_require__("2b3d");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
    var slicedToArray = __webpack_require__("3835");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
    var classCallCheck = __webpack_require__("d4ec");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }
    // EXTERNAL MODULE: ./src/misc/errors.js + 10 modules
    var errors = __webpack_require__("1cc0");

    // EXTERNAL MODULE: ./node_modules/callforth/dist/callforth.mjs
    var callforth = __webpack_require__("c036");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
    var es_array_concat = __webpack_require__("99af");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
    var es_array_find = __webpack_require__("7db0");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
    var es_array_slice = __webpack_require__("fb6a");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
    var es_array_some = __webpack_require__("45fc");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
    var es_function_name = __webpack_require__("b0c0");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
    var esm_typeof = __webpack_require__("53ca");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
    var es_array_reduce = __webpack_require__("13d5");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
    var es_map = __webpack_require__("4ec9");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
    var es_object_assign = __webpack_require__("cca6");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
    var es_regexp_exec = __webpack_require__("ac1f");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
    var es_regexp_to_string = __webpack_require__("25f0");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
    var es_string_ends_with = __webpack_require__("8a79");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
    var es_string_match = __webpack_require__("466d");

    // CONCATENATED MODULE: ./node_modules/webrtc-adapter/src/js/utils.js
    /*
     *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
     *
     *  Use of this source code is governed by a BSD-style license
     *  that can be found in the LICENSE file in the root of the source
     *  tree.
     */

    /* eslint-env node */

    var logDisabled_ = true;
    var deprecationWarnings_ = true;
    /**
     * Extract browser version out of the provided user agent string.
     *
     * @param {!string} uastring userAgent string.
     * @param {!string} expr Regular expression used as match criteria.
     * @param {!number} pos position in the version string to be returned.
     * @return {!number} browser version.
     */

    function extractVersion(uastring, expr, pos) {
      var match = uastring.match(expr);
      return match && match.length >= pos && parseInt(match[pos], 10);
    } // Wraps the peerconnection event eventNameToWrap in a function
    // which returns the modified event object (or false to prevent
    // the event).

    function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
      if (!window.RTCPeerConnection) {
        return;
      }

      var proto = window.RTCPeerConnection.prototype;
      var nativeAddEventListener = proto.addEventListener;

      proto.addEventListener = function (nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) {
          return nativeAddEventListener.apply(this, arguments);
        }

        var wrappedCallback = function wrappedCallback(e) {
          var modifiedEvent = wrapper(e);

          if (modifiedEvent) {
            if (cb.handleEvent) {
              cb.handleEvent(modifiedEvent);
            } else {
              cb(modifiedEvent);
            }
          }
        };

        this._eventMap = this._eventMap || {};

        if (!this._eventMap[eventNameToWrap]) {
          this._eventMap[eventNameToWrap] = new Map();
        }

        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);

        return nativeAddEventListener.apply(this, [nativeEventName, wrappedCallback]);
      };

      var nativeRemoveEventListener = proto.removeEventListener;

      proto.removeEventListener = function (nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) {
          return nativeRemoveEventListener.apply(this, arguments);
        }

        if (!this._eventMap[eventNameToWrap].has(cb)) {
          return nativeRemoveEventListener.apply(this, arguments);
        }

        var unwrappedCb = this._eventMap[eventNameToWrap].get(cb);

        this._eventMap[eventNameToWrap].delete(cb);

        if (this._eventMap[eventNameToWrap].size === 0) {
          delete this._eventMap[eventNameToWrap];
        }

        if (Object.keys(this._eventMap).length === 0) {
          delete this._eventMap;
        }

        return nativeRemoveEventListener.apply(this, [nativeEventName, unwrappedCb]);
      };

      Object.defineProperty(proto, 'on' + eventNameToWrap, {
        get: function get() {
          return this['_on' + eventNameToWrap];
        },
        set: function set(cb) {
          if (this['_on' + eventNameToWrap]) {
            this.removeEventListener(eventNameToWrap, this['_on' + eventNameToWrap]);
            delete this['_on' + eventNameToWrap];
          }

          if (cb) {
            this.addEventListener(eventNameToWrap, this['_on' + eventNameToWrap] = cb);
          }
        },
        enumerable: true,
        configurable: true
      });
    }
    function disableLog(bool) {
      if (typeof bool !== 'boolean') {
        return new Error('Argument type: ' + Object(esm_typeof["a" /* default */])(bool) + '. Please use a boolean.');
      }

      logDisabled_ = bool;
      return bool ? 'adapter.js logging disabled' : 'adapter.js logging enabled';
    }
    /**
     * Disable or enable deprecation warnings
     * @param {!boolean} bool set to true to disable warnings.
     */

    function disableWarnings(bool) {
      if (typeof bool !== 'boolean') {
        return new Error('Argument type: ' + Object(esm_typeof["a" /* default */])(bool) + '. Please use a boolean.');
      }

      deprecationWarnings_ = !bool;
      return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
    }
    function log() {
      if ((typeof window === "undefined" ? "undefined" : Object(esm_typeof["a" /* default */])(window)) === 'object') {
        if (logDisabled_) {
          return;
        }

        if (typeof console !== 'undefined' && typeof console.log === 'function') {
          console.log.apply(console, arguments);
        }
      }
    }
    /**
     * Shows a deprecation warning suggesting the modern and spec-compatible API.
     */

    function deprecated(oldMethod, newMethod) {
      if (!deprecationWarnings_) {
        return;
      }

      console.warn(oldMethod + ' is deprecated, please use ' + newMethod + ' instead.');
    }
    /**
     * Browser detector.
     *
     * @return {object} result containing browser and version
     *     properties.
     */

    function detectBrowser(window) {
      // Returned result object.
      var result = {
        browser: null,
        version: null
      }; // Fail early if it's not a browser

      if (typeof window === 'undefined' || !window.navigator) {
        result.browser = 'Not a browser.';
        return result;
      }

      var navigator = window.navigator;

      if (navigator.mozGetUserMedia) {
        // Firefox.
        result.browser = 'firefox';
        result.version = extractVersion(navigator.userAgent, /Firefox\/(\d+)\./, 1);
      } else if (navigator.webkitGetUserMedia || window.isSecureContext === false && window.webkitRTCPeerConnection && !window.RTCIceGatherer) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = 'chrome';
        result.version = extractVersion(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
      } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
        // Edge.
        result.browser = 'edge';
        result.version = extractVersion(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
      } else if (window.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        // Safari.
        result.browser = 'safari';
        result.version = extractVersion(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window.RTCRtpTransceiver && 'currentDirection' in window.RTCRtpTransceiver.prototype;
      } else {
        // Default fallthrough: not supported.
        result.browser = 'Not a supported browser.';
        return result;
      }

      return result;
    }
    /**
     * Checks if something is an object.
     *
     * @param {*} val The something you want to check.
     * @return true if val is an object, false otherwise.
     */

    function isObject(val) {
      return Object.prototype.toString.call(val) === '[object Object]';
    }
    /**
     * Remove all empty objects and undefined values
     * from a nested object -- an enhanced and vanilla version
     * of Lodash's `compact`.
     */

    function compactObject(data) {
      if (!isObject(data)) {
        return data;
      }

      return Object.keys(data).reduce(function (accumulator, key) {
        var isObj = isObject(data[key]);
        var value = isObj ? compactObject(data[key]) : data[key];
        var isEmptyObject = isObj && !Object.keys(value).length;

        if (value === undefined || isEmptyObject) {
          return accumulator;
        }

        return Object.assign(accumulator, _defineProperty({}, key, value));
      }, {});
    }
    /* iterates the stats graph recursively. */

    function walkStats(stats, base, resultSet) {
      if (!base || resultSet.has(base.id)) {
        return;
      }

      resultSet.set(base.id, base);
      Object.keys(base).forEach(function (name) {
        if (name.endsWith('Id')) {
          walkStats(stats, stats.get(base[name]), resultSet);
        } else if (name.endsWith('Ids')) {
          base[name].forEach(function (id) {
            walkStats(stats, stats.get(id), resultSet);
          });
        }
      });
    }
    /* filter getStats for a sender/receiver track. */

    function filterStats(result, track, outbound) {
      var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
      var filteredResult = new Map();

      if (track === null) {
        return filteredResult;
      }

      var trackStats = [];
      result.forEach(function (value) {
        if (value.type === 'track' && value.trackIdentifier === track.id) {
          trackStats.push(value);
        }
      });
      trackStats.forEach(function (trackStat) {
        result.forEach(function (stats) {
          if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
            walkStats(result, stats, filteredResult);
          }
        });
      });
      return filteredResult;
    }
    // CONCATENATED MODULE: ./node_modules/webrtc-adapter/src/js/chrome/getusermedia.js
    /*
     *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
     *
     *  Use of this source code is governed by a BSD-style license
     *  that can be found in the LICENSE file in the root of the source
     *  tree.
     */

    /* eslint-env node */

    var logging = log;
    function shimGetUserMedia(window) {
      var navigator = window && window.navigator;

      if (!navigator.mediaDevices) {
        return;
      }

      var browserDetails = detectBrowser(window);

      var constraintsToChrome_ = function constraintsToChrome_(c) {
        if (Object(esm_typeof["a" /* default */])(c) !== 'object' || c.mandatory || c.optional) {
          return c;
        }

        var cc = {};
        Object.keys(c).forEach(function (key) {
          if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
            return;
          }

          var r = Object(esm_typeof["a" /* default */])(c[key]) === 'object' ? c[key] : {
            ideal: c[key]
          };

          if (r.exact !== undefined && typeof r.exact === 'number') {
            r.min = r.max = r.exact;
          }

          var oldname_ = function oldname_(prefix, name) {
            if (prefix) {
              return prefix + name.charAt(0).toUpperCase() + name.slice(1);
            }

            return name === 'deviceId' ? 'sourceId' : name;
          };

          if (r.ideal !== undefined) {
            cc.optional = cc.optional || [];
            var oc = {};

            if (typeof r.ideal === 'number') {
              oc[oldname_('min', key)] = r.ideal;
              cc.optional.push(oc);
              oc = {};
              oc[oldname_('max', key)] = r.ideal;
              cc.optional.push(oc);
            } else {
              oc[oldname_('', key)] = r.ideal;
              cc.optional.push(oc);
            }
          }

          if (r.exact !== undefined && typeof r.exact !== 'number') {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_('', key)] = r.exact;
          } else {
            ['min', 'max'].forEach(function (mix) {
              if (r[mix] !== undefined) {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_(mix, key)] = r[mix];
              }
            });
          }
        });

        if (c.advanced) {
          cc.optional = (cc.optional || []).concat(c.advanced);
        }

        return cc;
      };

      var shimConstraints_ = function shimConstraints_(constraints, func) {
        if (browserDetails.version >= 61) {
          return func(constraints);
        }

        constraints = JSON.parse(JSON.stringify(constraints));

        if (constraints && Object(esm_typeof["a" /* default */])(constraints.audio) === 'object') {
          var remap = function remap(obj, a, b) {
            if (a in obj && !(b in obj)) {
              obj[b] = obj[a];
              delete obj[a];
            }
          };

          constraints = JSON.parse(JSON.stringify(constraints));
          remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
          remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
          constraints.audio = constraintsToChrome_(constraints.audio);
        }

        if (constraints && Object(esm_typeof["a" /* default */])(constraints.video) === 'object') {
          // Shim facingMode for mobile & surface pro.
          var face = constraints.video.facingMode;
          face = face && (Object(esm_typeof["a" /* default */])(face) === 'object' ? face : {
            ideal: face
          });
          var getSupportedFacingModeLies = browserDetails.version < 66;

          if (face && (face.exact === 'user' || face.exact === 'environment' || face.ideal === 'user' || face.ideal === 'environment') && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
            delete constraints.video.facingMode;
            var matches;

            if (face.exact === 'environment' || face.ideal === 'environment') {
              matches = ['back', 'rear'];
            } else if (face.exact === 'user' || face.ideal === 'user') {
              matches = ['front'];
            }

            if (matches) {
              // Look for matches in label, or use last cam for back (typical).
              return navigator.mediaDevices.enumerateDevices().then(function (devices) {
                devices = devices.filter(function (d) {
                  return d.kind === 'videoinput';
                });
                var dev = devices.find(function (d) {
                  return matches.some(function (match) {
                    return d.label.toLowerCase().includes(match);
                  });
                });

                if (!dev && devices.length && matches.includes('back')) {
                  dev = devices[devices.length - 1]; // more likely the back cam
                }

                if (dev) {
                  constraints.video.deviceId = face.exact ? {
                    exact: dev.deviceId
                  } : {
                    ideal: dev.deviceId
                  };
                }

                constraints.video = constraintsToChrome_(constraints.video);
                logging('chrome: ' + JSON.stringify(constraints));
                return func(constraints);
              });
            }
          }

          constraints.video = constraintsToChrome_(constraints.video);
        }

        logging('chrome: ' + JSON.stringify(constraints));
        return func(constraints);
      };

      var shimError_ = function shimError_(e) {
        if (browserDetails.version >= 64) {
          return e;
        }

        return {
          name: {
            PermissionDeniedError: 'NotAllowedError',
            PermissionDismissedError: 'NotAllowedError',
            InvalidStateError: 'NotAllowedError',
            DevicesNotFoundError: 'NotFoundError',
            ConstraintNotSatisfiedError: 'OverconstrainedError',
            TrackStartError: 'NotReadableError',
            MediaDeviceFailedDueToShutdown: 'NotAllowedError',
            MediaDeviceKillSwitchOn: 'NotAllowedError',
            TabCaptureError: 'AbortError',
            ScreenCaptureError: 'AbortError',
            DeviceCaptureError: 'AbortError'
          }[e.name] || e.name,
          message: e.message,
          constraint: e.constraint || e.constraintName,
          toString: function toString() {
            return this.name + (this.message && ': ') + this.message;
          }
        };
      };

      var getUserMedia_ = function getUserMedia_(constraints, onSuccess, onError) {
        shimConstraints_(constraints, function (c) {
          navigator.webkitGetUserMedia(c, onSuccess, function (e) {
            if (onError) {
              onError(shimError_(e));
            }
          });
        });
      };

      navigator.getUserMedia = getUserMedia_.bind(navigator); // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
      // function which returns a Promise, it does not accept spec-style
      // constraints.

      if (navigator.mediaDevices.getUserMedia) {
        var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

        navigator.mediaDevices.getUserMedia = function (cs) {
          return shimConstraints_(cs, function (c) {
            return origGetUserMedia(c).then(function (stream) {
              if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                stream.getTracks().forEach(function (track) {
                  track.stop();
                });
                throw new DOMException('', 'NotFoundError');
              }

              return stream;
            }, function (e) {
              return Promise.reject(shimError_(e));
            });
          });
        };
      }
    }
    // CONCATENATED MODULE: ./node_modules/webrtc-adapter/src/js/edge/getusermedia.js
    /*
     *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
     *
     *  Use of this source code is governed by a BSD-style license
     *  that can be found in the LICENSE file in the root of the source
     *  tree.
     */

    /* eslint-env node */

    function getusermedia_shimGetUserMedia(window) {
      var navigator = window && window.navigator;

      var shimError_ = function shimError_(e) {
        return {
          name: {
            PermissionDeniedError: 'NotAllowedError'
          }[e.name] || e.name,
          message: e.message,
          constraint: e.constraint,
          toString: function toString() {
            return this.name;
          }
        };
      }; // getUserMedia error shim.


      var origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

      navigator.mediaDevices.getUserMedia = function (c) {
        return origGetUserMedia(c).catch(function (e) {
          return Promise.reject(shimError_(e));
        });
      };
    }
    // CONCATENATED MODULE: ./node_modules/webrtc-adapter/src/js/firefox/getusermedia.js
    /*
     *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
     *
     *  Use of this source code is governed by a BSD-style license
     *  that can be found in the LICENSE file in the root of the source
     *  tree.
     */

    /* eslint-env node */

    function firefox_getusermedia_shimGetUserMedia(window) {
      var browserDetails = detectBrowser(window);
      var navigator = window && window.navigator;
      var MediaStreamTrack = window && window.MediaStreamTrack;

      navigator.getUserMedia = function (constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        deprecated('navigator.getUserMedia', 'navigator.mediaDevices.getUserMedia');
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
      };

      if (!(browserDetails.version > 55 && 'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
        var remap = function remap(obj, a, b) {
          if (a in obj && !(b in obj)) {
            obj[b] = obj[a];
            delete obj[a];
          }
        };

        var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);

        navigator.mediaDevices.getUserMedia = function (c) {
          if (Object(esm_typeof["a" /* default */])(c) === 'object' && Object(esm_typeof["a" /* default */])(c.audio) === 'object') {
            c = JSON.parse(JSON.stringify(c));
            remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
            remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
          }

          return nativeGetUserMedia(c);
        };

        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
          var nativeGetSettings = MediaStreamTrack.prototype.getSettings;

          MediaStreamTrack.prototype.getSettings = function () {
            var obj = nativeGetSettings.apply(this, arguments);
            remap(obj, 'mozAutoGainControl', 'autoGainControl');
            remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
            return obj;
          };
        }

        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
          var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;

          MediaStreamTrack.prototype.applyConstraints = function (c) {
            if (this.kind === 'audio' && Object(esm_typeof["a" /* default */])(c) === 'object') {
              c = JSON.parse(JSON.stringify(c));
              remap(c, 'autoGainControl', 'mozAutoGainControl');
              remap(c, 'noiseSuppression', 'mozNoiseSuppression');
            }

            return nativeApplyConstraints.apply(this, [c]);
          };
        }
      }
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
    var es_array_index_of = __webpack_require__("c975");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
    var es_array_splice = __webpack_require__("a434");

    // CONCATENATED MODULE: ./node_modules/webrtc-adapter/src/js/safari/safari_shim.js
    /*
     *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
     *
     *  Use of this source code is governed by a BSD-style license
     *  that can be found in the LICENSE file in the root of the source
     *  tree.
     */

    function shimLocalStreamsAPI(window) {
      if (Object(esm_typeof["a" /* default */])(window) !== 'object' || !window.RTCPeerConnection) {
        return;
      }

      if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
        window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
          if (!this._localStreams) {
            this._localStreams = [];
          }

          return this._localStreams;
        };
      }

      if (!('addStream' in window.RTCPeerConnection.prototype)) {
        var _addTrack = window.RTCPeerConnection.prototype.addTrack;

        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
          var _this = this;

          if (!this._localStreams) {
            this._localStreams = [];
          }

          if (!this._localStreams.includes(stream)) {
            this._localStreams.push(stream);
          } // Try to emulate Chrome's behaviour of adding in audio-video order.
          // Safari orders by track id.


          stream.getAudioTracks().forEach(function (track) {
            return _addTrack.call(_this, track, stream);
          });
          stream.getVideoTracks().forEach(function (track) {
            return _addTrack.call(_this, track, stream);
          });
        };

        window.RTCPeerConnection.prototype.addTrack = function addTrack(track) {
          var _this2 = this;

          for (var _len = arguments.length, streams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            streams[_key - 1] = arguments[_key];
          }

          if (streams) {
            streams.forEach(function (stream) {
              if (!_this2._localStreams) {
                _this2._localStreams = [stream];
              } else if (!_this2._localStreams.includes(stream)) {
                _this2._localStreams.push(stream);
              }
            });
          }

          return _addTrack.apply(this, arguments);
        };
      }

      if (!('removeStream' in window.RTCPeerConnection.prototype)) {
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
          var _this3 = this;

          if (!this._localStreams) {
            this._localStreams = [];
          }

          var index = this._localStreams.indexOf(stream);

          if (index === -1) {
            return;
          }

          this._localStreams.splice(index, 1);

          var tracks = stream.getTracks();
          this.getSenders().forEach(function (sender) {
            if (tracks.includes(sender.track)) {
              _this3.removeTrack(sender);
            }
          });
        };
      }
    }
    function shimRemoteStreamsAPI(window) {
      if (Object(esm_typeof["a" /* default */])(window) !== 'object' || !window.RTCPeerConnection) {
        return;
      }

      if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
        window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
          return this._remoteStreams ? this._remoteStreams : [];
        };
      }

      if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
          get: function get() {
            return this._onaddstream;
          },
          set: function set(f) {
            var _this4 = this;

            if (this._onaddstream) {
              this.removeEventListener('addstream', this._onaddstream);
              this.removeEventListener('track', this._onaddstreampoly);
            }

            this.addEventListener('addstream', this._onaddstream = f);
            this.addEventListener('track', this._onaddstreampoly = function (e) {
              e.streams.forEach(function (stream) {
                if (!_this4._remoteStreams) {
                  _this4._remoteStreams = [];
                }

                if (_this4._remoteStreams.includes(stream)) {
                  return;
                }

                _this4._remoteStreams.push(stream);

                var event = new Event('addstream');
                event.stream = stream;

                _this4.dispatchEvent(event);
              });
            });
          }
        });
        var origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;

        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
          var pc = this;

          if (!this._onaddstreampoly) {
            this.addEventListener('track', this._onaddstreampoly = function (e) {
              e.streams.forEach(function (stream) {
                if (!pc._remoteStreams) {
                  pc._remoteStreams = [];
                }

                if (pc._remoteStreams.indexOf(stream) >= 0) {
                  return;
                }

                pc._remoteStreams.push(stream);

                var event = new Event('addstream');
                event.stream = stream;
                pc.dispatchEvent(event);
              });
            });
          }

          return origSetRemoteDescription.apply(pc, arguments);
        };
      }
    }
    function shimCallbacksAPI(window) {
      if (Object(esm_typeof["a" /* default */])(window) !== 'object' || !window.RTCPeerConnection) {
        return;
      }

      var prototype = window.RTCPeerConnection.prototype;
      var origCreateOffer = prototype.createOffer;
      var origCreateAnswer = prototype.createAnswer;
      var setLocalDescription = prototype.setLocalDescription;
      var setRemoteDescription = prototype.setRemoteDescription;
      var addIceCandidate = prototype.addIceCandidate;

      prototype.createOffer = function createOffer(successCallback, failureCallback) {
        var options = arguments.length >= 2 ? arguments[2] : arguments[0];
        var promise = origCreateOffer.apply(this, [options]);

        if (!failureCallback) {
          return promise;
        }

        promise.then(successCallback, failureCallback);
        return Promise.resolve();
      };

      prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        var options = arguments.length >= 2 ? arguments[2] : arguments[0];
        var promise = origCreateAnswer.apply(this, [options]);

        if (!failureCallback) {
          return promise;
        }

        promise.then(successCallback, failureCallback);
        return Promise.resolve();
      };

      var withCallback = function withCallback(description, successCallback, failureCallback) {
        var promise = setLocalDescription.apply(this, [description]);

        if (!failureCallback) {
          return promise;
        }

        promise.then(successCallback, failureCallback);
        return Promise.resolve();
      };

      prototype.setLocalDescription = withCallback;

      withCallback = function withCallback(description, successCallback, failureCallback) {
        var promise = setRemoteDescription.apply(this, [description]);

        if (!failureCallback) {
          return promise;
        }

        promise.then(successCallback, failureCallback);
        return Promise.resolve();
      };

      prototype.setRemoteDescription = withCallback;

      withCallback = function withCallback(candidate, successCallback, failureCallback) {
        var promise = addIceCandidate.apply(this, [candidate]);

        if (!failureCallback) {
          return promise;
        }

        promise.then(successCallback, failureCallback);
        return Promise.resolve();
      };

      prototype.addIceCandidate = withCallback;
    }
    function safari_shim_shimGetUserMedia(window) {
      var navigator = window && window.navigator;

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        var mediaDevices = navigator.mediaDevices;

        var _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);

        navigator.mediaDevices.getUserMedia = function (constraints) {
          return _getUserMedia(shimConstraints(constraints));
        };
      }

      if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.getUserMedia = function getUserMedia(constraints, cb, errcb) {
          navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
        }.bind(navigator);
      }
    }
    function shimConstraints(constraints) {
      if (constraints && constraints.video !== undefined) {
        return Object.assign({}, constraints, {
          video: compactObject(constraints.video)
        });
      }

      return constraints;
    }
    function shimRTCIceServerUrls(window) {
      if (!window.RTCPeerConnection) {
        return;
      } // migrate from non-spec RTCIceServer.url to RTCIceServer.urls


      var OrigPeerConnection = window.RTCPeerConnection;

      window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
          var newIceServers = [];

          for (var i = 0; i < pcConfig.iceServers.length; i++) {
            var server = pcConfig.iceServers[i];

            if (!server.hasOwnProperty('urls') && server.hasOwnProperty('url')) {
              deprecated('RTCIceServer.url', 'RTCIceServer.urls');
              server = JSON.parse(JSON.stringify(server));
              server.urls = server.url;
              delete server.url;
              newIceServers.push(server);
            } else {
              newIceServers.push(pcConfig.iceServers[i]);
            }
          }

          pcConfig.iceServers = newIceServers;
        }

        return new OrigPeerConnection(pcConfig, pcConstraints);
      };

      window.RTCPeerConnection.prototype = OrigPeerConnection.prototype; // wrap static methods. Currently just generateCertificate.

      if ('generateCertificate' in OrigPeerConnection) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function get() {
            return OrigPeerConnection.generateCertificate;
          }
        });
      }
    }
    function shimTrackEventTransceiver(window) {
      // Add event.transceiver member over deprecated event.receiver
      if (Object(esm_typeof["a" /* default */])(window) === 'object' && window.RTCTrackEvent && 'receiver' in window.RTCTrackEvent.prototype && !('transceiver' in window.RTCTrackEvent.prototype)) {
        Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
          get: function get() {
            return {
              receiver: this.receiver
            };
          }
        });
      }
    }
    function shimCreateOfferLegacy(window) {
      var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;

      window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
          if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
            // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
          }

          var audioTransceiver = this.getTransceivers().find(function (transceiver) {
            return transceiver.receiver.track.kind === 'audio';
          });

          if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
            if (audioTransceiver.direction === 'sendrecv') {
              if (audioTransceiver.setDirection) {
                audioTransceiver.setDirection('sendonly');
              } else {
                audioTransceiver.direction = 'sendonly';
              }
            } else if (audioTransceiver.direction === 'recvonly') {
              if (audioTransceiver.setDirection) {
                audioTransceiver.setDirection('inactive');
              } else {
                audioTransceiver.direction = 'inactive';
              }
            }
          } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) {
            this.addTransceiver('audio');
          }

          if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
            // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
          }

          var videoTransceiver = this.getTransceivers().find(function (transceiver) {
            return transceiver.receiver.track.kind === 'video';
          });

          if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
            if (videoTransceiver.direction === 'sendrecv') {
              if (videoTransceiver.setDirection) {
                videoTransceiver.setDirection('sendonly');
              } else {
                videoTransceiver.direction = 'sendonly';
              }
            } else if (videoTransceiver.direction === 'recvonly') {
              if (videoTransceiver.setDirection) {
                videoTransceiver.setDirection('inactive');
              } else {
                videoTransceiver.direction = 'inactive';
              }
            }
          } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) {
            this.addTransceiver('video');
          }
        }

        return origCreateOffer.apply(this, arguments);
      };
    }
    function shimAudioContext(window) {
      if (Object(esm_typeof["a" /* default */])(window) !== 'object' || window.AudioContext) {
        return;
      }

      window.AudioContext = window.webkitAudioContext;
    }
    // CONCATENATED MODULE: ./src/misc/util.js
    var indempotent = function indempotent(action) {
      var called = false;
      var result = undefined;
      return function () {
        if (called) {
          return result;
        } else {
          result = action.apply(void 0, arguments);
          called = true;
          return result;
        }
      };
    };
    // CONCATENATED MODULE: ./src/misc/shimGetUserMedia.js


    /* harmony default export */var misc_shimGetUserMedia = indempotent(function () {
      var _detectBrowser = detectBrowser(window),
          browser = _detectBrowser.browser;

      switch (browser) {
        case "chrome":
          shimGetUserMedia(window);
          break;

        case "firefox":
          firefox_getusermedia_shimGetUserMedia(window);
          break;

        case "edge":
          getusermedia_shimGetUserMedia(window);
          break;

        case "safari":
          safari_shim_shimGetUserMedia(window);
          break;

        default:
          throw new errors["c" /* StreamApiNotSupportedError */]();
      }
    });
    // CONCATENATED MODULE: ./src/misc/camera.js


    var camera_Camera = /*#__PURE__*/function () {
      function Camera(videoEl, stream) {
        Object(classCallCheck["a" /* default */])(this, Camera);

        this.videoEl = videoEl;
        this.stream = stream;
      }

      _createClass(Camera, [{
        key: "stop",
        value: function stop() {
          var _this = this;

          this.videoEl.srcObject = null;
          this.stream.getTracks().forEach(function (track) {
            _this.stream.removeTrack(track);

            track.stop();
          });
        }
      }, {
        key: "getCapabilities",
        value: function getCapabilities() {
          var _track$getCapabilitie, _track$getCapabilitie2;

          var _this$stream$getVideo = this.stream.getVideoTracks(),
              _this$stream$getVideo2 = Object(slicedToArray["a" /* default */])(_this$stream$getVideo, 1),
              track = _this$stream$getVideo2[0]; // Firefox does not yet support getCapabilities as of August 2020


          return (_track$getCapabilitie = track === null || track === void 0 ? void 0 : (_track$getCapabilitie2 = track.getCapabilities) === null || _track$getCapabilitie2 === void 0 ? void 0 : _track$getCapabilitie2.call(track)) !== null && _track$getCapabilitie !== void 0 ? _track$getCapabilitie : {};
        }
      }]);

      return Camera;
    }(); // Modern phones often have multipe front/rear cameras.
    // Sometimes special purpose cameras like the wide-angle camera are picked
    // by default. Those are not optimal for scanning QR codes but standard
    // media constraints don't allow us to specify which camera we want exactly.


    var narrowDownFacingMode = /*#__PURE__*/function () {
      var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(camera) {
        var deviceBlackList, devices, frontCamera, rearCamera;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Filter some devices, known to be bad choices.
                deviceBlackList = ["OBS Virtual Camera", "OBS-Camera"];
                _context.next = 3;
                return navigator.mediaDevices.enumerateDevices();

              case 3:
                devices = _context.sent.filter(function (_ref2) {
                  var kind = _ref2.kind;
                  return kind === "videoinput";
                }).filter(function (_ref3) {
                  var label = _ref3.label;
                  return !deviceBlackList.includes(label);
                }).filter(function (_ref4) {
                  var label = _ref4.label;
                  return !label.includes("infrared");
                });

                if (!(devices.length > 2)) {
                  _context.next = 16;
                  break;
                }

                // Explicitly picking the first entry in the list of all videoinput
                // devices for as the default front camera and the last entry as the default
                // rear camera seems to be a good heuristic on some devices.
                frontCamera = devices[0];
                rearCamera = devices[devices.length - 1];
                _context.t0 = camera;
                _context.next = _context.t0 === "auto" ? 10 : _context.t0 === "rear" ? 11 : _context.t0 === "front" ? 12 : 13;
                break;

              case 10:
                return _context.abrupt("return", {
                  deviceId: {
                    exact: rearCamera.deviceId
                  }
                });

              case 11:
                return _context.abrupt("return", {
                  deviceId: {
                    exact: rearCamera.deviceId
                  }
                });

              case 12:
                return _context.abrupt("return", {
                  deviceId: {
                    exact: frontCamera.deviceId
                  }
                });

              case 13:
                return _context.abrupt("return", undefined);

              case 14:
                _context.next = 23;
                break;

              case 16:
                _context.t1 = camera;
                _context.next = _context.t1 === "auto" ? 19 : _context.t1 === "rear" ? 20 : _context.t1 === "front" ? 21 : 22;
                break;

              case 19:
                return _context.abrupt("return", {
                  facingMode: {
                    ideal: "environment"
                  }
                });

              case 20:
                return _context.abrupt("return", {
                  facingMode: {
                    exact: "environment"
                  }
                });

              case 21:
                return _context.abrupt("return", {
                  facingMode: {
                    exact: "user"
                  }
                });

              case 22:
                return _context.abrupt("return", undefined);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function narrowDownFacingMode(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    /* harmony default export */var misc_camera = function misc_camera(_x2, _x3) {
      return _ref6.apply(this, arguments);
    };

    function _ref6() {
      _ref6 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(videoEl, _ref5) {
        var _navigator, _navigator$mediaDevic;

        var camera, torch, constraints, stream, _stream$getVideoTrack, _stream$getVideoTrack2, track, capabilities;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                camera = _ref5.camera, torch = _ref5.torch;

                if (!(window.isSecureContext !== true)) {
                  _context2.next = 3;
                  break;
                }

                throw new errors["b" /* InsecureContextError */]();

              case 3:
                if (!(((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$mediaDevic = _navigator.mediaDevices) === null || _navigator$mediaDevic === void 0 ? void 0 : _navigator$mediaDevic.getUserMedia) === undefined)) {
                  _context2.next = 5;
                  break;
                }

                throw new errors["c" /* StreamApiNotSupportedError */]();

              case 5:
                _context2.next = 7;
                return misc_shimGetUserMedia();

              case 7:
                _context2.t0 = _objectSpread2;
                _context2.t1 = {
                  width: {
                    min: 360,
                    ideal: 640,
                    max: 1920
                  },
                  height: {
                    min: 240,
                    ideal: 480,
                    max: 1080
                  }
                };
                _context2.next = 11;
                return narrowDownFacingMode(camera);

              case 11:
                _context2.t2 = _context2.sent;
                _context2.t3 = (0, _context2.t0)(_context2.t1, _context2.t2);
                constraints = {
                  audio: false,
                  video: _context2.t3
                };
                _context2.next = 16;
                return navigator.mediaDevices.getUserMedia(constraints);

              case 16:
                stream = _context2.sent;

                if (videoEl.srcObject !== undefined) {
                  videoEl.srcObject = stream;
                } else if (videoEl.mozSrcObject !== undefined) {
                  videoEl.mozSrcObject = stream;
                } else if (window.URL.createObjectURL) {
                  videoEl.src = window.URL.createObjectURL(stream);
                } else if (window.webkitURL) {
                  videoEl.src = window.webkitURL.createObjectURL(stream);
                } else {
                  videoEl.src = stream;
                }

                _context2.next = 20;
                return Object(callforth["a" /* eventOn */])(videoEl, "loadeddata");

              case 20:
                _context2.next = 22;
                return Object(callforth["b" /* timeout */])(500);

              case 22:
                if (torch) {
                  _stream$getVideoTrack = stream.getVideoTracks(), _stream$getVideoTrack2 = Object(slicedToArray["a" /* default */])(_stream$getVideoTrack, 1), track = _stream$getVideoTrack2[0];
                  capabilities = track.getCapabilities();

                  if (capabilities.torch) {
                    track.applyConstraints({
                      advanced: [{
                        torch: true
                      }]
                    });
                  } else {
                    console.warn("device does not support torch capability");
                  }
                }

                return _context2.abrupt("return", new camera_Camera(videoEl, stream));

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _ref6.apply(this, arguments);
    }
    // EXTERNAL MODULE: ./src/mixins/CommonAPI.vue + 3 modules
    var CommonAPI = __webpack_require__("b3af");

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeStream.vue?vue&type=script&lang=js&


    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var QrcodeStreamvue_type_script_lang_js_ = {
      name: "qrcode-stream",
      mixins: [CommonAPI["a" /* default */]],
      props: {
        camera: {
          type: String,
          default: "auto",
          validator: function validator(camera) {
            return ["auto", "rear", "front", "off"].includes(camera);
          }
        },
        torch: {
          type: Boolean,
          default: false
        },
        track: {
          type: Function
        }
      },
      data: function data() {
        return {
          cameraInstance: null,
          destroyed: false
        };
      },
      computed: {
        shouldStream: function shouldStream() {
          return this.destroyed === false && this.camera !== "off";
        },
        shouldScan: function shouldScan() {
          return this.shouldStream === true && this.cameraInstance !== null;
        },

        /**
         * Minimum delay in milliseconds between frames to be scanned. Don't scan
         * so often when visual tracking is disabled to improve performance.
         */
        scanInterval: function scanInterval() {
          if (this.track === undefined) {
            return 500;
          } else {
            return 40; // ~ 25fps
          }
        }
      },
      watch: {
        shouldStream: function shouldStream(_shouldStream) {
          if (!_shouldStream) {
            var canvas = this.$refs.pauseFrame;
            var ctx = canvas.getContext("2d");
            var video = this.$refs.video;
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          }
        },
        shouldScan: function shouldScan(_shouldScan) {
          if (_shouldScan) {
            this.clearCanvas(this.$refs.pauseFrame);
            this.clearCanvas(this.$refs.trackingLayer);
            this.startScanning();
          }
        },
        torch: function torch() {
          this.init();
        },
        camera: function camera() {
          this.init();
        }
      },
      mounted: function mounted() {
        this.init();
      },
      beforeDestroy: function beforeDestroy() {
        this.beforeResetCamera();
        this.destroyed = true;
      },
      methods: {
        init: function init() {
          var _this = this;

          var promise = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var capabilities;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.beforeResetCamera();

                    if (!(_this.camera === "off")) {
                      _context.next = 6;
                      break;
                    }

                    _this.cameraInstance = null;
                    return _context.abrupt("return", {
                      capabilities: {}
                    });

                  case 6:
                    _context.next = 8;
                    return misc_camera(_this.$refs.video, {
                      camera: _this.camera,
                      torch: _this.torch
                    });

                  case 8:
                    _this.cameraInstance = _context.sent;
                    capabilities = _this.cameraInstance.getCapabilities(); // if the component is destroyed before `cameraInstance` resolves a
                    // `beforeDestroy` hook has no chance to clear the remaining camera
                    // stream.

                    if (_this.destroyed) {
                      _this.cameraInstance.stop();
                    }

                    return _context.abrupt("return", {
                      capabilities: capabilities
                    });

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }))();

          this.$emit("init", promise);
        },
        startScanning: function startScanning() {
          var _this2 = this;

          var detectHandler = function detectHandler(result) {
            _this2.onDetect(Promise.resolve(result));
          };

          Object(scanner["a" /* keepScanning */])(this.$refs.video, {
            detectHandler: detectHandler,
            locateHandler: this.onLocate,
            minDelay: this.scanInterval
          });
        },
        beforeResetCamera: function beforeResetCamera() {
          if (this.cameraInstance !== null) {
            this.cameraInstance.stop();
            this.cameraInstance = null;
          }
        },
        onLocate: function onLocate(detectedCodes) {
          var canvas = this.$refs.trackingLayer;
          var video = this.$refs.video;

          if (canvas !== undefined) {
            if (detectedCodes.length > 0 && this.track !== undefined && video !== undefined) {
              // The visually occupied area of the video element.
              // Because the component is responsive and fills the available space,
              // this can be more or less than the actual resolution of the camera.
              var _displayWidth = video.offsetWidth;
              var _displayHeight = video.offsetHeight; // The actual resolution of the camera.
              // These values are fixed no matter the screen size.

              var resolutionWidth = video.videoWidth;
              var resolutionHeight = video.videoHeight; // Dimensions of the video element as if there would be no
              //   object-fit: cover;
              // Thus, the ratio is the same as the cameras resolution but it's
              // scaled down to the size of the visually occupied area.

              var largerRatio = Math.max(_displayWidth / resolutionWidth, _displayHeight / resolutionHeight);
              var uncutWidth = resolutionWidth * largerRatio;
              var uncutHeight = resolutionHeight * largerRatio;
              var xScalar = uncutWidth / resolutionWidth;
              var yScalar = uncutHeight / resolutionHeight;
              var xOffset = (_displayWidth - uncutWidth) / 2;
              var yOffset = (_displayHeight - uncutHeight) / 2;

              var scale = function scale(_ref2) {
                var x = _ref2.x,
                    y = _ref2.y;
                return {
                  x: Math.floor(x * xScalar),
                  y: Math.floor(y * yScalar)
                };
              };

              var translate = function translate(_ref3) {
                var x = _ref3.x,
                    y = _ref3.y;
                return {
                  x: Math.floor(x + xOffset),
                  y: Math.floor(y + yOffset)
                };
              };

              var adjustedCodes = detectedCodes.map(function (detectedCode) {
                var boundingBox = detectedCode.boundingBox,
                    cornerPoints = detectedCode.cornerPoints;

                var _translate = translate(scale({
                  x: boundingBox.x,
                  y: boundingBox.y
                })),
                    x = _translate.x,
                    y = _translate.y;

                var _scale = scale({
                  x: boundingBox.width,
                  y: boundingBox.height
                }),
                    width = _scale.x,
                    height = _scale.y;

                return _objectSpread2(_objectSpread2({}, detectedCode), {}, {
                  cornerPoints: cornerPoints.map(function (point) {
                    return translate(scale(point));
                  }),
                  boundingBox: DOMRectReadOnly.fromRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                  })
                });
              });
              canvas.width = video.offsetWidth;
              canvas.height = video.offsetHeight;
              var ctx = canvas.getContext('2d');
              this.track(adjustedCodes, ctx);
            } else {
              this.clearCanvas(canvas);
            }
          }
        },
        repaintTrackingLayer: function repaintTrackingLayer(video, canvas, location) {
          var _this3 = this;

          var ctx = canvas.getContext("2d");
          window.requestAnimationFrame(function () {
            canvas.width = displayWidth;
            canvas.height = displayHeight;

            _this3.trackRepaintFunction(coordinatesAdjusted, ctx);
          });
        },
        clearCanvas: function clearCanvas(canvas) {
          var ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/QrcodeStream.vue?vue&type=script&lang=js&
    /* harmony default export */var components_QrcodeStreamvue_type_script_lang_js_ = QrcodeStreamvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./src/components/QrcodeStream.vue?vue&type=style&index=0&id=35411cc1&lang=css&scoped=true&
    var QrcodeStreamvue_type_style_index_0_id_35411cc1_lang_css_scoped_true_ = __webpack_require__("15fd");

    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__("2877");

    // CONCATENATED MODULE: ./src/components/QrcodeStream.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(components_QrcodeStreamvue_type_script_lang_js_, render, staticRenderFns, false, null, "35411cc1", null);

    /* harmony default export */var QrcodeStream = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/"0d3b":
  /***/function d3b(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");
    var wellKnownSymbol = __webpack_require__("b622");
    var IS_PURE = __webpack_require__("c430");

    var ITERATOR = wellKnownSymbol('iterator');

    module.exports = !fails(function () {
      var url = new URL('b?a=1&b=2&c=3', 'http://a');
      var searchParams = url.searchParams;
      var result = '';
      url.pathname = 'c%20d';
      searchParams.forEach(function (value, key) {
        searchParams['delete']('b');
        result += key + value;
      });
      return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== 'http://a/c%20d?a=1&c=3' || searchParams.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !searchParams[ITERATOR]
      // throws in Edge
      || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
      // not punycoded in Edge
      || new URL('http://тест').host !== 'xn--e1aybc'
      // not escaped in Chrome 62-
      || new URL('http://a#б').hash !== '#%D0%B1'
      // fails in Chrome 66-
      || result !== 'a1c3'
      // throws in Safari
      || new URL('http://x', undefined).host !== 'x';
    });

    /***/
  },

  /***/"131a":
  /***/function a(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var setPrototypeOf = __webpack_require__("d2bb");

    // `Object.setPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.setprototypeof
    $({ target: 'Object', stat: true }, {
      setPrototypeOf: setPrototypeOf
    });

    /***/
  },

  /***/"13d5":
  /***/function d5(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $reduce = __webpack_require__("d58f").left;
    var arrayMethodIsStrict = __webpack_require__("a640");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var STRICT_METHOD = arrayMethodIsStrict('reduce');
    var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

    // `Array.prototype.reduce` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
    $({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
      reduce: function reduce(callbackfn /* , initialValue */) {
        return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"14c3":
  /***/function c3(module, exports, __webpack_require__) {

    var classof = __webpack_require__("c6b6");
    var regexpExec = __webpack_require__("9263");

    // `RegExpExec` abstract operation
    // https://tc39.github.io/ecma262/#sec-regexpexec
    module.exports = function (R, S) {
      var exec = R.exec;
      if (typeof exec === 'function') {
        var result = exec.call(R, S);
        if ((typeof result === 'undefined' ? 'undefined' : _typeof2(result)) !== 'object') {
          throw TypeError('RegExp exec method returned something other than an Object or null');
        }
        return result;
      }

      if (classof(R) !== 'RegExp') {
        throw TypeError('RegExp#exec called on incompatible receiver');
      }

      return regexpExec.call(R, S);
    };

    /***/
  },

  /***/"159b":
  /***/function b(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var DOMIterables = __webpack_require__("fdbc");
    var forEach = __webpack_require__("17c2");
    var createNonEnumerableProperty = __webpack_require__("9112");

    for (var COLLECTION_NAME in DOMIterables) {
      var Collection = global[COLLECTION_NAME];
      var CollectionPrototype = Collection && Collection.prototype;
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
        createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
      } catch (error) {
        CollectionPrototype.forEach = forEach;
      }
    }

    /***/
  },

  /***/"15fd":
  /***/function fd(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony import */
    var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QrcodeStream_vue_vue_type_style_index_0_id_35411cc1_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1d20");
    /* harmony import */var _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QrcodeStream_vue_vue_type_style_index_0_id_35411cc1_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QrcodeStream_vue_vue_type_style_index_0_id_35411cc1_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
    /* unused harmony reexport * */
    /* unused harmony default export */var _unused_webpack_default_export = _node_modules_vue_style_loader_index_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QrcodeStream_vue_vue_type_style_index_0_id_35411cc1_lang_css_scoped_true___WEBPACK_IMPORTED_MODULE_0___default.a;

    /***/
  },

  /***/"17c2":
  /***/function c2(module, exports, __webpack_require__) {

    "use strict";

    var $forEach = __webpack_require__("b727").forEach;
    var arrayMethodIsStrict = __webpack_require__("a640");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var STRICT_METHOD = arrayMethodIsStrict('forEach');
    var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

    // `Array.prototype.forEach` method implementation
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    module.exports = !STRICT_METHOD || !USES_TO_LENGTH ? function forEach(callbackfn /* , thisArg */) {
      return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    } : [].forEach;

    /***/
  },

  /***/"19aa":
  /***/function aa(module, exports) {

    module.exports = function (it, Constructor, name) {
      if (!(it instanceof Constructor)) {
        throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
      }return it;
    };

    /***/
  },

  /***/"1be4":
  /***/function be4(module, exports, __webpack_require__) {

    var getBuiltIn = __webpack_require__("d066");

    module.exports = getBuiltIn('document', 'documentElement');

    /***/
  },

  /***/"1c0b":
  /***/function c0b(module, exports) {

    module.exports = function (it) {
      if (typeof it != 'function') {
        throw TypeError(String(it) + ' is not a function');
      }return it;
    };

    /***/
  },

  /***/"1c7e":
  /***/function c7e(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");

    var ITERATOR = wellKnownSymbol('iterator');
    var SAFE_CLOSING = false;

    try {
      var called = 0;
      var iteratorWithReturn = {
        next: function next() {
          return { done: !!called++ };
        },
        'return': function _return() {
          SAFE_CLOSING = true;
        }
      };
      iteratorWithReturn[ITERATOR] = function () {
        return this;
      };
      // eslint-disable-next-line no-throw-literal
      Array.from(iteratorWithReturn, function () {
        throw 2;
      });
    } catch (error) {/* empty */}

    module.exports = function (exec, SKIP_CLOSING) {
      if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
      var ITERATION_SUPPORT = false;
      try {
        var object = {};
        object[ITERATOR] = function () {
          return {
            next: function next() {
              return { done: ITERATION_SUPPORT = true };
            }
          };
        };
        exec(object);
      } catch (error) {/* empty */}
      return ITERATION_SUPPORT;
    };

    /***/
  },

  /***/"1cc0":
  /***/function cc0(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // EXPORTS

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return (/* binding */errors_DropImageFetchError
      );
    });
    __webpack_require__.d(__webpack_exports__, "c", function () {
      return (/* binding */errors_StreamApiNotSupportedError
      );
    });
    __webpack_require__.d(__webpack_exports__, "b", function () {
      return (/* binding */errors_InsecureContextError
      );
    });

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
    var es_function_name = __webpack_require__("b0c0");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
    var classCallCheck = __webpack_require__("d4ec");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
    var es_object_set_prototype_of = __webpack_require__("131a");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
    var es_reflect_construct = __webpack_require__("4ae1");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
    var es_object_get_prototype_of = __webpack_require__("3410");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js


    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
    var es_object_to_string = __webpack_require__("d3b7");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
    var es_regexp_to_string = __webpack_require__("25f0");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js


    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
    var esm_typeof = __webpack_require__("53ca");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


    function _possibleConstructorReturn(self, call) {
      if (call && (Object(esm_typeof["a" /* default */])(call) === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js


    function _createSuper(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct();
      return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;

        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf(this).constructor;
          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }

        return _possibleConstructorReturn(this, result);
      };
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
    var es_array_iterator = __webpack_require__("e260");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.map.js
    var es_map = __webpack_require__("4ec9");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
    var es_string_iterator = __webpack_require__("3ca3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
    var web_dom_collections_iterator = __webpack_require__("ddb0");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
    var es_array_index_of = __webpack_require__("c975");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js


    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/construct.js


    function construct_construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        construct_construct = Reflect.construct;
      } else {
        construct_construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return construct_construct.apply(null, arguments);
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js


    function wrapNativeSuper_wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return construct_construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return wrapNativeSuper_wrapNativeSuper(Class);
    }
    // CONCATENATED MODULE: ./src/misc/errors.js


    var errors_DropImageFetchError = /*#__PURE__*/function (_Error) {
      _inherits(DropImageFetchError, _Error);

      var _super = _createSuper(DropImageFetchError);

      function DropImageFetchError() {
        var _this;

        Object(classCallCheck["a" /* default */])(this, DropImageFetchError);

        _this = _super.call(this, "can't process cross-origin image");
        _this.name = "DropImageFetchError";
        return _this;
      }

      return DropImageFetchError;
    }( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));
    var errors_StreamApiNotSupportedError = /*#__PURE__*/function (_Error2) {
      _inherits(StreamApiNotSupportedError, _Error2);

      var _super2 = _createSuper(StreamApiNotSupportedError);

      function StreamApiNotSupportedError() {
        var _this2;

        Object(classCallCheck["a" /* default */])(this, StreamApiNotSupportedError);

        _this2 = _super2.call(this, "this browser has no Stream API support");
        _this2.name = "StreamApiNotSupportedError";
        return _this2;
      }

      return StreamApiNotSupportedError;
    }( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));
    var errors_InsecureContextError = /*#__PURE__*/function (_Error3) {
      _inherits(InsecureContextError, _Error3);

      var _super3 = _createSuper(InsecureContextError);

      function InsecureContextError() {
        var _this3;

        Object(classCallCheck["a" /* default */])(this, InsecureContextError);

        _this3 = _super3.call(this, "camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.");
        _this3.name = "InsecureContextError";
        return _this3;
      }

      return InsecureContextError;
    }( /*#__PURE__*/wrapNativeSuper_wrapNativeSuper(Error));

    /***/
  },

  /***/"1cdc":
  /***/function cdc(module, exports, __webpack_require__) {

    var userAgent = __webpack_require__("342f");

    module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);

    /***/
  },

  /***/"1d20":
  /***/function d20(module, exports, __webpack_require__) {

    // style-loader: Adds some css to the DOM by adding a <style> tag

    // load the styles
    var content = __webpack_require__("7260");
    if (typeof content === 'string') content = [[module.i, content, '']];
    if (content.locals) module.exports = content.locals;
    // add the styles to the DOM
    var add = __webpack_require__("499e").default;
    var update = add("22ae7e38", content, true, { "sourceMap": false, "shadowMode": false });

    /***/
  },

  /***/"1d80":
  /***/function d80(module, exports) {

    // `RequireObjectCoercible` abstract operation
    // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
    module.exports = function (it) {
      if (it == undefined) throw TypeError("Can't call method on " + it);
      return it;
    };

    /***/
  },

  /***/"1da1":
  /***/function da1(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _asyncToGenerator;
    });
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3b7");
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e6cf");
    /* harmony import */var core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise__WEBPACK_IMPORTED_MODULE_1__);

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    /***/
  },

  /***/"1dde":
  /***/function dde(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");
    var wellKnownSymbol = __webpack_require__("b622");
    var V8_VERSION = __webpack_require__("2d00");

    var SPECIES = wellKnownSymbol('species');

    module.exports = function (METHOD_NAME) {
      // We can't use this feature detection in V8 since it causes
      // deoptimization and serious performance degradation
      // https://github.com/zloirock/core-js/issues/677
      return V8_VERSION >= 51 || !fails(function () {
        var array = [];
        var constructor = array.constructor = {};
        constructor[SPECIES] = function () {
          return { foo: 1 };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
      });
    };

    /***/
  },

  /***/"2266":
  /***/function _(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var isArrayIteratorMethod = __webpack_require__("e95a");
    var toLength = __webpack_require__("50c4");
    var bind = __webpack_require__("0366");
    var getIteratorMethod = __webpack_require__("35a1");
    var callWithSafeIterationClosing = __webpack_require__("9bdd");

    var Result = function Result(stopped, result) {
      this.stopped = stopped;
      this.result = result;
    };

    var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
      var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
      var iterator, iterFn, index, length, result, next, step;

      if (IS_ITERATOR) {
        iterator = iterable;
      } else {
        iterFn = getIteratorMethod(iterable);
        if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
        // optimisation for array iterators
        if (isArrayIteratorMethod(iterFn)) {
          for (index = 0, length = toLength(iterable.length); length > index; index++) {
            result = AS_ENTRIES ? boundFunction(anObject(step = iterable[index])[0], step[1]) : boundFunction(iterable[index]);
            if (result && result instanceof Result) return result;
          }return new Result(false);
        }
        iterator = iterFn.call(iterable);
      }

      next = iterator.next;
      while (!(step = next.call(iterator)).done) {
        result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
        if ((typeof result === 'undefined' ? 'undefined' : _typeof2(result)) == 'object' && result && result instanceof Result) return result;
      }return new Result(false);
    };

    iterate.stop = function (result) {
      return new Result(true, result);
    };

    /***/
  },

  /***/"23cb":
  /***/function cb(module, exports, __webpack_require__) {

    var toInteger = __webpack_require__("a691");

    var max = Math.max;
    var min = Math.min;

    // Helper for a popular repeating case of the spec:
    // Let integer be ? ToInteger(index).
    // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
    module.exports = function (index, length) {
      var integer = toInteger(index);
      return integer < 0 ? max(integer + length, 0) : min(integer, length);
    };

    /***/
  },

  /***/"23e7":
  /***/function e7(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
    var createNonEnumerableProperty = __webpack_require__("9112");
    var redefine = __webpack_require__("6eeb");
    var setGlobal = __webpack_require__("ce4e");
    var copyConstructorProperties = __webpack_require__("e893");
    var isForced = __webpack_require__("94ca");

    /*
      options.target      - name of the target object
      options.global      - target is the global object
      options.stat        - export as static methods of target
      options.proto       - export as prototype methods of target
      options.real        - real prototype method for the `pure` version
      options.forced      - export even if the native feature is available
      options.bind        - bind methods to the target, required for the `pure` version
      options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
      options.unsafe      - use the simple assignment of property instead of delete + defineProperty
      options.sham        - add a flag to not completely full polyfills
      options.enumerable  - export as enumerable property
      options.noTargetGet - prevent calling a getter on target
    */
    module.exports = function (options, source) {
      var TARGET = options.target;
      var GLOBAL = options.global;
      var STATIC = options.stat;
      var FORCED, target, key, targetProperty, sourceProperty, descriptor;
      if (GLOBAL) {
        target = global;
      } else if (STATIC) {
        target = global[TARGET] || setGlobal(TARGET, {});
      } else {
        target = (global[TARGET] || {}).prototype;
      }
      if (target) for (key in source) {
        sourceProperty = source[key];
        if (options.noTargetGet) {
          descriptor = getOwnPropertyDescriptor(target, key);
          targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
          if ((typeof sourceProperty === 'undefined' ? 'undefined' : _typeof2(sourceProperty)) === (typeof targetProperty === 'undefined' ? 'undefined' : _typeof2(targetProperty))) continue;
          copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) {
          createNonEnumerableProperty(sourceProperty, 'sham', true);
        }
        // extend global
        redefine(target, key, sourceProperty, options);
      }
    };

    /***/
  },

  /***/"241c":
  /***/function c(module, exports, __webpack_require__) {

    var internalObjectKeys = __webpack_require__("ca84");
    var enumBugKeys = __webpack_require__("7839");

    var hiddenKeys = enumBugKeys.concat('length', 'prototype');

    // `Object.getOwnPropertyNames` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return internalObjectKeys(O, hiddenKeys);
    };

    /***/
  },

  /***/"24fb":
  /***/function fb(module, exports, __webpack_require__) {

    "use strict";

    /*
      MIT License http://www.opensource.org/licenses/mit-license.php
      Author Tobias Koppers @sokra
    */
    // css base code, injected by the css-loader
    // eslint-disable-next-line func-names

    module.exports = function (useSourceMap) {
      var list = []; // return the list of modules as css string

      list.toString = function toString() {
        return this.map(function (item) {
          var content = cssWithMappingToString(item, useSourceMap);

          if (item[2]) {
            return "@media ".concat(item[2], " {").concat(content, "}");
          }

          return content;
        }).join('');
      }; // import a list of modules into the list
      // eslint-disable-next-line func-names


      list.i = function (modules, mediaQuery, dedupe) {
        if (typeof modules === 'string') {
          // eslint-disable-next-line no-param-reassign
          modules = [[null, modules, '']];
        }

        var alreadyImportedModules = {};

        if (dedupe) {
          for (var i = 0; i < this.length; i++) {
            // eslint-disable-next-line prefer-destructuring
            var id = this[i][0];

            if (id != null) {
              alreadyImportedModules[id] = true;
            }
          }
        }

        for (var _i = 0; _i < modules.length; _i++) {
          var item = [].concat(modules[_i]);

          if (dedupe && alreadyImportedModules[item[0]]) {
            // eslint-disable-next-line no-continue
            continue;
          }

          if (mediaQuery) {
            if (!item[2]) {
              item[2] = mediaQuery;
            } else {
              item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
            }
          }

          list.push(item);
        }
      };

      return list;
    };

    function cssWithMappingToString(item, useSourceMap) {
      var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

      var cssMapping = item[3];

      if (!cssMapping) {
        return content;
      }

      if (useSourceMap && typeof btoa === 'function') {
        var sourceMapping = toComment(cssMapping);
        var sourceURLs = cssMapping.sources.map(function (source) {
          return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
        });
        return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
      }

      return [content].join('\n');
    } // Adapted from convert-source-map (MIT)


    function toComment(sourceMap) {
      // eslint-disable-next-line no-undef
      var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
      var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
      return "/*# ".concat(data, " */");
    }

    /***/
  },

  /***/"2532":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var notARegExp = __webpack_require__("5a34");
    var requireObjectCoercible = __webpack_require__("1d80");
    var correctIsRegExpLogic = __webpack_require__("ab13");

    // `String.prototype.includes` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.includes
    $({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
      includes: function includes(searchString /* , position = 0 */) {
        return !!~String(requireObjectCoercible(this)).indexOf(notARegExp(searchString), arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"25f0":
  /***/function f0(module, exports, __webpack_require__) {

    "use strict";

    var redefine = __webpack_require__("6eeb");
    var anObject = __webpack_require__("825a");
    var fails = __webpack_require__("d039");
    var flags = __webpack_require__("ad6d");

    var TO_STRING = 'toString';
    var RegExpPrototype = RegExp.prototype;
    var nativeToString = RegExpPrototype[TO_STRING];

    var NOT_GENERIC = fails(function () {
      return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b';
    });
    // FF44- RegExp#toString has a wrong name
    var INCORRECT_NAME = nativeToString.name != TO_STRING;

    // `RegExp.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
    if (NOT_GENERIC || INCORRECT_NAME) {
      redefine(RegExp.prototype, TO_STRING, function toString() {
        var R = anObject(this);
        var p = String(R.source);
        var rf = R.flags;
        var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
        return '/' + p + '/' + f;
      }, { unsafe: true });
    }

    /***/
  },

  /***/"2626":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var getBuiltIn = __webpack_require__("d066");
    var definePropertyModule = __webpack_require__("9bf2");
    var wellKnownSymbol = __webpack_require__("b622");
    var DESCRIPTORS = __webpack_require__("83ab");

    var SPECIES = wellKnownSymbol('species');

    module.exports = function (CONSTRUCTOR_NAME) {
      var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
      var defineProperty = definePropertyModule.f;

      if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
        defineProperty(Constructor, SPECIES, {
          configurable: true,
          get: function get() {
            return this;
          }
        });
      }
    };

    /***/
  },

  /***/"2877":
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return normalizeComponent;
    });
    /* globals __VUE_SSR_CONTEXT__ */

    // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
    // This module is a runtime utility for cleaner component module output and will
    // be included in the final webpack user bundle.

    function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */
    shadowMode /* vue-cli only */
    ) {
      // Vue.extend constructor export interop
      var options = typeof scriptExports === 'function' ? scriptExports.options : scriptExports;

      // render functions
      if (render) {
        options.render = render;
        options.staticRenderFns = staticRenderFns;
        options._compiled = true;
      }

      // functional template
      if (functionalTemplate) {
        options.functional = true;
      }

      // scopedId
      if (scopeId) {
        options._scopeId = 'data-v-' + scopeId;
      }

      var hook;
      if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
          // 2.3 injection
          context = context || // cached call
          this.$vnode && this.$vnode.ssrContext || // stateful
          this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__;
          }
          // inject component styles
          if (injectStyles) {
            injectStyles.call(this, context);
          }
          // register component module identifier for async chunk inferrence
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier);
          }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
      } else if (injectStyles) {
        hook = shadowMode ? function () {
          injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
        } : injectStyles;
      }

      if (hook) {
        if (options.functional) {
          // for template-only hot-reload because in that case the render fn doesn't
          // go through the normalizer
          options._injectStyles = hook;
          // register for functional component in vue file
          var originalRender = options.render;
          options.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context);
          };
        } else {
          // inject component registration as beforeCreate hook
          var existing = options.beforeCreate;
          options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }

      return {
        exports: scriptExports,
        options: options
      };
    }

    /***/
  },

  /***/"2909":
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // EXPORTS

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return (/* binding */_toConsumableArray
      );
    });

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
    var arrayLikeToArray = __webpack_require__("6b75");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return Object(arrayLikeToArray["a" /* default */])(arr);
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
    var es_symbol = __webpack_require__("a4d3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
    var es_symbol_description = __webpack_require__("e01a");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
    var es_symbol_iterator = __webpack_require__("d28b");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
    var es_array_from = __webpack_require__("a630");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
    var es_array_iterator = __webpack_require__("e260");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
    var es_object_to_string = __webpack_require__("d3b7");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
    var es_string_iterator = __webpack_require__("3ca3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
    var web_dom_collections_iterator = __webpack_require__("ddb0");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js


    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
    var unsupportedIterableToArray = __webpack_require__("06c5");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js


    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || Object(unsupportedIterableToArray["a" /* default */])(arr) || _nonIterableSpread();
    }

    /***/
  },

  /***/"2b3d":
  /***/function b3d(module, exports, __webpack_require__) {

    "use strict";

    // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

    __webpack_require__("3ca3");
    var $ = __webpack_require__("23e7");
    var DESCRIPTORS = __webpack_require__("83ab");
    var USE_NATIVE_URL = __webpack_require__("0d3b");
    var global = __webpack_require__("da84");
    var defineProperties = __webpack_require__("37e8");
    var redefine = __webpack_require__("6eeb");
    var anInstance = __webpack_require__("19aa");
    var has = __webpack_require__("5135");
    var assign = __webpack_require__("60da");
    var arrayFrom = __webpack_require__("4df4");
    var codeAt = __webpack_require__("6547").codeAt;
    var toASCII = __webpack_require__("5fb2");
    var setToStringTag = __webpack_require__("d44e");
    var URLSearchParamsModule = __webpack_require__("9861");
    var InternalStateModule = __webpack_require__("69f3");

    var NativeURL = global.URL;
    var URLSearchParams = URLSearchParamsModule.URLSearchParams;
    var getInternalSearchParamsState = URLSearchParamsModule.getState;
    var setInternalState = InternalStateModule.set;
    var getInternalURLState = InternalStateModule.getterFor('URL');
    var floor = Math.floor;
    var pow = Math.pow;

    var INVALID_AUTHORITY = 'Invalid authority';
    var INVALID_SCHEME = 'Invalid scheme';
    var INVALID_HOST = 'Invalid host';
    var INVALID_PORT = 'Invalid port';

    var ALPHA = /[A-Za-z]/;
    var ALPHANUMERIC = /[\d+-.A-Za-z]/;
    var DIGIT = /\d/;
    var HEX_START = /^(0x|0X)/;
    var OCT = /^[0-7]+$/;
    var DEC = /^\d+$/;
    var HEX = /^[\dA-Fa-f]+$/;
    // eslint-disable-next-line no-control-regex
    var FORBIDDEN_HOST_CODE_POINT = /[\u0000\u0009\u000A\u000D #%/:?@[\\]]/;
    // eslint-disable-next-line no-control-regex
    var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\u0009\u000A\u000D #/:?@[\\]]/;
    // eslint-disable-next-line no-control-regex
    var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
    // eslint-disable-next-line no-control-regex
    var TAB_AND_NEW_LINE = /[\u0009\u000A\u000D]/g;
    var EOF;

    var parseHost = function parseHost(url, input) {
      var result, codePoints, index;
      if (input.charAt(0) == '[') {
        if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
        result = parseIPv6(input.slice(1, -1));
        if (!result) return INVALID_HOST;
        url.host = result;
        // opaque host
      } else if (!isSpecial(url)) {
        if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
        result = '';
        codePoints = arrayFrom(input);
        for (index = 0; index < codePoints.length; index++) {
          result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
        }
        url.host = result;
      } else {
        input = toASCII(input);
        if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
        result = parseIPv4(input);
        if (result === null) return INVALID_HOST;
        url.host = result;
      }
    };

    var parseIPv4 = function parseIPv4(input) {
      var parts = input.split('.');
      var partsLength, numbers, index, part, radix, number, ipv4;
      if (parts.length && parts[parts.length - 1] == '') {
        parts.pop();
      }
      partsLength = parts.length;
      if (partsLength > 4) return input;
      numbers = [];
      for (index = 0; index < partsLength; index++) {
        part = parts[index];
        if (part == '') return input;
        radix = 10;
        if (part.length > 1 && part.charAt(0) == '0') {
          radix = HEX_START.test(part) ? 16 : 8;
          part = part.slice(radix == 8 ? 1 : 2);
        }
        if (part === '') {
          number = 0;
        } else {
          if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
          number = parseInt(part, radix);
        }
        numbers.push(number);
      }
      for (index = 0; index < partsLength; index++) {
        number = numbers[index];
        if (index == partsLength - 1) {
          if (number >= pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
      }
      ipv4 = numbers.pop();
      for (index = 0; index < numbers.length; index++) {
        ipv4 += numbers[index] * pow(256, 3 - index);
      }
      return ipv4;
    };

    // eslint-disable-next-line max-statements
    var parseIPv6 = function parseIPv6(input) {
      var address = [0, 0, 0, 0, 0, 0, 0, 0];
      var pieceIndex = 0;
      var compress = null;
      var pointer = 0;
      var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

      var char = function char() {
        return input.charAt(pointer);
      };

      if (char() == ':') {
        if (input.charAt(1) != ':') return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
      }
      while (char()) {
        if (pieceIndex == 8) return;
        if (char() == ':') {
          if (compress !== null) return;
          pointer++;
          pieceIndex++;
          compress = pieceIndex;
          continue;
        }
        value = length = 0;
        while (length < 4 && HEX.test(char())) {
          value = value * 16 + parseInt(char(), 16);
          pointer++;
          length++;
        }
        if (char() == '.') {
          if (length == 0) return;
          pointer -= length;
          if (pieceIndex > 6) return;
          numbersSeen = 0;
          while (char()) {
            ipv4Piece = null;
            if (numbersSeen > 0) {
              if (char() == '.' && numbersSeen < 4) pointer++;else return;
            }
            if (!DIGIT.test(char())) return;
            while (DIGIT.test(char())) {
              number = parseInt(char(), 10);
              if (ipv4Piece === null) ipv4Piece = number;else if (ipv4Piece == 0) return;else ipv4Piece = ipv4Piece * 10 + number;
              if (ipv4Piece > 255) return;
              pointer++;
            }
            address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
            numbersSeen++;
            if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
          }
          if (numbersSeen != 4) return;
          break;
        } else if (char() == ':') {
          pointer++;
          if (!char()) return;
        } else if (char()) return;
        address[pieceIndex++] = value;
      }
      if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while (pieceIndex != 0 && swaps > 0) {
          swap = address[pieceIndex];
          address[pieceIndex--] = address[compress + swaps - 1];
          address[compress + --swaps] = swap;
        }
      } else if (pieceIndex != 8) return;
      return address;
    };

    var findLongestZeroSequence = function findLongestZeroSequence(ipv6) {
      var maxIndex = null;
      var maxLength = 1;
      var currStart = null;
      var currLength = 0;
      var index = 0;
      for (; index < 8; index++) {
        if (ipv6[index] !== 0) {
          if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
          }
          currStart = null;
          currLength = 0;
        } else {
          if (currStart === null) currStart = index;
          ++currLength;
        }
      }
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      return maxIndex;
    };

    var serializeHost = function serializeHost(host) {
      var result, index, compress, ignore0;
      // ipv4
      if (typeof host == 'number') {
        result = [];
        for (index = 0; index < 4; index++) {
          result.unshift(host % 256);
          host = floor(host / 256);
        }return result.join('.');
        // ipv6
      } else if ((typeof host === 'undefined' ? 'undefined' : _typeof2(host)) == 'object') {
        result = '';
        compress = findLongestZeroSequence(host);
        for (index = 0; index < 8; index++) {
          if (ignore0 && host[index] === 0) continue;
          if (ignore0) ignore0 = false;
          if (compress === index) {
            result += index ? ':' : '::';
            ignore0 = true;
          } else {
            result += host[index].toString(16);
            if (index < 7) result += ':';
          }
        }
        return '[' + result + ']';
      }return host;
    };

    var C0ControlPercentEncodeSet = {};
    var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
      ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
    });
    var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
      '#': 1, '?': 1, '{': 1, '}': 1
    });
    var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
      '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
    });

    var percentEncode = function percentEncode(char, set) {
      var code = codeAt(char, 0);
      return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
    };

    var specialSchemes = {
      ftp: 21,
      file: null,
      http: 80,
      https: 443,
      ws: 80,
      wss: 443
    };

    var isSpecial = function isSpecial(url) {
      return has(specialSchemes, url.scheme);
    };

    var includesCredentials = function includesCredentials(url) {
      return url.username != '' || url.password != '';
    };

    var cannotHaveUsernamePasswordPort = function cannotHaveUsernamePasswordPort(url) {
      return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
    };

    var isWindowsDriveLetter = function isWindowsDriveLetter(string, normalized) {
      var second;
      return string.length == 2 && ALPHA.test(string.charAt(0)) && ((second = string.charAt(1)) == ':' || !normalized && second == '|');
    };

    var startsWithWindowsDriveLetter = function startsWithWindowsDriveLetter(string) {
      var third;
      return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (string.length == 2 || (third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#');
    };

    var shortenURLsPath = function shortenURLsPath(url) {
      var path = url.path;
      var pathSize = path.length;
      if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
        path.pop();
      }
    };

    var isSingleDot = function isSingleDot(segment) {
      return segment === '.' || segment.toLowerCase() === '%2e';
    };

    var isDoubleDot = function isDoubleDot(segment) {
      segment = segment.toLowerCase();
      return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
    };

    // States:
    var SCHEME_START = {};
    var SCHEME = {};
    var NO_SCHEME = {};
    var SPECIAL_RELATIVE_OR_AUTHORITY = {};
    var PATH_OR_AUTHORITY = {};
    var RELATIVE = {};
    var RELATIVE_SLASH = {};
    var SPECIAL_AUTHORITY_SLASHES = {};
    var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
    var AUTHORITY = {};
    var HOST = {};
    var HOSTNAME = {};
    var PORT = {};
    var FILE = {};
    var FILE_SLASH = {};
    var FILE_HOST = {};
    var PATH_START = {};
    var PATH = {};
    var CANNOT_BE_A_BASE_URL_PATH = {};
    var QUERY = {};
    var FRAGMENT = {};

    // eslint-disable-next-line max-statements
    var parseURL = function parseURL(url, input, stateOverride, base) {
      var state = stateOverride || SCHEME_START;
      var pointer = 0;
      var buffer = '';
      var seenAt = false;
      var seenBracket = false;
      var seenPasswordToken = false;
      var codePoints, char, bufferCodePoints, failure;

      if (!stateOverride) {
        url.scheme = '';
        url.username = '';
        url.password = '';
        url.host = null;
        url.port = null;
        url.path = [];
        url.query = null;
        url.fragment = null;
        url.cannotBeABaseURL = false;
        input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
      }

      input = input.replace(TAB_AND_NEW_LINE, '');

      codePoints = arrayFrom(input);

      while (pointer <= codePoints.length) {
        char = codePoints[pointer];
        switch (state) {
          case SCHEME_START:
            if (char && ALPHA.test(char)) {
              buffer += char.toLowerCase();
              state = SCHEME;
            } else if (!stateOverride) {
              state = NO_SCHEME;
              continue;
            } else return INVALID_SCHEME;
            break;

          case SCHEME:
            if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
              buffer += char.toLowerCase();
            } else if (char == ':') {
              if (stateOverride && (isSpecial(url) != has(specialSchemes, buffer) || buffer == 'file' && (includesCredentials(url) || url.port !== null) || url.scheme == 'file' && !url.host)) return;
              url.scheme = buffer;
              if (stateOverride) {
                if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
                return;
              }
              buffer = '';
              if (url.scheme == 'file') {
                state = FILE;
              } else if (isSpecial(url) && base && base.scheme == url.scheme) {
                state = SPECIAL_RELATIVE_OR_AUTHORITY;
              } else if (isSpecial(url)) {
                state = SPECIAL_AUTHORITY_SLASHES;
              } else if (codePoints[pointer + 1] == '/') {
                state = PATH_OR_AUTHORITY;
                pointer++;
              } else {
                url.cannotBeABaseURL = true;
                url.path.push('');
                state = CANNOT_BE_A_BASE_URL_PATH;
              }
            } else if (!stateOverride) {
              buffer = '';
              state = NO_SCHEME;
              pointer = 0;
              continue;
            } else return INVALID_SCHEME;
            break;

          case NO_SCHEME:
            if (!base || base.cannotBeABaseURL && char != '#') return INVALID_SCHEME;
            if (base.cannotBeABaseURL && char == '#') {
              url.scheme = base.scheme;
              url.path = base.path.slice();
              url.query = base.query;
              url.fragment = '';
              url.cannotBeABaseURL = true;
              state = FRAGMENT;
              break;
            }
            state = base.scheme == 'file' ? FILE : RELATIVE;
            continue;

          case SPECIAL_RELATIVE_OR_AUTHORITY:
            if (char == '/' && codePoints[pointer + 1] == '/') {
              state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
              pointer++;
            } else {
              state = RELATIVE;
              continue;
            }break;

          case PATH_OR_AUTHORITY:
            if (char == '/') {
              state = AUTHORITY;
              break;
            } else {
              state = PATH;
              continue;
            }

          case RELATIVE:
            url.scheme = base.scheme;
            if (char == EOF) {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = base.path.slice();
              url.query = base.query;
            } else if (char == '/' || char == '\\' && isSpecial(url)) {
              state = RELATIVE_SLASH;
            } else if (char == '?') {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = base.path.slice();
              url.query = '';
              state = QUERY;
            } else if (char == '#') {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = base.path.slice();
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              url.path = base.path.slice();
              url.path.pop();
              state = PATH;
              continue;
            }break;

          case RELATIVE_SLASH:
            if (isSpecial(url) && (char == '/' || char == '\\')) {
              state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            } else if (char == '/') {
              state = AUTHORITY;
            } else {
              url.username = base.username;
              url.password = base.password;
              url.host = base.host;
              url.port = base.port;
              state = PATH;
              continue;
            }break;

          case SPECIAL_AUTHORITY_SLASHES:
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
            pointer++;
            break;

          case SPECIAL_AUTHORITY_IGNORE_SLASHES:
            if (char != '/' && char != '\\') {
              state = AUTHORITY;
              continue;
            }break;

          case AUTHORITY:
            if (char == '@') {
              if (seenAt) buffer = '%40' + buffer;
              seenAt = true;
              bufferCodePoints = arrayFrom(buffer);
              for (var i = 0; i < bufferCodePoints.length; i++) {
                var codePoint = bufferCodePoints[i];
                if (codePoint == ':' && !seenPasswordToken) {
                  seenPasswordToken = true;
                  continue;
                }
                var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
                if (seenPasswordToken) url.password += encodedCodePoints;else url.username += encodedCodePoints;
              }
              buffer = '';
            } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
              if (seenAt && buffer == '') return INVALID_AUTHORITY;
              pointer -= arrayFrom(buffer).length + 1;
              buffer = '';
              state = HOST;
            } else buffer += char;
            break;

          case HOST:
          case HOSTNAME:
            if (stateOverride && url.scheme == 'file') {
              state = FILE_HOST;
              continue;
            } else if (char == ':' && !seenBracket) {
              if (buffer == '') return INVALID_HOST;
              failure = parseHost(url, buffer);
              if (failure) return failure;
              buffer = '';
              state = PORT;
              if (stateOverride == HOSTNAME) return;
            } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url)) {
              if (isSpecial(url) && buffer == '') return INVALID_HOST;
              if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
              failure = parseHost(url, buffer);
              if (failure) return failure;
              buffer = '';
              state = PATH_START;
              if (stateOverride) return;
              continue;
            } else {
              if (char == '[') seenBracket = true;else if (char == ']') seenBracket = false;
              buffer += char;
            }break;

          case PORT:
            if (DIGIT.test(char)) {
              buffer += char;
            } else if (char == EOF || char == '/' || char == '?' || char == '#' || char == '\\' && isSpecial(url) || stateOverride) {
              if (buffer != '') {
                var port = parseInt(buffer, 10);
                if (port > 0xFFFF) return INVALID_PORT;
                url.port = isSpecial(url) && port === specialSchemes[url.scheme] ? null : port;
                buffer = '';
              }
              if (stateOverride) return;
              state = PATH_START;
              continue;
            } else return INVALID_PORT;
            break;

          case FILE:
            url.scheme = 'file';
            if (char == '/' || char == '\\') state = FILE_SLASH;else if (base && base.scheme == 'file') {
              if (char == EOF) {
                url.host = base.host;
                url.path = base.path.slice();
                url.query = base.query;
              } else if (char == '?') {
                url.host = base.host;
                url.path = base.path.slice();
                url.query = '';
                state = QUERY;
              } else if (char == '#') {
                url.host = base.host;
                url.path = base.path.slice();
                url.query = base.query;
                url.fragment = '';
                state = FRAGMENT;
              } else {
                if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
                  url.host = base.host;
                  url.path = base.path.slice();
                  shortenURLsPath(url);
                }
                state = PATH;
                continue;
              }
            } else {
              state = PATH;
              continue;
            }break;

          case FILE_SLASH:
            if (char == '/' || char == '\\') {
              state = FILE_HOST;
              break;
            }
            if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);else url.host = base.host;
            }
            state = PATH;
            continue;

          case FILE_HOST:
            if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
              if (!stateOverride && isWindowsDriveLetter(buffer)) {
                state = PATH;
              } else if (buffer == '') {
                url.host = '';
                if (stateOverride) return;
                state = PATH_START;
              } else {
                failure = parseHost(url, buffer);
                if (failure) return failure;
                if (url.host == 'localhost') url.host = '';
                if (stateOverride) return;
                buffer = '';
                state = PATH_START;
              }continue;
            } else buffer += char;
            break;

          case PATH_START:
            if (isSpecial(url)) {
              state = PATH;
              if (char != '/' && char != '\\') continue;
            } else if (!stateOverride && char == '?') {
              url.query = '';
              state = QUERY;
            } else if (!stateOverride && char == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (char != EOF) {
              state = PATH;
              if (char != '/') continue;
            }break;

          case PATH:
            if (char == EOF || char == '/' || char == '\\' && isSpecial(url) || !stateOverride && (char == '?' || char == '#')) {
              if (isDoubleDot(buffer)) {
                shortenURLsPath(url);
                if (char != '/' && !(char == '\\' && isSpecial(url))) {
                  url.path.push('');
                }
              } else if (isSingleDot(buffer)) {
                if (char != '/' && !(char == '\\' && isSpecial(url))) {
                  url.path.push('');
                }
              } else {
                if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                  if (url.host) url.host = '';
                  buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
                }
                url.path.push(buffer);
              }
              buffer = '';
              if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
                while (url.path.length > 1 && url.path[0] === '') {
                  url.path.shift();
                }
              }
              if (char == '?') {
                url.query = '';
                state = QUERY;
              } else if (char == '#') {
                url.fragment = '';
                state = FRAGMENT;
              }
            } else {
              buffer += percentEncode(char, pathPercentEncodeSet);
            }break;

          case CANNOT_BE_A_BASE_URL_PATH:
            if (char == '?') {
              url.query = '';
              state = QUERY;
            } else if (char == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (char != EOF) {
              url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
            }break;

          case QUERY:
            if (!stateOverride && char == '#') {
              url.fragment = '';
              state = FRAGMENT;
            } else if (char != EOF) {
              if (char == "'" && isSpecial(url)) url.query += '%27';else if (char == '#') url.query += '%23';else url.query += percentEncode(char, C0ControlPercentEncodeSet);
            }break;

          case FRAGMENT:
            if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
            break;
        }

        pointer++;
      }
    };

    // `URL` constructor
    // https://url.spec.whatwg.org/#url-class
    var URLConstructor = function URL(url /* , base */) {
      var that = anInstance(this, URLConstructor, 'URL');
      var base = arguments.length > 1 ? arguments[1] : undefined;
      var urlString = String(url);
      var state = setInternalState(that, { type: 'URL' });
      var baseState, failure;
      if (base !== undefined) {
        if (base instanceof URLConstructor) baseState = getInternalURLState(base);else {
          failure = parseURL(baseState = {}, String(base));
          if (failure) throw TypeError(failure);
        }
      }
      failure = parseURL(state, urlString, null, baseState);
      if (failure) throw TypeError(failure);
      var searchParams = state.searchParams = new URLSearchParams();
      var searchParamsState = getInternalSearchParamsState(searchParams);
      searchParamsState.updateSearchParams(state.query);
      searchParamsState.updateURL = function () {
        state.query = String(searchParams) || null;
      };
      if (!DESCRIPTORS) {
        that.href = serializeURL.call(that);
        that.origin = getOrigin.call(that);
        that.protocol = getProtocol.call(that);
        that.username = getUsername.call(that);
        that.password = getPassword.call(that);
        that.host = getHost.call(that);
        that.hostname = getHostname.call(that);
        that.port = getPort.call(that);
        that.pathname = getPathname.call(that);
        that.search = getSearch.call(that);
        that.searchParams = getSearchParams.call(that);
        that.hash = getHash.call(that);
      }
    };

    var URLPrototype = URLConstructor.prototype;

    var serializeURL = function serializeURL() {
      var url = getInternalURLState(this);
      var scheme = url.scheme;
      var username = url.username;
      var password = url.password;
      var host = url.host;
      var port = url.port;
      var path = url.path;
      var query = url.query;
      var fragment = url.fragment;
      var output = scheme + ':';
      if (host !== null) {
        output += '//';
        if (includesCredentials(url)) {
          output += username + (password ? ':' + password : '') + '@';
        }
        output += serializeHost(host);
        if (port !== null) output += ':' + port;
      } else if (scheme == 'file') output += '//';
      output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
      if (query !== null) output += '?' + query;
      if (fragment !== null) output += '#' + fragment;
      return output;
    };

    var getOrigin = function getOrigin() {
      var url = getInternalURLState(this);
      var scheme = url.scheme;
      var port = url.port;
      if (scheme == 'blob') try {
        return new URL(scheme.path[0]).origin;
      } catch (error) {
        return 'null';
      }
      if (scheme == 'file' || !isSpecial(url)) return 'null';
      return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
    };

    var getProtocol = function getProtocol() {
      return getInternalURLState(this).scheme + ':';
    };

    var getUsername = function getUsername() {
      return getInternalURLState(this).username;
    };

    var getPassword = function getPassword() {
      return getInternalURLState(this).password;
    };

    var getHost = function getHost() {
      var url = getInternalURLState(this);
      var host = url.host;
      var port = url.port;
      return host === null ? '' : port === null ? serializeHost(host) : serializeHost(host) + ':' + port;
    };

    var getHostname = function getHostname() {
      var host = getInternalURLState(this).host;
      return host === null ? '' : serializeHost(host);
    };

    var getPort = function getPort() {
      var port = getInternalURLState(this).port;
      return port === null ? '' : String(port);
    };

    var getPathname = function getPathname() {
      var url = getInternalURLState(this);
      var path = url.path;
      return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
    };

    var getSearch = function getSearch() {
      var query = getInternalURLState(this).query;
      return query ? '?' + query : '';
    };

    var getSearchParams = function getSearchParams() {
      return getInternalURLState(this).searchParams;
    };

    var getHash = function getHash() {
      var fragment = getInternalURLState(this).fragment;
      return fragment ? '#' + fragment : '';
    };

    var accessorDescriptor = function accessorDescriptor(getter, setter) {
      return { get: getter, set: setter, configurable: true, enumerable: true };
    };

    if (DESCRIPTORS) {
      defineProperties(URLPrototype, {
        // `URL.prototype.href` accessors pair
        // https://url.spec.whatwg.org/#dom-url-href
        href: accessorDescriptor(serializeURL, function (href) {
          var url = getInternalURLState(this);
          var urlString = String(href);
          var failure = parseURL(url, urlString);
          if (failure) throw TypeError(failure);
          getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
        }),
        // `URL.prototype.origin` getter
        // https://url.spec.whatwg.org/#dom-url-origin
        origin: accessorDescriptor(getOrigin),
        // `URL.prototype.protocol` accessors pair
        // https://url.spec.whatwg.org/#dom-url-protocol
        protocol: accessorDescriptor(getProtocol, function (protocol) {
          var url = getInternalURLState(this);
          parseURL(url, String(protocol) + ':', SCHEME_START);
        }),
        // `URL.prototype.username` accessors pair
        // https://url.spec.whatwg.org/#dom-url-username
        username: accessorDescriptor(getUsername, function (username) {
          var url = getInternalURLState(this);
          var codePoints = arrayFrom(String(username));
          if (cannotHaveUsernamePasswordPort(url)) return;
          url.username = '';
          for (var i = 0; i < codePoints.length; i++) {
            url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
          }
        }),
        // `URL.prototype.password` accessors pair
        // https://url.spec.whatwg.org/#dom-url-password
        password: accessorDescriptor(getPassword, function (password) {
          var url = getInternalURLState(this);
          var codePoints = arrayFrom(String(password));
          if (cannotHaveUsernamePasswordPort(url)) return;
          url.password = '';
          for (var i = 0; i < codePoints.length; i++) {
            url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
          }
        }),
        // `URL.prototype.host` accessors pair
        // https://url.spec.whatwg.org/#dom-url-host
        host: accessorDescriptor(getHost, function (host) {
          var url = getInternalURLState(this);
          if (url.cannotBeABaseURL) return;
          parseURL(url, String(host), HOST);
        }),
        // `URL.prototype.hostname` accessors pair
        // https://url.spec.whatwg.org/#dom-url-hostname
        hostname: accessorDescriptor(getHostname, function (hostname) {
          var url = getInternalURLState(this);
          if (url.cannotBeABaseURL) return;
          parseURL(url, String(hostname), HOSTNAME);
        }),
        // `URL.prototype.port` accessors pair
        // https://url.spec.whatwg.org/#dom-url-port
        port: accessorDescriptor(getPort, function (port) {
          var url = getInternalURLState(this);
          if (cannotHaveUsernamePasswordPort(url)) return;
          port = String(port);
          if (port == '') url.port = null;else parseURL(url, port, PORT);
        }),
        // `URL.prototype.pathname` accessors pair
        // https://url.spec.whatwg.org/#dom-url-pathname
        pathname: accessorDescriptor(getPathname, function (pathname) {
          var url = getInternalURLState(this);
          if (url.cannotBeABaseURL) return;
          url.path = [];
          parseURL(url, pathname + '', PATH_START);
        }),
        // `URL.prototype.search` accessors pair
        // https://url.spec.whatwg.org/#dom-url-search
        search: accessorDescriptor(getSearch, function (search) {
          var url = getInternalURLState(this);
          search = String(search);
          if (search == '') {
            url.query = null;
          } else {
            if ('?' == search.charAt(0)) search = search.slice(1);
            url.query = '';
            parseURL(url, search, QUERY);
          }
          getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
        }),
        // `URL.prototype.searchParams` getter
        // https://url.spec.whatwg.org/#dom-url-searchparams
        searchParams: accessorDescriptor(getSearchParams),
        // `URL.prototype.hash` accessors pair
        // https://url.spec.whatwg.org/#dom-url-hash
        hash: accessorDescriptor(getHash, function (hash) {
          var url = getInternalURLState(this);
          hash = String(hash);
          if (hash == '') {
            url.fragment = null;
            return;
          }
          if ('#' == hash.charAt(0)) hash = hash.slice(1);
          url.fragment = '';
          parseURL(url, hash, FRAGMENT);
        })
      });
    }

    // `URL.prototype.toJSON` method
    // https://url.spec.whatwg.org/#dom-url-tojson
    redefine(URLPrototype, 'toJSON', function toJSON() {
      return serializeURL.call(this);
    }, { enumerable: true });

    // `URL.prototype.toString` method
    // https://url.spec.whatwg.org/#URL-stringification-behavior
    redefine(URLPrototype, 'toString', function toString() {
      return serializeURL.call(this);
    }, { enumerable: true });

    if (NativeURL) {
      var nativeCreateObjectURL = NativeURL.createObjectURL;
      var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
      // `URL.createObjectURL` method
      // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
      // eslint-disable-next-line no-unused-vars
      if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
        return nativeCreateObjectURL.apply(NativeURL, arguments);
      });
      // `URL.revokeObjectURL` method
      // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
      // eslint-disable-next-line no-unused-vars
      if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
        return nativeRevokeObjectURL.apply(NativeURL, arguments);
      });
    }

    setToStringTag(URLConstructor, 'URL');

    $({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
      URL: URLConstructor
    });

    /***/
  },

  /***/"2ca0":
  /***/function ca0(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
    var toLength = __webpack_require__("50c4");
    var notARegExp = __webpack_require__("5a34");
    var requireObjectCoercible = __webpack_require__("1d80");
    var correctIsRegExpLogic = __webpack_require__("ab13");
    var IS_PURE = __webpack_require__("c430");

    var nativeStartsWith = ''.startsWith;
    var min = Math.min;

    var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
    // https://github.com/zloirock/core-js/pull/702
    var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
      var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
      return descriptor && !descriptor.writable;
    }();

    // `String.prototype.startsWith` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.startswith
    $({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
      startsWith: function startsWith(searchString /* , position = 0 */) {
        var that = String(requireObjectCoercible(this));
        notARegExp(searchString);
        var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return nativeStartsWith ? nativeStartsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
      }
    });

    /***/
  },

  /***/"2cf4":
  /***/function cf4(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var fails = __webpack_require__("d039");
    var classof = __webpack_require__("c6b6");
    var bind = __webpack_require__("0366");
    var html = __webpack_require__("1be4");
    var createElement = __webpack_require__("cc12");
    var IS_IOS = __webpack_require__("1cdc");

    var location = global.location;
    var set = global.setImmediate;
    var clear = global.clearImmediate;
    var process = global.process;
    var MessageChannel = global.MessageChannel;
    var Dispatch = global.Dispatch;
    var counter = 0;
    var queue = {};
    var ONREADYSTATECHANGE = 'onreadystatechange';
    var defer, channel, port;

    var run = function run(id) {
      // eslint-disable-next-line no-prototype-builtins
      if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
      }
    };

    var runner = function runner(id) {
      return function () {
        run(id);
      };
    };

    var listener = function listener(event) {
      run(event.data);
    };

    var post = function post(id) {
      // old engines have not location.origin
      global.postMessage(id + '', location.protocol + '//' + location.host);
    };

    // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
    if (!set || !clear) {
      set = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while (arguments.length > i) {
          args.push(arguments[i++]);
        }queue[++counter] = function () {
          // eslint-disable-next-line no-new-func
          (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
        };
        defer(counter);
        return counter;
      };
      clear = function clearImmediate(id) {
        delete queue[id];
      };
      // Node.js 0.8-
      if (classof(process) == 'process') {
        defer = function defer(id) {
          process.nextTick(runner(id));
        };
        // Sphere (JS game engine) Dispatch API
      } else if (Dispatch && Dispatch.now) {
        defer = function defer(id) {
          Dispatch.now(runner(id));
        };
        // Browsers with MessageChannel, includes WebWorkers
        // except iOS - https://github.com/zloirock/core-js/issues/624
      } else if (MessageChannel && !IS_IOS) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = bind(port.postMessage, port, 1);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts && !fails(post) && location.protocol !== 'file:') {
        defer = post;
        global.addEventListener('message', listener, false);
        // IE8-
      } else if (ONREADYSTATECHANGE in createElement('script')) {
        defer = function defer(id) {
          html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
            html.removeChild(this);
            run(id);
          };
        };
        // Rest old browsers
      } else {
        defer = function defer(id) {
          setTimeout(runner(id), 0);
        };
      }
    }

    module.exports = {
      set: set,
      clear: clear
    };

    /***/
  },

  /***/"2d00":
  /***/function d00(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var userAgent = __webpack_require__("342f");

    var process = global.process;
    var versions = process && process.versions;
    var v8 = versions && versions.v8;
    var match, version;

    if (v8) {
      match = v8.split('.');
      version = match[0] + match[1];
    } else if (userAgent) {
      match = userAgent.match(/Edge\/(\d+)/);
      if (!match || match[1] >= 74) {
        match = userAgent.match(/Chrome\/(\d+)/);
        if (match) version = match[1];
      }
    }

    module.exports = version && +version;

    /***/
  },

  /***/"3410":
  /***/function _(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var fails = __webpack_require__("d039");
    var toObject = __webpack_require__("7b0b");
    var nativeGetPrototypeOf = __webpack_require__("e163");
    var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

    var FAILS_ON_PRIMITIVES = fails(function () {
      nativeGetPrototypeOf(1);
    });

    // `Object.getPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.getprototypeof
    $({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
      getPrototypeOf: function getPrototypeOf(it) {
        return nativeGetPrototypeOf(toObject(it));
      }
    });

    /***/
  },

  /***/"342f":
  /***/function f(module, exports, __webpack_require__) {

    var getBuiltIn = __webpack_require__("d066");

    module.exports = getBuiltIn('navigator', 'userAgent') || '';

    /***/
  },

  /***/"35a1":
  /***/function a1(module, exports, __webpack_require__) {

    var classof = __webpack_require__("f5df");
    var Iterators = __webpack_require__("3f8c");
    var wellKnownSymbol = __webpack_require__("b622");

    var ITERATOR = wellKnownSymbol('iterator');

    module.exports = function (it) {
      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };

    /***/
  },

  /***/"37e8":
  /***/function e8(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var definePropertyModule = __webpack_require__("9bf2");
    var anObject = __webpack_require__("825a");
    var objectKeys = __webpack_require__("df75");

    // `Object.defineProperties` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperties
    module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = objectKeys(Properties);
      var length = keys.length;
      var index = 0;
      var key;
      while (length > index) {
        definePropertyModule.f(O, key = keys[index++], Properties[key]);
      }return O;
    };

    /***/
  },

  /***/"3835":
  /***/function _(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // EXPORTS

    __webpack_require__.d(__webpack_exports__, "a", function () {
      return (/* binding */_slicedToArray
      );
    });

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }
    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
    var es_symbol = __webpack_require__("a4d3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
    var es_symbol_description = __webpack_require__("e01a");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
    var es_symbol_iterator = __webpack_require__("d28b");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
    var es_array_iterator = __webpack_require__("e260");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
    var es_object_to_string = __webpack_require__("d3b7");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
    var es_string_iterator = __webpack_require__("3ca3");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
    var web_dom_collections_iterator = __webpack_require__("ddb0");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js


    function _iterableToArrayLimit(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }
    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
    var unsupportedIterableToArray = __webpack_require__("06c5");

    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    // CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js


    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || Object(unsupportedIterableToArray["a" /* default */])(arr, i) || _nonIterableRest();
    }

    /***/
  },

  /***/"3bbe":
  /***/function bbe(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");

    module.exports = function (it) {
      if (!isObject(it) && it !== null) {
        throw TypeError("Can't set " + String(it) + ' as a prototype');
      }return it;
    };

    /***/
  },

  /***/"3ca3":
  /***/function ca3(module, exports, __webpack_require__) {

    "use strict";

    var charAt = __webpack_require__("6547").charAt;
    var InternalStateModule = __webpack_require__("69f3");
    var defineIterator = __webpack_require__("7dd0");

    var STRING_ITERATOR = 'String Iterator';
    var setInternalState = InternalStateModule.set;
    var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

    // `String.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
    defineIterator(String, 'String', function (iterated) {
      setInternalState(this, {
        type: STRING_ITERATOR,
        string: String(iterated),
        index: 0
      });
      // `%StringIteratorPrototype%.next` method
      // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
    }, function next() {
      var state = getInternalState(this);
      var string = state.string;
      var index = state.index;
      var point;
      if (index >= string.length) return { value: undefined, done: true };
      point = charAt(string, index);
      state.index += point.length;
      return { value: point, done: false };
    });

    /***/
  },

  /***/"3f8c":
  /***/function f8c(module, exports) {

    module.exports = {};

    /***/
  },

  /***/"4160":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var forEach = __webpack_require__("17c2");

    // `Array.prototype.forEach` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
    $({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
      forEach: forEach
    });

    /***/
  },

  /***/"428f":
  /***/function f(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");

    module.exports = global;

    /***/
  },

  /***/"44ad":
  /***/function ad(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");
    var classof = __webpack_require__("c6b6");

    var split = ''.split;

    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    module.exports = fails(function () {
      // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
      // eslint-disable-next-line no-prototype-builtins
      return !Object('z').propertyIsEnumerable(0);
    }) ? function (it) {
      return classof(it) == 'String' ? split.call(it, '') : Object(it);
    } : Object;

    /***/
  },

  /***/"44d2":
  /***/function d2(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");
    var create = __webpack_require__("7c73");
    var definePropertyModule = __webpack_require__("9bf2");

    var UNSCOPABLES = wellKnownSymbol('unscopables');
    var ArrayPrototype = Array.prototype;

    // Array.prototype[@@unscopables]
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    if (ArrayPrototype[UNSCOPABLES] == undefined) {
      definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
        configurable: true,
        value: create(null)
      });
    }

    // add a key to Array.prototype[@@unscopables]
    module.exports = function (key) {
      ArrayPrototype[UNSCOPABLES][key] = true;
    };

    /***/
  },

  /***/"44de":
  /***/function de(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");

    module.exports = function (a, b) {
      var console = global.console;
      if (console && console.error) {
        arguments.length === 1 ? console.error(a) : console.error(a, b);
      }
    };

    /***/
  },

  /***/"44e7":
  /***/function e7(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");
    var classof = __webpack_require__("c6b6");
    var wellKnownSymbol = __webpack_require__("b622");

    var MATCH = wellKnownSymbol('match');

    // `IsRegExp` abstract operation
    // https://tc39.github.io/ecma262/#sec-isregexp
    module.exports = function (it) {
      var isRegExp;
      return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
    };

    /***/
  },

  /***/"45fc":
  /***/function fc(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $some = __webpack_require__("b727").some;
    var arrayMethodIsStrict = __webpack_require__("a640");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var STRICT_METHOD = arrayMethodIsStrict('some');
    var USES_TO_LENGTH = arrayMethodUsesToLength('some');

    // `Array.prototype.some` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.some
    $({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
      some: function some(callbackfn /* , thisArg */) {
        return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"466d":
  /***/function d(module, exports, __webpack_require__) {

    "use strict";

    var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
    var anObject = __webpack_require__("825a");
    var toLength = __webpack_require__("50c4");
    var requireObjectCoercible = __webpack_require__("1d80");
    var advanceStringIndex = __webpack_require__("8aa5");
    var regExpExec = __webpack_require__("14c3");

    // @@match logic
    fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
      return [
      // `String.prototype.match` method
      // https://tc39.github.io/ecma262/#sec-string.prototype.match
      function match(regexp) {
        var O = requireObjectCoercible(this);
        var matcher = regexp == undefined ? undefined : regexp[MATCH];
        return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
      },
      // `RegExp.prototype[@@match]` method
      // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
      function (regexp) {
        var res = maybeCallNative(nativeMatch, regexp, this);
        if (res.done) return res.value;

        var rx = anObject(regexp);
        var S = String(this);

        if (!rx.global) return regExpExec(rx, S);

        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
        var A = [];
        var n = 0;
        var result;
        while ((result = regExpExec(rx, S)) !== null) {
          var matchStr = String(result[0]);
          A[n] = matchStr;
          if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
          n++;
        }
        return n === 0 ? null : A;
      }];
    });

    /***/
  },

  /***/"4840":
  /***/function _(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var aFunction = __webpack_require__("1c0b");
    var wellKnownSymbol = __webpack_require__("b622");

    var SPECIES = wellKnownSymbol('species');

    // `SpeciesConstructor` abstract operation
    // https://tc39.github.io/ecma262/#sec-speciesconstructor
    module.exports = function (O, defaultConstructor) {
      var C = anObject(O).constructor;
      var S;
      return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
    };

    /***/
  },

  /***/"4930":
  /***/function _(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");

    module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
      // Chrome 38 Symbol has incorrect toString conversion
      // eslint-disable-next-line no-undef
      return !String(Symbol());
    });

    /***/
  },

  /***/"499e":
  /***/function e(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    // ESM COMPAT FLAG

    __webpack_require__.r(__webpack_exports__);

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "default", function () {
      return (/* binding */addStylesClient
      );
    });

    // CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
    /**
     * Translates the list format produced by css-loader into something
     * easier to manipulate.
     */
    function listToStyles(parentId, list) {
      var styles = [];
      var newStyles = {};
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var id = item[0];
        var css = item[1];
        var media = item[2];
        var sourceMap = item[3];
        var part = {
          id: parentId + ':' + i,
          css: css,
          media: media,
          sourceMap: sourceMap
        };
        if (!newStyles[id]) {
          styles.push(newStyles[id] = { id: id, parts: [part] });
        } else {
          newStyles[id].parts.push(part);
        }
      }
      return styles;
    }

    // CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
    /*
      MIT License http://www.opensource.org/licenses/mit-license.php
      Author Tobias Koppers @sokra
      Modified by Evan You @yyx990803
    */

    var hasDocument = typeof document !== 'undefined';

    if (typeof DEBUG !== 'undefined' && DEBUG) {
      if (!hasDocument) {
        throw new Error('vue-style-loader cannot be used in a non-browser environment. ' + "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");
      }
    }

    /*
    type StyleObject = {
      id: number;
      parts: Array<StyleObjectPart>
    }
    
    type StyleObjectPart = {
      css: string;
      media: string;
      sourceMap: ?string
    }
    */

    var stylesInDom = {/*
                       [id: number]: {
                       id: number,
                       refs: number,
                       parts: Array<(obj?: StyleObjectPart) => void>
                       }
                       */};

    var head = hasDocument && (document.head || document.getElementsByTagName('head')[0]);
    var singletonElement = null;
    var singletonCounter = 0;
    var isProduction = false;
    var noop = function noop() {};
    var options = null;
    var ssrIdKey = 'data-vue-ssr-id';

    // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
    // tags it will allow on a page
    var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase());

    function addStylesClient(parentId, list, _isProduction, _options) {
      isProduction = _isProduction;

      options = _options || {};

      var styles = listToStyles(parentId, list);
      addStylesToDom(styles);

      return function update(newList) {
        var mayRemove = [];
        for (var i = 0; i < styles.length; i++) {
          var item = styles[i];
          var domStyle = stylesInDom[item.id];
          domStyle.refs--;
          mayRemove.push(domStyle);
        }
        if (newList) {
          styles = listToStyles(parentId, newList);
          addStylesToDom(styles);
        } else {
          styles = [];
        }
        for (var i = 0; i < mayRemove.length; i++) {
          var domStyle = mayRemove[i];
          if (domStyle.refs === 0) {
            for (var j = 0; j < domStyle.parts.length; j++) {
              domStyle.parts[j]();
            }
            delete stylesInDom[domStyle.id];
          }
        }
      };
    }

    function addStylesToDom(styles /* Array<StyleObject> */) {
      for (var i = 0; i < styles.length; i++) {
        var item = styles[i];
        var domStyle = stylesInDom[item.id];
        if (domStyle) {
          domStyle.refs++;
          for (var j = 0; j < domStyle.parts.length; j++) {
            domStyle.parts[j](item.parts[j]);
          }
          for (; j < item.parts.length; j++) {
            domStyle.parts.push(addStyle(item.parts[j]));
          }
          if (domStyle.parts.length > item.parts.length) {
            domStyle.parts.length = item.parts.length;
          }
        } else {
          var parts = [];
          for (var j = 0; j < item.parts.length; j++) {
            parts.push(addStyle(item.parts[j]));
          }
          stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts };
        }
      }
    }

    function createStyleElement() {
      var styleElement = document.createElement('style');
      styleElement.type = 'text/css';
      head.appendChild(styleElement);
      return styleElement;
    }

    function addStyle(obj /* StyleObjectPart */) {
      var update, remove;
      var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]');

      if (styleElement) {
        if (isProduction) {
          // has SSR styles and in production mode.
          // simply do nothing.
          return noop;
        } else {
          // has SSR styles but in dev mode.
          // for some reason Chrome can't handle source map in server-rendered
          // style tags - source maps in <style> only works if the style tag is
          // created and inserted dynamically. So we remove the server rendered
          // styles and inject new ones.
          styleElement.parentNode.removeChild(styleElement);
        }
      }

      if (isOldIE) {
        // use singleton mode for IE9.
        var styleIndex = singletonCounter++;
        styleElement = singletonElement || (singletonElement = createStyleElement());
        update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
        remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
      } else {
        // use multi-style-tag mode in all other cases
        styleElement = createStyleElement();
        update = applyToTag.bind(null, styleElement);
        remove = function remove() {
          styleElement.parentNode.removeChild(styleElement);
        };
      }

      update(obj);

      return function updateStyle(newObj /* StyleObjectPart */) {
        if (newObj) {
          if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
            return;
          }
          update(obj = newObj);
        } else {
          remove();
        }
      };
    }

    var replaceText = function () {
      var textStore = [];

      return function (index, replacement) {
        textStore[index] = replacement;
        return textStore.filter(Boolean).join('\n');
      };
    }();

    function applyToSingletonTag(styleElement, index, remove, obj) {
      var css = remove ? '' : obj.css;

      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = replaceText(index, css);
      } else {
        var cssNode = document.createTextNode(css);
        var childNodes = styleElement.childNodes;
        if (childNodes[index]) styleElement.removeChild(childNodes[index]);
        if (childNodes.length) {
          styleElement.insertBefore(cssNode, childNodes[index]);
        } else {
          styleElement.appendChild(cssNode);
        }
      }
    }

    function applyToTag(styleElement, obj) {
      var css = obj.css;
      var media = obj.media;
      var sourceMap = obj.sourceMap;

      if (media) {
        styleElement.setAttribute('media', media);
      }
      if (options.ssrId) {
        styleElement.setAttribute(ssrIdKey, obj.id);
      }

      if (sourceMap) {
        // https://developer.chrome.com/devtools/docs/javascript-debugging
        // this makes source maps inside style tags work properly in Chrome
        css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
        // http://stackoverflow.com/a/26603875
        css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */';
      }

      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = css;
      } else {
        while (styleElement.firstChild) {
          styleElement.removeChild(styleElement.firstChild);
        }
        styleElement.appendChild(document.createTextNode(css));
      }
    }

    /***/
  },

  /***/"4ae1":
  /***/function ae1(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var getBuiltIn = __webpack_require__("d066");
    var aFunction = __webpack_require__("1c0b");
    var anObject = __webpack_require__("825a");
    var isObject = __webpack_require__("861d");
    var create = __webpack_require__("7c73");
    var bind = __webpack_require__("0538");
    var fails = __webpack_require__("d039");

    var nativeConstruct = getBuiltIn('Reflect', 'construct');

    // `Reflect.construct` method
    // https://tc39.github.io/ecma262/#sec-reflect.construct
    // MS Edge supports only 2 arguments and argumentsList argument is optional
    // FF Nightly sets third argument as `new.target`, but does not create `this` from it
    var NEW_TARGET_BUG = fails(function () {
      function F() {/* empty */}
      return !(nativeConstruct(function () {/* empty */}, [], F) instanceof F);
    });
    var ARGS_BUG = !fails(function () {
      nativeConstruct(function () {/* empty */});
    });
    var FORCED = NEW_TARGET_BUG || ARGS_BUG;

    $({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
      construct: function construct(Target, args /* , newTarget */) {
        aFunction(Target);
        anObject(args);
        var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
        if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
        if (Target == newTarget) {
          // w/o altered newTarget, optimization for 0-4 arguments
          switch (args.length) {
            case 0:
              return new Target();
            case 1:
              return new Target(args[0]);
            case 2:
              return new Target(args[0], args[1]);
            case 3:
              return new Target(args[0], args[1], args[2]);
            case 4:
              return new Target(args[0], args[1], args[2], args[3]);
          }
          // w/o altered newTarget, lot of arguments case
          var $args = [null];
          $args.push.apply($args, args);
          return new (bind.apply(Target, $args))();
        }
        // with altered newTarget, not support built-in constructors
        var proto = newTarget.prototype;
        var instance = create(isObject(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return isObject(result) ? result : instance;
      }
    });

    /***/
  },

  /***/"4d64":
  /***/function d64(module, exports, __webpack_require__) {

    var toIndexedObject = __webpack_require__("fc6a");
    var toLength = __webpack_require__("50c4");
    var toAbsoluteIndex = __webpack_require__("23cb");

    // `Array.prototype.{ indexOf, includes }` methods implementation
    var createMethod = function createMethod(IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIndexedObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++];
          // eslint-disable-next-line no-self-compare
          if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }return !IS_INCLUDES && -1;
      };
    };

    module.exports = {
      // `Array.prototype.includes` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.includes
      includes: createMethod(true),
      // `Array.prototype.indexOf` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
      indexOf: createMethod(false)
    };

    /***/
  },

  /***/"4de4":
  /***/function de4(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $filter = __webpack_require__("b727").filter;
    var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
    // Edge 14- issue
    var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

    // `Array.prototype.filter` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.filter
    // with adding support of @@species
    $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
      filter: function filter(callbackfn /* , thisArg */) {
        return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"4df4":
  /***/function df4(module, exports, __webpack_require__) {

    "use strict";

    var bind = __webpack_require__("0366");
    var toObject = __webpack_require__("7b0b");
    var callWithSafeIterationClosing = __webpack_require__("9bdd");
    var isArrayIteratorMethod = __webpack_require__("e95a");
    var toLength = __webpack_require__("50c4");
    var createProperty = __webpack_require__("8418");
    var getIteratorMethod = __webpack_require__("35a1");

    // `Array.from` method implementation
    // https://tc39.github.io/ecma262/#sec-array.from
    module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
      var O = toObject(arrayLike);
      var C = typeof this == 'function' ? this : Array;
      var argumentsLength = arguments.length;
      var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
      var mapping = mapfn !== undefined;
      var iteratorMethod = getIteratorMethod(O);
      var index = 0;
      var length, result, step, iterator, next, value;
      if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
      // if the target is not iterable or it's an array with the default iterator - use a simple case
      if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
        iterator = iteratorMethod.call(O);
        next = iterator.next;
        result = new C();
        for (; !(step = next.call(iterator)).done; index++) {
          value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
          createProperty(result, index, value);
        }
      } else {
        length = toLength(O.length);
        result = new C(length);
        for (; length > index; index++) {
          value = mapping ? mapfn(O[index], index) : O[index];
          createProperty(result, index, value);
        }
      }
      result.length = index;
      return result;
    };

    /***/
  },

  /***/"4ec9":
  /***/function ec9(module, exports, __webpack_require__) {

    "use strict";

    var collection = __webpack_require__("6d61");
    var collectionStrong = __webpack_require__("6566");

    // `Map` constructor
    // https://tc39.github.io/ecma262/#sec-map-objects
    module.exports = collection('Map', function (init) {
      return function Map() {
        return init(this, arguments.length ? arguments[0] : undefined);
      };
    }, collectionStrong);

    /***/
  },

  /***/"50c4":
  /***/function c4(module, exports, __webpack_require__) {

    var toInteger = __webpack_require__("a691");

    var min = Math.min;

    // `ToLength` abstract operation
    // https://tc39.github.io/ecma262/#sec-tolength
    module.exports = function (argument) {
      return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
    };

    /***/
  },

  /***/"5135":
  /***/function _(module, exports) {

    var hasOwnProperty = {}.hasOwnProperty;

    module.exports = function (it, key) {
      return hasOwnProperty.call(it, key);
    };

    /***/
  },

  /***/"53ca":
  /***/function ca(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _typeof;
    });
    /* harmony import */var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a4d3");
    /* harmony import */var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("e01a");
    /* harmony import */var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("d28b");
    /* harmony import */var core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_iterator__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("e260");
    /* harmony import */var core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("d3b7");
    /* harmony import */var core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string__WEBPACK_IMPORTED_MODULE_4__);
    /* harmony import */var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3ca3");
    /* harmony import */var core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator__WEBPACK_IMPORTED_MODULE_5__);
    /* harmony import */var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ddb0");
    /* harmony import */var core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_iterator__WEBPACK_IMPORTED_MODULE_6__);

    function _typeof(obj) {
      "@babel/helpers - typeof";

      if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
        _typeof = function _typeof(obj) {
          return typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
        };
      } else {
        _typeof = function _typeof(obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : _typeof2(obj);
        };
      }

      return _typeof(obj);
    }

    /***/
  },

  /***/"5692":
  /***/function _(module, exports, __webpack_require__) {

    var IS_PURE = __webpack_require__("c430");
    var store = __webpack_require__("c6cd");

    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: '3.6.5',
      mode: IS_PURE ? 'pure' : 'global',
      copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
    });

    /***/
  },

  /***/"56ef":
  /***/function ef(module, exports, __webpack_require__) {

    var getBuiltIn = __webpack_require__("d066");
    var getOwnPropertyNamesModule = __webpack_require__("241c");
    var getOwnPropertySymbolsModule = __webpack_require__("7418");
    var anObject = __webpack_require__("825a");

    // all object keys, includes non-enumerable and symbols
    module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
      var keys = getOwnPropertyNamesModule.f(anObject(it));
      var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
      return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
    };

    /***/
  },

  /***/"5a34":
  /***/function a34(module, exports, __webpack_require__) {

    var isRegExp = __webpack_require__("44e7");

    module.exports = function (it) {
      if (isRegExp(it)) {
        throw TypeError("The method doesn't accept regular expressions");
      }return it;
    };

    /***/
  },

  /***/"5c0b":
  /***/function c0b(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"392d026c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeCapture.vue?vue&type=template&id=260ec977&lang=html&

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('input', { attrs: { "type": "file", "name": "image", "accept": "image/*", "capture": "environment", "multiple": "" }, on: { "change": _vm.onChangeInput } });
    };
    var staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/QrcodeCapture.vue?vue&type=template&id=260ec977&lang=html&

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
    var es_array_for_each = __webpack_require__("4160");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
    var es_array_map = __webpack_require__("d81d");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
    var web_dom_collections_for_each = __webpack_require__("159b");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
    var toConsumableArray = __webpack_require__("2909");

    // EXTERNAL MODULE: ./src/misc/scanner.js
    var scanner = __webpack_require__("a180");

    // EXTERNAL MODULE: ./src/mixins/CommonAPI.vue + 3 modules
    var CommonAPI = __webpack_require__("b3af");

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeCapture.vue?vue&type=script&lang=js&


    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var QrcodeCapturevue_type_script_lang_js_ = {
      name: "qrcode-capture",
      mixins: [CommonAPI["a" /* default */]],
      methods: {
        onChangeInput: function onChangeInput(event) {
          var files = Object(toConsumableArray["a" /* default */])(event.target.files);

          var resultPromises = files.map(scanner["b" /* processFile */]);
          resultPromises.forEach(this.onDetect);
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/QrcodeCapture.vue?vue&type=script&lang=js&
    /* harmony default export */var components_QrcodeCapturevue_type_script_lang_js_ = QrcodeCapturevue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__("2877");

    // CONCATENATED MODULE: ./src/components/QrcodeCapture.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(components_QrcodeCapturevue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* harmony default export */var QrcodeCapture = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/"5c6c":
  /***/function c6c(module, exports) {

    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    /***/
  },

  /***/"5fb2":
  /***/function fb2(module, exports, __webpack_require__) {

    "use strict";

    // based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js

    var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = '-'; // '\x2D'
    var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
    var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
    var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;

    /**
     * Creates an array containing the numeric code points of each Unicode
     * character in the string. While JavaScript uses UCS-2 internally,
     * this function will convert a pair of surrogate halves (each of which
     * UCS-2 exposes as separate characters) into a single code point,
     * matching UTF-16.
     */
    var ucs2decode = function ucs2decode(string) {
      var output = [];
      var counter = 0;
      var length = string.length;
      while (counter < length) {
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
          // It's a high surrogate, and there is a next character.
          var extra = string.charCodeAt(counter++);
          if ((extra & 0xFC00) == 0xDC00) {
            // Low surrogate.
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
          } else {
            // It's an unmatched surrogate; only append this code unit, in case the
            // next code unit is the high surrogate of a surrogate pair.
            output.push(value);
            counter--;
          }
        } else {
          output.push(value);
        }
      }
      return output;
    };

    /**
     * Converts a digit/integer into a basic code point.
     */
    var digitToBasic = function digitToBasic(digit) {
      //  0..25 map to ASCII a..z or A..Z
      // 26..35 map to ASCII 0..9
      return digit + 22 + 75 * (digit < 26);
    };

    /**
     * Bias adaptation function as per section 3.4 of RFC 3492.
     * https://tools.ietf.org/html/rfc3492#section-3.4
     */
    var adapt = function adapt(delta, numPoints, firstTime) {
      var k = 0;
      delta = firstTime ? floor(delta / damp) : delta >> 1;
      delta += floor(delta / numPoints);
      for (; delta > baseMinusTMin * tMax >> 1; k += base) {
        delta = floor(delta / baseMinusTMin);
      }
      return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };

    /**
     * Converts a string of Unicode symbols (e.g. a domain name label) to a
     * Punycode string of ASCII-only symbols.
     */
    // eslint-disable-next-line  max-statements
    var encode = function encode(input) {
      var output = [];

      // Convert the input in UCS-2 to an array of Unicode code points.
      input = ucs2decode(input);

      // Cache the length.
      var inputLength = input.length;

      // Initialize the state.
      var n = initialN;
      var delta = 0;
      var bias = initialBias;
      var i, currentValue;

      // Handle the basic code points.
      for (i = 0; i < input.length; i++) {
        currentValue = input[i];
        if (currentValue < 0x80) {
          output.push(stringFromCharCode(currentValue));
        }
      }

      var basicLength = output.length; // number of basic code points.
      var handledCPCount = basicLength; // number of code points that have been handled;

      // Finish the basic string with a delimiter unless it's empty.
      if (basicLength) {
        output.push(delimiter);
      }

      // Main encoding loop:
      while (handledCPCount < inputLength) {
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = maxInt;
        for (i = 0; i < input.length; i++) {
          currentValue = input[i];
          if (currentValue >= n && currentValue < m) {
            m = currentValue;
          }
        }

        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
          throw RangeError(OVERFLOW_ERROR);
        }

        delta += (m - n) * handledCPCountPlusOne;
        n = m;

        for (i = 0; i < input.length; i++) {
          currentValue = input[i];
          if (currentValue < n && ++delta > maxInt) {
            throw RangeError(OVERFLOW_ERROR);
          }
          if (currentValue == n) {
            // Represent delta as a generalized variable-length integer.
            var q = delta;
            for (var k = base;; /* no condition */k += base) {
              var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
              if (q < t) break;
              var qMinusT = q - t;
              var baseMinusT = base - t;
              output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
              q = floor(qMinusT / baseMinusT);
            }

            output.push(stringFromCharCode(digitToBasic(q)));
            bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
            delta = 0;
            ++handledCPCount;
          }
        }

        ++delta;
        ++n;
      }
      return output.join('');
    };

    module.exports = function (input) {
      var encoded = [];
      var labels = input.toLowerCase().replace(regexSeparators, '.').split('.');
      var i, label;
      for (i = 0; i < labels.length; i++) {
        label = labels[i];
        encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
      }
      return encoded.join('.');
    };

    /***/
  },

  /***/"60da":
  /***/function da(module, exports, __webpack_require__) {

    "use strict";

    var DESCRIPTORS = __webpack_require__("83ab");
    var fails = __webpack_require__("d039");
    var objectKeys = __webpack_require__("df75");
    var getOwnPropertySymbolsModule = __webpack_require__("7418");
    var propertyIsEnumerableModule = __webpack_require__("d1e7");
    var toObject = __webpack_require__("7b0b");
    var IndexedObject = __webpack_require__("44ad");

    var nativeAssign = Object.assign;
    var defineProperty = Object.defineProperty;

    // `Object.assign` method
    // https://tc39.github.io/ecma262/#sec-object.assign
    module.exports = !nativeAssign || fails(function () {
      // should have correct order of operations (Edge bug)
      if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
        enumerable: true,
        get: function get() {
          defineProperty(this, 'b', {
            value: 3,
            enumerable: false
          });
        }
      }), { b: 2 })).b !== 1) return true;
      // should work with symbols and should have deterministic property order (V8 bug)
      var A = {};
      var B = {};
      // eslint-disable-next-line no-undef
      var symbol = Symbol();
      var alphabet = 'abcdefghijklmnopqrst';
      A[symbol] = 7;
      alphabet.split('').forEach(function (chr) {
        B[chr] = chr;
      });
      return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
    }) ? function assign(target, source) {
      // eslint-disable-line no-unused-vars
      var T = toObject(target);
      var argumentsLength = arguments.length;
      var index = 1;
      var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
      var propertyIsEnumerable = propertyIsEnumerableModule.f;
      while (argumentsLength > index) {
        var S = IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while (length > j) {
          key = keys[j++];
          if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
        }
      }return T;
    } : nativeAssign;

    /***/
  },

  /***/"6547":
  /***/function _(module, exports, __webpack_require__) {

    var toInteger = __webpack_require__("a691");
    var requireObjectCoercible = __webpack_require__("1d80");

    // `String.prototype.{ codePointAt, at }` methods implementation
    var createMethod = function createMethod(CONVERT_TO_STRING) {
      return function ($this, pos) {
        var S = String(requireObjectCoercible($this));
        var position = toInteger(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = S.charCodeAt(position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? S.charAt(position) : first : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
      };
    };

    module.exports = {
      // `String.prototype.codePointAt` method
      // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
      codeAt: createMethod(false),
      // `String.prototype.at` method
      // https://github.com/mathiasbynens/String.prototype.at
      charAt: createMethod(true)
    };

    /***/
  },

  /***/"6566":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var defineProperty = __webpack_require__("9bf2").f;
    var create = __webpack_require__("7c73");
    var redefineAll = __webpack_require__("e2cc");
    var bind = __webpack_require__("0366");
    var anInstance = __webpack_require__("19aa");
    var iterate = __webpack_require__("2266");
    var defineIterator = __webpack_require__("7dd0");
    var setSpecies = __webpack_require__("2626");
    var DESCRIPTORS = __webpack_require__("83ab");
    var fastKey = __webpack_require__("f183").fastKey;
    var InternalStateModule = __webpack_require__("69f3");

    var setInternalState = InternalStateModule.set;
    var internalStateGetterFor = InternalStateModule.getterFor;

    module.exports = {
      getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var C = wrapper(function (that, iterable) {
          anInstance(that, C, CONSTRUCTOR_NAME);
          setInternalState(that, {
            type: CONSTRUCTOR_NAME,
            index: create(null),
            first: undefined,
            last: undefined,
            size: 0
          });
          if (!DESCRIPTORS) that.size = 0;
          if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        });

        var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

        var define = function define(that, key, value) {
          var state = getInternalState(that);
          var entry = getEntry(that, key);
          var previous, index;
          // change existing entry
          if (entry) {
            entry.value = value;
            // create new entry
          } else {
            state.last = entry = {
              index: index = fastKey(key, true),
              key: key,
              value: value,
              previous: previous = state.last,
              next: undefined,
              removed: false
            };
            if (!state.first) state.first = entry;
            if (previous) previous.next = entry;
            if (DESCRIPTORS) state.size++;else that.size++;
            // add to index
            if (index !== 'F') state.index[index] = entry;
          }return that;
        };

        var getEntry = function getEntry(that, key) {
          var state = getInternalState(that);
          // fast case
          var index = fastKey(key);
          var entry;
          if (index !== 'F') return state.index[index];
          // frozen object case
          for (entry = state.first; entry; entry = entry.next) {
            if (entry.key == key) return entry;
          }
        };

        redefineAll(C.prototype, {
          // 23.1.3.1 Map.prototype.clear()
          // 23.2.3.2 Set.prototype.clear()
          clear: function clear() {
            var that = this;
            var state = getInternalState(that);
            var data = state.index;
            var entry = state.first;
            while (entry) {
              entry.removed = true;
              if (entry.previous) entry.previous = entry.previous.next = undefined;
              delete data[entry.index];
              entry = entry.next;
            }
            state.first = state.last = undefined;
            if (DESCRIPTORS) state.size = 0;else that.size = 0;
          },
          // 23.1.3.3 Map.prototype.delete(key)
          // 23.2.3.4 Set.prototype.delete(value)
          'delete': function _delete(key) {
            var that = this;
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            if (entry) {
              var next = entry.next;
              var prev = entry.previous;
              delete state.index[entry.index];
              entry.removed = true;
              if (prev) prev.next = next;
              if (next) next.previous = prev;
              if (state.first == entry) state.first = next;
              if (state.last == entry) state.last = prev;
              if (DESCRIPTORS) state.size--;else that.size--;
            }return !!entry;
          },
          // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
          // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
          forEach: function forEach(callbackfn /* , that = undefined */) {
            var state = getInternalState(this);
            var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
            var entry;
            while (entry = entry ? entry.next : state.first) {
              boundFunction(entry.value, entry.key, this);
              // revert to the last existing entry
              while (entry && entry.removed) {
                entry = entry.previous;
              }
            }
          },
          // 23.1.3.7 Map.prototype.has(key)
          // 23.2.3.7 Set.prototype.has(value)
          has: function has(key) {
            return !!getEntry(this, key);
          }
        });

        redefineAll(C.prototype, IS_MAP ? {
          // 23.1.3.6 Map.prototype.get(key)
          get: function get(key) {
            var entry = getEntry(this, key);
            return entry && entry.value;
          },
          // 23.1.3.9 Map.prototype.set(key, value)
          set: function set(key, value) {
            return define(this, key === 0 ? 0 : key, value);
          }
        } : {
          // 23.2.3.1 Set.prototype.add(value)
          add: function add(value) {
            return define(this, value = value === 0 ? 0 : value, value);
          }
        });
        if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
          get: function get() {
            return getInternalState(this).size;
          }
        });
        return C;
      },
      setStrong: function setStrong(C, CONSTRUCTOR_NAME, IS_MAP) {
        var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
        var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
        var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
          setInternalState(this, {
            type: ITERATOR_NAME,
            target: iterated,
            state: getInternalCollectionState(iterated),
            kind: kind,
            last: undefined
          });
        }, function () {
          var state = getInternalIteratorState(this);
          var kind = state.kind;
          var entry = state.last;
          // revert to the last existing entry
          while (entry && entry.removed) {
            entry = entry.previous;
          } // get next entry
          if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
            // or finish the iteration
            state.target = undefined;
            return { value: undefined, done: true };
          }
          // return step by kind
          if (kind == 'keys') return { value: entry.key, done: false };
          if (kind == 'values') return { value: entry.value, done: false };
          return { value: [entry.key, entry.value], done: false };
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

        // add [@@species], 23.1.2.2, 23.2.2.2
        setSpecies(CONSTRUCTOR_NAME);
      }
    };

    /***/
  },

  /***/"65f0":
  /***/function f0(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");
    var isArray = __webpack_require__("e8b5");
    var wellKnownSymbol = __webpack_require__("b622");

    var SPECIES = wellKnownSymbol('species');

    // `ArraySpeciesCreate` abstract operation
    // https://tc39.github.io/ecma262/#sec-arrayspeciescreate
    module.exports = function (originalArray, length) {
      var C;
      if (isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;else if (isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      }return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
    };

    /***/
  },

  /***/"69f3":
  /***/function f3(module, exports, __webpack_require__) {

    var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
    var global = __webpack_require__("da84");
    var isObject = __webpack_require__("861d");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var objectHas = __webpack_require__("5135");
    var sharedKey = __webpack_require__("f772");
    var hiddenKeys = __webpack_require__("d012");

    var WeakMap = global.WeakMap;
    var set, get, has;

    var enforce = function enforce(it) {
      return has(it) ? get(it) : set(it, {});
    };

    var getterFor = function getterFor(TYPE) {
      return function (it) {
        var state;
        if (!isObject(it) || (state = get(it)).type !== TYPE) {
          throw TypeError('Incompatible receiver, ' + TYPE + ' required');
        }return state;
      };
    };

    if (NATIVE_WEAK_MAP) {
      var store = new WeakMap();
      var wmget = store.get;
      var wmhas = store.has;
      var wmset = store.set;
      set = function set(it, metadata) {
        wmset.call(store, it, metadata);
        return metadata;
      };
      get = function get(it) {
        return wmget.call(store, it) || {};
      };
      has = function has(it) {
        return wmhas.call(store, it);
      };
    } else {
      var STATE = sharedKey('state');
      hiddenKeys[STATE] = true;
      set = function set(it, metadata) {
        createNonEnumerableProperty(it, STATE, metadata);
        return metadata;
      };
      get = function get(it) {
        return objectHas(it, STATE) ? it[STATE] : {};
      };
      has = function has(it) {
        return objectHas(it, STATE);
      };
    }

    module.exports = {
      set: set,
      get: get,
      has: has,
      enforce: enforce,
      getterFor: getterFor
    };

    /***/
  },

  /***/"6b75":
  /***/function b75(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _arrayLikeToArray;
    });
    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;

      for (var i = 0, arr2 = new Array(len); i < len; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    }

    /***/
  },

  /***/"6d61":
  /***/function d61(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var global = __webpack_require__("da84");
    var isForced = __webpack_require__("94ca");
    var redefine = __webpack_require__("6eeb");
    var InternalMetadataModule = __webpack_require__("f183");
    var iterate = __webpack_require__("2266");
    var anInstance = __webpack_require__("19aa");
    var isObject = __webpack_require__("861d");
    var fails = __webpack_require__("d039");
    var checkCorrectnessOfIteration = __webpack_require__("1c7e");
    var setToStringTag = __webpack_require__("d44e");
    var inheritIfRequired = __webpack_require__("7156");

    module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
      var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
      var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
      var ADDER = IS_MAP ? 'set' : 'add';
      var NativeConstructor = global[CONSTRUCTOR_NAME];
      var NativePrototype = NativeConstructor && NativeConstructor.prototype;
      var Constructor = NativeConstructor;
      var exported = {};

      var fixMethod = function fixMethod(KEY) {
        var nativeMethod = NativePrototype[KEY];
        redefine(NativePrototype, KEY, KEY == 'add' ? function add(value) {
          nativeMethod.call(this, value === 0 ? 0 : value);
          return this;
        } : KEY == 'delete' ? function (key) {
          return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
        } : KEY == 'get' ? function get(key) {
          return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
        } : KEY == 'has' ? function has(key) {
          return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
        } : function set(key, value) {
          nativeMethod.call(this, key === 0 ? 0 : key, value);
          return this;
        });
      };

      // eslint-disable-next-line max-len
      if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
        new NativeConstructor().entries().next();
      })))) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        InternalMetadataModule.REQUIRED = true;
      } else if (isForced(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = fails(function () {
          instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new
        var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) {
          new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && fails(function () {
          // V8 ~ Chromium 42- fails only with 5+ elements
          var $instance = new NativeConstructor();
          var index = 5;
          while (index--) {
            $instance[ADDER](index, index);
          }return !$instance.has(-0);
        });

        if (!ACCEPT_ITERABLES) {
          Constructor = wrapper(function (dummy, iterable) {
            anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
            var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
            if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
            return that;
          });
          Constructor.prototype = NativePrototype;
          NativePrototype.constructor = Constructor;
        }

        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
          fixMethod('delete');
          fixMethod('has');
          IS_MAP && fixMethod('get');
        }

        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
      }

      exported[CONSTRUCTOR_NAME] = Constructor;
      $({ global: true, forced: Constructor != NativeConstructor }, exported);

      setToStringTag(Constructor, CONSTRUCTOR_NAME);

      if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

      return Constructor;
    };

    /***/
  },

  /***/"6eeb":
  /***/function eeb(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var has = __webpack_require__("5135");
    var setGlobal = __webpack_require__("ce4e");
    var inspectSource = __webpack_require__("8925");
    var InternalStateModule = __webpack_require__("69f3");

    var getInternalState = InternalStateModule.get;
    var enforceInternalState = InternalStateModule.enforce;
    var TEMPLATE = String(String).split('String');

    (module.exports = function (O, key, value, options) {
      var unsafe = options ? !!options.unsafe : false;
      var simple = options ? !!options.enumerable : false;
      var noTargetGet = options ? !!options.noTargetGet : false;
      if (typeof value == 'function') {
        if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
        enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
      }
      if (O === global) {
        if (simple) O[key] = value;else setGlobal(key, value);
        return;
      } else if (!unsafe) {
        delete O[key];
      } else if (!noTargetGet && O[key]) {
        simple = true;
      }
      if (simple) O[key] = value;else createNonEnumerableProperty(O, key, value);
      // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, 'toString', function toString() {
      return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
    });

    /***/
  },

  /***/"7156":
  /***/function _(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");
    var setPrototypeOf = __webpack_require__("d2bb");

    // makes subclassing work correct for wrapped built-ins
    module.exports = function ($this, dummy, Wrapper) {
      var NewTarget, NewTargetPrototype;
      if (
      // it can work only with native `setPrototypeOf`
      setPrototypeOf &&
      // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
      typeof (NewTarget = dummy.constructor) == 'function' && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
      return $this;
    };

    /***/
  },

  /***/"7260":
  /***/function _(module, exports, __webpack_require__) {

    // Imports
    var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("24fb");
    exports = ___CSS_LOADER_API_IMPORT___(false);
    // Module
    exports.push([module.i, ".qrcode-stream-wrapper[data-v-35411cc1]{width:100%;height:100%;position:relative;z-index:0}.qrcode-stream-overlay[data-v-35411cc1]{width:100%;height:100%;position:absolute;top:0;left:0}.qrcode-stream-camera[data-v-35411cc1]{width:100%;height:100%;display:block;-o-object-fit:cover;object-fit:cover}.qrcode-stream-camera--hidden[data-v-35411cc1]{visibility:hidden;position:absolute}", ""]);
    // Exports
    module.exports = exports;

    /***/
  },

  /***/"7418":
  /***/function _(module, exports) {

    exports.f = Object.getOwnPropertySymbols;

    /***/
  },

  /***/"746f":
  /***/function f(module, exports, __webpack_require__) {

    var path = __webpack_require__("428f");
    var has = __webpack_require__("5135");
    var wrappedWellKnownSymbolModule = __webpack_require__("e538");
    var defineProperty = __webpack_require__("9bf2").f;

    module.exports = function (NAME) {
      var _Symbol = path.Symbol || (path.Symbol = {});
      if (!has(_Symbol, NAME)) defineProperty(_Symbol, NAME, {
        value: wrappedWellKnownSymbolModule.f(NAME)
      });
    };

    /***/
  },

  /***/"7839":
  /***/function _(module, exports) {

    // IE8- don't enum bug keys
    module.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

    /***/
  },

  /***/"7b0b":
  /***/function b0b(module, exports, __webpack_require__) {

    var requireObjectCoercible = __webpack_require__("1d80");

    // `ToObject` abstract operation
    // https://tc39.github.io/ecma262/#sec-toobject
    module.exports = function (argument) {
      return Object(requireObjectCoercible(argument));
    };

    /***/
  },

  /***/"7c73":
  /***/function c73(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var defineProperties = __webpack_require__("37e8");
    var enumBugKeys = __webpack_require__("7839");
    var hiddenKeys = __webpack_require__("d012");
    var html = __webpack_require__("1be4");
    var documentCreateElement = __webpack_require__("cc12");
    var sharedKey = __webpack_require__("f772");

    var GT = '>';
    var LT = '<';
    var PROTOTYPE = 'prototype';
    var SCRIPT = 'script';
    var IE_PROTO = sharedKey('IE_PROTO');

    var EmptyConstructor = function EmptyConstructor() {/* empty */};

    var scriptTag = function scriptTag(content) {
      return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
    };

    // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
    var NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
      activeXDocument.write(scriptTag(''));
      activeXDocument.close();
      var temp = activeXDocument.parentWindow.Object;
      activeXDocument = null; // avoid memory leak
      return temp;
    };

    // Create object with fake `null` prototype: use iframe Object with cleared prototype
    var NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = documentCreateElement('iframe');
      var JS = 'java' + SCRIPT + ':';
      var iframeDocument;
      iframe.style.display = 'none';
      html.appendChild(iframe);
      // https://github.com/zloirock/core-js/issues/475
      iframe.src = String(JS);
      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(scriptTag('document.F=Object'));
      iframeDocument.close();
      return iframeDocument.F;
    };

    // Check for document.domain and active x support
    // No need to use active x approach when document.domain is not set
    // see https://github.com/es-shims/es5-shim/issues/150
    // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
    // avoid IE GC bug
    var activeXDocument;
    var _NullProtoObject = function NullProtoObject() {
      try {
        /* global ActiveXObject */
        activeXDocument = document.domain && new ActiveXObject('htmlfile');
      } catch (error) {/* ignore */}
      _NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
      var length = enumBugKeys.length;
      while (length--) {
        delete _NullProtoObject[PROTOTYPE][enumBugKeys[length]];
      }return _NullProtoObject();
    };

    hiddenKeys[IE_PROTO] = true;

    // `Object.create` method
    // https://tc39.github.io/ecma262/#sec-object.create
    module.exports = Object.create || function create(O, Properties) {
      var result;
      if (O !== null) {
        EmptyConstructor[PROTOTYPE] = anObject(O);
        result = new EmptyConstructor();
        EmptyConstructor[PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[IE_PROTO] = O;
      } else result = _NullProtoObject();
      return Properties === undefined ? result : defineProperties(result, Properties);
    };

    /***/
  },

  /***/"7db0":
  /***/function db0(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $find = __webpack_require__("b727").find;
    var addToUnscopables = __webpack_require__("44d2");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var FIND = 'find';
    var SKIPS_HOLES = true;

    var USES_TO_LENGTH = arrayMethodUsesToLength(FIND);

    // Shouldn't skip holes
    if (FIND in []) Array(1)[FIND](function () {
      SKIPS_HOLES = false;
    });

    // `Array.prototype.find` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.find
    $({ target: 'Array', proto: true, forced: SKIPS_HOLES || !USES_TO_LENGTH }, {
      find: function find(callbackfn /* , that = undefined */) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables(FIND);

    /***/
  },

  /***/"7dd0":
  /***/function dd0(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var createIteratorConstructor = __webpack_require__("9ed3");
    var getPrototypeOf = __webpack_require__("e163");
    var setPrototypeOf = __webpack_require__("d2bb");
    var setToStringTag = __webpack_require__("d44e");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var redefine = __webpack_require__("6eeb");
    var wellKnownSymbol = __webpack_require__("b622");
    var IS_PURE = __webpack_require__("c430");
    var Iterators = __webpack_require__("3f8c");
    var IteratorsCore = __webpack_require__("ae93");

    var IteratorPrototype = IteratorsCore.IteratorPrototype;
    var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
    var ITERATOR = wellKnownSymbol('iterator');
    var KEYS = 'keys';
    var VALUES = 'values';
    var ENTRIES = 'entries';

    var returnThis = function returnThis() {
      return this;
    };

    module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
      createIteratorConstructor(IteratorConstructor, NAME, next);

      var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch (KIND) {
          case KEYS:
            return function keys() {
              return new IteratorConstructor(this, KIND);
            };
          case VALUES:
            return function values() {
              return new IteratorConstructor(this, KIND);
            };
          case ENTRIES:
            return function entries() {
              return new IteratorConstructor(this, KIND);
            };
        }return function () {
          return new IteratorConstructor(this);
        };
      };

      var TO_STRING_TAG = NAME + ' Iterator';
      var INCORRECT_VALUES_NAME = false;
      var IterablePrototype = Iterable.prototype;
      var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
      var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
      var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
      var CurrentIteratorPrototype, methods, KEY;

      // fix native
      if (anyNativeIterator) {
        CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
          if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
            if (setPrototypeOf) {
              setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
            } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
              createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
            }
          }
          // Set @@toStringTag to native iterators
          setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
          if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
        }
      }

      // fix Array#{values, @@iterator}.name in V8 / FF
      if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
        INCORRECT_VALUES_NAME = true;
        defaultIterator = function values() {
          return nativeIterator.call(this);
        };
      }

      // define iterator
      if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
        createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
      }
      Iterators[NAME] = defaultIterator;

      // export additional methods
      if (DEFAULT) {
        methods = {
          values: getIterationMethod(VALUES),
          keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
          entries: getIterationMethod(ENTRIES)
        };
        if (FORCED) for (KEY in methods) {
          if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
            redefine(IterablePrototype, KEY, methods[KEY]);
          }
        } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
      }

      return methods;
    };

    /***/
  },

  /***/"7f9a":
  /***/function f9a(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var inspectSource = __webpack_require__("8925");

    var WeakMap = global.WeakMap;

    module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

    /***/
  },

  /***/"825a":
  /***/function a(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");

    module.exports = function (it) {
      if (!isObject(it)) {
        throw TypeError(String(it) + ' is not an object');
      }return it;
    };

    /***/
  },

  /***/"83ab":
  /***/function ab(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");

    // Thank's IE8 for his funny defineProperty
    module.exports = !fails(function () {
      return Object.defineProperty({}, 1, { get: function get() {
          return 7;
        } })[1] != 7;
    });

    /***/
  },

  /***/"8418":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var toPrimitive = __webpack_require__("c04e");
    var definePropertyModule = __webpack_require__("9bf2");
    var createPropertyDescriptor = __webpack_require__("5c6c");

    module.exports = function (object, key, value) {
      var propertyKey = toPrimitive(key);
      if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));else object[propertyKey] = value;
    };

    /***/
  },

  /***/"861d":
  /***/function d(module, exports) {

    module.exports = function (it) {
      return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) === 'object' ? it !== null : typeof it === 'function';
    };

    /***/
  },

  /***/"8875":
  /***/function _(module, exports, __webpack_require__) {

    var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; // addapted from the document.currentScript polyfill by Adam Miller
    // MIT license
    // source: https://github.com/amiller-gh/currentScript-polyfill

    // added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

    (function (root, factory) {
      if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
      } else {}
    })(typeof self !== 'undefined' ? self : this, function () {
      function getCurrentScript() {
        var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript');
        // for chrome
        if (!descriptor && 'currentScript' in document && document.currentScript) {
          return document.currentScript;
        }

        // for other browsers with native support for currentScript
        if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
          return document.currentScript;
        }

        // IE 8-10 support script readyState
        // IE 11+ & Firefox support stack trace
        try {
          throw new Error();
        } catch (err) {
          // Find the second match for the "at" string to get file src url from stack.
          var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
              ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
              stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
              scriptLocation = stackDetails && stackDetails[1] || false,
              line = stackDetails && stackDetails[2] || false,
              currentLocation = document.location.href.replace(document.location.hash, ''),
              pageSource,
              inlineScriptSourceRegExp,
              inlineScriptSource,
              scripts = document.getElementsByTagName('script'); // Live NodeList collection

          if (scriptLocation === currentLocation) {
            pageSource = document.documentElement.outerHTML;
            inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
            inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
          }

          for (var i = 0; i < scripts.length; i++) {
            // If ready state is interactive, return the script tag
            if (scripts[i].readyState === 'interactive') {
              return scripts[i];
            }

            // If src matches, return the script tag
            if (scripts[i].src === scriptLocation) {
              return scripts[i];
            }

            // If inline source matches, return the script tag
            if (scriptLocation === currentLocation && scripts[i].innerHTML && scripts[i].innerHTML.trim() === inlineScriptSource) {
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      };

      return getCurrentScript;
    });

    /***/
  },

  /***/"8925":
  /***/function _(module, exports, __webpack_require__) {

    var store = __webpack_require__("c6cd");

    var functionToString = Function.toString;

    // this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
    if (typeof store.inspectSource != 'function') {
      store.inspectSource = function (it) {
        return functionToString.call(it);
      };
    }

    module.exports = store.inspectSource;

    /***/
  },

  /***/"8a79":
  /***/function a79(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
    var toLength = __webpack_require__("50c4");
    var notARegExp = __webpack_require__("5a34");
    var requireObjectCoercible = __webpack_require__("1d80");
    var correctIsRegExpLogic = __webpack_require__("ab13");
    var IS_PURE = __webpack_require__("c430");

    var nativeEndsWith = ''.endsWith;
    var min = Math.min;

    var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
    // https://github.com/zloirock/core-js/pull/702
    var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
      var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
      return descriptor && !descriptor.writable;
    }();

    // `String.prototype.endsWith` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.endswith
    $({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
      endsWith: function endsWith(searchString /* , endPosition = @length */) {
        var that = String(requireObjectCoercible(this));
        notARegExp(searchString);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = toLength(that.length);
        var end = endPosition === undefined ? len : min(toLength(endPosition), len);
        var search = String(searchString);
        return nativeEndsWith ? nativeEndsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
      }
    });

    /***/
  },

  /***/"8aa5":
  /***/function aa5(module, exports, __webpack_require__) {

    "use strict";

    var charAt = __webpack_require__("6547").charAt;

    // `AdvanceStringIndex` abstract operation
    // https://tc39.github.io/ecma262/#sec-advancestringindex
    module.exports = function (S, index, unicode) {
      return index + (unicode ? charAt(S, index).length : 1);
    };

    /***/
  },

  /***/"90e3":
  /***/function e3(module, exports) {

    var id = 0;
    var postfix = Math.random();

    module.exports = function (key) {
      return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
    };

    /***/
  },

  /***/"9112":
  /***/function _(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var definePropertyModule = __webpack_require__("9bf2");
    var createPropertyDescriptor = __webpack_require__("5c6c");

    module.exports = DESCRIPTORS ? function (object, key, value) {
      return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    /***/
  },

  /***/"9263":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    var regexpFlags = __webpack_require__("ad6d");
    var stickyHelpers = __webpack_require__("9f7f");

    var nativeExec = RegExp.prototype.exec;
    // This always refers to the native implementation, because the
    // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
    // which loads this file before patching the method.
    var nativeReplace = String.prototype.replace;

    var patchedExec = nativeExec;

    var UPDATES_LAST_INDEX_WRONG = function () {
      var re1 = /a/;
      var re2 = /b*/g;
      nativeExec.call(re1, 'a');
      nativeExec.call(re2, 'a');
      return re1.lastIndex !== 0 || re2.lastIndex !== 0;
    }();

    var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

    // nonparticipating capturing group, copied from es5-shim's String#split patch.
    var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

    var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

    if (PATCH) {
      patchedExec = function exec(str) {
        var re = this;
        var lastIndex, reCopy, match, i;
        var sticky = UNSUPPORTED_Y && re.sticky;
        var flags = regexpFlags.call(re);
        var source = re.source;
        var charsAdded = 0;
        var strCopy = str;

        if (sticky) {
          flags = flags.replace('y', '');
          if (flags.indexOf('g') === -1) {
            flags += 'g';
          }

          strCopy = String(str).slice(re.lastIndex);
          // Support anchored sticky behavior.
          if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
          }
          // ^(? + rx + ) is needed, in combination with some str slicing, to
          // simulate the 'y' flag.
          reCopy = new RegExp('^(?:' + source + ')', flags);
        }

        if (NPCG_INCLUDED) {
          reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
        }
        if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

        match = nativeExec.call(sticky ? reCopy : re, strCopy);

        if (sticky) {
          if (match) {
            match.input = match.input.slice(charsAdded);
            match[0] = match[0].slice(charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
          } else re.lastIndex = 0;
        } else if (UPDATES_LAST_INDEX_WRONG && match) {
          re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
        }
        if (NPCG_INCLUDED && match && match.length > 1) {
          // Fix browsers whose `exec` methods don't consistently return `undefined`
          // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
          nativeReplace.call(match[0], reCopy, function () {
            for (i = 1; i < arguments.length - 2; i++) {
              if (arguments[i] === undefined) match[i] = undefined;
            }
          });
        }

        return match;
      };
    }

    module.exports = patchedExec;

    /***/
  },

  /***/"94ca":
  /***/function ca(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");

    var replacement = /#|\.prototype\./;

    var isForced = function isForced(feature, detection) {
      var value = data[normalize(feature)];
      return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
    };

    var normalize = isForced.normalize = function (string) {
      return String(string).replace(replacement, '.').toLowerCase();
    };

    var data = isForced.data = {};
    var NATIVE = isForced.NATIVE = 'N';
    var POLYFILL = isForced.POLYFILL = 'P';

    module.exports = isForced;

    /***/
  },

  /***/"96cf":
  /***/function cf(module, exports, __webpack_require__) {

    /**
     * Copyright (c) 2014-present, Facebook, Inc.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */

    var runtime = function (exports) {
      "use strict";

      var Op = Object.prototype;
      var hasOwn = Op.hasOwnProperty;
      var undefined; // More compressible than void 0.
      var $Symbol = typeof Symbol === "function" ? Symbol : {};
      var iteratorSymbol = $Symbol.iterator || "@@iterator";
      var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
      var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

      function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);

        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);

        return generator;
      }
      exports.wrap = wrap;

      // Try/catch helper to minimize deoptimizations. Returns a completion
      // record like context.tryEntries[i].completion. This interface could
      // have been (and was previously) designed to take a closure to be
      // invoked without arguments, but in all the cases we care about we
      // already have an existing method we want to call, so there's no need
      // to create a new function object. We can even get away with assuming
      // the method takes exactly one argument, since that happens to be true
      // in every case, so we don't have to touch the arguments object. The
      // only additional allocation required is the completion record, which
      // has a stable shape and so hopefully should be cheap to allocate.
      function tryCatch(fn, obj, arg) {
        try {
          return { type: "normal", arg: fn.call(obj, arg) };
        } catch (err) {
          return { type: "throw", arg: err };
        }
      }

      var GenStateSuspendedStart = "suspendedStart";
      var GenStateSuspendedYield = "suspendedYield";
      var GenStateExecuting = "executing";
      var GenStateCompleted = "completed";

      // Returning this object from the innerFn has the same effect as
      // breaking out of the dispatch switch statement.
      var ContinueSentinel = {};

      // Dummy constructor functions that we use as the .constructor and
      // .constructor.prototype properties for functions that return Generator
      // objects. For full spec compliance, you may wish to configure your
      // minifier not to mangle the names of these two functions.
      function Generator() {}
      function GeneratorFunction() {}
      function GeneratorFunctionPrototype() {}

      // This is a polyfill for %IteratorPrototype% for environments that
      // don't natively support it.
      var IteratorPrototype = {};
      IteratorPrototype[iteratorSymbol] = function () {
        return this;
      };

      var getProto = Object.getPrototypeOf;
      var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
      if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
        // This environment has a native %IteratorPrototype%; use it instead
        // of the polyfill.
        IteratorPrototype = NativeIteratorPrototype;
      }

      var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
      GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
      GeneratorFunctionPrototype.constructor = GeneratorFunction;
      GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

      // Helper for defining the .next, .throw, and .return methods of the
      // Iterator interface in terms of a single ._invoke method.
      function defineIteratorMethods(prototype) {
        ["next", "throw", "return"].forEach(function (method) {
          prototype[method] = function (arg) {
            return this._invoke(method, arg);
          };
        });
      }

      exports.isGeneratorFunction = function (genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
      };

      exports.mark = function (genFun) {
        if (Object.setPrototypeOf) {
          Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        } else {
          genFun.__proto__ = GeneratorFunctionPrototype;
          if (!(toStringTagSymbol in genFun)) {
            genFun[toStringTagSymbol] = "GeneratorFunction";
          }
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
      };

      // Within the body of any async function, `await x` is transformed to
      // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
      // `hasOwn.call(value, "__await")` to determine if the yielded value is
      // meant to be awaited.
      exports.awrap = function (arg) {
        return { __await: arg };
      };

      function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
          var record = tryCatch(generator[method], generator, arg);
          if (record.type === "throw") {
            reject(record.arg);
          } else {
            var result = record.arg;
            var value = result.value;
            if (value && (typeof value === 'undefined' ? 'undefined' : _typeof2(value)) === "object" && hasOwn.call(value, "__await")) {
              return PromiseImpl.resolve(value.__await).then(function (value) {
                invoke("next", value, resolve, reject);
              }, function (err) {
                invoke("throw", err, resolve, reject);
              });
            }

            return PromiseImpl.resolve(value).then(function (unwrapped) {
              // When a yielded Promise is resolved, its final value becomes
              // the .value of the Promise<{value,done}> result for the
              // current iteration.
              result.value = unwrapped;
              resolve(result);
            }, function (error) {
              // If a rejected Promise was yielded, throw the rejection back
              // into the async generator function so it can be handled there.
              return invoke("throw", error, resolve, reject);
            });
          }
        }

        var previousPromise;

        function enqueue(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }

          return previousPromise =
          // If enqueue has been called before, then we want to wait until
          // all previous Promises have been resolved before calling invoke,
          // so that results are always delivered in the correct order. If
          // enqueue has not been called before, then it is important to
          // call invoke immediately, without waiting on a callback to fire,
          // so that the async generator function has the opportunity to do
          // any necessary setup in a predictable way. This predictability
          // is why the Promise constructor synchronously invokes its
          // executor callback, and why async functions synchronously
          // execute code before the first await. Since we implement simple
          // async functions in terms of async generators, it is especially
          // important to get this right, even though it requires care.
          previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }

        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
      }

      defineIteratorMethods(AsyncIterator.prototype);
      AsyncIterator.prototype[asyncIteratorSymbol] = function () {
        return this;
      };
      exports.AsyncIterator = AsyncIterator;

      // Note that simple async functions are implemented on top of
      // AsyncIterator objects; they just return a Promise for the value of
      // the final result produced by the iterator.
      exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;

        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);

        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
        : iter.next().then(function (result) {
          return result.done ? result.value : iter.next();
        });
      };

      function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;

        return function invoke(method, arg) {
          if (state === GenStateExecuting) {
            throw new Error("Generator is already running");
          }

          if (state === GenStateCompleted) {
            if (method === "throw") {
              throw arg;
            }

            // Be forgiving, per 25.3.3.3.3 of the spec:
            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
            return doneResult();
          }

          context.method = method;
          context.arg = arg;

          while (true) {
            var delegate = context.delegate;
            if (delegate) {
              var delegateResult = maybeInvokeDelegate(delegate, context);
              if (delegateResult) {
                if (delegateResult === ContinueSentinel) continue;
                return delegateResult;
              }
            }

            if (context.method === "next") {
              // Setting context._sent for legacy support of Babel's
              // function.sent implementation.
              context.sent = context._sent = context.arg;
            } else if (context.method === "throw") {
              if (state === GenStateSuspendedStart) {
                state = GenStateCompleted;
                throw context.arg;
              }

              context.dispatchException(context.arg);
            } else if (context.method === "return") {
              context.abrupt("return", context.arg);
            }

            state = GenStateExecuting;

            var record = tryCatch(innerFn, self, context);
            if (record.type === "normal") {
              // If an exception is thrown from innerFn, we leave state ===
              // GenStateExecuting and loop back for another invocation.
              state = context.done ? GenStateCompleted : GenStateSuspendedYield;

              if (record.arg === ContinueSentinel) {
                continue;
              }

              return {
                value: record.arg,
                done: context.done
              };
            } else if (record.type === "throw") {
              state = GenStateCompleted;
              // Dispatch the exception by looping back around to the
              // context.dispatchException(context.arg) call above.
              context.method = "throw";
              context.arg = record.arg;
            }
          }
        };
      }

      // Call delegate.iterator[context.method](context.arg) and handle the
      // result, either by returning a { value, done } result from the
      // delegate iterator, or by modifying context.method and context.arg,
      // setting context.delegate to null, and returning the ContinueSentinel.
      function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
          // A .throw or .return when the delegate iterator has no .throw
          // method always terminates the yield* loop.
          context.delegate = null;

          if (context.method === "throw") {
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (delegate.iterator["return"]) {
              // If the delegate iterator has a return method, give it a
              // chance to clean up.
              context.method = "return";
              context.arg = undefined;
              maybeInvokeDelegate(delegate, context);

              if (context.method === "throw") {
                // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
              }
            }

            context.method = "throw";
            context.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return ContinueSentinel;
        }

        var record = tryCatch(method, delegate.iterator, context.arg);

        if (record.type === "throw") {
          context.method = "throw";
          context.arg = record.arg;
          context.delegate = null;
          return ContinueSentinel;
        }

        var info = record.arg;

        if (!info) {
          context.method = "throw";
          context.arg = new TypeError("iterator result is not an object");
          context.delegate = null;
          return ContinueSentinel;
        }

        if (info.done) {
          // Assign the result of the finished delegate to the temporary
          // variable specified by delegate.resultName (see delegateYield).
          context[delegate.resultName] = info.value;

          // Resume execution at the desired location (see delegateYield).
          context.next = delegate.nextLoc;

          // If context.method was "throw" but the delegate handled the
          // exception, let the outer generator proceed normally. If
          // context.method was "next", forget context.arg since it has been
          // "consumed" by the delegate iterator. If context.method was
          // "return", allow the original .return call to continue in the
          // outer generator.
          if (context.method !== "return") {
            context.method = "next";
            context.arg = undefined;
          }
        } else {
          // Re-yield the result returned by the delegate method.
          return info;
        }

        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
      }

      // Define Generator.prototype.{next,throw,return} in terms of the
      // unified ._invoke helper method.
      defineIteratorMethods(Gp);

      Gp[toStringTagSymbol] = "Generator";

      // A Generator should always return itself as the iterator object when the
      // @@iterator function is called on it. Some browsers' implementations of the
      // iterator prototype chain incorrectly implement this, causing the Generator
      // object to not be returned from this call. This ensures that doesn't happen.
      // See https://github.com/facebook/regenerator/issues/274 for more details.
      Gp[iteratorSymbol] = function () {
        return this;
      };

      Gp.toString = function () {
        return "[object Generator]";
      };

      function pushTryEntry(locs) {
        var entry = { tryLoc: locs[0] };

        if (1 in locs) {
          entry.catchLoc = locs[1];
        }

        if (2 in locs) {
          entry.finallyLoc = locs[2];
          entry.afterLoc = locs[3];
        }

        this.tryEntries.push(entry);
      }

      function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
      }

      function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [{ tryLoc: "root" }];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
      }

      exports.keys = function (object) {
        var keys = [];
        for (var key in object) {
          keys.push(key);
        }
        keys.reverse();

        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
          while (keys.length) {
            var key = keys.pop();
            if (key in object) {
              next.value = key;
              next.done = false;
              return next;
            }
          }

          // To avoid creating an additional object, we just hang the .value
          // and .done properties off the next function object itself. This
          // also ensures that the minifier will not anonymize the function.
          next.done = true;
          return next;
        };
      };

      function values(iterable) {
        if (iterable) {
          var iteratorMethod = iterable[iteratorSymbol];
          if (iteratorMethod) {
            return iteratorMethod.call(iterable);
          }

          if (typeof iterable.next === "function") {
            return iterable;
          }

          if (!isNaN(iterable.length)) {
            var i = -1,
                next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }

              next.value = undefined;
              next.done = true;

              return next;
            };

            return next.next = next;
          }
        }

        // Return an iterator with no values.
        return { next: doneResult };
      }
      exports.values = values;

      function doneResult() {
        return { value: undefined, done: true };
      }

      Context.prototype = {
        constructor: Context,

        reset: function reset(skipTempReset) {
          this.prev = 0;
          this.next = 0;
          // Resetting context._sent for legacy support of Babel's
          // function.sent implementation.
          this.sent = this._sent = undefined;
          this.done = false;
          this.delegate = null;

          this.method = "next";
          this.arg = undefined;

          this.tryEntries.forEach(resetTryEntry);

          if (!skipTempReset) {
            for (var name in this) {
              // Not sure about the optimal order of these conditions:
              if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                this[name] = undefined;
              }
            }
          }
        },

        stop: function stop() {
          this.done = true;

          var rootEntry = this.tryEntries[0];
          var rootRecord = rootEntry.completion;
          if (rootRecord.type === "throw") {
            throw rootRecord.arg;
          }

          return this.rval;
        },

        dispatchException: function dispatchException(exception) {
          if (this.done) {
            throw exception;
          }

          var context = this;
          function handle(loc, caught) {
            record.type = "throw";
            record.arg = exception;
            context.next = loc;

            if (caught) {
              // If the dispatched exception was caught by a catch block,
              // then let that catch block handle the exception normally.
              context.method = "next";
              context.arg = undefined;
            }

            return !!caught;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            var record = entry.completion;

            if (entry.tryLoc === "root") {
              // Exception thrown outside of any try block that could handle
              // it, so set the completion value of the entire function to
              // throw the exception.
              return handle("end");
            }

            if (entry.tryLoc <= this.prev) {
              var hasCatch = hasOwn.call(entry, "catchLoc");
              var hasFinally = hasOwn.call(entry, "finallyLoc");

              if (hasCatch && hasFinally) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                } else if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else if (hasCatch) {
                if (this.prev < entry.catchLoc) {
                  return handle(entry.catchLoc, true);
                }
              } else if (hasFinally) {
                if (this.prev < entry.finallyLoc) {
                  return handle(entry.finallyLoc);
                }
              } else {
                throw new Error("try statement without catch or finally");
              }
            }
          }
        },

        abrupt: function abrupt(type, arg) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
              var finallyEntry = entry;
              break;
            }
          }

          if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
            // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
          }

          var record = finallyEntry ? finallyEntry.completion : {};
          record.type = type;
          record.arg = arg;

          if (finallyEntry) {
            this.method = "next";
            this.next = finallyEntry.finallyLoc;
            return ContinueSentinel;
          }

          return this.complete(record);
        },

        complete: function complete(record, afterLoc) {
          if (record.type === "throw") {
            throw record.arg;
          }

          if (record.type === "break" || record.type === "continue") {
            this.next = record.arg;
          } else if (record.type === "return") {
            this.rval = this.arg = record.arg;
            this.method = "return";
            this.next = "end";
          } else if (record.type === "normal" && afterLoc) {
            this.next = afterLoc;
          }

          return ContinueSentinel;
        },

        finish: function finish(finallyLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc) {
              this.complete(entry.completion, entry.afterLoc);
              resetTryEntry(entry);
              return ContinueSentinel;
            }
          }
        },

        "catch": function _catch(tryLoc) {
          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
              var record = entry.completion;
              if (record.type === "throw") {
                var thrown = record.arg;
                resetTryEntry(entry);
              }
              return thrown;
            }
          }

          // The context.catch method must only be called with a location
          // argument that corresponds to a known catch block.
          throw new Error("illegal catch attempt");
        },

        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
          this.delegate = {
            iterator: values(iterable),
            resultName: resultName,
            nextLoc: nextLoc
          };

          if (this.method === "next") {
            // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
          }

          return ContinueSentinel;
        }
      };

      // Regardless of whether this script is executing as a CommonJS module
      // or not, return the runtime object so that we can declare the variable
      // regeneratorRuntime in the outer scope, which allows this module to be
      // injected easily by `bin/regenerator --include-runtime script.js`.
      return exports;
    }(
    // If this script is executing as a CommonJS module, use module.exports
    // as the regeneratorRuntime namespace. Otherwise create a new empty
    // object. Either way, the resulting object will be used to initialize
    // the regeneratorRuntime variable at the top of this file.
    true ? module.exports : undefined);

    try {
      regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
      // This module should not be running in strict mode, so the above
      // assignment should always work unless something is misconfigured. Just
      // in case runtime.js accidentally runs in strict mode, we can escape
      // strict mode using a global Function call. This could conceivably fail
      // if a Content Security Policy forbids using Function, but in that case
      // the proper solution is to fix the accidental strict mode problem. If
      // you've misconfigured your bundler to force strict mode and applied a
      // CSP to forbid Function, and you're not willing to fix either of those
      // problems, please detail your unique predicament in a GitHub issue.
      Function("r", "regeneratorRuntime = r")(runtime);
    }

    /***/
  },

  /***/"9861":
  /***/function _(module, exports, __webpack_require__) {

    "use strict";

    // TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

    __webpack_require__("e260");
    var $ = __webpack_require__("23e7");
    var getBuiltIn = __webpack_require__("d066");
    var USE_NATIVE_URL = __webpack_require__("0d3b");
    var redefine = __webpack_require__("6eeb");
    var redefineAll = __webpack_require__("e2cc");
    var setToStringTag = __webpack_require__("d44e");
    var createIteratorConstructor = __webpack_require__("9ed3");
    var InternalStateModule = __webpack_require__("69f3");
    var anInstance = __webpack_require__("19aa");
    var hasOwn = __webpack_require__("5135");
    var bind = __webpack_require__("0366");
    var classof = __webpack_require__("f5df");
    var anObject = __webpack_require__("825a");
    var isObject = __webpack_require__("861d");
    var create = __webpack_require__("7c73");
    var createPropertyDescriptor = __webpack_require__("5c6c");
    var getIterator = __webpack_require__("9a1f");
    var getIteratorMethod = __webpack_require__("35a1");
    var wellKnownSymbol = __webpack_require__("b622");

    var $fetch = getBuiltIn('fetch');
    var Headers = getBuiltIn('Headers');
    var ITERATOR = wellKnownSymbol('iterator');
    var URL_SEARCH_PARAMS = 'URLSearchParams';
    var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
    var setInternalState = InternalStateModule.set;
    var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
    var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

    var plus = /\+/g;
    var sequences = Array(4);

    var percentSequence = function percentSequence(bytes) {
      return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
    };

    var percentDecode = function percentDecode(sequence) {
      try {
        return decodeURIComponent(sequence);
      } catch (error) {
        return sequence;
      }
    };

    var deserialize = function deserialize(it) {
      var result = it.replace(plus, ' ');
      var bytes = 4;
      try {
        return decodeURIComponent(result);
      } catch (error) {
        while (bytes) {
          result = result.replace(percentSequence(bytes--), percentDecode);
        }
        return result;
      }
    };

    var find = /[!'()~]|%20/g;

    var replace = {
      '!': '%21',
      "'": '%27',
      '(': '%28',
      ')': '%29',
      '~': '%7E',
      '%20': '+'
    };

    var replacer = function replacer(match) {
      return replace[match];
    };

    var serialize = function serialize(it) {
      return encodeURIComponent(it).replace(find, replacer);
    };

    var parseSearchParams = function parseSearchParams(result, query) {
      if (query) {
        var attributes = query.split('&');
        var index = 0;
        var attribute, entry;
        while (index < attributes.length) {
          attribute = attributes[index++];
          if (attribute.length) {
            entry = attribute.split('=');
            result.push({
              key: deserialize(entry.shift()),
              value: deserialize(entry.join('='))
            });
          }
        }
      }
    };

    var updateSearchParams = function updateSearchParams(query) {
      this.entries.length = 0;
      parseSearchParams(this.entries, query);
    };

    var validateArgumentsLength = function validateArgumentsLength(passed, required) {
      if (passed < required) throw TypeError('Not enough arguments');
    };

    var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
      setInternalState(this, {
        type: URL_SEARCH_PARAMS_ITERATOR,
        iterator: getIterator(getInternalParamsState(params).entries),
        kind: kind
      });
    }, 'Iterator', function next() {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var step = state.iterator.next();
      var entry = step.value;
      if (!step.done) {
        step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
      }return step;
    });

    // `URLSearchParams` constructor
    // https://url.spec.whatwg.org/#interface-urlsearchparams
    var URLSearchParamsConstructor = function URLSearchParams() /* init */{
      anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
      var init = arguments.length > 0 ? arguments[0] : undefined;
      var that = this;
      var entries = [];
      var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

      setInternalState(that, {
        type: URL_SEARCH_PARAMS,
        entries: entries,
        updateURL: function updateURL() {/* empty */},
        updateSearchParams: updateSearchParams
      });

      if (init !== undefined) {
        if (isObject(init)) {
          iteratorMethod = getIteratorMethod(init);
          if (typeof iteratorMethod === 'function') {
            iterator = iteratorMethod.call(init);
            next = iterator.next;
            while (!(step = next.call(iterator)).done) {
              entryIterator = getIterator(anObject(step.value));
              entryNext = entryIterator.next;
              if ((first = entryNext.call(entryIterator)).done || (second = entryNext.call(entryIterator)).done || !entryNext.call(entryIterator).done) throw TypeError('Expected sequence with length 2');
              entries.push({ key: first.value + '', value: second.value + '' });
            }
          } else for (key in init) {
            if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
          }
        } else {
          parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
        }
      }
    };

    var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

    redefineAll(URLSearchParamsPrototype, {
      // `URLSearchParams.prototype.appent` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-append
      append: function append(name, value) {
        validateArgumentsLength(arguments.length, 2);
        var state = getInternalParamsState(this);
        state.entries.push({ key: name + '', value: value + '' });
        state.updateURL();
      },
      // `URLSearchParams.prototype.delete` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
      'delete': function _delete(name) {
        validateArgumentsLength(arguments.length, 1);
        var state = getInternalParamsState(this);
        var entries = state.entries;
        var key = name + '';
        var index = 0;
        while (index < entries.length) {
          if (entries[index].key === key) entries.splice(index, 1);else index++;
        }
        state.updateURL();
      },
      // `URLSearchParams.prototype.get` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-get
      get: function get(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = name + '';
        var index = 0;
        for (; index < entries.length; index++) {
          if (entries[index].key === key) return entries[index].value;
        }
        return null;
      },
      // `URLSearchParams.prototype.getAll` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
      getAll: function getAll(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = name + '';
        var result = [];
        var index = 0;
        for (; index < entries.length; index++) {
          if (entries[index].key === key) result.push(entries[index].value);
        }
        return result;
      },
      // `URLSearchParams.prototype.has` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-has
      has: function has(name) {
        validateArgumentsLength(arguments.length, 1);
        var entries = getInternalParamsState(this).entries;
        var key = name + '';
        var index = 0;
        while (index < entries.length) {
          if (entries[index++].key === key) return true;
        }
        return false;
      },
      // `URLSearchParams.prototype.set` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-set
      set: function set(name, value) {
        validateArgumentsLength(arguments.length, 1);
        var state = getInternalParamsState(this);
        var entries = state.entries;
        var found = false;
        var key = name + '';
        var val = value + '';
        var index = 0;
        var entry;
        for (; index < entries.length; index++) {
          entry = entries[index];
          if (entry.key === key) {
            if (found) entries.splice(index--, 1);else {
              found = true;
              entry.value = val;
            }
          }
        }
        if (!found) entries.push({ key: key, value: val });
        state.updateURL();
      },
      // `URLSearchParams.prototype.sort` method
      // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
      sort: function sort() {
        var state = getInternalParamsState(this);
        var entries = state.entries;
        // Array#sort is not stable in some engines
        var slice = entries.slice();
        var entry, entriesIndex, sliceIndex;
        entries.length = 0;
        for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
          entry = slice[sliceIndex];
          for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
            if (entries[entriesIndex].key > entry.key) {
              entries.splice(entriesIndex, 0, entry);
              break;
            }
          }
          if (entriesIndex === sliceIndex) entries.push(entry);
        }
        state.updateURL();
      },
      // `URLSearchParams.prototype.forEach` method
      forEach: function forEach(callback /* , thisArg */) {
        var entries = getInternalParamsState(this).entries;
        var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
        var index = 0;
        var entry;
        while (index < entries.length) {
          entry = entries[index++];
          boundFunction(entry.value, entry.key, this);
        }
      },
      // `URLSearchParams.prototype.keys` method
      keys: function keys() {
        return new URLSearchParamsIterator(this, 'keys');
      },
      // `URLSearchParams.prototype.values` method
      values: function values() {
        return new URLSearchParamsIterator(this, 'values');
      },
      // `URLSearchParams.prototype.entries` method
      entries: function entries() {
        return new URLSearchParamsIterator(this, 'entries');
      }
    }, { enumerable: true });

    // `URLSearchParams.prototype[@@iterator]` method
    redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

    // `URLSearchParams.prototype.toString` method
    // https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
    redefine(URLSearchParamsPrototype, 'toString', function toString() {
      var entries = getInternalParamsState(this).entries;
      var result = [];
      var index = 0;
      var entry;
      while (index < entries.length) {
        entry = entries[index++];
        result.push(serialize(entry.key) + '=' + serialize(entry.value));
      }return result.join('&');
    }, { enumerable: true });

    setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

    $({ global: true, forced: !USE_NATIVE_URL }, {
      URLSearchParams: URLSearchParamsConstructor
    });

    // Wrap `fetch` for correct work with polyfilled `URLSearchParams`
    // https://github.com/zloirock/core-js/issues/674
    if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
      $({ global: true, enumerable: true, forced: true }, {
        fetch: function fetch(input /* , init */) {
          var args = [input];
          var init, body, headers;
          if (arguments.length > 1) {
            init = arguments[1];
            if (isObject(init)) {
              body = init.body;
              if (classof(body) === URL_SEARCH_PARAMS) {
                headers = init.headers ? new Headers(init.headers) : new Headers();
                if (!headers.has('content-type')) {
                  headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
                init = create(init, {
                  body: createPropertyDescriptor(0, String(body)),
                  headers: createPropertyDescriptor(0, headers)
                });
              }
            }
            args.push(init);
          }return $fetch.apply(this, args);
        }
      });
    }

    module.exports = {
      URLSearchParams: URLSearchParamsConstructor,
      getState: getInternalParamsState
    };

    /***/
  },

  /***/"99af":
  /***/function af(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var fails = __webpack_require__("d039");
    var isArray = __webpack_require__("e8b5");
    var isObject = __webpack_require__("861d");
    var toObject = __webpack_require__("7b0b");
    var toLength = __webpack_require__("50c4");
    var createProperty = __webpack_require__("8418");
    var arraySpeciesCreate = __webpack_require__("65f0");
    var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
    var wellKnownSymbol = __webpack_require__("b622");
    var V8_VERSION = __webpack_require__("2d00");

    var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/679
    var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
      var array = [];
      array[IS_CONCAT_SPREADABLE] = false;
      return array.concat()[0] !== array;
    });

    var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

    var isConcatSpreadable = function isConcatSpreadable(O) {
      if (!isObject(O)) return false;
      var spreadable = O[IS_CONCAT_SPREADABLE];
      return spreadable !== undefined ? !!spreadable : isArray(O);
    };

    var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

    // `Array.prototype.concat` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.concat
    // with adding support of @@isConcatSpreadable and @@species
    $({ target: 'Array', proto: true, forced: FORCED }, {
      concat: function concat(arg) {
        // eslint-disable-line no-unused-vars
        var O = toObject(this);
        var A = arraySpeciesCreate(O, 0);
        var n = 0;
        var i, k, length, len, E;
        for (i = -1, length = arguments.length; i < length; i++) {
          E = i === -1 ? O : arguments[i];
          if (isConcatSpreadable(E)) {
            len = toLength(E.length);
            if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
            for (k = 0; k < len; k++, n++) {
              if (k in E) createProperty(A, n, E[k]);
            }
          } else {
            if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
            createProperty(A, n++, E);
          }
        }
        A.length = n;
        return A;
      }
    });

    /***/
  },

  /***/"9a1f":
  /***/function a1f(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var getIteratorMethod = __webpack_require__("35a1");

    module.exports = function (it) {
      var iteratorMethod = getIteratorMethod(it);
      if (typeof iteratorMethod != 'function') {
        throw TypeError(String(it) + ' is not iterable');
      }return anObject(iteratorMethod.call(it));
    };

    /***/
  },

  /***/"9bdd":
  /***/function bdd(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");

    // call something on iterator step with safe closing on error
    module.exports = function (iterator, fn, value, ENTRIES) {
      try {
        return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
      } catch (error) {
        var returnMethod = iterator['return'];
        if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
        throw error;
      }
    };

    /***/
  },

  /***/"9bf2":
  /***/function bf2(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var IE8_DOM_DEFINE = __webpack_require__("0cfb");
    var anObject = __webpack_require__("825a");
    var toPrimitive = __webpack_require__("c04e");

    var nativeDefineProperty = Object.defineProperty;

    // `Object.defineProperty` method
    // https://tc39.github.io/ecma262/#sec-object.defineproperty
    exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return nativeDefineProperty(O, P, Attributes);
      } catch (error) {/* empty */}
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    /***/
  },

  /***/"9ed3":
  /***/function ed3(module, exports, __webpack_require__) {

    "use strict";

    var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
    var create = __webpack_require__("7c73");
    var createPropertyDescriptor = __webpack_require__("5c6c");
    var setToStringTag = __webpack_require__("d44e");
    var Iterators = __webpack_require__("3f8c");

    var returnThis = function returnThis() {
      return this;
    };

    module.exports = function (IteratorConstructor, NAME, next) {
      var TO_STRING_TAG = NAME + ' Iterator';
      IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
      setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
      Iterators[TO_STRING_TAG] = returnThis;
      return IteratorConstructor;
    };

    /***/
  },

  /***/"9f7f":
  /***/function f7f(module, exports, __webpack_require__) {

    "use strict";

    var fails = __webpack_require__("d039");

    // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
    // so we use an intermediate function.
    function RE(s, f) {
      return RegExp(s, f);
    }

    exports.UNSUPPORTED_Y = fails(function () {
      // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
      var re = RE('a', 'y');
      re.lastIndex = 2;
      return re.exec('abcd') != null;
    });

    exports.BROKEN_CARET = fails(function () {
      // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
      var re = RE('^r', 'gy');
      re.lastIndex = 2;
      return re.exec('str') != null;
    });

    /***/
  },

  /***/"a180":
  /***/function a180(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return keepScanning;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
      return processFile;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "c", function () {
      return processUrl;
    });
    /* harmony import */var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("caad");
    /* harmony import */var core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("2532");
    /* harmony import */var core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2ca0");
    /* harmony import */var core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_starts_with__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("96cf");
    /* harmony import */var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */var _home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("1da1");
    /* harmony import */var _home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("3835");
    /* harmony import */var _errors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("1cc0");
    /* harmony import */var callforth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("c036");

    var adaptOldFormat = function adaptOldFormat(detectedCodes) {
      if (detectedCodes.length > 0) {
        var _detectedCodes = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(detectedCodes, 1),
            firstCode = _detectedCodes[0];

        var _firstCode$cornerPoin = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_5__[/* default */"a"])(firstCode.cornerPoints, 4),
            topLeftCorner = _firstCode$cornerPoin[0],
            topRightCorner = _firstCode$cornerPoin[1],
            bottomRightCorner = _firstCode$cornerPoin[2],
            bottomLeftCorner = _firstCode$cornerPoin[3];

        return {
          content: firstCode.rawValue,
          location: {
            topLeftCorner: topLeftCorner,
            topRightCorner: topRightCorner,
            bottomRightCorner: bottomRightCorner,
            bottomLeftCorner: bottomLeftCorner,
            // not supported by native API:
            topLeftFinderPattern: {},
            topRightFinderPattern: {},
            bottomLeftFinderPattern: {}
          },
          imageData: null
        };
      } else {
        return {
          content: null,
          location: null,
          imageData: null
        };
      }
    };
    /**
     * Continuously extracts frames from camera stream and tries to read
     * potentially pictured QR codes.
     */

    var keepScanning = function keepScanning(videoElement, options) {
      var barcodeDetector = new BarcodeDetector({
        formats: ["qr_code"]
      });
      var detectHandler = options.detectHandler,
          locateHandler = options.locateHandler,
          minDelay = options.minDelay;

      var processFrame = function processFrame(state) {
        return (/*#__PURE__*/function () {
            var _ref = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee(timeNow) {
              var lastScanned, contentBefore, locationBefore, detectedCodes, _adaptOldFormat, content, _location, imageData;

              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(videoElement.readyState > 1)) {
                        _context.next = 13;
                        break;
                      }

                      lastScanned = state.lastScanned, contentBefore = state.contentBefore, locationBefore = state.locationBefore;

                      if (!(timeNow - lastScanned >= minDelay)) {
                        _context.next = 12;
                        break;
                      }

                      _context.next = 5;
                      return barcodeDetector.detect(videoElement);

                    case 5:
                      detectedCodes = _context.sent;
                      _adaptOldFormat = adaptOldFormat(detectedCodes), content = _adaptOldFormat.content, _location = _adaptOldFormat.location, imageData = _adaptOldFormat.imageData;

                      if (content !== null && content !== contentBefore) {
                        detectHandler({
                          content: content,
                          location: _location,
                          imageData: imageData
                        });
                      }

                      if (_location !== null || locationBefore !== null) {
                        locateHandler(detectedCodes);
                      }

                      window.requestAnimationFrame(processFrame({
                        lastScanned: timeNow,
                        contentBefore: content !== null && content !== void 0 ? content : contentBefore,
                        locationBefore: _location
                      }));
                      _context.next = 13;
                      break;

                    case 12:
                      window.requestAnimationFrame(processFrame(state));

                    case 13:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()
        );
      };

      processFrame({
        contentBefore: null,
        locationBefore: null,
        lastScanned: performance.now()
      })();
    };

    var imageElementFromUrl = /*#__PURE__*/function () {
      var _ref2 = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
        var image;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(url.startsWith("http") && url.includes(location.host) === false)) {
                  _context2.next = 2;
                  break;
                }

                throw new _errors_js__WEBPACK_IMPORTED_MODULE_6__[/* DropImageFetchError */"a"]();

              case 2:
                image = document.createElement("img");
                image.src = url;
                _context2.next = 6;
                return Object(callforth__WEBPACK_IMPORTED_MODULE_7__[/* eventOn */"a"])(image, "load");

              case 6:
                return _context2.abrupt("return", image);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function imageElementFromUrl(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var processFile = /*#__PURE__*/function () {
      var _ref3 = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file) {
        var barcodeDetector, detectedCodes;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                barcodeDetector = new BarcodeDetector({
                  formats: ["qr_code"]
                });
                _context3.next = 3;
                return barcodeDetector.detect(file);

              case 3:
                detectedCodes = _context3.sent;
                return _context3.abrupt("return", adaptOldFormat(detectedCodes));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function processFile(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var processUrl = /*#__PURE__*/function () {
      var _ref4 = Object(_home_runner_work_vue_qrcode_reader_vue_qrcode_reader_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__[/* default */"a"])( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url) {
        var barcodeDetector, image, detectedCodes;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                barcodeDetector = new BarcodeDetector({
                  formats: ["qr_code"]
                });
                _context4.next = 3;
                return imageElementFromUrl(url);

              case 3:
                image = _context4.sent;
                _context4.next = 6;
                return barcodeDetector.detect(image);

              case 6:
                detectedCodes = _context4.sent;
                return _context4.abrupt("return", adaptOldFormat(detectedCodes));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function processUrl(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    /***/
  },

  /***/"a434":
  /***/function a434(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var toAbsoluteIndex = __webpack_require__("23cb");
    var toInteger = __webpack_require__("a691");
    var toLength = __webpack_require__("50c4");
    var toObject = __webpack_require__("7b0b");
    var arraySpeciesCreate = __webpack_require__("65f0");
    var createProperty = __webpack_require__("8418");
    var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
    var USES_TO_LENGTH = arrayMethodUsesToLength('splice', { ACCESSORS: true, 0: 0, 1: 2 });

    var max = Math.max;
    var min = Math.min;
    var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
    var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

    // `Array.prototype.splice` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.splice
    // with adding support of @@species
    $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
      splice: function splice(start, deleteCount /* , ...items */) {
        var O = toObject(this);
        var len = toLength(O.length);
        var actualStart = toAbsoluteIndex(start, len);
        var argumentsLength = arguments.length;
        var insertCount, actualDeleteCount, A, k, from, to;
        if (argumentsLength === 0) {
          insertCount = actualDeleteCount = 0;
        } else if (argumentsLength === 1) {
          insertCount = 0;
          actualDeleteCount = len - actualStart;
        } else {
          insertCount = argumentsLength - 2;
          actualDeleteCount = min(max(toInteger(deleteCount), 0), len - actualStart);
        }
        if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
          throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
        }
        A = arraySpeciesCreate(O, actualDeleteCount);
        for (k = 0; k < actualDeleteCount; k++) {
          from = actualStart + k;
          if (from in O) createProperty(A, k, O[from]);
        }
        A.length = actualDeleteCount;
        if (insertCount < actualDeleteCount) {
          for (k = actualStart; k < len - actualDeleteCount; k++) {
            from = k + actualDeleteCount;
            to = k + insertCount;
            if (from in O) O[to] = O[from];else delete O[to];
          }
          for (k = len; k > len - actualDeleteCount + insertCount; k--) {
            delete O[k - 1];
          }
        } else if (insertCount > actualDeleteCount) {
          for (k = len - actualDeleteCount; k > actualStart; k--) {
            from = k + actualDeleteCount - 1;
            to = k + insertCount - 1;
            if (from in O) O[to] = O[from];else delete O[to];
          }
        }
        for (k = 0; k < insertCount; k++) {
          O[k + actualStart] = arguments[k + 2];
        }
        O.length = len - actualDeleteCount + insertCount;
        return A;
      }
    });

    /***/
  },

  /***/"a4d3":
  /***/function a4d3(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var global = __webpack_require__("da84");
    var getBuiltIn = __webpack_require__("d066");
    var IS_PURE = __webpack_require__("c430");
    var DESCRIPTORS = __webpack_require__("83ab");
    var NATIVE_SYMBOL = __webpack_require__("4930");
    var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
    var fails = __webpack_require__("d039");
    var has = __webpack_require__("5135");
    var isArray = __webpack_require__("e8b5");
    var isObject = __webpack_require__("861d");
    var anObject = __webpack_require__("825a");
    var toObject = __webpack_require__("7b0b");
    var toIndexedObject = __webpack_require__("fc6a");
    var toPrimitive = __webpack_require__("c04e");
    var createPropertyDescriptor = __webpack_require__("5c6c");
    var nativeObjectCreate = __webpack_require__("7c73");
    var objectKeys = __webpack_require__("df75");
    var getOwnPropertyNamesModule = __webpack_require__("241c");
    var getOwnPropertyNamesExternal = __webpack_require__("057f");
    var getOwnPropertySymbolsModule = __webpack_require__("7418");
    var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
    var definePropertyModule = __webpack_require__("9bf2");
    var propertyIsEnumerableModule = __webpack_require__("d1e7");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var redefine = __webpack_require__("6eeb");
    var shared = __webpack_require__("5692");
    var sharedKey = __webpack_require__("f772");
    var hiddenKeys = __webpack_require__("d012");
    var uid = __webpack_require__("90e3");
    var wellKnownSymbol = __webpack_require__("b622");
    var wrappedWellKnownSymbolModule = __webpack_require__("e538");
    var defineWellKnownSymbol = __webpack_require__("746f");
    var setToStringTag = __webpack_require__("d44e");
    var InternalStateModule = __webpack_require__("69f3");
    var $forEach = __webpack_require__("b727").forEach;

    var HIDDEN = sharedKey('hidden');
    var SYMBOL = 'Symbol';
    var PROTOTYPE = 'prototype';
    var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
    var setInternalState = InternalStateModule.set;
    var getInternalState = InternalStateModule.getterFor(SYMBOL);
    var ObjectPrototype = Object[PROTOTYPE];
    var $Symbol = global.Symbol;
    var $stringify = getBuiltIn('JSON', 'stringify');
    var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var nativeDefineProperty = definePropertyModule.f;
    var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
    var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
    var AllSymbols = shared('symbols');
    var ObjectPrototypeSymbols = shared('op-symbols');
    var StringToSymbolRegistry = shared('string-to-symbol-registry');
    var SymbolToStringRegistry = shared('symbol-to-string-registry');
    var WellKnownSymbolsStore = shared('wks');
    var QObject = global.QObject;
    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
    var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
    var setSymbolDescriptor = DESCRIPTORS && fails(function () {
      return nativeObjectCreate(nativeDefineProperty({}, 'a', {
        get: function get() {
          return nativeDefineProperty(this, 'a', { value: 7 }).a;
        }
      })).a != 7;
    }) ? function (O, P, Attributes) {
      var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
      if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
      nativeDefineProperty(O, P, Attributes);
      if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
        nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
      }
    } : nativeDefineProperty;

    var wrap = function wrap(tag, description) {
      var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
      setInternalState(symbol, {
        type: SYMBOL,
        tag: tag,
        description: description
      });
      if (!DESCRIPTORS) symbol.description = description;
      return symbol;
    };

    var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
      return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) == 'symbol';
    } : function (it) {
      return Object(it) instanceof $Symbol;
    };

    var $defineProperty = function defineProperty(O, P, Attributes) {
      if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
      anObject(O);
      var key = toPrimitive(P, true);
      anObject(Attributes);
      if (has(AllSymbols, key)) {
        if (!Attributes.enumerable) {
          if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
          O[HIDDEN][key] = true;
        } else {
          if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
          Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
        }return setSymbolDescriptor(O, key, Attributes);
      }return nativeDefineProperty(O, key, Attributes);
    };

    var $defineProperties = function defineProperties(O, Properties) {
      anObject(O);
      var properties = toIndexedObject(Properties);
      var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
      $forEach(keys, function (key) {
        if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
      });
      return O;
    };

    var $create = function create(O, Properties) {
      return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
    };

    var $propertyIsEnumerable = function propertyIsEnumerable(V) {
      var P = toPrimitive(V, true);
      var enumerable = nativePropertyIsEnumerable.call(this, P);
      if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
      return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
    };

    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
      var it = toIndexedObject(O);
      var key = toPrimitive(P, true);
      if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
      var descriptor = nativeGetOwnPropertyDescriptor(it, key);
      if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
        descriptor.enumerable = true;
      }
      return descriptor;
    };

    var $getOwnPropertyNames = function getOwnPropertyNames(O) {
      var names = nativeGetOwnPropertyNames(toIndexedObject(O));
      var result = [];
      $forEach(names, function (key) {
        if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
      });
      return result;
    };

    var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
      var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
      var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
      var result = [];
      $forEach(names, function (key) {
        if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
          result.push(AllSymbols[key]);
        }
      });
      return result;
    };

    // `Symbol` constructor
    // https://tc39.github.io/ecma262/#sec-symbol-constructor
    if (!NATIVE_SYMBOL) {
      $Symbol = function _Symbol2() {
        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
        var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
        var tag = uid(description);
        var setter = function setter(value) {
          if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
          if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
          setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
        };
        if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
        return wrap(tag, description);
      };

      redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return getInternalState(this).tag;
      });

      redefine($Symbol, 'withoutSetter', function (description) {
        return wrap(uid(description), description);
      });

      propertyIsEnumerableModule.f = $propertyIsEnumerable;
      definePropertyModule.f = $defineProperty;
      getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
      getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
      getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

      wrappedWellKnownSymbolModule.f = function (name) {
        return wrap(wellKnownSymbol(name), name);
      };

      if (DESCRIPTORS) {
        // https://github.com/tc39/proposal-Symbol-description
        nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
          configurable: true,
          get: function description() {
            return getInternalState(this).description;
          }
        });
        if (!IS_PURE) {
          redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
        }
      }
    }

    $({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
      Symbol: $Symbol
    });

    $forEach(objectKeys(WellKnownSymbolsStore), function (name) {
      defineWellKnownSymbol(name);
    });

    $({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
      // `Symbol.for` method
      // https://tc39.github.io/ecma262/#sec-symbol.for
      'for': function _for(key) {
        var string = String(key);
        if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
        var symbol = $Symbol(string);
        StringToSymbolRegistry[string] = symbol;
        SymbolToStringRegistry[symbol] = string;
        return symbol;
      },
      // `Symbol.keyFor` method
      // https://tc39.github.io/ecma262/#sec-symbol.keyfor
      keyFor: function keyFor(sym) {
        if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
        if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
      },
      useSetter: function useSetter() {
        USE_SETTER = true;
      },
      useSimple: function useSimple() {
        USE_SETTER = false;
      }
    });

    $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
      // `Object.create` method
      // https://tc39.github.io/ecma262/#sec-object.create
      create: $create,
      // `Object.defineProperty` method
      // https://tc39.github.io/ecma262/#sec-object.defineproperty
      defineProperty: $defineProperty,
      // `Object.defineProperties` method
      // https://tc39.github.io/ecma262/#sec-object.defineproperties
      defineProperties: $defineProperties,
      // `Object.getOwnPropertyDescriptor` method
      // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
      getOwnPropertyDescriptor: $getOwnPropertyDescriptor
    });

    $({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
      // `Object.getOwnPropertyNames` method
      // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
      getOwnPropertyNames: $getOwnPropertyNames,
      // `Object.getOwnPropertySymbols` method
      // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
      getOwnPropertySymbols: $getOwnPropertySymbols
    });

    // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
    // https://bugs.chromium.org/p/v8/issues/detail?id=3443
    $({ target: 'Object', stat: true, forced: fails(function () {
        getOwnPropertySymbolsModule.f(1);
      }) }, {
      getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return getOwnPropertySymbolsModule.f(toObject(it));
      }
    });

    // `JSON.stringify` method behavior with symbols
    // https://tc39.github.io/ecma262/#sec-json.stringify
    if ($stringify) {
      var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
        var symbol = $Symbol();
        // MS Edge converts symbol values to JSON as {}
        return $stringify([symbol]) != '[null]'
        // WebKit converts symbol values to JSON as null
        || $stringify({ a: symbol }) != '{}'
        // V8 throws on boxed symbols
        || $stringify(Object(symbol)) != '{}';
      });

      $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
        // eslint-disable-next-line no-unused-vars
        stringify: function stringify(it, replacer, space) {
          var args = [it];
          var index = 1;
          var $replacer;
          while (arguments.length > index) {
            args.push(arguments[index++]);
          }$replacer = replacer;
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
          if (!isArray(replacer)) replacer = function replacer(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return $stringify.apply(null, args);
        }
      });
    }

    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
    if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
      createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
    }
    // `Symbol.prototype[@@toStringTag]` property
    // https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
    setToStringTag($Symbol, SYMBOL);

    hiddenKeys[HIDDEN] = true;

    /***/
  },

  /***/"a630":
  /***/function a630(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var from = __webpack_require__("4df4");
    var checkCorrectnessOfIteration = __webpack_require__("1c7e");

    var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
      Array.from(iterable);
    });

    // `Array.from` method
    // https://tc39.github.io/ecma262/#sec-array.from
    $({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
      from: from
    });

    /***/
  },

  /***/"a640":
  /***/function a640(module, exports, __webpack_require__) {

    "use strict";

    var fails = __webpack_require__("d039");

    module.exports = function (METHOD_NAME, argument) {
      var method = [][METHOD_NAME];
      return !!method && fails(function () {
        // eslint-disable-next-line no-useless-call,no-throw-literal
        method.call(null, argument || function () {
          throw 1;
        }, 1);
      });
    };

    /***/
  },

  /***/"a691":
  /***/function a691(module, exports) {

    var ceil = Math.ceil;
    var floor = Math.floor;

    // `ToInteger` abstract operation
    // https://tc39.github.io/ecma262/#sec-tointeger
    module.exports = function (argument) {
      return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
    };

    /***/
  },

  /***/"ab13":
  /***/function ab13(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");

    var MATCH = wellKnownSymbol('match');

    module.exports = function (METHOD_NAME) {
      var regexp = /./;
      try {
        '/./'[METHOD_NAME](regexp);
      } catch (e) {
        try {
          regexp[MATCH] = false;
          return '/./'[METHOD_NAME](regexp);
        } catch (f) {/* empty */}
      }return false;
    };

    /***/
  },

  /***/"ac1f":
  /***/function ac1f(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var exec = __webpack_require__("9263");

    $({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
      exec: exec
    });

    /***/
  },

  /***/"ad6d":
  /***/function ad6d(module, exports, __webpack_require__) {

    "use strict";

    var anObject = __webpack_require__("825a");

    // `RegExp.prototype.flags` getter implementation
    // https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
    module.exports = function () {
      var that = anObject(this);
      var result = '';
      if (that.global) result += 'g';
      if (that.ignoreCase) result += 'i';
      if (that.multiline) result += 'm';
      if (that.dotAll) result += 's';
      if (that.unicode) result += 'u';
      if (that.sticky) result += 'y';
      return result;
    };

    /***/
  },

  /***/"ae40":
  /***/function ae40(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var fails = __webpack_require__("d039");
    var has = __webpack_require__("5135");

    var defineProperty = Object.defineProperty;
    var cache = {};

    var thrower = function thrower(it) {
      throw it;
    };

    module.exports = function (METHOD_NAME, options) {
      if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
      if (!options) options = {};
      var method = [][METHOD_NAME];
      var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
      var argument0 = has(options, 0) ? options[0] : thrower;
      var argument1 = has(options, 1) ? options[1] : undefined;

      return cache[METHOD_NAME] = !!method && !fails(function () {
        if (ACCESSORS && !DESCRIPTORS) return true;
        var O = { length: -1 };

        if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });else O[1] = 1;

        method.call(O, argument0, argument1);
      });
    };

    /***/
  },

  /***/"ae93":
  /***/function ae93(module, exports, __webpack_require__) {

    "use strict";

    var getPrototypeOf = __webpack_require__("e163");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var has = __webpack_require__("5135");
    var wellKnownSymbol = __webpack_require__("b622");
    var IS_PURE = __webpack_require__("c430");

    var ITERATOR = wellKnownSymbol('iterator');
    var BUGGY_SAFARI_ITERATORS = false;

    var returnThis = function returnThis() {
      return this;
    };

    // `%IteratorPrototype%` object
    // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
    var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

    if ([].keys) {
      arrayIterator = [].keys();
      // Safari 8 has buggy iterators w/o `next`
      if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
        PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
        if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
      }
    }

    if (IteratorPrototype == undefined) IteratorPrototype = {};

    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
    if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
      createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
    }

    module.exports = {
      IteratorPrototype: IteratorPrototype,
      BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
    };

    /***/
  },

  /***/"b041":
  /***/function b041(module, exports, __webpack_require__) {

    "use strict";

    var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
    var classof = __webpack_require__("f5df");

    // `Object.prototype.toString` method implementation
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
      return '[object ' + classof(this) + ']';
    };

    /***/
  },

  /***/"b0c0":
  /***/function b0c0(module, exports, __webpack_require__) {

    var DESCRIPTORS = __webpack_require__("83ab");
    var defineProperty = __webpack_require__("9bf2").f;

    var FunctionPrototype = Function.prototype;
    var FunctionPrototypeToString = FunctionPrototype.toString;
    var nameRE = /^\s*function ([^ (]*)/;
    var NAME = 'name';

    // Function instances `.name` property
    // https://tc39.github.io/ecma262/#sec-function-instances-name
    if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
      defineProperty(FunctionPrototype, NAME, {
        configurable: true,
        get: function get() {
          try {
            return FunctionPrototypeToString.call(this).match(nameRE)[1];
          } catch (error) {
            return '';
          }
        }
      });
    }

    /***/
  },

  /***/"b3af":
  /***/function b3af(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js

    var runtime = __webpack_require__("96cf");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
    var asyncToGenerator = __webpack_require__("1da1");

    // CONCATENATED MODULE: ./node_modules/barcode-detector/dist/barcode-detector.module.js
    function o(o, e, r) {
      var t = document.createElement("canvas"),
          s = t.getContext("2d");return t.width = e, t.height = r, s.drawImage(o, 0, 0, e, r), s.getImageData(0, 0, e, r);
    }var e = function e(_e2) {
      try {
        if (_e2 instanceof HTMLImageElement) {
          try {
            _e2.decode();
          } catch (o) {
            throw new DOMException("HTMLImageElement is not decodable", "InvalidStateError");
          }return Promise.resolve(o(_e2, _e2.naturalWidth, _e2.naturalHeight));
        }if (_e2 instanceof SVGImageElement) return Promise.resolve(o(_e2, 640, 480));if (_e2 instanceof HTMLVideoElement) {
          if (0 === _e2.readyState || 1 === _e2.readyState) throw new DOMException("", "InvalidStateError");return Promise.resolve(o(_e2, _e2.videoWidth, _e2.videoHeight));
        }if (_e2 instanceof HTMLCanvasElement) {
          var t = _e2.getContext("2d");return Promise.resolve(t.getImageData(0, 0, _e2.width, _e2.height));
        }if ("ImageBitmap" in window && _e2 instanceof ImageBitmap) return Promise.resolve(o(_e2, _e2.width, _e2.height));if ("OffscreenCanvas" in window && _e2 instanceof OffscreenCanvas) {
          var s = _e2.getContext("2d");return Promise.resolve(s.getImageData(0, 0, _e2.width, _e2.height));
        }return _e2 instanceof Blob ? Promise.resolve(r(_e2)) : _e2 instanceof ImageData ? Promise.resolve(_e2) : Promise.resolve();
      } catch (o) {
        return Promise.reject(o);
      }
    },
        r = function r(o) {
      try {
        var r = URL.createObjectURL(o),
            t = new Image();return t.src = r, Promise.resolve(new Promise(function (o, e) {
          t.onload = o, t.onerror = e;
        })).then(function () {
          return URL.revokeObjectURL(r), e(t);
        });
      } catch (o) {
        return Promise.reject(o);
      }
    };function t(o) {
      return (t = Object.setPrototypeOf ? Object.getPrototypeOf : function (o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      })(o);
    }function s(o, e) {
      return (s = Object.setPrototypeOf || function (o, e) {
        return o.__proto__ = e, o;
      })(o, e);
    }function c() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;if (Reflect.construct.sham) return !1;if ("function" == typeof Proxy) return !0;try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (o) {
        return !1;
      }
    }function n(o, e, r) {
      return (n = c() ? Reflect.construct : function (o, e, r) {
        var t = [null];t.push.apply(t, e);var c = new (Function.bind.apply(o, t))();return r && s(c, r.prototype), c;
      }).apply(null, arguments);
    }function a(o) {
      var e = "function" == typeof Map ? new Map() : void 0;return (a = function a(o) {
        if (null === o || -1 === Function.toString.call(o).indexOf("[native code]")) return o;if ("function" != typeof o) throw new TypeError("Super expression must either be null or a function");if (void 0 !== e) {
          if (e.has(o)) return e.get(o);e.set(o, r);
        }function r() {
          return n(o, arguments, t(this).constructor);
        }return r.prototype = Object.create(o.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), s(r, o);
      })(o);
    }var d = function (o) {
      var e, r;function t(e) {
        var r;return (r = o.call(this) || this).worker = void 0, r.timeout = void 0, r.stringUrl = void 0, r.stringUrl = e, r;
      }return r = o, (e = t).prototype = Object.create(r.prototype), e.prototype.constructor = e, s(e, r), t.prototype.postMessage = function (o, e) {
        var r = this;void 0 === this.worker ? (this.worker = new Worker(this.stringUrl), this.worker.onmessage = function (o) {
          r.dispatchEvent(new MessageEvent("message", { data: o.data }));
        }) : self.clearTimeout(this.timeout), this.worker.postMessage(o, e), this.timeout = self.setTimeout(function () {
          r.worker.terminate(), r.worker = void 0;
        }, 2500);
      }, t;
    }(a(EventTarget)),
        l = URL.createObjectURL(new Blob(['\n!function(o){"function"==typeof define&&define.amd?define(o):o()}(function(){function o(o){return o&&o.__esModule&&Object.prototype.hasOwnProperty.call(o,"default")?o.default:o}"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self&&self;var e,r=o((function(o,e){var r;"undefined"!=typeof self&&self,r=function(){return function(o){var e={};function r(t){if(e[t])return e[t].exports;var c=e[t]={i:t,l:!1,exports:{}};return o[t].call(c.exports,c,c.exports,r),c.l=!0,c.exports}return r.m=o,r.c=e,r.d=function(o,e,t){r.o(o,e)||Object.defineProperty(o,e,{configurable:!1,enumerable:!0,get:t})},r.n=function(o){var e=o&&o.__esModule?function(){return o.default}:function(){return o};return r.d(e,"a",e),e},r.o=function(o,e){return Object.prototype.hasOwnProperty.call(o,e)},r.p="",r(r.s=3)}([function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=function(){function o(o,e){this.width=e,this.height=o.length/e,this.data=o}return o.createEmpty=function(e,r){return new o(new Uint8ClampedArray(e*r),e)},o.prototype.get=function(o,e){return!(o<0||o>=this.width||e<0||e>=this.height||!this.data[e*this.width+o])},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r?1:0},o.prototype.setRegion=function(o,e,r,t,c){for(var s=e;s<e+t;s++)for(var a=o;a<o+r;a++)this.set(a,s,!!c)},o}();e.BitMatrix=t},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(2);e.addOrSubtractGF=function(o,e){return o^e};var c=function(){function o(o,e,r){this.primitive=o,this.size=e,this.generatorBase=r,this.expTable=new Array(this.size),this.logTable=new Array(this.size);for(var c=1,s=0;s<this.size;s++)this.expTable[s]=c,(c*=2)>=this.size&&(c=(c^this.primitive)&this.size-1);for(s=0;s<this.size-1;s++)this.logTable[this.expTable[s]]=s;this.zero=new t.default(this,Uint8ClampedArray.from([0])),this.one=new t.default(this,Uint8ClampedArray.from([1]))}return o.prototype.multiply=function(o,e){return 0===o||0===e?0:this.expTable[(this.logTable[o]+this.logTable[e])%(this.size-1)]},o.prototype.inverse=function(o){if(0===o)throw new Error("Can\'t invert 0");return this.expTable[this.size-this.logTable[o]-1]},o.prototype.buildMonomial=function(o,e){if(o<0)throw new Error("Invalid monomial degree less than 0");if(0===e)return this.zero;var r=new Uint8ClampedArray(o+1);return r[0]=e,new t.default(this,r)},o.prototype.log=function(o){if(0===o)throw new Error("Can\'t take log(0)");return this.logTable[o]},o.prototype.exp=function(o){return this.expTable[o]},o}();e.default=c},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(1),c=function(){function o(o,e){if(0===e.length)throw new Error("No coefficients.");this.field=o;var r=e.length;if(r>1&&0===e[0]){for(var t=1;t<r&&0===e[t];)t++;if(t===r)this.coefficients=o.zero.coefficients;else{this.coefficients=new Uint8ClampedArray(r-t);for(var c=0;c<this.coefficients.length;c++)this.coefficients[c]=e[t+c]}}else this.coefficients=e}return o.prototype.degree=function(){return this.coefficients.length-1},o.prototype.isZero=function(){return 0===this.coefficients[0]},o.prototype.getCoefficient=function(o){return this.coefficients[this.coefficients.length-1-o]},o.prototype.addOrSubtract=function(e){var r;if(this.isZero())return e;if(e.isZero())return this;var c=this.coefficients,s=e.coefficients;c.length>s.length&&(c=(r=[s,c])[0],s=r[1]);for(var a=new Uint8ClampedArray(s.length),n=s.length-c.length,d=0;d<n;d++)a[d]=s[d];for(d=n;d<s.length;d++)a[d]=t.addOrSubtractGF(c[d-n],s[d]);return new o(this.field,a)},o.prototype.multiply=function(e){if(0===e)return this.field.zero;if(1===e)return this;for(var r=this.coefficients.length,t=new Uint8ClampedArray(r),c=0;c<r;c++)t[c]=this.field.multiply(this.coefficients[c],e);return new o(this.field,t)},o.prototype.multiplyPoly=function(e){if(this.isZero()||e.isZero())return this.field.zero;for(var r=this.coefficients,c=r.length,s=e.coefficients,a=s.length,n=new Uint8ClampedArray(c+a-1),d=0;d<c;d++)for(var l=r[d],i=0;i<a;i++)n[d+i]=t.addOrSubtractGF(n[d+i],this.field.multiply(l,s[i]));return new o(this.field,n)},o.prototype.multiplyByMonomial=function(e,r){if(e<0)throw new Error("Invalid degree less than 0");if(0===r)return this.field.zero;for(var t=this.coefficients.length,c=new Uint8ClampedArray(t+e),s=0;s<t;s++)c[s]=this.field.multiply(this.coefficients[s],r);return new o(this.field,c)},o.prototype.evaluateAt=function(o){var e=0;if(0===o)return this.getCoefficient(0);var r=this.coefficients.length;if(1===o)return this.coefficients.forEach(function(o){e=t.addOrSubtractGF(e,o)}),e;e=this.coefficients[0];for(var c=1;c<r;c++)e=t.addOrSubtractGF(this.field.multiply(o,e),this.coefficients[c]);return e},o}();e.default=c},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(4),c=r(5),s=r(11),a=r(12);function n(o){var e=a.locate(o);if(!e)return null;for(var r=0,t=e;r<t.length;r++){var n=t[r],d=s.extract(o,n),l=c.decode(d.matrix);if(l)return{binaryData:l.bytes,data:l.text,chunks:l.chunks,location:{topRightCorner:d.mappingFunction(n.dimension,0),topLeftCorner:d.mappingFunction(0,0),bottomRightCorner:d.mappingFunction(n.dimension,n.dimension),bottomLeftCorner:d.mappingFunction(0,n.dimension),topRightFinderPattern:n.topRight,topLeftFinderPattern:n.topLeft,bottomLeftFinderPattern:n.bottomLeft,bottomRightAlignmentPattern:n.alignmentPattern}}}return null}var d={inversionAttempts:"attemptBoth"};function l(o,e,r,c){void 0===c&&(c={});var s=d;Object.keys(s||{}).forEach(function(o){s[o]=c[o]||s[o]});var a="onlyInvert"===s.inversionAttempts||"invertFirst"===s.inversionAttempts,l=t.binarize(o,e,r,"attemptBoth"===s.inversionAttempts||"invertFirst"===s.inversionAttempts),i=l.binarized,B=l.inverted,k=n(a?B:i);return k||"attemptBoth"!==s.inversionAttempts&&"invertFirst"!==s.inversionAttempts||(k=n(a?i:B)),k}l.default=l,e.default=l},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(0);function c(o,e,r){return o<e?e:o>r?r:o}var s=function(){function o(o,e){this.width=o,this.data=new Uint8ClampedArray(o*e)}return o.prototype.get=function(o,e){return this.data[e*this.width+o]},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r},o}();e.binarize=function(o,e,r,a){if(o.length!==e*r*4)throw new Error("Malformed data passed to binarizer.");for(var n=new s(e,r),d=0;d<e;d++)for(var l=0;l<r;l++)n.set(d,l,.2126*o[4*(l*e+d)+0]+.7152*o[4*(l*e+d)+1]+.0722*o[4*(l*e+d)+2]);for(var i=Math.ceil(e/8),B=Math.ceil(r/8),k=new s(i,B),u=0;u<B;u++)for(var f=0;f<i;f++){var m=0,C=Infinity,w=0;for(l=0;l<8;l++)for(d=0;d<8;d++){var P=n.get(8*f+d,8*u+l);m+=P,C=Math.min(C,P),w=Math.max(w,P)}var h=m/Math.pow(8,2);if(w-C<=24&&(h=C/2,u>0&&f>0)){var v=(k.get(f,u-1)+2*k.get(f-1,u)+k.get(f-1,u-1))/4;C<v&&(h=v)}k.set(f,u,h)}var y=t.BitMatrix.createEmpty(e,r),p=null;for(a&&(p=t.BitMatrix.createEmpty(e,r)),u=0;u<B;u++)for(f=0;f<i;f++){for(var b=c(f,2,i-3),g=c(u,2,B-3),x=(m=0,-2);x<=2;x++)for(var M=-2;M<=2;M++)m+=k.get(b+x,g+M);var L=m/25;for(x=0;x<8;x++)for(M=0;M<8;M++){var I=n.get(d=8*f+x,l=8*u+M);y.set(d,l,I<=L),a&&p.set(d,l,!(I<=L))}}return a?{binarized:y,inverted:p}:{binarized:y}}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(0),c=r(6),s=r(9),a=r(10);function n(o,e){for(var r=o^e,t=0;r;)t++,r&=r-1;return t}function d(o,e){return e<<1|o}var l=[{bits:21522,formatInfo:{errorCorrectionLevel:1,dataMask:0}},{bits:20773,formatInfo:{errorCorrectionLevel:1,dataMask:1}},{bits:24188,formatInfo:{errorCorrectionLevel:1,dataMask:2}},{bits:23371,formatInfo:{errorCorrectionLevel:1,dataMask:3}},{bits:17913,formatInfo:{errorCorrectionLevel:1,dataMask:4}},{bits:16590,formatInfo:{errorCorrectionLevel:1,dataMask:5}},{bits:20375,formatInfo:{errorCorrectionLevel:1,dataMask:6}},{bits:19104,formatInfo:{errorCorrectionLevel:1,dataMask:7}},{bits:30660,formatInfo:{errorCorrectionLevel:0,dataMask:0}},{bits:29427,formatInfo:{errorCorrectionLevel:0,dataMask:1}},{bits:32170,formatInfo:{errorCorrectionLevel:0,dataMask:2}},{bits:30877,formatInfo:{errorCorrectionLevel:0,dataMask:3}},{bits:26159,formatInfo:{errorCorrectionLevel:0,dataMask:4}},{bits:25368,formatInfo:{errorCorrectionLevel:0,dataMask:5}},{bits:27713,formatInfo:{errorCorrectionLevel:0,dataMask:6}},{bits:26998,formatInfo:{errorCorrectionLevel:0,dataMask:7}},{bits:5769,formatInfo:{errorCorrectionLevel:3,dataMask:0}},{bits:5054,formatInfo:{errorCorrectionLevel:3,dataMask:1}},{bits:7399,formatInfo:{errorCorrectionLevel:3,dataMask:2}},{bits:6608,formatInfo:{errorCorrectionLevel:3,dataMask:3}},{bits:1890,formatInfo:{errorCorrectionLevel:3,dataMask:4}},{bits:597,formatInfo:{errorCorrectionLevel:3,dataMask:5}},{bits:3340,formatInfo:{errorCorrectionLevel:3,dataMask:6}},{bits:2107,formatInfo:{errorCorrectionLevel:3,dataMask:7}},{bits:13663,formatInfo:{errorCorrectionLevel:2,dataMask:0}},{bits:12392,formatInfo:{errorCorrectionLevel:2,dataMask:1}},{bits:16177,formatInfo:{errorCorrectionLevel:2,dataMask:2}},{bits:14854,formatInfo:{errorCorrectionLevel:2,dataMask:3}},{bits:9396,formatInfo:{errorCorrectionLevel:2,dataMask:4}},{bits:8579,formatInfo:{errorCorrectionLevel:2,dataMask:5}},{bits:11994,formatInfo:{errorCorrectionLevel:2,dataMask:6}},{bits:11245,formatInfo:{errorCorrectionLevel:2,dataMask:7}}],i=[function(o){return(o.y+o.x)%2==0},function(o){return o.y%2==0},function(o){return o.x%3==0},function(o){return(o.y+o.x)%3==0},function(o){return(Math.floor(o.y/2)+Math.floor(o.x/3))%2==0},function(o){return o.x*o.y%2+o.x*o.y%3==0},function(o){return(o.y*o.x%2+o.y*o.x%3)%2==0},function(o){return((o.y+o.x)%2+o.y*o.x%3)%2==0}];function B(o){var e=function(o){var e=o.height,r=Math.floor((e-17)/4);if(r<=6)return a.VERSIONS[r-1];for(var t=0,c=5;c>=0;c--)for(var s=e-9;s>=e-11;s--)t=d(o.get(s,c),t);var l=0;for(s=5;s>=0;s--)for(c=e-9;c>=e-11;c--)l=d(o.get(s,c),l);for(var i,B=Infinity,k=0,u=a.VERSIONS;k<u.length;k++){var f=u[k];if(f.infoBits===t||f.infoBits===l)return f;var m=n(t,f.infoBits);m<B&&(i=f,B=m),(m=n(l,f.infoBits))<B&&(i=f,B=m)}return B<=3?i:void 0}(o);if(!e)return null;var r=function(o){for(var e=0,r=0;r<=8;r++)6!==r&&(e=d(o.get(r,8),e));for(var t=7;t>=0;t--)6!==t&&(e=d(o.get(8,t),e));var c=o.height,s=0;for(t=c-1;t>=c-7;t--)s=d(o.get(8,t),s);for(r=c-8;r<c;r++)s=d(o.get(r,8),s);for(var a=Infinity,i=null,B=0,k=l;B<k.length;B++){var u=k[B],f=u.bits,m=u.formatInfo;if(f===e||f===s)return m;var C=n(e,f);C<a&&(i=m,a=C),e!==s&&(C=n(s,f))<a&&(i=m,a=C)}return a<=3?i:null}(o);if(!r)return null;var B=function(o,e,r){var t=e.errorCorrectionLevels[r],c=[],s=0;if(t.ecBlocks.forEach(function(o){for(var e=0;e<o.numBlocks;e++)c.push({numDataCodewords:o.dataCodewordsPerBlock,codewords:[]}),s+=o.dataCodewordsPerBlock+t.ecCodewordsPerBlock}),o.length<s)return null;o=o.slice(0,s);for(var a=t.ecBlocks[0].dataCodewordsPerBlock,n=0;n<a;n++)for(var d=0,l=c;d<l.length;d++)l[d].codewords.push(o.shift());if(t.ecBlocks.length>1){var i=t.ecBlocks[0].numBlocks,B=t.ecBlocks[1].numBlocks;for(n=0;n<B;n++)c[i+n].codewords.push(o.shift())}for(;o.length>0;)for(var k=0,u=c;k<u.length;k++)u[k].codewords.push(o.shift());return c}(function(o,e,r){for(var c=i[r.dataMask],s=o.height,a=function(o){var e=17+4*o.versionNumber,r=t.BitMatrix.createEmpty(e,e);r.setRegion(0,0,9,9,!0),r.setRegion(e-8,0,8,9,!0),r.setRegion(0,e-8,9,8,!0);for(var c=0,s=o.alignmentPatternCenters;c<s.length;c++)for(var a=s[c],n=0,d=o.alignmentPatternCenters;n<d.length;n++){var l=d[n];6===a&&6===l||6===a&&l===e-7||a===e-7&&6===l||r.setRegion(a-2,l-2,5,5,!0)}return r.setRegion(6,9,1,e-17,!0),r.setRegion(9,6,e-17,1,!0),o.versionNumber>6&&(r.setRegion(e-11,0,3,6,!0),r.setRegion(0,e-11,6,3,!0)),r}(e),n=[],l=0,B=0,k=!0,u=s-1;u>0;u-=2){6===u&&u--;for(var f=0;f<s;f++)for(var m=k?s-1-f:f,C=0;C<2;C++){var w=u-C;if(!a.get(w,m)){B++;var P=o.get(w,m);c({y:m,x:w})&&(P=!P),l=d(P,l),8===B&&(n.push(l),B=0,l=0)}}k=!k}return n}(o,e,r),e,r.errorCorrectionLevel);if(!B)return null;for(var k=B.reduce(function(o,e){return o+e.numDataCodewords},0),u=new Uint8ClampedArray(k),f=0,m=0,C=B;m<C.length;m++){var w=C[m],P=s.decode(w.codewords,w.codewords.length-w.numDataCodewords);if(!P)return null;for(var h=0;h<w.numDataCodewords;h++)u[f++]=P[h]}try{return c.decode(u,e.versionNumber)}catch(o){return null}}e.decode=function(o){if(null==o)return null;var e=B(o);if(e)return e;for(var r=0;r<o.width;r++)for(var t=r+1;t<o.height;t++)o.get(r,t)!==o.get(t,r)&&(o.set(r,t,!o.get(r,t)),o.set(t,r,!o.get(t,r)));return B(o)}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t,c,s=r(7),a=r(8);function n(o,e){for(var r=[],t="",c=o.readBits([10,12,14][e]);c>=3;){if((d=o.readBits(10))>=1e3)throw new Error("Invalid numeric value above 999");var s=Math.floor(d/100),a=Math.floor(d/10)%10,n=d%10;r.push(48+s,48+a,48+n),t+=s.toString()+a.toString()+n.toString(),c-=3}if(2===c){if((d=o.readBits(7))>=100)throw new Error("Invalid numeric value above 99");s=Math.floor(d/10),r.push(48+s,48+(a=d%10)),t+=s.toString()+a.toString()}else if(1===c){var d;if((d=o.readBits(4))>=10)throw new Error("Invalid numeric value above 9");r.push(48+d),t+=d.toString()}return{bytes:r,text:t}}!function(o){o.Numeric="numeric",o.Alphanumeric="alphanumeric",o.Byte="byte",o.Kanji="kanji",o.ECI="eci"}(t=e.Mode||(e.Mode={})),function(o){o[o.Terminator=0]="Terminator",o[o.Numeric=1]="Numeric",o[o.Alphanumeric=2]="Alphanumeric",o[o.Byte=4]="Byte",o[o.Kanji=8]="Kanji",o[o.ECI=7]="ECI"}(c||(c={}));var d=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"," ","$","%","*","+","-",".","/",":"];function l(o,e){for(var r=[],t="",c=o.readBits([9,11,13][e]);c>=2;){var s=o.readBits(11),a=Math.floor(s/45),n=s%45;r.push(d[a].charCodeAt(0),d[n].charCodeAt(0)),t+=d[a]+d[n],c-=2}return 1===c&&(a=o.readBits(6),r.push(d[a].charCodeAt(0)),t+=d[a]),{bytes:r,text:t}}function i(o,e){for(var r=[],t="",c=o.readBits([8,16,16][e]),s=0;s<c;s++){var a=o.readBits(8);r.push(a)}try{t+=decodeURIComponent(r.map(function(o){return"%"+("0"+o.toString(16)).substr(-2)}).join(""))}catch(o){}return{bytes:r,text:t}}function B(o,e){for(var r=[],t="",c=o.readBits([8,10,12][e]),s=0;s<c;s++){var n=o.readBits(13),d=Math.floor(n/192)<<8|n%192;r.push((d+=d<7936?33088:49472)>>8,255&d),t+=String.fromCharCode(a.shiftJISTable[d])}return{bytes:r,text:t}}e.decode=function(o,e){for(var r,a,d,k,u=new s.BitStream(o),f=e<=9?0:e<=26?1:2,m={text:"",bytes:[],chunks:[]};u.available()>=4;){var C=u.readBits(4);if(C===c.Terminator)return m;if(C===c.ECI)0===u.readBits(1)?m.chunks.push({type:t.ECI,assignmentNumber:u.readBits(7)}):0===u.readBits(1)?m.chunks.push({type:t.ECI,assignmentNumber:u.readBits(14)}):0===u.readBits(1)?m.chunks.push({type:t.ECI,assignmentNumber:u.readBits(21)}):m.chunks.push({type:t.ECI,assignmentNumber:-1});else if(C===c.Numeric){var w=n(u,f);m.text+=w.text,(r=m.bytes).push.apply(r,w.bytes),m.chunks.push({type:t.Numeric,text:w.text})}else if(C===c.Alphanumeric){var P=l(u,f);m.text+=P.text,(a=m.bytes).push.apply(a,P.bytes),m.chunks.push({type:t.Alphanumeric,text:P.text})}else if(C===c.Byte){var h=i(u,f);m.text+=h.text,(d=m.bytes).push.apply(d,h.bytes),m.chunks.push({type:t.Byte,bytes:h.bytes,text:h.text})}else if(C===c.Kanji){var v=B(u,f);m.text+=v.text,(k=m.bytes).push.apply(k,v.bytes),m.chunks.push({type:t.Kanji,bytes:v.bytes,text:v.text})}}if(0===u.available()||0===u.readBits(u.available()))return m}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=function(){function o(o){this.byteOffset=0,this.bitOffset=0,this.bytes=o}return o.prototype.readBits=function(o){if(o<1||o>32||o>this.available())throw new Error("Cannot read "+o.toString()+" bits");var e=0;if(this.bitOffset>0){var r=8-this.bitOffset,t=o<r?o:r;e=(this.bytes[this.byteOffset]&255>>8-t<<(c=r-t))>>c,o-=t,this.bitOffset+=t,8===this.bitOffset&&(this.bitOffset=0,this.byteOffset++)}if(o>0){for(;o>=8;)e=e<<8|255&this.bytes[this.byteOffset],this.byteOffset++,o-=8;var c;o>0&&(e=e<<o|(this.bytes[this.byteOffset]&255>>(c=8-o)<<c)>>c,this.bitOffset+=o)}return e},o.prototype.available=function(){return 8*(this.bytes.length-this.byteOffset)-this.bitOffset},o}();e.BitStream=t},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0}),e.shiftJISTable={32:32,33:33,34:34,35:35,36:36,37:37,38:38,39:39,40:40,41:41,42:42,43:43,44:44,45:45,46:46,47:47,48:48,49:49,50:50,51:51,52:52,53:53,54:54,55:55,56:56,57:57,58:58,59:59,60:60,61:61,62:62,63:63,64:64,65:65,66:66,67:67,68:68,69:69,70:70,71:71,72:72,73:73,74:74,75:75,76:76,77:77,78:78,79:79,80:80,81:81,82:82,83:83,84:84,85:85,86:86,87:87,88:88,89:89,90:90,91:91,92:165,93:93,94:94,95:95,96:96,97:97,98:98,99:99,100:100,101:101,102:102,103:103,104:104,105:105,106:106,107:107,108:108,109:109,110:110,111:111,112:112,113:113,114:114,115:115,116:116,117:117,118:118,119:119,120:120,121:121,122:122,123:123,124:124,125:125,126:8254,33088:12288,33089:12289,33090:12290,33091:65292,33092:65294,33093:12539,33094:65306,33095:65307,33096:65311,33097:65281,33098:12443,33099:12444,33100:180,33101:65344,33102:168,33103:65342,33104:65507,33105:65343,33106:12541,33107:12542,33108:12445,33109:12446,33110:12291,33111:20189,33112:12293,33113:12294,33114:12295,33115:12540,33116:8213,33117:8208,33118:65295,33119:92,33120:12316,33121:8214,33122:65372,33123:8230,33124:8229,33125:8216,33126:8217,33127:8220,33128:8221,33129:65288,33130:65289,33131:12308,33132:12309,33133:65339,33134:65341,33135:65371,33136:65373,33137:12296,33138:12297,33139:12298,33140:12299,33141:12300,33142:12301,33143:12302,33144:12303,33145:12304,33146:12305,33147:65291,33148:8722,33149:177,33150:215,33152:247,33153:65309,33154:8800,33155:65308,33156:65310,33157:8806,33158:8807,33159:8734,33160:8756,33161:9794,33162:9792,33163:176,33164:8242,33165:8243,33166:8451,33167:65509,33168:65284,33169:162,33170:163,33171:65285,33172:65283,33173:65286,33174:65290,33175:65312,33176:167,33177:9734,33178:9733,33179:9675,33180:9679,33181:9678,33182:9671,33183:9670,33184:9633,33185:9632,33186:9651,33187:9650,33188:9661,33189:9660,33190:8251,33191:12306,33192:8594,33193:8592,33194:8593,33195:8595,33196:12307,33208:8712,33209:8715,33210:8838,33211:8839,33212:8834,33213:8835,33214:8746,33215:8745,33224:8743,33225:8744,33226:172,33227:8658,33228:8660,33229:8704,33230:8707,33242:8736,33243:8869,33244:8978,33245:8706,33246:8711,33247:8801,33248:8786,33249:8810,33250:8811,33251:8730,33252:8765,33253:8733,33254:8757,33255:8747,33256:8748,33264:8491,33265:8240,33266:9839,33267:9837,33268:9834,33269:8224,33270:8225,33271:182,33276:9711,33359:65296,33360:65297,33361:65298,33362:65299,33363:65300,33364:65301,33365:65302,33366:65303,33367:65304,33368:65305,33376:65313,33377:65314,33378:65315,33379:65316,33380:65317,33381:65318,33382:65319,33383:65320,33384:65321,33385:65322,33386:65323,33387:65324,33388:65325,33389:65326,33390:65327,33391:65328,33392:65329,33393:65330,33394:65331,33395:65332,33396:65333,33397:65334,33398:65335,33399:65336,33400:65337,33401:65338,33409:65345,33410:65346,33411:65347,33412:65348,33413:65349,33414:65350,33415:65351,33416:65352,33417:65353,33418:65354,33419:65355,33420:65356,33421:65357,33422:65358,33423:65359,33424:65360,33425:65361,33426:65362,33427:65363,33428:65364,33429:65365,33430:65366,33431:65367,33432:65368,33433:65369,33434:65370,33439:12353,33440:12354,33441:12355,33442:12356,33443:12357,33444:12358,33445:12359,33446:12360,33447:12361,33448:12362,33449:12363,33450:12364,33451:12365,33452:12366,33453:12367,33454:12368,33455:12369,33456:12370,33457:12371,33458:12372,33459:12373,33460:12374,33461:12375,33462:12376,33463:12377,33464:12378,33465:12379,33466:12380,33467:12381,33468:12382,33469:12383,33470:12384,33471:12385,33472:12386,33473:12387,33474:12388,33475:12389,33476:12390,33477:12391,33478:12392,33479:12393,33480:12394,33481:12395,33482:12396,33483:12397,33484:12398,33485:12399,33486:12400,33487:12401,33488:12402,33489:12403,33490:12404,33491:12405,33492:12406,33493:12407,33494:12408,33495:12409,33496:12410,33497:12411,33498:12412,33499:12413,33500:12414,33501:12415,33502:12416,33503:12417,33504:12418,33505:12419,33506:12420,33507:12421,33508:12422,33509:12423,33510:12424,33511:12425,33512:12426,33513:12427,33514:12428,33515:12429,33516:12430,33517:12431,33518:12432,33519:12433,33520:12434,33521:12435,33600:12449,33601:12450,33602:12451,33603:12452,33604:12453,33605:12454,33606:12455,33607:12456,33608:12457,33609:12458,33610:12459,33611:12460,33612:12461,33613:12462,33614:12463,33615:12464,33616:12465,33617:12466,33618:12467,33619:12468,33620:12469,33621:12470,33622:12471,33623:12472,33624:12473,33625:12474,33626:12475,33627:12476,33628:12477,33629:12478,33630:12479,33631:12480,33632:12481,33633:12482,33634:12483,33635:12484,33636:12485,33637:12486,33638:12487,33639:12488,33640:12489,33641:12490,33642:12491,33643:12492,33644:12493,33645:12494,33646:12495,33647:12496,33648:12497,33649:12498,33650:12499,33651:12500,33652:12501,33653:12502,33654:12503,33655:12504,33656:12505,33657:12506,33658:12507,33659:12508,33660:12509,33661:12510,33662:12511,33664:12512,33665:12513,33666:12514,33667:12515,33668:12516,33669:12517,33670:12518,33671:12519,33672:12520,33673:12521,33674:12522,33675:12523,33676:12524,33677:12525,33678:12526,33679:12527,33680:12528,33681:12529,33682:12530,33683:12531,33684:12532,33685:12533,33686:12534,33695:913,33696:914,33697:915,33698:916,33699:917,33700:918,33701:919,33702:920,33703:921,33704:922,33705:923,33706:924,33707:925,33708:926,33709:927,33710:928,33711:929,33712:931,33713:932,33714:933,33715:934,33716:935,33717:936,33718:937,33727:945,33728:946,33729:947,33730:948,33731:949,33732:950,33733:951,33734:952,33735:953,33736:954,33737:955,33738:956,33739:957,33740:958,33741:959,33742:960,33743:961,33744:963,33745:964,33746:965,33747:966,33748:967,33749:968,33750:969,33856:1040,33857:1041,33858:1042,33859:1043,33860:1044,33861:1045,33862:1025,33863:1046,33864:1047,33865:1048,33866:1049,33867:1050,33868:1051,33869:1052,33870:1053,33871:1054,33872:1055,33873:1056,33874:1057,33875:1058,33876:1059,33877:1060,33878:1061,33879:1062,33880:1063,33881:1064,33882:1065,33883:1066,33884:1067,33885:1068,33886:1069,33887:1070,33888:1071,33904:1072,33905:1073,33906:1074,33907:1075,33908:1076,33909:1077,33910:1105,33911:1078,33912:1079,33913:1080,33914:1081,33915:1082,33916:1083,33917:1084,33918:1085,33920:1086,33921:1087,33922:1088,33923:1089,33924:1090,33925:1091,33926:1092,33927:1093,33928:1094,33929:1095,33930:1096,33931:1097,33932:1098,33933:1099,33934:1100,33935:1101,33936:1102,33937:1103,33951:9472,33952:9474,33953:9484,33954:9488,33955:9496,33956:9492,33957:9500,33958:9516,33959:9508,33960:9524,33961:9532,33962:9473,33963:9475,33964:9487,33965:9491,33966:9499,33967:9495,33968:9507,33969:9523,33970:9515,33971:9531,33972:9547,33973:9504,33974:9519,33975:9512,33976:9527,33977:9535,33978:9501,33979:9520,33980:9509,33981:9528,33982:9538,34975:20124,34976:21782,34977:23043,34978:38463,34979:21696,34980:24859,34981:25384,34982:23030,34983:36898,34984:33909,34985:33564,34986:31312,34987:24746,34988:25569,34989:28197,34990:26093,34991:33894,34992:33446,34993:39925,34994:26771,34995:22311,34996:26017,34997:25201,34998:23451,34999:22992,35e3:34427,35001:39156,35002:32098,35003:32190,35004:39822,35005:25110,35006:31903,35007:34999,35008:23433,35009:24245,35010:25353,35011:26263,35012:26696,35013:38343,35014:38797,35015:26447,35016:20197,35017:20234,35018:20301,35019:20381,35020:20553,35021:22258,35022:22839,35023:22996,35024:23041,35025:23561,35026:24799,35027:24847,35028:24944,35029:26131,35030:26885,35031:28858,35032:30031,35033:30064,35034:31227,35035:32173,35036:32239,35037:32963,35038:33806,35039:34915,35040:35586,35041:36949,35042:36986,35043:21307,35044:20117,35045:20133,35046:22495,35047:32946,35048:37057,35049:30959,35050:19968,35051:22769,35052:28322,35053:36920,35054:31282,35055:33576,35056:33419,35057:39983,35058:20801,35059:21360,35060:21693,35061:21729,35062:22240,35063:23035,35064:24341,35065:39154,35066:28139,35067:32996,35068:34093,35136:38498,35137:38512,35138:38560,35139:38907,35140:21515,35141:21491,35142:23431,35143:28879,35144:32701,35145:36802,35146:38632,35147:21359,35148:40284,35149:31418,35150:19985,35151:30867,35152:33276,35153:28198,35154:22040,35155:21764,35156:27421,35157:34074,35158:39995,35159:23013,35160:21417,35161:28006,35162:29916,35163:38287,35164:22082,35165:20113,35166:36939,35167:38642,35168:33615,35169:39180,35170:21473,35171:21942,35172:23344,35173:24433,35174:26144,35175:26355,35176:26628,35177:27704,35178:27891,35179:27945,35180:29787,35181:30408,35182:31310,35183:38964,35184:33521,35185:34907,35186:35424,35187:37613,35188:28082,35189:30123,35190:30410,35191:39365,35192:24742,35193:35585,35194:36234,35195:38322,35196:27022,35197:21421,35198:20870,35200:22290,35201:22576,35202:22852,35203:23476,35204:24310,35205:24616,35206:25513,35207:25588,35208:27839,35209:28436,35210:28814,35211:28948,35212:29017,35213:29141,35214:29503,35215:32257,35216:33398,35217:33489,35218:34199,35219:36960,35220:37467,35221:40219,35222:22633,35223:26044,35224:27738,35225:29989,35226:20985,35227:22830,35228:22885,35229:24448,35230:24540,35231:25276,35232:26106,35233:27178,35234:27431,35235:27572,35236:29579,35237:32705,35238:35158,35239:40236,35240:40206,35241:40644,35242:23713,35243:27798,35244:33659,35245:20740,35246:23627,35247:25014,35248:33222,35249:26742,35250:29281,35251:20057,35252:20474,35253:21368,35254:24681,35255:28201,35256:31311,35257:38899,35258:19979,35259:21270,35260:20206,35261:20309,35262:20285,35263:20385,35264:20339,35265:21152,35266:21487,35267:22025,35268:22799,35269:23233,35270:23478,35271:23521,35272:31185,35273:26247,35274:26524,35275:26550,35276:27468,35277:27827,35278:28779,35279:29634,35280:31117,35281:31166,35282:31292,35283:31623,35284:33457,35285:33499,35286:33540,35287:33655,35288:33775,35289:33747,35290:34662,35291:35506,35292:22057,35293:36008,35294:36838,35295:36942,35296:38686,35297:34442,35298:20420,35299:23784,35300:25105,35301:29273,35302:30011,35303:33253,35304:33469,35305:34558,35306:36032,35307:38597,35308:39187,35309:39381,35310:20171,35311:20250,35312:35299,35313:22238,35314:22602,35315:22730,35316:24315,35317:24555,35318:24618,35319:24724,35320:24674,35321:25040,35322:25106,35323:25296,35324:25913,35392:39745,35393:26214,35394:26800,35395:28023,35396:28784,35397:30028,35398:30342,35399:32117,35400:33445,35401:34809,35402:38283,35403:38542,35404:35997,35405:20977,35406:21182,35407:22806,35408:21683,35409:23475,35410:23830,35411:24936,35412:27010,35413:28079,35414:30861,35415:33995,35416:34903,35417:35442,35418:37799,35419:39608,35420:28012,35421:39336,35422:34521,35423:22435,35424:26623,35425:34510,35426:37390,35427:21123,35428:22151,35429:21508,35430:24275,35431:25313,35432:25785,35433:26684,35434:26680,35435:27579,35436:29554,35437:30906,35438:31339,35439:35226,35440:35282,35441:36203,35442:36611,35443:37101,35444:38307,35445:38548,35446:38761,35447:23398,35448:23731,35449:27005,35450:38989,35451:38990,35452:25499,35453:31520,35454:27179,35456:27263,35457:26806,35458:39949,35459:28511,35460:21106,35461:21917,35462:24688,35463:25324,35464:27963,35465:28167,35466:28369,35467:33883,35468:35088,35469:36676,35470:19988,35471:39993,35472:21494,35473:26907,35474:27194,35475:38788,35476:26666,35477:20828,35478:31427,35479:33970,35480:37340,35481:37772,35482:22107,35483:40232,35484:26658,35485:33541,35486:33841,35487:31909,35488:21e3,35489:33477,35490:29926,35491:20094,35492:20355,35493:20896,35494:23506,35495:21002,35496:21208,35497:21223,35498:24059,35499:21914,35500:22570,35501:23014,35502:23436,35503:23448,35504:23515,35505:24178,35506:24185,35507:24739,35508:24863,35509:24931,35510:25022,35511:25563,35512:25954,35513:26577,35514:26707,35515:26874,35516:27454,35517:27475,35518:27735,35519:28450,35520:28567,35521:28485,35522:29872,35523:29976,35524:30435,35525:30475,35526:31487,35527:31649,35528:31777,35529:32233,35530:32566,35531:32752,35532:32925,35533:33382,35534:33694,35535:35251,35536:35532,35537:36011,35538:36996,35539:37969,35540:38291,35541:38289,35542:38306,35543:38501,35544:38867,35545:39208,35546:33304,35547:20024,35548:21547,35549:23736,35550:24012,35551:29609,35552:30284,35553:30524,35554:23721,35555:32747,35556:36107,35557:38593,35558:38929,35559:38996,35560:39e3,35561:20225,35562:20238,35563:21361,35564:21916,35565:22120,35566:22522,35567:22855,35568:23305,35569:23492,35570:23696,35571:24076,35572:24190,35573:24524,35574:25582,35575:26426,35576:26071,35577:26082,35578:26399,35579:26827,35580:26820,35648:27231,35649:24112,35650:27589,35651:27671,35652:27773,35653:30079,35654:31048,35655:23395,35656:31232,35657:32e3,35658:24509,35659:35215,35660:35352,35661:36020,35662:36215,35663:36556,35664:36637,35665:39138,35666:39438,35667:39740,35668:20096,35669:20605,35670:20736,35671:22931,35672:23452,35673:25135,35674:25216,35675:25836,35676:27450,35677:29344,35678:30097,35679:31047,35680:32681,35681:34811,35682:35516,35683:35696,35684:25516,35685:33738,35686:38816,35687:21513,35688:21507,35689:21931,35690:26708,35691:27224,35692:35440,35693:30759,35694:26485,35695:40653,35696:21364,35697:23458,35698:33050,35699:34384,35700:36870,35701:19992,35702:20037,35703:20167,35704:20241,35705:21450,35706:21560,35707:23470,35708:24339,35709:24613,35710:25937,35712:26429,35713:27714,35714:27762,35715:27875,35716:28792,35717:29699,35718:31350,35719:31406,35720:31496,35721:32026,35722:31998,35723:32102,35724:26087,35725:29275,35726:21435,35727:23621,35728:24040,35729:25298,35730:25312,35731:25369,35732:28192,35733:34394,35734:35377,35735:36317,35736:37624,35737:28417,35738:31142,35739:39770,35740:20136,35741:20139,35742:20140,35743:20379,35744:20384,35745:20689,35746:20807,35747:31478,35748:20849,35749:20982,35750:21332,35751:21281,35752:21375,35753:21483,35754:21932,35755:22659,35756:23777,35757:24375,35758:24394,35759:24623,35760:24656,35761:24685,35762:25375,35763:25945,35764:27211,35765:27841,35766:29378,35767:29421,35768:30703,35769:33016,35770:33029,35771:33288,35772:34126,35773:37111,35774:37857,35775:38911,35776:39255,35777:39514,35778:20208,35779:20957,35780:23597,35781:26241,35782:26989,35783:23616,35784:26354,35785:26997,35786:29577,35787:26704,35788:31873,35789:20677,35790:21220,35791:22343,35792:24062,35793:37670,35794:26020,35795:27427,35796:27453,35797:29748,35798:31105,35799:31165,35800:31563,35801:32202,35802:33465,35803:33740,35804:34943,35805:35167,35806:35641,35807:36817,35808:37329,35809:21535,35810:37504,35811:20061,35812:20534,35813:21477,35814:21306,35815:29399,35816:29590,35817:30697,35818:33510,35819:36527,35820:39366,35821:39368,35822:39378,35823:20855,35824:24858,35825:34398,35826:21936,35827:31354,35828:20598,35829:23507,35830:36935,35831:38533,35832:20018,35833:27355,35834:37351,35835:23633,35836:23624,35904:25496,35905:31391,35906:27795,35907:38772,35908:36705,35909:31402,35910:29066,35911:38536,35912:31874,35913:26647,35914:32368,35915:26705,35916:37740,35917:21234,35918:21531,35919:34219,35920:35347,35921:32676,35922:36557,35923:37089,35924:21350,35925:34952,35926:31041,35927:20418,35928:20670,35929:21009,35930:20804,35931:21843,35932:22317,35933:29674,35934:22411,35935:22865,35936:24418,35937:24452,35938:24693,35939:24950,35940:24935,35941:25001,35942:25522,35943:25658,35944:25964,35945:26223,35946:26690,35947:28179,35948:30054,35949:31293,35950:31995,35951:32076,35952:32153,35953:32331,35954:32619,35955:33550,35956:33610,35957:34509,35958:35336,35959:35427,35960:35686,35961:36605,35962:38938,35963:40335,35964:33464,35965:36814,35966:39912,35968:21127,35969:25119,35970:25731,35971:28608,35972:38553,35973:26689,35974:20625,35975:27424,35976:27770,35977:28500,35978:31348,35979:32080,35980:34880,35981:35363,35982:26376,35983:20214,35984:20537,35985:20518,35986:20581,35987:20860,35988:21048,35989:21091,35990:21927,35991:22287,35992:22533,35993:23244,35994:24314,35995:25010,35996:25080,35997:25331,35998:25458,35999:26908,36e3:27177,36001:29309,36002:29356,36003:29486,36004:30740,36005:30831,36006:32121,36007:30476,36008:32937,36009:35211,36010:35609,36011:36066,36012:36562,36013:36963,36014:37749,36015:38522,36016:38997,36017:39443,36018:40568,36019:20803,36020:21407,36021:21427,36022:24187,36023:24358,36024:28187,36025:28304,36026:29572,36027:29694,36028:32067,36029:33335,36030:35328,36031:35578,36032:38480,36033:20046,36034:20491,36035:21476,36036:21628,36037:22266,36038:22993,36039:23396,36040:24049,36041:24235,36042:24359,36043:25144,36044:25925,36045:26543,36046:28246,36047:29392,36048:31946,36049:34996,36050:32929,36051:32993,36052:33776,36053:34382,36054:35463,36055:36328,36056:37431,36057:38599,36058:39015,36059:40723,36060:20116,36061:20114,36062:20237,36063:21320,36064:21577,36065:21566,36066:23087,36067:24460,36068:24481,36069:24735,36070:26791,36071:27278,36072:29786,36073:30849,36074:35486,36075:35492,36076:35703,36077:37264,36078:20062,36079:39881,36080:20132,36081:20348,36082:20399,36083:20505,36084:20502,36085:20809,36086:20844,36087:21151,36088:21177,36089:21246,36090:21402,36091:21475,36092:21521,36160:21518,36161:21897,36162:22353,36163:22434,36164:22909,36165:23380,36166:23389,36167:23439,36168:24037,36169:24039,36170:24055,36171:24184,36172:24195,36173:24218,36174:24247,36175:24344,36176:24658,36177:24908,36178:25239,36179:25304,36180:25511,36181:25915,36182:26114,36183:26179,36184:26356,36185:26477,36186:26657,36187:26775,36188:27083,36189:27743,36190:27946,36191:28009,36192:28207,36193:28317,36194:30002,36195:30343,36196:30828,36197:31295,36198:31968,36199:32005,36200:32024,36201:32094,36202:32177,36203:32789,36204:32771,36205:32943,36206:32945,36207:33108,36208:33167,36209:33322,36210:33618,36211:34892,36212:34913,36213:35611,36214:36002,36215:36092,36216:37066,36217:37237,36218:37489,36219:30783,36220:37628,36221:38308,36222:38477,36224:38917,36225:39321,36226:39640,36227:40251,36228:21083,36229:21163,36230:21495,36231:21512,36232:22741,36233:25335,36234:28640,36235:35946,36236:36703,36237:40633,36238:20811,36239:21051,36240:21578,36241:22269,36242:31296,36243:37239,36244:40288,36245:40658,36246:29508,36247:28425,36248:33136,36249:29969,36250:24573,36251:24794,36252:39592,36253:29403,36254:36796,36255:27492,36256:38915,36257:20170,36258:22256,36259:22372,36260:22718,36261:23130,36262:24680,36263:25031,36264:26127,36265:26118,36266:26681,36267:26801,36268:28151,36269:30165,36270:32058,36271:33390,36272:39746,36273:20123,36274:20304,36275:21449,36276:21766,36277:23919,36278:24038,36279:24046,36280:26619,36281:27801,36282:29811,36283:30722,36284:35408,36285:37782,36286:35039,36287:22352,36288:24231,36289:25387,36290:20661,36291:20652,36292:20877,36293:26368,36294:21705,36295:22622,36296:22971,36297:23472,36298:24425,36299:25165,36300:25505,36301:26685,36302:27507,36303:28168,36304:28797,36305:37319,36306:29312,36307:30741,36308:30758,36309:31085,36310:25998,36311:32048,36312:33756,36313:35009,36314:36617,36315:38555,36316:21092,36317:22312,36318:26448,36319:32618,36320:36001,36321:20916,36322:22338,36323:38442,36324:22586,36325:27018,36326:32948,36327:21682,36328:23822,36329:22524,36330:30869,36331:40442,36332:20316,36333:21066,36334:21643,36335:25662,36336:26152,36337:26388,36338:26613,36339:31364,36340:31574,36341:32034,36342:37679,36343:26716,36344:39853,36345:31545,36346:21273,36347:20874,36348:21047,36416:23519,36417:25334,36418:25774,36419:25830,36420:26413,36421:27578,36422:34217,36423:38609,36424:30352,36425:39894,36426:25420,36427:37638,36428:39851,36429:30399,36430:26194,36431:19977,36432:20632,36433:21442,36434:23665,36435:24808,36436:25746,36437:25955,36438:26719,36439:29158,36440:29642,36441:29987,36442:31639,36443:32386,36444:34453,36445:35715,36446:36059,36447:37240,36448:39184,36449:26028,36450:26283,36451:27531,36452:20181,36453:20180,36454:20282,36455:20351,36456:21050,36457:21496,36458:21490,36459:21987,36460:22235,36461:22763,36462:22987,36463:22985,36464:23039,36465:23376,36466:23629,36467:24066,36468:24107,36469:24535,36470:24605,36471:25351,36472:25903,36473:23388,36474:26031,36475:26045,36476:26088,36477:26525,36478:27490,36480:27515,36481:27663,36482:29509,36483:31049,36484:31169,36485:31992,36486:32025,36487:32043,36488:32930,36489:33026,36490:33267,36491:35222,36492:35422,36493:35433,36494:35430,36495:35468,36496:35566,36497:36039,36498:36060,36499:38604,36500:39164,36501:27503,36502:20107,36503:20284,36504:20365,36505:20816,36506:23383,36507:23546,36508:24904,36509:25345,36510:26178,36511:27425,36512:28363,36513:27835,36514:29246,36515:29885,36516:30164,36517:30913,36518:31034,36519:32780,36520:32819,36521:33258,36522:33940,36523:36766,36524:27728,36525:40575,36526:24335,36527:35672,36528:40235,36529:31482,36530:36600,36531:23437,36532:38635,36533:19971,36534:21489,36535:22519,36536:22833,36537:23241,36538:23460,36539:24713,36540:28287,36541:28422,36542:30142,36543:36074,36544:23455,36545:34048,36546:31712,36547:20594,36548:26612,36549:33437,36550:23649,36551:34122,36552:32286,36553:33294,36554:20889,36555:23556,36556:25448,36557:36198,36558:26012,36559:29038,36560:31038,36561:32023,36562:32773,36563:35613,36564:36554,36565:36974,36566:34503,36567:37034,36568:20511,36569:21242,36570:23610,36571:26451,36572:28796,36573:29237,36574:37196,36575:37320,36576:37675,36577:33509,36578:23490,36579:24369,36580:24825,36581:20027,36582:21462,36583:23432,36584:25163,36585:26417,36586:27530,36587:29417,36588:29664,36589:31278,36590:33131,36591:36259,36592:37202,36593:39318,36594:20754,36595:21463,36596:21610,36597:23551,36598:25480,36599:27193,36600:32172,36601:38656,36602:22234,36603:21454,36604:21608,36672:23447,36673:23601,36674:24030,36675:20462,36676:24833,36677:25342,36678:27954,36679:31168,36680:31179,36681:32066,36682:32333,36683:32722,36684:33261,36685:33311,36686:33936,36687:34886,36688:35186,36689:35728,36690:36468,36691:36655,36692:36913,36693:37195,36694:37228,36695:38598,36696:37276,36697:20160,36698:20303,36699:20805,36700:21313,36701:24467,36702:25102,36703:26580,36704:27713,36705:28171,36706:29539,36707:32294,36708:37325,36709:37507,36710:21460,36711:22809,36712:23487,36713:28113,36714:31069,36715:32302,36716:31899,36717:22654,36718:29087,36719:20986,36720:34899,36721:36848,36722:20426,36723:23803,36724:26149,36725:30636,36726:31459,36727:33308,36728:39423,36729:20934,36730:24490,36731:26092,36732:26991,36733:27529,36734:28147,36736:28310,36737:28516,36738:30462,36739:32020,36740:24033,36741:36981,36742:37255,36743:38918,36744:20966,36745:21021,36746:25152,36747:26257,36748:26329,36749:28186,36750:24246,36751:32210,36752:32626,36753:26360,36754:34223,36755:34295,36756:35576,36757:21161,36758:21465,36759:22899,36760:24207,36761:24464,36762:24661,36763:37604,36764:38500,36765:20663,36766:20767,36767:21213,36768:21280,36769:21319,36770:21484,36771:21736,36772:21830,36773:21809,36774:22039,36775:22888,36776:22974,36777:23100,36778:23477,36779:23558,36780:23567,36781:23569,36782:23578,36783:24196,36784:24202,36785:24288,36786:24432,36787:25215,36788:25220,36789:25307,36790:25484,36791:25463,36792:26119,36793:26124,36794:26157,36795:26230,36796:26494,36797:26786,36798:27167,36799:27189,36800:27836,36801:28040,36802:28169,36803:28248,36804:28988,36805:28966,36806:29031,36807:30151,36808:30465,36809:30813,36810:30977,36811:31077,36812:31216,36813:31456,36814:31505,36815:31911,36816:32057,36817:32918,36818:33750,36819:33931,36820:34121,36821:34909,36822:35059,36823:35359,36824:35388,36825:35412,36826:35443,36827:35937,36828:36062,36829:37284,36830:37478,36831:37758,36832:37912,36833:38556,36834:38808,36835:19978,36836:19976,36837:19998,36838:20055,36839:20887,36840:21104,36841:22478,36842:22580,36843:22732,36844:23330,36845:24120,36846:24773,36847:25854,36848:26465,36849:26454,36850:27972,36851:29366,36852:30067,36853:31331,36854:33976,36855:35698,36856:37304,36857:37664,36858:22065,36859:22516,36860:39166,36928:25325,36929:26893,36930:27542,36931:29165,36932:32340,36933:32887,36934:33394,36935:35302,36936:39135,36937:34645,36938:36785,36939:23611,36940:20280,36941:20449,36942:20405,36943:21767,36944:23072,36945:23517,36946:23529,36947:24515,36948:24910,36949:25391,36950:26032,36951:26187,36952:26862,36953:27035,36954:28024,36955:28145,36956:30003,36957:30137,36958:30495,36959:31070,36960:31206,36961:32051,36962:33251,36963:33455,36964:34218,36965:35242,36966:35386,36967:36523,36968:36763,36969:36914,36970:37341,36971:38663,36972:20154,36973:20161,36974:20995,36975:22645,36976:22764,36977:23563,36978:29978,36979:23613,36980:33102,36981:35338,36982:36805,36983:38499,36984:38765,36985:31525,36986:35535,36987:38920,36988:37218,36989:22259,36990:21416,36992:36887,36993:21561,36994:22402,36995:24101,36996:25512,36997:27700,36998:28810,36999:30561,37e3:31883,37001:32736,37002:34928,37003:36930,37004:37204,37005:37648,37006:37656,37007:38543,37008:29790,37009:39620,37010:23815,37011:23913,37012:25968,37013:26530,37014:36264,37015:38619,37016:25454,37017:26441,37018:26905,37019:33733,37020:38935,37021:38592,37022:35070,37023:28548,37024:25722,37025:23544,37026:19990,37027:28716,37028:30045,37029:26159,37030:20932,37031:21046,37032:21218,37033:22995,37034:24449,37035:24615,37036:25104,37037:25919,37038:25972,37039:26143,37040:26228,37041:26866,37042:26646,37043:27491,37044:28165,37045:29298,37046:29983,37047:30427,37048:31934,37049:32854,37050:22768,37051:35069,37052:35199,37053:35488,37054:35475,37055:35531,37056:36893,37057:37266,37058:38738,37059:38745,37060:25993,37061:31246,37062:33030,37063:38587,37064:24109,37065:24796,37066:25114,37067:26021,37068:26132,37069:26512,37070:30707,37071:31309,37072:31821,37073:32318,37074:33034,37075:36012,37076:36196,37077:36321,37078:36447,37079:30889,37080:20999,37081:25305,37082:25509,37083:25666,37084:25240,37085:35373,37086:31363,37087:31680,37088:35500,37089:38634,37090:32118,37091:33292,37092:34633,37093:20185,37094:20808,37095:21315,37096:21344,37097:23459,37098:23554,37099:23574,37100:24029,37101:25126,37102:25159,37103:25776,37104:26643,37105:26676,37106:27849,37107:27973,37108:27927,37109:26579,37110:28508,37111:29006,37112:29053,37113:26059,37114:31359,37115:31661,37116:32218,37184:32330,37185:32680,37186:33146,37187:33307,37188:33337,37189:34214,37190:35438,37191:36046,37192:36341,37193:36984,37194:36983,37195:37549,37196:37521,37197:38275,37198:39854,37199:21069,37200:21892,37201:28472,37202:28982,37203:20840,37204:31109,37205:32341,37206:33203,37207:31950,37208:22092,37209:22609,37210:23720,37211:25514,37212:26366,37213:26365,37214:26970,37215:29401,37216:30095,37217:30094,37218:30990,37219:31062,37220:31199,37221:31895,37222:32032,37223:32068,37224:34311,37225:35380,37226:38459,37227:36961,37228:40736,37229:20711,37230:21109,37231:21452,37232:21474,37233:20489,37234:21930,37235:22766,37236:22863,37237:29245,37238:23435,37239:23652,37240:21277,37241:24803,37242:24819,37243:25436,37244:25475,37245:25407,37246:25531,37248:25805,37249:26089,37250:26361,37251:24035,37252:27085,37253:27133,37254:28437,37255:29157,37256:20105,37257:30185,37258:30456,37259:31379,37260:31967,37261:32207,37262:32156,37263:32865,37264:33609,37265:33624,37266:33900,37267:33980,37268:34299,37269:35013,37270:36208,37271:36865,37272:36973,37273:37783,37274:38684,37275:39442,37276:20687,37277:22679,37278:24974,37279:33235,37280:34101,37281:36104,37282:36896,37283:20419,37284:20596,37285:21063,37286:21363,37287:24687,37288:25417,37289:26463,37290:28204,37291:36275,37292:36895,37293:20439,37294:23646,37295:36042,37296:26063,37297:32154,37298:21330,37299:34966,37300:20854,37301:25539,37302:23384,37303:23403,37304:23562,37305:25613,37306:26449,37307:36956,37308:20182,37309:22810,37310:22826,37311:27760,37312:35409,37313:21822,37314:22549,37315:22949,37316:24816,37317:25171,37318:26561,37319:33333,37320:26965,37321:38464,37322:39364,37323:39464,37324:20307,37325:22534,37326:23550,37327:32784,37328:23729,37329:24111,37330:24453,37331:24608,37332:24907,37333:25140,37334:26367,37335:27888,37336:28382,37337:32974,37338:33151,37339:33492,37340:34955,37341:36024,37342:36864,37343:36910,37344:38538,37345:40667,37346:39899,37347:20195,37348:21488,37349:22823,37350:31532,37351:37261,37352:38988,37353:40441,37354:28381,37355:28711,37356:21331,37357:21828,37358:23429,37359:25176,37360:25246,37361:25299,37362:27810,37363:28655,37364:29730,37365:35351,37366:37944,37367:28609,37368:35582,37369:33592,37370:20967,37371:34552,37372:21482,37440:21481,37441:20294,37442:36948,37443:36784,37444:22890,37445:33073,37446:24061,37447:31466,37448:36799,37449:26842,37450:35895,37451:29432,37452:40008,37453:27197,37454:35504,37455:20025,37456:21336,37457:22022,37458:22374,37459:25285,37460:25506,37461:26086,37462:27470,37463:28129,37464:28251,37465:28845,37466:30701,37467:31471,37468:31658,37469:32187,37470:32829,37471:32966,37472:34507,37473:35477,37474:37723,37475:22243,37476:22727,37477:24382,37478:26029,37479:26262,37480:27264,37481:27573,37482:30007,37483:35527,37484:20516,37485:30693,37486:22320,37487:24347,37488:24677,37489:26234,37490:27744,37491:30196,37492:31258,37493:32622,37494:33268,37495:34584,37496:36933,37497:39347,37498:31689,37499:30044,37500:31481,37501:31569,37502:33988,37504:36880,37505:31209,37506:31378,37507:33590,37508:23265,37509:30528,37510:20013,37511:20210,37512:23449,37513:24544,37514:25277,37515:26172,37516:26609,37517:27880,37518:34411,37519:34935,37520:35387,37521:37198,37522:37619,37523:39376,37524:27159,37525:28710,37526:29482,37527:33511,37528:33879,37529:36015,37530:19969,37531:20806,37532:20939,37533:21899,37534:23541,37535:24086,37536:24115,37537:24193,37538:24340,37539:24373,37540:24427,37541:24500,37542:25074,37543:25361,37544:26274,37545:26397,37546:28526,37547:29266,37548:30010,37549:30522,37550:32884,37551:33081,37552:33144,37553:34678,37554:35519,37555:35548,37556:36229,37557:36339,37558:37530,37559:38263,37560:38914,37561:40165,37562:21189,37563:25431,37564:30452,37565:26389,37566:27784,37567:29645,37568:36035,37569:37806,37570:38515,37571:27941,37572:22684,37573:26894,37574:27084,37575:36861,37576:37786,37577:30171,37578:36890,37579:22618,37580:26626,37581:25524,37582:27131,37583:20291,37584:28460,37585:26584,37586:36795,37587:34086,37588:32180,37589:37716,37590:26943,37591:28528,37592:22378,37593:22775,37594:23340,37595:32044,37596:29226,37597:21514,37598:37347,37599:40372,37600:20141,37601:20302,37602:20572,37603:20597,37604:21059,37605:35998,37606:21576,37607:22564,37608:23450,37609:24093,37610:24213,37611:24237,37612:24311,37613:24351,37614:24716,37615:25269,37616:25402,37617:25552,37618:26799,37619:27712,37620:30855,37621:31118,37622:31243,37623:32224,37624:33351,37625:35330,37626:35558,37627:36420,37628:36883,37696:37048,37697:37165,37698:37336,37699:40718,37700:27877,37701:25688,37702:25826,37703:25973,37704:28404,37705:30340,37706:31515,37707:36969,37708:37841,37709:28346,37710:21746,37711:24505,37712:25764,37713:36685,37714:36845,37715:37444,37716:20856,37717:22635,37718:22825,37719:23637,37720:24215,37721:28155,37722:32399,37723:29980,37724:36028,37725:36578,37726:39003,37727:28857,37728:20253,37729:27583,37730:28593,37731:3e4,37732:38651,37733:20814,37734:21520,37735:22581,37736:22615,37737:22956,37738:23648,37739:24466,37740:26007,37741:26460,37742:28193,37743:30331,37744:33759,37745:36077,37746:36884,37747:37117,37748:37709,37749:30757,37750:30778,37751:21162,37752:24230,37753:22303,37754:22900,37755:24594,37756:20498,37757:20826,37758:20908,37760:20941,37761:20992,37762:21776,37763:22612,37764:22616,37765:22871,37766:23445,37767:23798,37768:23947,37769:24764,37770:25237,37771:25645,37772:26481,37773:26691,37774:26812,37775:26847,37776:30423,37777:28120,37778:28271,37779:28059,37780:28783,37781:29128,37782:24403,37783:30168,37784:31095,37785:31561,37786:31572,37787:31570,37788:31958,37789:32113,37790:21040,37791:33891,37792:34153,37793:34276,37794:35342,37795:35588,37796:35910,37797:36367,37798:36867,37799:36879,37800:37913,37801:38518,37802:38957,37803:39472,37804:38360,37805:20685,37806:21205,37807:21516,37808:22530,37809:23566,37810:24999,37811:25758,37812:27934,37813:30643,37814:31461,37815:33012,37816:33796,37817:36947,37818:37509,37819:23776,37820:40199,37821:21311,37822:24471,37823:24499,37824:28060,37825:29305,37826:30563,37827:31167,37828:31716,37829:27602,37830:29420,37831:35501,37832:26627,37833:27233,37834:20984,37835:31361,37836:26932,37837:23626,37838:40182,37839:33515,37840:23493,37841:37193,37842:28702,37843:22136,37844:23663,37845:24775,37846:25958,37847:27788,37848:35930,37849:36929,37850:38931,37851:21585,37852:26311,37853:37389,37854:22856,37855:37027,37856:20869,37857:20045,37858:20970,37859:34201,37860:35598,37861:28760,37862:25466,37863:37707,37864:26978,37865:39348,37866:32260,37867:30071,37868:21335,37869:26976,37870:36575,37871:38627,37872:27741,37873:20108,37874:23612,37875:24336,37876:36841,37877:21250,37878:36049,37879:32905,37880:34425,37881:24319,37882:26085,37883:20083,37884:20837,37952:22914,37953:23615,37954:38894,37955:20219,37956:22922,37957:24525,37958:35469,37959:28641,37960:31152,37961:31074,37962:23527,37963:33905,37964:29483,37965:29105,37966:24180,37967:24565,37968:25467,37969:25754,37970:29123,37971:31896,37972:20035,37973:24316,37974:20043,37975:22492,37976:22178,37977:24745,37978:28611,37979:32013,37980:33021,37981:33075,37982:33215,37983:36786,37984:35223,37985:34468,37986:24052,37987:25226,37988:25773,37989:35207,37990:26487,37991:27874,37992:27966,37993:29750,37994:30772,37995:23110,37996:32629,37997:33453,37998:39340,37999:20467,38e3:24259,38001:25309,38002:25490,38003:25943,38004:26479,38005:30403,38006:29260,38007:32972,38008:32954,38009:36649,38010:37197,38011:20493,38012:22521,38013:23186,38014:26757,38016:26995,38017:29028,38018:29437,38019:36023,38020:22770,38021:36064,38022:38506,38023:36889,38024:34687,38025:31204,38026:30695,38027:33833,38028:20271,38029:21093,38030:21338,38031:25293,38032:26575,38033:27850,38034:30333,38035:31636,38036:31893,38037:33334,38038:34180,38039:36843,38040:26333,38041:28448,38042:29190,38043:32283,38044:33707,38045:39361,38046:40614,38047:20989,38048:31665,38049:30834,38050:31672,38051:32903,38052:31560,38053:27368,38054:24161,38055:32908,38056:30033,38057:30048,38058:20843,38059:37474,38060:28300,38061:30330,38062:37271,38063:39658,38064:20240,38065:32624,38066:25244,38067:31567,38068:38309,38069:40169,38070:22138,38071:22617,38072:34532,38073:38588,38074:20276,38075:21028,38076:21322,38077:21453,38078:21467,38079:24070,38080:25644,38081:26001,38082:26495,38083:27710,38084:27726,38085:29256,38086:29359,38087:29677,38088:30036,38089:32321,38090:33324,38091:34281,38092:36009,38093:31684,38094:37318,38095:29033,38096:38930,38097:39151,38098:25405,38099:26217,38100:30058,38101:30436,38102:30928,38103:34115,38104:34542,38105:21290,38106:21329,38107:21542,38108:22915,38109:24199,38110:24444,38111:24754,38112:25161,38113:25209,38114:25259,38115:26e3,38116:27604,38117:27852,38118:30130,38119:30382,38120:30865,38121:31192,38122:32203,38123:32631,38124:32933,38125:34987,38126:35513,38127:36027,38128:36991,38129:38750,38130:39131,38131:27147,38132:31800,38133:20633,38134:23614,38135:24494,38136:26503,38137:27608,38138:29749,38139:30473,38140:32654,38208:40763,38209:26570,38210:31255,38211:21305,38212:30091,38213:39661,38214:24422,38215:33181,38216:33777,38217:32920,38218:24380,38219:24517,38220:30050,38221:31558,38222:36924,38223:26727,38224:23019,38225:23195,38226:32016,38227:30334,38228:35628,38229:20469,38230:24426,38231:27161,38232:27703,38233:28418,38234:29922,38235:31080,38236:34920,38237:35413,38238:35961,38239:24287,38240:25551,38241:30149,38242:31186,38243:33495,38244:37672,38245:37618,38246:33948,38247:34541,38248:39981,38249:21697,38250:24428,38251:25996,38252:27996,38253:28693,38254:36007,38255:36051,38256:38971,38257:25935,38258:29942,38259:19981,38260:20184,38261:22496,38262:22827,38263:23142,38264:23500,38265:20904,38266:24067,38267:24220,38268:24598,38269:25206,38270:25975,38272:26023,38273:26222,38274:28014,38275:29238,38276:31526,38277:33104,38278:33178,38279:33433,38280:35676,38281:36e3,38282:36070,38283:36212,38284:38428,38285:38468,38286:20398,38287:25771,38288:27494,38289:33310,38290:33889,38291:34154,38292:37096,38293:23553,38294:26963,38295:39080,38296:33914,38297:34135,38298:20239,38299:21103,38300:24489,38301:24133,38302:26381,38303:31119,38304:33145,38305:35079,38306:35206,38307:28149,38308:24343,38309:25173,38310:27832,38311:20175,38312:29289,38313:39826,38314:20998,38315:21563,38316:22132,38317:22707,38318:24996,38319:25198,38320:28954,38321:22894,38322:31881,38323:31966,38324:32027,38325:38640,38326:25991,38327:32862,38328:19993,38329:20341,38330:20853,38331:22592,38332:24163,38333:24179,38334:24330,38335:26564,38336:20006,38337:34109,38338:38281,38339:38491,38340:31859,38341:38913,38342:20731,38343:22721,38344:30294,38345:30887,38346:21029,38347:30629,38348:34065,38349:31622,38350:20559,38351:22793,38352:29255,38353:31687,38354:32232,38355:36794,38356:36820,38357:36941,38358:20415,38359:21193,38360:23081,38361:24321,38362:38829,38363:20445,38364:33303,38365:37610,38366:22275,38367:25429,38368:27497,38369:29995,38370:35036,38371:36628,38372:31298,38373:21215,38374:22675,38375:24917,38376:25098,38377:26286,38378:27597,38379:31807,38380:33769,38381:20515,38382:20472,38383:21253,38384:21574,38385:22577,38386:22857,38387:23453,38388:23792,38389:23791,38390:23849,38391:24214,38392:25265,38393:25447,38394:25918,38395:26041,38396:26379,38464:27861,38465:27873,38466:28921,38467:30770,38468:32299,38469:32990,38470:33459,38471:33804,38472:34028,38473:34562,38474:35090,38475:35370,38476:35914,38477:37030,38478:37586,38479:39165,38480:40179,38481:40300,38482:20047,38483:20129,38484:20621,38485:21078,38486:22346,38487:22952,38488:24125,38489:24536,38490:24537,38491:25151,38492:26292,38493:26395,38494:26576,38495:26834,38496:20882,38497:32033,38498:32938,38499:33192,38500:35584,38501:35980,38502:36031,38503:37502,38504:38450,38505:21536,38506:38956,38507:21271,38508:20693,38509:21340,38510:22696,38511:25778,38512:26420,38513:29287,38514:30566,38515:31302,38516:37350,38517:21187,38518:27809,38519:27526,38520:22528,38521:24140,38522:22868,38523:26412,38524:32763,38525:20961,38526:30406,38528:25705,38529:30952,38530:39764,38531:40635,38532:22475,38533:22969,38534:26151,38535:26522,38536:27598,38537:21737,38538:27097,38539:24149,38540:33180,38541:26517,38542:39850,38543:26622,38544:40018,38545:26717,38546:20134,38547:20451,38548:21448,38549:25273,38550:26411,38551:27819,38552:36804,38553:20397,38554:32365,38555:40639,38556:19975,38557:24930,38558:28288,38559:28459,38560:34067,38561:21619,38562:26410,38563:39749,38564:24051,38565:31637,38566:23724,38567:23494,38568:34588,38569:28234,38570:34001,38571:31252,38572:33032,38573:22937,38574:31885,38575:27665,38576:30496,38577:21209,38578:22818,38579:28961,38580:29279,38581:30683,38582:38695,38583:40289,38584:26891,38585:23167,38586:23064,38587:20901,38588:21517,38589:21629,38590:26126,38591:30431,38592:36855,38593:37528,38594:40180,38595:23018,38596:29277,38597:28357,38598:20813,38599:26825,38600:32191,38601:32236,38602:38754,38603:40634,38604:25720,38605:27169,38606:33538,38607:22916,38608:23391,38609:27611,38610:29467,38611:30450,38612:32178,38613:32791,38614:33945,38615:20786,38616:26408,38617:40665,38618:30446,38619:26466,38620:21247,38621:39173,38622:23588,38623:25147,38624:31870,38625:36016,38626:21839,38627:24758,38628:32011,38629:38272,38630:21249,38631:20063,38632:20918,38633:22812,38634:29242,38635:32822,38636:37326,38637:24357,38638:30690,38639:21380,38640:24441,38641:32004,38642:34220,38643:35379,38644:36493,38645:38742,38646:26611,38647:34222,38648:37971,38649:24841,38650:24840,38651:27833,38652:30290,38720:35565,38721:36664,38722:21807,38723:20305,38724:20778,38725:21191,38726:21451,38727:23461,38728:24189,38729:24736,38730:24962,38731:25558,38732:26377,38733:26586,38734:28263,38735:28044,38736:29494,38737:29495,38738:30001,38739:31056,38740:35029,38741:35480,38742:36938,38743:37009,38744:37109,38745:38596,38746:34701,38747:22805,38748:20104,38749:20313,38750:19982,38751:35465,38752:36671,38753:38928,38754:20653,38755:24188,38756:22934,38757:23481,38758:24248,38759:25562,38760:25594,38761:25793,38762:26332,38763:26954,38764:27096,38765:27915,38766:28342,38767:29076,38768:29992,38769:31407,38770:32650,38771:32768,38772:33865,38773:33993,38774:35201,38775:35617,38776:36362,38777:36965,38778:38525,38779:39178,38780:24958,38781:25233,38782:27442,38784:27779,38785:28020,38786:32716,38787:32764,38788:28096,38789:32645,38790:34746,38791:35064,38792:26469,38793:33713,38794:38972,38795:38647,38796:27931,38797:32097,38798:33853,38799:37226,38800:20081,38801:21365,38802:23888,38803:27396,38804:28651,38805:34253,38806:34349,38807:35239,38808:21033,38809:21519,38810:23653,38811:26446,38812:26792,38813:29702,38814:29827,38815:30178,38816:35023,38817:35041,38818:37324,38819:38626,38820:38520,38821:24459,38822:29575,38823:31435,38824:33870,38825:25504,38826:30053,38827:21129,38828:27969,38829:28316,38830:29705,38831:30041,38832:30827,38833:31890,38834:38534,38835:31452,38836:40845,38837:20406,38838:24942,38839:26053,38840:34396,38841:20102,38842:20142,38843:20698,38844:20001,38845:20940,38846:23534,38847:26009,38848:26753,38849:28092,38850:29471,38851:30274,38852:30637,38853:31260,38854:31975,38855:33391,38856:35538,38857:36988,38858:37327,38859:38517,38860:38936,38861:21147,38862:32209,38863:20523,38864:21400,38865:26519,38866:28107,38867:29136,38868:29747,38869:33256,38870:36650,38871:38563,38872:40023,38873:40607,38874:29792,38875:22593,38876:28057,38877:32047,38878:39006,38879:20196,38880:20278,38881:20363,38882:20919,38883:21169,38884:23994,38885:24604,38886:29618,38887:31036,38888:33491,38889:37428,38890:38583,38891:38646,38892:38666,38893:40599,38894:40802,38895:26278,38896:27508,38897:21015,38898:21155,38899:28872,38900:35010,38901:24265,38902:24651,38903:24976,38904:28451,38905:29001,38906:31806,38907:32244,38908:32879,38976:34030,38977:36899,38978:37676,38979:21570,38980:39791,38981:27347,38982:28809,38983:36034,38984:36335,38985:38706,38986:21172,38987:23105,38988:24266,38989:24324,38990:26391,38991:27004,38992:27028,38993:28010,38994:28431,38995:29282,38996:29436,38997:31725,38998:32769,38999:32894,39e3:34635,39001:37070,39002:20845,39003:40595,39004:31108,39005:32907,39006:37682,39007:35542,39008:20525,39009:21644,39010:35441,39011:27498,39012:36036,39013:33031,39014:24785,39015:26528,39016:40434,39017:20121,39018:20120,39019:39952,39020:35435,39021:34241,39022:34152,39023:26880,39024:28286,39025:30871,39026:33109,39071:24332,39072:19984,39073:19989,39074:20010,39075:20017,39076:20022,39077:20028,39078:20031,39079:20034,39080:20054,39081:20056,39082:20098,39083:20101,39084:35947,39085:20106,39086:33298,39087:24333,39088:20110,39089:20126,39090:20127,39091:20128,39092:20130,39093:20144,39094:20147,39095:20150,39096:20174,39097:20173,39098:20164,39099:20166,39100:20162,39101:20183,39102:20190,39103:20205,39104:20191,39105:20215,39106:20233,39107:20314,39108:20272,39109:20315,39110:20317,39111:20311,39112:20295,39113:20342,39114:20360,39115:20367,39116:20376,39117:20347,39118:20329,39119:20336,39120:20369,39121:20335,39122:20358,39123:20374,39124:20760,39125:20436,39126:20447,39127:20430,39128:20440,39129:20443,39130:20433,39131:20442,39132:20432,39133:20452,39134:20453,39135:20506,39136:20520,39137:20500,39138:20522,39139:20517,39140:20485,39141:20252,39142:20470,39143:20513,39144:20521,39145:20524,39146:20478,39147:20463,39148:20497,39149:20486,39150:20547,39151:20551,39152:26371,39153:20565,39154:20560,39155:20552,39156:20570,39157:20566,39158:20588,39159:20600,39160:20608,39161:20634,39162:20613,39163:20660,39164:20658,39232:20681,39233:20682,39234:20659,39235:20674,39236:20694,39237:20702,39238:20709,39239:20717,39240:20707,39241:20718,39242:20729,39243:20725,39244:20745,39245:20737,39246:20738,39247:20758,39248:20757,39249:20756,39250:20762,39251:20769,39252:20794,39253:20791,39254:20796,39255:20795,39256:20799,39257:20800,39258:20818,39259:20812,39260:20820,39261:20834,39262:31480,39263:20841,39264:20842,39265:20846,39266:20864,39267:20866,39268:22232,39269:20876,39270:20873,39271:20879,39272:20881,39273:20883,39274:20885,39275:20886,39276:20900,39277:20902,39278:20898,39279:20905,39280:20906,39281:20907,39282:20915,39283:20913,39284:20914,39285:20912,39286:20917,39287:20925,39288:20933,39289:20937,39290:20955,39291:20960,39292:34389,39293:20969,39294:20973,39296:20976,39297:20981,39298:20990,39299:20996,39300:21003,39301:21012,39302:21006,39303:21031,39304:21034,39305:21038,39306:21043,39307:21049,39308:21071,39309:21060,39310:21067,39311:21068,39312:21086,39313:21076,39314:21098,39315:21108,39316:21097,39317:21107,39318:21119,39319:21117,39320:21133,39321:21140,39322:21138,39323:21105,39324:21128,39325:21137,39326:36776,39327:36775,39328:21164,39329:21165,39330:21180,39331:21173,39332:21185,39333:21197,39334:21207,39335:21214,39336:21219,39337:21222,39338:39149,39339:21216,39340:21235,39341:21237,39342:21240,39343:21241,39344:21254,39345:21256,39346:30008,39347:21261,39348:21264,39349:21263,39350:21269,39351:21274,39352:21283,39353:21295,39354:21297,39355:21299,39356:21304,39357:21312,39358:21318,39359:21317,39360:19991,39361:21321,39362:21325,39363:20950,39364:21342,39365:21353,39366:21358,39367:22808,39368:21371,39369:21367,39370:21378,39371:21398,39372:21408,39373:21414,39374:21413,39375:21422,39376:21424,39377:21430,39378:21443,39379:31762,39380:38617,39381:21471,39382:26364,39383:29166,39384:21486,39385:21480,39386:21485,39387:21498,39388:21505,39389:21565,39390:21568,39391:21548,39392:21549,39393:21564,39394:21550,39395:21558,39396:21545,39397:21533,39398:21582,39399:21647,39400:21621,39401:21646,39402:21599,39403:21617,39404:21623,39405:21616,39406:21650,39407:21627,39408:21632,39409:21622,39410:21636,39411:21648,39412:21638,39413:21703,39414:21666,39415:21688,39416:21669,39417:21676,39418:21700,39419:21704,39420:21672,39488:21675,39489:21698,39490:21668,39491:21694,39492:21692,39493:21720,39494:21733,39495:21734,39496:21775,39497:21780,39498:21757,39499:21742,39500:21741,39501:21754,39502:21730,39503:21817,39504:21824,39505:21859,39506:21836,39507:21806,39508:21852,39509:21829,39510:21846,39511:21847,39512:21816,39513:21811,39514:21853,39515:21913,39516:21888,39517:21679,39518:21898,39519:21919,39520:21883,39521:21886,39522:21912,39523:21918,39524:21934,39525:21884,39526:21891,39527:21929,39528:21895,39529:21928,39530:21978,39531:21957,39532:21983,39533:21956,39534:21980,39535:21988,39536:21972,39537:22036,39538:22007,39539:22038,39540:22014,39541:22013,39542:22043,39543:22009,39544:22094,39545:22096,39546:29151,39547:22068,39548:22070,39549:22066,39550:22072,39552:22123,39553:22116,39554:22063,39555:22124,39556:22122,39557:22150,39558:22144,39559:22154,39560:22176,39561:22164,39562:22159,39563:22181,39564:22190,39565:22198,39566:22196,39567:22210,39568:22204,39569:22209,39570:22211,39571:22208,39572:22216,39573:22222,39574:22225,39575:22227,39576:22231,39577:22254,39578:22265,39579:22272,39580:22271,39581:22276,39582:22281,39583:22280,39584:22283,39585:22285,39586:22291,39587:22296,39588:22294,39589:21959,39590:22300,39591:22310,39592:22327,39593:22328,39594:22350,39595:22331,39596:22336,39597:22351,39598:22377,39599:22464,39600:22408,39601:22369,39602:22399,39603:22409,39604:22419,39605:22432,39606:22451,39607:22436,39608:22442,39609:22448,39610:22467,39611:22470,39612:22484,39613:22482,39614:22483,39615:22538,39616:22486,39617:22499,39618:22539,39619:22553,39620:22557,39621:22642,39622:22561,39623:22626,39624:22603,39625:22640,39626:27584,39627:22610,39628:22589,39629:22649,39630:22661,39631:22713,39632:22687,39633:22699,39634:22714,39635:22750,39636:22715,39637:22712,39638:22702,39639:22725,39640:22739,39641:22737,39642:22743,39643:22745,39644:22744,39645:22757,39646:22748,39647:22756,39648:22751,39649:22767,39650:22778,39651:22777,39652:22779,39653:22780,39654:22781,39655:22786,39656:22794,39657:22800,39658:22811,39659:26790,39660:22821,39661:22828,39662:22829,39663:22834,39664:22840,39665:22846,39666:31442,39667:22869,39668:22864,39669:22862,39670:22874,39671:22872,39672:22882,39673:22880,39674:22887,39675:22892,39676:22889,39744:22904,39745:22913,39746:22941,39747:20318,39748:20395,39749:22947,39750:22962,39751:22982,39752:23016,39753:23004,39754:22925,39755:23001,39756:23002,39757:23077,39758:23071,39759:23057,39760:23068,39761:23049,39762:23066,39763:23104,39764:23148,39765:23113,39766:23093,39767:23094,39768:23138,39769:23146,39770:23194,39771:23228,39772:23230,39773:23243,39774:23234,39775:23229,39776:23267,39777:23255,39778:23270,39779:23273,39780:23254,39781:23290,39782:23291,39783:23308,39784:23307,39785:23318,39786:23346,39787:23248,39788:23338,39789:23350,39790:23358,39791:23363,39792:23365,39793:23360,39794:23377,39795:23381,39796:23386,39797:23387,39798:23397,39799:23401,39800:23408,39801:23411,39802:23413,39803:23416,39804:25992,39805:23418,39806:23424,39808:23427,39809:23462,39810:23480,39811:23491,39812:23495,39813:23497,39814:23508,39815:23504,39816:23524,39817:23526,39818:23522,39819:23518,39820:23525,39821:23531,39822:23536,39823:23542,39824:23539,39825:23557,39826:23559,39827:23560,39828:23565,39829:23571,39830:23584,39831:23586,39832:23592,39833:23608,39834:23609,39835:23617,39836:23622,39837:23630,39838:23635,39839:23632,39840:23631,39841:23409,39842:23660,39843:23662,39844:20066,39845:23670,39846:23673,39847:23692,39848:23697,39849:23700,39850:22939,39851:23723,39852:23739,39853:23734,39854:23740,39855:23735,39856:23749,39857:23742,39858:23751,39859:23769,39860:23785,39861:23805,39862:23802,39863:23789,39864:23948,39865:23786,39866:23819,39867:23829,39868:23831,39869:23900,39870:23839,39871:23835,39872:23825,39873:23828,39874:23842,39875:23834,39876:23833,39877:23832,39878:23884,39879:23890,39880:23886,39881:23883,39882:23916,39883:23923,39884:23926,39885:23943,39886:23940,39887:23938,39888:23970,39889:23965,39890:23980,39891:23982,39892:23997,39893:23952,39894:23991,39895:23996,39896:24009,39897:24013,39898:24019,39899:24018,39900:24022,39901:24027,39902:24043,39903:24050,39904:24053,39905:24075,39906:24090,39907:24089,39908:24081,39909:24091,39910:24118,39911:24119,39912:24132,39913:24131,39914:24128,39915:24142,39916:24151,39917:24148,39918:24159,39919:24162,39920:24164,39921:24135,39922:24181,39923:24182,39924:24186,39925:40636,39926:24191,39927:24224,39928:24257,39929:24258,39930:24264,39931:24272,39932:24271,4e4:24278,40001:24291,40002:24285,40003:24282,40004:24283,40005:24290,40006:24289,40007:24296,40008:24297,40009:24300,40010:24305,40011:24307,40012:24304,40013:24308,40014:24312,40015:24318,40016:24323,40017:24329,40018:24413,40019:24412,40020:24331,40021:24337,40022:24342,40023:24361,40024:24365,40025:24376,40026:24385,40027:24392,40028:24396,40029:24398,40030:24367,40031:24401,40032:24406,40033:24407,40034:24409,40035:24417,40036:24429,40037:24435,40038:24439,40039:24451,40040:24450,40041:24447,40042:24458,40043:24456,40044:24465,40045:24455,40046:24478,40047:24473,40048:24472,40049:24480,40050:24488,40051:24493,40052:24508,40053:24534,40054:24571,40055:24548,40056:24568,40057:24561,40058:24541,40059:24755,40060:24575,40061:24609,40062:24672,40064:24601,40065:24592,40066:24617,40067:24590,40068:24625,40069:24603,40070:24597,40071:24619,40072:24614,40073:24591,40074:24634,40075:24666,40076:24641,40077:24682,40078:24695,40079:24671,40080:24650,40081:24646,40082:24653,40083:24675,40084:24643,40085:24676,40086:24642,40087:24684,40088:24683,40089:24665,40090:24705,40091:24717,40092:24807,40093:24707,40094:24730,40095:24708,40096:24731,40097:24726,40098:24727,40099:24722,40100:24743,40101:24715,40102:24801,40103:24760,40104:24800,40105:24787,40106:24756,40107:24560,40108:24765,40109:24774,40110:24757,40111:24792,40112:24909,40113:24853,40114:24838,40115:24822,40116:24823,40117:24832,40118:24820,40119:24826,40120:24835,40121:24865,40122:24827,40123:24817,40124:24845,40125:24846,40126:24903,40127:24894,40128:24872,40129:24871,40130:24906,40131:24895,40132:24892,40133:24876,40134:24884,40135:24893,40136:24898,40137:24900,40138:24947,40139:24951,40140:24920,40141:24921,40142:24922,40143:24939,40144:24948,40145:24943,40146:24933,40147:24945,40148:24927,40149:24925,40150:24915,40151:24949,40152:24985,40153:24982,40154:24967,40155:25004,40156:24980,40157:24986,40158:24970,40159:24977,40160:25003,40161:25006,40162:25036,40163:25034,40164:25033,40165:25079,40166:25032,40167:25027,40168:25030,40169:25018,40170:25035,40171:32633,40172:25037,40173:25062,40174:25059,40175:25078,40176:25082,40177:25076,40178:25087,40179:25085,40180:25084,40181:25086,40182:25088,40183:25096,40184:25097,40185:25101,40186:25100,40187:25108,40188:25115,40256:25118,40257:25121,40258:25130,40259:25134,40260:25136,40261:25138,40262:25139,40263:25153,40264:25166,40265:25182,40266:25187,40267:25179,40268:25184,40269:25192,40270:25212,40271:25218,40272:25225,40273:25214,40274:25234,40275:25235,40276:25238,40277:25300,40278:25219,40279:25236,40280:25303,40281:25297,40282:25275,40283:25295,40284:25343,40285:25286,40286:25812,40287:25288,40288:25308,40289:25292,40290:25290,40291:25282,40292:25287,40293:25243,40294:25289,40295:25356,40296:25326,40297:25329,40298:25383,40299:25346,40300:25352,40301:25327,40302:25333,40303:25424,40304:25406,40305:25421,40306:25628,40307:25423,40308:25494,40309:25486,40310:25472,40311:25515,40312:25462,40313:25507,40314:25487,40315:25481,40316:25503,40317:25525,40318:25451,40320:25449,40321:25534,40322:25577,40323:25536,40324:25542,40325:25571,40326:25545,40327:25554,40328:25590,40329:25540,40330:25622,40331:25652,40332:25606,40333:25619,40334:25638,40335:25654,40336:25885,40337:25623,40338:25640,40339:25615,40340:25703,40341:25711,40342:25718,40343:25678,40344:25898,40345:25749,40346:25747,40347:25765,40348:25769,40349:25736,40350:25788,40351:25818,40352:25810,40353:25797,40354:25799,40355:25787,40356:25816,40357:25794,40358:25841,40359:25831,40360:33289,40361:25824,40362:25825,40363:25260,40364:25827,40365:25839,40366:25900,40367:25846,40368:25844,40369:25842,40370:25850,40371:25856,40372:25853,40373:25880,40374:25884,40375:25861,40376:25892,40377:25891,40378:25899,40379:25908,40380:25909,40381:25911,40382:25910,40383:25912,40384:30027,40385:25928,40386:25942,40387:25941,40388:25933,40389:25944,40390:25950,40391:25949,40392:25970,40393:25976,40394:25986,40395:25987,40396:35722,40397:26011,40398:26015,40399:26027,40400:26039,40401:26051,40402:26054,40403:26049,40404:26052,40405:26060,40406:26066,40407:26075,40408:26073,40409:26080,40410:26081,40411:26097,40412:26482,40413:26122,40414:26115,40415:26107,40416:26483,40417:26165,40418:26166,40419:26164,40420:26140,40421:26191,40422:26180,40423:26185,40424:26177,40425:26206,40426:26205,40427:26212,40428:26215,40429:26216,40430:26207,40431:26210,40432:26224,40433:26243,40434:26248,40435:26254,40436:26249,40437:26244,40438:26264,40439:26269,40440:26305,40441:26297,40442:26313,40443:26302,40444:26300,40512:26308,40513:26296,40514:26326,40515:26330,40516:26336,40517:26175,40518:26342,40519:26345,40520:26352,40521:26357,40522:26359,40523:26383,40524:26390,40525:26398,40526:26406,40527:26407,40528:38712,40529:26414,40530:26431,40531:26422,40532:26433,40533:26424,40534:26423,40535:26438,40536:26462,40537:26464,40538:26457,40539:26467,40540:26468,40541:26505,40542:26480,40543:26537,40544:26492,40545:26474,40546:26508,40547:26507,40548:26534,40549:26529,40550:26501,40551:26551,40552:26607,40553:26548,40554:26604,40555:26547,40556:26601,40557:26552,40558:26596,40559:26590,40560:26589,40561:26594,40562:26606,40563:26553,40564:26574,40565:26566,40566:26599,40567:27292,40568:26654,40569:26694,40570:26665,40571:26688,40572:26701,40573:26674,40574:26702,40576:26803,40577:26667,40578:26713,40579:26723,40580:26743,40581:26751,40582:26783,40583:26767,40584:26797,40585:26772,40586:26781,40587:26779,40588:26755,40589:27310,40590:26809,40591:26740,40592:26805,40593:26784,40594:26810,40595:26895,40596:26765,40597:26750,40598:26881,40599:26826,40600:26888,40601:26840,40602:26914,40603:26918,40604:26849,40605:26892,40606:26829,40607:26836,40608:26855,40609:26837,40610:26934,40611:26898,40612:26884,40613:26839,40614:26851,40615:26917,40616:26873,40617:26848,40618:26863,40619:26920,40620:26922,40621:26906,40622:26915,40623:26913,40624:26822,40625:27001,40626:26999,40627:26972,40628:27e3,40629:26987,40630:26964,40631:27006,40632:26990,40633:26937,40634:26996,40635:26941,40636:26969,40637:26928,40638:26977,40639:26974,40640:26973,40641:27009,40642:26986,40643:27058,40644:27054,40645:27088,40646:27071,40647:27073,40648:27091,40649:27070,40650:27086,40651:23528,40652:27082,40653:27101,40654:27067,40655:27075,40656:27047,40657:27182,40658:27025,40659:27040,40660:27036,40661:27029,40662:27060,40663:27102,40664:27112,40665:27138,40666:27163,40667:27135,40668:27402,40669:27129,40670:27122,40671:27111,40672:27141,40673:27057,40674:27166,40675:27117,40676:27156,40677:27115,40678:27146,40679:27154,40680:27329,40681:27171,40682:27155,40683:27204,40684:27148,40685:27250,40686:27190,40687:27256,40688:27207,40689:27234,40690:27225,40691:27238,40692:27208,40693:27192,40694:27170,40695:27280,40696:27277,40697:27296,40698:27268,40699:27298,40700:27299,40768:27287,40769:34327,40770:27323,40771:27331,40772:27330,40773:27320,40774:27315,40775:27308,40776:27358,40777:27345,40778:27359,40779:27306,40780:27354,40781:27370,40782:27387,40783:27397,40784:34326,40785:27386,40786:27410,40787:27414,40788:39729,40789:27423,40790:27448,40791:27447,40792:30428,40793:27449,40794:39150,40795:27463,40796:27459,40797:27465,40798:27472,40799:27481,40800:27476,40801:27483,40802:27487,40803:27489,40804:27512,40805:27513,40806:27519,40807:27520,40808:27524,40809:27523,40810:27533,40811:27544,40812:27541,40813:27550,40814:27556,40815:27562,40816:27563,40817:27567,40818:27570,40819:27569,40820:27571,40821:27575,40822:27580,40823:27590,40824:27595,40825:27603,40826:27615,40827:27628,40828:27627,40829:27635,40830:27631,40832:40638,40833:27656,40834:27667,40835:27668,40836:27675,40837:27684,40838:27683,40839:27742,40840:27733,40841:27746,40842:27754,40843:27778,40844:27789,40845:27802,40846:27777,40847:27803,40848:27774,40849:27752,40850:27763,40851:27794,40852:27792,40853:27844,40854:27889,40855:27859,40856:27837,40857:27863,40858:27845,40859:27869,40860:27822,40861:27825,40862:27838,40863:27834,40864:27867,40865:27887,40866:27865,40867:27882,40868:27935,40869:34893,40870:27958,40871:27947,40872:27965,40873:27960,40874:27929,40875:27957,40876:27955,40877:27922,40878:27916,40879:28003,40880:28051,40881:28004,40882:27994,40883:28025,40884:27993,40885:28046,40886:28053,40887:28644,40888:28037,40889:28153,40890:28181,40891:28170,40892:28085,40893:28103,40894:28134,40895:28088,40896:28102,40897:28140,40898:28126,40899:28108,40900:28136,40901:28114,40902:28101,40903:28154,40904:28121,40905:28132,40906:28117,40907:28138,40908:28142,40909:28205,40910:28270,40911:28206,40912:28185,40913:28274,40914:28255,40915:28222,40916:28195,40917:28267,40918:28203,40919:28278,40920:28237,40921:28191,40922:28227,40923:28218,40924:28238,40925:28196,40926:28415,40927:28189,40928:28216,40929:28290,40930:28330,40931:28312,40932:28361,40933:28343,40934:28371,40935:28349,40936:28335,40937:28356,40938:28338,40939:28372,40940:28373,40941:28303,40942:28325,40943:28354,40944:28319,40945:28481,40946:28433,40947:28748,40948:28396,40949:28408,40950:28414,40951:28479,40952:28402,40953:28465,40954:28399,40955:28466,40956:28364,161:65377,162:65378,163:65379,164:65380,165:65381,166:65382,167:65383,168:65384,169:65385,170:65386,171:65387,172:65388,173:65389,174:65390,175:65391,176:65392,177:65393,178:65394,179:65395,180:65396,181:65397,182:65398,183:65399,184:65400,185:65401,186:65402,187:65403,188:65404,189:65405,190:65406,191:65407,192:65408,193:65409,194:65410,195:65411,196:65412,197:65413,198:65414,199:65415,200:65416,201:65417,202:65418,203:65419,204:65420,205:65421,206:65422,207:65423,208:65424,209:65425,210:65426,211:65427,212:65428,213:65429,214:65430,215:65431,216:65432,217:65433,218:65434,219:65435,220:65436,221:65437,222:65438,223:65439,57408:28478,57409:28435,57410:28407,57411:28550,57412:28538,57413:28536,57414:28545,57415:28544,57416:28527,57417:28507,57418:28659,57419:28525,57420:28546,57421:28540,57422:28504,57423:28558,57424:28561,57425:28610,57426:28518,57427:28595,57428:28579,57429:28577,57430:28580,57431:28601,57432:28614,57433:28586,57434:28639,57435:28629,57436:28652,57437:28628,57438:28632,57439:28657,57440:28654,57441:28635,57442:28681,57443:28683,57444:28666,57445:28689,57446:28673,57447:28687,57448:28670,57449:28699,57450:28698,57451:28532,57452:28701,57453:28696,57454:28703,57455:28720,57456:28734,57457:28722,57458:28753,57459:28771,57460:28825,57461:28818,57462:28847,57463:28913,57464:28844,57465:28856,57466:28851,57467:28846,57468:28895,57469:28875,57470:28893,57472:28889,57473:28937,57474:28925,57475:28956,57476:28953,57477:29029,57478:29013,57479:29064,57480:29030,57481:29026,57482:29004,57483:29014,57484:29036,57485:29071,57486:29179,57487:29060,57488:29077,57489:29096,57490:29100,57491:29143,57492:29113,57493:29118,57494:29138,57495:29129,57496:29140,57497:29134,57498:29152,57499:29164,57500:29159,57501:29173,57502:29180,57503:29177,57504:29183,57505:29197,57506:29200,57507:29211,57508:29224,57509:29229,57510:29228,57511:29232,57512:29234,57513:29243,57514:29244,57515:29247,57516:29248,57517:29254,57518:29259,57519:29272,57520:29300,57521:29310,57522:29314,57523:29313,57524:29319,57525:29330,57526:29334,57527:29346,57528:29351,57529:29369,57530:29362,57531:29379,57532:29382,57533:29380,57534:29390,57535:29394,57536:29410,57537:29408,57538:29409,57539:29433,57540:29431,57541:20495,57542:29463,57543:29450,57544:29468,57545:29462,57546:29469,57547:29492,57548:29487,57549:29481,57550:29477,57551:29502,57552:29518,57553:29519,57554:40664,57555:29527,57556:29546,57557:29544,57558:29552,57559:29560,57560:29557,57561:29563,57562:29562,57563:29640,57564:29619,57565:29646,57566:29627,57567:29632,57568:29669,57569:29678,57570:29662,57571:29858,57572:29701,57573:29807,57574:29733,57575:29688,57576:29746,57577:29754,57578:29781,57579:29759,57580:29791,57581:29785,57582:29761,57583:29788,57584:29801,57585:29808,57586:29795,57587:29802,57588:29814,57589:29822,57590:29835,57591:29854,57592:29863,57593:29898,57594:29903,57595:29908,57596:29681,57664:29920,57665:29923,57666:29927,57667:29929,57668:29934,57669:29938,57670:29936,57671:29937,57672:29944,57673:29943,57674:29956,57675:29955,57676:29957,57677:29964,57678:29966,57679:29965,57680:29973,57681:29971,57682:29982,57683:29990,57684:29996,57685:30012,57686:30020,57687:30029,57688:30026,57689:30025,57690:30043,57691:30022,57692:30042,57693:30057,57694:30052,57695:30055,57696:30059,57697:30061,57698:30072,57699:30070,57700:30086,57701:30087,57702:30068,57703:30090,57704:30089,57705:30082,57706:30100,57707:30106,57708:30109,57709:30117,57710:30115,57711:30146,57712:30131,57713:30147,57714:30133,57715:30141,57716:30136,57717:30140,57718:30129,57719:30157,57720:30154,57721:30162,57722:30169,57723:30179,57724:30174,57725:30206,57726:30207,57728:30204,57729:30209,57730:30192,57731:30202,57732:30194,57733:30195,57734:30219,57735:30221,57736:30217,57737:30239,57738:30247,57739:30240,57740:30241,57741:30242,57742:30244,57743:30260,57744:30256,57745:30267,57746:30279,57747:30280,57748:30278,57749:30300,57750:30296,57751:30305,57752:30306,57753:30312,57754:30313,57755:30314,57756:30311,57757:30316,57758:30320,57759:30322,57760:30326,57761:30328,57762:30332,57763:30336,57764:30339,57765:30344,57766:30347,57767:30350,57768:30358,57769:30355,57770:30361,57771:30362,57772:30384,57773:30388,57774:30392,57775:30393,57776:30394,57777:30402,57778:30413,57779:30422,57780:30418,57781:30430,57782:30433,57783:30437,57784:30439,57785:30442,57786:34351,57787:30459,57788:30472,57789:30471,57790:30468,57791:30505,57792:30500,57793:30494,57794:30501,57795:30502,57796:30491,57797:30519,57798:30520,57799:30535,57800:30554,57801:30568,57802:30571,57803:30555,57804:30565,57805:30591,57806:30590,57807:30585,57808:30606,57809:30603,57810:30609,57811:30624,57812:30622,57813:30640,57814:30646,57815:30649,57816:30655,57817:30652,57818:30653,57819:30651,57820:30663,57821:30669,57822:30679,57823:30682,57824:30684,57825:30691,57826:30702,57827:30716,57828:30732,57829:30738,57830:31014,57831:30752,57832:31018,57833:30789,57834:30862,57835:30836,57836:30854,57837:30844,57838:30874,57839:30860,57840:30883,57841:30901,57842:30890,57843:30895,57844:30929,57845:30918,57846:30923,57847:30932,57848:30910,57849:30908,57850:30917,57851:30922,57852:30956,57920:30951,57921:30938,57922:30973,57923:30964,57924:30983,57925:30994,57926:30993,57927:31001,57928:31020,57929:31019,57930:31040,57931:31072,57932:31063,57933:31071,57934:31066,57935:31061,57936:31059,57937:31098,57938:31103,57939:31114,57940:31133,57941:31143,57942:40779,57943:31146,57944:31150,57945:31155,57946:31161,57947:31162,57948:31177,57949:31189,57950:31207,57951:31212,57952:31201,57953:31203,57954:31240,57955:31245,57956:31256,57957:31257,57958:31264,57959:31263,57960:31104,57961:31281,57962:31291,57963:31294,57964:31287,57965:31299,57966:31319,57967:31305,57968:31329,57969:31330,57970:31337,57971:40861,57972:31344,57973:31353,57974:31357,57975:31368,57976:31383,57977:31381,57978:31384,57979:31382,57980:31401,57981:31432,57982:31408,57984:31414,57985:31429,57986:31428,57987:31423,57988:36995,57989:31431,57990:31434,57991:31437,57992:31439,57993:31445,57994:31443,57995:31449,57996:31450,57997:31453,57998:31457,57999:31458,58e3:31462,58001:31469,58002:31472,58003:31490,58004:31503,58005:31498,58006:31494,58007:31539,58008:31512,58009:31513,58010:31518,58011:31541,58012:31528,58013:31542,58014:31568,58015:31610,58016:31492,58017:31565,58018:31499,58019:31564,58020:31557,58021:31605,58022:31589,58023:31604,58024:31591,58025:31600,58026:31601,58027:31596,58028:31598,58029:31645,58030:31640,58031:31647,58032:31629,58033:31644,58034:31642,58035:31627,58036:31634,58037:31631,58038:31581,58039:31641,58040:31691,58041:31681,58042:31692,58043:31695,58044:31668,58045:31686,58046:31709,58047:31721,58048:31761,58049:31764,58050:31718,58051:31717,58052:31840,58053:31744,58054:31751,58055:31763,58056:31731,58057:31735,58058:31767,58059:31757,58060:31734,58061:31779,58062:31783,58063:31786,58064:31775,58065:31799,58066:31787,58067:31805,58068:31820,58069:31811,58070:31828,58071:31823,58072:31808,58073:31824,58074:31832,58075:31839,58076:31844,58077:31830,58078:31845,58079:31852,58080:31861,58081:31875,58082:31888,58083:31908,58084:31917,58085:31906,58086:31915,58087:31905,58088:31912,58089:31923,58090:31922,58091:31921,58092:31918,58093:31929,58094:31933,58095:31936,58096:31941,58097:31938,58098:31960,58099:31954,58100:31964,58101:31970,58102:39739,58103:31983,58104:31986,58105:31988,58106:31990,58107:31994,58108:32006,58176:32002,58177:32028,58178:32021,58179:32010,58180:32069,58181:32075,58182:32046,58183:32050,58184:32063,58185:32053,58186:32070,58187:32115,58188:32086,58189:32078,58190:32114,58191:32104,58192:32110,58193:32079,58194:32099,58195:32147,58196:32137,58197:32091,58198:32143,58199:32125,58200:32155,58201:32186,58202:32174,58203:32163,58204:32181,58205:32199,58206:32189,58207:32171,58208:32317,58209:32162,58210:32175,58211:32220,58212:32184,58213:32159,58214:32176,58215:32216,58216:32221,58217:32228,58218:32222,58219:32251,58220:32242,58221:32225,58222:32261,58223:32266,58224:32291,58225:32289,58226:32274,58227:32305,58228:32287,58229:32265,58230:32267,58231:32290,58232:32326,58233:32358,58234:32315,58235:32309,58236:32313,58237:32323,58238:32311,58240:32306,58241:32314,58242:32359,58243:32349,58244:32342,58245:32350,58246:32345,58247:32346,58248:32377,58249:32362,58250:32361,58251:32380,58252:32379,58253:32387,58254:32213,58255:32381,58256:36782,58257:32383,58258:32392,58259:32393,58260:32396,58261:32402,58262:32400,58263:32403,58264:32404,58265:32406,58266:32398,58267:32411,58268:32412,58269:32568,58270:32570,58271:32581,58272:32588,58273:32589,58274:32590,58275:32592,58276:32593,58277:32597,58278:32596,58279:32600,58280:32607,58281:32608,58282:32616,58283:32617,58284:32615,58285:32632,58286:32642,58287:32646,58288:32643,58289:32648,58290:32647,58291:32652,58292:32660,58293:32670,58294:32669,58295:32666,58296:32675,58297:32687,58298:32690,58299:32697,58300:32686,58301:32694,58302:32696,58303:35697,58304:32709,58305:32710,58306:32714,58307:32725,58308:32724,58309:32737,58310:32742,58311:32745,58312:32755,58313:32761,58314:39132,58315:32774,58316:32772,58317:32779,58318:32786,58319:32792,58320:32793,58321:32796,58322:32801,58323:32808,58324:32831,58325:32827,58326:32842,58327:32838,58328:32850,58329:32856,58330:32858,58331:32863,58332:32866,58333:32872,58334:32883,58335:32882,58336:32880,58337:32886,58338:32889,58339:32893,58340:32895,58341:32900,58342:32902,58343:32901,58344:32923,58345:32915,58346:32922,58347:32941,58348:20880,58349:32940,58350:32987,58351:32997,58352:32985,58353:32989,58354:32964,58355:32986,58356:32982,58357:33033,58358:33007,58359:33009,58360:33051,58361:33065,58362:33059,58363:33071,58364:33099,58432:38539,58433:33094,58434:33086,58435:33107,58436:33105,58437:33020,58438:33137,58439:33134,58440:33125,58441:33126,58442:33140,58443:33155,58444:33160,58445:33162,58446:33152,58447:33154,58448:33184,58449:33173,58450:33188,58451:33187,58452:33119,58453:33171,58454:33193,58455:33200,58456:33205,58457:33214,58458:33208,58459:33213,58460:33216,58461:33218,58462:33210,58463:33225,58464:33229,58465:33233,58466:33241,58467:33240,58468:33224,58469:33242,58470:33247,58471:33248,58472:33255,58473:33274,58474:33275,58475:33278,58476:33281,58477:33282,58478:33285,58479:33287,58480:33290,58481:33293,58482:33296,58483:33302,58484:33321,58485:33323,58486:33336,58487:33331,58488:33344,58489:33369,58490:33368,58491:33373,58492:33370,58493:33375,58494:33380,58496:33378,58497:33384,58498:33386,58499:33387,58500:33326,58501:33393,58502:33399,58503:33400,58504:33406,58505:33421,58506:33426,58507:33451,58508:33439,58509:33467,58510:33452,58511:33505,58512:33507,58513:33503,58514:33490,58515:33524,58516:33523,58517:33530,58518:33683,58519:33539,58520:33531,58521:33529,58522:33502,58523:33542,58524:33500,58525:33545,58526:33497,58527:33589,58528:33588,58529:33558,58530:33586,58531:33585,58532:33600,58533:33593,58534:33616,58535:33605,58536:33583,58537:33579,58538:33559,58539:33560,58540:33669,58541:33690,58542:33706,58543:33695,58544:33698,58545:33686,58546:33571,58547:33678,58548:33671,58549:33674,58550:33660,58551:33717,58552:33651,58553:33653,58554:33696,58555:33673,58556:33704,58557:33780,58558:33811,58559:33771,58560:33742,58561:33789,58562:33795,58563:33752,58564:33803,58565:33729,58566:33783,58567:33799,58568:33760,58569:33778,58570:33805,58571:33826,58572:33824,58573:33725,58574:33848,58575:34054,58576:33787,58577:33901,58578:33834,58579:33852,58580:34138,58581:33924,58582:33911,58583:33899,58584:33965,58585:33902,58586:33922,58587:33897,58588:33862,58589:33836,58590:33903,58591:33913,58592:33845,58593:33994,58594:33890,58595:33977,58596:33983,58597:33951,58598:34009,58599:33997,58600:33979,58601:34010,58602:34e3,58603:33985,58604:33990,58605:34006,58606:33953,58607:34081,58608:34047,58609:34036,58610:34071,58611:34072,58612:34092,58613:34079,58614:34069,58615:34068,58616:34044,58617:34112,58618:34147,58619:34136,58620:34120,58688:34113,58689:34306,58690:34123,58691:34133,58692:34176,58693:34212,58694:34184,58695:34193,58696:34186,58697:34216,58698:34157,58699:34196,58700:34203,58701:34282,58702:34183,58703:34204,58704:34167,58705:34174,58706:34192,58707:34249,58708:34234,58709:34255,58710:34233,58711:34256,58712:34261,58713:34269,58714:34277,58715:34268,58716:34297,58717:34314,58718:34323,58719:34315,58720:34302,58721:34298,58722:34310,58723:34338,58724:34330,58725:34352,58726:34367,58727:34381,58728:20053,58729:34388,58730:34399,58731:34407,58732:34417,58733:34451,58734:34467,58735:34473,58736:34474,58737:34443,58738:34444,58739:34486,58740:34479,58741:34500,58742:34502,58743:34480,58744:34505,58745:34851,58746:34475,58747:34516,58748:34526,58749:34537,58750:34540,58752:34527,58753:34523,58754:34543,58755:34578,58756:34566,58757:34568,58758:34560,58759:34563,58760:34555,58761:34577,58762:34569,58763:34573,58764:34553,58765:34570,58766:34612,58767:34623,58768:34615,58769:34619,58770:34597,58771:34601,58772:34586,58773:34656,58774:34655,58775:34680,58776:34636,58777:34638,58778:34676,58779:34647,58780:34664,58781:34670,58782:34649,58783:34643,58784:34659,58785:34666,58786:34821,58787:34722,58788:34719,58789:34690,58790:34735,58791:34763,58792:34749,58793:34752,58794:34768,58795:38614,58796:34731,58797:34756,58798:34739,58799:34759,58800:34758,58801:34747,58802:34799,58803:34802,58804:34784,58805:34831,58806:34829,58807:34814,58808:34806,58809:34807,58810:34830,58811:34770,58812:34833,58813:34838,58814:34837,58815:34850,58816:34849,58817:34865,58818:34870,58819:34873,58820:34855,58821:34875,58822:34884,58823:34882,58824:34898,58825:34905,58826:34910,58827:34914,58828:34923,58829:34945,58830:34942,58831:34974,58832:34933,58833:34941,58834:34997,58835:34930,58836:34946,58837:34967,58838:34962,58839:34990,58840:34969,58841:34978,58842:34957,58843:34980,58844:34992,58845:35007,58846:34993,58847:35011,58848:35012,58849:35028,58850:35032,58851:35033,58852:35037,58853:35065,58854:35074,58855:35068,58856:35060,58857:35048,58858:35058,58859:35076,58860:35084,58861:35082,58862:35091,58863:35139,58864:35102,58865:35109,58866:35114,58867:35115,58868:35137,58869:35140,58870:35131,58871:35126,58872:35128,58873:35148,58874:35101,58875:35168,58876:35166,58944:35174,58945:35172,58946:35181,58947:35178,58948:35183,58949:35188,58950:35191,58951:35198,58952:35203,58953:35208,58954:35210,58955:35219,58956:35224,58957:35233,58958:35241,58959:35238,58960:35244,58961:35247,58962:35250,58963:35258,58964:35261,58965:35263,58966:35264,58967:35290,58968:35292,58969:35293,58970:35303,58971:35316,58972:35320,58973:35331,58974:35350,58975:35344,58976:35340,58977:35355,58978:35357,58979:35365,58980:35382,58981:35393,58982:35419,58983:35410,58984:35398,58985:35400,58986:35452,58987:35437,58988:35436,58989:35426,58990:35461,58991:35458,58992:35460,58993:35496,58994:35489,58995:35473,58996:35493,58997:35494,58998:35482,58999:35491,59e3:35524,59001:35533,59002:35522,59003:35546,59004:35563,59005:35571,59006:35559,59008:35556,59009:35569,59010:35604,59011:35552,59012:35554,59013:35575,59014:35550,59015:35547,59016:35596,59017:35591,59018:35610,59019:35553,59020:35606,59021:35600,59022:35607,59023:35616,59024:35635,59025:38827,59026:35622,59027:35627,59028:35646,59029:35624,59030:35649,59031:35660,59032:35663,59033:35662,59034:35657,59035:35670,59036:35675,59037:35674,59038:35691,59039:35679,59040:35692,59041:35695,59042:35700,59043:35709,59044:35712,59045:35724,59046:35726,59047:35730,59048:35731,59049:35734,59050:35737,59051:35738,59052:35898,59053:35905,59054:35903,59055:35912,59056:35916,59057:35918,59058:35920,59059:35925,59060:35938,59061:35948,59062:35960,59063:35962,59064:35970,59065:35977,59066:35973,59067:35978,59068:35981,59069:35982,59070:35988,59071:35964,59072:35992,59073:25117,59074:36013,59075:36010,59076:36029,59077:36018,59078:36019,59079:36014,59080:36022,59081:36040,59082:36033,59083:36068,59084:36067,59085:36058,59086:36093,59087:36090,59088:36091,59089:36100,59090:36101,59091:36106,59092:36103,59093:36111,59094:36109,59095:36112,59096:40782,59097:36115,59098:36045,59099:36116,59100:36118,59101:36199,59102:36205,59103:36209,59104:36211,59105:36225,59106:36249,59107:36290,59108:36286,59109:36282,59110:36303,59111:36314,59112:36310,59113:36300,59114:36315,59115:36299,59116:36330,59117:36331,59118:36319,59119:36323,59120:36348,59121:36360,59122:36361,59123:36351,59124:36381,59125:36382,59126:36368,59127:36383,59128:36418,59129:36405,59130:36400,59131:36404,59132:36426,59200:36423,59201:36425,59202:36428,59203:36432,59204:36424,59205:36441,59206:36452,59207:36448,59208:36394,59209:36451,59210:36437,59211:36470,59212:36466,59213:36476,59214:36481,59215:36487,59216:36485,59217:36484,59218:36491,59219:36490,59220:36499,59221:36497,59222:36500,59223:36505,59224:36522,59225:36513,59226:36524,59227:36528,59228:36550,59229:36529,59230:36542,59231:36549,59232:36552,59233:36555,59234:36571,59235:36579,59236:36604,59237:36603,59238:36587,59239:36606,59240:36618,59241:36613,59242:36629,59243:36626,59244:36633,59245:36627,59246:36636,59247:36639,59248:36635,59249:36620,59250:36646,59251:36659,59252:36667,59253:36665,59254:36677,59255:36674,59256:36670,59257:36684,59258:36681,59259:36678,59260:36686,59261:36695,59262:36700,59264:36706,59265:36707,59266:36708,59267:36764,59268:36767,59269:36771,59270:36781,59271:36783,59272:36791,59273:36826,59274:36837,59275:36834,59276:36842,59277:36847,59278:36999,59279:36852,59280:36869,59281:36857,59282:36858,59283:36881,59284:36885,59285:36897,59286:36877,59287:36894,59288:36886,59289:36875,59290:36903,59291:36918,59292:36917,59293:36921,59294:36856,59295:36943,59296:36944,59297:36945,59298:36946,59299:36878,59300:36937,59301:36926,59302:36950,59303:36952,59304:36958,59305:36968,59306:36975,59307:36982,59308:38568,59309:36978,59310:36994,59311:36989,59312:36993,59313:36992,59314:37002,59315:37001,59316:37007,59317:37032,59318:37039,59319:37041,59320:37045,59321:37090,59322:37092,59323:25160,59324:37083,59325:37122,59326:37138,59327:37145,59328:37170,59329:37168,59330:37194,59331:37206,59332:37208,59333:37219,59334:37221,59335:37225,59336:37235,59337:37234,59338:37259,59339:37257,59340:37250,59341:37282,59342:37291,59343:37295,59344:37290,59345:37301,59346:37300,59347:37306,59348:37312,59349:37313,59350:37321,59351:37323,59352:37328,59353:37334,59354:37343,59355:37345,59356:37339,59357:37372,59358:37365,59359:37366,59360:37406,59361:37375,59362:37396,59363:37420,59364:37397,59365:37393,59366:37470,59367:37463,59368:37445,59369:37449,59370:37476,59371:37448,59372:37525,59373:37439,59374:37451,59375:37456,59376:37532,59377:37526,59378:37523,59379:37531,59380:37466,59381:37583,59382:37561,59383:37559,59384:37609,59385:37647,59386:37626,59387:37700,59388:37678,59456:37657,59457:37666,59458:37658,59459:37667,59460:37690,59461:37685,59462:37691,59463:37724,59464:37728,59465:37756,59466:37742,59467:37718,59468:37808,59469:37804,59470:37805,59471:37780,59472:37817,59473:37846,59474:37847,59475:37864,59476:37861,59477:37848,59478:37827,59479:37853,59480:37840,59481:37832,59482:37860,59483:37914,59484:37908,59485:37907,59486:37891,59487:37895,59488:37904,59489:37942,59490:37931,59491:37941,59492:37921,59493:37946,59494:37953,59495:37970,59496:37956,59497:37979,59498:37984,59499:37986,59500:37982,59501:37994,59502:37417,59503:38e3,59504:38005,59505:38007,59506:38013,59507:37978,59508:38012,59509:38014,59510:38017,59511:38015,59512:38274,59513:38279,59514:38282,59515:38292,59516:38294,59517:38296,59518:38297,59520:38304,59521:38312,59522:38311,59523:38317,59524:38332,59525:38331,59526:38329,59527:38334,59528:38346,59529:28662,59530:38339,59531:38349,59532:38348,59533:38357,59534:38356,59535:38358,59536:38364,59537:38369,59538:38373,59539:38370,59540:38433,59541:38440,59542:38446,59543:38447,59544:38466,59545:38476,59546:38479,59547:38475,59548:38519,59549:38492,59550:38494,59551:38493,59552:38495,59553:38502,59554:38514,59555:38508,59556:38541,59557:38552,59558:38549,59559:38551,59560:38570,59561:38567,59562:38577,59563:38578,59564:38576,59565:38580,59566:38582,59567:38584,59568:38585,59569:38606,59570:38603,59571:38601,59572:38605,59573:35149,59574:38620,59575:38669,59576:38613,59577:38649,59578:38660,59579:38662,59580:38664,59581:38675,59582:38670,59583:38673,59584:38671,59585:38678,59586:38681,59587:38692,59588:38698,59589:38704,59590:38713,59591:38717,59592:38718,59593:38724,59594:38726,59595:38728,59596:38722,59597:38729,59598:38748,59599:38752,59600:38756,59601:38758,59602:38760,59603:21202,59604:38763,59605:38769,59606:38777,59607:38789,59608:38780,59609:38785,59610:38778,59611:38790,59612:38795,59613:38799,59614:38800,59615:38812,59616:38824,59617:38822,59618:38819,59619:38835,59620:38836,59621:38851,59622:38854,59623:38856,59624:38859,59625:38876,59626:38893,59627:40783,59628:38898,59629:31455,59630:38902,59631:38901,59632:38927,59633:38924,59634:38968,59635:38948,59636:38945,59637:38967,59638:38973,59639:38982,59640:38991,59641:38987,59642:39019,59643:39023,59644:39024,59712:39025,59713:39028,59714:39027,59715:39082,59716:39087,59717:39089,59718:39094,59719:39108,59720:39107,59721:39110,59722:39145,59723:39147,59724:39171,59725:39177,59726:39186,59727:39188,59728:39192,59729:39201,59730:39197,59731:39198,59732:39204,59733:39200,59734:39212,59735:39214,59736:39229,59737:39230,59738:39234,59739:39241,59740:39237,59741:39248,59742:39243,59743:39249,59744:39250,59745:39244,59746:39253,59747:39319,59748:39320,59749:39333,59750:39341,59751:39342,59752:39356,59753:39391,59754:39387,59755:39389,59756:39384,59757:39377,59758:39405,59759:39406,59760:39409,59761:39410,59762:39419,59763:39416,59764:39425,59765:39439,59766:39429,59767:39394,59768:39449,59769:39467,59770:39479,59771:39493,59772:39490,59773:39488,59774:39491,59776:39486,59777:39509,59778:39501,59779:39515,59780:39511,59781:39519,59782:39522,59783:39525,59784:39524,59785:39529,59786:39531,59787:39530,59788:39597,59789:39600,59790:39612,59791:39616,59792:39631,59793:39633,59794:39635,59795:39636,59796:39646,59797:39647,59798:39650,59799:39651,59800:39654,59801:39663,59802:39659,59803:39662,59804:39668,59805:39665,59806:39671,59807:39675,59808:39686,59809:39704,59810:39706,59811:39711,59812:39714,59813:39715,59814:39717,59815:39719,59816:39720,59817:39721,59818:39722,59819:39726,59820:39727,59821:39730,59822:39748,59823:39747,59824:39759,59825:39757,59826:39758,59827:39761,59828:39768,59829:39796,59830:39827,59831:39811,59832:39825,59833:39830,59834:39831,59835:39839,59836:39840,59837:39848,59838:39860,59839:39872,59840:39882,59841:39865,59842:39878,59843:39887,59844:39889,59845:39890,59846:39907,59847:39906,59848:39908,59849:39892,59850:39905,59851:39994,59852:39922,59853:39921,59854:39920,59855:39957,59856:39956,59857:39945,59858:39955,59859:39948,59860:39942,59861:39944,59862:39954,59863:39946,59864:39940,59865:39982,59866:39963,59867:39973,59868:39972,59869:39969,59870:39984,59871:40007,59872:39986,59873:40006,59874:39998,59875:40026,59876:40032,59877:40039,59878:40054,59879:40056,59880:40167,59881:40172,59882:40176,59883:40201,59884:40200,59885:40171,59886:40195,59887:40198,59888:40234,59889:40230,59890:40367,59891:40227,59892:40223,59893:40260,59894:40213,59895:40210,59896:40257,59897:40255,59898:40254,59899:40262,59900:40264,59968:40285,59969:40286,59970:40292,59971:40273,59972:40272,59973:40281,59974:40306,59975:40329,59976:40327,59977:40363,59978:40303,59979:40314,59980:40346,59981:40356,59982:40361,59983:40370,59984:40388,59985:40385,59986:40379,59987:40376,59988:40378,59989:40390,59990:40399,59991:40386,59992:40409,59993:40403,59994:40440,59995:40422,59996:40429,59997:40431,59998:40445,59999:40474,6e4:40475,60001:40478,60002:40565,60003:40569,60004:40573,60005:40577,60006:40584,60007:40587,60008:40588,60009:40594,60010:40597,60011:40593,60012:40605,60013:40613,60014:40617,60015:40632,60016:40618,60017:40621,60018:38753,60019:40652,60020:40654,60021:40655,60022:40656,60023:40660,60024:40668,60025:40670,60026:40669,60027:40672,60028:40677,60029:40680,60030:40687,60032:40692,60033:40694,60034:40695,60035:40697,60036:40699,60037:40700,60038:40701,60039:40711,60040:40712,60041:30391,60042:40725,60043:40737,60044:40748,60045:40766,60046:40778,60047:40786,60048:40788,60049:40803,60050:40799,60051:40800,60052:40801,60053:40806,60054:40807,60055:40812,60056:40810,60057:40823,60058:40818,60059:40822,60060:40853,60061:40860,60062:40864,60063:22575,60064:27079,60065:36953,60066:29796,60067:20956,60068:29081}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(1),c=r(2);e.decode=function(o,e){var r=new Uint8ClampedArray(o.length);r.set(o);for(var s=new t.default(285,256,0),a=new c.default(s,r),n=new Uint8ClampedArray(e),d=!1,l=0;l<e;l++){var i=a.evaluateAt(s.exp(l+s.generatorBase));n[n.length-1-l]=i,0!==i&&(d=!0)}if(!d)return r;var B=new c.default(s,n),k=function(o,e,r,t){var c;e.degree()<r.degree()&&(e=(c=[r,e])[0],r=c[1]);for(var s=e,a=r,n=o.zero,d=o.one;a.degree()>=t/2;){var l=s,i=n;if(n=d,(s=a).isZero())return null;a=l;for(var B=o.zero,k=s.getCoefficient(s.degree()),u=o.inverse(k);a.degree()>=s.degree()&&!a.isZero();){var f=a.degree()-s.degree(),m=o.multiply(a.getCoefficient(a.degree()),u);B=B.addOrSubtract(o.buildMonomial(f,m)),a=a.addOrSubtract(s.multiplyByMonomial(f,m))}if(d=B.multiplyPoly(n).addOrSubtract(i),a.degree()>=s.degree())return null}var C=d.getCoefficient(0);if(0===C)return null;var w=o.inverse(C);return[d.multiply(w),a.multiply(w)]}(s,s.buildMonomial(e,1),B,e);if(null===k)return null;var u=function(o,e){var r=e.degree();if(1===r)return[e.getCoefficient(1)];for(var t=new Array(r),c=0,s=1;s<o.size&&c<r;s++)0===e.evaluateAt(s)&&(t[c]=o.inverse(s),c++);return c!==r?null:t}(s,k[0]);if(null==u)return null;for(var f=function(o,e,r){for(var c=r.length,s=new Array(c),a=0;a<c;a++){for(var n=o.inverse(r[a]),d=1,l=0;l<c;l++)a!==l&&(d=o.multiply(d,t.addOrSubtractGF(1,o.multiply(r[l],n))));s[a]=o.multiply(e.evaluateAt(n),o.inverse(d)),0!==o.generatorBase&&(s[a]=o.multiply(s[a],n))}return s}(s,k[1],u),m=0;m<u.length;m++){var C=r.length-1-s.log(u[m]);if(C<0)return null;r[C]=t.addOrSubtractGF(r[C],f[m])}return r}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0}),e.VERSIONS=[{infoBits:null,versionNumber:1,alignmentPatternCenters:[],errorCorrectionLevels:[{ecCodewordsPerBlock:7,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:13,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:13}]},{ecCodewordsPerBlock:17,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:2,alignmentPatternCenters:[6,18],errorCorrectionLevels:[{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:34}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:28}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]}]},{infoBits:null,versionNumber:3,alignmentPatternCenters:[6,22],errorCorrectionLevels:[{ecCodewordsPerBlock:15,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:55}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:13}]}]},{infoBits:null,versionNumber:4,alignmentPatternCenters:[6,26],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:80}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:32}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:5,alignmentPatternCenters:[6,30],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:43}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:11},{numBlocks:2,dataCodewordsPerBlock:12}]}]},{infoBits:null,versionNumber:6,alignmentPatternCenters:[6,34],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:27}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:31892,versionNumber:7,alignmentPatternCenters:[6,22,38],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:78}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:31}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:13},{numBlocks:1,dataCodewordsPerBlock:14}]}]},{infoBits:34236,versionNumber:8,alignmentPatternCenters:[6,24,42],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:97}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:38},{numBlocks:2,dataCodewordsPerBlock:39}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:18},{numBlocks:2,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:14},{numBlocks:2,dataCodewordsPerBlock:15}]}]},{infoBits:39577,versionNumber:9,alignmentPatternCenters:[6,26,46],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:12},{numBlocks:4,dataCodewordsPerBlock:13}]}]},{infoBits:42195,versionNumber:10,alignmentPatternCenters:[6,28,50],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68},{numBlocks:2,dataCodewordsPerBlock:69}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:43},{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]}]},{infoBits:48118,versionNumber:11,alignmentPatternCenters:[6,30,54],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:81}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:50},{numBlocks:4,dataCodewordsPerBlock:51}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:22},{numBlocks:4,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:12},{numBlocks:8,dataCodewordsPerBlock:13}]}]},{infoBits:51042,versionNumber:12,alignmentPatternCenters:[6,32,58],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:92},{numBlocks:2,dataCodewordsPerBlock:93}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:20},{numBlocks:6,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:55367,versionNumber:13,alignmentPatternCenters:[6,34,62],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:37},{numBlocks:1,dataCodewordsPerBlock:38}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:20},{numBlocks:4,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:11},{numBlocks:4,dataCodewordsPerBlock:12}]}]},{infoBits:58893,versionNumber:14,alignmentPatternCenters:[6,26,46,66],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:40},{numBlocks:5,dataCodewordsPerBlock:41}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:16},{numBlocks:5,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:5,dataCodewordsPerBlock:13}]}]},{infoBits:63784,versionNumber:15,alignmentPatternCenters:[6,26,48,70],errorCorrectionLevels:[{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:87},{numBlocks:1,dataCodewordsPerBlock:88}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:41},{numBlocks:5,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:7,dataCodewordsPerBlock:13}]}]},{infoBits:68472,versionNumber:16,alignmentPatternCenters:[6,26,50,74],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:98},{numBlocks:1,dataCodewordsPerBlock:99}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:70749,versionNumber:17,alignmentPatternCenters:[6,30,54,78],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:1,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22},{numBlocks:15,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:17,dataCodewordsPerBlock:15}]}]},{infoBits:76311,versionNumber:18,alignmentPatternCenters:[6,30,56,82],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:120},{numBlocks:1,dataCodewordsPerBlock:121}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:43},{numBlocks:4,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:1,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:19,dataCodewordsPerBlock:15}]}]},{infoBits:79154,versionNumber:19,alignmentPatternCenters:[6,30,58,86],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:113},{numBlocks:4,dataCodewordsPerBlock:114}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:44},{numBlocks:11,dataCodewordsPerBlock:45}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:21},{numBlocks:4,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:13},{numBlocks:16,dataCodewordsPerBlock:14}]}]},{infoBits:84390,versionNumber:20,alignmentPatternCenters:[6,34,62,90],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:41},{numBlocks:13,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:5,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:15},{numBlocks:10,dataCodewordsPerBlock:16}]}]},{infoBits:87683,versionNumber:21,alignmentPatternCenters:[6,28,50,72,94],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:116},{numBlocks:4,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:16},{numBlocks:6,dataCodewordsPerBlock:17}]}]},{infoBits:92361,versionNumber:22,alignmentPatternCenters:[6,26,50,74,98],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:111},{numBlocks:7,dataCodewordsPerBlock:112}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:13}]}]},{infoBits:96236,versionNumber:23,alignmentPatternCenters:[6,30,54,74,102],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:121},{numBlocks:5,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:47},{numBlocks:14,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:16,dataCodewordsPerBlock:15},{numBlocks:14,dataCodewordsPerBlock:16}]}]},{infoBits:102084,versionNumber:24,alignmentPatternCenters:[6,28,54,80,106],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:45},{numBlocks:14,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:30,dataCodewordsPerBlock:16},{numBlocks:2,dataCodewordsPerBlock:17}]}]},{infoBits:102881,versionNumber:25,alignmentPatternCenters:[6,32,58,84,110],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:106},{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:47},{numBlocks:13,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:110507,versionNumber:26,alignmentPatternCenters:[6,30,58,86,114],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:114},{numBlocks:2,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:46},{numBlocks:4,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:28,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:33,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]}]},{infoBits:110734,versionNumber:27,alignmentPatternCenters:[6,34,62,90,118],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:23},{numBlocks:26,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:117786,versionNumber:28,alignmentPatternCenters:[6,26,50,74,98,122],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:117},{numBlocks:10,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:45},{numBlocks:23,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:24},{numBlocks:31,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:31,dataCodewordsPerBlock:16}]}]},{infoBits:119615,versionNumber:29,alignmentPatternCenters:[6,30,54,78,102,126],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:116},{numBlocks:7,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:21,dataCodewordsPerBlock:45},{numBlocks:7,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:23},{numBlocks:37,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:26,dataCodewordsPerBlock:16}]}]},{infoBits:126325,versionNumber:30,alignmentPatternCenters:[6,26,52,78,104,130],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:115},{numBlocks:10,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:47},{numBlocks:10,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:25,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:25,dataCodewordsPerBlock:16}]}]},{infoBits:127568,versionNumber:31,alignmentPatternCenters:[6,30,56,82,108,134],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:3,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:46},{numBlocks:29,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:24},{numBlocks:1,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:133589,versionNumber:32,alignmentPatternCenters:[6,34,60,86,112,138],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:24},{numBlocks:35,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:35,dataCodewordsPerBlock:16}]}]},{infoBits:136944,versionNumber:33,alignmentPatternCenters:[6,30,58,86,114,142],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:21,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:24},{numBlocks:19,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:141498,versionNumber:34,alignmentPatternCenters:[6,34,62,90,118,146],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:6,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:44,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:59,dataCodewordsPerBlock:16},{numBlocks:1,dataCodewordsPerBlock:17}]}]},{infoBits:145311,versionNumber:35,alignmentPatternCenters:[6,30,54,78,102,126,150],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:121},{numBlocks:7,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:47},{numBlocks:26,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:39,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:41,dataCodewordsPerBlock:16}]}]},{infoBits:150283,versionNumber:36,alignmentPatternCenters:[6,24,50,76,102,128,154],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:121},{numBlocks:14,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:47},{numBlocks:34,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:46,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:64,dataCodewordsPerBlock:16}]}]},{infoBits:152622,versionNumber:37,alignmentPatternCenters:[6,28,54,80,106,132,158],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:46},{numBlocks:14,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:49,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:24,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:158308,versionNumber:38,alignmentPatternCenters:[6,32,58,84,110,136,162],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:122},{numBlocks:18,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:46},{numBlocks:32,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:48,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:15},{numBlocks:32,dataCodewordsPerBlock:16}]}]},{infoBits:161089,versionNumber:39,alignmentPatternCenters:[6,26,54,82,110,138,166],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:40,dataCodewordsPerBlock:47},{numBlocks:7,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:43,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:15},{numBlocks:67,dataCodewordsPerBlock:16}]}]},{infoBits:167017,versionNumber:40,alignmentPatternCenters:[6,30,58,86,114,142,170],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:118},{numBlocks:6,dataCodewordsPerBlock:119}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:18,dataCodewordsPerBlock:47},{numBlocks:31,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:24},{numBlocks:34,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:15},{numBlocks:61,dataCodewordsPerBlock:16}]}]}]},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=r(0);function c(o,e,r,t){var c=o.x-e.x+r.x-t.x,s=o.y-e.y+r.y-t.y;if(0===c&&0===s)return{a11:e.x-o.x,a12:e.y-o.y,a13:0,a21:r.x-e.x,a22:r.y-e.y,a23:0,a31:o.x,a32:o.y,a33:1};var a=e.x-r.x,n=t.x-r.x,d=e.y-r.y,l=t.y-r.y,i=a*l-n*d,B=(c*l-n*s)/i,k=(a*s-c*d)/i;return{a11:e.x-o.x+B*e.x,a12:e.y-o.y+B*e.y,a13:B,a21:t.x-o.x+k*t.x,a22:t.y-o.y+k*t.y,a23:k,a31:o.x,a32:o.y,a33:1}}e.extract=function(o,e){for(var r,s,a={a11:(u=c({x:3.5,y:3.5},{x:e.dimension-3.5,y:3.5},{x:e.dimension-6.5,y:e.dimension-6.5},{x:3.5,y:e.dimension-3.5})).a22*u.a33-u.a23*u.a32,a12:u.a13*u.a32-u.a12*u.a33,a13:u.a12*u.a23-u.a13*u.a22,a21:u.a23*u.a31-u.a21*u.a33,a22:u.a11*u.a33-u.a13*u.a31,a23:u.a13*u.a21-u.a11*u.a23,a31:u.a21*u.a32-u.a22*u.a31,a32:u.a12*u.a31-u.a11*u.a32,a33:u.a11*u.a22-u.a12*u.a21},n={a11:(r=c(e.topLeft,e.topRight,e.alignmentPattern,e.bottomLeft)).a11*(s=a).a11+r.a21*s.a12+r.a31*s.a13,a12:r.a12*s.a11+r.a22*s.a12+r.a32*s.a13,a13:r.a13*s.a11+r.a23*s.a12+r.a33*s.a13,a21:r.a11*s.a21+r.a21*s.a22+r.a31*s.a23,a22:r.a12*s.a21+r.a22*s.a22+r.a32*s.a23,a23:r.a13*s.a21+r.a23*s.a22+r.a33*s.a23,a31:r.a11*s.a31+r.a21*s.a32+r.a31*s.a33,a32:r.a12*s.a31+r.a22*s.a32+r.a32*s.a33,a33:r.a13*s.a31+r.a23*s.a32+r.a33*s.a33},d=t.BitMatrix.createEmpty(e.dimension,e.dimension),l=function(o,e){var r=n.a13*o+n.a23*e+n.a33;return{x:(n.a11*o+n.a21*e+n.a31)/r,y:(n.a12*o+n.a22*e+n.a32)/r}},i=0;i<e.dimension;i++)for(var B=0;B<e.dimension;B++){var k=l(B+.5,i+.5);d.set(B,i,o.get(Math.floor(k.x),Math.floor(k.y)))}var u;return{matrix:d,mappingFunction:l}}},function(o,e,r){Object.defineProperty(e,"__esModule",{value:!0});var t=function(o,e){return Math.sqrt(Math.pow(e.x-o.x,2)+Math.pow(e.y-o.y,2))};function c(o){return o.reduce(function(o,e){return o+e})}function s(o,e,r,c){var s,a,n,d,l=[{x:Math.floor(o.x),y:Math.floor(o.y)}],i=Math.abs(e.y-o.y)>Math.abs(e.x-o.x);i?(s=Math.floor(o.y),a=Math.floor(o.x),n=Math.floor(e.y),d=Math.floor(e.x)):(s=Math.floor(o.x),a=Math.floor(o.y),n=Math.floor(e.x),d=Math.floor(e.y));for(var B=Math.abs(n-s),k=Math.abs(d-a),u=Math.floor(-B/2),f=s<n?1:-1,m=a<d?1:-1,C=!0,w=s,P=a;w!==n+f;w+=f){var h=i?P:w,v=i?w:P;if(r.get(h,v)!==C&&(C=!C,l.push({x:h,y:v}),l.length===c+1))break;if((u+=k)>0){if(P===d)break;P+=m,u-=B}}for(var y=[],p=0;p<c;p++)y.push(l[p]&&l[p+1]?t(l[p],l[p+1]):0);return y}function a(o,e,r,t){var c,a=e.y-o.y,n=e.x-o.x,d=s(o,e,r,Math.ceil(t/2)),l=s(o,{x:o.x-n,y:o.y-a},r,Math.ceil(t/2)),i=d.shift()+l.shift()-1;return(c=l.concat(i)).concat.apply(c,d)}function n(o,e){var r=c(o)/c(e),t=0;return e.forEach(function(e,c){t+=Math.pow(o[c]-e*r,2)}),{averageSize:r,error:t}}function d(o,e,r){try{var t=a(o,{x:-1,y:o.y},r,e.length),c=a(o,{x:o.x,y:-1},r,e.length),s=a(o,{x:Math.max(0,o.x-o.y)-1,y:Math.max(0,o.y-o.x)-1},r,e.length),d=a(o,{x:Math.min(r.width,o.x+o.y)+1,y:Math.min(r.height,o.y+o.x)+1},r,e.length),l=n(t,e),i=n(c,e),B=n(s,e),k=n(d,e),u=Math.sqrt(l.error*l.error+i.error*i.error+B.error*B.error+k.error*k.error),f=(l.averageSize+i.averageSize+B.averageSize+k.averageSize)/4;return u+(Math.pow(l.averageSize-f,2)+Math.pow(i.averageSize-f,2)+Math.pow(B.averageSize-f,2)+Math.pow(k.averageSize-f,2))/f}catch(o){return Infinity}}function l(o,e){for(var r=Math.round(e.x);o.get(r,Math.round(e.y));)r--;for(var t=Math.round(e.x);o.get(t,Math.round(e.y));)t++;for(var c=(r+t)/2,s=Math.round(e.y);o.get(Math.round(c),s);)s--;for(var a=Math.round(e.y);o.get(Math.round(c),a);)a++;return{x:c,y:(s+a)/2}}function i(o,e,r,s,n){var l,i,B;try{l=function(o,e,r,s){var n=(c(a(o,r,s,5))/7+c(a(o,e,s,5))/7+c(a(r,o,s,5))/7+c(a(e,o,s,5))/7)/4;if(n<1)throw new Error("Invalid module size");var d=Math.round(t(o,e)/n),l=Math.round(t(o,r)/n),i=Math.floor((d+l)/2)+7;switch(i%4){case 0:i++;break;case 2:i--}return{dimension:i,moduleSize:n}}(s,r,n,o),i=l.dimension,B=l.moduleSize}catch(o){return null}var k=r.x-s.x+n.x,u=r.y-s.y+n.y,f=(t(s,n)+t(s,r))/2/B,m=1-3/f,C={x:s.x+m*(k-s.x),y:s.y+m*(u-s.y)},w=e.map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,s=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.floor(r),Math.floor(s)))return c([e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1]),{x:r,y:s,score:d({x:Math.floor(r),y:Math.floor(s)},[1,1,1],o)+t({x:r,y:s},C)}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score});return{alignmentPattern:f>=15&&w.length?w[0]:C,dimension:i}}e.locate=function(o){for(var e=[],r=[],s=[],a=[],n=function(t){for(var n=0,d=!1,l=[0,0,0,0,0],i=function(e){var s=o.get(e,t);if(s===d)n++;else{l=[l[1],l[2],l[3],l[4],n],n=1,d=s;var i=c(l)/7,B=Math.abs(l[0]-i)<i&&Math.abs(l[1]-i)<i&&Math.abs(l[2]-3*i)<3*i&&Math.abs(l[3]-i)<i&&Math.abs(l[4]-i)<i&&!s,k=c(l.slice(-3))/3,u=Math.abs(l[2]-k)<k&&Math.abs(l[3]-k)<k&&Math.abs(l[4]-k)<k&&s;if(B){var f=e-l[3]-l[4],m=f-l[2],C={startX:m,endX:f,y:t};(w=r.filter(function(o){return m>=o.bottom.startX&&m<=o.bottom.endX||f>=o.bottom.startX&&m<=o.bottom.endX||m<=o.bottom.startX&&f>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<1.5&&l[2]/(o.bottom.endX-o.bottom.startX)>.5})).length>0?w[0].bottom=C:r.push({top:C,bottom:C})}if(u){var w,P=e-l[4],h=P-l[3];C={startX:h,y:t,endX:P},(w=a.filter(function(o){return h>=o.bottom.startX&&h<=o.bottom.endX||P>=o.bottom.startX&&h<=o.bottom.endX||h<=o.bottom.startX&&P>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<1.5&&l[2]/(o.bottom.endX-o.bottom.startX)>.5})).length>0?w[0].bottom=C:a.push({top:C,bottom:C})}}},B=-1;B<=o.width;B++)i(B);e.push.apply(e,r.filter(function(o){return o.bottom.y!==t&&o.bottom.y-o.top.y>=2})),r=r.filter(function(o){return o.bottom.y===t}),s.push.apply(s,a.filter(function(o){return o.bottom.y!==t})),a=a.filter(function(o){return o.bottom.y===t})},B=0;B<=o.height;B++)n(B);e.push.apply(e,r.filter(function(o){return o.bottom.y-o.top.y>=2})),s.push.apply(s,a);var k=e.filter(function(o){return o.bottom.y-o.top.y>=2}).map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,t=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.round(r),Math.round(t))){var s=[e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1],a=c(s)/s.length;return{score:d({x:Math.round(r),y:Math.round(t)},[1,1,3,1,1],o),x:r,y:t,size:a}}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score}).map(function(o,e,r){if(e>4)return null;var t=r.filter(function(o,r){return e!==r}).map(function(e){return{x:e.x,y:e.y,score:e.score+Math.pow(e.size-o.size,2)/o.size,size:e.size}}).sort(function(o,e){return o.score-e.score});if(t.length<2)return null;var c=o.score+t[0].score+t[1].score;return{points:[o].concat(t.slice(0,2)),score:c}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score});if(0===k.length)return null;var u=function(o,e,r){var c,s,a,n,d,l,i,B=t(o,e),k=t(e,r),u=t(o,r);return k>=B&&k>=u?(d=(c=[e,o,r])[0],l=c[1],i=c[2]):u>=k&&u>=B?(d=(s=[o,e,r])[0],l=s[1],i=s[2]):(d=(a=[o,r,e])[0],l=a[1],i=a[2]),(i.x-l.x)*(d.y-l.y)-(i.y-l.y)*(d.x-l.x)<0&&(d=(n=[i,d])[0],i=n[1]),{bottomLeft:d,topLeft:l,topRight:i}}(k[0].points[0],k[0].points[1],k[0].points[2]),f=u.topRight,m=u.topLeft,C=u.bottomLeft,w=i(o,s,f,m,C),P=[];w&&P.push({alignmentPattern:{x:w.alignmentPattern.x,y:w.alignmentPattern.y},bottomLeft:{x:C.x,y:C.y},dimension:w.dimension,topLeft:{x:m.x,y:m.y},topRight:{x:f.x,y:f.y}});var h=l(o,f),v=l(o,m),y=l(o,C),p=i(o,s,h,v,y);return p&&P.push({alignmentPattern:{x:p.alignmentPattern.x,y:p.alignmentPattern.y},bottomLeft:{x:y.x,y:y.y},topLeft:{x:v.x,y:v.y},topRight:{x:h.x,y:h.y},dimension:p.dimension}),0===P.length?null:P}}]).default},o.exports=r()}(e={exports:{}}),e.exports));self.addEventListener("message",function(o){var e=o.data,t=e.id,c=function(o){try{var e=r(o.data,o.width,o.height,{inversionAttempts:"dontInvert"});if(null===e||""===e.data)return[];var t=e.location,c=e.data,s=Object.freeze([t.topLeftCorner,t.topRightCorner,t.bottomRightCorner,t.bottomLeftCorner]),a=Math.min.apply(Math,s.map(function(o){return o.x})),n=Math.max.apply(Math,s.map(function(o){return o.x})),d=Math.min.apply(Math,s.map(function(o){return o.y})),l=Math.max.apply(Math,s.map(function(o){return o.y}));return[{boundingBox:DOMRectReadOnly.fromRect({x:a,y:d,width:n-a,height:l-d}),rawValue:c,format:"qr_code",cornerPoints:s}]}catch(o){return console.error(o),[]}}(e.imageData);self.postMessage({id:t,detectedBarcodes:c})})});\n'], { type: "text/javascript" })),
        i = ["qr_code"],
        B = function () {
      function o(o) {
        var e;this.worker = void 0, this.workerLoad = void 0, this.messageCount = void 0;var r = null != (e = null == o ? void 0 : o.formats) ? e : i;if (0 === r.length) throw new TypeError("");if (r.includes("unknown")) throw new TypeError("");this.worker = new d(l), this.workerLoad = 0, this.messageCount = 0;
      }return o.getSupportedFormats = function () {
        return Promise.resolve(i);
      }, o.prototype.detect = function (o) {
        try {
          var r = this;if (r.workerLoad > 5) return Promise.resolve([]);r.workerLoad++;var t = r.messageCount++;return Promise.resolve(e(o)).then(function (o) {
            return r.worker.postMessage({ id: t, imageData: o }, [o.data.buffer]), Promise.resolve(new Promise(function (o) {
              r.worker.addEventListener("message", function (e) {
                var r = e.data;r.id === t && o(r.detectedBarcodes);
              });
            })).then(function (o) {
              return r.workerLoad--, o;
            });
          });
        } catch (o) {
          return Promise.reject(o);
        }
      }, o;
    }(); /* harmony default export */var barcode_detector_module = B;
    //# sourceMappingURL=barcode-detector.module.js.map

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/mixins/CommonAPI.vue?vue&type=script&lang=js&


    /* harmony default export */var CommonAPIvue_type_script_lang_js_ = {
      beforeMount: function beforeMount() {
        // if (!('BarcodeDetector' in window)) {
        window.BarcodeDetector = barcode_detector_module; // }
      },
      methods: {
        onDetect: function onDetect(resultPromise) {
          var _this = this;

          return Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var _yield$resultPromise, content;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.$emit("detect", resultPromise);

                    _context.prev = 1;
                    _context.next = 4;
                    return resultPromise;

                  case 4:
                    _yield$resultPromise = _context.sent;
                    content = _yield$resultPromise.content;

                    if (content !== null) {
                      _this.$emit("decode", content);
                    }

                    _context.next = 11;
                    break;

                  case 9:
                    _context.prev = 9;
                    _context.t0 = _context["catch"](1);

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[1, 9]]);
          }))();
        }
      }
    };
    // CONCATENATED MODULE: ./src/mixins/CommonAPI.vue?vue&type=script&lang=js&
    /* harmony default export */var mixins_CommonAPIvue_type_script_lang_js_ = CommonAPIvue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__("2877");

    // CONCATENATED MODULE: ./src/mixins/CommonAPI.vue
    var render, staticRenderFns;

    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(mixins_CommonAPIvue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* harmony default export */var CommonAPI = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/"b575":
  /***/function b575(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
    var classof = __webpack_require__("c6b6");
    var macrotask = __webpack_require__("2cf4").set;
    var IS_IOS = __webpack_require__("1cdc");

    var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
    var process = global.process;
    var Promise = global.Promise;
    var IS_NODE = classof(process) == 'process';
    // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
    var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
    var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

    var flush, head, last, notify, toggle, node, promise, then;

    // modern engines have queueMicrotask method
    if (!queueMicrotask) {
      flush = function flush() {
        var parent, fn;
        if (IS_NODE && (parent = process.domain)) parent.exit();
        while (head) {
          fn = head.fn;
          head = head.next;
          try {
            fn();
          } catch (error) {
            if (head) notify();else last = undefined;
            throw error;
          }
        }last = undefined;
        if (parent) parent.enter();
      };

      // Node.js
      if (IS_NODE) {
        notify = function notify() {
          process.nextTick(flush);
        };
        // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
      } else if (MutationObserver && !IS_IOS) {
        toggle = true;
        node = document.createTextNode('');
        new MutationObserver(flush).observe(node, { characterData: true });
        notify = function notify() {
          node.data = toggle = !toggle;
        };
        // environments with maybe non-completely correct, but existent Promise
      } else if (Promise && Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        promise = Promise.resolve(undefined);
        then = promise.then;
        notify = function notify() {
          then.call(promise, flush);
        };
        // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout
      } else {
        notify = function notify() {
          // strange IE + webpack dev server bug - use .call(global)
          macrotask.call(global, flush);
        };
      }
    }

    module.exports = queueMicrotask || function (fn) {
      var task = { fn: fn, next: undefined };
      if (last) last.next = task;
      if (!head) {
        head = task;
        notify();
      }last = task;
    };

    /***/
  },

  /***/"b622":
  /***/function b622(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var shared = __webpack_require__("5692");
    var has = __webpack_require__("5135");
    var uid = __webpack_require__("90e3");
    var NATIVE_SYMBOL = __webpack_require__("4930");
    var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

    var WellKnownSymbolsStore = shared('wks');
    var _Symbol3 = global.Symbol;
    var createWellKnownSymbol = USE_SYMBOL_AS_UID ? _Symbol3 : _Symbol3 && _Symbol3.withoutSetter || uid;

    module.exports = function (name) {
      if (!has(WellKnownSymbolsStore, name)) {
        if (NATIVE_SYMBOL && has(_Symbol3, name)) WellKnownSymbolsStore[name] = _Symbol3[name];else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
      }return WellKnownSymbolsStore[name];
    };

    /***/
  },

  /***/"b635":
  /***/function b635(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* WEBPACK VAR INJECTION */
    (function (global) {
      /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "e", function () {
        return install;
      });
      /* harmony import */var _components_QrcodeStream_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0d0e");
      /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "c", function () {
        return _components_QrcodeStream_vue__WEBPACK_IMPORTED_MODULE_0__["a"];
      });

      /* harmony import */var _components_QrcodeCapture_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5c0b");
      /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "a", function () {
        return _components_QrcodeCapture_vue__WEBPACK_IMPORTED_MODULE_1__["a"];
      });

      /* harmony import */var _components_QrcodeDropZone_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("fe6b");
      /* harmony reexport (safe) */__webpack_require__.d(__webpack_exports__, "b", function () {
        return _components_QrcodeDropZone_vue__WEBPACK_IMPORTED_MODULE_2__["a"];
      });

      // Install the components

      function install(Vue) {
        Vue.component("qrcode-stream", _components_QrcodeStream_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */"a"]);
        Vue.component("qrcode-capture", _components_QrcodeCapture_vue__WEBPACK_IMPORTED_MODULE_1__[/* default */"a"]);
        Vue.component("qrcode-drop-zone", _components_QrcodeDropZone_vue__WEBPACK_IMPORTED_MODULE_2__[/* default */"a"]);
      } // Expose the components


      /* -- Plugin definition & Auto-install -- */

      /* You shouldn't have to modify the code below */
      // Plugin

      var plugin = {
        install: install
      };
      /* harmony default export */__webpack_exports__["d"] = plugin; // Auto-install

      var GlobalVue = null;

      if (typeof window !== "undefined") {
        GlobalVue = window.Vue;
      } else if (typeof global !== "undefined") {
        GlobalVue = global.Vue;
      }

      if (GlobalVue) {
        GlobalVue.use(plugin);
      }
      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"b64b":
  /***/function b64b(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var toObject = __webpack_require__("7b0b");
    var nativeKeys = __webpack_require__("df75");
    var fails = __webpack_require__("d039");

    var FAILS_ON_PRIMITIVES = fails(function () {
      nativeKeys(1);
    });

    // `Object.keys` method
    // https://tc39.github.io/ecma262/#sec-object.keys
    $({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
      keys: function keys(it) {
        return nativeKeys(toObject(it));
      }
    });

    /***/
  },

  /***/"b727":
  /***/function b727(module, exports, __webpack_require__) {

    var bind = __webpack_require__("0366");
    var IndexedObject = __webpack_require__("44ad");
    var toObject = __webpack_require__("7b0b");
    var toLength = __webpack_require__("50c4");
    var arraySpeciesCreate = __webpack_require__("65f0");

    var push = [].push;

    // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
    var createMethod = function createMethod(TYPE) {
      var IS_MAP = TYPE == 1;
      var IS_FILTER = TYPE == 2;
      var IS_SOME = TYPE == 3;
      var IS_EVERY = TYPE == 4;
      var IS_FIND_INDEX = TYPE == 6;
      var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
      return function ($this, callbackfn, that, specificCreate) {
        var O = toObject($this);
        var self = IndexedObject(O);
        var boundFunction = bind(callbackfn, that, 3);
        var length = toLength(self.length);
        var index = 0;
        var create = specificCreate || arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var value, result;
        for (; length > index; index++) {
          if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
              if (IS_MAP) target[index] = result; // map
              else if (result) switch (TYPE) {
                  case 3:
                    return true; // some
                  case 5:
                    return value; // find
                  case 6:
                    return index; // findIndex
                  case 2:
                    push.call(target, value); // filter
                } else if (IS_EVERY) return false; // every
            }
          }
        }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
      };
    };

    module.exports = {
      // `Array.prototype.forEach` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
      forEach: createMethod(0),
      // `Array.prototype.map` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.map
      map: createMethod(1),
      // `Array.prototype.filter` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.filter
      filter: createMethod(2),
      // `Array.prototype.some` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.some
      some: createMethod(3),
      // `Array.prototype.every` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.every
      every: createMethod(4),
      // `Array.prototype.find` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.find
      find: createMethod(5),
      // `Array.prototype.findIndex` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
      findIndex: createMethod(6)
    };

    /***/
  },

  /***/"bb2f":
  /***/function bb2f(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");

    module.exports = !fails(function () {
      return Object.isExtensible(Object.preventExtensions({}));
    });

    /***/
  },

  /***/"c036":
  /***/function c036(__webpack_module__, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return e;
    });
    /* harmony export (binding) */__webpack_require__.d(__webpack_exports__, "b", function () {
      return n;
    });
    function e(e, n, r) {
      var t, i;void 0 === r && (r = "error");var o = new Promise(function (e, n) {
        t = e, i = n;
      });return e.addEventListener(n, t), e.addEventListener(r, i), o.finally(function () {
        e.removeEventListener(n, t), e.removeEventListener(r, i);
      }), o;
    }function n(e) {
      return new Promise(function (n) {
        return setTimeout(n, e);
      });
    }
    //# sourceMappingURL=callforth.mjs.map


    /***/
  },

  /***/"c04e":
  /***/function c04e(module, exports, __webpack_require__) {

    var isObject = __webpack_require__("861d");

    // `ToPrimitive` abstract operation
    // https://tc39.github.io/ecma262/#sec-toprimitive
    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    module.exports = function (input, PREFERRED_STRING) {
      if (!isObject(input)) return input;
      var fn, val;
      if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
      if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
      if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
      throw TypeError("Can't convert object to primitive value");
    };

    /***/
  },

  /***/"c430":
  /***/function c430(module, exports) {

    module.exports = false;

    /***/
  },

  /***/"c6b6":
  /***/function c6b6(module, exports) {

    var toString = {}.toString;

    module.exports = function (it) {
      return toString.call(it).slice(8, -1);
    };

    /***/
  },

  /***/"c6cd":
  /***/function c6cd(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var setGlobal = __webpack_require__("ce4e");

    var SHARED = '__core-js_shared__';
    var store = global[SHARED] || setGlobal(SHARED, {});

    module.exports = store;

    /***/
  },

  /***/"c8ba":
  /***/function c8ba(module, exports) {

    var g;

    // This works in non-strict mode
    g = function () {
      return this;
    }();

    try {
      // This works if eval is allowed (see CSP)
      g = g || new Function("return this")();
    } catch (e) {
      // This works if the window reference is available
      if ((typeof window === 'undefined' ? 'undefined' : _typeof2(window)) === "object") g = window;
    }

    // g can still be undefined, but nothing to do about it...
    // We return undefined, instead of nothing here, so it's
    // easier to handle this case. if(!global) { ...}

    module.exports = g;

    /***/
  },

  /***/"c975":
  /***/function c975(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $indexOf = __webpack_require__("4d64").indexOf;
    var arrayMethodIsStrict = __webpack_require__("a640");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var nativeIndexOf = [].indexOf;

    var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
    var STRICT_METHOD = arrayMethodIsStrict('indexOf');
    var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

    // `Array.prototype.indexOf` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
    $({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
      indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
        return NEGATIVE_ZERO
        // convert -0 to +0
        ? nativeIndexOf.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"ca84":
  /***/function ca84(module, exports, __webpack_require__) {

    var has = __webpack_require__("5135");
    var toIndexedObject = __webpack_require__("fc6a");
    var indexOf = __webpack_require__("4d64").indexOf;
    var hiddenKeys = __webpack_require__("d012");

    module.exports = function (object, names) {
      var O = toIndexedObject(object);
      var i = 0;
      var result = [];
      var key;
      for (key in O) {
        !has(hiddenKeys, key) && has(O, key) && result.push(key);
      } // Don't enum bug & hidden keys
      while (names.length > i) {
        if (has(O, key = names[i++])) {
          ~indexOf(result, key) || result.push(key);
        }
      }return result;
    };

    /***/
  },

  /***/"caad":
  /***/function caad(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $includes = __webpack_require__("4d64").includes;
    var addToUnscopables = __webpack_require__("44d2");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

    // `Array.prototype.includes` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    $({ target: 'Array', proto: true, forced: !USES_TO_LENGTH }, {
      includes: function includes(el /* , fromIndex = 0 */) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables('includes');

    /***/
  },

  /***/"cc12":
  /***/function cc12(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var isObject = __webpack_require__("861d");

    var document = global.document;
    // typeof document.createElement is 'object' in old IE
    var EXISTS = isObject(document) && isObject(document.createElement);

    module.exports = function (it) {
      return EXISTS ? document.createElement(it) : {};
    };

    /***/
  },

  /***/"cca6":
  /***/function cca6(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var assign = __webpack_require__("60da");

    // `Object.assign` method
    // https://tc39.github.io/ecma262/#sec-object.assign
    $({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
      assign: assign
    });

    /***/
  },

  /***/"cdf9":
  /***/function cdf9(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var isObject = __webpack_require__("861d");
    var newPromiseCapability = __webpack_require__("f069");

    module.exports = function (C, x) {
      anObject(C);
      if (isObject(x) && x.constructor === C) return x;
      var promiseCapability = newPromiseCapability.f(C);
      var resolve = promiseCapability.resolve;
      resolve(x);
      return promiseCapability.promise;
    };

    /***/
  },

  /***/"ce4e":
  /***/function ce4e(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var createNonEnumerableProperty = __webpack_require__("9112");

    module.exports = function (key, value) {
      try {
        createNonEnumerableProperty(global, key, value);
      } catch (error) {
        global[key] = value;
      }return value;
    };

    /***/
  },

  /***/"d012":
  /***/function d012(module, exports) {

    module.exports = {};

    /***/
  },

  /***/"d039":
  /***/function d039(module, exports) {

    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (error) {
        return true;
      }
    };

    /***/
  },

  /***/"d066":
  /***/function d066(module, exports, __webpack_require__) {

    var path = __webpack_require__("428f");
    var global = __webpack_require__("da84");

    var aFunction = function aFunction(variable) {
      return typeof variable == 'function' ? variable : undefined;
    };

    module.exports = function (namespace, method) {
      return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace]) : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
    };

    /***/
  },

  /***/"d1e7":
  /***/function d1e7(module, exports, __webpack_require__) {

    "use strict";

    var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

    // Nashorn ~ JDK8 bug
    var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

    // `Object.prototype.propertyIsEnumerable` method implementation
    // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
    exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
      var descriptor = getOwnPropertyDescriptor(this, V);
      return !!descriptor && descriptor.enumerable;
    } : nativePropertyIsEnumerable;

    /***/
  },

  /***/"d28b":
  /***/function d28b(module, exports, __webpack_require__) {

    var defineWellKnownSymbol = __webpack_require__("746f");

    // `Symbol.iterator` well-known symbol
    // https://tc39.github.io/ecma262/#sec-symbol.iterator
    defineWellKnownSymbol('iterator');

    /***/
  },

  /***/"d2bb":
  /***/function d2bb(module, exports, __webpack_require__) {

    var anObject = __webpack_require__("825a");
    var aPossiblePrototype = __webpack_require__("3bbe");

    // `Object.setPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.setprototypeof
    // Works with __proto__ only. Old v8 can't work with null proto objects.
    /* eslint-disable no-proto */
    module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
      var CORRECT_SETTER = false;
      var test = {};
      var setter;
      try {
        setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
        setter.call(test, []);
        CORRECT_SETTER = test instanceof Array;
      } catch (error) {/* empty */}
      return function setPrototypeOf(O, proto) {
        anObject(O);
        aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter.call(O, proto);else O.__proto__ = proto;
        return O;
      };
    }() : undefined);

    /***/
  },

  /***/"d3b7":
  /***/function d3b7(module, exports, __webpack_require__) {

    var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
    var redefine = __webpack_require__("6eeb");
    var toString = __webpack_require__("b041");

    // `Object.prototype.toString` method
    // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
    if (!TO_STRING_TAG_SUPPORT) {
      redefine(Object.prototype, 'toString', toString, { unsafe: true });
    }

    /***/
  },

  /***/"d44e":
  /***/function d44e(module, exports, __webpack_require__) {

    var defineProperty = __webpack_require__("9bf2").f;
    var has = __webpack_require__("5135");
    var wellKnownSymbol = __webpack_require__("b622");

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');

    module.exports = function (it, TAG, STATIC) {
      if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
        defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
      }
    };

    /***/
  },

  /***/"d4ec":
  /***/function d4ec(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    /* harmony export (binding) */
    __webpack_require__.d(__webpack_exports__, "a", function () {
      return _classCallCheck;
    });
    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    /***/
  },

  /***/"d58f":
  /***/function d58f(module, exports, __webpack_require__) {

    var aFunction = __webpack_require__("1c0b");
    var toObject = __webpack_require__("7b0b");
    var IndexedObject = __webpack_require__("44ad");
    var toLength = __webpack_require__("50c4");

    // `Array.prototype.{ reduce, reduceRight }` methods implementation
    var createMethod = function createMethod(IS_RIGHT) {
      return function (that, callbackfn, argumentsLength, memo) {
        aFunction(callbackfn);
        var O = toObject(that);
        var self = IndexedObject(O);
        var length = toLength(O.length);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while (true) {
          if (index in self) {
            memo = self[index];
            index += i;
            break;
          }
          index += i;
          if (IS_RIGHT ? index < 0 : length <= index) {
            throw TypeError('Reduce of empty array with no initial value');
          }
        }
        for (; IS_RIGHT ? index >= 0 : length > index; index += i) {
          if (index in self) {
            memo = callbackfn(memo, self[index], index, O);
          }
        }return memo;
      };
    };

    module.exports = {
      // `Array.prototype.reduce` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
      left: createMethod(false),
      // `Array.prototype.reduceRight` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
      right: createMethod(true)
    };

    /***/
  },

  /***/"d784":
  /***/function d784(module, exports, __webpack_require__) {

    "use strict";

    // TODO: Remove from `core-js@4` since it's moved to entry points

    __webpack_require__("ac1f");
    var redefine = __webpack_require__("6eeb");
    var fails = __webpack_require__("d039");
    var wellKnownSymbol = __webpack_require__("b622");
    var regexpExec = __webpack_require__("9263");
    var createNonEnumerableProperty = __webpack_require__("9112");

    var SPECIES = wellKnownSymbol('species');

    var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
      // #replace needs built-in support for named groups.
      // #match works fine because it just return the exec results, even if it has
      // a "grops" property.
      var re = /./;
      re.exec = function () {
        var result = [];
        result.groups = { a: '7' };
        return result;
      };
      return ''.replace(re, '$<a>') !== '7';
    });

    // IE <= 11 replaces $0 with the whole match, as if it was $&
    // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
    var REPLACE_KEEPS_$0 = function () {
      return 'a'.replace(/./, '$0') === '$0';
    }();

    var REPLACE = wellKnownSymbol('replace');
    // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
    var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function () {
      if (/./[REPLACE]) {
        return (/./[REPLACE]('a', '$0') === ''
        );
      }
      return false;
    }();

    // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
    // Weex JS has frozen built-in prototypes, so use try / catch wrapper
    var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
      var re = /(?:)/;
      var originalExec = re.exec;
      re.exec = function () {
        return originalExec.apply(this, arguments);
      };
      var result = 'ab'.split(re);
      return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
    });

    module.exports = function (KEY, length, exec, sham) {
      var SYMBOL = wellKnownSymbol(KEY);

      var DELEGATES_TO_SYMBOL = !fails(function () {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function () {
          return 7;
        };
        return ''[KEY](O) != 7;
      });

      var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;

        if (KEY === 'split') {
          // We can't use real regex here since it causes deoptimization
          // and serious performance degradation in V8
          // https://github.com/zloirock/core-js/issues/306
          re = {};
          // RegExp[@@split] doesn't call the regex's exec method, but first creates
          // a new one. We need to return the patched regex when creating the new one.
          re.constructor = {};
          re.constructor[SPECIES] = function () {
            return re;
          };
          re.flags = '';
          re[SYMBOL] = /./[SYMBOL];
        }

        re.exec = function () {
          execCalled = true;return null;
        };

        re[SYMBOL]('');
        return !execCalled;
      });

      if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !(REPLACE_SUPPORTS_NAMED_GROUPS && REPLACE_KEEPS_$0 && !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE) || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
          if (regexp.exec === regexpExec) {
            if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
              // The native String method already delegates to @@method (this
              // polyfilled function), leasing to infinite recursion.
              // We avoid it by directly calling the native @@method method.
              return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
            }
            return { done: true, value: nativeMethod.call(str, regexp, arg2) };
          }
          return { done: false };
        }, {
          REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
          REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
        });
        var stringMethod = methods[0];
        var regexMethod = methods[1];

        redefine(String.prototype, KEY, stringMethod);
        redefine(RegExp.prototype, SYMBOL, length == 2
        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
        ? function (string, arg) {
          return regexMethod.call(string, this, arg);
        }
        // 21.2.5.6 RegExp.prototype[@@match](string)
        // 21.2.5.9 RegExp.prototype[@@search](string)
        : function (string) {
          return regexMethod.call(string, this);
        });
      }

      if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
    };

    /***/
  },

  /***/"d81d":
  /***/function d81d(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var $map = __webpack_require__("b727").map;
    var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
    // FF49- issue
    var USES_TO_LENGTH = arrayMethodUsesToLength('map');

    // `Array.prototype.map` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.map
    // with adding support of @@species
    $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
      map: function map(callbackfn /* , thisArg */) {
        return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    /***/
  },

  /***/"da84":
  /***/function da84(module, exports, __webpack_require__) {

    /* WEBPACK VAR INJECTION */(function (global) {
      var check = function check(it) {
        return it && it.Math == Math && it;
      };

      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      module.exports =
      // eslint-disable-next-line no-undef
      check((typeof globalThis === 'undefined' ? 'undefined' : _typeof2(globalThis)) == 'object' && globalThis) || check((typeof window === 'undefined' ? 'undefined' : _typeof2(window)) == 'object' && window) || check((typeof self === 'undefined' ? 'undefined' : _typeof2(self)) == 'object' && self) || check((typeof global === 'undefined' ? 'undefined' : _typeof2(global)) == 'object' && global) ||
      // eslint-disable-next-line no-new-func
      Function('return this')();

      /* WEBPACK VAR INJECTION */
    }).call(this, __webpack_require__("c8ba"));

    /***/
  },

  /***/"dbb4":
  /***/function dbb4(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var DESCRIPTORS = __webpack_require__("83ab");
    var ownKeys = __webpack_require__("56ef");
    var toIndexedObject = __webpack_require__("fc6a");
    var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
    var createProperty = __webpack_require__("8418");

    // `Object.getOwnPropertyDescriptors` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
    $({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = toIndexedObject(object);
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        var keys = ownKeys(O);
        var result = {};
        var index = 0;
        var key, descriptor;
        while (keys.length > index) {
          descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
          if (descriptor !== undefined) createProperty(result, key, descriptor);
        }
        return result;
      }
    });

    /***/
  },

  /***/"ddb0":
  /***/function ddb0(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");
    var DOMIterables = __webpack_require__("fdbc");
    var ArrayIteratorMethods = __webpack_require__("e260");
    var createNonEnumerableProperty = __webpack_require__("9112");
    var wellKnownSymbol = __webpack_require__("b622");

    var ITERATOR = wellKnownSymbol('iterator');
    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    var ArrayValues = ArrayIteratorMethods.values;

    for (var COLLECTION_NAME in DOMIterables) {
      var Collection = global[COLLECTION_NAME];
      var CollectionPrototype = Collection && Collection.prototype;
      if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
          createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
        } catch (error) {
          CollectionPrototype[ITERATOR] = ArrayValues;
        }
        if (!CollectionPrototype[TO_STRING_TAG]) {
          createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        }
        if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
          // some Chrome versions have non-configurable methods on DOMTokenList
          if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
            createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
          } catch (error) {
            CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
          }
        }
      }
    }

    /***/
  },

  /***/"df75":
  /***/function df75(module, exports, __webpack_require__) {

    var internalObjectKeys = __webpack_require__("ca84");
    var enumBugKeys = __webpack_require__("7839");

    // `Object.keys` method
    // https://tc39.github.io/ecma262/#sec-object.keys
    module.exports = Object.keys || function keys(O) {
      return internalObjectKeys(O, enumBugKeys);
    };

    /***/
  },

  /***/"e01a":
  /***/function e01a(module, exports, __webpack_require__) {

    "use strict";
    // `Symbol.prototype.description` getter
    // https://tc39.github.io/ecma262/#sec-symbol.prototype.description

    var $ = __webpack_require__("23e7");
    var DESCRIPTORS = __webpack_require__("83ab");
    var global = __webpack_require__("da84");
    var has = __webpack_require__("5135");
    var isObject = __webpack_require__("861d");
    var defineProperty = __webpack_require__("9bf2").f;
    var copyConstructorProperties = __webpack_require__("e893");

    var NativeSymbol = global.Symbol;

    if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
    // Safari 12 bug
    NativeSymbol().description !== undefined)) {
      var EmptyStringDescriptionStore = {};
      // wrap Symbol constructor for correct work with undefined description
      var SymbolWrapper = function _Symbol4() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
        var result = this instanceof SymbolWrapper ? new NativeSymbol(description)
        // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
        : description === undefined ? NativeSymbol() : NativeSymbol(description);
        if (description === '') EmptyStringDescriptionStore[result] = true;
        return result;
      };
      copyConstructorProperties(SymbolWrapper, NativeSymbol);
      var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
      symbolPrototype.constructor = SymbolWrapper;

      var symbolToString = symbolPrototype.toString;
      var native = String(NativeSymbol('test')) == 'Symbol(test)';
      var regexp = /^Symbol\((.*)\)[^)]+$/;
      defineProperty(symbolPrototype, 'description', {
        configurable: true,
        get: function description() {
          var symbol = isObject(this) ? this.valueOf() : this;
          var string = symbolToString.call(symbol);
          if (has(EmptyStringDescriptionStore, symbol)) return '';
          var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
          return desc === '' ? undefined : desc;
        }
      });

      $({ global: true, forced: true }, {
        Symbol: SymbolWrapper
      });
    }

    /***/
  },

  /***/"e163":
  /***/function e163(module, exports, __webpack_require__) {

    var has = __webpack_require__("5135");
    var toObject = __webpack_require__("7b0b");
    var sharedKey = __webpack_require__("f772");
    var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

    var IE_PROTO = sharedKey('IE_PROTO');
    var ObjectPrototype = Object.prototype;

    // `Object.getPrototypeOf` method
    // https://tc39.github.io/ecma262/#sec-object.getprototypeof
    module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO)) return O[IE_PROTO];
      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }return O instanceof Object ? ObjectPrototype : null;
    };

    /***/
  },

  /***/"e177":
  /***/function e177(module, exports, __webpack_require__) {

    var fails = __webpack_require__("d039");

    module.exports = !fails(function () {
      function F() {/* empty */}
      F.prototype.constructor = null;
      return Object.getPrototypeOf(new F()) !== F.prototype;
    });

    /***/
  },

  /***/"e260":
  /***/function e260(module, exports, __webpack_require__) {

    "use strict";

    var toIndexedObject = __webpack_require__("fc6a");
    var addToUnscopables = __webpack_require__("44d2");
    var Iterators = __webpack_require__("3f8c");
    var InternalStateModule = __webpack_require__("69f3");
    var defineIterator = __webpack_require__("7dd0");

    var ARRAY_ITERATOR = 'Array Iterator';
    var setInternalState = InternalStateModule.set;
    var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

    // `Array.prototype.entries` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.entries
    // `Array.prototype.keys` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.keys
    // `Array.prototype.values` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.values
    // `Array.prototype[@@iterator]` method
    // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
    // `CreateArrayIterator` internal method
    // https://tc39.github.io/ecma262/#sec-createarrayiterator
    module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
      setInternalState(this, {
        type: ARRAY_ITERATOR,
        target: toIndexedObject(iterated), // target
        index: 0, // next index
        kind: kind // kind
      });
      // `%ArrayIteratorPrototype%.next` method
      // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
    }, function () {
      var state = getInternalState(this);
      var target = state.target;
      var kind = state.kind;
      var index = state.index++;
      if (!target || index >= target.length) {
        state.target = undefined;
        return { value: undefined, done: true };
      }
      if (kind == 'keys') return { value: index, done: false };
      if (kind == 'values') return { value: target[index], done: false };
      return { value: [index, target[index]], done: false };
    }, 'values');

    // argumentsList[@@iterator] is %ArrayProto_values%
    // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
    // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
    Iterators.Arguments = Iterators.Array;

    // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');

    /***/
  },

  /***/"e2cc":
  /***/function e2cc(module, exports, __webpack_require__) {

    var redefine = __webpack_require__("6eeb");

    module.exports = function (target, src, options) {
      for (var key in src) {
        redefine(target, key, src[key], options);
      }return target;
    };

    /***/
  },

  /***/"e439":
  /***/function e439(module, exports, __webpack_require__) {

    var $ = __webpack_require__("23e7");
    var fails = __webpack_require__("d039");
    var toIndexedObject = __webpack_require__("fc6a");
    var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
    var DESCRIPTORS = __webpack_require__("83ab");

    var FAILS_ON_PRIMITIVES = fails(function () {
      nativeGetOwnPropertyDescriptor(1);
    });
    var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

    // `Object.getOwnPropertyDescriptor` method
    // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
    $({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
        return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
      }
    });

    /***/
  },

  /***/"e538":
  /***/function e538(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");

    exports.f = wellKnownSymbol;

    /***/
  },

  /***/"e667":
  /***/function e667(module, exports) {

    module.exports = function (exec) {
      try {
        return { error: false, value: exec() };
      } catch (error) {
        return { error: true, value: error };
      }
    };

    /***/
  },

  /***/"e6cf":
  /***/function e6cf(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var IS_PURE = __webpack_require__("c430");
    var global = __webpack_require__("da84");
    var getBuiltIn = __webpack_require__("d066");
    var NativePromise = __webpack_require__("fea9");
    var redefine = __webpack_require__("6eeb");
    var redefineAll = __webpack_require__("e2cc");
    var setToStringTag = __webpack_require__("d44e");
    var setSpecies = __webpack_require__("2626");
    var isObject = __webpack_require__("861d");
    var aFunction = __webpack_require__("1c0b");
    var anInstance = __webpack_require__("19aa");
    var classof = __webpack_require__("c6b6");
    var inspectSource = __webpack_require__("8925");
    var iterate = __webpack_require__("2266");
    var checkCorrectnessOfIteration = __webpack_require__("1c7e");
    var speciesConstructor = __webpack_require__("4840");
    var task = __webpack_require__("2cf4").set;
    var microtask = __webpack_require__("b575");
    var promiseResolve = __webpack_require__("cdf9");
    var hostReportErrors = __webpack_require__("44de");
    var newPromiseCapabilityModule = __webpack_require__("f069");
    var perform = __webpack_require__("e667");
    var InternalStateModule = __webpack_require__("69f3");
    var isForced = __webpack_require__("94ca");
    var wellKnownSymbol = __webpack_require__("b622");
    var V8_VERSION = __webpack_require__("2d00");

    var SPECIES = wellKnownSymbol('species');
    var PROMISE = 'Promise';
    var getInternalState = InternalStateModule.get;
    var setInternalState = InternalStateModule.set;
    var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
    var PromiseConstructor = NativePromise;
    var TypeError = global.TypeError;
    var document = global.document;
    var process = global.process;
    var $fetch = getBuiltIn('fetch');
    var newPromiseCapability = newPromiseCapabilityModule.f;
    var newGenericPromiseCapability = newPromiseCapability;
    var IS_NODE = classof(process) == 'process';
    var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
    var UNHANDLED_REJECTION = 'unhandledrejection';
    var REJECTION_HANDLED = 'rejectionhandled';
    var PENDING = 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    var HANDLED = 1;
    var UNHANDLED = 2;
    var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

    var FORCED = isForced(PROMISE, function () {
      var GLOBAL_CORE_JS_PROMISE = inspectSource(PromiseConstructor) !== String(PromiseConstructor);
      if (!GLOBAL_CORE_JS_PROMISE) {
        // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
        // We can't detect it synchronously, so just check versions
        if (V8_VERSION === 66) return true;
        // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        if (!IS_NODE && typeof PromiseRejectionEvent != 'function') return true;
      }
      // We need Promise#finally in the pure version for preventing prototype pollution
      if (IS_PURE && !PromiseConstructor.prototype['finally']) return true;
      // We can't use @@species feature detection in V8 since it causes
      // deoptimization and performance degradation
      // https://github.com/zloirock/core-js/issues/679
      if (V8_VERSION >= 51 && /native code/.test(PromiseConstructor)) return false;
      // Detect correctness of subclassing with @@species support
      var promise = PromiseConstructor.resolve(1);
      var FakePromise = function FakePromise(exec) {
        exec(function () {/* empty */}, function () {/* empty */});
      };
      var constructor = promise.constructor = {};
      constructor[SPECIES] = FakePromise;
      return !(promise.then(function () {/* empty */}) instanceof FakePromise);
    });

    var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
      PromiseConstructor.all(iterable)['catch'](function () {/* empty */});
    });

    // helpers
    var isThenable = function isThenable(it) {
      var then;
      return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
    };

    var notify = function notify(promise, state, isReject) {
      if (state.notified) return;
      state.notified = true;
      var chain = state.reactions;
      microtask(function () {
        var value = state.value;
        var ok = state.state == FULFILLED;
        var index = 0;
        // variable length - can't use forEach
        while (chain.length > index) {
          var reaction = chain[index++];
          var handler = ok ? reaction.ok : reaction.fail;
          var resolve = reaction.resolve;
          var reject = reaction.reject;
          var domain = reaction.domain;
          var result, then, exited;
          try {
            if (handler) {
              if (!ok) {
                if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
                state.rejection = HANDLED;
              }
              if (handler === true) result = value;else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                  domain.exit();
                  exited = true;
                }
              }
              if (result === reaction.promise) {
                reject(TypeError('Promise-chain cycle'));
              } else if (then = isThenable(result)) {
                then.call(result, resolve, reject);
              } else resolve(result);
            } else reject(value);
          } catch (error) {
            if (domain && !exited) domain.exit();
            reject(error);
          }
        }
        state.reactions = [];
        state.notified = false;
        if (isReject && !state.rejection) onUnhandled(promise, state);
      });
    };

    var dispatchEvent = function dispatchEvent(name, promise, reason) {
      var event, handler;
      if (DISPATCH_EVENT) {
        event = document.createEvent('Event');
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        global.dispatchEvent(event);
      } else event = { promise: promise, reason: reason };
      if (handler = global['on' + name]) handler(event);else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
    };

    var onUnhandled = function onUnhandled(promise, state) {
      task.call(global, function () {
        var value = state.value;
        var IS_UNHANDLED = isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
          result = perform(function () {
            if (IS_NODE) {
              process.emit('unhandledRejection', value, promise);
            } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
          });
          // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
          state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
          if (result.error) throw result.value;
        }
      });
    };

    var isUnhandled = function isUnhandled(state) {
      return state.rejection !== HANDLED && !state.parent;
    };

    var onHandleUnhandled = function onHandleUnhandled(promise, state) {
      task.call(global, function () {
        if (IS_NODE) {
          process.emit('rejectionHandled', promise);
        } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
      });
    };

    var bind = function bind(fn, promise, state, unwrap) {
      return function (value) {
        fn(promise, state, value, unwrap);
      };
    };

    var internalReject = function internalReject(promise, state, value, unwrap) {
      if (state.done) return;
      state.done = true;
      if (unwrap) state = unwrap;
      state.value = value;
      state.state = REJECTED;
      notify(promise, state, true);
    };

    var internalResolve = function internalResolve(promise, state, value, unwrap) {
      if (state.done) return;
      state.done = true;
      if (unwrap) state = unwrap;
      try {
        if (promise === value) throw TypeError("Promise can't be resolved itself");
        var then = isThenable(value);
        if (then) {
          microtask(function () {
            var wrapper = { done: false };
            try {
              then.call(value, bind(internalResolve, promise, wrapper, state), bind(internalReject, promise, wrapper, state));
            } catch (error) {
              internalReject(promise, wrapper, error, state);
            }
          });
        } else {
          state.value = value;
          state.state = FULFILLED;
          notify(promise, state, false);
        }
      } catch (error) {
        internalReject(promise, { done: false }, error, state);
      }
    };

    // constructor polyfill
    if (FORCED) {
      // 25.4.3.1 Promise(executor)
      PromiseConstructor = function Promise(executor) {
        anInstance(this, PromiseConstructor, PROMISE);
        aFunction(executor);
        Internal.call(this);
        var state = getInternalState(this);
        try {
          executor(bind(internalResolve, this, state), bind(internalReject, this, state));
        } catch (error) {
          internalReject(this, state, error);
        }
      };
      // eslint-disable-next-line no-unused-vars
      Internal = function Promise(executor) {
        setInternalState(this, {
          type: PROMISE,
          done: false,
          notified: false,
          parent: false,
          reactions: [],
          rejection: false,
          state: PENDING,
          value: undefined
        });
      };
      Internal.prototype = redefineAll(PromiseConstructor.prototype, {
        // `Promise.prototype.then` method
        // https://tc39.github.io/ecma262/#sec-promise.prototype.then
        then: function then(onFulfilled, onRejected) {
          var state = getInternalPromiseState(this);
          var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
          reaction.fail = typeof onRejected == 'function' && onRejected;
          reaction.domain = IS_NODE ? process.domain : undefined;
          state.parent = true;
          state.reactions.push(reaction);
          if (state.state != PENDING) notify(this, state, false);
          return reaction.promise;
        },
        // `Promise.prototype.catch` method
        // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
        'catch': function _catch(onRejected) {
          return this.then(undefined, onRejected);
        }
      });
      OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new Internal();
        var state = getInternalState(promise);
        this.promise = promise;
        this.resolve = bind(internalResolve, promise, state);
        this.reject = bind(internalReject, promise, state);
      };
      newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
        return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
      };

      if (!IS_PURE && typeof NativePromise == 'function') {
        nativeThen = NativePromise.prototype.then;

        // wrap native Promise#then for native async functions
        redefine(NativePromise.prototype, 'then', function then(onFulfilled, onRejected) {
          var that = this;
          return new PromiseConstructor(function (resolve, reject) {
            nativeThen.call(that, resolve, reject);
          }).then(onFulfilled, onRejected);
          // https://github.com/zloirock/core-js/issues/640
        }, { unsafe: true });

        // wrap fetch result
        if (typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
          // eslint-disable-next-line no-unused-vars
          fetch: function fetch(input /* , init */) {
            return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
          }
        });
      }
    }

    $({ global: true, wrap: true, forced: FORCED }, {
      Promise: PromiseConstructor
    });

    setToStringTag(PromiseConstructor, PROMISE, false, true);
    setSpecies(PROMISE);

    PromiseWrapper = getBuiltIn(PROMISE);

    // statics
    $({ target: PROMISE, stat: true, forced: FORCED }, {
      // `Promise.reject` method
      // https://tc39.github.io/ecma262/#sec-promise.reject
      reject: function reject(r) {
        var capability = newPromiseCapability(this);
        capability.reject.call(undefined, r);
        return capability.promise;
      }
    });

    $({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
      // `Promise.resolve` method
      // https://tc39.github.io/ecma262/#sec-promise.resolve
      resolve: function resolve(x) {
        return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
      }
    });

    $({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
      // `Promise.all` method
      // https://tc39.github.io/ecma262/#sec-promise.all
      all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function () {
          var $promiseResolve = aFunction(C.resolve);
          var values = [];
          var counter = 0;
          var remaining = 1;
          iterate(iterable, function (promise) {
            var index = counter++;
            var alreadyCalled = false;
            values.push(undefined);
            remaining++;
            $promiseResolve.call(C, promise).then(function (value) {
              if (alreadyCalled) return;
              alreadyCalled = true;
              values[index] = value;
              --remaining || resolve(values);
            }, reject);
          });
          --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
      },
      // `Promise.race` method
      // https://tc39.github.io/ecma262/#sec-promise.race
      race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function () {
          var $promiseResolve = aFunction(C.resolve);
          iterate(iterable, function (promise) {
            $promiseResolve.call(C, promise).then(capability.resolve, reject);
          });
        });
        if (result.error) reject(result.value);
        return capability.promise;
      }
    });

    /***/
  },

  /***/"e893":
  /***/function e893(module, exports, __webpack_require__) {

    var has = __webpack_require__("5135");
    var ownKeys = __webpack_require__("56ef");
    var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
    var definePropertyModule = __webpack_require__("9bf2");

    module.exports = function (target, source) {
      var keys = ownKeys(source);
      var defineProperty = definePropertyModule.f;
      var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
      }
    };

    /***/
  },

  /***/"e8b5":
  /***/function e8b5(module, exports, __webpack_require__) {

    var classof = __webpack_require__("c6b6");

    // `IsArray` abstract operation
    // https://tc39.github.io/ecma262/#sec-isarray
    module.exports = Array.isArray || function isArray(arg) {
      return classof(arg) == 'Array';
    };

    /***/
  },

  /***/"e95a":
  /***/function e95a(module, exports, __webpack_require__) {

    var wellKnownSymbol = __webpack_require__("b622");
    var Iterators = __webpack_require__("3f8c");

    var ITERATOR = wellKnownSymbol('iterator');
    var ArrayPrototype = Array.prototype;

    // check on default Array iterator
    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
    };

    /***/
  },

  /***/"f069":
  /***/function f069(module, exports, __webpack_require__) {

    "use strict";

    var aFunction = __webpack_require__("1c0b");

    var PromiseCapability = function PromiseCapability(C) {
      var resolve, reject;
      this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aFunction(resolve);
      this.reject = aFunction(reject);
    };

    // 25.4.1.5 NewPromiseCapability(C)
    module.exports.f = function (C) {
      return new PromiseCapability(C);
    };

    /***/
  },

  /***/"f183":
  /***/function f183(module, exports, __webpack_require__) {

    var hiddenKeys = __webpack_require__("d012");
    var isObject = __webpack_require__("861d");
    var has = __webpack_require__("5135");
    var defineProperty = __webpack_require__("9bf2").f;
    var uid = __webpack_require__("90e3");
    var FREEZING = __webpack_require__("bb2f");

    var METADATA = uid('meta');
    var id = 0;

    var isExtensible = Object.isExtensible || function () {
      return true;
    };

    var setMetadata = function setMetadata(it) {
      defineProperty(it, METADATA, { value: {
          objectID: 'O' + ++id, // object ID
          weakData: {} // weak collections IDs
        } });
    };

    var fastKey = function fastKey(it, create) {
      // return a primitive with prefix
      if (!isObject(it)) return (typeof it === 'undefined' ? 'undefined' : _typeof2(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
      if (!has(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        setMetadata(it);
        // return object ID
      }return it[METADATA].objectID;
    };

    var getWeakData = function getWeakData(it, create) {
      if (!has(it, METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        setMetadata(it);
        // return the store of weak collections IDs
      }return it[METADATA].weakData;
    };

    // add metadata on freeze-family methods calling
    var onFreeze = function onFreeze(it) {
      if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
      return it;
    };

    var meta = module.exports = {
      REQUIRED: false,
      fastKey: fastKey,
      getWeakData: getWeakData,
      onFreeze: onFreeze
    };

    hiddenKeys[METADATA] = true;

    /***/
  },

  /***/"f5df":
  /***/function f5df(module, exports, __webpack_require__) {

    var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
    var classofRaw = __webpack_require__("c6b6");
    var wellKnownSymbol = __webpack_require__("b622");

    var TO_STRING_TAG = wellKnownSymbol('toStringTag');
    // ES3 wrong here
    var CORRECT_ARGUMENTS = classofRaw(function () {
      return arguments;
    }()) == 'Arguments';

    // fallback for IE11 Script Access Denied error
    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (error) {/* empty */}
    };

    // getting tag from ES6+ `Object.prototype.toString`
    module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
      var O, tag, result;
      return it === undefined ? 'Undefined' : it === null ? 'Null'
      // @@toStringTag case
      : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
      // builtinTag case
      : CORRECT_ARGUMENTS ? classofRaw(O)
      // ES3 arguments fallback
      : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
    };

    /***/
  },

  /***/"f772":
  /***/function f772(module, exports, __webpack_require__) {

    var shared = __webpack_require__("5692");
    var uid = __webpack_require__("90e3");

    var keys = shared('keys');

    module.exports = function (key) {
      return keys[key] || (keys[key] = uid(key));
    };

    /***/
  },

  /***/"fb15":
  /***/function fb15(module, __webpack_exports__, __webpack_require__) {

    "use strict";
    // ESM COMPAT FLAG

    __webpack_require__.r(__webpack_exports__);

    // EXPORTS
    __webpack_require__.d(__webpack_exports__, "install", function () {
      return (/* reexport */src_0["e" /* install */]
      );
    });
    __webpack_require__.d(__webpack_exports__, "QrcodeStream", function () {
      return (/* reexport */src_0["c" /* QrcodeStream */]
      );
    });
    __webpack_require__.d(__webpack_exports__, "QrcodeCapture", function () {
      return (/* reexport */src_0["a" /* QrcodeCapture */]
      );
    });
    __webpack_require__.d(__webpack_exports__, "QrcodeDropZone", function () {
      return (/* reexport */src_0["b" /* QrcodeDropZone */]
      );
    });

    // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
    // This file is imported into lib/wc client bundles.

    if (typeof window !== 'undefined') {
      var currentScript = window.document.currentScript;
      if (true) {
        var getCurrentScript = __webpack_require__("8875");
        currentScript = getCurrentScript();

        // for backward compatibility, because previously we directly included the polyfill
        if (!('currentScript' in document)) {
          Object.defineProperty(document, 'currentScript', { get: getCurrentScript });
        }
      }

      var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
      if (src) {
        __webpack_require__.p = src[1]; // eslint-disable-line
      }
    }

    // Indicate to webpack that this file can be concatenated
    /* harmony default export */var setPublicPath = null;

    // EXTERNAL MODULE: ./src/index.js
    var src_0 = __webpack_require__("b635");

    // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


    /* harmony default export */var entry_lib = __webpack_exports__["default"] = src_0["d" /* default */];

    /***/
  },

  /***/"fb6a":
  /***/function fb6a(module, exports, __webpack_require__) {

    "use strict";

    var $ = __webpack_require__("23e7");
    var isObject = __webpack_require__("861d");
    var isArray = __webpack_require__("e8b5");
    var toAbsoluteIndex = __webpack_require__("23cb");
    var toLength = __webpack_require__("50c4");
    var toIndexedObject = __webpack_require__("fc6a");
    var createProperty = __webpack_require__("8418");
    var wellKnownSymbol = __webpack_require__("b622");
    var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
    var arrayMethodUsesToLength = __webpack_require__("ae40");

    var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
    var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

    var SPECIES = wellKnownSymbol('species');
    var nativeSlice = [].slice;
    var max = Math.max;

    // `Array.prototype.slice` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.slice
    // fallback for not array-like ES3 strings and DOM objects
    $({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
      slice: function slice(start, end) {
        var O = toIndexedObject(this);
        var length = toLength(O.length);
        var k = toAbsoluteIndex(start, length);
        var fin = toAbsoluteIndex(end === undefined ? length : end, length);
        // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
        var Constructor, result, n;
        if (isArray(O)) {
          Constructor = O.constructor;
          // cross-realm fallback
          if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
            Constructor = undefined;
          } else if (isObject(Constructor)) {
            Constructor = Constructor[SPECIES];
            if (Constructor === null) Constructor = undefined;
          }
          if (Constructor === Array || Constructor === undefined) {
            return nativeSlice.call(O, k, fin);
          }
        }
        result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
        for (n = 0; k < fin; k++, n++) {
          if (k in O) createProperty(result, n, O[k]);
        }result.length = n;
        return result;
      }
    });

    /***/
  },

  /***/"fc6a":
  /***/function fc6a(module, exports, __webpack_require__) {

    // toObject with fallback for non-array-like ES3 strings
    var IndexedObject = __webpack_require__("44ad");
    var requireObjectCoercible = __webpack_require__("1d80");

    module.exports = function (it) {
      return IndexedObject(requireObjectCoercible(it));
    };

    /***/
  },

  /***/"fdbc":
  /***/function fdbc(module, exports) {

    // iterable DOM collections
    // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
    module.exports = {
      CSSRuleList: 0,
      CSSStyleDeclaration: 0,
      CSSValueList: 0,
      ClientRectList: 0,
      DOMRectList: 0,
      DOMStringList: 0,
      DOMTokenList: 1,
      DataTransferItemList: 0,
      FileList: 0,
      HTMLAllCollection: 0,
      HTMLCollection: 0,
      HTMLFormElement: 0,
      HTMLSelectElement: 0,
      MediaList: 0,
      MimeTypeArray: 0,
      NamedNodeMap: 0,
      NodeList: 1,
      PaintRequestList: 0,
      Plugin: 0,
      PluginArray: 0,
      SVGLengthList: 0,
      SVGNumberList: 0,
      SVGPathSegList: 0,
      SVGPointList: 0,
      SVGStringList: 0,
      SVGTransformList: 0,
      SourceBufferList: 0,
      StyleSheetList: 0,
      TextTrackCueList: 0,
      TextTrackList: 0,
      TouchList: 0
    };

    /***/
  },

  /***/"fdbf":
  /***/function fdbf(module, exports, __webpack_require__) {

    var NATIVE_SYMBOL = __webpack_require__("4930");

    module.exports = NATIVE_SYMBOL
    // eslint-disable-next-line no-undef
    && !Symbol.sham
    // eslint-disable-next-line no-undef
    && _typeof2(Symbol.iterator) == 'symbol';

    /***/
  },

  /***/"fe6b":
  /***/function fe6b(module, __webpack_exports__, __webpack_require__) {

    "use strict";

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"392d026c-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeDropZone.vue?vue&type=template&id=61d46f6c&lang=html&

    var render = function render() {
      var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { on: { "drop": function drop($event) {
            $event.preventDefault();$event.stopPropagation();return _vm.onDrop($event);
          }, "dragenter": function dragenter($event) {
            $event.preventDefault();$event.stopPropagation();return _vm.onDragOver(true);
          }, "dragleave": function dragleave($event) {
            $event.preventDefault();$event.stopPropagation();return _vm.onDragOver(false);
          }, "dragover": function dragover($event) {
            $event.preventDefault();$event.stopPropagation();
          } } }, [_vm._t("default")], 2);
    };
    var staticRenderFns = [];

    // CONCATENATED MODULE: ./src/components/QrcodeDropZone.vue?vue&type=template&id=61d46f6c&lang=html&

    // EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
    var es_array_for_each = __webpack_require__("4160");

    // EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
    var web_dom_collections_for_each = __webpack_require__("159b");

    // EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
    var toConsumableArray = __webpack_require__("2909");

    // EXTERNAL MODULE: ./src/misc/scanner.js
    var scanner = __webpack_require__("a180");

    // EXTERNAL MODULE: ./src/mixins/CommonAPI.vue + 3 modules
    var CommonAPI = __webpack_require__("b3af");

    // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QrcodeDropZone.vue?vue&type=script&lang=js&


    //
    //
    //
    //
    //
    //
    //
    //
    //
    //
    //


    /* harmony default export */var QrcodeDropZonevue_type_script_lang_js_ = {
      name: "qrcode-drop-zone",
      mixins: [CommonAPI["a" /* default */]],
      methods: {
        onDragOver: function onDragOver(isDraggingOver) {
          this.$emit("dragover", isDraggingOver);
        },
        onDrop: function onDrop(_ref) {
          var _this = this;

          var dataTransfer = _ref.dataTransfer;
          this.onDragOver(false);

          var droppedFiles = Object(toConsumableArray["a" /* default */])(dataTransfer.files);

          var droppedUrl = dataTransfer.getData("text/uri-list");
          droppedFiles.forEach(function (file) {
            _this.onDetect(Object(scanner["b" /* processFile */])(file));
          });

          if (droppedUrl !== "") {
            this.onDetect(Object(scanner["c" /* processUrl */])(droppedUrl));
          }
        }
      }
    };
    // CONCATENATED MODULE: ./src/components/QrcodeDropZone.vue?vue&type=script&lang=js&
    /* harmony default export */var components_QrcodeDropZonevue_type_script_lang_js_ = QrcodeDropZonevue_type_script_lang_js_;
    // EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
    var componentNormalizer = __webpack_require__("2877");

    // CONCATENATED MODULE: ./src/components/QrcodeDropZone.vue


    /* normalize component */

    var component = Object(componentNormalizer["a" /* default */])(components_QrcodeDropZonevue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);

    /* harmony default export */var QrcodeDropZone = __webpack_exports__["a"] = component.exports;

    /***/
  },

  /***/"fea9":
  /***/function fea9(module, exports, __webpack_require__) {

    var global = __webpack_require__("da84");

    module.exports = global.Promise;

    /***/
  }

  /******/ });
//# sourceMappingURL=VueQrcodeReader.common.js.map

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js